(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Orillusion = {}));
})(this, (function (exports) { 'use strict';

    var _documentCurrentScript = typeof document !== 'undefined' ? document.currentScript : null;
    class Color {
      /**
       * red color
       */
      static COLOR_RED = new Color(1, 0, 0, 1);
      /**
       * green color
       */
      static COLOR_GREEN = new Color(0, 1, 0, 1);
      /**
       * blue color
       */
      static COLOR_BLUE = new Color(0, 0, 1, 1);
      /**
       * white color
       */
      static COLOR_WHITE = new Color(1, 1, 1, 1);
      /**
       * cache 
       * @internal
       */
      static COLOR_0 = new Color();
      /**
       * cache 
       * @internal
       */
      static COLOR_1 = new Color();
      /**
       * cache 
       * @internal
       */
      static COLOR_2 = new Color();
      /**
       * @internal
       */
      static HEX_CHARACTERS = "a-f\\d";
      /**
       * @internal
       */
      static MATCH_3OR4_HEX = `#?[${Color.HEX_CHARACTERS}]{3}[${Color.HEX_CHARACTERS}]?`;
      /**
       * @internal
       */
      static MATCH_6OR8_HEX = `#?[${Color.HEX_CHARACTERS}]{6}([${Color.HEX_CHARACTERS}]{2})?`;
      /**
       * @internal
       */
      static NON_HEX_CHARS = new RegExp(`[^#${Color.HEX_CHARACTERS}]`, "gi");
      /**
       * @internal
       */
      static VALID_HEX_SIZE = new RegExp(`^${Color.MATCH_3OR4_HEX}$|^${Color.MATCH_6OR8_HEX}$`, "i");
      /**
       * red channel
       */
      r = 0;
      /**
       * green channel
       */
      g = 0;
      /**
       * blue channel
       */
      b = 0;
      /**
       * alpha channel
       */
      a = 0;
      /**
       * create new color instance
       * @param r red channel
       * @param g green channel
       * @param b blue channel
       * @param a alpha channel
       */
      constructor(r = 1, g = 1, b = 1, a = 1) {
        this.setTo(r, g, b, a);
      }
      /***
       * convert to hdr color , channel a is intensity 
       */
      convertToHDRRGB() {
        this.r = this.r * Math.pow(2.4, this.a);
        this.g = this.g * Math.pow(2.4, this.a);
        this.b = this.b * Math.pow(2.4, this.a);
        return this;
      }
      /**
       * unSerialized color by data
       * @param data 
       * @returns 
       */
      unSerialized(data) {
        this.r = data["r"];
        this.g = data["g"];
        this.b = data["b"];
        this.a = data["a"];
        return this;
      }
      /**
       * update this color rgb from hexadecimal no alpha
       * @param value 
       */
      hexToRGB(value) {
        this.r = (value >> 16 & 255) / 255;
        this.g = (value >> 8 & 255) / 255;
        this.b = (value & 255) / 255;
        return this;
      }
      /**
       * update this color rgb from hexadecimal has alpha
       * @param value 
       */
      hexToRGBA(value) {
        this.a = (value >> 24 & 255) / 255;
        this.r = (value >> 16 & 255) / 255;
        this.g = (value >> 8 & 255) / 255;
        this.b = (value & 255) / 255;
        return this;
      }
      /**
       * random on color 
       * @returns 
       */
      static random(base = 1) {
        let color = new Color();
        color.a = base;
        color.r = base * Math.random();
        color.g = base * Math.random();
        color.b = base * Math.random();
        return color;
      }
      /**
       * generate a random color from per-channel seeds and base values
       * @returns
       */
      static randomRGB(seedR = 0.5, seedG = 0.5, seedB = 0.5, baseR = 0.5, baseG = 0.5, baseB = 0.5) {
        let color = new Color();
        color.a = 1;
        color.r = baseR + seedR * Math.random();
        color.g = baseG + seedG * Math.random();
        color.b = baseB + seedB * Math.random();
        return color;
      }
      /**
       * random on color 
       * @returns 
       */
      static randomGray(base = 0.5, random = 0.5) {
        let seed = Math.random() * random + base;
        let color = new Color();
        color.a = 1;
        color.r = seed;
        color.g = seed;
        color.b = seed;
        return color;
      }
      /**
       * set rgba to this color
       * @param r red channel
       * @param g green channel
       * @param b blue channel
       * @param a alpha channel
       */
      setTo(r, g, b, a) {
        this.r = Math.max(r, 0);
        this.g = Math.max(g, 0);
        this.b = Math.max(b, 0);
        this.a = Math.max(a, 0);
        return this;
      }
      /**
       * update this color rgba from hexadecimal 
       * @param hex hex string.
       */
      setHex(hex) {
        if (typeof hex !== "string" || Color.NON_HEX_CHARS.test(hex) || !Color.VALID_HEX_SIZE.test(hex)) {
          throw new TypeError("Expected a valid hex string");
        }
        hex = hex.replace(/^#/, "");
        let alphaFromHex = 1;
        if (hex.length === 8) {
          alphaFromHex = Number.parseInt(hex.slice(6, 8), 16) / 255;
          hex = hex.slice(0, 6);
        }
        if (hex.length === 4) {
          alphaFromHex = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
          hex = hex.slice(0, 3);
        }
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        const number = Number.parseInt(hex, 16);
        const red = number >> 16;
        const green = number >> 8 & 255;
        const blue = number & 255;
        const alpha = alphaFromHex;
        this.a = alpha;
        this.r = red / 255;
        this.g = green / 255;
        this.b = blue / 255;
        return this;
      }
      /**
       * convert this color to hex string code 
       * @returns 
       */
      getHex() {
        let getHexStr = (n) => {
          n *= 255;
          let str = n.toString(16);
          if (str.length === 1) {
            str = "0" + str;
          }
          return str;
        };
        let hex = getHexStr(this.r) + getHexStr(this.g) + getHexStr(this.b) + getHexStr(this.a);
        return hex;
      }
      /**
       * get rgb to array
       */
      get rgb() {
        return [this.r * 255 >>> 0, this.g * 255 >>> 0, this.b * 255 >>> 0];
      }
      /**
       * set rgb by array
       */
      set rgb(c) {
        this.setTo(c[0] / 255, c[1] / 255, c[2] / 255, this.a);
      }
      /**
       * get rgba to array
       */
      get rgba() {
        return [this.r * 255 >>> 0, this.g * 255 >>> 0, this.b * 255 >>> 0, this.a * 255 >>> 0];
      }
      /**
       * set rgb by array
       */
      set rgba(c) {
        this.setTo(c[0] / 255, c[1] / 255, c[2] / 255, c[3] / 255);
      }
      /**
       * clone this color
       * @returns 
       */
      clone() {
        return new Color().copy(this);
      }
      /**
       * copy color from source color
       * @returns
       */
      copy(src) {
        this.r = src.r;
        this.g = src.g;
        this.b = src.b;
        this.a = src.a;
        return this;
      }
      /**
       * copy color from array
       * @param arr [ 255 , 255 , 255 , 255 ]
       * @param scalar 
       * @returns 
       */
      copyFromArray(arr, scalar = 255) {
        this.r = arr[0] / scalar;
        this.g = arr[1] / scalar;
        this.b = arr[2] / scalar;
        this.a = arr[3] / scalar;
        return this;
      }
      /**
       * copy color from vector3 or vector4
       * @param value { x: number, y: number, z: number, w?: number }
       * @returns 
       */
      copyFromVector(value) {
        this.r = value.x;
        this.g = value.y;
        this.b = value.z;
        this.a = value.w;
        return this;
      }
      /**
       * update this color rgb from hexadecimal no alpha
       * @param hexColor rgb color
       * @param dst ref out color
       */
      static hexRGBColor(hexColor, dst = null) {
        dst = dst || new Color();
        dst.hexToRGB(hexColor);
        return dst;
      }
      /**
       * lerp two color 
       * @param v 
       * @param c1 
       * @param c2 
       * @param target 
       * @returns 
       */
      static lerp(v, c1, c2, target) {
        let ret = target ? target : new Color();
        ret.r = (c2.r - c1.r) * v + c1.r;
        ret.g = (c2.g - c1.g) * v + c1.g;
        ret.b = (c2.b - c1.b) * v + c1.b;
        ret.a = (c2.a - c1.a) * v + c1.a;
        return ret;
      }
      /** Preset color: primary. */
      static PRIMARY = 4149685;
      //
      /** Preset color: primary dark. */
      static PRIMARYDARK = 3162015;
      //
      /** Preset color: accent. */
      static ACCENT = 16728193;
      //
      /** Preset color: white. */
      static WHITE = 16777215;
      /** Preset color: ivory. */
      static IVORY = 16777200;
      /** Preset color: light yellow. */
      static LIGHTYELLOW = 16777184;
      /** Preset color: yellow. */
      static YELLOW = 16776960;
      /** Preset color: snow. */
      static SNOW = 16775930;
      /** Preset color: floral white. */
      static FLORALWHITE = 16775920;
      /** Preset color: lemon chiffon. */
      static LEMONCHIFFON = 16775885;
      /** Preset color: cornsilk. */
      static CORNSILK = 16775388;
      /** Preset color: seashell. */
      static SEASHELL = 16774638;
      /** Preset color: lavender blush. */
      static LAVENDERBLUSH = 16773365;
      /** Preset color: papaya whip. */
      static PAPAYAWHIP = 16773077;
      /** Preset color: blanched almond. */
      static BLANCHEDALMOND = 16772045;
      /** Preset color: misty rose. */
      static MISTYROSE = 16770273;
      /** Preset color: bisque. */
      static BISQUE = 16770244;
      /** Preset color: moccasin. */
      static MOCCASIN = 16770229;
      /** Preset color: navajo white. */
      static NAVAJOWHITE = 16768685;
      /** Preset color: peach puff. */
      static PEACHPUFF = 16767673;
      /** Preset color: gold. */
      static GOLD = 16766720;
      /** Preset color: pink. */
      static PINK = 16761035;
      /** Preset color: light pink. */
      static LIGHTPINK = 16758465;
      /** Preset color: orange. */
      static ORANGE = 16753920;
      /** Preset color: light salmon. */
      static LIGHTSALMON = 16752762;
      /** Preset color: dark orange. */
      static DARKORANGE = 16747520;
      /** Preset color: coral. */
      static CORAL = 16744272;
      /** Preset color: hot pink. */
      static HOTPINK = 16738740;
      /** Preset color: tomato. */
      static TOMATO = 16737095;
      /** Preset color: orange red. */
      static ORANGERED = 16729344;
      /** Preset color: deep pink. */
      static DEEPPINK = 16716947;
      /** Preset color: fuchsia. */
      static FUCHSIA = 16711935;
      /** Preset color: magenta. */
      static MAGENTA = 16711935;
      /** Preset color: red. */
      static RED = 16711680;
      /** Preset color: old lace. */
      static OLDLACE = 16643558;
      /** Preset color: light goldenrod yellow. */
      static LIGHTGOLDENRODYELLOW = 16448210;
      /** Preset color: linen. */
      static LINEN = 16445670;
      /** Preset color: antique white. */
      static ANTIQUEWHITE = 16444375;
      /** Preset color: salmon. */
      static SALMON = 16416882;
      /** Preset color: ghost white. */
      static GHOSTWHITE = 16316671;
      /** Preset color: mint cream. */
      static MINTCREAM = 16121850;
      /** Preset color: white smoke. */
      static WHITESMOKE = 16119285;
      /** Preset color: beige. */
      static BEIGE = 16119260;
      /** Preset color: wheat. */
      static WHEAT = 16113331;
      /** Preset color: sandy brown. */
      static SANDYBROWN = 16032864;
      /** Preset color: azure. */
      static AZURE = 15794175;
      /** Preset color: honeydew. */
      static HONEYDEW = 15794160;
      /** Preset color: alice blue. */
      static ALICEBLUE = 15792383;
      /** Preset color: khaki. */
      static KHAKI = 15787660;
      /** Preset color: light coral. */
      static LIGHTCORAL = 15761536;
      /** Preset color: pale goldenrod. */
      static PALEGOLDENROD = 15657130;
      /** Preset color: violet. */
      static VIOLET = 15631086;
      /** Preset color: dark salmon. */
      static DARKSALMON = 15308410;
      /** Preset color: lavender. */
      static LAVENDER = 15132410;
      /** Preset color: light cyan. */
      static LIGHTCYAN = 14745599;
      /** Preset color: burlywood. */
      static BURLYWOOD = 14596231;
      /** Preset color: plum. */
      static PLUM = 14524637;
      /** Preset color: gainsboro. */
      static GAINSBORO = 14474460;
      /** Preset color: crimson. */
      static CRIMSON = 14423100;
      /** Preset color: pale violet red. */
      static PALEVIOLETRED = 14381203;
      /** Preset color: goldenrod. */
      static GOLDENROD = 14329120;
      /** Preset color: orchid. */
      static ORCHID = 14315734;
      /** Preset color: thistle. */
      static THISTLE = 14204888;
      /** Preset color: light grey. */
      static LIGHTGREY = 13882323;
      /** Preset color: tan. */
      static TAN = 13808780;
      /** Preset color: chocolate. */
      static CHOCOLATE = 13789470;
      /** Preset color: peru. */
      static PERU = 13468991;
      /** Preset color: indian red. */
      static INDIANRED = 13458524;
      /** Preset color: medium violet red. */
      static MEDIUMVIOLETRED = 13047173;
      /** Preset color: silver. */
      static SILVER = 12632256;
      /** Preset color: dark khaki. */
      static DARKKHAKI = 12433259;
      /** Preset color: rosy brown. */
      static ROSYBROWN = 12357519;
      /** Preset color: medium orchid. */
      static MEDIUMORCHID = 12211667;
      /** Preset color: dark goldenrod. */
      static DARKGOLDENROD = 12092939;
      /** Preset color: firebrick. */
      static FIREBRICK = 11674146;
      /** Preset color: powder blue. */
      static POWDERBLUE = 11591910;
      /** Preset color: light steel blue. */
      static LIGHTSTEELBLUE = 11584734;
      /** Preset color: pale turquoise. */
      static PALETURQUOISE = 11529966;
      /** Preset color: green yellow. */
      static GREENYELLOW = 11403055;
      /** Preset color: light blue. */
      static LIGHTBLUE = 11393254;
      /** Preset color: dark gray. */
      static DARKGRAY = 11119017;
      /** Preset color: brown. */
      static BROWN = 10824234;
      /** Preset color: sienna. */
      static SIENNA = 10506797;
      /** Preset color: dark orchid. */
      static DARKORCHID = 10040012;
      /** Preset color: pale green. */
      static PALEGREEN = 10025880;
      /** Preset color: dark violet. */
      static DARKVIOLET = 9699539;
      /** Preset color: medium purple. */
      static MEDIUMPURPLE = 9662683;
      /** Preset color: light green. */
      static LIGHTGREEN = 9498256;
      /** Preset color: dark sea green. */
      static DARKSEAGREEN = 9419919;
      /** Preset color: saddle brown. */
      static SADDLEBROWN = 9127187;
      /** Preset color: dark magenta. */
      static DARKMAGENTA = 9109643;
      /** Preset color: dark red. */
      static DARKRED = 9109504;
      /** Preset color: blue violet. */
      static BLUEVIOLET = 9055202;
      /** Preset color: light sky blue. */
      static LIGHTSKYBLUE = 8900346;
      /** Preset color: sky blue. */
      static SKYBLUE = 8900331;
      /** Preset color: gray. */
      static GRAY = 8421504;
      /** Preset color: olive. */
      static OLIVE = 8421376;
      /** Preset color: purple. */
      static PURPLE = 8388736;
      /** Preset color: maroon. */
      static MAROON = 8388608;
      /** Preset color: aquamarine. */
      static AQUAMARINE = 8388564;
      /** Preset color: chartreuse. */
      static CHARTREUSE = 8388352;
      /** Preset color: lawn green. */
      static LAWNGREEN = 8190976;
      /** Preset color: medium slate blue. */
      static MEDIUMSLATEBLUE = 8087790;
      /** Preset color: light slate gray. */
      static LIGHTSLATEGRAY = 7833753;
      /** Preset color: slate gray. */
      static SLATEGRAY = 7372944;
      /** Preset color: olive drab. */
      static OLIVEDRAB = 7048739;
      /** Preset color: slate blue. */
      static SLATEBLUE = 6970061;
      /** Preset color: dim gray. */
      static DIMGRAY = 6908265;
      /** Preset color: medium aquamarine. */
      static MEDIUMAQUAMARINE = 6737322;
      /** Preset color: cornflower blue. */
      static CORNFLOWERBLUE = 6591981;
      /** Preset color: cadet blue. */
      static CADETBLUE = 6266528;
      /** Preset color: dark olive green. */
      static DARKOLIVEGREEN = 5597999;
      /** Preset color: indigo. */
      static INDIGO = 4915330;
      /** Preset color: medium turquoise. */
      static MEDIUMTURQUOISE = 4772300;
      /** Preset color: dark slate blue. */
      static DARKSLATEBLUE = 4734347;
      /** Preset color: steel blue. */
      static STEELBLUE = 4620980;
      /** Preset color: royal blue. */
      static ROYALBLUE = 4286945;
      /** Preset color: turquoise. */
      static TURQUOISE = 4251856;
      /** Preset color: medium sea green. */
      static MEDIUMSEAGREEN = 3978097;
      /** Preset color: lime green. */
      static LIMEGREEN = 3329330;
      /** Preset color: dark slate gray. */
      static DARKSLATEGRAY = 3100495;
      /** Preset color: sea green. */
      static SEAGREEN = 3050327;
      /** Preset color: forest green. */
      static FORESTGREEN = 2263842;
      /** Preset color: light sea green. */
      static LIGHTSEAGREEN = 2142890;
      /** Preset color: dodger blue. */
      static DODGERBLUE = 2003199;
      /** Preset color: midnight blue. */
      static MIDNIGHTBLUE = 1644912;
      /** Preset color: aqua. */
      static AQUA = 65535;
      /** Preset color: cyan. */
      static CYAN = 65535;
      /** Preset color: spring green. */
      static SPRINGGREEN = 65407;
      /** Preset color: lime. */
      static LIME = 65280;
      /** Preset color: medium spring green. */
      static MEDIUMSPRINGGREEN = 64154;
      /** Preset color: dark turquoise. */
      static DARKTURQUOISE = 52945;
      /** Preset color: deep sky blue. */
      static DEEPSKYBLUE = 49151;
      /** Preset color: dark cyan. */
      static DARKCYAN = 35723;
      /** Preset color: teal. */
      static TEAL = 32896;
      /** Preset color: green. */
      static GREEN = 32768;
      /** Preset color: dark green. */
      static DARKGREEN = 25600;
      /** Preset color: blue. */
      static BLUE = 255;
      /** Preset color: medium blue. */
      static MEDIUMBLUE = 205;
      /** Preset color: dark blue. */
      static DARKBLUE = 139;
      /** Preset color: navy. */
      static NAVY = 128;
      /** Preset color: black. */
      static BLACK = 0;
    }

    class Time {
      /**
       * The time the engine has been running
       */
      static time = 0;
      /**
       * the frame count engine is running
       */
      static frame = 0;
      /**
       * Time from previous frame to present
       */
      static delta = 0;
      static _startTime = 0;
      static _timeLabel = ``;
      /**
       * @internal
       * @param label
       */
      static start(label) {
        this._startTime = performance.now();
        this._timeLabel = label;
      }
      /**
       * @internal
       */
      static end() {
        console.log(this._timeLabel, performance.now() - this._startTime);
      }
    }

    class CEvent {
      /**
       * Event target, it's usually event dispatcher
       */
      target;
      /**
       * Current event target, it's current bubble object
       */
      currentTarget;
      /**
       * event type, it's registered string of key
       */
      type;
      /**
       * extra data.Used for the transmission process of events, carrying data
       */
      data;
      /**
       *
       * The param data when event is registered
       */
      param;
      /**
       *
       * the time when event is
       */
      time = 0;
      /**
       *
       *the delay time when event is dispatched.
       */
      delay = 0;
      /**
       *
       * mouse code, see @MouseCode {@link MouseCode}
       */
      mouseCode = 0;
      /**
       * Is Ctrl key pressed when the event occurs
       */
      ctrlKey;
      /**
       * Is Meta key pressed when the event occurs
       */
      metaKey;
      /**
       * Is Alt key pressed when the event occurs
       */
      altKey;
      /**
       * Is Shift key pressed when the event occurs
       */
      shiftKey;
      /**
       * Collection of finger touch points, which registered
       */
      targetTouches;
      /**
       * Collection of finger touch points changed
       */
      changedTouches;
      /**
       * Collection of finger touch points
       */
      touches;
      _stopImmediatePropagation = false;
      /**
       * binded view3D object in event.
       */
      view;
      /**
       *
       * Create a new event, with type and data
       * @param eventType {any} eventType
       * @param data {any} param
       */
      constructor(eventType = null, data = null) {
        this.type = eventType;
        this.data = data;
      }
      /**
       *
       * Prevent bubbling of all event listeners in subsequent nodes of the current node in the event flow.
       */
      stopImmediatePropagation() {
        this._stopImmediatePropagation = true;
      }
      /**
       * @internal
       * set stopImmediatePropagation as false
       */
      reset() {
        this._stopImmediatePropagation = false;
      }
      /**
       * Returns stopImmediatePropagation value
       */
      get isStopImmediatePropagation() {
        return this._stopImmediatePropagation;
      }
    }

    class CEventListener {
      /**
       *
       * @param type {string} event type
       * @param thisObject {any} the object is registerd
       * @param handler {Function} The callback function that handles events. 
       * @param param {any} Parameters bound when registering events
       * @param priority {number} The priority of callback function execution, with a larger set value having priority to call
       */
      constructor(type = null, thisObject = null, handler = null, param = null, priority = 0) {
        this.type = type;
        this.thisObject = thisObject;
        this.handler = handler;
        this.param = param;
        this.priority = priority;
      }
      /**
       * @private
       */
      static event_id_count = 0;
      /**
       *
       * Record a id. When registering a listening event, the value will increase automatically
       */
      id = 0;
      /**
       *
       * Returns current event dispatcher
       */
      current;
      /**
       *
       * Compare whether two events are the same
       * @param type {string} event type
       * @param handler {Function} The callback function that handles events. 
       * @param thisObject {any} the object is registerd
       * @param param {any} Parameters bound when registering events
       * @returns {boolean} Returns a boolean
       */
      equalCurrentListener(type, handler, thisObject, param) {
        if (this.type == type && this.thisObject == thisObject && this.handler == handler && this.param == param) {
          return true;
        }
        return false;
      }
      /**
       *
       * release all registered event.
       */
      dispose() {
        this.handler = null;
        this.thisObject = null;
        this.param = null;
        this.priority = 0;
      }
    }

    class CEventDispatcher {
      /**
       * @internal
       */
      listeners = {};
      /**
       * @internal
       */
      data;
      /**
       *
       * Dispatch an event to all registered objects with a specific type of listener.
       * @param event3D the event is dispatched.
       */
      dispatchEvent(event) {
        var list = this.listeners[event.type];
        if (list != null) {
          list = list.slice();
          for (var i = 0; i < list.length; i++) {
            var listener = list[i];
            if (listener.handler) {
              try {
                event.param = listener.param;
                event.currentTarget = listener;
                if (!listener.thisObject) {
                }
                listener.handler.call(listener.thisObject, event);
              } catch (error) {
                throw error;
              }
              if (event.isStopImmediatePropagation) {
                break;
              }
            }
          }
        }
      }
      /**
       *
       * release all registered event.
       */
      destroy() {
        for (var key in this.listeners) {
          var list = this.listeners[key];
          while (list.length > 0) {
            var listener = list[0];
            listener.handler = null;
            listener.thisObject = null;
            list.splice(0, 1);
          }
        }
      }
      /**
       *
       * register an event listener to event distancher.
       * @param type {string} event type.
       * @param callback {Function} The callback function that handles events. 
       * This function must accept an Event3D object as its unique parameter and cannot return any result.
       * for example: function(evt:Event3D):void.
       * @param thisObject {any} Current registration object, it'll call callback function.
       * @param param {any} the data binded to registered event, the default value is null.
       * @param priority {number} The priority of callback function execution, with a larger set value having priority to call
       * @returns {number} Returns register event id
       */
      addEventListener(type, callback, thisObject, param = null, priority = 0) {
        if (this.listeners[type] == null) {
          this.listeners[type] = [];
        }
        if (!this.hasEventListener(type, callback, thisObject)) {
          var listener = new CEventListener(type, thisObject, callback, param, priority);
          listener.id = ++CEventListener.event_id_count;
          listener.current = this;
          this.listeners[type].push(listener);
          this.listeners[type].sort(function(listener1, listener2) {
            return listener2.priority - listener1.priority;
          });
          return listener.id;
        }
        for (let i = 0; i < this.listeners[type].length; i++) {
          let listener2 = this.listeners[type][i];
          if (listener2.equalCurrentListener(type, callback, thisObject, param)) {
            return listener2.id;
          }
        }
        return 0;
      }
      /**
       *
       * Remove Event Listening
       * @param type {string} event type
       * @param callback {Function} callback function of event register
       * @param thisObject {any} The current registered object.
       */
      removeEventListener(type, callback, thisObject) {
        if (this.hasEventListener(type, callback, thisObject)) {
          for (var i = 0; i < this.listeners[type].length; i++) {
            var listener = this.listeners[type][i];
            if (listener.equalCurrentListener(type, callback, thisObject, listener.param)) {
              listener.handler = null;
              listener.thisObject = null;
              this.listeners[type].splice(i, 1);
              return;
            }
          }
        }
      }
      /**
       *
       * Remove an event Listening with id
       * @param register event id, see {@link addEventListener}
       * Returns true when removed success.
       */
      removeEventListenerAt(id) {
        for (var key in this.listeners) {
          for (var i = 0; i < this.listeners[key].length; i++) {
            var listener = this.listeners[key][i];
            if (listener.id == id) {
              listener.handler = null;
              listener.thisObject = null;
              this.listeners[key].splice(i, 1);
              return true;
            }
          }
        }
        return false;
      }
      /**
       *
       * Specify a event type to remove all related event listeners
       * eventType event type, set null to remove all event listeners
       */
      removeAllEventListener(eventType = null) {
        let listener;
        if (eventType) {
          if (this.listeners[eventType]) {
            for (var i = 0; i < this.listeners[eventType].length; i++) {
              listener = this.listeners[eventType][i];
              listener.dispose();
              this.listeners[eventType].splice(i, 1);
            }
            delete this.listeners[eventType];
          }
        } else {
          for (let key in this.listeners) {
            for (var i = 0; i < this.listeners[key].length; i++) {
              listener = this.listeners[key][i];
              listener.dispose();
              this.listeners[key].splice(i, 1);
            }
            delete this.listeners[key];
          }
        }
      }
      /**
       *
       * whether the target presence of a listener with event type.
       * @param type {string} event type.
       * @returns {boolean} Returns a boolean.
       */
      containEventListener(type) {
        if (this.listeners[type] == null) return false;
        return this.listeners[type].length > 0;
      }
      /**
       *
       * whether the target presence of a listener with event type. it associate more registration parameters.
       * @param type {string} event name.
       * @param callback {Function} callback function of event register.
       * @param thisObject {any} The registered object.
       * @returns {boolean} Returns a boolean.
       */
      hasEventListener(type, callback = null, thisObject = null) {
        if (this.listeners[type] == null) return false;
        if (thisObject && callback) {
          for (var i = 0; i < this.listeners[type].length; i++) {
            var listener = this.listeners[type][i];
            if (listener.equalCurrentListener(type, callback, thisObject, listener.param)) {
              return true;
            }
          }
        }
        return false;
      }
    }

    class KeyEvent extends CEvent {
      /**
       *
       * Constant Definition Key Press Event Identification
       * Event response status: Responds every time the keyboard is pressed.
       * Response event parameters: keyboard key
       * @platform Web,Native
       */
      static KEY_DOWN = "onKeyDown";
      /**
       *
       * Constant Definition Key up Event Identification
       * Event response status: Responds every time the keyboard is released.
       * Response event parameters: keyboard key
       * @platform Web,Native
       */
      static KEY_UP = "onKeyUp";
      /**
       *
       * Key code value, enumeration type see KeyCode {@link KeyCode}
       * @default 0
       * @platform Web,Native
       */
      keyCode = 0;
    }

    class PointerEvent3D extends CEvent {
      /**
       * Triggered when the touch point enters the collision
       */
      static PICK_OVER = "onPickOver";
      /**
       * Triggered when the touch point clicked the collision
       */
      static PICK_CLICK = "onPickClick";
      /**
      * Triggered when the touch point leave the collision
      */
      static PICK_OUT = "onPickOut";
      /**
      * Triggered when the touch point move on the collision
      */
      static PICK_MOVE = "onPickMove";
      /**
       * Triggered when the touch point release from the collision
       */
      static PICK_UP = "onPickUp";
      /**
       * Triggered when the touch point pressed the collision
       */
      static PICK_DOWN = "onPickDown";
      /**
       *
       * Triggered when the right pointer clicked
       */
      static POINTER_RIGHT_CLICK = "onPointerRightClick";
      /**
       * Triggered when the pointer clicked  
       */
      static POINTER_CLICK = "onPointerClick";
      /**
       *
       * Triggered when the pointer moved  
       */
      static POINTER_MOVE = "onPointerMove";
      /**
       *
       * Triggered when the pointer pressed  
       */
      static POINTER_DOWN = "onPointerDown";
      /**
       *
       * Triggered when the pointer released  
       */
      static POINTER_UP = "onPointerUp";
      /**
       *
       * Triggered when the pointer move out  
       */
      static POINTER_OUT = "onPointerOut";
      /**
       *
       * Triggered when the pointer move over  
       */
      static POINTER_OVER = "onPointerOver";
      /**
       *
       * Triggered when the wheel pointer is used
       */
      static POINTER_WHEEL = "onPointerWheel";
      /**
       * A unique identifier for an event caused by a pointer.
       */
      pointerId;
      /**
       * event type
       */
      pointerType = "onPointer";
      /**
       * whether it's the preferred pointer in this type of pointer.
       */
      isPrimary;
      /**
       * Normalize values
       */
      pressure;
      /**
       * coord x of mouse
       */
      mouseX;
      /**
       * coord y of mouse
       */
      mouseY;
      /**
       * delta of coord x of mouse
       */
      movementX;
      /**
       * delta of coord y of mouse
       */
      movementY;
      /**
       * Returns a negative value when scrolling left, 
       * a positive value when scrolling right, otherwise 0.
       */
      deltaX;
      /**
       * Returns a positive value when scrolling down,
       * a negative value when scrolling up, otherwise 0.
       */
      deltaY;
      /**
       * @internal
       */
      deltaZ;
      /**
       * @internal
       */
      reset() {
        super.reset();
        this.mouseX = 0;
        this.mouseY = 0;
        this.movementX = 0;
        this.movementY = 0;
        this.deltaX = 0;
        this.deltaY = 0;
        this.deltaZ = 0;
      }
    }

    class Vector3 {
      /**
       * Vector maximum
       */
      static MAX = new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
      /**
       * Vector minimum
       */
      static MIN = new Vector3(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
      /**
       * Vector maximum integer value
       */
      static SAFE_MAX = new Vector3(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
      /**
       * Vector minimum integer value
       */
      static SAFE_MIN = new Vector3(Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
      /**
       * X axis positive axis coordinate (1, 0, 0).
       */
      static X_AXIS = new Vector3(1, 0, 0);
      /**
       * The X-axis is negative (-1, 0, 0).
       */
      static neg_X_AXIS = new Vector3(-1, 0, 0);
      /**
       * The y axis defined as a Vector3 object with coordinates (0,1,0).
       */
      static Y_AXIS = new Vector3(0, 1, 0);
      /**
       * The z axis defined as a Vector3 object with coordinates (0,0,1).
       */
      static Z_AXIS = new Vector3(0, 0, 1);
      /**
       * @internal
       */
      static HELP_0 = new Vector3();
      /**
       * @internal
       */
      static HELP_1 = new Vector3();
      /**
       * @internal
       */
      static HELP_2 = new Vector3();
      /**
       * @internal
       */
      static EPSILON = 1e-5;
      /**
       * @internal
       */
      static HELP_3 = new Vector3();
      /**
       * @internal
       */
      static HELP_4 = new Vector3();
      /**
       * @internal
       */
      static HELP_5 = new Vector3();
      /**
       * @internal
       */
      static HELP_6 = new Vector3();
      /**
       * Returns a new vector with zero x, y, and z components
       */
      static get ZERO() {
        return new Vector3(0, 0, 0);
      }
      /**
       * Returns a new vector whose x, y, and z components are all 1
       */
      static get ONE() {
        return new Vector3(1, 1, 1);
      }
      /**
       * Returns a new vector pointing to the left, x is -1, y is 0, and z is 0
       */
      static get LEFT() {
        return new Vector3(-1, 0, 0);
      }
      /**
       * Returns a new vector pointing in the right direction, where x is 1, y is 0, and z is 0
       */
      static get RIGHT() {
        return new Vector3(1, 0, 0);
      }
      /**
       * Returns a new vector pointing upwards, that is, x equals 0, y equals 1, and z equals 0
       */
      static get UP() {
        return new Vector3(0, 1, 0);
      }
      /**
       * Returns a new vector pointing down, where x is 0, y is -1, and z is 0
       */
      static get DOWN() {
        return new Vector3(0, -1, 0);
      }
      /** 
       * Returns a new backward vector, x equals 0, y equals 0, and z equals negative 1
       */
      static get BACK() {
        return new Vector3(0, 0, -1);
      }
      /**
       * Returns a new forward-pointing vector, that is, x is 0, y is 0, and z is 1
       */
      static get FORWARD() {
        return new Vector3(0, 0, 1);
      }
      /**
       * The first element of a Vector3 object, such as the x coordinate of
       * a point in the three-dimensional space. The default value is 0.
       */
      x = 0;
      /**
       * The second element of a Vector3 object, such as the y coordinate of
       * a point in the three-dimensional space. The default value is 0.
       */
      y = 0;
      /**
       * The third element of a Vector3 object, such as the y coordinate of
       * a point in the three-dimensional space. The default value is 0.
       */
      z = 0;
      /**
       * The z component of the vector,
       * A three-dimensional position or projection that can be used as a perspective projection
       * We can also do w in the quaternion
       */
      w = 1;
      /**
       * @internal
       */
      index = 0;
      /**
       * @internal
       */
      static _index = 0;
      /**
       * Creates an instance of a Vector3 object. If you do not specify a.
       * parameter for the constructor, a Vector3 object is created with
       * the elements (0,0,0,0).
       *
       * @param x The first element, such as the x coordinate.
       * @param y The second element, such as the y coordinate.
       * @param z The third element, such as the z coordinate.
       * @param w An optional element for additional data such as the angle
       *          of rotation.
       */
      constructor(x = 0, y = 0, z = 0, w = 0) {
        this.set(x, y, z, w);
        this.index = Vector3._index++;
      }
      /**
       *  Set w component
       * @param value
       */
      set a(value) {
        this.w = value;
      }
      /**
       *  Set x component
       * @param value 
       */
      set r(value) {
        this.x = value;
      }
      /**
       *  Set the y component
       * @param value 
       */
      set g(value) {
        this.y = value;
      }
      /**
       *  Set z component
       * @param value 
       */
      set b(value) {
        this.z = value;
      }
      /**
       *  get the w component
       * @returns value of w
       */
      get a() {
        return this.w;
      }
      /**
       *  get the x component
       * @returns value of x
       */
      get r() {
        return this.x;
      }
      /**
       *  get the y component
       * @returns value of y
       */
      get g() {
        return this.y;
      }
      /**
       *  get the z component
       * @returns value of z
       */
      get b() {
        return this.z;
      }
      /**
       * The length of the vector, the distance from the origin (0, 0, 0) to (x, y, z)
       */
      get length() {
        return Math.sqrt(this.lengthSquared);
      }
      /**
       * You get the square of the length of the vector
       * @returns 
       */
      get lengthSquared() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
      }
      /**
       * Get the current vector
       */
      get position() {
        return this;
      }
      /**
       *  Obtain a vertical line segment with width through an orientation
       * @param dir
       * @param tp1
       * @param tp2
       * @param width
       */
      static getTowPointbyDir(dir, tp1, tp2, width, aix) {
        if (aix == Vector3.Z_AXIS) {
          tp1.x = dir.y;
          tp1.y = -dir.x;
          tp2.x = -dir.y;
          tp2.y = dir.x;
          tp1.multiplyScalar(width * 0.5);
          tp2.multiplyScalar(width * 0.5);
        } else if (aix == Vector3.Y_AXIS) {
          tp1.x = dir.z;
          tp1.z = -dir.x;
          tp2.x = -dir.z;
          tp2.z = dir.x;
          tp1.multiplyScalar(width * 0.5);
          tp2.multiplyScalar(width * 0.5);
        }
      }
      /**
       * Calculate the distance from the point to the line
       * @param point1 Starting point of line segment
       * @param point2 End point of line segment
       * @param position Point position
       * @returns Distance from a point to a line segment
       */
      static pointToLine(point1, point2, position) {
        let space = 0;
        let a, b, c;
        a = Vector3.distance(point1, point2);
        b = Vector3.distance(point1, position);
        c = Vector3.distance(point2, position);
        if (c <= 1e-6 || b <= 1e-6) {
          space = 0;
          return space;
        }
        if (a <= 1e-6) {
          space = b;
          return space;
        }
        if (c * c >= a * a + b * b) {
          space = b;
          return space;
        }
        if (b * b >= a * a + c * c) {
          space = c;
          return space;
        }
        let p = (a + b + c) / 2;
        let s = Math.sqrt(p * (p - a) * (p - b) * (p - c));
        space = 2 * s / a;
        return space;
      }
      /**
       * Take the dot product of two vectors.
       * @param a Vector a
       * @param b Vector b
       * @returns 
       */
      static dot(a, b) {
        return a.x * b.x + a.y * b.y + a.z * b.z;
      }
      /** Generate `total` random Vector3 points within a cube of side `randSeed` centered at origin. */
      static getPoints(total, randSeed) {
        let points = [];
        for (let index = 0; index < total; index++) {
          const element = new Vector3(Math.random() * randSeed - randSeed * 0.5, Math.random() * randSeed - randSeed * 0.5, Math.random() * randSeed - randSeed * 0.5);
          points.push(element);
        }
        return points;
      }
      /** Generate `total` random points as a flat number array (x, y, z, ...) within a cube of side `randSeed`. */
      static getPointNumbers(total, randSeed) {
        let points = [];
        for (let index = 0; index < total; index++) {
          points.push(Math.random() * randSeed - randSeed * 0.5, Math.random() * randSeed - randSeed * 0.5, Math.random() * randSeed - randSeed * 0.5);
        }
        return points;
      }
      /**
       * Returns the Angle, in degrees, between the source vector and the target vector.
       * @param from source vector.
       * @param to target vector.
       * @returns 
       */
      static getAngle(from, to) {
        let t = from.dotProduct(to) / (from.length * to.length);
        return Math.acos(t) * 180 / Math.PI;
      }
      /** Returns the squared magnitude (x^2 + y^2 + z^2) of the given vector. */
      static sqrMagnitude(arg0) {
        return arg0.x * arg0.x + arg0.y * arg0.y + arg0.z * arg0.z;
      }
      /** Returns the angle, in degrees, between two vectors projected onto the ZY plane. */
      static getZYAngle(zd, yd) {
        return this.calAngle(zd.y, zd.z, yd.y, yd.z);
      }
      /**
       * Subtract two vectors
       * @param a Vector a
       * @param b Vector b
       * @param target output vector
       * @returns 
       */
      static sub(a, b, target = null) {
        target = target || new Vector3();
        target.x = a.x - b.x;
        target.y = a.y - b.y;
        target.z = a.z - b.z;
        return target;
      }
      /**
       * Add two vectors
       * @param a Vector a
       * @param b Vector b
       * @param target output vector
       * @returns 
       */
      static add(a, b, target = null) {
        target = target || new Vector3();
        target.x = a.x + b.x;
        target.y = a.y + b.y;
        target.z = a.z + b.z;
        return target;
      }
      /**
       * Component-wise multiply two vectors
       */
      static multiply(a, b, result) {
        result ||= new Vector3();
        result.x = a.x * b.x;
        result.y = a.y * b.y;
        result.z = a.z * b.z;
        return result;
      }
      /**
       * Component-wise divide two vectors
       */
      static divide(a, b, result) {
        result ||= new Vector3();
        result.x = a.x / b.x;
        result.y = a.y / b.y;
        result.z = a.z / b.z;
        return result;
      }
      /**
       * Multiply a vector by a scalar
       */
      static multiplyScalar(a, s, result) {
        result ||= new Vector3();
        result.x = a.x * s;
        result.y = a.y * s;
        result.z = a.z * s;
        return result;
      }
      /**
       * result = a + b * s
       */
      static addScaledVector(a, b, s, result) {
        result ||= new Vector3();
        result.x = a.x + b.x * s;
        result.y = a.y + b.y * s;
        result.z = a.z + b.z * s;
        return result;
      }
      /**
       * Cross product of two vectors
       */
      static cross(a, b, result) {
        result ||= new Vector3();
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        result.x = ay * bz - az * by;
        result.y = az * bx - ax * bz;
        result.z = ax * by - ay * bx;
        result.w = 1;
        return result;
      }
      /**
       * Negate a vector
       */
      static negate(a, result) {
        result ||= new Vector3();
        result.x = -a.x;
        result.y = -a.y;
        result.z = -a.z;
        return result;
      }
      /**
       * Component-wise minimum of two vectors
       */
      static min(a, b, result) {
        result ||= new Vector3();
        result.x = Math.min(a.x, b.x);
        result.y = Math.min(a.y, b.y);
        result.z = Math.min(a.z, b.z);
        return result;
      }
      /**
       * Component-wise maximum of two vectors
       */
      static max(a, b, result) {
        result ||= new Vector3();
        result.x = Math.max(a.x, b.x);
        result.y = Math.max(a.y, b.y);
        result.z = Math.max(a.z, b.z);
        return result;
      }
      /**
       * @internal
       * @param current 
       * @param target 
       * @param currentVelocity 
       * @param smoothTime 
       * @param maxSpeed 
       * @param deltaTime 
       * @returns 
       */
      static smoothDamp(current, target, currentVelocity, smoothTime, maxSpeed, deltaTime) {
        return null;
      }
      /**
       * Calculate the distance between two vectors
       * @param pt1 Vector 1
       * @param pt2 Vector 2
       * @returns number The distance between two vectors
       */
      static distance(pt1, pt2) {
        var x = pt1.x - pt2.x;
        var y = pt1.y - pt2.y;
        var z = pt1.z - pt2.z;
        return Math.sqrt(x * x + y * y + z * z);
      }
      /**
       * Calculate the square distance between two vectors
       * @param pt1 Vector 1
       * @param pt2 Vector 2
       * @returns number The square distance between two vectors
       */
      static squareDistance(pt1, pt2) {
        var x = pt1.x - pt2.x;
        var y = pt1.y - pt2.y;
        var z = pt1.z - pt2.z;
        return x * x + y * y + z * z;
      }
      /**
       * Calculate the distance between two vectors XZ axes
       * @param pt1 Vector 1
       * @param pt2 Vector 2
       * @returns number The distance between two vectors
       */
      static distanceXZ(pt1, pt2) {
        var x = pt1.x - pt2.x;
        var y = 0;
        var z = pt1.z - pt2.z;
        return Math.sqrt(x * x + y * y + z * z);
      }
      /**
       * Sets the current vector x, y, z, and w components
       * @param x 
       * @param y 
       * @param z 
       * @param w 
       * @returns 
       */
      set(x, y, z, w = 1) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
      }
      /**
       * Adds vector `a` to this vector (component-wise on xyz). Mutates and returns this.
       */
      add(a) {
        return Vector3.add(this, a, this);
      }
      /** Set this = a + b. Ternary mutator form. */
      addVectors(a, b) {
        return Vector3.add(a, b, this);
      }
      /** Set this = a - b. Mutates and returns this. */
      subVectors(a, b) {
        return Vector3.sub(a, b, this);
      }
      /** Set this = a * b component-wise. */
      multiplyVectors(a, b) {
        return Vector3.multiply(a, b, this);
      }
      /** Add scalar to x, y, and z. Mutates and returns this. */
      addScalar(scalar) {
        this.x += scalar;
        this.y += scalar;
        this.z += scalar;
        return this;
      }
      /** Subtract scalar from x, y, and z. Mutates and returns this. */
      subScalar(scalar) {
        this.x -= scalar;
        this.y -= scalar;
        this.z -= scalar;
        return this;
      }
      /**
       * Component-wise minimum with `v`. Mutates and returns this.
       */
      min(v) {
        return Vector3.min(this, v, this);
      }
      /**
       * Component-wise maximum with `v`. Mutates and returns this.
       */
      max(v) {
        return Vector3.max(this, v, this);
      }
      /** Squared Euclidean distance from this vector to v. */
      distanceToSquared(v) {
        let dx = this.x - v.x;
        let dy = this.y - v.y;
        let dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
      }
      /**
       * Adds (x, y, z, w) to each component. Mutates and returns this.
       */
      addXYZW(x, y, z, w) {
        this.x += x;
        this.y += y;
        this.z += z;
        this.w += w;
        return this;
      }
      /**
       * Clone a vector with the same components as the current vector
       */
      clone() {
        return new Vector3(this.x, this.y, this.z, this.w);
      }
      /**
       * The components of the source vector are set to the current vector
       * @param src Original vector
       * @returns 
       */
      /**
       * Subtract two vectors and assign the result to yourself
       * @param a Minus vector
       */
      decrementBy(a) {
        this.x -= a.x;
        this.y -= a.y;
        this.z -= a.z;
        return this;
      }
      /**
       * 
       * Calculate the dot product of two vectors and return the Angle relationship between the two vectors
       * @param a The vector that you need to compute
       * @returns number Returns the Angle relationship between two vectors
       */
      dotProduct(a) {
        return this.x * a.x + this.y * a.y + this.z * a.z;
      }
      // /**
      //  * @language en_US
      //  * @param toCompare The Vector3 object to be compared with the current
      //  *                  Vector3 object.
      //  * @param allFour   An optional parameter that specifies whether the w
      //  *                  property of the Vector3 objects is used in the
      //  *                  comparison.
      //  * @returns 
      //  *          to the current Vector3 object; false if it is not equal.
      //  */
      /**
       * 
       * Find whether the values of two vectors are identical
       * @param toCompare The vector to compare
       * @param allFour The default parameter is 1, whether to compare the w component
       * @returns A value of true if the specified Vector3 object is equal to the current Vector3 object; false if it is not equal.
       */
      equals(toCompare, allFour = false) {
        return this.x == toCompare.x && this.y == toCompare.y && this.z == toCompare.z && (!allFour || this.w == toCompare.w);
      }
      // /**
      //  * @language en_US
      //  * Increments the value of the x, y, and z elements of the current
      //  * Vector3 object by the values of the x, y, and z elements of a
      //  * specified Vector3 object. Unlike the <code>Vector3.add()</code>
      //  * method, the <code>incrementBy()</code> method changes the current
      //  * Vector3 object and does not return a new Vector3 object.
      //  *
      //  * @param a The Vector3 object to be added to the current Vector3
      //  *          object.
      //  */
      /**
       * The current vector plus is equal to the vector, plus just the x, y, and z components
       * @param a vector
       */
      incrementBy(a) {
        this.x += a.x;
        this.y += a.y;
        this.z += a.z;
        return this;
      }
      /**
       * Component-wise divides this vector by `v`. Mutates and returns this.
       */
      divide(v) {
        return Vector3.divide(this, v, this);
      }
      /**
       * Sets the current Vector3 object to its inverse. The inverse object
       * is also considered the opposite of the original object. The value of
       * the x, y, and z properties of the current Vector3 object is changed
       * to -x, -y, and -z.
       */
      negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
      }
      /**
       * Scales the line segment between(0,0) and the current point to a set
       * length.
       *
       * @param thickness The scaling value. For example, if the current
       * Vector3 object is (0,3,4), and you normalize it to
       * 1, the point returned is at(0,0.6,0.8).
       */
      normalize(thickness = 1) {
        let self = this;
        if (this.length != 0) {
          var invLength = thickness / this.length;
          this.x *= invLength;
          this.y *= invLength;
          this.z *= invLength;
          return self;
        }
        return self;
      }
      /**
       * Apply the rotation quaternion
       * @param q quaternion
       * @returns 
       */
      applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
      }
      /** Transform this vector as a point by Matrix4 m. Mutates and returns this. */
      applyMatrix4(m) {
        return m.transformPoint(this);
      }
      /**
       * @language en_US
       * Sets the members of Vector3 to the specified values
       *
       * @param xa The first element, such as the x coordinate.
       * @param ya The second element, such as the y coordinate.
       * @param za The third element, such as the z coordinate.
       */
      setTo(xa, ya, za, wa = 1) {
        this.x = xa;
        this.y = ya;
        this.z = za;
        this.w = wa;
      }
      /**
       * Copy the components of the source vector to this vector
       * @param src Source vector
       * @returns 
       */
      copy(src) {
        this.x = src.x;
        this.y = src.y;
        this.z = src.z;
        this.w = src.w;
        return this;
      }
      /**
       * @language en_US
       * Subtracts the value of the x, y, and z elements of the current
       * Vector3 object from the values of the x, y, and z elements of
       * another Vector3 object. Returns a new Vector3.
       *
       * @param a The Vector3 object to be subtracted from the current
       *          Vector3 object.
       * @returns A new Vector3 object that is the difference between the
       *          current Vector3 and the specified Vector3 object.
       */
      sub(a) {
        return Vector3.sub(this, a, this);
      }
      /**
       * Component-wise multiplies this vector by `other`. Mutates and returns this.
       */
      multiply(other) {
        return Vector3.multiply(this, other, this);
      }
      /**
      * Computes the linear interpolation between two Vector3, and the result is the current object
      * @param v0 Vector 1
      * @param v1 Vector 2
      * @param t Interpolation factor
      */
      lerp(v0, v1, t) {
        var v0x = v0.x, v0y = v0.y, v0z = v0.z, v0w = v0.w;
        var v1x = v1.x, v1y = v1.y, v1z = v1.z, v1w = v1.w;
        this.x = (v1x - v0x) * t + v0x;
        this.y = (v1y - v0y) * t + v0y;
        this.z = (v1z - v0z) * t + v0z;
        this.w = (v1w - v0w) * t + v0w;
      }
      /**
       * The x, y, and z components of this vector are rounded upward to the nearest integers.
       * @param min minimum value
       * @param max maximum value
       * @returns 
       */
      clamp(min, max) {
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
      }
      //     /**
      //    *
      //    * Computes the linear interpolation between two Vector3, and the result is the current object
      //    * @param lhs Vector3 1
      //    * @param rhs Vector3 2
      //    * @param t Interpolation factor
      //    */
      //     public slerp(lhs: Vector3, rhs: Vector3, t: number): void {
      //         var lhsMag: number = Math.sqrt(this.Dot(lhs, lhs));
      //         var rhsMag: number = Math.sqrt(this.Dot(rhs, rhs));
      //         if (lhsMag < 0.00001 || rhsMag < 0.00001) {
      //             return this.lerp(lhs, rhs, t);
      //         }
      //         var lerpedMagnitude: number = lhsMag + t * (rhsMag - lhsMag);
      //         var dot: number = this.Dot(lhs, rhs) / (lhsMag * rhsMag);
      //         // direction is almost the same
      //         if (dot > 1.0 - 0.00001) {
      //             return this.lerp(lhs, rhs, t);
      //         }
      //         // directions are almost opposite
      //         else if (dot < -1.0 + 0.00001) {
      //             Vector3.HELP_0.copy(lhs);
      //             var lhsNorm: Vector3 = Vector3.HELP_0.divide(lhsMag);
      //             this.OrthoNormalVectorFast(lhsNorm, Vector3.HELP_1);
      //             var axis: Vector3 = Vector3.HELP_1;
      //             Quaternion.HELP_0.setFromAxisAngle(Vector3.HELP_1, 3.1415926 * t * MathConfig.RADIANS_TO_DEGREES);
      //             var m: Matrix4 = Quaternion.HELP_0.toMatrix3D(Matrix4.helpMatrix);
      //             m.transformVector4(lhsNorm, this);
      //             this.multiplyScalar(lerpedMagnitude);
      //             return;
      //         }
      //         // normal case
      //         else {
      //             lhs.dotProduct;
      //             this.Cross(lhs, rhs, Vector3.HELP_0);
      //             var axis: Vector3 = Vector3.HELP_0;
      //             Vector3.HELP_1.copy(lhs);
      //             var lhsNorm: Vector3 = Vector3.HELP_1.divide(lhsMag);
      //             axis.normalize();
      //             var angle: number = Math.acos(dot) * t;
      //             Quaternion.HELP_0.setFromAxisAngle(axis, angle * MathConfig.RADIANS_TO_DEGREES);
      //             var m: Matrix4 = Quaternion.HELP_0.toMatrix3D(Matrix4.helpMatrix);
      //             m.transformVector4(lhsNorm, this);
      //             this.multiplyScalar(lerpedMagnitude);
      //             return;
      //         }
      //     }
      /**
       * Returns the string form of the current vector
       * @returns 
       */
      toString() {
        return "<" + this.x + ", " + this.y + ", " + this.z + ">";
      }
      //  */
      // public vertical(a: Vector3, dir: Vector3, target: Vector3) {
      //   let DoT = Vector3.dot(dir, target);
      //   if (DoT > 0) {
      //     target.x = a.y;
      //     target.y = -a.x;
      //   } else {
      //     target.x = -a.y;
      //     target.y = a.x;
      //   }
      // }
      /** Snap this vector to the nearest 2D axis direction (LEFT/RIGHT/UP/DOWN) based on x and y. */
      normalizeToWay2D_XY() {
        let tx = Math.abs(this.x);
        let ty = Math.abs(this.y);
        if (tx > ty) {
          if (this.x > 0) {
            this.copy(Vector3.RIGHT);
          } else {
            this.copy(Vector3.LEFT);
          }
        } else {
          if (this.y > 0) {
            this.copy(Vector3.DOWN);
          } else {
            this.copy(Vector3.UP);
          }
        }
      }
      /** Returns the x, y, and z components as a new array. */
      toArray() {
        return [this.x, this.y, this.z];
      }
      /** Write x, y, and z as little-endian float32 values into the DataView. */
      copyToBytes(byte) {
        byte.setFloat32(0 * Float32Array.BYTES_PER_ELEMENT, this.x, true);
        byte.setFloat32(1 * Float32Array.BYTES_PER_ELEMENT, this.y, true);
        byte.setFloat32(2 * Float32Array.BYTES_PER_ELEMENT, this.z, true);
      }
      /**
       * You take the cross product of two vectors,
       * The cross product is going to be the perpendicular vector between these two vectors
       * @param a Take the cross product of another vector
       * @returns Vector3 returns the cross product vector
       */
      /**
       * Cross product with another vector. Returns a new Vector3.
       */
      cross(a) {
        return Vector3.cross(this, a, this);
      }
      /** Set this = cross product of a and b. Mutates and returns this. */
      crossVectors(a, b) {
        Vector3.cross(a, b, this);
        return this;
      }
      /** Multiply x, y, and z by scalar. Mutates and returns this. */
      multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
      }
      /** Set x/y/z from array starting at firstElementPos. */
      setFromArray(array, firstElementPos = 0) {
        this.x = array[firstElementPos];
        this.y = array[firstElementPos + 1];
        this.z = array[firstElementPos + 2];
      }
      /**
       * Divides this vector by scalar. Mutates and returns this.
       */
      divideScalar(scalar) {
        return Vector3.multiplyScalar(this, 1 / scalar, this);
      }
      /**
       * Clamps the length of this vector into [min, max]. Mutates and returns this.
       */
      clampLength(min, max) {
        let length = this.length;
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
      }
      /** Set x, y, and z all to value. Mutates and returns this. */
      setScalar(value) {
        this.x = value;
        this.y = value;
        this.z = value;
        return this;
      }
      /** Add v * scale to this vector. Mutates and returns this. */
      addScaledVector(v, scale) {
        this.x += v.x * scale;
        this.y += v.y * scale;
        this.z += v.z * scale;
        return this;
      }
      // -------- Standard instance API --------
      /** Dot product. Canonical alias of {@link dotProduct}. */
      dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
      }
      /** Squared length of this vector. */
      lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
      }
      /** Euclidean distance to v. */
      distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
      }
      /** Angle between this and v, in radians (range [0, π]). */
      angleTo(v) {
        const denom = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denom === 0) return Math.PI / 2;
        const theta = this.dot(v) / denom;
        return Math.acos(Math.max(-1, Math.min(1, theta)));
      }
      /** Set this to v1 + (v2 - v1) * alpha. Canonical alias of {@link lerp}. */
      lerpVectors(v1, v2, alpha) {
        this.lerp(v1, v2, alpha);
        return this;
      }
      /** Set this = position column of Matrix4 m. */
      setFromMatrixPosition(m) {
        const e = m.rawData;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
      }
      /** Set this = scale extracted from Matrix4 m (length of each column basis). */
      setFromMatrixScale(m) {
        const e = m.rawData;
        const sx = Math.hypot(e[0], e[1], e[2]);
        const sy = Math.hypot(e[4], e[5], e[6]);
        const sz = Math.hypot(e[8], e[9], e[10]);
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
      }
      /** Set this = column index of Matrix4 m (0, 1, 2, or 3). */
      setFromMatrixColumn(m, index) {
        const offset = index * 4;
        const e = m.rawData;
        this.x = e[offset];
        this.y = e[offset + 1];
        this.z = e[offset + 2];
        return this;
      }
      /** Project this onto v. Mutates and returns this. */
      projectOnVector(v) {
        const denom = v.lengthSq();
        if (denom === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denom;
        return this.copy(v).multiplyScalar(scalar);
      }
      /** Project this onto a plane defined by its normal (unit vector). */
      projectOnPlane(planeNormal) {
        Vector3._tmp.copy(this).projectOnVector(planeNormal);
        return this.sub(Vector3._tmp);
      }
      /** Reflect this off a surface with the given unit normal. */
      reflect(normal) {
        return this.sub(Vector3._tmp.copy(normal).multiplyScalar(2 * this.dot(normal)));
      }
      /** Apply a 3x3 matrix to this vector. */
      applyMatrix3(m) {
        const r = m.rawData;
        if (r) {
          const x = this.x, y = this.y, z = this.z;
          this.x = r[0] * x + r[3] * y + r[6] * z;
          this.y = r[1] * x + r[4] * y + r[7] * z;
          this.z = r[2] * x + r[5] * y + r[8] * z;
        } else {
          const a = m;
          const x = this.x, y = this.y;
          this.x = a.a * x + a.c * y + a.tx;
          this.y = a.b * x + a.d * y + a.ty;
        }
        return this;
      }
      /** Apply axis-angle rotation (axis must be unit, angle in radians). */
      applyAxisAngle(axis, angle) {
        const halfA = angle * 0.5;
        const s = Math.sin(halfA);
        const qx = axis.x * s, qy = axis.y * s, qz = axis.z * s, qw = Math.cos(halfA);
        return this.applyQuaternion({ x: qx, y: qy, z: qz, w: qw });
      }
      /** Transform this as a direction (no translation) by Matrix4 m, then normalize. */
      transformDirection(m) {
        const e = m.rawData;
        const x = this.x, y = this.y, z = this.z;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
      }
      /** Canonical alias of {@link setFromArray}. */
      fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
      }
      /** Floors each component. Mutates and returns this. */
      floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
      }
      /** Ceils each component. Mutates and returns this. */
      ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
      }
      /** Rounds each component to the nearest integer. Mutates and returns this. */
      round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
      }
      /** Rounds each component toward zero. Mutates and returns this. */
      roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
      }
      /** Fill this with components in [0, 1). */
      random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
      }
      static _tmp = new Vector3();
      static calAngle(cx, cy, x, y) {
        const radian = getCosBy2pt(x, y, cx, cy);
        let angle = Math.acos(radian) * 180 / Math.PI;
        if (x < cx) angle = -angle;
        return angle;
        function getCosBy2pt(x2, y2, cx2, cy2) {
          let a = [x2 - cx2, y2 - cy2];
          let b = [0, -1];
          return calCos(a, b);
        }
        function calCos(a, b) {
          let dotProduct = a[0] * b[0] + a[1] * b[1];
          let d = Math.sqrt(a[0] * a[0] + a[1] * a[1]) * Math.sqrt(b[0] * b[0] + b[1] * b[1]);
          return dotProduct / d;
        }
      }
      /** Tests whether point `pt` lies inside the triangle (pt0, pt1, pt2), using their x/z coordinates. */
      static pointInsideTriangle(pt, pt0, pt1, pt2) {
        Vector3.HELP_0.setTo(pt.x, pt.z, 0);
        Vector3.HELP_1.setTo(pt0.x, pt0.z, 0);
        Vector3.HELP_2.setTo(pt1.x, pt1.z, 0);
        Vector3.HELP_3.setTo(pt2.x, pt2.z, 0);
        return Vector3.pointInsideTriangle2d();
      }
      static pointInsideTriangle2d() {
        if (Vector3.productXY(Vector3.HELP_1, Vector3.HELP_2, Vector3.HELP_3) >= 0) {
          return Vector3.productXY(Vector3.HELP_1, Vector3.HELP_2, Vector3.HELP_0) >= 0 && Vector3.productXY(Vector3.HELP_2, Vector3.HELP_3, Vector3.HELP_0) >= 0 && Vector3.productXY(Vector3.HELP_3, Vector3.HELP_1, Vector3.HELP_0) >= 0;
        } else {
          return Vector3.productXY(Vector3.HELP_1, Vector3.HELP_2, Vector3.HELP_0) <= 0 && Vector3.productXY(Vector3.HELP_2, Vector3.HELP_3, Vector3.HELP_0) <= 0 && Vector3.productXY(Vector3.HELP_3, Vector3.HELP_1, Vector3.HELP_0) <= 0;
        }
      }
      static productXY(p1, p2, p3) {
        var val = (p1.x - p3.x) * (p2.y - p3.y) - (p1.y - p3.y) * (p2.x - p3.x);
        if (val > -1e-5 && val < 1e-5)
          val = 0;
        return val;
      }
      /** Returns a new Vector3 copy of the given vector, used for serialization. */
      static serialize(position) {
        let v = new Vector3(position.x, position.y, position.z, position.w);
        return v;
      }
    }

    class TouchData {
      constructor(touch) {
        this.canvasX = touch.clientX;
        this.canvasY = touch.clientY;
        this.identifier = touch.identifier;
        this.clientX = touch.clientX;
        this.clientY = touch.clientY;
        this.pageX = touch.pageX;
        this.pageY = touch.pageY;
        this.screenX = touch.screenX;
        this.screenY = touch.screenY;
      }
      /**
       * The horizontal offset relative to the position of the upper left corner of Canvas.
       */
      canvasX;
      /**
       * The vertical offset relative to the position of the upper left corner of Canvas.
       */
      canvasY;
      /**
       * touch id
       */
      identifier;
      /**
       * The horizontal offset relative to the top left corner of the browser content area
       * It will change with the movement of the scroll bar.
       */
      clientX;
      /**
       * The ertical offset relative to the top left corner of the browser content area
       * It will change with the movement of the scroll bar.
       */
      clientY;
      /**
       * The horizontal offset relative to the top left corner of the browser content area
       * It won't change with the movement of the scroll bar.
       */
      pageX;
      /**
       * The ertical offset relative to the top left corner of the browser content area
       * It won't change with the movement of the scroll bar.
       */
      pageY;
      /**
       * The horizontal offset relative to the position of the top left corner of the user screen.
       */
      screenX;
      /**
       * The vertical offset relative to the position of the top left corner of the user screen.
       */
      screenY;
    }

    class InputSystem extends CEventDispatcher {
      /**
       * coord x of canvas
       */
      canvasX = 0;
      /**
       * coord y of canvas
       */
      canvasY = 0;
      /**
       *  whether the mouse is down now
       */
      isMouseDown = false;
      /**
       * reference of canvas
       */
      canvas;
      /**
       * current mouse coordinate x of Canvas
       */
      mouseX = 0;
      /**
       * current mouse coordinate y of Canvas
       */
      mouseY = 0;
      /**
       * the delta value when mouse wheeled
       */
      wheelDelta = 0;
      /**
       * the delta value of mouse x
       */
      mouseOffsetX = 0;
      /**
       * the delta value of mouse y
       */
      mouseOffsetY = 0;
      /**
       * the history value of mouse x
       */
      mouseLastX = 0;
      /**
       *
       * the history value of mouse y
       *
       */
      mouseLastY = 0;
      _time = 0;
      _keyStatus;
      _mouseStatus;
      _isTouchStart;
      _keyEvent3d;
      _pointerEvent3D;
      _windowsEvent3d;
      /** Whether pointer lock is currently active. */
      mouseLock = false;
      _wheelHandler = null;
      _keyDownHandler = null;
      _keyUpHandler = null;
      _mouseLockHandler = null;
      /**
       * init the input system
       * @param canvas the reference of canvas
       */
      initCanvas(canvas) {
        this.canvas = canvas;
        let _t = 0, _x = 0, _y = 0, _button = 0;
        canvas.onpointerdown = (ev) => {
          _t = performance.now();
          _x = ev.clientX;
          _y = ev.clientY;
          _button = ev.button;
          this.mouseStart(ev);
          canvas.setPointerCapture(ev.pointerId);
        };
        canvas.onpointerup = (ev) => {
          this.mouseEnd(ev);
          if (ev.button === _button && performance.now() - _t < 300 && Math.abs(_x - ev.clientX) < 20 && Math.abs(_y - ev.clientY) < 20) {
            ev.button === 0 ? this.mouseClick(ev) : this.rightClick(ev);
          }
          canvas.releasePointerCapture(ev.pointerId);
        };
        canvas.onpointerenter = (ev) => {
          this.mouseOver(ev);
        };
        canvas.onpointermove = (ev) => {
          this.mouseMove(ev);
        };
        canvas.onpointercancel = (ev) => {
          canvas.releasePointerCapture(ev.pointerId);
          this.mouseEnd(ev);
        };
        this._wheelHandler = (e) => this.mouseWheel(e);
        this._keyDownHandler = (e) => this.keyDown(e);
        this._keyUpHandler = (e) => this.keyUp(e);
        canvas.addEventListener(`wheel`, this._wheelHandler, { passive: false });
        window.addEventListener("keydown", this._keyDownHandler, true);
        window.addEventListener("keyup", this._keyUpHandler, true);
        canvas.oncontextmenu = function() {
          return false;
        };
        let rect = this.canvas.getBoundingClientRect();
        this.canvasX = rect.left;
        this.canvasY = rect.top;
        this._keyStatus = {};
        this._mouseStatus = {};
        this._isTouchStart = false;
        this._keyEvent3d = new KeyEvent();
        this._pointerEvent3D = new PointerEvent3D();
        this._windowsEvent3d = new CEvent();
      }
      /**
       * Detach every listener this InputSystem installed (window keyboard
       * listeners + canvas pointer/wheel handlers). Idempotent. Called by
       * `Engine3D.dispose()` — without it, every disposed engine leaks a
       * pair of window-level keydown/keyup listeners that still reference
       * the engine's scene graph.
       */
      dispose() {
        if (this._keyDownHandler) {
          window.removeEventListener("keydown", this._keyDownHandler, true);
          this._keyDownHandler = null;
        }
        if (this._keyUpHandler) {
          window.removeEventListener("keyup", this._keyUpHandler, true);
          this._keyUpHandler = null;
        }
        if (this._mouseLockHandler) {
          document.removeEventListener("mousemove", this._mouseLockHandler, false);
          this._mouseLockHandler = null;
        }
        if (this.canvas) {
          if (this._wheelHandler) this.canvas.removeEventListener("wheel", this._wheelHandler);
          this.canvas.onpointerdown = null;
          this.canvas.onpointerup = null;
          this.canvas.onpointerenter = null;
          this.canvas.onpointermove = null;
          this.canvas.onpointercancel = null;
          this.canvas.oncontextmenu = null;
        }
        this._wheelHandler = null;
        this.canvas = null;
      }
      /** Request pointer lock on the canvas and start tracking locked mouse movement. */
      useMouseLock() {
        if (this.mouseLock) return;
        this.canvas.requestPointerLock();
        this.mouseLock = true;
        this._mouseLockHandler = (e) => this.onMouseLockMove(e);
        document.addEventListener("mousemove", this._mouseLockHandler, false);
      }
      /** Exit pointer lock and stop tracking locked mouse movement. */
      releaseMouseLock() {
        this.mouseLock = false;
        document.exitPointerLock();
        if (this._mouseLockHandler) {
          document.removeEventListener("mousemove", this._mouseLockHandler, false);
          this._mouseLockHandler = null;
        }
      }
      onMouseLockMove(e) {
        this.mouseLastX = this.mouseX;
        this.mouseLastY = this.mouseY;
        this.mouseX = e.clientX - this.canvasX;
        this.mouseY = e.clientY - this.canvasY;
        this.mouseOffsetX = e.movementX;
        this.mouseOffsetY = e.movementY;
        this._pointerEvent3D.reset();
        this._pointerEvent3D.type = PointerEvent3D.POINTER_MOVE;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this._pointerEvent3D.mouseX = this.mouseX;
        this._pointerEvent3D.mouseY = this.mouseY;
        this._pointerEvent3D.movementX = e.movementX;
        this._pointerEvent3D.movementY = e.movementY;
        this.dispatchEvent(this._pointerEvent3D);
      }
      onPinch(x1, y1, x2, y2) {
        this._oldPosition1 = new Vector3(x1, y1);
        this._oldPosition2 = new Vector3(x2, y2);
      }
      onSwipe(x, y) {
        this.mouseX = x;
        this.mouseY = y;
        this._oldPosition1 = null;
        this._oldPosition2 = null;
        this._time = (/* @__PURE__ */ new Date()).getTime();
      }
      _oldPosition1 = null;
      _oldPosition2 = null;
      GetTargetTouches(targetTouches) {
        var array = new Array();
        for (var i = 0; i < targetTouches.length; i++) {
          var touchData = new TouchData(targetTouches[i]);
          array.push(touchData);
        }
        return array;
      }
      rightClick(e) {
        this._pointerEvent3D.reset();
        this._pointerEvent3D.mouseCode = e.button;
        this._pointerEvent3D.mouseX = e.clientX - this.canvasX;
        this._pointerEvent3D.mouseY = e.clientY - this.canvasY;
        this._pointerEvent3D.type = PointerEvent3D.POINTER_RIGHT_CLICK;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this.dispatchEvent(this._pointerEvent3D);
      }
      mouseClick(e) {
        this._pointerEvent3D.reset();
        this._pointerEvent3D.mouseCode = e.button;
        this._pointerEvent3D.mouseX = e.clientX - this.canvasX;
        this._pointerEvent3D.mouseY = e.clientY - this.canvasY;
        this._pointerEvent3D.type = PointerEvent3D.POINTER_CLICK;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.metaKey = e.metaKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this.dispatchEvent(this._pointerEvent3D);
      }
      _downTime = 0;
      mouseEnd(e) {
        this.isMouseDown = false;
        this.mouseLastX = this.mouseX;
        this.mouseLastY = this.mouseY;
        this.mouseX = e.clientX - this.canvasX;
        this.mouseY = e.clientY - this.canvasY;
        this.mouseOffsetX = this.mouseX - this.mouseLastX;
        this.mouseOffsetY = this.mouseY - this.mouseLastY;
        this._pointerEvent3D.reset();
        this._pointerEvent3D.mouseCode = e.button;
        this._mouseStatus[this._pointerEvent3D.mouseCode] = false;
        this._pointerEvent3D.type = PointerEvent3D.POINTER_UP;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.metaKey = e.metaKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this._pointerEvent3D.pointerId = e.pointerId;
        this._pointerEvent3D.pointerType = e.pointerType;
        this._pointerEvent3D.isPrimary = e.isPrimary;
        this._pointerEvent3D.pressure = e.pressure;
        this._pointerEvent3D.mouseX = this.mouseX;
        this._pointerEvent3D.mouseY = this.mouseY;
        this.dispatchEvent(this._pointerEvent3D);
      }
      mouseStart(e) {
        this.isMouseDown = true;
        this.mouseLastX = this.mouseX;
        this.mouseLastY = this.mouseY;
        this.mouseX = e.clientX - this.canvasX;
        this.mouseY = e.clientY - this.canvasY;
        this.mouseOffsetX = this.mouseX - this.mouseLastX;
        this.mouseOffsetY = this.mouseY - this.mouseLastY;
        this._pointerEvent3D.reset();
        this._pointerEvent3D.mouseCode = e.button;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.metaKey = e.metaKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this._pointerEvent3D.pointerId = e[`pointerId`] ? e[`pointerId`] : 0;
        this._pointerEvent3D.pointerType = e[`pointerType`] ? e[`pointerType`] : 0;
        this._pointerEvent3D.isPrimary = e[`isPrimary`] ? e[`isPrimary`] : 0;
        this._pointerEvent3D.pressure = e[`pressure`] ? e[`pressure`] : 0;
        this._pointerEvent3D.mouseX = this.mouseX;
        this._pointerEvent3D.mouseY = this.mouseY;
        this._pointerEvent3D.type = PointerEvent3D.POINTER_DOWN;
        this.dispatchEvent(this._pointerEvent3D);
      }
      mouseMove(e) {
        this.mouseLastX = this.mouseX;
        this.mouseLastY = this.mouseY;
        this.mouseX = e.clientX - this.canvasX;
        this.mouseY = e.clientY - this.canvasY;
        this.mouseOffsetX = this.mouseX - this.mouseLastX;
        this.mouseOffsetY = this.mouseY - this.mouseLastY;
        this._pointerEvent3D.reset();
        this._pointerEvent3D.type = PointerEvent3D.POINTER_MOVE;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.metaKey = e.metaKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this._pointerEvent3D.pointerId = e.pointerId;
        this._pointerEvent3D.pointerType = e.pointerType;
        this._pointerEvent3D.isPrimary = e.isPrimary;
        this._pointerEvent3D.pressure = e.pressure;
        this._pointerEvent3D.mouseX = this.mouseX;
        this._pointerEvent3D.mouseY = this.mouseY;
        this._pointerEvent3D.movementX = e.movementX;
        this._pointerEvent3D.movementY = e.movementY;
        this.dispatchEvent(this._pointerEvent3D);
      }
      mouseOver(e) {
        this.isMouseDown = false;
        this.mouseLastX = this.mouseX;
        this.mouseLastY = this.mouseY;
        this.mouseX = e.clientX - this.canvasX;
        this.mouseY = e.clientY - this.canvasY;
        this.mouseOffsetX = this.mouseX - this.mouseLastX;
        this.mouseOffsetY = this.mouseY - this.mouseLastY;
        this._pointerEvent3D.reset();
        this._pointerEvent3D.type = PointerEvent3D.POINTER_OVER;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.metaKey = e.metaKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this._pointerEvent3D.pointerId = e.pointerId;
        this._pointerEvent3D.pointerType = e.pointerType;
        this._pointerEvent3D.isPrimary = e.isPrimary;
        this._pointerEvent3D.pressure = e.pressure;
        this._pointerEvent3D.mouseX = this.mouseX;
        this._pointerEvent3D.mouseY = this.mouseY;
        this.dispatchEvent(this._pointerEvent3D);
      }
      mouseWheel(e) {
        e.preventDefault();
        this.mouseLastX = this.mouseX;
        this.mouseLastY = this.mouseY;
        this.mouseX = e.clientX - this.canvasX;
        this.mouseY = e.clientY - this.canvasY;
        this.mouseOffsetX = this.mouseX - this.mouseLastX;
        this.mouseOffsetY = this.mouseY - this.mouseLastY;
        if (`wheelDelta` in e) {
          this._pointerEvent3D.delay = e[`wheelDelta`];
          this.wheelDelta = e[`wheelDelta`];
        } else if (`delta` in e) {
          this.wheelDelta = e[`delta`];
        }
        this._pointerEvent3D.reset();
        this._pointerEvent3D.type = PointerEvent3D.POINTER_WHEEL;
        this._pointerEvent3D.ctrlKey = e.ctrlKey;
        this._pointerEvent3D.metaKey = e.metaKey;
        this._pointerEvent3D.altKey = e.altKey;
        this._pointerEvent3D.shiftKey = e.shiftKey;
        this._pointerEvent3D.mouseX = this.mouseX;
        this._pointerEvent3D.mouseY = this.mouseY;
        this._pointerEvent3D.deltaX = e.deltaX;
        this._pointerEvent3D.deltaY = e.deltaY;
        this._pointerEvent3D.deltaZ = e.deltaZ;
        this.dispatchEvent(this._pointerEvent3D);
      }
      keyDown(e) {
        this._keyEvent3d.reset();
        this._keyEvent3d.keyCode = e.keyCode;
        this._keyEvent3d.ctrlKey = e.ctrlKey;
        this._keyEvent3d.altKey = e.altKey;
        this._keyEvent3d.shiftKey = e.shiftKey;
        if (!this._keyStatus[e.keyCode]) {
          this._keyStatus[e.keyCode] = true;
          this._keyEvent3d.type = KeyEvent.KEY_DOWN;
          this.dispatchEvent(this._keyEvent3d);
        }
      }
      keyUp(e) {
        this._keyEvent3d.reset();
        this._keyEvent3d.keyCode = e.keyCode;
        this._keyStatus[e.keyCode] = false;
        this._keyEvent3d.type = KeyEvent.KEY_UP;
        this.dispatchEvent(this._keyEvent3d);
      }
      GetSlideAngle(dx, dy) {
        return Math.atan2(dy, dx) * 180 / Math.PI;
      }
      /**
       *
       * @param  startX {Number} 
       * @param  startY {Number} 
       * @param  endX   {Number} 
       * @param  endY   {Number} 
       * @returns result {number} 1: up, 2: down, 3: left, 4: right, 0: not move
       */
      GetSlideDirection(startX, startY, endX, endY) {
        var dy = startY - endY;
        var dx = endX - startX;
        var result = 0;
        if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
          return result;
        }
        var angle = this.GetSlideAngle(dx, dy);
        if (angle >= -45 && angle < 45) {
          result = 4;
        } else if (angle >= 45 && angle < 135) {
          result = 1;
        } else if (angle >= -135 && angle < -45) {
          result = 2;
        } else if (angle >= 135 && angle <= 180 || angle >= -180 && angle < -135) {
          result = 3;
        }
        return result;
      }
    }

    const version = "0.9.1";

    class CResizeEvent extends CEvent {
      /**
       *
       * RESIZE:enum event type
       */
      static RESIZE = "resize";
    }

    let GPUAddressMode = {
      clamp_to_edge: "clamp-to-edge",
      repeat: "repeat",
      mirror_repeat: "mirror-repeat"
    };
    let GPUBlendFactor = {
      zero: "zero",
      one: "one",
      src: "src",
      one_minus_src: "one-minus-src",
      src_alpha: "src-alpha",
      one_minus_src_alpha: "one-minus-src-alpha",
      dst: "dst",
      one_minus_dst: "one-minus-dst",
      dst_alpha: "dst-alpha",
      one_minus_dst_alpha: "one-minus-dst-alpha",
      src_alpha_saturated: "src-alpha-saturated",
      constant: "constant",
      one_minus_constant: "one-minus-constant"
    };
    const blendComponent = {
      srcFactor: "one",
      dstFactor: "zero",
      operation: "add"
    };
    const defaultStencilFaceState = {
      compare: "always",
      failOp: "keep",
      depthFailOp: "keep",
      passOp: "keep"
    };
    let GPUStencilOperation = {
      keep: "keep",
      zero: "zero",
      replace: "replace",
      invert: "invert",
      increment_clamp: "increment-clamp",
      decrement_clamp: "decrement-clamp",
      increment_wrap: "increment-wrap",
      decrement_wrap: "decrement-wrap"
    };
    let GPUCompareFunction = {
      never: "never",
      less: "less",
      equal: "equal",
      less_equal: "less-equal",
      greater: "greater",
      not_equal: "not-equal",
      greater_equal: "greater-equal",
      always: "always"
    };
    let GPUCullMode = {
      none: "none",
      front: "front",
      back: "back"
    };
    let GPUFilterMode = {
      nearest: "nearest",
      linear: "linear"
    };
    let GPUPrimitiveTopology = {
      point_list: "point-list",
      line_list: "line-list",
      line_strip: "line-strip",
      triangle_list: "triangle-list",
      triangle_strip: "triangle-strip"
    };
    let GPUTextureFormat = {
      r8unorm: "r8unorm",
      r8snorm: "r8snorm",
      r8uint: "r8uint",
      r8sint: "r8sint",
      r16uint: "r16uint",
      r16sint: "r16sint",
      r16float: "r16float",
      rg8unorm: "rg8unorm",
      rg8snorm: "rg8snorm",
      rg8uint: "rg8uint",
      rg8sint: "rg8sint",
      r32uint: "r32uint",
      r32sint: "r32sint",
      r32float: "r32float",
      rg16uint: "rg16uint",
      rg16sint: "rg16sint",
      rg16float: "rg16float",
      rgba8unorm: "rgba8unorm",
      rgba8unorm_srgb: "rgba8unorm-srgb",
      rgba8snorm: "rgba8snorm",
      rgba8uint: "rgba8uint",
      rgba8sint: "rgba8sint",
      bgra8unorm: "bgra8unorm",
      bgra8unorm_srgb: "bgra8unorm-srgb",
      rgb9e5ufloat: "rgb9e5ufloat",
      rgb10a2unorm: "rgb10a2unorm",
      rg11b10ufloat: "rg11b10ufloat",
      rg32uint: "rg32uint",
      rg32sint: "rg32sint",
      rg32float: "rg32float",
      rgba16uint: "rgba16uint",
      rgba16sint: "rgba16sint",
      rgba16float: "rgba16float",
      rgba32uint: "rgba32uint",
      rgba32sint: "rgba32sint",
      rgba32float: "rgba32float",
      stencil8: "stencil8",
      depth16unorm: "depth16unorm",
      depth24plus: "depth24plus",
      depth24plus_stencil8: "depth24plus-stencil8",
      depth32float: "depth32float",
      bc1_rgba_unorm: "bc1-rgba-unorm",
      bc1_rgba_unorm_srgb: "bc1-rgba-unorm-srgb",
      bc2_rgba_unorm: "bc2-rgba-unorm",
      bc2_rgba_unorm_srgb: "bc2-rgba-unorm-srgb",
      bc3_rgba_unorm: "bc3-rgba-unorm",
      bc3_rgba_unorm_srgb: "bc3-rgba-unorm-srgb",
      bc4_r_unorm: "bc4-r-unorm",
      bc4_r_snorm: "bc4-r-snorm",
      bc5_rg_unorm: "bc5-rg-unorm",
      bc5_rg_snorm: "bc5-rg-snorm",
      bc6h_rgb_ufloat: "bc6h-rgb-ufloat",
      bc6h_rgb_float: "bc6h-rgb-float",
      bc7_rgba_unorm: "bc7-rgba-unorm",
      bc7_rgba_unorm_srgb: "bc7-rgba-unorm-srgb",
      depth24unorm_stencil8: "depth24unorm-stencil8",
      depth32float_stencil8: "depth32float-stencil8"
    };
    let GPUVertexFormat = {
      uint8x2: "uint8x2",
      uint8x4: "uint8x4",
      sint8x2: "sint8x2",
      sint8x4: "sint8x4",
      unorm8x2: "unorm8x2",
      unorm8x4: "unorm8x4",
      snorm8x2: "snorm8x2",
      snorm8x4: "snorm8x4",
      uint16x2: "uint16x2",
      uint16x4: "uint16x4",
      sint16x2: "sint16x2",
      sint16x4: "sint16x4",
      unorm16x2: "unorm16x2",
      unorm16x4: "unorm16x4",
      snorm16x2: "snorm16x2",
      snorm16x4: "snorm16x4",
      float16x2: "float16x2",
      float16x4: "float16x4",
      float32: "float32",
      float32x2: "float32x2",
      float32x3: "float32x3",
      float32x4: "float32x4",
      uint32: "uint32",
      uint32x2: "uint32x2",
      uint32x3: "uint32x3",
      uint32x4: "uint32x4",
      sint32: "sint32",
      sint32x2: "sint32x2",
      sint32x3: "sint32x3",
      sint32x4: "sint32x4"
    };
    let GPUVertexStepMode = {
      vertex: "vertex",
      instance: "instance"
    };

    class TextureMipmapGenerator {
      static mipmapShader = `
        var<private> pos : array<vec2<f32>, 4> = array<vec2<f32>, 4>(
        vec2<f32>(-1.0, 1.0), vec2<f32>(1.0, 1.0),
        vec2<f32>(-1.0, -1.0), vec2<f32>(1.0, -1.0));

        struct VertexOutput {
        @builtin(position) position : vec4<f32>,
        @location(0) texCoord : vec2<f32>
        };

        @vertex
        fn vertexMain(@builtin(vertex_index) vertexIndex : u32) -> VertexOutput {
        var output : VertexOutput;
        output.texCoord = pos[vertexIndex] * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5);
        output.position = vec4<f32>(pos[vertexIndex], 0.0, 1.0);
        return output;
        }

        @binding(0) @group(0) var imgSampler : sampler;
        @binding(1) @group(0) var img : texture_2d<f32>;

        @fragment
        fn fragmentMain(@location(0) texCoord : vec2<f32>) -> @location(0) vec4<f32> {
        var outColor: vec4<f32> = textureSampleLevel(img, imgSampler, texCoord , 0.0 );
        return outColor;
        }
      `;
      static getMipmapPipeline(texture) {
        const ctx = texture._boundCtx;
        let gpuDevice = ctx.device;
        let cache = ctx.cache(TextureMipmapGenerator, () => ({}));
        let pipeline = cache[texture.format];
        if (!pipeline) {
          const mipmapShaderModule = gpuDevice.createShaderModule({
            code: TextureMipmapGenerator.mipmapShader
          });
          let textureLayout = gpuDevice.createBindGroupLayout({
            entries: [
              {
                binding: 0,
                //TODO : After adding a shadow reflection, it is necessary to know that the vertex is used | the segment is used
                visibility: texture.visibility,
                // use GPUSamplerBindingLayout = { type:`filtering`} error
                sampler: texture.samplerBindingLayout
              },
              {
                binding: 1,
                //TODO : After adding a shadow reflection, it is necessary to know that the vertex is used | the segment is used
                visibility: texture.visibility,
                // use GPUTextureBindingLayout = { sampleType:`float`} error
                texture: texture.textureBindingLayout
              }
            ]
          });
          let layouts = gpuDevice.createPipelineLayout({
            bindGroupLayouts: [textureLayout]
          });
          pipeline = gpuDevice.createRenderPipeline({
            layout: layouts,
            vertex: {
              module: mipmapShaderModule,
              entryPoint: "vertexMain"
            },
            fragment: {
              module: mipmapShaderModule,
              entryPoint: "fragmentMain",
              targets: [
                {
                  format: texture.format
                  // Make sure to use the same format as the texture
                }
              ]
            },
            primitive: {
              topology: "triangle-strip",
              stripIndexFormat: "uint32"
            }
          });
          cache[texture.format] = pipeline;
        }
        return pipeline;
      }
      // TextureDescriptor should be the descriptor that the texture was created with.
      // This version only works for basic 2D textures.
      static webGPUGenerateMipmap(texture) {
        const ctx = texture._boundCtx;
        let gpuDevice = ctx.device;
        let textureDescriptor = texture.textureDescriptor;
        let pipeline = TextureMipmapGenerator.getMipmapPipeline(texture);
        let srcView = texture.getGPUTexture().createView({
          baseMipLevel: 0,
          mipLevelCount: 1
        });
        const commandEncoder = gpuDevice.createCommandEncoder();
        for (let i = 1; i < textureDescriptor.mipLevelCount; ++i) {
          const dstView = texture.getGPUTexture().createView({
            baseMipLevel: i,
            // Make sure we're getting the right mip level...
            mipLevelCount: 1
            // And only selecting one mip level
          });
          const passEncoder = commandEncoder.beginRenderPass({
            colorAttachments: [
              {
                view: dstView,
                // Render pass uses the next mip level as it's render attachment.
                clearValue: [0, 0, 0, 0],
                loadOp: `clear`,
                storeOp: "store"
              }
            ]
          });
          let textureLayout = gpuDevice.createBindGroupLayout({
            entries: [
              {
                binding: 0,
                //TODO : After adding a shadow reflection, it is necessary to know that the vertex is used | the segment is used
                visibility: texture.visibility,
                // use GPUSamplerBindingLayout = { type:`filtering`} error
                sampler: texture.samplerBindingLayout
              },
              {
                binding: 1,
                //TODO : After adding a shadow reflection, it is necessary to know that the vertex is used | the segment is used
                visibility: texture.visibility,
                // use GPUTextureBindingLayout = { sampleType:`float`} error
                texture: texture.textureBindingLayout
              }
            ]
          });
          const bindGroup = gpuDevice.createBindGroup({
            layout: textureLayout,
            entries: [
              {
                binding: 0,
                resource: texture.gpuSampler
              },
              {
                binding: 1,
                resource: srcView
              }
            ]
          });
          passEncoder.setPipeline(pipeline);
          passEncoder.setBindGroup(0, bindGroup);
          passEncoder.draw(4);
          passEncoder.end();
          srcView = dstView;
        }
        gpuDevice.queue.submit([commandEncoder.finish()]);
      }
      static getMipmapCount(width, height) {
        let w = width;
        let h = height;
        let maxSize = Math.max(w, h);
        return 1 + Math.log2(maxSize) | 0;
      }
    }

    class Texture {
      /** The Context3D this texture is bound to. Set on first GPU use. */
      _boundCtx = null;
      /**
       * Ensure this texture is bound to a Context3D and return it. Resolution
       * order: explicit arg, prior `bindCtx()`, then the single-engine default
       * (same contract as Engine3D._defaultContext() for no-arg material
       * constructors). Throws only when the choice is ambiguous — no engine
       * yet, or several engines alive without an explicit ctx.
       */
      _ensureBound(ctx) {
        if (ctx) {
          bindCtx(this, ctx);
          return ctx;
        }
        if (this._boundCtx) return this._boundCtx;
        const fallback = resolveDefaultCtx();
        if (fallback) {
          bindCtx(this, fallback);
          return fallback;
        }
        throw new Error(`Texture(${this.constructor.name}) used before bindCtx — with zero or multiple engines alive, thread a Context3D from the owning Engine3D.`);
      }
      /**
       * name of texture
       */
      name;
      /**
       * source url
       */
      url;
      /**
       * Single GPU texture slot. Reads auto-materialize on first access
       * when a descriptor is set: creates the GPUTexture on `_boundCtx` and
       * replays the cached source image upload (if any). Bound to one
       * Context3D for the lifetime of the texture.
       */
      _gpuTexture = null;
      /** Latch guarding against re-entrant auto-mipmap generation on the 2D path. */
      _mipmapMaterialized = false;
      get gpuTexture() {
        if (!this._gpuTexture && this.textureDescriptor) {
          this._ensureBound();
          this._gpuTexture = this._boundCtx.device.createTexture(this.textureDescriptor);
          this._uploadSourceImage(this._gpuTexture);
          if (this.useMipmap && !this._mipmapMaterialized && this._isAutoMipmappable()) {
            this._mipmapMaterialized = true;
            TextureMipmapGenerator.webGPUGenerateMipmap(this);
          }
        }
        return this._gpuTexture;
      }
      set gpuTexture(v) {
        this._gpuTexture = v ?? null;
      }
      /**
       * Single-layer 2D textures can go through the generic render-to-mip
       * pipeline. Anything else (cube, 2d-array, cube-array, 3d) manages its
       * own mipmap chain.
       */
      _isAutoMipmappable() {
        const layers = this.textureDescriptor?.size?.["depthOrArrayLayers"] ?? 1;
        const dim = this.textureDescriptor?.dimension ?? "2d";
        return dim === "2d" && layers === 1;
      }
      /**
       * Return index in texture array
       */
      pid;
      /**
       * Single GPU texture view slot. Auto-materializes from `viewDescriptor`
       * on first access when `gpuTexture` is a real GPUTexture.
       */
      _view = null;
      get view() {
        if (!this._view && this.viewDescriptor) {
          const t = this.gpuTexture;
          if (t instanceof GPUTexture) {
            this._view = t.createView(this.viewDescriptor);
            if (this.name) this._view.label = this.name;
          }
        }
        return this._view;
      }
      set view(v) {
        this._view = v ?? null;
      }
      /**
       * Single GPU sampler slot. Auto-materializes using this Texture as its
       * own GPUSamplerDescriptor on first access.
       */
      _gpuSampler = null;
      get gpuSampler() {
        if (!this._gpuSampler) {
          this._ensureBound();
          this._gpuSampler = this._boundCtx.device.createSampler(this);
        }
        return this._gpuSampler;
      }
      set gpuSampler(v) {
        this._gpuSampler = v ?? null;
      }
      /**
       * Single GPU comparison sampler slot. Auto-materializes with
       * `compare: 'less'` (or `_compare`) on first access.
       */
      _gpuSampler_cmp = null;
      get gpuSampler_comparison() {
        if (!this._gpuSampler_cmp) {
          this._ensureBound();
          this._gpuSampler_cmp = this._boundCtx.device.createSampler({
            compare: this._compare || "less",
            label: "sampler_comparison"
          });
        }
        return this._gpuSampler_cmp;
      }
      set gpuSampler_comparison(v) {
        this._gpuSampler_cmp = v ?? null;
      }
      /**
       * GPUTextureFormat
       */
      format;
      /**
       * GPUTextureUsage
       */
      usage;
      /**
       * texture width
       */
      width = 4;
      /**
       * texture height
       */
      height = 4;
      /**
       * depth or layers, default value is 1
       */
      depthOrArrayLayers = 1;
      /**
       * depth or layers, default value is 1
       */
      numberLayer = 1;
      /**
       * GPUTextureViewDescriptor
       */
      viewDescriptor;
      /**
       * GPUTextureDescriptor
       */
      textureDescriptor;
      /**
       * GPUShaderStage
       */
      visibility = GPUShaderStage.COMPUTE | GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT;
      /**
       * GPUTextureBindingLayout, contains viewDimension and multisampled
       */
      textureBindingLayout = {
        viewDimension: `2d`,
        multisampled: false
      };
      /**
       * GPUSamplerBindingLayout
       */
      samplerBindingLayout = {
        type: `filtering`
      };
      /**
       * GPUSamplerBindingLayout
       */
      sampler_comparisonBindingLayout = {
        type: `comparison`
      };
      /**
       * whether to flip the image on the y-axis
       */
      flipY;
      /**
       *  whether is video texture
       */
      isVideoTexture;
      /**
       * whether this texture holds HDR (high dynamic range) image data
       */
      isHDRTexture;
      /** Backing field for {@link useMipmap}. */
      _useMipmap = false;
      /** Cached CPU source image, replayed onto the GPU texture when it is (re)materialized. */
      _sourceImageData;
      //****************************************/
      /** Backing field for the U-coordinate address mode (see {@link addressModeU}). */
      _addressModeU;
      /** Backing field for the V-coordinate address mode (see {@link addressModeV}). */
      _addressModeV;
      /**
       * Specifies the {{GPUAddressMode|address modes}} for the texture width, height, and depth
       * coordinates, respectively.
       */
      _addressModeW;
      /**
       * Specifies the sampling behavior when the sample footprint is smaller than or equal to one
       * texel.
       */
      _magFilter;
      /**
       * Specifies the sampling behavior when the sample footprint is larger than one texel.
       */
      _minFilter;
      /**
       * Specifies behavior for sampling between mipmap levels.
       */
      _mipmapFilter;
      /**
       * Specifies the minimum level of detail used internally when sampling a texture.
       */
      _lodMinClamp;
      /**
       * Specifies the minimum and maximum levels of detail, respectively, used internally when
       * sampling a texture.
       */
      _lodMaxClamp;
      /**
       * When provided the sampler will be a comparison sampler with the specified
       * {@link GPUCompareFunction}.
       * Note: Comparison samplers may use filtering, but the sampling results will be
       * implementation-dependent and may differ from the normal filtering rules.
       */
      _compare;
      /**
       * Specifies the maximum anisotropy value clamp used by the sampler.
       * Note: Most implementations support {@link GPUSamplerDescriptor#maxAnisotropy} values in range
       * between 1 and 16, inclusive. The used value of {@link GPUSamplerDescriptor#maxAnisotropy} will
       * be clamped to the maximum value that the platform supports.
       */
      _maxAnisotropy;
      /**
       *  mipmap Count, default value is 1
       */
      mipmapCount = 1;
      /** Flag set when the mipmap state changes, signalling the texture needs rebuilding. */
      _textureChange = false;
      /**
       * Create a texture2D
       * @param width size of texture width
       * @param height height of texture width
       * @param numberLayer number layer of texture
       * @returns
       */
      constructor(width = 32, height = 32, numberLayer = 1) {
        this.width = width;
        this.height = height;
        this.numberLayer = numberLayer;
        this.minFilter = GPUFilterMode.linear;
        this.magFilter = GPUFilterMode.linear;
        this.mipmapFilter = GPUFilterMode.linear;
        this.addressModeU = GPUAddressMode.repeat;
        this.addressModeV = GPUAddressMode.repeat;
      }
      /**
       * Run the optional internal create hooks (binding layout, texture, view,
       * sampler) if a subclass provides them.
       * @returns this texture, for chaining
       */
      init() {
        let self = this;
        if (self[`internalCreateBindingLayoutDesc`]) {
          self[`internalCreateBindingLayoutDesc`]();
        }
        if (self[`internalCreateTexture`]) {
          self[`internalCreateTexture`]();
        }
        if (self[`internalCreateView`]) {
          self[`internalCreateView`]();
        }
        if (self[`internalCreateSampler`]) {
          self[`internalCreateSampler`]();
        }
        return this;
      }
      /**
       * creatTextureDescriptor
       */
      createTextureDescriptor(width, height, mipLevelCount, format, usage = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.STORAGE_BINDING, sizeCount = 1, sampleCount = 0) {
        if (typeof format === "string" && format.endsWith("-srgb")) {
          usage &= ~GPUTextureUsage.STORAGE_BINDING;
        }
        this.width = width;
        this.height = height;
        this.format = format;
        this.usage = usage;
        this.textureDescriptor = {
          size: [width, height, sizeCount],
          mipLevelCount,
          format,
          usage,
          label: `${this.name + this.width + this.height + this.format}`
        };
        if (sampleCount > 0) {
          this.textureDescriptor.sampleCount = sampleCount;
        }
        if (sizeCount > 1) {
          this.viewDescriptor = {
            format,
            dimension: `2d-array`
          };
        } else {
          this.viewDescriptor = {
            format,
            dimension: this.textureBindingLayout.viewDimension,
            mipLevelCount,
            baseMipLevel: 0
          };
        }
      }
      /**
       * Derive the texture size from the given source image and (re)create the
       * GPU texture from it.
       * @param imageBitmap source image to upload into the texture
       */
      generate(imageBitmap) {
        let width = 32;
        let height = 32;
        if ("width" in imageBitmap) {
          width = imageBitmap.width;
          height = imageBitmap.height;
        }
        if (width < 32 || height < 32) {
          console.warn(imageBitmap["name"] + "Size must be greater than 32!");
        }
        this.width = width;
        this.height = height;
        this.createTexture(imageBitmap);
      }
      /**
       * Cache the source image and rebuild the texture descriptor, then
       * invalidate the materialized GPU resources so consumers rebind.
       * @param imageBitmap source image to cache for later GPU upload
       */
      createTexture(imageBitmap) {
        this._sourceImageData = imageBitmap;
        this.updateTextureDescription();
        this.updateGPUTexture();
        this.noticeChange();
      }
      /**
       * Upload the cached source image (if any) into the given GPU texture.
       * Called from the gpuTexture getter when materializing the GPU texture
       * on first access.
       */
      _uploadSourceImage(tex) {
        if (!this._sourceImageData) return;
        this._ensureBound();
        this._boundCtx.device.queue.copyExternalImageToTexture(
          { source: this._sourceImageData },
          { texture: tex },
          [this.width, this.height]
        );
      }
      /**
       * enable/disable mipmap
       */
      get useMipmap() {
        return this._useMipmap;
      }
      /**
       * get mipmap
       */
      set useMipmap(value) {
        if (value) {
          this.samplerBindingLayout.type = "filtering";
          if (this._useMipmap == false && this._sourceImageData) {
            this._useMipmap = true;
            this.updateTextureDescription();
            this.updateGPUTexture();
            if (this.gpuTexture instanceof GPUTexture) {
              TextureMipmapGenerator.webGPUGenerateMipmap(this);
            }
          }
        } else {
          this.samplerBindingLayout.type = "non-filtering";
          if (this._useMipmap == true && this._sourceImageData) {
            this._useMipmap = false;
            this.updateTextureDescription();
            this.updateGPUTexture();
            void this.gpuTexture;
          }
        }
        this._textureChange = true;
        this._useMipmap = value;
        this.noticeChange();
      }
      /**
       * the cached CPU source image used to (re)upload the GPU texture
       */
      get sourceImageData() {
        return this._sourceImageData;
      }
      /**
       * Compute the full mipmap chain length for the current texture size.
       * @returns number of mip levels
       */
      getMipmapCount() {
        let w = this.width;
        let h = this.height;
        let maxSize = Math.max(w, h);
        return 1 + Math.log2(maxSize) | 0;
      }
      /**
       * Recompute the mip level count and rebuild the texture descriptor.
       */
      updateTextureDescription() {
        this.mipmapCount = Math.floor(this.useMipmap ? this.getMipmapCount() : 1);
        this.createTextureDescriptor(this.width, this.height, this.mipmapCount, this.format);
      }
      /**
       * Destroy the materialized GPU texture and invalidate the cached view and
       * samplers so they re-materialize lazily from the current descriptor.
       */
      updateGPUTexture() {
        if (this._gpuTexture instanceof GPUTexture) {
          try {
            this._gpuTexture.destroy();
          } catch {
          }
        }
        this._gpuTexture = null;
        this._view = null;
        this._gpuSampler = null;
        this._gpuSampler_cmp = null;
        this._mipmapMaterialized = false;
      }
      /**
       * create or get GPUTexture (delegates to the per-context gpuTexture
       * getter, which handles lazy creation + source-image upload).
       */
      getGPUTexture() {
        return this.gpuTexture;
      }
      /**
       * create or get GPUTextureView (delegates to the per-context view
       * getter, which handles lazy creation from `viewDescriptor`).
       */
      getGPUView(_index = 0) {
        return this.view;
      }
      /** Registered state-change callbacks, keyed by their owner reference. */
      _stateChangeRef = /* @__PURE__ */ new Map();
      /**
       * Register a callback invoked when this texture's GPU resources change.
       * @param fun callback to invoke on change
       * @param ref owner reference used as the key for later unbinding
       */
      bindStateChange(fun, ref) {
        this._stateChangeRef.set(ref, fun);
      }
      /**
       * Remove a previously registered state-change callback.
       * @param ref owner reference used when binding the callback
       */
      unBindStateChange(ref) {
        this._stateChangeRef.delete(ref);
      }
      /**
       * Drop the cached samplers and notify all registered listeners that this
       * texture's descriptor changed.
       */
      noticeChange() {
        this._gpuSampler = null;
        this._gpuSampler_cmp = null;
        this._stateChangeRef.forEach((v) => {
          v();
        });
      }
      /**
       * release the materialized texture and all GPU slots
       */
      destroy(force) {
        if (force) {
          if (this._gpuTexture instanceof GPUTexture) {
            try {
              this._gpuTexture.destroy();
            } catch {
            }
          }
          this._gpuTexture = null;
          this._view = null;
          this._gpuSampler = null;
          this._gpuSampler_cmp = null;
          this._boundCtx = null;
          this.textureBindingLayout = null;
          this.textureDescriptor = null;
        }
        this._stateChangeRef.clear();
      }
      /**
       * Sampler address mode for the U (width) texture coordinate.
       */
      get addressModeU() {
        return this._addressModeU;
      }
      set addressModeU(value) {
        if (this._addressModeU != value) {
          this._addressModeU = value;
          this.noticeChange();
        }
      }
      /**
       * Sampler address mode for the V (height) texture coordinate.
       */
      get addressModeV() {
        return this._addressModeV;
      }
      set addressModeV(value) {
        if (this._addressModeV != value) {
          this._addressModeV = value;
          this.noticeChange();
        }
      }
      /**
       * Sampler address mode for the W (depth) texture coordinate.
       */
      get addressModeW() {
        return this._addressModeW;
      }
      set addressModeW(value) {
        if (this._addressModeW != value) {
          this._addressModeW = value;
          this.noticeChange();
        }
      }
      /**
       * Sampling filter used when the sample footprint is smaller than or equal
       * to one texel (magnification).
       */
      get magFilter() {
        return this._magFilter;
      }
      set magFilter(value) {
        if (this._magFilter != value) {
          this._magFilter = value;
          this.noticeChange();
        }
      }
      /**
       * Sampling filter used when the sample footprint is larger than one texel
       * (minification).
       */
      get minFilter() {
        return this._minFilter;
      }
      set minFilter(value) {
        if (this._minFilter != value) {
          this._minFilter = value;
          this.noticeChange();
        }
      }
      /**
       * Filter used when sampling between mipmap levels.
       */
      get mipmapFilter() {
        return this._mipmapFilter;
      }
      set mipmapFilter(value) {
        if (this._mipmapFilter != value) {
          this._mipmapFilter = value;
          this.noticeChange();
        }
      }
      /**
       * Minimum level-of-detail clamp used internally when sampling.
       */
      get lodMinClamp() {
        return this._lodMinClamp;
      }
      set lodMinClamp(value) {
        if (this._lodMinClamp != value) {
          this._lodMinClamp = value;
          this.noticeChange();
        }
      }
      /**
       * Maximum level-of-detail clamp used internally when sampling.
       */
      get lodMaxClamp() {
        return this._lodMaxClamp;
      }
      set lodMaxClamp(value) {
        if (this._lodMaxClamp != value) {
          this._lodMaxClamp = value;
          this.noticeChange();
        }
      }
      /**
       * Comparison function; when set the sampler becomes a comparison sampler.
       */
      get compare() {
        return this._compare;
      }
      set compare(value) {
        if (this._compare != value) {
          this._compare = value;
          this.noticeChange();
        }
      }
      /**
       * Maximum anisotropy clamp used by the sampler.
       */
      get maxAnisotropy() {
        return this._maxAnisotropy;
      }
      set maxAnisotropy(value) {
        if (this._maxAnisotropy != value) {
          this._maxAnisotropy = value;
          this.noticeChange();
        }
      }
      /**
       * Per-context list of GPU textures queued for deferred destruction.
       * @param ctx the context whose pending-destroy list is returned
       * @returns the context-scoped list of textures awaiting destruction
       */
      static _texs(ctx) {
        return ctx.cache(Texture, () => []);
      }
      /**
       * Queue a GPU texture for deferred destruction on the given context.
       * @param ctx the owning context
       * @param tex the GPU texture to destroy later
       */
      static delayDestroyTexture(ctx, tex) {
        let list = this._texs(ctx);
        if (!list.includes(tex)) {
          list.push(tex);
        }
      }
      /**
       * Destroy all GPU textures queued for deferred destruction on the context.
       * @param ctx the context whose queued textures are destroyed
       */
      static destroyTexture(ctx) {
        let list = this._texs(ctx);
        if (list.length > 0) {
          while (list.length > 0) {
            list.shift().destroy();
          }
        }
      }
    }

    class Context3D extends CEventDispatcher {
      /** Canvas aspect ratio (`windowWidth / windowHeight`), recomputed on resize. */
      aspect;
      /** Drawable surface size in physical pixels as `[width, height]`. */
      presentationSize = [0, 0];
      /** The HTML canvas element this context renders into. */
      canvas;
      /** The WebGPU canvas context obtained from `canvas.getContext('webgpu')`. */
      context;
      /** Canvas backing-store width in physical pixels (clientWidth * pixelRatio). */
      windowWidth;
      /** Canvas backing-store height in physical pixels (clientHeight * pixelRatio). */
      windowHeight;
      /** The canvas/configuration options supplied to `init()`. */
      canvasConfig;
      _pixelRatio = 1;
      _resizeEvent;
      _resizeObserver = null;
      _ownsCanvas = false;
      /** The GPUAdapter this context requested during `init()`. */
      adapter;
      /** The GPUDevice owned by this context; the root handle for all GPU work. */
      device;
      /** The format pipelines target — the sRGB view variant, so the
       *  GPU does the linear→sRGB encode at write time. Must match the
       *  view created in `GPUContext.beginRenderPass`. */
      presentationFormat;
      /** The non-sRGB swapchain configure format. Chromium rejects
       *  sRGB variants in `GPUCanvasContext.configure`, so the canvas
       *  is configured non-sRGB and an sRGB view is created on top. */
      _swapchainConfigureFormat;
      /** Back-reference to the owning Engine3D. Populated by `new Engine3D()`
       *  immediately after constructing this Context3D. Used by per-context
       *  subsystems (GlobalUniformGroup, RenderShaderPass, ...) to read the
       *  engine's instance `setting` without needing a view/camera handle. */
      engine = null;
      /** Set to true when the underlying GPUDevice has been lost (driver reset,
       *  device unplug, tab/iframe suspended, explicit `device.destroy()`...).
       *  Once lost, the device is permanently unusable — all `_boundCtx`
       *  resources on this Context3D are stale. The owning Engine3D stops
       *  scheduling render frames. App code should listen for
       *  `Context3D.DEVICE_LOST` and call `Engine3D.init()` again to recover. */
      lost = false;
      /** The `GPUDeviceLostInfo` captured when the device was lost, else null. */
      lostInfo = null;
      /** Event type dispatched on this Context3D when `device.lost` fires.
       *  `event.data` is the `GPUDeviceLostInfo` (reason + message). */
      static DEVICE_LOST = "deviceLost";
      /** Per-Context3D GPU command/pipeline state (lazy).
       *  Factory is installed by GPUContext.ts at its module load to avoid a
       *  circular ESM import at Context3D load time. */
      _gpuContext = null;
      /**
       * The per-Context3D GPU command/pipeline state, created lazily on first
       * access. Requires GPUContext.ts to have been imported so its factory is
       * registered; throws otherwise.
       *
       * @returns the GPUContextInstance bound to this Context3D.
       */
      get gpuContext() {
        if (!this._gpuContext) {
          if (!_gpuContextFactory) throw new Error("gpuContext factory not registered — import GPUContext before using gpuContext.");
          this._gpuContext = _gpuContextFactory(this);
        }
        return this._gpuContext;
      }
      /** Device pixel ratio used to scale the canvas backing store (clamped to 2.0). */
      get pixelRatio() {
        return this._pixelRatio;
      }
      /**
       * Initialize the WebGPU adapter, device, canvas and swapchain for this
       * context, wire up uncaptured-error and device-lost handlers, and start
       * observing the canvas for resize.
       *
       * @param canvasConfig optional canvas/configuration; when omitted (or
       *        without a `canvas`), a full-screen canvas is created and owned
       *        by this context.
       * @returns a promise resolving to true once initialization completes.
       */
      async init(canvasConfig) {
        if (navigator.gpu === void 0) throw new Error("Your browser does not support WebGPU!");
        this.adapter = await navigator.gpu.requestAdapter({ powerPreference: "high-performance" });
        if (!this.adapter) throw new Error("Your browser does not support WebGPU!");
        const ainfo = this.adapter.info;
        if (ainfo) ; else {
          try {
            const infoAsync = await this.adapter.requestAdapterInfo?.();
            if (infoAsync) {
            } else {
              if (false) ;
            }
          } catch (e) {
            console.log("[Context3D] adapter.info probe failed:", e?.message ?? e);
          }
        }
        Array.from(this.adapter.features || []);
        this.device = await this.adapter.requestDevice({
          requiredFeatures: [
            "bgra8unorm-storage",
            "depth-clip-control",
            "depth32float-stencil8",
            "indirect-first-instance",
            "rg11b10ufloat-renderable"
          ],
          requiredLimits: {
            minUniformBufferOffsetAlignment: 256,
            maxStorageBufferBindingSize: this.adapter.limits.maxStorageBufferBindingSize
          }
        });
        if (!this.device) throw new Error("Your browser does not support WebGPU!");
        this.device.label = `device-${Context3D._nextLabel++}`;
        const preferred = navigator.gpu.getPreferredCanvasFormat();
        if (preferred === "bgra8unorm") {
          this.presentationFormat = "bgra8unorm-srgb";
          this._swapchainConfigureFormat = "bgra8unorm";
        } else if (preferred === "rgba8unorm") {
          this.presentationFormat = "rgba8unorm-srgb";
          this._swapchainConfigureFormat = "rgba8unorm";
        } else {
          this.presentationFormat = preferred;
          this._swapchainConfigureFormat = preferred;
        }
        this.device.addEventListener("uncapturederror", (event) => {
          const e = event.error;
          console.error("[WebGPU uncaptured]", e?.constructor?.name ?? "Error", e?.message ?? e);
        });
        this.device.lost.then((info) => {
          this.lost = true;
          this.lostInfo = info;
          this.dispatchEvent(new CEvent(Context3D.DEVICE_LOST, info));
        });
        this.canvasConfig = canvasConfig;
        if (canvasConfig && canvasConfig.canvas) {
          this.canvas = canvasConfig.canvas;
          if (this.canvas === null) throw new Error("no Canvas");
          if (!this.canvas.style.width) this.canvas.style.width = this.canvas.width + "px";
          if (!this.canvas.style.height) this.canvas.style.height = this.canvas.height + "px";
        } else {
          this.canvas = document.createElement("canvas");
          this.canvas.style.position = `absolute`;
          this.canvas.style.top = "0px";
          this.canvas.style.left = "0px";
          this.canvas.style.width = "100%";
          this.canvas.style.height = "100%";
          this.canvas.style.zIndex = canvasConfig?.zIndex ? canvasConfig.zIndex.toString() : "0";
          document.body.appendChild(this.canvas);
          this._ownsCanvas = true;
        }
        if (canvasConfig && canvasConfig.backgroundImage) {
          this.canvas.style.background = `url(${canvasConfig.backgroundImage})`;
          this.canvas.style["background-size"] = "cover";
          this.canvas.style["background-position"] = "center";
        } else {
          this.canvas.style.background = "transparent";
        }
        this.canvas.style["touch-action"] = "none";
        this.canvas.style["object-fit"] = "cover";
        this.context = this.canvas.getContext("webgpu");
        this.context.configure({
          device: this.device,
          format: this._swapchainConfigureFormat,
          viewFormats: this._swapchainConfigureFormat !== this.presentationFormat ? [this.presentationFormat] : void 0,
          usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT,
          alphaMode: "premultiplied",
          colorSpace: `srgb`
        });
        this._resizeEvent = new CResizeEvent(CResizeEvent.RESIZE, { width: this.windowWidth, height: this.windowHeight });
        this._resizeObserver = new ResizeObserver(async () => {
          this.updateSize();
          try {
            if (this.device && !this.lost) {
              await this.device.queue.onSubmittedWorkDone();
            }
          } catch {
          }
          Texture.destroyTexture(this);
        });
        this._resizeObserver.observe(this.canvas);
        this.updateSize();
        return true;
      }
      /**
       * Release everything this context owns: the ResizeObserver, the
       * GPUCanvasContext configuration, the GPUDevice (frees the adapter
       * slot so the next Engine3D.init() can succeed without exhausting
       * the browser's per-origin device limit), and any canvas we created
       * ourselves. Safe to call more than once; idempotent after first run.
       *
       * After dispose(), `this.lost` flips to true via the device.lost
       * promise resolver installed in init(); the shared render loop
       * already skips lost contexts.
       */
      dispose() {
        if (this._resizeObserver) {
          this._resizeObserver.disconnect();
          this._resizeObserver = null;
        }
        if (this.context) {
          try {
            this.context.unconfigure();
          } catch {
          }
        }
        if (this.device && !this.lost) {
          try {
            this.device.destroy();
          } catch {
          }
        }
        if (this._ownsCanvas && this.canvas && this.canvas.parentNode) {
          this.canvas.parentNode.removeChild(this.canvas);
        }
        this._caches.clear();
        this._gpuContext = null;
        this.removeAllEventListener();
      }
      /**
       * Recompute the pixel ratio and canvas backing-store size from the
       * current client size. When the size changes, updates `windowWidth`,
       * `windowHeight`, `presentationSize`, `aspect` and dispatches a RESIZE event.
       */
      updateSize() {
        this._pixelRatio = this.canvasConfig?.devicePixelRatio || window.devicePixelRatio || 1;
        this._pixelRatio = Math.min(this._pixelRatio, 2);
        let w = Math.floor(this.canvas.clientWidth * this._pixelRatio);
        let h = Math.floor(this.canvas.clientHeight * this._pixelRatio);
        if (w != this.windowWidth || h != this.windowHeight) {
          this.canvas.width = this.windowWidth = w;
          this.canvas.height = this.windowHeight = h;
          this.presentationSize[0] = this.windowWidth;
          this.presentationSize[1] = this.windowHeight;
          this.aspect = this.windowWidth / this.windowHeight;
          this._resizeEvent.data.width = this.windowWidth;
          this._resizeEvent.data.height = this.windowHeight;
          this.dispatchEvent(this._resizeEvent);
        }
      }
      static _nextLabel = 0;
      /**
       * Per-Context3D lazy cache. Stores one value per `key` (typically the
       * owning class) so GPU objects can be memoized against a specific device
       * without leaking across Context3Ds.
       *
       * Usage: `ctx.cache(MyClass, () => new ExpensiveThing(ctx))`.
       */
      _caches = /* @__PURE__ */ new Map();
      cache(key, factory) {
        let v = this._caches.get(key);
        if (v === void 0) {
          v = factory();
          this._caches.set(key, v);
        }
        return v;
      }
    }
    let _defaultCtxResolver = null;
    function _registerDefaultCtxResolver(f) {
      _defaultCtxResolver = f;
    }
    function resolveDefaultCtx() {
      return _defaultCtxResolver ? _defaultCtxResolver() : null;
    }
    let _gpuContextFactory = null;
    function _registerGpuContextFactory(f) {
      _gpuContextFactory = f;
    }
    function bindCtx(owner, ctx) {
      if (owner._boundCtx === ctx) return ctx;
      if (owner._boundCtx && owner._boundCtx !== ctx) {
        throw new Error(
          `GPU resource already bound to a different Engine3D. Each GPU-bearing resource may only be used by one engine. Clone the CPU data to share across engines.`
        );
      }
      owner._boundCtx = ctx;
      return ctx;
    }

    exports.VisibleLayer = void 0;
    ((VisibleLayer2) => {
      VisibleLayer2.None = 0;
      VisibleLayer2.Default = 1 << 0;
      VisibleLayer2.All = 4294967295;
      function add(src, m) {
        return (src | m) >>> 0;
      }
      VisibleLayer2.add = add;
      function remove(src, m) {
        return (src & ~m) >>> 0;
      }
      VisibleLayer2.remove = remove;
      function has(src, m) {
        return (src & m) !== 0;
      }
      VisibleLayer2.has = has;
    })(exports.VisibleLayer || (exports.VisibleLayer = {}));
    class VisibleLayerUtil {
      static addMask(src, tag) {
        return exports.VisibleLayer.add(src, tag);
      }
      static removeMask(src, tag) {
        return exports.VisibleLayer.remove(src, tag);
      }
      static hasMask(m1, m2) {
        return exports.VisibleLayer.has(m1, m2);
      }
    }

    class ComponentCollect {
      /**
       * @internal
       */
      static componentsUpdateList;
      /**
       * @internal
       */
      static componentsLateUpdateList;
      /**
       * @internal
       */
      static componentsBeforeUpdateList;
      /**
       * @internal
       */
      static componentsComputeList;
      /**
       * @internal
       */
      static componentsEnablePickerList;
      /**
       * @internal
       */
      static graphicComponent;
      /**
       * Type-keyed index of live components per View3D. The outer map is
       * keyed by View, the inner map by the component's concrete class
       * (`(this as any).constructor`), the value is the live set of
       * instances enabled in that view.
       *
       * This is a pure registry — semantically independent of rendering.
       * RenderGraph passes use {@link collectByTypeLayered} to enumerate
       * a specific component type for a view, but the same index can
       * back physics queries, editor enumeration, audio listener
       * lookups, or any system that needs "give me every X in this
       * scene/view" by type rather than by lifecycle callback.
       *
       * @internal
       */
      static componentsByType;
      /**
       * @internal
       */
      // private static waitStartComponentBak: Map<Object3D, IComponent[]>;
      // private static waitStartComponentBody: Map<Object3D, IComponent[]>;
      static waitStartComponent;
      static _init = false;
      static init() {
        if (!this._init) {
          this._init = true;
          this.componentsUpdateList = /* @__PURE__ */ new Map();
          this.componentsLateUpdateList = /* @__PURE__ */ new Map();
          this.componentsBeforeUpdateList = /* @__PURE__ */ new Map();
          this.componentsComputeList = /* @__PURE__ */ new Map();
          this.componentsEnablePickerList = /* @__PURE__ */ new Map();
          this.graphicComponent = /* @__PURE__ */ new Map();
          this.componentsByType = /* @__PURE__ */ new Map();
          this.waitStartComponent = /* @__PURE__ */ new Map();
        }
      }
      static bindUpdate(view, component, call) {
        this.init();
        let list = this.componentsUpdateList.get(view);
        if (!list) {
          list = /* @__PURE__ */ new Map();
          this.componentsUpdateList.set(view, list);
        }
        list.set(component, call);
      }
      static unBindUpdate(view, component) {
        this.init();
        let list = this.componentsUpdateList.get(view);
        if (list) {
          list.delete(component);
        }
      }
      static bindLateUpdate(view, component, call) {
        this.init();
        let list = this.componentsLateUpdateList.get(view);
        if (!list) {
          list = /* @__PURE__ */ new Map();
          this.componentsLateUpdateList.set(view, list);
        }
        list.set(component, call);
      }
      static unBindLateUpdate(view, component) {
        this.init();
        let list = this.componentsLateUpdateList.get(view);
        if (list) {
          list.delete(component);
        }
      }
      static bindBeforeUpdate(view, component, call) {
        this.init();
        let list = this.componentsBeforeUpdateList.get(view);
        if (!list) {
          list = /* @__PURE__ */ new Map();
          this.componentsBeforeUpdateList.set(view, list);
        }
        list.set(component, call);
      }
      static unBindBeforeUpdate(view, component) {
        this.init();
        let list = this.componentsBeforeUpdateList.get(view);
        if (list) {
          list.delete(component);
        }
      }
      static bindCompute(view, component, call) {
        this.init();
        let list = this.componentsComputeList.get(view);
        if (!list) {
          list = /* @__PURE__ */ new Map();
          this.componentsComputeList.set(view, list);
        }
        list.set(component, call);
      }
      static unBindCompute(view, component) {
        this.init();
        let list = this.componentsComputeList.get(view);
        if (list) {
          list.delete(component);
        }
      }
      static bindGraphic(view, component, call) {
        this.init();
        let list = this.graphicComponent.get(view);
        if (!list) {
          list = /* @__PURE__ */ new Map();
          this.graphicComponent.set(view, list);
        }
        list.set(component, call);
      }
      static unBindGraphic(view, component) {
        this.init();
        let list = this.graphicComponent.get(view);
        if (list) {
          list.delete(component);
        }
      }
      static appendWaitStart(component) {
        this.init();
        let arr = this.waitStartComponent.get(component.object3D);
        if (!arr) {
          this.waitStartComponent.set(component.object3D, [component]);
        } else {
          let index = arr.indexOf(component);
          if (index == -1) {
            arr.push(component);
          }
        }
      }
      static removeWaitStart(obj, component) {
        this.init();
        let arr = ComponentCollect.waitStartComponent.get(obj);
        if (arr) {
          let index = arr.indexOf(component);
          if (index != -1) {
            arr.splice(index);
          }
        }
      }
      static bindEnablePick(view, component, call) {
        this.init();
        let list = this.componentsEnablePickerList.get(view);
        if (!list) {
          list = /* @__PURE__ */ new Map();
          this.componentsEnablePickerList.set(view, list);
        }
        list.set(component, call);
      }
      static unBindEnablePick(view, component) {
        this.init();
        let list = this.componentsEnablePickerList.get(view);
        if (list) {
          list.delete(component);
        }
      }
      /**
       * Add `comp` to the type-keyed registry under `(view, ctor)`. Used
       * by {@link ComponentBase.onEnable} to make the instance
       * discoverable via {@link collectByTypeLayered}.
       *
       * `ctor` should be the component's concrete class
       * (`(this as any).constructor` from the instance). Subclasses are
       * registered under their own class — a query for the parent class
       * will not enumerate subclass instances. Idempotent.
       */
      static register(view, ctor, component) {
        this.init();
        let perView = this.componentsByType.get(view);
        if (!perView) {
          perView = /* @__PURE__ */ new Map();
          this.componentsByType.set(view, perView);
        }
        let set = perView.get(ctor);
        if (!set) {
          set = /* @__PURE__ */ new Set();
          perView.set(ctor, set);
        }
        set.add(component);
      }
      /**
       * Remove `comp` from the type-keyed registry. Empty inner sets are
       * left in place so the next register call can reuse them without
       * a fresh allocation. Idempotent.
       */
      static unregister(view, ctor, component) {
        this.init();
        const perView = this.componentsByType.get(view);
        if (!perView) return;
        const set = perView.get(ctor);
        if (!set) return;
        set.delete(component);
      }
      /**
       * Collect all live components of `ctor` registered against `view`
       * whose `visibleLayer` intersects `layerMask`. Pass
       * {@link VisibleLayer.All} (`0xFFFFFFFF`) to skip layer filtering —
       * the bitwise AND then matches every bit.
       *
       * The caller owns `out`: it is cleared (`length = 0`) on entry and
       * populated in place, so a pass can hold a scratch array as a
       * member field and reuse it across frames without GC pressure
       * (mirrors {@link EntityCollect.getLayerLists}'s buffer-reuse
       * pattern). The returned reference is the same `out` for chaining.
       *
       * Callers that want to honour a camera's `cullingMask` should
       * pre-AND it into `layerMask` themselves; the predicate inside
       * does not re-read camera state.
       *
       * @param view       The View3D this pass executes against. A
       *                   `null` view returns immediately.
       * @param ctor       Concrete component class to enumerate. Must
       *                   match what {@link register} stored — i.e. the
       *                   subclass, not a base.
       * @param layerMask  Already-combined pass × camera mask.
       * @param out        Scratch array, owned by the caller; mutated.
       */
      static collectByTypeLayered(view, ctor, layerMask, out) {
        this.init();
        out.length = 0;
        if (!view) return out;
        const perView = this.componentsByType.get(view);
        if (!perView) return out;
        const set = perView.get(ctor);
        if (!set || set.size === 0) return out;
        const mask = (layerMask & exports.VisibleLayer.All) >>> 0;
        if (mask === 0) return out;
        for (const comp of set) {
          const c = comp;
          if (!c.enable) continue;
          if (((c.visibleLayer | 0) & mask) === 0) continue;
          out.push(c);
        }
        return out;
      }
      // Called from Engine3D.dispose() so a disposed engine's View3D entries
      // don't linger in every per-view static map (would leak the View3D, its
      // scene tree, and every registered component callback).
      static removeView(view) {
        this.init();
        this.componentsUpdateList.delete(view);
        this.componentsLateUpdateList.delete(view);
        this.componentsBeforeUpdateList.delete(view);
        this.componentsComputeList.delete(view);
        this.componentsEnablePickerList.delete(view);
        this.graphicComponent.delete(view);
        this.componentsByType.delete(view);
      }
      // Some components bind with a null View3D because their owning Object3D
      // was never attached to a scene (ViewQuad, CSM shadow cameras, cube
      // cameras). Those live under a shared `view=null` key in every inner map,
      // so per-view eviction cannot reach them. Purge all null-keyed entries
      // whose component or object3D was bound to the given ctx.
      static removeNullViewEntriesForCtx(ctx) {
        this.init();
        const lists = [
          this.componentsUpdateList,
          this.componentsLateUpdateList,
          this.componentsBeforeUpdateList,
          this.componentsComputeList,
          this.graphicComponent
        ];
        for (const list of lists) {
          const inner = list.get(null);
          if (!inner) continue;
          for (const comp of [...inner.keys()]) {
            const compCtx = comp._boundCtx;
            const objCtx = comp.object3D?._boundCtx;
            if (compCtx === ctx || objCtx === ctx) {
              inner.delete(comp);
            }
          }
          if (inner.size === 0) list.delete(null);
        }
      }
    }

    function NonSerialize(cls, key) {
      let dic = cls["__NonSerialize__"];
      if (!dic) {
        dic = cls["__NonSerialize__"] = {};
        dic["__NonSerialize__"] = true;
      }
      dic[key] = true;
    }
    function IsNonSerialize(instance, key) {
      let noSerializeDic;
      while (instance) {
        instance = instance["__proto__"];
        if (instance) noSerializeDic = instance["__NonSerialize__"];
        if (noSerializeDic) break;
      }
      return noSerializeDic && noSerializeDic[key];
    }
    function EditorInspector(cls, key, p1, p2, p3) {
      let dic = cls["__EditorInspector__"];
      if (!dic) {
        dic = cls["__EditorInspector__"] = /* @__PURE__ */ new Map();
      }
      let property = dic.get(cls.constructor.name);
      if (!property) {
        property = /* @__PURE__ */ new Map();
        dic.set(cls.constructor.name, property);
      }
      property.set(key, { p1, p2, p3 });
    }
    function IsEditorInspector(instance) {
      let propertyDic;
      let ins = instance;
      let list = [];
      while (ins) {
        if (list.indexOf(ins.constructor.name) != -1) {
          ins = ins["__proto__"];
          continue;
        }
        list.push(ins.constructor.name);
        ins = ins["__proto__"];
      }
      list = list.reverse();
      ins = instance;
      while (ins) {
        ins = ins["__proto__"];
        if (ins) {
          propertyDic = ins["__EditorInspector__"];
        }
        if (propertyDic) break;
      }
      let final = /* @__PURE__ */ new Map();
      if (propertyDic) {
        for (let i = 0; i < list.length; i++) {
          const c_name = list[i];
          let dic = propertyDic.get(c_name);
          if (dic) {
            dic.forEach((v, k) => {
              final.set(k, v);
            });
          }
        }
      }
      return final;
    }
    function RegisterComponent(cls, key, p1, p2, p3) {
      let dic = window["__Component__"];
      if (!dic) {
        dic = window["__Component__"] = {};
      }
      dic[key ?? cls.name] = cls;
    }
    function GetComponentClass(name) {
      let coms = window["__Component__"];
      if (coms[name]) {
        return coms[name];
      }
      return null;
    }
    function RegisterShader(cls, key, p1, p2, p3) {
      let dic = window["__shader__"];
      if (!dic) {
        dic = window["__shader__"] = {};
      }
      dic[key ?? cls.name] = cls;
    }
    function GetShader(name) {
      let coms = window["__shader__"];
      if (coms[name]) {
        return coms[name];
      }
      return null;
    }

    var __defProp$4 = Object.defineProperty;
    var __getOwnPropDesc$r = Object.getOwnPropertyDescriptor;
    var __decorateClass$s = (decorators, target, key, kind) => {
      var result = __getOwnPropDesc$r(target, key) ;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(target, key, result) ) || result;
      if (result) __defProp$4(target, key, result);
      return result;
    };
    class ComponentBase {
      /**
       * owner object3D
       */
      object3D = null;
      _visibleLayer = exports.VisibleLayer.Default;
      get visibleLayer() {
        return this._visibleLayer;
      }
      set visibleLayer(value) {
        this._visibleLayer = value >>> 0;
      }
      /**
       * @internal
       */
      _eventDispatcher;
      get eventDispatcher() {
        this._eventDispatcher ||= new CEventDispatcher();
        return this._eventDispatcher;
      }
      set eventDispatcher(value) {
        console.error("The eventDispatcher should not be set externally!");
      }
      /**
       * @internal
       */
      _enable = true;
      __isStart = false;
      isDestroyed = false;
      get isStart() {
        return this.__isStart;
      }
      /**
       * Return the Transform component attached to the Object3D.
       * Null before the component is attached — `addComponent` assigns
       * `object3D` only after construction — so constructor-time callers
       * can probe safely via `this.transform?.`.
       */
      get transform() {
        return this.object3D ? this.object3D.transform : null;
      }
      /**
       * Enable/disable components. The enabled components can be updated, while the disabled components cannot be updated.
       */
      set enable(value) {
        if (this._enable != value) {
          this._enable = value;
          const view = this.transform.view3D;
          if (this._enable) {
            if (view) ComponentCollect.register(view, this.constructor, this);
            this.onEnable?.(view);
          } else {
            if (view) ComponentCollect.unregister(view, this.constructor, this);
            this.onDisable?.(view);
          }
        }
      }
      /**
       * Enable/disable components. The enabled components can be updated, while the disabled components cannot be updated.
       */
      get enable() {
        return this._enable;
      }
      __init(param) {
        this.init(param);
      }
      __start() {
        if (this.transform && this.transform.scene3D && this._enable) {
          const view = this.transform.view3D;
          if (view) ComponentCollect.register(view, this.constructor, this);
          this.onEnable?.(view);
        }
        if (this.transform && this.transform.scene3D && this.__isStart == false) {
          this.start?.();
          this.__isStart = true;
        }
        if (this.onUpdate) {
          this._onUpdate(this.onUpdate.bind(this));
        }
        if (this.onLateUpdate) {
          this._onLateUpdate(this.onLateUpdate.bind(this));
        }
        if (this.onBeforeUpdate) {
          this._onBeforeUpdate(this.onBeforeUpdate.bind(this));
        }
        if (this.onCompute) {
          this._onCompute(this.onCompute.bind(this));
        }
        if (this.onGraphic) {
          this._onGraphic(this.onGraphic.bind(this));
        }
      }
      __stop() {
        if (this.transform && this.transform.scene3D) {
          const view = this.transform.view3D;
          if (view) ComponentCollect.unregister(view, this.constructor, this);
          this.onDisable?.(view);
        }
        this._onUpdate(null);
        this._onLateUpdate(null);
        this._onBeforeUpdate(null);
        this._onCompute(null);
        this._onGraphic(null);
      }
      init(param) {
      }
      start() {
      }
      stop() {
      }
      /**
       *
       * clone component data to target object3D
       * @param obj target object3D
       */
      cloneTo(obj) {
      }
      copyComponent(from) {
        return this;
      }
      /**
       * internal
       * Add update function. Will be executed at every frame update.
       * @param call callback
       */
      _onUpdate(call) {
        if (call != null) {
          ComponentCollect.bindUpdate(this.transform.view3D, this, call);
        } else {
          ComponentCollect.unBindUpdate(this.transform.view3D, this);
        }
      }
      /**
       * Add a delayed update function.
       * @param call callback
       */
      _onLateUpdate(call) {
        if (call != null) {
          ComponentCollect.bindLateUpdate(this.transform.view3D, this, call);
        } else {
          ComponentCollect.unBindLateUpdate(this.transform.view3D, this);
        }
      }
      /**
       * The function executed before adding frame updates.
       * @param call callback
       */
      _onBeforeUpdate(call) {
        if (call != null) {
          ComponentCollect.bindBeforeUpdate(this.transform.view3D, this, call);
        } else {
          ComponentCollect.unBindBeforeUpdate(this.transform.view3D, this);
        }
      }
      /**
       * @internal
       * Add individual execution compute capability
       * @param call callback
       */
      _onCompute(call) {
        if (call != null) {
          ComponentCollect.bindCompute(this.transform.view3D, this, call);
        } else {
          ComponentCollect.unBindCompute(this.transform.view3D, this);
        }
      }
      /**
       * Add individual execution drawing ability
       * @param call callback
       */
      _onGraphic(call) {
        if (call != null) {
          ComponentCollect.bindGraphic(this.transform.view3D, this, call);
        } else {
          ComponentCollect.unBindGraphic(this.transform.view3D, this);
        }
      }
      /**
       * before release this component, object refrences are not be set null now.
       */
      beforeDestroy(force) {
        ComponentCollect.removeWaitStart(this.object3D, this);
      }
      /**
       * release this component
       */
      destroy(force) {
        if (this.isDestroyed) return;
        this.isDestroyed = true;
        this.enable = false;
        this.stop();
        this._onBeforeUpdate(null);
        this._onUpdate(null);
        this._onLateUpdate(null);
        this.onEnable = null;
        this.onDisable = null;
        this.onUpdate = null;
        this.onLateUpdate = null;
        this.onBeforeUpdate = null;
        this.onCompute = null;
        this.onGraphic = null;
      }
    }
    __decorateClass$s([
      EditorInspector
    ], ComponentBase.prototype, "visibleLayer");

    class HaltonSeq {
      value = 0;
      inv_base = 0;
      /** Computes the Halton sequence value at the given index for the given radix (base). */
      static get(index, radix) {
        let result = 0;
        let fraction = 1 / radix;
        while (index > 0) {
          result += index % radix * fraction;
          index /= radix;
          fraction /= radix;
        }
        return result;
      }
      /** Computes the Halton value at the given index for the given base and stores it as the current value. */
      getBase(index, base) {
        let f = this.inv_base = 1 / base;
        while (index > 0) {
          this.value += f * (index % base);
          index /= base;
          f *= this.inv_base;
        }
      }
      /** Advances the sequence to the next value incrementally. */
      next() {
        let r = 1 - this.value - 1e-7;
        if (this.inv_base < r) this.value += this.inv_base;
        else {
          let h = this.inv_base, hh;
          do {
            hh = h;
            h *= this.inv_base;
          } while (h >= r);
          this.value += hh + h - 1;
        }
      }
      /** Returns the current value of the sequence. */
      get() {
        return this.value;
      }
    }

    var Module = (() => {
      var _scriptDir = (typeof document === 'undefined' && typeof location === 'undefined' ? require('u' + 'rl').pathToFileURL(__filename).href : typeof document === 'undefined' ? location.href : (_documentCurrentScript && _documentCurrentScript.tagName.toUpperCase() === 'SCRIPT' && _documentCurrentScript.src || new URL('orillusion.umd.max.js', document.baseURI).href));
      
      return (
    async function(moduleArg = {}) {

    var Module=moduleArg;var readyPromiseResolve,readyPromiseReject;Module["ready"]=new Promise((resolve,reject)=>{readyPromiseResolve=resolve;readyPromiseReject=reject;});var moduleOverrides=Object.assign({},Module);var arguments_=[];var thisProgram="./this.program";var quit_=(status,toThrow)=>{throw toThrow};var ENVIRONMENT_IS_WEB=typeof window=="object";var ENVIRONMENT_IS_WORKER=typeof importScripts=="function";var ENVIRONMENT_IS_NODE=typeof process=="object"&&typeof process.versions=="object"&&typeof process.versions.node=="string";var scriptDirectory="";function locateFile(path){if(Module["locateFile"]){return Module["locateFile"](path,scriptDirectory)}return scriptDirectory+path}var read_,readBinary;if(ENVIRONMENT_IS_NODE){const{createRequire:createRequire}=await Promise.resolve().then(() => __viteBrowserExternal);var require$1=createRequire((typeof document === 'undefined' && typeof location === 'undefined' ? require('u' + 'rl').pathToFileURL(__filename).href : typeof document === 'undefined' ? location.href : (_documentCurrentScript && _documentCurrentScript.tagName.toUpperCase() === 'SCRIPT' && _documentCurrentScript.src || new URL('orillusion.umd.max.js', document.baseURI).href)));var fs=require$1("fs");var nodePath=require$1("path");if(ENVIRONMENT_IS_WORKER){scriptDirectory=nodePath.dirname(scriptDirectory)+"/";}else {scriptDirectory=require$1("url").fileURLToPath(new URL("./", (typeof document === 'undefined' && typeof location === 'undefined' ? require('u' + 'rl').pathToFileURL(__filename).href : typeof document === 'undefined' ? location.href : (_documentCurrentScript && _documentCurrentScript.tagName.toUpperCase() === 'SCRIPT' && _documentCurrentScript.src || new URL('orillusion.umd.max.js', document.baseURI).href))));}read_=(filename,binary)=>{filename=isFileURI(filename)?new URL(filename):nodePath.normalize(filename);return fs.readFileSync(filename,binary?undefined:"utf8")};readBinary=filename=>{var ret=read_(filename,true);if(!ret.buffer){ret=new Uint8Array(ret);}return ret};if(!Module["thisProgram"]&&process.argv.length>1){thisProgram=process.argv[1].replace(/\\/g,"/");}arguments_=process.argv.slice(2);quit_=(status,toThrow)=>{process.exitCode=status;throw toThrow};Module["inspect"]=()=>"[Emscripten Module object]";}else if(ENVIRONMENT_IS_WEB||ENVIRONMENT_IS_WORKER){if(ENVIRONMENT_IS_WORKER){scriptDirectory=self.location.href;}else if(typeof document!="undefined"&&document.currentScript){scriptDirectory=document.currentScript.src;}if(_scriptDir){scriptDirectory=_scriptDir;}if(scriptDirectory.indexOf("blob:")!==0){scriptDirectory=scriptDirectory.substr(0,scriptDirectory.replace(/[?#].*/,"").lastIndexOf("/")+1);}else {scriptDirectory="";}{read_=url=>{var xhr=new XMLHttpRequest;xhr.open("GET",url,false);xhr.send(null);return xhr.responseText};if(ENVIRONMENT_IS_WORKER){readBinary=url=>{var xhr=new XMLHttpRequest;xhr.open("GET",url,false);xhr.responseType="arraybuffer";xhr.send(null);return new Uint8Array(xhr.response)};}}}else;var out=Module["print"]||console.log.bind(console);var err=Module["printErr"]||console.error.bind(console);Object.assign(Module,moduleOverrides);moduleOverrides=null;if(Module["arguments"])arguments_=Module["arguments"];if(Module["thisProgram"])thisProgram=Module["thisProgram"];if(Module["quit"])quit_=Module["quit"];var wasmBinary;if(Module["wasmBinary"])wasmBinary=Module["wasmBinary"];Module["noExitRuntime"]||true;if(typeof WebAssembly!="object"){abort("no native wasm support detected");}var wasmMemory;var ABORT=false;var EXITSTATUS;var HEAP8,HEAPU8,HEAPU32;function updateMemoryViews(){var b=wasmMemory.buffer;Module["HEAP8"]=HEAP8=new Int8Array(b);Module["HEAP16"]=new Int16Array(b);Module["HEAPU8"]=HEAPU8=new Uint8Array(b);Module["HEAPU16"]=new Uint16Array(b);Module["HEAP32"]=new Int32Array(b);Module["HEAPU32"]=HEAPU32=new Uint32Array(b);Module["HEAPF32"]=new Float32Array(b);Module["HEAPF64"]=new Float64Array(b);}var __ATPRERUN__=[];var __ATINIT__=[];var __ATMAIN__=[];var __ATPOSTRUN__=[];function preRun(){if(Module["preRun"]){if(typeof Module["preRun"]=="function")Module["preRun"]=[Module["preRun"]];while(Module["preRun"].length){addOnPreRun(Module["preRun"].shift());}}callRuntimeCallbacks(__ATPRERUN__);}function initRuntime(){callRuntimeCallbacks(__ATINIT__);}function preMain(){callRuntimeCallbacks(__ATMAIN__);}function postRun(){if(Module["postRun"]){if(typeof Module["postRun"]=="function")Module["postRun"]=[Module["postRun"]];while(Module["postRun"].length){addOnPostRun(Module["postRun"].shift());}}callRuntimeCallbacks(__ATPOSTRUN__);}function addOnPreRun(cb){__ATPRERUN__.unshift(cb);}function addOnInit(cb){__ATINIT__.unshift(cb);}function addOnPostRun(cb){__ATPOSTRUN__.unshift(cb);}var runDependencies=0;var dependenciesFulfilled=null;function addRunDependency(id){runDependencies++;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}}function removeRunDependency(id){runDependencies--;if(Module["monitorRunDependencies"]){Module["monitorRunDependencies"](runDependencies);}if(runDependencies==0){if(dependenciesFulfilled){var callback=dependenciesFulfilled;dependenciesFulfilled=null;callback();}}}function abort(what){if(Module["onAbort"]){Module["onAbort"](what);}what="Aborted("+what+")";err(what);ABORT=true;EXITSTATUS=1;what+=". Build with -sASSERTIONS for more info.";var e=new WebAssembly.RuntimeError(what);readyPromiseReject(e);throw e}var dataURIPrefix="data:application/octet-stream;base64,";function isDataURI(filename){return filename.startsWith(dataURIPrefix)}function isFileURI(filename){return filename.startsWith("file://")}var wasmBinaryFile;wasmBinaryFile="data:application/octet-stream;base64,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";if(!isDataURI(wasmBinaryFile)){wasmBinaryFile=locateFile(wasmBinaryFile);}function getBinarySync(file){if(file==wasmBinaryFile&&wasmBinary){return new Uint8Array(wasmBinary)}var binary=tryParseAsDataURI(file);if(binary){return binary}if(readBinary){return readBinary(file)}throw "both async and sync fetching of the wasm failed"}function getBinaryPromise(binaryFile){return Promise.resolve().then(()=>getBinarySync(binaryFile))}function instantiateArrayBuffer(binaryFile,imports,receiver){return getBinaryPromise(binaryFile).then(binary=>WebAssembly.instantiate(binary,imports)).then(instance=>instance).then(receiver,reason=>{err(`failed to asynchronously prepare wasm: ${reason}`);abort(reason);})}function instantiateAsync(binary,binaryFile,imports,callback){return instantiateArrayBuffer(binaryFile,imports,callback)}function createWasm(){var info={"a":wasmImports};function receiveInstance(instance,module){var exports$1=instance.exports;wasmExports=exports$1;wasmMemory=wasmExports["f"];updateMemoryViews();wasmExports["r"];addOnInit(wasmExports["g"]);removeRunDependency();return exports$1}addRunDependency();function receiveInstantiationResult(result){receiveInstance(result["instance"]);}if(Module["instantiateWasm"]){try{return Module["instantiateWasm"](info,receiveInstance)}catch(e){err(`Module.instantiateWasm callback failed with error: ${e}`);readyPromiseReject(e);}}instantiateAsync(wasmBinary,wasmBinaryFile,info,receiveInstantiationResult).catch(readyPromiseReject);return {}}function ExitStatus(status){this.name="ExitStatus";this.message=`Program terminated with exit(${status})`;this.status=status;}var callRuntimeCallbacks=callbacks=>{while(callbacks.length>0){callbacks.shift()(Module);}};function ExceptionInfo(excPtr){this.excPtr=excPtr;this.ptr=excPtr-24;this.set_type=function(type){HEAPU32[this.ptr+4>>2]=type;};this.get_type=function(){return HEAPU32[this.ptr+4>>2]};this.set_destructor=function(destructor){HEAPU32[this.ptr+8>>2]=destructor;};this.get_destructor=function(){return HEAPU32[this.ptr+8>>2]};this.set_caught=function(caught){caught=caught?1:0;HEAP8[this.ptr+12>>0]=caught;};this.get_caught=function(){return HEAP8[this.ptr+12>>0]!=0};this.set_rethrown=function(rethrown){rethrown=rethrown?1:0;HEAP8[this.ptr+13>>0]=rethrown;};this.get_rethrown=function(){return HEAP8[this.ptr+13>>0]!=0};this.init=function(type,destructor){this.set_adjusted_ptr(0);this.set_type(type);this.set_destructor(destructor);};this.set_adjusted_ptr=function(adjustedPtr){HEAPU32[this.ptr+16>>2]=adjustedPtr;};this.get_adjusted_ptr=function(){return HEAPU32[this.ptr+16>>2]};this.get_exception_ptr=function(){var isPointer=___cxa_is_pointer_type(this.get_type());if(isPointer){return HEAPU32[this.excPtr>>2]}var adjusted=this.get_adjusted_ptr();if(adjusted!==0)return adjusted;return this.excPtr};}var exceptionLast=0;var ___cxa_throw=(ptr,type,destructor)=>{var info=new ExceptionInfo(ptr);info.init(type,destructor);exceptionLast=ptr;throw exceptionLast};var _abort=()=>{abort("");};var _emscripten_memcpy_big=(dest,src,num)=>HEAPU8.copyWithin(dest,src,src+num);var getHeapMax=()=>2147483648;var growMemory=size=>{var b=wasmMemory.buffer;var pages=(size-b.byteLength+65535)/65536;try{wasmMemory.grow(pages);updateMemoryViews();return 1}catch(e){}};var _emscripten_resize_heap=requestedSize=>{var oldSize=HEAPU8.length;requestedSize>>>=0;var maxHeapSize=getHeapMax();if(requestedSize>maxHeapSize){return false}var alignUp=(x,multiple)=>x+(multiple-x%multiple)%multiple;for(var cutDown=1;cutDown<=4;cutDown*=2){var overGrownHeapSize=oldSize*(1+.2/cutDown);overGrownHeapSize=Math.min(overGrownHeapSize,requestedSize+100663296);var newSize=Math.min(maxHeapSize,alignUp(Math.max(requestedSize,overGrownHeapSize),65536));var replacement=growMemory(newSize);if(replacement){return true}}return false};var printCharBuffers=[null,[],[]];var UTF8Decoder=typeof TextDecoder!="undefined"?new TextDecoder("utf8"):undefined;var UTF8ArrayToString=(heapOrArray,idx,maxBytesToRead)=>{var endIdx=idx+maxBytesToRead;var endPtr=idx;while(heapOrArray[endPtr]&&!(endPtr>=endIdx))++endPtr;if(endPtr-idx>16&&heapOrArray.buffer&&UTF8Decoder){return UTF8Decoder.decode(heapOrArray.subarray(idx,endPtr))}var str="";while(idx<endPtr){var u0=heapOrArray[idx++];if(!(u0&128)){str+=String.fromCharCode(u0);continue}var u1=heapOrArray[idx++]&63;if((u0&224)==192){str+=String.fromCharCode((u0&31)<<6|u1);continue}var u2=heapOrArray[idx++]&63;if((u0&240)==224){u0=(u0&15)<<12|u1<<6|u2;}else {u0=(u0&7)<<18|u1<<12|u2<<6|heapOrArray[idx++]&63;}if(u0<65536){str+=String.fromCharCode(u0);}else {var ch=u0-65536;str+=String.fromCharCode(55296|ch>>10,56320|ch&1023);}}return str};var printChar=(stream,curr)=>{var buffer=printCharBuffers[stream];if(curr===0||curr===10){(stream===1?out:err)(UTF8ArrayToString(buffer,0));buffer.length=0;}else {buffer.push(curr);}};var _fd_write=(fd,iov,iovcnt,pnum)=>{var num=0;for(var i=0;i<iovcnt;i++){var ptr=HEAPU32[iov>>2];var len=HEAPU32[iov+4>>2];iov+=8;for(var j=0;j<len;j++){printChar(fd,HEAPU8[ptr+j]);}num+=len;}HEAPU32[pnum>>2]=num;return 0};var _proc_exit=code=>{EXITSTATUS=code;quit_(code,new ExitStatus(code));};var exitJS=(status,implicit)=>{EXITSTATUS=status;_proc_exit(status);};var handleException=e=>{if(e instanceof ExitStatus||e=="unwind"){return EXITSTATUS}quit_(1,e);};var lengthBytesUTF8=str=>{var len=0;for(var i=0;i<str.length;++i){var c=str.charCodeAt(i);if(c<=127){len++;}else if(c<=2047){len+=2;}else if(c>=55296&&c<=57343){len+=4;++i;}else {len+=3;}}return len};var stringToUTF8Array=(str,heap,outIdx,maxBytesToWrite)=>{if(!(maxBytesToWrite>0))return 0;var startIdx=outIdx;var endIdx=outIdx+maxBytesToWrite-1;for(var i=0;i<str.length;++i){var u=str.charCodeAt(i);if(u>=55296&&u<=57343){var u1=str.charCodeAt(++i);u=65536+((u&1023)<<10)|u1&1023;}if(u<=127){if(outIdx>=endIdx)break;heap[outIdx++]=u;}else if(u<=2047){if(outIdx+1>=endIdx)break;heap[outIdx++]=192|u>>6;heap[outIdx++]=128|u&63;}else if(u<=65535){if(outIdx+2>=endIdx)break;heap[outIdx++]=224|u>>12;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}else {if(outIdx+3>=endIdx)break;heap[outIdx++]=240|u>>18;heap[outIdx++]=128|u>>12&63;heap[outIdx++]=128|u>>6&63;heap[outIdx++]=128|u&63;}}heap[outIdx]=0;return outIdx-startIdx};var stringToUTF8=(str,outPtr,maxBytesToWrite)=>stringToUTF8Array(str,HEAPU8,outPtr,maxBytesToWrite);var stringToUTF8OnStack=str=>{var size=lengthBytesUTF8(str)+1;var ret=stackAlloc(size);stringToUTF8(str,ret,size);return ret};var wasmImports={b:___cxa_throw,d:_abort,e:_emscripten_memcpy_big,c:_emscripten_resize_heap,a:_fd_write};var wasmExports=createWasm();Module["_initialize"]=(a0,a1,a2)=>(Module["_initialize"]=wasmExports["h"])(a0,a1,a2);Module["_allocMatrix"]=a0=>(Module["_allocMatrix"]=wasmExports["i"])(a0);Module["_getMatrixBufferPtr"]=()=>(Module["_getMatrixBufferPtr"]=wasmExports["j"])();Module["_getSRTPtr"]=()=>(Module["_getSRTPtr"]=wasmExports["k"])();Module["_getInfoPtr"]=()=>(Module["_getInfoPtr"]=wasmExports["l"])();Module["_getContinuedSRTPtr"]=()=>(Module["_getContinuedSRTPtr"]=wasmExports["m"])();Module["_getWorldPositionHLPtr"]=()=>(Module["_getWorldPositionHLPtr"]=wasmExports["n"])();Module["_printMatrix"]=a0=>(Module["_printMatrix"]=wasmExports["o"])(a0);Module["_updateAllMatrixContinueTransform"]=(a0,a1,a2,a3)=>(Module["_updateAllMatrixContinueTransform"]=wasmExports["p"])(a0,a1,a2,a3);var _main=Module["_main"]=(a0,a1)=>(_main=Module["_main"]=wasmExports["q"])(a0,a1);var stackAlloc=a0=>(stackAlloc=wasmExports["s"])(a0);var ___cxa_is_pointer_type=a0=>(___cxa_is_pointer_type=wasmExports["t"])(a0);function intArrayFromBase64(s){if(typeof ENVIRONMENT_IS_NODE!="undefined"&&ENVIRONMENT_IS_NODE){var buf=Buffer.from(s,"base64");return new Uint8Array(buf.buffer,buf.byteOffset,buf.length)}try{var decoded=atob(s);var bytes=new Uint8Array(decoded.length);for(var i=0;i<decoded.length;++i){bytes[i]=decoded.charCodeAt(i);}return bytes}catch(_){throw new Error("Converting base64 string to bytes failed.")}}function tryParseAsDataURI(filename){if(!isDataURI(filename)){return}return intArrayFromBase64(filename.slice(dataURIPrefix.length))}var calledRun;dependenciesFulfilled=function runCaller(){if(!calledRun)run();if(!calledRun)dependenciesFulfilled=runCaller;};function callMain(args=[]){var entryFunction=_main;args.unshift(thisProgram);var argc=args.length;var argv=stackAlloc((argc+1)*4);var argv_ptr=argv;args.forEach(arg=>{HEAPU32[argv_ptr>>2]=stringToUTF8OnStack(arg);argv_ptr+=4;});HEAPU32[argv_ptr>>2]=0;try{var ret=entryFunction(argc,argv);exitJS(ret,true);return ret}catch(e){return handleException(e)}}function run(args=arguments_){if(runDependencies>0){return}preRun();if(runDependencies>0){return}function doRun(){if(calledRun)return;calledRun=true;Module["calledRun"]=true;if(ABORT)return;initRuntime();preMain();readyPromiseResolve(Module);if(Module["onRuntimeInitialized"])Module["onRuntimeInitialized"]();if(shouldRunNow)callMain(args);postRun();}if(Module["setStatus"]){Module["setStatus"]("Running...");setTimeout(function(){setTimeout(function(){Module["setStatus"]("");},1);doRun();},1);}else {doRun();}}if(Module["preInit"]){if(typeof Module["preInit"]=="function")Module["preInit"]=[Module["preInit"]];while(Module["preInit"].length>0){Module["preInit"].pop()();}}var shouldRunNow=true;if(Module["noInitialRun"])shouldRunNow=false;run();


      return moduleArg.ready
    }

    );
    })();

    function CreateFloatArray(buffer, byteOffset, length) {
      if (WasmMatrix.useDoublePrecision)
        return new Float64Array(buffer, byteOffset, length);
      return new Float32Array(buffer, byteOffset, length);
    }
    class WasmMatrix {
      /** World-matrix output buffer mapped onto the WASM heap. */
      static matrixBuffer;
      /** 32-bit copy of the world matrices (used when running in double precision). */
      static matrixBuffer_32bit;
      /** Per-object scale/rotation(quaternion)/translation input buffer. */
      static matrixSRTBuffer;
      /** Per-object continuous (per-frame delta) SRT buffer for animated transforms. */
      static matrixContinuedSRTBuffer;
      /** High/low split of world positions for relative-to-eye (RTE) precision. */
      static matrixWorldPositionHLBuffer;
      /** Per-object state buffer (dirty flags, parent index, depth order). */
      static matrixStateBuffer;
      /** WASM heap pointer to the world-matrix buffer. */
      static matrixBufferPtr;
      /** WASM heap pointer to the SRT buffer. */
      static matrixSRTBufferPtr;
      /** WASM heap pointer to the continuous SRT buffer. */
      static matrixContinuedSRTBufferPtr;
      /** WASM heap pointer to the world-position high/low buffer. */
      static matrixWorldPositionHLBufferPtr;
      /** WASM heap pointer to the state buffer. */
      static matrixStateBufferPtr;
      /** Loaded WASM matrix module instance. */
      static wasm;
      /** Number of Int32 entries per object in the state buffer. */
      static stateStruct = 4;
      /** Number of float entries per object in {@link matrixSRTBuffer}: 3 scale + 4 rotation quaternion (x, y, z, w) + 3 translation. */
      static srtStride = 10;
      /** Number of float entries per object in {@link matrixContinuedSRTBuffer}: 3 scale + 4 rotation delta quaternion (x, y, z, w) + 3 translation delta. */
      static continuedSrtStride = 10;
      /** Whether matrices are stored in 64-bit (double) precision. */
      static useDoublePrecision = false;
      /**
       * Load and initialize the WASM module, then allocate buffers for
       * `count` matrices.
       * @param count maximum number of matrices to allocate
       * @param useDoublePrecision use 64-bit floats when true
       */
      static async init(count, useDoublePrecision = false) {
        this.wasm = await Module();
        this.useDoublePrecision = useDoublePrecision;
        this.wasm._initialize(count, useDoublePrecision, 0);
        this.allocMatrix(count);
      }
      /**
       * Allocate the WASM-side matrix storage and map the shared buffers
       * onto the WASM heap for `count` matrices.
       * @param count number of matrices to allocate
       */
      static allocMatrix(count) {
        if (count > Matrix4.maxCount) {
          console.error(`The maximum allocation size is exceeded! current:${count}, limit:${Matrix4.maxCount}`);
        }
        this.wasm._allocMatrix(count);
        this.matrixBufferPtr = this.wasm._getMatrixBufferPtr();
        this.matrixSRTBufferPtr = this.wasm._getSRTPtr();
        this.matrixStateBufferPtr = this.wasm._getInfoPtr();
        this.matrixContinuedSRTBufferPtr = this.wasm._getContinuedSRTPtr();
        this.matrixWorldPositionHLBufferPtr = this.wasm._getWorldPositionHLPtr();
        if (this.useDoublePrecision) {
          this.matrixBuffer = CreateFloatArray(this.wasm.HEAPF64.buffer, this.matrixBufferPtr, 16 * count);
          this.matrixBuffer_32bit = new Float32Array(16 * count);
          this.matrixSRTBuffer = CreateFloatArray(this.wasm.HEAPF64.buffer, this.matrixSRTBufferPtr, WasmMatrix.srtStride * count);
          this.matrixContinuedSRTBuffer = CreateFloatArray(this.wasm.HEAPF64.buffer, this.matrixContinuedSRTBufferPtr, WasmMatrix.continuedSrtStride * count);
          this.matrixWorldPositionHLBuffer = new Float32Array(this.wasm.HEAPF32.buffer, this.matrixWorldPositionHLBufferPtr, 4 * 2 * count);
          Matrix4.blockBytes = Matrix4.block * 8;
        } else {
          this.matrixBuffer = CreateFloatArray(this.wasm.HEAPF32.buffer, this.matrixBufferPtr, 16 * count);
          this.matrixSRTBuffer = CreateFloatArray(this.wasm.HEAPF32.buffer, this.matrixSRTBufferPtr, WasmMatrix.srtStride * count);
          this.matrixContinuedSRTBuffer = CreateFloatArray(this.wasm.HEAPF32.buffer, this.matrixContinuedSRTBufferPtr, WasmMatrix.continuedSrtStride * count);
          this.matrixWorldPositionHLBuffer = new Float32Array(this.wasm.HEAPF32.buffer, this.matrixWorldPositionHLBufferPtr, 4 * 2 * count);
          Matrix4.blockBytes = Matrix4.block * 4;
        }
        this.matrixStateBuffer = new Int32Array(this.wasm.HEAP32.buffer, this.matrixStateBufferPtr, WasmMatrix.stateStruct * count);
        Matrix4.allocMatrix(count);
      }
      /**
       * Advance all continuous (auto-animating) transforms in the index
       * range `[start, end)` by `dt`.
       * @param start first matrix index
       * @param end one past the last matrix index
       * @param dt delta time in seconds
       * @param RTEScale relative-to-eye scale factor
       */
      static updateAllContinueTransform(start, end, dt, RTEScale) {
        this.wasm._updateAllMatrixContinueTransform(start, end, dt, RTEScale);
      }
      /**
       * Set the parent index and depth order for a matrix.
       * @param matIndex matrix index to update
       * @param x parent matrix index, or negative for no parent
       * @param depthOrder hierarchy depth order used for update sequencing
       */
      static setParent(matIndex, x, depthOrder) {
        const index = matIndex * WasmMatrix.stateStruct;
        this.matrixStateBuffer[index + 2] = x >= 0 ? x : -1;
        this.matrixStateBuffer[index + 3] = depthOrder;
      }
      /** Set the local translation of a matrix. */
      static setTranslate(matIndex, x, y, z) {
        const index = matIndex * WasmMatrix.srtStride;
        this.matrixSRTBuffer[index + 7] = x;
        this.matrixSRTBuffer[index + 8] = y;
        this.matrixSRTBuffer[index + 9] = z;
      }
      /** Set the local rotation of a matrix (quaternion x, y, z, w). */
      static setRotation(matIndex, x, y, z, w) {
        const index = matIndex * WasmMatrix.srtStride;
        this.matrixSRTBuffer[index + 3] = x;
        this.matrixSRTBuffer[index + 4] = y;
        this.matrixSRTBuffer[index + 5] = z;
        this.matrixSRTBuffer[index + 6] = w;
      }
      /** Set the local scale of a matrix. */
      static setScale(matIndex, x, y, z) {
        const index = matIndex * WasmMatrix.srtStride;
        this.matrixSRTBuffer[index + 0] = x;
        this.matrixSRTBuffer[index + 1] = y;
        this.matrixSRTBuffer[index + 2] = z;
      }
      /** Set a per-frame continuous translation delta (auto-applied each update). */
      static setContinueTranslate(matIndex, x, y, z) {
        if (x != 0 || y != 0 || z != 0) {
          const index = matIndex * WasmMatrix.continuedSrtStride;
          this.matrixContinuedSRTBuffer[index + 7] = x;
          this.matrixContinuedSRTBuffer[index + 8] = y;
          this.matrixContinuedSRTBuffer[index + 9] = z;
          this.matrixStateBuffer[matIndex * WasmMatrix.stateStruct + 1] = 1;
        }
      }
      /** Set a per-frame continuous rotation delta (Euler degrees/frame, auto-applied each update). */
      static setContinueRotation(matIndex, x, y, z) {
        if (x != 0 || y != 0 || z != 0) {
          const temp = Quaternion.HELP_2.setFromEuler(x, y, z);
          const index = matIndex * WasmMatrix.continuedSrtStride;
          this.matrixContinuedSRTBuffer[index + 3] = temp.x;
          this.matrixContinuedSRTBuffer[index + 4] = temp.y;
          this.matrixContinuedSRTBuffer[index + 5] = temp.z;
          this.matrixContinuedSRTBuffer[index + 6] = temp.w;
          this.matrixStateBuffer[matIndex * WasmMatrix.stateStruct + 1] = 1;
        }
      }
      /** Set a per-frame continuous scale delta (auto-applied each update). */
      static setContinueScale(matIndex, x, y, z) {
        if (x != 0 || y != 0 || z != 0) {
          const index = matIndex * WasmMatrix.continuedSrtStride;
          this.matrixContinuedSRTBuffer[index + 0] = x;
          this.matrixContinuedSRTBuffer[index + 1] = y;
          this.matrixContinuedSRTBuffer[index + 2] = z;
          this.matrixStateBuffer[matIndex * WasmMatrix.stateStruct + 1] = 1;
        }
      }
    }

    class Orientation3D {
      static AXIS_ANGLE = "axisAngle";
      static EULER_ANGLES = "eulerAngles";
      static QUATERNION = "quaternion";
    }

    class Quaternion {
      /** Shared scratch quaternion for intermediate calculations. */
      static HELP_0 = new Quaternion(0, 0, 0, 1);
      /** Shared scratch quaternion for intermediate calculations. */
      static HELP_1 = new Quaternion(0, 0, 0, 1);
      /** Shared scratch quaternion for intermediate calculations. */
      static HELP_2 = new Quaternion(0, 0, 0, 1);
      /** Shared identity quaternion (0, 0, 0, 1). */
      static _zero = new Quaternion(0, 0, 0, 1);
      /** Shared scratch quaternion used for rotation calculations. */
      static CALCULATION_QUATERNION = new Quaternion();
      /**
       * @internal
       */
      x = 0;
      /**
       * @internal
       */
      y = 0;
      /**
       * @internal
       */
      z = 0;
      /**
       * @internal
       */
      w = 1;
      /**
       * Create a new quaternion object
       * @param x The X component of a quaternion.
       * @param y The Y component of a quaternion.
       * @param z The Z component of a quaternion.
       * @param w The W component of a quaternion.
       */
      constructor(x = 0, y = 0, z = 0, w = 1) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
      }
      /**
       * Identity quaternion
       * @returns 
       */
      static identity() {
        return Quaternion._zero;
      }
      /**
       * Converts quaternions to matrices
       * @param q Quaternion
       * @param m Matrix
       */
      static quaternionToMatrix(q, m) {
        let x = q.x * 2;
        let y = q.y * 2;
        let z = q.z * 2;
        let xx = q.x * x;
        let yy = q.y * y;
        let zz = q.z * z;
        let xy = q.x * y;
        let xz = q.x * z;
        let yz = q.y * z;
        let wx = q.w * x;
        let wy = q.w * y;
        let wz = q.w * z;
        m.rawData[0] = 1 - (yy + zz);
        m.rawData[1] = xy + wz;
        m.rawData[2] = xz - wy;
        m.rawData[3] = 0;
        m.rawData[4] = xy - wz;
        m.rawData[5] = 1 - (xx + zz);
        m.rawData[6] = yz + wx;
        m.rawData[7] = 0;
        m.rawData[8] = xz + wy;
        m.rawData[9] = yz - wx;
        m.rawData[10] = 1 - (xx + yy);
        m.rawData[11] = 0;
        m.rawData[12] = 0;
        m.rawData[13] = 0;
        m.rawData[14] = 0;
        m.rawData[15] = 1;
      }
      /** The magnitude (norm) of this quaternion. */
      get magnitude() {
        return Math.sqrt(this.w * this.w + this.x * this.x + this.y * this.y + this.z * this.z);
      }
      /**
       * Set the x, y, z, and w components of the existing quaternions.
       * @param x The X component of a quaternion.
       * @param y The Y component of a quaternion.
       * @param z The Z component of a quaternion.
       * @param w The W component of a quaternion.
       */
      set(x = 0, y = 0, z = 0, w = 1) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
      }
      /** Divide this quaternion by another quaternion (component-wise, new instance) or by a scalar (in place). */
      divide(v) {
        if (v instanceof Quaternion) {
          return new Quaternion(this.x / v.x, this.y / v.y, this.z / v.z);
        } else {
          this.x = this.x / v;
          this.y = this.y / v;
          this.z = this.z / v;
        }
        return this;
      }
      /**
       * @internal
       */
      setFromArray(d) {
        this.x = d[0];
        this.y = d[1];
        this.z = d[2];
        this.w = d[3];
        return this;
      }
      /**
       * Multiply two quaternions
       * @param qa Quaternion 1
       * @param qb Quaternion 2
       */
      multiply(qa, qb) {
        var w1 = qa.w;
        var x1 = qa.x;
        var y1 = qa.y;
        var z1 = qa.z;
        var w2 = qb.w;
        var x2 = qb.x;
        var y2 = qb.y;
        var z2 = qb.z;
        this.w = w1 * w2 - x1 * x2 - y1 * y2 - z1 * z2;
        this.x = w1 * x2 + x1 * w2 + y1 * z2 - z1 * y2;
        this.y = w1 * y2 - x1 * z2 + y1 * w2 + z1 * x2;
        this.z = w1 * z2 + x1 * y2 - y1 * x2 + z1 * w2;
        return this;
      }
      /**
       * Multiply this quaternion by a vector. Returns a new Quaternion.
       */
      multiplyVector(vector) {
        const x2 = vector.x;
        const y2 = vector.y;
        const z2 = vector.z;
        return new Quaternion(
          this.w * x2 + this.y * z2 - this.z * y2,
          this.w * y2 - this.x * z2 + this.z * x2,
          this.w * z2 + this.x * y2 - this.y * x2,
          -this.x * x2 - this.y * y2 - this.z * z2
        );
      }
      /**
       * Set the quaternion with a given rotation of the axis and Angle.
       * @param axis  axis
       * @param angle angle
       */
      setFromAxisAngle(axis, angle) {
        angle *= Math.PI / 180;
        var halfAngle = angle * 0.5;
        var sinA = Math.sin(halfAngle);
        this.w = Math.cos(halfAngle);
        this.x = axis.x * sinA;
        this.y = axis.y * sinA;
        this.z = axis.z * sinA;
        this.normalize();
        return this;
      }
      /**
       * Turn quaternions into angles
       * @param axis axis
       * @returns 
       */
      toAxisAngle(axis) {
        var sqrLength = this.x * this.x + this.y * this.y + this.z * this.z;
        var angle = 0;
        if (sqrLength > 0) {
          angle = 2 * Math.acos(this.w);
          sqrLength = 1 / Math.sqrt(sqrLength);
          axis.x = this.x * sqrLength;
          axis.y = this.y * sqrLength;
          axis.z = this.z * sqrLength;
        } else {
          angle = 0;
          axis.x = 1;
          axis.y = 0;
          axis.z = 0;
        }
        return angle;
      }
      /**
       * Spherically interpolates between two quaternions, providing an interpolation between rotations with constant angle change rate.
       * @param qa The first quaternion to interpolate.
       * @param qb The second quaternion to interpolate.
       * @param t The interpolation weight, a value between 0 and 1.
       */
      slerp(qa, qb, t) {
        var w1 = qa.w;
        var x1 = qa.x;
        var y1 = qa.y;
        var z1 = qa.z;
        var w2 = qb.w;
        var x2 = qb.x;
        var y2 = qb.y;
        var z2 = qb.z;
        var dot = w1 * w2 + x1 * x2 + y1 * y2 + z1 * z2;
        if (dot < 0) {
          dot = -dot;
          w2 = -w2;
          x2 = -x2;
          y2 = -y2;
          z2 = -z2;
        }
        if (dot < 0.95) {
          var angle = Math.acos(dot);
          var s = 1 / Math.sin(angle);
          var s1 = Math.sin(angle * (1 - t)) * s;
          var s2 = Math.sin(angle * t) * s;
          this.w = w1 * s1 + w2 * s2;
          this.x = x1 * s1 + x2 * s2;
          this.y = y1 * s1 + y2 * s2;
          this.z = z1 * s1 + z2 * s2;
        } else {
          this.w = w1 + t * (w2 - w1);
          this.x = x1 + t * (x2 - x1);
          this.y = y1 + t * (y2 - y1);
          this.z = z1 + t * (z2 - z1);
          var len = 1 / Math.sqrt(this.w * this.w + this.x * this.x + this.y * this.y + this.z * this.z);
          this.w *= len;
          this.x *= len;
          this.y *= len;
          this.z *= len;
        }
      }
      /**
       * Linearly interpolates between two quaternions.
       * @param qa The first quaternion to interpolate.
       * @param qb The second quaternion to interpolate.
       * @param t The interpolation weight, a value between 0 and 1.
       */
      lerp(qa, qb, t) {
        var w1 = qa.w;
        var x1 = qa.x;
        var y1 = qa.y;
        var z1 = qa.z;
        var w2 = qb.w;
        var x2 = qb.x;
        var y2 = qb.y;
        var z2 = qb.z;
        var len;
        if (w1 * w2 + x1 * x2 + y1 * y2 + z1 * z2 < 0) {
          w2 = -w2;
          x2 = -x2;
          y2 = -y2;
          z2 = -z2;
        }
        this.w = w1 + t * (w2 - w1);
        this.x = x1 + t * (x2 - x1);
        this.y = y1 + t * (y2 - y1);
        this.z = z1 + t * (z2 - z1);
        len = 1 / Math.sqrt(this.w * this.w + this.x * this.x + this.y * this.y + this.z * this.z);
        this.w *= len;
        this.x *= len;
        this.y *= len;
        this.z *= len;
      }
      /**
       * Fills the quaternion object with values representing the given euler rotation.
       * @param    ax        The angle in radians of the rotation around the ax axis.
       * @param    ay        The angle in radians of the rotation around the ay axis.
       * @param    az        The angle in radians of the rotation around the az axis.
       */
      setFromEuler(ax, ay, az) {
        ax *= DEGREES_TO_RADIANS;
        ay *= DEGREES_TO_RADIANS;
        az *= DEGREES_TO_RADIANS;
        var halfX = ax * 0.5;
        var halfY = ay * 0.5;
        var halfZ = az * 0.5;
        var cosX = Math.cos(halfX);
        var sinX = Math.sin(halfX);
        var cosY = Math.cos(halfY);
        var sinY = Math.sin(halfY);
        var cosZ = Math.cos(halfZ);
        var sinZ = Math.sin(halfZ);
        this.w = cosX * cosY * cosZ + sinX * sinY * sinZ;
        this.x = sinX * cosY * cosZ - cosX * sinY * sinZ;
        this.y = cosX * sinY * cosZ + sinX * cosY * sinZ;
        this.z = cosX * cosY * sinZ - sinX * sinY * cosZ;
        return this;
      }
      /**
       * Sets the current quaternion from the rotation matrix
       * @param m 
       * @returns 
       */
      setFromRotationMatrix(m) {
        const te = m.rawData;
        const m11 = te[0];
        const m12 = te[4];
        const m13 = te[8];
        const m21 = te[1];
        const m22 = te[5];
        const m23 = te[9];
        const m31 = te[2];
        const m32 = te[6];
        const m33 = te[10];
        const trace = m11 + m22 + m33;
        if (trace > 0) {
          const s = 0.5 / Math.sqrt(trace + 1);
          this.w = 0.25 / s;
          this.x = (m32 - m23) * s;
          this.y = (m13 - m31) * s;
          this.z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
          const s = 2 * Math.sqrt(1 + m11 - m22 - m33);
          this.w = (m32 - m23) / s;
          this.x = 0.25 * s;
          this.y = (m12 + m21) / s;
          this.z = (m13 + m31) / s;
        } else if (m22 > m33) {
          const s = 2 * Math.sqrt(1 + m22 - m11 - m33);
          this.w = (m13 - m31) / s;
          this.x = (m12 + m21) / s;
          this.y = 0.25 * s;
          this.z = (m23 + m32) / s;
        } else {
          const s = 2 * Math.sqrt(1 + m33 - m11 - m22);
          this.w = (m21 - m12) / s;
          this.x = (m13 + m31) / s;
          this.y = (m23 + m32) / s;
          this.z = 0.25 * s;
        }
        return this;
      }
      /**
       * Get the Euler Angle
       * @param eulers 
       * @returns 
       */
      getEulerAngles(eulers) {
        var x;
        var y;
        var z;
        var qx;
        var qy;
        var qz;
        var qw;
        var a2;
        eulers ||= new Vector3();
        qx = this.x;
        qy = this.y;
        qz = this.z;
        qw = this.w;
        a2 = 2 * (qw * qy - qx * qz);
        if (a2 <= -0.99999) {
          x = 2 * Math.atan2(qx, qw);
          y = -Math.PI / 2;
          z = 0;
        } else if (a2 >= 0.99999) {
          x = 2 * Math.atan2(qx, qw);
          y = Math.PI / 2;
          z = 0;
        } else {
          x = Math.atan2(2 * (qw * qx + qy * qz), 1 - 2 * (qx * qx + qy * qy));
          y = Math.asin(a2);
          z = Math.atan2(2 * (qw * qz + qx * qy), 1 - 2 * (qy * qy + qz * qz));
        }
        return eulers.set(x, y, z).multiplyScalar(RADIANS_TO_DEGREES);
      }
      /**
       * The normalize of the quaternion. Convert this quaternion to a normalize coefficient.
       * @param val normalize coefficient, which is 1 by default
       */
      normalize(val = 1) {
        var mag = val / Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
        this.x *= mag;
        this.y *= mag;
        this.z *= mag;
        this.w *= mag;
        return this;
      }
      /**
       * Returns the value of a quaternion as a string
       * @returns 
       */
      toString() {
        return "{x:" + this.x + " y:" + this.y + " z:" + this.z + " w:" + this.w + "}";
      }
      /**
       * Inverts this quaternion in place. Mutates and returns this.
       */
      invert() {
        return Quaternion.invert(this, this);
      }
      /**
       * Clones the quaternion.
       * @returns An exact duplicate of the current Quaternion.
       */
      clone() {
        return new Quaternion(this.x, this.y, this.z, this.w);
      }
      /**
       * Rotates `vector` by this quaternion. Mutates and returns `vector`.
       */
      transformVector(vector) {
        return Quaternion.transformVector(this, vector, vector);
      }
      /**
       * Copies the data from a quaternion into this instance.
       * @param q The quaternion to copy from.
       */
      copy(q) {
        var v = this;
        v.x = q.x;
        v.y = q.y;
        v.z = q.z;
        v.w = q.w;
        return this;
      }
      /**
       * from untiy API
       * op
       */
      static mul(lhs, rhs, result) {
        result ||= new Quaternion();
        const x = lhs.w * rhs.x + lhs.x * rhs.w + lhs.y * rhs.z - lhs.z * rhs.y;
        const y = lhs.w * rhs.y + lhs.y * rhs.w + lhs.z * rhs.x - lhs.x * rhs.z;
        const z = lhs.w * rhs.z + lhs.z * rhs.w + lhs.x * rhs.y - lhs.y * rhs.x;
        const w = lhs.w * rhs.w - lhs.x * rhs.x - lhs.y * rhs.y - lhs.z * rhs.z;
        result.x = x;
        result.y = y;
        result.z = z;
        result.w = w;
        return result;
      }
      /**
       * Canonical static multiply — alias of Quaternion.mul.
       */
      static multiply(a, b, result) {
        return Quaternion.mul(a, b, result);
      }
      /**
       * Invert a quaternion.
       */
      static invert(src, result) {
        result ||= new Quaternion();
        const norm = src.w * src.w + src.x * src.x + src.y * src.y + src.z * src.z;
        if (norm > 0) {
          const invNorm = 1 / norm;
          result.w = src.w * invNorm;
          result.x = -src.x * invNorm;
          result.y = -src.y * invNorm;
          result.z = -src.z * invNorm;
        } else {
          result.x = result.y = result.z = 0;
          result.w = 1;
        }
        return result;
      }
      /**
       * Rotate a Vector3 by a Quaternion.
       */
      static transformVector(q, v, result) {
        result ||= new Vector3();
        const x2 = v.x;
        const y2 = v.y;
        const z2 = v.z;
        const w1 = -q.x * x2 - q.y * y2 - q.z * z2;
        const x1 = q.w * x2 + q.y * z2 - q.z * y2;
        const y1 = q.w * y2 - q.x * z2 + q.z * x2;
        const z1 = q.w * z2 + q.x * y2 - q.y * x2;
        result.x = -w1 * q.x + x1 * q.w - y1 * q.z + z1 * q.y;
        result.y = -w1 * q.y + x1 * q.z + y1 * q.w - z1 * q.x;
        result.z = -w1 * q.z - x1 * q.y + y1 * q.x + z1 * q.w;
        return result;
      }
      clampf(value, minInclusive, maxInclusive) {
        if (minInclusive > maxInclusive) {
          var temp = minInclusive;
          minInclusive = maxInclusive;
          maxInclusive = temp;
        }
        return value < minInclusive ? minInclusive : value < maxInclusive ? value : maxInclusive;
      }
      /** Returns a new Quaternion copy of the given quaternion, used for serialization. */
      static serialize(value) {
        let v = new Quaternion(value.x, value.y, value.z, value.w);
        return v;
      }
      // -------- Standard instance API --------
      /** Set this = a * b. Canonical alias of {@link multiply}. */
      multiplyQuaternions(a, b) {
        return this.multiply(a, b);
      }
      /** Set this = q * this. */
      premultiply(q) {
        return Quaternion.mul(q, this, this);
      }
      /** Conjugate: negate (x, y, z). For a unit quaternion this equals the inverse. */
      conjugate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
      }
      /** Dot product of this quaternion and q. */
      dot(q) {
        return this.x * q.x + this.y * q.y + this.z * q.z + this.w * q.w;
      }
      /** Squared length (norm) of this quaternion. */
      lengthSq() {
        return this.dot(this);
      }
      /** Length (norm) of this quaternion. */
      length() {
        return Math.sqrt(this.lengthSq());
      }
      /** Returns true if every component of q exactly equals this quaternion. */
      equals(q) {
        return q.x === this.x && q.y === this.y && q.z === this.z && q.w === this.w;
      }
      /** Set x/y/z/w from array starting at offset. Mutates and returns this. */
      fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
      }
      /** Write x/y/z/w into array starting at offset and return the array. */
      toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
      }
      /** Set this = the rotation that takes unit vector vFrom to unit vector vTo. */
      setFromUnitVectors(vFrom, vTo) {
        let r = vFrom.x * vTo.x + vFrom.y * vTo.y + vFrom.z * vTo.z + 1;
        if (r < Number.EPSILON) {
          r = 0;
          if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
            this.x = -vFrom.y;
            this.y = vFrom.x;
            this.z = 0;
          } else {
            this.x = 0;
            this.y = -vFrom.z;
            this.z = vFrom.y;
          }
          this.w = r;
        } else {
          this.x = vFrom.y * vTo.z - vFrom.z * vTo.y;
          this.y = vFrom.z * vTo.x - vFrom.x * vTo.z;
          this.z = vFrom.x * vTo.y - vFrom.y * vTo.x;
          this.w = r;
        }
        return this.normalize();
      }
      /** Canonical alias of {@link slerp} (qa, qb, t form). */
      slerpQuaternions(qa, qb, t) {
        this.slerp(qa, qb, t);
        return this;
      }
    }
    function rotateVectorByQuat(lhs, rhs, target) {
      let x = lhs.x * 2;
      let y = lhs.y * 2;
      let z = lhs.z * 2;
      let xx = lhs.x * x;
      let yy = lhs.y * y;
      let zz = lhs.z * z;
      let xy = lhs.x * y;
      let xz = lhs.x * z;
      let yz = lhs.y * z;
      let wx = lhs.w * x;
      let wy = lhs.w * y;
      let wz = lhs.w * z;
      let res = target ? target : new Vector3();
      res.x = (1 - (yy + zz)) * rhs.x + (xy - wz) * rhs.y + (xz + wy) * rhs.z;
      res.y = (xy + wz) * rhs.x + (1 - (xx + zz)) * rhs.y + (yz - wx) * rhs.z;
      res.z = (xz - wy) * rhs.x + (yz + wx) * rhs.y + (1 - (xx + yy)) * rhs.z;
      return res;
    }

    const EPSILON = 1e-6;
    class Matrix4 {
      /**
       * matrix44 bytes block size 
       */
      static blockBytes = 16 * 4;
      /**
       * @internal
       */
      static block = 16;
      /**
       * matrix do total count 
       */
      static allocCount = 1e3;
      /**
       * quantity allocated for each capacity expansion
       */
      static allocOnceCount = 1e3;
      /**
       * matrix has max limit count
       */
      static maxCount = 50 * 1e4;
      /**
       * current matrix use count 
       */
      static useCount = 0;
      /**
       * @internal
       */
      static buffer;
      /**
       * @internal
       * wasm use memory use first ptr
       */
      static wasmMatrixPtr = 0;
      /**
       * matrix do use share bytesArray
       */
      static dynamicMatrixBytes;
      /** 32-bit float view of the shared matrix byte array. */
      static dynamicMatrixBytes_32bit;
      /** Shared buffer holding high-precision (split-float) world position data. */
      static matrixWorldPositionHLDatas;
      /**
       * cache all use do matrix 
       */
      static dynamicGlobalMatrixRef;
      /**
       * @internal
       */
      static wasm;
      /**
       * help fix global matrix 0 
       */
      static help_matrix_0;
      /**
       * help fix global matrix 1 
       */
      static help_matrix_1;
      /**
       * help fix global matrix 2 
       */
      static help_matrix_2;
      /**
       * help fix global matrix 3 
       */
      static helpMatrix;
      /**
       * help fix global matrix 4 
       */
      static helpMatrix2;
      static _getEulerMatrix;
      static _zero = new Vector3(0, 0, 0);
      static _zero2 = new Vector3(0, 0, 0);
      static _one = new Vector3(1, 1, 1);
      static _prs = [new Vector3(), new Vector3(), new Vector3()];
      /**
      * matrix index at global matrix list 
      */
      index = 0;
      /**
       * @internal
       */
      offset = 0;
      /**
       * matrix raw data format FloatArray
       * @see {@link FloatArray}
       */
      rawData;
      _position;
      /**
      * alloc web runtime cpu memory totalCount * 4(float) * 4
      * init matrix memory by totalCount * 4(float) * 4
      * @param count every alloc matrix count
          */
      static allocMatrix(allocCount) {
        this.allocCount = allocCount;
        Matrix4.dynamicMatrixBytes = WasmMatrix.matrixBuffer;
        Matrix4.dynamicMatrixBytes_32bit = WasmMatrix.matrixBuffer_32bit;
        Matrix4.matrixWorldPositionHLDatas = WasmMatrix.matrixWorldPositionHLBuffer;
        Matrix4.buffer = Matrix4.dynamicMatrixBytes.buffer;
        Matrix4.wasmMatrixPtr = WasmMatrix.matrixBufferPtr;
        this.dynamicGlobalMatrixRef ||= [];
        this.dynamicGlobalMatrixRef.forEach((m) => {
          m.offset = Matrix4.wasmMatrixPtr + m.index * Matrix4.blockBytes;
          m.rawData = CreateFloatArray(Matrix4.dynamicMatrixBytes.buffer, m.offset, 16);
        });
        Matrix4.help_matrix_0 ||= new Matrix4();
        Matrix4.help_matrix_1 ||= new Matrix4();
        Matrix4.help_matrix_2 ||= new Matrix4();
        Matrix4.helpMatrix ||= new Matrix4();
        Matrix4.helpMatrix2 ||= new Matrix4();
        Matrix4._getEulerMatrix ||= new Matrix4();
        Matrix4._getEulerMatrix.identity();
      }
      /**
       * create matrix from two direction
       * @param fromDirection first direction
       * @param toDirection  second direction
       * @param target ref matrix
       * @param epsilon tiny number
       * @returns return new one matrix
       */
      static fromToRotation(fromDirection, toDirection, target, epsilon) {
        target ||= new Matrix4();
        target.transformDir(fromDirection, toDirection, epsilon);
        return target;
      }
      /**
       * Generate a matrix (rotate degrees with x,y,z as the center axis)
       * @param x x on the central axis
       * @param y y on the central axis
       * @param z z on the central axis
       * @param degrees rotation angle
       * @returns Matrix4 result
       */
      static getAxisRotation(x, y, z, degrees) {
        let m = new Matrix4();
        let rad = degrees * (Math.PI / 180);
        let c = Math.cos(rad);
        let s = Math.sin(rad);
        let t = 1 - c;
        let tmp1, tmp2;
        m.rawData[0] = c + x * x * t;
        m.rawData[5] = c + y * y * t;
        m.rawData[10] = c + z * z * t;
        tmp1 = x * y * t;
        tmp2 = z * s;
        m.rawData[1] = tmp1 + tmp2;
        m.rawData[4] = tmp1 - tmp2;
        tmp1 = x * z * t;
        tmp2 = y * s;
        m.rawData[8] = tmp1 + tmp2;
        m.rawData[2] = tmp1 - tmp2;
        tmp1 = y * z * t;
        tmp2 = x * s;
        m.rawData[9] = tmp1 - tmp2;
        m.rawData[6] = tmp1 + tmp2;
        return m;
      }
      /**
       * Arrange the Euler values
       * @param euler Euler values
       */
      static sanitizeEuler(euler) {
        Matrix4.makePositive(euler);
      }
      /**
       *
       * @param euler
       */
      static makePositive(euler) {
        let negativeFlip = -1e-4;
        let positiveFlip = Math.PI * 2 - 1e-4;
        if (euler.x < negativeFlip) {
          euler.x += 2 * Math.PI;
        } else if (euler.x > positiveFlip) {
          euler.x -= 2 * Math.PI;
        }
        if (euler.y < negativeFlip) {
          euler.y += 2 * Math.PI;
        } else if (euler.y > positiveFlip) {
          euler.y -= 2 * Math.PI;
        }
        if (euler.z < negativeFlip) {
          euler.z += 2 * Math.PI;
        } else if (euler.z > positiveFlip) {
          euler.z -= 2 * Math.PI;
        }
      }
      /**
       * Convert the matrix to Euler angles
       * @param matrix Matrix to be transformed
       * @param v euler angle
       * @returns
       */
      static matrixToEuler(matrix, v) {
        if (matrix.get(1, 2) < 0.999) {
          if (matrix.get(1, 2) > -0.999) {
            v.x = Math.asin(-matrix.get(1, 2));
            v.y = Math.atan2(matrix.get(0, 2), matrix.get(2, 2));
            v.z = Math.atan2(matrix.get(1, 0), matrix.get(1, 1));
            Matrix4.sanitizeEuler(v);
            return true;
          } else {
            v.x = Math.PI * 0.5;
            v.y = Math.atan2(matrix.get(0, 1), matrix.get(0, 0));
            v.z = 0;
            Matrix4.sanitizeEuler(v);
            return false;
          }
        } else {
          v.x = -Math.PI * 0.5;
          v.y = Math.atan2(-matrix.get(0, 1), matrix.get(0, 0));
          v.z = 0;
          Matrix4.sanitizeEuler(v);
          return false;
        }
      }
      /**
       * Multiply the world matrix, specifying parameters and results according to the index
       * @param aMat Matrix to be multiplied (please specify index)
       * @param bMat Matrix to be multiplied (please specify index)
       * @param target_Mat Result matrix (get results based on index)
       */
      static matrixMultiply(aMat, bMat, target_Mat) {
        Matrix4.wasm.Matrix_Multiply(aMat.index, bMat.index, target_Mat.index);
      }
      /**
       * World matrix extension, according to the index to specify parameters and results
       * @param aMat Matrix to be multiplied (please specify index)
       * @param bMat Matrix to be multiplied (please specify index)
       * @param target_Mat Result matrix (get results based on index)
       */
      static matrixAppend(aMat, bMat, target_Mat) {
        Matrix4.wasm.Matrix_Append(aMat.index, bMat.index, target_Mat.index);
      }
      /**
       * Rotate a matrix around the Y axis by the given angle, writing the result into the target matrix.
       * @param rad rotation angle, in radians
       * @param target_Mat result matrix (referenced by index)
       */
      static matrixRotateY(rad, target_Mat) {
        Matrix4.wasm.Matrix_Append(rad, target_Mat.index);
      }
      /**
       * Rotate a matrix around an arbitrary axis by the given angle, writing the result into the target matrix.
       * @param rad rotation angle, in radians
       * @param axis rotation axis
       * @param target_Mat result matrix (referenced by index)
       */
      static matrixRotate(rad, axis, target_Mat) {
        Matrix4.wasm.Matrix_Rotate(rad, axis, target_Mat.index);
      }
      /** Stack of matrix indices that have been freed and are available for reuse. */
      static freeIndexs = new Uint32Array(Matrix4.allocCount);
      /** Current top of the freed-index stack. */
      static freeIndexOffset = 0;
      /** Allocate a matrix index, reusing a freed index when available. */
      static allocIndex() {
        return this.freeIndexOffset <= 0 ? Matrix4.useCount++ : this.freeIndexs[--this.freeIndexOffset];
      }
      /** Return a matrix's index to the free list for later reuse. */
      static freeIndex(matrix) {
        if (this.freeIndexOffset >= this.freeIndexs.length) {
          let buff = new Uint32Array(this.freeIndexs.length + Matrix4.allocOnceCount);
          buff.set(this.freeIndexs);
          this.freeIndexs = buff;
        }
        this.freeIndexs[this.freeIndexOffset++] = matrix.index;
      }
      /**
       * Create a Matrix4.
       * @param doMatrix reserved flag; when set, requests an explicit matrix allocation
       */
      constructor(doMatrix = false) {
        if (Matrix4.useCount >= Matrix4.allocCount) {
          let allocCount = Math.max(Matrix4.allocCount * 2, Matrix4.allocCount + Matrix4.allocOnceCount);
          WasmMatrix.allocMatrix(allocCount);
        }
        this.index = Matrix4.allocIndex();
        this.offset = Matrix4.wasmMatrixPtr + this.index * Matrix4.blockBytes;
        Matrix4.dynamicGlobalMatrixRef[this.index] = this;
        this.rawData = CreateFloatArray(Matrix4.dynamicMatrixBytes.buffer, this.offset, 16);
        this._position = new Vector3();
        this.identity();
      }
      /**
       * current matrix move position and rotation to target 
       * @param eye eye position
       * @param at target position
       * @param up normalize axis way
       */
      lookAt(eye, at, up = Vector3.Y_AXIS) {
        let data = this.rawData;
        let zAxis = Vector3.sub(at, eye, Vector3.HELP_0);
        if (zAxis.length === 0) {
          zAxis.z = 1;
        }
        zAxis.normalize();
        let xAxis = Vector3.cross(up, zAxis, Vector3.HELP_1);
        if (xAxis.length === 0) {
          if (Math.abs(up.z) === 1) {
            zAxis.x += 1e-4;
          } else {
            zAxis.z -= 1e-4;
          }
          zAxis.normalize();
          xAxis = Vector3.cross(up, zAxis, Vector3.HELP_1);
        }
        xAxis.normalize();
        let yAxis = Vector3.cross(zAxis, xAxis, Vector3.HELP_2);
        data[0] = xAxis.x;
        data[1] = yAxis.x;
        data[2] = zAxis.x;
        data[3] = 0;
        data[4] = xAxis.y;
        data[5] = yAxis.y;
        data[6] = zAxis.y;
        data[7] = 0;
        data[8] = xAxis.z;
        data[9] = yAxis.z;
        data[10] = zAxis.z;
        data[11] = 0;
        data[12] = -xAxis.dotProduct(eye);
        data[13] = -yAxis.dotProduct(eye);
        data[14] = -zAxis.dotProduct(eye);
        data[15] = 1;
      }
      static floatArray = new Float64Array(16).fill(0);
      /**
       * matrix multiply
       * @param mat4 multiply target
       */
      multiply(mat4) {
        let a = this.rawData;
        let b = mat4.rawData;
        let r = Matrix4.floatArray;
        r[0] = a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12];
        r[1] = a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13];
        r[2] = a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14];
        r[3] = a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15];
        r[4] = a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12];
        r[5] = a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13];
        r[6] = a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14];
        r[7] = a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15];
        r[8] = a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12];
        r[9] = a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13];
        r[10] = a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14];
        r[11] = a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15];
        r[12] = a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12];
        r[13] = a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13];
        r[14] = a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14];
        r[15] = a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15];
        a[0] = r[0];
        a[1] = r[1];
        a[2] = r[2];
        a[3] = r[3];
        a[4] = r[4];
        a[5] = r[5];
        a[6] = r[6];
        a[7] = r[7];
        a[8] = r[8];
        a[9] = r[9];
        a[10] = r[10];
        a[11] = r[11];
        a[12] = r[12];
        a[13] = r[13];
        a[14] = r[14];
        a[15] = r[15];
        return this;
      }
      /** Set this = m * this. */
      premultiply(m) {
        return this.multiplyMatrices(m, this);
      }
      /** Multiply two matrices: result = a * b. Allocates a new Matrix4 if result is omitted. */
      static multiply(a, b, result) {
        result ||= new Matrix4();
        result.multiplyMatrices(a, b);
        return result;
      }
      /**
       * Invert a matrix into result. Returns null when src is singular.
       * @param src source matrix
       * @param result optional output matrix
       */
      static invert(src, result) {
        if (Math.abs(src.determinant) <= 1e-11) return null;
        result ||= new Matrix4();
        if (result !== src) {
          result.copy(src);
        }
        result.invert();
        return result;
      }
      /**
       *
       * @param a
       * @param b
       * @returns
       */
      multiplyMatrices(a, b) {
        const ae = a.rawData;
        const be = b.rawData;
        const te = this.rawData;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
      }
      /**
       * Convert a point (w=1) to this matrix space. Mutates and returns `v`.
       * @param v target point — mutated in place
       */
      multiplyPoint3(v) {
        return Matrix4.multiplyPoint3(this, v, v);
      }
      /** Transform point v (w=1) by matrix m into result. Allocates a new Vector3 if result is omitted. */
      static multiplyPoint3(m, v, result) {
        result ||= new Vector3();
        const rawData = m.rawData;
        const x = v.x, y = v.y, z = v.z;
        result.x = rawData[0] * x + rawData[4] * y + rawData[8] * z + rawData[12];
        result.y = rawData[1] * x + rawData[5] * y + rawData[9] * z + rawData[13];
        result.z = rawData[2] * x + rawData[6] * y + rawData[10] * z + rawData[14];
        return result;
      }
      /**
       * Transform a homogeneous vector (w computed from matrix) and divide by w.
       * Mutates and returns `a`.
       */
      multiplyVector4(a) {
        return Matrix4.multiplyVector4(this, a, a);
      }
      /** Transform homogeneous vector a by matrix m (w computed and divided out) into result. */
      static multiplyVector4(m, a, result) {
        result ||= new Vector3();
        const d = m.rawData;
        const x = a.x, y = a.y, z = a.z;
        let w = d[3] * x + d[7] * y + d[11] * z + d[15];
        w = w || 1;
        result.x = (d[0] * x + d[4] * y + d[8] * z + d[12]) / w;
        result.y = (d[1] * x + d[5] * y + d[9] * z + d[13]) / w;
        result.z = (d[2] * x + d[6] * y + d[10] * z + d[14]) / w;
        result.w = 1;
        return result;
      }
      /**
       * Transform a 4D vector (v.w used directly) by this matrix. Mutates and returns `v`.
       */
      transformVector4(v) {
        return Matrix4.transformVector4(this, v, v);
      }
      /** Transform 4D vector v (v.w used directly) by matrix m into result. */
      static transformVector4(m, v, result) {
        result ||= new Vector3();
        const data = m.rawData;
        const x = v.x, y = v.y, z = v.z, w = v.w;
        result.x = x * data[0] + y * data[4] + z * data[8] + w * data[12];
        result.y = x * data[1] + y * data[5] + z * data[9] + w * data[13];
        result.z = x * data[2] + y * data[6] + z * data[10] + w * data[14];
        result.w = x * data[3] + y * data[7] + z * data[11] + w * data[15];
        return result;
      }
      /**
       * Convert projection coordinates to 3D coordinates
       * @param v vector3 target
       * @param output ref vector3d
       * @returns
       */
      perspectiveMultiplyPoint3(v, output) {
        let res = Vector3.HELP_2;
        let w;
        let rawData = this.rawData;
        res.x = rawData[0] * v.x + rawData[4] * v.y + rawData[8] * v.z + rawData[12];
        res.y = rawData[1] * v.x + rawData[5] * v.y + rawData[9] * v.z + rawData[13];
        res.z = rawData[2] * v.x + rawData[6] * v.y + rawData[10] * v.z + rawData[14];
        w = rawData[3] * v.x + rawData[7] * v.y + rawData[11] * v.z + rawData[15];
        if (Math.abs(w) > 1e-7) {
          let invW = 1 / w;
          output.x = res.x * invW;
          output.y = res.y * invW;
          output.z = res.z * invW;
          return true;
        } else {
          output.x = 0;
          output.y = 0;
          output.z = 0;
          return false;
        }
      }
      /**
       * set matrix perspective 
       * @param fov perspective angle 0 ~ 90
       * @param aspect aspect ratio
       * @param zn near plane
       * @param zf far plane
       */
      perspective(fov, aspect, zn, zf) {
        let data = this.rawData;
        let angle = fov * DEGREES_TO_RADIANS / 2;
        let f = Math.cos(angle) / Math.sin(angle);
        data[0] = -f / aspect;
        data[1] = 0;
        data[2] = 0;
        data[3] = 0;
        data[4] = 0;
        data[5] = f;
        data[6] = 0;
        data[7] = 0;
        data[8] = 0;
        data[9] = 0;
        data[10] = zf / (zf - zn);
        data[11] = 1;
        data[12] = 0;
        data[13] = 0;
        data[14] = -zn * zf / (zf - zn);
        data[15] = 0;
      }
      /**
       * Set this matrix to a perspective projection defined by field of view.
       * @param fov vertical field of view, in degrees
       * @param aspect aspect ratio (width / height)
       * @param near near plane distance
       * @param far far plane distance
       */
      perspective3(fov, aspect, near, far) {
        var y = Math.tan(fov * Math.PI / 360) * near;
        var x = y * aspect;
        this.frustum(-x, x, -y, y, near, far);
      }
      /**
       * Set this matrix to a perspective projection defined by frustum bounds.
       * @param l left plane
       * @param r right plane
       * @param b bottom plane
       * @param t top plane
       * @param n near plane
       * @param f far plane
       */
      frustum(l, r, b, t, n, f) {
        var m = this.rawData;
        m[0] = -2 * n / (r - l);
        m[1] = 0;
        m[2] = 0;
        m[3] = 0;
        m[4] = 0;
        m[5] = 2 * n / (t - b);
        m[6] = 0;
        m[7] = 0;
        m[8] = (r + l) / (r - l);
        m[9] = (t + b) / (t - b);
        m[10] = f / (f - n);
        m[11] = 1;
        m[12] = 0;
        m[13] = 0;
        m[14] = -f * n / (f - n);
        m[15] = 0;
      }
      /**
       * set matrix orthogonal projection
       * @param w screen width
       * @param h screen height
       * @param zn camera near plane
       * @param zf camera far plane
       * @returns this matrix
       */
      ortho(w, h, zn, zf) {
        let data = this.rawData;
        data[0] = 2 / w;
        data[1] = 0;
        data[2] = 0;
        data[3] = 0;
        data[4] = 0;
        data[5] = 2 / h;
        data[6] = 0;
        data[7] = 0;
        data[8] = 0;
        data[9] = 0;
        data[10] = 1 / (zf - zn);
        data[11] = 0;
        data[12] = 0;
        data[13] = 0;
        data[14] = zn / (zn - zf);
        data[15] = 1;
        return this;
      }
      /**
       * set matrix orthogonal projection by view side
       * @param left orthogonal view left
       * @param right orthogonal view right
       * @param bottom orthogonal view bottom
       * @param top orthogonal view top
       * @param near camera near plane
       * @param far camera far plane
       * @returns this matrix
       */
      orthoZO(left, right, bottom, top, near, far) {
        let data = this.rawData;
        let lr = 1 / (left - right);
        let bt = 1 / (bottom - top);
        let nf = 1 / (near - far);
        data[0] = -2 * lr;
        data[1] = 0;
        data[2] = 0;
        data[3] = 0;
        data[4] = 0;
        data[5] = -2 * bt;
        data[6] = 0;
        data[7] = 0;
        data[8] = 0;
        data[9] = 0;
        data[10] = nf;
        data[11] = 0;
        data[12] = (left + right) * lr;
        data[13] = (top + bottom) * bt;
        data[14] = near * nf;
        data[15] = 1;
        return this;
      }
      /**
       * set matrix orthogonal projection by view center
       */
      orthoOffCenter(l, r, b, t, zn, zf) {
        let data = this.rawData;
        data[0] = -2 / (r - l);
        data[1] = 0;
        data[2] = 0;
        data[3] = 0;
        data[4] = 0;
        data[5] = 2 / (t - b);
        data[6] = 0;
        data[7] = 0;
        data[8] = 0;
        data[9] = 0;
        data[10] = 1 / (zf - zn);
        data[11] = 0;
        data[12] = (l + r) / (l - r);
        data[13] = (t + b) / (b - t);
        data[14] = zn / (zn - zf);
        data[15] = 1;
      }
      /**
       * set matrix from two direction
       * @param fromDirection first direction
       * @param toDirection second direction
       * @param epsilon tiny number
       */
      transformDir(fromDirection, toDirection, epsilon) {
        epsilon ||= EPSILON;
        let data = this.rawData;
        let zero = Matrix4._zero2.set(0, 0, 0);
        Vector3.cross(toDirection, fromDirection, zero);
        let e = toDirection.dotProduct(fromDirection);
        if (e > 1 - epsilon) {
          this.identity();
        } else if (e < -1 + epsilon) {
          let up = Vector3.HELP_1;
          let left = Vector3.HELP_2;
          let invLen = 0;
          let fxx;
          let fyy;
          let fzz;
          let fxy;
          let fxz;
          let fyz;
          let uxx;
          let uyy;
          let uzz;
          let uxy;
          let uxz;
          let uyz;
          let lxx;
          let lyy;
          let lzz;
          let lxy;
          let lxz;
          let lyz;
          left.x = 0;
          left.y = fromDirection.z;
          left.z = -fromDirection.y;
          if (left.dotProduct(left) < epsilon) {
            left.x = -fromDirection.z;
            left.y = 0;
            left.z = fromDirection.x;
          }
          invLen = 1 / Math.sqrt(left.dotProduct(left));
          left.x *= invLen;
          left.y *= invLen;
          left.z *= invLen;
          Vector3.cross(left, fromDirection, up);
          fxx = -fromDirection.x * fromDirection.x;
          fyy = -fromDirection.y * fromDirection.y;
          fzz = -fromDirection.z * fromDirection.z;
          fxy = -fromDirection.x * fromDirection.y;
          fxz = -fromDirection.x * fromDirection.z;
          fyz = -fromDirection.y * fromDirection.z;
          uxx = up.x * up.x;
          uyy = up.y * up.y;
          uzz = up.z * up.z;
          uxy = up.x * up.y;
          uxz = up.x * up.z;
          uyz = up.y * up.z;
          lxx = -left.x * left.x;
          lyy = -left.y * left.y;
          lzz = -left.z * left.z;
          lxy = -left.x * left.y;
          lxz = -left.x * left.z;
          lyz = -left.y * left.z;
          data[0] = fxx + uxx + lxx;
          data[1] = fxy + uxy + lxy;
          data[2] = fxz + uxz + lxz;
          data[4] = data[1];
          data[5] = fyy + uyy + lyy;
          data[6] = fyz + uyz + lyz;
          data[8] = data[2];
          data[9] = data[6];
          data[10] = fzz + uzz + lzz;
          data[3] = 0;
          data[7] = 0;
          data[11] = 0;
          data[15] = 1;
        } else {
          let hvx;
          let hvz;
          let hvxy;
          let hvxz;
          let hvyz;
          let v2 = zero.dotProduct(zero);
          let h = (1 - e) / v2;
          hvx = h * zero.x;
          hvz = h * zero.z;
          hvxy = hvx * zero.y;
          hvxz = hvx * zero.z;
          hvyz = hvz * zero.y;
          data[0] = e + hvx * zero.x;
          data[1] = hvxy - zero.z;
          data[2] = hvxz + zero.y;
          data[4] = hvxy + zero.z;
          data[5] = e + h * zero.y * zero.y;
          data[6] = hvyz - zero.x;
          data[8] = hvxz - zero.y;
          data[9] = hvyz + zero.x;
          data[10] = e + hvz * zero.z;
          data[3] = 0;
          data[7] = 0;
          data[11] = 0;
          data[15] = 1;
        }
        return this;
      }
      /**
       * multiply matrix a b
       * @param lhs target matrix
       */
      append(lhs) {
        let data = this.rawData;
        let m111 = data[0];
        let m121 = data[4];
        let m131 = data[8];
        let m141 = data[12];
        let m112 = data[1];
        let m122 = data[5];
        let m132 = data[9];
        let m142 = data[13];
        let m113 = data[2];
        let m123 = data[6];
        let m133 = data[10];
        let m143 = data[14];
        let m114 = data[3];
        let m124 = data[7];
        let m134 = data[11];
        let m144 = data[15];
        data[0] = m111 * lhs.rawData[0] + m112 * lhs.rawData[4] + m113 * lhs.rawData[8] + m114 * lhs.rawData[12];
        data[1] = m111 * lhs.rawData[1] + m112 * lhs.rawData[5] + m113 * lhs.rawData[9] + m114 * lhs.rawData[13];
        data[2] = m111 * lhs.rawData[2] + m112 * lhs.rawData[6] + m113 * lhs.rawData[10] + m114 * lhs.rawData[14];
        data[3] = m111 * lhs.rawData[3] + m112 * lhs.rawData[7] + m113 * lhs.rawData[11] + m114 * lhs.rawData[15];
        data[4] = m121 * lhs.rawData[0] + m122 * lhs.rawData[4] + m123 * lhs.rawData[8] + m124 * lhs.rawData[12];
        data[5] = m121 * lhs.rawData[1] + m122 * lhs.rawData[5] + m123 * lhs.rawData[9] + m124 * lhs.rawData[13];
        data[6] = m121 * lhs.rawData[2] + m122 * lhs.rawData[6] + m123 * lhs.rawData[10] + m124 * lhs.rawData[14];
        data[7] = m121 * lhs.rawData[3] + m122 * lhs.rawData[7] + m123 * lhs.rawData[11] + m124 * lhs.rawData[15];
        data[8] = m131 * lhs.rawData[0] + m132 * lhs.rawData[4] + m133 * lhs.rawData[8] + m134 * lhs.rawData[12];
        data[9] = m131 * lhs.rawData[1] + m132 * lhs.rawData[5] + m133 * lhs.rawData[9] + m134 * lhs.rawData[13];
        data[10] = m131 * lhs.rawData[2] + m132 * lhs.rawData[6] + m133 * lhs.rawData[10] + m134 * lhs.rawData[14];
        data[11] = m131 * lhs.rawData[3] + m132 * lhs.rawData[7] + m133 * lhs.rawData[11] + m134 * lhs.rawData[15];
        data[12] = m141 * lhs.rawData[0] + m142 * lhs.rawData[4] + m143 * lhs.rawData[8] + m144 * lhs.rawData[12];
        data[13] = m141 * lhs.rawData[1] + m142 * lhs.rawData[5] + m143 * lhs.rawData[9] + m144 * lhs.rawData[13];
        data[14] = m141 * lhs.rawData[2] + m142 * lhs.rawData[6] + m143 * lhs.rawData[10] + m144 * lhs.rawData[14];
        data[15] = m141 * lhs.rawData[3] + m142 * lhs.rawData[7] + m143 * lhs.rawData[11] + m144 * lhs.rawData[15];
        return this;
      }
      /**
       * matrix a add matrix b
       * @param lhs target matrix.
       * @returns Matrix4 result.
       */
      add(lhs) {
        let data = this.rawData;
        let m111 = data[0];
        let m121 = data[4];
        let m131 = data[8];
        let m141 = data[12];
        let m112 = data[1];
        let m122 = data[5];
        let m132 = data[9];
        let m142 = data[13];
        let m113 = data[2];
        let m123 = data[6];
        let m133 = data[10];
        let m143 = data[14];
        let m114 = data[3];
        let m124 = data[7];
        let m134 = data[11];
        let m144 = data[15];
        let m211 = lhs.rawData[0];
        let m221 = lhs.rawData[4];
        let m231 = lhs.rawData[8];
        let m241 = lhs.rawData[12];
        let m212 = lhs.rawData[1];
        let m222 = lhs.rawData[5];
        let m232 = lhs.rawData[9];
        let m242 = lhs.rawData[13];
        let m213 = lhs.rawData[2];
        let m223 = lhs.rawData[6];
        let m233 = lhs.rawData[10];
        let m243 = lhs.rawData[14];
        let m214 = lhs.rawData[3];
        let m224 = lhs.rawData[7];
        let m234 = lhs.rawData[11];
        let m244 = lhs.rawData[15];
        data[0] = m111 + m211;
        data[1] = m112 + m212;
        data[2] = m113 + m213;
        data[3] = m114 + m214;
        data[4] = m121 + m221;
        data[5] = m122 + m222;
        data[6] = m123 + m223;
        data[7] = m124 + m224;
        data[8] = m131 + m231;
        data[9] = m132 + m232;
        data[10] = m133 + m233;
        data[11] = m134 + m234;
        data[12] = m141 + m241;
        data[13] = m142 + m242;
        data[14] = m143 + m243;
        data[15] = m144 + m244;
        return this;
      }
      /**
       * matrix a sub matrix b
       * @param lhs target matrix b.
       * @returns Matrix4 .
       */
      sub(lhs) {
        let data = this.rawData;
        let m111 = data[0];
        let m121 = data[4];
        let m131 = data[8];
        let m141 = data[12];
        let m112 = data[1];
        let m122 = data[5];
        let m132 = data[9];
        let m142 = data[13];
        let m113 = data[2];
        let m123 = data[6];
        let m133 = data[10];
        let m143 = data[14];
        let m114 = data[3];
        let m124 = data[7];
        let m134 = data[11];
        let m144 = data[15];
        let m211 = lhs.rawData[0];
        let m221 = lhs.rawData[4];
        let m231 = lhs.rawData[8];
        let m241 = lhs.rawData[12];
        let m212 = lhs.rawData[1];
        let m222 = lhs.rawData[5];
        let m232 = lhs.rawData[9];
        let m242 = lhs.rawData[13];
        let m213 = lhs.rawData[2];
        let m223 = lhs.rawData[6];
        let m233 = lhs.rawData[10];
        let m243 = lhs.rawData[14];
        let m214 = lhs.rawData[3];
        let m224 = lhs.rawData[7];
        let m234 = lhs.rawData[11];
        let m244 = lhs.rawData[15];
        data[0] = m111 - m211;
        data[1] = m112 - m212;
        data[2] = m113 - m213;
        data[3] = m114 - m214;
        data[4] = m121 - m221;
        data[5] = m122 - m222;
        data[6] = m123 - m223;
        data[7] = m124 - m224;
        data[8] = m131 - m231;
        data[9] = m132 - m232;
        data[10] = m133 - m233;
        data[11] = m134 - m234;
        data[12] = m141 - m241;
        data[13] = m142 - m242;
        data[14] = m143 - m243;
        data[15] = m144 - m244;
        return this;
      }
      /**
       * Matrix times components.
       * @param v This matrix is going to be multiplied by this value
       * @returns Matrix4 Returns a multiplicative result matrix.
       */
      mult(v) {
        let data = this.rawData;
        data[0] *= v;
        data[1] *= v;
        data[2] *= v;
        data[3] *= v;
        data[4] *= v;
        data[5] *= v;
        data[6] *= v;
        data[7] *= v;
        data[8] *= v;
        data[9] *= v;
        data[10] *= v;
        data[11] *= v;
        data[12] *= v;
        data[13] *= v;
        data[14] *= v;
        data[15] *= v;
        return this;
      }
      // /**
      //  * Create an Euler rotation matrix.
      //  * @param x Angle of rotation around the x axis.
      //  * @param y Angle of rotation around the y axis.
      //  * @param z Angle of rotation around the z axis.
      //      //  */
      // public rotation(x: number, y: number, z: number) {
      //   Quaternion.CALCULATION_QUATERNION.setFromEuler(x, y, z);
      //   this.makeTransform(
      //     Matrix4.position_000,
      //     Matrix4.scale_111,
      //     Quaternion.CALCULATION_QUATERNION,
      //   );
      // }
      /**
       Add a direction Angle rotation to the current matrix (the matrix created by rotating degrees according to axis)
       @param degrees Angle of rotation.
       @param axis Angle of rotation around axis axis
       @version Orillusion3D  0.5.1
      */
      appendRotation(degrees, axis) {
        let m = Matrix4.getAxisRotation(axis.x, axis.y, axis.z, degrees);
        this.append(m);
      }
      /**
       * Create a matrix based on the axis and rotation Angle (the matrix created by rotating the degrees according to the axis)
       * @param degrees Angle of rotation.
       * @param axis Rotation Angle around axis axis. Axis needs to be specified as the orientation of an axis between x/y/z
       */
      createByRotation(degrees, axis) {
        let tmp = Matrix4.helpMatrix;
        let s;
        let c;
        let angle = degrees * DEGREES_TO_RADIANS;
        s = Math.sin(angle);
        c = Math.cos(angle);
        if (axis.x == 1) {
          tmp.rawData[0] = 1;
          tmp.rawData[1] = 0;
          tmp.rawData[2] = 0;
          tmp.rawData[3] = 0;
          tmp.rawData[4] = 0;
          tmp.rawData[5] = c;
          tmp.rawData[6] = s;
          tmp.rawData[7] = 0;
          tmp.rawData[8] = 0;
          tmp.rawData[9] = -s;
          tmp.rawData[10] = c;
          tmp.rawData[11] = 0;
          tmp.rawData[12] = 0;
          tmp.rawData[13] = 0;
          tmp.rawData[14] = 0;
          tmp.rawData[15] = 1;
        }
        if (axis.y == 1) {
          tmp.rawData[0] = c;
          tmp.rawData[1] = 0;
          tmp.rawData[2] = -s;
          tmp.rawData[3] = 0;
          tmp.rawData[4] = 0;
          tmp.rawData[5] = 1;
          tmp.rawData[6] = 0;
          tmp.rawData[7] = 0;
          tmp.rawData[8] = s;
          tmp.rawData[9] = 0;
          tmp.rawData[10] = c;
          tmp.rawData[11] = 0;
          tmp.rawData[12] = 0;
          tmp.rawData[13] = 0;
          tmp.rawData[14] = 0;
          tmp.rawData[15] = 1;
        }
        if (axis.z == 1) {
          tmp.rawData[0] = c;
          tmp.rawData[1] = s;
          tmp.rawData[2] = 0;
          tmp.rawData[3] = 0;
          tmp.rawData[4] = -s;
          tmp.rawData[5] = c;
          tmp.rawData[6] = 0;
          tmp.rawData[7] = 0;
          tmp.rawData[8] = 0;
          tmp.rawData[9] = 0;
          tmp.rawData[10] = 1;
          tmp.rawData[11] = 0;
          tmp.rawData[12] = 0;
          tmp.rawData[13] = 0;
          tmp.rawData[14] = 0;
          tmp.rawData[15] = 1;
        }
        this.append(tmp);
        return this;
      }
      /**
       * Append the triaxial scaling value
       * @param xScale x axis scaling
       * @param yScale y axis scaling
       * @param zScale z axis scaling
       */
      appendScale(xScale, yScale, zScale) {
        Matrix4.helpMatrix.createByScale(xScale, yScale, zScale);
        this.append(Matrix4.helpMatrix);
      }
      /**
       * A scaling matrix is generated and other properties are reset
       * @param xScale x axis scaling
       * @param yScale y axis scaling
       * @param zScale z axis scaling
       */
      createByScale(xScale, yScale, zScale) {
        let data = this.rawData;
        data[0] = xScale;
        data[1] = 0;
        data[2] = 0;
        data[3] = 0;
        data[4] = 0;
        data[5] = yScale;
        data[6] = 0;
        data[7] = 0;
        data[8] = 0;
        data[9] = 0;
        data[10] = zScale;
        data[11] = 0;
        data[12] = 0;
        data[13] = 0;
        data[14] = 0;
        data[15] = 1;
      }
      /**
       * Plus a translation matrix
       * @param x x axis scaling
       * @param y y axis scaling
       * @param z z axis scaling
       */
      appendTranslation(x, y, z) {
        let data = this.rawData;
        data[12] += x;
        data[13] += y;
        data[14] += z;
      }
      /**
       * Returns a clone of the current matrix
       * @returns Matrix4 The cloned matrix
       */
      clone() {
        let ret = new Matrix4();
        ret.copy(this);
        return ret;
      }
      /**
       * Assigns a value to one row of the current matrix
       * @param row Row of copy
       * @param Vector3 Value of copy
       */
      copyRowFrom(row, Vector32) {
        let data = this.rawData;
        switch (row) {
          case 0:
            data[0] = Vector32.x;
            data[1] = Vector32.y;
            data[2] = Vector32.z;
            data[3] = Vector32.w;
            break;
          case 1:
            data[4] = Vector32.x;
            data[5] = Vector32.y;
            data[6] = Vector32.z;
            data[7] = Vector32.w;
            break;
          case 2:
            data[8] = Vector32.x;
            data[9] = Vector32.y;
            data[10] = Vector32.z;
            data[11] = Vector32.w;
            break;
          case 3:
            data[12] = Vector32.x;
            data[13] = Vector32.y;
            data[14] = Vector32.z;
            data[15] = Vector32.w;
            break;
        }
      }
      /**
       * One of the rows in the copy matrix stores the values in Vector3.
       * @param row Row of copy
       * @param Vector3 Copy the storage target
       */
      copyRowTo(row, Vector32) {
        let data = this.rawData;
        switch (row) {
          case 0:
            Vector32.x = data[0];
            Vector32.y = data[1];
            Vector32.z = data[2];
            Vector32.w = data[3];
            break;
          case 1:
            Vector32.x = data[4];
            Vector32.y = data[5];
            Vector32.z = data[6];
            Vector32.w = data[7];
            break;
          case 2:
            Vector32.x = data[8];
            Vector32.y = data[9];
            Vector32.z = data[10];
            Vector32.w = data[11];
            break;
          case 3:
            Vector32.x = data[12];
            Vector32.y = data[13];
            Vector32.z = data[14];
            Vector32.w = data[15];
            break;
        }
      }
      /**
       * Assigns the value of a matrix to the current matrix.
       * @param sourceMatrix3D source Matrix
       * @returns Returns the current matrix
       */
      copy(sourceMatrix3D) {
        let data = this.rawData;
        data[0] = sourceMatrix3D.rawData[0];
        data[1] = sourceMatrix3D.rawData[1];
        data[2] = sourceMatrix3D.rawData[2];
        data[3] = sourceMatrix3D.rawData[3];
        data[4] = sourceMatrix3D.rawData[4];
        data[5] = sourceMatrix3D.rawData[5];
        data[6] = sourceMatrix3D.rawData[6];
        data[7] = sourceMatrix3D.rawData[7];
        data[8] = sourceMatrix3D.rawData[8];
        data[9] = sourceMatrix3D.rawData[9];
        data[10] = sourceMatrix3D.rawData[10];
        data[11] = sourceMatrix3D.rawData[11];
        data[12] = sourceMatrix3D.rawData[12];
        data[13] = sourceMatrix3D.rawData[13];
        data[14] = sourceMatrix3D.rawData[14];
        data[15] = sourceMatrix3D.rawData[15];
        return this;
      }
      /**
       * CoMath.PIes the value of the current matrix to a float array.
       * @param vector The target array.
       * @param index copy from the index of the array.
       * @param transpose Whether to transpose the current matrix.
       */
      copyRawDataTo(vector, index = 0, transpose = false) {
        let data = this.rawData;
        vector[0 + index] = data[0];
        vector[1 + index] = data[1];
        vector[2 + index] = data[2];
        vector[3 + index] = data[3];
        vector[4 + index] = data[4];
        vector[5 + index] = data[5];
        vector[6 + index] = data[6];
        vector[7 + index] = data[7];
        vector[8 + index] = data[8];
        vector[9 + index] = data[9];
        vector[10 + index] = data[10];
        vector[11 + index] = data[11];
        vector[12 + index] = data[12];
        vector[13 + index] = data[13];
        vector[14 + index] = data[14];
        vector[15 + index] = data[15];
      }
      /**
       * Assigns a value to a column of the current matrix
       * @param col column
       * @param Vector3 Source of value
       */
      copyColFrom(col, Vector32) {
        let data = this.rawData;
        switch (col) {
          case 0:
            data[0] = Vector32.x;
            data[4] = Vector32.y;
            data[8] = Vector32.z;
            data[12] = Vector32.w;
            break;
          case 1:
            data[1] = Vector32.x;
            data[5] = Vector32.y;
            data[9] = Vector32.z;
            data[13] = Vector32.w;
            break;
          case 2:
            data[2] = Vector32.x;
            data[6] = Vector32.y;
            data[10] = Vector32.z;
            data[14] = Vector32.w;
            break;
          case 3:
            data[3] = Vector32.x;
            data[7] = Vector32.y;
            data[11] = Vector32.z;
            data[15] = Vector32.w;
            break;
        }
      }
      /**
       * Copy a column of the current matrix
       * @param col column
       * @param Vector3 Target of copy
       */
      /**
       * Copy a column of the current matrix into a Vector3.
       * @param col column index (0-3)
       * @param Vector3 target of copy
       */
      copyColTo(col, Vector32) {
        let data = this.rawData;
        switch (col) {
          case 0:
            Vector32.x = data[0];
            Vector32.y = data[4];
            Vector32.z = data[8];
            Vector32.w = data[12];
            break;
          case 1:
            Vector32.x = data[1];
            Vector32.y = data[5];
            Vector32.z = data[9];
            Vector32.w = data[13];
            break;
          case 2:
            Vector32.x = data[2];
            Vector32.y = data[6];
            Vector32.z = data[10];
            Vector32.w = data[14];
            break;
          case 3:
            Vector32.x = data[3];
            Vector32.y = data[7];
            Vector32.z = data[11];
            Vector32.w = data[15];
            break;
        }
      }
      /**
       * Copy the current matrix
       * @param dest Target of copy
       */
      copyToMatrix3D(dest) {
        dest.rawData = this.rawData.slice(0);
      }
      /**
       * Calculate rotation matrix
       * @param quaternion Rotate the quaternion
       * @returns
       */
      makeRotationFromQuaternion(quaternion) {
        this.compose(Matrix4._zero, quaternion, Matrix4._one);
        return this;
      }
      static decomposeRawData = new Float64Array(16).fill(0);
      /**
       * Decompose the current matrix
       * @param orientationStyle The default decomposition type is Orientation3D.EULER_ANGLES
       * @see Orientation3D.AXIS_ANGLE
       * @see Orientation3D.EULER_ANGLES
       * @see Orientation3D.QUATERNION
       * @returns Vector3[3] pos rot scale
       */
      decompose(orientationStyle = "eulerAngles", target) {
        let q = Quaternion.CALCULATION_QUATERNION;
        let vec = target ? target : Matrix4._prs;
        this.copyRawDataTo(Matrix4.decomposeRawData);
        let mr = Matrix4.decomposeRawData;
        let pos = vec[0];
        pos.x = mr[12];
        pos.y = mr[13];
        pos.z = mr[14];
        mr[12] = 0;
        mr[13] = 0;
        mr[14] = 0;
        let scale = vec[2];
        scale.x = Math.sqrt(mr[0] * mr[0] + mr[1] * mr[1] + mr[2] * mr[2]);
        scale.y = Math.sqrt(mr[4] * mr[4] + mr[5] * mr[5] + mr[6] * mr[6]);
        scale.z = Math.sqrt(mr[8] * mr[8] + mr[9] * mr[9] + mr[10] * mr[10]);
        if (mr[0] * (mr[5] * mr[10] - mr[6] * mr[9]) - mr[1] * (mr[4] * mr[10] - mr[6] * mr[8]) + mr[2] * (mr[4] * mr[9] - mr[5] * mr[8]) < 0) {
          scale.z = -scale.z;
        }
        mr[0] /= scale.x;
        mr[1] /= scale.x;
        mr[2] /= scale.x;
        mr[4] /= scale.y;
        mr[5] /= scale.y;
        mr[6] /= scale.y;
        mr[8] /= scale.z;
        mr[9] /= scale.z;
        mr[10] /= scale.z;
        let rot = vec[1];
        let tr;
        switch (orientationStyle) {
          case Orientation3D.AXIS_ANGLE:
            rot.w = Math.acos((mr[0] + mr[5] + mr[10] - 1) / 2);
            let len = Math.sqrt((mr[6] - mr[9]) * (mr[6] - mr[9]) + (mr[8] - mr[2]) * (mr[8] - mr[2]) + (mr[1] - mr[4]) * (mr[1] - mr[4]));
            rot.x = (mr[6] - mr[9]) / len;
            rot.y = (mr[8] - mr[2]) / len;
            rot.z = (mr[1] - mr[4]) / len;
            break;
          case Orientation3D.QUATERNION:
            tr = mr[0] + mr[5] + mr[10];
            if (tr > 0) {
              rot.w = Math.sqrt(1 + tr) / 2;
              rot.x = (mr[6] - mr[9]) / (4 * rot.w);
              rot.y = (mr[8] - mr[2]) / (4 * rot.w);
              rot.z = (mr[1] - mr[4]) / (4 * rot.w);
            } else if (mr[0] > mr[5] && mr[0] > mr[10]) {
              rot.x = Math.sqrt(1 + mr[0] - mr[5] - mr[10]) / 2;
              rot.w = (mr[6] - mr[9]) / (4 * rot.x);
              rot.y = (mr[1] + mr[4]) / (4 * rot.x);
              rot.z = (mr[8] + mr[2]) / (4 * rot.x);
            } else if (mr[5] > mr[10]) {
              rot.y = Math.sqrt(1 + mr[5] - mr[0] - mr[10]) / 2;
              rot.x = (mr[1] + mr[4]) / (4 * rot.y);
              rot.w = (mr[8] - mr[2]) / (4 * rot.y);
              rot.z = (mr[6] + mr[9]) / (4 * rot.y);
            } else {
              rot.z = Math.sqrt(1 + mr[10] - mr[0] - mr[5]) / 2;
              rot.x = (mr[8] + mr[2]) / (4 * rot.z);
              rot.y = (mr[6] + mr[9]) / (4 * rot.z);
              rot.w = (mr[1] - mr[4]) / (4 * rot.z);
            }
            break;
          case Orientation3D.EULER_ANGLES:
            tr = mr[0] + mr[5] + mr[10];
            if (tr > 0) {
              q.w = Math.sqrt(1 + tr) / 2;
              q.x = (mr[6] - mr[9]) / (4 * q.w);
              q.y = (mr[8] - mr[2]) / (4 * q.w);
              q.z = (mr[1] - mr[4]) / (4 * q.w);
            } else if (mr[0] > mr[5] && mr[0] > mr[10]) {
              q.x = Math.sqrt(1 + mr[0] - mr[5] - mr[10]) / 2;
              q.w = (mr[6] - mr[9]) / (4 * q.x);
              q.y = (mr[1] + mr[4]) / (4 * q.x);
              q.z = (mr[8] + mr[2]) / (4 * q.x);
            } else if (mr[5] > mr[10]) {
              rot.y = Math.sqrt(1 + mr[5] - mr[0] - mr[10]) / 2;
              q.x = (mr[1] + mr[4]) / (4 * q.y);
              q.w = (mr[8] - mr[2]) / (4 * q.y);
              q.z = (mr[6] + mr[9]) / (4 * q.y);
            } else {
              q.z = Math.sqrt(1 + mr[10] - mr[0] - mr[5]) / 2;
              q.x = (mr[8] + mr[2]) / (4 * q.z);
              q.y = (mr[6] + mr[9]) / (4 * q.z);
              q.w = (mr[1] - mr[4]) / (4 * q.z);
            }
            q.getEulerAngles(rot);
            break;
        }
        vec[0] = pos;
        vec[1] = rot;
        vec[2] = scale;
        return vec;
      }
      /**
       * Get the Euler vector
       * @param target Vector of results
       * @param quaternion Rotate the quaternion
       * @param isDegree Whether to convert to Angle
       * @param order convert order
       * @returns
       */
      static getEuler(target, quaternion, isDegree = true, order) {
        target ||= new Vector3();
        Matrix4._getEulerMatrix.makeRotationFromQuaternion(quaternion).makeEuler(target, isDegree, order);
        return target;
      }
      /**
       * Calculate the combined matrix of displacement, rotation and scaling
       * @param position translation
       * @param quaternion rotation
       * @param scale scale
       * @returns
       */
      compose(position, quaternion, scale) {
        const te = this.rawData;
        const x = quaternion.x;
        const y = quaternion.y;
        const z = quaternion.z;
        const w = quaternion.w;
        const x2 = x + x;
        const y2 = y + y;
        const z2 = z + z;
        const xx = x * x2;
        const xy = x * y2;
        const xz = x * z2;
        const yy = y * y2;
        const yz = y * z2;
        const zz = z * z2;
        const wx = w * x2;
        const wy = w * y2;
        const wz = w * z2;
        const sx = scale.x;
        const sy = scale.y;
        const sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
      }
      /**
       * The current matrix transforms a vector
       * @param v Vector to transform
       * @param target The default is null and if the current argument is null then a new Vector3 will be returned
       * @returns Vector3 The transformed vector
       */
      deltaTransformVector(v, target) {
        target ||= new Vector3();
        let data = this.rawData;
        let x = v.x;
        let y = v.y;
        let z = v.z;
        target.x = x * data[0] + y * data[4] + z * data[8];
        target.y = x * data[1] + y * data[5] + z * data[9];
        target.z = x * data[2] + y * data[6] + z * data[10];
        target.w = x * data[3] + y * data[7] + z * data[11];
        return target;
      }
      /**
       * Unifies the current matrix
       */
      identity() {
        let data = this.rawData;
        data[0] = 1;
        data[1] = 0;
        data[2] = 0;
        data[3] = 0;
        data[4] = 0;
        data[5] = 1;
        data[6] = 0;
        data[7] = 0;
        data[8] = 0;
        data[9] = 0;
        data[10] = 1;
        data[11] = 0;
        data[12] = 0;
        data[13] = 0;
        data[14] = 0;
        data[15] = 1;
        return this;
      }
      /**
       * Fill the current matrix
       * @param value The filled value
       */
      fill(value) {
        let data = this.rawData;
        data[1] = value;
        data[2] = value;
        data[3] = value;
        data[4] = value;
        data[6] = value;
        data[7] = value;
        data[8] = value;
        data[9] = value;
        data[11] = value;
        data[12] = value;
        data[13] = value;
        data[14] = value;
        data[0] = value;
        data[5] = value;
        data[10] = value;
        data[15] = value;
      }
      /**
       * Invert the current matrix
       */
      invers33() {
        let data = this.rawData;
        let rkInverse_00 = data[5] * data[10] - data[9] * data[6];
        let rkInverse_01 = data[8] * data[6] - data[4] * data[10];
        let rkInverse_02 = data[4] * data[9] - data[8] * data[5];
        let rkInverse_10 = data[9] * data[2] - data[1] * data[10];
        let rkInverse_11 = data[0] * data[10] - data[8] * data[2];
        let rkInverse_12 = data[8] * data[1] - data[0] * data[9];
        let rkInverse_20 = data[1] * data[6] - data[5] * data[2];
        let rkInverse_21 = data[4] * data[2] - data[0] * data[6];
        let rkInverse_22 = data[0] * data[5] - data[4] * data[1];
        let fDet = data[0] * rkInverse_00 + data[4] * rkInverse_10 + data[8] * rkInverse_20;
        if (Math.abs(fDet) > 1e-11) {
          let fInvDet = 1 / fDet;
          data[0] = fInvDet * rkInverse_00;
          data[4] = fInvDet * rkInverse_01;
          data[8] = fInvDet * rkInverse_02;
          data[1] = fInvDet * rkInverse_10;
          data[5] = fInvDet * rkInverse_11;
          data[9] = fInvDet * rkInverse_12;
          data[2] = fInvDet * rkInverse_20;
          data[6] = fInvDet * rkInverse_21;
          data[10] = fInvDet * rkInverse_22;
        }
      }
      /**
       * Invert the current matrix in place. No-ops silently when the matrix is
       * singular (matches Matrix3.invert). Use `Matrix4.invert(src, result?)`
       * for the safe variant that returns `null` on singular input.
       */
      invert() {
        let d = this.determinant;
        let invertable = Math.abs(d) > 1e-11;
        let data = this.rawData;
        if (invertable) {
          d = 1 / d;
          let m11 = data[0];
          let m21 = data[4];
          let m31 = data[8];
          let m41 = data[12];
          let m12 = data[1];
          let m22 = data[5];
          let m32 = data[9];
          let m42 = data[13];
          let m13 = data[2];
          let m23 = data[6];
          let m33 = data[10];
          let m43 = data[14];
          let m14 = data[3];
          let m24 = data[7];
          let m34 = data[11];
          let m44 = data[15];
          data[0] = d * (m22 * (m33 * m44 - m43 * m34) - m32 * (m23 * m44 - m43 * m24) + m42 * (m23 * m34 - m33 * m24));
          data[1] = -d * (m12 * (m33 * m44 - m43 * m34) - m32 * (m13 * m44 - m43 * m14) + m42 * (m13 * m34 - m33 * m14));
          data[2] = d * (m12 * (m23 * m44 - m43 * m24) - m22 * (m13 * m44 - m43 * m14) + m42 * (m13 * m24 - m23 * m14));
          data[3] = -d * (m12 * (m23 * m34 - m33 * m24) - m22 * (m13 * m34 - m33 * m14) + m32 * (m13 * m24 - m23 * m14));
          data[4] = -d * (m21 * (m33 * m44 - m43 * m34) - m31 * (m23 * m44 - m43 * m24) + m41 * (m23 * m34 - m33 * m24));
          data[5] = d * (m11 * (m33 * m44 - m43 * m34) - m31 * (m13 * m44 - m43 * m14) + m41 * (m13 * m34 - m33 * m14));
          data[6] = -d * (m11 * (m23 * m44 - m43 * m24) - m21 * (m13 * m44 - m43 * m14) + m41 * (m13 * m24 - m23 * m14));
          data[7] = d * (m11 * (m23 * m34 - m33 * m24) - m21 * (m13 * m34 - m33 * m14) + m31 * (m13 * m24 - m23 * m14));
          data[8] = d * (m21 * (m32 * m44 - m42 * m34) - m31 * (m22 * m44 - m42 * m24) + m41 * (m22 * m34 - m32 * m24));
          data[9] = -d * (m11 * (m32 * m44 - m42 * m34) - m31 * (m12 * m44 - m42 * m14) + m41 * (m12 * m34 - m32 * m14));
          data[10] = d * (m11 * (m22 * m44 - m42 * m24) - m21 * (m12 * m44 - m42 * m14) + m41 * (m12 * m24 - m22 * m14));
          data[11] = -d * (m11 * (m22 * m34 - m32 * m24) - m21 * (m12 * m34 - m32 * m14) + m31 * (m12 * m24 - m22 * m14));
          data[12] = -d * (m21 * (m32 * m43 - m42 * m33) - m31 * (m22 * m43 - m42 * m23) + m41 * (m22 * m33 - m32 * m23));
          data[13] = d * (m11 * (m32 * m43 - m42 * m33) - m31 * (m12 * m43 - m42 * m13) + m41 * (m12 * m33 - m32 * m13));
          data[14] = -d * (m11 * (m22 * m43 - m42 * m23) - m21 * (m12 * m43 - m42 * m13) + m41 * (m12 * m23 - m22 * m13));
          data[15] = d * (m11 * (m22 * m33 - m32 * m23) - m21 * (m12 * m33 - m32 * m13) + m31 * (m12 * m23 - m22 * m13));
        }
        return this;
      }
      /**
       * Convert the given point from the current matrix coordinate system to world
       * coordinates. Mutates and returns `v`.
       */
      transformPoint(v) {
        return Matrix4.transformPoint(this, v, v);
      }
      /** Transform point v (with translation) by matrix m into result. Allocates a new Vector3 if result is omitted. */
      static transformPoint(m, v, result) {
        result ||= new Vector3();
        const data = m.rawData;
        const x = v.x, y = v.y, z = v.z;
        result.x = x * data[0] + y * data[4] + z * data[8] + data[12];
        result.y = x * data[1] + y * data[5] + z * data[9] + data[13];
        result.z = x * data[2] + y * data[6] + z * data[10] + data[14];
        return result;
      }
      /**
       * Transform a 3D direction vector (no translation) by this matrix.
       * Mutates and returns `v`.
       */
      transformVector(v) {
        return Matrix4.transformVector(this, v, v);
      }
      /** Transform direction v (no translation) by matrix m into result. Allocates a new Vector3 if result is omitted. */
      static transformVector(m, v, result) {
        result ||= new Vector3();
        const data = m.rawData;
        const x = v.x, y = v.y, z = v.z;
        result.x = x * data[0] + y * data[4] + z * data[8];
        result.y = x * data[1] + y * data[5] + z * data[9];
        result.z = x * data[2] + y * data[6] + z * data[10];
        return result;
      }
      /**
       * The current matrix transpose
       */
      transpose() {
        let data = this.rawData;
        for (let i = 0; i < Matrix4.helpMatrix.rawData.length; i++) {
          Matrix4.helpMatrix.rawData[i] = data[i];
        }
        data[1] = Matrix4.helpMatrix.rawData[4];
        data[2] = Matrix4.helpMatrix.rawData[8];
        data[3] = Matrix4.helpMatrix.rawData[12];
        data[4] = Matrix4.helpMatrix.rawData[1];
        data[6] = Matrix4.helpMatrix.rawData[9];
        data[7] = Matrix4.helpMatrix.rawData[13];
        data[8] = Matrix4.helpMatrix.rawData[2];
        data[9] = Matrix4.helpMatrix.rawData[6];
        data[11] = Matrix4.helpMatrix.rawData[14];
        data[12] = Matrix4.helpMatrix.rawData[3];
        data[13] = Matrix4.helpMatrix.rawData[7];
        data[14] = Matrix4.helpMatrix.rawData[11];
      }
      /**
       * Returns the matrix determinant
       * @returns number determinant
       */
      get determinant() {
        let data = this.rawData;
        return (data[0] * data[5] - data[4] * data[1]) * (data[10] * data[15] - data[14] * data[11]) - (data[0] * data[9] - data[8] * data[1]) * (data[6] * data[15] - data[14] * data[7]) + (data[0] * data[13] - data[12] * data[1]) * (data[6] * data[11] - data[10] * data[7]) + (data[4] * data[9] - data[8] * data[5]) * (data[2] * data[15] - data[14] * data[3]) - (data[4] * data[13] - data[12] * data[5]) * (data[2] * data[11] - data[10] * data[3]) + (data[8] * data[13] - data[12] * data[9]) * (data[2] * data[7] - data[6] * data[3]);
      }
      /**
       * Return matrix displacement
       * @param out Position of translation
       * @returns Position of translation
       */
      getPosition(out) {
        out ||= new Vector3();
        let data = this.rawData;
        out.x = data[12];
        out.y = data[13];
        out.z = data[14];
        return out;
      }
      /**
       * Return translation
       * @returns Vector3 Position of translation
       */
      get position() {
        this._position.set(this.rawData[12], this.rawData[13], this.rawData[14]);
        return this._position;
      }
      /**
       * Set Position of translation
       * @param value Position of translation
       */
      set position(value) {
        let data = this.rawData;
        data[12] = value.x;
        data[13] = value.y;
        data[14] = value.z;
      }
      /**
       * get Component of scale
       *
       * @returns Vector3 scale
       */
      get scale() {
        let data = this.rawData;
        return new Vector3(data[0], data[5], data[10]);
      }
      /**
       * Set component of scale
       */
      set scale(value) {
        let data = this.rawData;
        data[0] = value.x;
        data[5] = value.y;
        data[10] = value.z;
      }
      // public setWorldTrans( pos:Vector3 , rotQ:Quaternion,scale:Vector3 = Vector3.SCALE){
      //     this.makeTransform(pos,scale,rotQ);
      // }
      /**
       * Returns the value of the matrix as a string
       *
       * @returns string 
       */
      toString() {
        let data = this.rawData;
        return "matrix3d(" + Math.round(data[0] * 1e3) / 1e3 + "," + Math.round(data[1] * 1e3) / 1e3 + "," + Math.round(data[2] * 1e3) / 1e3 + "," + Math.round(data[3] * 1e3) / 1e3 + "," + Math.round(data[4] * 1e3) / 1e3 + "," + Math.round(data[5] * 1e3) / 1e3 + "," + Math.round(data[6] * 1e3) / 1e3 + "," + Math.round(data[7] * 1e3) / 1e3 + "," + Math.round(data[8] * 1e3) / 1e3 + "," + Math.round(data[9] * 1e3) / 1e3 + "," + Math.round(data[10] * 1e3) / 1e3 + "," + Math.round(data[11] * 1e3) / 1e3 + "," + Math.round(data[12] * 1e3) / 1e3 + "," + Math.round(data[13] * 1e3) / 1e3 + "," + Math.round(data[14] * 1e3) / 1e3 + "," + Math.round(data[15] * 1e3) / 1e3 + ")";
      }
      /**
       * Interpolate between two matrices
       * @param m0 Matrix 0
       * @param m1 Matrix 1
       * @param t Factor of interpolation 0.0 - 1.0
       */
      lerp(m0, m1, t) {
        this.copy(m1).sub(m0).mult(t).add(m0);
      }
      /**
       * Read matrix element values
       * @param row row
       * @param column column
       * @returns
       */
      get(row, column) {
        return this.rawData[row + column * 4];
      }
      /**
       * Sets the matrix element values
       * @param row row
       * @param column column
       * @param v value
       */
      set(row, column, v) {
        this.rawData[row + column * 4] = v;
      }
      /**
       * Get the maximum value of the matrix scaled on each axis
       */
      getMaxScaleOnAxis() {
        let te = this.rawData;
        let scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        let scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        let scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
      }
      /**
       * Calculate the displacement from the vector
       * @param inTrans Vector
       * @returns current matrix
       */
      translate(inTrans) {
        let x = this.get(0, 0) * inTrans.x + this.get(0, 1) * inTrans.y + this.get(0, 2) * inTrans.z + this.get(0, 3);
        let y = this.get(1, 0) * inTrans.x + this.get(1, 1) * inTrans.y + this.get(1, 2) * inTrans.z + this.get(1, 3);
        let z = this.get(2, 0) * inTrans.x + this.get(2, 1) * inTrans.y + this.get(2, 2) * inTrans.z + this.get(2, 3);
        let w = this.get(3, 0) * inTrans.x + this.get(3, 1) * inTrans.y + this.get(3, 2) * inTrans.z + this.get(3, 3);
        this.set(0, 3, x);
        this.set(1, 3, y);
        this.set(2, 3, z);
        this.set(3, 3, w);
        return this;
      }
      /**
       * Set this matrix to the inverse of the translation-rotation transform built from pos and q.
       * @param pos translation
       * @param q rotation quaternion
       */
      setTRInverse(pos, q) {
        q = q.clone().invert();
        Quaternion.quaternionToMatrix(q, this);
        this.translate(new Vector3(-pos.x, -pos.y, -pos.z));
      }
      /**
       * Set scale value
       * @param inScale scale value
       * @returns this matrix
       */
      setScale(inScale) {
        this.set(0, 0, inScale.x);
        this.set(0, 1, 0);
        this.set(0, 2, 0);
        this.set(0, 3, 0);
        this.set(1, 0, 0);
        this.set(1, 1, inScale.y);
        this.set(1, 2, 0);
        this.set(1, 3, 0);
        this.set(2, 0, 0);
        this.set(2, 1, 0);
        this.set(2, 2, inScale.z);
        this.set(2, 3, 0);
        this.set(3, 0, 0);
        this.set(3, 1, 0);
        this.set(3, 2, 0);
        this.set(3, 3, 1);
        return this;
      }
      /**
       * Generate the matrix according to the three axes
       * @param xAxis
       * @param yAxis
       * @param zAxis
       */
      makeBasis(xAxis, yAxis, zAxis) {
        this.setElements(
          xAxis.x,
          yAxis.x,
          zAxis.x,
          0,
          xAxis.y,
          yAxis.y,
          zAxis.y,
          0,
          xAxis.z,
          yAxis.z,
          zAxis.z,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * Set this matrix to a rotation about the given axis by the given angle (in radians).
       * @param axis rotation axis (should be unit length)
       * @param angle rotation angle, in radians
       */
      makeRotationAxis(axis, angle) {
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.setElements(
          tx * x + c,
          tx * y - s * z,
          tx * z + s * y,
          0,
          tx * y + s * z,
          ty * y + c,
          ty * z - s * x,
          0,
          tx * z - s * y,
          ty * z + s * x,
          t * z * z + c,
          0,
          0,
          0,
          0,
          1
        );
        return this;
      }
      /**
       * private
       */
      static transpose(matrix, result) {
        result ||= new Matrix4();
        let m = matrix.rawData;
        let r = result.rawData;
        r[0] = m[0];
        r[1] = m[4];
        r[2] = m[8];
        r[3] = m[12];
        r[4] = m[1];
        r[5] = m[5];
        r[6] = m[9];
        r[7] = m[13];
        r[8] = m[2];
        r[9] = m[6];
        r[10] = m[10];
        r[11] = m[14];
        r[12] = m[3];
        r[13] = m[7];
        r[14] = m[11];
        r[15] = m[15];
        return result;
      }
      /**
       * private
       */
      static inverse(matrix, result) {
        result ||= new Matrix4();
        let m = matrix.rawData;
        let r = result.rawData;
        r[0] = m[5] * m[10] * m[15] - m[5] * m[14] * m[11] - m[6] * m[9] * m[15] + m[6] * m[13] * m[11] + m[7] * m[9] * m[14] - m[7] * m[13] * m[10];
        r[1] = -m[1] * m[10] * m[15] + m[1] * m[14] * m[11] + m[2] * m[9] * m[15] - m[2] * m[13] * m[11] - m[3] * m[9] * m[14] + m[3] * m[13] * m[10];
        r[2] = m[1] * m[6] * m[15] - m[1] * m[14] * m[7] - m[2] * m[5] * m[15] + m[2] * m[13] * m[7] + m[3] * m[5] * m[14] - m[3] * m[13] * m[6];
        r[3] = -m[1] * m[6] * m[11] + m[1] * m[10] * m[7] + m[2] * m[5] * m[11] - m[2] * m[9] * m[7] - m[3] * m[5] * m[10] + m[3] * m[9] * m[6];
        r[4] = -m[4] * m[10] * m[15] + m[4] * m[14] * m[11] + m[6] * m[8] * m[15] - m[6] * m[12] * m[11] - m[7] * m[8] * m[14] + m[7] * m[12] * m[10];
        r[5] = m[0] * m[10] * m[15] - m[0] * m[14] * m[11] - m[2] * m[8] * m[15] + m[2] * m[12] * m[11] + m[3] * m[8] * m[14] - m[3] * m[12] * m[10];
        r[6] = -m[0] * m[6] * m[15] + m[0] * m[14] * m[7] + m[2] * m[4] * m[15] - m[2] * m[12] * m[7] - m[3] * m[4] * m[14] + m[3] * m[12] * m[6];
        r[7] = m[0] * m[6] * m[11] - m[0] * m[10] * m[7] - m[2] * m[4] * m[11] + m[2] * m[8] * m[7] + m[3] * m[4] * m[10] - m[3] * m[8] * m[6];
        r[8] = m[4] * m[9] * m[15] - m[4] * m[13] * m[11] - m[5] * m[8] * m[15] + m[5] * m[12] * m[11] + m[7] * m[8] * m[13] - m[7] * m[12] * m[9];
        r[9] = -m[0] * m[9] * m[15] + m[0] * m[13] * m[11] + m[1] * m[8] * m[15] - m[1] * m[12] * m[11] - m[3] * m[8] * m[13] + m[3] * m[12] * m[9];
        r[10] = m[0] * m[5] * m[15] - m[0] * m[13] * m[7] - m[1] * m[4] * m[15] + m[1] * m[12] * m[7] + m[3] * m[4] * m[13] - m[3] * m[12] * m[5];
        r[11] = -m[0] * m[5] * m[11] + m[0] * m[9] * m[7] + m[1] * m[4] * m[11] - m[1] * m[8] * m[7] - m[3] * m[4] * m[9] + m[3] * m[8] * m[5];
        r[12] = -m[4] * m[9] * m[14] + m[4] * m[13] * m[10] + m[5] * m[8] * m[14] - m[5] * m[12] * m[10] - m[6] * m[8] * m[13] + m[6] * m[12] * m[9];
        r[13] = m[0] * m[9] * m[14] - m[0] * m[13] * m[10] - m[1] * m[8] * m[14] + m[1] * m[12] * m[10] + m[2] * m[8] * m[13] - m[2] * m[12] * m[9];
        r[14] = -m[0] * m[5] * m[14] + m[0] * m[13] * m[6] + m[1] * m[4] * m[14] - m[1] * m[12] * m[6] - m[2] * m[4] * m[13] + m[2] * m[12] * m[5];
        r[15] = m[0] * m[5] * m[10] - m[0] * m[9] * m[6] - m[1] * m[4] * m[10] + m[1] * m[8] * m[6] + m[2] * m[4] * m[9] - m[2] * m[8] * m[5];
        let det = m[0] * r[0] + m[1] * r[4] + m[2] * r[8] + m[3] * r[12];
        for (let i = 0; i < 16; i++) {
          r[i] /= det;
        }
        return result;
      }
      makeEuler(target, toDegree, order = "XYZ") {
        const te = this.rawData;
        const m11 = te[0];
        const m12 = te[4];
        const m13 = te[8];
        const m21 = te[1];
        const m22 = te[5];
        const m23 = te[9];
        const m31 = te[2];
        const m32 = te[6];
        const m33 = te[10];
        switch (order) {
          case "XYZ":
            target.y = Math.asin(clamp$2(m13, -1, 1));
            if (Math.abs(m13) < 0.9999999) {
              target.x = Math.atan2(-m23, m33);
              target.z = Math.atan2(-m12, m11);
            } else {
              target.x = Math.atan2(m32, m22);
              target.z = 0;
            }
            break;
          case "YXZ":
            target.x = Math.asin(-clamp$2(m23, -1, 1));
            if (Math.abs(m23) < 0.9999999) {
              target.y = Math.atan2(m13, m33);
              target.z = Math.atan2(m21, m22);
            } else {
              target.y = Math.atan2(-m31, m11);
              target.z = 0;
            }
            break;
          case "ZXY":
            target.x = Math.asin(clamp$2(m32, -1, 1));
            if (Math.abs(m32) < 0.9999999) {
              target.y = Math.atan2(-m31, m33);
              target.z = Math.atan2(-m12, m22);
            } else {
              target.y = 0;
              target.z = Math.atan2(m21, m11);
            }
            break;
          case "ZYX":
            target.y = Math.asin(-clamp$2(m31, -1, 1));
            if (Math.abs(m31) < 0.9999999) {
              target.x = Math.atan2(m32, m33);
              target.z = Math.atan2(m21, m11);
            } else {
              target.x = 0;
              target.z = Math.atan2(-m12, m22);
            }
            break;
          case "YZX":
            target.z = Math.asin(clamp$2(m21, -1, 1));
            if (Math.abs(m21) < 0.9999999) {
              target.x = Math.atan2(-m23, m22);
              target.y = Math.atan2(-m31, m11);
            } else {
              target.x = 0;
              target.y = Math.atan2(m13, m33);
            }
            break;
          case "XZY":
            target.z = Math.asin(-clamp$2(m12, -1, 1));
            if (Math.abs(m12) < 0.9999999) {
              target.x = Math.atan2(m32, m22);
              target.y = Math.atan2(m13, m11);
            } else {
              target.x = Math.atan2(-m23, m33);
              target.y = 0;
            }
            break;
        }
        if (toDegree) {
          target.multiplyScalar(RADIANS_TO_DEGREES);
        }
        return target;
      }
      setElements(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.rawData;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
      }
      /**
       * @internal
       */
      makeMatrix44ByQuaternion(pos, scale, rot) {
        this.identity();
        Quaternion.quaternionToMatrix(rot, this);
        this.appendTranslation(pos.x, pos.y, pos.z);
        this.appendScale(scale.x, scale.y, scale.z);
      }
    }
    function multiplyMatrices4x4REF(lhs, rhs, res) {
      for (let i = 0; i < 4; i++) {
        res.rawData[i] = lhs.rawData[i] * rhs.rawData[0] + lhs.rawData[i + 4] * rhs.rawData[1] + lhs.rawData[i + 8] * rhs.rawData[2] + lhs.rawData[i + 12] * rhs.rawData[3];
        res.rawData[i + 4] = lhs.rawData[i] * rhs.rawData[4] + lhs.rawData[i + 4] * rhs.rawData[5] + lhs.rawData[i + 8] * rhs.rawData[6] + lhs.rawData[i + 12] * rhs.rawData[7];
        res.rawData[i + 8] = lhs.rawData[i] * rhs.rawData[8] + lhs.rawData[i + 4] * rhs.rawData[9] + lhs.rawData[i + 8] * rhs.rawData[10] + lhs.rawData[i + 12] * rhs.rawData[11];
        res.rawData[i + 12] = lhs.rawData[i] * rhs.rawData[12] + lhs.rawData[i + 4] * rhs.rawData[13] + lhs.rawData[i + 8] * rhs.rawData[14] + lhs.rawData[i + 12] * rhs.rawData[15];
      }
    }
    function makeMatrix44(r, p, s, outMat) {
      let rawData = outMat.rawData;
      let x = r.x * DEGREES_TO_RADIANS;
      let y = r.y * DEGREES_TO_RADIANS;
      let z = r.z * DEGREES_TO_RADIANS;
      let w = 0;
      let halfX = x * 0.5;
      let halfY = y * 0.5;
      let halfZ = z * 0.5;
      let cosX = Math.cos(halfX);
      let sinX = Math.sin(halfX);
      let cosY = Math.cos(halfY);
      let sinY = Math.sin(halfY);
      let cosZ = Math.cos(halfZ);
      let sinZ = Math.sin(halfZ);
      w = cosX * cosY * cosZ + sinX * sinY * sinZ;
      x = sinX * cosY * cosZ - cosX * sinY * sinZ;
      y = cosX * sinY * cosZ + sinX * cosY * sinZ;
      z = cosX * cosY * sinZ - sinX * sinY * cosZ;
      let x2 = x + x;
      let y2 = y + y;
      let z2 = z + z;
      let xx = x * x2;
      let xy = x * y2;
      let xz = x * z2;
      let yy = y * y2;
      let yz = y * z2;
      let zz = z * z2;
      let wx = w * x2;
      let wy = w * y2;
      let wz = w * z2;
      let sx = s.x;
      let sy = s.y;
      let sz = s.z;
      rawData[0] = (1 - (yy + zz)) * sx;
      rawData[1] = (xy + wz) * sx;
      rawData[2] = (xz - wy) * sx;
      rawData[3] = 0;
      rawData[4] = (xy - wz) * sy;
      rawData[5] = (1 - (xx + zz)) * sy;
      rawData[6] = (yz + wx) * sy;
      rawData[7] = 0;
      rawData[8] = (xz + wy) * sz;
      rawData[9] = (yz - wx) * sz;
      rawData[10] = (1 - (xx + yy)) * sz;
      rawData[11] = 0;
      rawData[12] = p.x;
      rawData[13] = p.y;
      rawData[14] = p.z;
      rawData[15] = 1;
    }
    function append(src, lhs, target) {
      let data = src.rawData;
      let targetData = target.rawData;
      let m111 = data[0];
      let m121 = data[4];
      let m131 = data[8];
      let m141 = data[12];
      let m112 = data[1];
      let m122 = data[5];
      let m132 = data[9];
      let m142 = data[13];
      let m113 = data[2];
      let m123 = data[6];
      let m133 = data[10];
      let m143 = data[14];
      let m114 = data[3];
      let m124 = data[7];
      let m134 = data[11];
      let m144 = data[15];
      targetData[0] = m111 * lhs.rawData[0] + m112 * lhs.rawData[4] + m113 * lhs.rawData[8] + m114 * lhs.rawData[12];
      targetData[1] = m111 * lhs.rawData[1] + m112 * lhs.rawData[5] + m113 * lhs.rawData[9] + m114 * lhs.rawData[13];
      targetData[2] = m111 * lhs.rawData[2] + m112 * lhs.rawData[6] + m113 * lhs.rawData[10] + m114 * lhs.rawData[14];
      targetData[3] = m111 * lhs.rawData[3] + m112 * lhs.rawData[7] + m113 * lhs.rawData[11] + m114 * lhs.rawData[15];
      targetData[4] = m121 * lhs.rawData[0] + m122 * lhs.rawData[4] + m123 * lhs.rawData[8] + m124 * lhs.rawData[12];
      targetData[5] = m121 * lhs.rawData[1] + m122 * lhs.rawData[5] + m123 * lhs.rawData[9] + m124 * lhs.rawData[13];
      targetData[6] = m121 * lhs.rawData[2] + m122 * lhs.rawData[6] + m123 * lhs.rawData[10] + m124 * lhs.rawData[14];
      targetData[7] = m121 * lhs.rawData[3] + m122 * lhs.rawData[7] + m123 * lhs.rawData[11] + m124 * lhs.rawData[15];
      targetData[8] = m131 * lhs.rawData[0] + m132 * lhs.rawData[4] + m133 * lhs.rawData[8] + m134 * lhs.rawData[12];
      targetData[9] = m131 * lhs.rawData[1] + m132 * lhs.rawData[5] + m133 * lhs.rawData[9] + m134 * lhs.rawData[13];
      targetData[10] = m131 * lhs.rawData[2] + m132 * lhs.rawData[6] + m133 * lhs.rawData[10] + m134 * lhs.rawData[14];
      targetData[11] = m131 * lhs.rawData[3] + m132 * lhs.rawData[7] + m133 * lhs.rawData[11] + m134 * lhs.rawData[15];
      targetData[12] = m141 * lhs.rawData[0] + m142 * lhs.rawData[4] + m143 * lhs.rawData[8] + m144 * lhs.rawData[12];
      targetData[13] = m141 * lhs.rawData[1] + m142 * lhs.rawData[5] + m143 * lhs.rawData[9] + m144 * lhs.rawData[13];
      targetData[14] = m141 * lhs.rawData[2] + m142 * lhs.rawData[6] + m143 * lhs.rawData[10] + m144 * lhs.rawData[14];
      targetData[15] = m141 * lhs.rawData[3] + m142 * lhs.rawData[7] + m143 * lhs.rawData[11] + m144 * lhs.rawData[15];
    }
    function rotMatrix(mat, q) {
      let x = q.x;
      let y = q.y;
      let z = q.z;
      let w = q.w;
      let rawData = mat.rawData;
      let xy2 = 2 * x * y;
      let xz2 = 2 * x * z;
      let xw2 = 2 * x * w;
      let yz2 = 2 * y * z;
      let yw2 = 2 * y * w;
      let zw2 = 2 * z * w;
      let xx = x * x;
      let yy = y * y;
      let zz = z * z;
      let ww = w * w;
      rawData[0] = xx - yy - zz + ww;
      rawData[4] = xy2 - zw2;
      rawData[8] = xz2 + yw2;
      rawData[12] = 0;
      rawData[1] = xy2 + zw2;
      rawData[5] = -xx + yy - zz + ww;
      rawData[9] = yz2 - xw2;
      rawData[13] = 0;
      rawData[2] = xz2 - yw2;
      rawData[6] = yz2 + xw2;
      rawData[10] = -xx - yy + zz + ww;
      rawData[14] = 0;
      rawData[3] = 0;
      rawData[7] = 0;
      rawData[11] = 0;
      rawData[15] = 1;
      return mat;
    }
    function matrixRotateY(rad, target) {
      let out = target.rawData;
      let s = Math.sin(rad);
      let c = Math.cos(rad);
      out[0] = c;
      out[1] = 0;
      out[2] = -s;
      out[3] = 0;
      out[8] = s;
      out[9] = 0;
      out[10] = c;
      out[11] = 0;
      return out;
    }
    function matrixRotate(rad, axis, target, epsilon) {
      epsilon ||= EPSILON;
      let x = axis.x;
      let y = axis.y;
      let z = axis.z;
      let len = Math.hypot(x, y, z);
      let s;
      let c;
      let t;
      let b00;
      let b01;
      let b02;
      let b10;
      let b11;
      let b12;
      let b20;
      let b21;
      let b22;
      if (len < epsilon) {
        return null;
      }
      len = 1 / len;
      x *= len;
      y *= len;
      z *= len;
      s = Math.sin(rad);
      c = Math.cos(rad);
      t = 1 - c;
      b00 = x * x * t + c;
      b01 = y * x * t + z * s;
      b02 = z * x * t - y * s;
      b10 = x * y * t - z * s;
      b11 = y * y * t + c;
      b12 = z * y * t + x * s;
      b20 = x * z * t + y * s;
      b21 = y * z * t - x * s;
      b22 = z * z * t + c;
      let out = target.rawData;
      out[0] = b00;
      out[1] = b01;
      out[2] = b02;
      out[3] = 0;
      out[4] = b10;
      out[5] = b11;
      out[6] = b12;
      out[7] = 0;
      out[8] = b20;
      out[9] = b21;
      out[10] = b22;
      out[11] = 0;
      out[12] = 0;
      out[13] = 0;
      out[14] = 0;
      out[15] = 1;
      return out;
    }
    function matrixMultiply(aMat, bMat, target) {
      let a = aMat.rawData;
      let a00 = a[0];
      let a01 = a[1];
      let a02 = a[2];
      let a03 = a[3];
      let a10 = a[4];
      let a11 = a[5];
      let a12 = a[6];
      let a13 = a[7];
      let a20 = a[8];
      let a21 = a[9];
      let a22 = a[10];
      let a23 = a[11];
      let a30 = a[12];
      let a31 = a[13];
      let a32 = a[14];
      let a33 = a[15];
      let b = bMat.rawData;
      let out = target.rawData;
      let b0 = b[0];
      let b1 = b[1];
      let b2 = b[2];
      let b3 = b[3];
      out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
      out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
      out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
      out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
      b0 = b[4];
      b1 = b[5];
      b2 = b[6];
      b3 = b[7];
      out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
      out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
      out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
      out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
      b0 = b[8];
      b1 = b[9];
      b2 = b[10];
      b3 = b[11];
      out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
      out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
      out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
      out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
      b0 = b[12];
      b1 = b[13];
      b2 = b[14];
      b3 = b[15];
      out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
      out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
      out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
      out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
      return out;
    }

    class Rand {
      _x = 0;
      _y = 0;
      _z = 0;
      _w = 0;
      /**
       * Create a random number generator object with a specified seed.
       * @param seed Random seed
       */
      constructor(seed = 0) {
        this.seed = seed;
      }
      /**
       * Random seed
       */
      get seed() {
        return this._x;
      }
      /**
       * Set the random seed and reinitialize the generator state
       */
      set seed(value) {
        this._x = value;
        this._y = this._x * 1812433253 + 1;
        this._z = this._y * 1812433253 + 1;
        this._w = this._z * 1812433253 + 1;
      }
      /**
       * Convert an integer to a floating-point number
       * @param value integer
       * @returns 
       */
      static getFloatFromInt(value) {
        return Math.floor((value & 8388607) * (1 / 8388607));
      }
      /**
       * Converts an integer to a single-byte integer
       * @param value integer
       * @returns 
       */
      static getByteFromInt(value) {
        return value >> 23 - 8;
      }
      /**
       * Returns a new random number generator object with the same seed state as 
       * the current random number generator object
       * @returns 
       */
      clone() {
        let result = new Rand();
        result._x = this._x;
        result._y = this._y;
        result._z = this._z;
        result._w = this._w;
        return result;
      }
      /**
       * Generate a random number
       * @returns 
       */
      get() {
        let t = this._x ^ this._x << 11;
        this._x = this._y;
        this._y = this._z;
        this._z = this._w;
        return this._w = this._w ^ this._w >> 19 ^ (t ^ t >> 8);
      }
      /**
       * Randomly generate a floating-point number 0.0 to 1.0
       * @returns 
       */
      getFloat() {
        return getFloatFromInt(this.get());
      }
      /**
       * Randomly generates signed floating-point numbers -1.0 to 1.0
       * @returns 
       */
      getSignedFloat() {
        return this.getFloat() * 2 - 1;
      }
    }

    class Vector2 {
      /**
       * @internal
       */
      static HELP_0 = new Vector2();
      /**
       * @internal
       */
      static HELP_1 = new Vector2();
      /**
       * @internal
       */
      static HELP_2 = new Vector2();
      /** A zero vector (0, 0). */
      static ZERO = new Vector2(0, 0);
      /** A vector whose components are the maximum safe integer. */
      static SAFE_MAX = new Vector2(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
      /** A vector whose components are the minimum safe integer. */
      static SAFE_MIN = new Vector2(Number.MIN_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
      /**
       * The x component of the vector, the default value is 0.
      */
      x = 0;
      /**
       * The y component of the vector, the default value is 0.
       */
      y = 0;
      /**
       * Create a new Vector2.
       * @param x The x component of the vector, which defaults to 0.
       * @param y The y component of the vector, which defaults to 0.
       */
      constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
      }
      /**
       * Returns the Angle, in radians, between two vectors.
       * @param a Vector a
       * @param b Vector b
       * @returns result
       */
      static getAngle(a, b) {
        return Math.atan2(b.y - a.y, b.x - a.x);
      }
      /**
       * Computes linear interpolation between two vectors.
       * @param from starting vector
       * @param to The vector in which you interpolate
       * @param t 
       */
      static slerp(from, to, t) {
        let v = new Vector2();
        let dot = from.dot(to);
        if (dot < 0) {
          to.x = -to.x;
          to.y = -to.y;
          dot = -dot;
        }
        if (dot > 0.9995) {
          v.x = from.x + t * (to.x - from.x);
          v.y = from.y + t * (to.y - from.y);
          return v;
        }
        let theta = Math.acos(dot);
        let sinTheta = Math.sin(theta);
        let scale0 = Math.sin((1 - t) * theta) / sinTheta;
        let scale1 = Math.sin(t * theta) / sinTheta;
        v.x = scale0 * from.x + scale1 * to.x;
        v.y = scale0 * from.y + scale1 * to.y;
        return v;
      }
      /**
       * Linear interpolation between two vectors.
       * @param from starting vector
       * @param to  The vector in which you interpolate
       * @param t 
       * @returns 
       */
      static lerp(from, to, t) {
        Vector2.HELP_0.copy(from);
        Vector2.HELP_1.copy(to);
        Vector2.HELP_0.multiplyScalar(t);
        Vector2.HELP_1.multiplyScalar(1 - t);
        return new Vector2(Vector2.HELP_0.x + Vector2.HELP_1.x, Vector2.HELP_0.y + Vector2.HELP_1.y);
      }
      /**
       * Add two vectors
       */
      static add(a, b, result) {
        result ||= new Vector2();
        result.x = a.x + b.x;
        result.y = a.y + b.y;
        return result;
      }
      /**
       * Subtract two vectors
       */
      static sub(a, b, result) {
        result ||= new Vector2();
        result.x = a.x - b.x;
        result.y = a.y - b.y;
        return result;
      }
      /**
       * Component-wise multiply two vectors
       */
      static multiply(a, b, result) {
        result ||= new Vector2();
        result.x = a.x * b.x;
        result.y = a.y * b.y;
        return result;
      }
      /**
       * Component-wise divide two vectors
       */
      static divide(a, b, result) {
        result ||= new Vector2();
        result.x = a.x / b.x;
        result.y = a.y / b.y;
        return result;
      }
      /**
       * Multiply a vector by a scalar
       */
      static multiplyScalar(a, s, result) {
        result ||= new Vector2();
        result.x = a.x * s;
        result.y = a.y * s;
        return result;
      }
      /**
       * Negate a vector
       */
      static negate(a, result) {
        result ||= new Vector2();
        result.x = -a.x;
        result.y = -a.y;
        return result;
      }
      /**
       * Sets the x and y components of this vector.
       * @param x The x component of the vector, which defaults to 0.
       * @param y The y component of the vector, which defaults to 0.
       */
      set(x = 0, y = 0) {
        this.x = x;
        this.y = y;
        return this;
      }
      /**
       * Calculate the distance between this vector and the incoming vector.
       * @param a Target vector
       * @returns
       */
      distance(a) {
        return Math.sqrt(Math.pow(this.x - a.x, 2) + Math.pow(this.y - a.y, 2));
      }
      /**
       * Adds vector `a` to this vector. Mutates and returns this.
       */
      add(a) {
        return Vector2.add(this, a, this);
      }
      /**
       * Subtracts vector `a` from this vector. Mutates and returns this.
       */
      sub(a) {
        return Vector2.sub(this, a, this);
      }
      /**
       * Multiplies x/y of this vector by scalar s. Mutates and returns this.
       */
      multiplyScalar(s) {
        return Vector2.multiplyScalar(this, s, this);
      }
      /**
       * Multiplies x/y of this vector by scalar a. Mutates and returns this.
       * Kept as an alternative name for the scalar `multiplyScalar`.
       */
      multiply(a) {
        return Vector2.multiplyScalar(this, a, this);
      }
      /**
       * Divides x/y of this vector by scalar v. Mutates and returns this.
       */
      divide(v) {
        return Vector2.multiplyScalar(this, 1 / v, this);
      }
      /**
       * Negates this vector. Mutates and returns this.
       */
      neg() {
        return Vector2.negate(this, this);
      }
      /** Returns the Euclidean length of this vector. */
      abs() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }
      /**
       * Length of vector
       * @returns 
       */
      length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }
      /**
       * Returns the Angle, in radians, between the current vector and the target vector.
       * @param target Target vector
       * @returns 
       */
      getAngle(target) {
        return Math.atan2(target.y - this.y, target.x - this.x);
      }
      /**
       * Normalizes this vector to unit length. Mutates and returns this.
       */
      unt() {
        let d = this.abs();
        this.x = this.x / d;
        this.y = this.y / d;
        return this;
      }
      /** Returns the angle, in radians, from this vector to v. */
      angleTo(v) {
        let dx = v.x - this.x;
        let dy = v.y - this.y;
        return Math.atan2(dy, dx);
      }
      /**
       * Whether two vectors are equal
       * @param a Vector of comparison
       * @returns 
       */
      equals(a) {
        if (Math.abs(this.x - a.x) < 1e-6 && Math.abs(this.y - a.y) < 1e-6) return true;
        return false;
      }
      /** Tests parallelism with a: 1 if same direction, -1 if opposite, 0 otherwise. */
      pal(a) {
        let u1 = this.clone().unt();
        let u2 = a.clone().unt();
        if (u1.equals(u2)) return 1;
        if (u1.equals(u2.neg())) return -1;
        return 0;
      }
      /**
       * Returns a new vector that has the same x and y as the current vector.
       * @returns 
       */
      clone() {
        return new Vector2(this.x, this.y);
      }
      /**
       * Copy the x and y properties of the source vector to this vector
       * @param v Source vector
       * @returns 
       */
      copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
      }
      /**
       * Add scaling vector
       * @param v Source vector
       * @param size Scale size
       * @returns 
       */
      addScaledVector(v, size) {
        this.x += v.x * size;
        this.y += v.y * size;
        return this;
      }
      /**
       * Take the dot product of two vectors.
       * @param value Target vector
       * @returns 
       */
      dot(value) {
        return this.x * value.x + this.y * value.y;
      }
      /**
       * Convert this vector to a unit vector.
       */
      normalize() {
        let d = this.abs();
        this.x = this.x / d;
        this.y = this.y / d;
        return this;
      }
      /**
       * Add the scalar to the x and y of this vector.
       * @param s Additive scalar
       * @returns 
       */
      addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
      }
      /**
       * 
       * @param minVal Component will be limited to the minimum value of
       * @param maxVal The component will be limited to the maximum value of
       * @returns 
       */
      clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
      }
      // -------- Standard instance API --------
      /** Set this = a + b. */
      addVectors(a, b) {
        return Vector2.add(a, b, this);
      }
      /** Set this = a - b. */
      subVectors(a, b) {
        return Vector2.sub(a, b, this);
      }
      /** Set this = a * b component-wise. */
      multiplyVectors(a, b) {
        return Vector2.multiply(a, b, this);
      }
      /** Negate this vector. Canonical alias of {@link neg}. */
      negate() {
        return Vector2.negate(this, this);
      }
      /** Squared length. */
      lengthSq() {
        return this.x * this.x + this.y * this.y;
      }
      /** Euclidean distance to v. Canonical alias of {@link distance}. */
      distanceTo(v) {
        return this.distance(v);
      }
      /** Squared distance to v. */
      distanceToSquared(v) {
        const dx = this.x - v.x;
        const dy = this.y - v.y;
        return dx * dx + dy * dy;
      }
      /** Linearly interpolate this towards v by alpha. */
      lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
      }
      /** Set this = v1 + (v2 - v1) * alpha. */
      lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
      }
      /** Component-wise min/max/clamp. */
      min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
      }
      /** Component-wise maximum with v. Mutates and returns this. */
      max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
      }
      /** Component-wise clamp into [min, max]. Mutates and returns this. */
      clamp(min, max) {
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
      }
      /** Floors each component. Mutates and returns this. */
      floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
      }
      /** Ceils each component. Mutates and returns this. */
      ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
      }
      /** Rounds each component to the nearest integer. Mutates and returns this. */
      round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
      }
      /** Rounds each component toward zero. Mutates and returns this. */
      roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
      }
      /** Set x/y from array starting at offset. Mutates and returns this. */
      fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
      }
      /** Write x/y into array starting at offset and return the array. */
      toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
      }
      /** Rotate this around `center` by angle (radians). */
      rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
      }
      /** Fill this with components in [0, 1). Mutates and returns this. */
      random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
      }
    }

    let RADIANS_TO_DEGREES = 180 / Math.PI;
    let DEGREES_TO_RADIANS = Math.PI / 180;
    let MAX_VALUE = 2147483647;
    let MIN_VALUE = -2147483647;
    function clamp$2(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }
    class MathUtil {
      /**
       * @private
       * The gaussian function to calculate the color value
       * @param {number} value the value (the x-value)
       * @param {number} amplitude the curve peak
       * @param {number} center the curve center
       * @param {number} rmsWidth the curve width
       * @returns {number} the color value (the y-value)
       */
      static gaussFunction(value, amplitude, center, rmsWidth) {
        let numerator = Math.pow(value - center, 2);
        let denominator = 2 * Math.pow(rmsWidth, 2);
        let exp = -1 * (numerator / denominator);
        let curve = Math.pow(Math.E, exp);
        return Math.round(curve * amplitude);
      }
      /**
       * Calculate the Gaussian distribution function
       * @param n Function variable value
       * @param theta The degree of dispersion of the data distribution
       * @returns The result of the calculated Gaussian distribution value
       */
      static computeGaussian(n, theta) {
        return 1 / Math.sqrt(2 * Math.PI * theta) * Math.exp(-(n * n) / (2 * theta * theta));
      }
      /**
       * Calculate Gaussian coefficient
       * @param sigma sigma value
       * @returns Return the calculation result
       */
      static gaussCoef(sigma) {
        if (sigma < 0.5) {
          sigma = 0.5;
        }
        let a = Math.exp(0.726 * 0.726) / sigma;
        let g1 = Math.exp(-a);
        let g2 = Math.exp(-2 * a);
        let k = (1 - g1) * (1 - g1) / (1 + 2 * a * g1 - g2);
        let a0 = k;
        let a1 = k * (a - 1) * g1;
        let a2 = k * (a + 1) * g1;
        let a3 = -k * g2;
        let b1 = 2 * g1;
        let b2 = -g2;
        let left_corner = (a0 + a1) / (1 - b1 - b2);
        let right_corner = (a2 + a3) / (1 - b1 - b2);
        return new Float32Array([a0, a1, a2, a3, b1, b2, left_corner, right_corner]);
      }
      /**
       * Limit the value to a certain range
       * @param value Original value
       * @param min_inclusive minimum value
       * @param max_inclusive maximum value
       * @returns Return the calculation result
       */
      static clampf(value, min_inclusive, max_inclusive) {
        if (min_inclusive > max_inclusive) {
          let temp = min_inclusive;
          min_inclusive = max_inclusive;
          max_inclusive = temp;
        }
        return value < min_inclusive ? min_inclusive : value < max_inclusive ? value : max_inclusive;
      }
      /**
       * Normalize the Angle so that it is limited to the range [-180, 180]
       * @param a Angle of input
       * @returns Return the processing result
       */
      static normalizeAngle(a) {
        while (a > 180) {
          a -= 360;
        }
        while (a < -180) {
          a += 360;
        }
        return a;
      }
      /**
       * Returns the fractional part of a number
       * @param v input value
       * @returns Return the result
       */
      static fract(v) {
        return v - Math.floor(v);
      }
      /**
       * Generate a random pair of x and z coordinates that fall within the radius of the circle
       * @param r radius
       * @returns The generated x, z results
       */
      static getRandDirXZ(r) {
        let rr = r * Math.random();
        let ra = 360 * Math.random() * DEGREES_TO_RADIANS;
        let x = Math.cos(ra) * rr;
        let z = Math.sin(ra) * rr;
        return { x, z };
      }
      /**
       * Generate a random pair of x, y, and z coordinates that fall within the radius of the sphere
       * @param r radius
       * @returns The Vector3 vector formed by the generated x, y, and z coordinate values
       */
      static getRandDirXYZ(r) {
        let rr = r * Math.random();
        let ra = 360 * Math.random() * DEGREES_TO_RADIANS;
        let x = Math.cos(ra) * rr;
        let y = Math.tan(ra) * rr;
        let z = Math.sin(ra) * rr;
        return new Vector3(x, y, z);
      }
      /**
       * According to the radius, generate a random pair of x, y, z coordinates that fall within the sphere and the y value is between [-r/2, r/2]
       * @param r radius
       * @returns The Vector3 vector formed by the generated x, y, and z coordinate values
       */
      static getCycleXYZ(r) {
        let rr = r * Math.random();
        let ra = 360 * Math.random() * DEGREES_TO_RADIANS;
        let x = Math.cos(ra) * rr;
        let y = r * Math.random() - r * 0.5;
        let z = Math.sin(ra) * rr;
        return new Vector3(x, y, z);
      }
      /**
       * Calculate the Angle between two vectors
       * @param p1 Vector 1
       * @param p2 Vector 2
       * @returns Return the calculation result
       */
      static angle(p1, p2) {
        let v1 = Vector2.HELP_0;
        let v2 = Vector2.HELP_1;
        v1.set(p1.x, p1.z);
        v2.set(p2.x, p2.z);
        return Math.acos((v1.x * v2.x + v1.y * v2.y) / (v1.abs() * v2.abs()));
      }
      /**
       * Calculate the Angle between two vectors
       * @param from Vector 1
       * @param to Vector 2
       * @returns The Angle between two vectors
       */
      static angle_360(from, to) {
        let v3 = Vector3.HELP_0;
        Vector3.cross(from, to, v3);
        if (v3.z > 0) {
          return MathUtil.angle(from, to);
        } else {
          return 360 - MathUtil.angle(from, to);
        }
      }
      /**
       * The rotation Angle around the Y-axis is obtained from the input vector
       * @param v input vector
       * @returns Return the calculation result
       */
      getRotationY(v) {
        let rot = MathUtil.normalizeAngle(Math.atan2(v.z, v.x) * RADIANS_TO_DEGREES);
        return rot;
      }
      /**
       * Calculate the quaternion from one direction to the other
       * @param fromDirection Initial direction
       * @param toDirection The transformed direction
       * @param target The calculated quaternion is null by default and the result is returned
       * @returns Quaternion The calculated quaternion returns a new instance created if target is null
       */
      static fromToRotation(fromDirection, toDirection, target = null) {
        target ||= new Quaternion();
        let mat = Matrix4.help_matrix_2;
        Matrix4.fromToRotation(fromDirection, toDirection, mat);
        target.setFromRotationMatrix(mat);
        return target;
      }
      /**
       * Get the Eular direction
       * @param v input value
       * @returns Return the calculation result
       */
      static getEularDir_yUp(v) {
        let q = Quaternion.HELP_0;
        q.setFromEuler(0, v, 0);
        Quaternion.transformVector(q, Vector3.Z_AXIS, Vector3.HELP_5);
        return Vector3.HELP_5;
      }
      /**
       * Compute the vector transformation and assign the results to the input variables
       * @param matrix transformation matrix
       * @param vector Original vector
       * @param result output vector
       * @returns Returns the output vector
       */
      static transformVector(matrix, vector, result = null) {
        result ||= new Vector3();
        let raw = matrix.rawData;
        let a = raw[0];
        let e = raw[1];
        let i = raw[2];
        let m = raw[3];
        let b = raw[4];
        let f = raw[5];
        let j = raw[6];
        let n = raw[7];
        let c = raw[8];
        let g = raw[9];
        let k = raw[10];
        let o = raw[11];
        let d = raw[12];
        let h = raw[13];
        let l = raw[14];
        let p = raw[15];
        let x = vector.x;
        let y = vector.y;
        let z = vector.z;
        result.x = a * x + b * y + c * z + d;
        result.y = e * x + f * y + g * z + h;
        result.z = i * x + j * y + k * z + l;
        result.w = m * x + n * y + o * z + p;
        return result;
      }
    }
    let lerp = function(v0, v1, t) {
      return v0 * (1 - t) + v1 * t;
    };
    function lerpVector3(v0, v1, t) {
      let newV = new Vector3();
      let v0x = v0.x;
      let v0y = v0.y;
      let v0z = v0.z;
      let v0w = v0.w;
      let v1x = v1.x;
      let v1y = v1.y;
      let v1z = v1.z;
      let v1w = v1.w;
      newV.x = (v1x - v0x) * t + v0x;
      newV.y = (v1y - v0y) * t + v0y;
      newV.z = (v1z - v0z) * t + v0z;
      newV.w = (v1w - v0w) * t + v0w;
      return newV;
    }
    function lerpColor(c0, c1, t) {
      let newColor = new Color();
      newColor.r = (1 - t) * c0.r + t * c1.r;
      newColor.g = (1 - t) * c0.g + t * c1.g;
      newColor.b = (1 - t) * c0.b + t * c1.b;
      newColor.a = (1 - t) * c0.a + t * c1.a;
      return newColor;
    }
    function lerpByte(u0, u1, scale2) {
      return u0 + ((u1 - u0) * scale2 >> 8) & 255;
    }
    let PingPong = function(t, start, end) {
      let len = end - start;
      let tt = Math.floor(t / len);
      let sd = tt % 2;
      if (sd == 0) {
        return t % len + start;
      } else {
        return end - t % len + start;
      }
    };
    let RepeatSE = function(t, start, end) {
      let len = end - start;
      return ((t - start) % len + len) % len + start;
    };
    let GetRepeat = function(datas, element) {
      let count = 0;
      for (let i in datas) {
        if (i == element) {
          count++;
        }
      }
      return count;
    };
    class RandomSeed {
      x = 0;
      y = 0;
      z = 0;
      w = 0;
      randSeedList;
      constructor() {
        this.randSeedList = [];
      }
      reset() {
        this.x = Math.random() * 1;
        this.y = Math.random() * 1;
        this.z = Math.random() * 1;
        this.w = Math.random() * 1;
        this.randSeedList.length = 0;
        for (let i = 0; i < 20; i++) {
          this.randSeedList.push(Math.random() * 1);
        }
      }
    }
    function dot(lhs, rhs) {
      if (lhs instanceof Vector3 && rhs instanceof Vector3) {
        return lhs.x * rhs.x + lhs.y * rhs.y + lhs.z * rhs.z;
      } else if (lhs instanceof Quaternion && rhs instanceof Quaternion) {
        return lhs.x * rhs.x + lhs.y * rhs.y + lhs.z * rhs.z;
      } else {
        return lhs.x * rhs.x + lhs.y * rhs.y;
      }
    }
    function scale(lhs, rhs) {
      return new Vector3(lhs.x * rhs.x, lhs.y * rhs.y, lhs.z * rhs.z);
    }
    function sqrtImpl(f) {
      return Math.sqrt(f);
    }
    function magnitude(inV) {
      return sqrtImpl(dot(inV, inV));
    }
    function normalizeSafe(inV, defaultV) {
      let mag = magnitude(inV);
      if (mag > Vector3.EPSILON) {
        if (inV instanceof Vector2) return inV.clone().divide(mag);
        if (inV instanceof Vector3) return inV.clone().divideScalar(mag);
      } else {
        if (inV instanceof Vector2) {
          return new Vector2();
        }
        if (inV instanceof Vector3) {
          return new Vector3();
        }
        if (inV instanceof Quaternion) {
          return new Quaternion();
        }
      }
    }
    function getFloatFromInt(value) {
      let v = value & 8388607;
      return v * (1 / 8388607);
    }
    function random01(value) {
      return value.getFloat();
    }
    function rangedRandomFloat(r, min, max) {
      let t = r.getFloat();
      t = min * t + (1 - t) * max;
      return t;
    }
    function rangedRandomInt(r, min, max) {
      let dif;
      if (min < max) {
        dif = max - min;
        let t = r.get() % dif;
        t += min;
        return t;
      } else if (min > max) {
        dif = min - max;
        let t = r.get() % dif;
        t = min - t;
        return t;
      } else {
        return min;
      }
    }
    function randomUnitVector(rand) {
      let z = rangedRandomFloat(rand, -1, 1);
      let a = rangedRandomFloat(rand, 0, 2 * Math.PI);
      let r = Math.sqrt(1 - z * z);
      let x = r * Math.cos(a);
      let y = r * Math.sin(a);
      return new Vector3(x, y, z);
    }
    function randomUnitVector2(rand) {
      let a = rangedRandomFloat(rand, 0, 2 * Math.PI);
      let x = Math.cos(a);
      let y = Math.sin(a);
      return new Vector2(x, y);
    }
    function randomQuaternion(rand) {
      let q = new Quaternion();
      q.x = rangedRandomFloat(rand, -1, 1);
      q.y = rangedRandomFloat(rand, -1, 1);
      q.z = rangedRandomFloat(rand, -1, 1);
      q.w = rangedRandomFloat(rand, -1, 1);
      q = normalizeSafe(q);
      if (dot(q, Quaternion.identity()) < 0) {
        return -q;
      } else {
        return q;
      }
    }
    function randomQuaternionUniformDistribution(rand) {
      const two_pi = 2 * Math.PI;
      let u1 = rangedRandomFloat(rand, 0, 1);
      let theta = rangedRandomFloat(rand, 0, two_pi);
      let rho = rangedRandomFloat(rand, 0, two_pi);
      let i = Math.sqrt(1 - u1);
      let j = Math.sqrt(u1);
      let q = new Quaternion(i * Math.sin(theta), i * Math.cos(theta), j * Math.sin(rho), j * Math.cos(rho));
      if (dot(q, Quaternion.identity()) < 0) {
        return -q;
      } else {
        return q;
      }
    }
    function randomPointInsideCube(r, extents) {
      return new Vector3(rangedRandomFloat(r, -extents.x, extents.x), rangedRandomFloat(r, -extents.y, extents.y), rangedRandomFloat(r, -extents.z, extents.z));
    }
    function randomPointInsideUnitSphere(r) {
      let v = randomUnitVector(r);
      v.multiplyScalar(Math.pow(random01(r), 1 / 3));
      return v;
    }
    function randomPointInsideEllipsoid(r, extents) {
      return scale(randomPointInsideUnitSphere(r), extents);
    }
    function randomPointBetweenSphere(r, minRadius, maxRadius) {
      let v = randomUnitVector(r);
      let range = Math.pow(rangedRandomFloat(r, 0, 1), 1 / 3);
      v.multiplyScalar(minRadius + (maxRadius - minRadius) * range);
      return v;
    }
    function randomPointInsideUnitCircle(r) {
      let v = randomUnitVector2(r);
      Vector2.multiplyScalar(v, Math.pow(rangedRandomFloat(r, 0, 1), 1 / 2), v);
      return v;
    }
    function randomPointBetweenEllipsoid(r, maxExtents, minRange) {
      let v = scale(randomUnitVector(r), maxExtents);
      let range = Math.pow(rangedRandomFloat(r, minRange, 1), 1 / 3);
      v.multiplyScalar(range);
      return v;
    }
    function randomBarycentricCoord(rand) {
      let u = rand.getFloat();
      let v = rand.getFloat();
      if (u + v > 1) {
        u = 1 - u;
        v = 1 - v;
      }
      let w = 1 - u - v;
      return new Vector3(u, v, w);
    }
    function deg2Rad(deg) {
      return deg / 360 * 2 * Math.PI;
    }
    function rad2Deg(deg) {
      return 180 * deg / Math.PI;
    }
    function sin(v) {
      return Math.sin(v);
    }
    function cos(v) {
      return Math.cos(v);
    }
    exports.randomSeed = 4919;
    function getGlobalRandomSeed() {
      return ++exports.randomSeed;
    }
    function swap(values, i1, i2) {
      let v1 = values[i1];
      let v2 = values[i2];
      values[i1] = v2;
      values[i2] = v1;
    }
    function floorfToIntPos(f) {
      return Math.floor(f);
    }
    function roundfToIntPos(f) {
      return floorfToIntPos(f + 0.5);
    }
    function normalizedToWord(f) {
      f = Math.max(f, 0);
      f = Math.min(f, 1);
      return roundfToIntPos(f * 65535);
    }
    function normalizedToByte(f) {
      f = Math.max(f, 0);
      f = Math.min(f, 1);
      return roundfToIntPos(f * 255);
    }
    function fastInvSqrt(f) {
      if (Math.abs(f) == 0) {
        return f;
      }
      return 1 / Math.sqrt(f);
    }
    function normalizeFast(inV) {
      let m = sqrMagnitude(inV);
      return inV.multiplyScalar(fastInvSqrt(m));
    }
    function crossProduct(lhs, rhs) {
      return lhs.clone().cross(rhs);
    }
    function sqrMagnitude(inV) {
      return dot(inV, inV);
    }
    function generateRandom(randomIn) {
      let rand = new Rand(randomIn);
      return random01(rand);
    }
    function generateRandom3(randomOut, randomIn) {
      let rand = new Rand(randomIn);
      randomOut.x = random01(rand);
      randomOut.y = random01(rand);
      randomOut.z = random01(rand);
    }
    function clampRepeat(t, t0, t1) {
      if (t < t0) {
        return t1;
      } else if (t > t1) {
        return t0;
      } else {
        return t;
      }
    }
    function repeat(t, length) {
      return t - Math.floor(t / length) * length;
    }

    class Ray {
      /**
       * Ray starting point
       */
      origin = new Vector3();
      /**
       * length
       */
      length = Number.MAX_VALUE;
      static _rayl = 1e9;
      static _smallnum = 1e-8;
      _vector = new Vector3();
      _dir = new Vector3();
      /**
       * Build a new ray object
       * @param origin Ray starting point
       * @param dir Ray direction
       */
      constructor(origin, dir) {
        this.origin.copy(origin || new Vector3());
        this._dir.copy(dir || new Vector3());
        this._dir.normalize();
      }
      /**
       * Ray direction
       */
      get direction() {
        return this._dir;
      }
      /**
       * Set the ray direction (normalized internally)
       */
      set direction(dir) {
        this._dir.copy(dir);
        this._dir.normalize();
      }
      /**
       * Clone a new Ray object
       * @returns 
       */
      clone() {
        return new Ray(this.origin, this.direction);
      }
      /**
       * Determine whether it intersects a bounding box
       * @param box bounding box
       * @returns whether intersect
       */
      // public intersectsBox(box: IBound): boolean {
      //     return this.intersectBox(box, this._vector) !== null;
      // }
      /**
       * Compute the intersection point of this ray with a bounding box
       * @param box bounding box
       * @param target optional output point
       * @returns the intersection point, or null if there is none
       */
      intersectBox(box, target) {
        let direction = this.direction;
        let origin = this.origin;
        let tMin;
        let tMax;
        let tYMin;
        let tYMax;
        let tZMin;
        let tZMax;
        const invDirX = 1 / direction.x;
        const invDirY = 1 / direction.y;
        const invDirZ = 1 / direction.z;
        const min = box.min;
        const max = box.max;
        tMin = ((invDirX >= 0 ? min.x : max.x) - origin.x) * invDirX;
        tMax = ((invDirX >= 0 ? max.x : min.x) - origin.x) * invDirX;
        tYMin = ((invDirY >= 0 ? min.y : max.y) - origin.y) * invDirY;
        tYMax = ((invDirY >= 0 ? max.y : min.y) - origin.y) * invDirY;
        if (tMin > tYMax || tYMin > tMax) {
          return null;
        }
        if (tYMin > tMin) {
          tMin = tYMin;
        }
        if (tYMax < tMax) {
          tMax = tYMax;
        }
        tZMin = ((invDirZ >= 0 ? min.z : max.z) - origin.z) * invDirZ;
        tZMax = ((invDirZ >= 0 ? max.z : min.z) - origin.z) * invDirZ;
        if (tMin > tZMax || tZMin > tMax) {
          return null;
        }
        if (tZMin > tMin) {
          tMin = tZMin;
        }
        if (tZMax < tMax) {
          tMax = tZMax;
        }
        if (tMax < 0) {
          return null;
        }
        target ||= new Vector3();
        return this.pointAt(tMin >= 0 ? tMin : tMax, target);
      }
      /**
       * Calculate a point on the ray
       * @param t Length scalar
       * @param target output target
       * @returns result
       */
      pointAt(t, target) {
        target ||= new Vector3();
        target.copy(this.direction);
        target.multiplyScalar(t);
        Vector3.add(target, this.origin, target);
        return target;
      }
      /**
       * Sets the ray to be a copy of the original ray
       * @param src Ray object source
       * @returns New ray object
       */
      copy(src) {
        this.origin.copy(src.origin);
        this.direction.copy(src.direction);
        this._dir.copy(src._dir);
        this.length = src.length;
        return this;
      }
      /**
       * Fast to the approximate ray direction
       * @param dir direction
       */
      setApproxDirection(dir) {
        this._dir = dir.normalize();
      }
      /**
       * Set ray origin
       * @param origin ray origin
       */
      setOrigin(origin) {
        this.origin.copy(origin);
      }
      /**
       * Get ray origin
       */
      getOrigin() {
        return this.origin;
      }
      /**
       * Gets the point at the specified position on the ray
       * @param t Length position
       * @returns Returns a point at the specified location
       */
      getPoint(t) {
        this._dir.multiplyScalar(t);
        return this.origin.add(this._dir);
      }
      /**
       * Calculate the distance from a point
       * @param P Specify Point
       * @returns result
       */
      sqrDistToPoint(P) {
        let v = this._dir;
        let w = P.clone().sub(this.origin);
        let c1 = dot(w, v);
        let c2 = dot(v, v);
        let b = c1 / c2;
        let Pb = this.getPoint(b);
        return sqrMagnitude(P.clone().sub(Pb));
      }
      /**
       * Applied matrix transformation
       * @param mat4 matrix
       */
      applyMatrix(mat4) {
        this.origin = mat4.transformPoint(this.origin);
        this._dir = mat4.transformVector(this._dir);
      }
      _v0 = new Vector3();
      _v1 = new Vector3();
      _v2 = new Vector3();
      /**
       * Calculates whether a specified point is inside a triangle
       * @param P point
       * @param A Triangle vertex 1
       * @param B Triangle vertex 2
       * @param C Triangle vertex 3
       * @returns whether it is inside a triangle
       */
      pointInTriangle(P, A, B, C) {
        let v0 = this._v0;
        let v1 = this._v1;
        let v2 = this._v2;
        Vector3.sub(C, A, v0);
        Vector3.sub(B, A, v1);
        Vector3.sub(P, A, v2);
        let dot00 = Vector3.dot(v0, v0);
        let dot01 = Vector3.dot(v0, v1);
        let dot02 = Vector3.dot(v0, v2);
        let dot11 = Vector3.dot(v1, v1);
        let dot12 = Vector3.dot(v1, v2);
        let invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
        let u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        let v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        return u >= 0 && v >= 0 && u + v < 1;
      }
      // Determine whether a ray intersect with a triangle
      // Parameters
      // orig: origin of the ray
      // dir: direction of the ray
      // v0, v1, v2: vertices of triangle
      // t(out): weight of the intersection for the ray
      // u(out), v(out): barycentric coordinate of intersection
      _E1 = new Vector3();
      _E2 = new Vector3();
      _P = new Vector3();
      _T = new Vector3();
      _Q = new Vector3();
      /**
       * Determine whether a ray intersects a triangle
       * @param orig Ray starting point
       * @param dir Ray direction
       * @param face triangle
       * @returns point of intersection
       */
      intersectTriangle(orig, dir, face) {
        let v0 = face.v1;
        let v1 = face.v2;
        let v2 = face.v3;
        Vector3.sub(v1, v0, this._E1);
        Vector3.sub(v2, v0, this._E2);
        Vector3.cross(dir, this._E2, this._P);
        let det = this._E1.dotProduct(this._P);
        if (det > 0) {
          Vector3.sub(orig, v0, this._T);
        } else {
          Vector3.sub(v0, orig, this._T);
          det = -det;
        }
        if (det < 1e-4) return null;
        face.u = this._T.dotProduct(this._P);
        if (face.u < 0 || face.u > det) return null;
        Vector3.cross(this._T, this._E1, this._Q);
        face.v = dir.dotProduct(this._Q);
        if (face.v < 0 || face.u + face.v > det) return null;
        let hit = new Vector3();
        face.t0 = face.t = this._E2.dotProduct(this._Q);
        let fInvDet = 1 / det;
        face.t *= fInvDet;
        face.u *= fInvDet;
        face.v *= fInvDet;
        hit.x = orig.x + face.t * dir.x;
        hit.y = orig.y + face.t * dir.y;
        hit.z = orig.z + face.t * dir.z;
        return hit;
      }
      /**
       * Determine whether a ray intersects the sphere
       * @param o Ray starting point
       * @param dir Ray direction
       * @param center Sphere center
       * @param radius radius of sphericity
       * @returns point of intersection
       */
      intersectSphere(o, dir, center, radius) {
        let oc = o.clone().sub(center);
        let a = Vector3.dot(dir, dir);
        let b = 2 * Vector3.dot(oc, dir);
        let c = Vector3.dot(oc, oc) - radius * radius;
        let dt = b * b - 4 * a * c;
        let hit = Vector3.HELP_3;
        if (dt < 0) {
          return null;
        } else {
          let t0 = (-b - Math.sqrt(dt)) / (a * 2);
          if (t0 < 0) {
            return null;
          }
          hit.x = o.x + t0 * dir.x;
          hit.y = o.y + t0 * dir.y;
          hit.z = o.z + t0 * dir.z;
          return hit;
        }
      }
      /**
       * A test of the intersection between a ray and 
       * a given line segment within a given tolerance (threshold)
       * @param sega The first point of a line segment used to test the intersection
       * @param segb The second point of a line segment used to test the intersection
       * @param threshold Margin, if the ray does not intersect the line segment but is close to the given threshold, the intersection is successful
       * @return If there is an intersection, then the distance from the ray origin to the intersection, if there is no intersection, is -1
       */
      intersectionSegment(sega, segb, threshold) {
        const o = this.origin;
        const u = Vector3.HELP_0;
        const rsegb = Vector3.HELP_1;
        const v = Vector3.HELP_2;
        const w = Vector3.HELP_3;
        Vector3.sub(segb, sega, u);
        Vector3.multiplyScalar(this._dir, Ray._rayl, v);
        Vector3.add(o, v, rsegb);
        Vector3.sub(sega, o, w);
        var a = Vector3.dot(u, u);
        var b = Vector3.dot(u, v);
        var c = Vector3.dot(v, v);
        var d = Vector3.dot(u, w);
        var e = Vector3.dot(v, w);
        var det = a * c - b * b;
        var sc, sN, sD = det;
        var tc, tN, tD = det;
        if (det < Ray._smallnum) {
          sN = 0;
          sD = 1;
          tN = e;
          tD = c;
        } else {
          sN = b * e - c * d;
          tN = a * e - b * d;
          if (sN < 0) {
            sN = 0;
            tN = e;
            tD = c;
          } else if (sN > sD) {
            sN = sD;
            tN = e + b;
            tD = c;
          }
        }
        if (tN < 0) {
          tN = 0;
          if (-d < 0) {
            sN = 0;
          } else if (-d > a) {
            sN = sD;
          } else {
            sN = -d;
            sD = a;
          }
        } else if (tN > tD) {
          tN = tD;
          if (-d + b < 0) {
            sN = 0;
          } else if (-d + b > a) {
            sN = sD;
          } else {
            sN = -d + b;
            sD = a;
          }
        }
        sc = Math.abs(sN) < Ray._smallnum ? 0 : sN / sD;
        tc = Math.abs(tN) < Ray._smallnum ? 0 : tN / tD;
        const qtc = Vector3.HELP_4;
        Vector3.multiplyScalar(v, tc, qtc);
        const qsc = Vector3.HELP_5;
        Vector3.multiplyScalar(u, sc, qsc);
        Vector3.add(qsc, w, qsc);
        const dP = Vector3.HELP_6;
        Vector3.sub(qsc, qtc, dP);
        var isIntersected = tc > 0 && tc <= this._dir.length && dP.lengthSquared < threshold * threshold;
        if (isIntersected) {
          let dd0 = new Vector3();
          Vector3.sub(segb, sega, dd0);
          dd0.multiplyScalar(sc);
          Vector3.add(dd0, sega, dd0);
          return { out: dd0, length: qsc.length };
        }
        return { out: null, length: -1 };
      }
      get_vec(p, q) {
        let rc = Vector3.HELP_1;
        rc.x = p.x - q.x;
        rc.y = p.y - q.y;
        rc.z = p.z - q.z;
        return rc;
      }
    }

    class Rect {
      /**
       * The x-coordinate of the rectangle
       */
      x;
      /**
       * The y-coordinate of the rectangle
       */
      y;
      /**
       * Width of a rectangle
       */
      w;
      /**
       * Height of rectangle
       */
      h;
      /**
       * Creates a new rectangular area object
       * @param x The x-coordinate of the rectangle
       * @param y The y coordinate of the rectangle
       * @param width Width of a rectangle
       * @param height Height of rectangle
       */
      constructor(x = 0, y = 0, width = 0, height = 0) {
        this.x = x;
        this.y = y;
        this.w = width;
        this.h = height;
      }
      /**
       * Width of a rectangle
       */
      get width() {
        return this.w;
      }
      /**
       * Set the width of the rectangle
       */
      set width(v) {
        this.w = v;
      }
      /**
       * Height of rectangle
       */
      get height() {
        return this.h;
      }
      /**
       * Set the height of the rectangle
       */
      set height(v) {
        this.h = v;
      }
      /**
       * Whether the point is within the specified area
       * @param x x value of point
       * @param y y value of point
       * @param lt_x The x value in the upper left corner
       * @param lt_y The y value in the upper left corner
       * @param rb_x The x value in the lower right corner
       * @param rb_y The y value in the lower right corner
       * @returns 
       */
      static pointInRect(x, y, lt_x, lt_y, rb_x, rb_y) {
        if (x < lt_x || x > rb_x || y < lt_y || y > rb_y) {
          return false;
        }
        return true;
      }
      /**
       * Returns a new rectangular area object with the same properties as the current rectangular area
       * @returns 
       */
      clone() {
        return new Rect(this.x, this.y, this.w, this.h);
      }
      /**
       * Copy the properties of the source object to this object
       * @param v source object
       * @returns 
       */
      copy(rect) {
        this.x = rect.x;
        this.y = rect.y;
        this.w = rect.w;
        this.h = rect.h;
      }
      /**
       * Copy the properties of this object to the target object
       * @param v target object
       * @returns 
       */
      copyTo(rect) {
        rect.copy(this);
      }
      /**
       * Whether the point is in this area
       * @param x x value of point
       * @param y y value of point
       * @returns 
       */
      inner(x, y) {
        if (x < this.x || x > this.x + this.width || y < this.y || y > this.y + this.height) {
          return false;
        }
        return true;
      }
      /**
       * Whether the current rectangle is equal to the target rectangle
       * @param rectangle Target rectangle
       * @returns 
       */
      equal(rectangle) {
        return !(this.x != rectangle.x || this.y != rectangle.y || this.width != rectangle.width || this.height != rectangle.height);
      }
      /**
       * Whether the current rectangle is equal to the target rectangle
       * @param x The x value of the rectangle
       * @param y The y value of the rectangle
       * @param width Rectangle width
       * @param height Rectangular height
       * @returns 
       */
      equalArea(x, y, width, height) {
        return !(this.x != x || this.y != y || this.width != width || this.height != height);
      }
      /**
       * Whether this rectangle overlaps with the target object
       * @param source Source object
       * @returns 
       */
      equalInnerArea(source) {
        var aMinX = this.x;
        var aMinY = this.y;
        var aMaxX = this.x + this.width;
        var aMaxY = this.y + this.height;
        var bMinX = source.x;
        var bMinY = source.y;
        var bMaxX = source.x + source.width;
        var bMaxY = source.y + source.height;
        if (Math.max(aMinX, bMinX) <= Math.min(aMaxX, bMaxX) && Math.max(aMinY, bMinY) <= Math.min(aMaxY, bMaxY)) {
          return true;
        }
        return false;
      }
      /**
       * Returns the overlap of two rectangles
       * @param source source object
       * @param target target object
       * @returns 
       */
      innerArea(source, target) {
        target = target || new Rect();
        var Xa1 = this.x;
        var Ya1 = this.y;
        var Xa2 = this.x + this.width;
        var Ya2 = this.y + this.height;
        var Xb1 = source.x;
        var Yb1 = source.y;
        var Xb2 = source.x + source.width;
        var Yb2 = source.y + source.height;
        var top = Math.max(Ya1, Yb1);
        var bottom = Math.min(Ya2, Yb2);
        var left = Math.max(Xa1, Xb1);
        var right = Math.min(Xb2, Xa2);
        if (top >= 0 && bottom >= 0 && bottom - top >= 0 && right - left > 0) {
          target.x = left;
          target.y = top;
          target.width = right - left;
          target.height = bottom - top;
        } else {
          target.x = 0;
          target.y = 0;
          target.width = 0;
          target.height = 0;
        }
        return target;
      }
      /**
       * Sets the properties of the rectangle
       * @param x x value
       * @param y y value
       * @param width Rectangle width
       * @param height Rectangular height
       */
      setTo(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
      }
    }

    class Transform extends ComponentBase {
      /**
      * @internal
      */
      static LIMIT = 1;
      /**
      * @internal
      */
      static COMPONENT_NAME = "UUTransform";
      /**
      * @internal
      */
      static COMPONENT_TYPE = "Transform";
      /**
      * @internal
      */
      static POSITION_ONCHANGE = "POSITION_ONCHANGE";
      /**
      * @internal
      */
      static ROTATION_ONCHANGE = "ROTATION_ONCHANGE";
      /**
      * @internal
      */
      static SCALE_ONCHANGE = "SCALE_ONCHANGE";
      /**
      * @internal
      */
      static PARENT_ONCHANGE = "PARENT_ONCHANGE";
      /**
      * @internal
      */
      static CHILDREN_ONCHANGE = "CHILDREN_ONCHANGE";
      /**
      * @internal
      */
      static ADD_ONCHANGE = "ADD_ONCHANGE";
      /**
       * @internal
       */
      static LOCAL_ONCHANGE = "LOCAL_ONCHANGE";
      /**
      * @internal
      */
      eventPositionChange = new CEvent(Transform.POSITION_ONCHANGE);
      /**
      * @internal
      */
      eventRotationChange = new CEvent(Transform.ROTATION_ONCHANGE);
      /**
      * @internal
      */
      eventScaleChange = new CEvent(Transform.SCALE_ONCHANGE);
      /**
      * @internal
      */
      eventLocalChange = new CEvent(Transform.LOCAL_ONCHANGE);
      /**
      * @internal
      */
      onPositionChange;
      /**
      * @internal
      */
      onRotationChange;
      /**
      * @internal
      */
      onScaleChange;
      _scene3d;
      _parent;
      _localPos;
      _localRot;
      _localRotQuat;
      _localScale;
      _localDetailPos;
      _localDetailRot;
      _localDetailScale;
      index;
      index2;
      // public localMatrix: Matrix4;
      // private _localChange: boolean = true;
      _forward = new Vector3();
      _back = new Vector3();
      _right = new Vector3();
      _left = new Vector3();
      _up = new Vector3();
      _down = new Vector3();
      _worldMatrix;
      _targetPos;
      static = false;
      depthOrder = 0;
      /** Whether the local transform is dirty and the world matrix needs recomputing. */
      get localChange() {
        return WasmMatrix.matrixStateBuffer[this.index2] != 0;
      }
      set localChange(value) {
        WasmMatrix.matrixStateBuffer[this.index2] = value ? 1 : 0;
      }
      /** Optional look-at target position used by orientation helpers. */
      get targetPos() {
        return this._targetPos;
      }
      set targetPos(value) {
        this._targetPos = value;
      }
      /** Parent transform in the hierarchy, or null for a root. */
      get parent() {
        return this._parent;
      }
      set parent(value) {
        let lastParent = this._parent?.object3D;
        this._parent = value;
        this.depthOrder = value ? value.depthOrder + 1 : 0;
        WasmMatrix.setParent(this.index, value ? value.worldMatrix.index : -1, this.depthOrder);
        this.localChange = true;
        if (this.object3D) {
          let hasRoot = value ? value.scene3D : null;
          if (!hasRoot) {
            this.object3D.components.forEach((c) => {
              c[`__stop`]();
            });
          } else {
            this._scene3d = hasRoot;
            this.object3D.components.forEach((c) => {
              ComponentCollect.appendWaitStart(c);
            });
          }
          for (let child of this.object3D.entityChildren) {
            child.transform.parent = value ? this : null;
          }
          this.object3D.components.forEach((c) => {
            c.onParentChange?.(lastParent, this._parent?.object3D);
          });
        }
        this.notifyLocalChange();
      }
      /** Enable state; propagates to all child transforms. */
      set enable(value) {
        if (this.transform._scene3d && value) {
          super.enable = true;
        } else {
          super.enable = false;
        }
        for (let child of this.object3D.entityChildren) {
          child.transform.enable = value;
        }
      }
      get enable() {
        return this._enable;
      }
      /** The scene this transform belongs to. */
      get scene3D() {
        return this._scene3d;
      }
      set scene3D(value) {
        this._scene3d = value;
      }
      /** The view associated with this transform's scene, or null. */
      get view3D() {
        if (this._scene3d && this._scene3d.view) {
          return this._scene3d.view;
        }
        return null;
      }
      constructor() {
        super();
        this._worldMatrix = new Matrix4(true);
        this.index = this._worldMatrix.index;
        this.index2 = this._worldMatrix.index * WasmMatrix.stateStruct;
        this._localPos = new Vector3();
        this._localRot = new Vector3();
        this._localRotQuat = new Quaternion();
        this._localScale = new Vector3(1, 1, 1);
        WasmMatrix.setScale(this.index, this._localScale.x, this._localScale.y, this._localScale.z);
        WasmMatrix.setRotation(this.index, this._localRotQuat.x, this._localRotQuat.y, this._localRotQuat.z, this._localRotQuat.w);
        WasmMatrix.setTranslate(this.index, this._localPos.x, this._localPos.y, this._localPos.z);
      }
      /** Lifecycle hook called once when the transform is created. */
      awake() {
      }
      /** Lifecycle hook called when the transform starts. */
      start() {
      }
      /** Lifecycle hook called when the transform stops. */
      stop() {
      }
      /**
      * @internal
      */
      notifyLocalChange() {
        this.localChange = true;
        if (this.object3D) {
          let entityChildren = this.object3D.entityChildren;
          let i = 0, len = entityChildren.length;
          for (i = 0; i < len; i++) {
            const transform = entityChildren[i].transform;
            transform.notifyLocalChange();
          }
        }
        this.eventDispatcher.dispatchEvent(this.eventLocalChange);
      }
      /**
       * @internal
       * Push a rotation (given as both its Euler and quaternion form) into the
       * transform's local state and to the WASM matrix solver, which stores
       * rotation as a quaternion to avoid Euler gimbal lock. Does not invoke
       * `onRotationChange` or dispatch `eventRotationChange` — callers differ
       * in when/how they do that.
       */
      _applyLocalRotation(euler, quat) {
        this._localRot.copy(euler);
        this._localRotQuat.copy(quat);
        WasmMatrix.setRotation(this.index, quat.x, quat.y, quat.z, quat.w);
        this.notifyLocalChange();
      }
      /** World-space up direction; setting it rotates the object to face that up. */
      get up() {
        Matrix4.transformVector(this.worldMatrix, Vector3.UP, this._up);
        return this._up;
      }
      set up(value) {
        this._up.copy(value);
        MathUtil.fromToRotation(Vector3.UP, this._up, Quaternion.HELP_0);
        this.transform.localRotQuat = Quaternion.HELP_0;
      }
      /** World-space down direction; setting it reorients the object. */
      get down() {
        Matrix4.transformVector(this.worldMatrix, Vector3.DOWN, this._down);
        return this._down;
      }
      set down(value) {
        this._down.copy(value);
        MathUtil.fromToRotation(Vector3.DOWN, this._down, Quaternion.HELP_0);
        this.transform.localRotQuat = Quaternion.HELP_0;
        this.notifyLocalChange();
        this.onRotationChange?.();
        if (this.eventRotationChange) {
          this.eventDispatcher.dispatchEvent(this.eventRotationChange);
        }
      }
      /** World-space forward direction; setting it reorients the object. */
      get forward() {
        Matrix4.transformVector(this.worldMatrix, Vector3.FORWARD, this._forward);
        return this._forward;
      }
      set forward(value) {
        this._forward.copy(value);
        MathUtil.fromToRotation(Vector3.FORWARD, this._forward, Quaternion.HELP_0);
        this.transform.localRotQuat = Quaternion.HELP_0;
        this.notifyLocalChange();
        this.onRotationChange?.();
        if (this.eventRotationChange) {
          this.eventDispatcher.dispatchEvent(this.eventRotationChange);
        }
      }
      /** World-space back direction; setting it reorients the object. */
      get back() {
        Matrix4.transformVector(this.worldMatrix, Vector3.BACK, this._back);
        return this._back;
      }
      set back(value) {
        this._back.copy(value);
        MathUtil.fromToRotation(Vector3.BACK, this._back, Quaternion.HELP_0);
        this.transform.localRotQuat = Quaternion.HELP_0;
      }
      /** World-space left direction; setting it reorients the object. */
      get left() {
        Matrix4.transformVector(this.worldMatrix, Vector3.neg_X_AXIS, this._left);
        return this._left;
      }
      set left(value) {
        this._left.copy(value);
        MathUtil.fromToRotation(Vector3.LEFT, this._left, Quaternion.HELP_0);
        this.transform.localRotQuat = Quaternion.HELP_0;
      }
      /** World-space right direction; setting it reorients the object. */
      get right() {
        Matrix4.transformVector(this.worldMatrix, Vector3.X_AXIS, this._right);
        return this._right;
      }
      set right(value) {
        this._right.copy(value);
        MathUtil.fromToRotation(Vector3.RIGHT, this._right, Quaternion.HELP_0);
        this.transform.localRotQuat = Quaternion.HELP_0;
        this.notifyLocalChange();
        this.onRotationChange?.();
        if (this.eventRotationChange) {
          this.eventDispatcher.dispatchEvent(this.eventRotationChange);
        }
      }
      /**
       *
       * The transformation property of the object relative to the parent, stored in the from of a quaternion
       */
      get localRotQuat() {
        if (this.localChange) {
          this.updateWorldMatrix();
        }
        return this._localRotQuat;
      }
      set localRotQuat(value) {
        if (value.x != this._localRotQuat.x || value.y != this._localRotQuat.y || value.z != this._localRotQuat.z || value.w != this._localRotQuat.w) {
          value.getEulerAngles(Vector3.HELP_0);
          this._applyLocalRotation(Vector3.HELP_0, value);
          this.onRotationChange?.();
          if (this.eventRotationChange) {
            this.eventDispatcher.dispatchEvent(this.eventRotationChange);
          }
        }
      }
      /**
       * @private
       */
      notifyChange() {
        this.notifyLocalChange();
        this.onRotationChange?.();
        this.onScaleChange?.();
        this.onPositionChange?.();
        if (this.eventRotationChange) {
          this.eventDispatcher.dispatchEvent(this.eventRotationChange);
        }
        if (this.eventPositionChange) {
          this.eventDispatcher.dispatchEvent(this.eventPositionChange);
        }
        if (this.eventScaleChange) {
          this.eventDispatcher.dispatchEvent(this.eventScaleChange);
        }
      }
      /**
      * @internal
      */
      get worldMatrix() {
        this.updateWorldMatrix();
        return this._worldMatrix;
      }
      /**
       *
       * Update the matrix4 in world space
       */
      updateWorldMatrix(force = false) {
        if (this.localChange || force) {
          this._worldMatrix.compose(this._localPos, this._localRotQuat, this._localScale);
          if (this.parent) {
            append(this._worldMatrix, this.parent.worldMatrix, this._worldMatrix);
          }
          this.localChange = false;
        }
      }
      /** Recursively update this transform and all descendants' world matrices. */
      updateChildTransform() {
        let self = this;
        if (self.localChange) {
          self.updateWorldMatrix();
        }
        if (self.object3D.numChildren > 0) {
          for (const child of self.object3D.entityChildren) {
            child.transform.updateChildTransform();
          }
        }
      }
      /**
       * Rotate the object to look at a world-space target from its current position.
       * @param target world-space point to look at
       * @param up up direction
       */
      lookTarget(target, up = Vector3.UP) {
        this.lookAt(this.transform.worldPosition, target, up);
      }
      /**
       * Current object's gaze position (global) (modified by its own global transformation)
       * @param pos Own position (global)
       * @param target Location of the target (global)
       * @param up up direction
       */
      lookAt(pos, target, up = Vector3.UP) {
        this._targetPos ||= new Vector3();
        this._targetPos.copy(target);
        this.localPosition = pos;
        Matrix4.helpMatrix.lookAt(pos, target, up);
        Matrix4.helpMatrix.invert();
        var prs = Matrix4.helpMatrix.decompose(Orientation3D.QUATERNION);
        this.localRotQuat = Quaternion.CALCULATION_QUATERNION.copy(prs[1]);
      }
      /**
       * Set this transform's local position/rotation/scale by decomposing a matrix.
       * @param matrix the matrix to decompose
       * @param orientationStyle decomposition style (defaults to euler angles)
       */
      decomposeFromMatrix(matrix, orientationStyle = "eulerAngles") {
        let prs = matrix.decompose(orientationStyle);
        let transform = this.transform;
        transform.localRotQuat.copy(prs[1]);
        transform.localRotQuat = transform.localRotQuat;
        transform.localPosition.copy(prs[0]);
        transform.localPosition = transform.localPosition;
        transform.localScale.copy(prs[2]);
        transform.localScale = transform.localScale;
        return this;
      }
      /**
      *
      * Create a new component, copy the properties of the current component, and add it to the target object.
      * @param obj source Object3D
      */
      cloneTo(obj) {
        obj.transform.localPosition = this.localPosition;
        obj.transform.localRotation = this.localRotation;
        obj.transform.localScale = this.localScale;
      }
      set x(value) {
        if (this._localPos.x != value) {
          this._localPos.x = value;
          WasmMatrix.setTranslate(this.index, this._localPos.x, this._localPos.y, this._localPos.z);
          this.notifyLocalChange();
          this.onPositionChange?.();
          if (this.eventPositionChange) {
            this.eventDispatcher.dispatchEvent(this.eventPositionChange);
          }
        }
      }
      /**
       *
       * The position of the object relative to its parent X-axis
       */
      get x() {
        return this._localPos.x;
      }
      set y(value) {
        if (this._localPos.y != value) {
          this._localPos.y = value;
          WasmMatrix.setTranslate(this.index, this._localPos.x, this._localPos.y, this._localPos.z);
          this.notifyLocalChange();
          this.onPositionChange?.();
          if (this.eventPositionChange) {
            this.eventDispatcher.dispatchEvent(this.eventPositionChange);
          }
        }
      }
      /**
       *
       * The position of the object relative to its parent Y-axis
       */
      get y() {
        return this._localPos.y;
      }
      set z(value) {
        if (this._localPos.z != value) {
          this._localPos.z = value;
          WasmMatrix.setTranslate(this.index, this._localPos.x, this._localPos.y, this._localPos.z);
          this.notifyLocalChange();
          this.onPositionChange?.();
          if (this.eventPositionChange) {
            this.eventDispatcher.dispatchEvent(this.eventPositionChange);
          }
        }
      }
      /**
       *
       * The position of the object relative to its parent Y-axis
       */
      get z() {
        return this._localPos.z;
      }
      set scaleX(value) {
        if (this._localScale.x != value) {
          this._localScale.x = value;
          WasmMatrix.setScale(this.index, this._localScale.x, this._localScale.y, this._localScale.z);
          this.notifyLocalChange();
          this.onScaleChange?.();
          if (this.eventScaleChange) {
            this.eventDispatcher.dispatchEvent(this.eventScaleChange);
          }
        }
      }
      /**
       *
       * The scale of the object relative to its parent X-axis
       */
      get scaleX() {
        return this._localScale.x;
      }
      set scaleY(value) {
        if (this._localScale.y != value) {
          this._localScale.y = value;
          WasmMatrix.setScale(this.index, this._localScale.x, this._localScale.y, this._localScale.z);
          this.notifyLocalChange();
          this.onScaleChange?.();
          if (this.eventScaleChange) {
            this.eventDispatcher.dispatchEvent(this.eventScaleChange);
          }
        }
      }
      /**
       *
       * The scale of the object relative to its parent Y-axis
       */
      get scaleY() {
        return this._localScale.y;
      }
      set scaleZ(value) {
        if (this._localScale.z != value) {
          this._localScale.z = value;
          WasmMatrix.setScale(this.index, this._localScale.x, this._localScale.y, this._localScale.z);
          this.notifyLocalChange();
          this.onScaleChange?.();
          if (this.eventScaleChange) {
            this.eventDispatcher.dispatchEvent(this.eventScaleChange);
          }
        }
      }
      /**
       *
       * The scale of the object relative to its parent Z-axis
       */
      get scaleZ() {
        return this._localScale.z;
      }
      set rotationX(value) {
        if (this._localRot.x != value) {
          this._localRot.x = value;
          Quaternion.HELP_1.setFromEuler(this._localRot.x, this._localRot.y, this._localRot.z);
          this._applyLocalRotation(this._localRot, Quaternion.HELP_1);
          this.onRotationChange?.();
          if (this.eventRotationChange) {
            this.eventDispatcher.dispatchEvent(this.eventRotationChange);
          }
        }
      }
      /**
       *
       * The rotation of the object relative to its parent X-axis
       */
      get rotationX() {
        return this._localRot.x;
      }
      set rotationY(value) {
        if (this._localRot.y != value) {
          this._localRot.y = value;
          Quaternion.HELP_1.setFromEuler(this._localRot.x, this._localRot.y, this._localRot.z);
          this._applyLocalRotation(this._localRot, Quaternion.HELP_1);
          this.onRotationChange?.();
          if (this.eventRotationChange) {
            this.eventDispatcher.dispatchEvent(this.eventRotationChange);
          }
        }
      }
      /**
       *
       * The rotation of the object relative to its parent Y-axis
       */
      get rotationY() {
        return this._localRot.y;
      }
      set rotationZ(value) {
        if (this._localRot.z != value) {
          this._localRot.z = value;
          Quaternion.HELP_1.setFromEuler(this._localRot.x, this._localRot.y, this._localRot.z);
          this._applyLocalRotation(this._localRot, Quaternion.HELP_1);
          this.onRotationChange?.();
          if (this.eventRotationChange) {
            this.eventDispatcher.dispatchEvent(this.eventRotationChange);
          }
        }
      }
      /**
       *
       * The rotation of the object relative to its parent Z-axis
       */
      get rotationZ() {
        return this._localRot.z;
      }
      /**
       *
       * world position
       */
      get worldPosition() {
        if (this.localChange) {
          this.updateWorldMatrix();
        }
        return this._worldMatrix.position;
      }
      set localPosition(v) {
        if (this.onPositionChange) {
          if (this._localPos.x != v.x || this._localPos.y != v.y || this._localPos.z != v.z) {
            this.onPositionChange(this._localPos, v);
          }
        }
        this._localPos.copy(v);
        WasmMatrix.setTranslate(this.index, v.x, v.y, v.z);
        this.notifyLocalChange();
        if (this.eventPositionChange) {
          this.eventDispatcher.dispatchEvent(this.eventPositionChange);
        }
      }
      /**
       *
       * The position of an object relative to its parent
       */
      get localPosition() {
        return this._localPos;
      }
      set localRotation(v) {
        if (this.onRotationChange) {
          if (this._localRot.x != v.x || this._localRot.y != v.y || this._localRot.z != v.z) {
            this.onRotationChange(this._localRot, v);
          }
        }
        Quaternion.HELP_1.setFromEuler(v.x, v.y, v.z);
        this._applyLocalRotation(v, Quaternion.HELP_1);
        if (this.eventRotationChange) {
          this.eventDispatcher.dispatchEvent(this.eventRotationChange);
        }
      }
      /**
       *
       * The rotaion vector of an object relative to its parent
       */
      get localRotation() {
        return this._localRot;
      }
      set localScale(v) {
        WasmMatrix.setScale(this.index, v.x, v.y, v.z);
        this._localScale.copy(v);
        this.notifyLocalChange();
        this.onScaleChange?.();
        if (this.eventScaleChange) {
          this.eventDispatcher.dispatchEvent(this.eventScaleChange);
        }
      }
      /**
       *
       * The scale of an object relative to its parent
       */
      get localScale() {
        return this._localScale;
      }
      /** Per-frame continuous scale delta auto-applied by the matrix solver. */
      get localDetailScale() {
        return this._localDetailScale;
      }
      set localDetailScale(value) {
        this._localDetailScale = value;
        WasmMatrix.setContinueScale(this.index, value.x, value.y, value.z);
      }
      /** Per-frame continuous rotation delta auto-applied by the matrix solver. */
      get localDetailRot() {
        return this._localDetailRot;
      }
      set localDetailRot(value) {
        this._localDetailRot = value;
        WasmMatrix.setContinueRotation(this.index, value.x, value.y, value.z);
      }
      /** Per-frame continuous translation delta auto-applied by the matrix solver. */
      get localDetailPos() {
        return this._localDetailPos;
      }
      set localDetailPos(value) {
        this._localDetailPos = value;
        WasmMatrix.setContinueTranslate(this.index, value.x, value.y, value.z);
      }
      /** Detach from the parent before the component is destroyed. */
      beforeDestroy(force) {
        if (this.parent && this.parent.object3D) {
          this.parent.object3D.removeChild(this.object3D);
        }
        super.beforeDestroy(force);
      }
      /** Destroy the transform and free its matrix-table slot. */
      destroy() {
        super.destroy();
        if (this._worldMatrix) Matrix4.freeIndex(this._worldMatrix);
        this.scene3D = null;
        this.eventPositionChange = null;
        this.eventRotationChange = null;
        this.eventScaleChange = null;
        this.onPositionChange = null;
        this.onRotationChange = null;
        this.onScaleChange = null;
        this._scene3d = null;
        this._parent = null;
        this._localPos = null;
        this._localRot = null;
        this._localRotQuat = null;
        this._localScale = null;
        this._forward = null;
        this._back = null;
        this._right = null;
        this._left = null;
        this._up = null;
        this._down = null;
        this.localChange = null;
        this._targetPos = null;
      }
    }

    class BoundingBox {
      /**
       * The center of the bounding box.
       */
      center;
      /**
       *
       * The range of the bounding box. This is always half the size of these Bounds.
       */
      extents;
      /**
       *
       *  The maximum point of the box body. This always equals center+extensions.
       */
      max;
      /**
       *
       *  The minimum point of the box body. This always equals center extensions.
       */
      min;
      /**
       *
       * The total size of the box. This is always twice as much as extensions.
       */
      size;
      static maxVector3 = new Vector3(1, 1, 1).multiplyScalar(Number.MAX_VALUE * 0.1);
      static minVector3 = new Vector3(1, 1, 1).multiplyScalar(-Number.MAX_VALUE * 0.1);
      /**
       *
       * Create a new Bounds.
       * @param center the center of the box.
       * @param size The size of the box.
       */
      constructor(center, size) {
        center ||= Vector3.ZERO.clone();
        size ||= Vector3.ZERO.clone();
        this.setFromCenterAndSize(center, size);
      }
      /**
       * Reset the box to an inverted/empty state so the first expansion fits it tightly.
       * @returns this box for chaining
       */
      makeEmpty() {
        this.setFromMinMax(BoundingBox.maxVector3, BoundingBox.minVector3);
        return this;
      }
      /**
       * Build the box from its minimum and maximum corner points.
       * @param min the minimum corner
       * @param max the maximum corner
       * @returns this box for chaining
       */
      setFromMinMax(min, max) {
        this.init();
        Vector3.sub(max, min, this.size);
        Vector3.add(min, max, this.center);
        this.center.multiplyScalar(0.5);
        this.extents.copy(this.size).multiplyScalar(0.5);
        this.min.copy(min);
        this.max.copy(max);
        return this;
      }
      init() {
        this.min ||= new Vector3();
        this.max ||= new Vector3();
        this.size ||= new Vector3();
        this.center ||= new Vector3();
        this.extents ||= new Vector3();
        return this;
      }
      /**
       * Build the box from its center and full size.
       * @param center the center of the box
       * @param size the full size of the box
       * @returns this box for chaining
       */
      setFromCenterAndSize(center, size) {
        this.size = size;
        this.center = center;
        this.init();
        this.extents.copy(size).multiplyScalar(0.5);
        Vector3.sub(this.center, this.extents, this.min);
        Vector3.add(this.center, this.extents, this.max);
        return this;
      }
      /**
       * Whether the object's bound is inside the given frustum.
       * @param obj the object whose bound is tested
       * @param frustum the frustum to test against
       */
      inFrustum(obj, frustum) {
        return frustum.containsBoundingBox(obj.bound);
      }
      /**
       * Expand this box to also contain the given box.
       * @param bound the box to merge in
       */
      merge(bound) {
        if (bound.min.x < this.min.x) this.min.x = bound.min.x;
        if (bound.min.y < this.min.y) this.min.y = bound.min.y;
        if (bound.min.z < this.min.z) this.min.z = bound.min.z;
        if (bound.max.x > this.max.x) this.max.x = bound.max.x;
        if (bound.max.y > this.max.y) this.max.y = bound.max.y;
        if (bound.max.z > this.max.z) this.max.z = bound.max.z;
        this.size.x = bound.max.x - bound.min.x;
        this.size.y = bound.max.y - bound.min.y;
        this.size.z = bound.max.z - bound.min.z;
        this.extents.x = this.size.x * 0.5;
        this.extents.y = this.size.y * 0.5;
        this.extents.z = this.size.z * 0.5;
        this.center.x = this.extents.x + bound.min.x;
        this.center.y = this.extents.y + bound.min.y;
        this.center.z = this.extents.z + bound.min.z;
      }
      /**
       * Whether this box intersects another bound.
       * @param bounds the bound to test against
       */
      intersects(bounds) {
        return this.min.x <= bounds.max.x && this.max.x >= bounds.min.x && this.min.y <= bounds.max.y && this.max.y >= bounds.min.y && this.min.z <= bounds.max.z && this.max.z >= bounds.min.z;
      }
      /**
       * Whether this box intersects the given sphere's bound.
       * @param sphere the sphere bound to test against
       */
      intersectsSphere(sphere) {
        return this.min.x <= sphere.max.x && this.max.x >= sphere.min.x && this.min.y <= sphere.max.y && this.max.y >= sphere.min.y && this.min.z <= sphere.max.z && this.max.z >= sphere.min.z;
      }
      /**
       *
       * Does the target bounding box intersect with the bounding box
       * @param box
       * @returns
       */
      intersectsBox(box) {
        return this.min.x <= box.max.x && this.max.x >= box.min.x && this.min.y <= box.max.y && this.max.y >= box.min.y && this.min.z <= box.max.z && this.max.z >= box.min.z;
      }
      /**
       * Whether this box equals another bound (same center and extents).
       * @param bounds the bound to compare with
       */
      equals(bounds) {
        return this.center.equals(bounds.center) && this.extents.equals(bounds.extents);
      }
      /**
       * Grow the box's min/max so it contains the given point.
       * @param point the point to include
       */
      expandByPoint(point) {
        if (point.x < this.min.x) {
          this.min.x = point.x;
        }
        if (point.x > this.max.x) {
          this.max.x = point.x;
        }
        if (point.y < this.min.y) {
          this.min.y = point.y;
        }
        if (point.y > this.max.y) {
          this.max.y = point.y;
        }
        if (point.z < this.min.z) {
          this.min.z = point.z;
        }
        if (point.z > this.max.z) {
          this.max.z = point.z;
        }
      }
      /**
       * Create a box that tightly contains all the given points.
       * @param points the points to enclose
       * @returns a new bounding box
       */
      static fromPoints(points) {
        var bounds = new BoundingBox(new Vector3(), new Vector3());
        for (var i = 0; i < points.length; i++) {
          bounds.expandByPoint(points[i]);
        }
        return bounds;
      }
      /**
       * Recalculate the bound from the given object's transform.
       * @param obj the owning object
       */
      calculateTransform(obj) {
      }
      /**
       * Create a copy of this bounding box.
       * @returns a new bound with the same center and size
       */
      clone() {
        var bound = new BoundingBox(this.center.clone(), this.size.clone());
        return bound;
      }
      /**
       * Test whether the ray intersects this box, storing the hit point.
       * @param ray the ray to test
       * @param point output hit point
       */
      intersectsRay(ray, point) {
        throw new Error("Method not implemented.");
      }
      /**
       * Whether the given point lies inside this box.
       * @param point the point to test
       */
      containsPoint(point) {
        return this.min.x <= point.x && this.max.x >= point.x && this.min.y <= point.y && this.max.y >= point.y && this.min.z <= point.z && this.max.z >= point.z;
      }
      /**
       * Whether the given box is fully contained within this box.
       * @param box the box to test
       */
      containsBox(box) {
        let min = this.min;
        let max = this.max;
        let isContain = min.x <= box.min.x && min.y <= box.min.y && min.z <= box.min.z && (max.x >= box.max.x && max.y >= box.max.y && max.z >= box.max.z);
        return isContain;
      }
      /**
       * Recompute the derived bound data after the source data changes.
       */
      updateBound() {
      }
      /**
       * Release the vectors held by this bound.
       * @param force whether to force-destroy
       */
      destroy(force) {
        this.center = null;
        this.extents = null;
        this.min = null;
        this.max = null;
        this.size = null;
      }
    }

    var RendererMask = /* @__PURE__ */ ((RendererMask2) => {
      RendererMask2[RendererMask2["Default"] = 1] = "Default";
      RendererMask2[RendererMask2["IgnoreDepthPass"] = 2] = "IgnoreDepthPass";
      RendererMask2[RendererMask2["Sky"] = 6] = "Sky";
      RendererMask2[RendererMask2["Particle"] = 10] = "Particle";
      RendererMask2[RendererMask2["SkinnedMesh"] = 16] = "SkinnedMesh";
      RendererMask2[RendererMask2["MorphTarget"] = 32] = "MorphTarget";
      RendererMask2[RendererMask2["Terrain"] = 64] = "Terrain";
      RendererMask2[RendererMask2["Reflection"] = 256] = "Reflection";
      RendererMask2[RendererMask2["ReflectionDebug"] = 512] = "ReflectionDebug";
      RendererMask2[RendererMask2["Graphic3D"] = 1024] = "Graphic3D";
      return RendererMask2;
    })(RendererMask || {});
    class RendererMaskUtil {
      static addMask(src, tag) {
        let value = src | tag;
        return value;
      }
      static removeMask(src, tag) {
        let value = src & ~tag;
        return value;
      }
      static hasMask(m1, m2) {
        return (m1 & m2) == m2;
      }
    }

    class Vector4 {
      /**
       * The x axis defined as a Vector4 object with coordinates (1,0,0).
       */
      static X_AXIS = new Vector4(1, 0, 0);
      /**
       * The y axis defined as a Vector4 object with coordinates (0,1,0).
       */
      static Y_AXIS = new Vector4(0, 1, 0);
      /**
       * The z axis defined as a Vector4 object with coordinates (0,0,1).
       */
      static Z_AXIS = new Vector4(0, 0, 1);
      /**
       * @internal
       */
      static HELP_0 = new Vector4();
      /**
       * @internal
       */
      static HELP_1 = new Vector4();
      /**
       * @internal
       */
      static HELP_2 = new Vector4();
      /**
       * @internal
       */
      static EPSILON = 1e-5;
      /**
       * @internal
       */
      static HELP_3 = new Vector4();
      /**
       * @internal
       */
      static HELP_4 = new Vector4();
      /**
       * @internal
       */
      static HELP_5 = new Vector4();
      /**
       * @internal
       */
      static HELP_6 = new Vector4();
      static ZERO = new Vector4();
      static ONE = new Vector4(1, 1, 1, 1);
      static LEFT = new Vector4(-1, 0, 0);
      static RIGHT = new Vector4(1, 0, 0);
      static UP = new Vector4(0, -1, 0);
      static DOWN = new Vector4(0, 1, 0);
      static BACK = new Vector4(0, 0, -1);
      static FORWARD = new Vector4(0, 0, 1);
      /**
       * @language en_US
       * The first element of a Vector4 object, such as the x coordinate of
       * a point in the three-dimensional space. The default value is 0.
       */
      x = 0;
      /**
       * @language en_US
       * The second element of a Vector4 object, such as the y coordinate of
       * a point in the three-dimensional space. The default value is 0.
       */
      y = 0;
      /**
       * @language en_US
       * The third element of a Vector4 object, such as the y coordinate of
       * a point in the three-dimensional space. The default value is 0.
       */
      z = 0;
      /**
       * A three-dimensional position or projection that can be used as 
       * a perspective projection can also be a w in a quaternion
       */
      w = 1;
      constructor(x = 0, y = 0, z = 0, w = 0) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
      }
      get width() {
        return this.z;
      }
      get height() {
        return this.w;
      }
      static crossVectors(a, b, target) {
        target = target || new Vector4();
        var ax = a.x, ay = a.y, az = a.z;
        var bx = b.x, by = b.y, bz = b.z;
        target.x = ay * bz - az * by;
        target.y = az * bx - ax * bz;
        target.z = ax * by - ay * bx;
        return target;
      }
      /**
       * Add two vectors
       */
      static add(a, b, result) {
        result ||= new Vector4();
        result.x = a.x + b.x;
        result.y = a.y + b.y;
        result.z = a.z + b.z;
        result.w = a.w + b.w;
        return result;
      }
      /**
       * Subtract two vectors
       */
      static sub(a, b, result) {
        result ||= new Vector4();
        result.x = a.x - b.x;
        result.y = a.y - b.y;
        result.z = a.z - b.z;
        result.w = a.w - b.w;
        return result;
      }
      /**
       * Multiply a vector by a scalar
       */
      static multiplyScalar(a, s, result) {
        result ||= new Vector4();
        result.x = a.x * s;
        result.y = a.y * s;
        result.z = a.z * s;
        result.w = a.w * s;
        return result;
      }
      /**
       * Linear interpolation between two vectors: result = a + (b - a) * t
       */
      static lerp(a, b, t, result) {
        result ||= new Vector4();
        result.x = a.x + (b.x - a.x) * t;
        result.y = a.y + (b.y - a.y) * t;
        result.z = a.z + (b.z - a.z) * t;
        result.w = a.w + (b.w - a.w) * t;
        return result;
      }
      static distance(pt1, pt2) {
        let x = pt1.x - pt2.x;
        let y = pt1.y - pt2.y;
        let z = pt1.z - pt2.z;
        let w = pt1.w - pt2.w;
        return Math.sqrt(x * x + y * y + z * z + w * w);
      }
      set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
      }
      multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
      }
      copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w;
        return this;
      }
      clone() {
        return new Vector4(this.x, this.y, this.z, this.w);
      }
      // -------- Standard instance API --------
      add(a) {
        return Vector4.add(this, a, this);
      }
      sub(a) {
        return Vector4.sub(this, a, this);
      }
      addVectors(a, b) {
        return Vector4.add(a, b, this);
      }
      subVectors(a, b) {
        return Vector4.sub(a, b, this);
      }
      divideScalar(s) {
        return this.multiplyScalar(1 / s);
      }
      negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
      }
      dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
      }
      lengthSq() {
        return this.dot(this);
      }
      length() {
        return Math.sqrt(this.lengthSq());
      }
      normalize() {
        return this.divideScalar(this.length() || 1);
      }
      /** Linearly interpolate this towards v by alpha. */
      lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
      }
      lerpVectors(v1, v2, alpha) {
        return Vector4.lerp(v1, v2, alpha, this);
      }
      equals(v) {
        return this.x === v.x && this.y === v.y && this.z === v.z && this.w === v.w;
      }
      fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
      }
      toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
      }
      /** Apply a 4x4 matrix to this vector (w included). */
      applyMatrix4(m) {
        const e = m.rawData;
        const x = this.x, y = this.y, z = this.z, w = this.w;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
      }
    }

    var __defProp$3 = Object.defineProperty;
    var __decorateClass$r = (decorators, target, key, kind) => {
      var result = void 0 ;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(target, key, result) ) || result;
      if (result) __defProp$3(target, key, result);
      return result;
    };
    const _Struct = class _Struct {
      __refection;
      __size = 0;
      /**
       * get reflection name
       * @returns
       */
      getValueType() {
        if (!this.__refection) {
          let self = this;
          this.__refection = [];
          for (const key in self) {
            if (!IsNonSerialize(this, key)) {
              const element = self[key];
              let att = {
                name: key,
                type: element.constructor.name
              };
              this.__refection.push(att);
            }
          }
        }
        return this.__refection;
      }
      /**
       * get any type value memory size
       * @param value any type value
       * @returns
       */
      static getValueSize(value) {
        let type = value.constructor.name;
        switch (type) {
          case `Boolean`:
            return 1 * 4;
          case `Number`:
            return 1 * 4;
          case `f32`:
            return 1 * 4;
          case `i32`:
            return 1 * 4;
          case `u32`:
            return 1 * 4;
          case `Float32Array`:
            return value.byteLength;
          case `Vector2`:
            return 2 * 4;
          case `Vector3`:
            return 3 * 4;
          case `Vector4`:
            return 4 * 4;
          case `Color`:
            return 4 * 4;
          case `Array`:
            let singleSize = 0;
            for (let i = 0, c = value.length; i < c; i++) {
              singleSize += _Struct.getValueSize(value[i]);
            }
            return singleSize;
        }
        return 0;
      }
      static __cacheStruct = /* @__PURE__ */ new Map();
      static Ref(c) {
        let struct = this.Get(c);
        let ref = struct.getValueType();
        return ref;
      }
      static Get(c) {
        let struct = _Struct.__cacheStruct.get(c.prototype);
        if (!struct) {
          struct = new c();
          _Struct.__cacheStruct.set(c.prototype, struct);
        }
        return struct;
      }
      /**
       * get any struct memory size
       * @returns
       */
      static GetSize(c) {
        let struct = this.Get(c);
        if (struct.__size == 0) {
          for (const key in struct) {
            if (!IsNonSerialize(struct, key)) {
              const element = struct[key];
              struct.__size += _Struct.getValueSize(element);
            }
          }
          if (struct.__size > 4) {
            struct.__size = Math.ceil(struct.__size / 4) * 4;
          }
        }
        return struct.__size;
      }
    };
    __decorateClass$r([
      NonSerialize
    ], _Struct.prototype, "__refection");
    __decorateClass$r([
      NonSerialize
    ], _Struct.prototype, "__size");
    let Struct = _Struct;

    class MemoryInfo {
      /** Byte offset of this slice within the owning memory block. */
      byteOffset;
      /** Size of this slice in bytes. */
      byteSize;
      /** Current write cursor, in bytes, used by the `write*` methods. */
      offset = 0;
      /** Data view bound to this slice's bytes. */
      dataBytes;
      /** Get the first float component. */
      get x() {
        return this.dataBytes.getFloat32(0 * Float32Array.BYTES_PER_ELEMENT, true);
      }
      /** Set the first float component. */
      set x(v) {
        this.dataBytes.setFloat32(0 * Float32Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Get the second float component. */
      get y() {
        return this.dataBytes.getFloat32(1 * Float32Array.BYTES_PER_ELEMENT, true);
      }
      /** Set the second float component. */
      set y(v) {
        this.dataBytes.setFloat32(1 * Float32Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Get the third float component. */
      get z() {
        return this.dataBytes.getFloat32(2 * Float32Array.BYTES_PER_ELEMENT, true);
      }
      /** Set the third float component. */
      set z(v) {
        this.dataBytes.setFloat32(2 * Float32Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Get the fourth float component. */
      get w() {
        return this.dataBytes.getFloat32(3 * Float32Array.BYTES_PER_ELEMENT, true);
      }
      /** Set the fourth float component. */
      set w(v) {
        this.dataBytes.setFloat32(3 * Float32Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Set the x component. */
      setX(x) {
        this.x = x;
      }
      /** Set the x and y components. */
      setXY(x, y) {
        this.x = x;
        this.y = y;
      }
      /** Set the x, y and z components. */
      setXYZ(x, y, z) {
        this.x = x;
        this.y = y;
        this.z = z;
      }
      /** Set the x, y, z and w components. */
      setXYZW(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
      }
      /** Write an array of Vector2 packed as consecutive xy float pairs. */
      setVector2Array(vs) {
        for (let i = 0; i < vs.length; i++) {
          const element = vs[i];
          this.dataBytes.setFloat32((i * 2 + 0) * Float32Array.BYTES_PER_ELEMENT, element.x, true);
          this.dataBytes.setFloat32((i * 2 + 1) * Float32Array.BYTES_PER_ELEMENT, element.y, true);
        }
      }
      /** Write an array of Vector3 packed as consecutive xyz float triples. */
      setVector3Array(vs) {
        for (let i = 0; i < vs.length; i++) {
          const element = vs[i];
          this.dataBytes.setFloat32((i * 3 + 0) * Float32Array.BYTES_PER_ELEMENT, element.x, true);
          this.dataBytes.setFloat32((i * 3 + 1) * Float32Array.BYTES_PER_ELEMENT, element.y, true);
          this.dataBytes.setFloat32((i * 3 + 2) * Float32Array.BYTES_PER_ELEMENT, element.z, true);
        }
      }
      /** Write an array of 4-component vectors/quaternions packed as xyzw float quads. */
      setVector4Array(vs) {
        for (let i = 0; i < vs.length; i++) {
          const element = vs[i];
          this.dataBytes.setFloat32((i * 4 + 0) * Float32Array.BYTES_PER_ELEMENT, element.x, true);
          this.dataBytes.setFloat32((i * 4 + 1) * Float32Array.BYTES_PER_ELEMENT, element.y, true);
          this.dataBytes.setFloat32((i * 4 + 2) * Float32Array.BYTES_PER_ELEMENT, element.z, true);
          this.dataBytes.setFloat32((i * 4 + 3) * Float32Array.BYTES_PER_ELEMENT, element.w, true);
        }
      }
      /** Write an array of colors packed as consecutive rgba float quads. */
      setColorArray(colorArray) {
        for (let i = 0; i < colorArray.length; i++) {
          const element = colorArray[i];
          this.dataBytes.setFloat32((i * 4 + 0) * Float32Array.BYTES_PER_ELEMENT, element.r, true);
          this.dataBytes.setFloat32((i * 4 + 1) * Float32Array.BYTES_PER_ELEMENT, element.g, true);
          this.dataBytes.setFloat32((i * 4 + 2) * Float32Array.BYTES_PER_ELEMENT, element.b, true);
          this.dataBytes.setFloat32((i * 4 + 3) * Float32Array.BYTES_PER_ELEMENT, element.a, true);
        }
      }
      /** Write an 8-bit signed integer at the given element index. */
      setInt8(v, index = 0) {
        this.dataBytes.setInt8(index * Int8Array.BYTES_PER_ELEMENT, v);
      }
      /** Read an 8-bit signed integer at the given element index. */
      getInt8(index = 0) {
        return this.dataBytes.getInt8(index * Int8Array.BYTES_PER_ELEMENT);
      }
      /** Write a 16-bit signed integer at the given element index. */
      setInt16(v, index = 0) {
        this.dataBytes.setInt16(index * Int16Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Read a 16-bit signed integer at the given element index. */
      getInt16(index = 0) {
        return this.dataBytes.getInt16(index * Int16Array.BYTES_PER_ELEMENT, true);
      }
      /** Write a 32-bit signed integer at the given element index. */
      setInt32(v, index = 0) {
        this.dataBytes.setInt32(index * Int32Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Read a 32-bit signed integer at the given element index. */
      getInt32(index = 0) {
        return this.dataBytes.getInt32(index * Int32Array.BYTES_PER_ELEMENT, true);
      }
      /** Write a 32-bit float at the given element index. */
      setFloat(v, index = 0) {
        this.dataBytes.setFloat32(index * Float32Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Read a 32-bit float at the given element index. */
      getFloat(index = 0) {
        return this.dataBytes.getFloat32(index * Float32Array.BYTES_PER_ELEMENT, true);
      }
      /** Write an 8-bit unsigned integer at the given element index. */
      setUint8(v, index = 0) {
        this.dataBytes.setUint8(index * Uint8Array.BYTES_PER_ELEMENT, v);
      }
      /** Read an 8-bit unsigned integer at the given element index. */
      getUint8(index = 0) {
        return this.dataBytes.getUint8(index * Uint8Array.BYTES_PER_ELEMENT);
      }
      /** Write a 16-bit unsigned integer at the given element index. */
      setUint16(v, index = 0) {
        this.dataBytes.setUint16(index * Uint16Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Read a 16-bit unsigned integer at the given element index. */
      getUint16(index = 0) {
        return this.dataBytes.getUint16(index * Uint16Array.BYTES_PER_ELEMENT, true);
      }
      /** Write a 32-bit unsigned integer at the given element index. */
      setUint32(v, index = 0) {
        this.dataBytes.setUint32(index * Uint32Array.BYTES_PER_ELEMENT, v, true);
      }
      /** Read a 32-bit unsigned integer at the given element index. */
      getUint32(index = 0) {
        return this.dataBytes.getUint32(index * Uint32Array.BYTES_PER_ELEMENT, true);
      }
      /** Write a number array as consecutive floats starting at the given float index. */
      setArray(index, data) {
        for (let i = 0; i < data.length; i++) {
          const element = data[i];
          this.dataBytes.setFloat32((index + i) * Float32Array.BYTES_PER_ELEMENT, element, true);
        }
      }
      /** Copy a Float32Array into this slice starting at the given float index. */
      setFloat32Array(index, data) {
        let tmp = new Float32Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Float32Array.BYTES_PER_ELEMENT, data.length);
        tmp.set(data);
      }
      /** Copy a FloatArray into this slice as 32-bit floats at the given float index. */
      setFloatArray(index, value) {
        let data;
        if (value instanceof Float32Array) {
          data = value;
        } else {
          data = new Float32Array(value);
        }
        let tmp = new Float32Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Float32Array.BYTES_PER_ELEMENT, data.length);
        tmp.set(data);
      }
      /** Copy a typed-array buffer into this slice, dispatching by its concrete type. */
      setArrayBuffer(index, arrayBuffer) {
        if (arrayBuffer instanceof Uint8Array) {
          this.setUint8Array(index, arrayBuffer);
        } else if (arrayBuffer instanceof Uint16Array) {
          this.setUint16Array(index, arrayBuffer);
        } else if (arrayBuffer instanceof Uint32Array) {
          this.setUint32Array(index, arrayBuffer);
        } else if (arrayBuffer instanceof Int8Array) {
          this.setInt8Array(index, arrayBuffer);
        } else if (arrayBuffer instanceof Int16Array) {
          this.setInt16Array(index, arrayBuffer);
        } else if (arrayBuffer instanceof Int32Array) {
          this.setInt32Array(index, arrayBuffer);
        } else if (arrayBuffer instanceof Float32Array) {
          this.setFloat32Array(index, arrayBuffer);
        } else ;
      }
      /** Copy an Int8Array into this slice starting at the given element index. */
      setInt8Array(index, data) {
        let tmp = new Int8Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Int8Array.BYTES_PER_ELEMENT);
        tmp.set(data);
      }
      /** Copy an Int16Array into this slice starting at the given element index. */
      setInt16Array(index, data) {
        let tmp = new Int16Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Int16Array.BYTES_PER_ELEMENT);
        tmp.set(data);
      }
      /** Copy an Int32Array into this slice starting at the given element index. */
      setInt32Array(index, data) {
        let tmp = new Int32Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Int32Array.BYTES_PER_ELEMENT);
        tmp.set(data);
      }
      /** Copy a Uint8Array into this slice starting at the given element index. */
      setUint8Array(index, data) {
        let tmp = new Uint8Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Uint8Array.BYTES_PER_ELEMENT);
        tmp.set(data);
      }
      /** Copy a Uint16Array into this slice starting at the given element index. */
      setUint16Array(index, data) {
        let tmp = new Uint16Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Uint16Array.BYTES_PER_ELEMENT);
        tmp.set(data);
      }
      /** Copy a Uint32Array into this slice starting at the given element index. */
      setUint32Array(index, data) {
        let tmp = new Uint32Array(this.dataBytes.buffer, this.dataBytes.byteOffset + index * Uint32Array.BYTES_PER_ELEMENT);
        tmp.set(data);
      }
      /** Write a single float at the given float index. */
      setData(index, data) {
        this.dataBytes.setFloat32(index * Float32Array.BYTES_PER_ELEMENT, data, true);
      }
      /** Write a Vector2 at the given float index. */
      setVector2(index, data) {
        this.dataBytes.setFloat32(index * Float32Array.BYTES_PER_ELEMENT, data.x, true);
        this.dataBytes.setFloat32((index + 1) * Float32Array.BYTES_PER_ELEMENT, data.y, true);
      }
      /** Write a Vector3 at the given float index. */
      setVector3(index, data) {
        this.dataBytes.setFloat32(index * Float32Array.BYTES_PER_ELEMENT, data.x, true);
        this.dataBytes.setFloat32((index + 1) * Float32Array.BYTES_PER_ELEMENT, data.y, true);
        this.dataBytes.setFloat32((index + 2) * Float32Array.BYTES_PER_ELEMENT, data.z, true);
      }
      /** Write a Vector4 at the given float index. */
      setVector4(index, data) {
        this.dataBytes.setFloat32(index * Float32Array.BYTES_PER_ELEMENT, data.x, true);
        this.dataBytes.setFloat32((index + 1) * Float32Array.BYTES_PER_ELEMENT, data.y, true);
        this.dataBytes.setFloat32((index + 2) * Float32Array.BYTES_PER_ELEMENT, data.z, true);
        this.dataBytes.setFloat32((index + 3) * Float32Array.BYTES_PER_ELEMENT, data.w, true);
      }
      /** Write a Color (rgba) at the given float index. */
      setColor(index, data) {
        this.dataBytes.setFloat32(index * Float32Array.BYTES_PER_ELEMENT, data.r, true);
        this.dataBytes.setFloat32((index + 1) * Float32Array.BYTES_PER_ELEMENT, data.g, true);
        this.dataBytes.setFloat32((index + 2) * Float32Array.BYTES_PER_ELEMENT, data.b, true);
        this.dataBytes.setFloat32((index + 3) * Float32Array.BYTES_PER_ELEMENT, data.a, true);
      }
      /** Read a single float at the given float index. */
      getData(index) {
        return this.dataBytes.getFloat32(index * Float32Array.BYTES_PER_ELEMENT, true);
      }
      /** Write a float at the current cursor and advance the cursor. */
      writeFloat(v) {
        this.dataBytes.setFloat32(this.offset, v, true);
        this.offset += Float32Array.BYTES_PER_ELEMENT;
      }
      /** Write an 8-bit signed integer at the current cursor and advance the cursor. */
      writeInt8(v) {
        this.dataBytes.setInt8(this.offset, v);
        this.offset += Int8Array.BYTES_PER_ELEMENT;
      }
      /** Write a 16-bit signed integer at the current cursor and advance the cursor. */
      writeInt16(v) {
        this.dataBytes.setInt16(this.offset, v, true);
        this.offset += Int16Array.BYTES_PER_ELEMENT;
      }
      /** Write a 32-bit signed integer at the current cursor and advance the cursor. */
      writeInt32(v) {
        this.dataBytes.setInt32(this.offset, v, true);
        this.offset += Int32Array.BYTES_PER_ELEMENT;
      }
      /** Write an 8-bit unsigned integer at the current cursor and advance the cursor. */
      writeUint8(v) {
        this.dataBytes.setUint8(this.offset, v);
        this.offset += Uint8Array.BYTES_PER_ELEMENT;
      }
      /** Write a 16-bit unsigned integer at the current cursor and advance the cursor. */
      writeUint16(v) {
        this.dataBytes.setUint16(this.offset, v, true);
        this.offset += Uint16Array.BYTES_PER_ELEMENT;
      }
      /** Write a 32-bit unsigned integer at the current cursor and advance the cursor. */
      writeUint32(v) {
        this.dataBytes.setUint32(this.offset, v, true);
        this.offset += Uint32Array.BYTES_PER_ELEMENT;
      }
      /** Write a Vector2 at the current cursor and advance the cursor. */
      writeVector2(v) {
        this.writeFloat(v.x);
        this.writeFloat(v.y);
      }
      /** Write a Vector3 at the current cursor and advance the cursor. */
      writeVector3(v) {
        this.writeFloat(v.x);
        this.writeFloat(v.y);
        this.writeFloat(v.z);
      }
      /** Write a Vector4 at the current cursor and advance the cursor. */
      writeVector4(v) {
        this.writeFloat(v.x);
        this.writeFloat(v.y);
        this.writeFloat(v.z);
        this.writeFloat(v.w);
      }
      /** Write the rgb channels of a color at the current cursor and advance the cursor. */
      writeRGBColor(v) {
        this.writeFloat(v.r);
        this.writeFloat(v.g);
        this.writeFloat(v.b);
      }
      /** Write a number array as consecutive floats at the current cursor. */
      writeArray(v) {
        for (let i = 0; i < v.length; i++) {
          const d = v[i];
          this.writeFloat(d);
        }
      }
      /** Write a Float32Array at the current cursor and advance the cursor. */
      writeFloat32Array(v) {
        new Float32Array(this.dataBytes.buffer, this.dataBytes.byteOffset + this.offset).set(v);
        this.offset += v.byteLength;
      }
      /** Write an Int8Array at the current cursor and advance the cursor. */
      writeInt8Array(v) {
        new Int8Array(this.dataBytes.buffer, this.dataBytes.byteOffset + this.offset).set(v);
        this.offset += v.byteLength;
      }
      /** Write an Int16Array at the current cursor and advance the cursor. */
      writeInt16Array(v) {
        new Int16Array(this.dataBytes.buffer, this.dataBytes.byteOffset + this.offset).set(v);
        this.offset += v.byteLength;
      }
      /** Write an Int32Array at the current cursor and advance the cursor. */
      writeInt32Array(v) {
        new Int32Array(this.dataBytes.buffer, this.dataBytes.byteOffset + this.offset).set(v);
        this.offset += v.byteLength;
      }
      /** Write a Uint8Array at the current cursor and advance the cursor. */
      writeUint8Array(v) {
        new Uint8Array(this.dataBytes.buffer, this.dataBytes.byteOffset + this.offset).set(v);
        this.offset += v.byteLength;
      }
      /** Write a Uint16Array at the current cursor and advance the cursor. */
      writeUint16Array(v) {
        new Uint16Array(this.dataBytes.buffer, this.dataBytes.byteOffset + this.offset).set(v);
        this.offset += v.byteLength;
      }
      /** Write a Uint32Array at the current cursor and advance the cursor. */
      writeUint32Array(v) {
        new Uint32Array(this.dataBytes.buffer, this.dataBytes.byteOffset + this.offset).set(v);
        this.offset += v.byteLength;
      }
      /** Reset the write cursor back to the start of this slice. */
      reset() {
        this.offset = 0;
      }
      /** Release references held by this memory view. */
      destroy() {
        this.byteOffset = null;
        this.byteSize = null;
        this.offset = null;
        this.dataBytes = null;
      }
    }

    class MemoryDO {
      shareDataBuffer;
      _byteOffset = 0;
      allocation(byteSize) {
        if (this.shareDataBuffer && this.shareDataBuffer.byteLength < byteSize) {
          this._byteOffset = 0;
        } else {
          this.shareDataBuffer = new ArrayBuffer(byteSize);
        }
      }
      allocation_node(byteSize) {
        if (this._byteOffset + byteSize > this.shareDataBuffer.byteLength) {
          console.error("memory not enough!", this._byteOffset, byteSize, this.shareDataBuffer.byteLength);
          return null;
        }
        let memoryInfo = new MemoryInfo();
        memoryInfo.byteOffset = this._byteOffset;
        memoryInfo.byteSize = byteSize;
        memoryInfo.dataBytes = new DataView(this.shareDataBuffer, this._byteOffset, memoryInfo.byteSize);
        this._byteOffset += memoryInfo.byteSize;
        return memoryInfo;
      }
      allocation_memory(memoryInfo) {
        if (this._byteOffset + memoryInfo.byteSize > this.shareDataBuffer.byteLength) {
          console.error("memory not enough!", this._byteOffset, memoryInfo.byteSize, this.shareDataBuffer.byteLength);
          return null;
        }
        memoryInfo.byteOffset = this._byteOffset;
        memoryInfo.dataBytes = new DataView(this.shareDataBuffer, this._byteOffset, memoryInfo.byteSize);
        this._byteOffset += memoryInfo.byteSize;
        return memoryInfo;
      }
      reset() {
        this._byteOffset = 0;
      }
      destroy(force) {
        this.shareDataBuffer = null;
        this._byteOffset = 0;
      }
    }

    class GPUBufferBase {
      bufferType;
      memory;
      memoryNodes;
      seek;
      outFloat32Array;
      byteSize;
      usage;
      visibility = GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
      mapAsyncBuffersOutstanding = 0;
      mapAsyncReady;
      _dataView;
      /** The Context3D this buffer is bound to. Set on first GPU use via `bindCtx`. */
      _boundCtx = null;
      /** The single GPU buffer. Null until first materialize. */
      _buffer = null;
      /** Single readback staging buffer. Null until first `readBuffer`. */
      _readBuffer = null;
      _label;
      constructor() {
        this.mapAsyncReady = [];
      }
      /**
       * Ensure this buffer is bound to a Context3D and return it. A ctx must
       * be available either by explicit arg or via prior `bindCtx()` — there
       * is no ambient fallback.
       */
      _ensureBound(ctx) {
        if (ctx) {
          bindCtx(this, ctx);
          return ctx;
        }
        if (this._boundCtx) return this._boundCtx;
        throw new Error(`GPUBuffer(${this.constructor.name}) used before bindCtx — thread a Context3D from the owning Engine3D.`);
      }
      /**
       * Return the GPU buffer. Materializes lazily on first access.
       * Callers must have bound this buffer to a Context3D via `bindCtx()`
       * before touching `.buffer`.
       */
      get buffer() {
        this._ensureBound();
        if (!this._buffer) this._materialize(this._boundCtx);
        return this._buffer;
      }
      /**
       * Materialize this buffer on its bound Context3D. Uploads any CPU-side
       * initial data via queue.writeBuffer.
       */
      _materialize(ctx) {
        if (!this.usage || !this.byteSize) {
          throw new Error(`GPUBufferBase._materialize: usage/byteSize not set (call createBuffer() first)`);
        }
        this._buffer = ctx.device.createBuffer({
          label: this._label,
          size: this.byteSize,
          usage: this.usage,
          mappedAtCreation: false
        });
        if (this.memory && this.memory.shareDataBuffer) {
          ctx.device.queue.writeBuffer(this._buffer, 0, this.memory.shareDataBuffer);
        }
      }
      /** Destroy the materialized GPU buffer, forcing re-materialization on next access. */
      _invalidateGpu() {
        if (this._buffer) {
          try {
            this._buffer.destroy();
          } catch {
          }
          this._buffer = null;
        }
      }
      debug() {
      }
      reset(clean = false, size = 0, data) {
        this.seek = 0;
        this.memory.reset();
        if (clean) {
          this.createBuffer(this.usage, size, data);
        }
      }
      setBoolean(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setX(v ? 1 : 0);
      }
      readBoole(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getFloat() == 0 ? false : true;
        }
        return null;
      }
      setFloat(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setX(v);
      }
      getFloat(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getFloat();
        }
        return null;
      }
      setInt8(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 1);
          this.memoryNodes.set(name, node);
        }
        node.setInt8(v);
      }
      getInt8(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getInt8();
        }
        return null;
      }
      setInt16(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 2);
          this.memoryNodes.set(name, node);
        }
        node.setInt16(v);
      }
      getInt16(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getInt16();
        }
        return null;
      }
      setInt32(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setInt32(v);
      }
      getInt32(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getInt32();
        }
        return null;
      }
      setUint8(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 1);
          this.memoryNodes.set(name, node);
        }
        node.setUint8(v);
      }
      getUint8(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getUint8();
        }
        return null;
      }
      setUint16(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 2);
          this.memoryNodes.set(name, node);
        }
        node.setUint16(v);
      }
      getUint16(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getUint16();
        }
        return null;
      }
      setUint32(name, v) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(1 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setUint32(v);
      }
      getUint32(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return node.getUint32();
        }
        return null;
      }
      setVector2(name, v2) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(2 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setXY(v2.x, v2.y);
      }
      getVector2(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return new Vector2(node.x, node.y);
        }
        return null;
      }
      setVector3(name, v3) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(3 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setXYZ(v3.x, v3.y, v3.z);
      }
      getVector3(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return new Vector3(node.x, node.y, node.z);
        }
        return null;
      }
      setVector4(name, v4) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(4 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setXYZW(v4.x, v4.y, v4.z, v4.w);
      }
      getVector4(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return new Vector4(node.x, node.y, node.z, node.w);
        }
        return null;
      }
      setVector4Array(name, v4Array) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(4 * 4 * v4Array.length);
          this.memoryNodes.set(name, node);
        }
        node.setVector4Array(v4Array);
      }
      setColor(name, color) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(4 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setXYZW(color.r, color.g, color.b, color.a);
      }
      getColor(name) {
        let node = this.memoryNodes.get(name);
        if (node) {
          return new Color(node.x, node.y, node.z, node.w);
        }
        return null;
      }
      setColorArray(name, colorArray) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(4 * 4 * colorArray.length);
          this.memoryNodes.set(name, node);
        }
        node.setColorArray(colorArray);
      }
      setMatrix(name, mat) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(16 * 4);
          this.memoryNodes.set(name, node);
        }
        node.setFloatArray(0, mat.rawData);
      }
      setMatrixArray(name, mats) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(16 * 4 * mats.length);
          this.memoryNodes.set(name, node);
        }
        for (let i = 0; i < mats.length; i++) {
          const mat = mats[i];
          node.setFloatArray(i * 16, mat.rawData);
        }
      }
      setArray(name, data) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(data.length * 4);
          this.memoryNodes.set(name, node);
        }
        node.setArray(0, data);
      }
      setFloat32Array(name, data) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(data.length * 4);
          this.memoryNodes.set(name, node);
        }
        node.setFloat32Array(0, data);
      }
      setInt32Array(name, data) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(data.length * 4);
          this.memoryNodes.set(name, node);
        }
        node.setInt32Array(0, data);
      }
      setUint32Array(name, data) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(data.length * 4);
          this.memoryNodes.set(name, node);
        }
        node.setUint32Array(0, data);
      }
      allocMemoryNode(name, byteSize) {
        let node = this.memoryNodes.get(name);
        if (!node) {
          node = this.memory.allocation_node(byteSize);
          this.memoryNodes.set(name, node);
        }
        return node;
      }
      getMemoryNode(name) {
        return this.memoryNodes.get(name);
      }
      setStruct(c, index, data, property) {
        let ref = Struct.Ref(c);
        let name = index;
        let node = this.memoryNodes.get(name);
        node.reset();
        let obj = data;
        if (property) {
          obj = obj[property];
        }
        for (let i = 0; i < ref.length; i++) {
          const att = ref[i];
          let value = obj[att.name];
          this.writeValue(node, att, value);
        }
      }
      writeValue(node, att, value) {
        switch (att.type) {
          case `Boolean`:
            node.writeFloat(value);
            break;
          case `Number`:
            node.writeFloat(value);
            break;
          case `Float32Array`:
            node.writeFloat32Array(value);
            break;
          case `Float64Array`:
            node.writeFloat32Array(new Float32Array(value));
            break;
          case `Vector2`:
            node.writeVector2(value);
            break;
          case `Vector3`:
            node.writeVector3(value);
            break;
          case `Vector4`:
            node.writeVector4(value);
            break;
          case `Color`:
            node.writeRGBColor(value);
            break;
          case `Array`:
            node.writeArray(value);
            break;
        }
      }
      setStructArray(c, dataList, property) {
        let len = dataList.length;
        for (let i = 0; i < len; i++) {
          const data = dataList[i];
          this.setStruct(c, i, data, property);
        }
      }
      clean() {
        this._dataView.fill(0, 0, this._dataView.length);
      }
      /**
       * Upload CPU-side memory to the GPU buffer. Lazy-materializes when a
       * Context3D is available. If called with no ctx and the buffer is not
       * yet bound, the upload is DEFERRED: CPU data remains in
       * `shareDataBuffer` and flows to the GPU automatically when `.buffer`
       * is first accessed with a real ctx (via `_materialize`).
       */
      apply(ctx) {
        if (!this.memory || !this.memory.shareDataBuffer) return;
        if (!ctx && !this._boundCtx) return;
        const bound = this._ensureBound(ctx);
        if (!this._buffer && this.usage && this.byteSize) {
          this._materialize(bound);
          return;
        }
        if (this._buffer) {
          bound.device.queue.writeBuffer(this._buffer, 0, this.memory.shareDataBuffer);
        }
      }
      mapAsyncWrite(floatArray, len) {
        let mapAsyncArray;
        if (floatArray instanceof Float64Array) {
          mapAsyncArray = new Float32Array(floatArray);
        } else {
          mapAsyncArray = floatArray;
        }
        this._ensureBound();
        const ctx = this._boundCtx;
        const device = ctx.device;
        const destBuffer = this.buffer;
        if (mapAsyncArray.length > 0) {
          let tBuffer = null;
          while (this.mapAsyncReady.length) {
            tBuffer = this.mapAsyncReady.shift();
            if (tBuffer["usedSize"] == mapAsyncArray.byteLength)
              break;
            tBuffer.destroy();
            this.mapAsyncBuffersOutstanding--;
            tBuffer = null;
          }
          if (!tBuffer) {
            tBuffer = device.createBuffer({
              size: mapAsyncArray.byteLength,
              usage: GPUBufferUsage.COPY_SRC | GPUBufferUsage.MAP_WRITE,
              mappedAtCreation: true
            });
            tBuffer["usedSize"] = mapAsyncArray.byteLength;
            this.mapAsyncBuffersOutstanding++;
            if (this.mapAsyncBuffersOutstanding > 20) {
              console.warn(` Warning: mapAsync requests from ${this.mapAsyncBuffersOutstanding} frames ago have not resolved yet.  MB of staging buffers allocated.`);
            }
          }
          let a = new Float32Array(mapAsyncArray.buffer, mapAsyncArray.byteOffset, len);
          let b = new Float32Array(tBuffer.getMappedRange(0, len * 4));
          b.set(a);
          tBuffer.unmap();
          const commandEncoder = device.createCommandEncoder();
          commandEncoder.copyBufferToBuffer(tBuffer, 0, destBuffer, 0, len * 4);
          device.queue.submit([commandEncoder.finish()]);
          tBuffer.mapAsync(GPUMapMode.WRITE).then(
            () => this.mapAsyncReady.push(tBuffer),
            (err) => {
              if (err?.name !== "AbortError") throw err;
            }
          );
        }
      }
      destroy() {
        if (this.memoryNodes) {
          this.memoryNodes.forEach((v) => {
            v.destroy();
          });
        }
        this.bufferType = null;
        this.seek = null;
        this.byteSize = null;
        this.usage = null;
        this.visibility = null;
        this.outFloat32Array = null;
        this._invalidateGpu();
        if (this.memory) {
          this.memory.destroy();
        }
        this.memory = null;
        if (this._readBuffer) {
          try {
            this._readBuffer.destroy();
          } catch {
          }
          this._readBuffer = null;
        }
        this._boundCtx = null;
      }
      /**
       * Configure this buffer. Does NOT allocate a GPU buffer — that happens
       * lazily per context in `get buffer`.
       */
      createBuffer(usage, size, data, debugLabel) {
        this._invalidateGpu();
        this.byteSize = size * 4;
        this.usage = usage;
        this._label = debugLabel;
        this.memory = new MemoryDO();
        this.memoryNodes = /* @__PURE__ */ new Map();
        this._dataView = new Float32Array(this.memory.shareDataBuffer);
        this.memory.allocation(this.byteSize);
        if (data) {
          let m = this.memory.allocation_node(data.length * 4);
          m.setArrayBuffer(0, data);
        }
      }
      resizeBuffer(size, data) {
        this.createBuffer(this.usage, size, data);
      }
      createNewBuffer(usage, size) {
        this._ensureBound();
        let device = this._boundCtx.device;
        let tByteSize = size * 4;
        let tUsage = usage;
        this._invalidateGpu();
        let buffer = device.createBuffer({
          size: tByteSize,
          usage: tUsage,
          mappedAtCreation: false
        });
        return buffer;
      }
      createBufferByStruct(usage, struct, count) {
        let structSize = Struct.GetSize(struct);
        let totalLength = structSize * count;
        this._invalidateGpu();
        this.byteSize = totalLength;
        this.usage = usage;
        this._label = "StructStorageGPUBuffer";
        this.memory = new MemoryDO();
        this.memoryNodes = /* @__PURE__ */ new Map();
        this._dataView = new Float32Array(this.memory.shareDataBuffer);
        this.memory.allocation(totalLength);
        for (let i = 0; i < count; i++) {
          let name = i;
          let node = this.memoryNodes.get(name);
          if (!node) {
            node = this.memory.allocation_node(structSize);
            this.memoryNodes.set(name, node);
          }
        }
      }
      readBuffer(promise = false) {
        this.outFloat32Array ||= new Float32Array(this.memory.shareDataBuffer.byteLength / 4);
        const ctx = this._ensureBound();
        if (!this._readBuffer) {
          this._readBuffer = ctx.device.createBuffer({
            size: this.memory.shareDataBuffer.byteLength,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ,
            mappedAtCreation: false
          });
        }
        let p = this.read(ctx, this._readBuffer);
        return promise ? p : this.outFloat32Array;
      }
      _readFlag = false;
      async read(ctx, rb) {
        if (!this._readFlag) {
          this._readFlag = true;
          let command = ctx.device.createCommandEncoder();
          command.copyBufferToBuffer(this.buffer, 0, rb, 0, this.memory.shareDataBuffer.byteLength);
          ctx.device.queue.submit([command.finish()]);
          await rb.mapAsync(GPUMapMode.READ);
          const copyArrayBuffer = rb.getMappedRange();
          this.outFloat32Array.set(new Float32Array(copyArrayBuffer), 0);
          rb.unmap();
          this._readFlag = false;
        }
        return this.outFloat32Array;
      }
    }

    var GPUBufferType = /* @__PURE__ */ ((GPUBufferType2) => {
      GPUBufferType2[GPUBufferType2["IndicesGPUBuffer"] = 0] = "IndicesGPUBuffer";
      GPUBufferType2[GPUBufferType2["VertexGPUBuffer"] = 1] = "VertexGPUBuffer";
      GPUBufferType2[GPUBufferType2["UniformGPUBuffer"] = 2] = "UniformGPUBuffer";
      GPUBufferType2[GPUBufferType2["StorageGPUBuffer"] = 3] = "StorageGPUBuffer";
      GPUBufferType2[GPUBufferType2["ComputeGPUBuffer"] = 4] = "ComputeGPUBuffer";
      GPUBufferType2[GPUBufferType2["MaterialDataUniformGPUBuffer"] = 5] = "MaterialDataUniformGPUBuffer";
      GPUBufferType2[GPUBufferType2["StructStorageGPUBuffer"] = 6] = "StructStorageGPUBuffer";
      return GPUBufferType2;
    })(GPUBufferType || {});

    class StorageGPUBuffer extends GPUBufferBase {
      constructor(size, usage = 0, data) {
        super();
        this.bufferType = GPUBufferType.StorageGPUBuffer;
        this.createBuffer(GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | usage, size, data, "StorageGPUBuffer");
      }
    }

    class UniformGPUBuffer extends GPUBufferBase {
      constructor(size, data) {
        super();
        this.bufferType = GPUBufferType.UniformGPUBuffer;
        this.createBuffer(GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC, size, data, "UniformGPUBuffer");
      }
      genUniformNodes() {
      }
    }

    class MorphTarget_shader {
      static getMorphTargetShaderBinding(group, beginBinding) {
        return (
          /* wgsl */
          `
            fn blendMorphTargetPosition(vertexID:i32, posIn:vec3<f32>) -> vec3<f32>{
                let offset:i32 = vertexID * 3;
                var pos = posIn * morphTargetConfig.morphBaseInfluence;
                pos += vec3<f32>(morphTargetOpPositions[offset], morphTargetOpPositions[offset + 1], morphTargetOpPositions[offset + 2]);
                return pos;
            }

            #if USE_MORPHNORMALS
                fn blendMorphTargetNormal(vertexID:i32, normalIn:vec3<f32>) -> vec3<f32>{
                    let offset:i32 = vertexID * 3;
                    var normal = normalIn * morphTargetConfig.morphBaseInfluence;
                    normal += vec3<f32>(morphTargetOpNormals[offset], morphTargetOpNormals[offset + 1], morphTargetOpNormals[offset + 2]);
                    return normal;
                }
            #endif

            struct MorphTargetConfigData {
                morphBaseInfluence:f32,
                morphTargetCount:f32,
                totalVertexCount:f32,
                computeWorkGroupXY:f32,
            };
            
            @group(${group}) @binding(${beginBinding})
            var<uniform> morphTargetConfig: MorphTargetConfigData;
            
            @group(${group}) @binding(${beginBinding + 1})
            var<storage,read> morphTargetOpPositions: array<f32>;

            #if USE_MORPHNORMALS
                @group(${group}) @binding(${beginBinding + 2})
                var<storage,read> morphTargetOpNormals: array<f32>;
            #endif
`
        );
      }
      // public static getMorphTargetAttr(beginLocation: number): string {
      //     let value = `@location(${beginLocation}) vIndex: f32,`;
      //     return value;
      // }
      static getMorphTargetCalcVertex() {
        return (
          /* wgsl */
          `
            vertexPosition = blendMorphTargetPosition(i32(vertex.vIndex), vertexPosition);

            #if USE_MORPHNORMALS
                vertexNormal = blendMorphTargetNormal(i32(vertex.vIndex), vertexNormal);
            #endif
        `
        );
      }
      static CsMain = (
        /* wgsl */
        `
        struct MorphTargetConfigData {
            morphBaseInfluence:f32,
            morphTargetCount:f32,
            totalVertexCount:f32,
            computeWorkGroupXY:f32,
        };

        @group(0) @binding(0) var<uniform> morphTargetConfig: MorphTargetConfigData;
        @group(0) @binding(1) var<storage, read> morphTargetInfluence : array<f32>;
        @group(0) @binding(2) var<storage, read> morphTargetPositions : array<f32>;
        @group(0) @binding(3) var<storage, read_write> morphTargetOpPositions : array<f32>;
        
        #if USE_MORPHNORMALS
            @group(0) @binding(4) var<storage, read> morphTargetNormals : array<f32>;
            @group(0) @binding(5) var<storage, read_write> morphTargetOpNormals : array<f32>;
        #endif
        
        @compute @workgroup_size( 8 , 8 , 1 )
        fn CsMain(@builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
        {
            let vertexIndex:i32 = i32(globalInvocation_id.y) * i32(morphTargetConfig.computeWorkGroupXY) + i32(globalInvocation_id.x);
        
            let morphTargetCount:i32 = i32(morphTargetConfig.morphTargetCount);
            let totalVertexCount:i32 = i32(morphTargetConfig.totalVertexCount);
            var vertexPosition:vec3<f32> = vec3<f32>(0.0);
            var vertexNormal:vec3<f32> = vec3<f32>(0.0);
            if(vertexIndex < totalVertexCount)
            {
                for(var i:i32 = 0; i < morphTargetCount; i ++){
                    let offset:i32 = (i * totalVertexCount + vertexIndex) * 3;
                    let morphPosition = vec3<f32>(morphTargetPositions[offset], morphTargetPositions[offset + 1], morphTargetPositions[offset + 2]);
                    vertexPosition += morphTargetInfluence[i] * morphPosition;
                }

                var writeOffset = vertexIndex * 3;
                //op position
                morphTargetOpPositions[writeOffset] = vertexPosition.x;
                morphTargetOpPositions[writeOffset + 1] = vertexPosition.y;
                morphTargetOpPositions[writeOffset + 2] = vertexPosition.z;

                #if USE_MORPHNORMALS
                    for(var i:i32 = 0; i < morphTargetCount; i ++){
                        let offset:i32 = (i * totalVertexCount + vertexIndex) * 3;
                        let morphNormal = vec3<f32>(morphTargetNormals[offset], morphTargetNormals[offset + 1], morphTargetNormals[offset + 2]);
                        vertexNormal += morphTargetInfluence[i] * morphNormal;
                    }

                    //op normal
                    morphTargetOpNormals[writeOffset] = vertexNormal.x;
                    morphTargetOpNormals[writeOffset + 1] = vertexNormal.y;
                    morphTargetOpNormals[writeOffset + 2] = vertexNormal.z;
                #endif
            }
        }
`
      );
    }

    let UUID = function(len = 16, radix = 16) {
      var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split("");
      var uuid = [], i;
      radix = radix || chars.length;
      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
      } else {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
        uuid[14] = "4";
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16;
            uuid[i] = chars[i == 19 ? r & 3 | 8 : r];
          }
        }
      }
      return uuid.join("");
    };
    let _instanceID = 1e6;
    let GetCountInstanceID = function() {
      _instanceID++;
      return _instanceID;
    };
    let ArrayHas = function(array, item) {
      let i = 0;
      let len = array.length;
      for (i = 0; i < len; i++) {
        const element = array[i];
        if (element == item) {
          return true;
        }
      }
      return false;
    };
    let ArrayItemIndex = function(array, item) {
      let i = 0;
      let len = array.length;
      for (i = 0; i < len; i++) {
        const element = array[i];
        if (element == item) {
          return i;
        }
      }
      return -1;
    };
    let mergeFunctions = (...funcs) => {
      return function(...args) {
        funcs.forEach((func) => func.apply(this, args));
      };
    };

    var UniformType = /* @__PURE__ */ ((UniformType2) => {
      UniformType2[UniformType2["Number"] = 0] = "Number";
      UniformType2[UniformType2["Vector2"] = 1] = "Vector2";
      UniformType2[UniformType2["Vector3"] = 2] = "Vector3";
      UniformType2[UniformType2["Vector4"] = 3] = "Vector4";
      UniformType2[UniformType2["Color"] = 4] = "Color";
      UniformType2[UniformType2["Float32Array"] = 5] = "Float32Array";
      UniformType2[UniformType2["Int32Array"] = 6] = "Int32Array";
      UniformType2[UniformType2["Int32"] = 7] = "Int32";
      return UniformType2;
    })(UniformType || {});

    class UniformNode {
      size;
      memoryInfo;
      bindOnChange;
      _data;
      _type = UniformType.Number;
      _x = 0;
      _y = 0;
      _z = 0;
      _w = 0;
      constructor(value, type) {
        this._type = type || UniformType.Number;
        this.data = value;
      }
      get data() {
        return this._data;
      }
      set data(value) {
        this._data = value;
        if (value instanceof Vector2) {
          this.size = 2;
          this._x = value.x;
          this._y = value.y;
          this._type = UniformType.Vector2;
        } else if (value instanceof Vector3) {
          this.size = 3;
          this._x = value.x;
          this._y = value.y;
          this._z = value.z;
          this._type = UniformType.Vector3;
        } else if (value instanceof Vector4) {
          this.size = 4;
          this._x = value.x;
          this._y = value.y;
          this._z = value.z;
          this._w = value.w;
          this._type = UniformType.Vector4;
        } else if (value instanceof Color) {
          this.size = 4;
          this._x = value.r;
          this._y = value.g;
          this._z = value.b;
          this._w = value.a;
          this._type = UniformType.Color;
        } else if (value instanceof Float32Array) {
          this.size = value.length;
          this._type = UniformType.Float32Array;
        } else if (value instanceof Int32Array) {
          this.size = value.length;
          this._type = UniformType.Int32Array;
        } else {
          this.size = 1;
          this._x = value;
          this._data = value;
          this._type = this._type || UniformType.Number;
        }
      }
      getColor(ret) {
        if (ret) {
          ret.copy(this._data);
        } else {
          ret = this._data;
        }
        return ret;
      }
      get color() {
        let c = new Color(this._data.r, this._data.g, this._data.b, this._data.a);
        return c;
      }
      set color(value) {
        if (this._x != value.r || this._y != value.g || this._z != value.b || this._w != value.a) {
          this._data.r = value.r;
          this._data.g = value.g;
          this._data.b = value.b;
          this._data.a = value.a;
          this._x = value.r;
          this._y = value.g;
          this._z = value.b;
          this._w = value.a;
          this.onChange();
        }
      }
      get value() {
        return this._x;
      }
      set value(value) {
        if (this._x != value) {
          this._data = value;
          this._x = value;
          this.onChange();
        }
      }
      get vector2() {
        return this._data;
      }
      set vector2(value) {
        if (this._x != value.x || this._y != value.y) {
          this._data.x = value.x;
          this._data.y = value.y;
          this._x = value.x;
          this._y = value.y;
          this.onChange();
        }
      }
      get vector3() {
        return this._data;
      }
      set vector3(value) {
        if (this._x != value.x || this._y != value.y || this._z != value.z) {
          this._data.x = value.x;
          this._data.y = value.y;
          this._data.z = value.z;
          this._x = value.x;
          this._y = value.y;
          this._z = value.z;
          this.onChange();
        }
      }
      get vector4() {
        return this._data;
      }
      set vector4(value) {
        if (this._x != value.x || this._y != value.y || this._z != value.z || this._w != value.w) {
          this._data.x = value.x;
          this._data.y = value.y;
          this._data.z = value.z;
          this._data.w = value.w;
          this._x = value.x;
          this._y = value.y;
          this._z = value.z;
          this._w = value.w;
          this.onChange();
        }
      }
      onChange() {
        if (this.bindOnChange) {
          this.bindOnChange();
        }
      }
      float32Array(value) {
        this._data.set(value);
        this.onChange();
      }
      update() {
        switch (this._type) {
          case UniformType.Number:
            this.memoryInfo.dataBytes.setFloat32(0 * Float32Array.BYTES_PER_ELEMENT, this._data, true);
            break;
          case UniformType.Int32:
            this.memoryInfo.dataBytes.setInt32(0 * Int32Array.BYTES_PER_ELEMENT, this._data, true);
            break;
          case UniformType.Vector2:
            this.memoryInfo.setVector2(0, this._data);
            break;
          case UniformType.Vector3:
            this.memoryInfo.setVector3(0, this._data);
            break;
          case UniformType.Vector4:
            this.memoryInfo.setVector4(0, this._data);
            break;
          case UniformType.Color:
            this.memoryInfo.setColor(0, this._data);
            break;
          case UniformType.Float32Array:
            this.memoryInfo.setFloat32Array(0, this._data);
            break;
          case UniformType.Int32Array:
            this.memoryInfo.setInt32Array(0, this._data);
            break;
        }
      }
    }

    class ShaderPassBase {
      /**
       * Shader Unique instance id
       */
      instanceID;
      /**
       * Shader variant value
       */
      shaderVariant;
      /**
       * Vertex stage entry point name
       */
      vsEntryPoint = `main`;
      /**
       * Fragment stage entry point name
       */
      fsEntryPoint = `main`;
      /**
       * The Context3D this pass is bound to. Set on first GPU use via bindCtx.
       * Plan B: a ShaderPass may only be used by one Engine3D.
       */
      _boundCtx = null;
      /**
       * BindGroups — single array owned by the bound Context3D.
       */
      bindGroups = [];
      /**
       * Shader reflection info
       */
      shaderReflection;
      /**
       * The defined syntax value of the Shader when it is precompiled
       */
      defineValue;
      /**
       * The constant value of the Shader when it is precompiled
       */
      constValues;
      /**
       * Uniforms data collection
       */
      uniforms;
      /**
         * Uniform data for materials
         */
      materialDataUniformBuffer;
      /**
       * Internal registry mapping buffer names to their GPU buffer instances.
       */
      _bufferDic;
      /**
       * Flag indicating the shader needs to be recompiled.
       */
      _shaderChange = true;
      /**
       * Flag indicating uniform values changed and need to be reapplied.
       */
      _valueChange = false;
      constructor() {
        this.instanceID = UUID();
        this.defineValue = {};
        this.constValues = {};
        this.uniforms = {};
        this._bufferDic = /* @__PURE__ */ new Map();
      }
      /**
       * notice shader change
       */
      noticeShaderChange() {
        this._shaderChange = true;
      }
      /**
       * notice shader state change
       */
      noticeValueChange() {
        this._valueChange = true;
      }
      /**
      * set storage gpu buffer
      * @param name buffer name
      * @param buffer storage useAge gpu buffer
      */
      setStorageBuffer(name, buffer) {
        const prev = this._bufferDic.get(name);
        this._bufferDic.set(name, buffer);
        if (prev !== buffer) {
          this.noticeBufferChange(name);
        }
      }
      /**
       * Get a previously set storage gpu buffer by name.
       * @param name buffer name
       */
      getStorageBuffer(name) {
        return this._bufferDic.get(name);
      }
      /**
       * set struct storage gpu buffer
       * @param name buffer name
       * @param buffer struct storage useAge gpu buffer
       */
      setStructStorageBuffer(name, buffer) {
        if (this._bufferDic.has(name)) {
          this._bufferDic.set(name, buffer);
          this.noticeBufferChange(name);
        } else {
          this._bufferDic.set(name, buffer);
        }
      }
      /**
       * set uniform gpu buffer min size 256
       * @param name
       * @param buffer
       */
      setUniformBuffer(name, buffer) {
        if (this._bufferDic.has(name)) {
          this._bufferDic.set(name, buffer);
          this.noticeBufferChange(name);
        } else {
          this._bufferDic.set(name, buffer);
        }
      }
      /**
       * Get a previously set uniform gpu buffer by name.
       * @param name buffer name
       */
      getUniformBuffer(name) {
        return this._bufferDic.get(name);
      }
      /**
       * set define value
       * @param defineName 
       * @param value 
       */
      setDefine(defineName, value) {
        if (this.defineValue[defineName] == null || this.defineValue[defineName] != value) {
          this.defineValue[defineName] = value;
          this.noticeValueChange();
          this.noticeShaderChange();
        }
        this.defineValue[defineName] = value;
      }
      /**
       * Whether there is a define key
       * @param defineName 
       * @returns 
       */
      hasDefine(defineName) {
        return this.defineValue[defineName] != null;
      }
      /**
       * delete define value
       * @param defineName 
       */
      deleteDefine(defineName) {
        delete this.defineValue[defineName];
        this.noticeShaderChange();
      }
      /**
       * set uniform float value
       * @param name 
       * @param value 
       */
      setUniformFloat(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value);
          this.noticeValueChange();
        } else {
          this.uniforms[name].value = value;
        }
      }
      /**
       * set uniform int32 value
       * @param name 
       * @param value 
       */
      setUniformInt32(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value, UniformType.Int32);
          this.noticeValueChange();
        } else {
          this.uniforms[name].value = value;
        }
      }
      /**
       * set uniform vector2 value
       * @param name 
       * @param value 
       */
      setUniformVector2(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value);
          this.noticeValueChange();
        } else {
          this.uniforms[name].vector2 = value;
        }
      }
      /**
       * set uniform vector3 value
       * @param name 
       * @param value 
       */
      setUniformVector3(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value);
        } else {
          this.uniforms[name].vector3 = value;
        }
      }
      /**
       * set uniform vector4 value
       * @param name 
       * @param value 
       */
      setUniformVector4(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value);
        } else {
          this.uniforms[name].vector4 = value;
        }
      }
      /**
       * set uniform color value
       * @param name 
       * @param value 
       */
      setUniformColor(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value);
        } else {
          this.uniforms[name].color = value;
        }
      }
      /**
       * set uniform array value
       * @param name 
       * @param value 
       */
      setUniformArray(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value);
        } else {
          this.uniforms[name].float32Array(value);
        }
      }
      /**
       * Set a uniform value of an arbitrary supported type.
       * @param name uniform name
       * @param value uniform value
       */
      setUniform(name, value) {
        if (!this.uniforms[name]) {
          this.uniforms[name] = new UniformNode(value);
        } else {
          this.uniforms[name].data = value;
        }
      }
      /**
       * Get a uniform value by name.
       * @param name uniform name
       */
      getUniform(name) {
        return this.uniforms[name].data;
      }
      /**
       * Get a uniform float value by name.
       * @param name uniform name
       */
      getUniformFloat(name) {
        return this.uniforms[name].data;
      }
      /**
       * Get a uniform vector2 value by name.
       * @param name uniform name
       */
      getUniformVector2(name) {
        return this.uniforms[name].data;
      }
      /**
       * Get a uniform vector3 value by name.
       * @param name uniform name
       */
      getUniformVector3(name) {
        return this.uniforms[name].data;
      }
      /**
       * Get a uniform vector4 value by name.
       * @param name uniform name
       */
      getUniformVector4(name) {
        return this.uniforms[name].data;
      }
      /**
       * Get a uniform color value by name.
       * @param name uniform name
       */
      getUniformColor(name) {
        return this.uniforms[name].color;
      }
      /**
       * Get a registered gpu buffer by name.
       * @param name buffer name
       */
      getBuffer(name) {
        return this._bufferDic[name].data;
      }
      /**
       * Hook invoked when a buffer is added or replaced. Subclasses may override.
       * @param name buffer name
       */
      noticeBufferChange(name) {
      }
      /**
       * Apply pending material uniform data to the GPU when values have changed.
       */
      applyUniform() {
        if (this.materialDataUniformBuffer && this._valueChange) {
          this.materialDataUniformBuffer.apply();
        }
      }
      /**
       * destroy
       */
      destroy(force) {
      }
    }

    var VertexAttributeSize = /* @__PURE__ */ ((VertexAttributeSize2) => {
      VertexAttributeSize2[VertexAttributeSize2["u32"] = 1] = "u32";
      VertexAttributeSize2[VertexAttributeSize2["f32"] = 1] = "f32";
      VertexAttributeSize2[VertexAttributeSize2["vec2<f32>"] = 2] = "vec2<f32>";
      VertexAttributeSize2[VertexAttributeSize2["vec3<f32>"] = 3] = "vec3<f32>";
      VertexAttributeSize2[VertexAttributeSize2["vec4<f32>"] = 4] = "vec4<f32>";
      VertexAttributeSize2[VertexAttributeSize2["float32"] = 1] = "float32";
      VertexAttributeSize2[VertexAttributeSize2["float32x2"] = 2] = "float32x2";
      VertexAttributeSize2[VertexAttributeSize2["float32x3"] = 3] = "float32x3";
      VertexAttributeSize2[VertexAttributeSize2["float32x4"] = 4] = "float32x4";
      return VertexAttributeSize2;
    })(VertexAttributeSize || {});

    let VertexFormat = [null, GPUVertexFormat.float32, GPUVertexFormat.float32x2, GPUVertexFormat.float32x3, GPUVertexFormat.float32x4];

    let ClusterDebug_frag = (
      /*wgsl*/
      `
        var<private> colorSet : array<vec3<f32>, 9> = array<vec3<f32>, 9>(
            vec3<f32>(1.0, 0.0, 0.0),
            vec3<f32>(1.0, 0.5, 0.0),
            vec3<f32>(0.5, 1.0, 0.0),
            vec3<f32>(0.0, 1.0, 0.0),
            vec3<f32>(0.0, 1.0, 0.5),
            vec3<f32>(0.0, 0.5, 1.0),
            vec3<f32>(0.0, 0.0, 1.0),
            vec3<f32>(0.5, 0.0, 1.0),
            vec3<f32>(1.0, 0.0, 0.5)
        );

        #if DEBUG_CLUSTER
        fn debugCluster(fragCoord:vec4<f32>) {
            #if USE_LIGHT
              var tileID : u32 = getClusterId3().z;
              let clusterDebug = vec4<f32>(colorSet[tileID % 9u], 1.0);
              // ORI_FragmentOutput.color = clusterDebug ;
            #endif
          }
      
          fn debugClusterBox(fragCoord:vec4<f32>) {
            #if USE_LIGHT
              let clusterId3 : vec3<u32> = getClusterId3();
              let px = f32(clusterId3.x) / clustersUniform.clusterTileX ;
              let py = f32(clusterId3.y) / clustersUniform.clusterTileY ;
              let pz = f32(clusterId3.z) / clustersUniform.clusterTileZ ;
              // ORI_FragmentOutput.color = vec4<f32>(px,py,pz, 1.0);

              var screenUV = ORI_VertexVarying.fragCoord.xy / vec2<f32>( globalUniform.windowWidth , globalUniform.windowHeight );
              // ORI_FragmentOutput.color = vec4<f32>(screenUV.x,screenUV.y,0.0, 1.0);

              // let clusterId : u32 = getClusterIndex();
              // let cluster = clusterBuffer[clusterId];
        
              // let midPoint : vec3<f32> = (cluster.maxPoint.xyz - cluster.minPoint.xyz) * vec3<f32>(0.5);
              // let center : vec3<f32> = cluster.minPoint.xyz + midPoint;
              // let radius : f32 = length(midPoint) ;
        
              // let fragToBoundsCenter : vec3<f32> = ORI_VertexVarying.viewPosition.xyz - center;
              // let distToBoundsCenter : f32 = length(fragToBoundsCenter);
              // let normDist : f32 = distToBoundsCenter / radius;
              // ORI_FragmentOutput.color = vec4<f32>(normDist,normDist,normDist, 1.0);
            #endif
          }
      
          fn debugClusterLightCount(fragCoord:vec4<f32>){
            #if USE_LIGHT
            //LightIndex
              let cluster : LightIndex = getCluster();
              let lightCount : u32 = u32(cluster.count);
              let lightFactor : f32 = f32(lightCount) / f32(clustersUniform.maxNumLightsPerCluster);
              // ORI_FragmentOutput.color =  mix(vec4<f32>(0.0, 0.0,0.0, 1.0), vec4<f32>(1.0, 1.0, 1.0, 1.0), vec4<f32>(lightFactor, lightFactor, lightFactor, lightFactor));
            #endif
          }
          #endif
    `
    );

    class CubeSky_Shader {
      static sky_vs_frag_wgsl = (
        /* wgsl */
        `
    #include "WorldMatrixUniform"
    #include "GlobalUniform"

    struct uniformData {
      fixOrthProj: mat4x4<f32>,
      enableFixOrthProj: f32,
      exposure: f32,
      roughness: f32
  };

    struct VertexOutput {
      @location(auto) fragUV: vec2<f32>,
      @location(auto) vClipPos: vec4<f32>,
      @location(auto) vWorldPos: vec4<f32>,
      @location(auto) vWorldNormal: vec3<f32>,
      @builtin(position) member: vec4<f32>
    };

    var<private> ORI_VertexOut: VertexOutput ;

    @group(2) @binding(0)
    var<uniform> global: uniformData;

    @vertex
    fn main( 
      @builtin(instance_index) index : u32,
      @location(auto) position: vec3<f32>,
      @location(auto) normal: vec3<f32>,
      @location(auto) uv: vec2<f32>
    ) -> VertexOutput {
      ORI_VertexOut.fragUV = uv;
      let modelMat = models.matrix[u32(index)];
      let vm = modelMat;
      let normalMatrix = mat3x3<f32>(vm[0].xyz,vm[1].xyz,vm[2].xyz);
	    ORI_VertexOut.vWorldNormal = normalize( normalMatrix * normal );
      ORI_VertexOut.vWorldPos = modelMat * vec4<f32>(position.xyz,1.0) ;
      
      var fixProjMat = globalUniform.projMat ;
      if(global.enableFixOrthProj > 0.5){
        fixProjMat = global.fixOrthProj;
      }
      fixProjMat[2].z = 1.0 ;//99999.0 / (99999.0 - 1.0) ;
      fixProjMat[3].z = -1.0 ;//(-1.0 * 99999.0) / (99999.0 - 1.0) ;

      var fixViewMat = globalUniform.viewMat ;
      fixViewMat[3].x = 0.0 ;
      fixViewMat[3].y = 0.0 ;
      fixViewMat[3].z = 0.0 ;

      var clipPos = fixProjMat * fixViewMat * ORI_VertexOut.vWorldPos;
      clipPos.z = clipPos.w;
      ORI_VertexOut.vClipPos = clipPos ;
      ORI_VertexOut.member = clipPos;
      return ORI_VertexOut;
    }
  `
      );
      static sky_fs_frag_wgsl = (
        /* wgsl */
        `
    #include "GlobalUniform"
    #include "MathShader"
    #include "BitUtil"
    #include "ColorUtil_frag"
    #include "FragmentOutput"

    struct uniformData {
        fixOrthProj: mat4x4<f32>,
        enableFixOrthProj: f32,
        exposure: f32,
        roughness: f32
    };

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_cube<f32>;

    @group(2) @binding(0)
    var<uniform> global: uniformData;

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>,@location(auto) vClipPos: vec4<f32>, @location(auto) vWorldPos: vec4<f32>, @location(auto) vWorldNormal: vec3<f32> , @builtin(position) fragCoord : vec4<f32> ) -> FragmentOutput {
        let maxLevel: u32 = textureNumLevels(baseMap);
        let dir = normalize(vWorldPos.xyz);
        var textureColor:vec3<f32> = textureSampleLevel(baseMap, baseMapSampler, normalize(dir.xyz), global.roughness * f32(maxLevel) ).xyz;
        // HDR sky stored as linear; emit as linear so the sRGB
        // swapchain encode produces matching display values to the
        // legacy non-srgb-swapchain + LinearToGammaSpace pairing.

        // let o_Target: vec4<f32> = globalUniform.hdrExposure * vec4<f32>(textureColor, 1.0) * globalUniform.skyExposure ;
        // global.exposure is the per-sky-material control (SkyMaterial.exposure /
        // AtmosphericComponent.exposure GUI slider) — previously unused here, so
        // the slider had no visible effect. globalUniform.skyExposure is the
        // separate scene-wide multiplier; both apply.
        let o_Target: vec4<f32> = vec4<f32>(textureColor, 1.0) * globalUniform.skyExposure * global.exposure;
        var fixProjMat = globalUniform.projMat ;
        if(global.enableFixOrthProj > 0.5){
          fixProjMat = global.fixOrthProj;
        }
        let finalMatrix = fixProjMat * globalUniform.viewMat ;
        let nMat = mat3x3<f32>(finalMatrix[0].xyz,finalMatrix[1].xyz,finalMatrix[2].xyz) ;
        let ORI_NORMALMATRIX = transpose(inverse( nMat ));
       
        var vNormal = (ORI_NORMALMATRIX * -vWorldNormal );
        var gBuffer = packGBuffer(
          -globalUniform.far,
          vec3f(0.0),
          o_Target.rgb,
          vec3f(0.0),
          vNormal
        ) ;
      var fragmentOutput:FragmentOutput;
      #if USE_CASTREFLECTION
        fragmentOutput.gBuffer = gBuffer ;
      #else
        fragmentOutput.color = o_Target ;
        fragmentOutput.gBuffer = gBuffer ;
      #endif

      #if USE_OUTDEPTH
        fragmentOutput.out_depth = fragCoord.z ;
      #endif
      return fragmentOutput;
    }

    fn packGBuffer(depth:f32, albedo:vec3f,hdrLighting:vec3f,rmao:vec3f,normal:vec3f) -> vec4f{
        var gBuffer : vec4f ;
        var octUVNormal = (octEncode(normalize(normal)) + 1.0) * 0.5 ;

        var yc = f32(r11g11b9_to_float(vec3f(octUVNormal,0.0))) ;
        #if USE_CASTREFLECTION
          var rgbm = EncodeRGBM(hdrLighting);
          var zc = f32(pack4x8unorm(vec4f(rgbm.rgb,0.0))) ;
          var wc = f32(pack4x8unorm(vec4f(rmao.rg,rgbm.a,0.0)));
        #else
          var zc = f32(vec4fToFloat_7bits(vec4f(albedo.rgb,0.0)));
          var wc = f32(r22g8_to_float(vec2f(f32(0.0),rmao.g)));
        #endif
    
        gBuffer.x = depth  ;
        gBuffer.y = yc ;
        gBuffer.z = zc ;
        gBuffer.w = wc ;
        return gBuffer ;
    }
    `
      );
    }

    let LightingFunction_frag = (
      /*wgsl*/
      `
#include "BRDF_frag"
#include "ClusterLight"
#include "ShadowMapping_frag"

#if USE_IES_PROFILE
  #include "IESProfiles_frag"
#endif



const PI2 = 3.1415926 * 3.1415926 ;

fn sampleLighting(light:LightData,direction:vec3f,iblSpecularResult:vec3f , intensity :f32 , shadow:f32 ) -> vec3f{
  var ret = vec3f(0.0);
  var normalDir  = fragData.N;
  var viewDir    = fragData.V;

  var lightDir   = normalize(-direction.xyz);
  var halfDir    = normalize(lightDir + viewDir);
  var reflectDir = normalize(reflect(-viewDir,normalDir));

  var NdotH = max(0.00001,dot(normalDir,halfDir));
  var NdotL = max(0.00001,dot(normalDir,lightDir));
  var NdotV = max(0.00001,dot(normalDir,viewDir));
  var HdotL = max(0.00001,dot(halfDir,lightDir));

  var baseColor = fragData.Albedo.rgb ; 
  var metallic = fragData.Metallic ;
  var roughness = fragData.Roughness ;

  var lightColor = getHDRColor( light.lightColor.rgb , light.linear )  ;
  var att = max(0.0,intensity);
  
  var lighting:vec3f = lightContribution(NdotH,NdotL,NdotV,HdotL,fragData.Roughness,fragData.Albedo.rgb / 3.14, metallic ,shadow,fragData.F0,lightColor.rgb);
  // ACES is now applied as a final post-pass (TonemapPost) so the
  // light contribution stays linear HDR here. Just modulate by
  // attenuation. Direct premultiply matches the standard PBR
  // totalDirect accumulation done before the final tonemap.
  lighting = lighting * att;
  return lighting ;
}

fn directLighting( light:LightData, iblSpecularResult: vec3f) -> vec3<f32> {
    var color = vec3<f32>(0.0);
    #if USE_LIGHT
      var L = normalize(light.direction.xyz);
      #if USE_BRDF
        var shadow = directShadowVisibility[(light.castShadow)];
        color = sampleLighting(light, L, iblSpecularResult, light.intensity, shadow);
      #endif 
    #endif 
    return color;
}

fn directDulLighting( albedo:vec3<f32>, N:vec3<f32>, V:vec3<f32>,  roughness:f32 , metallic:f32 , light:LightData , shadowBias:f32 ) -> vec3<f32> {
  var color = vec3<f32>(0.0) ;
  #if USE_LIGHT
    var L = -normalize(light.direction.xyz) ;
    let lightCC = pow( light.lightColor.rgb,vec3<f32>(2.2));
    var lightColor = getHDRColor( lightCC.rgb , light.linear )  ;
    var att = light.intensity;
    if(light.castShadow>=0){
        #if USE_SHADOWMAPING
          for (var j: i32 = 0; j < 8; j += 1) {
              if(j == light.castShadow){
                att *= directShadowVisibility[j] ; 
              }
          }
        #endif
    }
    #if USE_LAMBERT
      color = vec3<f32>(1.0,1.0,1.0) ;
    #endif 
    
    #if USE_BRDF
      color = 0.85 * simpleBRDF(albedo,N,V,L,att,lightColor,0.85 * roughness,metallic) ;
      color += 0.15 * simpleBRDF(albedo,N,V,L,att,lightColor,0.15 * roughness,metallic) ;
    #endif 
  #endif 
  return color;
}

fn directHairLighting( albedo:vec3<f32>, N:vec3<f32>, V:vec3<f32>,  roughness:f32 , metallic:f32 , light:LightData , shadowBias:f32 ) -> vec3<f32> {
  var color = vec3<f32>(0.0) ;
  #if USE_LIGHT
    var L = -normalize(light.direction.xyz) ;
    let lightCC = pow( light.lightColor.rgb,vec3<f32>(2.2));
    var lightColor = getHDRColor( lightCC.rgb , light.linear )  ;
    var att = light.intensity;
    if(light.castShadow>=0){
        #if USE_SHADOWMAPING
          for (var j: i32 = 0; j < 8; j += 1) {
              if(j == light.castShadow){
                att *= directShadowVisibility[j] ; 
              }
          }
        #endif
    }
    #if USE_LAMBERT
      color = vec3<f32>(1.0,1.0,1.0) ;
    #endif 
    
    #if USE_BRDF
      color = 0.5 * simpleBRDF(albedo,N,V,L,att,lightColor,0.85 ,metallic) ;
      color += 0.5 * simpleBRDF(albedo,N,V,L,att,lightColor,0.15 ,metallic) ;
    #endif 
  #endif 
  return color;
}


fn pointLighting( WP:vec3<f32>, light:LightData , iblSpecularResult : vec3f ) -> vec3<f32> {
    var color = vec3<f32>(0.0) ;
    let lightPos = light.position.xyz;
    var dir = lightPos.xyz - WP ;
    let dist = length(dir);
    if(dist != 0.0){
      dir *= 1.0 / dist ;
    }
    if( abs(dist) < light.range ){
        var L = dir ;
        var atten = 1.0 ;
        atten = 1.0 - smoothstep(0.0,light.range,dist) ;
        atten *= 1.0 / max(light.radius,0.001)  ;

        // if( light.castShadow >= 0 )
        // {
        //     #if USE_SHADOWMAPING
        //       for (var j: i32 = 0; j < 8; j += 1) {
        //           if(j == light.castShadow){
        //             atten *= pointShadows[j] ; 
        //           }
        //       }
        //     #endif
        // }

        var shadow = pointShadows[i32(light.castShadow)] ;

        #if USE_IES_PROFILE
            atten *= getLightIESProfileAtt(WP,light);
        #endif

        atten *= sphere_unit(light.range,light.intensity) ;

        color = sampleLighting(light,-L,iblSpecularResult,atten,shadow);
    } 
    return color ;
}

fn pointAtt( WP:vec3<f32>, light:LightData ) -> f32 {
  var atten = 0.0 ;
  let lightPos = light.position.xyz;
  var dir = lightPos.xyz - WP ;
  let dist = length(dir);
  if(dist != 0.0){
    dir *= 1.0 / dist ;
  }
  if( abs(dist) < light.range ){
      var L = dir ;
      atten = 1.0 - smoothstep(0.0,light.range,dist) ;
      atten *= 1.0 / max(light.radius,0.001)  ;
      var shadow = pointShadows[i32(light.castShadow)] ;
      #if USE_IES_PROFILE
          atten *= getLightIESProfileAtt(WP,light);
      #endif
      atten *= sphere_unit(light.range,light.intensity) ;
  } 
  return atten ;
}

fn getDistanceAtten(  light:LightData , dist : f32 ) -> f32 {
  return 1.0 - smoothstep(0.0,light.range,dist) ;
}

fn spotLighting( WP:vec3<f32>, light:LightData , iblSpecularResult : vec3f) -> vec3<f32> {
    let lightPos = light.position.xyz;
    var dir = lightPos.xyz - WP ;
    let dist = length(dir) ;
    if(dist != 0.0){
      dir *= 1.0 / dist ;
    }

    var color = vec3<f32>(0.0) ;
    if( abs(dist) < light.range * 2.0 ){
        var L = dir ;
        let theta = dot(-L, normalize(light.direction));
        let angle = acos(theta) ;
        var atten = 1.0 ;
        var lightColor = light.lightColor.rgb  ;

        atten = 1.0 - smoothstep(0.0,light.range,dist) ;
        atten *= 1.0 / max(light.radius,0.001) ;
        if(angle < light.outerCutOff){
          if(angle > light.innerCutOff){
            atten *= 1.0 - smoothstep(light.innerCutOff, light.outerCutOff, angle) ;
          }
        }else{
            atten = 0.0 ;
        }

        var shadow = pointShadows[i32(light.castShadow)] ;

        #if USE_IES_PROFILE
            atten *= getLightIESProfileAtt(WP,light);
        #endif

        atten *= sphere_unit(light.range, light.intensity) ;

        color = sampleLighting(light,-L,iblSpecularResult,atten,shadow);
    }
    return  color ;
}

fn sphere_unit( radius:f32 , intensity:f32 ) -> f32 {
  return intensity / (4.0 * PI2 * radius * radius) ;
}
`
    );

    let MathShader = (
      /* wgsl */
      `
  #include 'BitUtil'
  // fn getViewPosition(z:f32,uv:vec2f) -> vec3f {
  //   let pvMatrix = globalUniform.projMat * globalUniform.viewMat ;
  //   let worldPos = getWorldPosition(z,uv) ;
  //   var viewPos = pvMatrix * worldPos ;
  //   return viewPos.xyz;
  // }

  

  struct TBN_ret{
    tan:vec3f,
    bit:vec3f,
  }
  
  fn TBN( N:vec3f) -> mat3x3<f32>{
    //Returns the simple tangent space matrix
    var Nb : vec3f;
    var Nt : vec3f;
    if (abs(N.y)>0.999) {
        Nb = vec3f(1.0,0.0,0.0);
        Nt = vec3f(0.0,0.0,1.0);
    } else {
      Nb = normalize(cross(N,vec3f(0.0,1.0,0.0)));
      Nt = normalize(cross(Nb,N));
    }

    var mat3 = mat3x3<f32>(
      Nb.x,Nt.x,N.x,
      Nb.y,Nt.y,N.y,
      Nb.z,Nt.z,N.z
    );

    return mat3;
  }

  fn TBN_out( N : vec3f ) -> TBN_ret {
      var tbn_ret : TBN_ret;
      //Returns the simple tangent space directions
      if (abs(N.y)>0.999) {
          tbn_ret.tan = vec3f(1.0,0.0,0.0);
          tbn_ret.bit = vec3f(0.0,0.0,1.0);
      } else {
          tbn_ret.tan = normalize(cross(N,vec3f(0.0,1.0,0.0)));
          tbn_ret.bit = normalize(cross(tbn_ret.tan,N));
      }

      return tbn_ret;
  }


  fn ARand21( uv: vec2f) -> f32 {
      //Returns 1D noise from 2D
      return fract(sin(uv.x*uv.y)*403.125+cos(dot(uv,vec2f(13.18273,51.2134)))*173.137);
  }

fn applyQuaternion(position:vec3<f32>, q:vec4<f32>) -> vec3<f32>{
  let x:f32 = position.x;
  let y:f32 = position.y;
  let z:f32 = position.z;

  let qx:f32 = q.x;
  let qy:f32 = q.y;
  let qz:f32 = q.z;
  let qw:f32 = q.w;

  let ix:f32 = qw * x + qy * z - qz * y;
  let iy:f32 = qw * y + qz * x - qx * z;
  let iz:f32 = qw * z + qx * y - qy * x;
  let iw:f32 = -qx * x - qy * y - qz * z;

  var ret: vec3<f32>;
  ret.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
  ret.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
  ret.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;

  return ret;
}

fn inverse( m:mat3x3<f32>) -> mat3x3<f32>{
  var a00 = m[0][0];
  var a01 = m[0][1];
  var a02 = m[0][2];
  var a10 = m[1][0];
  var a11 = m[1][1];
  var a12 = m[1][2];
  var a20 = m[2][0];
  var a21 = m[2][1];
  var a22 = m[2][2];

  var b01 = a22 * a11 - a12 * a21;
  var b11 = -a22 * a10 + a12 * a20;
  var b21 = a21 * a10 - a11 * a20;

  var det = a00 * b01 + a01 * b11 + a02 * b21 ;
  return mat3x3<f32>(
      vec3<f32>(b01/ det, (-a22 * a01 + a02 * a21)/ det, (a12 * a01 - a02 * a11)/ det),
      vec3<f32>(b11/ det, (a22 * a00 - a02 * a20)/ det, (-a12 * a00 + a02 * a10)/ det),
      vec3<f32>(b21/ det, (-a21 * a00 + a01 * a20)/ det, (a11 * a00 - a01 * a10)/ det)
  );
}


fn inverseMat4x4(m: mat4x4f) -> mat4x4f {
    let a00 = m[0][0]; let a01 = m[0][1]; let a02 = m[0][2]; let a03 = m[0][3];
    let a10 = m[1][0]; let a11 = m[1][1]; let a12 = m[1][2]; let a13 = m[1][3];
    let a20 = m[2][0]; let a21 = m[2][1]; let a22 = m[2][2]; let a23 = m[2][3];
    let a30 = m[3][0]; let a31 = m[3][1]; let a32 = m[3][2]; let a33 = m[3][3];

    let b00 = a00 * a11 - a01 * a10;
    let b01 = a00 * a12 - a02 * a10;
    let b02 = a00 * a13 - a03 * a10;
    let b03 = a01 * a12 - a02 * a11;
    let b04 = a01 * a13 - a03 * a11;
    let b05 = a02 * a13 - a03 * a12;
    let b06 = a20 * a31 - a21 * a30;
    let b07 = a20 * a32 - a22 * a30;
    let b08 = a20 * a33 - a23 * a30;
    let b09 = a21 * a32 - a22 * a31;
    let b10 = a21 * a33 - a23 * a31;
    let b11 = a22 * a33 - a23 * a32;

    let det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

    return mat4x4f(
        a11 * b11 - a12 * b10 + a13 * b09,
        a02 * b10 - a01 * b11 - a03 * b09,
        a31 * b05 - a32 * b04 + a33 * b03,
        a22 * b04 - a21 * b05 - a23 * b03,
        a12 * b08 - a10 * b11 - a13 * b07,
        a00 * b11 - a02 * b08 + a03 * b07,
        a32 * b02 - a30 * b05 - a33 * b01,
        a20 * b05 - a22 * b02 + a23 * b01,
        a10 * b10 - a11 * b08 + a13 * b06,
        a01 * b08 - a00 * b10 - a03 * b06,
        a30 * b04 - a31 * b02 + a33 * b00,
        a21 * b02 - a20 * b04 - a23 * b00,
        a11 * b07 - a10 * b09 - a12 * b06,
        a00 * b09 - a01 * b07 + a02 * b06,
        a31 * b01 - a30 * b03 - a32 * b00,
        a20 * b03 - a21 * b01 + a22 * b00) * (1 / det);
}

fn dir_to_faceId(pt:vec3<f32>) -> i32 {
    //**** nx px ny py nz pz
    var abs_x = abs(pt.x);
    var abs_y = abs(pt.y);
    var abs_z = abs(pt.z);
    var coord = max(max(abs_x, abs_y), abs_z);
    if(coord == -pt.x){  return 0;}
    if(coord == pt.x) { return 1;}

    if(coord == -pt.y){  return 2;}
    if(coord == pt.y) { return 3;}

    if(coord == -pt.z) { return 4;}
    return 5;
  }

  const us = 1.0 /6.0 ;
  fn uv_2_xyz(u:f32,v:f32) -> vec3f 
  {
    let face = floor(u / us);
    var uu = (u - face * us) / us ;

    var uc = 2.0 * uu - 1.0;
    var vc = 2.0 * v - 1.0;
    var xyz = vec3f(0,0,0);

    if(face == 0.0){
    // x,y,z = 1.0,vc,-uc
      xyz = vec3f(1.0,-vc,uc);
    }else if(face == 1.0){
    // x,y,z = -1.0,vc,uc
      xyz = vec3f(-1.0,-vc,-uc);
    }else if(face == 2.0){
    // x,y,z = uc,1.0,-vc
      xyz = vec3f(uc,1.0,-vc);
    }else if(face == 3.0){
    // x,y,z = uc,-1.0,vc
      xyz = vec3f(uc,-1.0,vc);
    }else if(face == 4.0){
    // x,y,z = uc,vc,1.0
      xyz = vec3f(-uc,-vc,1.0);
    }else if(face == 5.0){
    // x,y,z = -uc,vc,-1.0
      xyz = vec3f(uc,-vc,-1.0);
    }
    return xyz ;
  }

  fn convert_xyz_to_cube_uv(x:f32, y:f32, z:f32 ) -> vec2f
  {
    var dir = vec3f(x, y, z);
    var absX = abs(dir.x);
    var absY = abs(dir.y);
    var absZ = abs(dir.z);

    var isXPositive = 0;
    if(dir.x > 0.0){isXPositive = 1;}
    var isYPositive = 0;
    if(dir.y > 0.0){isYPositive = 1;}
    var isZPositive = 0;
    if(dir.z > 0.0){isZPositive = 1;}

    var maxAxis:f32 = 0.0;
    var uc:f32 = 0.0;
    var vc:f32 = 0.0;

    // POSITIVE X
    if (isXPositive == 1 && absX >= absY && absX >= absZ) {
      // u (0 to 1) goes from +z to -z
      // v (0 to 1) goes from -y to +y
      maxAxis = absX;
      uc = -z;
      vc = y;
    }
    // NEGATIVE X
    if (isXPositive ==0 && absX >= absY && absX >= absZ) {
      // u (0 to 1) goes from -z to +z
      // v (0 to 1) goes from -y to +y
      maxAxis = absX;
      uc = z;
      vc = y;
    }
    // POSITIVE Y
    if (isYPositive==1 && absY >= absX && absY >= absZ) {
      // u (0 to 1) goes from -x to +x
      // v (0 to 1) goes from +z to -z
      maxAxis = absY;
      uc = x;
      vc = -z;
    }
    // NEGATIVE Y
    if (isYPositive ==0 && absY >= absX && absY >= absZ) {
      // u (0 to 1) goes from -x to +x
      // v (0 to 1) goes from -z to +z
      maxAxis = absY;
      uc = x;
      vc = z;
    }
    // POSITIVE Z
    if (isZPositive == 1&& absZ >= absX && absZ >= absY) {
      // u (0 to 1) goes from -x to +x
      // v (0 to 1) goes from -y to +y
      maxAxis = absZ;
      uc = x;
      vc = y;
    }
    // NEGATIVE Z
    if (isZPositive ==0 && absZ >= absX && absZ >= absY) {
      // u (0 to 1) goes from +x to -x
      // v (0 to 1) goes from -y to +y
      maxAxis = absZ;
      uc = -x;
      vc = y;
    }

    // Convert range from -1 to 1 to 0 to 1
    var u = 0.5f * (uc / maxAxis + 1.0f);
    var v = 0.5f * (vc / maxAxis + 1.0f);

    return vec2f(u, v);
  }

    // Returns ±1
    fn signNotZero( v1:vec2<f32>) -> vec2<f32> {
        var v:vec2<f32> = v1;
        if(v.x >= 0.0){
            v.x = 1.0;
        }else{
            v.x = -1.0;
        }
        if(v.y >= 0.0){
            v.y = 1.0;
        }else{
            v.y= -1.0;
        }
        return v;
    }

    fn octEncode( v:vec3<f32> ) -> vec2<f32> {
        var l1norm = abs(v.x) + abs(v.y) + abs(v.z);
        var result = v.xy * (1.0 / l1norm);
        if (v.z < 0.0) {
            result = (1.0 - abs(result.yx)) * signNotZero(result.xy);
        }
        return result;
    }

    // Returns a unit vector. Argument o is an octahedral vector packed via octEncode,on the [-1, +1] square*/
    fn octDecode( o:vec2<f32> ) -> vec3<f32> {
        var v = vec3<f32>(o.x, o.y, 1.0 - abs(o.x) - abs(o.y));
        if (v.z < 0.0) {
            var tmp = (1.0 - abs(v.yx)) * signNotZero(v.xy);
            v.x = tmp.x;
            v.y = tmp.y;
        }
        return normalize(v);
    }

    fn Linear01Depth(z:f32,near:f32,far:f32)-> f32{
        let ZBufferZ = (-1.0+(far/near)) / far;
        let ZBufferW = near /far ;
        return 1.0 / (ZBufferZ * z + ZBufferW) ;
    }

    
    fn LinearizeDepth( depth:f32 , nearPlane:f32 , farPlane:f32 )-> f32 {
      var z = depth * 2.0 - 1.0;
      return (2.0 * nearPlane * farPlane) / (farPlane + nearPlane - z * (farPlane - nearPlane));
    }

    fn logDepth(depth : f32, far:f32) -> f32 {
      return log2(depth + 1.0) * 2.0 / (log(far + 1.0) / 0.6931471805599453) * 0.5;
    }

    // Logarithmic depth in WebGPU NDC [0, 1].
    //   L(w) = log2(1 + w) / log2(far + 1),   w = view-space distance.
    //
    // VS and FS target the SAME ndc.z function — only the input w
    // differs. log2Depth runs in VS on per-vertex clip.w and
    // pre-multiplies by w to survive the perspective divide;
    // log2DepthFixPersp runs in FS on the perspective-correctly
    // interpolated clip.w to recover the true per-pixel log curve that
    // rasterizer-interpolated clip.z drifts away from on long triangles.
    //
    // Earlier ports of the Outerra OpenGL snippet kept a (1 + x) / 2
    // remap that converted OpenGL's [-1, 1] ndc.z to its [0, 1] depth
    // buffer. WGSL ndc.z is already [0, 1], so the remap was pure waste
    // and squeezed the usable depth range to [0.5, 1]. The inverse
    // (inverseLog2Depth in GBufferStand) and decal-pass decode were
    // both written against the un-remapped L; this collapses VS/FS to
    // match them.
    fn log2Depth01(w:f32, far:f32) -> f32 {
      return log2(max(1e-6, 1.0 + w)) / log2(far + 1.0);
    }

    fn log2Depth(depth:f32, near:f32, far:f32) -> f32 {
      return log2Depth01(depth, far) * depth;
    }

    fn log2DepthFixPersp(depth:f32, near:f32, far:f32) -> f32 {
      return log2Depth01(depth, far);
    }


    fn QuaternionToMatrix(q: vec4<f32>) -> mat4x4<f32> {
      // If q is guaranteed to be a unit quaternion, s will always
      // be 1.  In that case, this calculation can be optimized out.
      //float norm = GetNorm (q);
      //float s = (norm > 0.0) ? 2.0/norm : 0;

      var result: mat4x4<f32>;
  
      // Precalculate coordinate products
      let x = q.x * 2.0;
      let y = q.y * 2.0;
      let z = q.z * 2.0;
      let xx = q.x * x;
      let yy = q.y * y;
      let zz = q.z * z;
      let xy = q.x * y;
      let xz = q.x * z;
      let yz = q.y * z;
      let wx = q.w * x;
      let wy = q.w * y;
      let wz = q.w * z;
  
      // Calculate 3x3 matrix from orthonormal basis
      result[0][0] = 1.0 - (yy + zz);
      result[0][1] = xy + wz;
      result[0][2] = xz - wy;
      result[0][3] = 0.0;
  
      result[1][0] = xy - wz;
      result[1][1] = 1.0 - (xx + zz);
      result[1][2] = yz + wx;
      result[1][3] = 0.0;
  
      result[2][0] = xz + wy;
      result[2][1] = yz - wx;
      result[2][2] = 1.0 - (xx + yy);
      result[2][3] = 0.0;
  
      result[3][0] = 0.0;
      result[3][1] = 0.0;
      result[3][2] = 0.0;
      result[3][3] = 1.0;

      return result;
    }

    fn MakeScaleMatrix(scale: vec3<f32>) -> mat4x4<f32> {
        return mat4x4<f32>(
          scale.x, 0.0, 0.0, 0.0,
          0.0, scale.y, 0.0, 0.0,
          0.0, 0.0, scale.z, 0.0,
          0.0, 0.0, 0.0, 1.0,
        );
    }

    fn MakeRotationMatrix(rotationQuaternion: vec4<f32>) -> mat4x4<f32> {
        return QuaternionToMatrix(rotationQuaternion);
    }

    fn MakeTranslationMatrix(translation: vec3<f32>) -> mat4x4<f32> {
        return mat4x4<f32>(
          1.0, 0.0, 0.0, 0.0,
          0.0, 1.0, 0.0, 0.0,
          0.0, 0.0, 1.0, 0.0,
          translation.x, translation.y, translation.z, 1.0,
        );
    }

    fn MakeMatrix4x4(scale: vec3<f32>, rotationQuaternion: vec4<f32>, translation: vec3<f32>) -> mat4x4<f32> {
        var scaleMat: mat4x4<f32> = MakeScaleMatrix(scale);
        var rotationMat: mat4x4<f32> = MakeRotationMatrix(rotationQuaternion);
        var translationMat: mat4x4<f32> = MakeTranslationMatrix(translation);
        return translationMat * scaleMat * rotationMat;
    }

    fn mixMatrix4x4(a: mat4x4<f32>, b: mat4x4<f32>, t:f32) -> mat4x4<f32> {
      return a * (1.0 - t) + b * t;
      // return mat4x4<f32>(
      //   mix(a[0], b[0], t),
      //   mix(a[1], b[1], t),
      //   mix(a[2], b[2], t),
      //   mix(a[3], b[3], t)
      // );
    }

    fn decodeDepth( color:vec4<f32> ) -> f32{
      var depth = 0.0 ;
      const bitShifts = vec4<f32>(1.0 / (256.0 * 256.0 * 256.0), 1.0 / (256.0 * 256.0), 1.0 / 256.0, 1.0); 
      depth = dot(color, bitShifts);
      return depth;
    }

    fn encodeDepth( depth:f32 ) -> vec4<f32>{
      const bitSh  = vec4<f32>(256.0 * 256.0 * 256.0, 256.0 * 256.0, 256.0, 1.0);
      const bitMsk = vec4<f32>(0, 1.0 / 256.0, 1.0 / 256.0, 1.0 / 256.0);
      var comp:vec4<f32>;
      comp  = depth * bitSh;
      comp  = fract(comp);
      comp -= comp.xxyz * bitMsk;
      return comp;
    }

    fn calculateBillboardMatrix2(eye:vec3f,pos:vec3f,up:vec3f) -> mat3x3<f32> {
      
      let zAxis: vec3f = -normalize(pos.xyz - eye);
      var xAxis: vec3f = cross(up,zAxis);
      xAxis = normalize(cross(zAxis,xAxis));
      let yAxis = normalize(cross(zAxis, xAxis));
      return mat3x3<f32>(xAxis, yAxis, zAxis);
    }

    struct SH9Struct{
      SHAr:vec4f,
      SHAg:vec4f,
      SHAb:vec4f,
      SHBr:vec4f,
      SHBg:vec4f,
      SHBb:vec4f,
      SHC:vec4f,
    }

    fn ShadeSH9 ( normal:vec4f , sh9:SH9Struct) -> vec3f
    {
      var x1:vec3f = vec3f(0.0);
      var x2:vec3f = vec3f(0.0);
      var x3:vec3f = vec3f(0.0);
      
      // Linear + constant polynomial terms
      x1.r = dot(sh9.SHAr,normal);
      x1.g = dot(sh9.SHAg,normal);
      x1.b = dot(sh9.SHAb,normal);
      
      // 4 of the quadratic polynomials
      var vB = normal.xyzz * normal.yzzx;
      x2.r = dot(sh9.SHBr,vB);
      x2.g = dot(sh9.SHBg,vB);
      x2.b = dot(sh9.SHBb,vB);
      
      // Final quadratic polynomial
      var vC = normal.x*normal.x - normal.y*normal.y;
      x3 = sh9.SHC.rgb * vC;
      return x1 + x2 + x3;
    } 

    fn clipViewUV(viewRectangle:vec4f,size:vec2f,fragCoord:vec2f) -> vec2u {
        let subViewUV = (fragCoord - viewRectangle.xy) / viewRectangle.zw ;
        return vec2u(subViewUV*size) ;
    }

    fn insideRectangle( point:vec2f , rec:vec4f) -> bool {
      if( point.x > rec.x &&  point.y > rec.y &&  point.x < (rec.x + rec.z ) &&  point.y < (rec.y + rec.w ) ){
         return true ;
      }
      return false;
    }

    fn convert_cube_uv_to_xyz( index:i32,  u:f32,  v:f32) -> vec3f
    {
      var ret : vec3f ;
      // convert range 0 to 1 to -1 to 1
      var uc = 2.0f * u - 1.0f;
      var vc = 2.0f * v - 1.0f;
      switch (index)
      {
        case 0: {
          ret.x =  1.0f; 
          ret.y =    vc; 
          ret.z =   -uc; 
          break;
        }	// POSITIVE X
        case 1: {
          ret.x = -1.0f; 
          ret.y =    vc; 
          ret.z =    uc; 
          break;
        }	// NEGATIVE X
        case 2: {
          ret.x =    uc; 
          ret.y =  1.0f; 
          ret.z =   -vc; 
          break;
        }	// POSITIVE Y
        case 3: {
          ret.x =    uc; 
          ret.y = -1.0f; 
          ret.z =    vc; 
          break;
        }	// NEGATIVE Y
        case 4: {
          ret.x =    uc; 
          ret.y =    vc; 
          ret.z =  1.0f; 
          break;
        }	// POSITIVE Z
        case 5: {
          ret.x =   -uc; 
          ret.y =    vc; 
          ret.z = -1.0f; 
          break;
        }	// NEGATIVE Z
        default:{
          ret = vec3f(0.0);
        }
      }
      return ret ;
    }

    fn convert_cube_uv_to_normal( index:i32, u:f32, v:f32) -> vec3f
    {
      var ret : vec3f ;
      // convert range 0 to 1 to -1 to 1
      var uc = 2.0f * u - 1.0f;
      var vc = 2.0f * v - 1.0f;
      switch (index)
      {
        case 0: {
          ret.x =  1.0f; 
          ret.y =    vc; 
          ret.z =   -uc; 
          break;
        }	// POSITIVE X
        case 1: {
          ret.x = -1.0f; 
          ret.y =    vc; 
          ret.z =    uc; 
          break;
        }	// NEGATIVE X
        case 2: {
          ret.x =    uc; 
          ret.y =  1.0f; 
          ret.z =   -vc; 
          break;
        }	// POSITIVE Y
        case 3: {
          ret.x =    uc; 
          ret.y = -1.0f; 
          ret.z =    vc; 
          break;
        }	// NEGATIVE Y
        case 4: {
          ret.x =    uc; 
          ret.y =    vc; 
          ret.z =  1.0f; 
          break;
        }	// POSITIVE Z
        case 5: {
          ret.x =   -uc; 
          ret.y =    vc; 
          ret.z = -1.0f; 
          break;
        }	// NEGATIVE Z
        default:{
          ret = vec3f(0.0);
        }
      }
      return ret ;
    }

    fn UvToDir( uv1:vec2f) -> vec3f{
      var uv = uv1 ;
      uv *= vec2f(2.0*3.1415926535897932384626433832795, 3.1415926535897932384626433832795);
      var theta = uv.y;
      var phi = uv.x + 3.1415926535897932384626433832795 * 0.5 ;
      // var phi = uv.x ;
      var dir = vec3f(0.0,0.0,0.0);
      dir.x = sin(phi) * sin(theta) * -1;
      dir.y = cos(theta) * -1;
      dir.z = cos(phi) * sin(theta);
      return dir;
    }

    fn DirTOUV( a_coords:vec3f ) ->vec2f
    {
      var coords = normalize(a_coords);
      var lon = atan2(coords.z, coords.x);
      var lat = acos(coords.y);
      var sphereCoords = vec2f(lon, lat) * (1.0 / 3.1415926535897932384626433832795);
      return vec2f(sphereCoords.x * 0.5 + 0.5 , 1.0 - sphereCoords.y);
      // return vec2f(sphereCoords.y, (sphereCoords.x * 0.5 ));
    }
    
`
    );

    let PhysicMaterialUniform_frag = (
      /* wgsl */
      `
          #if USE_CUSTOMUNIFORM
          #else
              struct MaterialUniform {
                  baseColor: vec4<f32>,
                  emissiveColor: vec4<f32>,
                  materialF0: vec4<f32>,
                  specularColor: vec4<f32>,

                  envIntensity: f32,
                  normalScale: f32,
                  roughness: f32,
                  metallic: f32,

                  ao: f32,
                  roughness_min: f32,
                  roughness_max: f32,
                  metallic_min: f32,

                  metallic_max: f32,
                  emissiveIntensity: f32,
                  alphaCutoff: f32,
                  ior: f32,

                  clearcoatColor: vec4<f32>,

                  clearcoatWeight: f32,
                  clearcoatFactor: f32,
                  clearcoatRoughnessFactor: f32,
                  clearcoatIor: f32,

                  transmissionFactor: f32,
                  thicknessFactor: f32,
                  attenuationDistance: f32,
                  transmissionAlphaMode: f32,

                  attenuationColor: vec4<f32>,

                  baseMapOffsetSize:vec4<f32>,
                  normalMapOffsetSize:vec4<f32>,
                  emissiveMapOffsetSize:vec4<f32>,
                  roughnessMapOffsetSize:vec4<f32>,
                  metallicMapOffsetSize:vec4<f32>,
                  aoMapOffsetSize:vec4<f32>,
              };
        #endif
      
        @group(2) @binding(0)
        var<uniform> materialUniform: MaterialUniform;
      `
    );

    let UnLitMaterialUniform_frag = (
      /* wgsl */
      `


#if USE_CUSTOMUNIFORM
#else
    struct MaterialUniform {
      transformUV1:vec4<f32>,
      transformUV2:vec4<f32>,
      baseColor: vec4<f32>,
      alphaCutoff: f32,
    };
#endif


@group(2) @binding(0)
var<uniform> materialUniform: MaterialUniform;
`
    );

    let UnLit_frag = (
      /*wgsl*/
      `
    #include "Common_frag"
    #include "GlobalUniform"

    fn UnLit(){
        let alpha = ORI_ShadingInput.BaseColor.a ;
        // Engine-wide premultiplied-alpha convention: COLOR pass output is
        // (rgb*alpha, alpha). BlendMode.NORMAL/ALPHA pair with srcFactor=one
        // so the blend math becomes rgb*alpha + dst*(1-alpha). ADD pairs
        // with (one, one) — transparent pixels (alpha=0) zero out at source,
        // killing PNG-transparent-region rgb noise that would otherwise leak
        // through additive blends. OIT_DEPTH_PEEL is the exception: its
        // sub-passes premultiply downstream in Common_frag, so emit
        // straight-alpha there to avoid alpha^2.
        var viewColorPremul = vec4<f32>(ORI_ShadingInput.BaseColor.rgb * alpha , alpha) ;
        var vNormal = ORI_VertexVarying.vWorldNormal.rgb ;
        let gBuffer = packNHMDGBuffer(
            getGBufferDepth(),
            vec3f(0.0),
            viewColorPremul.rgb,
            vec3f(1.0,0.0,0.0),
            vNormal,
            alpha
          ) ;

          #if USE_OIT_DEPTH_PEEL
            ORI_FragmentOutput.color = viewColorPremul;
          #else
            #if USE_CASTREFLECTION
              ORI_FragmentOutput.gBuffer = gBuffer;
            #else
              ORI_FragmentOutput.gBuffer = gBuffer;
              ORI_FragmentOutput.color = viewColorPremul;
            #endif
          #endif
    }

    fn debugFragmentOut(){

    }
`
    );

    let VertexAttributes = (
      /*wgsl*/
      `
    struct VertexAttributes{
        @builtin(instance_index) index : u32,
        @location(auto) position: vec3<f32>,
        @location(auto) normal: vec3<f32>,
        @location(auto) uv: vec2<f32>,
        @location(auto) TEXCOORD_1: vec2<f32>,

        #if USE_TANGENT
            @location(auto) TANGENT: vec4<f32>,
        #endif

        #if USE_SKELETON || USE_METAHUMAN
            @location(auto) joints0: vec4<f32>,
            @location(auto) weights0: vec4<f32>,
            #if USE_JOINT_VEC8
                @location(auto) joints1: vec4<f32>,
                @location(auto) weights1: vec4<f32>,
            #endif
        #endif

        #if USE_MORPHTARGETS || USE_METAHUMAN
            @location(auto) vIndex: f32,
        #endif
    }
`
    );
    let VertexAttributes_vert = (
      /*wgsl*/
      `
    #include "VertexAttributes"
    #include "VertexOutput"
    #include "VertexFunction_vert"
`
    );

    let VertexOutput = (
      /*wgsl*/
      `
    struct VertexOutput {
    @location(auto) @interpolate(flat) index: f32,
    @location(auto) varying_UV0: vec2<f32>,
    @location(auto) varying_UV1: vec2<f32>,
    @location(auto) varying_ViewPos: vec4<f32>,
    @location(auto) varying_Clip: vec4<f32>,
    @location(auto) varying_WPos: vec4<f32>,
    @location(auto) varying_WNormal: vec3<f32>,
    @location(auto) varying_Color: vec4<f32>,

    #if USE_SHADOWMAPING
        @location(auto) varying_ShadowPos: vec4<f32>,
    #endif

    #if USE_TANGENT
        @location(auto) varying_Tangent: vec4<f32>,
    #endif

    #if USE_TRANSMISSION
        // Per-instance model scale derived from worldMat[i].xyz lengths
        // in vertex stage; consumed by PBRLitShader's KHR_materials_volume
        // refraction ray (transmissionRay = thickness * refractDir *
        // modelScale) so non-uniform-scaled meshes refract correctly.
        @location(auto) varying_ModelScale: vec3<f32>,
    #endif


    @builtin(position) member: vec4<f32>
    };
`
    );

    class SkeletonAnimation_shader {
      static groupBindingAndFunctions(beginGroup, beginBinding) {
        return (
          /* wgsl */
          `
            struct JointsMatrix {
                matrix : array<mat4x4<f32>>
            };

            @group(${beginGroup}) @binding(${beginBinding})
            var<storage, read> jointsMatrixIndexTable: array<f32>;

            @group(${beginGroup}) @binding(${beginBinding + 1})
            var<storage, read> jointsInverseMatrix: JointsMatrix;

            @group(${beginGroup}) @binding(${beginBinding + 2})
            var<storage, read> jointsIndexMapingTable: array<f32>;

            const MAX_JOINT_NUM = 8;
            fn getSkeletonWorldMatrix(joints: array<f32, MAX_JOINT_NUM>, weights: array<f32, MAX_JOINT_NUM>, num: u32) -> mat4x4<f32> {
                var result: mat4x4<f32>;
                for(var i: u32 = 0; i < num; i = i + 1) {
                    let jointId = i32(joints[i]);
                    let jointIndex = u32(jointsIndexMapingTable[jointId]);
                    let jointMatrixIndex = u32(jointsMatrixIndexTable[jointIndex]);
                    let joint = models.matrix[jointMatrixIndex] * jointsInverseMatrix.matrix[jointId] * weights[i];
                    result += joint;
                }
                return result;
            }

            fn getSkeletonWorldMatrix_4(joints: vec4<f32>, weights: vec4<f32>) -> mat4x4<f32> {
                return getSkeletonWorldMatrix(array<f32, MAX_JOINT_NUM>(
                    joints.x, joints.y, joints.z, joints.w,
                    0, 0, 0, 0,
                ), array<f32, MAX_JOINT_NUM>(
                    weights.x, weights.y, weights.z, weights.w,
                    0, 0, 0, 0,
                ), 4);
            }
    
            fn getSkeletonWorldMatrix_8(joints0: vec4<f32>, weights0: vec4<f32>, joints1: vec4<f32>, weights1: vec4<f32>) -> mat4x4<f32> {
                return getSkeletonWorldMatrix(array<f32, MAX_JOINT_NUM>(
                    joints0.x, joints0.y, joints0.z, joints0.w,
                    joints1.x, joints1.y, joints1.z, joints1.w,
                ), array<f32, MAX_JOINT_NUM>(
                    weights0.x, weights0.y, weights0.z, weights0.w,
                    weights1.x, weights1.y, weights1.z, weights1.w,
                ), 8);
            }
        `
        );
      }
    }

    let VertexFunction_vert = (
      /*wgsl*/
      `
    var<private> PI: f32 = 3.14159265359;
    #if USE_METAHUMAN
        ${MorphTarget_shader.getMorphTargetShaderBinding(3, 0)}
        ${SkeletonAnimation_shader.groupBindingAndFunctions(3, 2)}
    #else
        #if USE_MORPHTARGETS
            ${MorphTarget_shader.getMorphTargetShaderBinding(3, 0)}
        #endif

        #if USE_SKELETON
            ${SkeletonAnimation_shader.groupBindingAndFunctions(3, 0)}
        #endif
    #endif

    var<private> ORI_VertexOut: VertexOutput ;

    fn ORI_Vert(vertex:VertexAttributes){
    var vertexPosition = vertex.position;
    var vertexNormal = vertex.normal;

    // glTF 2.0 spec: skinned-mesh vertex positions are pre-transformed
    // into world-bind frame by the exporter, and the skinning matrix
    // (sum of weight * jointWorld * invBind) maps them from world-bind
    // to current world. The mesh node worldMatrix is intentionally
    // IGNORED — multiplying it in would double-transform the vertex
    // when the mesh node has a non-identity world (e.g. Kira's
    // Kira_Hair_A.0020 at Y=-0.404). User transforms applied to the
    // loader root reach the skinned mesh through the bone chain
    // (joints live-parented under the gltf ancestor), not through
    // mesh node lineage.
    #if USE_METAHUMAN
        ${MorphTarget_shader.getMorphTargetCalcVertex()}
        #if USE_JOINT_VEC8
            let skeletonNormal = getSkeletonWorldMatrix_8(vertex.joints0, vertex.weights0, vertex.joints1, vertex.weights1);
            ORI_MATRIX_M = skeletonNormal ;
        #else
            let skeletonNormal = getSkeletonWorldMatrix_4(vertex.joints0, vertex.weights0);
            ORI_MATRIX_M = skeletonNormal ;
        #endif
    #else
        #if USE_MORPHTARGETS
            ${MorphTarget_shader.getMorphTargetCalcVertex()}
        #endif

        #if USE_SKELETON
            #if USE_JOINT_VEC8
                let skeletonNormal = getSkeletonWorldMatrix_8(vertex.joints0, vertex.weights0, vertex.joints1, vertex.weights1);
                ORI_MATRIX_M = skeletonNormal ;
            #else
                let skeletonNormal = getSkeletonWorldMatrix_4(vertex.joints0, vertex.weights0);
                ORI_MATRIX_M = skeletonNormal ;
            #endif
        #endif
    #endif

    ORI_NORMALMATRIX = transpose(inverse( mat3x3<f32>(ORI_MATRIX_M[0].xyz,ORI_MATRIX_M[1].xyz,ORI_MATRIX_M[2].xyz) ));

    #if USE_TANGENT
        ORI_VertexOut.varying_Tangent = vec4f(normalize(ORI_NORMALMATRIX * vertex.TANGENT.xyz),vertex.TANGENT.w)  ;
    #endif

    var worldPos = (ORI_MATRIX_M * vec4<f32>(vertexPosition.xyz, 1.0));
    var viewPosition = ORI_MATRIX_V * worldPos;
    var clipPosition = ORI_MATRIX_P * viewPosition ;

    #if USE_LOGDEPTH
        clipPosition.z = log2Depth(clipPosition.w, globalUniform.near, globalUniform.far);
    #endif

    ORI_CameraWorldDir = normalize(ORI_CAMERAMATRIX[3].xyz - worldPos.xyz) ;

    ORI_VertexOut.index = f32(vertex.index) ;

    ORI_VertexOut.varying_UV0 = vertex.uv.xy ;

    ORI_VertexOut.varying_UV1 = vertex.TEXCOORD_1.xy;

    ORI_VertexOut.varying_ViewPos = viewPosition ;
    ORI_VertexOut.varying_Clip = clipPosition ;
    ORI_VertexOut.varying_WPos = worldPos ;
    ORI_VertexOut.varying_WPos.w = f32(vertex.index);
    ORI_VertexOut.varying_WNormal = normalize(ORI_NORMALMATRIX * vertexNormal.xyz) ;

    #if USE_TRANSMISSION
        // length(worldMat[i].xyz) recovers the per-axis scale even for
        // non-uniform / sheared instance transforms. For uniform scale
        // it collapses to (s, s, s); for unscaled meshes (1, 1, 1).
        // Includes skinning effect because ORI_MATRIX_M may have been
        // multiplied by skeletonNormal above — which is correct for
        // skinned glass too.
        ORI_VertexOut.varying_ModelScale = vec3<f32>(
            length(ORI_MATRIX_M[0].xyz),
            length(ORI_MATRIX_M[1].xyz),
            length(ORI_MATRIX_M[2].xyz)
        );
    #endif

    ORI_VertexOut.member = clipPosition ;
    }
`
    );

    let VideoUniform_frag = (
      /* wgsl */
      `
struct MaterialUniform {
  transformUV1:vec4<f32>,
  transformUV2:vec4<f32>,
  baseColor: vec4<f32>,
  rectClip: vec4<f32>,
  alphaCutoff: f32,
};

@group(2) @binding(0)
var<uniform> materialUniform: MaterialUniform;
`
    );

    let IrradianceVolumeData_frag = (
      /*wgsl*/
      `
    struct IrradianceVolumeData {
        //0
        orientationIndex:f32,
            hysteresis:f32,
            OctRTSideSize:f32,
            OctRTMaxSize:f32,

            //1
            startX:f32,
            startY:f32,
            startZ:f32,
            ProbeSpace:f32,

            //2
            gridXCount:f32,
            gridYCount:f32,
            gridZCount:f32,
            maxDistance:f32,

            //3
            depthSharpness:f32,
            ProbeSourceTextureSize:f32,
            ProbeSize:f32,
            bounceIntensity:f32,

            //4
            probeRoughness:f32,
            normalBias:f32,
            irradianceChebyshevBias:f32,
            rayNumber:f32,

            //5
            irradianceDistanceBias:f32,
            indirectIntensity:f32,
            ddgiGamma:f32,
            lerpHysteresis:f32,
            //6

            debugX:f32,
            debugY:f32,
            debugZ:f32,
            slot0:f32,

            //..
            v7:vec4<f32>,
    }
`
    );

    let Inline_vert = (
      /*wgsl*/
      `
    #include "MathShader"
    #include "FastMathShader"
    #include "InstanceUniform"

    var<private> ORI_MATRIX_P: mat4x4<f32>;
    var<private> ORI_MATRIX_V: mat4x4<f32>;
    var<private> ORI_MATRIX_M: mat4x4<f32>;
    var<private> ORI_MATRIX_PV: mat4x4<f32>;
    var<private> ORI_MATRIX_PInv: mat4x4<f32>;
    var<private> ORI_MATRIX_World: mat4x4<f32>;
    var<private> ORI_CAMERAMATRIX: mat4x4<f32>;
    var<private> ORI_NORMALMATRIX: mat3x3<f32>;
    var<private> ORI_CameraWorldDir: vec3<f32>;
    var<private> ORI_ViewDir: vec3<f32>;

    fn TIME() -> vec3f {
        return vec3f(globalUniform.frame, globalUniform.time , globalUniform.delta);
    }

    fn TIME_frame() -> f32 {
        return globalUniform.frame ;
    }

    fn TIME_time() -> f32 {
        return globalUniform.time ;
    }

    fn TIME_delta() -> f32 {
        return globalUniform.delta ;
    }

    fn MOUSE() -> vec2f {
        return vec2f( globalUniform.mouseX, globalUniform.mouseY) ;
    }

    fn SCREEN() -> vec2f {
        return vec2f( globalUniform.windowWidth, globalUniform.windowHeight) ;
    }

    fn ProjectionParams() -> vec3f {
        return vec3f( globalUniform.near, globalUniform.far,1.0 + 1.0 / globalUniform.far) ;
    }

    fn vertex_inline(vertex:VertexAttributes){
        ORI_MATRIX_P = globalUniform.projMat ;
        ORI_MATRIX_V = globalUniform.viewMat ;
        ORI_MATRIX_PV = ORI_MATRIX_P * ORI_MATRIX_V ;
        ORI_MATRIX_PInv = globalUniform.projMatInv ;
        ORI_CAMERAMATRIX = globalUniform.cameraWorldMatrix ;
        
        ORI_MATRIX_M = models.matrix[u32(vertex.index)];
        
        #if USE_INSTANCEDRAW
            let modelID = instanceDrawID.matrixIDs[vertex.index];
            ORI_MATRIX_M = models.matrix[modelID];
        #endif

        if (globalUniform.useRTE != 0) {
            #if USE_INSTANCEDRAW
                UpdateWorldMatrixToRTE_PrivatePtr(u32(modelID), &ORI_MATRIX_M);
            #else
                UpdateWorldMatrixToRTE_PrivatePtr(u32(vertex.index), &ORI_MATRIX_M);
            #endif
        }
    }
`
    );

    let Common_frag = (
      /*wgsl*/
      `
  #include "GlobalUniform"
  #include "FragmentVarying"
  #include "FragmentOutput"
  #include "ShadingInput"
  #include "ColorUtil_frag"
  #include "BitUtil"

  var<private> ORI_FragmentOutput: FragmentOutput;
  var<private> ORI_VertexVarying: FragmentVarying;
  var<private> ORI_ShadingInput: ShadingInput;
  var<private> viewDir:vec3<f32>;
  var<private> modelIndex:u32;
  
  @fragment
  fn FragMain( vertex_varying:FragmentVarying ) -> FragmentOutput {
   
    modelIndex = u32(round(vertex_varying.index)) ; 

    ORI_VertexVarying = vertex_varying;
    ORI_VertexVarying.vWorldNormal = normalize(vertex_varying.vWorldNormal);
    ORI_FragmentOutput.color = vec4<f32>(1.0, 0.0, 0.0, 1.0);
    viewDir = normalize(globalUniform.CameraPos.xyz - ORI_VertexVarying.vWorldPos.xyz) ;

    frag();
    
    #if USE_DEBUG
      debugFragmentOut();
    #endif

    #if USE_DEFAULTFRAGOUT
      // let finalMatrix = globalUniform.projMat * globalUniform.viewMat ;
      // let nMat = mat3x3<f32>(finalMatrix[0].xyz,finalMatrix[1].xyz,finalMatrix[2].xyz) ;
      // let ORI_NORMALMATRIX = transpose(inverse( nMat ));
      // var vNormal = normalize(ORI_NORMALMATRIX * (ORI_VertexVarying.vWorldNormal));

      // let gBuffer = packNHMDGBuffer(
      //   ORI_VertexVarying.fragCoord.z,
      //   ORI_ShadingInput.BaseColor.rgb,
      //   ORI_ShadingInput.BaseColor.rgb,
      //   vec3f(ORI_ShadingInput.Roughness,ORI_ShadingInput.Metallic,ORI_ShadingInput.AmbientOcclusion),
      //   ORI_ShadingInput.Normal,
      //   ORI_ShadingInput.Opacity
      // ) ;
    #endif

    #if USE_OUTDEPTH
      #if USE_LOGDEPTH
        ORI_FragmentOutput.out_depth = log2DepthFixPersp(ORI_VertexVarying.fragPosition.w, globalUniform.near, globalUniform.far);
      #else
        ORI_FragmentOutput.out_depth = ORI_ShadingInput.FragDepth ;
      #endif
    #endif

    #if USE_OIT_DEPTH_PEEL_DEPTH
      // Dual Depth Peeling — depth-extraction sub-pass.
      //
      // Dual-depth-peel algorithm: each pixel maintains (depth_min,
      // depth_max) in an RG32F MRT cleared to (-MAX_DEPTH, -MAX_DEPTH).
      // Every transparent fragment writes vec4(-fragDepth, fragDepth)
      // and the attachment is configured with MAX blend (per-channel),
      // so after one geometry pass the MRT contains:
      //
      //   .r = max(-d_i)  =  -min(d_i)   →  nearest fragment depth
      //   .g = max( d_i)                 →  furthest fragment depth
      //
      // Subsequent peel iterations (stage 3) read the previous-pass
      // depth MRT, skip fragments whose depth is at the boundary
      // (already rendered) or outside (already peeled), and write the
      // depth of the next-nearest / next-furthest fragments. Stage 2
      // implements only the init pass — full per-iteration peeling
      // logic with prev-pass texelFetch lands in stage 3.
      //
      // fragCoord is the @builtin(position) — its .z is NDC depth in
      // [0, 1], the same value the depth-test uses, which is what we
      // want to peel by.
      let _ddpDepth = ORI_VertexVarying.fragCoord.z;
      ORI_FragmentOutput.color = vec4<f32>(-_ddpDepth, _ddpDepth, 0.0, 0.0);
    #endif

    #if USE_OIT_DEPTH_PEEL_FRONT
      // Dual Depth Peeling — front-color accumulation sub-pass.
      //
      // The front-color MRT accumulates layers in front-to-back order
      // via the over operator. For each peeled layer:
      //   newFront = prevFront + (1 - prevFront.a) * (rgb*α, α)
      //
      // When any layer reaches α=1, prevFront.a becomes 1 and all
      // subsequent contributions are zeroed — the front-most fragment
      // dominates and α=1 is naturally opaque. This is the property
      // weighted-blended OIT cannot replicate at small scene scales.
      //
      // Stage 2 outputs the premultiplied current-layer colour. Stage 3
      // adds the texelFetch of prev-pass front MRT and the over-operator
      // composition. Until then the result is just "first peeled layer"
      // which roughly matches the init pass's contribution.
      let _ddpAlpha = clamp(ORI_FragmentOutput.color.a, 0.0, 1.0);
      ORI_FragmentOutput.color = vec4<f32>(ORI_FragmentOutput.color.rgb * _ddpAlpha, _ddpAlpha);
    #endif

    #if USE_OIT_DEPTH_PEEL_BACK
      // Dual Depth Peeling — back-color accumulation sub-pass.
      //
      // The back-color MRT accumulates layers in back-to-front order via
      // an under-blend (associative). Final composite (in resolve
      // feature, stage 4):
      //   final = bg·(1 - frontA) + frontColor + (1 - frontA)·backColor
      //
      // Stage 2 outputs premultiplied current-layer colour; stage 3 adds
      // the layer-discrimination logic (only fragments at the current
      // peel iteration's furthest depth contribute here).
      let _ddpAlpha = clamp(ORI_FragmentOutput.color.a, 0.0, 1.0);
      ORI_FragmentOutput.color = vec4<f32>(ORI_FragmentOutput.color.rgb * _ddpAlpha, _ddpAlpha);
    #endif

    #if USE_OIT_ACCUM
      // Weighted-Blended OIT (McGuire and Bavoil 2013, Eq. 7).
      //
      // BxDF_frag / UnLit_frag pre-multiply rgb by alpha, so the .rgb
      // here is already lit·α. WBOIT compositing wants:
      //   accum.rgb = sum(rgb · α · w)   →  we multiply by w
      //   accum.a   = sum(α · w)         →  we write α·w into the .a slot
      //   reveal.r  = product(1 − α)     →  multiplicative blend on gBuffer.r
      //
      // Weight formula per the paper: w = alpha * clamp(0.03 / (1e-5 + (z/200)^4), 1e-2, 3e3).
      //
      // The previous implementation did two things wrong:
      //   1. fed fragCoord.z (post-projection NDC depth in [0,1]) into
      //      the formula. The paper's z is LINEAR eye-space depth in
      //      world units (centred around the [0, ~200] expected by the
      //      z/200 term). NDC depth packs non-linearly and for anything
      //      past the near plane saturates the depth term to its 3000
      //      cap, making every fragment's weight identical. With
      //      identical weights, accum.rgb / accum.a degenerates to a
      //      plain colour average — every transparent stack rendered
      //      as "milky averaged" regardless of alpha (the alpha factor
      //      cancels in the ratio when w is constant).
      //   2. used alpha^4 + depth_term (additive, with alpha
      //      exponentiated) instead of alpha · depth_term
      //      (multiplicative). The additive form let the depth-
      //      saturated 3000 dominate so alpha had no effect at all on
      //      the contribution; the multiplicative form scales the
      //      per-fragment contribution by alpha directly.
      //
      // Compute linear depth from the world-space position via the view
      // matrix — globalUniform.viewMat is already bound. Take abs(z)
      // because the camera looks down −z in eye space.
      //
      // WGSL spec reserves leading double-underscore identifiers; we
      // use single-underscore prefixes.
      {
        let _oitAlpha = clamp(ORI_FragmentOutput.color.a, 0.0, 1.0);
        let _eyePos = (globalUniform.viewMat * vec4<f32>(ORI_VertexVarying.vWorldPos.xyz, 1.0)).xyz;
        let _oitZ = abs(_eyePos.z);
        let _oitW = _oitAlpha * clamp(
          0.03 / (1e-5 + pow(_oitZ / 200.0, 4.0)),
          0.01, 3000.0
        );
        ORI_FragmentOutput.color = vec4<f32>(ORI_FragmentOutput.color.rgb * _oitW, _oitAlpha * _oitW);
        ORI_FragmentOutput.gBuffer = vec4<f32>(_oitAlpha, 0.0, 0.0, 0.0);
      }
    #endif

    return ORI_FragmentOutput ;
  }


  fn packNHMDGBuffer(depth:f32, albedo:vec3f,hdrLighting:vec3f,rmao:vec3f,normal:vec3f,alpha:f32) -> vec4f  {
      var gBuffer : vec4f ;
      var octUVNormal = (octEncode(normalize( (normal) )) + 1.0) * 0.5 ;
      var yc = f32(r11g11b9_to_float(vec3f(octUVNormal,rmao.r))) ;
      #if USE_CASTREFLECTION
        var rgbm = EncodeRGBM(hdrLighting);
        var zc = f32(pack4x8unorm(vec4f(rgbm.rgb,0.0))) ;
        var wc = f32(pack4x8unorm(vec4f(rmao.rg,rgbm.a,0.0)));
      #else
        var zc = f32(vec4fToFloat_7bits(vec4f(albedo.rgb,alpha)));
        var wc = f32(r22g8_to_float(vec2f(f32(modelIndex)/f_r22g8.r,rmao.g)));
      #endif

      gBuffer.x = depth  ;
      gBuffer.y = yc ;
      gBuffer.z = zc ;
      gBuffer.w = wc ;
      return gBuffer ;
  }

  // Per-pixel scene depth for the compressed gBuffer.x channel.
  //
  // Under USE_LOGDEPTH the rasterizer-interpolated fragCoord.z drifts from
  // the true logarithmic curve on long triangles (the curve is non-linear
  // in clip.w; the rasterizer interpolates ndc.z linearly in screen-space
  // with perspective correction, which is only exact for functions linear
  // in 1/w). clip.w itself IS interpolated exactly because it's linear in
  // view-space, so we recompute via log2DepthFixPersp — the same function
  // FragMain writes into @builtin(frag_depth), making gBuffer.x agree with
  // _MainDepthTexture at every pixel. Without log-z the rasterizer value
  // is already exact.
  fn getGBufferDepth() -> f32 {
    #if USE_LOGDEPTH
      return log2DepthFixPersp(ORI_VertexVarying.fragPosition.w, globalUniform.near, globalUniform.far);
    #else
      return ORI_VertexVarying.fragCoord.z;
    #endif
  }

  fn transformUV( uv:vec2f , offsetScale:vec4f ) -> vec2f{
     return uv * offsetScale.zw + offsetScale.xy ;
  }

`
    );

    let Common_vert = (
      /*wgsl*/
      `
    #include "WorldMatrixUniform"
    #include "VertexAttributes_vert"
    #include "GlobalUniform"
    #include "Inline_vert"
    @vertex
    fn VertMain( vertex:VertexAttributes ) -> VertexOutput {
        vertex_inline(vertex);
        vert(vertex);
        return ORI_VertexOut ;
    }
`
    );

    let BrdfLut_frag = (
      /*wgsl*/
      `
    @group(1) @binding(auto)
    var brdflutMapSampler: sampler;
    @group(1) @binding(auto)
    var brdflutMap: texture_2d<f32>;
`
    );

    let EnvMap_frag = (
      /*wgsl*/
      `
    @group(1) @binding(auto)
    var prefilterMapSampler: sampler;
    @group(1) @binding(auto)
    var prefilterMap: texture_cube<f32>;
    @group(1) @binding(auto)
    var envMapSampler: sampler;
    @group(1) @binding(auto)
    var envMap: texture_cube<f32>;
`
    );

    class CSM {
      /**
       * Number of shadow cascades used by the CSM technique.
       */
      static Cascades = 4;
    }

    function GlobalUniform(maxShadowMapNum) {
      return (
        /* wgsl */
        `
  #include "MathShader"

  struct GlobalUniform {

    projMat: mat4x4<f32>,
    viewMat: mat4x4<f32>,
    cameraWorldMatrix: mat4x4<f32>,
    projMatInv : mat4x4<f32>,
    viewToWorld : mat4x4<f32>,
    shadowMatrix: array<mat4x4<f32>, ${maxShadowMapNum}>,

    csmShadowBias: vec4<f32>,

    csmMatrix: array<mat4x4<f32>,${CSM.Cascades}>,
    
    shadowLights:mat4x4<f32>,

    reflectionProbeSize:f32,
    reflectionProbeMaxCount:f32,
    reflectionMapWidth:f32,
    reflectionMapHeight:f32,

    reflectionCount:f32,
    test2:f32,
    test3:f32,
    test4:f32,

    CameraPos: vec3<f32>,
    frame: f32,
    SH:  array<vec4f, 9u> ,

    time: f32,
    delta: f32,
    shadowBias: f32,
    skyExposure: f32,

    renderPassState:f32,
    quadScale: f32,
    hdrExposure: f32,
    renderState_left: i32,

    renderState_right: i32,
    renderState_split: f32,
    mouseX: f32,
    mouseY: f32,

    windowWidth: f32,
    windowHeight: f32,
    near: f32,
    far: f32,

    pointShadowBias: f32,
    shadowMapSize: f32,
    shadowSoft: f32,
    pcfKernelScale: f32,

    enableCSM:f32,


    csmMargin:f32,
    nDirShadowStart: i32,
    nDirShadowEnd: i32,
    nPointShadowStart: i32,

    nPointShadowEnd: i32,
    cameraForward:vec3f,

    frustumPlanes: array<vec4f, 6u>,

    cameraPositionH: vec3<f32>,
    maxModelsCount: u32,

    cameraPositionL: vec3<f32>,
    cameraMatrixIndex: u32,

    useRTE: u32,
  };

  @group(0) @binding(0)
  var<uniform> globalUniform: GlobalUniform;

  fn getViewPosition(z:f32,uv:vec2f) -> vec3f {
    let projMatInv = globalUniform.projMatInv ;
    let clip = vec4<f32>((uv * 2.0 - 1.0) , z , 1.0);
    var viewPos = projMatInv * clip ;
    return viewPos.xyz / viewPos.w ;
  }

  fn getWorldPosition(z:f32,uv:vec2f) -> vec3f {
    let viewToWorld = globalUniform.viewToWorld ;
    let clip = vec4<f32>((uv * 2.0 - 1.0) , z , 1.0);
    var worldPos = viewToWorld * clip ;
    worldPos = worldPos / worldPos.w ;
    return worldPos.xyz ;
  }

  var<private> NORMALMATRIX_INV : mat3x3<f32> ;
  var<private> NORMALMATRIX : mat3x3<f32> ;
  fn useNormalMatrix()  {
     let finalMatrix = globalUniform.projMat * globalUniform.viewMat ;
     let nMat = mat3x3<f32>(finalMatrix[0].xyz,finalMatrix[1].xyz,finalMatrix[2].xyz) ;
     NORMALMATRIX = transpose(inverse( nMat ));
  }

  fn useNormalMatrixInv()  {
    let finalMatrix = globalUniform.projMat * globalUniform.viewMat ;
    let nMat = mat3x3<f32>(finalMatrix[0].xyz,finalMatrix[1].xyz,finalMatrix[2].xyz) ;
    NORMALMATRIX_INV = transpose(( nMat ));
  }

  fn getWorldNormal(viewNormal:vec3f) -> vec3f {
    var worldNormal = NORMALMATRIX_INV * viewNormal ;
    return normalize(worldNormal.xyz);
  }

  fn getViewNormal(worldNormal:vec3f) -> vec3f {
    var viewNormal = globalUniform.viewMat * vec4f(worldNormal,0.0) ;
    return normalize(viewNormal.xyz);
  }
  `
      );
    }

    let InstanceUniform = (
      /*wgsl*/
      `
    #if USE_INSTANCEDRAW
        struct InstanceUniform {
            matrixIDs : array<i32>
        };
        @group(2) @binding(7)
        var<storage, read> instanceDrawID : InstanceUniform;
    #endif
`
    );

    let WorldMatrixUniform = (
      /*wgsl*/
      `
    struct Uniforms {
        matrix : array<mat4x4<f32>>
    };

    @group(0) @binding(1)
    var<storage, read> models : Uniforms;

    struct DoubleWorldPosition {
        high: vec4<f32>,
        low: vec4<f32>,
    };

    fn GetDoubleWorldPosition(index: u32) -> DoubleWorldPosition {
        var result: DoubleWorldPosition;
        let m = models.matrix[globalUniform.maxModelsCount + index / 2];
        let i = index % 2 * 2;
        result.high = m[i + 0];
        result.low = m[i + 1];
        return result;
    }

    fn SubtractSplitDoubles(aH:vec3<f32>, aL:vec3<f32>, bH:vec3<f32>, bL:vec3<f32>) -> vec3<f32> {
        var hi = aH - bH;
        // fix iOS/Mac 
        if (length(hi) == 0.0) {
            hi = vec3f(0, 0, 0);
        }
        let low = aL - bL;
        return hi + low;
    }

    fn UpdateWorldMatrixToRTE(modelMatrixIndex: u32, pWorldMatrix: ptr<function, mat4x4<f32>>) {
        let modelWorldPosHL = GetDoubleWorldPosition(modelMatrixIndex);
        let rtePos = SubtractSplitDoubles(modelWorldPosHL.high.xyz, modelWorldPosHL.low.xyz, globalUniform.cameraPositionH, globalUniform.cameraPositionL);
        (*pWorldMatrix)[3] = vec4<f32>(rtePos, 1.0);
    }

    fn UpdateWorldMatrixToRTE_PrivatePtr(modelMatrixIndex: u32, pWorldMatrix: ptr<private, mat4x4<f32>>) {
        let modelWorldPosHL = GetDoubleWorldPosition(modelMatrixIndex);
        let rtePos = SubtractSplitDoubles(modelWorldPosHL.high.xyz, modelWorldPosHL.low.xyz, globalUniform.cameraPositionH, globalUniform.cameraPositionL);
        (*pWorldMatrix)[3] = vec4<f32>(rtePos, 1.0);
    }
`
    );

    let FastMathShader = (
      /*wgsl*/
      `
  fn pow2(  x : f32 ) -> f32
  {
      return x * x;
  }

  fn pow2v3(  x : vec3f ) -> vec3f
  {
      return x * x;
  }


  fn pow3(  x : f32 ) -> f32
  {
      var xx = x*x;
      return x * xx;
  }

  fn pow4(  x : f32 ) -> f32
  {
      var xx = x*x;
      return xx * xx;
  }

  fn pow5(x: f32) -> f32 {
      var x2 = x * x;
      return x2 * x2 * x;
  }

  fn rcp( x:f32 ) -> f32
  {
      return 1.0 / x;
  }

  fn rsqrt3( a : vec3<f32> ) -> vec3<f32>
  {
    return pow(a, vec3<f32>(-0.5));
  }

  fn rsqrt( a : f32 ) -> f32
  {
    return pow(a, -0.5);
  }

  fn squareF( a : f32 ) -> f32
  {
    return a * a;
  }

  fn squareV2( a : vec2f ) -> vec2f
  {
    return a * a;
  }

  fn squareV3( a : vec3f ) -> vec3f
  {
    return a * a;
  }

  fn sqrtFast(  x : f32  ) -> f32 
  {
    var i = i32(x);
    i = 0x1FBD1DF5 + (i / 2 );
    return f32(i);
  }

  fn lengthFast(  v :vec3<f32> ) -> f32
  {
    var LengthSqr = dot(v,v);
    return sqrtFast( LengthSqr );
  }

  fn asinFast( x:f32 )-> f32
  {
      return (0.5 * PI) - acosFast(x);
  }

  fn acosFast( inX: f32 ) -> f32
  {
      var x = abs(inX);
      var res = -0.156583 * x + (0.5 * PI);
      res *= sqrt(1.0 - x);

    if(inX >= 0.0){
      return res ;
    }else{
      return PI - res ;
    }
  }

  fn acosFast4( inX : f32 )-> f32
  {
    var x1 = abs(inX);
    var x2 = x1 * x1;
    var x3 = x2 * x1;
    var s = 0.0 ;

    s = -0.2121144 * x1 + 1.5707288;
    s = 0.0742610 * x2 + s;
    s = -0.0187293 * x3 + s;
    s = sqrt(1.0 - x1) * s;

    // acos function mirroring
    // check per platform if compiles to a selector - no branch neeeded
    if(inX >= 0.0){
      return s ;
    }else{
      return PI - s ;
    }
  }
`
    );

    let NormalMap_frag = (
      /*wgsl*/
      `

    fn perturbNormal(  worldPos:vec3<f32>,  surf_norm:vec3<f32>,  mapN:vec3<f32> , normalScale:f32 , face:f32 ) -> vec3<f32> {
        var q0 = vec3<f32>( dpdx( worldPos.x ), dpdx( worldPos.y ), dpdx( worldPos.z ) );
        var q1 = vec3<f32>( dpdy( worldPos.x ), dpdy( worldPos.y ), dpdy( worldPos.z ) );
        var st0 = dpdx( ORI_VertexVarying.fragUV0.xy );
        var st1 = dpdy( ORI_VertexVarying.fragUV0.xy );
        var N = surf_norm;
        var q0perp = cross( N, q0 );
        var q1perp = cross( q1, N );

        // #if USE_TANGENT
        //     var T = ORI_VertexVarying.TANGENT.xyz ;
        // #else
            var T = q1perp * st0.x + q0perp * st1.x;
        // #endif
        
        var B = q1perp * st0.y + q0perp * st1.y;

        var det = max( dot( T, T ), dot( B, B ) );
        var scale = 1.0 ;
        if( det != 0.0 ){
            scale = inverseSqrt( det ) ;
        }

        // #if USE_TANGENT
        //     scale = scale * ORI_VertexVarying.TANGENT.w ;
        // #endif

        scale *= normalScale;
        return normalize( (T * ( -mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z ) * face ) ;
    }

    fn unpackNormalMap( normal : vec3<f32> ) -> vec3<f32>
    {
        var normalTex = vec3<f32>( normal.xyz * 2.0 - 1.0 ) ;
        return (normalTex);
    }

    fn unPackNormal(normal : vec3<f32> , height:f32 ) -> vec3<f32>{
        var face = 1.0 ;
        if(ORI_VertexVarying.face){
            face = 1.0 ;
        }else{
            face = -1.0 ;
        }

        #if USE_RGNORMAL
            return unPackRGNormal(normal,height,face);
        #else
            var n = normal ;
            #if USE_NORMALFILPY
            n.y = 1.0 - n.y ; 
            #endif
            
            var mapNormal: vec3<f32> = n ;//unpackNormalMap(n) ;
            return perturbNormal(ORI_VertexVarying.vWorldPos.xyz , ORI_VertexVarying.vWorldNormal.xyz , mapNormal , height , face  ) ;
        #endif
    }

    fn unPackRGNormal(normal : vec3<f32> , height:f32 , face:f32) -> vec3<f32> {
        var d = normal.rg * 2.0 - 1.0 ;
        var l = 1.0 - saturate(dot(d,d));
        var s = sqrt(l);
        var rg = d * height ; 
        var mapNormal = vec3<f32>(rg,s);
        var outN = perturbNormal(ORI_VertexVarying.vWorldPos.xyz,ORI_VertexVarying.vWorldNormal,mapNormal,1.0,face) ;
        return outN ;
    }
`
    );

    let FragmentVarying = (
      /*wgsl*/
      `
    struct FragmentVarying {
        @location(auto) @interpolate(flat) index: f32,
        @location(auto) fragUV0: vec2<f32>,
        @location(auto) fragUV1: vec2<f32>,
        @location(auto) viewPosition: vec4<f32>,
        @location(auto) fragPosition: vec4<f32>,
        @location(auto) vWorldPos: vec4<f32>,
        @location(auto) vWorldNormal: vec3<f32>,
        @location(auto) vColor: vec4<f32>,

        #if USE_SHADOWMAPING
            @location(auto) vShadowPos: vec4<f32>,
        #endif

        #if USE_TANGENT
            @location(auto) TANGENT: vec4<f32>,
        #endif

        #if USE_TRANSMISSION
            // Matches VertexOutput.varying_ModelScale; consumed by
            // PBRLitShader's transmission ray.
            @location(auto) modelScale: vec3<f32>,
        #endif

        @builtin(front_facing) face: bool,
        @builtin(position) fragCoord : vec4<f32>
    };
`
    );

    let FragmentOutput = (
      /*wgsl*/
      `
    #if USE_OIT_DEPTH_PEEL
        // Dual depth peeling sub-passes (DEPTH / FRONT / BACK) each
        // write to a single attachment. Other variants of
        // FragmentOutput include a gBuffer slot which would force
        // the pipeline to expect 2 color attachments — keep just one
        // color location here so each peel pass can be wired with a
        // single-attachment RTFrame and the WebGPU pipeline-build
        // does not complain about an unmatched fragment output.
        struct FragmentOutput {
            @location(auto) color: vec4<f32>,
            #if USE_OUTDEPTH
                @builtin(frag_depth) out_depth: f32
            #endif
        };
    #else
        #if USE_CASTREFLECTION
            struct FragmentOutput {
                @location(auto) gBuffer: vec4<f32>,
                #if USE_OUTDEPTH
                    @builtin(frag_depth) out_depth: f32
                #endif
            };
        #else
            struct FragmentOutput {
                @location(auto) color: vec4<f32>,
                @location(auto) gBuffer: vec4<f32>,
                #if USE_OUTDEPTH
                    @builtin(frag_depth) out_depth: f32
                #endif
            };
        #endif
    #endif
`
    );

    let ShadingInput = (
      /*wgsl*/
      `
    struct ShadingInput{
        BaseColor:vec4<f32>,

        Roughness:f32,
        Metallic:f32,
        Specular:f32,

        EmissiveColor:vec4<f32>,
        SurfaceColor:vec4<f32>,

        Normal:vec3<f32>,
        HairNormal:vec3<f32>,
        Tangent:vec4<f32>,

        WorldPositionOffset:vec3<f32>,
        AmbientOcclusion:f32,

        PixelDepthOffset:f32,

        Opacity:f32,
        OpacityMask:f32,

        Refraction:f32,
        FragDepth:f32,

        SSS:vec3f,

        // color:vec4f ,
        // normal:vec3f,
        // alpha:f32,
        // roughness:f32,
        // metallic:f32,
        // occlusion:f32,
        // specularColor:vec4f ,
        // specularIntensity:vec4f ,
        // emissiveColor:vec4f,
        // emissiveIntensity:f32,
        // shadow:f32,
        // ior:f32,
        // alphaClip:f32,

        // position:vec4f,
        // depth:f32
    }
`
    );

    let IESProfiles_frag = (
      /*wgsl*/
      `
    #if USE_IES_PROFILE 
        @group(1) @binding(auto)
        var iesTextureArrayMapSampler : sampler;
        @group(1) @binding(auto)
        var iesTextureArrayMap: texture_2d_array<f32> ;
    #endif

    fn getLightIESProfileAtt( wPos : vec3<f32> , light:LightData ) -> f32
    {
        #if USE_IES_PROFILE 
            let tangent = vec3<f32>(1.0,0.0,0.0);
            let lightBitangent = normalize( cross( tangent, light.direction ) );
            let lightMatrix = mat4x4( vec4<f32>(light.direction.xyz, 0.0), vec4<f32>(lightBitangent.xyz, 0.0), vec4<f32>(tangent.xyz, 0.0), vec4<f32>(0.0, 0.0, 0.0, 1.0) );
            let lightMatrixInv = transpose(lightMatrix);
            let lightPos = light.position.xyz;
            let l = lightPos - wPos; 
            let toLight = normalize(l);
            let localToLight = (vec4<f32>(toLight.xyz, 0.0) * lightMatrixInv).xyz;
            let dotProd = dot(toLight, light.direction);
            let angle = asin(dotProd);
            let normAngle = (angle / PI) + 0.5 ;
            let tangentAngle = atan2( -localToLight.z, -localToLight.x ); 
            let normTangentAngle = tangentAngle / (PI * 2.0) + 0.5 ;
            if(light.ies >= 0.0){
                return textureSampleLevel(iesTextureArrayMap, iesTextureArrayMapSampler, vec2<f32>(normAngle , normTangentAngle) , i32(light.ies) , 0.0).r ;
            }else{
                return 1.0;
            }
        #else 
            return 1.0;
        #endif
    }

`
    );

    let ShadowMapping_frag = (
      /*wgsl*/
      `
    #include "ShadowCommon"
    #include "PCF_frag"
    #include "CSM_frag"
    #include "DirectShadow_frag"
    #include "PointShadow_frag"

    fn useShadow(){
        directShadowVisibility = array<f32, 8>( 1.0,1.0,1.0,1.0,1.0,1.0,1.0,1.0) ;
        pointShadows = array<f32, 8>(1.0,1.0,1.0,1.0,1.0,1.0,1.0,1.0) ;
        directShadowMaping();
        pointShadowMapCompare();
    }
`
    );

    let ShadowCommon = (
      /*wgsl*/
      `
    @group(1) @binding(auto) var shadowMapSampler: sampler_comparison;
    @group(1) @binding(auto) var shadowMap: texture_depth_2d_array;
    @group(1) @binding(auto) var pointShadowMapSampler: sampler_comparison;
    @group(1) @binding(auto) var pointShadowMap: texture_depth_cube_array;
    // Non-comparison aliases for the same depth textures — used by PCSS
    // blocker search which needs the raw depth value, not a compared 0/1.
    // See RenderShaderPass sampler resolution (strips 'SamplerRaw' suffix
    // so both aliases point at the same underlying Texture).
    @group(1) @binding(auto) var shadowMapSamplerRaw: sampler;
    @group(1) @binding(auto) var pointShadowMapSamplerRaw: sampler;

    var<private> directShadowVisibility: array<f32, 8>;
    var<private> pointShadows: array<f32, 8>;
    var<private> shadowWeight: f32 = 1.0 ;

    const dirCount:i32 = 8 ;
    const pointCount:i32 = 8 ;
    const csmCount:i32 = ${CSM.Cascades} ;
    var<private> csmLevel:i32 = -1;

    // 16-tap Poisson disk (unit-disk coords, max radius ≤ 1). Shared by 2D
    // and cube-face samplers — both project these onto a tangent plane and
    // scale by a desired radius. Better spatial distribution than the old
    // 4×4×4 cube-grid or axis-aligned 3×3, and small enough to stay cheap.
    const POISSON_DISK_16 = array<vec2<f32>, 16>(
        vec2<f32>(-0.94201624, -0.39906216),
        vec2<f32>( 0.94558609, -0.76890725),
        vec2<f32>(-0.094184101, -0.92938870),
        vec2<f32>( 0.34495938,  0.29387760),
        vec2<f32>(-0.91588581,  0.45771432),
        vec2<f32>(-0.81544232, -0.87912464),
        vec2<f32>(-0.38277543,  0.27676845),
        vec2<f32>( 0.97484398,  0.75648379),
        vec2<f32>( 0.44323325, -0.97511554),
        vec2<f32>( 0.53742981, -0.47373420),
        vec2<f32>(-0.26496911, -0.41893023),
        vec2<f32>( 0.79197514,  0.19090188),
        vec2<f32>(-0.24188840,  0.99706507),
        vec2<f32>(-0.81409955,  0.91437590),
        vec2<f32>( 0.19984126,  0.78641367),
        vec2<f32>( 0.14383161, -0.14100790),
    );

    fn calcBasicBias(shadowWorldSize:f32, shadowDepthTexSize:f32, near:f32, far:f32) -> f32{
      var bias = shadowWorldSize / shadowDepthTexSize;
      bias = bias / (far - near);
      return bias * 2.0;
    }
`
    );

    let PCF_frag = (
      /*wgsl*/
      `
    fn sampleHard_Direct(uv: vec2<f32>, depthTexIndex: i32, refDepth: f32) -> f32 {
        return textureSampleCompareLevel(shadowMap, shadowMapSampler, uv, depthTexIndex, refDepth);
    }

    // 3x3 tent-weight PCF. Standard tent kernel weights:
    // center 4, edges 2, corners 1 (sum 16). Equivalent to (2-|x|)*(2-|y|).
    // Hardware sampler_comparison is LINEAR so each tap already does a 2x2
    // compare-and-filter; combined with the tent this gives an effective
    // ~5x5 footprint at only 9 taps, with smoother falloff than the
    // previous equal-weight 3x3 box.
    fn samplePCF3x3_Direct(uv: vec2<f32>, depthTexIndex: i32, refDepth: f32, uvOnePixel: vec2<f32>) -> f32 {
        var visibility = 0.0;
        for (var y = -1; y <= 1; y++) {
            for (var x = -1; x <= 1; x++) {
                let w = f32((2 - abs(x)) * (2 - abs(y)));
                let offsetUV = vec2<f32>(f32(x), f32(y)) * uvOnePixel;
                visibility += w * textureSampleCompareLevel(shadowMap, shadowMapSampler, uv + offsetUV, depthTexIndex, refDepth);
            }
        }
        return visibility * (1.0 / 16.0);
    }

    // Percentage-Closer Soft Shadows (Fernando 2005 + NVIDIA GPU Gems 3).
    // Three-stage pipeline:
    //   1. Blocker search: Poisson-16 taps using the non-comparison sampler
    //      to read raw depth; average the depth of taps closer than the
    //      receiver (the "occluders").
    //   2. Penumbra estimate via the similar-triangles model:
    //        penumbra = (refDepth - avgBlockerDepth) / avgBlockerDepth * lightSize
    //      Larger light size OR larger receiver-blocker distance -> wider
    //      penumbra. This is what gives shadows that soften with distance
    //      ("contact hardening").
    //   3. PCF of configured radius (16 Poisson taps) using the comparison
    //      sampler and the computed penumbra.
    // lightSize units: texels (at the shadow map's native resolution).
    fn samplePCSS_Direct(uv: vec2<f32>, depthTexIndex: i32, refDepth: f32, uvOnePixel: vec2<f32>, lightSize: f32) -> f32 {
        // Blocker search radius: a fraction of lightSize. Smaller than the
        // filter so very thin occluders still register.
        let searchRadiusUV = lightSize * uvOnePixel;
        var avgBlocker = 0.0;
        var numBlockers = 0.0;
        for (var i = 0; i < 16; i++) {
            let sampleUV = uv + POISSON_DISK_16[i] * searchRadiusUV;
            let sampleDepth = textureSampleLevel(shadowMap, shadowMapSamplerRaw, sampleUV, depthTexIndex, 0i);
            if (sampleDepth < refDepth) {
                avgBlocker += sampleDepth;
                numBlockers += 1.0;
            }
        }
        if (numBlockers < 0.5) {
            // No occluders between receiver and light -> fully lit. Avoids
            // running PCF and returning 0 when refDepth is already the
            // front-most surface.
            return 1.0;
        }
        let avgBlockerDepth = avgBlocker / numBlockers;
        // Similar-triangles penumbra in normalized depth; multiply by lightSize
        // to get filter radius back in texel units.
        let penumbra = max(refDepth - avgBlockerDepth, 0.0) / max(avgBlockerDepth, 1e-5);
        let filterRadiusTexels = min(penumbra * lightSize, lightSize);
        let filterRadiusUV = filterRadiusTexels * uvOnePixel;
        var visibility = 0.0;
        for (var i = 0; i < 16; i++) {
            let offsetUV = POISSON_DISK_16[i] * filterRadiusUV;
            visibility += textureSampleCompareLevel(shadowMap, shadowMapSampler, uv + offsetUV, depthTexIndex, refDepth);
        }
        return visibility * (1.0 / 16.0);
    }
`
    );

    let CSM_frag = (
      /*wgsl*/
      `
    fn calcCSMBlendWeight(shadowUV: vec2<f32>) -> f32 {
        var uv = 2.0 * shadowUV - vec2<f32>(1.0);
        uv = saturate(vec2<f32>(1.0) - abs(uv));
        uv /= clamp(globalUniform.csmMargin, 0.01, 0.5);
        return min(min(uv.x, 1.0), uv.y);
    }
`
    );

    let DirectShadow_frag = (
      /*wgsl*/
      `
    fn directShadowMaping()  {
        // Evaluate world-position derivatives once at function entry while
        // control flow is still uniform (pre-loop, pre-break). WGSL's
        // derivative_uniformity rule is pessimistic about loops containing
        // data-dependent breaks (CSM early-exit below), so computing
        // dpdx/dpdy later — even one line before the break — gets rejected.
        let dWorldPosDx = dpdx(ORI_VertexVarying.vWorldPos.xyz);
        let dWorldPosDy = dpdy(ORI_VertexVarying.vWorldPos.xyz);
        for (var i: i32 = 0; i < dirCount; i = i + 1) {
          if( i >= globalUniform.nDirShadowStart && i < globalUniform.nDirShadowEnd ) {
            var visibility = 1.0;
            let ldx = globalUniform.shadowLights[u32(i) / 4u][u32(i) % 4u];
            let light = lightBuffer[u32(ldx)];
            var shadowIndex = i32(light.castShadow);
            var shadowMatrix:mat4x4<f32>;

            #if USE_CSM
              if (light.csmShadowMapIndex >= 0){
                  visibility = 0.0;
                  var validCount = 0;
                  var totalWeight = 0.0;
                  for(var csm: i32 = 0; csm < csmCount; csm++) {
                    shadowMatrix = globalUniform.shadowMatrix[shadowIndex + csm];
                    let csmShadowResult = directShadowMapingIndex(light, shadowMatrix, shadowIndex + csm, light.shadowBias[csm], light.normalBias[csm], dWorldPosDx, dWorldPosDy);
                    if(csmShadowResult.y < 0.5) {
                      validCount++;

                      var weight:f32 = calcCSMBlendWeight(csmShadowResult.zw);

                      if(validCount == 1 && csm == csmCount - 1){
                        visibility = 1.0 - weight + csmShadowResult.x * weight;
                        totalWeight = 1.0;
                      } else {
                        weight *= 1.0 - totalWeight;
                        visibility += csmShadowResult.x * weight;
                        totalWeight += weight;
                      }
                      if(validCount >= 2 || totalWeight >= 0.99) {
                        csmLevel = csm;
                        break;
                      }
                    }
                  }
                  totalWeight += 0.0001;
                  if(validCount == 0) {
                    visibility = 1.0;
                  } else {
                    visibility = visibility / totalWeight;
                  }
              } else {
                shadowMatrix = globalUniform.shadowMatrix[shadowIndex];
                visibility = directShadowMapingIndex(light, shadowMatrix, shadowIndex, light.shadowBias[0], light.normalBias[0], dWorldPosDx, dWorldPosDy).x;
              }
            #else
              shadowMatrix = globalUniform.shadowMatrix[shadowIndex];
              visibility = directShadowMapingIndex(light, shadowMatrix, shadowIndex, light.shadowBias[0], light.normalBias[0], dWorldPosDx, dWorldPosDy).x;
            #endif
            directShadowVisibility[shadowIndex] = visibility;
          }
        }

    }

    fn directShadowMapingIndex(light: LightData, shadowMatrix: mat4x4<f32>, depthTexIndex: i32, shadowBias: f32, normalBias: f32, dWorldPosDx: vec3<f32>, dWorldPosDy: vec3<f32>) -> vec4<f32>
    {
      var visibility = 1.0;
      var isOutSideArea:f32 = 1.0;
      var varying_shadowUV:vec2<f32> = vec2<f32>(0.0);
      #if USE_SHADOWMAPING
        // RFC-003 Layer B (normalBias): push receiver along surface normal in
        // world space before the shadow-space transform.
        // RFC-003 Layer C (shadowBias): the incoming shadowBias is the
        // quantization baseline. We add a per-fragment slope term derived
        // analytically from dpdx/dpdy of worldPos (passed in as caller is in
        // uniform control flow) transformed into shadow-space Z. The result
        // equals dpdx(shadowPos.z) under an orthographic light camera
        // (w = 1 always), and matches a receiver-plane bias without the
        // matrix inverse. Capped at 8× baseline to keep silhouette-edge
        // derivative spikes from producing runaway peter-panning.
        // IMPORTANT (cross-platform): normalize() of a zero-length vector is
        // undefined in WGSL. Dawn's Metal backend typically returns (0,0,0)
        // while Dawn's D3D12 backend can return NaN — which propagates into
        // receiverPos and compareZ and a 'less' compare sampler can treat NaN
        // as "pass" → no shadows on Windows. Guard against a zero fragment
        // normal before using N for normalBias.
        let Nraw = fragData.N;
        let N_len2 = dot(Nraw, Nraw);
        let N = select(vec3<f32>(0.0, 1.0, 0.0), Nraw * inverseSqrt(max(N_len2, 1e-30)), N_len2 > 1e-8);
        // Safe-normalize of the vector pointing from fragment toward the
        // light. Used both for the NoL-based bias amplifier below and for
        // the analytic shadow-space slope. D3D12 returns NaN on a zero
        // vector via normalize(); guard with select() + inverseSqrt.
        let dirRaw = -light.direction;
        let dir_len2 = dot(dirRaw, dirRaw);
        let L = select(vec3<f32>(0.0, 0.0, -1.0), dirRaw * inverseSqrt(max(dir_len2, 1e-30)), dir_len2 > 1e-8);
        let NoL = max(dot(N, L), 0.1);

        let receiverPos = ORI_VertexVarying.vWorldPos.xyz + N * normalBias;
        var shadowPosTmp = shadowMatrix * vec4<f32>(receiverPos, 1.0);
        var shadowPos = shadowPosTmp.xyz / shadowPosTmp.w;
        varying_shadowUV = shadowPos.xy * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5, 0.5);
        // Classic receiver-slope bias: shadowBias / NoL. One texel on a
        // receiver tilted against the light direction stretches by 1/NoL
        // in the projected-light-direction axis, which is exactly the
        // direction depth varies along, so bias must grow the same way to
        // cover one-texel quantization on the receiver plane. Floor NoL
        // at 0.1 (10x cap) — matches common PBR-pipeline behaviour and keeps
        // silhouette-edge derivative spikes bounded.
        //
        // Additionally fold in a screen-space slope term (Plan C analytic
        // derivative of shadowPos.z via shadowMatrix row 2 and dpdx(worldPos))
        // so heavily foreshortened main-camera views still get adequate
        // bias even at non-grazing light NoL. Capped at 32x baseline.
        let slopeNoL = shadowBias / NoL;
        let zRow = vec3<f32>(shadowMatrix[0].z, shadowMatrix[1].z, shadowMatrix[2].z);
        let dShadowZdx = dot(zRow, dWorldPosDx);
        let dShadowZdy = dot(zRow, dWorldPosDy);
        let slopeScreen = max(abs(dShadowZdx), abs(dShadowZdy)) * 1.5;
        let maxSlope = shadowBias * 32.0;
        let effectiveShadowBias = min(max(slopeNoL, shadowBias + slopeScreen), maxSlope);
        if (varying_shadowUV.x <= 1.0
          && varying_shadowUV.x >= 0.0
          && varying_shadowUV.y <= 1.0
          && varying_shadowUV.y >= 0.0
          && shadowPosTmp.z <= 1.0
          && shadowPosTmp.z >= 0.0)
        {
          isOutSideArea = 0.0;
          let uvOnePixel = 1.0 / vec2<f32>(globalUniform.shadowMapSize) ;
          let refDepth = shadowPos.z - effectiveShadowBias;
          #if USE_HARD_SHADOW
            visibility = sampleHard_Direct(varying_shadowUV, depthTexIndex, refDepth);
          #else
            #if USE_SOFT_SHADOW
              // PCSS — contact-hardening soft shadow. Per-light softness
              // (shader: light.softness) overrides the global knob when set
              // to a positive value. Global fallback: max(shadowSoft*4, 4)
              // texels so SOFT mode is visibly softer than PCF by default.
              let pcssLightSize = select(
                  max(globalUniform.shadowSoft * 4.0, 4.0),
                  light.softness,
                  light.softness > 0.0
              );
              visibility = samplePCSS_Direct(varying_shadowUV, depthTexIndex, refDepth, uvOnePixel, pcssLightSize);
            #else
              // Default PCF path (USE_PCF_SHADOW, or unset). Live-tunable
              // kernel scale — globalUniform.pcfKernelScale multiplies the
              // per-tap texel step. 1.0 = standard 3x3 spacing, 2.0 = 5x5-
              // equivalent spread, etc. Falls back to 1.0 when the host
              // doesn't populate the field (legacy clients).
              let kernelScale = max(globalUniform.pcfKernelScale, 0.01);
              visibility = samplePCF3x3_Direct(varying_shadowUV, depthTexIndex, refDepth, uvOnePixel * kernelScale);
            #endif
          #endif
          // Smooth fade across the last 10% of the shadow frustum's depth
          // range so receivers don't pop from "shadowed" to "fully lit"
          // when they leave the ortho depth range. Matches the frustum-
          // edge fade common to shadow-map implementations.
          let edgeFade = smoothstep(0.9, 1.0, shadowPos.z);
          visibility = mix(visibility, 1.0, edgeFade);
      }
      #endif
      return vec4<f32>(visibility, isOutSideArea, varying_shadowUV);
    }
`
    );

    let PointShadow_frag = (
      /*wgsl*/
      `
    fn pointShadowMapCompare(){
      let worldPos = ORI_VertexVarying.vWorldPos.xyz;

      for (var i: i32 = 0; i < pointCount ; i = i + 1) {
        if( i >= globalUniform.nPointShadowStart && i < globalUniform.nPointShadowEnd ){
          let ldx = globalUniform.shadowLights[u32(i) / 4u][u32(i) % 4u];
          let light = lightBuffer[u32(ldx)] ;

          #if USE_SHADOWMAPING
              let lightPos = light.position.xyz;
              var shadow = 0.0;
              // RFC-003: shadowBias is a world-space distance subtracted from the
              // measured fragment-to-light distance; normalBias offsets the receiver
              // along its normal first to mitigate acne on grazing surfaces.
              //
              // IMPORTANT (cross-platform): normalize() of a zero-length vector is
              // undefined in WGSL. Metal returns (0,0,0), Dawn D3D12 returns NaN,
              // and once NaN is in compareZ the depth-compare sampler treats
              // NaN ref as "pass" on Windows, giving no shadows. Use select +
              // manual inverseSqrt to stay data-defined even for degenerate
              // normals or unset light.position.
              let Nraw = ORI_ShadingInput.Normal;
              let N_len2 = dot(Nraw, Nraw);
              let N = select(vec3<f32>(0.0, 1.0, 0.0), Nraw * inverseSqrt(max(N_len2, 1e-30)), N_len2 > 1e-8);
              let unshiftedLen = length(worldPos - lightPos.xyz);
              let lengthScale = min(unshiftedLen / max(light.range, 1.0), 1.0);
              let receiverPos = worldPos + N * (light.normalBias[0] * lengthScale);
              let frgToLight = receiverPos - lightPos.xyz;
              let frg_len2 = dot(frgToLight, frgToLight);
              var dir: vec3<f32> = select(vec3<f32>(1.0, 0.0, 0.0), frgToLight * inverseSqrt(max(frg_len2, 1e-30)), frg_len2 > 1e-8);
              var len = sqrt(max(frg_len2, 0.0));
              let shadowFarDecode = select(globalUniform.far, light.shadowFar, light.shadowFar > 0.0);
              // Analytic receiver-plane bias for cube shadow texel
              // quantization. A cube texel's footprint on the receiver is a
              // stretched ellipse with semi-major ~ len / (mapSize * NoL).
              // Depth variation within one texel is bounded by that
              // footprint; screen-space dpdx is *not* the right metric here
              // because cube shadow view and main camera view are independent.
              // NoL floor 0.05 caps the amplifier at 20x.
              let NoL = max(dot(N, -dir), 0.05);
              let worldBias = (light.shadowBias[0] * lengthScale) / NoL;
              let compareZ = (len - worldBias) / shadowFarDecode;

              // Tangent basis around 'dir' for projecting Poisson disk
              // offsets onto the cube-face tangent plane. 'up' picked to be
              // non-parallel to dir to avoid cross() collapsing to zero.
              let upAxis = select(vec3<f32>(0.0, 0.0, 1.0), vec3<f32>(0.0, 1.0, 0.0), abs(dir.y) < 0.9);
              let tRight = normalize(cross(upAxis, dir));
              let tUp = cross(dir, tRight);

              #if USE_HARD_SHADOW
                let depth = textureSampleCompareLevel(pointShadowMap, pointShadowMapSampler, dir, light.castShadow, compareZ);
                shadow = 1.0 - depth;
              #else
                #if USE_SOFT_SHADOW
                  // Cube PCSS — blocker search in angular space, penumbra
                  // estimated from (refDepth - avgBlocker) / avgBlocker.
                  // Per-light softness overrides the global knob when > 0.
                  // Units: multiplier on a 4-texel base angle (4/512 rad).
                  let pcssSoftBase = select(max(globalUniform.shadowSoft, 1.0), light.softness, light.softness > 0.0);
                  let pcssLightSize = pcssSoftBase * (4.0 / 512.0);
                  var avgBlocker = 0.0;
                  var numBlockers = 0.0;
                  for (var j = 0; j < 16; j++) {
                      let p = POISSON_DISK_16[j];
                      let searchDir = normalize(dir + (tRight * p.x + tUp * p.y) * pcssLightSize);
                      let sampleDepth = textureSampleLevel(pointShadowMap, pointShadowMapSamplerRaw, searchDir, light.castShadow, 0i);
                      if (sampleDepth < compareZ) {
                          avgBlocker += sampleDepth;
                          numBlockers += 1.0;
                      }
                  }
                  if (numBlockers < 0.5) {
                      shadow = 0.0;
                  } else {
                      let avgBlockerDepth = avgBlocker / numBlockers;
                      let penumbra = max(compareZ - avgBlockerDepth, 0.0) / max(avgBlockerDepth, 1e-5);
                      let filterRadius = min(penumbra * pcssLightSize, pcssLightSize);
                      shadow = 0.0;
                      for (var j = 0; j < 16; j++) {
                          let p = POISSON_DISK_16[j];
                          let offsetDir = normalize(dir + (tRight * p.x + tUp * p.y) * filterRadius);
                          let d = textureSampleCompareLevel(pointShadowMap, pointShadowMapSampler, offsetDir, light.castShadow, compareZ);
                          shadow += 1.0 - d;
                      }
                      shadow = shadow * (1.0 / 16.0);
                  }
                #else
                  // USE_PCF_SHADOW (default). Tangent-plane 16-Poisson at
                  // one-cube-texel angular radius (default shadow map 1024).
                  // Scaled by globalUniform.pcfKernelScale so the live GUI
                  // slider in ShadowSetting controls both directional and
                  // cube PCF uniformly.
                  let pcfRadius = (1.0 / 512.0) * max(globalUniform.pcfKernelScale, 0.01);
                  shadow = 0.0;
                  for (var j = 0; j < 16; j++) {
                      let p = POISSON_DISK_16[j];
                      let offsetDir = normalize(dir + (tRight * p.x + tUp * p.y) * pcfRadius);
                      let d = textureSampleCompareLevel(pointShadowMap, pointShadowMapSampler, offsetDir, light.castShadow, compareZ);
                      shadow += 1.0 - d;
                  }
                  shadow = shadow * (1.0 / 16.0);
                #endif
              #endif

              // Smooth fade across the last 5% of the cube shadow's depth
              // range so fragments past the light's range don't hard-edge
              // into "lit". Mirrors the directional frustum-edge fade.
              let edgeFade = smoothstep(0.95, 1.0, len / shadowFarDecode);
              shadow = shadow * (1.0 - edgeFade);

              // Direct write: previous code scanned all pointCount looking
              // for the matching castShadow index, an O(N^2) loop over all
              // shadowed lights.
              pointShadows[i32(light.castShadow)] = 1.0 - shadow;
          #endif
        }
        }
    }
`
    );

    let Irradiance_frag = (
      /*wgsl*/
      `
#include "IrradianceVolumeData_frag"
    struct IrradianceField {
        probeStartPosition: vec4<f32>,
        probeCounts:vec4<f32>,
        probeStep:f32,
        irradianceTextureWidth:f32,
        irradianceTextureHeight:f32,
        irradianceProbeSideLength:f32,
    };

    @group(1) @binding(auto)
    var irradianceMapSampler: sampler;
    @group(1) @binding(auto)
    var irradianceMap: texture_2d<f32>;
    @group(1) @binding(auto)
    var irradianceDepthMapSampler: sampler;
    @group(1) @binding(auto)
    var irradianceDepthMap: texture_2d<f32>;
    @group(2) @binding(7)
    var<uniform> irradianceData : IrradianceVolumeData ;

    var<private> irradianceFieldSurface: IrradianceField;
    var<private> energyPreservation: f32 = 0.85;
    var<private> quaternion:vec4<f32> = vec4<f32>(0.0, -0.7071067811865475, 0.7071067811865475, 0.0);

    fn getIrradianceFieldSurface() -> IrradianceField{
        let data = irradianceData ;
        irradianceFieldSurface.probeStartPosition = vec4<f32>(data.startX, data.startY, data.startZ, 0.0);
        irradianceFieldSurface.probeCounts = vec4<f32>(data.gridXCount, data.gridYCount, data.gridZCount, 0.0);
        irradianceFieldSurface.probeStep = data.ProbeSpace;
        irradianceFieldSurface.irradianceTextureWidth = data.OctRTMaxSize;
        irradianceFieldSurface.irradianceTextureHeight = data.OctRTMaxSize;
        irradianceFieldSurface.irradianceProbeSideLength = data.OctRTSideSize;
        return irradianceFieldSurface;
    }

    fn rotateDir(n:vec3<f32>) -> vec3<f32>{
       return normalize(applyQuaternion(-n, quaternion));
    }

    fn square1f(v:f32) -> f32 {
        return v * v ;
     }

   fn square(v:vec3<f32>) -> vec3<f32>{
      return v*v;
   }

    fn getIrradiance() -> vec4<f32>{
        var irradiance = sampleIrradianceField();
        var outerVolumeFactor:f32 = getOuterVolume(irradianceFieldSurface, ORI_VertexVarying.vWorldPos.xyz);
        irradiance *= outerVolumeFactor;
       return irradiance ;
    }
    
    fn debugProbe(id:i32) -> vec4<f32>{
        getIrradianceFieldSurface();
        var direction = normalize(ORI_VertexVarying.vWorldNormal);
        direction = applyQuaternion(-direction, quaternion);
        var probeTextureUV : vec2<f32> = textureCoordFromDirection(normalize(direction),
            id,
            irradianceFieldSurface.irradianceTextureWidth,
            irradianceFieldSurface.irradianceTextureHeight,
            irradianceFieldSurface.irradianceProbeSideLength);

        var probeIrradiance: vec4<f32> = textureSampleLevel(irradianceMap, irradianceMapSampler, probeTextureUV ,0.0);
        return probeIrradiance;
    }
    
    fn debugProbeDepth(id:i32) -> vec4<f32>{
        getIrradianceFieldSurface();
        var direction = normalize(ORI_VertexVarying.vWorldNormal);
        direction = applyQuaternion(-direction, quaternion);
        var probeTextureUV : vec2<f32> = textureCoordFromDirection(normalize(direction),
            id,
            irradianceFieldSurface.irradianceTextureWidth,
            irradianceFieldSurface.irradianceTextureHeight,
            irradianceFieldSurface.irradianceProbeSideLength);
        
        var probeIrradiance: vec4<f32> = textureSampleLevel(irradianceDepthMap, irradianceDepthMapSampler, probeTextureUV ,0.0);
        probeIrradiance.x = probeIrradiance.x / irradianceData.maxDistance;
        probeIrradiance.y = 0.0;
        probeIrradiance.z = 0.0;
        probeIrradiance.w = 1.0;
        return probeIrradiance;
    }
    
    fn getOuterVolume(L:IrradianceField, position:vec3<f32>) -> f32{
        let halfWidth:vec3<f32> = 0.5 * (L.probeCounts.xyz - 1.0) * L.probeStep;
        let edgeWidth:vec3<f32> = halfWidth + L.probeStep;
        let centerPosition:vec3<f32> = halfWidth + L.probeStartPosition.xyz;
        let clampPos = min(edgeWidth, abs(position - centerPosition));
        
        let factorX = getOuterAxis(clampPos.x, edgeWidth.x, L.probeStep);
        let factorY = getOuterAxis(clampPos.y, edgeWidth.y, L.probeStep);
        let factorZ = getOuterAxis(clampPos.z, edgeWidth.z, L.probeStep);
        return factorX * factorY * factorZ;
    }
    
    fn getOuterAxis(current:f32, edge:f32, space:f32) -> f32{
        return clamp((edge - current) / space, 0.0, 1.0);
    }

    fn getBaseGridCoord(L:IrradianceField, X:vec3<f32>) -> vec3<i32> {
        var offsetIndex = (X - L.probeStartPosition.xyz) / irradianceFieldSurface.probeStep;
        return clamp(vec3<i32>(offsetIndex.xyz), vec3<i32>(0), vec3<i32>(L.probeCounts.xyz) - 1);
    }

    fn gridCoordToProbeIndex(L:IrradianceField, grid:vec3<i32>) -> i32
    {
        return grid.x + i32(L.probeCounts.x) * grid.z + grid.y * i32(L.probeCounts.z * L.probeCounts.x);
    }

    fn gridCoordToPosition(L:IrradianceField, grid:vec3<i32>) -> vec3<f32>
    {
        var pos:vec3<f32> = vec3<f32>(grid.xyz) * L.probeStep + L.probeStartPosition.xyz;
        return pos;
    }

    fn textureCoordFromDirection(dir:vec3<f32>, probeIndex:i32, width:f32, height:f32, sideLength:f32) -> vec2<f32>
    {
        var uv = getWriteOctUVByID(dir, u32(probeIndex), sideLength) ;
        uv.x = uv.x / irradianceFieldSurface.irradianceTextureWidth;
        uv.y = uv.y / irradianceFieldSurface.irradianceTextureHeight;
        return uv ;
    }

    fn getWriteOctUVByID(dir:vec3<f32> , probeID:u32, size: f32) -> vec2<f32>
    {
        var blockCount = u32(irradianceFieldSurface.probeCounts.x * irradianceFieldSurface.probeCounts.z) ;
        var offsetX = (probeID % blockCount) % u32(irradianceFieldSurface.probeCounts.x) ;
        var offsetY = u32(irradianceFieldSurface.probeCounts.z - 1.0) - (probeID % blockCount) / u32(irradianceFieldSurface.probeCounts.x) ;
        var offsetZ = probeID / blockCount ;

        var pixelCoord = (( octEncode(dir) + 1.0 ) * 0.5) * vec2<f32>(size,size) ;

        var blockOffset = vec2<f32>(0.0);
        blockOffset.x = f32(offsetX) * size;
        blockOffset.y = f32(offsetY) * size + f32(offsetZ) * irradianceFieldSurface.probeCounts.z * size;

        let mapHeight = u32(irradianceFieldSurface.irradianceTextureHeight);
        var probeCounts:vec3<f32> = irradianceFieldSurface.probeCounts.xyz;

        var gridOffsetFrom = vec2<i32>(blockOffset) + 1;
        var gridOffsetTo = offsetByCol(gridOffsetFrom, size, mapHeight, probeCounts);

        pixelCoord = pixelCoord + vec2<f32>(gridOffsetTo - 1) + vec2<f32>(vec2<i32>(vec2<f32>(gridOffsetTo) / size) * 2);

        return pixelCoord + 1.0 ;
    }

    fn offsetByCol(pixelCoord0:vec2<i32>, octSideSize:f32, mapHeight:u32, counts:vec3<f32>) -> vec2<i32>
    {
      var pixelCoord = pixelCoord0;
      let blockSize:vec2<i32> = vec2<i32>(i32(octSideSize * counts.x),  i32(octSideSize * counts.z));
      let blockSizeYBorder:i32 = i32((octSideSize + 2.0) * counts.z);
      let blockMaxRowBorder:i32 = i32(mapHeight) / blockSizeYBorder;
      let pixelCountYMax:i32 = blockMaxRowBorder * i32(octSideSize * counts.z);
      let col:i32 = pixelCoord.y / pixelCountYMax;
      pixelCoord.x = col * i32(octSideSize * counts.x) + pixelCoord.x;
      pixelCoord.y = pixelCoord.y % pixelCountYMax;
      return pixelCoord;
    }

    var<private> wpNormal:vec3<f32> ;
    fn sampleIrradianceField() -> vec4<f32>{
        wpNormal = ORI_ShadingInput.Normal.xyz ;
        var wo:vec3<f32> = ORI_CameraWorldDir ;
        var wsN:vec3<f32> = normalize(wpNormal);
        var direction:vec3<f32> = wpNormal;
        var worldPosition: vec3<f32> = ORI_VertexVarying.vWorldPos.xyz;
   
        getIrradianceFieldSurface();

        let surfaceBias = (wsN + 3.0 * wo) * irradianceData.normalBias ;

        var irradiance = vec3<f32>(0.0, 0.0, 0.0);
        var accumulatedWeights = 0.0;
        var biasedWorldPosition = (worldPosition + surfaceBias);

        var baseProbeCoords: vec3<i32> = getBaseGridCoord(irradianceFieldSurface, worldPosition);
        
        var baseProbeWorldPosition: vec3<f32> = gridCoordToPosition(irradianceFieldSurface, baseProbeCoords) ;
        
        var gridSpaceDistance = (biasedWorldPosition - baseProbeWorldPosition);

        // alpha is how far from the floor(currentVertex) position. on [0, 1] for each axis.
        var alpha: vec3<f32> = clamp(gridSpaceDistance / (irradianceFieldSurface.probeStep), vec3<f32>(0.0), vec3<f32>(1.0));
        // let irradianceDir = rotateDir(wsN.xyz);
        // Iterate over adjacent probe cage
        for (var i:i32 = 0; i < 8; i = i + 1) {
            var adjacentProbeOffset : vec3<i32> = vec3<i32>(i, i32(f32(i) * 0.5), i32(f32(i) * 0.25)) & vec3<i32>(1);
            var adjacentProbeCoords: vec3<i32> = clamp(baseProbeCoords + adjacentProbeOffset, vec3<i32>(0),  vec3<i32>(irradianceFieldSurface.probeCounts.xyz) - 1) ;
            
            var adjacentProbeIndex :i32 = gridCoordToProbeIndex(irradianceFieldSurface, adjacentProbeCoords);
            var adjacentProbeWorldPosition :vec3<f32> = gridCoordToPosition(irradianceFieldSurface, adjacentProbeCoords) ;//+ (wsN + 3.0 * w_o) * globalUniform.normalBias;
         
            var worldPosToAdjProbe = normalize(adjacentProbeWorldPosition - worldPosition);
            var biasedPosToAdjProbe = normalize(adjacentProbeWorldPosition - biasedWorldPosition);
            var biasedPosToAdjProbeDist = length(adjacentProbeWorldPosition - biasedWorldPosition);

            let trilinear = max(vec3<f32>(0.001), mix(1.0 - alpha, alpha, vec3<f32>(adjacentProbeOffset)));
            let trilinearWeight = (trilinear.x * trilinear.y * trilinear.z);
            var weight = 1.0;

            var wrapShading = (dot(worldPosToAdjProbe, direction) + 1.0) * 0.5;
            weight *= (wrapShading * wrapShading) + 0.2;

            var depthDir = -biasedPosToAdjProbe;//probe - world
            depthDir = applyQuaternion(depthDir, quaternion);
            var probeTextureUV : vec2<f32> = textureCoordFromDirection(depthDir.xyz,
                adjacentProbeIndex,
                irradianceFieldSurface.irradianceTextureWidth,
                irradianceFieldSurface.irradianceTextureHeight,
                irradianceFieldSurface.irradianceProbeSideLength);

            var filteredDistance : vec2<f32> = 2.0 * textureSampleLevel(irradianceDepthMap, irradianceDepthMapSampler, probeTextureUV,0.0).rg ;
           
            var variance = abs((filteredDistance.x * filteredDistance.x) - filteredDistance.y);

            var chebyshevWeight = 1.0;
            if(biasedPosToAdjProbeDist > filteredDistance.x ) // occluded
            {
                var v = biasedPosToAdjProbeDist - filteredDistance.x ;
                chebyshevWeight = variance / (variance + (v * v));
                // Increase the contrast in the weight
                chebyshevWeight = max((chebyshevWeight * chebyshevWeight * chebyshevWeight), 0.0);
            }

            weight *= max(0.05, chebyshevWeight);
            weight = max(0.000001, weight);

            let crushThreshold = 0.2;
            if (weight < crushThreshold)
            {
                weight *= (weight * weight) * (1.0 / (crushThreshold * crushThreshold));
            }

            weight *= trilinearWeight;
            
            //worldPosToAdjProbe
            let rotateDir = applyQuaternion(-direction, quaternion);
            probeTextureUV = textureCoordFromDirection((rotateDir),
            adjacentProbeIndex,
            irradianceFieldSurface.irradianceTextureWidth,
            irradianceFieldSurface.irradianceTextureHeight,
            irradianceFieldSurface.irradianceProbeSideLength);

            var probeIrradiance: vec3<f32> = textureSampleLevel(irradianceMap, irradianceMapSampler, probeTextureUV ,0.0).xyz;

            var exponent =  irradianceData.ddgiGamma * 0.5;
            probeIrradiance = pow(probeIrradiance, vec3<f32>(exponent));
            
            irradiance += (weight * probeIrradiance);
            accumulatedWeights += weight;
        }

        if(accumulatedWeights == 0.0){
            return vec4<f32>(0.0, 0.0, 0.0,1.0);
        }

        irradiance *= (1.0 / accumulatedWeights);   
        irradiance *= irradiance;                   

        irradiance *= 6.2831853071795864;
        irradiance *= irradianceData.indirectIntensity;
        return vec4<f32>(irradiance,1.0) ;
    }

`
    );

    let BRDF_frag = (
      /*wgsl*/
      `
#include "Clearcoat_frag"
    #include "EnvMap_frag"
    #include "BrdfLut_frag"
    #include "ColorUtil_frag"
    #include "SHCommon_frag"
    
    struct FragData {
        Ao: f32,
        Metallic: f32,
        Roughness: f32,

        Albedo: vec4<f32>,
        Emissive: vec3<f32>,
        Specular: vec3<f32>,

        N: vec3<f32>,
        V: vec3<f32>,
        R: vec3<f32>,
        T: vec3<f32>,

        F0: vec3<f32>,
        F: vec3<f32>,
        KS: vec3<f32>,
        KD: vec3<f32>,

        Alpha: f32,
        Shadow: f32,
        Indirect: f32,
        Reflectance: f32,

        NoV: f32,
        FaceDirection:f32,

        ClearcoatRoughness:f32,
        ClearcoatFactor:f32,
        ClearcoatIor:f32,
        EnvColor: vec3<f32>,
        Irradiance: vec3<f32>,

        LightChannel: vec3<f32>
    };

    var<private> fragData: FragData;

    struct BxDFContext
    {
        NoV : f32 ,
        NoL : f32 ,
        VoL : f32 ,
        NoH : f32 ,
        HoL : f32 ,
        VoH : f32
    };

    fn getContext( N:vec3<f32>, V:vec3<f32>, H:vec3<f32>, L:vec3<f32> ) -> BxDFContext
    {
        var Context:BxDFContext ;
        Context.NoL = saturate(dot(N, L));
        Context.NoV = saturate(dot(N, V));
        Context.VoL = saturate(dot(V, L));
        Context.NoH = saturate(dot(N, H));
        Context.VoH = saturate(dot(V, H));
        Context.HoL = saturate(dot(H, L));
        return Context ;
    }

    // convert roughness to mipmapLevel
    fn roughnessToMipmapLevel( roughness: f32 , mipmapCount:i32 ) -> f32{
        let level = roughness * (1.7 - 0.7 * roughness );
        return level * f32(mipmapCount);
    }

    fn IORToF0(ior:f32)->f32{
        var dc = ior - 1.0 ;
        dc *= dc ;
        var dt = ior + 1.0 ;
        dt *= dt ;
        return dc / dt ;
    }

    fn Fd90( NoL:f32, roughness:f32) -> f32
    {
        return (2.0 * NoL * roughness) + 0.4;
    }

  

    fn KDisneyTerm( NoL:f32, NoV:f32 , roughness:f32) -> f32
    {
        return (1.0 + Fd90(NoL, roughness) * pow(1.0 - NoL, 5.0)) * (1.0 + Fd90(NoV, roughness) * pow(1.0 - NoV, 5.0));
    }

    fn FresnelSchlick( NoV:f32,  F0:vec3<f32>) -> vec3<f32>
    {
        return F0 + (1.0 - F0) * pow(1.0 - NoV, 5.0);
    }

    fn FresnelTerm( cosA:f32,  F0:vec3<f32>) -> vec3<f32>
    {
        let t = pow5( 1.0 - cosA );
        return F0 + (1.0 - F0) * t;
    }

    fn FresnelLerp( cosA:f32, F0:vec3<f32> , F90:vec3<f32>) -> vec3<f32>
    {
        let t = pow5( 1.0 - cosA );
        return mix( F0 ,F90,t ) ;
    }

    fn FresnelSchlickRoughness( NoV:f32,  F0:vec3<f32>,  roughness:f32) -> vec3<f32>
    {
        return F0 + (max(vec3(roughness), F0) - F0) * pow(1.0 - NoV, 5.0);
    }

    fn DistributionGGX( NdotH:f32 ,  roughness:f32 ) -> f32
    {
        let alpha = roughness * roughness;
        let alpha2 = roughness * roughness;

        let NdotH2 = NdotH * NdotH;

        let nom   = alpha2;
        var denom = (NdotH2 * (alpha2 - 1.0) + 1.0);
        denom = PI * denom * denom;

        return nom / denom;
    }

    // [Heitz 2014, "Understanding the Masking-Shadowing Function in Microfacet-Based BRDFs"]
    fn Vis_SmithJoint( NoV : f32 ,  NoL : f32 ,  a2 : f32) -> f32
    {
        var Vis_SmithV = NoL * sqrt(NoV * (NoV - NoV * a2) + a2);
        var Vis_SmithL = NoV * sqrt(NoL * (NoL - NoL * a2) + a2);
        return 0.5 * rcp(Vis_SmithV + Vis_SmithL);
    }

    fn Vis_SmithJointApprox( NoV : f32 ,  NoL : f32 ,  a2 : f32 ) -> f32
    {
        let a = sqrt(a2);
        let Vis_SmithV = NoL * ( NoV * ( 1.0 - a ) + a );
        let Vis_SmithL = NoV * ( NoL * ( 1.0 - a ) + a );
        return 0.5 * rcp( Vis_SmithV + Vis_SmithL );
    }

    fn GeometrySchlickGGX( NdotV : f32 , roughness : f32 ) -> f32
    {
        //roughness compute ks
        let r = (roughness + 1.0);
        let k = (r*r) / 8.0;

        let nom   = NdotV;
        let denom = NdotV * (1.0 - k) + k;
        
        return nom / denom;
    }
    
    fn GeometrySmith( NdotV:f32 , NdotL:f32 , roughness : f32) -> f32
    {
        // let NdotV = max(dot(N, V), 0.0);
        // let NdotL = max(dot(N, L), 0.0);
        let ggx1 = GeometrySchlickGGX(NdotV, roughness);
        let ggx2 = GeometrySchlickGGX(NdotL, roughness);
        return ggx1 * ggx2;
    }

    fn GeometryAttenuationGGXSmith( NdotL:f32,  NdotV:f32,  roughness:f32) -> f32
    {
        var NdotL2 = NdotL * NdotL;
        var NdotV2 = NdotV * NdotV;
        var kRough2 = roughness * roughness + 0.0001;

        var ggxL = (2.0 * NdotL) / (NdotL + sqrt(NdotL2 + kRough2 * (1.0 - NdotL2)));
        var ggxV = (2.0 * NdotV) / (NdotV + sqrt(NdotV2 + kRough2 * (1.0 - NdotV2)));

        return ggxL * ggxV;
    }

    fn colorLinear( colorVector:vec3<f32> ) -> vec3<f32>
    {
        var linearColor = pow(colorVector.rgb, vec3<f32>(2.2));
        return linearColor;
    }

    fn computeFresnelSchlick( NoV:f32 , F0:vec3<f32>) -> vec3<f32>
    {
        return F0 + (1.0 - F0) * pow(clamp(1.0 - NoV,0.0,1.0), 5.0);
    }

    fn computeFresnelSchlickRoughness(NoV:f32 , F0:vec3<f32>,  roughness:f32) -> vec3<f32>
    {
        return F0 + (max(vec3(1.0 - roughness), F0) - F0) * pow(clamp(1.0 - fragData.NoV,0.0,1.0), 5.0);
    }

    fn computeDistributionGGX( N:vec3<f32>,  H:vec3<f32>,  roughness:f32) -> f32
    {
        var alpha = roughness * roughness;
        var alpha2 = alpha * alpha; 

        var NdotH = saturate(dot(N, H));
        var NdotH2 = NdotH * NdotH;

        return (alpha2) / (PI * (NdotH2 * (alpha2 - 1.0) + 1.0) * (NdotH2 * (alpha2 - 1.0) + 1.0));
    }

    fn D_GGX( NoH:f32,  roughness:f32 ) -> f32
    {
        var d = ( NoH * roughness - NoH ) * NoH + 1.0;	// 2 mad
        return roughness / ( PI*d*d );					// 4 mul, 1 rcp
    }

    fn computeGeometryAttenuationGGXSmith( NdotL:f32 ,  NdotV:f32,  roughness:f32) -> f32
    {
        var NdotL2 = NdotL * NdotL;
        var NdotV2 = NdotV * NdotV;
        var kRough2 = roughness * roughness + 0.0001;

        var ggxL = (2.0 * NdotL) / (NdotL + sqrt(NdotL2 + kRough2 * (1.0 - NdotL2)));
        var ggxV = (2.0 * NdotV) / (NdotV + sqrt(NdotV2 + kRough2 * (1.0 - NdotV2)));

        return ggxL * ggxV;
    }

    fn Vis_Smith(  NoL:f32 ,  NoV:f32,  a2:f32 )-> f32
    {
        var Vis_SmithV = NoV + sqrt( NoV * (NoV - NoV * a2) + a2 );
        var Vis_SmithL = NoL + sqrt( NoL * (NoL - NoL * a2) + a2 );
        return rcp( Vis_SmithV * Vis_SmithL );
    }

    fn F_Function( HdotL:f32, F0:vec3f ) -> vec3f
  {
      var fresnel = exp2((-5.55473 * HdotL - 6.98316) * HdotL);
      return mix(vec3f(fresnel),vec3f(1.0),F0);
  }

  fn D_Function( NdotH:f32, roughness:f32) ->f32
  {
      var a      = roughness*roughness;
      var a2     = a*a;
      var NdotH2 = NdotH*NdotH;
      var nom   = a2;
      var denom = (NdotH2 * (a2 - 1.0) + 1.0);
      denom = PI * denom * denom;
      return nom / denom;
  }

  // G term: geometry function
  fn G_SubFunction( NdotW : f32,  K : f32)->f32
  {
      return NdotW / mix(NdotW,1.0,K);
  }

  fn G_Function( NdotL: f32, NdotV: f32, roughness: f32)->f32
  {
      var K = (1.0+roughness) * (1.0+roughness) / 8.0;
      return G_SubFunction(NdotL,K) * G_SubFunction(NdotV,K);
  }
  
  fn DGF_Function( NdotH:f32, NdotL:f32,NdotV:f32, HdotL:f32, roughness:f32, shadow:f32, F0:vec3f , lightColor:vec3f )-> vec3f
  {
      var  D = D_Function(NdotH,roughness);
      var  G = G_Function(NdotL,NdotV,roughness);
      var F = F_Function(HdotL,F0);
      // var light_BRDF = saturate(( D * G * F ) / (4 * NdotL * NdotV + 0.001));
      let light_BRDF = ( D * G * F ) / (4.0 * NdotV * NdotL + 0.001);
      return light_BRDF * lightColor * NdotL * PI * shadow;
  }

  fn LightDiffuse_Function( HdotL:f32, NdotL:f32 ,  baseColor:vec3f,  metallic:f32,  shadow:f32, F0:vec3f, lightColor:vec3f) -> vec3f
  {
      var KS = F_Function(HdotL,F0);
      var KD = (1 - KS) * (1 - metallic);
      return KD * baseColor * lightColor.rgb * NdotL * shadow; 
  }

  fn lightContribution( NdotH:f32, NdotL:f32, NdotV:f32, HdotL:f32, roughness:f32, baseColor:vec3f, metallic:f32, shadow:f32, F0:vec3f, lightColor:vec3f ) ->vec3f
  {
      return LightDiffuse_Function(HdotL,NdotL,baseColor,metallic,shadow,F0,lightColor) + DGF_Function(NdotH,NdotL,NdotV,HdotL,roughness,shadow,F0,lightColor);
  }

    fn simpleBRDF( albedo:vec3<f32>, N:vec3<f32>, V:vec3<f32>,L:vec3<f32>,att:f32,lightColor:vec3<f32>,roughness:f32 ,metallic:f32)-> vec3<f32>{
        let H = normalize(V + L);
        let Context:BxDFContext = getContext(N,V,H,L);
        let alpha = roughness * roughness;
        let a2 = alpha * alpha;
        let F0 = mix(vec3<f32>(materialUniform.materialF0.rgb), albedo.rgb , metallic);
        let D = D_GGX( Context.NoH , a2);
        let G = Vis_SmithJointApprox(Context.NoV,Context.NoL, a2 );
        let F = FresnelSchlick(Context.VoH, vec3<f32>(F0));
        let specular = ( D * G * F ) / (4.0 * Context.NoV * Context.NoL + 0.001);
        
        // let kS = exp2( (-5.55473 * Context.HoL - 6.98316) * Context.HoL );
        let kS = F ;
        var kd = 1.0 - kS ;
        kd *= 1.0 - metallic ;

        #if USE_SRGB_ALBEDO
            var diffuse = kd ;
        #else 
            var diffuse = kd * (albedo.rgb / PI ) ;
        #endif

        let lightAtt = Context.NoL * lightColor * att ; 
        var diffuseColor = diffuse * lightAtt; 
        // diffuseColor = vec3f(0.0) ; 
        var specularColor = specular * lightAtt; 
        var col = (diffuseColor + specularColor ) ;
        return vec3f(col) ;
    }

    fn getSpecularDominantDir (  N : vec3<f32> , R : vec3<f32> , roughness : f32 ) -> vec3<f32>
    {
        var smoothness = saturate (1.0 - roughness );
        var lerpFactor = smoothness * ( sqrt ( smoothness ) + roughness );
        // The result is not normalized as we fetch in a cubemap
        return mix (N, R, lerpFactor );
    }

    fn approximateSpecularIBL( specularColor:vec3<f32> , roughness:f32 , R:vec3<f32> , NoV:f32 ) -> vec3<f32> {
       
        let MAX_REFLECTION_LOD  = i32(textureNumLevels(prefilterMap)) ;
        let mip = roughnessToMipmapLevel(roughness,MAX_REFLECTION_LOD) * f32(MAX_REFLECTION_LOD);
        fragData.EnvColor = (textureSampleLevel(prefilterMap, prefilterMapSampler, getSpecularDominantDir(fragData.N,R,roughness) , mip ).rgb);
        fragData.EnvColor = globalUniform.skyExposure * (fragData.EnvColor);
        var envBRDF = textureSampleLevel(brdflutMap, brdflutMapSampler, vec2<f32>(NoV, roughness) , 0.0 ) ;
        return (specularColor.rgb * envBRDF.x + envBRDF.y) ;
    }

    fn fresnel_coat(n:vec3<f32>,v:vec3<f32>,ior:f32) -> f32 {
        var f0 = (1.0-ior)/(1.0+ior);
        f0 = f0 * f0  ;
        let fr = pow((f0 + (1.0 - f0)*(1.0 - abs( max(dot(n,v),0.0) ))) , 5.0 ) ;  
        return fr ;
    }

    fn reflectEnvMap(n:vec3<f32> , v:vec3<f32> , roughness:f32) -> vec3<f32> {
        let MAX_REFLECTION_LOD  = i32(textureNumLevels(envMap)) ;
        let mip = roughnessToMipmapLevel(roughness,MAX_REFLECTION_LOD);
        let R = 2.0 * dot( v , n ) * n - v ;
        // envMap stores linear HDR; keep in linear so IBL contribution
        // accumulates in the same space as direct lighting and gets a
        // single linear-to-sRGB encode on present.
        var prefilteredColor: vec3<f32> = globalUniform.skyExposure * (textureSampleLevel(envMap, envMapSampler, R , mip ).rgb);
        return prefilteredColor ;
    }

    fn Specular_D_GGX( NoH:f32,  roughness:f32 ) -> f32
    {
        let a2 = roughness * roughness ;
        let f = (NoH * a2 - NoH) * NoH + 1.0;
        return a2 / (PI * f * f) ;
    }

    fn V_Kelemen( LoH : f32 ) -> f32 {
        return 0.25 / (LoH * LoH);
    }

    fn F_Schlick( f0:vec3<f32> ,  f90 : f32 ,  VoH : f32 ) -> vec3<f32> {
        return f0 + (f90 - f0) * pow(1.0 - VoH,5.0);
    }

    fn F_Schlick2(  SpecularColor:vec3<f32>,  VoH :f32 )-> vec3<f32> {
        var Fc = pow5( 1.0 - VoH );
        let rt = clamp(50.0 * SpecularColor.g,0.0,1.0) ;
        return rt * Fc + (1.0 - Fc) * SpecularColor;
    }

    fn oneMinusReflectivity ( metallic : f32 , F0:f32 ) -> f32 {
        let range = 1.0 - F0;
        return range - metallic * range;
    }

    //https://google.github.io/filament/Filament.html materialsystem/clearcoatmodel/clearcoatparameterization
    fn CoatSpecular_brdf( f:vec3<f32>, s:vec3<f32>, n:vec3<f32> , v:vec3<f32> , l:vec3<f32> , att:f32 , layer :vec3<f32> , clearcoatRoughnessFactor:f32 ) -> vec3<f32> {
        let H = normalize(v + l); 
        let VdotNc = max(dot(v,n),0.0);
        let LdotNc = max(dot(l,n),0.0);
        let NoH = max(dot(n,H),0.0);
        let LoH = saturate(dot(l, H))  ;
        let NoL = max(dot(n,l),0.0);

        let Fd = f ; 
        let Fr = s ; 

        let factor = clamp(clearcoatRoughnessFactor,0.089,1.0);
        let clearCoatRoughness = factor * factor ;

        let Dc = D_GGX( NoH , factor ) ;
        let Vc = V_Kelemen( LoH ) * NoL ;
        let Fc = F_Schlick(vec3<f32>(0.04), 2.0 , LoH); 
        let Frc = (Dc * Vc) * Fc ;
        // return layer * vec3<f32>((Fd + Fr * (1.0 - Fc)) * (1.0 - Fc) + Frc) * ( 0.5 + NoL * 0.5 ) ;
        return vec3<f32>(Frc) ;
    }

    #if USE_CLEARCOAT
    fn approximate_coating(base:vec3<f32> , clearColor: vec3<f32>, n:vec3<f32> , v:vec3<f32> , light:LightData , clearcoatRoughnessFactor:f32 ) -> vec3<f32> {
        let factor = clamp(clearcoatRoughnessFactor,0.084,1.0);
        var clearcoatAlpha = factor * factor + fragData.ClearcoatRoughness;

        // var lightColor = getHDRColor( lightCC.rgb , light.linear )  ;
        var att = light.intensity ;
        let l = light.direction ;
   
        let NdotV = max(dot(n,v),0.0);
        let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
        // let mip = roughnessToMipmapLevel(clearcoatAlpha,MAX_REFLECTION_LOD);
        let R = 2.0 * dot( v , n ) * n - v ;
        var envIBL: vec3<f32> = globalUniform.skyExposure * (textureSampleLevel(prefilterMap, prefilterMapSampler, R , MAX_REFLECTION_LOD * clearcoatRoughnessFactor ).rgb) ;
        // envIBL = LinearToGammaSpace(envIBL);

        let clearCoat = materialUniform.clearcoatFactor ;
        // let f = FresnelSchlickRoughness( max(dot(n,v),0.0) , vec3<f32>(0.0) , clearcoatAlpha ) ;
        let clearcoat_brdf =  CoatSpecular_brdf( vec3<f32>(0.04) , vec3<f32>( 0.04 ) , n , v , -l , att , vec3<f32>( 0.04 ) , factor ) ;

        // return clearcoat_brdf;+ fragData.ClearcoatRoughness 
        return mix(base, clearcoat_brdf,materialUniform.clearcoatWeight ) ;
    }
    #endif
   

    fn EnvBRDF( SpecularColor : vec3f , Roughness : f32 , NoV : f32) -> vec3f
    {
        // brdflutMap, brdflutMapSampler
        var AB = textureSampleLevel( brdflutMap, brdflutMapSampler, vec2f( NoV, Roughness ), 0.0 ).rg;
        var GF = SpecularColor * AB.x + saturate( 50.0 * SpecularColor.g ) * AB.y;
        return GF;
    }

    fn EnvBRDF_FD90( F0: vec3f , F90: vec3f ,  Roughness: f32,  NoV: f32)-> vec3f
    {
        // Importance sampled preintegrated G * F
        var AB = textureSampleLevel(brdflutMap, brdflutMapSampler, vec2f(NoV, Roughness), 0.0).rg;
        var GF = F0 * AB.x + F90 * AB.y;
        return GF;
    }

    fn IBLEnv( V:vec3f , N:vec3f , Roughness : f32) -> vec3f 
    {
        let MAX_REFLECTION_LOD  = i32(textureNumLevels(prefilterMap));
        let mip = roughnessToMipmapLevel(Roughness,MAX_REFLECTION_LOD);
        let R = 2.0 * dot( V , N ) * N - V ;
        var envIBL: vec3<f32> = textureSampleLevel(prefilterMap, prefilterMapSampler, R , mip ).rgb ;
        return envIBL;
    }

    fn IBLEnv2( R:vec3f , Roughness : f32) -> vec3f 
    {
        let MAX_REFLECTION_LOD  = i32(textureNumLevels(reflectionMap));
        let mip = roughnessToMipmapLevel(Roughness,MAX_REFLECTION_LOD);
        var envIBL: vec3<f32> ;
        // envIBL = textureSampleLevel(envMap, envMapSampler, R , mip * 12.0 ).rgb ;
        envIBL = getReflectionsEnv(R,ORI_VertexVarying.vWorldPos.xyz, mip).rgb ;
        envIBL = gammaToLiner(envIBL);
        return envIBL;
    }


    fn F_indirect_Function( NdotV:f32, roughness:f32, F0:vec3f) -> vec3f
    {
        var fresnel = exp2((-5.55473 * NdotV - 6.98316) * NdotV);
        return F0 + fresnel * saturate(1.0 - roughness - F0);
    }


     // indirection*_Function reference materialUniform.envIntensity /
     // .specularColor.a, fields that only exist on the PBR
     // (USE_BRDF) MaterialUniform layout. WGSL validates included
     // function bodies even when uncalled, so non-BRDF shaders
     // (Grass, Sprite, Unlit, ...) that pull LightingFunction_frag
     // for the direct-light helpers reject the parse with
     // "struct member envIntensity not found". Gate the helpers behind
     // USE_BRDF so non-BRDF includes only see the direct-light path.
     #if USE_BRDF
     fn indirectionDiffuse_Function( NdotV:f32, normalDir:vec3f, metallic:f32, baseColor:vec3f, roughness:f32, occlusion:f32, F0:vec3f)-> vec3f
     {
        //  var SHColor = SH9(normalDir,globalUniform.SH).rgb * globalUniform.skyExposure ;
         var SHColor = fragData.Irradiance.rgb ;

         var KS = F_indirect_Function(NdotV,roughness,F0);
         var KD = (1.0 - KS) * (1.0 - metallic);
         // envIntensity exclusively scales the IBL diffuse term — the
         // ambient sky / SH lighting that fills in matte / shadow
         // areas. Pairing it with specularIntensity (which drives the
         // IBL spec lobe alone) gives the GUI two visually distinct
         // knobs: env → "ambient brightness", spec → "highlight strength".
         return SHColor * KD * baseColor * occlusion * materialUniform.envIntensity;
        //  return SHColor ;
     }

     fn indirectionSpec_Function( reflectDir:vec3f, roughness:f32, NdotV:f32,occlusion:f32, F0:vec3f )-> vec3f
     {
         var mipRoughness = roughness * (1.7 - 0.7 * roughness) ;
         var env : vec3f ;
         #if USE_CASTREFLECTION
            env = textureSampleLevel(envMap, envMapSampler, reflectDir , mipRoughness * 12.0 ).rgb ;
         #else
            useSphereReflection();
            env = getReflectionsEnv(reflectDir,ORI_VertexVarying.vWorldPos.xyz, mipRoughness).rgb ;
        #endif

        //  env *= 0.45 ;
         // Note: this lobe is the IBL specular term and is governed
         // by specularIntensity (specularColor.a) — NOT by envIntensity.
         // envIntensity is reserved for the IBL diffuse term in
         // indirectionDiffuse_Function so the two GUI sliders feel
         // distinct: env → ambient brightness on matte / shadow
         // areas; spec → highlight / mirror reflection.
         var indirectionCube: vec3<f32> = globalUniform.skyExposure * env ;
         var F_IndirectionLight = F_indirect_Function(NdotV,roughness,F0);

         var AB = LUT_Approx(roughness,NdotV);
        //  var AB = textureSampleLevel(brdflutMap, brdflutMapSampler, vec2f(NdotV, roughness), 0.0).rg;
         var indirectionSpecFactor = indirectionCube.rgb * (F_IndirectionLight * AB.r + AB.g) ;
         let specStrength = clamp(materialUniform.specularColor.a, 0.0, 1.0);
         return indirectionSpecFactor * occlusion * specStrength;
     }
     #endif

     const  c0 = vec4f(-1, -0.0275, -0.572, 0.022 );
     const  c1 = vec4f(1, 0.0425, 1.04, -0.04 );
     fn LUT_Approx( roughness:f32,  NoV:f32 )->vec2f
     {
         // [ Lazarov 2013, "Getting More Physical in Call of Duty: Black Ops II" ]
         // Adaptation to fit our G term.
         var r = roughness * c0 + c1;
         var a004 = min( r.x * r.x, exp2( -9.28 * NoV ) ) * r.x + r.y;
         var AB = vec2f( -1.04, 1.04 ) * a004 + r.zw;
         return saturate(AB);
     }

`
    );

    let BxDF_frag = (
      /*wgsl*/
      `
  #include "Clearcoat_frag"
  #include "BRDF_frag"
  #include "MathShader"
  #include "FastMathShader"
  #include "BitUtil"
  #include "Common_frag"
  #include "GlobalUniform"
  #include "SHCommon_frag"

  #include "PhysicMaterialUniform_frag"
  #include "NormalMap_frag"
  #include "LightingFunction_frag"
  #include "Irradiance_frag"
  #include "ColorUtil_frag"
  #include "BxdfDebug_frag"
  #include "ReflectionCG"
 
  //ORI_ShadingInput
  fn initFragData() {
      // fragData.Albedo = vec4f(gammaToLiner(ORI_ShadingInput.BaseColor.rgb),ORI_ShadingInput.BaseColor.w) ;
      fragData.Albedo = vec4f((ORI_ShadingInput.BaseColor.rgb),ORI_ShadingInput.BaseColor.w) ;
      fragData.Ao = clamp( pow(ORI_ShadingInput.AmbientOcclusion,materialUniform.ao) , 0.0 , 1.0 ) ; 
      fragData.Roughness = clamp((ORI_ShadingInput.Roughness),0.0001,1.0) * 1.85 ; 
      fragData.Metallic = ORI_ShadingInput.Metallic ; 
      fragData.Emissive = gammaToLiner(ORI_ShadingInput.EmissiveColor.rgb) * materialUniform.emissiveIntensity ; 
      fragData.N = ORI_ShadingInput.Normal;
      let viewDir = normalize(globalUniform.CameraPos.xyz - ORI_VertexVarying.vWorldPos.xyz) ;
      fragData.V = viewDir ;

      #if USE_TANGENT
        fragData.T = ORI_VertexVarying.TANGENT.xyz * ORI_VertexVarying.TANGENT.w ;
      #endif
 
      let R = 2.0 * dot( fragData.V , fragData.N ) * fragData.N - fragData.V ;
      fragData.R = R ;//reflect( fragData.V , fragData.N ) ;

      fragData.NoV = saturate(dot(fragData.N, fragData.V)) ;

      // F0 derived from IOR via the Schlick approximation:
      //   F0 = ((ior - 1) / (ior + 1))^2
      // The standard KHR_materials_ior derivation. At the canonical
      // ior=1.5 this collapses to 0.04 (the legacy hard-coded value),
      // so existing demos that don't touch ior get unchanged visuals.
      // Pulling ior down (water = 1.33, F0 ≈ 0.02) softens the rim
      // Fresnel; pushing it up (sapphire / diamond, ior 1.77 / 2.42,
      // F0 ≈ 0.077 / 0.17) lights it up. This is also why IOR has
      // visible effect on a transmissive surface even at thickness=0
      // — F0 governs the lit-signal Fresnel split between
      // specular reflection and transmitted refraction.
      // specularColor (KHR_materials_specular) modulates the result
      // for non-physical hue tints (default white = no tint).
      let iorF0 = pow((materialUniform.ior - 1.0) / max(materialUniform.ior + 1.0, 1e-4), 2.0);
      let dielectricF0 = vec3<f32>(iorF0) * materialUniform.specularColor.rgb;
      fragData.F0 = mix(dielectricF0, fragData.Albedo.rgb, fragData.Metallic);
      // fragData.F0 = gammaToLiner(fragData.F0);
      
      fragData.F = computeFresnelSchlick(fragData.NoV, fragData.F0);
      fragData.KD = vec3<f32>(fragData.F) ;
      fragData.KS = vec3<f32>(0.0) ;

      fragData.Indirect = 0.0 ;
      fragData.Reflectance = 1.0 ;

      fragData.ClearcoatRoughness = materialUniform.clearcoatRoughnessFactor ;
      fragData.ClearcoatIor = materialUniform.clearcoatIor ;
      fragData.ClearcoatFactor = materialUniform.clearcoatFactor;
        
      #if USE_CLEARCOAT_ROUGHNESS
        fragData.ClearcoatRoughness *= getClearcoatRoughness() ;
        fragData.ClearcoatFactor *= getClearcoatWeight() ;
      #endif
  }

  fn BxDFShading(){
      initFragData();

      let sunLight = lightBuffer[0] ;

      var irradiance = vec3<f32>(0.0) ;
      #if USEGI
          irradiance += getIrradiance().rgb ;
      #else
          let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
          #if USE_CASTREFLECTION
              irradiance += globalUniform.hdrExposure * (globalUniform.skyExposure * textureSampleLevel(prefilterMap, prefilterMapSampler, fragData.N.xyz, 0.8 * (MAX_REFLECTION_LOD) ).rgb);
          #else
              useSphereReflection();
              irradiance = getReflectionsEnv(fragData.N,ORI_VertexVarying.vWorldPos.xyz,1.0) ;
          #endif
       #endif
      fragData.Irradiance = irradiance.rgb ;

      //***********lighting-PBR part********* 
      var F = FresnelSchlickRoughness(fragData.NoV, fragData.Albedo.rgb , fragData.Roughness);
      var kS = F;
      var kD = vec3(1.0) - kS;
      kD = kD * (1.0 - fragData.Metallic);
      //***********lighting-PBR part********* 
      
      //***********indirect-specular part********* 
      var surReduction = 1.0/(fragData.Roughness * fragData.Roughness + 1.0);
      var grazingTerm = saturate(1.0 - fragData.Roughness + kD);
      var surfaceReduction = 1.0 / (pow(fragData.Roughness,2.0) + 1.0);
      var fresnelLerp = FresnelLerp(fragData.NoV,fragData.F0.rgb,vec3<f32>(grazingTerm)) ;  
      var iblSpecularResult = fresnelLerp * surReduction ;
      //***********indirect-specular part********* 

      //***********lighting-PBR part********* 
      var diffuseColor = mix(fragData.Albedo.rgb,vec3f(0.04),fragData.Metallic);
      var specColor = vec3<f32>(0.0) ;
      let lightIndex = getCluster();
      let start = max(lightIndex.start, 0.0);
      let count = max(lightIndex.count, 0.0);
      let end = max(start + count , 0.0);
      for(var i:i32 = i32(start) ; i < i32(end); i += 1 )
      {
          let light = getLight(i32(i));
          switch (light.lightType) {
            case PointLightType: {
              specColor += pointLighting(ORI_VertexVarying.vWorldPos.xyz, light ,iblSpecularResult) ;
              break;
            }
            case DirectLightType: {
              specColor += directLighting(light,iblSpecularResult);
              // specColor = iblSpecularResult;
              break;
            }
            case SpotLightType: {
              specColor += spotLighting( ORI_VertexVarying.vWorldPos.xyz, light ,iblSpecularResult) ;
              break;
            }
            default: {
              break;
            }
          }
      }

      //***********indirect-ambient part********* 
      // var kdLast = (1.0 - 0.04) * (1.0 - fragData.Metallic);    
      var iblDiffuseResult : vec3f ;

      let MAX_LOD  = i32(textureNumLevels(prefilterMap)) ;
      let mip = roughnessToMipmapLevel(fragData.Roughness,MAX_LOD) * f32(MAX_LOD) * 0.5;
    
      var indirectionDiffuse = indirectionDiffuse_Function(fragData.NoV,fragData.N,fragData.Metallic,fragData.Albedo.rgb,fragData.Roughness,fragData.Ao,fragData.F0);
      iblDiffuseResult += indirectionDiffuse / 3.14;

      var indirectionSpec    = indirectionSpec_Function(fragData.R,fragData.Roughness,fragData.NoV,fragData.Ao,gammaToLiner(fragData.F0));
      #if USE_CASTREFLECTION
        indirectionSpec *= globalUniform.hdrExposure ;
      #endif

      // Export the IBL specular term so material-level shaders can
      // pull a *clean* highlight signal — used by PBRLitShader's
      // transmission cutout path to preserve real highlights on top
      // of refraction without doubling diffuse contribution.
      fragData.Specular = indirectionSpec;

      var color = vec3f(iblDiffuseResult + indirectionSpec + specColor)  ;
      // var color = vec3f(indirectionDiffuse )  ;

      var clearCoatColor = vec3<f32>(0.0);
      #if USE_CLEARCOAT
        let clearCoatBaseColor = vec3<f32>(1.0) * materialUniform.baseColor.rgb ;
        let clearNormal = fragData.N ;
        let clearcoatRoughness = fragData.ClearcoatRoughness ;
           
        for(var i:i32 = i32(start) ; i < i32(end); i += 1 )
        {
            let light = getLight(i32(i));
            switch (light.lightType) {
              case PointLightType: {
                var lightColor = light.lightColor.rgb  ;
                var att = pointAtt(ORI_VertexVarying.vWorldPos.xyz, light);
                clearCoatColor += ClearCoat_BRDF( color , materialUniform.clearcoatColor.rgb , fragData.ClearcoatIor , clearNormal ,  light.direction , fragData.V , clearcoatRoughness , lightColor,  att );
                break;
              }
              case DirectLightType: {
                var lightColor = getHDRColor( light.lightColor.rgb , light.linear )  ;
                var att = max(0.0,light.intensity);
                clearCoatColor += ClearCoat_BRDF( color , materialUniform.clearcoatColor.rgb , fragData.ClearcoatIor , clearNormal ,  light.direction , fragData.V , clearcoatRoughness , lightColor,  att );
                break;
              }
              case SpotLightType: {
                // var lightColor = light.lightColor.rgb  ;
                // var att = pointAtt(ORI_VertexVarying.vWorldPos.xyz, light);
                // clearCoatColor += ClearCoat_BRDF( color , materialUniform.clearcoatColor.rgb , 1.5 , clearNormal ,  light.direction , fragData.V , clearcoatRoughness , lightColor,  att );
                break;
              }
              default: {
                break;
              }
            }
        }
       
        color = clearCoatColor ;
      #endif
      
        // Output linear HDR — the swapchain runs sRGB-srgb format
        // so the GPU does the linear-to-sRGB encode on present.
        // Doing both would double-encode (washed out). TonemapPost
        // is the LDR clamp/curve before this.
        var retColor = color.rgb;
        retColor += fragData.Emissive.xyz ;

        // Engine-wide premultiplied-alpha convention: COLOR pass output is
        // (rgb*alpha, alpha). BlendMode.NORMAL/ALPHA pair with srcFactor=one
        // so the final blend is rgb*alpha + dst*(1-alpha). ADD pairs with
        // (one, one) and transparent pixels zero out at source. OIT_DEPTH_PEEL
        // sub-passes premultiply downstream in Common_frag, so emit
        // straight-alpha there to avoid alpha^2.
        var viewColorPremul = vec4<f32>( retColor.rgb * fragData.Albedo.w, fragData.Albedo.a) ;

        var vNormal = ORI_VertexVarying.vWorldNormal.rgb ;

        let gBuffer = packNHMDGBuffer(
          getGBufferDepth(),
          fragData.Albedo.rgb,
          viewColorPremul.rgb,
          vec3f(fragData.Roughness,fragData.Metallic,fragData.Ao),
          vNormal,
          fragData.Albedo.a
        ) ;

        #if USE_OIT_DEPTH_PEEL
          ORI_FragmentOutput.color = viewColorPremul;
        #else
          #if USE_CASTREFLECTION
            ORI_FragmentOutput.gBuffer = gBuffer;
          #else
            ORI_FragmentOutput.gBuffer = gBuffer;
            ORI_FragmentOutput.color = viewColorPremul;
          #endif
        #endif
  }

  `
    );

    let Clearcoat_frag = (
      /*wgsl*/
      `
    #if USE_CLEARCOAT_ROUGHNESS
    @group(1) @binding(auto)
    var clearCoatRoughnessMapSampler: sampler;
    @group(1) @binding(auto)
    var clearCoatRoughnessMap: texture_2d<f32>;

    fn getClearcoatRoughness() -> f32{
        let clearcoatRoughness = textureSample(clearCoatRoughnessMap, clearCoatRoughnessMapSampler, ORI_VertexVarying.fragUV0.xy).g;
        return clearcoatRoughness;
    }

    fn getClearcoatWeight() -> f32{
        let clearcoatWeight = textureSample(clearCoatRoughnessMap, clearCoatRoughnessMapSampler, ORI_VertexVarying.fragUV0.xy).r;
        return clearcoatWeight;
    }
    #else
    fn getClearcoatRoughness() -> f32{
        return 1.0;
    }
    fn getClearcoatWeight() -> f32{
        return 1.0;
    }
    #endif

    #if USE_CLEARCOAT
    fn ClearCoat_BRDF( baseColor:vec3<f32>, clearCoatColor:vec3<f32> , clearCoatIor:f32 ,N:vec3<f32>, L:vec3<f32> ,  V:vec3<f32> , clearCoatPerceptualRoughness:f32 ,lightColor:vec3f, att:f32) -> vec3<f32> {
        var factor = clamp(clearCoatPerceptualRoughness, 0.0001, 1.0);
        var clearCoatRoughness = factor ;
        let lightDir = -L ;
        let H = normalize( V + lightDir);
        // let LoH = dot(lightDir,H);
        let NoV = max(dot(N,V),0.00001);
        // let NoL = max(dot(N,lightDir),0.00001);
        // let NoH = max(dot(N,H),0.00001);

        // let clearSpeclur = IBLEnv2(fragData.R,clearCoatRoughness);
        // let F0 = IORToF0(clearCoatIor);
        // let Fr = FresnelSchlickRoughness( NoV , vec3<f32>(clearCoatColor) , clearCoatRoughness ) ;
        // var Fd = clearCoatColor ;
        // clear coat BRDF
        // var Dc = D_GGX(NoH,clearCoatRoughness);
        // var Vc = V_Kelemen(LoH) * NoL;
        // var Fc = F_Schlick2( vec3<f32>(F0) , NoV) ;
        // var Frc = (Dc * Vc) * Fc;
        // base layer attenuation for energy compensation
        // let oneMinusFc  = 1.0 - Fc;

        // let brdfSpecular = clearSpeclur * ((Fd + Fr * oneMinusFc) * oneMinusFc + Frc)  * att * lightColor; 
        var iblSpecular = vec3<f32>(0.0);
        // return brdfSpecular ;

        iblSpecular = indirectionSpec_Function(fragData.R,clearCoatRoughness,NoV,1.0,(clearCoatColor * att * vec3f(IORToF0(clearCoatIor))));
        // iblSpecular = IBLEnv2(fragData.R,clearCoatRoughness);
        // return mix(baseColor , brdfSpecular + iblSpecular ,fragData.ClearcoatFactor) ;
        // return vec3f(baseColor + (clearCoatColor * iblSpecular) * fragData.ClearcoatFactor) ;
        return mix(baseColor , (clearCoatColor * iblSpecular) , fragData.ClearcoatFactor) ;
        // return iblSpecular ;
    }
    #endif
`
    );

    let Lit_shader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "BxDF_frag"

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        ORI_ShadingInput.BaseColor = materialUniform.baseColor ;
        ORI_ShadingInput.Roughness = materialUniform.roughness  ;
        ORI_ShadingInput.Metallic = materialUniform.metallic ;
        ORI_ShadingInput.Specular = 0.5 ;
        ORI_ShadingInput.AmbientOcclusion = 1.0 ;
        ORI_ShadingInput.EmissiveColor = vec4<f32>(0.0);

        ORI_ShadingInput.Normal = ORI_VertexVarying.vWorldNormal.rgb ;

        BxDFShading();
    }
`
    );

    let PBRLItShader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "BxDF_frag"
    #include "AlphaHash_frag"

    @group(1) @binding(auto)
    var baseMapSampler: sampler;
    @group(1) @binding(auto)
    var baseMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var normalMapSampler: sampler;
    @group(1) @binding(auto)
    var normalMap: texture_2d<f32>;

    // #if USE_ARMC
        // @group(1) @binding(auto)
        // var maskMapSampler: sampler;
        // @group(1) @binding(auto)
        // var maskMap: texture_2d<f32>;
    // #endif

    // #if USE_MR
        @group(1) @binding(auto)
        var maskMapSampler: sampler;
        @group(1) @binding(auto)
        var maskMap: texture_2d<f32>;
    // #endif

    #if USE_AOTEX
        @group(1) @binding(auto)
        var aoMapSampler: sampler;
        @group(1) @binding(auto)
        var aoMap: texture_2d<f32>;
    #endif

    @group(1) @binding(auto)
    var emissiveMapSampler: sampler;
    @group(1) @binding(auto)
    var emissiveMap: texture_2d<f32>;

    #if USE_TRANSMISSION
        @group(1) @binding(auto)
        var sceneColorPyramidSampler: sampler;
        @group(1) @binding(auto)
        var sceneColorPyramid: texture_2d<f32>;
        #if USE_TRANSMISSIONMAP
            @group(1) @binding(auto)
            var transmissionMapSampler: sampler;
            @group(1) @binding(auto)
            var transmissionMap: texture_2d<f32>;
        #endif
        #if USE_THICKNESSMAP
            @group(1) @binding(auto)
            var thicknessMapSampler: sampler;
            @group(1) @binding(auto)
            var thicknessMap: texture_2d<f32>;
        #endif
    #endif

    var<private> debugOut : vec4f = vec4f(0.0) ;

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
   
        let baseMapOffsetSize = materialUniform.baseMapOffsetSize;
        var uv = transformUV(ORI_VertexVarying.fragUV0,baseMapOffsetSize) ; 

        #if USE_SRGB_ALBEDO
            ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
            // Sampled value is already linear (rgba8unorm-srgb hardware
            // decode), so no software gammaToLiner. Modulate component-
            // wise with baseColor — rgb*rgb, alpha*alpha. The previous
            // form did vec4*vec3 which WGSL rejects (no matching
            // overload); compilation only failed for assets that
            // actually flipped USE_SRGB_ALBEDO, which was an uncommon
            // path until glTF auto-set it post-#1.
            ORI_ShadingInput.BaseColor = vec4<f32>( ORI_ShadingInput.BaseColor.rgb * materialUniform.baseColor.rgb, ORI_ShadingInput.BaseColor.a * materialUniform.baseColor.a)  ;
        #else
            ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
            ORI_ShadingInput.BaseColor = vec4f(gammaToLiner(ORI_ShadingInput.BaseColor.rgb),ORI_ShadingInput.BaseColor.a)  ;
            ORI_ShadingInput.BaseColor *= vec4f(materialUniform.baseColor.rgba)  ;
        #endif

        let roughnessMapOffsetSize = materialUniform.roughnessMapOffsetSize;
        var uv4 = transformUV(ORI_VertexVarying.fragUV0,roughnessMapOffsetSize); 
        var maskTex = textureSample(maskMap, maskMapSampler, uv4 );
       
        #if USE_ALPHA_A
            ORI_ShadingInput.BaseColor.a =  ORI_ShadingInput.BaseColor.a * (maskTex.a) ;
        #endif

        #if USE_ALPHACUT
            if( (ORI_ShadingInput.BaseColor.a - materialUniform.alphaCutoff) <= 0.0 ){
                // discard kills the fragment; no need to write @location outputs.
                discard;
            }
        #endif

        #if USE_ALPHAHASH
            // Stochastic alpha test: per-fragment threshold from a
            // spatial hash of world position. Combined with TAA jitter
            // the result converges to true alpha over a few frames.
            // Routes through the opaque queue (depthWriteEnabled=true),
            // so writes interact correctly with depth-buffer consumers
            // (shadows, SSR, SSAO, transmission backdrop).
            if (ORI_ShadingInput.BaseColor.a < alphaHash3D(ORI_VertexVarying.vWorldPos.xyz)) {
                discard;
            }
        #endif

        useShadow();

        var roughnessChannel:f32 = 1.0 ;
        #if USE_ROUGHNESS_A
            roughnessChannel = maskTex.a ;
        #else if USE_ROUGHNESS_R
            roughnessChannel = maskTex.r ;
        #else if USE_ROUGHNESS_G
            roughnessChannel = maskTex.g ;
        #else if USE_ROUGHNESS_B
            roughnessChannel = maskTex.b ;
        #else if USE_ALBEDO_A
            roughnessChannel = ORI_ShadingInput.BaseColor.a ;
        #endif  

        #if USE_SMOOTH
            var roughness = ( 1.0 - roughnessChannel ) * materialUniform.roughness;
            ORI_ShadingInput.Roughness = clamp(roughness , 0.0001 , 1.0);
        #else
            ORI_ShadingInput.Roughness = clamp(roughnessChannel * materialUniform.roughness ,0.0001,1.0);
        #endif 

        var metallicChannel:f32 = 1.0 ;
        #if USE_METALLIC_A
            metallicChannel = maskTex.a ;
        #else if USE_METALLIC_R
            metallicChannel = maskTex.r ;
        #else if USE_METALLIC_G
            metallicChannel = maskTex.g ;
        #else if USE_METALLIC_B
            metallicChannel = maskTex.b ;
        #endif    

        ORI_ShadingInput.Metallic = metallicChannel * materialUniform.metallic ;
   
        var aoChannel:f32 = 1.0 ;
        #if USE_AOTEX
            let aoMapOffsetSize = materialUniform.aoMapOffsetSize;
            var aoMapOffsetSizeUV = transformUV(ORI_VertexVarying.fragUV0,aoMapOffsetSize); 
            var aoMap = textureSample(aoMap, aoMapSampler, ORI_VertexVarying.fragUV0 );
            aoChannel = aoMap.g ;
        #else
            #if USE_AO_A
                aoChannel = maskTex.a ;
            #else if USE_AO_R
                aoChannel = maskTex.r ;
            #else if USE_AO_G
                aoChannel = maskTex.g ;
            #else if USE_AO_B
                aoChannel = maskTex.b ;
            #endif  
        #endif

        ORI_ShadingInput.AmbientOcclusion = aoChannel ;
        ORI_ShadingInput.Specular = 1.0 ;

        let emissiveMapOffsetSize = materialUniform.emissiveMapOffsetSize;
        var emissiveUV = transformUV(ORI_VertexVarying.fragUV0,emissiveMapOffsetSize) ;
        #if USE_EMISSIVEMAP
            var emissiveMapColor = textureSample(emissiveMap, emissiveMapSampler , emissiveUV ) ;
            let emissiveColor = materialUniform.emissiveColor.rgb * emissiveMapColor.rgb * materialUniform.emissiveIntensity ;
            ORI_ShadingInput.EmissiveColor = vec4<f32>(emissiveColor.rgb,1.0);
        #else
            let emissiveColor = materialUniform.emissiveColor.rgb * materialUniform.emissiveIntensity ;
            ORI_ShadingInput.EmissiveColor = vec4<f32>(emissiveColor,1.0);
        #endif

        let normalMapOffsetSize = materialUniform.normalMapOffsetSize;
        var nomralUV = transformUV(ORI_VertexVarying.fragUV0,normalMapOffsetSize) ;
        var Normal = textureSample(normalMap,normalMapSampler,nomralUV).rgb ;
        // Flip on back-facing fragments so cullMode='none' surfaces don't
        // receive direct light / shadows on the side facing away from sun.
        let face = select(-1.0, 1.0, ORI_VertexVarying.face);
        let normal = unPackRGNormal(Normal,1.0,face) ;
        ORI_ShadingInput.Normal = normal ;
     
        BxDFShading();

        #if USE_TRANSMISSION
            // KHR_materials_transmission — sample the opaque-world
            // backdrop captured by SceneColorPyramidFeature.
            //
            // Refraction follows the KHR_materials_volume convention:
            // build a 3D refracted ray of length thickness starting
            // from the fragment's world position, then project its
            // exit point back to clip space and sample the pyramid at
            // that UV. This gives per-fragment offsets that depend on
            // surface curvature, view angle, and distance to camera —
            // the volumetric refraction look (gradient amber, multiple
            // colour bands across the body) that the previous flat
            // 2D normal.xy * (ior-1) approximation couldn't produce.
            let screenUV = ORI_VertexVarying.fragCoord.xy /
                vec2f(globalUniform.windowWidth, globalUniform.windowHeight);
            let viewDir = normalize(globalUniform.CameraPos.xyz - ORI_VertexVarying.vWorldPos.xyz);
            let normalWS = normalize(ORI_ShadingInput.Normal);
            // -viewDir points from camera into the surface; refract()
            // returns the transmitted direction continuing through the
            // medium. eta = 1/ior because we go from air (n≈1) into
            // glass (n=ior). For ior ≥ 1 the discriminant stays
            // non-negative so refract never returns the zero TIR
            // sentinel here.
            let refractDir = refract(-viewDir, normalWS, 1.0 / max(materialUniform.ior, 1.0));
            // glTF KHR_materials_volume: thicknessTexture G channel
            // scales thicknessFactor per-fragment, so thin regions
            // (wings, fins) stay bright while only thick regions (a
            // body core) reach full attenuation.
            var thickness = materialUniform.thicknessFactor;
            #if USE_THICKNESSMAP
                thickness = thickness * textureSample(thicknessMap, thicknessMapSampler, uv).g;
            #endif
            // Ray length in world units, scaled per-axis by modelScale
            // (vertex stage computed length(worldMat[i].xyz) into
            // ORI_VertexVarying.modelScale). Uniform meshes collapse to
            // (s,s,s); unscaled to (1,1,1). Matches the standard
            // KHR_materials_volume transmission ray so a stretched
            // glass cube refracts proportionally to its world dims.
            let transmissionRay = refractDir * thickness * ORI_VertexVarying.modelScale;
            let exitWorld = ORI_VertexVarying.vWorldPos.xyz + transmissionRay;
            // Project exit point back to NDC, then to UV space. Y is
            // flipped because WGSL's fragCoord origin is top-left
            // (y-down) while the post-projective NDC has y-up.
            let exitClip = globalUniform.projMat * globalUniform.viewMat * vec4f(exitWorld, 1.0);
            let exitNDC = exitClip.xy / max(exitClip.w, 1e-4);
            let refractedUV = vec2f(exitNDC.x * 0.5 + 0.5, exitNDC.y * -0.5 + 0.5);
            // Clamp to texture interior — the exit point can land
            // outside the framebuffer for thick glass + grazing
            // angles, and clamp behaviour beats whatever the sampler's
            // address mode would do (typically smear edge pixels).
            let sampleUV = clamp(refractedUV, vec2f(0.002), vec2f(0.998));
            // Roughness-aware mip selection. The reference
            // implementation pairs an IOR-roughness adjustment with
            // bicubic sampling; we approximate with a simple linear
            // mapping into the pyramid's mip chain — mip 0 for
            // polished glass, deepest mip for fully rough.
            let pyramidLodMax = f32(textureNumLevels(sceneColorPyramid)) - 1.0;
            // IOR-roughness adjustment: refraction blur scales
            // by an IOR-derived factor. ior=1 (no refraction) drops
            // the factor to 0 → sharp sample regardless of roughness;
            // ior >= 1.5 (typical glass / crystal) clamps the factor
            // to 1 → roughness drives blur as before. Subtle for the
            // common 1.5..2.4 range, important for transmission of
            // very-low-IOR media (water vapour, thin films).
            let iorRoughnessFactor = clamp(materialUniform.ior * 2.0 - 2.0, 0.0, 1.0);
            let effectiveRefractionRoughness = clamp(ORI_ShadingInput.Roughness, 0.0, 1.0) * iorRoughnessFactor;
            let lod = effectiveRefractionRoughness * pyramidLodMax;
            let transmittedRGBA = textureSampleLevel(sceneColorPyramid, sceneColorPyramidSampler, sampleUV, lod);
            let transmitted = transmittedRGBA.rgb;
            // Volumetric attenuation, log-space form (the standard
            // KHR_materials_volume derivation):
            //   coeff       = -log(attenuationColor) / attenuationDistance
            //   transmittance = exp(-coeff * distance)
            //                 = pow(attenuationColor, distance / attenuationDistance)
            // distance is the actual world-space path length light
            // travels through the medium — length(transmissionRay),
            // i.e. thickness already scaled by modelScale (and by the
            // thickness texture above). Using the raw, unscaled
            // thicknessFactor here (as opposed to the ray actually
            // traced above) previously made the exponent too large on
            // any scaled-down mesh, crushing attenuationColor's minor
            // channels toward zero and biasing the result red.
            var transmittance = vec3f(1.0);
            if (materialUniform.attenuationDistance < 1.0e18 && thickness > 0.0) {
                let safeColor = max(materialUniform.attenuationColor.rgb, vec3f(1e-4));
                let ratio = length(transmissionRay) / materialUniform.attenuationDistance;
                transmittance = pow(safeColor, vec3f(ratio));
            }
            var tf = clamp(materialUniform.transmissionFactor, 0.0, 1.0);
            #if USE_TRANSMISSIONMAP
                // glTF spec: transmissionTexture R channel scales the
                // factor per-fragment, so a single material can have
                // opaque + glassy regions (e.g. a window frame).
                tf = tf * textureSample(transmissionMap, transmissionMapSampler, uv).r;
            #endif
            // Tint the transmitted backdrop by baseColor (the user's
            // surface tint) only — transmittance above already fully
            // encodes the attenuationColor absorption via Beer-Lambert,
            // so multiplying attenuationColor in again here would
            // apply it twice (squaring it), over-darkening and
            // red-shifting the result.
            let tint = materialUniform.baseColor.rgb;
            let transmittedTinted = transmitted * transmittance * tint;
            // Default behavior matches the standard KHR_materials_
            // transmission path on an opaque canvas: mix lit color
            // with the attenuated backdrop and keep alpha at 1 so
            // opaque-queue depth and blending semantics hold.
            //
            // When transmissionAlphaMode is non-zero, the fragment also
            // attenuates its output alpha by transmission so an
            // alpha-true swapchain composites whatever lives behind the
            // canvas (HTML page background, video, ...) through the
            // glass — the alpha-canvas transmission trick.
            // Sampling the pyramid alpha for this would feed back
            // into itself (the pyramid is captured AfterOpaque, after
            // this fragment writes), so we derive alpha from 1 - tf
            // directly. The mode is opt-in to preserve existing
            // demos that share an opaque canvas with other geometry.
            let alphaMode = clamp(materialUniform.transmissionAlphaMode, 0.0, 1.0);
            // RGB: in alpha-cutout mode we approximate the standard
            // PBR material's specular-preserving behaviour — the
            // diffuse lobe is replaced by the attenuated backdrop
            // sample, but a fixed fraction of the lit signal (specular
            // + env reflection) survives unattenuated. In opaque mode
            // the original full mix stays; existing samples rely on it
            // for clean refraction through colored backdrops.
            let lit = ORI_FragmentOutput.color.rgb;
            // Pull the *real* IBL specular term BxDF_frag exported via
            // fragData.Specular. The standard PBR transmission flow
            // keeps the diffuse and specular sums separated, applies
            // transmission only to the diffuse, and adds specular back
            // unconditionally. We do the equivalent here by subtracting
            // spec from the combined lit value to approximate the
            // diffuse-only term, mixing that with the refracted env
            // sample, then adding spec back at the end. Without this,
            // transmission=1 used to wipe out the entire lit signal
            // (including specular), producing a glass surface with no
            // visible env reflection / rim highlights — visually much
            // weaker than the reference render at the same parameters.
            let cleanSpec = fragData.Specular;
            let litMinusSpec = max(lit - cleanSpec, vec3f(0.0));
            let diffuseLike = litMinusSpec;
            // In cutout mode tint the preserved highlight by
            // specularColor.rgb. The BRDF LUT's AB.g term keeps the
            // base IBL spec partially white regardless of F0, which
            // dilutes the user's chosen specular hue by the time it
            // reaches the visible output. This local multiplier sits
            // between fragData.Specular and the final composite —
            // direct enough that specular color noticeably tints the
            // dragon's highlights — and is mixed to white at
            // alphaMode=0 so opaque-queue PBR materials are
            // untouched. We mix back to white at metallic=1 so the
            // chrome path still mirrors the env honestly.
            // Specular is preserved on top of transmission in BOTH
            // opaque and cutout branches now (used to be cutout-only,
            // which made transmission=1 read as a flat refraction with
            // no env highlights). specularColor.rgb tints the
            // dielectric F0 to compensate for the BRDF LUT's AB.g
            // term — without it the user-set specular color gets diluted by
            // the time it reaches the visible output. Mix back to
            // white at metallic=1 so the chrome path mirrors the env
            // honestly (KHR_materials_specular spec).
            let specTint = mix(materialUniform.specularColor.rgb, vec3<f32>(1.0), fragData.Metallic);
            let tintedSpec = cleanSpec * specTint;
            let preservedSpec = tintedSpec;
            // KHR_materials_transmission spec: "A material with metallic
            // = 1 cannot transmit light." Standard PBR pipelines get
            // this for free because they multiply diffuse by kD =
            // (1-F)*(1-metallic), so a pure metal has zero diffuse
            // term and transmission, which only replaces diffuse, has
            // no visible effect — the surface becomes a pure mirror.
            // Our diffuseLike here also includes direct-light spec
            // contribution, so we need to gate transmission explicitly
            // by (1 - metallic) to get the same chrome-at-metallic=1
            // look the reference render produces.
            let metalMask = 1.0 - clamp(fragData.Metallic, 0.0, 1.0);
            let effectiveTf = tf * metalMask;
            // bodyRGB is the diffuse / transmitted-backdrop part of
            // the dragon (no specular). Spec is added separately
            // below so it can also contribute on top of the canvas
            // composite over a transparent backdrop (cells region) —
            // matching the standard "specular halo over alpha-canvas"
            // behaviour.
            //
            // Refracted-alpha gating + attenuation fallback. When the
            // refraction sample lands on a canvas-empty pixel
            // (transmittedRGBA.a = 0, e.g. a fragment whose refracted
            // exit point projects into the cells / HTML region),
            // textureSampleLevel returns (0,0,0,0) and the standard
            // transmittedTinted (rgb * transmittance * tint) collapses
            // to black. We instead fall back to a pure-attenuation
            // sample — what a beam of WHITE light would look like
            // after travelling thickness units through the volume.
            // That is transmittance * tint with the source RGB
            // implicitly set to white, and it preserves the dragon's
            // amber body colour over cells so the user sees a
            // continuously-shaded body whether the fragment refracts
            // cloth or cells / page-background.
            let refractCoverage = clamp(transmittedRGBA.a, 0.0, 1.0);
            let transmittedFallback = transmittance * tint;
            let transmittedFinal = mix(transmittedFallback, transmittedTinted, refractCoverage);
            let bodyRGB = mix(diffuseLike, transmittedFinal, effectiveTf);
            let dragonOpaqueRGB = bodyRGB + preservedSpec;
            // Alpha-blend simulation for cutout mode. The standard
            // PBR transparent path sets material.transparent=true and
            // lets the GPU blend state run the over-operator; we draw
            // with BlendMode.NONE in the opaque queue (depth-tested
            // override), so we emulate the same math in the shader.
            // backdropDirect samples the pyramid at THIS fragment's
            // screen position (no refraction offset) — the pyramid
            // contains the rest of the world (cloth / floor / walls)
            // at this stage of the frame thanks to the
            // TransmissionOpaqueFeature pipeline split.
            //
            //   srcA      = opacity * pyramid.a            // standard diffuseColor.a
            //   resultRGB = srcA * dragon + (1 - srcA) * pyramid.a * pyramid.rgb
            //   resultA   = srcA + pyramid.a * (1 - srcA)
            //
            // Cloth region (pyramid.a=1): result collapses to
            // (opacity*dragon + (1-opacity)*cloth, 1) — alpha-blend with
            // cloth, HTML fully blocked.
            // Cells region (pyramid.a=0): srcA=0, result=(0,0) — dragon
            // contributes nothing and the canvas's premultiplied
            // compositor reveals the HTML cell at full strength.
            let backdropDirect = textureSample(sceneColorPyramid, sceneColorPyramidSampler, screenUV);
            let opacity = ORI_FragmentOutput.color.a;
            let bodySrcA = opacity;
            // --- Page transmission through canvas alpha ---
            // The HTML page lives in the browser's DOM compositor, not
            // in the GPU scene, so refraction can never *sample* it.
            // The only way glass can "transmit" the page is to lower
            // the canvas alpha by the transmitted fraction and let the
            // premultiplied compositor blend the page behind us:
            //   out = ownLightRGB + page * (1 - alpha)
            //
            // The transmitted fraction may only reveal the page where
            // the transmitted path truly ends in empty space — i.e.
            // neither the refracted sample (refractCoverage) nor the
            // straight-through backdrop at this pixel (backdropDirect.a
            // — the opaque queue OVERWRITES the color buffer, so
            // anything the pyramid holds here would otherwise be lost,
            // not composited by the browser) has scene coverage.
            let directCov = clamp(backdropDirect.a, 0.0, 1.0);
            let sceneCov = max(refractCoverage, directCov);
            // Per-channel medium filter (Beer-Lambert x surface tint).
            // Source-over only offers a SCALAR (1 - alpha) page term,
            // so the colored filter is decomposed:
            //   - the weakest-transmitted channel (tPass) becomes the
            //     scalar page pass-through -> drives alpha;
            //   - the per-channel excess (mediumVis - tPass) is
            //     emitted as own light under a neutral-bright-page
            //     assumption (pageTintGlow).
            // Over a white page the two recombine to exactly
            // mediumVis * page — amber glass reads amber; over colored
            // cells the hue dominates while the cell still shows
            // through at tPass strength.
            let mediumVis = clamp(transmittance * tint, vec3f(0.0), vec3f(1.0));
            // Floor the scalar pass-through at half the average
            // transmission: a fully saturated filter (e.g. pure-yellow
            // attenuation, min channel = 0) would otherwise drive
            // alpha to 1 and read as opaque emissive plastic instead
            // of stained glass. The floor trades a little hue
            // saturation for guaranteed see-through.
            let minVis = min(mediumVis.r, min(mediumVis.g, mediumVis.b));
            let avgVis = dot(mediumVis, vec3f(1.0 / 3.0));
            let tPass = max(minVis, 0.5 * avgVis);
            let pageFrac = 1.0 - sceneCov;
            // The DOM page cannot be refraction-sampled, so a straight
            // scalar pass-through renders the page rigidly undistorted
            // — jarring next to the properly refracted in-scene
            // backdrop. Approximate the glassy read with the two
            // signals refraction produces on the scene side:
            //   - Schlick Fresnel: grazing fragments transmit less and
            //     reflect more, so rims go spec/body instead of page;
            //   - bend fade: where the screen-space refraction offset
            //     is large, the straight-through page is not what the
            //     transmitted ray would actually see — fade it out and
            //     let the medium glow / specular take over, mirroring
            //     the "busy" look of strongly bent regions over cloth.
            let pageNoV = clamp(dot(normalWS, viewDir), 0.0, 1.0);
            let pageF0 = pow((materialUniform.ior - 1.0) / (materialUniform.ior + 1.0), 2.0);
            let pageFresnelT = 1.0 - (pageF0 + (1.0 - pageF0) * pow(1.0 - pageNoV, 5.0));
            let pageBend = length(refractedUV - screenUV);
            let pageBendFade = 1.0 - smoothstep(0.02, 0.25, pageBend);
            let pageVis = pageFresnelT * pageBendFade;
            let pageThrough = effectiveTf * pageFrac * tPass * pageVis;
            // Clamped at 0 — with the floor active a channel can sit
            // below tPass and must not subtract from the body light.
            // Note glow <= 1 - tPass = alpha, so the premultiplied
            // output stays spec-valid without relying on the present
            // pass's alpha lift. Scaled by pageVis like the
            // pass-through itself: the glow models the chromatic part
            // of page light crossing the medium, and light that
            // Fresnel-reflects away or bends off-path never crosses.
            let pageTintGlow = max(mediumVis - vec3f(tPass), vec3f(0.0)) * pageFrac * pageVis;
            // Own transmitted light in cutout mode: refracted scene
            // sample where available, else the straight-through
            // backdrop attenuated by the medium, else the tint glow —
            // the page itself supplies the remaining light through
            // alpha, so keeping the opaque path's white-light fallback
            // here would count the backdrop light twice.
            let transmittedCutout = mix(backdropDirect.rgb * transmittance * tint, transmittedTinted, refractCoverage) + pageTintGlow;
            let bodyCutoutRGB = mix(diffuseLike, transmittedCutout, effectiveTf);
            // canvasAlpha semantics:
            //   scene-backed pixels (sceneCov = 1) -> 1, cloth blocks HTML;
            //   page-backed glass at opacity 1 -> 1 - tf * tPass, HTML
            //   shows through proportionally to the transmission;
            //   opacity < 1 fades the body itself toward directCov.
            let cutoutAlpha = mix(directCov, 1.0 - pageThrough, bodySrcA);
            // Diffuse / transmission part: opacity blends dragon body
            // with the cloth (or whatever else has depth at this
            // pixel). Specular is added unconditionally on top so a
            // glass surface in front of an alpha:true canvas region
            // (HTML cells) still casts bright highlights / reflection
            // halos onto the visible page background.
            let cutoutBodyRGB = bodySrcA * bodyCutoutRGB + (1.0 - bodySrcA) * backdropDirect.a * backdropDirect.rgb;
            let cutoutRGB = cutoutBodyRGB + preservedSpec;
            // Opaque-branch alpha was hardcoded to 1.0, which made the
            // sphere fully visible regardless of the user's opacity
            // slider on materials that flipped the GPU pipeline to
            // alphaMode='BLEND' (Sample_Transmission). Forward the
            // computed BaseColor.a (= baseColor.a * maskTex.a from
            // USE_ALPHA_A) so opacity=0 produces an invisible surface
            // — matching the standard PBR transparent contract.
            // For alphaMode='OPAQUE' GPU pipelines the value is
            // ignored anyway (no blending), so this doesn't change
            // opaque-glass demos.
            let outAlphaOpaque = ORI_FragmentOutput.color.a;
            let outAlpha = mix(outAlphaOpaque, cutoutAlpha, alphaMode);
            let outRGB = mix(dragonOpaqueRGB, cutoutRGB, alphaMode);
            ORI_FragmentOutput.color = vec4f(outRGB, outAlpha);
        #endif
    }
`
    );

    let BxdfDebug_frag = (
      /*wgsl*/
      `
#include "ClusterDebug_frag" 

        fn debugPosition(){
            //ORI_FragmentOutput.color = vec4<f32>(ORI_VertexVarying.vWorldPos.xyz,1.0);
        }

        fn debugMeshID(){
            let meshIDColor = u32(round(ORI_VertexVarying.vWorldPos.w) ) ;
            let color = colorSet[ meshIDColor % 9u] ;
            // ORI_FragmentOutput.color = vec4<f32>(vec3<f32>(color.rgb),1.0);
        }

        fn debugNormal(){
            // ORI_FragmentOutput.color = vec4<f32>(ORI_ShadingInput.Normal.xyz,1.0);
        }

        fn debugUV(){
            // ORI_FragmentOutput.color = vec4<f32>(ORI_VertexVarying.fragUV0.xy,0.0,1.0);
        }

        fn debugColor(){
            // ORI_FragmentOutput.color = vec4<f32>(fragData.Albedo.rgb,1.0);
        }

        fn debugDiffuse(){
            // ORI_FragmentOutput.color = vec4<f32>( fragData.LightChannel.rgb,1.0);
        }

        fn debugAmbient(){
            // ORI_FragmentOutput.color = vec4<f32>(vec3f(fragData.Alpha) ,1.0);
        }
        
        fn debugEmissive(){
            // ORI_FragmentOutput.color = vec4<f32>(fragData.Emissive.rgb,1.0);
        }

        fn debugEnvment(){
            // ORI_FragmentOutput.color = vec4<f32>(fragData.EnvColor.rgb,1.0);
        }

        fn debugAo(){
            // ORI_FragmentOutput.color = vec4<f32>(vec3<f32>(fragData.Ao),1.0);
        }

        fn debugRoughness(){
            // ORI_FragmentOutput.color = vec4<f32>(vec3<f32>(fragData.Roughness),1.0);
        }

        fn debugMetallic(){
            // ORI_FragmentOutput.color = vec4<f32>(vec3<f32>(fragData.Metallic),1.0);
        }

        fn debugIrradiance(){
            // ORI_FragmentOutput.color = vec4<f32>(vec3<f32>(fragData.Irradiance),1.0);
        }

        fn debugTangent(){
            // ORI_FragmentOutput.color = vec4<f32>(vec3<f32>(fragData.T),1.0);
        }

        fn debugFragmentOut(){
            if(ORI_VertexVarying.fragCoord.x > globalUniform.renderState_split) {
                switch (globalUniform.renderState_right)
                {
                  case 0: {
                    debugPosition();
                  }
                  case 1: {
                    debugColor();
                  }
                  case 2: {
                    debugNormal();
                  }
                  case 3: {
                    debugIrradiance();
                  }
                  case 4: {
                    debugTangent();
                  }
                  case 5: {
                    // debugTangent();
                  }
                  case 6: {
                    debugEmissive();
                  }
                  case 7: {
                    debugEnvment();
                  }
                  case 8: {
                    debugAo();
                  }
                  case 9: {
                    debugRoughness();
                  }
                  case 10: {
                    debugMetallic();
                  }
                  case 11: {
                    debugDiffuse();
                  }
                  case 12: {
                    debugAmbient();
                  }
                  case 13: {
                    debugMeshID();
                  }
                  case 14: {
                    #if DEBUG_CLUSTER
                      debugCluster( ORI_VertexVarying.fragCoord );
                    #endif
                  }
                  case 15: {
                    #if DEBUG_CLUSTER
                      debugClusterBox( ORI_VertexVarying.fragCoord );
                    #endif
                  }
                  case 16: {
                    #if DEBUG_CLUSTER
                      debugClusterLightCount( vec4<f32>(ORI_VertexVarying.fragCoord.xyz,0.0));
                      #endif
                  }
                  default: {
                  }
                }
              } else {
                switch (globalUniform.renderState_left)
                {
                  case 0: {
                    debugPosition();
                  }
                  case 1: {
                    debugColor();
                  }
                  case 2: {
                    debugNormal();
                  }
                  case 3: {
                    debugIrradiance();
                  }
                  case 4: {
                    debugTangent();
                  }
                  case 5: {
                    // debugTangent();
                  }
                  case 6: {
                    debugEmissive();
                  }
                  case 7: {
                    debugEnvment();
                  }
                  case 8: {
                    debugAo();
                  }
                  case 9: {
                    debugRoughness();
                  }
                  case 10: {
                    debugMetallic();
                  }
                  case 11: {
                    debugDiffuse();
                  }
                  case 12: {
                    debugAmbient();
                  }
                  case 13: {
                    debugMeshID();
                  }
                  case 14: {
                    #if DEBUG_CLUSTER
                      debugCluster( ORI_VertexVarying.fragCoord );
                    #endif
                  }
                  case 15: {
                    #if DEBUG_CLUSTER
                      debugClusterBox( ORI_VertexVarying.fragCoord );
                    #endif
                  }
                  case 16: {
                    #if DEBUG_CLUSTER
                      debugClusterLightCount( vec4<f32>(ORI_VertexVarying.fragCoord.xyz,0.0));
                      #endif
                  }
                  default: {
                  }
                }
              }
        }
`
    );

    let FullQuad_vert_wgsl = (
      /*wgsl*/
      `
    #include "WorldMatrixUniform"
    #include "GlobalUniform"

    struct MaterialUniform {
    x:f32,
    y:f32,
    width:f32,
    height:f32,
    };

    struct VertexOutput {
        @location(auto) fragUV: vec2<f32>,
        @builtin(position) position: vec4<f32>
    };

    @vertex
    fn main(@builtin(vertex_index) vertexIndex : u32, @builtin(instance_index) index : u32 ) -> VertexOutput {
        const pos = array(
        vec2(-1.0, -1.0), vec2(1.0, -1.0), vec2(-1.0, 1.0),
        vec2(-1.0, 1.0), vec2(1.0, -1.0), vec2(1.0, 1.0),
        );
        const uv = array(
        vec2(1.0, 0.0), vec2(1.0, 1.0), vec2(0.0, 1.0), 
        vec2(1.0, 0.0), vec2(0.0, 1.0), vec2(0.0, 0.0),
        );
        let id = u32(index) ;
        var output : VertexOutput;
        output.fragUV = uv[vertexIndex] ;
        output.position = vec4<f32>(pos[vertexIndex] , 0.0, 1.0) ;
        return output ;
    }
`
    );
    let Quad_vert_wgsl = (
      /*wgsl*/
      `
#include "WorldMatrixUniform"
      #include "GlobalUniform"
   
      struct MaterialUniform {
        x:f32,
        y:f32,
        width:f32,
        height:f32,
      };

      struct VertexOutput {
          @location(auto) fragUV: vec2<f32>,
          @builtin(position) member: vec4<f32>
      };

      @vertex
      fn main(@builtin(instance_index) index : u32,@location(auto) position: vec3<f32>, @location(auto) TEXCOORD_1: vec2<f32>) -> VertexOutput {
        //   let id = u32(index) ;
        //   let worldMatrix = models.matrix[id];
        //   let windowSize = vec2<f32>(globalUniform.windowWidth,globalUniform.windowHeight) ;
        //   let pos = worldMatrix[3].xy ;
        //   let size = vec2<f32>(worldMatrix[0].x,worldMatrix[1].y) / windowSize ;
          let uv = vec2(((TEXCOORD_1.xy * 2.0) - vec2<f32>(1.0))) ;// / windowSize * size - offset ;
          return VertexOutput(TEXCOORD_1, vec4<f32>(uv, 0.0, 1.0));
      }
`
    );
    let Quad_frag_wgsl = (
      /*wgsl*/
      `
    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    };

    var<private> fragUV1: vec2<f32>;
    var<private> o_Target: vec4<f32>;
    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d<f32>;

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var uv = fragUV ;
        uv.y = 1.0 - uv.y ;
        var color: vec4<f32> = textureSample(baseMap, baseMapSampler, uv );

        return FragmentOutput(color);
    }
`
    );
    let Quad_opaque_frag_wgsl = (
      /*wgsl*/
      `
    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    };

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d<f32>;

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var uv = fragUV ;
        uv.y = 1.0 - uv.y ;
        var color: vec4<f32> = textureSample(baseMap, baseMapSampler, uv );
        color.a = 1.0;
        return FragmentOutput(color);
    }
`
    );
    let Quad_premultiply_frag_wgsl = (
      /*wgsl*/
      `
    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    };

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d<f32>;

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var uv = fragUV ;
        uv.y = 1.0 - uv.y ;
        var color: vec4<f32> = textureSample(baseMap, baseMapSampler, uv );
        let coverage = saturate(max(color.r, max(color.g, color.b)));
        color.a = max(color.a, coverage);
        return FragmentOutput(color);
    }
`
    );
    let Quad_depth2d_frag_wgsl = (
      /*wgsl*/
      `
    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    }; 

    var<private> fragUV1: vec2<f32>;
    var<private> o_Target: vec4<f32>;

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_depth_2d ;

    fn Linear01Depth(  z : f32 ) -> f32
    {
        return 1.0 / (1.0 * z + 5000.0);
    }

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var uv = fragUV ;
        uv.y = 1.0 - uv.y ;
        var depth = textureSample(baseMap, baseMapSampler, uv , vec2<i32>(0) ) ;
        return FragmentOutput(vec4<f32>(depth,0.0,0.0,1.0));
    }
`
    );
    let Quad_depthCube_frag_wgsl = (
      /*wgsl*/
      `
    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    };

    var<private> fragUV1: vec2<f32>;
    var<private> o_Target: vec4<f32>;

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_depth_cube ;

    fn uvToXYZ( face : i32 ,  uv : vec2<f32> ) -> vec3<f32>
    {
        var out : vec3<f32> ;
        if(face == 0){
            out = vec3<f32>( 1.0, uv.y, -uv.x);
        }else if(face == 1){
            out = vec3<f32>( -1.0, uv.y, uv.x);
        }else if(face == 2){
            out = vec3<f32>( uv.x, -1.0, uv.y);
        }else if(face == 3){
            out = vec3<f32>( uv.x,  1.0, -uv.y);
        }else if(face == 4){
            out = vec3<f32>( uv.x, uv.y, 1.0);
        }else{	
            out = vec3<f32>( -uv.x, uv.y, -1.0);
        }
        return out ;
    }

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var uv = fragUV ;
        uv.y = 1.0 - uv.y ;
        var ii = 0.16 ;
        var ouv = vec3<f32>(0.0);
        if(uv.x < ii * 6.0){
            ouv = uvToXYZ(5,uv/ii);
        }
        if(uv.x < ii * 5.0){
            ouv = uvToXYZ(4,uv/ii);
        }
        if(uv.x < ii * 4.0){
            ouv = uvToXYZ(3,uv/ii);
        } 
        if(uv.x < ii * 3.0){
            ouv = uvToXYZ(2,uv/ii);
        }
        if(uv.x < ii * 2.0){
            ouv = uvToXYZ(1,uv/ii);
        }
        if(uv.x < ii * 1.0){
            ouv = uvToXYZ(0,uv/ii);
        }
        var depth = textureSample(baseMap, baseMapSampler, ouv ) ;
        depth = 1.0 - depth; 

        return FragmentOutput(vec4<f32>(depth,0.0,0.0,1.0));
    }
`
    );
    let Quad_depth2dArray_frag_wgsl = (
      /*wgsl*/
      `
    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    };

    var<private> fragUV1: vec2<f32>;
    var<private> o_Target: vec4<f32>;

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d_array ;

    struct MaterialData{
        index:f32;
    }

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var uv = fragUV ;
        uv.y = 1.0 - uv.y ;
    
        var depth = textureSample(baseMap, baseMapSampler, ouv ) ;
        depth = 1.0 - depth; 

        return FragmentOutput(vec4<f32>(depth,0.0,0.0,1.0));
    }
`
    );

    let ColorUtil = (
      /*wgsl*/
      `
    fn getHDRColor(color: vec3<f32>, exposure: f32) -> vec3 < f32 > {
        return color * pow(2.4, exposure) ;
    }

    // RGBM encode/decode
    const kRGBMRange = 8.0;

    fn EncodeRGBM( icolor : vec3f ) ->vec4f
    {
        var color = icolor ;
        color *= 1.0 / kRGBMRange;
        var m = max(max(color.x, color.y), max(color.z, 1e-5));
        m = ceil(m * 255) / 255;
        return vec4f(color / m, m);
    }

    fn DecodeRGBM( rgbm : vec4f ) -> vec3f
    {
        return rgbm.xyz * rgbm.w * kRGBMRange;
    }

    fn Luminance(  LinearColor : vec3f, LuminanceFactors: vec3f ) -> f32
    {
        return dot( LinearColor, LuminanceFactors );
    }

    fn lambda2rgb(lambda : f32) -> vec3 < f32 > {
        let ultraviolet = 400.0;
        let infrared = 700.0;

        var a = (lambda - ultraviolet) / (infrared - ultraviolet);
        let c = 10.0;
        var b = vec3<f32>(a) - vec3<f32>(0.75, 0.5, 0.25);
        return max((1.0 - c * b * b), vec3<f32>(0.0));
    }

    fn CEToneMapping(color: vec3<f32>, adapted_lum: f32) -> vec3<f32>
    {
        return 1.0 - exp(-adapted_lum * color);
    }


    fn acesFilm( x:vec3f) -> vec3f {
        return clamp((x*(2.51*x+vec3f(0.03)))/(x*(2.43*x+vec3f(0.59))+vec3f(0.14)),vec3f(0.0),vec3f(1.0));
    }

    fn ACESToneMapping(color: vec3<f32>, adapted_lum: f32) -> vec3<f32>
    {
        let A = 2.51;
        let B = 0.03;
        let C = 2.43;
        let D = 0.59;
        let E = 0.14;

        var color2 = color * adapted_lum;
        color2 = (color2 * (A * color2 + B)) / (color2 * (C * color2 + D) + E);
        return color2;
    }

    fn gammaToLiner(color: vec3<f32>) -> vec3 < f32 > {
        let gammaCorrect = 2.4;
        var color2 = pow(color, vec3<f32>(gammaCorrect));
        return color2 ;
    }

    fn linerToGamma4(color: vec4<f32>) -> vec4 < f32 > {
        let gammaCorrect = 0.416666667;
        var color2 = pow(color, vec4<f32>(gammaCorrect));
        return color2 ;
    }

    fn linerToGamma3(color: vec3<f32>) -> vec3 < f32 > {
        let gammaCorrect = 0.416666667;
        var color2 = pow(color, vec3<f32>(gammaCorrect));
        return color2 ;
    }

    // fn LinearToGammaSpace(linRGB0: vec3<f32>) -> vec3 < f32 > {
    //     var linRGB = max(linRGB0, vec3(0.0, 0.0, 0.0));
    //     linRGB.r = pow(linRGB.r, 0.416666667);
    //     linRGB.g = pow(linRGB.g, 0.416666667);
    //     linRGB.b = pow(linRGB.b, 0.416666667);
    //     return max(1.055 * linRGB - 0.055, vec3(0.0, 0.0, 0.0));
    // }

    fn LinearToGammaSpace(linRGB: vec3<f32>) -> vec3<f32> {
        var linRGB1 = max(linRGB, vec3<f32>(0.0));
        linRGB1 = pow(linRGB1, vec3<f32>(0.4166666567325592));
        return max(((1.0549999475479126 * linRGB1) - vec3<f32>(0.054999999701976776)), vec3<f32>(0.0));
    }

    var<private>sRGB_2_LMS_MAT: mat3x3<f32> = mat3x3<f32>(
        17.8824, 43.5161, 4.1193,
        3.4557, 27.1554, 3.8671,
        0.02996, 0.18431, 1.4670,
    );

    var<private>LMS_2_sRGB_MAT: mat3x3<f32> = mat3x3<f32>(
        0.0809, -0.1305, 0.1167,
        -0.0102, 0.0540, -0.1136,
        -0.0003, -0.0041, 0.6935,
    );

    fn sRGB_2_LMS(RGB: vec3<f32>) -> vec3<f32>
    {
        return sRGB_2_LMS_MAT * RGB;
    }

    fn LMS_2_sRGB(LMS: vec3<f32>) -> vec3<f32>
    {
        return LMS_2_sRGB_MAT * LMS;
    }

    fn LinearToSrgbBranchless(lin: vec3<f32>) -> vec3<f32>
    {
        var lin2 = max(vec3<f32>(6.10352e-5), lin);
        return min(lin2 * 12.92, pow(max(lin2, vec3<f32>(0.00313067)), vec3<f32>(0.416666667)) * vec3<f32>(1.055) - vec3<f32>(0.055));
    }

    fn sRGBToLinear(color : vec3<f32>) -> vec3<f32>
    {
        let color2 = max(vec3<f32>(6.10352e-5), color);
        let c = 0.04045;
        if (color2.r > c && color2.g > c && color2.b > c) {
            return pow(color2 * (1.0 / 1.055) + 0.0521327, vec3<f32>(2.4));
        } else {
            return color2 * (1.0 / 12.92);
        }
    }

    fn BlendNormalRNM( n1:vec3f,  n2:vec3f) -> vec3f
	{
		let t = n1.xyz + vec3f(0.0, 0.0, 1.0);
		let u = n2.xyz * vec3f(-1.0, -1.0, 1.0);
		let r = (t / t.z) * dot(t, u) - u;
		return r;
	}

//     fn ReorientedBlendNormal(){
//         vec3 t = texture(baseMap,   uv).xyz * vec3( 2.0,  2.0, 2.0) + vec3(-1.0, -1.0,  0.0);
// vec3 u = texture(detailMap, uv).xyz * vec3(-2.0, -2.0, 2.0) + vec3( 1.0,  1.0, -1.0);
// vec3 r = normalize(t * dot(t, u) - u * t.z);
// return r;
//     }

//     fn UDNBlendNormal(){
    // vec3 t = texture(baseMap,   uv).xyz * 2.0 - 1.0;
    // vec3 u = texture(detailMap, uv).xyz * 2.0 - 1.0;
    // vec3 r = normalize(t.xy + u.xy, t.z);
    // return r;
//     }


fn packRGBA8( In : vec4f ) ->u32
{
	let r = (u32(saturate(In.r) * 255.0) << 0u);
	let g = (u32(saturate(In.g) * 255.0) << 8u);
	let b = (u32(saturate(In.b) * 255.0) << 16u);
	let a = (u32(saturate(In.a) * 255.0) << 24u);
	return r | g | b | a;
}

const i256:f32 = 1.0 / 255.0 ;
fn unpackRGBA8( In : u32 ) -> vec4f 
{
	var Out:vec4f ;
	Out.r = f32((In >> 0u) & 0xFF) * i256;
	Out.g = f32((In >> 8u) & 0xFF) * i256;
	Out.b = f32((In >> 16u) & 0xFF) * i256;
	Out.a = f32((In >> 24u) & 0xFF) * i256;
	return Out;
}
`
    );

    let GenerayRandomDir = (
      /*wgsl*/
      `
    fn madfrac(A:f32, B:f32)-> f32 {
        return A*B-floor(A*B) ;
    }

    fn sampleRandomDir(count:u32,SAMPLE_COUNT:u32) -> vec3<f32>{
    var ray_dir = sphericalFibonacci(f32((count)), f32(SAMPLE_COUNT) );
    return normalize(ray_dir) ;
    }

    fn sphericalFibonacci( i : f32 ,  n : f32 ) -> vec3<f32>{
        const PHI = sqrt(5.0) * 0.5 + 0.5;
        let phi = 2.0 * PI * madfrac(i, PHI - 1);
        let cosTheta = 1.0 - (2.0 * i + 1.0) * (1.0 / n);
        let sinTheta = sqrt(saturate(1.0 - cosTheta*cosTheta));

        return vec3<f32>(
            cos(phi) * sinTheta,
            sin(phi) * sinTheta,
            cosTheta);

    }
`
    );

    let MatrixShader = (
      /* wgsl */
      `
    #include "MathShader"

    fn buildMatrix3x3() -> mat3x3<f32>{
        var mat3 = mat3x3<f32>(
            1.0,0.0,0.0,
            0.0,1.0,0.0,
            0.0,0.0,1.0,
        );
        return mat3 ;
    }

    fn buildMatrix4x4() -> mat4x4<f32>{
        var mat4 = mat4x4<f32>(
            1.0,0.0,0.0,0.0,
            0.0,1.0,0.0,0.0,
            0.0,0.0,1.0,0.0,
            0.0,0.0,0.0,1.0,
        );
        return mat4 ;
    }

    fn buildRotateXMat3(rad:f32) -> mat3x3<f32>{
        var xrot = mat3x3<f32>(
            1.0,0.0,0.0,
            0.0,cos(rad),-sin(rad),
            0.0,sin(rad),cos(rad)
        );
        return xrot;
    }

    fn buildRotateXMat4(rad:f32,x:f32,y:f32,z:f32) -> mat4x4<f32>{
        var xrot = mat4x4<f32>(
            1.0,0.0,0.0,0.0,
            0.0,cos(rad),-sin(rad),0.0,
            0.0,sin(rad),cos(rad),0.0,
            x,y,z,1.0,
        );
        return xrot;
    }

    fn buildYRotateXMat4(radY:f32,x:f32,y:f32,z:f32) -> mat4x4<f32>{
        var yRot = mat4x4<f32>(
            cos(radY),0.0,sin(radY),0.0,
            0.0,1.0,0.0,0.0,
            -sin(radY),0.0,cos(radY),0.0,
            x,y,z,1.0,
        );
        return yRot;
    }

    fn buildRotateXYZMat4(radX:f32,radY:f32,radZ:f32,x:f32,y:f32,z:f32) -> mat4x4<f32>{
        var xRot = mat4x4<f32>(
            1.0,0.0,0.0,0.0,
            0.0,cos(radX),-sin(radX),0.0,
            0.0,sin(radX),cos(radX),0.0,
            0.0,0.0,0.0,1.0,
        );
        var yRot = mat4x4<f32>(
            cos(radY),0.0,sin(radY),0.0,
            0.0,1.0,0.0,0.0,
            -sin(radY),0.0,cos(radY),0.0,
            0.0,0.0,0.0,1.0,
        );
        var zRot = mat4x4<f32>(
            cos(radZ),-sin(radZ),0.0,0.0,
            sin(radZ), cos(radZ),0.0,0.0,
            0.0,0.0,1.0,0.0,
            0.0,0.0,0.0,1.0,
        );
        var fMat = xRot * yRot * zRot ;
        fMat[3].x = x;
        fMat[3].y = y;
        fMat[3].z = z;
        return fMat;
    }

    fn buildRotateYMat3(rad:f32) -> mat3x3<f32>{
        var yrot = mat3x3<f32>(
            cos(rad),0.0,sin(rad),
            0.0,1.0,0.0,
            -sin(rad),0.0,cos(rad)
        );
        return yrot ;
    }

    fn buildRotateZ(rad:f32) -> mat3x3<f32>{
        var zrot = mat3x3<f32>(
            cos(rad),-sin(rad),0.0,
            sin(rad), cos(rad),0.0,
            0.0,0.0,1.0
        );
        return zrot;
    }

    // fn buildRotateXMat4(rad:f32) -> mat4x4<f32>{
    //     var xrot = mat4x4<f32>(
    //         1.0,0.0,0.0,0.0,
    //         0.0,cos(rad),-sin(rad),0.0,
    //         0.0,sin(rad),cos(rad),0.0,
    //         0.0,0.0,0.0,1.0);
    //     return xrot;
    // }

    fn bulidTranslateMat4(x:f32,y:f32,z:f32) -> mat4x4<f32>{
        var trans = mat4x4<f32>(
            1.0,0.0,0.0,0.0,
            0.0,1.0,0.0,0.0,
            0.0,0.0,1.0,0.0,
            x,y,z,1.0);
        return trans;
    }

`
    );

    let ClusterLight = (
      /*wgsl*/
      `
    #include "LightData"

    const PointLightType = 1;
    const DirectLightType = 2;
    const SpotLightType = 3;

    struct ClusterBox {
        minPoint:vec4<f32>,
        maxPoint:vec4<f32>
    };

    struct LightIndex {
            count:f32,
            start:f32,
            empty0:f32,
            empty1:f32,
    };

    struct ClustersUniform {
        clusterTileX:f32,
        clusterTileY:f32,
        clusterTileZ:f32,
        numLights:f32,
        maxNumLightsPerCluster:f32,
        near:f32,
        far:f32,
        screenWidth:f32,
        screenHeight:f32,
        clusterPix:f32, 
    };

    @group(2) @binding(1)
    var<storage,read> lightBuffer: array<LightData>;
    @group(2) @binding(2)
    var<uniform> clustersUniform : ClustersUniform;
    @group(2) @binding(3)
    var<storage,read> lightAssignBuffer : array<f32>;
    @group(2) @binding(4)
    var<storage,read> assignTable : array<LightIndex>;
    #if DEBUG_CLUSTER
        @group(2) @binding(5)
        var<storage,read> clusterBuffer : array<ClusterBox>;
    #endif

    fn getLight( index:i32 ) -> LightData {
        let lightId = i32(lightAssignBuffer[index]);
        var lightData = lightBuffer[lightId];
        return lightData ;
    }

    fn linearTo01Depth(depth : f32) -> f32 {
        return (globalUniform.far ) * globalUniform.near / fma(depth, globalUniform.near-globalUniform.far, globalUniform.far);
    }

    fn getClusterId3() -> vec3<u32> {
        let z = linearTo01Depth(ORI_VertexVarying.fragCoord.z) ; 

        let sliceScale = f32(clustersUniform.clusterTileZ) / log2(globalUniform.far / globalUniform.near);
        let sliceBias = -(f32(clustersUniform.clusterTileZ) * log2(globalUniform.near) / log2(globalUniform.far / globalUniform.near));
        let zTile = u32(max(log2(z) * sliceScale + sliceBias, 0.0));

        var screenUV = ORI_VertexVarying.fragCoord.xy / vec2<f32>( globalUniform.windowWidth , globalUniform.windowHeight );
        let i = u32(floor(screenUV.x * clustersUniform.clusterTileX)) ;
        let j = u32(floor(screenUV.y * clustersUniform.clusterTileY) );

        return vec3<u32>(i,j,zTile);
    }

    fn getCluster() -> LightIndex {
        let tile = getClusterId3();
        let id = tile.x +
            tile.y * u32(clustersUniform.clusterTileX) +
            tile.z * u32(clustersUniform.clusterTileX) * u32(clustersUniform.clusterTileY);
        return assignTable[id];
    }

    fn getClusterIndex() -> u32 {
        let tile = getClusterId3();
        let id = tile.x +
            tile.y * u32(clustersUniform.clusterTileX) +
            tile.z * u32(clustersUniform.clusterTileX) * u32(clustersUniform.clusterTileY);
        return id;
    }
`
    );

    let Hair_frag = (
      /*wgsl*/
      `
  #include "BRDF_frag"
  #include "MathShader"
  #include "FastMathShader"
  #include "Common_frag"
  #include "GlobalUniform"

  #include "PhysicMaterialUniform_frag"
  #include "NormalMap_frag"
  #include "LightingFunction_frag"
  #include "Irradiance_frag"
  #include "ColorUtil_frag"
  #include "BxdfDebug_frag"

  struct FHairTransmittanceData{
    bUseBacklit:bool,
    bUseSeparableR:bool,
    bUseLegacyAbsorption:bool
  };
 
  //ORI_ShadingInput
  fn initFragData() {
      fragData.Albedo = ORI_ShadingInput.BaseColor ;
      fragData.Ao = clamp( pow(ORI_ShadingInput.AmbientOcclusion,materialUniform.ao) , 0.0 , 1.0 ) ; 
      fragData.Roughness = ORI_ShadingInput.Roughness ; 
      fragData.Metallic = ORI_ShadingInput.Metallic ; 
      fragData.Emissive = ORI_ShadingInput.EmissiveColor.rgb ; 
      fragData.Specular = vec3f(materialUniform.specularColor.rgb) ; 
      fragData.N = ORI_ShadingInput.Normal;
      let viewDir = normalize(globalUniform.CameraPos.xyz - ORI_VertexVarying.vWorldPos.xyz ) ;
      fragData.V = viewDir ;
      fragData.Ao = materialUniform.ao ;
      #if USE_TANGENT
        fragData.T = ORI_VertexVarying.TANGENT.xyz * ORI_VertexVarying.TANGENT.w ;
      #endif
 
      let R = 2.0 * dot( fragData.V , fragData.N ) * fragData.N - fragData.V ;
      fragData.R = R ;//reflect( fragData.V , fragData.N ) ;

      fragData.NoV = saturate(dot(fragData.N, fragData.V)) ;

      fragData.F0 = mix(vec3<f32>(materialUniform.specularColor.rgb), fragData.Albedo.rgb, fragData.Metallic);
      
      fragData.F = computeFresnelSchlick(fragData.NoV, fragData.F0);
      fragData.KD = vec3<f32>(fragData.F) ;
      fragData.KS = vec3<f32>(0.0) ;

      fragData.Indirect = 0.0 ;
      fragData.Reflectance = 1.0 ;
  }

  

  fn transformHairNormal(normal : vec3<f32>) -> vec3<f32>{
      var face = 1.0 ;
      if(ORI_VertexVarying.face){
          face = 1.0 ;
      }else{
          face = -1.0 ;
      }
      #if USE_TANGENT
        let T = ORI_VertexVarying.TANGENT.xyz;
        let N = ORI_VertexVarying.vWorldNormal ;
        let B = cross(T,N) * ORI_VertexVarying.TANGENT.w * face;
        let mat3 = mat3x3<f32>(T,B,N);
        let n = mat3 * normal;
        return n ;
      #else
        return normal ;
      #endif
  }


  fn Hair_g( B:f32 ,  Theta:f32 ) -> f32
  {
      return exp(-0.5 * pow2(Theta) / (B * B)) / (sqrt(2 * PI) * B);
  }

  fn Hair_F( CosTheta:f32 )-> f32
  {
      let n = 1.55;
      let F0 = pow2((1.0 - n) / (1.0 + n));
      return F0 + (1.0 - F0) * pow5(1.0 - CosTheta);
  }

  fn HairColorToAbsorption( C:vec3f ,  B:f32 ) -> vec3f
  {
      let b2 = B * B;
      let b3 = B * b2;
      let b4 = b2 * b2;
      let b5 = B * b4;
      let D = (5.969 - 0.215 * B + 2.532 * b2 - 10.73 * b3 + 5.574 * b4 + 0.245 * b5);
      return pow2v3(log(C) / D);
  }

  fn Luminance(  LinearColor : vec3f ) -> f32
  {
    return dot( LinearColor, vec3f( 0.3, 0.59, 0.11 ) );
  }

  fn KajiyaKayDiffuseAttenuation( L:vec3f,  V:vec3f,  N:vec3f,  Shadow:f32 ) -> vec3f
  {
    // Use soft Kajiya Kay diffuse attenuation
    var KajiyaDiffuse = 1.0 - abs(dot(N, L));

    var FakeNormal = normalize(V - N * dot(V, N));
    //N = normalize( DiffuseN + FakeNormal * 2 );
    let nN = FakeNormal;

    let BaseColor = fragData.Albedo.rgb / PI ;
    // Hack approximation for multiple scattering.
    var Wrap = 1.0;
    var NoL = saturate((dot(nN, L) + Wrap) / squareF(1.0 + Wrap));
    var DiffuseScatter = (1.0 / PI) * mix(NoL, KajiyaDiffuse, 0.33) * fragData.Metallic;
    var Luma = Luminance(BaseColor);
    var ScatterTint = pow(BaseColor / Luma, vec3f(1.0 - Shadow));
    return sqrt(BaseColor) * DiffuseScatter * ScatterTint;
  }

  fn HairNormal( ID : f32 ) -> vec4f {
      let tangentA = vec4f(0.0,0.0,0.3,1.0);
      let tangentB = vec4f(0.0,0.0,-0.3,1.0);

      let iTangent = mix(tangentA,tangentB,vec4f(ID));
      var tangent = vec4f(0.0);
      #if USE_FLOWER

      #else 
        let tt = vec4f(0.0,-1.0,0.0,1.0);
        tangent = tt + iTangent;
      #endif

      return normalize(tangent) ;
  }

  fn hairShading( light:LightData , sV:vec3f, N:vec3f, Shadow:f32 , HairTransmittance : FHairTransmittanceData ,  InBacklit:f32 ,  Area:f32 ,  Random:vec2f ) -> vec3f{
      var ClampedRoughness = clamp(fragData.Roughness, 1/255.0, 1.0);
      let Backlit	= min(InBacklit, materialUniform.backlit);
      let HairColor = fragData.Albedo.rgb ;
      let lightCC = pow( light.lightColor.rgb,vec3<f32>(2.2));
      var lightColor = getHDRColor( lightCC.rgb , light.linear )  ;
      var lightAtt = light.intensity  ;

      let V = normalize(sV) ;
      let L = normalize(-light.direction) ;
      let H = normalize(N+L) ;
      var S : vec3f= vec3f(0.0) ;

      var KajiyaKayDiffuseFactor = 1.0;

      let VoL       = dot(V,L);                                                      
      let SinThetaL = clamp(dot(N,L), -1.0, 1.0);
      let SinThetaV = clamp(dot(N,V), -1.0, 1.0);

      var CosThetaD = cos( 0.5 * abs( asinFast( SinThetaV ) - asinFast( SinThetaL ) ) );
      // var CosThetaD = cos( 0.5 * abs( asin( SinThetaV ) - asin( SinThetaL ) ) );
      
      var Lp = L - SinThetaL * N;
      var Vp = V - SinThetaV * N;
      var CosPhi = dot(Lp,Vp) * rsqrt( dot(Lp,Lp) * dot(Vp,Vp) + 1e-4 );
      var CosHalfPhi = sqrt( saturate( 0.5 + 0.5 * CosPhi ) );

      let n = 1.55;
      let n_prime = 1.19 / CosThetaD + 0.36 * CosThetaD;

      let Shift = 0.035;
      var Alpha:array<f32,3> = array<f32,3>(
        -Shift * 2.0,
        Shift,
        Shift * 4.0,
      );

      var B:array<f32,3> =array<f32,3>(
        Area + pow2(ClampedRoughness),
        (Area + pow2(ClampedRoughness) / 2.0),
        Area + pow2(ClampedRoughness) * 2.0,
      );
     
      //S SR
      let sa = sin(Alpha[0]);
      let ca = cos(Alpha[0]);
      var ShiftA = 2.0 * sa * (ca * CosHalfPhi * sqrt(1.0 - SinThetaV * SinThetaV) + sa * SinThetaV);
      var BScale = 1.0;
      if(HairTransmittance.bUseSeparableR){
          BScale = sqrt(2.0) * CosHalfPhi ;
      }
      var Mp_R = Hair_g(B[0] * BScale, SinThetaL + SinThetaV - ShiftA);
      var Np_R = 0.25 * CosHalfPhi;
      var Fp_R = Hair_F(sqrt(saturate(0.5 + 0.5 * (VoL))));
      S += vec3f(Mp_R* Np_R * Fp_R * (fragData.F0 * 2.0)) * mix(1.0, 0.0, saturate(-VoL));
      KajiyaKayDiffuseFactor -= Fp_R;

      //S ST
      var Mp_ST = Hair_g( B[1], SinThetaL + SinThetaV - Alpha[1] );
      var a_ST = 1.0 / n_prime;
      var h_ST = CosHalfPhi * ( 1.0 + a_ST * ( 0.6 - 0.8 * CosPhi ) );
      var f_ST = Hair_F( CosThetaD * sqrt( saturate( 1.0 - h_ST * h_ST ) ) );
      var Fp_ST = pow2(1.0 - f_ST);
      var Tp_ST : vec3f = vec3f( 0.0 );
      if (HairTransmittance.bUseLegacyAbsorption)
      {
        Tp_ST = pow(HairColor.rgb, vec3f(0.5 * sqrt(1.0 - pow2(h_ST * a_ST)) / CosThetaD));
      }
      else
      {
        let AbsorptionColor = HairColorToAbsorption(HairColor.rgb,0.3);
        Tp_ST = exp(-AbsorptionColor * 2.0 * abs(1.0 - pow2(h_ST * a_ST) / CosThetaD));
      }
     
      var Np_ST = exp( -3.65 * CosPhi - 3.98 );
      
      S += Mp_ST * Np_ST * Fp_ST * Tp_ST * Backlit;
      KajiyaKayDiffuseFactor -= Fp_ST;

      //S TRT
      var Mp_TRT = Hair_g( B[2], SinThetaL + SinThetaV - Alpha[2] );
      
      //float h = 0.75;
      var f_TRT = Hair_F( CosThetaD * 0.5 );
      var Fp_TRT = pow2(1.0 - f_TRT) * f_TRT;
      var Tp_TRT = pow( HairColor.rgb , vec3f(0.8 / CosThetaD) );
      var Np_TRT = exp( 17.0 * CosPhi - 16.78 );
      
      S += Mp_TRT * Np_TRT * Fp_TRT * Tp_TRT;
      KajiyaKayDiffuseFactor -= Fp_TRT;
      // S = vec3f((KajiyaKayDiffuseFactor));
     
      S += KajiyaKayDiffuseAttenuation(L,V,N,Shadow) ;//* saturate(KajiyaKayDiffuseFactor);
      // S = vec3f((KajiyaKayDiffuseFactor));
      S = -min(-S, vec3f(0.0));
      return 2.0 * PI *vec3f(S) * (lightAtt ) ;
  }

  fn BSSSRDFShading(){
    initFragData();

    var irradiance = vec3<f32>(0.0) ;
    #if USEGI
        irradiance += getIrradiance().rgb ;
    #else
        let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
        irradiance += (globalUniform.skyExposure * textureSampleLevel(prefilterMap, prefilterMapSampler, fragData.N.xyz, 0.8 * (MAX_REFLECTION_LOD) ).rgb);
    #endif
    irradiance = ORI_ShadingInput.SSS + (irradiance.rgb);
    fragData.Irradiance = irradiance.rgb ;

    //***********lighting-PBR part********* 
    var specColor = vec3<f32>(0.0) ;
    let lightIndex = getCluster();
    let start = max(lightIndex.start, 0.0);
    let count = max(lightIndex.count, 0.0);
    let end = max(start + count , 0.0);
    for(var i:i32 = i32(start) ; i < i32(end); i += 1 )
    {
        let light = getLight(i32(i));
        switch (light.lightType) {
          case PointLightType: {
            // specColor += pointLighting( fragData.Albedo.rgb,ORI_VertexVarying.vWorldPos.xyz,fragData.N,fragData.V,fragData.Roughness,fragData.Metallic,light) ;
          }
          case DirectLightType: {
              // specColor += directHairLighting( fragData.Albedo.rgb ,fragData.N,fragData.V,fragData.Roughness ,fragData.Metallic, light , globalUniform.shadowBias) ;
              var fHairTransmittanceData : FHairTransmittanceData ;
              fHairTransmittanceData.bUseBacklit = true ;
              fHairTransmittanceData.bUseSeparableR = true ;
              fHairTransmittanceData.bUseLegacyAbsorption = false ;

              //use shadow visible backlit
              specColor = hairShading(light,fragData.V, ORI_ShadingInput.HairNormal , 1.0 ,fHairTransmittanceData,1.0,materialUniform.area,vec2f(0.0));
          }
          case SpotLightType: {
            // specColor += spotLighting( fragData.Albedo.rgb,ORI_VertexVarying.vWorldPos.xyz,fragData.N,fragData.V,fragData.Roughness,fragData.Metallic , light ) ;
          }
          default: {
          }
        }
    }


    let sunLight = lightBuffer[0] ;
    //***********lighting-PBR part********* 
    var F = FresnelSchlickRoughness(fragData.NoV, fragData.F0.rgb , fragData.Roughness);
    var kS = F;
    // var kD = vec3(1.0) - kS;
    // kD = kD * (1.0 - fragData.Metallic);
    let envIBL =  materialUniform.envIntensity * IBLEnv(fragData.V ,fragData.N ,fragData.Roughness ) ;
    fragData.EnvColor = envIBL ;
    // fragData.Specular = envIBL ;
    //***********indirect-specular part********* 
    
    var iblSpecularResult = fragData.Metallic * fragData.EnvColor * materialUniform.specularColor.rgb ;
    //***********indirect-specular part********* 
    
    //***********indirect-ambient part********* 
    var kdLast = (1.0 - fragData.F0.r) * (1.0 - fragData.Metallic);    
    var iblDiffuseResult = irradiance * kdLast * fragData.Albedo.rgb * (vec3(1.0) - kS) ;
    //irradiance
    //***********indirect-ambient part********* 
    var indirectResult = (iblSpecularResult + iblDiffuseResult * max(sunLight.quadratic,0.05) ) * fragData.Ao ;
    fragData.LightChannel = specColor ;

    // Using stripped down, 'pure log', formula. Parameterized by grey points and dynamic range covered.
    #if USEGBUFFER
        var normal_rgba8unorm = (ORI_VertexVarying.vWorldNormal + 1.0) * 0.5;
        normal_rgba8unorm = clamp(normal_rgba8unorm, vec3<f32>(0.0), vec3<f32>(1.0));
        ORI_FragmentOutput.worldNormal = vec4<f32>(normal_rgba8unorm,1.0);
        ORI_FragmentOutput.material = vec4<f32>(1.0,fragData.Roughness,fragData.Metallic,1.0);
    #endif
    
    #if USE_WORLDPOS
        ORI_FragmentOutput.worldPos = vec4<f32>(ORI_VertexVarying.vWorldPos.xyzw);
    #endif
  
    // Linear HDR out; swapchain does the linear-to-sRGB encode.
    // Engine convention: COLOR pass writes premultiplied (rgb*alpha, alpha).
    // OIT_DEPTH_PEEL is the only exception (Common_frag premultiplies later).
    let finalColor = vec3f(specColor + indirectResult);
    ORI_FragmentOutput.color = vec4<f32>(finalColor * fragData.Albedo.a, fragData.Albedo.a) ;
}

  `
    );

    let BsDF_frag = (
      /*wgsl*/
      `
  #include "Clearcoat_frag"
  #include "BRDF_frag"
  #include "MathShader"
  #include "FastMathShader"
  #include "Common_frag"
  #include "GlobalUniform"

  #include "PhysicMaterialUniform_frag"
  #include "NormalMap_frag"
  #include "LightingFunction_frag"
  #include "Irradiance_frag"
  #include "ColorUtil_frag"
  #include "BxdfDebug_frag"


 
  //ORI_ShadingInput
  fn initFragData() {
      fragData.Albedo = ORI_ShadingInput.BaseColor ;
      fragData.Ao = clamp( pow(ORI_ShadingInput.AmbientOcclusion,materialUniform.ao) , 0.0 , 1.0 ) ; 
      fragData.Roughness = clamp((ORI_ShadingInput.Roughness),0.003,1.0) ; 
      fragData.Metallic = ORI_ShadingInput.Metallic ; 
      fragData.Emissive = ORI_ShadingInput.EmissiveColor.rgb ; 
      fragData.N = ORI_ShadingInput.Normal;
      let viewDir = normalize(globalUniform.CameraPos.xyz - ORI_VertexVarying.vWorldPos.xyz) ;
      fragData.V = viewDir ;
      #if USE_TANGENT
        fragData.T = ORI_VertexVarying.TANGENT.xyz ;
      #endif
 
      let R = 2.0 * dot( fragData.V , fragData.N ) * fragData.N - fragData.V ;
      fragData.R = R ;//reflect( fragData.V , fragData.N ) ;

      fragData.NoV = saturate(dot(fragData.N, fragData.V)) ;

      // F0 follows the KHR_materials_specular convention:
      // for dielectrics, F0 starts at the canonical 0.04 (Schlick approx
      // for ior=1.5 glass) and is *modulated* by specularColor — i.e.
      // specularColor (1,1,1) keeps F0 at 0.04, tinting it shifts the
      // hue of grazing-angle reflection without inflating the overall
      // reflectance. Treating specularColor as F0 directly (the old
      // path) coupled the slider to the entire BRDF balance, so a
      // red picker turned the whole material red instead of just
      // tinting highlights.
      let dielectricF0 = vec3<f32>(0.04) * materialUniform.specularColor.rgb;
      fragData.F0 = mix(dielectricF0, fragData.Albedo.rgb, fragData.Metallic);
      
      fragData.F = computeFresnelSchlick(fragData.NoV, fragData.F0);
      fragData.KD = vec3<f32>(fragData.F) ;
      fragData.KS = vec3<f32>(0.0) ;

      fragData.Indirect = 0.0 ;
      fragData.Reflectance = 1.0 ;

      fragData.ClearcoatRoughness = materialUniform.clearcoatRoughnessFactor ;
      #if USE_CLEARCOAT_ROUGHNESS
        fragData.ClearcoatRoughness = getClearcoatRoughness() * materialUniform.clearcoatRoughnessFactor;
      #endif
  }

  fn BsDFShading(){
      initFragData();

      var irradiance = vec3<f32>(0.0) ;
      #if USEGI
          irradiance += getIrradiance().rgb ;
      #else
          let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
          irradiance += (globalUniform.skyExposure * textureSampleLevel(prefilterMap, prefilterMapSampler, fragData.N.xyz, 0.8 * (MAX_REFLECTION_LOD) ).rgb);
      #endif
      // Irradiance is sampled linear; keep linear (no in-shader gamma)
      // so the SSS sum stays in linear HDR for the linear-to-sRGB
      // encode the swapchain handles on present.
      irradiance = ORI_ShadingInput.SSS + irradiance.rgb;
      fragData.Irradiance = irradiance.rgb ;

   

      //***********lighting-PBR part********* 
      var specColor = vec3<f32>(0.0) ;
      let lightIndex = getCluster();
      let start = max(lightIndex.start, 0.0);
      let count = max(lightIndex.count, 0.0);
      let end = max(start + count , 0.0);
      for(var i:i32 = i32(start) ; i < i32(end); i += 1 )
      {
          let light = getLight(i32(i));
          switch (light.lightType) {
            case PointLightType: {
              specColor += pointLighting( fragData.Albedo.rgb,ORI_VertexVarying.vWorldPos.xyz,fragData.N,fragData.V,fragData.Roughness,fragData.Metallic,light) ;
            }
            case DirectLightType: {
              specColor += directDulLighting( fragData.Albedo.rgb, fragData.N, fragData.V, fragData.Roughness, fragData.Metallic, light, light.shadowBias);
            }
            case SpotLightType: {
              specColor += spotLighting( fragData.Albedo.rgb,ORI_VertexVarying.vWorldPos.xyz,fragData.N,fragData.V,fragData.Roughness,fragData.Metallic , light ) ;
            }
            default: {
            }
          }
      }


      fragData.LightChannel = specColor ;

      let sunLight = lightBuffer[0] ;
      //***********lighting-PBR part********* 
      var F = FresnelSchlickRoughness(fragData.NoV, fragData.F0, fragData.Roughness);
      var kS = F;
      var kD = vec3(1.0) - kS;
      kD = kD * (1.0 - fragData.Metallic);
      let envIBL =  materialUniform.envIntensity * approximateSpecularIBL( F , fragData.Roughness , fragData.R , fragData.NoV ) ;
      fragData.EnvColor = envIBL ;
      //***********indirect-specular part********* 
      
      var surfaceReduction = 1.0/(fragData.Roughness*fragData.Roughness+1.0);   
      var oneMinusReflectivity = oneMinusReflectivity(fragData.Metallic , materialUniform.materialF0.r );
      var grazingTerm = clamp((1.0 - fragData.Roughness ) + (1.0 - oneMinusReflectivity),0.0,1.0);
      var t = pow5(fragData.NoV);
      var fresnelLerp = FresnelLerp(fragData.NoV,fragData.F0.rgb,vec3<f32>(grazingTerm)) ;   
      var iblSpecularResult = surfaceReduction * fragData.EnvColor * fresnelLerp + envIBL;
      iblSpecularResult *= max(sunLight.quadratic,0.05) ;
      //***********indirect-specular part********* 
      
      //***********indirect-ambient part********* 
      var kdLast = (1.0 - fragData.F0.r) * (1.0 - fragData.Metallic);    
      //  Dim the edges, there should be more specular reflection at the edges
      var iblDiffuseResult = irradiance * 2.0 * kdLast * fragData.Albedo.rgb * (vec3(1.0) - kS) ;
      //irradiance
      //***********indirect-ambient part********* 
      var indirectResult = (iblSpecularResult + iblDiffuseResult) * fragData.Ao * max(sunLight.quadratic,0.05);
      // debugOut = vec4f(iblDiffuseResult,1.0);

      ORI_FragmentOutput.color = vec4<f32>(0.0);

      // Using stripped down, 'pure log', formula. Parameterized by grey points and dynamic range covered.
      #if USEGBUFFER
          var normal_rgba8unorm = (ORI_VertexVarying.vWorldNormal + 1.0) * 0.5;
          normal_rgba8unorm = clamp(normal_rgba8unorm, vec3<f32>(0.0), vec3<f32>(1.0));
          ORI_FragmentOutput.worldNormal = vec4<f32>(normal_rgba8unorm,1.0);
          ORI_FragmentOutput.material = vec4<f32>(1.0,fragData.Roughness,fragData.Metallic,1.0);
      #endif
      
      #if USE_WORLDPOS
          ORI_FragmentOutput.worldPos = vec4<f32>(ORI_VertexVarying.vWorldPos.xyzw);
      #endif
      
      var color = specColor + indirectResult ;
      color += fragData.Emissive.xyz ;

      var clearCoatColor = vec3<f32>(0.0);
      #if USE_CLEARCOAT
        let clearCoatBaseColor = vec3<f32>(1.0) * materialUniform.baseColor.rgb ;
        let clearNormal = fragData.N ;
        let clearcoatRoughness = fragData.ClearcoatRoughness ;
        let att = sunLight.intensity ;
        let clearCoatLayer = ClearCoat_BRDF( color , materialUniform.clearcoatColor.rgb , materialUniform.ior , clearNormal , -sunLight.direction ,-fragData.V , materialUniform.clearcoatWeight , clearcoatRoughness , att );
        color = vec3<f32>(clearCoatLayer.rgb/fragData.Albedo.a) ; 
      #endif
      
      // Linear HDR out; swapchain does the linear-to-sRGB encode.
      let retColor = color.rgb;
      ORI_FragmentOutput.color = vec4<f32>( retColor ,fragData.Albedo.a) ;
  }

  `
    );

    let AlphaHash_frag = (
      /*wgsl*/
      `
  fn alphaHash3D(p: vec3<f32>) -> f32 {
      // 3-component fract-sin hash — cheap and produces a uniform
      // distribution across [0,1] with no banding once TAA averages
      // adjacent samples. The constants are the standard "shadertoy"
      // integers; any pseudo-random hash works as long as it's
      // deterministic per (worldPos, frame).
      return fract(sin(dot(p, vec3<f32>(127.1, 311.7, 74.7))) * 43758.5453);
  }
`
    );

    let UnLit = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "UnLit_frag"
    #include "UnLitMaterialUniform_frag"
    #include "AlphaHash_frag"

    #if USE_CUSTOMUNIFORM
        struct MaterialUniform {
            transformUV1:vec4<f32>,
            transformUV2:vec4<f32>,
            baseColor: vec4<f32>,
            alphaCutoff: f32,
        };
    #endif

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d<f32>;

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        var transformUV1 = materialUniform.transformUV1;
        var transformUV2 = materialUniform.transformUV2;

        var uv = transformUV1.zw * ORI_VertexVarying.fragUV0 + transformUV1.xy;
        var color = textureSample(baseMap,baseMapSampler,uv) ;
        if(color.w < materialUniform.alphaCutoff){
            discard ;
        }
        // Texture color stays in sRGB-encoded numerical form when
        // the user loads a default rgba8unorm BitmapTexture2D —
        // shader-side gammaToLiner brings it into linear HDR before
        // the final ACES TonemapPost + sRGB swapchain encode.
        // Without this, sRGB-encoded values get re-encoded by the
        // swapchain view → washed-out / over-bright look.
        // USE_SRGB_ALBEDO opts out for hardware-decoded
        // (rgba8unorm-srgb) textures.
        #if USE_SRGB_ALBEDO
            ORI_ShadingInput.BaseColor = color * materialUniform.baseColor ;
        #else
            color = vec4f(gammaToLiner(color.rgb), color.a);
            ORI_ShadingInput.BaseColor = color * materialUniform.baseColor ;
        #endif

        #if USE_ALPHAHASH
            // Stochastic alpha test (Wyman 2017): see PBRLitShader for
            // the full rationale. Lives in the opaque pipeline because
            // alphaMode='HASH' sets renderOrder=0 + depthWriteEnabled=true.
            if (ORI_ShadingInput.BaseColor.a < alphaHash3D(ORI_VertexVarying.vWorldPos.xyz)) {
                discard;
            }
        #endif

        UnLit();
    }
`
    );

    let Sprite_shader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "UnLit_frag"

    #if USE_CUSTOMUNIFORM
    #else
        struct MaterialUniform {
            color: vec4<f32>,
            uvRect: vec4<f32>,
            size: vec2<f32>,
            pivot: vec2<f32>,
            distanceInvariant: f32,
            cornerRadius: f32,
            spritePad0: f32,
            spritePad1: f32,
        };
    #endif

    @group(2) @binding(0)
    var<uniform> materialUniform: MaterialUniform;

    @group(1) @binding(auto)
    var baseMapSampler: sampler;
    #if USE_VIDEO_TEXTURE
        @group(1) @binding(auto)
        var baseMap: texture_external;
    #else
        @group(1) @binding(auto)
        var baseMap: texture_2d<f32>;
    #endif

    fn vert(inputData: VertexAttributes) -> VertexOutput {
        // Shared unit-quad has positions in [-0.5, +0.5].
        // Apply pivot (0..1, 0.5 = centered) then scale by size (world units).
        var v = inputData;
        let shift = vec2<f32>(0.5 - materialUniform.pivot.x, 0.5 - materialUniform.pivot.y);
        var scale = materialUniform.size;
        if (materialUniform.distanceInvariant > 0.5) {
            // Keep on-screen size constant as the camera moves by scaling the
            // quad's local extent with camera distance. Reference distance is
            // hard-coded to 10 m — the size value is "meters at 10 m depth".
            // ORI_MATRIX_M is the per-node model matrix, already populated by
            // Inline_vert by the time our vert() is called.
            let worldOrigin = (ORI_MATRIX_M * vec4<f32>(0.0, 0.0, 0.0, 1.0)).xyz;
            let camDist = distance(worldOrigin, globalUniform.CameraPos);
            scale = scale * (camDist / 10.0);
        }
        v.position = vec3<f32>(
            (inputData.position.x + shift.x) * scale.x,
            (inputData.position.y + shift.y) * scale.y,
            inputData.position.z
        );
        ORI_Vert(v);
        return ORI_VertexOut;
    }

    // Rounded-corner SDF in local UV space [0,1]². Result is an alpha mask
    // in [0,1] that's 1.0 well inside, smoothly drops to 0.0 at the rounded
    // edge. Radius is in world units (matches size).
    fn spriteCornerMask(local: vec2<f32>, radius: f32) -> f32 {
        let half = materialUniform.size * 0.5;
        let p = (local - vec2<f32>(0.5)) * materialUniform.size;
        let r = min(radius, min(half.x, half.y));
        let q = abs(p) - half + vec2<f32>(r);
        let d = length(max(q, vec2<f32>(0.0))) + min(max(q.x, q.y), 0.0) - r;
        return 1.0 - smoothstep(-1.0, 1.0, d);
    }

    fn frag() {
        let local = ORI_VertexVarying.fragUV0;
        let uv = materialUniform.uvRect.xy + local * materialUniform.uvRect.zw;

        #if USE_VIDEO_TEXTURE
            let vsize = textureDimensions(baseMap).xy - 1;
            let iuv = vec2<i32>(uv * vec2<f32>(vsize));
            var sampled = textureLoad(baseMap, iuv);
        #else
            var sampled = textureSample(baseMap, baseMapSampler, uv);
        #endif
        // Sprite baseMap samples come back sRGB-encoded — both
        // paths: rgba8unorm PNG bytes are sRGB by convention, and
        // texture_external defaults to colorSpace='srgb' returning
        // gamma-encoded values. Decode to linear before the lighting /
        // composite math so the final sRGB-swapchain encode lands on
        // real linear values. USE_SRGB_ALBEDO opts out for hardware-
        // decoded textures.
        #if !USE_SRGB_ALBEDO
            sampled = vec4f(gammaToLiner(sampled.rgb), sampled.a);
        #endif
        sampled = sampled * materialUniform.color;

        if (materialUniform.cornerRadius > 0.0) {
            sampled.a = sampled.a * spriteCornerMask(local, materialUniform.cornerRadius);
        }

        if (sampled.a <= 0.0) {
            discard;
        }

        ORI_ShadingInput.BaseColor = sampled;
        UnLit();
    }
`
    );

    let Lambert_shader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "ClusterLight"
    #include "UnLit_frag"
    #include "UnLitMaterialUniform_frag"
    #include "EnvMap_frag"
    #include "ReflectionCG"
    #include "AlphaHash_frag"

    @group(1) @binding(auto)
    var baseMapSampler: sampler;
    @group(1) @binding(auto)
    var baseMap: texture_2d<f32>;

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        var transformUV1 = materialUniform.transformUV1;
        var transformUV2 = materialUniform.transformUV2;

        var uv = transformUV1.zw * ORI_VertexVarying.fragUV0 + transformUV1.xy;
        var baseMapColor = textureSample(baseMap,baseMapSampler,uv);
        if(baseMapColor.a < materialUniform.alphaCutoff) {
            discard;
        }

        #if USE_ALPHAHASH
            // Stochastic alpha test (Wyman 2017) — see PBRLitShader for
            // the full rationale. Alpha includes the materialUniform.baseColor.a
            // factor since that's what drives the user-visible slider.
            let _hashAlpha = baseMapColor.a * materialUniform.baseColor.a;
            if (_hashAlpha < alphaHash3D(ORI_VertexVarying.vWorldPos.xyz)) {
                discard;
            }
        #endif
        // sRGB-encoded baseMap → decode to linear before lighting
        // math (mirrors PBRLitShader's #else branch). Skip when
        // USE_SRGB_ALBEDO marks the texture as hardware-decoded.
        #if !USE_SRGB_ALBEDO
            baseMapColor = vec4f(gammaToLiner(baseMapColor.rgb), baseMapColor.a);
        #endif

        var lightColor = vec4<f32>(0.0);
        let lightIndex = getCluster();
        let start = max(lightIndex.start, 0.0);
        let count = max(lightIndex.count, 0.0);
        let end = max(start + count , 0.0);
        for(var i:i32 = i32(start) ; i < i32(end); i += 1 )
        {
          let light = getLight(i32(i));
  
          switch (light.lightType) {
            case PointLightType: {
            }
            case DirectLightType: {
                var normal = ORI_VertexVarying.vWorldNormal;
                let intensity = light.intensity;
                let att = max(dot(normal,-light.direction),0.0) * intensity;
                lightColor += vec4f(light.lightColor * att, 1.0);
            }
            case SpotLightType: {
            }
            default: {
            }
          }
        }

        let irradiance: vec3f = getReflectionsEnv(ORI_VertexVarying.vWorldNormal, ORI_VertexVarying.vWorldPos.xyz, 1.0);
        let albedo = baseMapColor.rgb * materialUniform.baseColor.rgb;
        // Direct: light · NdotL · albedo. Indirect: env irradiance ·
        // albedo (modulating env by surface colour gives the ambient
        // term its hue, matching PBR's diffuse IBL behaviour). Adding
        // raw irradiance — as the prior code did — washed every
        // shadow-side fragment to a uniform env-grey regardless of
        // sphere colour.
        //
        // NOTE: avoid the literal six-letter word v-e-r-s-i-o-n
        // followed by a space inside any shader string. The engine
        // RenderShaderPass.preCompileShader uses a naive substring
        // scan for that token to decide whether to route through the
        // GLSL converter; a comment containing it trips the detector
        // and the GLSL preprocessor then crashes on the include
        // directive.
        let directDiffuse = lightColor.rgb * albedo;
        let indirectDiffuse = irradiance * albedo;
        // Output alpha must combine the texture's alpha AND the
        // material's baseColor.a uniform. The prior code only
        // forwarded baseMapColor.a, so per-material alpha sliders had
        // no effect on Lambert's transparent rendering.
        let outAlpha = baseMapColor.a * materialUniform.baseColor.a;
        ORI_ShadingInput.BaseColor = vec4f(directDiffuse + indirectDiffuse, outAlpha);
        if(ORI_ShadingInput.BaseColor.a > 1.0){
            ORI_ShadingInput.BaseColor.a = 1.0;
        }
        UnLit();

        // let n = globalUniform.near ;
        // let f = globalUniform.far ;
        // let z = ORI_VertexVarying.fragCoord.z ;
        // ORI_FragmentOutput.out_depth = z * (n/(f-n)) ;
    }
`
    );

    let QuadGlsl_vs = (
      /* wgsl */
      `
    #include "WorldMatrixUniform"
    #include "GlobalUniform"

    struct VertexOutput {
        @location(auto) fragUV: vec2<f32>,
        @builtin(position) member: vec4<f32>
    };

    @vertex
    fn main(@builtin(instance_index) index : u32, @location(auto) position: vec3<f32>, @location(auto) TEXCOORD_1: vec2<f32>) -> VertexOutput {
        let id = u32(index);
        let worldMatrix = models.matrix[id];

        let screenPos = vec2(((TEXCOORD_1 * 2.0) - vec2<f32>(1.0))) * 0.5 ; 
        return VertexOutput(TEXCOORD_1, vec4<f32>(screenPos, 0.0, 1.0));
    }
`
    );
    let QuadGlsl_fs = (
      /* wgsl */
      `
#version 450

layout(location = 0) in vec2 fragUV;

layout(location = 0) out vec4 o_Target;

layout(set = 0, binding = 0) uniform ConstUniform {
    mat4 projMat;
    mat4 viewMat;
    mat4 shadowMatrix;
    mat4 cameraWorldMatrix;
    mat4 projMatInv;
    float frame;
    float time;
    float delta;
    float shadowBias;
    float skyExposure;
    float renderPassState;
    float quadScale;

};

layout(set = 2, binding = 0) uniform sampler baseMapSampler;
layout(set = 2, binding = 1) uniform texture2D baseMap;
layout(set = 3, binding = 0) uniform MaterialDataUniform {
    vec4 color;
};

void main() {
        vec2 uv = fragUV.xy;
    uv.y = 1.0 - uv.y;
        vec4 colorTexture = texture(sampler2D(baseMap, baseMapSampler), uv * quadScale) * color;
    o_Target = vec4(colorTexture.rgb, colorTexture.a);

    if (o_Target.r <= 0.5 && o_Target.g <= 0.5 && o_Target.b <= 0.5) {
        discard;
    }
    // float gamma     = 2.2;
    // float exposure  = 1.0;
    // float pureWhite = 1.0;

    // float luminance = dot(colorTexture.rgb, vec3(0.2126, 0.7152, 0.0722));
    // float mappedLuminance = (luminance * (1.0 + luminance/(pureWhite*pureWhite))) / (1.0 + luminance);

    // // Scale color by ratio of average luminances.
    // vec3 mappedColor = (mappedLuminance / luminance) * colorTexture.rgb;

    // // Gamma correction.
    // o_Target = vec4(pow(o_Target.rgb, vec3(1.0/gamma)), 1.0);
};
`
    );

    let SkyGBuffer_pass = (
      /*wgsl*/
      `
#include "GlobalUniform"
#include "ColorUtil_frag"

struct uniformData {
    eyesPos: vec3<f32>,
    exposure: f32,
    roughness: f32,
};

struct FragmentOutput {
    @location(auto) o_Position: vec4<f32>,
    @location(auto) o_Normal: vec4<f32>,
    @location(auto) o_Color: vec4<f32>
};

@group(1) @binding(4)
var baseMapSampler: sampler;
@group(1) @binding(5)
var baseMap: texture_cube<f32>;

@group(2) @binding(0)
var<uniform> global: uniformData;

@fragment
fn main(@location(auto) fragUV: vec2<f32>,@location(auto) vClipPos: vec4<f32>, @location(auto) vWorldPos: vec4<f32>, @location(auto) vWorldNormal: vec3<f32> , @builtin(position) fragCoord : vec4<f32> ) -> FragmentOutput {
    let maxLevel: u32 = textureNumLevels(baseMap);
    let textureColor:vec3<f32> = textureSampleLevel(baseMap, baseMapSampler, normalize(vWorldPos.xyz), global.roughness * f32(maxLevel) ).xyz;
    // Linear HDR sky out; swapchain handles the linear-to-sRGB encode.
    let o_Color = 0.618 * vec4<f32>(textureColor * globalUniform.skyExposure , 1.0);
    let o_Normal = vec4(vWorldNormal,1.0) ;
    let o_Position = vec4<f32>(vWorldPos.xyz,100000.0) ;
    return FragmentOutput(o_Position,o_Normal,o_Color);
}
`
    );

    let GBuffer_pass = (
      /*wgsl*/
      `
#include "Common_vert"
#include "FragmentVarying"
#include "GlobalUniform"

struct FragmentOutput {
    @location(auto) o_Position: vec4<f32>,
    @location(auto) o_Normal: vec4<f32>,
    @location(auto) o_Color: vec4<f32>
};

struct MaterialUniform {
    baseColor: vec4<f32>,
    emissiveColor: vec4<f32>,
    emissiveIntensity: f32,
    normalScale: f32,
    alphaCutoff: f32
};

@group(2) @binding(0)
var<uniform> materialUniform: MaterialUniform;

@group(1) @binding(auto)
var baseMapSampler: sampler;
@group(1) @binding(auto)
var baseMap: texture_2d<f32>;

@group(1) @binding(auto)
var normalMapSampler: sampler;
@group(1) @binding(auto)
var normalMap: texture_2d<f32>;

@group(1) @binding(auto)
var emissiveMapSampler: sampler;
@group(1) @binding(auto)
var emissiveMap: texture_2d<f32>;

fn vert(inputData:VertexAttributes) -> VertexOutput {
    ORI_Vert(inputData) ;
    return ORI_VertexOut ;
}

var<private> ORI_FragmentOutput: FragmentOutput;
var<private> ORI_VertexVarying: FragmentVarying;

@fragment
fn FragMain(vertex_varying:FragmentVarying) -> FragmentOutput {
    ORI_VertexVarying = vertex_varying;
    var texColor = textureSample(baseMap, baseMapSampler, ORI_VertexVarying.fragUV0.xy );

    var emissive = textureSample(emissiveMap, emissiveMapSampler, ORI_VertexVarying.fragUV0.xy ).rgb ;
    let intensity = materialUniform.emissiveIntensity * materialUniform.emissiveColor.a ;
    emissive = emissive.rgb * materialUniform.emissiveColor.rgb ;
    emissive = convertToHDRRGB(emissive,intensity);

    if (materialUniform.alphaCutoff-texColor.w > 0.0) {
        discard ;
    }

    var o_Position = vec4<f32>(ORI_VertexVarying.vWorldPos.xyz,emissive.r) ;
    var o_Normal = vec4<f32>((ORI_VertexVarying.vWorldNormal.xyz * 0.5 + 0.5 ),emissive.g) ;
    var o_Color = vec4<f32>((texColor * materialUniform.baseColor).rgb , emissive.b )  ;
    return FragmentOutput(o_Position,o_Normal,vec4<f32>(o_Color));
}

fn convertToHDRRGB( color : vec3<f32> , ins:f32 ) -> vec3<f32> {
    var hdrColor = vec3<f32>(0.0,0.0,0.0);
    hdrColor.r = color.r * pow(2.4, ins);
    hdrColor.g = color.g * pow(2.4, ins);
    hdrColor.b = color.b * pow(2.4, ins);
    return hdrColor;
}
`
    );

    let shadowCastMap_vert = (
      /*wgsl*/
      `
#include "WorldMatrixUniform"
#include "GlobalUniform"
#include "VertexAttributes"

struct VertexOutput {
    @location(auto) fragUV: vec2<f32>,
    @builtin(position) member: vec4<f32>
};

#if USE_MORPHTARGETS
    ${MorphTarget_shader.getMorphTargetShaderBinding(2, 1)}
#endif

#if USE_SKELETON
    ${SkeletonAnimation_shader.groupBindingAndFunctions(2, 1)}
#endif

var<private> worldMatrix: mat4x4<f32>;

@vertex
fn main(vertex:VertexAttributes) -> VertexOutput {
    worldMatrix = models.matrix[vertex.index];
    let shadowMatrix: mat4x4<f32> = globalUniform.projMat * globalUniform.viewMat;
    var vertexPosition = vertex.position.xyz;
    var vertexNormal = vertex.normal.xyz;

    if (globalUniform.useRTE != 0) {
        UpdateWorldMatrixToRTE_PrivatePtr(u32(vertex.index), &worldMatrix);
    }

    #if USE_MORPHTARGETS
     ${MorphTarget_shader.getMorphTargetCalcVertex()}    
    #endif

    #if USE_SKELETON
        // glTF 2.0 skinning: the skinning matrix already produces
        // world-space positions (sum of weight * jointWorld * invBind),
        // so we OVERWRITE worldMatrix instead of multiplying. Multiplying
        // would fold in the mesh node's worldMatrix a second time —
        // visible on Sample_Skeleton (man.scaleX = 30) as a 30×-larger
        // shadow that doesn't match the actual mesh. Matches the color
        // pass: VertexFunction_vert sets ORI_MATRIX_M = skeletonNormal.
        #if USE_JOINT_VEC8
          worldMatrix = getSkeletonWorldMatrix_8(vertex.joints0, vertex.weights0, vertex.joints1, vertex.weights1);
        #else
          worldMatrix = getSkeletonWorldMatrix_4(vertex.joints0, vertex.weights0);
        #endif
    #endif

    var worldPos = worldMatrix * vec4<f32>(vertexPosition, 1.0) ;
    var vPos = shadowMatrix * worldPos;

    return VertexOutput(vertex.uv, vPos );
}
`
    );
    let castPointShadowMap_vert = (
      /*wgsl*/
      `
#include "WorldMatrixUniform"
#include "GlobalUniform"
#include "VertexAttributes"

struct VertexOutput {
    @location(auto) fragUV: vec2<f32>,
    @location(auto) worldPos: vec3<f32>,
    @builtin(position) member: vec4<f32>
};

#if USE_MORPHTARGETS
    ${MorphTarget_shader.getMorphTargetShaderBinding(2, 1)}
#endif

#if USE_SKELETON
    ${SkeletonAnimation_shader.groupBindingAndFunctions(2, 1)}
#endif

var<private> worldMatrix: mat4x4<f32>;

@vertex
fn main(vertex:VertexAttributes) -> VertexOutput {
    worldMatrix = models.matrix[vertex.index];
    let shadowMatrix: mat4x4<f32> = globalUniform.projMat * globalUniform.viewMat;
    var vertexPosition = vertex.position.xyz;

    if (globalUniform.useRTE != 0) {
        UpdateWorldMatrixToRTE_PrivatePtr(u32(vertex.index), &worldMatrix);
    }

    // Skinning OVERWRITES worldMatrix (glTF 2.0 skinning matrix already
    // produces world-space positions). Same fix as shadowCastMap_vert
    // and matches VertexFunction_vert for the color pass.
    #if USE_METAHUMAN
        ${MorphTarget_shader.getMorphTargetCalcVertex()}
        #if USE_JOINT_VEC8
            worldMatrix = getSkeletonWorldMatrix_8(vertex.joints0, vertex.weights0, vertex.joints1, vertex.weights1);
        #else
            worldMatrix = getSkeletonWorldMatrix_4(vertex.joints0, vertex.weights0);
        #endif
    #endif

    #if USE_MORPHTARGETS
        ${MorphTarget_shader.getMorphTargetCalcVertex()}
    #endif

    #if USE_SKELETON
        #if USE_JOINT_VEC8
          worldMatrix = getSkeletonWorldMatrix_8(vertex.joints0, vertex.weights0, vertex.joints1, vertex.weights1);
        #else
          worldMatrix = getSkeletonWorldMatrix_4(vertex.joints0, vertex.weights0);
        #endif
    #endif

    var worldPos = worldMatrix * vec4<f32>(vertexPosition, 1.0) ;
    var vPos = shadowMatrix * worldPos;
    return VertexOutput(vertex.uv, worldPos.xyz , vPos );
}
`
    );
    let shadowCastMap_frag = (
      /*wgsl*/
      `
    #include "GlobalUniform"

    #if USE_ALPHACUT
      @group(1) @binding(0)
      var baseMapSampler: sampler;
      @group(1) @binding(1)
      var baseMap: texture_2d<f32>;
    #endif

    struct FragmentOutput {
      @location(auto) o_Target: vec4<f32>,
      @builtin(frag_depth) out_depth: f32
    };

    @fragment
    fn main(@location(auto) fragUV: vec2<f32> , @location(auto) worldPos:vec3<f32> ) -> FragmentOutput {
        let lightWorldPos = globalUniform.CameraPos;
        var distance = length(worldPos.xyz - lightWorldPos) ;
        distance = distance / globalUniform.far;
        var fragOut:FragmentOutput; 

      #if USE_ALPHACUT
        let Albedo = textureSample(baseMap,baseMapSampler,fragUV);
        if(Albedo.w > 0.5){
          fragOut = FragmentOutput(vec4<f32>(0.0),distance);
        }
      #else
        fragOut = FragmentOutput(vec4<f32>(0.0),distance);
      #endif
      
        return fragOut ;
    }
`
    );
    let directionShadowCastMap_frag = (
      /*wgsl*/
      `
    #if USE_ALPHACUT
      @group(1) @binding(0)
      var baseMapSampler: sampler;
      @group(1) @binding(1)
      var baseMap: texture_2d<f32>;
    #endif

    // Directional shadow is a DEPTH-ONLY pass: ShadowMapPassRenderer builds
    // RTFrame([], []) with no color attachments. This fragment shader must
    // therefore declare NO outputs (no @location and no @builtin(frag_depth))
    // and only take varyings that the vertex shader actually produces — the
    // VertexOutput struct only exports fragUV at location 0 plus position.
    // Even an "unused" extra input like @location(1) would create a binding
    // that Dawn's D3D12 backend can silently drop rasterized fragments for,
    // which is the symptom we saw (Mac works, Windows no shadows).
    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) {
    }
`
    );

    let ZPassShader_vs = (
      /*wgsl*/
      `
    #include "GlobalUniform"
    #include "MathShader"
    #include "VertexAttributes"

    struct VertexOutput {
        @location(auto) vID: f32 ,
        @location(auto) vPos: vec3<f32> ,
        @location(auto) vClipPos: vec4<f32> ,
        @builtin(position) member: vec4<f32>
    };

    struct Uniforms {
        matrix : array<mat4x4<f32>>
    };

    @group(0) @binding(1)
    var<storage, read> models : Uniforms;

    var<private> worldMatrix: mat4x4<f32>;

    #if USE_MORPHTARGETS
        ${MorphTarget_shader.getMorphTargetShaderBinding(1, 0)}
    #endif

    #if USE_SKELETON
        ${SkeletonAnimation_shader.groupBindingAndFunctions(1, 0)}
    #endif

    @vertex
    fn main(vertex: VertexAttributes) -> VertexOutput {
        worldMatrix = models.matrix[vertex.index];

        var vertexPosition = vertex.position;
        var vertexNormal = vertex.normal;

        #if USE_MORPHTARGETS
            ${MorphTarget_shader.getMorphTargetCalcVertex()}
        #endif

        #if USE_SKELETON
            #if USE_JOINT_VEC8
                worldMatrix *= getSkeletonWorldMatrix_8(vertex.joints0, vertex.weights0, vertex.joints1, vertex.weights1);
            #else
                worldMatrix *= getSkeletonWorldMatrix_4(vertex.joints0, vertex.weights0);
            #endif
        #endif

        let wPos = worldMatrix * vec4<f32>(vertexPosition.xyz, 1.0);
        var fixProjMat = globalUniform.projMat ;
        var rzMatrix : mat4x4<f32> ;
        rzMatrix[0] = vec4<f32>(1.0,0.0,0.0,0.0) ;
        rzMatrix[1] = vec4<f32>(0.0,1.0,0.0,0.0) ;
        rzMatrix[2] = vec4<f32>(0.0,0.0,1.0,0.0) ;
        rzMatrix[3] = vec4<f32>(0.0,0.0,0.0,1.0) ;
        var clipPos:vec4<f32> = fixProjMat * globalUniform.viewMat * (wPos) ;

        // Intentionally NOT applying log-z here even under USE_LOGDEPTH.
        // The prepass needs to produce a depth value the color pass will
        // less_equal-test against; the color FS writes log-encoded depth
        // via log2DepthFixPersp (ndc.z = log2(1+w)/log2(far+1)), which is
        // always strictly less than the standard linear ndc.z = (a*w+b)/w
        // for w >= near, so leaving the prepass linear guarantees
        // less_equal passes on every covered pixel.
        //
        // The seemingly natural fix — encode log-z here too — looks right
        // at the vertex but fails at interior pixels: the rasterizer
        // interpolates clip.z linearly in screen-space and the log curve
        // is concave, so interpolated_L < exact_L between vertices. Under
        // less_equal the color pass's per-pixel exact L incoming value is
        // larger than the stored interpolated L → every interior fragment
        // gets rejected and the scene goes blank. CDP-verified against
        // Sample_DecalShadowVolume. The fix-for-the-fix would be running
        // an FS in the prepass that recomputes per-pixel L the same way
        // the color FS does, which means wiring up a real fragment stage
        // to DepthMaterialPass — out of scope here.
        return VertexOutput(f32(vertex.index) , wPos.xyz, clipPos, clipPos);
    }

    fn depthToLinear01(depth:f32) -> f32 {
        let a = 1.0 / (globalUniform.near - globalUniform.far);
        return (globalUniform.near*globalUniform.far*a) / (depth + globalUniform.far * a) ;
    }
`
    );

    let BitUtil = (
      /* wgsl */
      `

    const inv256:f32 = 1.0/256.0;
    const inv1024:f32 = 1.0/1024.0;

    const bit7_inv128:f32 = 1.0 / 128.0;
    const bit7_128:f32 = 128.0;
    
    const r10g10b10 = vec2i(0x3FFFFF,0xFF);
    fn floatToVec3f( v:f32 ) -> vec3f {
        var VPInt:i32 = bitcast<i32>(v);
        var VPInt1024:i32 = VPInt%1024;
        var VPInt10241024:i32 = ((VPInt-VPInt1024)/1024)%1024;
        return vec3f(f32(VPInt1024),f32(VPInt10241024),f32(((VPInt-VPInt1024-VPInt10241024)/1048576)))*vec3f(inv1024);
    }

    fn vec3fToFloat( v:vec3f) -> f32{
        let intv = min(vec3<i32>(floor(v*1024.)),vec3<i32>(1023));
        return bitcast<f32>(i32(intv.x+intv.y*1024+intv.z*1048576));
    }

    fn vec4fToFloat_7bits( v:vec4f) -> f32{
        //0~256
        let intv = min(vec4<i32>(floor(v*bit7_128)),vec4<i32>(127));
        return bitcast<f32>(i32(intv.x+intv.y*128+intv.z*16384+intv.w*2097152));
    }

    fn floatToVec4f_7bits( v:f32 ) -> vec4f {
        var VPInt:i32 = bitcast<i32>(v);
        var VPInt128:i32 = VPInt%128;
        var VPInt128128:i32 = ((VPInt-VPInt128)/128)%128;
        var VPInt128128128:i32 = ((VPInt-VPInt128-VPInt128128)/16384)%128;
        var VPInt128128128128:i32 = ((VPInt-VPInt128-VPInt128128-VPInt128128128)/2097152)%128;
        return vec4f(f32(VPInt128),f32(VPInt128128),f32(VPInt128128128),f32(VPInt128128128128))*vec4f(bit7_inv128);
    }






    const i_r11g11b11 = vec3i(0x7FF,0x7FF,0x7FF);
    const f_r11g11b11 = vec3f(f32(0x7FF),f32(0x7FF),f32(0x7FF));
    fn r11g11b11_to_float( v:vec3f) -> f32{
        let iR: i32 = i32(v.r * f_r11g11b11.r);
        let iG: i32 = i32(v.g * f_r11g11b11.g);
        let iB: i32 = i32(v.b * f_r11g11b11.b);
        return bitcast<f32>((iR << 22u) | (iG << 11u) | iB );
    }

    fn float_to_r11g11b11( v:f32 ) -> vec3f {
        let iV: i32 = bitcast<i32>(v);
        var r: f32 = f32((iV >> 22u) & i_r11g11b11.r) / f_r11g11b11.r;
        var g: f32 = f32((iV >> 11u) & i_r11g11b11.g) / f_r11g11b11.g;
        var b: f32 = f32(iV & i_r11g11b11.b) / f_r11g11b11.b ;
        return vec3f(r,g,b);
    }

    const i_r22g8 = vec2i(0x3FFFFF,0xFF);
    const f_r22g8 = vec2f(f32(0x3FFFFF),f32(0xFF));
    fn r22g8_to_float( v:vec2f) -> f32{
        let iR: i32 = i32(v.r * f_r22g8.r);
        let iG: i32 = i32(v.g * f_r22g8.g);
        return bitcast<f32>((iR << 8u) | iG);
    }

    fn float_to_r22g8( v:f32 ) -> vec2f {
        let iV: i32 = bitcast<i32>(v);
        var r: f32 = f32((iV >> 8u) & i_r22g8.r) / f_r22g8.r;
        var g: f32 = f32(iV & i_r22g8.g) / f_r22g8.g ;
        return vec2f(r,g);
    }

    const r11g11b9 = vec3i(0x7FF,0x7FF,0x1FF);
    fn r11g11b9_to_float( v:vec3f) -> f32{
        let iR: i32 = i32(v.r * f32(r11g11b9.r));
        let iG: i32 = i32(v.g * f32(r11g11b9.g));
        let iB: i32 = i32(v.b * f32(r11g11b9.b));
        return bitcast<f32>((iR << 20u) | (iG << 9u) | iB );
    }

    fn float_to_r11g11b9( v:f32 ) -> vec3f {
        let iV: i32 = bitcast<i32>(v);
        var r: f32 = f32((iV >> 20u) & r11g11b9.r) / f32(r11g11b9.r);
        var g: f32 = f32((iV >> 9u) & r11g11b9.g) / f32(r11g11b9.g);
        var b: f32 = f32(iV & r11g11b9.b) / f32(r11g11b9.b) ;
        return vec3f(r,g,b);
    }




    fn floatToRGBA(v:f32) -> vec4f{
        var iv = bitcast<u32>(v);
        var color = vec4f(0.0);
        color.x = f32((iv&0x00FF0000u)>>16u)/255.0;
        color.y = f32((iv&0x000FF00u)>>8u)/255.0;
        color.z = f32(iv&0x000000FFu)/255.0;
        return color;
    }

    const bitShift:vec4f = vec4f(1.0, 1.0/256.0, 1.0/(256.0*256.0), 1.0/(256.0*256.0*256.0));
    fn RGBAToFloat(v:vec4f) -> f32 {
        var f = dot(v, bitShift);
        return f;
    }

`
    );

    let GBufferStand = (
      /* wgsl */
      `
    #include "MathShader"
    #include "FastMathShader"
    #include "BitUtil"
    #include "ColorUtil_frag"

    @group(0) @binding(1) var gBufferTexture : texture_2d<f32>;

    struct GBuffer{
        x : f32 ,
        y : f32 ,
        z : f32 ,
        w : f32 ,
    }

    struct ViewSpaceGBuffer{
        depth:f32,
        color:vec3f ,
        abldeoColor:vec3f ,
        viewPosition:vec3f,
        viewNormal:vec3f,
        roughness:f32,
        metallic:f32,
    }

    struct WorldSpaceGBuffer{
        depth:f32,
        color:vec3f ,
        abldeoColor:vec3f ,
        worldPosition:vec3f,
        worldNormal:vec3f,
        roughness:f32,
        metallic:f32,
    }

    fn getViewSpaceGBuffer(fragCoord:vec2i , uv:vec2f ) -> ViewSpaceGBuffer {
        var sampleUV = uv ;
        sampleUV.y = 1.0 - sampleUV.y ;
        let gBufferTexture = textureLoad(gBufferTexture, fragCoord , 0) ;

        var gBuffer : ViewSpaceGBuffer ;
        //x channel view space depth 
        gBuffer.depth = gBufferTexture.x ;
        let viewPos = getViewPosition(gBufferTexture.x,sampleUV);
        gBuffer.viewPosition = viewPos;
        
        //y channel last final color texture
        gBuffer.color = floatToVec3f(gBufferTexture.y) ;

        //z channel view space normal 
        let zChannel = floatToVec3f(gBufferTexture.z) ;
        let octUV = zChannel.xy * 2.0 - 1.0  ;
        gBuffer.viewNormal = octDecode(octUV.xy) ;

        //w channel view space normal 
        let wChannel = floatToVec3f(gBufferTexture.w) ;
        gBuffer.abldeoColor = wChannel.xyz ;

        gBuffer.roughness = zChannel.z ;
        gBuffer.metallic = 0.0 ;//wChannel.w ;

        return gBuffer ;
    }

    fn getWorldSpaceGBuffer(fragCoord:vec2i , uv:vec2f ) -> WorldSpaceGBuffer {
        var sampleUV = uv ;
        sampleUV.y = 1.0 - sampleUV.y ;
        let gBufferTexture = textureLoad(gBufferTexture, fragCoord , 0) ;

        var gBuffer : WorldSpaceGBuffer ;
        //x channel view space depth 
        gBuffer.depth = gBufferTexture.x ;
        let worldPos = getWorldPosition(gBufferTexture.x,sampleUV);
        gBuffer.worldPosition = worldPos;

        //y channel last final color texture
        gBuffer.color = floatToVec3f(gBufferTexture.y) ;

        //z channel world space normal and roughness 
        let zChannel = floatToVec3f(gBufferTexture.z) ;
        let octUV = zChannel.xy * 2.0 - 1.0  ;
        gBuffer.worldNormal = getWorldNormal(octDecode(octUV.xy)) ;

        //w channel abldeoColor and metallic
        let wChannel = floatToVec3f(gBufferTexture.w) ;
        gBuffer.abldeoColor = wChannel.xyz ;

        gBuffer.roughness = zChannel.z ;
        gBuffer.metallic = 0.0 ;//wChannel.w ;

        return gBuffer ;
    }

    fn getGBuffer(fragCoord:vec2i) -> GBuffer {
        let gBufferTexture = textureLoad(gBufferTexture, fragCoord , 0) ;
        var gBuffer:GBuffer ;
        gBuffer.x = gBufferTexture.x ;
        gBuffer.y = gBufferTexture.y ;
        gBuffer.z = gBufferTexture.z ;
        gBuffer.w = gBufferTexture.w ;
        return gBuffer ;
    }

    fn getDepthFromGBuffer(gBuffer:GBuffer) -> f32 {
        return gBuffer.x ;
    }

    fn getViewPositionFromGBuffer(gBuffer:GBuffer,screenUV:vec2f) -> vec3f {
        var sampleUV = screenUV ;
        sampleUV.x = 1.0 - sampleUV.x ;
        sampleUV.y = 1.0 - sampleUV.y ;
        let viewPos = getViewPosition(gBuffer.x,sampleUV);
        return viewPos;
    }

    fn getViewNormalFromGBuffer(gBuffer:GBuffer) -> vec3f {
        let worldNormal = getWorldNormalFromGBuffer(gBuffer) ;
        return getViewNormal(worldNormal);
    }

    // Inverse of the vertex-shader log encoding for gBuffer.x.
    //
    // When USE_LOGDEPTH is on, VertexFunction_vert sets
    //   clip.z = log2(1+w) / log2(far+1) * w
    // so after perspective divide
    //   fragCoord.z = log2(1+w) / log2(far+1)
    // which is what BxDF_frag writes into gBuffer.x. Inverting that
    // recovers w = view-space distance (positive, LH convention).
    fn inverseLog2Depth(encoded: f32, far: f32) -> f32 {
        return pow(far + 1.0, encoded) - 1.0;
    }

    // Reconstruct view-space position from a linear (view-z) depth by
    // unprojecting through projMatInv (NDC -> View) and scaling the ray
    // so its z lands at linearDepth. Stays in view space so all
    // magnitudes are bounded by ~far instead of ECEF-scale world coords;
    // the world transform happens once at the end via cameraWorldMatrix.
    //
    // We unproject ndc.z = 0 (near plane) rather than ndc.z = 1 (far
    // plane): for the standard LH WebGPU projection used by Orillusion,
    // projMatInv * (x, y, 1, 1) has w = 0 because the far plane maps to
    // a point at infinity, and viewFar.xyz / viewFar.w blows up to NaN
    // / Inf. The near-plane unprojection has w > 0 and produces the
    // same view-space ray direction (any point on the ray works since
    // we rescale to linearDepth anyway).
    fn reconstructViewPosFromLinearDepth(linearDepth: f32, sampleUV: vec2f) -> vec3f {
        let clipNear = vec4<f32>((sampleUV * 2.0 - 1.0), 0.0, 1.0);
        let viewNear = globalUniform.projMatInv * clipNear;
        let viewRay = viewNear.xyz / viewNear.w;
        return viewRay * (linearDepth / viewRay.z);
    }

    fn getWorldPositionFromGBuffer(gBuffer:GBuffer,uv:vec2f) -> vec3f {
        var sampleUV = uv ;
        sampleUV.y = 1.0 - sampleUV.y ;
        #if USE_LOGDEPTH
            // gBuffer.x is log-encoded fragCoord.z; the standard
            // viewToWorld * (uv, z, 1) reconstruction would treat the
            // log value as NDC z and unproject to the wrong point.
            // Recover linear view-space depth first, rebuild view-space
            // position via projMatInv, then go to world.
            let linearDepth = inverseLog2Depth(gBuffer.x, globalUniform.far);
            let viewPos = reconstructViewPosFromLinearDepth(linearDepth, sampleUV);
            let worldPos4 = globalUniform.cameraWorldMatrix * vec4<f32>(viewPos, 1.0);
            return worldPos4.xyz;
        #else
            let worldPos = getWorldPosition(gBuffer.x,sampleUV);
            return worldPos;
        #endif
    }

    fn getSkyPositionFromGBuffer(uv:vec2f) -> vec3f {
        var sampleUV = uv ;
        sampleUV.y = 1.0 - sampleUV.y ;
        let worldPos = getWorldPosition(0.9999999, sampleUV);
        return worldPos;
    }

    fn getRGBMColorFromGBuffer(gBuffer:GBuffer) -> vec3f {
        let rgb = unpack4x8unorm(u32(gBuffer.z)).rgb ;
        let m = unpack4x8unorm(u32(gBuffer.w)).z ;
        return DecodeRGBM(vec4f(rgb,m)) ;
    }

   
    fn getWorldNormalFromGBuffer(gBuffer:GBuffer) -> vec3f {
        // let viewNormal = getViewNormalFromGBuffer(gBuffer) ; 
        // let worldNormal = getWorldNormal(viewNormal) ;
        // return worldNormal;
        let zChannel = float_to_r11g11b9(gBuffer.y) ;
        let octUV = zChannel.xy * 2.0 - 1.0  ;
        let viewNormal = octDecode(octUV.xy);
        return viewNormal;
    }



    fn getAbldeoFromGBuffer(gBuffer:GBuffer) -> vec4f {
        let rgba = floatToVec4f_7bits(gBuffer.z).rgba ;
        return rgba ;
    }

    fn getAlphaFromGBuffer(gBuffer:GBuffer) -> f32 {
        let rgba = floatToVec4f_7bits(gBuffer.z).rgba ;
        return rgba.a;
    }

    fn getMetaillicFromGBuffer(gBuffer:GBuffer) -> f32 {
        let channel = float_to_r22g8(gBuffer.w) ;
        return channel.y;
    }

    fn getRoughnessFromGBuffer(gBuffer:GBuffer) -> f32 {
        let channel = float_to_r11g11b9(gBuffer.y) ;
        return channel.z;
    }

    fn getIDFromGBuffer_f32_01(gBuffer:GBuffer) -> f32 {
        let channel = float_to_r22g8(gBuffer.w) ;
        return channel.x;
    }

    fn getIDFromGBuffer_i32(gBuffer:GBuffer) -> i32 {
        let id_f32_01 = getIDFromGBuffer_f32_01(gBuffer) ;
        let id = i32(round(id_f32_01 * f_r22g8.r));
        return id;
    }

    
`
    );

    let ReflectionShader_shader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "GlobalUniform"
    #include "BitUtil"
    #include "MathShader"
    #include "ReflectionCG"
    #include "ColorUtil_frag"
    
    struct MaterialUniform {
        transformUV1:vec4<f32>,
        transformUV2:vec4<f32>,
        baseColor: vec4<f32>,
        alphaCutoff: f32,
        reflectionIndex : f32,
    };

    // @group(1) @binding(0)
    // var baseMapSampler: sampler;
    // @group(1) @binding(1)
    // var baseMap: texture_2d<f32>;
    @group(2) @binding(0)
    var<uniform> materialUniform: MaterialUniform;

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        var transformUV1 = materialUniform.transformUV1;
        var transformUV2 = materialUniform.transformUV2;

        useSphereReflection();
        var finalColor : vec3f ;
        let scale = vec2f(1.0/8.0,1.0/globalUniform.reflectionProbeMaxCount) ;
        var uv = (octEncode(-ORI_VertexVarying.vWorldNormal) + 1.0) * 0.5 ;
        var uv1 = uv * scale + vec2f(0.0,(materialUniform.reflectionIndex * scale.y )) ;
        let gBuffer = textureSampleLevel(reflectionMap,reflectionMapSampler,uv1,0.0);
        ORI_ShadingInput.BaseColor = vec4f(gBuffer.rgb,1.0) ;
        UnLit();
    }

    fn UnLit(){
        var viewColor = ORI_ShadingInput.BaseColor ;
            let finalMatrix = globalUniform.projMat * globalUniform.viewMat ;
            let nMat = mat3x3<f32>(finalMatrix[0].xyz,finalMatrix[1].xyz,finalMatrix[2].xyz) ;
            let ORI_NORMALMATRIX = transpose(inverse( nMat ));

            var vNormal = normalize(ORI_NORMALMATRIX * (ORI_VertexVarying.vWorldNormal ));
            var worldNormal = vec3<f32>( (vNormal.xyz + 1.0) * 0.5);

            let gBuffer = packNHMDGBuffer(
                getGBufferDepth(),
                vec3f(0.0),
                viewColor.rgb,
                vec3f(0.0),
                vNormal,
                viewColor.a
            );

            #if USE_CASTREFLECTION
                ORI_FragmentOutput.gBuffer = gBuffer ;
            #else
                ORI_FragmentOutput.color = viewColor ;
                ORI_FragmentOutput.gBuffer = gBuffer ;
            #endif
    }
`
    );

    let ReflectionCG = (
      /* wgsl */
      `
    #include 'MathShader'
    #include 'BitUtil'
    #include 'GlobalUniform'

    struct ReflectionInfo{
        gid:f32,
        worldPosition:vec3f,
        radius:f32,
        worldPosition2:vec3f,
    }

    @group(1) @binding(auto)
    var reflectionMap: texture_2d<f32>;
    @group(1) @binding(auto)
    var reflectionMapSampler: sampler;

    @group(2) @binding(8) 
    var<storage,read> reflectionBuffer : array<ReflectionInfo>;

    var<private> reflectionSize : vec2f ; 
    var<private> PROBE_SOURCESIZE : vec2f ; 
    var<private> PROBEMAP_SOURCESIZE : vec2f ; 
    var<private> aspect : vec2f ; 
    var<private> spaceV : f32 ; 

    fn useSphereReflection(){
        reflectionSize = vec2f(textureDimensions(reflectionMap).xy);
        PROBE_SOURCESIZE = vec2f(globalUniform.reflectionProbeSize);
        PROBEMAP_SOURCESIZE = vec2f(globalUniform.reflectionMapWidth,globalUniform.reflectionMapHeight) ;
        aspect = PROBE_SOURCESIZE / PROBEMAP_SOURCESIZE;
        spaceV = 1.0 / globalUniform.reflectionProbeMaxCount;
    }

    fn getSampleProbeUV(dir:vec3<f32>,gid:f32) -> vec2<f32> {
        let faceId = dir_to_faceId(dir);
        var targetUV:vec2<f32> = convert_xyz_to_cube_uv(dir.x, dir.y, dir.z);
        targetUV.x = 1.0 - targetUV.x;
        // targetUV.y = 1.0 - targetUV.y;
        let threshould = 0.5 / PROBE_SOURCESIZE;
        targetUV = clamp(targetUV, vec2<f32>(threshould), vec2<f32>(1.0 - threshould));
     
        targetUV.x = f32(faceId) + targetUV.x;
        targetUV = targetUV * aspect ;
        targetUV.y = targetUV.y + (spaceV*gid);
        return targetUV ;
     }

    //  fn getReflectionsMap(n:vec3<f32>,gid:f32) -> vec3f {
    //     var uv = getSampleProbeUV(-n,gid);
    //     let color = textureSample(reflectionMap,reflectionMapSampler,uv) ;
    //     return floatToVec3f(color.y) ;
    //  }

    const magic = vec4f(0.9852,0.99214,0.00754,0.0);
     fn getReflectionsBuffer(n:vec3<f32>,gid:f32,mip:f32) -> vec4f {
        let scaleA = vec2f(1.0/8.0,1.0/globalUniform.reflectionProbeMaxCount) ;
        let mipSource = clamp((mip * 8.0),0.0,8.0) ;
        let mip1 = floor(mipSource) ;
        let mip2 = mip1 + 1.0 ;
        let mipPect = mipSource - mip1 ;
        var uv = (octEncode(-n) + 1.0) * 0.5 * magic.xy + magic.zw ;
        var uv1 = (uv * scaleA + vec2f((mip1 * (scaleA.x)) ,0.0 ));
        var uv2 = (uv * scaleA + vec2f((mip2 * (scaleA.x)) ,0.0 ));
        let b1 = textureSampleLevel(reflectionMap,reflectionMapSampler,uv1,0.0);
        let b2 = textureSampleLevel(reflectionMap,reflectionMapSampler,uv2,0.0);
        let b1Color = b1.rgb ;
        let b2Color = b2.rgb ;

        // let rgb1 = unpack4x8unorm(u32(b1.z)).rgb ;
        // let rgb2 = unpack4x8unorm(u32(b2.z)).rgb ;

        // let m1 = unpack4x8unorm(u32(b1.w)).z ;
        // let m2 = unpack4x8unorm(u32(b2.w)).z ;

        // let b1Color = DecodeRGBM(vec4f(rgb1,m1));
        // let b2Color = DecodeRGBM(vec4f(rgb2,m2));

        // let b1D = b1.x; 
        // let b2D = b2.x; 

        let color = mix(b1Color,b2Color,vec3f(mipPect));  ;
        // let depth = mix(b1D,b2D,(mipPect)); 
        // return vec4f(color,depth) ;
        return vec4f(color,0.0) ;
     }

     fn getReflectionsEnv(reflectDir:vec3<f32>,worldPos:vec3f,mip:f32) -> vec3f{
        let maxCount = u32(globalUniform.reflectionProbeMaxCount) ;
        var nearColor = vec3f(0.0);
        if(globalUniform.reflectionCount > 0.0){
            var nearDistance = 99999.0 ;
            var nearReflectionIndex = 0u ;
            for(var i = 0u ; i < maxCount; i+=1u){
                var reflectionInfo = reflectionBuffer[i];
                let dis = length(reflectionInfo.worldPosition - worldPos) ;
                if(dis < nearDistance){
                    nearDistance = dis;
                    nearReflectionIndex = i;
                }
            }
            nearColor = getReflectionsBuffer(reflectDir,f32(nearReflectionIndex),mip).xyz;
        }else{
            nearColor = textureSampleLevel(envMap, envMapSampler, reflectDir , mip * 12.0 ).rgb ;
        }
        return nearColor ;
     }

    //  fn getReflectionsEnv(n:vec3<f32>,worldPos:vec3f,mip:f32) -> vec3f{
    //     let count = 1.0 ;//globalUniform.reflectionProbeMaxCount ;
    //     var nearColor = vec3f(0.0);
    //     var nearDistance = 99999.0 ;
    //     for(var i = 0.0 ; i < count; i+=1.0){
    //         var reflectionInfo = reflectionBuffer[i32(i)];
    //         let dis = length(reflectionInfo.worldPosition - worldPos) ;
    //         if(dis > reflectionInfo.radius){
    //             var buffer = getReflectionsBuffer(n,i,mip);
    //             var d = buffer.w;
    //             if(d <= -globalUniform.far){
    //                 d = 99999.0 - 1.0 ;
    //             }
    //             if(nearDistance > d){
    //                 nearColor = buffer.xyz;
    //                 nearDistance = d;
    //             }
    //         }else{
    //             nearColor = vec3f(1.0,0.0,0.0);
    //         }
    //     }
    //     return nearColor ;
    //  }


`
    );

    let SHCommon_frag = (
      /*wgsl*/
      `

fn Y0(v : vec3f ) -> f32 {
     return ((1.0 / 2.0) * sqrt(1.0 / PI)); 
}

fn Y1(v: vec3f ) -> f32 {
    return ( sqrt(3.0 / (4.0 * PI)) * v.z ) ;
}

fn Y2(v: vec3f ) -> f32 { 
    return (sqrt(3.0 / (4.0 * PI)) * v.y) ;
}

fn Y3(v: vec3f ) -> f32 {  
    return (sqrt(3.0 / (4.0 * PI)) * v.x) ;
}

fn Y4(v: vec3f ) -> f32 { 
    return (1.0 / 2.0 * sqrt(15.0 / PI) * v.x * v.z) ;
}

fn Y5(v: vec3f ) -> f32 { 
    return (1.0 / 2.0 * sqrt(15.0 / PI) * v.z * v.y) ;
}

fn Y6(v: vec3f ) -> f32 { 
    return (1.0 / 4.0 * sqrt(5.0 / PI) * (-v.x * v.x - v.z * v.z + 2.0 * v.y * v.y)) ;
}

fn Y7(v: vec3f ) -> f32 { 
    return (1.0 / 2.0 * -sqrt(15.0 / PI) * v.y * v.x) ;
}

fn Y8(v: vec3f ) -> f32 { 
    return (1.0 / 4.0 * sqrt(15.0 / PI) * (v.x * v.x - v.z * v.z)) ;
}

fn Y9(v: vec3f ) -> f32 { 
    return (1.0 / 4.0 * sqrt(35.0 / (2.0 * PI)) * (3.0 * v.x * v.x - v.z * v.z) * v.z) ;
}

fn Y10(v: vec3f ) -> f32 { 
    return ( 1.0 / 2.0 * sqrt(105.0 / PI) * v.x * v.z * v.y );
}

fn Y11(v: vec3f ) -> f32 { 
    return ( 1.0 / 4.0 * sqrt(21.0 / (2.0 * PI)) * v.z * (4.0 * v.y * v.y - v.x * v.x - v.z * v.z) );
}

fn Y12(v: vec3f ) -> f32 { 
    return ( 1.0 / 4.0 * sqrt(7.0 / PI) * v.y * (2 * v.y * v.y - 3.0 * v.x * v.x - 3.0 * v.z * v.z) );
}

fn Y13(v: vec3f ) -> f32 { 
    return ( 1.0 / 4.0 * sqrt(21.0 / (2.0 * PI)) * v.x * (4.0 * v.y * v.y - v.x * v.x - v.z * v.z) );
}

fn Y14(v: vec3f ) -> f32 { 
    return ( 1.0 / 4.0 * sqrt(105.0 / PI) * (v.x * v.x - v.z * v.z) * v.y );
}

fn Y15(v: vec3f ) -> f32 { 
    return ( 1.0 / 4.0 * sqrt(35.0 / (2.0 * PI)) * (v.x * v.x - 3.0 * v.z * v.z) * v.x );
}

fn SH9(dir: vec3<f32>, coefficients: array<vec4f, 9>) -> vec4<f32> {
    let N: vec3<f32> = vec3<f32>(dir.z, dir.y, dir.x);
    let v: vec3<f32> = normalize(N);

    let color = coefficients[0] * Y0(v)  
        + coefficients[1] * Y1(v) 
        + coefficients[2] * Y2(v) 
        + coefficients[3] * Y3(v) 
        + coefficients[4] * Y4(v) 
        + coefficients[5] * Y5(v) 
        + coefficients[6] * Y6(v) 
        + coefficients[7] * Y7(v)  
        + coefficients[8] * Y8(v) 
    ;
    
    return vec4(color.rgb,1.0) ;
}
`
    );

    function getLightData(maxCascades) {
      return (
        /*wgsl*/
        `
    struct LightData {
        index:f32,
        lightType:i32,
        radius:f32,
        linear:f32,
        
        position:vec3<f32>,
        lightMatrixIndex:f32,

        direction:vec3<f32>,
        quadratic:f32,

        lightColor:vec3<f32>,
        intensity:f32,

        innerCutOff :f32,
        outerCutOff:f32,
        range :f32,
        castShadow:i32,

        lightTangent:vec3<f32>,
        ies:f32,

        csmShadowMapNum: f32,
        csmShadowMapIndex: f32,
        shadowFar: f32,
        softness: f32,

        shadowBias: array<f32, ${maxCascades}>,
        normalBias: array<f32, ${maxCascades}>,
    };
`
      );
    }

    class EarthSky_Shader {
      static earthsky_vs_wgsl = (
        /* wgsl */
        `
    #include "WorldMatrixUniform"
    #include "GlobalUniform"

    struct uniformData {
        exposure: f32,
        roughness: f32,
        yaw: f32,
        pitch: f32,
    };

    struct VertexOutput {
        @location(auto) fragUV: vec2<f32>,
        @location(auto) vWorldPos: vec4<f32>,
        @location(auto) vWorldNormal: vec3<f32>,
        @location(auto) viewDir: vec3<f32>,
        @builtin(position) member: vec4<f32>
    };

    var<private> ORI_VertexOut: VertexOutput;

    @group(2) @binding(0)
    var<uniform> global: uniformData;

    @vertex
    fn main( 
        @builtin(instance_index) index : u32,
        @location(auto) position: vec3<f32>,
        @location(auto) normal: vec3<f32>,
        @location(auto) uv: vec2<f32>
    ) -> VertexOutput {
        ORI_VertexOut.fragUV = uv;
        var modelMat = models.matrix[u32(index)];
        
        // Handle RTE (Relative To Eye) mode
        if (globalUniform.useRTE != 0) {
            UpdateWorldMatrixToRTE(u32(index), &modelMat);
        }
        
        let normalMatrix = mat3x3<f32>(modelMat[0].xyz, modelMat[1].xyz, modelMat[2].xyz);
        ORI_VertexOut.vWorldNormal = normalize(normalMatrix * normal);
        ORI_VertexOut.vWorldPos = modelMat * vec4<f32>(position.xyz, 1.0);

        let viewPos = globalUniform.viewMat * ORI_VertexOut.vWorldPos;
        ORI_VertexOut.viewDir = viewPos.xyz;

        var clipPos = globalUniform.projMat * viewPos;
        clipPos.z = clipPos.w;
        ORI_VertexOut.member = clipPos;
        return ORI_VertexOut;
    }
    `
      );
      static earthsky_fs_wgsl = (
        /* wgsl */
        `
    #include "GlobalUniform"
    #include "MathShader"
    #include "BitUtil"
    #include "ColorUtil_frag"
    #include "FragmentOutput"

    struct uniformData {
        exposure: f32,
        roughness: f32,
        yaw: f32,
        pitch: f32,
    };

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_cube<f32>;

    @group(2) @binding(0)
    var<uniform> global: uniformData;

    // Rotate a vector around Y axis (yaw)
    fn rotateY(v: vec3<f32>, angle: f32) -> vec3<f32> {
        let c = cos(angle);
        let s = sin(angle);
        return vec3<f32>(
            c * v.x + s * v.z,
            v.y,
            -s * v.x + c * v.z
        );
    }

    // Rotate a vector around X axis (pitch)
    fn rotateX(v: vec3<f32>, angle: f32) -> vec3<f32> {
        let c = cos(angle);
        let s = sin(angle);
        return vec3<f32>(
            v.x,
            c * v.y - s * v.z,
            s * v.y + c * v.z
        );
    }

    @fragment
    fn main(
        @location(auto) fragUV: vec2<f32>,
        @location(auto) vWorldPos: vec4<f32>,
        @location(auto) vWorldNormal: vec3<f32>,
        @location(auto) viewDir: vec3<f32>,
        @builtin(position) fragCoord: vec4<f32>
    ) -> FragmentOutput {
        let maxLevel: u32 = textureNumLevels(baseMap);
 
        var samplerDir = normalize(viewDir);
        samplerDir = rotateX(samplerDir, global.pitch);
        samplerDir = rotateY(samplerDir, global.yaw);
        
        var textureColor: vec3<f32> = textureSampleLevel(baseMap, baseMapSampler, samplerDir, global.roughness * f32(maxLevel)).xyz;
        
        #if IS_HDR_SKY
            textureColor = LinearToGammaSpace(textureColor);
        #endif

        let o_Target: vec4<f32> = vec4<f32>(textureColor, 1.0) * global.exposure;

        var fragmentOutput: FragmentOutput;
        fragmentOutput.color = o_Target;
        #if USE_OUTDEPTH
            // Ensure sky is always at far plane (depth = 1.0) for log depth
            fragmentOutput.out_depth = 0.999999;
        #endif
        return fragmentOutput;
    }
    `
      );
    }

    class EarthAtm_Shader {
      static earthatm_vs_wgsl = (
        /* wgsl */
        `
    #include "WorldMatrixUniform"
    #include "GlobalUniform"

    struct uniformData {
        // Earth parameters
        earthRadius: f32,           // Earth radius in meters (default: 6371000)
        atmosphereRadius: f32,      // Atmosphere outer radius (default: earthRadius * 1.025)
        sunIntensity: f32,          // Sun light intensity
        mieG: f32,                  // Mie phase function g parameter
        
        // Sun direction
        sunDirectionX: f32,
        sunDirectionY: f32,
        sunDirectionZ: f32,
        exposure: f32,              // Exposure for tone mapping
        
        // Scattering coefficients
        rayleighCoeffX: f32,
        rayleighCoeffY: f32,
        rayleighCoeffZ: f32,
        mieCoeff: f32,              // Mie scattering coefficient
        
        // Additional parameters
        rayleighScale: f32,         // Rayleigh scale height
        mieScale: f32,              // Mie scale height
        earthCenterX: f32,
        earthCenterY: f32,
        
        earthCenterZ: f32,
        padding1: f32,
        padding2: f32,
        padding3: f32,
    };

    struct VertexOutput {
        @location(auto) fragUV: vec2<f32>,
        @location(auto) vWorldPos: vec4<f32>,
        @location(auto) vWorldNormal: vec3<f32>,
        @location(auto) viewDir: vec3<f32>,
        @builtin(position) member: vec4<f32>
    };

    var<private> ORI_VertexOut: VertexOutput;

    @group(2) @binding(0)
    var<uniform> global: uniformData;

    @vertex
    fn main( 
        @builtin(instance_index) index : u32,
        @location(auto) position: vec3<f32>,
        @location(auto) normal: vec3<f32>,
        @location(auto) uv: vec2<f32>
    ) -> VertexOutput {
        ORI_VertexOut.fragUV = uv;
        var modelMat = models.matrix[u32(index)];
        
        // Handle RTE (Relative To Eye) mode
        if (globalUniform.useRTE != 0) {
            UpdateWorldMatrixToRTE(u32(index), &modelMat);
        }
        
        let normalMatrix = mat3x3<f32>(modelMat[0].xyz, modelMat[1].xyz, modelMat[2].xyz);
        ORI_VertexOut.vWorldNormal = normalize(normalMatrix * normal);
        ORI_VertexOut.vWorldPos = modelMat * vec4<f32>(position.xyz, 1.0);

        let viewPos = globalUniform.viewMat * ORI_VertexOut.vWorldPos;
        ORI_VertexOut.viewDir = viewPos.xyz;

        var clipPos = globalUniform.projMat * viewPos;
        clipPos.z = clipPos.w;
        ORI_VertexOut.member = clipPos;
        return ORI_VertexOut;
    }
    `
      );
      static earthatm_fs_wgsl = (
        /* wgsl */
        `
    #include "GlobalUniform"
    #include "MathShader"
    #include "BitUtil"
    #include "ColorUtil_frag"
    #include "FragmentOutput"

    struct uniformData {
        // Earth parameters
        earthRadius: f32,           
        atmosphereRadius: f32,      
        sunIntensity: f32,
        mieG: f32,
        
        // Sun direction
        sunDirectionX: f32,
        sunDirectionY: f32,
        sunDirectionZ: f32,
        exposure: f32,
        
        // Scattering coefficients
        rayleighCoeffX: f32,
        rayleighCoeffY: f32,
        rayleighCoeffZ: f32,
        mieCoeff: f32,
        
        // Additional parameters
        rayleighScale: f32,
        mieScale: f32,
        earthCenterX: f32,
        earthCenterY: f32,
        
        earthCenterZ: f32,
        padding1: f32,
        padding2: f32,
        padding3: f32,
    };

    // Placeholder texture binding for group 1 (required by engine)
    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_cube<f32>;

    @group(2) @binding(0)
    var<uniform> global: uniformData;

    // Constants
    const PI: f32 = 3.14159265359;
    const NUM_SAMPLES: i32 = 8;
    const NUM_SAMPLES_LIGHT: i32 = 4;

    // Rayleigh phase function
    fn rayleighPhase(cosTheta: f32) -> f32 {
        return 0.75 * (1.0 + cosTheta * cosTheta);
    }

    // Mie phase function (Henyey-Greenstein)
    fn miePhase(cosTheta: f32, g: f32) -> f32 {
        let g2 = g * g;
        let num = 1.5 * (1.0 - g2) * (1.0 + cosTheta * cosTheta);
        let denom = (2.0 + g2) * pow(1.0 + g2 - 2.0 * g * cosTheta, 1.5);
        return num / denom;
    }

    // Ray-sphere intersection
    fn raySphereIntersect(rayOrigin: vec3<f32>, rayDir: vec3<f32>, sphereCenter: vec3<f32>, sphereRadius: f32) -> vec2<f32> {
        let oc = rayOrigin - sphereCenter;
        let b = dot(oc, rayDir);
        let c = dot(oc, oc) - sphereRadius * sphereRadius;
        let discriminant = b * b - c;
        
        if (discriminant < 0.0) {
            return vec2<f32>(-1.0, -1.0);
        }
        
        let sqrtDisc = sqrt(discriminant);
        return vec2<f32>(-b - sqrtDisc, -b + sqrtDisc);
    }

    // Scale height density function
    fn densityAtHeight(height: f32, scaleHeight: f32) -> f32 {
        return exp(-height / scaleHeight);
    }

    // Compute optical depth from point to atmosphere edge along direction
    fn opticalDepth(
        rayOrigin: vec3<f32>,
        rayDir: vec3<f32>,
        rayLength: f32,
        earthCenter: vec3<f32>,
        earthRadius: f32,
        scaleHeight: f32
    ) -> f32 {
        let stepSize = rayLength / f32(NUM_SAMPLES_LIGHT);
        var depth = 0.0;
        
        for (var i = 0; i < NUM_SAMPLES_LIGHT; i = i + 1) {
            let pos = rayOrigin + rayDir * (f32(i) + 0.5) * stepSize;
            let height = length(pos - earthCenter) - earthRadius;
            depth = depth + densityAtHeight(max(0.0, height), scaleHeight) * stepSize;
        }
        
        return depth;
    }

    @fragment
    fn main(
        @location(auto) fragUV: vec2<f32>,
        @location(auto) vWorldPos: vec4<f32>,
        @location(auto) vWorldNormal: vec3<f32>,
        @location(auto) viewDir: vec3<f32>,
        @builtin(position) fragCoord: vec4<f32>
    ) -> FragmentOutput {
        let cameraPos = globalUniform.cameraWorldMatrix[3].xyz;
        
        var earthCenter: vec3<f32>;
        if (globalUniform.useRTE != 0) {
            let earthCenterWorld = vec3<f32>(global.earthCenterX, global.earthCenterY, global.earthCenterZ);
            earthCenter = earthCenterWorld - (globalUniform.cameraPositionH + globalUniform.cameraPositionL);
        } else {
            earthCenter = vec3<f32>(global.earthCenterX, global.earthCenterY, global.earthCenterZ);
        }
        
        let rayDir = normalize(vWorldPos.xyz - cameraPos);
        
        let sunDir = normalize(vec3<f32>(global.sunDirectionX, global.sunDirectionY, global.sunDirectionZ));
        let rayleighCoeff = vec3<f32>(global.rayleighCoeffX, global.rayleighCoeffY, global.rayleighCoeffZ);
        
        let earthRadius = global.earthRadius;
        let atmosphereRadius = global.atmosphereRadius;
        let rayleighScale = global.rayleighScale;
        let mieScale = global.mieScale;
        let mieCoeff = global.mieCoeff;
        let mieG = global.mieG;
        let sunIntensity = global.sunIntensity;
        
        // Check atmosphere intersection
        let atmIntersect = raySphereIntersect(cameraPos, rayDir, earthCenter, atmosphereRadius);
        
        // Slightly inflated earth radius to catch grazing rays at horizon
        let earthHitRadius = earthRadius + rayleighScale * 0.1;
        let earthIntersect = raySphereIntersect(cameraPos, rayDir, earthCenter, earthHitRadius);
        let hitEarth = earthIntersect.x > 0.0;
        let hitAtm = atmIntersect.y >= 0.0;

        // Accumulated scattering
        var totalRayleigh = vec3<f32>(0.0);
        var totalMie = vec3<f32>(0.0);
        var viewOpticalDepthRayleigh = 0.0;
        var viewOpticalDepthMie = 0.0;

        // Ray march only when ray intersects atmosphere
        if (hitAtm) {
            var tStart = max(atmIntersect.x, 0.0);
            var tEnd = atmIntersect.y;
            
            if (hitEarth && earthIntersect.x > 0.0) {
                tEnd = min(tEnd, earthIntersect.x);
            }
            
            let rayLength = tEnd - tStart;
            if (rayLength > 0.0) {
                let stepSize = rayLength / f32(NUM_SAMPLES);
                
                for (var i = 0; i < NUM_SAMPLES; i = i + 1) {
                    let t = tStart + (f32(i) + 0.5) * stepSize;
                    let samplePos = cameraPos + rayDir * t;
                    let height = length(samplePos - earthCenter) - earthRadius;
                    
                    let densityRayleigh = densityAtHeight(max(0.0, height), rayleighScale);
                    let densityMie = densityAtHeight(max(0.0, height), mieScale);
                    
                    viewOpticalDepthRayleigh = viewOpticalDepthRayleigh + densityRayleigh * stepSize;
                    viewOpticalDepthMie = viewOpticalDepthMie + densityMie * stepSize;
                    
                    let sunIntersect = raySphereIntersect(samplePos, sunDir, earthCenter, atmosphereRadius);
                    
                    if (sunIntersect.y > 0.0) {
                        let sunEarthIntersect = raySphereIntersect(samplePos, sunDir, earthCenter, earthRadius);
                        
                        if (sunEarthIntersect.x < 0.0) {
                            let sunRayLength = sunIntersect.y;
                            
                            let sunOpticalDepthRayleigh = opticalDepth(
                                samplePos, sunDir, sunRayLength,
                                earthCenter, earthRadius, rayleighScale
                            );
                            let sunOpticalDepthMie = opticalDepth(
                                samplePos, sunDir, sunRayLength,
                                earthCenter, earthRadius, mieScale
                            );
                            
                            let totalOpticalDepthRayleigh = viewOpticalDepthRayleigh + sunOpticalDepthRayleigh;
                            let totalOpticalDepthMie = viewOpticalDepthMie + sunOpticalDepthMie;
                            
                            let transmittance = exp(
                                -(rayleighCoeff * totalOpticalDepthRayleigh + 
                                vec3<f32>(mieCoeff) * totalOpticalDepthMie)
                            );
                            
                            totalRayleigh = totalRayleigh + densityRayleigh * transmittance * stepSize;
                            totalMie = totalMie + densityMie * transmittance * stepSize;
                        }
                    }
                }
            }
        }
        
        // Phase functions
        let cosTheta = dot(rayDir, sunDir);
        let phaseR = rayleighPhase(cosTheta);
        let phaseM = miePhase(cosTheta, mieG);
        
        // Scattering color
        let rayleighColor = totalRayleigh * rayleighCoeff * phaseR;
        let mieColor = totalMie * mieCoeff * phaseM;
        var color = (rayleighColor + mieColor) * sunIntensity;
        
        // Sun attenuation through atmosphere (1.0 when no atmosphere traversal)
        let sunAttenuation = exp(-(rayleighCoeff * viewOpticalDepthRayleigh + vec3<f32>(mieCoeff) * viewOpticalDepthMie));

        // Glow only when ray passes through atmosphere; sun disc always visible
        var sunDisc = 0.0;
        if (!hitEarth) {
            if (hitAtm) {
                let cosTheta01 = max(cosTheta, 0.0);
                let glow1 = pow(cosTheta01, 350.0) * 0.08;
                let glow2 = pow(cosTheta01, 60.0) * 0.012;
                let glow3 = pow(cosTheta01, 6.0) * 0.003;
                let glowColor = vec3<f32>(1.0, 0.92, 0.82);
                color = color + glowColor * (glow1 + glow2 + glow3) * sunIntensity * sunAttenuation;
            }

            // Sun disc
            let sunAngularRadius = 0.035;
            let sunCosAngle = cos(sunAngularRadius);
            if (cosTheta > sunCosAngle) {
                sunDisc = smoothstep(sunCosAngle - 0.003, sunCosAngle, cosTheta);
            }
        }
        
        // Discard if nothing visible
        if (!hitAtm && length(color) < 0.0001 && sunDisc < 0.001) {
            discard;
        }

        // Apply exposure
        color = color * global.exposure;
        
        // Tone mapping (ACES approximation)
        let a = 2.51;
        let b = 0.03;
        let c = 2.43;
        let d = 0.59;
        let e = 0.14;
        color = clamp((color * (a * color + b)) / (color * (c * color + d) + e), vec3<f32>(0.0), vec3<f32>(1.0));
        
        // Gamma correction
        color = pow(color, vec3<f32>(1.0 / 2.2));
        
        // Sun disc composited AFTER tone mapping (always visible)
        if (sunDisc > 0.0) {
            let sunCenterColor = vec3<f32>(1.0, 1.0, 0.98);
            let sunEdgeColor = vec3<f32>(1.0, 0.85, 0.4);
            let centerFactor = pow(sunDisc, 0.4);
            let sunDiskColor = mix(sunEdgeColor, sunCenterColor, centerFactor);
            color = mix(color, sunDiskColor, sunDisc);
        }
        
        // Alpha
        let scatterIntensity = length(color);
        var alpha = 1.0;
        if (!hitAtm) {
            alpha = clamp(scatterIntensity * 2.0, 0.0, 1.0);
        } else if (!hitEarth) {
            let viewTransmittance = exp(-(rayleighCoeff * viewOpticalDepthRayleigh + vec3<f32>(mieCoeff) * viewOpticalDepthMie));
            let avgTransmittance = (viewTransmittance.x + viewTransmittance.y + viewTransmittance.z) / 3.0;
            let atmOpacity = 1.0 - avgTransmittance;
            alpha = max(atmOpacity, clamp(scatterIntensity * 2.0, 0.0, 1.0));
        }

        var fragmentOutput: FragmentOutput;
        fragmentOutput.color = vec4<f32>(color, alpha);
        
        #if USE_OUTDEPTH
            fragmentOutput.out_depth = 1.0;
        #endif
        
        return fragmentOutput;
    }
    `
      );
    }

    class ShaderLib {
      static init(seedSetting) {
        ShaderLib.register("MathShader", MathShader);
        ShaderLib.register("FastMathShader", FastMathShader);
        ShaderLib.register("BitUtil", BitUtil);
        ShaderLib.register("GBufferStand", GBufferStand);
        ShaderLib.register("SHCommon_frag", SHCommon_frag);
        ShaderLib.register("MatrixShader", MatrixShader);
        ShaderLib.register("GlobalUniform", GlobalUniform(seedSetting.shadow.maxShadowMapNum));
        ShaderLib.register("WorldMatrixUniform", WorldMatrixUniform);
        ShaderLib.register("NormalMap_frag", NormalMap_frag);
        ShaderLib.register("LightingFunction_frag", LightingFunction_frag);
        ShaderLib.register("PhysicMaterialUniform_frag", PhysicMaterialUniform_frag);
        ShaderLib.register("UnLitMaterialUniform_frag", UnLitMaterialUniform_frag);
        ShaderLib.register("VideoUniform_frag", VideoUniform_frag);
        ShaderLib.register("InstanceUniform", InstanceUniform);
        ShaderLib.register("Inline_vert", Inline_vert);
        ShaderLib.register("VertexAttributes", VertexAttributes);
        ShaderLib.register("VertexOutput", VertexOutput);
        ShaderLib.register("VertexFunction_vert", VertexFunction_vert);
        ShaderLib.register("VertexAttributes_vert", VertexAttributes_vert);
        ShaderLib.register("Common_vert", Common_vert);
        ShaderLib.register("Common_frag", Common_frag);
        ShaderLib.register("FragmentVarying", FragmentVarying);
        ShaderLib.register("FragmentOutput", FragmentOutput);
        ShaderLib.register("LightData", getLightData(seedSetting.shadow.maxCascades));
        ShaderLib.register("ClusterLight", ClusterLight);
        ShaderLib.register("ShadingInput", ShadingInput);
        ShaderLib.register("IESProfiles_frag", IESProfiles_frag);
        ShaderLib.register("ShadowCommon", ShadowCommon);
        ShaderLib.register("PCF_frag", PCF_frag);
        ShaderLib.register("CSM_frag", CSM_frag);
        ShaderLib.register("DirectShadow_frag", DirectShadow_frag);
        ShaderLib.register("PointShadow_frag", PointShadow_frag);
        ShaderLib.register("ShadowMapping_frag", ShadowMapping_frag);
        ShaderLib.register("Irradiance_frag", Irradiance_frag);
        ShaderLib.register("IrradianceVolumeData_frag", IrradianceVolumeData_frag);
        ShaderLib.register("BrdfLut_frag", BrdfLut_frag);
        ShaderLib.register("EnvMap_frag", EnvMap_frag);
        ShaderLib.register("ColorUtil_frag", ColorUtil);
        ShaderLib.register("BRDF_frag", BRDF_frag);
        ShaderLib.register("Hair_frag", Hair_frag);
        ShaderLib.register("BxDF_frag", BxDF_frag);
        ShaderLib.register("BsDF_frag", BsDF_frag);
        ShaderLib.register("AlphaHash_frag", AlphaHash_frag);
        ShaderLib.register("UnLit_frag", UnLit_frag);
        ShaderLib.register("UnLit", UnLit);
        ShaderLib.register("Sprite", Sprite_shader);
        ShaderLib.register("ReflectionCG", ReflectionCG);
        ShaderLib.register("ReflectionShader_shader", ReflectionShader_shader);
        ShaderLib.register("Clearcoat_frag", Clearcoat_frag);
        ShaderLib.register("LitShader", Lit_shader);
        ShaderLib.register("PBRLItShader", PBRLItShader);
        ShaderLib.register("ClusterDebug_frag", ClusterDebug_frag);
        ShaderLib.register("BxdfDebug_frag", BxdfDebug_frag);
        ShaderLib.register("GenerayRandomDir", GenerayRandomDir);
        ShaderLib.register("Quad_vert_wgsl", Quad_vert_wgsl);
        ShaderLib.register("Quad_frag_wgsl", Quad_frag_wgsl);
        ShaderLib.register("Quad_premultiply_frag_wgsl", Quad_premultiply_frag_wgsl);
        ShaderLib.register("Quad_opaque_frag_wgsl", Quad_opaque_frag_wgsl);
        ShaderLib.register("Quad_depth2d_frag_wgsl", Quad_depth2d_frag_wgsl);
        ShaderLib.register("Quad_depthCube_frag_wgsl", Quad_depthCube_frag_wgsl);
        ShaderLib.register("sky_vs_frag_wgsl", CubeSky_Shader.sky_vs_frag_wgsl);
        ShaderLib.register("sky_fs_frag_wgsl", CubeSky_Shader.sky_fs_frag_wgsl);
        ShaderLib.register("earthsky_vs_wgsl", EarthSky_Shader.earthsky_vs_wgsl);
        ShaderLib.register("earthsky_fs_wgsl", EarthSky_Shader.earthsky_fs_wgsl);
        ShaderLib.register("earthatm_vs_wgsl", EarthAtm_Shader.earthatm_vs_wgsl);
        ShaderLib.register("earthatm_fs_wgsl", EarthAtm_Shader.earthatm_fs_wgsl);
        ShaderLib.register("LambertShader", Lambert_shader);
        ShaderLib.register("QuadGlsl_vs", QuadGlsl_vs);
        ShaderLib.register("QuadGlsl_fs", QuadGlsl_fs);
        ShaderLib.register("SkyGBuffer_fs", SkyGBuffer_pass);
        ShaderLib.register("gbuffer_vs", GBuffer_pass);
        ShaderLib.register("gbuffer_fs", GBuffer_pass);
        ShaderLib.register("castPointShadowMap_vert", castPointShadowMap_vert);
        ShaderLib.register("shadowCastMap_frag", shadowCastMap_frag);
        ShaderLib.register("shadowCastMap_vert", shadowCastMap_vert);
        ShaderLib.register("directionShadowCastMap_frag", directionShadowCastMap_frag);
        ShaderLib.register("ZPass_shader_vs", ZPassShader_vs);
      }
      /**
       * Monotonic revision of the registered chunk set. Anything caching data
       * derived from #include expansion (see Preprocessor's parse cache) must
       * invalidate when this changes, otherwise an HMR edit or a re-init with
       * different seed settings would keep serving stale expansions — the same
       * staleness class described in register() below.
       */
      static _revision = 0;
      static register(keyName, code) {
        let key = keyName.toLowerCase();
        if (ShaderLib[key] !== code) ShaderLib._revision++;
        ShaderLib[key] = code;
      }
      static getShader(keyName) {
        if (ShaderLib[keyName.toLowerCase()]) {
          return ShaderLib[keyName.toLowerCase()];
        }
        return ShaderLib[keyName.toLowerCase()];
      }
    }

    function isDigit(c) {
      return c >= "0" && c <= "9";
    }
    function isIdentStart(c) {
      return c >= "A" && c <= "Z" || c >= "a" && c <= "z" || c === "_";
    }
    function isIdentPart(c) {
      return isIdentStart(c) || isDigit(c);
    }
    function tokenize(src) {
      const tokens = [];
      const n = src.length;
      let i = 0;
      while (i < n) {
        const c = src[i];
        if (c === " " || c === "	" || c === "\n" || c === "\r") {
          i++;
          continue;
        }
        if (isDigit(c)) {
          let j = i + 1;
          while (j < n && isDigit(src[j])) j++;
          tokens.push({ k: "num", v: Number(src.substring(i, j)) });
          i = j;
          continue;
        }
        if (isIdentStart(c)) {
          let j = i + 1;
          while (j < n && isIdentPart(src[j])) j++;
          tokens.push({ k: "ident", v: src.substring(i, j) });
          i = j;
          continue;
        }
        if (c === '"') {
          let j = i + 1;
          while (j < n && src[j] !== '"') j++;
          if (j >= n) throw new Error(`unterminated string in expression: ${src}`);
          tokens.push({ k: "str", v: src.substring(i + 1, j) });
          i = j + 1;
          continue;
        }
        const two = src.substring(i, i + 2);
        if (two === "&&" || two === "||" || two === "==" || two === "!=" || two === "<=" || two === ">=") {
          tokens.push({ k: "op", v: two });
          i += 2;
          continue;
        }
        if (c === "!" || c === "<" || c === ">" || c === "(" || c === ")") {
          tokens.push({ k: "op", v: c });
          i++;
          continue;
        }
        throw new Error(`unexpected char '${c}' at ${i} in expression: ${src}`);
      }
      return tokens;
    }
    class Parser {
      constructor(tokens) {
        this.tokens = tokens;
      }
      pos = 0;
      peek() {
        return this.tokens[this.pos];
      }
      tryOp(v) {
        const t = this.tokens[this.pos];
        if (t && t.k === "op" && t.v === v) {
          this.pos++;
          return true;
        }
        return false;
      }
      expectOp(v) {
        if (!this.tryOp(v)) {
          const t = this.tokens[this.pos];
          throw new Error(`expected '${v}', got ${t ? JSON.stringify(t) : "EOF"}`);
        }
      }
      parseOr() {
        let l = this.parseAnd();
        while (this.tryOp("||")) {
          const r = this.parseAnd();
          l = { k: "binary", op: "||", l, r };
        }
        return l;
      }
      parseAnd() {
        let l = this.parseCmp();
        while (this.tryOp("&&")) {
          const r = this.parseCmp();
          l = { k: "binary", op: "&&", l, r };
        }
        return l;
      }
      parseCmp() {
        const l = this.parseUnary();
        const t = this.tokens[this.pos];
        if (t && t.k === "op" && (t.v === "==" || t.v === "!=" || t.v === "<" || t.v === "<=" || t.v === ">" || t.v === ">=")) {
          this.pos++;
          const r = this.parseUnary();
          return { k: "binary", op: t.v, l, r };
        }
        return l;
      }
      parseUnary() {
        if (this.tryOp("!")) return { k: "unary", op: "!", x: this.parseUnary() };
        return this.parsePrimary();
      }
      parsePrimary() {
        const t = this.tokens[this.pos];
        if (!t) throw new Error("unexpected end of expression");
        if (t.k === "num") {
          this.pos++;
          return { k: "lit", v: t.v };
        }
        if (t.k === "str") {
          this.pos++;
          return { k: "lit", v: t.v };
        }
        if (t.k === "ident") {
          this.pos++;
          if (t.v === "true") return { k: "lit", v: 1 };
          if (t.v === "false") return { k: "lit", v: 0 };
          if (t.v === "defined") {
            this.expectOp("(");
            const nameTok = this.tokens[this.pos];
            if (!nameTok || nameTok.k !== "ident")
              throw new Error(`defined() expects an identifier`);
            this.pos++;
            this.expectOp(")");
            return { k: "defined", v: nameTok.v };
          }
          return { k: "ident", v: t.v };
        }
        if (t.k === "op" && t.v === "(") {
          this.pos++;
          const e = this.parseOr();
          this.expectOp(")");
          return e;
        }
        throw new Error(`unexpected token: ${JSON.stringify(t)}`);
      }
    }
    function resolve(name, defines) {
      if (!(name in defines)) return 0;
      const v = defines[name];
      if (typeof v === "number") return v;
      if (typeof v === "boolean") return v ? 1 : 0;
      if (typeof v === "string") {
        if (v === "") return 0;
        const n = Number(v);
        if (!Number.isNaN(n)) return n;
        return v;
      }
      return 0;
    }
    function toBool(v) {
      if (typeof v === "number") return v !== 0;
      return v !== "" && v !== "0";
    }
    function evalNode(node, defines) {
      switch (node.k) {
        case "lit":
          return node.v;
        case "ident":
          return resolve(node.v, defines);
        case "defined":
          return node.v in defines ? 1 : 0;
        case "unary":
          if (node.op === "!") return toBool(evalNode(node.x, defines)) ? 0 : 1;
          throw new Error(`unknown unary op: ${node.op}`);
        case "binary": {
          if (node.op === "&&") {
            const l2 = evalNode(node.l, defines);
            if (!toBool(l2)) return 0;
            return toBool(evalNode(node.r, defines)) ? 1 : 0;
          }
          if (node.op === "||") {
            const l2 = evalNode(node.l, defines);
            if (toBool(l2)) return 1;
            return toBool(evalNode(node.r, defines)) ? 1 : 0;
          }
          const l = evalNode(node.l, defines);
          const r = evalNode(node.r, defines);
          switch (node.op) {
            case "==":
              if (typeof l === "string" || typeof r === "string")
                return String(l) === String(r) ? 1 : 0;
              return l === r ? 1 : 0;
            case "!=":
              if (typeof l === "string" || typeof r === "string")
                return String(l) !== String(r) ? 1 : 0;
              return l !== r ? 1 : 0;
            case "<":
              return Number(l) < Number(r) ? 1 : 0;
            case "<=":
              return Number(l) <= Number(r) ? 1 : 0;
            case ">":
              return Number(l) > Number(r) ? 1 : 0;
            case ">=":
              return Number(l) >= Number(r) ? 1 : 0;
          }
          throw new Error(`unknown binary op: ${node.op}`);
        }
      }
    }
    function evalCondition(expr, defines) {
      if (!expr || !expr.trim()) return false;
      const tokens = tokenize(expr);
      if (!tokens.length) return false;
      const parser = new Parser(tokens);
      const ast = parser.parseOr();
      if (parser.pos !== tokens.length)
        throw new Error(`unexpected trailing tokens in expression: ${expr}`);
      return toBool(evalNode(ast, defines));
    }
    function stringifyDefine(v) {
      if (v === void 0 || v === null) return "";
      if (typeof v === "string") return v;
      if (typeof v === "boolean") return v ? "1" : "0";
      if (typeof v === "number") return String(v);
      return String(v);
    }
    function expand(text, defines) {
      return text.replace(
        /defined\s*\(\s*[A-Za-z_]\w*\s*\)|\b[A-Za-z_]\w*\b/g,
        (match) => {
          if (match.startsWith("defined")) return match;
          if (match === "true" || match === "false" || match === "defined") return match;
          if (!(match in defines)) return match;
          return stringifyDefine(defines[match]);
        }
      );
    }

    class Preprocessor {
      // Parsing is a pure function of (source, defines, ShaderLib chunks), and
      // every RenderShaderPass instance parses its own copy of the source — a
      // scene with N materials sharing one shader would otherwise run the full
      // regex pipeline N times over identical input. Memoize the result; the
      // cache is dropped whenever ShaderLib._revision moves (HMR edit, engine
      // re-init with different seed settings) so #include expansion never goes
      // stale.
      static _parseCache = /* @__PURE__ */ new Map();
      static _parseCacheRevision = -1;
      static parse(code, defineValue) {
        return this.parseCached(`r`, code, defineValue, () => {
          let out = this.filterComment(code);
          out = this.parsePreprocess(new PreprocessorContext(), out, defineValue);
          out = this.parseAutoBindingForAllGroup(out);
          out = this.parseAutoLocationBlock(out);
          return out;
        });
      }
      static parseComputeShader(code, defineValue) {
        return this.parseCached(`c`, code, defineValue, () => {
          let out = this.filterComment(code);
          out = this.parsePreprocess(new PreprocessorContext(), out, defineValue);
          out = this.parseAutoBindingForAllGroup(out);
          return out;
        });
      }
      static parseCached(kind, code, defineValue, build) {
        if (this._parseCacheRevision !== ShaderLib._revision) {
          this._parseCache.clear();
          this._parseCacheRevision = ShaderLib._revision;
        }
        let key = kind + `\0` + code;
        for (let name of Object.keys(defineValue).sort()) {
          key += `\0` + name + `=` + defineValue[name];
        }
        let result = this._parseCache.get(key);
        if (result === void 0) {
          result = build();
          if (this._parseCache.size >= 512) this._parseCache.clear();
          this._parseCache.set(key, result);
        }
        return result;
      }
      static parsePreprocess(context, code, defineValue) {
        let begIndex = code.indexOf("#");
        if (begIndex == -1) {
          return code;
        }
        let header = code.substring(0, begIndex);
        let endIndex = code.indexOf("\n", code.lastIndexOf("#"));
        let codeBlock = code.substring(begIndex, endIndex);
        let tail = code.substring(endIndex);
        let body = this.parsePreprocessCommand(context, codeBlock, defineValue);
        return expand(header, defineValue) + body + expand(tail, defineValue);
      }
      static parseAutoBindingForAllGroup(code) {
        let offset = 0;
        let result = "";
        let group = /* @__PURE__ */ new Map();
        while (offset < code.length) {
          let nLeftIndex = code.indexOf("@group(", offset);
          if (nLeftIndex == -1) {
            result += code.substring(offset);
            break;
          }
          let nRightIndex = code.indexOf(")", nLeftIndex);
          let groupID = Number.parseInt(code.substring(nLeftIndex + 7, nRightIndex));
          nLeftIndex = code.indexOf("@binding(", nRightIndex);
          nRightIndex = code.indexOf(")", nLeftIndex);
          let bindingID = code.substring(nLeftIndex + 9, nRightIndex);
          result += code.substring(offset, nLeftIndex);
          if (bindingID.includes(`auto`)) {
            if (group.has(groupID)) {
              let lastBindingId = group.get(groupID) + 1;
              result += `@binding(${lastBindingId})`;
              group.set(groupID, lastBindingId);
            } else {
              result += "@binding(0)";
              group.set(groupID, 0);
            }
          } else {
            let nBindingID = Number.parseInt(bindingID);
            if (!group.has(groupID) || group.get(groupID) < nBindingID) {
              group.set(groupID, nBindingID);
            }
            result += `@binding(${bindingID})`;
          }
          offset = nRightIndex + 1;
        }
        return result;
      }
      static parseAutoBindingForGroupX(code, nGroup) {
        let offset = 0;
        let result = "";
        let group = /* @__PURE__ */ new Map();
        while (offset < code.length) {
          let nLeftIndex = code.indexOf("@group(", offset);
          if (nLeftIndex == -1) {
            result += code.substring(offset);
            break;
          }
          let nRightIndex = code.indexOf(")", nLeftIndex);
          let groupID = Number.parseInt(code.substring(nLeftIndex + 7, nRightIndex));
          nLeftIndex = code.indexOf("@binding(", nRightIndex);
          nRightIndex = code.indexOf(")", nLeftIndex);
          result += code.substring(offset, nLeftIndex);
          if (groupID == nGroup) {
            if (group.has(groupID)) {
              let lastBindingId = group.get(groupID) + 1;
              result += `@binding(${lastBindingId})`;
              group.set(groupID, lastBindingId);
            } else {
              result += "@binding(0)";
              group.set(groupID, 0);
            }
          } else {
            result += code.substring(nLeftIndex, nRightIndex + 1);
          }
          offset = nRightIndex + 1;
        }
        return result;
      }
      static parseAutoLocation(code) {
        let offset = 0;
        let result = "";
        let lastBindingId = 0;
        while (offset < code.length) {
          let nLeftIndex = code.indexOf("@location(", offset);
          if (nLeftIndex == -1) {
            result += code.substring(offset);
            break;
          }
          let nRightIndex = code.indexOf(")", nLeftIndex);
          let id = code.substring(nLeftIndex + 10, nRightIndex);
          result += code.substring(offset, nLeftIndex);
          if (id === "auto") {
            result += `@location(${lastBindingId})`;
            lastBindingId++;
          } else {
            result += code.substring(nLeftIndex, nRightIndex + 1);
          }
          offset = nRightIndex + 1;
        }
        return result;
      }
      static parseAutoLocationBlock(code) {
        let offset = 0;
        let result = "";
        while (offset < code.length) {
          let nLeftIndex = code.indexOf("@location(", offset);
          if (nLeftIndex == -1) {
            result += code.substring(offset);
            break;
          }
          let nRightIndex = code.indexOf("}", nLeftIndex);
          let nRightIndex2 = code.indexOf("->", nLeftIndex);
          if (nRightIndex2 != -1 && nRightIndex2 < nRightIndex) {
            nRightIndex = nRightIndex2;
          }
          let block = code.substring(nLeftIndex, nRightIndex + 1);
          block = this.parseAutoLocation(block);
          result += code.substring(offset, nLeftIndex);
          result += block;
          offset = nRightIndex + 1;
        }
        return result;
      }
      static parsePreprocessCommand(context, code, defineValue) {
        let result = "";
        let lines = code.split("\n");
        let stack = [false];
        let stackElseif = [false];
        for (let i = 0; i < lines.length; i++) {
          let line = lines[i];
          let skip = stack[stack.length - 1];
          if (line.trim().indexOf("#") != 0) {
            if (!skip) {
              result += expand(line, defineValue) + "\n";
            }
            continue;
          }
          let command = line.trim();
          if (command.indexOf("#if") != -1) {
            if (skip && stack.length > 1) {
              stack.push(skip);
              continue;
            }
            let condition = command.substring(3).trim();
            skip = !this.parseCondition(condition, defineValue);
            stack.push(skip);
            stackElseif.push(!skip);
            continue;
          } else if (command.indexOf("#elseif") != -1 || command.indexOf("#else") != -1 && command.indexOf(" if") != -1) {
            let skipElseif = stackElseif[stackElseif.length - 1];
            if (skipElseif) {
              stack.pop();
              skip = true;
              stack.push(skip);
              continue;
            }
            stack.pop();
            skip = stack[stack.length - 1];
            if (skip && stack.length > 1) {
              stack.push(skip);
              continue;
            }
            let condition = command.substring(command.indexOf("if") + 2).trim();
            if (condition == "") {
              console.error(`preprocess command error, conditions missing: ${command}`);
            }
            skip = !this.parseCondition(condition, defineValue);
            stack.push(skip);
            stackElseif.push(!skip);
            continue;
          } else if (command.indexOf("#else") != -1) {
            stack.pop();
            if (skip && (stack.length > 1 && stack[stack.length - 1])) {
              stack.push(skip);
            } else {
              stack.push(!skip);
            }
            continue;
          } else if (command.indexOf("#endif") != -1) {
            stack.pop();
            stackElseif.pop();
            continue;
          } else if (command.indexOf("#include") != -1) {
            let includeName = "";
            let char = command.charAt(command.length - 1);
            if (char == `>`) {
              includeName = this.extract(command, "<", ">");
            } else {
              includeName = this.extract(command, char, char);
            }
            if (!context.includeMap.has(includeName)) {
              context.includeMap.set(includeName, true);
              let code2 = ShaderLib.getShader(includeName);
              if (!code2) {
                throw `${command} error: '${includeName}' not found`;
              }
              code2 = this.filterComment(code2);
              code2 = this.parsePreprocess(context, code2, defineValue);
              result += code2 + "\r\n";
            }
            continue;
          } else if (command.indexOf("#define ") != -1) {
            let expression = command.substring(command.indexOf("#define ") + 8).trim();
            let index = expression.indexOf(" ");
            let name = expression;
            let value = "";
            if (index != -1) {
              name = expression.substring(0, index).trim();
              value = expression.substring(index + 1).trim();
            }
            defineValue[name] = value;
            continue;
          } else throw "nonsupport: " + command;
        }
        return result;
      }
      static parseCondition(condition, defineValue) {
        try {
          return evalCondition(expand(condition, defineValue), defineValue);
        } catch (e) {
          console.error(`preprocess condition parse error: '${condition}'`, e);
          return false;
        }
      }
      static filterComment(code) {
        let result = "";
        let findSingleComment = true;
        let findMultiComment = true;
        for (let offset = 0; offset < code.length; ) {
          let index1 = findSingleComment ? code.indexOf("//", offset) : -1;
          let index2 = findMultiComment ? code.indexOf("/*", offset) : -1;
          if (index1 == -1 && index2 == -1) {
            result += code.substring(offset);
            break;
          }
          findSingleComment = index1 != -1;
          findMultiComment = index2 != -1;
          if (index1 != -1 && index2 != -1) {
            if (index1 < index2) {
              index2 = -1;
            } else {
              index1 = -1;
            }
          }
          if (index1 != -1) {
            index2 = code.indexOf("\n", index1);
            result += code.substring(offset, index1);
            offset = index2 != -1 ? index2 : code.length;
          } else if (index2 != -1) {
            index1 = code.indexOf("*/", index2);
            result += code.substring(offset, index2);
            offset = index1 + 2;
          }
        }
        return result;
      }
      static extract(str, leftStr, rightStr) {
        let indexL = str.indexOf(leftStr) + leftStr.length;
        let indexR = str.indexOf(rightStr, indexL);
        return str.substring(indexL, indexR).trim();
      }
    }
    class PreprocessorContext {
      includeMap = /* @__PURE__ */ new Map();
      constructor() {
      }
    }

    class ShaderReflection {
      static _shaderReflectionMap = /* @__PURE__ */ new Map();
      attributes = [];
      vs_variables = [];
      fs_variables = [];
      cs_variables = [];
      groups = [];
      variables = {};
      useSplit = false;
      /**
       *
       * @param wgsl
       * @param shaderReflection
       */
      static parser(wgsl, shaderValue) {
        if (!shaderValue.shaderReflection) shaderValue.shaderReflection = new ShaderReflection();
        if (wgsl.indexOf(`@vertex`) != -1) {
          shaderValue.shaderReflection.attributes = this.parserVertexOld(wgsl);
          shaderValue.shaderReflection.vs_variables = this.parserVariables(wgsl);
        } else if (wgsl.indexOf(`@fragment`) != -1) {
          shaderValue.shaderReflection.fs_variables = this.parserVariables(wgsl);
        } else if (wgsl.indexOf(`@compute`) != -1) {
          shaderValue.shaderReflection.cs_variables = this.parserVariables(wgsl);
        }
      }
      static parser2(wgsl, shaderBase) {
        if (!shaderBase.shaderReflection) shaderBase.shaderReflection = new ShaderReflection();
        let shaderReflection = shaderBase.shaderReflection;
        if (wgsl.indexOf(`@vertex`) != -1) {
          shaderReflection.attributes = this.parserVertex(shaderBase.vsEntryPoint, wgsl);
          shaderReflection.vs_variables = this.parserVariables(wgsl);
        } else if (wgsl.indexOf(`@fragment`) != -1) {
          shaderReflection.fs_variables = this.parserVariables(wgsl);
        } else if (wgsl.indexOf(`@compute`) != -1) {
          shaderReflection.cs_variables = this.parserVariables(wgsl);
        }
        if (wgsl.indexOf("splitTexture") != -1) {
          shaderReflection.useSplit = true;
        }
      }
      static combineShaderReflectionVarInfo(shaderReflection, shader_variables) {
        for (const iterator of shader_variables) {
          if (!shaderReflection.groups[iterator.group]) {
            shaderReflection.groups[iterator.group] = [];
          }
          let combineInfo = iterator;
          if (shaderReflection.groups[iterator.group][iterator.binding]) {
            let aInfo = shaderReflection.groups[iterator.group][iterator.binding];
            let bInfo = iterator;
            if (aInfo.dataFields) {
              for (let i = 0; i < aInfo.dataFields.length; i++) {
                aInfo.dataFields[i];
              }
            }
            if (bInfo.dataFields) {
              for (let i = 0; i < bInfo.dataFields.length; i++) {
                bInfo.dataFields[i];
              }
            }
          }
          shaderReflection.groups[iterator.group][iterator.binding] = combineInfo;
          shaderReflection.variables[iterator.varName] = combineInfo;
        }
      }
      static final(shaderBase) {
        let shaderReflection = shaderBase.shaderReflection;
        this._shaderReflectionMap.set(shaderBase.shaderVariant, shaderReflection);
        this.combineShaderReflectionVarInfo(shaderReflection, shaderReflection.vs_variables);
        this.combineShaderReflectionVarInfo(shaderReflection, shaderReflection.fs_variables);
      }
      static getShaderReflection2(code, shaderBase) {
        let preShader = Preprocessor.parse(code, shaderBase.defineValue);
        ShaderReflection.parser2(preShader, shaderBase);
      }
      /**
       * 
       * @param shaderVariant shader variant name 
       * @returns 
       */
      static poolGetReflection(shaderVariant) {
        let ref = this._shaderReflectionMap.get(shaderVariant);
        return ref;
      }
      static genShaderVar(shaderValue) {
        let shaderVariant = `${shaderValue.vs}${shaderValue.fs}${shaderValue.compute}`;
        shaderVariant += "|";
        for (const key in shaderValue.uniforms) {
          shaderVariant += key + ":";
        }
        shaderVariant += "|";
        for (const key in shaderValue.constValues) {
          shaderVariant += key + ":";
          shaderVariant += shaderValue.constValues[key];
        }
        shaderVariant += "|";
        for (const key in shaderValue.defines) {
          shaderVariant += key + ":";
          shaderVariant += shaderValue.defines[key];
        }
        shaderVariant += "|";
        for (const key in shaderValue.shaderState) {
          shaderVariant += key + ":";
          shaderVariant += shaderValue.shaderState[key] + ";";
        }
        return shaderVariant;
      }
      static genShaderVariant(shader) {
        let shaderVariant = "";
        for (const key in shader.uniforms) {
          shaderVariant += key + ":";
        }
        shaderVariant += "|";
        for (const key in shader.constValues) {
          shaderVariant += key + ":";
          shaderVariant += shader.constValues[key];
        }
        shaderVariant += "|";
        for (const key in shader.defineValue) {
          shaderVariant += key + ":";
          shaderVariant += shader.defineValue[key];
        }
        return shaderVariant;
      }
      static genRenderShaderVariant(renderShader) {
        let shaderVariant = `RenderShader(${renderShader.vsName},${renderShader.fsName})`;
        shaderVariant += "|";
        shaderVariant += this.genShaderVariant(renderShader);
        shaderVariant += "|";
        for (const key in renderShader.shaderState) {
          const v = renderShader.shaderState[key];
          shaderVariant += key + ":";
          shaderVariant += v !== null && typeof v === "object" ? JSON.stringify(v) : v;
          shaderVariant += ";";
        }
        return shaderVariant;
      }
      static genComputeShaderVariant(computeShader) {
        let shaderVariant = `ComputeShader(${computeShader.instanceID})`;
        shaderVariant += "|";
        shaderVariant += this.genShaderVariant(computeShader);
        return shaderVariant;
      }
      combine(shaderValue) {
        let shaderReflection = shaderValue.shaderReflection;
        let defines = shaderValue.defines;
        let tmp = {};
        for (let i = 0; i < this.attributes.length; i++) {
          let att = this.attributes[i];
          if (defines[att.name]) tmp[att.name] = att;
        }
        let len = shaderReflection.attributes.length;
        for (let j = 0; j < len; j++) {
          const newAtt = shaderReflection.attributes[j];
          if (!tmp[newAtt.name]) {
            this.attributes.push(newAtt);
          } else {
            let oldAtt = tmp[newAtt.name];
            if (oldAtt.location == newAtt.location && oldAtt.name != newAtt.name) {
              console.warn("location must same!");
            }
          }
        }
      }
      static parserVariables(wgsl) {
        let position = 0;
        let variables = [];
        while (position < wgsl.length) {
          let nLeftIndex = wgsl.indexOf("@group(", position);
          if (nLeftIndex < 0) break;
          let nRightIndex = wgsl.indexOf(";", nLeftIndex);
          position = nRightIndex;
          let item = wgsl.substring(nLeftIndex, nRightIndex);
          let group = this.extract(item, "@group(", ")");
          let binding = this.extract(item, "@binding(", ")");
          let varName = "";
          let varType = "var";
          if (item.indexOf("var<") != -1) {
            varName = this.extract(item, ">", ":");
            varType = this.extract(item, "var<", ">").replace(",", "-").replaceAll(" ", "");
          } else {
            varName = this.extract(item, "var", ":");
          }
          let dataType = item.substring(item.lastIndexOf(":") + 1).trim();
          let info = {
            group: 0,
            binding: 0,
            varType: "",
            varName: "",
            dataType: "",
            dataIsBuiltinType: true,
            dataFields: null
          };
          info.group = Number.parseInt(group);
          info.binding = Number.parseInt(binding);
          info.varType = varType;
          info.varName = varName;
          info.dataType = dataType;
          info.dataIsBuiltinType = this.isBuiltinTypes(info.dataType);
          if (!info.dataIsBuiltinType) {
            info.dataFields = this.parserStructFields(wgsl, info.dataType);
          }
          variables.push(info);
        }
        return variables;
      }
      static extract(str, leftStr, rightStr) {
        let indexL = str.indexOf(leftStr) + leftStr.length;
        let indexR = str.indexOf(rightStr, indexL);
        return str.substring(indexL, indexR).trim();
      }
      static isBuiltinTypes(dataType) {
        switch (dataType) {
          case "i32":
            return true;
          case "u32":
            return true;
          case "f32":
            return true;
          default:
            let index = dataType.indexOf("<");
            if (index != -1) {
              let type = dataType.substring(0, index);
              switch (type) {
                case "vec2":
                  return true;
                case "vec3":
                  return true;
                case "vec4":
                  return true;
                case "mat3":
                  return true;
                case "mat4":
                  return true;
                case "array":
                  return this.isBuiltinTypes(dataType.substring(index + 1, dataType.lastIndexOf(">")));
              }
            }
            break;
        }
        return false;
      }
      static parserStructFields(wgsl, structName) {
        let result = [];
        let position = 0;
        while (position < wgsl.length) {
          let nLeftIndex = wgsl.indexOf("struct ", position);
          if (nLeftIndex < 0) break;
          let nRightIndex = wgsl.indexOf("{", nLeftIndex);
          position = nRightIndex;
          let name = wgsl.substring(nLeftIndex + 6, nRightIndex).trim();
          if (name === structName) {
            nLeftIndex = wgsl.indexOf("{", nLeftIndex);
            nRightIndex = wgsl.indexOf("}", nLeftIndex);
            let items = wgsl.substring(nLeftIndex + 1, nRightIndex);
            let fields = items.split(",");
            for (let field of fields) {
              let index = field.indexOf(":");
              if (index != -1) {
                let obj = {
                  name: field.substring(0, index).trim(),
                  type: field.substring(index + 1).trim()
                };
                result.push(obj);
              }
            }
            break;
          }
        }
        return result;
      }
      static parserVertexOld(wgsl) {
        let attributes = [];
        let list = wgsl.split(`fn main(`);
        let block = list[1].split("->")[0];
        let blockList = block.split("@");
        if (blockList && blockList.length > 1) {
          for (let i = 1; i < blockList.length; i++) {
            const element = blockList[i];
            let code2 = element.replace(/\s*$/g, "");
            code2 = code2.replaceAll(",", "");
            code2 = code2.replaceAll("\n", "");
            code2 = code2.replaceAll("  ", " ");
            this.parserAttribute(code2, attributes);
          }
        } else {
          let code1 = block.split(":");
          var code = code1[1];
          code = code.replaceAll("  ", "");
          code = code.replaceAll(" ", "");
          code = code.replaceAll(")", "");
          code = wgsl.split(`struct ${code}`)[1];
          let start = code.indexOf("{");
          let end = code.indexOf("}");
          code = code.slice(start, end);
          blockList = code.split("@");
          for (let i = 1; i < blockList.length; i++) {
            const element = blockList[i];
            let code2 = element.replace(/\s*$/g, "");
            code2 = code2.replaceAll("\n", "");
            code2 = code2.split(",")[0];
            code2 = code2.replaceAll("  ", " ");
            this.parserAttribute(code2, attributes);
          }
        }
        return attributes;
      }
      static parserVertex(entryPoint, wgsl) {
        let attributes = [];
        let list = wgsl.split(`fn ${entryPoint}(`);
        let block = list[1].split("->")[0];
        let blockList = block.split("@");
        if (blockList && blockList.length > 1) {
          for (let i = 1; i < blockList.length; i++) {
            const element = blockList[i];
            let code2 = element.replace(/\s*$/g, "");
            code2 = code2.replaceAll(",", "");
            code2 = code2.replaceAll("\n", "");
            code2 = code2.replaceAll("  ", " ");
            this.parserAttribute(code2, attributes);
          }
        } else {
          let code1 = block.split(":");
          var code = code1[1];
          code = code.replaceAll("  ", "");
          code = code.replaceAll(" ", "");
          code = code.replaceAll(")", "");
          code = wgsl.split(`struct ${code}`)[1];
          let start = code.indexOf("{");
          let end = code.indexOf("}");
          code = code.slice(start, end);
          blockList = code.split("@");
          for (let i = 1; i < blockList.length; i++) {
            const element = blockList[i];
            let code2 = element.replace(/\s*$/g, "");
            code2 = code2.replaceAll("\n", "");
            code2 = code2.split(",")[0];
            code2 = code2.replaceAll("  ", " ");
            this.parserAttribute(code2, attributes);
          }
        }
        return attributes;
      }
      /**
       * builtin(instance_index) index : u32
       * location(0) Vertex_Position : vec3<f32>
       * @param line
       * @param attributes
       */
      static parserAttribute(line, attributes) {
        let obj = {
          name: "",
          group: 0,
          location: 0,
          type: "",
          valueType: "",
          value: 0,
          size: 0,
          format: `float32`
        };
        if (line.indexOf("builtin") != -1) {
          obj.type = "builtin";
          var tmp = line.match(/\((.+?)\)/g)[0];
          tmp = line.match(/\((.+?)\)/g)[0];
          tmp = tmp.replace("(", "");
          tmp = tmp.replaceAll(")", "");
          obj.location = parseInt(tmp);
          let cc = line.split(":");
          obj.name = cc[0].split(" ")[1];
          obj.name = obj.name.replaceAll("  ", " ");
          obj.name = obj.name.replaceAll(" ", "");
          obj.valueType = cc[1];
          obj.valueType = obj.valueType.replaceAll("  ", " ");
          obj.valueType = obj.valueType.replaceAll(" ", "");
          obj.valueType = obj.valueType.replaceAll("\r", "");
          obj.valueType = obj.valueType.replaceAll(")", "");
          obj.valueType = obj.valueType.replaceAll(")", "");
          obj.size = VertexAttributeSize[obj.valueType];
          attributes.push(obj);
        } else if (line.indexOf("location") != -1) {
          obj.type = "location";
          var tmp = line.match(/\((.+?)\)/g)[0];
          tmp = line.match(/\((.+?)\)/g)[0];
          tmp = tmp.replace("(", "");
          tmp = tmp.replaceAll(")", "");
          obj.location = parseInt(tmp);
          let cc = line.split(":");
          obj.name = cc[0].split(" ")[1];
          obj.name = obj.name.replaceAll("  ", " ");
          obj.name = obj.name.replaceAll(" ", "");
          obj.valueType = cc[1];
          obj.valueType = obj.valueType.replaceAll("  ", " ");
          obj.valueType = obj.valueType.replaceAll(" ", "");
          obj.valueType = obj.valueType.replaceAll("\r", "");
          obj.valueType = obj.valueType.replaceAll(")", "");
          obj.valueType = obj.valueType.replaceAll(")", "");
          obj.size = VertexAttributeSize[obj.valueType];
          attributes.push(obj);
        }
        obj.format = VertexFormat[VertexAttributeSize[obj.valueType]];
      }
    }

    class ComputeShader extends ShaderPassBase {
      /**
       * Compute shader entry point name
       */
      entryPoint = `CsMain`;
      /**
       * Compute shader x worker number
       */
      workerSizeX = 1;
      /**
       * Compute shader y worker number
       */
      workerSizeY = 0;
      /**
       * Compute shader z worker number
       */
      workerSizeZ = 0;
      // Plan B: single compute pipeline bound to one Context3D.
      _computePipeline = null;
      _csShaderModule;
      _destCS;
      _sourceCS;
      _storageTextureDic;
      _sampleTextureDic;
      _groupsShaderReflectionVarInfos;
      _groupCache = {};
      /**
       *
       * @param computeShader wgsl compute shader
       */
      constructor(computeShader) {
        super();
        this._sourceCS = computeShader;
        ShaderReflection.getShaderReflection2(computeShader, this);
        this._storageTextureDic = /* @__PURE__ */ new Map();
        this._sampleTextureDic = /* @__PURE__ */ new Map();
      }
      /**
       * set write or read storage texture , use textureLod
       * @param name
       * @param texture
       */
      setStorageTexture(name, texture) {
        this._storageTextureDic.set(name, texture);
      }
      /**
       * set samplerTexture , use textureSample or other sample texture api
       * @param name
       * @param texture
       */
      setSamplerTexture(name, texture) {
        this._sampleTextureDic.set(name, texture);
      }
      /**
       * Record the compute shader distribution command
       * @param computePass Compute pass encoder
       */
      compute(computePass) {
        if (!this._boundCtx) {
          for (const buf of this._bufferDic.values()) {
            if (buf._boundCtx) {
              bindCtx(this, buf._boundCtx);
              break;
            }
          }
          if (!this._boundCtx) {
            for (const tex of this._storageTextureDic.values()) {
              if (tex._boundCtx) {
                bindCtx(this, tex._boundCtx);
                break;
              }
            }
          }
          if (!this._boundCtx) {
            for (const tex of this._sampleTextureDic.values()) {
              if (tex._boundCtx) {
                bindCtx(this, tex._boundCtx);
                break;
              }
            }
          }
          if (!this._boundCtx) bindCtx(this, Engine3D._defaultContext());
        }
        if (this._boundCtx) this._propagateCtx(this._boundCtx);
        if (!this._computePipeline) {
          this.genComputePipeline();
        }
        for (let i = 0; i < this._groupsShaderReflectionVarInfos.length; ++i) {
          if (!this.bindGroups[i] && this._groupsShaderReflectionVarInfos[i]) {
            this.genGroups(i, this._groupsShaderReflectionVarInfos, true);
          }
        }
        computePass.setPipeline(this._computePipeline);
        for (let i = 0; i < this.bindGroups.length; ++i) {
          computePass.setBindGroup(i, this.bindGroups[i]);
        }
        if (this.workerSizeX && this.workerSizeY && this.workerSizeZ) {
          computePass.dispatchWorkgroups(this.workerSizeX, this.workerSizeY, this.workerSizeZ);
        } else if (this.workerSizeX && this.workerSizeY) {
          computePass.dispatchWorkgroups(this.workerSizeX, this.workerSizeY);
        } else {
          computePass.dispatchWorkgroups(this.workerSizeX);
        }
      }
      /**
       * Bind all attached buffers/textures to the ComputeShader's Context3D so
       * their `.buffer` / `.gpuTexture` getters materialize on the correct device.
       */
      _propagateCtx(ctx) {
        for (const buf of this._bufferDic.values()) {
          if (!buf._boundCtx) bindCtx(buf, ctx);
        }
        for (const tex of this._storageTextureDic.values()) {
          if (!tex._boundCtx) bindCtx(tex, ctx);
        }
        for (const tex of this._sampleTextureDic.values()) {
          if (!tex._boundCtx) bindCtx(tex, ctx);
        }
      }
      createBufferBindGroup(groupIndex, varName, binding, entries) {
        let buffer = this._bufferDic.get(varName);
        if (buffer) {
          let entry = {
            binding,
            resource: {
              buffer: buffer.buffer,
              offset: 0,
              //buffer.memory.shareFloat32Array.byteOffset,
              size: buffer.memory.shareDataBuffer.byteLength
            }
          };
          entries.push(entry);
        } else {
          console.error(`ComputeShader(${this.instanceID})`, `buffer ${varName} is missing!`);
        }
      }
      noticeBufferChange(name) {
        let bindGroupCache = this._groupCache[name];
        if (bindGroupCache) {
          this.genGroups(bindGroupCache.groupIndex, bindGroupCache.infos, true);
        }
      }
      genGroups(groupIndex, infos, force = false) {
        if (!this.bindGroups[groupIndex] || force) {
          const shaderRefs = infos[groupIndex];
          let entries = [];
          for (let j = 0; j < shaderRefs.length; ++j) {
            const refs = shaderRefs[j];
            if (!refs) continue;
            switch (refs.varType) {
              case `uniform`:
              case `storage-read`:
              case `storage-read_write`:
                {
                  this.createBufferBindGroup(groupIndex, refs.varName, refs.binding, entries);
                  this._groupCache[refs.varName] = { groupIndex, infos };
                }
                break;
              case `var`:
                {
                  if (refs.dataType == `sampler`) {
                    let textureName = refs.varName.replace(`Sampler`, ``);
                    let texture = this._sampleTextureDic.get(textureName);
                    if (texture) {
                      let entry = {
                        binding: refs.binding,
                        resource: texture.gpuSampler
                      };
                      entries.push(entry);
                    } else {
                      console.error(`ComputeShader(${this.instanceID})`, `texture ${refs.varName} is missing! `);
                    }
                  } else if (refs.dataType == `sampler_comparison`) {
                    let textureName = refs.varName.replace(`Sampler`, ``);
                    let texture = this._sampleTextureDic.get(textureName);
                    if (texture) {
                      let entry = {
                        binding: refs.binding,
                        resource: texture.gpuSampler_comparison
                      };
                      entries.push(entry);
                    } else {
                      console.error(`ComputeShader(${this.instanceID})`, `texture ${refs.varName} is missing! `);
                    }
                  } else if (refs.dataType.indexOf("texture_storage") != -1) {
                    let texture = this._storageTextureDic.get(refs.varName);
                    if (texture) {
                      let entry = {
                        binding: refs.binding,
                        resource: texture.getGPUView()
                      };
                      entries.push(entry);
                      Reference.getInstance().attached(texture, this);
                    } else {
                      console.error(`ComputeShader(${this.instanceID})`, `texture ${refs.varName} is missing! `);
                    }
                  } else if (refs.dataType.indexOf("texture") != -1) {
                    let texture = this._sampleTextureDic.get(refs.varName);
                    if (texture) {
                      let entry = {
                        binding: refs.binding,
                        resource: texture.getGPUView()
                      };
                      entries.push(entry);
                      Reference.getInstance().attached(texture, this);
                    } else {
                      console.error(`ComputeShader(${this.instanceID})`, `texture ${refs.varName} is missing! `);
                    }
                  }
                }
                break;
              default:
                console.error(`unprocessed type:`, refs.varType);
                break;
            }
          }
          const device = this._boundCtx.device;
          let gpubindGroup = device.createBindGroup({
            layout: this._computePipeline.getBindGroupLayout(groupIndex),
            entries
          });
          this.bindGroups[groupIndex] = gpubindGroup;
        }
      }
      genComputePipeline() {
        this.preCompileShader(this._sourceCS);
        this.genReflection();
        const device = this._boundCtx.device;
        this._computePipeline = device.createComputePipeline({
          layout: `auto`,
          compute: {
            module: this.compileShader(),
            entryPoint: this.entryPoint
          }
        });
        this._groupsShaderReflectionVarInfos = [];
        let shaderReflection = this.shaderReflection;
        this.bindGroups = [];
        for (let i = 0; i < shaderReflection.groups.length; ++i) {
          let srvs = shaderReflection.groups[i];
          this._groupsShaderReflectionVarInfos[i] = srvs;
          this.genGroups(i, this._groupsShaderReflectionVarInfos);
        }
        this._boundCtx.addEventListener(CResizeEvent.RESIZE, (e) => {
          for (let i = 0; i < shaderReflection.groups.length; ++i) {
            let srvs = shaderReflection.groups[i];
            this._groupsShaderReflectionVarInfos[i] = srvs;
            this.genGroups(i, this._groupsShaderReflectionVarInfos, true);
          }
        }, this);
      }
      preCompileShader(shader) {
        for (const key in this.constValues) {
          if (Object.prototype.hasOwnProperty.call(this.constValues, key)) {
            const value = this.constValues[key];
            shader = shader.replaceAll(`&${key}`, value.toString());
          }
        }
        this._destCS = Preprocessor.parseComputeShader(shader, this.defineValue);
      }
      compileShader() {
        const device = this._boundCtx.device;
        let shaderModule = device.createShaderModule({
          label: `ComputeShader(${this.instanceID})`,
          code: this._destCS
        });
        shaderModule.getCompilationInfo().then((e) => {
          if (e.messages.length > 0) {
            console.warn("[shader error]", e, this._destCS);
          }
        });
        this._csShaderModule = shaderModule;
        return shaderModule;
      }
      genReflection() {
        this.shaderVariant += ShaderReflection.genComputeShaderVariant(this);
        let reflection = ShaderReflection.poolGetReflection(this.shaderVariant);
        if (!reflection) {
          ShaderReflection.getShaderReflection2(this._destCS, this);
          ShaderReflection.combineShaderReflectionVarInfo(this.shaderReflection, this.shaderReflection.cs_variables);
        } else {
          this.shaderReflection = reflection;
        }
      }
    }

    class MorphAttrDataGroup {
      source;
      input;
      output;
      reset(value) {
        this.input && this.input.destroy();
        this.output && this.output.destroy();
        this.input = this.output = null;
        this.source = value;
      }
      apply(vertexCount) {
        if (this.source) {
          if (!this.input) {
            let usage = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST;
            this.input = new StorageGPUBuffer(this.source.length, usage, this.source);
            this.input.apply();
          }
          if (!this.output) {
            let usage = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC;
            this.output = new StorageGPUBuffer(vertexCount * 3, usage);
            this.output.apply();
          }
        }
      }
    }
    class MorphTargetData {
      /** Whether morph-target processing is active. */
      enable;
      /** When true, target deltas are applied relatively (added on top of the base). */
      morphTargetsRelative;
      /** Maximum number of morph targets supported per geometry. */
      MaxMorphTargetCount = 64;
      _computeConfigArray;
      _computeConfigBuffer;
      _morphInfluenceArray;
      _morphInfluenceBuffer;
      _positionAttrDataGroup;
      _normalAttrDataGroup;
      _isInfluenceDirty;
      _morphTargetCount;
      _totalVertexCount;
      _computeShader;
      _computeShaders;
      _computeWorkGroupXY = 1;
      _collectMorphTargetData;
      _blendTarget;
      constructor() {
        this._isInfluenceDirty = true;
        this.generateGPUBuffer();
        this._positionAttrDataGroup = new MorphAttrDataGroup();
        this._normalAttrDataGroup = new MorphAttrDataGroup();
      }
      /** Collect a geometry's morph targets and build the compute shader + buffers. */
      initMorphTarget(geometry) {
        this._collectMorphTargetData = this.collectMorphTargetList(geometry);
        this._computeShader && this._computeShader.destroy();
        let code = MorphTarget_shader.CsMain;
        this._computeShader = new ComputeShader(code);
        if (this._collectMorphTargetData.mergedNormal) {
          this._computeShader.setDefine("USE_MORPHNORMALS", true);
        } else {
          this._computeShader.deleteDefine("USE_MORPHNORMALS");
        }
        this._computeShaders = [this._computeShader];
        this._isInfluenceDirty = true;
        this._morphTargetCount = this._collectMorphTargetData.mtCount;
        this._totalVertexCount = this._collectMorphTargetData.vCount;
        this._morphInfluenceArray.fill(0);
        this._computeWorkGroupXY = this.calcWorkGroup(this._totalVertexCount);
        this._positionAttrDataGroup.reset(this._collectMorphTargetData.mergedPos);
        this._normalAttrDataGroup.reset(this._collectMorphTargetData.mergedNormal);
      }
      /** Bind the morph-target config and output buffers onto a render shader pass. */
      applyRenderShader(renderShader) {
        this.uploadMorphTargetBuffer();
        this.uploadConfigGBuffer();
        renderShader.setUniformBuffer("morphTargetConfig", this._computeConfigBuffer);
        renderShader.setStorageBuffer("morphTargetOpPositions", this._positionAttrDataGroup.output);
        if (this._collectMorphTargetData.mergedNormal) {
          renderShader.setStorageBuffer("morphTargetOpNormals", this._normalAttrDataGroup.output);
        }
      }
      /** Dispatch the compute shader that accumulates weighted morph deltas. */
      computeMorphTarget(view, command) {
        this.uploadConfigGBuffer();
        this.uploadMorphTargetBuffer();
        this._computeShader.setUniformBuffer("morphTargetConfig", this._computeConfigBuffer);
        this._computeShader.setStorageBuffer("morphTargetInfluence", this._morphInfluenceBuffer);
        this._computeShader.setStorageBuffer("morphTargetPositions", this._positionAttrDataGroup.input);
        this._computeShader.setStorageBuffer("morphTargetOpPositions", this._positionAttrDataGroup.output);
        if (this._collectMorphTargetData.mergedNormal) {
          this._computeShader.setStorageBuffer("morphTargetNormals", this._normalAttrDataGroup.input);
          this._computeShader.setStorageBuffer("morphTargetOpNormals", this._normalAttrDataGroup.output);
        }
        this._computeShader.workerSizeX = this._computeWorkGroupXY;
        this._computeShader.workerSizeY = this._computeWorkGroupXY;
        this._computeShader.workerSizeZ = 1;
        view.engine3D.context3D.gpuContext.computeCommand(command, this._computeShaders);
      }
      /** Set the influence weight of the morph target at `index`. */
      updateInfluence(index, value) {
        this._isInfluenceDirty = true;
        this._morphInfluenceArray[index] = value;
      }
      /** Map of blend-shape name to its influence-setter function. */
      get blendShape() {
        return this._blendTarget;
      }
      collectMorphTargetList(geometry) {
        let posAttrList = this.collectAttribute("a_morphPositions_", geometry);
        let morphTargetCount = posAttrList.length;
        let vertexCount = posAttrList[0].data.length / 3;
        this._blendTarget = {};
        if (geometry.blendShapeData) {
          for (let i = 0; i < geometry.blendShapeData.shapeIndexs.length; i++) {
            let index = geometry.blendShapeData.shapeIndexs[i];
            let shapeNames = geometry.blendShapeData.shapeNames[i].split(".");
            let shapeName = shapeNames[shapeNames.length - 1];
            this._blendTarget[shapeName] = (value) => this.updateInfluence(index, value);
          }
        }
        let posArray = new Float32Array(vertexCount * morphTargetCount * 3);
        {
          let offset = 0;
          for (let i = 0; i < morphTargetCount; i++) {
            let item = posAttrList[i];
            posArray.set(item.data, offset);
            offset += item.data.length;
          }
        }
        let normalAttrList = this.collectAttribute("a_morphNormals_", geometry);
        let normalArray;
        if (normalAttrList && normalAttrList.length > 0) {
          let offset = 0;
          normalArray = new Float32Array(vertexCount * morphTargetCount * 3);
          for (let i = 0; i < morphTargetCount; i++) {
            let item = normalAttrList[i];
            normalArray.set(item.data, offset);
            offset += item.data.length;
          }
        }
        return { mtCount: morphTargetCount, vCount: vertexCount, mergedPos: posArray, mergedNormal: normalArray };
      }
      collectAttribute(attrKey, geometry) {
        let list = [];
        for (let i = 0; i < this.MaxMorphTargetCount; i++) {
          let morphKey = attrKey + i;
          let item = geometry.getAttribute(morphKey);
          if (!item) break;
          else list[i] = item;
        }
        return list;
      }
      uploadConfigGBuffer() {
        if (this._isInfluenceDirty) {
          let sumInfluence = 0;
          for (let i = 0; i < this._morphTargetCount; i++) {
            sumInfluence += this._morphInfluenceArray[i];
          }
          this._morphInfluenceBuffer.setFloat32Array("data", this._morphInfluenceArray);
          this._morphInfluenceBuffer.apply();
          this._computeConfigArray[0] = this.morphTargetsRelative ? 1 : 1 - sumInfluence;
          this._computeConfigArray[1] = this._morphTargetCount;
          this._computeConfigArray[2] = this._totalVertexCount;
          this._computeConfigArray[3] = this._computeWorkGroupXY;
          this._computeConfigBuffer.setFloat32Array("data", this._computeConfigArray);
          this._computeConfigBuffer.apply();
          this._isInfluenceDirty = false;
        }
      }
      calcWorkGroup(count) {
        let groupXY = Math.ceil(Math.sqrt(count));
        let log2 = Math.ceil(Math.log2(groupXY));
        groupXY = Math.pow(2, log2);
        return groupXY;
      }
      uploadMorphTargetBuffer() {
        if (!this._positionAttrDataGroup.output) {
          this._positionAttrDataGroup.apply(this._totalVertexCount);
        }
        if (!this._normalAttrDataGroup.output) {
          this._normalAttrDataGroup.apply(this._totalVertexCount);
        }
      }
      generateGPUBuffer() {
        this._computeConfigArray = new Float32Array(4);
        this._computeConfigBuffer = new UniformGPUBuffer(4);
        this._morphInfluenceArray = new Float32Array(this.MaxMorphTargetCount);
        let usage = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST;
        this._morphInfluenceBuffer = new StorageGPUBuffer(this.MaxMorphTargetCount, usage);
      }
    }

    var PassType = /* @__PURE__ */ ((PassType2) => {
      PassType2[PassType2["COLOR"] = 1] = "COLOR";
      PassType2[PassType2["REFLECTION"] = 2] = "REFLECTION";
      PassType2[PassType2["POSITION"] = 4] = "POSITION";
      PassType2[PassType2["GRAPHIC"] = 8] = "GRAPHIC";
      PassType2[PassType2["GI"] = 16] = "GI";
      PassType2[PassType2["Cluster"] = 32] = "Cluster";
      PassType2[PassType2["SHADOW"] = 64] = "SHADOW";
      PassType2[PassType2["POINT_SHADOW"] = 128] = "POINT_SHADOW";
      PassType2[PassType2["POST"] = 256] = "POST";
      PassType2[PassType2["DEPTH"] = 512] = "DEPTH";
      PassType2[PassType2["OIT_ACCUM"] = 1024] = "OIT_ACCUM";
      PassType2[PassType2["OIT_DEPTH_PEEL_DEPTH"] = 2048] = "OIT_DEPTH_PEEL_DEPTH";
      PassType2[PassType2["OIT_DEPTH_PEEL_FRONT"] = 4096] = "OIT_DEPTH_PEEL_FRONT";
      PassType2[PassType2["OIT_DEPTH_PEEL_BACK"] = 8192] = "OIT_DEPTH_PEEL_BACK";
      return PassType2;
    })(PassType || {});

    class GLTFType {
      static GLTF_NODE_INDEX_PROPERTY;
      static BASE_COLOR_UNIFORM = "u_baseColorFactor";
      static BASE_COLOR_TEXTURE_UNIFORM = "u_baseColorSampler";
      static METALROUGHNESS_UNIFORM = "u_metallicRoughnessValues";
      static METALROUGHNESS_TEXTURE_UNIFORM = "u_metallicRoughnessSampler";
      static NORMAL_TEXTURE_UNIFORM = "u_normalSampler";
      static NORMAL_SCALE_UNIFORM = "u_normalScale";
      static EMISSIVE_TEXTURE_UNIFORM = "u_emissiveSampler";
      static EMISSIVE_FACTOR_UNIFORM = "u_emissiveFactor";
      static OCCLUSION_TEXTURE_UNIFORM = "u_occlusionSampler";
      static OCCLUSION_FACTOR_UNIFORM = "u_occlusionFactor";
      static MAX_MORPH_TARGETS = 8;
      static MORPH_POSITION_PREFIX = "a_morphPositions_";
      static MORPH_NORMAL_PREFIX = "a_morphNormals_";
      static MORPH_TANGENT_PREFIX = "a_morphTangents_";
      static MORPH_WEIGHT_UNIFORM = "u_morphWeights";
      static SCENE_ROOT_SKELETON = "SCENE_ROOT";
      static IDENTITY_INVERSE_BIND_MATRICES = "IDENTITY_IBM";
      static JOINT_MATRICES_UNIFORM = "u_jointMatrix";
      static ALPHA_CUTOFF_UNIFORM = "u_alphaCutoff";
    }

    var VertexAttributeName = /* @__PURE__ */ ((VertexAttributeName2) => {
      VertexAttributeName2["position"] = "position";
      VertexAttributeName2["normal"] = "normal";
      VertexAttributeName2["uv"] = "uv";
      VertexAttributeName2["TANGENT"] = "TANGENT";
      VertexAttributeName2["TEXCOORD_1"] = "TEXCOORD_1";
      VertexAttributeName2["TEXCOORD_2"] = "TEXCOORD_2";
      VertexAttributeName2["TEXCOORD_3"] = "TEXCOORD_3";
      VertexAttributeName2["TEXCOORD_4"] = "TEXCOORD_4";
      VertexAttributeName2["TEXCOORD_5"] = "TEXCOORD_5";
      VertexAttributeName2["TEXCOORD_6"] = "TEXCOORD_6";
      VertexAttributeName2["TEXCOORD_7"] = "TEXCOORD_7";
      VertexAttributeName2["color"] = "color";
      VertexAttributeName2["joints0"] = "joints0";
      VertexAttributeName2["joints1"] = "joints1";
      VertexAttributeName2["weights0"] = "weights0";
      VertexAttributeName2["weights1"] = "weights1";
      VertexAttributeName2["weight"] = "weight";
      VertexAttributeName2["indices"] = `indices`;
      VertexAttributeName2["vIndex"] = "vIndex";
      VertexAttributeName2["a_morphPositions_0"] = "a_morphPositions_0";
      VertexAttributeName2["all"] = "all";
      return VertexAttributeName2;
    })(VertexAttributeName || {});

    var BlendMode = /* @__PURE__ */ ((BlendMode2) => {
      BlendMode2[BlendMode2["NONE"] = 0] = "NONE";
      BlendMode2[BlendMode2["ABOVE"] = 1] = "ABOVE";
      BlendMode2[BlendMode2["ALPHA"] = 2] = "ALPHA";
      BlendMode2[BlendMode2["NORMAL"] = 3] = "NORMAL";
      BlendMode2[BlendMode2["ADD"] = 4] = "ADD";
      BlendMode2[BlendMode2["BELOW"] = 5] = "BELOW";
      BlendMode2[BlendMode2["ERASE"] = 6] = "ERASE";
      BlendMode2[BlendMode2["MUL"] = 7] = "MUL";
      BlendMode2[BlendMode2["SCREEN"] = 8] = "SCREEN";
      BlendMode2[BlendMode2["DIVD"] = 9] = "DIVD";
      BlendMode2[BlendMode2["SOFT_ADD"] = 10] = "SOFT_ADD";
      return BlendMode2;
    })(BlendMode || {});
    var Blend = /* @__PURE__ */ ((Blend2) => {
      Blend2[Blend2["src_a"] = 0] = "src_a";
      Blend2[Blend2["dest_a"] = 1] = "dest_a";
      return Blend2;
    })(Blend || {});
    class BlendFactor {
      static getBlend(blendMode) {
        let blend = {
          color: {
            srcFactor: "src-alpha",
            dstFactor: "one"
          },
          alpha: {
            srcFactor: "one",
            dstFactor: "one"
          }
        };
        switch (blendMode) {
          case 0 /* NONE */:
            blend.color.srcFactor = `one`;
            blend.color.dstFactor = `zero`;
            blend.color.operation = "add";
            break;
          case 1 /* ABOVE */:
            blend.color.srcFactor = `one-minus-src-alpha`;
            blend.color.dstFactor = `dst-alpha`;
            blend.color.operation = "add";
            break;
          case 4 /* ADD */:
            blend.color.srcFactor = `one`;
            blend.color.dstFactor = "one";
            blend.color.operation = `add`;
            blend.alpha.srcFactor = `zero`;
            blend.alpha.dstFactor = `one`;
            blend.alpha.operation = `add`;
            break;
          case 2 /* ALPHA */:
            blend.color.srcFactor = `src-alpha`;
            blend.color.dstFactor = `one-minus-src-alpha`;
            blend.color.operation = "add";
            break;
          case 5 /* BELOW */:
            blend.color.srcFactor = `one-minus-src-alpha`;
            blend.color.dstFactor = "one";
            blend.color.operation = "add";
            break;
          case 6 /* ERASE */:
            blend.color.srcFactor = `zero`;
            blend.color.dstFactor = "one-minus-src-alpha";
            blend.color.operation = "add";
            break;
          case 7 /* MUL */:
            blend.color.srcFactor = `dst`;
            blend.color.dstFactor = `one-minus-src-alpha`;
            blend.color.operation = "add";
            break;
          case 3 /* NORMAL */:
            blend.color.srcFactor = `src-alpha`;
            blend.color.dstFactor = `one-minus-src-alpha`;
            blend.color.operation = `add`;
            break;
          case 10 /* SOFT_ADD */:
            blend.color.srcFactor = `one`;
            blend.color.dstFactor = "one";
            blend.color.operation = `max`;
            blend.alpha.srcFactor = `zero`;
            blend.alpha.dstFactor = `one`;
            blend.alpha.operation = `add`;
            break;
          case 8 /* SCREEN */:
            blend.color.srcFactor = "one";
            blend.color.dstFactor = `one-minus-src`;
            blend.color.operation = "add";
            break;
        }
        return blend;
      }
    }

    class BitmapTexture2DArray extends Texture {
      _bitmapTextures;
      constructor(width, height, numberLayer, ctx, usage = 0, colorSpace = "linear") {
        super(width, height, numberLayer);
        this.usage |= usage;
        this.format = colorSpace === "srgb" ? GPUTextureFormat.rgba8unorm_srgb : GPUTextureFormat.rgba8unorm;
        this.mipmapCount = 1;
        this._bitmapTextures = [];
        this._ensureBound(ctx);
        this.init();
      }
      /**
       * fill self by set texture list
       * @param texs array of BitmapTexture2D
       * @returns
       */
      setTextures(texs) {
        this._bitmapTextures.length = 0;
        for (let i = 0; i < texs.length; i++) {
          const tex = texs[i];
          this.addTexture(tex);
        }
      }
      /**
       * add one BitmapTexture2D to this
       * @param bitmapTexture the bitmapTexture2D be added
       * @returns
       */
      addTexture(bitmapTexture) {
        if (bitmapTexture.width != this.width || bitmapTexture.height != this.height) {
          console.error("bitmap texture must match bitmapTextureArray size!");
        }
        bitmapTexture.pid = this._bitmapTextures.length;
        this._bitmapTextures.push(bitmapTexture);
        this.updateTexture();
      }
      /**
      * remove one BitmapTexture2D from this
      * @param bitmapTexture the bitmapTexture2D be removed
      * @returns
      */
      removeTexture(bitmapTexture) {
        let index = this._bitmapTextures.indexOf(bitmapTexture);
        if (index != -1) {
          this._bitmapTextures.splice(index, 1);
          for (let i = 0; i < this._bitmapTextures.length; i++) {
            const bitmapTexture2 = this._bitmapTextures[i];
            bitmapTexture2.pid = i;
          }
        }
      }
      /**
       * @internal
       */
      updateTexture() {
        let encoder = this._boundCtx.gpuContext.beginCommandEncoder();
        for (let i = 0; i < this._bitmapTextures.length; i++) {
          let bitmapTexture = this._bitmapTextures[i];
          encoder.copyTextureToTexture(
            {
              texture: bitmapTexture.getGPUTexture(),
              mipLevel: 0,
              origin: { x: 0, y: 0, z: 0 }
            },
            {
              texture: this.getGPUTexture(),
              mipLevel: 0,
              origin: { x: 0, y: 0, z: i }
            },
            {
              width: this.width,
              height: this.height,
              depthOrArrayLayers: 1
            }
          );
        }
        this._boundCtx.gpuContext.endCommandEncoder(encoder);
      }
      internalCreateBindingLayoutDesc() {
        this.textureBindingLayout.viewDimension = `2d-array`;
        this.samplerBindingLayout.type = `filtering`;
        this.minFilter = GPUFilterMode.linear;
        this.magFilter = GPUFilterMode.linear;
      }
      internalCreateTexture() {
        this.textureDescriptor = {
          format: this.format,
          size: { width: this.width, height: this.height, depthOrArrayLayers: this.numberLayer },
          dimension: "2d",
          usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.TEXTURE_BINDING | this.usage
        };
        this.gpuTexture = this.getGPUTexture();
      }
      internalCreateView() {
        this.viewDescriptor = {
          dimension: `2d-array`
        };
        this.view = this.getGPUView();
      }
      internalCreateSampler() {
        this._ensureBound();
        this.gpuSampler = this._boundCtx.device.createSampler(this);
      }
    }

    class IESProfiles {
      _iesTexture;
      /** Layer index inside the owning pool's texture array. -1 until registered. */
      index = -1;
      /**
       * Set the IES photometric texture. Can only be assigned before the
       * profile is registered into a pool; later assignments are ignored.
       */
      set IESTexture(texture) {
        if (this._iesTexture === texture) return;
        if (this.index !== -1) {
          console.warn(`IESProfiles: texture cannot be replaced after the profile has been registered.`);
          return;
        }
        this._iesTexture = texture;
        texture.addressModeU = GPUAddressMode.repeat;
        texture.addressModeV = GPUAddressMode.repeat;
        texture.addressModeW = GPUAddressMode.repeat;
      }
      /** The assigned IES photometric texture, or undefined if none. */
      get IESTexture() {
        return this._iesTexture;
      }
    }
    class IESProfilesPool {
      /** Layer capacity of the texture array. */
      static MAX_PROFILES = 48;
      iesTexture = null;
      _profiles = [];
      _ctx;
      constructor(ctx) {
        this._ctx = ctx;
      }
      static for(ctx) {
        return ctx.cache(IESProfilesPool, () => new IESProfilesPool(ctx));
      }
      /** True once any profile is registered — drives the USE_IES_PROFILE shader define. */
      get use() {
        return this._profiles.length > 0;
      }
      /**
       * Register a profile and return its texture-array layer index.
       * Idempotent for an already-registered profile. Returns -1 (no IES
       * applied) when the profile has no texture yet or the pool is full.
       */
      register(profile) {
        const existing = this._profiles.indexOf(profile);
        if (existing !== -1) return existing;
        const texture = profile.IESTexture;
        if (!texture) return -1;
        if (this._profiles.length >= IESProfilesPool.MAX_PROFILES) {
          console.error(`IESProfilesPool: capacity (${IESProfilesPool.MAX_PROFILES}) exceeded, profile ignored.`);
          return -1;
        }
        if (!this.iesTexture) {
          this.iesTexture = new BitmapTexture2DArray(texture.width, texture.height, IESProfilesPool.MAX_PROFILES, this._ctx);
        }
        const index = this._profiles.length;
        this._profiles.push(profile);
        profile.index = index;
        this.iesTexture.addTexture(texture);
        return index;
      }
    }

    class GlobalBindGroupLayout {
      /**
       * Get the cached global data bind group layout for the given context.
       * @param ctx the rendering context
       */
      static getGlobalDataBindGroupLayout(ctx) {
        return ctx.cache(GlobalBindGroupLayout, () => {
          let entries = [];
          entries.push({
            binding: 0,
            visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE,
            buffer: {
              type: "uniform"
            }
          });
          entries.push({
            binding: 1,
            visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE,
            buffer: {
              type: "read-only-storage"
            }
          });
          return ctx.device.createBindGroupLayout({ entries });
        });
      }
    }

    class GLSLLexerToken {
      Type = 0;
      Line = 0;
      Colume = 0;
      Literal = "";
      constructor(type = 0 /* EOF */, literal = "\0") {
        this.Type = type;
        this.Literal = literal;
      }
      /**
       * @returns determin the type is same to token
       */
      isTypeEqual(type) {
        return this.Type == type;
      }
      /**
       * @returns determin the value is same
       */
      isLiteralEqual(literal) {
        return this.Literal == literal;
      }
      /**
       * @returns determin it's builtin type
       */
      isBuiltinType() {
        return this.Type > 33 /* BeginBuiltinType */ && this.Type < 101 /* EndBuiltinType */;
      }
      /**
       * @returns determin it's a data type
       */
      isDataType() {
        return this.Type == 1 /* IDENT */ || this.isBuiltinType();
      }
      /**
       * @returns determin it's a operation
       */
      isOperation() {
        return this.Type > 102 /* BeginOperation */ && this.Type < 127 /* EndOperation */;
      }
      /**
       * @returns determin it's a assign operation
       */
      isAssignOperation() {
        return this.Type > 128 /* BeginAssignOperation */ && this.Type < 133 /* EndAssignOperation */;
      }
      /**
       * The priority of the current operator
       */
      get nOperationPriorityLevel() {
        switch (this.Type) {
          case 26 /* LEFTSAMLL */:
            return 1;
          case 27 /* RIGHTSAMLL */:
            return 1;
          case 125 /* DOT */:
            return 2;
          case 110 /* NOT */:
            return 3;
          case 114 /* BITNOT */:
            return 3;
          case 105 /* MUL */:
            return 4;
          case 106 /* DIV */:
            return 4;
          case 103 /* ADD */:
            return 5;
          case 104 /* SUB */:
            return 5;
          case 115 /* BITSHIFT_L */:
            return 6;
          case 116 /* BITSHIFT_R */:
            return 6;
          case 119 /* GREATER */:
            return 7;
          case 120 /* GREATEREQUAL */:
            return 7;
          case 122 /* LESS */:
            return 7;
          case 123 /* LESSEQUAL */:
            return 7;
          case 121 /* EQUAL */:
            return 8;
          case 124 /* NOTEQUAL */:
            return 8;
          case 111 /* BITAND */:
            return 9;
          case 113 /* BITXOR */:
            return 10;
          case 112 /* BITOR */:
            return 11;
          case 107 /* AND */:
            return 12;
          case 109 /* XOR */:
            return 13;
          case 108 /* OR */:
            return 14;
          case 24 /* QUEMARK */:
            return 15;
          case 126 /* ASSIGN */:
            return 16;
          case 129 /* ADDASSIGN */:
            return 16;
          case 130 /* SUBASSIGN */:
            return 16;
          case 131 /* MULASSIGN */:
            return 16;
          case 132 /* DIVASSIGN */:
            return 16;
        }
        return 99;
      }
    }
    var TokenType = /* @__PURE__ */ ((TokenType2) => {
      TokenType2[TokenType2["EOF"] = 0] = "EOF";
      TokenType2[TokenType2["IDENT"] = 1] = "IDENT";
      TokenType2[TokenType2["VOID"] = 2] = "VOID";
      TokenType2[TokenType2["CONST"] = 3] = "CONST";
      TokenType2[TokenType2["LAYOUT"] = 4] = "LAYOUT";
      TokenType2[TokenType2["PRECISION"] = 5] = "PRECISION";
      TokenType2[TokenType2["ATTRIBUTE"] = 6] = "ATTRIBUTE";
      TokenType2[TokenType2["UNIFORM"] = 7] = "UNIFORM";
      TokenType2[TokenType2["VARYING"] = 8] = "VARYING";
      TokenType2[TokenType2["INVARIANT"] = 9] = "INVARIANT";
      TokenType2[TokenType2["IN"] = 10] = "IN";
      TokenType2[TokenType2["OUT"] = 11] = "OUT";
      TokenType2[TokenType2["INOUT"] = 12] = "INOUT";
      TokenType2[TokenType2["IF"] = 13] = "IF";
      TokenType2[TokenType2["ELSE"] = 14] = "ELSE";
      TokenType2[TokenType2["FOR"] = 15] = "FOR";
      TokenType2[TokenType2["WHILE"] = 16] = "WHILE";
      TokenType2[TokenType2["DO"] = 17] = "DO";
      TokenType2[TokenType2["BREAK"] = 18] = "BREAK";
      TokenType2[TokenType2["RETURN"] = 19] = "RETURN";
      TokenType2[TokenType2["CONTINUE"] = 20] = "CONTINUE";
      TokenType2[TokenType2["STRUCT"] = 21] = "STRUCT";
      TokenType2[TokenType2["COMMA"] = 22] = "COMMA";
      TokenType2[TokenType2["COLON"] = 23] = "COLON";
      TokenType2[TokenType2["QUEMARK"] = 24] = "QUEMARK";
      TokenType2[TokenType2["SEMICOLON"] = 25] = "SEMICOLON";
      TokenType2[TokenType2["LEFTSAMLL"] = 26] = "LEFTSAMLL";
      TokenType2[TokenType2["RIGHTSAMLL"] = 27] = "RIGHTSAMLL";
      TokenType2[TokenType2["LEFTMEDI"] = 28] = "LEFTMEDI";
      TokenType2[TokenType2["RIGHTMEDI"] = 29] = "RIGHTMEDI";
      TokenType2[TokenType2["LEFTBIG"] = 30] = "LEFTBIG";
      TokenType2[TokenType2["RIGHTBIG"] = 31] = "RIGHTBIG";
      TokenType2[TokenType2["LITERAL"] = 32] = "LITERAL";
      TokenType2[TokenType2["BeginBuiltinType"] = 33] = "BeginBuiltinType";
      TokenType2[TokenType2["INT"] = 34] = "INT";
      TokenType2[TokenType2["INT_ARRAY"] = 35] = "INT_ARRAY";
      TokenType2[TokenType2["UINT"] = 36] = "UINT";
      TokenType2[TokenType2["UINT_ARRAY"] = 37] = "UINT_ARRAY";
      TokenType2[TokenType2["BOOL"] = 38] = "BOOL";
      TokenType2[TokenType2["BOOL_ARRAY"] = 39] = "BOOL_ARRAY";
      TokenType2[TokenType2["FLOAT"] = 40] = "FLOAT";
      TokenType2[TokenType2["FLOAT_ARRAY"] = 41] = "FLOAT_ARRAY";
      TokenType2[TokenType2["DOUBLE"] = 42] = "DOUBLE";
      TokenType2[TokenType2["DOUBLE_ARRAY"] = 43] = "DOUBLE_ARRAY";
      TokenType2[TokenType2["VEC2"] = 44] = "VEC2";
      TokenType2[TokenType2["VEC2_ARRAY"] = 45] = "VEC2_ARRAY";
      TokenType2[TokenType2["VEC3"] = 46] = "VEC3";
      TokenType2[TokenType2["VEC3_ARRAY"] = 47] = "VEC3_ARRAY";
      TokenType2[TokenType2["VEC4"] = 48] = "VEC4";
      TokenType2[TokenType2["VEC4_ARRAY"] = 49] = "VEC4_ARRAY";
      TokenType2[TokenType2["BVEC2"] = 50] = "BVEC2";
      TokenType2[TokenType2["BVEC2_ARRAY"] = 51] = "BVEC2_ARRAY";
      TokenType2[TokenType2["BVEC3"] = 52] = "BVEC3";
      TokenType2[TokenType2["BVEC3_ARRAY"] = 53] = "BVEC3_ARRAY";
      TokenType2[TokenType2["BVEC4"] = 54] = "BVEC4";
      TokenType2[TokenType2["BVEC4_ARRAY"] = 55] = "BVEC4_ARRAY";
      TokenType2[TokenType2["IVEC2"] = 56] = "IVEC2";
      TokenType2[TokenType2["IVEC2_ARRAY"] = 57] = "IVEC2_ARRAY";
      TokenType2[TokenType2["IVEC3"] = 58] = "IVEC3";
      TokenType2[TokenType2["IVEC3_ARRAY"] = 59] = "IVEC3_ARRAY";
      TokenType2[TokenType2["IVEC4"] = 60] = "IVEC4";
      TokenType2[TokenType2["IVEC4_ARRAY"] = 61] = "IVEC4_ARRAY";
      TokenType2[TokenType2["UVEC2"] = 62] = "UVEC2";
      TokenType2[TokenType2["UVEC2_ARRAY"] = 63] = "UVEC2_ARRAY";
      TokenType2[TokenType2["UVEC3"] = 64] = "UVEC3";
      TokenType2[TokenType2["UVEC3_ARRAY"] = 65] = "UVEC3_ARRAY";
      TokenType2[TokenType2["UVEC4"] = 66] = "UVEC4";
      TokenType2[TokenType2["UVEC4_ARRAY"] = 67] = "UVEC4_ARRAY";
      TokenType2[TokenType2["MAT2x2"] = 68] = "MAT2x2";
      TokenType2[TokenType2["MAT2x2_ARRAY"] = 69] = "MAT2x2_ARRAY";
      TokenType2[TokenType2["MAT2x3"] = 70] = "MAT2x3";
      TokenType2[TokenType2["MAT2x3_ARRAY"] = 71] = "MAT2x3_ARRAY";
      TokenType2[TokenType2["MAT2x4"] = 72] = "MAT2x4";
      TokenType2[TokenType2["MAT2x4_ARRAY"] = 73] = "MAT2x4_ARRAY";
      TokenType2[TokenType2["MAT3x2"] = 74] = "MAT3x2";
      TokenType2[TokenType2["MAT3x2_ARRAY"] = 75] = "MAT3x2_ARRAY";
      TokenType2[TokenType2["MAT3x3"] = 76] = "MAT3x3";
      TokenType2[TokenType2["MAT3x3_ARRAY"] = 77] = "MAT3x3_ARRAY";
      TokenType2[TokenType2["MAT3x4"] = 78] = "MAT3x4";
      TokenType2[TokenType2["MAT3x4_ARRAY"] = 79] = "MAT3x4_ARRAY";
      TokenType2[TokenType2["MAT4x2"] = 80] = "MAT4x2";
      TokenType2[TokenType2["MAT4x2_ARRAY"] = 81] = "MAT4x2_ARRAY";
      TokenType2[TokenType2["MAT4x3"] = 82] = "MAT4x3";
      TokenType2[TokenType2["MAT4x3_ARRAY"] = 83] = "MAT4x3_ARRAY";
      TokenType2[TokenType2["MAT4x4"] = 84] = "MAT4x4";
      TokenType2[TokenType2["MAT4x4_ARRAY"] = 85] = "MAT4x4_ARRAY";
      TokenType2[TokenType2["SAMPLER"] = 86] = "SAMPLER";
      TokenType2[TokenType2["SAMPLER_1D"] = 87] = "SAMPLER_1D";
      TokenType2[TokenType2["SAMPLER_2D"] = 88] = "SAMPLER_2D";
      TokenType2[TokenType2["SAMPLER_3D"] = 89] = "SAMPLER_3D";
      TokenType2[TokenType2["SAMPLER_CUBE"] = 90] = "SAMPLER_CUBE";
      TokenType2[TokenType2["SAMPLER_SHADOW"] = 91] = "SAMPLER_SHADOW";
      TokenType2[TokenType2["SAMPLER_1D_SHADOW"] = 92] = "SAMPLER_1D_SHADOW";
      TokenType2[TokenType2["SAMPLER_2D_SHADOW"] = 93] = "SAMPLER_2D_SHADOW";
      TokenType2[TokenType2["TEXTURE_1D"] = 94] = "TEXTURE_1D";
      TokenType2[TokenType2["TEXTURE_1D_ARRAY"] = 95] = "TEXTURE_1D_ARRAY";
      TokenType2[TokenType2["TEXTURE_2D"] = 96] = "TEXTURE_2D";
      TokenType2[TokenType2["TEXTURE_2D_ARRAY"] = 97] = "TEXTURE_2D_ARRAY";
      TokenType2[TokenType2["TEXTURE_3D"] = 98] = "TEXTURE_3D";
      TokenType2[TokenType2["TEXTURE_CUBE"] = 99] = "TEXTURE_CUBE";
      TokenType2[TokenType2["TEXTURE_CUBE_ARRAY"] = 100] = "TEXTURE_CUBE_ARRAY";
      TokenType2[TokenType2["EndBuiltinType"] = 101] = "EndBuiltinType";
      TokenType2[TokenType2["BeginOperation"] = 102] = "BeginOperation";
      TokenType2[TokenType2["ADD"] = 103] = "ADD";
      TokenType2[TokenType2["SUB"] = 104] = "SUB";
      TokenType2[TokenType2["MUL"] = 105] = "MUL";
      TokenType2[TokenType2["DIV"] = 106] = "DIV";
      TokenType2[TokenType2["AND"] = 107] = "AND";
      TokenType2[TokenType2["OR"] = 108] = "OR";
      TokenType2[TokenType2["XOR"] = 109] = "XOR";
      TokenType2[TokenType2["NOT"] = 110] = "NOT";
      TokenType2[TokenType2["BITAND"] = 111] = "BITAND";
      TokenType2[TokenType2["BITOR"] = 112] = "BITOR";
      TokenType2[TokenType2["BITXOR"] = 113] = "BITXOR";
      TokenType2[TokenType2["BITNOT"] = 114] = "BITNOT";
      TokenType2[TokenType2["BITSHIFT_L"] = 115] = "BITSHIFT_L";
      TokenType2[TokenType2["BITSHIFT_R"] = 116] = "BITSHIFT_R";
      TokenType2[TokenType2["INC"] = 117] = "INC";
      TokenType2[TokenType2["DEC"] = 118] = "DEC";
      TokenType2[TokenType2["GREATER"] = 119] = "GREATER";
      TokenType2[TokenType2["GREATEREQUAL"] = 120] = "GREATEREQUAL";
      TokenType2[TokenType2["EQUAL"] = 121] = "EQUAL";
      TokenType2[TokenType2["LESS"] = 122] = "LESS";
      TokenType2[TokenType2["LESSEQUAL"] = 123] = "LESSEQUAL";
      TokenType2[TokenType2["NOTEQUAL"] = 124] = "NOTEQUAL";
      TokenType2[TokenType2["DOT"] = 125] = "DOT";
      TokenType2[TokenType2["ASSIGN"] = 126] = "ASSIGN";
      TokenType2[TokenType2["EndOperation"] = 127] = "EndOperation";
      TokenType2[TokenType2["BeginAssignOperation"] = 128] = "BeginAssignOperation";
      TokenType2[TokenType2["ADDASSIGN"] = 129] = "ADDASSIGN";
      TokenType2[TokenType2["SUBASSIGN"] = 130] = "SUBASSIGN";
      TokenType2[TokenType2["MULASSIGN"] = 131] = "MULASSIGN";
      TokenType2[TokenType2["DIVASSIGN"] = 132] = "DIVASSIGN";
      TokenType2[TokenType2["EndAssignOperation"] = 133] = "EndAssignOperation";
      return TokenType2;
    })(TokenType || {});

    class Reader {
      _char;
      _line;
      _column;
      _source;
      _currPosition;
      _nextPosition;
      constructor(source) {
        this.reset(source);
      }
      reset(source) {
        this._char = "";
        this._line = 0;
        this._column = 0;
        this._source = source;
        this._currPosition = 0;
        this._nextPosition = 0;
      }
      get source() {
        return this._source;
      }
      getChar() {
        return this._char;
      }
      get currPosition() {
        return this._currPosition;
      }
      peekChar() {
        return this._nextPosition >= this._source.length ? "\0" : this._source[this._nextPosition];
      }
      readChar() {
        this._char = this._nextPosition >= this._source.length ? "\0" : this._source[this._nextPosition];
        if (this._char !== "\n") {
          this._column++;
        } else {
          this._line++;
          this._column = 0;
        }
        this._currPosition = this._nextPosition;
        this._nextPosition++;
      }
      readCharAndSkipWhitespace() {
        this.readChar();
        this.skipWhitespace();
      }
      readIdentifier() {
        var pos = this._currPosition;
        while (this.isIdentifier(this._char)) {
          this.readChar();
        }
        return this._source.substring(pos, this._currPosition);
      }
      isIdentifier(char) {
        var code = char.charCodeAt(0);
        return 97 <= code && code <= 122 || 65 <= code && code <= 90 || 48 <= code && code <= 57 || code == 95;
      }
      skipWhitespace() {
        while (this.IsWhitespace(this._char)) {
          this.readChar();
        }
      }
      IsWhitespace(char) {
        return char === " " || char === "	" || char === "\r" || char === "\n";
      }
      skipComment() {
        while (this._char !== "\n" && this._char !== "\0") {
          this.readChar();
        }
        this.skipWhitespace();
      }
      skipMultilineComment() {
        if (this._char !== "/" && this.peekChar() !== "*") {
          return;
        }
        this.readChar();
        this.readChar();
        for (let nCount = 1; nCount > 0 && this._char !== "\0"; ) {
          this.readChar();
          if (this._char === "/" && this.peekChar() === "*") {
            nCount++;
            this.readChar();
            continue;
          } else if (this._char === "*" && this.peekChar() === "/") {
            nCount--;
            this.readChar();
            continue;
          }
        }
        this.readChar();
        this.readChar();
        this.skipWhitespace();
      }
      isDigit(char) {
        var code = char.charCodeAt(0);
        return 48 <= code && code <= 57;
      }
      readNumber() {
        var pos = this._currPosition;
        while (this.isDigit(this._char)) {
          this.readChar();
        }
        if (this._char === ".") {
          this.readChar();
          while (this.isDigit(this._char)) {
            this.readChar();
          }
        }
        return this._source.substring(pos, this._currPosition);
      }
      readValue() {
        if (this.isDigit(this._char)) {
          return this.readNumber();
        }
        return this.readIdentifier();
      }
      readLine() {
        var pos = this._currPosition;
        var index = this._source.indexOf("\n", this._currPosition);
        if (index == -1) {
          index = this._source.length;
        }
        this._line++;
        this._column = 0;
        this._currPosition = index;
        this._nextPosition = index + 1;
        return this._source.substring(pos, index + 1);
      }
    }

    class GLSLLexer extends Reader {
      _tokenPosition = 0;
      _tokens = [];
      constructor(input) {
        super(input.source);
        this.parse();
      }
      skipToken(offset) {
        this._tokenPosition += offset;
      }
      peekToken(offset) {
        if (this._tokenPosition + offset >= this._tokens.length) {
          return new GLSLLexerToken(TokenType.EOF, "\0");
        }
        return this._tokens[this._tokenPosition + offset];
      }
      GetNextToken() {
        if (this._tokenPosition >= this._tokens.length) {
          return new GLSLLexerToken(TokenType.EOF, "\0");
        }
        let result = this._tokens[this._tokenPosition];
        this._tokenPosition++;
        return result;
      }
      get currTokenPosition() {
        return this._tokenPosition;
      }
      // start to parse
      parse() {
        this.readChar();
        this._tokens = new Array();
        var token;
        do {
          token = this.nextToken();
          this._tokens.push(token);
        } while (token.Type != TokenType.EOF);
      }
      // get next token
      nextToken() {
        this.skipWhitespace();
        if (this._char === "/") {
          if (this.peekChar() === "/") {
            this.skipComment();
            return this.nextToken();
          }
          if (this.peekChar() === "*") {
            this.skipMultilineComment();
            return this.nextToken();
          }
        }
        var token = new GLSLLexerToken();
        token.Line = this._line;
        token.Colume = this._column;
        switch (this._char) {
          case "\0":
            token.Type = TokenType.EOF;
            token.Literal = "EOF";
            break;
          case ".":
            token.Type = TokenType.DOT;
            token.Literal = ".";
            break;
          case ",":
            token.Type = TokenType.COMMA;
            token.Literal = ",";
            break;
          case ":":
            token.Type = TokenType.COLON;
            token.Literal = ":";
            break;
          case "?":
            token.Type = TokenType.QUEMARK;
            token.Literal = "?";
            break;
          case ";":
            token.Type = TokenType.SEMICOLON;
            token.Literal = ";";
            break;
          case "(":
            token.Type = TokenType.LEFTSAMLL;
            token.Literal = "(";
            break;
          case ")":
            token.Type = TokenType.RIGHTSAMLL;
            token.Literal = ")";
            break;
          case "[":
            token.Type = TokenType.LEFTMEDI;
            token.Literal = "[";
            break;
          case "]":
            token.Type = TokenType.RIGHTMEDI;
            token.Literal = "]";
            break;
          case "{":
            token.Type = TokenType.LEFTBIG;
            token.Literal = "{";
            break;
          case "}":
            token.Type = TokenType.RIGHTBIG;
            token.Literal = "}";
            break;
          case "+":
            if (this.peekChar() === "+") {
              this.readChar();
              token.Type = TokenType.INC;
              token.Literal = "++";
              break;
            } else if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.ADDASSIGN;
              token.Literal = "+=";
              break;
            }
            token.Type = TokenType.ADD;
            token.Literal = "+";
            break;
          case "-":
            if (this.peekChar() === "-") {
              this.readChar();
              token.Type = TokenType.DEC;
              token.Literal = "--";
              break;
            } else if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.SUBASSIGN;
              token.Literal = "-=";
              break;
            }
            token.Type = TokenType.SUB;
            token.Literal = "-";
            break;
          case "*":
            if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.MULASSIGN;
              token.Literal = "*=";
              break;
            }
            token.Type = TokenType.MUL;
            token.Literal = "*";
            break;
          case "/":
            if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.DIVASSIGN;
              token.Literal = "/=";
              break;
            }
            token.Type = TokenType.DIV;
            token.Literal = "/";
            break;
          case "&":
            if (this.peekChar() === "&") {
              this.readChar();
              token.Type = TokenType.AND;
              token.Literal = "&&";
              break;
            }
            token.Type = TokenType.BITAND;
            token.Literal = "&";
            break;
          case "|":
            if (this.peekChar() === "|") {
              this.readChar();
              token.Type = TokenType.OR;
              token.Literal = "||";
              break;
            }
            token.Type = TokenType.BITOR;
            token.Literal = "&";
            break;
          case "^":
            token.Type = TokenType.BITXOR;
            token.Literal = "^";
            break;
          case "!":
            if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.NOTEQUAL;
              token.Literal = "!=";
              break;
            }
            token.Type = TokenType.NOT;
            token.Literal = "!";
            break;
          case ">":
            if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.GREATEREQUAL;
              token.Literal = ">=";
              break;
            } else if (this.peekChar() === ">") {
              this.readChar();
              token.Type = TokenType.BITSHIFT_R;
              token.Literal = ">>";
              break;
            }
            token.Type = TokenType.GREATER;
            token.Literal = ">";
            break;
          case "=":
            if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.EQUAL;
              token.Literal = "==";
              break;
            }
            token.Type = TokenType.ASSIGN;
            token.Literal = "=";
            break;
          case "<":
            if (this.peekChar() === "=") {
              this.readChar();
              token.Type = TokenType.LESSEQUAL;
              token.Literal = "<=";
              break;
            } else if (this.peekChar() === "<") {
              this.readChar();
              token.Type = TokenType.BITSHIFT_L;
              token.Literal = "<<";
              break;
            }
            token.Type = TokenType.LESS;
            token.Literal = "<";
            break;
          default:
            if (this.isDigit(this._char)) {
              return this.readDecimal();
            }
            token.Literal = this.readIdentifier();
            token.Type = this.lookupIdentifier(token.Literal);
            if (this.getChar() == "[" && this.peekChar() == "]" && token.isBuiltinType()) {
              token.Type++;
              token.Literal += "[]";
              this.readChar();
              this.readChar();
            }
            return token;
        }
        this.readChar();
        return token;
      }
      // read dicimal
      readDecimal() {
        var token = new GLSLLexerToken();
        token.Line = this._line;
        token.Colume = this._column;
        token.Type = TokenType.LITERAL;
        var integer = this.readNumber();
        if (this._char === "e") {
          token.Literal = integer + this._char;
          this.readChar();
          token.Literal += this._char;
          this.readChar();
          token.Literal += this.readNumber();
          token.Type = TokenType.LITERAL;
          return token;
        }
        if (this._char === "u") {
          this.readChar();
          token.Type = TokenType.LITERAL;
          token.Literal = integer + "u";
          return token;
        }
        if (this._char === "f") {
          this.readChar();
          token.Type = TokenType.LITERAL;
          token.Literal = integer + "f";
          return token;
        }
        token.Type = TokenType.LITERAL;
        token.Literal = integer;
        return token;
      }
      lookupIdentifier(literal) {
        switch (literal) {
          case "void":
            return TokenType.VOID;
          case "int":
            return TokenType.INT;
          case "uint":
            return TokenType.UINT;
          case "bool":
            return TokenType.BOOL;
          case "true":
            return TokenType.BOOL;
          case "false":
            return TokenType.BOOL;
          case "float":
            return TokenType.FLOAT;
          case "vec2":
            return TokenType.VEC2;
          case "vec3":
            return TokenType.VEC3;
          case "vec4":
            return TokenType.VEC4;
          case "bvec2":
            return TokenType.BVEC2;
          case "bvec3":
            return TokenType.BVEC3;
          case "bvec4":
            return TokenType.BVEC4;
          case "ivec2":
            return TokenType.IVEC2;
          case "ivec3":
            return TokenType.IVEC3;
          case "ivec4":
            return TokenType.IVEC4;
          case "uvec2":
            return TokenType.UVEC2;
          case "uvec3":
            return TokenType.UVEC3;
          case "uvec4":
            return TokenType.UVEC4;
          case "mat2":
            return TokenType.MAT2x2;
          case "mat2x2":
            return TokenType.MAT2x2;
          case "mat2x3":
            return TokenType.MAT2x3;
          case "mat2x4":
            return TokenType.MAT2x4;
          case "mat3":
            return TokenType.MAT3x3;
          case "mat3x2":
            return TokenType.MAT3x2;
          case "mat3x3":
            return TokenType.MAT3x3;
          case "mat3x4":
            return TokenType.MAT3x4;
          case "mat4":
            return TokenType.MAT4x4;
          case "mat4x2":
            return TokenType.MAT4x2;
          case "mat4x3":
            return TokenType.MAT4x3;
          case "mat4x4":
            return TokenType.MAT4x4;
          case "sampler":
            return TokenType.SAMPLER;
          case "sampler1D":
            return TokenType.SAMPLER_1D;
          case "sampler2D":
            return TokenType.SAMPLER_2D;
          case "sampler3D":
            return TokenType.SAMPLER_3D;
          case "samplerCube":
            return TokenType.SAMPLER_CUBE;
          case "samplerShadow":
            return TokenType.SAMPLER_SHADOW;
          case "sampler1DShadow":
            return TokenType.SAMPLER_1D_SHADOW;
          case "sampler2DShadow":
            return TokenType.SAMPLER_2D_SHADOW;
          case "texture1D":
            return TokenType.TEXTURE_1D;
          case "texture2D":
            return TokenType.TEXTURE_2D;
          case "texture3D":
            return TokenType.TEXTURE_3D;
          case "textureCube":
            return TokenType.TEXTURE_CUBE;
          case "texture1DArray":
            return TokenType.TEXTURE_1D_ARRAY;
          case "texture2DArray":
            return TokenType.TEXTURE_2D_ARRAY;
          case "textureCubeArray":
            return TokenType.TEXTURE_CUBE_ARRAY;
          case "const":
            return TokenType.CONST;
          case "layout":
            return TokenType.LAYOUT;
          case "precision":
            return TokenType.PRECISION;
          case "attribute":
            return TokenType.ATTRIBUTE;
          case "uniform":
            return TokenType.UNIFORM;
          case "varying":
            return TokenType.VARYING;
          case "invariant":
            return TokenType.INVARIANT;
          case "in":
            return TokenType.IN;
          case "out":
            return TokenType.OUT;
          case "inout":
            return TokenType.INOUT;
          case "if":
            return TokenType.IF;
          case "else":
            return TokenType.ELSE;
          case "for":
            return TokenType.FOR;
          case "while":
            return TokenType.WHILE;
          case "do":
            return TokenType.DO;
          case "break":
            return TokenType.BREAK;
          case "return":
            return TokenType.RETURN;
          case "continue":
            return TokenType.CONTINUE;
          case "struct":
            return TokenType.STRUCT;
        }
        return TokenType.IDENT;
      }
    }

    class MacroSubstitution {
      name = "";
      value = "";
      args = [];
    }
    class GLSLPreprocessor extends Reader {
      _result;
      _skipLine;
      _definitionTables;
      constructor(source) {
        super(source);
        this._result = "";
        this._skipLine = false;
        this._definitionTables = /* @__PURE__ */ new Map();
        this.parse();
      }
      parse() {
        this.readChar();
        while (this._char !== "\0") {
          this.skipWhitespace();
          if (this._char === "/") {
            if (this.peekChar() === "/") {
              this.skipComment();
              continue;
            }
            if (this.peekChar() === "*") {
              this.skipMultilineComment();
              continue;
            }
          }
          if (this._char === "#") {
            this.readCharAndSkipWhitespace();
            var name = this.readIdentifier();
            switch (name) {
              case "version":
                this.readLine().trim();
                break;
              case "define":
                this.readCharAndSkipWhitespace();
                var defineName = this.readIdentifier();
                if (this.getChar() === "(") {
                  let macro = new MacroSubstitution();
                  this.readCharAndSkipWhitespace();
                  if (this.getChar() !== ")") {
                    do {
                      var argName = this.readIdentifier();
                      macro.args.push(argName);
                      this.skipWhitespace();
                      if (this.getChar() === ",") {
                        this.readCharAndSkipWhitespace();
                        continue;
                      }
                    } while (this.getChar() !== ")");
                  }
                  this.readCharAndSkipWhitespace();
                  macro.name = defineName;
                  macro.value = this.readLine().trim();
                  this._definitionTables.set(defineName, macro);
                  this.readCharAndSkipWhitespace();
                } else {
                  let defineValue = this.readLine().trim();
                  if (defineValue[0] == "=") {
                    defineValue = defineValue.substring(1);
                  }
                  this._definitionTables.set(defineName, defineValue);
                }
                break;
              case "if":
                let condition = this.readLine().trim();
                if (condition == "0" || condition == "false") {
                  this._skipLine = true;
                  break;
                }
                if (this._definitionTables.has(condition)) {
                  condition = this._definitionTables.get(condition);
                  if (condition == "0" || condition == "false") {
                    this._skipLine = true;
                    break;
                  }
                }
                break;
              case "ifdef":
                this.readCharAndSkipWhitespace();
                var value = this.readIdentifier();
                this._skipLine = !this._definitionTables.has(value);
                break;
              case "else":
                this._skipLine = !this._skipLine;
                break;
              case "endif":
                this._skipLine = false;
                break;
              default:
                throw "Unknown preprocessing command:" + name;
            }
          } else {
            var line = this.readLine();
            if (!this._skipLine) {
              for (let key of this._definitionTables.keys()) {
                let index = line.indexOf(key);
                if (index != -1) {
                  let value2 = this._definitionTables.get(key);
                  if (typeof value2 === "string") {
                    line = line.replace(key, value2);
                  } else {
                    let macro = value2;
                    let reader = new Reader(line.substring(index + key.length));
                    reader.readCharAndSkipWhitespace();
                    if (reader.getChar() === "(") {
                      reader.readCharAndSkipWhitespace();
                      for (let count = 1; reader.getChar() !== "\0" && count > 0; ) {
                        switch (reader.getChar()) {
                          case "(":
                            count++;
                            break;
                          case ")":
                            count--;
                            break;
                        }
                        reader.readCharAndSkipWhitespace();
                      }
                    }
                    let nBeginPos = index;
                    let nEndPos = nBeginPos + key.length + reader.currPosition;
                    let expr = line.substring(nBeginPos, nEndPos).trim();
                    if (macro.args.length > 0) {
                      let args = [];
                      let argsStr = expr.substring(expr.indexOf("(") + 1, expr.lastIndexOf(")")).trim();
                      if (argsStr.length > 0) {
                        args = this.parseArgs(argsStr);
                      }
                      let macroValue = macro.value.substring(macro.value.indexOf("("));
                      for (let i = 0; i < macro.args.length; i++) {
                        macroValue = macroValue.replace(macro.args[i], args[i]);
                      }
                      macroValue = macro.value.substring(0, macro.value.indexOf("(")) + macroValue;
                      line = line.replace(expr, macroValue);
                    } else {
                      line = line.replace(expr, macro.value);
                    }
                  }
                }
              }
              this._result += line;
            }
            this.readChar();
          }
        }
      }
      get source() {
        return this._result;
      }
      parseArgs(str) {
        let result = [];
        let count = 0;
        let reader = new Reader(str);
        let position = reader.currPosition;
        reader.readCharAndSkipWhitespace();
        if (reader.getChar() !== "\0") {
          reader.readCharAndSkipWhitespace();
          for (; reader.getChar() !== "\0"; ) {
            switch (reader.getChar()) {
              case "(":
                count++;
                break;
              case ")":
                count--;
                break;
              case ",":
                if (count == 0) {
                  let arg = str.substring(position, reader.currPosition);
                  result.push(arg);
                  position = reader.currPosition + 1;
                }
                break;
            }
            reader.readCharAndSkipWhitespace();
          }
        }
        if (position < reader.currPosition) {
          let arg = str.substring(position, reader.currPosition);
          result.push(arg);
        }
        return result;
      }
    }

    class WGSLTranslator {
      result;
      ASTRoot;
      _syntax;
      constructor(syntax) {
        this.result = "";
        this._syntax = syntax;
        this.ASTRoot = syntax.ASTRoot;
      }
      /**
       * Generate WGSL code
       * @returns WGSL code
       */
      generateWGSL() {
        let context = new TranslatorContext();
        var result = new ShaderConverterResult();
        let layoutsBuffer = [];
        let layoutsUniform = [];
        let statements = [];
        for (let item of this.ASTRoot.nodes) {
          if (item instanceof SN_Layout) {
            if (item.scope == "in") {
              if (item.nodes[0] instanceof SN_Declaration) {
                context.layoutsIn.push(item);
                let info = new ShaderAttributeInfo();
                info.name = item.nodes[0].name;
                info.type = item.nodes[0].type;
                info.locationID = Number.parseInt(item.qualifier.get("location"));
                result.inputAttribute.push(info);
              } else if (item.qualifier.has("local_size_x")) {
                context.workGroupSize = item;
              } else throw "not impl";
            } else if (item.scope == "out") {
              context.layoutsOut.push(item);
              if (item.nodes[0] instanceof SN_Declaration) {
                let info = new ShaderAttributeInfo();
                info.name = item.nodes[0].name;
                info.type = item.nodes[0].type;
                info.locationID = Number.parseInt(item.qualifier.get("location"));
                result.outputAttribute.push(info);
              } else throw "not impl";
            } else if (item.scope == "uniform") {
              layoutsUniform.push(item);
              if (item.nodes[0] instanceof SN_Declaration) {
                let info = new ShaderUniformInfo();
                info.name = item.nodes[0].name;
                info.type = item.nodes[0].type;
                info.setID = Number.parseInt(item.qualifier.get("set"));
                info.bindingID = Number.parseInt(item.qualifier.get("binding"));
                result.uniformInfo.push(info);
              } else if (item.nodes[0] instanceof SN_Struct) {
                let info = new ShaderUniformInfo();
                info.name = "unif" + result.uniformInfo.length.toString();
                info.type = item.nodes[0].name;
                info.setID = Number.parseInt(item.qualifier.get("set"));
                info.bindingID = Number.parseInt(item.qualifier.get("binding"));
                result.uniformInfo.push(info);
              } else throw "not impl";
            } else if (item.scope == "buffer") {
              layoutsBuffer.push(item);
            }
          } else {
            statements.push(item);
          }
        }
        context.stage = "fragment";
        let position = 0;
        let reader = new Reader("");
        let source = this._syntax.lexer.source;
        let unique = /* @__PURE__ */ new Map();
        while ((position = source.indexOf("gl_", position)) != -1) {
          reader.reset(source.substring(position, position + 32));
          reader.readChar();
          let name = reader.readIdentifier();
          position += name.length;
          if (unique.has(name)) {
            continue;
          }
          unique.set(name, name);
          switch (name) {
            case "gl_InstanceID":
              context.stage = "vertex";
              context.builtinIn.push("@builtin(instance_index) gl_InstanceID: u32");
              break;
            case "gl_Position":
              context.stage = "vertex";
              context.builtinOut.push("@builtin(position) gl_Position: vec4<f32>");
              context.addIdentifier("gl_Position", "stout.gl_Position");
              break;
            case "gl_VertexIndex":
              context.stage = "vertex";
              context.builtinIn.push("@builtin(vertex_index) gl_VertexIndex: u32");
              break;
            case "gl_FrontFacing":
              context.stage = "fragment";
              context.builtinIn.push("@builtin(front_facing) gl_FrontFacing: bool");
              break;
            case "gl_FragDepth":
              context.stage = "fragment";
              context.builtinOut.push("@builtin(frag_depth) gl_FragDepth: f32");
              context.addIdentifier("gl_FragDepth", "stout.gl_FragDepth");
              break;
            case "gl_WorkGroupID":
              context.stage = "compute";
              context.builtinIn.push("@builtin(workgroup_id) gl_WorkGroupID: vec3<u32>");
              break;
            case "gl_NumWorkGroups":
              context.stage = "compute";
              context.builtinIn.push("@builtin(num_workgroups) gl_NumWorkGroups: vec3<u32>");
              break;
            case "gl_LocalInvocationID":
              context.stage = "compute";
              context.builtinIn.push("@builtin(local_invocation_id) gl_LocalInvocationID: vec3<u32>");
              break;
            case "gl_LocalInvocationIndex":
              context.stage = "compute";
              context.builtinIn.push("@builtin(local_invocation_index) gl_LocalInvocationIndex: u32");
              break;
            case "gl_GlobalInvocationID":
              context.stage = "compute";
              context.builtinIn.push("@builtin(global_invocation_id) gl_GlobalInvocationID: vec3<u32>");
              break;
            default:
              throw "Unprocessed built-in variables: " + name;
          }
        }
        for (let item of layoutsUniform) {
          if (item.nodes[0] instanceof SN_Struct) {
            result.sourceCode += item.nodes[0].formatToWGSL(context, 0);
            result.sourceCode += "\r\n";
          }
        }
        for (let item of layoutsUniform) {
          result.sourceCode += item.formatToWGSL(context, 0);
        }
        result.sourceCode += "\r\n";
        for (let item of layoutsBuffer) {
          if (item.nodes[0] instanceof SN_Struct) {
            result.sourceCode += item.nodes[0].formatToWGSL(context, 0);
            result.sourceCode += "\r\n";
          }
        }
        for (let item of layoutsBuffer) {
          result.sourceCode += item.formatToWGSL(context, 0);
        }
        result.sourceCode += "\r\n";
        for (let item of statements) {
          result.sourceCode += item.formatToWGSL(context, 0);
          if (item instanceof SN_Declaration) {
            result.sourceCode += ";\r\n";
          }
        }
        return result;
      }
    }
    class TranslatorContext {
      _stage = "fragment";
      _builtinIn = [];
      _builtinOut = [];
      _layoutsIn = [];
      _layoutsOut = [];
      _layoutUniformCount = 0;
      _workGroupSize = void 0;
      _parentContext;
      _identifierEnv = /* @__PURE__ */ new Map();
      constructor(context) {
        this._parentContext = context;
      }
      get stage() {
        if (this.parentContext != void 0) {
          return this.parentContext.stage;
        }
        return this._stage;
      }
      set stage(value) {
        if (this.parentContext != void 0) {
          this.parentContext.stage = value;
        }
        this._stage = value;
      }
      get builtinIn() {
        if (this.parentContext != void 0) {
          return this.parentContext.builtinIn;
        }
        return this._builtinIn;
      }
      get builtinOut() {
        if (this.parentContext != void 0) {
          return this.parentContext.builtinOut;
        }
        return this._builtinOut;
      }
      get layoutsIn() {
        if (this.parentContext != void 0) {
          return this.parentContext.layoutsIn;
        }
        return this._layoutsIn;
      }
      get layoutsOut() {
        if (this.parentContext != void 0) {
          return this.parentContext.layoutsOut;
        }
        return this._layoutsOut;
      }
      get layoutUniformCount() {
        if (this.parentContext != void 0) {
          return this.parentContext.layoutUniformCount;
        }
        return this._layoutUniformCount;
      }
      set layoutUniformCount(value) {
        if (this.parentContext != void 0) {
          this.parentContext.layoutUniformCount = value;
          return;
        }
        this._layoutUniformCount = value;
      }
      get workGroupSize() {
        if (this.parentContext != void 0) {
          return this.parentContext.workGroupSize;
        }
        return this._workGroupSize;
      }
      set workGroupSize(value) {
        if (this.parentContext != void 0) {
          this.parentContext.workGroupSize = value;
        }
        this._workGroupSize = value;
      }
      get parentContext() {
        return this._parentContext;
      }
      findIdentifier(name) {
        if (this._identifierEnv.has(name)) {
          return this._identifierEnv.get(name);
        }
        if (this._parentContext != void 0) {
          return this._parentContext.findIdentifier(name);
        }
        return name;
      }
      addIdentifier(name, value) {
        this._identifierEnv.set(name, value);
      }
      hasIdentifier(name) {
        return this._identifierEnv.has(name);
      }
    }

    class StatementNode {
      nodes = [];
      constructor() {
      }
      addNode(node) {
        this.nodes.push(node);
      }
      formatToWGSL(context, depth) {
        return "";
      }
    }
    class SN_Struct extends StatementNode {
      name = "";
      fields = [];
      constructor(name) {
        super();
        this.name = name;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.LEFTBIG) {
          let result = new SN_Struct(r.peekToken(0).Literal);
          r.skipToken(2);
          while (r.peekToken(0).Type != TokenType.RIGHTBIG) {
            let field = SN_Declaration.parse(r);
            result.fields.push(field);
          }
          if (r.peekToken(0).Type == TokenType.RIGHTBIG) {
            r.skipToken(1);
          }
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
          }
          return result;
        }
        throw "Error parsing structure: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        result += prefix + "struct " + this.name + " {\r\n";
        for (let field of this.fields) {
          if (field.arraySize.nodes.length <= 0) {
            result += prefix + "  " + field.name + ": " + toWGSLType(field.type) + ",\r\n";
          } else {
            if (field.arraySize.nodes[0] instanceof SN_Constant) {
              result += prefix + "  " + field.name + ": array<" + toWGSLType(field.type) + ", " + field.arraySize.nodes[0].value + ">,\r\n";
            } else {
              result += prefix + "  " + field.name + ": array<" + toWGSLType(field.type) + ", " + field.arraySize.nodes[0].formatToWGSL(context, 0) + ">,\r\n";
            }
          }
        }
        result += prefix + "};\r\n";
        return result;
      }
    }
    class SN_Function extends StatementNode {
      name;
      args;
      body;
      returnType;
      constructor(name, args, body, returnType) {
        super();
        this.name = name;
        this.args = args;
        this.body = body;
        this.returnType = returnType;
      }
      static parse(r) {
        if ((r.peekToken(0).isBuiltinType() || r.peekToken(0).Type == TokenType.VOID) && r.peekToken(1).Type == TokenType.IDENT && r.peekToken(2).Type == TokenType.LEFTSAMLL) {
          let returnType = r.peekToken(0).Literal;
          let name = r.peekToken(1).Literal;
          r.skipToken(2);
          let args = new Array();
          if (r.peekToken(0).Type != TokenType.LEFTSAMLL) {
            throw "Error parsing function parameter list: Unexpected character";
          } else {
            r.skipToken(1);
            while (r.peekToken(0).Type != TokenType.EOF) {
              if (r.peekToken(0).Type == TokenType.RIGHTSAMLL) {
                r.skipToken(1);
                break;
              }
              if (r.peekToken(0).Type == TokenType.INOUT) {
                r.skipToken(1);
              } else if (r.peekToken(0).Type == TokenType.IN) {
                r.skipToken(1);
              } else if (r.peekToken(0).Type == TokenType.OUT) {
                r.skipToken(1);
              }
              let arg = SN_Declaration.parse(r);
              args.push(arg);
              if (r.peekToken(0).Type == TokenType.COMMA) {
                r.skipToken(1);
              }
            }
          }
          let body = SN_CodeBlock.parse(r);
          return new SN_Function(name, args, body, returnType);
        }
        throw "Error parsing function: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        let outStructName;
        let hasOutStruct = context.layoutsOut.length > 0 || context.builtinOut.length > 0;
        switch (context.stage) {
          case "compute":
            outStructName = "ComputeOutput";
            break;
          case "vertex":
            outStructName = "VertexOutput";
            break;
          case "fragment":
            outStructName = "FragmentOutput";
            break;
          default:
            outStructName = "StructOutput";
            break;
        }
        if (this.name == "main" && hasOutStruct) {
          result += "struct " + outStructName + " {\r\n";
          for (let item of context.layoutsOut) {
            if (item.nodes[0] instanceof SN_Declaration) {
              let arg = item.nodes[0];
              if (item.qualifier.size == 1 && item.qualifier.has("location")) {
                result += "  @location(" + item.qualifier.get("location") + ") ";
              }
              result += arg.name + ": " + toWGSLType(arg.type) + ",\r\n";
              context.addIdentifier(arg.name, "stout." + arg.name);
            }
          }
          let builtinOut = context.builtinOut;
          for (let item of builtinOut) {
            result += "  " + item + ",\r\n";
          }
          result += "};\r\n\r\n";
        }
        let header = "";
        if (this.name == "main") {
          if (context.workGroupSize != void 0) {
            header += "@" + context.stage + " " + context.workGroupSize.formatToWGSL(context, 0) + " \r\n";
          } else {
            header += "@" + context.stage + "\r\n";
          }
        }
        context = new TranslatorContext(context);
        header += prefix + "fn " + this.name + "(";
        if (this.name != "main") {
          for (let i = 0; i < this.args.length; i++) {
            let arg = this.args[i];
            if (i > 0) {
              header += ", ";
            }
            header += arg.name + ": " + toWGSLType(arg.type);
            context.addIdentifier(arg.name, arg.name);
          }
          header += ") -> " + toWGSLType(this.returnType);
        } else {
          let layoutsIn = context.layoutsIn;
          for (let i = 0; i < layoutsIn.length; i++) {
            let item = layoutsIn[i];
            if (i > 0) {
              header += ",\r\n    ";
            } else {
              header += "\r\n    ";
            }
            if (item.nodes[0] instanceof SN_Declaration) {
              let arg = item.nodes[0];
              if (item.qualifier.size == 1 && item.qualifier.has("location")) {
                header += "@location(" + item.qualifier.get("location") + ") ";
              }
              header += arg.name + ": " + toWGSLType(arg.type);
              context.addIdentifier(arg.name, arg.name);
            }
          }
          if (layoutsIn.length > 0) {
            header += ",\r\n    ";
          }
          let builtinIn = context.builtinIn;
          for (let item of builtinIn) {
            header += item + ",\r\n    ";
          }
          if (hasOutStruct) {
            header += ") -> " + outStructName;
          } else {
            header += ") ";
          }
        }
        let bodyResult = "";
        if (this.name == "main" && hasOutStruct) {
          bodyResult += "    var stout: " + outStructName + " ;\r\n";
        }
        for (let statement of this.body.nodes) {
          bodyResult += statement.formatToWGSL(context, depth + 1);
          if (!(statement instanceof SN_IFBranch) && !(statement instanceof SN_WhileLoop) && !(statement instanceof SN_ForLoop)) {
            bodyResult += ";\r\n";
          }
        }
        if (this.name == "main" && hasOutStruct) {
          bodyResult += "    return stout;\r\n";
        }
        result += header + " {\r\n";
        result += bodyResult;
        result += prefix + "}\r\n";
        result += "\r\n";
        return result;
      }
    }
    class SN_FunctionArgs extends StatementNode {
      args = [];
      constructor() {
        super();
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.LEFTSAMLL) {
          r.skipToken(1);
          let result = new SN_FunctionArgs();
          while (r.peekToken(0).Type != TokenType.EOF) {
            if (r.peekToken(0).Type == TokenType.RIGHTSAMLL) {
              r.skipToken(1);
              break;
            }
            let arg = SN_Expression.parse(r);
            result.args.push(arg);
            if (r.peekToken(0).Type == TokenType.COMMA) {
              r.skipToken(1);
            }
          }
          return result;
        }
        throw "Error parsing function argument table: Unexpected character";
      }
    }
    class SN_FunctionCall extends StatementNode {
      name;
      args;
      constructor(name, args) {
        super();
        this.name = name;
        this.args = args;
      }
      static parse(r) {
        if (r.peekToken(0).isDataType() && r.peekToken(1).Type == TokenType.LEFTSAMLL) {
          let name = r.peekToken(0).Literal;
          r.skipToken(1);
          let args = SN_FunctionArgs.parse(r);
          return new SN_FunctionCall(name, args);
        }
        throw "Error parsing function argument table: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        if (this.name == "texture" && this.args.args[0].nodes[0] instanceof SN_FunctionCall) {
          let callNode = this.args.args[0].nodes[0];
          if (callNode.name == "sampler2D") {
            result += prefix + "textureSample(";
            for (let i = 0; i < callNode.args.args.length; i++) {
              let arg = callNode.args.args[i];
              if (i > 0) {
                result += ", ";
              }
              result += arg.formatToWGSL(context, 0);
            }
            for (let i = 1; i < this.args.args.length; i++) {
              let arg = this.args.args[i];
              if (i > 0) {
                result += ", ";
              }
              result += arg.formatToWGSL(context, 0);
            }
            result += ")";
            return result;
          }
        }
        result += prefix + toWGSLType(this.name) + "(";
        for (let i = 0; i < this.args.args.length; i++) {
          let arg = this.args.args[i];
          if (i > 0) {
            result += ", ";
          }
          result += arg.formatToWGSL(context, 0);
        }
        result += ")";
        return result;
      }
    }
    class SN_Declaration extends StatementNode {
      type;
      name;
      arraySize;
      hasIn;
      hasOut;
      hasConst;
      constructor(type, name, arraySize = new SN_Expression()) {
        super();
        this.type = type;
        this.name = name;
        this.hasIn = false;
        this.hasOut = false;
        this.hasConst = false;
        this.arraySize = arraySize;
      }
      static parse(r) {
        let result = new SN_Declaration("", "");
        let first = r.peekToken(0);
        if (first.Type == TokenType.CONST) {
          r.skipToken(1);
          result.hasConst = true;
        } else if (first.Type == TokenType.IN) {
          r.skipToken(1);
          result.hasIn = true;
        } else if (first.Type == TokenType.OUT) {
          r.skipToken(1);
          result.hasOut = true;
        } else if (first.Type == TokenType.INOUT) {
          r.skipToken(1);
          result.hasIn = true;
          result.hasOut = true;
        } else if (!first.isDataType()) {
          throw "Error parsing declaration expression: Unexpected character(" + first.Literal + ")";
        }
        first = r.peekToken(0);
        if (first.isDataType() && r.peekToken(1).Type == TokenType.LEFTMEDI) {
          result.type = first.Literal;
          r.skipToken(2);
          result.arraySize = SN_Expression.parse(r);
          if (r.peekToken(0).Type == TokenType.RIGHTMEDI) {
            r.skipToken(1);
          }
          if (r.peekToken(0).Type != TokenType.IDENT) {
            throw "Unexpected";
          }
          result.name = r.peekToken(0).Literal;
          r.skipToken(1);
        } else if (first.isDataType() && r.peekToken(1).Type == TokenType.IDENT && r.peekToken(2).Type == TokenType.LEFTMEDI) {
          result.type = r.peekToken(0).Literal;
          result.name = r.peekToken(1).Literal;
          r.skipToken(3);
          if (r.peekToken(0).Type == TokenType.RIGHTMEDI) {
            r.skipToken(1);
          } else {
            result.arraySize = SN_Expression.parse(r);
            if (r.peekToken(0).Type == TokenType.RIGHTMEDI) {
              r.skipToken(1);
            }
          }
        } else if (first.isDataType() && r.peekToken(1).Type == TokenType.IDENT) {
          result.type = r.peekToken(0).Literal;
          result.name = r.peekToken(1).Literal;
          r.skipToken(2);
        } else throw "Error parsing declaration expression: Unexpected character(" + first.Literal + ")";
        first = r.peekToken(0);
        if (first.Type == TokenType.SEMICOLON) {
          r.skipToken(1);
          return result;
        } else if (first.Type == TokenType.RIGHTSAMLL) {
          return result;
        } else if (first.Type == TokenType.ASSIGN) {
          let op = r.peekToken(0);
          r.skipToken(1);
          let lValue = new SN_Identifier(result.name);
          let rValue = SN_Expression.parse(r);
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
          }
          result.addNode(new SN_BinaryOperation(op, lValue, rValue));
          return result;
        } else if (first.Type == TokenType.COMMA) {
          while (r.peekToken(0).Type == TokenType.COMMA && r.peekToken(1).Type == TokenType.IDENT) {
            let declaration = new SN_Declaration(result.type, r.peekToken(1).Literal);
            result.addNode(declaration);
            r.skipToken(2);
            if (r.peekToken(0).Type == TokenType.ASSIGN) {
              r.skipToken(-1);
              declaration.addNode(SN_Expression.parse(r));
            }
          }
          return result;
        }
        throw "Error parsing declaration expression: Unexpected character(" + r.peekToken(0).Literal + ")";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        if (this.hasConst) {
          result += prefix + "let ";
        } else {
          result += prefix + "var ";
        }
        context.addIdentifier(this.name, this.name);
        if (this.arraySize.nodes.length <= 0) {
          result += this.name + ": " + toWGSLType(this.type);
        } else {
          if (this.arraySize.nodes[0] instanceof SN_Constant) {
            result += this.name + ": array<" + toWGSLType(this.type) + ", " + this.arraySize.nodes[0].value + ">";
          } else {
            result += this.name + ": array<" + toWGSLType(this.type) + ", " + this.arraySize.nodes[0].formatToWGSL(context, 0) + ">";
          }
        }
        if (this.nodes.length > 0 && this.nodes[0] instanceof SN_BinaryOperation) {
          result += " = " + this.nodes[0].rightValue.formatToWGSL(context, 0);
        } else if (this.nodes.length > 0 && this.nodes[0] instanceof SN_Expression && this.nodes[0].nodes[0] instanceof SN_BinaryOperation) {
          result += " = " + this.nodes[0].nodes[0].rightValue.formatToWGSL(context, 0);
        } else if (this.nodes.length > 0 && this.nodes[0] instanceof SN_Declaration) {
          result += ";\r\n";
          for (let item of this.nodes) {
            result += item.formatToWGSL(context, depth) + ";\r\n";
          }
        } else {
          result += ";\r\n";
        }
        return result;
      }
    }
    class SN_ForLoop extends StatementNode {
      expression1;
      condition;
      expression2;
      loopBody;
      constructor(expression1, condition, expression2, loopBody) {
        super();
        this.expression1 = expression1;
        this.condition = condition;
        this.expression2 = expression2;
        this.loopBody = loopBody;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.FOR && r.peekToken(1).Type == TokenType.LEFTSAMLL) {
          r.skipToken(2);
          let expression1;
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
            expression1 = new SN_Expression();
          } else if (r.peekToken(0).isDataType() && r.peekToken(1).Type == TokenType.IDENT && r.peekToken(2).Type == TokenType.ASSIGN) {
            expression1 = new SN_Declaration(r.peekToken(0).Literal, r.peekToken(1).Literal);
            r.skipToken(1);
            expression1.addNode(SN_Expression.parse(r));
            if (r.peekToken(0).Type == TokenType.SEMICOLON) {
              r.skipToken(1);
            }
          } else {
            expression1 = SN_Expression.parse(r);
            if (r.peekToken(0).Type == TokenType.SEMICOLON) {
              r.skipToken(1);
            }
          }
          let condition;
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
            condition = new SN_Expression();
          } else {
            condition = SN_Expression.parse(r);
            if (r.peekToken(0).Type == TokenType.SEMICOLON) {
              r.skipToken(1);
            }
          }
          let expression2;
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
            expression2 = new SN_Expression();
          } else {
            expression2 = SN_Expression.parse(r);
            if (r.peekToken(0).Type == TokenType.SEMICOLON) {
              r.skipToken(1);
            }
          }
          if (r.peekToken(0).Type == TokenType.RIGHTSAMLL) {
            r.skipToken(1);
          }
          let loopBody;
          if (r.peekToken(0).Type == TokenType.LEFTBIG) {
            loopBody = SN_CodeBlock.parse(r);
          } else {
            loopBody = new SN_CodeBlock();
          }
          return new SN_ForLoop(expression1, condition, expression2, loopBody);
        }
        throw "Error parsing for loop: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        result += prefix + "for (";
        result += this.expression1.formatToWGSL(context, 0) + "; ";
        result += this.condition.formatToWGSL(context, 0) + "; ";
        result += this.expression2.formatToWGSL(context, 0) + ")";
        result += " { \r\n";
        for (let item of this.loopBody.nodes) {
          result += item.formatToWGSL(context, depth + 1);
          if (!(item instanceof SN_IFBranch) && !(item instanceof SN_WhileLoop) && !(item instanceof SN_ForLoop)) {
            result += ";\r\n";
          }
        }
        result += prefix + "} \r\n";
        return result;
      }
    }
    class SN_WhileLoop extends StatementNode {
      conditionExpr;
      loopBody;
      constructor(condition, loopBody) {
        super();
        this.conditionExpr = condition;
        this.loopBody = loopBody;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.WHILE) {
          r.skipToken(1);
          if (r.peekToken(0).Type == TokenType.LEFTSAMLL) {
            r.skipToken(1);
          }
          let condition = SN_Expression.parse(r);
          if (r.peekToken(0).Type == TokenType.RIGHTSAMLL) {
            r.skipToken(1);
          }
          let loopBody = SN_CodeBlock.parse(r);
          return new SN_WhileLoop(condition, loopBody);
        }
        throw "Error parsing while loop: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        result += prefix + "loop {\r\n";
        result += prefix + "    if (" + this.conditionExpr.formatToWGSL(context, 0) + ") { break; }\r\n\r\n";
        for (let item of this.loopBody.nodes) {
          result += item.formatToWGSL(context, depth + 1);
          if (!(item instanceof SN_IFBranch) && !(item instanceof SN_WhileLoop) && !(item instanceof SN_ForLoop)) {
            result += ";\r\n";
          }
        }
        result += prefix + "}\r\n";
        return result;
      }
    }
    class SN_DoWhileLoop extends StatementNode {
      constructor() {
        super();
      }
    }
    class SN_IFBranch extends StatementNode {
      conditionExpr;
      trueBranch;
      falseBranch;
      constructor(condition, trueBranch, falseBranch) {
        super();
        this.conditionExpr = condition;
        this.trueBranch = trueBranch;
        this.falseBranch = falseBranch;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.IF) {
          r.skipToken(1);
          if (r.peekToken(0).Type == TokenType.LEFTSAMLL) {
            r.skipToken(1);
          }
          let condition = SN_Expression.parse(r);
          let trueBranch;
          let falseBranch = new SN_CodeBlock();
          if (r.peekToken(0).Type == TokenType.RIGHTSAMLL) {
            r.skipToken(1);
          }
          if (r.peekToken(0).Type == TokenType.LEFTBIG) {
            trueBranch = SN_CodeBlock.parse(r);
          } else {
            trueBranch = new SN_CodeBlock();
            if (r.peekToken(0).Type == TokenType.RETURN) {
              trueBranch.addNode(SN_Return.parse(r));
            } else {
              trueBranch.addNode(SN_Expression.parse(r));
            }
          }
          if (r.peekToken(0).Type == TokenType.ELSE) {
            r.skipToken(1);
            if (r.peekToken(0).Type == TokenType.LEFTBIG) {
              falseBranch = SN_CodeBlock.parse(r);
            } else throw "not impl";
          }
          return new SN_IFBranch(condition, trueBranch, falseBranch);
        }
        throw "Error parsing IF branch statement: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let resultl = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        resultl += prefix + "if (" + this.conditionExpr.formatToWGSL(context, 0) + ") {\r\n";
        for (let item of this.trueBranch.nodes) {
          resultl += item.formatToWGSL(context, depth + 1) + ";\r\n";
        }
        if (this.falseBranch.nodes.length > 0) {
          resultl += prefix + "} else {\r\n";
          for (let item of this.falseBranch.nodes) {
            resultl += item.formatToWGSL(context, depth + 1) + ";\r\n";
          }
        }
        resultl += prefix + "}\r\n";
        return resultl;
      }
    }
    class SN_Expression extends StatementNode {
      constructor() {
        super();
      }
      static parse(r) {
        let opStack = new Array();
        let valueStack = new Array();
        let nSamllCount = 0;
        while (r.peekToken(0).Type != TokenType.EOF) {
          let currToken = r.peekToken(0);
          if (currToken.Type == TokenType.SEMICOLON || currToken.Type == TokenType.RIGHTMEDI) {
            break;
          }
          if (currToken.Type == TokenType.COMMA || currToken.Type == TokenType.COLON || currToken.Type == TokenType.RIGHTBIG) {
            break;
          }
          if (!currToken.isOperation()) {
            if (currToken.Type == TokenType.LITERAL) {
              valueStack.push(new SN_Constant(currToken.Literal));
              r.skipToken(1);
              continue;
            } else if (currToken.Type == TokenType.LEFTSAMLL) {
              nSamllCount++;
              opStack.push(currToken);
              r.skipToken(1);
              continue;
            } else if (currToken.Type == TokenType.RIGHTSAMLL) {
              if (nSamllCount <= 0) {
                break;
              }
              nSamllCount--;
              while (SN_Expression.unionOperation(opStack, valueStack)) ;
              if (opStack[opStack.length - 1].Type == TokenType.LEFTSAMLL) {
                opStack.pop();
                let parenExpr = new SN_ParenExpression();
                parenExpr.addNode(valueStack.pop());
                valueStack.push(parenExpr);
              }
              r.skipToken(1);
              continue;
            } else if (currToken.Type == TokenType.IDENT) {
              if (r.peekToken(1).Type == TokenType.INC || r.peekToken(1).Type == TokenType.DEC) {
                let op = r.peekToken(1);
                let value = new SN_Identifier(currToken.Literal);
                valueStack.push(new SN_UnaryOperation(op, value, void 0));
                r.skipToken(2);
                continue;
              } else if (r.peekToken(1).Type == TokenType.LEFTSAMLL) {
                valueStack.push(SN_FunctionCall.parse(r));
                continue;
              } else if (r.peekToken(1).Type == TokenType.DOT) {
                valueStack.push(SN_SelectOperation.parse(r));
                continue;
              } else if (r.peekToken(1).Type == TokenType.LEFTMEDI) {
                valueStack.push(SN_IndexOperation.parse(r));
                continue;
              }
              valueStack.push(new SN_Identifier(currToken.Literal));
              r.skipToken(1);
              continue;
            } else {
              if (currToken.isBuiltinType() && r.peekToken(1).Type == TokenType.LEFTSAMLL) {
                valueStack.push(SN_FunctionCall.parse(r));
                continue;
              }
              if (currToken.isAssignOperation()) {
                let op = currToken;
                r.skipToken(1);
                let lValue = valueStack.pop();
                let rValue = SN_Expression.parse(r);
                valueStack.push(new SN_BinaryOperation(op, lValue, rValue));
                continue;
              }
              if (currToken.Type == TokenType.LEFTBIG && (r.peekToken(1).Type == TokenType.LITERAL || r.peekToken(1).Type == TokenType.SUB && r.peekToken(2).Type == TokenType.LITERAL)) {
                valueStack.push(SN_ArrayConstant.parse(r));
                continue;
              }
              if (currToken.Type == TokenType.QUEMARK) {
                if (opStack.length > 0) {
                  let opToken = opStack[opStack.length - 1];
                  if (opToken.nOperationPriorityLevel <= currToken.nOperationPriorityLevel) {
                    SN_Expression.unionOperation(opStack, valueStack);
                  }
                }
                r.skipToken(1);
                let a = valueStack.pop();
                let b = SN_Expression.parse(r);
                if (r.peekToken(0).Type == TokenType.COLON) {
                  r.skipToken(1);
                }
                let c = SN_Expression.parse(r);
                valueStack.push(new SN_TernaryOperation(a, b, c));
                if (r.peekToken(-1).Type == TokenType.SEMICOLON) {
                  break;
                }
                continue;
              }
              if (currToken.Type == TokenType.LEFTMEDI) {
                r.skipToken(1);
                let indexValue = SN_Expression.parse(r);
                if (r.peekToken(0).Type == TokenType.RIGHTMEDI) {
                  r.skipToken(1);
                }
                let lValue = valueStack.pop();
                valueStack.push(new SN_IndexOperation(lValue, indexValue));
                continue;
              }
              throw "An unexpected character";
            }
          } else if (currToken.isOperation()) {
            if (currToken.Type == TokenType.INC || currToken.Type == TokenType.DEC) {
              let op = currToken;
              r.skipToken(1);
              let value = SN_Expression.parse(r);
              valueStack.push(new SN_UnaryOperation(op, void 0, value));
              continue;
            } else if (opStack.length > 0) {
              let opToken = opStack[opStack.length - 1];
              if (opToken.nOperationPriorityLevel <= currToken.nOperationPriorityLevel) {
                SN_Expression.unionOperation(opStack, valueStack);
              } else if (opStack.length > 0 && opStack[opStack.length - 1].Literal == "-") {
                let op = opStack.pop();
                let v1 = valueStack.pop();
                valueStack.push(new SN_UnaryOperation(op, void 0, v1));
              }
            }
            opStack.push(currToken);
            r.skipToken(1);
          }
        }
        while (opStack.length > 0 && SN_Expression.unionOperation(opStack, valueStack)) ;
        if (opStack.length <= 0 && valueStack.length == 1) {
          let expr = new SN_Expression();
          expr.addNode(valueStack.pop());
          return expr;
        }
        throw "Error parsing expression: Unexpected character(" + r.peekToken(0).Literal + ")";
      }
      formatToWGSL(context, depth) {
        return this.nodes[0].formatToWGSL(context, depth);
      }
      static unionOperation(opStack, valueStack) {
        if (opStack.length < 0 || valueStack.length < 2) {
          if (opStack.length > 0 && opStack[opStack.length - 1].Literal == "-") {
            let op = opStack.pop();
            let v1 = valueStack.pop();
            valueStack.push(new SN_UnaryOperation(op, void 0, v1));
            return true;
          }
          return false;
        }
        if (opStack[opStack.length - 1].isOperation()) {
          let v2 = valueStack.pop();
          let op = opStack.pop();
          let v1 = valueStack.pop();
          if (op.Type == TokenType.DOT) {
            valueStack.push(new SN_SelectOperation(v1, v2));
          } else {
            valueStack.push(new SN_BinaryOperation(op, v1, v2));
          }
          return true;
        }
        return false;
      }
    }
    class SN_ParenExpression extends StatementNode {
      constructor() {
        super();
      }
      formatToWGSL(context, depth) {
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        let result = prefix + "(" + this.nodes[0].formatToWGSL(context, 0) + ")";
        return result;
      }
    }
    class SN_Identifier extends StatementNode {
      name;
      constructor(name) {
        super();
        this.name = name;
      }
      formatToWGSL(context, depth) {
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        return prefix + context.findIdentifier(this.name);
      }
    }
    class SN_Constant extends StatementNode {
      value;
      constructor(value) {
        super();
        this.value = value;
      }
      static parse(r) {
        let firstToken = r.peekToken(0);
        if (firstToken.Type == TokenType.SUB && r.peekToken(1).Type == TokenType.LITERAL) {
          let result = new SN_Constant("-" + r.peekToken(1).Literal);
          r.skipToken(2);
          return result;
        } else if (firstToken.Type == TokenType.LITERAL) {
          let result = new SN_Constant(firstToken.Literal);
          r.skipToken(1);
          return result;
        }
        throw "Error parsing literal constants: Unexpected characters(" + firstToken.Literal + ")";
      }
      formatToWGSL(context, depth) {
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        return prefix + this.value;
      }
    }
    class SN_ArrayConstant extends SN_Constant {
      arrayValue;
      constructor(value) {
        super("");
        this.arrayValue = value;
      }
      static parse(r) {
        if (
          // { 1, 2, 3, 4 }
          r.peekToken(0).Type == TokenType.LEFTBIG && r.peekToken(1).Type == TokenType.LITERAL || // { -1, 2, 3, 4 }
          r.peekToken(0).Type == TokenType.LEFTBIG && r.peekToken(1).Type == TokenType.SUB && r.peekToken(2).Type == TokenType.LITERAL
        ) {
          r.skipToken(1);
          let arrayValue = [];
          while (r.peekToken(0).Type != TokenType.RIGHTBIG) {
            if (r.peekToken(0).Type == TokenType.LEFTSAMLL) {
              arrayValue.push(SN_ArrayConstant.parse(r));
              continue;
            }
            arrayValue.push(SN_Constant.parse(r));
            if (r.peekToken(0).Type == TokenType.COMMA) {
              r.skipToken(1);
              continue;
            } else if (r.peekToken(0).Type == TokenType.RIGHTBIG) {
              r.skipToken(1);
              break;
            } else throw "Error parsing array constants: Unexpected characters";
          }
          return new SN_ArrayConstant(arrayValue);
        }
        throw "Error parsing array constants: Unexpected characters";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        if (this.arrayValue[0].value.includes(".")) {
          result += prefix + "array<f32, " + this.arrayValue.length.toString() + ">(";
        } else {
          result += prefix + "array<i32, " + this.arrayValue.length.toString() + ">(";
        }
        for (let i = 0; i < this.arrayValue.length; i++) {
          if (i > 0) {
            result += ", ";
          }
          result += this.arrayValue[i].formatToWGSL(context, 0);
        }
        result += ")";
        return result;
      }
    }
    class SN_Break extends StatementNode {
      constructor() {
        super();
      }
    }
    class SN_Discard extends StatementNode {
      constructor() {
        super();
      }
    }
    class SN_Continue extends StatementNode {
      constructor() {
        super();
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.CONTINUE && r.peekToken(1).Type == TokenType.SEMICOLON) {
          r.skipToken(2);
          return new SN_Continue();
        }
        throw "Error parsing continue: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        result += prefix + "continue";
        return result;
      }
    }
    class SN_Return extends StatementNode {
      value;
      constructor(value) {
        super();
        this.value = value;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.RETURN) {
          r.skipToken(1);
          let expr = SN_Expression.parse(r);
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
          }
          return new SN_Return(expr);
        }
        throw "Error parsing return expression: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        result += prefix + "return " + this.value.formatToWGSL(context, 0);
        return result;
      }
    }
    class SN_UnaryOperation extends StatementNode {
      op;
      leftValue;
      rightValue;
      constructor(op, lValue, rValue) {
        super();
        this.op = op;
        this.leftValue = lValue;
        this.rightValue = rValue;
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        if (this.op.Literal == "++" || this.op.Literal == "--") {
          if (this.leftValue != void 0) {
            let lValue = this.leftValue.formatToWGSL(context, 0);
            result += prefix + lValue + " = " + lValue + " " + this.op.Literal[0] + " 1";
          } else {
            let rValue = this.rightValue.formatToWGSL(context, 0);
            result += prefix + rValue + " = " + rValue + " " + this.op.Literal[0] + " 1";
          }
        } else {
          if (this.leftValue != void 0) {
            result += prefix + this.leftValue.formatToWGSL(context, 0) + this.op.Literal;
          } else {
            result += prefix + this.op.Literal + this.rightValue.formatToWGSL(context, 0);
          }
        }
        return result;
      }
    }
    class SN_BinaryOperation extends StatementNode {
      op;
      leftValue;
      rightValue;
      constructor(op, lValue, rValue) {
        super();
        this.op = op;
        this.leftValue = lValue;
        this.rightValue = rValue;
      }
      formatToWGSL(context, depth) {
        let result = "";
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        result += prefix + this.leftValue.formatToWGSL(context, 0) + " " + this.op.Literal + " " + this.rightValue.formatToWGSL(context, 0);
        return result;
      }
    }
    class SN_TernaryOperation extends StatementNode {
      condition;
      expression1;
      expression2;
      constructor(condition, expression1, expression2) {
        super();
        this.condition = condition;
        this.expression1 = expression1;
        this.expression2 = expression2;
      }
      static parse(r) {
        throw "Error parsing ternary operation expression: Unexpected character";
      }
      formatToWGSL(context, depth) {
        return "";
      }
    }
    class SN_SelectOperation extends StatementNode {
      leftValue;
      rightValue;
      constructor(lValue, rValue) {
        super();
        this.leftValue = lValue;
        this.rightValue = rValue;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.DOT && r.peekToken(2).Type == TokenType.IDENT) {
          let lValue = new SN_Identifier(r.peekToken(0).Literal);
          let rValue = new SN_Identifier(r.peekToken(2).Literal);
          r.skipToken(3);
          return new SN_SelectOperation(lValue, rValue);
        }
        throw "Error parsing selection expression: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        return prefix + this.leftValue.formatToWGSL(context, 0) + "." + this.rightValue.formatToWGSL(context, 0);
      }
    }
    class SN_IndexOperation extends StatementNode {
      leftValue;
      indexValue;
      constructor(lValue, indexValue) {
        super();
        this.leftValue = lValue;
        this.indexValue = indexValue;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.LEFTMEDI) {
          let lValue = new SN_Identifier(r.peekToken(0).Literal);
          r.skipToken(2);
          let indexValue = SN_Expression.parse(r);
          if (r.peekToken(0).Type == TokenType.RIGHTMEDI) {
            r.skipToken(1);
          }
          let result = new SN_IndexOperation(lValue, indexValue);
          while (r.peekToken(0).Type == TokenType.LEFTMEDI) {
            r.skipToken(1);
            indexValue = SN_Expression.parse(r);
            if (r.peekToken(0).Type == TokenType.RIGHTMEDI) {
              r.skipToken(1);
            }
            result = new SN_IndexOperation(result, indexValue);
          }
          return result;
        }
        throw "Error parsing index expression: Unexpected character";
      }
      formatToWGSL(context, depth) {
        let prefix = depth <= 0 ? "" : "    ".repeat(depth);
        return prefix + this.leftValue.formatToWGSL(context, 0) + "[" + this.indexValue.formatToWGSL(context, 0) + "]";
      }
    }
    class SN_CodeBlock extends StatementNode {
      constructor() {
        super();
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.LEFTBIG) {
          r.skipToken(1);
          let result = new SN_CodeBlock();
          for (let count = 1; count > 0 && r.peekToken(0).Type != TokenType.EOF; ) {
            let currToken = r.peekToken(0);
            if (currToken.Type == TokenType.LEFTBIG) {
              count++;
              r.skipToken(1);
              continue;
            }
            if (currToken.Type == TokenType.RIGHTBIG) {
              count--;
              r.skipToken(1);
              continue;
            }
            if (currToken.Type == TokenType.SEMICOLON) {
              r.skipToken(1);
              continue;
            }
            if (currToken.isDataType() && r.peekToken(1).Type == TokenType.IDENT) {
              result.addNode(SN_Declaration.parse(r));
              continue;
            }
            if (currToken.Type == TokenType.CONST && r.peekToken(1).isDataType() && r.peekToken(2).Type == TokenType.IDENT) {
              result.addNode(SN_Declaration.parse(r));
              continue;
            } else if (
              /**
               * assignment expression
               * a = ...;
               */
              currToken.Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.ASSIGN
            ) {
              result.addNode(SN_Expression.parse(r));
              if (r.peekToken(0).Type == TokenType.SEMICOLON) {
                r.skipToken(1);
              }
              continue;
            } else if (
              /**
               * Expression of index
               * a[...]
               */
              currToken.Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.LEFTMEDI
            ) {
              let indexOperation = SN_IndexOperation.parse(r);
              if (r.peekToken(0).Type == TokenType.ASSIGN) {
                let op = r.peekToken(0);
                r.skipToken(1);
                let rValue = SN_Expression.parse(r);
                if (r.peekToken(0).Type == TokenType.RIGHTMEDI) {
                  r.skipToken(1);
                }
                result.addNode(new SN_BinaryOperation(op, indexOperation, rValue));
                continue;
              }
              result.addNode(indexOperation);
              continue;
            } else if (
              /**
               * Expression of choice
               * a.b
               */
              currToken.Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.DOT
            ) {
              let expr = SN_Expression.parse(r);
              result.addNode(expr);
              continue;
            } else if (
              /**
               * Assignment operation expression
               * a += ...;
               */
              currToken.Type == TokenType.IDENT && r.peekToken(1).isAssignOperation()
            ) {
              let op = r.peekToken(1);
              let lValue = new SN_Identifier(currToken.Literal);
              r.skipToken(2);
              let rValue = SN_Expression.parse(r);
              if (r.peekToken(0).Type == TokenType.SEMICOLON) {
                r.skipToken(1);
              }
              result.addNode(new SN_BinaryOperation(op, lValue, rValue));
              continue;
            } else if (
              /**
               * After the increase, after the decrease
               * a++;
               */
              currToken.Type == TokenType.IDENT && (r.peekToken(1).Type == TokenType.INC || r.peekToken(1).Type == TokenType.DEC) && r.peekToken(2).Type == TokenType.SEMICOLON
            ) {
              let op = r.peekToken(1);
              result.addNode(new SN_UnaryOperation(op, new SN_Identifier(currToken.Literal), void 0));
              r.skipToken(3);
              continue;
            } else if (currToken.Type == TokenType.RETURN) {
              result.addNode(SN_Return.parse(r));
              continue;
            } else if (currToken.Type == TokenType.CONTINUE) {
              result.addNode(SN_Continue.parse(r));
              continue;
            } else if (currToken.Type == TokenType.WHILE) {
              result.addNode(SN_WhileLoop.parse(r));
              continue;
            } else if (currToken.Type == TokenType.FOR) {
              result.addNode(SN_ForLoop.parse(r));
              continue;
            } else if (currToken.Type == TokenType.IF) {
              result.addNode(SN_IFBranch.parse(r));
              continue;
            } else if (
              /**
               * function call
               */
              currToken.Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.LEFTSAMLL
            ) {
              result.addNode(SN_FunctionCall.parse(r));
              if (r.peekToken(0).Type == TokenType.SEMICOLON) {
                r.skipToken(0);
              }
              continue;
            }
            throw "Error parsing block: Unexpected symbol(" + currToken.Literal + ")";
          }
          return result;
        }
        throw "Error parsing block: Unexpected symbol";
      }
    }
    class SN_Precision extends StatementNode {
      type;
      qualifier;
      constructor(qualifier, type) {
        super();
        this.type = type;
        this.qualifier = qualifier;
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.PRECISION && r.peekToken(1).Type == TokenType.IDENT && r.peekToken(2).isBuiltinType()) {
          let result = new SN_Precision(r.peekToken(1).Literal, r.peekToken(2).Literal);
          r.skipToken(3);
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
          }
          return result;
        }
        throw "Error parsing precision qualifier: Unexpected character";
      }
      formatToWGSL(context, depth) {
        return "";
      }
    }
    class SN_Layout extends StatementNode {
      scope = "";
      qualifier = /* @__PURE__ */ new Map();
      constructor() {
        super();
      }
      addQualifier(name, value = "") {
        this.qualifier.set(name, value);
      }
      static parse(r) {
        if (r.peekToken(0).Type == TokenType.LAYOUT && r.peekToken(1).Type == TokenType.LEFTSAMLL) {
          let result = new SN_Layout();
          r.skipToken(2);
          do {
            let currToken = r.peekToken(0);
            if (currToken.Type == TokenType.IDENT) {
              if (r.peekToken(1).Type == TokenType.ASSIGN && r.peekToken(2).Type == TokenType.LITERAL) {
                let name = r.peekToken(0).Literal;
                let value = r.peekToken(2).Literal;
                result.addQualifier(name, value);
                r.skipToken(3);
                if (r.peekToken(0).Type == TokenType.COMMA) {
                  r.skipToken(1);
                  continue;
                }
                let token = r.peekToken(0);
                token.Line = 0;
              } else if (r.peekToken(1).Type == TokenType.RIGHTSAMLL) {
                let name = r.peekToken(0).Literal;
                result.addQualifier(name, "");
                r.skipToken(1);
                break;
              } else if (r.peekToken(1).Type == TokenType.COMMA) {
                let name = r.peekToken(0).Literal;
                result.addQualifier(name, "");
                r.skipToken(2);
                continue;
              }
            }
          } while (r.peekToken(0).Type != TokenType.RIGHTSAMLL);
          if (r.peekToken(0).Type == TokenType.RIGHTSAMLL) {
            r.skipToken(1);
          }
          result.scope = r.peekToken(0).Literal;
          r.skipToken(1);
          if (r.peekToken(0).Type == TokenType.SEMICOLON) {
            r.skipToken(1);
            return result;
          } else if (r.peekToken(0).isBuiltinType() && r.peekToken(1).Type == TokenType.IDENT && r.peekToken(2).Type == TokenType.SEMICOLON) {
            let node = new SN_Declaration(r.peekToken(0).Literal, r.peekToken(1).Literal);
            result.addNode(node);
            r.skipToken(3);
            return result;
          } else if (r.peekToken(0).Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.LEFTBIG) {
            let structNode = SN_Struct.parse(r);
            result.addNode(structNode);
            if (r.peekToken(0).Type == TokenType.IDENT && r.peekToken(1).Type == TokenType.SEMICOLON) {
              structNode.addNode(new SN_Declaration(structNode.name, r.peekToken(0).Literal));
              r.skipToken(2);
            }
            return result;
          } else throw "Error parsing layout qualifier type: Unexpected symbol(" + r.peekToken(0).Literal + ")";
        }
        throw "Error parsing layout qualifier: Unexpected symbol";
      }
      formatToWGSL(context, depth) {
        let result = "";
        if (this.qualifier.size == 1 && this.qualifier.has("location")) {
          result += "@location(" + this.qualifier.get("location") + ") ";
        } else if (this.qualifier.size == 2 && this.qualifier.has("set") && this.qualifier.has("binding")) {
          result += "@group(" + this.qualifier.get("set") + ") @binding(" + this.qualifier.get("binding") + ") ";
        } else if (this.qualifier.size >= 1 && this.qualifier.has("binding")) {
          result += "@group(0) @binding(" + this.qualifier.get("binding") + ") ";
        } else if (this.qualifier.size == 1 && this.qualifier.has("push_constant")) {
          result += "@push_constant ";
        } else if (this.qualifier.size >= 1 && this.qualifier.has("local_size_x")) {
          result += "@workgroup_size(";
          result += this.qualifier.get("local_size_x") + ", ";
          result += this.qualifier.has("local_size_y") ? this.qualifier.get("local_size_y") + ", " : "1, ";
          result += this.qualifier.has("local_size_z") ? this.qualifier.get("local_size_z") + "" : "1";
          result += ")";
        } else if (this.nodes.length <= 0) {
          return "";
        }
        let item = this.nodes[0];
        if (item instanceof SN_Declaration) {
          switch (item.type) {
            case "sampler":
            case "texture2D":
              result += "var ";
              break;
            default:
              if (this.scope == "buffer") {
                if (context.stage == "compute") {
                  result += "var<storage, read_write> ";
                } else {
                  result += "var<storage, read> ";
                }
              } else {
                result += "var<" + this.scope + "> ";
              }
              break;
          }
          context.addIdentifier(item.name, item.name);
          result += item.name + ": " + toWGSLType(item.type) + ";\r\n";
        } else if (item instanceof SN_Struct) {
          if (this.scope == "buffer") {
            if (context.stage == "compute") {
              result += "var<storage, read_write> ";
            } else {
              result += "var<storage, read> ";
            }
          } else {
            result += "var<" + this.scope + "> ";
          }
          if (item.nodes.length <= 0) {
            let rename = "unif" + context.layoutUniformCount.toString();
            while (context.hasIdentifier(rename)) {
              context.layoutUniformCount++;
              rename = "unif" + context.layoutUniformCount.toString();
            }
            for (let field of item.fields) {
              context.addIdentifier(field.name, rename + "." + field.name);
            }
            result += rename + ": " + item.name + ";\r\n";
            context.layoutUniformCount++;
          } else {
            let declaration = item.nodes[0];
            result += declaration.name + ": " + declaration.type + ";\r\n";
          }
          return result;
        }
        return result;
      }
    }
    function toWGSLType(type) {
      switch (type) {
        case "int":
          return "i32";
        case "int[]":
          return "array<i32>";
        case "uint":
          return "u32";
        case "uint[]":
          return "array<u32>";
        case "float":
          return "f32";
        case "float[]":
          return "array<f32>";
        case "vec2":
          return "vec2<f32>";
        case "vec3":
          return "vec3<f32>";
        case "vec4":
          return "vec4<f32>";
        case "vec2[]":
          return "array<vec2<f32>>";
        case "vec3[]":
          return "array<vec3<f32>>";
        case "vec4[]":
          return "array<vec4<f32>>";
        case "ivec2":
          return "vec2<i32>";
        case "ivec3":
          return "vec3<i32>";
        case "ivec4":
          return "vec4<i32>";
        case "ivec2[]":
          return "array<vec2<i32>>";
        case "ivec3[]":
          return "array<vec3<i32>>";
        case "ivec4[]":
          return "array<vec4<i32>>";
        case "mat2":
          return "mat2x2<f32>";
        case "mat2x2":
          return "mat2x2<f32>";
        case "mat2x3":
          return "mat2x3<f32>";
        case "mat2x4":
          return "mat2x4<f32>";
        case "mat2[]":
          return "array<mat2x2<f32>>";
        case "mat2x2[]":
          return "array<mat2x2<f32>>";
        case "mat2x3[]":
          return "array<mat2x3<f32>>";
        case "mat2x4[]":
          return "array<mat2x4<f32>>";
        case "mat3":
          return "mat3x3<f32>";
        case "mat3x2":
          return "mat3x2<f32>";
        case "mat3x3":
          return "mat3x3<f32>";
        case "mat3x4":
          return "mat3x4<f32>";
        case "mat3[]":
          return "array<mat3x3<f32>>";
        case "mat3x2[]":
          return "array<mat3x2<f32>>";
        case "mat3x3[]":
          return "array<mat3x3<f32>>";
        case "mat3x4[]":
          return "array<mat3x4<f32>>";
        case "mat4":
          return "mat4x4<f32>";
        case "mat4x2":
          return "mat4x2<f32>";
        case "mat4x3":
          return "mat4x3<f32>";
        case "mat4x4":
          return "mat4x4<f32>";
        case "mat4[]":
          return "array<mat4x4<f32>>";
        case "mat4x2[]":
          return "array<mat4x2<f32>>";
        case "mat4x3[]":
          return "array<mat4x3<f32>>";
        case "mat4x4[]":
          return "array<mat4x4<f32>>";
        case "texture2D":
          return "texture_2d<f32>";
      }
      return type;
    }

    class GLSLSyntax {
      _lexer;
      _rootNode;
      constructor(input) {
        this._lexer = input;
        this._rootNode = new StatementNode();
        this.parse();
      }
      get lexer() {
        return this._lexer;
      }
      parse() {
        while (this.peekToken(0).Type !== TokenType.EOF) {
          if (this.peekToken(0).Type == TokenType.SEMICOLON) {
            this.skipToken(1);
            continue;
          }
          let node = this.parseStatement();
          if (node !== null) {
            this._rootNode.addNode(node);
          }
        }
      }
      parseStatement() {
        let first = this.peekToken();
        if (first.Type == TokenType.LAYOUT && this.peekToken(1).Type == TokenType.LEFTSAMLL) {
          let layoutNode = SN_Layout.parse(this._lexer);
          return layoutNode;
        } else if (first.Type == TokenType.STRUCT) {
          this.skipToken(1);
          let structNode = SN_Struct.parse(this._lexer);
          return structNode;
        } else if (
          /**
           * function declaration
           */
          (first.isBuiltinType() || first.Type == TokenType.VOID) && this.peekToken(1).Type == TokenType.IDENT && this.peekToken(2).Type == TokenType.LEFTSAMLL
        ) {
          let functionDec = SN_Function.parse(this._lexer);
          return functionDec;
        } else if (
          /**
           * Constant declaration
           * const int a = ...;
           */
          first.Type == TokenType.CONST && this.peekToken(1).isDataType()
        ) {
          let declarationNode = SN_Declaration.parse(this._lexer);
          return declarationNode;
        } else if (
          /**
           * Declaration of variables
           * int a = ...;
           */
          first.isDataType() && this.peekToken(1).Type == TokenType.IDENT
        ) {
          let declarationNode = SN_Declaration.parse(this._lexer);
          return declarationNode;
        } else if (
          /**
           * Declaration of variables
           * out float a = ...;
           */
          first.Type == TokenType.OUT && this.peekToken(1).isDataType() && this.peekToken(2).Type == TokenType.IDENT
        ) {
          let declarationNode = SN_Declaration.parse(this._lexer);
          return declarationNode;
        } else if (first.Type == TokenType.PRECISION) {
          let precisionNode = SN_Precision.parse(this._lexer);
          return precisionNode;
        }
        throw "Error parsing statement: Unexpected character";
      }
      skipToken(offset) {
        this._lexer.skipToken(offset);
      }
      peekToken(offset = 0) {
        return this._lexer.peekToken(offset);
      }
      getNextToken() {
        return this._lexer.GetNextToken();
      }
      get ASTRoot() {
        return this._rootNode;
      }
    }

    class ShaderConverter {
      /**
       * Shader type: Vertex stage
       */
      static VertexShader = "VertexShader";
      /**
       * Shader type: Fragment stage
       */
      static FragmentShader = "FragmentShader";
      /**
       * Convert GLSL code to WGSL
       * @param source GLSL
       * @returns WGSL
       */
      static convertGLSL(source) {
        var preprocessor = new GLSLPreprocessor(source);
        var lexer = new GLSLLexer(preprocessor);
        var syntax = new GLSLSyntax(lexer);
        var translator = new WGSLTranslator(syntax);
        return translator.generateWGSL();
      }
    }
    class ShaderUniformInfo {
      setID = 0;
      bindingID = 0;
      name = "";
      type = "";
    }
    class ShaderAttributeInfo {
      name = "";
      type = "";
      locationID = 0;
      builtinName = "";
      isBuiltinAttribute() {
        return this.builtinName != "";
      }
    }
    class ShaderConverterResult {
      uniformInfo = [];
      inputAttribute = [];
      outputAttribute = [];
      sourceCode = "";
    }

    var ShaderStage = /* @__PURE__ */ ((ShaderStage2) => {
      ShaderStage2[ShaderStage2["vertex"] = 0] = "vertex";
      ShaderStage2[ShaderStage2["fragment"] = 1] = "fragment";
      ShaderStage2[ShaderStage2["computer"] = 2] = "computer";
      return ShaderStage2;
    })(ShaderStage || {});

    class ShaderState {
      blendMode = BlendMode.NONE;
      depthCompare = GPUCompareFunction.less_equal;
      depthWriteEnabled = true;
      frontFace = `ccw`;
      cullMode = GPUCullMode.back;
      topology = GPUPrimitiveTopology.triangle_list;
      depthBias = 0;
      depthBiasSlopeScale = 0;
      depthBiasClamp = 0;
      stencilFront = {
        compare: GPUCompareFunction.always,
        failOp: GPUStencilOperation.keep,
        depthFailOp: GPUStencilOperation.keep,
        passOp: GPUStencilOperation.keep
      };
      stencilBack = {
        compare: GPUCompareFunction.always,
        failOp: GPUStencilOperation.keep,
        depthFailOp: GPUStencilOperation.keep,
        passOp: GPUStencilOperation.keep
      };
      stencilReadMask = 255;
      stencilWriteMask = 255;
      stencilRef = 0;
      useLight = false;
      useProbe = false;
      acceptGI = false;
      acceptShadow = false;
      castShadow = false;
      castReflection = true;
      receiveEnv = false;
      renderOrder = 2e3;
      unclippedDepth = false;
      transparent = false;
      multisample = 0;
      alphaToCoverageEnabled = false;
      label;
      useZ = true;
      splitTexture = false;
      alphaCutoff;
      useFragDepth = false;
      writeMasks = [];
      setFromMapValues(values) {
        if (values.has("blendMode")) {
          this.blendMode = this.convertBlendMode(values.get("blendMode"));
        }
        if (values.has("depthCompare")) {
          this.depthCompare = values.get("depthCompare");
        }
        if (values.has("depthWriteEnabled")) {
          this.depthWriteEnabled = values.get("depthWriteEnabled");
        }
        if (values.has("frontFace")) {
          this.frontFace = values.get("frontFace");
        }
        if (values.has("cullMode")) {
          this.cullMode = values.get("cullMode");
        }
        if (values.has("topology")) {
          this.topology = values.get("topology");
        }
        if (values.has("depthBias")) {
          this.depthBias = values.get("depthBias");
        }
        if (values.has("depthBiasSlopeScale")) {
          this.depthBiasSlopeScale = values.get("depthBiasSlopeScale");
        }
        if (values.has("depthBiasClamp")) {
          this.depthBiasClamp = values.get("depthBiasClamp");
        }
        if (values.has("useLight")) {
          this.useLight = values.get("useLight");
        }
        if (values.has("useProbe")) {
          this.useProbe = values.get("useProbe");
        }
        if (values.has("acceptGI")) {
          this.acceptGI = values.get("acceptGI");
        }
        if (values.has("acceptShadow")) {
          this.acceptShadow = values.get("acceptShadow");
        }
        if (values.has("castShadow")) {
          this.castShadow = values.get("castShadow");
        }
        if (values.has("receiveEnv")) {
          this.receiveEnv = values.get("receiveEnv");
        }
        if (values.has("renderOrder")) {
          this.renderOrder = values.get("renderOrder");
        }
        if (values.has("unclippedDepth")) {
          this.unclippedDepth = values.get("unclippedDepth");
        }
        if (values.has("multisample")) {
          this.multisample = values.get("multisample");
        }
        if (values.has("alphaToCoverageEnabled")) {
          this.alphaToCoverageEnabled = values.get("alphaToCoverageEnabled");
        }
        if (values.has("label")) {
          this.label = values.get("label");
        }
        if (values.has("useZ")) {
          this.useZ = values.get("useZ");
        }
      }
      convertBlendMode(value) {
        switch (value) {
          case "ABOVE":
            return BlendMode.ABOVE;
          case "ALPHA":
            return BlendMode.ALPHA;
          case "NORMAL":
            return BlendMode.NORMAL;
          case "ADD":
            return BlendMode.ADD;
          case "BELOW":
            return BlendMode.BELOW;
          case "ERASE":
            return BlendMode.ERASE;
          case "MUL":
            return BlendMode.MUL;
          case "SCREEN":
            return BlendMode.SCREEN;
          case "DIVD":
            return BlendMode.DIVD;
          case "SOFT_ADD":
            return BlendMode.SOFT_ADD;
        }
        return BlendMode.NONE;
      }
    }

    class MaterialDataUniformGPUBuffer extends GPUBufferBase {
      uniformNodes = [];
      _onChange = true;
      constructor() {
        super();
        this.bufferType = GPUBufferType.MaterialDataUniformGPUBuffer;
      }
      /**
       * Initialize bound shader base variables
       * The array of variables is automatically mapped through the parameters of the shader reflection
       * @param uniformNodes 
       * @see UniformNode
       */
      initDataUniform(uniformNodes) {
        this.uniformNodes = uniformNodes;
        let len = 0;
        for (const key in uniformNodes) {
          const node = uniformNodes[key];
          if (!node) {
            console.error(key, "is empty");
          }
          len += node.size * 4;
        }
        len = Math.floor(len / 256 + 1) * 256;
        this.createBuffer(GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST, len / 4, null, "MaterialDataUniformGPUBuffer");
        for (const key in uniformNodes) {
          const node = uniformNodes[key];
          if (!node) console.error(key, "is empty");
          let memoryInfo = this.memory.allocation_node(node.size * 4);
          node.memoryInfo = memoryInfo;
          node.bindOnChange = () => this.onChange();
        }
      }
      onChange() {
        this._onChange = true;
      }
      /**
       * Reapply and write to buffer
       * @returns
       */
      apply(ctx) {
        if (this.uniformNodes.length == 0) return;
        if (!this._onChange) return;
        for (const key in this.uniformNodes) {
          const node = this.uniformNodes[key];
          node.update();
        }
        super.apply(ctx);
        this._onChange = false;
      }
    }

    class ShaderUtil {
      /**
       * Per-Context3D shader state accessors. Device-bound GPU shader modules
       * are keyed per-device; the RenderShaderPass cache is also per-device
       * (since the passes internally hold device-bound pipelines).
       */
      static renderShaderModulePool(ctx) {
        return this._state(ctx).renderShaderModulePool;
      }
      /**
       * Get the per-context cache of render shader passes.
       * @param ctx the rendering context
       */
      static renderShader(ctx) {
        return this._state(ctx).renderShader;
      }
      static _state(ctx) {
        return ctx.cache(ShaderUtil, () => ({
          renderShaderModulePool: /* @__PURE__ */ new Map(),
          renderShader: /* @__PURE__ */ new Map()
        }));
      }
      /**
       * Initialize the per-context shader state caches.
       * @param ctx the rendering context
       */
      static init(ctx) {
        this._state(ctx);
      }
    }

    class Reference {
      reference;
      static _ins;
      /** Get the shared Reference singleton, creating it on first use. */
      static getInstance() {
        this._ins ||= new Reference();
        return this._ins;
      }
      /**
       * current instance attached from parent instance
       * @param ref reference current 
       * @param target reference parent
       */
      attached(ref, target) {
        this.reference ||= /* @__PURE__ */ new WeakMap();
        let refMap = this.reference.get(ref);
        refMap ||= /* @__PURE__ */ new Map();
        refMap.set(target, ref);
        this.reference.set(ref, refMap);
      }
      /**
       * current instance detached from parent instance
       * @param ref reference current 
       * @param target reference parent
       */
      detached(ref, target) {
        let refMap = this.reference.get(ref);
        if (refMap) {
          refMap.delete(target);
          if (refMap.size === 0) this.reference.delete(ref);
        }
      }
      /**
       * current instance has reference 
       */
      hasReference(ref) {
        let refMap = this.reference.get(ref);
        if (refMap) {
          return refMap.size > 0;
        }
        return false;
      }
      /**
       * get current instance reference count
       * @param ref 
       * @returns 
       */
      getReferenceCount(ref) {
        let refMap = this.reference.get(ref);
        if (refMap) {
          return refMap.size;
        }
        return 0;
      }
      /**
      * get current instance reference from where
      * @param ref 
      * @returns 
      */
      getReference(ref) {
        let refMap = this.reference.get(ref);
        if (refMap) {
          return refMap;
        }
        return null;
      }
    }

    class PipelinePool {
      static map(ctx) {
        return ctx.cache(PipelinePool, () => /* @__PURE__ */ new Map());
      }
      /**
       * Get a shared render pipeline for the given shader variant, or null if not cached.
       * @param ctx the rendering context
       * @param shaderVariant the shader variant key
       */
      static getSharePipeline(ctx, shaderVariant) {
        let pipeline = this.map(ctx).get(shaderVariant);
        if (pipeline) {
          return pipeline;
        } else {
          return null;
        }
      }
      static setSharePipeline(ctx, shaderVariant, pipeline) {
        this.map(ctx).set(shaderVariant, pipeline);
      }
    }

    class RenderShaderPass extends ShaderPassBase {
      /**
       * The type of pass (color, shadow, OIT accumulation, depth peel, …).
       */
      passType = PassType.COLOR;
      /**
       * Whether this pass participates in the reverse-Z depth pipeline.
       */
      useRz = false;
      /**
       * Vertex shader name
       */
      vsName;
      /**
       * Fragment shader name
       */
      fsName;
      /**
       * State of the shader
       */
      shaderState;
      /**
       * The collection of textures used in shading
       */
      textures;
      /**
       * Render pipeline. Plan B: one pipeline per RenderShaderPass, bound to
       * a single Context3D. Attempts to use this pass with a second engine
       * throw via bindCtx.
       */
      pipeline = null;
      /**
       * BindGroup layouts (single-field, bound to one Context3D)
       */
      bindGroupLayouts = [];
      /**
       * Environment cube map used for image-based lighting.
       */
      envMap;
      /**
       * Pre-filtered environment map used for specular IBL.
       */
      prefilterMap;
      /**
       * Reflection cube map used for environment reflections.
       */
      reflectionMap;
      _sourceVS;
      _sourceFS;
      _destVS;
      _destFS;
      _vsShaderModule;
      _fsShaderModule;
      _textureGroup = -1;
      _textureChange = false;
      _groupsShaderReflectionVarInfos;
      /**
       * Per-channel write mask applied to the pass's output buffer.
       */
      outBufferMask;
      /**
       * @param vs Vertex shader name (must be registered in ShaderLib).
       * @param fs Fragment shader name (must be registered in ShaderLib).
       */
      constructor(vs, fs) {
        super();
        this.vsName = vs.toLowerCase();
        this.fsName = fs.toLowerCase();
        if (!(this.vsName in ShaderLib)) {
          console.error(`Shader Not Register, Please Register Shader!`, this.vsName);
        }
        if (!(this.fsName in ShaderLib)) {
          console.error(`Shader Not Register, Please Register Shader!`, this.fsName);
        }
        if (ShaderLib[this.vsName]) {
          this._sourceVS = ShaderLib[this.vsName];
        }
        if (ShaderLib[this.fsName]) {
          this._sourceFS = ShaderLib[this.fsName];
        }
        this.textures = {};
        this.bindGroups = [];
        this.shaderState = new ShaderState();
        this.materialDataUniformBuffer = new MaterialDataUniformGPUBuffer();
        this.materialDataUniformBuffer.visibility = GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT;
        this._bufferDic.set(`global`, this.materialDataUniformBuffer);
        this._bufferDic.set(`materialUniform`, this.materialDataUniformBuffer);
      }
      /**
       * Blend mode
       */
      get renderOrder() {
        return this.shaderState.renderOrder;
      }
      set renderOrder(value) {
        if (this.shaderState.renderOrder != value) {
          this._valueChange = true;
        }
        this.shaderState.renderOrder = value;
      }
      /**
          * Cull mode
          */
      get doubleSide() {
        return this.shaderState.cullMode == GPUCullMode.none;
      }
      set doubleSide(value) {
        let b = value ? GPUCullMode.none : this.cullMode;
        if (this.shaderState.cullMode != b) {
          this._valueChange = true;
        }
        this.shaderState.cullMode = b;
      }
      /**
       * depthWriteEnabled mode
       */
      get depthWriteEnabled() {
        return this.shaderState.depthWriteEnabled;
      }
      set depthWriteEnabled(value) {
        if (this.shaderState.depthWriteEnabled != value) {
          this._valueChange = true;
        }
        this.shaderState.depthWriteEnabled = value;
      }
      /**
       * get render face cull mode
       */
      get cullMode() {
        return this.shaderState.cullMode;
      }
      /**
       * set render face cull mode
       */
      set cullMode(value) {
        if (this.shaderState.cullMode != value) {
          this._valueChange = true;
        }
        this.shaderState.cullMode = value;
      }
      /**
       * get front face mode
       * @GPUFrontFace
       */
      get frontFace() {
        return this.shaderState.frontFace;
      }
      /**
       * set front face mode
       * @GPUFrontFace value
       */
      set frontFace(value) {
        if (this.shaderState.frontFace != value) {
          this._valueChange = true;
        }
        this.shaderState.frontFace = value;
      }
      /**
       * Depth bias
       */
      get depthBias() {
        return this.shaderState.depthBias;
      }
      set depthBias(value) {
        if (this.shaderState.depthBias != value) {
          this._valueChange = true;
        }
        this.shaderState.depthBias = value;
      }
      /**
       * Primitive topology
       */
      get topology() {
        return this.shaderState.topology;
      }
      set topology(value) {
        if (this.shaderState.topology != value) {
          this._valueChange = true;
        }
        this.shaderState.topology = value;
      }
      /**
       * Blend mode
       */
      get blendMode() {
        return this.shaderState.blendMode;
      }
      set blendMode(value) {
        if (this.shaderState.blendMode != value) {
          this._valueChange = true;
          if (value != BlendMode.NORMAL && value != BlendMode.NONE) {
            this.renderOrder = 3e3;
          }
        }
        this.shaderState.blendMode = value;
      }
      /**
       * Depth compare function
       */
      get depthCompare() {
        return this.shaderState.depthCompare;
      }
      set depthCompare(value) {
        if (this.shaderState.depthCompare != value) {
          this._valueChange = true;
        }
        this.shaderState.depthCompare = value;
      }
      /**
       * Stencil front face state
       */
      get stencilFront() {
        return this.shaderState.stencilFront;
      }
      set stencilFront(value) {
        this.shaderState.stencilFront = value;
        this._valueChange = true;
      }
      /**
       * Stencil back face state
       */
      get stencilBack() {
        return this.shaderState.stencilBack;
      }
      set stencilBack(value) {
        this.shaderState.stencilBack = value;
        this._valueChange = true;
      }
      /**
       * Stencil read mask
       */
      get stencilReadMask() {
        return this.shaderState.stencilReadMask;
      }
      set stencilReadMask(value) {
        if (this.shaderState.stencilReadMask != value) {
          this._valueChange = true;
        }
        this.shaderState.stencilReadMask = value;
      }
      /**
       * Stencil write mask
       */
      get stencilWriteMask() {
        return this.shaderState.stencilWriteMask;
      }
      set stencilWriteMask(value) {
        if (this.shaderState.stencilWriteMask != value) {
          this._valueChange = true;
        }
        this.shaderState.stencilWriteMask = value;
      }
      /**
       * Stencil reference value (used with setStencilReference)
       */
      get stencilRef() {
        return this.shaderState.stencilRef;
      }
      set stencilRef(value) {
        this.shaderState.stencilRef = value;
      }
      /**
       * Sets the entry point names for the RenderShader vertex phase and fragment phase
       * @param vsEntryPoint 
       * @param fsEntryPoint 
       */
      setShaderEntry(vsEntryPoint = "", fsEntryPoint = "") {
        this.vsEntryPoint = vsEntryPoint;
        this.fsEntryPoint = fsEntryPoint;
      }
      /**
       * 
       * @param String name 
       * @param UniformValue value 
       */
      setUniform(name, value) {
        super.setUniform(name, value);
        this.materialDataUniformBuffer.onChange();
      }
      /**
       * Set the texture used in the Render Shader code
       * @param name Name in the shader code
       * @param texture Texture object
       */
      setTexture(name, texture) {
        if (texture && this.textures[name] != texture) {
          const prev = this.textures[name];
          if (prev) {
            prev.unBindStateChange(this);
            Reference.getInstance().detached(prev, this);
          }
          this._textureChange = true;
          this.textures[name] = texture;
          Reference.getInstance().attached(texture, this);
          if (name == "envMap") {
            this.envMap = texture;
          } else if (name == "prefilterMap") {
            this.prefilterMap = texture;
          } else if (name == "reflectionMap") {
            this.reflectionMap = texture;
          }
          texture.bindStateChange(() => {
            this._textureChange = true;
          }, this);
        }
      }
      /**
       * Base color tint, backed by the `baseColor` uniform.
       */
      get baseColor() {
        return this.getUniform(`baseColor`);
      }
      set baseColor(value) {
        this.setUniform(`baseColor`, value);
      }
      /**
       * Get the texture used in the Render Shader code
       * @param name Name in the shader code
       * @returns Texture object
       */
      getTexture(name) {
        return this.textures[name];
      }
      /**
       * Declare that the material slot `name` should be sourced from a
       * Frame Graph resource handle rather than a pre-bound Texture.
       * Resolution is deferred until `resolveBindings(view)` runs — the
       * graph's resource pool may not have produced the GPUTexture yet
       * when the declaration happens.
       *
       * A frame-graph-aware feature can hand its material a named handle
       * at setup time, and the `RenderNode.nodeUpdate` path keeps working
       * in parallel. No behavior change when `declareBinding` is never
       * called.
       *
       * @param name   Shader-side texture binding name (e.g. `shadowMap`).
       * @param handleName  Frame Graph handle name (e.g. `_MainShadowMap`).
       */
      declareBinding(name, handleName) {
        if (!this._graphBindings) this._graphBindings = /* @__PURE__ */ new Map();
        this._graphBindings.set(name, handleName);
      }
      /**
       * Return the declared handle name for a material slot, or null
       * if the slot is not backed by a Frame Graph handle.
       */
      getDeclaredBinding(name) {
        return this._graphBindings?.get(name) ?? null;
      }
      /**
       * Walk declared bindings and push the current frame's resolved
       * textures into the material via `setTexture`. Safe to call
       * every frame — `setTexture` is a no-op when the resolved
       * texture is identity-equal to the previously bound one.
       *
       * No-op unless `view.renderGraph` is present (legacy path) and
       * the pool actually holds the declared resource.
       */
      resolveBindings(view) {
        if (!this._graphBindings) return;
        const graph = view.renderGraph;
        if (!graph) return;
        const pool = graph.pool;
        for (const [slot, handleName] of this._graphBindings) {
          if (!pool.has(handleName)) continue;
          const resource = pool.get(handleName);
          if (resource) this.setTexture(slot, resource);
        }
      }
      /** Map of `materialSlotName → frameGraphHandleName`. Created lazily
       *  the first time `declareBinding` is called; remains undefined
       *  for materials that do not use Frame Graph handles. */
      _graphBindings;
      /**
       * Create a rendering pipeline
       * @param geometry
       * @param renderPassState
       */
      genRenderPipeline(geometry, renderPassState) {
        let layouts = this.createGroupLayouts();
        this.createPipeline(geometry, renderPassState, layouts);
      }
      /**
       * Recompile the shader and create the rendering pipeline
       * @param geometry 
       * @param rendererPassState 
       */
      reBuild(geometry, rendererPassState) {
        this.compileShader(ShaderStage.vertex, this._destVS, rendererPassState);
        this.compileShader(ShaderStage.fragment, this._destFS, rendererPassState);
        geometry.generate(this.shaderReflection);
        this.genRenderPipeline(geometry, rendererPassState);
      }
      /**
       * Apply render shader state value 
       * @param geometry 
       * @param materialPass 
       * @param rendererPassState 
       * @param noticeFun 
       */
      apply(ctx, geometry, rendererPassState, noticeFun) {
        bindCtx(this, ctx);
        const wasFirstBuild = !this.pipeline;
        this.materialDataUniformBuffer.apply(ctx);
        if (this._valueChange || !this.pipeline) {
          if (this._shaderChange) {
            this.preCompile(geometry);
            this._shaderChange = false;
          }
          this.shaderVariant = ShaderReflection.genRenderShaderVariant(this);
          this.reBuild(geometry, rendererPassState);
          this._valueChange = false;
          if (noticeFun) {
            noticeFun();
          }
        }
        if (wasFirstBuild) {
          this.materialDataUniformBuffer.onChange();
          this.materialDataUniformBuffer.apply(ctx);
        }
        if (this._textureChange && this._textureGroup != -1) {
          this._textureChange = false;
          this.genGroups(this._textureGroup, this.shaderReflection.groups, true);
        }
      }
      /**
       * Precompile the shader code
       * @param geometry 
       */
      preCompile(geometry) {
        this.preDefine(geometry);
        this.preCompileShader(ShaderStage.vertex, this._sourceVS.concat());
        this.preCompileShader(ShaderStage.fragment, this._sourceFS.concat());
        this.genReflection();
      }
      /**
       * Apply defines syntax values
       * @param shader 
       * @param renderPassState 
       * @returns 
       */
      applyPostDefine(shader, renderPassState) {
        if (renderPassState.renderTargetTextures.length > 1) {
          this.defineValue[`USE_WORLDPOS`] = true;
          this.defineValue[`USEGBUFFER`] = true;
        } else {
          this.defineValue[`USE_WORLDPOS`] = false;
          this.defineValue[`USEGBUFFER`] = false;
        }
        if (this._boundCtx.engine.setting.render.useCompressGBuffer) {
          this.defineValue[`USE_COMPRESSGBUFFER`] = true;
        } else {
          this.defineValue[`USE_COMPRESSGBUFFER`] = false;
        }
        return Preprocessor.parse(shader, this.defineValue);
      }
      /**
       * Set GPUBindGroup to the specified index slot
       * @param groupIndex 
       * @param group 
       */
      setBindGroup(groupIndex, group) {
        this.bindGroups[groupIndex] = group;
      }
      /**
       * Hook for subclasses to validate a bound buffer; no-op by default.
       * @param _bufferName Name of the buffer binding.
       * @param _buffer The buffer instance.
       */
      checkBuffer(_bufferName, _buffer) {
        return;
      }
      /**
       * Pre-process shader source: convert GLSL to WGSL when needed and
       * substitute const placeholders, storing the result as the stage's
       * destination source.
       * @param stage Vertex or fragment stage.
       * @param code Raw shader source code.
       */
      preCompileShader(stage, code) {
        let shader = code;
        if (/^\s*#version\s+\d/m.test(shader)) {
          var wgsl = ShaderConverter.convertGLSL(shader);
          shader = wgsl.sourceCode;
        }
        for (const key in this.constValues) {
          if (Object.prototype.hasOwnProperty.call(this.constValues, key)) {
            const value = this.constValues[key];
            shader = shader.replaceAll(`&${key}`, value.toString());
          }
        }
        switch (stage) {
          case ShaderStage.vertex:
            this._destVS = shader;
            break;
          case ShaderStage.fragment:
            this._destFS = shader;
            break;
        }
      }
      /**
       * Apply post-defines and compile the shader stage into a (cached)
       * GPUShaderModule, storing it on the matching stage field.
       * @param stage Vertex or fragment stage.
       * @param code Pre-processed shader source code.
       * @param renderPassState Render pass state driving the post-defines.
       */
      compileShader(stage, code, renderPassState) {
        let shader = code;
        shader = this.applyPostDefine(shader, renderPassState);
        let key = code;
        for (let k in this.defineValue) {
          key += `${k}=${this.defineValue[k]},`;
        }
        const shaderModulePool = ShaderUtil.renderShaderModulePool(this._boundCtx);
        let shaderModule = shaderModulePool.get(key);
        if (!shaderModule) {
          shader = this.applyPostDefine(shader, renderPassState);
          const device = this._boundCtx.device;
          shaderModule = device.createShaderModule({
            label: stage == ShaderStage.vertex ? this.vsName : this.fsName,
            code: shader
          });
          shaderModule.getCompilationInfo().then((e) => {
            if (e.messages.length > 0) {
              console.error(shader);
              console.error(e);
            }
          });
          shaderModulePool.set(key, shaderModule);
        }
        switch (stage) {
          case ShaderStage.vertex:
            this._vsShaderModule = shaderModule;
            this._destVS = shader;
            break;
          case ShaderStage.fragment:
            this._fsShaderModule = shaderModule;
            this._destFS = shader;
            break;
        }
      }
      /**
       * Build the bind group layout entries for a single group from its
       * reflection info, resolving uniforms, storage buffers, samplers and
       * textures (falling back to default textures when unset).
       * @param index Bind group index.
       * @param infos Reflection variable infos for the group.
       * @returns The layout entries for the group.
       */
      getGroupLayout(index, infos) {
        let entries = [];
        for (let i = 0; i < infos.length; i++) {
          const info = infos[i];
          if (!info) {
            continue;
          }
          if (info.varType == `uniform`) {
            if (!this._bufferDic.has(info.varName)) {
              console.error(`not set ${info.varName} buffer`);
            }
            let visibility = this._bufferDic.get(info.varName).visibility;
            let entry = {
              binding: info.binding,
              visibility,
              buffer: {
                type: "uniform"
              }
            };
            entries.push(entry);
          } else if (info.varType == `storage-read`) {
            if (!this._bufferDic.has(info.varName)) {
              console.error(`not set ${info.varName} buffer`);
            }
            let visibility = this._bufferDic.get(info.varName).visibility;
            let entry = {
              binding: info.binding,
              visibility,
              buffer: {
                type: "read-only-storage"
              }
            };
            entries.push(entry);
          } else if (info.varType == `var`) {
            switch (info.dataType) {
              case `sampler`:
                {
                  let textureName = info.varName.replace(/Sampler(Raw|Cmp)?$/, ``);
                  let texture = this.textures[textureName] ? this.textures[textureName] : Engine3D.resFor(this._boundCtx).redTexture;
                  let entry = {
                    binding: info.binding,
                    visibility: texture.visibility,
                    sampler: texture.samplerBindingLayout
                  };
                  entries.push(entry);
                  this._textureGroup = index;
                }
                break;
              case `sampler_comparison`:
                {
                  let textureName = info.varName.replace(/Sampler(Raw|Cmp)?$/, ``);
                  let texture = this.textures[textureName] ? this.textures[textureName] : Engine3D.resFor(this._boundCtx).redTexture;
                  let entry = {
                    binding: info.binding,
                    visibility: texture.visibility,
                    sampler: texture.sampler_comparisonBindingLayout
                  };
                  entries.push(entry);
                  this._textureGroup = index;
                }
                break;
              case `texture_2d<f32>`:
              case `texture_2d_array<f32>`:
              case `texture_cube<f32>`:
              case `texture_depth_2d`:
              case `texture_depth_2d_array`:
              case `texture_depth_cube`:
              case `texture_depth_cube_array`:
                {
                  let texture = this.textures[info.varName] ? this.textures[info.varName] : Engine3D.resFor(this._boundCtx).redTexture;
                  let entry = {
                    binding: info.binding,
                    visibility: texture.visibility,
                    texture: texture.textureBindingLayout
                  };
                  entries.push(entry);
                  this._textureGroup = index;
                  Reference.getInstance().attached(texture, this);
                }
                break;
              case `texture_external`:
                {
                  let texture = this.textures[info.varName] ? this.textures[info.varName] : Engine3D.resFor(this._boundCtx).redTexture;
                  let entry = {
                    binding: info.binding,
                    visibility: texture.visibility,
                    externalTexture: {}
                  };
                  entries.push(entry);
                  this._textureGroup = index;
                  Reference.getInstance().attached(texture, this);
                }
                break;
              default:
                {
                  let texture = this.textures[info.varName] ? this.textures[info.varName] : Engine3D.resFor(this._boundCtx).redTexture;
                  let entry = {
                    binding: info.binding,
                    visibility: texture.visibility,
                    texture: texture.textureBindingLayout
                  };
                  entries.push(entry);
                  this._textureGroup = index;
                  Reference.getInstance().attached(texture, this);
                }
                break;
            }
          } else {
            debugger;
            console.error("bind group can't empty");
          }
        }
        return entries;
      }
      /**
       * Create the GPUBindGroup for a group from its reflection info,
       * binding the resolved buffers, samplers and texture views.
       * @param groupIndex Bind group index to (re)build.
       * @param infos Per-group reflection variable infos.
       * @param force Rebuild even if the bind group already exists.
       */
      genGroups(groupIndex, infos, force = false) {
        if (!this.bindGroups[groupIndex] || force) {
          const shaderRefs = infos[groupIndex];
          let entries = [];
          for (let j = 0; j < shaderRefs.length; j++) {
            const refs = shaderRefs[j];
            if (!refs) continue;
            if (refs.varType == `uniform`) {
              let buffer = this._bufferDic.get(refs.varName);
              if (buffer) {
                if (buffer.bufferType == GPUBufferType.MaterialDataUniformGPUBuffer) {
                  let uniforms = [];
                  for (let i = 0; i < refs.dataFields.length; i++) {
                    const field = refs.dataFields[i];
                    if (!this.uniforms[field.name]) {
                      console.error(`shader-${this.vsName}:${this.fsName} ${field.name}is empty`);
                    }
                    uniforms.push(this.uniforms[field.name]);
                  }
                  this.materialDataUniformBuffer.initDataUniform(uniforms);
                }
                if (!buffer._boundCtx && this._boundCtx) bindCtx(buffer, this._boundCtx);
                let entry = {
                  binding: refs.binding,
                  resource: {
                    buffer: buffer.buffer,
                    offset: 0,
                    //buffer.memory.shareFloat32Array.byteOffset,
                    size: buffer.memory.shareDataBuffer.byteLength
                  }
                };
                entries.push(entry);
                this.checkBuffer(refs.varName, buffer);
              } else {
                console.error(`shader${this.vsName}-${this.fsName}`, `buffer ${refs.varName} is missing!`);
              }
            } else if (refs.varType == `storage-read`) {
              let buffer = this._bufferDic.get(refs.varName);
              if (buffer) {
                if (!buffer._boundCtx && this._boundCtx) bindCtx(buffer, this._boundCtx);
                let entry = {
                  binding: refs.binding,
                  resource: {
                    buffer: buffer.buffer,
                    offset: 0,
                    //buffer.memory.shareFloat32Array.byteOffset,
                    size: buffer.memory.shareDataBuffer.byteLength
                  }
                };
                entries.push(entry);
                this.checkBuffer(refs.varName, buffer);
              } else {
                console.error(`buffer ${refs.varName} is missing!`);
              }
            } else if (refs.varType == `var`) {
              const bindIfNeeded = (t) => {
                if (t && !t._boundCtx && this._boundCtx) bindCtx(t, this._boundCtx);
              };
              if (refs.dataType == `sampler`) {
                let textureName = refs.varName.replace(/Sampler(Raw|Cmp)?$/, ``);
                let texture = this.textures[textureName];
                if (!texture) {
                  texture = Engine3D.resFor(this._boundCtx).blackTexture;
                  this.setTexture(textureName, texture);
                }
                if (texture) {
                  bindIfNeeded(texture);
                  let entry = {
                    binding: refs.binding,
                    resource: texture.gpuSampler
                  };
                  entries.push(entry);
                } else {
                  console.error(`shader${this.vsName}-${this.fsName}`, `texture ${refs.varName} is missing! `);
                }
              } else if (refs.dataType == `sampler_comparison`) {
                let textureName = refs.varName.replace(/Sampler(Raw|Cmp)?$/, ``);
                let texture = this.textures[textureName];
                if (texture) {
                  bindIfNeeded(texture);
                  let entry = {
                    binding: refs.binding,
                    resource: texture.gpuSampler_comparison
                  };
                  entries.push(entry);
                } else {
                  console.error(`shader${this.vsName}-${this.fsName}`, `texture ${refs.varName} is missing! `);
                }
              } else {
                let texture = this.textures[refs.varName];
                if (!texture) {
                  texture = Engine3D.resFor(this._boundCtx).whiteTexture;
                  this.setTexture(refs.varName, texture);
                }
                if (texture) {
                  bindIfNeeded(texture);
                  let entry = {
                    binding: refs.binding,
                    resource: texture.getGPUView()
                  };
                  entries.push(entry);
                } else {
                  console.error(`shader${this.vsName}-${this.fsName}`, `texture ${refs.varName} is missing! `);
                }
              }
            }
          }
          const device = this._boundCtx.device;
          let gpubindGroup = device.createBindGroup({
            layout: this.bindGroupLayouts[groupIndex],
            entries
          });
          this.bindGroups[groupIndex] = gpubindGroup;
        }
      }
      createPipeline(geometry, renderPassState, layouts) {
        let bufferMesh = geometry;
        let shaderState = this.shaderState;
        let targets = [];
        for (const tex of renderPassState.renderTargetTextures) {
          targets.push({
            format: tex.format
          });
        }
        for (let i = 0; i < targets.length; i++) {
          const rtTexState = targets[i];
          if (shaderState.writeMasks && shaderState.writeMasks.length > 0) {
            rtTexState.writeMask = shaderState.writeMasks[i];
          }
        }
        if (renderPassState.outColor != -1) {
          let target = targets[renderPassState.outColor];
          if (shaderState.blendMode != BlendMode.NONE) {
            target.blend = BlendFactor.getBlend(shaderState.blendMode);
          } else {
            delete target[`blend`];
          }
        }
        if (this.passType === PassType.OIT_ACCUM && targets.length >= 2) {
          targets[0].blend = {
            color: { srcFactor: "one", dstFactor: "one", operation: "add" },
            alpha: { srcFactor: "one", dstFactor: "one", operation: "add" }
          };
          targets[1].blend = {
            color: { srcFactor: "zero", dstFactor: "one-minus-src", operation: "add" },
            alpha: { srcFactor: "zero", dstFactor: "one-minus-src-alpha", operation: "add" }
          };
        }
        if (this.passType === PassType.OIT_DEPTH_PEEL_DEPTH && targets.length >= 1) {
          targets[0].blend = {
            color: { srcFactor: "one", dstFactor: "one", operation: "max" },
            alpha: { srcFactor: "one", dstFactor: "one", operation: "max" }
          };
        }
        if (this.passType === PassType.OIT_DEPTH_PEEL_FRONT && targets.length >= 1) {
          targets[0].blend = {
            color: { srcFactor: "one", dstFactor: "zero", operation: "add" },
            alpha: { srcFactor: "one", dstFactor: "zero", operation: "add" }
          };
        }
        if (this.passType === PassType.OIT_DEPTH_PEEL_BACK && targets.length >= 1) {
          targets[0].blend = {
            color: { srcFactor: "one-minus-dst-alpha", dstFactor: "one", operation: "add" },
            alpha: { srcFactor: "one-minus-dst-alpha", dstFactor: "one", operation: "add" }
          };
        }
        let renderPipelineDescriptor = {
          label: this.vsName + "|" + this.fsName,
          layout: layouts,
          primitive: {
            topology: shaderState.topology,
            cullMode: shaderState.cullMode,
            frontFace: shaderState.frontFace,
            unclippedDepth: shaderState.unclippedDepth
          },
          vertex: void 0
        };
        if (this.vsEntryPoint != ``) {
          renderPipelineDescriptor[`vertex`] = {
            module: this._vsShaderModule,
            entryPoint: this.vsEntryPoint,
            buffers: bufferMesh.vertexBuffer.getPipelineLayout(this.shaderReflection)
          };
        }
        if (this.fsEntryPoint != "") {
          renderPipelineDescriptor[`fragment`] = {
            module: this._fsShaderModule,
            entryPoint: this.fsEntryPoint,
            targets
          };
        }
        const msaaCount = renderPassState.multisample > 0 ? renderPassState.multisample : shaderState.multisample;
        if (msaaCount > 0) {
          renderPipelineDescriptor[`multisample`] = {
            count: msaaCount,
            alphaToCoverageEnabled: shaderState.alphaToCoverageEnabled === true && msaaCount > 1 ? true : false
          };
        }
        if (renderPassState.zPreTexture || renderPassState.depthTexture) {
          if (this._boundCtx.engine.setting.render.zPrePass && renderPassState.zPreTexture && shaderState.useZ) {
            renderPipelineDescriptor[`depthStencil`] = {
              depthWriteEnabled: shaderState.depthWriteEnabled,
              depthCompare: shaderState.depthCompare == GPUCompareFunction.less ? GPUCompareFunction.less_equal : shaderState.depthCompare,
              format: renderPassState.zPreTexture.format
            };
          } else {
            let depthStencilState = {
              depthWriteEnabled: shaderState.depthWriteEnabled,
              depthCompare: shaderState.depthCompare,
              format: renderPassState.depthTexture.format,
              depthBias: shaderState.depthBias,
              depthBiasSlopeScale: shaderState.depthBiasSlopeScale,
              depthBiasClamp: shaderState.depthBiasClamp
            };
            if (renderPassState.depthTexture.format.includes("stencil")) {
              depthStencilState.stencilFront = shaderState.stencilFront;
              depthStencilState.stencilBack = shaderState.stencilBack;
              depthStencilState.stencilReadMask = shaderState.stencilReadMask;
              depthStencilState.stencilWriteMask = shaderState.stencilWriteMask;
            }
            renderPipelineDescriptor[`depthStencil`] = depthStencilState;
          }
        }
        const ctx = this._boundCtx;
        const pipelineKey = `${this.shaderVariant}|${RenderShaderPass._attachmentKey(renderPassState)}|a2c${shaderState.alphaToCoverageEnabled ? 1 : 0}|ucd${shaderState.unclippedDepth ? 1 : 0}`;
        let pipeline = PipelinePool.getSharePipeline(ctx, pipelineKey);
        if (pipeline) {
          this.pipeline = pipeline;
        } else {
          this.pipeline = ctx.gpuContext.createPipeline(renderPipelineDescriptor);
          PipelinePool.setSharePipeline(ctx, pipelineKey, this.pipeline);
        }
      }
      static _attachmentKey(rps) {
        let k = "[";
        const targets = rps.renderTargets;
        if (targets && targets.length > 0) {
          for (const t of targets) k += (t?.format ?? "_") + ",";
        } else if (rps.renderTargetTextures && rps.renderTargetTextures.length > 0) {
          for (const t of rps.renderTargetTextures) k += (t?.format ?? "_") + ",";
        } else {
          k += "_";
        }
        k += "]:" + (rps.depthTexture?.format ?? "_");
        if (rps.multisample) k += ":ms" + rps.multisample;
        return k;
      }
      createGroupLayouts() {
        this._groupsShaderReflectionVarInfos = [];
        let shaderReflection = this.shaderReflection;
        const device = this._boundCtx.device;
        this.bindGroupLayouts = [GlobalBindGroupLayout.getGlobalDataBindGroupLayout(this._boundCtx)];
        for (let i = 1; i < shaderReflection.groups.length; i++) {
          let shaderRefs = shaderReflection.groups[i];
          if (shaderRefs) {
            let entries = this.getGroupLayout(i, shaderRefs);
            this._groupsShaderReflectionVarInfos[i] = shaderRefs;
            let layout = device.createBindGroupLayout({
              entries,
              label: `vs${this.vsName} fs${this.fsName} ${shaderRefs.length}`
            });
            this.bindGroupLayouts[i] = layout;
          } else {
            console.error("can't set empty group!", i);
          }
        }
        let layouts = device.createPipelineLayout({
          bindGroupLayouts: this.bindGroupLayouts
        });
        if (this._groupsShaderReflectionVarInfos[0]) ;
        if (this._groupsShaderReflectionVarInfos[1]) {
          this.genGroups(1, this._groupsShaderReflectionVarInfos);
        }
        if (this._groupsShaderReflectionVarInfos[2]) {
          this.genGroups(2, this._groupsShaderReflectionVarInfos);
        }
        if (this._groupsShaderReflectionVarInfos[3]) {
          this.genGroups(3, this._groupsShaderReflectionVarInfos);
        }
        return layouts;
      }
      preDefine(geometry) {
        let useSecondUV = geometry.hasAttribute(VertexAttributeName.TEXCOORD_1);
        let isSkeleton = geometry.hasAttribute(VertexAttributeName.joints0);
        let hasMorphTarget = geometry.hasAttribute(VertexAttributeName.a_morphPositions_0);
        let useTangent = geometry.hasAttribute(VertexAttributeName.TANGENT);
        let useVertexColor = geometry.hasAttribute(VertexAttributeName.color);
        let useGI = this.shaderState.acceptGI;
        let useLight = this.shaderState.useLight;
        if (useSecondUV) {
          this.defineValue[`USE_SECONDUV`] = true;
        }
        if (isSkeleton && hasMorphTarget) {
          this.defineValue[`USE_METAHUMAN`] = true;
        } else {
          this.defineValue[`USE_SKELETON`] = isSkeleton;
          this.defineValue[`USE_MORPHTARGETS`] = hasMorphTarget;
        }
        if (!("USE_TANGENT" in this.defineValue)) {
          this.defineValue[`USE_TANGENT`] = useTangent;
        }
        this.defineValue[`USE_GI`] = useGI;
        this.defineValue[`USE_SHADOWMAPING`] = this.shaderState.acceptShadow;
        this.defineValue[`USE_LIGHT`] = useLight;
        this.defineValue[`USE_VERTXCOLOR`] = useVertexColor;
        const setting = this._boundCtx.engine.setting;
        if (setting.pick.mode == `pixel`) {
          this.defineValue[`USE_WORLDPOS`] = true;
        }
        if (setting.gi.enable) {
          this.defineValue[`USEGI`] = true;
        } else {
          this.defineValue[`USEGI`] = false;
        }
        if (setting.render.debug) {
          this.defineValue[`USE_DEBUG`] = true;
          this.defineValue[`DEBUG_CLUSTER`] = true;
        }
        if (this.shaderState.useLight) {
          this.defineValue[`USE_LIGHT`] = true;
        } else {
          this.defineValue[`USE_LIGHT`] = false;
        }
        if (setting.render.useLogDepth) {
          this.defineValue[`USE_LOGDEPTH`] = true;
          this.shaderState.useFragDepth = true;
        } else {
          this.defineValue[`USE_LOGDEPTH`] = false;
        }
        if (this.shaderState.useFragDepth) {
          this.defineValue[`USE_OUTDEPTH`] = true;
        } else {
          this.defineValue[`USE_OUTDEPTH`] = false;
        }
        this.defineValue[`USE_PCF_SHADOW`] = setting.shadow.type == `PCF`;
        this.defineValue[`USE_HARD_SHADOW`] = setting.shadow.type == `HARD`;
        this.defineValue[`USE_SOFT_SHADOW`] = setting.shadow.type == `SOFT`;
        this.defineValue[`USE_CSM`] = CSM.Cascades > 1;
        this.defineValue[`USE_IES_PROFILE`] = IESProfilesPool.for(this._boundCtx).use;
        this.defineValue[`USE_RTE`] = setting.useRTE;
      }
      genReflection() {
        this.shaderVariant = ShaderReflection.genRenderShaderVariant(this);
        let reflection = ShaderReflection.poolGetReflection(this.shaderVariant);
        if (!reflection) {
          if (this.shaderReflection) {
            this.shaderReflection.groups = [];
            this.shaderReflection.variables = {};
            this.shaderReflection.vs_variables = [];
            this.shaderReflection.fs_variables = [];
          }
          let vsPreShader = Preprocessor.parse(this._destVS, this.defineValue);
          vsPreShader = Preprocessor.parse(vsPreShader, this.defineValue);
          ShaderReflection.getShaderReflection2(vsPreShader, this);
          let fsPreShader = Preprocessor.parse(this._destFS, this.defineValue);
          fsPreShader = Preprocessor.parse(fsPreShader, this.defineValue);
          ShaderReflection.getShaderReflection2(fsPreShader, this);
          ShaderReflection.final(this);
        } else {
          this.shaderReflection = reflection;
        }
        this.shaderState.splitTexture = this.shaderReflection.useSplit;
      }
      /**
       * Deep-copy this pass into a fresh instance with its own GPU lifecycle.
       *
       * Why this exists: `Material.clone()` → `Shader.clone()` used to share
       * the same RenderShaderPass instance between source and clones. When
       * the clone's material was destroyed (Sample_AddRemove's add → remove
       * → add path), it tore down `materialDataUniformBuffer` /
       * `bindGroupLayouts` / `pipeline` on the SHARED pass — the source
       * material and any future clones then tried to render through dead
       * GPU resources and `createBindGroup` failed validation.
       *
       * The clone re-runs the (sub)class constructor via `this.constructor`
       * so subclass-specific setup (CastShadowMaterialPass uniforms,
       * OITAccumPass entry points, …) is preserved, then overlays the
       * source's user-modified state. Texture / external-buffer references
       * are shared (their lifetime is owner-managed); UniformNode values
       * are copied so vector mutations on one material don't leak into
       * the other; `materialDataUniformBuffer` and the pipeline objects
       * stay fresh from the constructor so the next apply() rebuilds
       * cleanly under the cloned material's own ownership.
       */
      clone() {
        const Ctor = this.constructor;
        const dst = new Ctor(this.vsName, this.fsName);
        dst.passType = this.passType;
        dst.useRz = this.useRz;
        dst.vsEntryPoint = this.vsEntryPoint;
        dst.fsEntryPoint = this.fsEntryPoint;
        Object.assign(dst.shaderState, this.shaderState);
        dst.defineValue = { ...this.defineValue };
        dst.constValues = { ...this.constValues };
        for (const k in this.textures) {
          if (this.textures[k]) dst.setTexture(k, this.textures[k]);
        }
        for (const k in this.uniforms) {
          const node = this.uniforms[k];
          if (!node) continue;
          const v = node.data;
          if (v instanceof Vector2) dst.setUniformVector2(k, new Vector2(v.x, v.y));
          else if (v instanceof Vector3) dst.setUniformVector3(k, new Vector3(v.x, v.y, v.z));
          else if (v instanceof Vector4) dst.setUniformVector4(k, new Vector4(v.x, v.y, v.z, v.w));
          else if (v instanceof Color) dst.setUniformColor(k, new Color(v.r, v.g, v.b, v.a));
          else if (v instanceof Float32Array) dst.setUniformArray(k, new Float32Array(v));
          else if (typeof v === "number") dst.setUniformFloat(k, v);
          else dst.setUniform(k, v);
        }
        for (const [name, buf] of this._bufferDic) {
          if (name === "global" || name === "materialUniform") continue;
          dst._bufferDic.set(name, buf);
        }
        dst._shaderChange = true;
        dst._valueChange = true;
        return dst;
      }
      /**
       * Destroy and release render shader related resources
       */
      destroy(force) {
        for (const key in this.textures) {
          if (Object.prototype.hasOwnProperty.call(this.textures, key)) {
            const texture = this.textures[key];
            Reference.getInstance().detached(texture, this);
            if (force && !Reference.getInstance().hasReference(texture)) {
              texture.destroy(force);
            } else {
              texture.destroy(false);
            }
          }
        }
        this.bindGroups.length = 0;
        this.shaderState = null;
        this.textures = null;
        this.pipeline = null;
        this.bindGroupLayouts = null;
        this._sourceVS = null;
        this._sourceFS = null;
        this._destVS = null;
        this._destFS = null;
        this._vsShaderModule = null;
        this._fsShaderModule = null;
        this.materialDataUniformBuffer.destroy();
        this.materialDataUniformBuffer = null;
      }
      /**
       * Destroy a RenderShader object
       * @param ctx Context3D owning the shader cache
       * @param instanceID instance ID of the RenderShader
       */
      static destroyShader(ctx, instanceID) {
        const registry = ShaderUtil.renderShader(ctx);
        if (registry.has(instanceID)) {
          let shader = registry.get(instanceID);
          shader.destroy();
          registry.delete(instanceID);
        }
      }
      /**
       * Get the RenderShader object by specifying the RenderShader instance ID
       * @param ctx Context3D owning the shader cache
       * @param instanceID instance ID of the RenderShader
       * @returns RenderShader object
       */
      static getShader(ctx, instanceID) {
        return ShaderUtil.renderShader(ctx).get(instanceID);
      }
      /**
       * Create a RenderShader with vertex shaders and fragment shaders
       * @param ctx Context3D owning the shader cache
       * @param vs Vertex shader name
       * @param fs Fragment shader name
       * @returns Returns the instance ID of the RenderShader
       */
      static createShader(ctx, vs, fs) {
        let shader = new RenderShaderPass(vs, fs);
        ShaderUtil.renderShader(ctx).set(shader.instanceID, shader);
        return shader.instanceID;
      }
    }

    class SkyGBufferPass extends RenderShaderPass {
      constructor() {
        super(`sky_vs_frag_wgsl`, `SkyGBuffer_fs`);
        this.passType = PassType.GI;
        this.setUniformVector3(`eyesPos`, new Vector3());
        this.setUniformFloat(`exposure`, 1);
        this.setUniformFloat(`roughness`, 0);
        let shaderState = this.shaderState;
        shaderState.frontFace = `ccw`;
        shaderState.cullMode = GPUCullMode.front;
        shaderState.depthWriteEnabled = false;
        shaderState.depthCompare = GPUCompareFunction.less_equal;
      }
    }

    class GBufferPass extends RenderShaderPass {
      transparency;
      constructor(ctx) {
        super(`gbuffer_vs`, `gbuffer_fs`);
        this.setShaderEntry(`VertMain`, `FragMain`);
        this.passType = PassType.GI;
        this.setUniformColor(`baseColor`, new Color());
        this.setUniformColor(`emissiveColor`, new Color());
        this.setUniformFloat(`emissiveIntensity`, 1);
        this.setUniformFloat(`normalScale`, 1);
        this.setUniformFloat(`alphaCutoff`, 1);
        this.blendMode = BlendMode.NONE;
        this.setTexture(`normalMap`, Engine3D.resFor(ctx).normalTexture);
      }
    }

    class CastShadowMaterialPass extends RenderShaderPass {
      constructor() {
        super(`shadowCastMap_vert`, `directionShadowCastMap_frag`);
        this.passType = PassType.SHADOW;
        this.setShaderEntry("main", "main");
        this.setUniformFloat("cameraFar", 5e3);
        this.setUniformVector3("lightWorldPos", Vector3.ZERO);
        this.shaderState.receiveEnv = false;
        this.shaderState.castShadow = false;
        this.shaderState.acceptShadow = false;
        this.shaderState.depthBias = 0;
        this.shaderState.depthBiasSlopeScale = 0;
        this.shaderState.depthBiasClamp = 0;
        this.setDefine(`USE_ALPHACUT`, true);
      }
    }

    class CastPointShadowMaterialPass extends RenderShaderPass {
      constructor() {
        super(`castPointShadowMap_vert`, `shadowCastMap_frag`);
        this.passType = PassType.POINT_SHADOW;
        this.setShaderEntry("main", "main");
        this.setUniformFloat("cameraFar", 5e3);
        this.setUniformVector3("lightWorldPos", Vector3.ZERO);
        this.shaderState.receiveEnv = false;
        this.shaderState.castShadow = false;
        this.shaderState.acceptShadow = false;
        this.shaderState.cullMode = GPUCullMode.front;
        this.shaderState.depthBias = 0;
        this.shaderState.depthBiasSlopeScale = 0.5;
        this.shaderState.depthBiasClamp = 0;
        this.setDefine(`USE_ALPHACUT`, true);
      }
    }

    class DepthMaterialPass extends RenderShaderPass {
      constructor() {
        super(`ZPass_shader_vs`, `ZPass_shader_vs`);
        this.passType = PassType.DEPTH;
        this.setShaderEntry("main");
        this.useRz = false;
        let shaderState = this.shaderState;
        shaderState.receiveEnv = false;
      }
    }

    class OITAccumPass extends RenderShaderPass {
      /**
       * @param vs / fs — registered shader names. Default to PBRLitShader
       *   so existing LitMaterial-based callers keep working unchanged.
       *   PassGenerate.createOITPass passes the COLOR pass's own vsName/
       *   fsName so the OIT pipeline runs the SAME fragment program the
       *   color pass would have run (PBRLit for LitMaterial, UnLit for
       *   UnLitMaterial, …). Without this, an UnLit material running
       *   `oitMode='weighted'` would fail to bind because the cloned OIT
       *   pass still expected the full PBR uniform set.
       */
      constructor(vs = `PBRLItShader`, fs = `PBRLItShader`) {
        super(vs, fs);
        this.setShaderEntry(`VertMain`, `FragMain`);
        this.passType = PassType.OIT_ACCUM;
        const state = this.shaderState;
        state.depthWriteEnabled = false;
        state.transparent = true;
      }
    }

    class DDPDepthPass extends RenderShaderPass {
      constructor(vs = `PBRLItShader`, fs = `PBRLItShader`) {
        super(vs, fs);
        this.setShaderEntry(`VertMain`, `FragMain`);
        this.passType = PassType.OIT_DEPTH_PEEL_DEPTH;
        const state = this.shaderState;
        state.depthWriteEnabled = false;
        state.transparent = true;
      }
    }

    class DDPFrontPass extends RenderShaderPass {
      constructor(vs = `PBRLItShader`, fs = `PBRLItShader`) {
        super(vs, fs);
        this.setShaderEntry(`VertMain`, `FragMain`);
        this.passType = PassType.OIT_DEPTH_PEEL_FRONT;
        const state = this.shaderState;
        state.depthWriteEnabled = true;
        state.transparent = true;
      }
    }

    class DDPBackPass extends RenderShaderPass {
      constructor(vs = `PBRLItShader`, fs = `PBRLItShader`) {
        super(vs, fs);
        this.setShaderEntry(`VertMain`, `FragMain`);
        this.passType = PassType.OIT_DEPTH_PEEL_BACK;
        const state = this.shaderState;
        state.depthWriteEnabled = false;
        state.transparent = true;
      }
    }

    class PassGenerate {
      static _ctxOf(renderNode) {
        return renderNode.transform?.view3D?.engine3D?.context3D ?? null;
      }
      static createGIPass(renderNode, shader) {
        if (RendererMaskUtil.hasMask(renderNode.rendererMask, RendererMask.Sky)) {
          let pass0 = shader.passShader.get(PassType.GI);
          if (!pass0) {
            let colorPass = shader.getSubShaders(PassType.COLOR)[0];
            let pass = new SkyGBufferPass();
            pass.setTexture(`baseMap`, colorPass.getTexture("baseMap"));
            pass.cullMode = colorPass.cullMode;
            pass.frontFace = colorPass.frontFace;
            shader.addRenderPass(pass, 0);
            const ctx = this._ctxOf(renderNode);
            if (ctx) bindCtx(pass, ctx);
            pass.preCompile(renderNode.geometry);
          }
        } else {
          this.castGBufferPass(renderNode, shader);
        }
      }
      static castGBufferPass(renderNode, shader) {
        let colorPassList = shader.getDefaultShaders();
        for (let jj = 0; jj < colorPassList.length; jj++) {
          const colorPass = colorPassList[jj];
          let giPassList = shader.getSubShaders(PassType.GI);
          if (!giPassList || giPassList.length == 0 || giPassList.length < jj) {
            let pass = new GBufferPass();
            pass.setTexture("baseMap", colorPass.getTexture("baseMap"));
            pass.setTexture("normalMap", colorPass.getTexture("normalMap"));
            pass.setTexture("emissiveMap", colorPass.getTexture("emissiveMap"));
            pass.setUniform("baseColor", colorPass.getUniform("baseColor"));
            pass.setUniform("envIntensity", colorPass.getUniform("envIntensity"));
            pass.setUniform("emissiveColor", colorPass.getUniform("emissiveColor"));
            pass.setUniform("emissiveIntensity", colorPass.getUniform("emissiveIntensity"));
            pass.setUniform("alphaCutoff", colorPass.getUniform("alphaCutoff"));
            pass.cullMode = colorPass.cullMode;
            pass.frontFace = colorPass.frontFace;
            const ctx = this._ctxOf(renderNode);
            if (ctx) bindCtx(pass, ctx);
            pass.preCompile(renderNode.geometry);
            shader.addRenderPass(pass);
          }
        }
      }
      static createShadowPass(renderNode, shader) {
        let use_skeleton = RendererMaskUtil.hasMask(renderNode.rendererMask, RendererMask.SkinnedMesh);
        let useMorphTargets = renderNode.geometry.hasAttribute(GLTFType.MORPH_POSITION_PREFIX + "0");
        let useMorphNormals = renderNode.geometry.hasAttribute(GLTFType.MORPH_NORMAL_PREFIX + "0");
        let colorPassList = shader.getSubShaders(PassType.COLOR);
        for (let i = 0; i < colorPassList.length; i++) {
          const colorPass = colorPassList[i];
          let shadowPassList = shader.getSubShaders(PassType.SHADOW);
          if (!shadowPassList || shadowPassList.length < i + 1) {
            let shadowPass = new CastShadowMaterialPass();
            shadowPass.cullMode = colorPass.cullMode;
            shadowPass.setTexture(`baseMap`, colorPass.getTexture(`baseMap`));
            shadowPass.setUniform(`alphaCutoff`, colorPass.getUniform(`alphaCutoff`));
            shadowPass.setDefine(`USE_TANGENT`, false);
            if (use_skeleton) {
              shadowPass.setDefine(`USE_SKELETON`, use_skeleton);
            }
            if (useMorphTargets) {
              shadowPass.setDefine(`USE_MORPHTARGETS`, useMorphTargets);
            }
            if (useMorphNormals) {
              shadowPass.setDefine(`USE_MORPHNORMALS`, useMorphNormals);
            }
            const ctxA = this._ctxOf(renderNode);
            if (ctxA) bindCtx(shadowPass, ctxA);
            shadowPass.preCompile(renderNode.geometry);
            shader.addRenderPass(shadowPass);
          }
          let castPointShadowPassList = shader.getSubShaders(PassType.POINT_SHADOW);
          if (!castPointShadowPassList || castPointShadowPassList.length < i + 1) {
            let castPointShadowPass = new CastPointShadowMaterialPass();
            castPointShadowPass.setTexture(`baseMap`, colorPass.getTexture(`baseMap`));
            castPointShadowPass.setUniform(`alphaCutoff`, colorPass.getUniform(`alphaCutoff`));
            castPointShadowPass.setDefine("USE_ALPHACUT", 1);
            for (let j = 0; j < 1; j++) {
              castPointShadowPass.setDefine(`USE_TANGENT`, false);
              if (use_skeleton) {
                castPointShadowPass.setDefine(`USE_SKELETON`, use_skeleton);
              }
              if (useMorphTargets) {
                castPointShadowPass.setDefine(`USE_MORPHTARGETS`, useMorphTargets);
              }
              if (useMorphNormals) {
                castPointShadowPass.setDefine(`USE_MORPHNORMALS`, useMorphNormals);
              }
              castPointShadowPass.shaderState.cullMode = `front`;
              const ctxB = this._ctxOf(renderNode);
              if (ctxB) bindCtx(castPointShadowPass, ctxB);
              castPointShadowPass.preCompile(renderNode.geometry);
            }
            shader.addRenderPass(castPointShadowPass);
          }
        }
      }
      static createDepthPass(renderNode, shader) {
        let colorListPass = shader.getSubShaders(PassType.COLOR);
        let useMorphTargets = renderNode.geometry.hasAttribute(GLTFType.MORPH_POSITION_PREFIX + "0");
        let useMorphNormals = renderNode.geometry.hasAttribute(GLTFType.MORPH_NORMAL_PREFIX + "0");
        let use_skeleton = RendererMaskUtil.hasMask(renderNode.rendererMask, RendererMask.SkinnedMesh);
        for (let i = 0; i < colorListPass.length; i++) {
          const colorPass = colorListPass[i];
          let depthPassList = shader.getSubShaders(PassType.DEPTH);
          if (depthPassList.length <= i && colorPass.shaderState.useZ) {
            let depthPass = new DepthMaterialPass();
            depthPass.setTexture(`baseMap`, colorPass.getTexture(`baseMap`));
            depthPass.setDefine(`USE_TANGENT`, false);
            if (use_skeleton) {
              depthPass.setDefine(`USE_SKELETON`, use_skeleton);
            }
            if (useMorphTargets) {
              depthPass.setDefine(`USE_MORPHTARGETS`, useMorphTargets);
            }
            if (useMorphNormals) {
              depthPass.setDefine(`USE_MORPHNORMALS`, useMorphNormals);
            }
            depthPass.cullMode = colorPass.cullMode;
            depthPass.frontFace = colorPass.frontFace;
            const ctx = this._ctxOf(renderNode);
            if (ctx) bindCtx(depthPass, ctx);
            depthPass.preCompile(renderNode.geometry);
            shader.addRenderPass(depthPass);
          }
        }
      }
      /**
       * Build the WBOIT accumulation pass for materials whose
       * `oitMode === 'weighted'`. Mirrors the createReflectionPass
       * pattern but reuses the **full PBRLitShader** lighting pipeline
       * — every define / uniform / texture from the color pass is
       * cloned, then `USE_OIT_ACCUM` is set so the trailing block in
       * Common_frag's FragMain overrides the fragment outputs with the
       * WBOIT-weighted (accum, reveal) pair instead of the lit color.
       *
       * The full clone is necessary because PBR lighting depends on
       * baseMap, normalMap, maskMap, environment probe, shadow maps,
       * IBL, clearcoat textures, transmission state, etc. Selectively
       * copying a subset (as the previous standalone OITAccumShader
       * version did) produced unlit-looking transparents.
       *
       * No-op if an OIT pass already exists for this material.
       */
      static createOITPass(renderNode, shader) {
        const colorPassList = shader.getDefaultShaders();
        if (!colorPassList) return;
        for (let jj = 0; jj < colorPassList.length; jj++) {
          const colorPass = colorPassList[jj];
          const existing = shader.getSubShaders(PassType.OIT_ACCUM);
          if (existing && existing.length > jj) continue;
          const pass = new OITAccumPass(colorPass.vsName, colorPass.fsName);
          for (const key in colorPass.shaderState) {
            if (key === "depthWriteEnabled" || key === "transparent" || key === "blendMode") continue;
            pass.shaderState[key] = colorPass.shaderState[key];
          }
          for (const uniformName in colorPass.uniforms) {
            pass.setUniform(uniformName, colorPass.getUniform(uniformName));
          }
          for (const textureName in colorPass.textures) {
            const tex = colorPass.getTexture(textureName);
            if (tex) pass.setTexture(textureName, tex);
          }
          for (const defineName in colorPass.defineValue) {
            pass.setDefine(defineName, colorPass.defineValue[defineName]);
          }
          pass.setDefine("USE_OIT_ACCUM", true);
          const ctx = this._ctxOf(renderNode);
          if (ctx) bindCtx(pass, ctx);
          pass.preCompile(renderNode.geometry);
          shader.addRenderPass(pass);
        }
      }
      /**
       * Dual depth peeling pass generator. For each
       * material color pass, clones THREE derived passes — one per sub-
       * pass-type (DEPTH / FRONT / BACK) — each with the corresponding
       * `USE_OIT_DEPTH_PEEL_*` define set so the shader writes the right
       * attachments. The DualDepthPeelingRenderer cycles through the
       * three pass types per peel iteration.
       *
       * Per-target blend states (MAX-MAX for depth, over for front,
       * under for back) are wired in {@link RenderShaderPass.createPipeline}
       * via the per-pass-type branches that match `this.passType`.
       *
       * No-op if the depth-peel passes already exist for this material.
       *
       * @param renderNode the renderer that owns this material
       * @param shader the material's shader (passes will be added to
       *               its passShader map)
       */
      static createDepthPeelPasses(renderNode, shader) {
        const colorPassList = shader.getDefaultShaders();
        if (!colorPassList) return;
        for (let jj = 0; jj < colorPassList.length; jj++) {
          const colorPass = colorPassList[jj];
          const existingDepth = shader.getSubShaders(PassType.OIT_DEPTH_PEEL_DEPTH);
          const existingFront = shader.getSubShaders(PassType.OIT_DEPTH_PEEL_FRONT);
          const existingBack = shader.getSubShaders(PassType.OIT_DEPTH_PEEL_BACK);
          const wantDepth = !existingDepth || existingDepth.length <= jj;
          const wantFront = !existingFront || existingFront.length <= jj;
          const wantBack = !existingBack || existingBack.length <= jj;
          if (wantDepth) {
            this._addDepthPeelClone(
              renderNode,
              shader,
              colorPass,
              new DDPDepthPass(colorPass.vsName, colorPass.fsName),
              "USE_OIT_DEPTH_PEEL_DEPTH"
            );
          }
          if (wantFront) {
            this._addDepthPeelClone(
              renderNode,
              shader,
              colorPass,
              new DDPFrontPass(colorPass.vsName, colorPass.fsName),
              "USE_OIT_DEPTH_PEEL_FRONT"
            );
          }
          if (wantBack) {
            this._addDepthPeelClone(
              renderNode,
              shader,
              colorPass,
              new DDPBackPass(colorPass.vsName, colorPass.fsName),
              "USE_OIT_DEPTH_PEEL_BACK"
            );
          }
        }
      }
      /** Helper: clones a COLOR pass into a DDP sub-pass with the given
       *  `USE_OIT_DEPTH_PEEL_*` flag. Mirrors the clone strategy used by
       *  {@link createOITPass} — every define / uniform / texture from the
       *  color pass is copied so the sub-pass runs the SAME PBR / UnLit /
       *  Lambert lighting program. The matching peel define is set last
       *  so it overrides any cloned `false`. */
      static _addDepthPeelClone(renderNode, shader, colorPass, pass, peelDefine) {
        for (const key in colorPass.shaderState) {
          if (key === "depthWriteEnabled" || key === "transparent" || key === "blendMode") continue;
          pass.shaderState[key] = colorPass.shaderState[key];
        }
        for (const uniformName in colorPass.uniforms) {
          pass.setUniform(uniformName, colorPass.getUniform(uniformName));
        }
        for (const textureName in colorPass.textures) {
          const tex = colorPass.getTexture(textureName);
          if (tex) pass.setTexture(textureName, tex);
        }
        for (const defineName in colorPass.defineValue) {
          pass.setDefine(defineName, colorPass.defineValue[defineName]);
        }
        pass.setDefine(peelDefine, true);
        pass.setDefine("USE_OIT_DEPTH_PEEL", true);
        const ctx = this._ctxOf(renderNode);
        if (ctx) bindCtx(pass, ctx);
        pass.preCompile(renderNode.geometry);
        shader.addRenderPass(pass);
      }
      static createReflectionPass(renderNode, shader) {
        let colorPassList = shader.getDefaultShaders();
        for (let jj = 0; jj < colorPassList.length; jj++) {
          const colorPass = colorPassList[jj];
          let colorSubPassList = shader.getSubShaders(PassType.REFLECTION);
          if (!colorSubPassList || colorSubPassList.length == 0 || colorSubPassList.length < jj) {
            let pass = new RenderShaderPass(colorPass.vsName, colorPass.fsName);
            pass.vsEntryPoint = colorPass.vsEntryPoint;
            pass.fsEntryPoint = colorPass.fsEntryPoint;
            pass.passType = PassType.REFLECTION;
            for (const state in colorPass.shaderState) {
              var v = colorPass.shaderState[state];
              pass.shaderState[state] = v;
            }
            for (const textureName in colorPass.textures) {
              var texture = colorPass.getTexture(textureName);
              pass.setTexture(textureName, texture);
            }
            for (const uniformName in colorPass.uniforms) {
              var value = colorPass.getUniform(uniformName);
              pass.setUniform(uniformName, value);
            }
            for (const defineName in colorPass.defineValue) {
              var value = colorPass.defineValue[defineName];
              pass.setDefine(defineName, value);
            }
            pass.setDefine("USE_CASTREFLECTION", true);
            const ctx = this._ctxOf(renderNode);
            if (ctx) bindCtx(pass, ctx);
            pass.preCompile(renderNode.geometry);
            shader.addRenderPass(pass);
          }
        }
      }
    }

    class Octree {
      static _v1 = new Vector3();
      static _v2 = new Vector3();
      // private static _plane = new Plane();
      // private static _line1 = new Line3();
      // private static _line2 = new Line3();
      // private static _sphere = new Sphere();
      // private static _capsule = new Capsule();
      entities;
      box;
      subTrees = [];
      parent;
      level;
      static maxSplitLevel = 6;
      static autoSplitLevel = 3;
      index;
      uuid;
      constructor(size, index = 0, parent = null, level = 0) {
        this.parent = parent;
        this.box = size.clone();
        this.level = level;
        this.index = index;
        this.uuid = level + "_" + index;
        this.entities = /* @__PURE__ */ new Map();
      }
      tryInsertEntity(entity) {
        let userBox = entity.renderer.object3D.bound;
        if (this.level == 0 || this.box.containsBox(userBox)) {
          if (this.subTrees.length == 0) {
            if (this.level < Octree.maxSplitLevel) {
              this.splitTree();
            }
          }
          let holdByChild;
          if (this.subTrees.length > 0) {
            for (let child of this.subTrees) {
              if (child.tryInsertEntity(entity)) {
                holdByChild = true;
                break;
              }
            }
          }
          if (!holdByChild) {
            entity.enterNode(this);
          }
          return true;
        }
        return false;
      }
      splitTree() {
        if (this.subTrees.length == 0) {
          const v = Octree._v1;
          const halfsize = this.box.extents.clone();
          let childLevel = this.level + 1;
          let index = 0;
          for (let x = 0; x < 2; x++) {
            for (let y = 0; y < 2; y++) {
              for (let z = 0; z < 2; z++) {
                const box = new BoundingBox();
                Vector3.add(this.box.min, v.set(x, y, z).multiply(halfsize), box.min);
                Vector3.add(box.min, halfsize, box.max);
                box.setFromMinMax(box.min, box.max);
                let subTree = new Octree(box, index++, this, childLevel);
                this.subTrees.push(subTree);
              }
            }
          }
        }
      }
      __rayCastTempVector = new Vector3();
      rayCasts(ray, ret) {
        if (this.level == 0 || ray.intersectBox(this.box, this.__rayCastTempVector)) {
          if (this.entities.size > 0) {
            ret.push(...this.entities.values());
          }
          for (let child of this.subTrees) {
            child.rayCasts(ray, ret);
          }
          return true;
        }
        return false;
      }
      frustumCasts(frustum, ret) {
        if (this.level == 0 || frustum.containsBoundingBox(this.box)) {
          if (this.entities.size > 0) {
            for (const item of this.entities.values()) {
              if (this.level > Octree.autoSplitLevel || frustum.containsBoundingBox(item.renderer.object3D.bound)) {
                ret.push(item);
              }
            }
          }
          for (let child of this.subTrees) {
            child.frustumCasts(frustum, ret);
          }
          return true;
        }
        return false;
      }
      getRenderNode(frustum, ret) {
        if (this.level == 0 || frustum.containsBoundingBox(this.box)) {
          if (this.entities.size > 0) {
            for (const item of this.entities.values()) {
              if (this.level > Octree.autoSplitLevel || frustum.containsBoundingBox(item.renderer.object3D.bound)) {
                if (item.renderer.renderOrder < 3e3) {
                  ret.opaqueList.push(item.renderer);
                } else if (item.renderer.renderOrder >= 3e3) {
                  ret.transparentList.push(item.renderer);
                }
              }
            }
          }
          for (let child of this.subTrees) {
            child.getRenderNode(frustum, ret);
          }
          return true;
        }
        return false;
      }
      boxCasts(box, ret) {
        if (box.intersectsBox(this.box)) {
          if (this.entities.size > 0) {
            ret.push(...this.entities.values());
          }
          for (let child of this.subTrees) {
            child.boxCasts(box, ret);
          }
          return true;
        }
        return false;
      }
      clean() {
        for (let item of this.entities.values()) {
          item.leaveNode();
        }
        this.entities.clear();
        return this;
      }
      // getRayTriangles(ray, triangles) {
      //   for (let subTree of this.subTrees) {
      //     if (!ray.intersectsBox(subTree.box)) {
      //       continue;
      //     }
      //     subTree.setGizmos(true, false);
      //     let count = subTree.entities.length;
      //     if (count > 0) {
      //       let tempTriangle: OctreeEntity;
      //       for (let j = 0; j < count; j++) {
      //         tempTriangle = subTree.entities[j];
      //         if (triangles.indexOf(tempTriangle) == -1) {
      //           triangles.push(tempTriangle);
      //         }
      //       }
      //     }
      //     // else {
      //     subTree.getRayTriangles(ray, triangles);
      //     // }
      //   }
      //   return triangles;
      // }
      // triangleCapsuleIntersect(capsule, triangle) {
      //   triangle.getPlane(Octree._plane);
      //   const d1 = Octree._plane.distanceToPoint(capsule.start) - capsule.radius;
      //   const d2 = Octree._plane.distanceToPoint(capsule.end) - capsule.radius;
      //   if ((d1 > 0 && d2 > 0) || (d1 < -capsule.radius && d2 < -capsule.radius)) {
      //     return false;
      //   }
      //   const delta = Math.abs(d1 / (Math.abs(d1) + Math.abs(d2)));
      //   const intersectPoint = Octree._v1.copy(capsule.start).lerp(capsule.end, delta);
      //   if (triangle.containsPoint(intersectPoint)) {
      //     return {
      //       normal: Octree._plane.normal.clone(),
      //       point: intersectPoint.clone(),
      //       depth: Math.abs(Math.min(d1, d2)),
      //     };
      //   }
      //   const r2 = capsule.radius * capsule.radius;
      //   const line1 = Octree._line1.set(capsule.start, capsule.end);
      //   const lines = [
      //     [triangle.a, triangle.b],
      //     [triangle.b, triangle.c],
      //     [triangle.c, triangle.a],
      //   ];
      //   for (let i = 0; i < lines.length; i++) {
      //     const line2 = Octree._line2.set(lines[i][0], lines[i][1]);
      //     const [point1, point2] = capsule.lineLineMinimumPoints(line1, line2);
      //     if (point1.distanceToSquared(point2) < r2) {
      //       return {
      //         normal: point1.clone().sub(point2).normalize(),
      //         point: point2.clone(),
      //         depth: capsule.radius - point1.distanceTo(point2),
      //       };
      //     }
      //   }
      //   return false;
      // }
      // triangleSphereIntersect(sphere, triangle) {
      //   triangle.getPlane(Octree._plane);
      //   if (!sphere.intersectsPlane(Octree._plane)) return false;
      //   const depth = Math.abs(Octree._plane.distanceToSphere(sphere));
      //   const r2 = sphere.radius * sphere.radius - depth * depth;
      //   const plainPoint = Octree._plane.projectPoint(sphere.center, Octree._v1);
      //   if (triangle.containsPoint(sphere.center)) {
      //     return {
      //       normal: Octree._plane.normal.clone(),
      //       point: plainPoint.clone(),
      //       depth: Math.abs(Octree._plane.distanceToSphere(sphere)),
      //     };
      //   }
      //   const lines = [
      //     [triangle.a, triangle.b],
      //     [triangle.b, triangle.c],
      //     [triangle.c, triangle.a],
      //   ];
      //   for (let i = 0; i < lines.length; i++) {
      //     Octree._line1.set(lines[i][0], lines[i][1]);
      //     Octree._line1.closestPointToPoint(plainPoint, true, Octree._v2);
      //     const d = Octree._v2.distanceToSquared(sphere.center);
      //     if (d < r2) {
      //       return {
      //         normal: sphere.center.clone().sub(Octree._v2).normalize(),
      //         point: Octree._v2.clone(),
      //         depth: sphere.radius - Math.sqrt(d),
      //       };
      //     }
      //   }
      //   return false;
      // }
      // getSphereTriangles(sphere, triangles) {
      //   for (let subTree of this.subTrees) {
      //     if (!sphere.intersectsBox(subTree.box)) continue;
      //     if (subTree.entities.length > 0) {
      //       for (let j = 0; j < subTree.entities.length; j++) {
      //         if (triangles.indexOf(subTree.entities[j]) === -1) triangles.push(subTree.entities[j]);
      //       }
      //     } else {
      //       subTree.getSphereTriangles(sphere, triangles);
      //     }
      //   }
      // }
      // getCapsuleTriangles(capsule, triangles) {
      //   for (let subTree of this.subTrees) {
      //     if (!capsule.intersectsBox(subTree.box)) continue;
      //     if (subTree.entities.length > 0) {
      //       for (let j = 0; j < subTree.entities.length; j++) {
      //         if (triangles.indexOf(subTree.entities[j]) === -1) triangles.push(subTree.entities[j]);
      //       }
      //     } else {
      //       subTree.getCapsuleTriangles(capsule, triangles);
      //     }
      //   }
      // }
      // sphereIntersect(sphere) {
      //   Octree._sphere.copy(sphere);
      //   const triangles = [];
      //   let result,
      //     hit = false;
      //   this.getSphereTriangles(sphere, triangles);
      //   for (let i = 0; i < triangles.length; i++) {
      //     if ((result = this.triangleSphereIntersect(Octree._sphere, triangles[i]))) {
      //       hit = true;
      //       Octree._sphere.center.add(result.normal.multiplyScalar(result.depth));
      //     }
      //   }
      //   if (hit) {
      //     const collisionVector = Octree._sphere.center.clone().sub(sphere.center);
      //     const depth = collisionVector.length();
      //     return {
      //       normal: collisionVector.normalize(),
      //       depth: depth,
      //     };
      //   }
      //   return false;
      // }
      // capsuleIntersect(capsule) {
      //   Octree._capsule.copy(capsule);
      //   const triangles = [];
      //   let result,
      //     hit = false;
      //   this.getCapsuleTriangles(Octree._capsule, triangles);
      //   for (let i = 0; i < triangles.length; i++) {
      //     if ((result = this.triangleCapsuleIntersect(Octree._capsule, triangles[i]))) {
      //       hit = true;
      //       Octree._capsule.translate(result.normal.multiplyScalar(result.depth));
      //     }
      //   }
      //   if (hit) {
      //     let collisionVector: Vector3;
      //     let getCenter = Octree._capsule['getCenter'] as any;
      //     collisionVector = getCenter(new Vector3()).sub(capsule.getCenter(Octree._v1));
      //     const depth = collisionVector.length();
      //     return {
      //       normal: collisionVector.normalize(),
      //       depth: depth,
      //     };
      //   }
      //   return false;
      // }
      // rayIntersect(ray) {
      //   if (ray.direction.length() === 0) return;
      //   const triangles = [];
      //   let triangle,
      //     position,
      //     distance = 1e100;
      //   this.getRayTriangles(ray, triangles);
      //   for (let i = 0; i < triangles.length; i++) {
      //     const result = ray.intersectTriangle(triangles[i].a, triangles[i].b, triangles[i].c, true, Octree._v1);
      //     if (result) {
      //       const newdistance = result.sub(ray.origin).length();
      //       if (distance > newdistance) {
      //         position = result.clone().add(ray.origin);
      //         distance = newdistance;
      //         triangle = triangles[i];
      //       }
      //     }
      //   }
      //   return distance < 1e100
      //     ? {
      //       distance: distance,
      //       triangle: triangle,
      //       position: position,
      //     }
      //     : false;
      // }
    }

    class ZSorterUtil {
      _pool = [];
      _worldPosition = new Vector3();
      _viewPosition = new Vector3();
      _zSortList = [];
      pop() {
        return this._pool.pop() || {};
      }
      recycle() {
        for (let item of this._zSortList) {
          item.z = 0;
          item.userData = null;
          item.obj3d = null;
          this._pool.push(item);
        }
        this._zSortList.length = 0;
      }
      /**
       * Sort userDataList by z based on the view coordinates of camera3D
       * @param camera3D camera3D
       * @param userDataList List of objects that users need to sort
       * @param getObject3D Obtain the function of the Object 3D reference based on userData
       * @param result Returns a list of userData, and if passed in as null, instantiates one
       * @returns
       */
      sort(camera3D, userDataList, getObject3D, result) {
        this._zSortList = [];
        for (let userData of userDataList) {
          let zSortItemObject3D = this.pop();
          zSortItemObject3D.userData = userData;
          zSortItemObject3D.obj3d = getObject3D(userData);
          zSortItemObject3D.z = this.worldToCameraDepth(zSortItemObject3D.obj3d, camera3D);
          this._zSortList.push(zSortItemObject3D);
        }
        this._zSortList.sort((a, b) => {
          return a.z - b.z > 0 ? 1 : -1;
        });
        result ||= [];
        for (let item of this._zSortList) {
          result.push(item.userData);
        }
        this.recycle();
        return result;
      }
      worldToCameraDepth(obj3d, camera) {
        camera ||= obj3d.transform.view3D.camera;
        let z = 0;
        if (camera) {
          this._worldPosition.copy(obj3d.transform.worldPosition);
          camera.worldToScreenPoint(this._worldPosition, this._viewPosition);
          z = this._viewPosition.z;
        }
        return z;
      }
    }
    let zSorterUtil = new ZSorterUtil();

    var BatchMode = /* @__PURE__ */ ((BatchMode2) => {
      BatchMode2[BatchMode2["None"] = 2] = "None";
      BatchMode2[BatchMode2["StaticBatch"] = 4] = "StaticBatch";
      BatchMode2[BatchMode2["DynamicBatch"] = 8] = "DynamicBatch";
      BatchMode2[BatchMode2["Hidden"] = 16] = "Hidden";
      return BatchMode2;
    })(BatchMode || {});
    class BatchModeUtil {
      static addMask(src, tag) {
        let value = src | tag;
        return value;
      }
      static removeMask(src, tag) {
        let value = src & ~tag;
        return value;
      }
      static hasMask(m1, m2) {
        return (m1 & m2) != 0;
      }
    }

    class CollectInfo {
      opaqueList = [];
      transparentList = [];
      sky;
      clean() {
        this.opaqueList.length = 0;
        this.transparentList.length = 0;
      }
    }

    class EntityBatchCollect {
      renderGroup;
      constructor() {
        this.renderGroup = /* @__PURE__ */ new Map();
      }
      collect_add(node) {
        let g_key = "";
        let s_key = "";
        g_key += node.geometry.instanceID;
        for (let i = 0; i < node.materials.length; i++) {
          const mat = node.materials[i];
          s_key += mat.shader.getDefaultColorShader().shaderVariant;
        }
        let key = g_key + s_key;
        let group = this.renderGroup.get(key);
        if (!group) {
          group = {
            bundleMap: /* @__PURE__ */ new Map(),
            key,
            renderNodes: [],
            nodeVersion: 0
          };
          this.renderGroup.set(key, group);
        }
        if (group.renderNodes.indexOf(node) == -1) {
          group.renderNodes.push(node);
          group.nodeVersion++;
          group.bundleMap.clear();
        }
      }
    }

    class RenderShaderCollect {
      /** Per-view map of `geometry+pass` key to the nodes drawn with that pass. */
      renderShaderUpdateList = /* @__PURE__ */ new Map();
      /** Per-view flat lookup of every render node by its instance id. */
      renderNodeList = /* @__PURE__ */ new Map();
      /** Register `node` (and all its material passes) into this view's render lists. */
      collect_add(node) {
        let view = node.transform.view3D;
        if (view && node.materials) {
          node.materials.forEach((mat) => {
            let rDic = this.renderShaderUpdateList.get(view);
            if (!rDic) {
              rDic = /* @__PURE__ */ new Map();
              this.renderShaderUpdateList.set(view, rDic);
            }
            let renderGlobalMap = this.renderNodeList.get(view);
            if (!renderGlobalMap) {
              renderGlobalMap = /* @__PURE__ */ new Map();
              this.renderNodeList.set(view, renderGlobalMap);
            }
            renderGlobalMap.set(node.instanceID, node);
            let colorPassList = mat.getAllPass();
            for (let i = 0; i < colorPassList.length; i++) {
              const pass = colorPassList[i];
              let key = `${node.geometry.instanceID + pass.instanceID}`;
              let nodeMap = rDic.get(key);
              if (!nodeMap) {
                nodeMap = /* @__PURE__ */ new Map();
                rDic.set(key, nodeMap);
              }
              nodeMap.set(node.instanceID, node);
            }
          });
        }
      }
      /** Remove `node`'s per-pass entries from this view's render lists. */
      collect_remove(node) {
        let view = node.transform.view3D;
        if (view && node.materials) {
          let rDic = this.renderShaderUpdateList.get(view);
          if (rDic) {
            node.materials.forEach((mat) => {
              let colorPassList = mat.getAllPass();
              for (let i = 0; i < colorPassList.length; i++) {
                const pass = colorPassList[i];
                let key = `${node.geometry.instanceID + pass.instanceID}`;
                rDic.delete(key);
              }
            });
          }
        }
      }
      /** Drop all entries for `view` (called on view/engine teardown). */
      removeView(view) {
        this.renderShaderUpdateList.delete(view);
        this.renderNodeList.delete(view);
      }
    }

    class EntityCollect {
      static _instance;
      // private static  _sceneRenderList: Map<Scene3D, RenderNode[]>;
      _sceneLights;
      _sceneGIProbes;
      _op_RenderNodes;
      _tr_RenderNodes;
      _octreeRenderNodes;
      _reflections;
      _sceneCaptureCameras = /* @__PURE__ */ new Map();
      _graphics;
      _op_renderGroup;
      _tr_renderGroup;
      _renderShaderCollect;
      state = {
        giLightingChange: true
      };
      /**
       * Per-scene sky renderer. Each scene (i.e. each Engine3D instance)
       * has at most one active sky. Indexing by scene avoids cross-device
       * resource leaks when multiple engines run simultaneously.
       */
      _skyMap = /* @__PURE__ */ new Map();
      getSky(scene) {
        return scene ? this._skyMap.get(scene) : void 0;
      }
      setSky(scene, node) {
        if (!scene) return;
        if (node) this._skyMap.set(scene, node);
        else this._skyMap.delete(scene);
      }
      _collectInfo;
      rendererOctree;
      static get instance() {
        if (!this._instance) {
          this._instance = new EntityCollect();
        }
        return this._instance;
      }
      constructor() {
        this._sceneLights = /* @__PURE__ */ new Map();
        this._sceneGIProbes = /* @__PURE__ */ new Map();
        this._op_RenderNodes = /* @__PURE__ */ new Map();
        this._tr_RenderNodes = /* @__PURE__ */ new Map();
        this._reflections = /* @__PURE__ */ new Map();
        this._graphics = [];
        this._op_renderGroup = /* @__PURE__ */ new Map();
        this._tr_renderGroup = /* @__PURE__ */ new Map();
        this._collectInfo = new CollectInfo();
        this._renderShaderCollect = new RenderShaderCollect();
        this._octreeRenderNodes = /* @__PURE__ */ new Map();
      }
      getPashList(root, renderNode) {
        if (renderNode.renderOrder < 3e3) {
          return this._op_RenderNodes.get(root);
        } else if (renderNode.renderOrder >= 3e3) {
          return this._tr_RenderNodes.get(root);
        }
      }
      sortRenderNode(list, renderNode) {
        for (let i = list.length - 1; i > 0; i--) {
          const element = list[i];
          if (element.renderOrder < renderNode.renderOrder) {
            list.push(renderNode);
            return;
          }
        }
        list.push(renderNode);
      }
      addRenderNode(root, renderNode) {
        if (!root) return;
        let isTransparent = renderNode.renderOrder >= 3e3;
        if (renderNode.hasMask(RendererMask.Sky)) {
          this.setSky(root, renderNode);
        } else if (renderNode.hasMask(RendererMask.Reflection)) {
          this.removeRenderNode(root, renderNode);
          let maps = this._reflections.get(root);
          if (!maps) {
            maps = [];
            this._reflections.set(root, maps);
            maps.push(renderNode);
          }
          if (!maps.includes(renderNode)) {
            maps.push(renderNode);
          }
        } else if (renderNode.hasMask(RendererMask.Graphic3D)) {
          if (this._graphics.indexOf(renderNode) == -1) {
            this._graphics.push(renderNode);
          }
        } else if (!BatchModeUtil.hasMask(renderNode.batchMode, BatchMode.None)) {
          this.removeRenderNode(root, renderNode);
          let group = isTransparent ? this._tr_renderGroup : this._op_renderGroup;
          if (!group.has(root)) {
            group.set(root, new EntityBatchCollect());
          }
          group.get(root).collect_add(renderNode);
        } else {
          this.removeRenderNode(root, renderNode);
          let map = isTransparent ? this._tr_RenderNodes : this._op_RenderNodes;
          if (!map.has(root)) {
            map.set(root, []);
          }
          map.get(root).push(renderNode);
          if (root.view?.engine3D?.setting.occlusionQuery.octree) {
            renderNode.attachSceneOctree(this.getOctree(root));
          }
          let list = this.getPashList(root, renderNode);
          let index = list.indexOf(renderNode);
          if (index == -1) {
            this.sortRenderNode(list, renderNode);
          }
        }
        renderNode.object3D.renderNode = renderNode;
        this._renderShaderCollect.collect_add(renderNode);
      }
      getOctree(root) {
        let octree;
        let setting = root.view?.engine3D?.setting.occlusionQuery.octree;
        if (setting) {
          octree = this._octreeRenderNodes.get(root);
          if (!octree) {
            let center = new Vector3(setting.x, setting.y, setting.z);
            let size = new Vector3(setting.width, setting.height, setting.depth);
            let bound = new BoundingBox(center, size);
            octree = new Octree(bound);
            this._octreeRenderNodes.set(root, octree);
          }
        }
        return octree;
      }
      removeRenderNode(root, renderNode) {
        renderNode.detachSceneOctree();
        if (renderNode.hasMask(RendererMask.Sky)) {
          this.setSky(root, null);
        } else if (renderNode.hasMask(RendererMask.Reflection)) {
          let maps = this._reflections.get(root);
          if (maps) {
            let index = maps.indexOf(renderNode);
            if (index != -1) {
              maps.splice(index, 1);
            }
          }
        } else if (!BatchModeUtil.hasMask(renderNode.batchMode, BatchMode.None)) ; else {
          const opList = this._op_RenderNodes.get(root);
          if (opList) {
            const opIdx = opList.indexOf(renderNode);
            if (opIdx !== -1) opList.splice(opIdx, 1);
          }
          const trList = this._tr_RenderNodes.get(root);
          if (trList) {
            const trIdx = trList.indexOf(renderNode);
            if (trIdx !== -1) trList.splice(trIdx, 1);
          }
        }
        this._renderShaderCollect.collect_remove(renderNode);
      }
      addLight(root, light) {
        if (!this._sceneLights.has(root)) {
          this._sceneLights.set(root, [light]);
        } else {
          let lights = this._sceneLights.get(root);
          let maxLight = root.view?.engine3D?.setting.light.maxLight;
          if (maxLight != null && lights.length >= maxLight) {
            console.warn("Alreay meet maxmium light number:", maxLight);
            return;
          }
          let hasLight = lights.indexOf(light) != -1;
          if (!hasLight) {
            lights.push(light);
          }
        }
      }
      removeLight(root, light) {
        if (this._sceneLights.has(root)) {
          let list = this._sceneLights.get(root);
          let index = list.indexOf(light);
          if (index != -1) {
            list.splice(index, 1);
          }
        }
      }
      getLights(root) {
        let list = this._sceneLights.get(root);
        return list ? list : [];
      }
      addGIProbe(root, probe) {
        if (!this._sceneGIProbes.has(root)) {
          this._sceneGIProbes.set(root, [probe]);
        } else {
          this._sceneGIProbes.get(root).push(probe);
        }
      }
      removeGIProbe(root, probe) {
        if (this._sceneGIProbes.has(root)) {
          let list = this._sceneGIProbes.get(root);
          let index = list.indexOf(probe);
          if (index != -1) {
            list.splice(index, 1);
          }
        }
      }
      getProbes(root) {
        let list = this._sceneGIProbes.get(root);
        return list ? list : [];
      }
      getReflections(root) {
        let list = this._reflections.get(root);
        return list ? list : [];
      }
      /**
       * Register a {@link SceneCaptureCameraComponent} into the per-scene
       * index. Idempotent — re-registering an already-tracked component
       * is a no-op so component lifecycle ping-pong (disable → enable on
       * the same frame) doesn't grow the list. Called from the
       * component's `onEnable`.
       */
      addSceneCaptureCamera(scene, cap) {
        if (!scene || !cap) return;
        let list = this._sceneCaptureCameras.get(scene);
        if (!list) {
          list = [];
          this._sceneCaptureCameras.set(scene, list);
        }
        if (list.indexOf(cap) === -1) list.push(cap);
      }
      /** Remove a capture component from the per-scene index. Called
       *  from the component's `onDisable`. */
      removeSceneCaptureCamera(scene, cap) {
        if (!scene || !cap) return;
        const list = this._sceneCaptureCameras.get(scene);
        if (!list) return;
        const idx = list.indexOf(cap);
        if (idx !== -1) list.splice(idx, 1);
      }
      /** Active capture cameras for a scene; SceneCapturePass iterates
       *  this list each frame. Returns an empty array when none are
       *  registered. */
      getSceneCaptureCameras(scene) {
        return this._sceneCaptureCameras.get(scene) ?? [];
      }
      // sort renderers by renderOrder and camera depth
      autoSortRenderNodes(scene) {
        let renderList = this._tr_RenderNodes.get(scene);
        if (!renderList)
          return;
        let needSort = false;
        let allWeighted = true;
        for (const renderNode of renderList) {
          if (renderNode.isRenderOrderChange || renderNode.needSortOnCameraZ) {
            needSort = true;
          }
          const mat = renderNode.materials?.[0];
          if (!mat || mat.oitMode !== "weighted") {
            allWeighted = false;
          }
          if (needSort && !allWeighted) break;
        }
        const view = scene.view;
        const useOIT = !!view?.engine3D?.setting.render?.useOIT;
        if (allWeighted && useOIT && renderList.length > 0) {
          for (const renderNode of renderList) {
            renderNode.isRenderOrderChange = false;
          }
          return this;
        }
        if (needSort) {
          for (const renderNode of renderList) {
            let __renderOrder = renderNode.renderOrder;
            if (renderNode.needSortOnCameraZ) {
              let cameraDepth = zSorterUtil.worldToCameraDepth(renderNode.object3D);
              cameraDepth = 1 - Math.max(0, Math.min(1, cameraDepth));
              __renderOrder += cameraDepth;
            }
            renderNode["__renderOrder"] = __renderOrder;
            renderNode.isRenderOrderChange = false;
          }
          renderList.sort((a, b) => {
            return a["__renderOrder"] > b["__renderOrder"] ? 1 : -1;
          });
        }
        return this;
      }
      getRenderNodes(scene, camera) {
        this.autoSortRenderNodes(scene);
        this._collectInfo.clean();
        this._collectInfo.sky = this.getSky(scene);
        if (scene.view?.engine3D?.setting.occlusionQuery.octree) {
          this.rendererOctree = this.getOctree(scene);
          this.rendererOctree.getRenderNode(camera.frustum, this._collectInfo);
        } else {
          let list2 = this._op_RenderNodes.get(scene);
          if (list2) {
            this._collectInfo.opaqueList = list2.concat();
          }
          let list5 = this._tr_RenderNodes.get(scene);
          if (list5) {
            this._collectInfo.transparentList = list5.concat();
          }
        }
        return this._collectInfo;
      }
      /**
       * Layer-aware variant of {@link getRenderNodes}. Returns freshly
       * built opaque + transparent arrays whose nodes pass the bitwise
       * AND test:
       *
       *     (node.visibleLayer & layerMask & cullingMask) !== 0
       *
       * Internally delegates the heavy lifting to {@link getRenderNodes}
       * so octree frustum culling, transparent z-sort, and the WBOIT
       * fast-path all stay shared with the legacy code path. The
       * filtering step is a single linear scan over the (already
       * frustum-culled) lists.
       *
       * When `(layerMask & cullingMask) === VisibleLayer.All`, the result
       * arrays are populated from the same scan rather than aliased to
       * the singleton's lists — callers can safely mutate / store the
       * returned arrays without affecting subsequent calls.
       *
       * @param scene       Scene to draw from.
       * @param camera      Active camera (required for octree frustum
       *                    culling on octree-enabled scenes).
       * @param layerMask   Pass-side layer mask, e.g. from
       *                    {@link RenderGraphPass.layerMask}.
       * @param cullingMask Camera-side culling mask, defaults to
       *                    {@link VisibleLayer.All}.
       */
      getLayerLists(scene, camera, layerMask, cullingMask = exports.VisibleLayer.All) {
        const mask = (layerMask & cullingMask) >>> 0;
        if (mask === 0) {
          return { opaque: [], transparent: [] };
        }
        const info = this.getRenderNodes(scene, camera);
        const opIn = info.opaqueList;
        const trIn = info.transparentList;
        const opOut = [];
        for (let i = 0, n = opIn.length; i < n; i++) {
          const node = opIn[i];
          if (EntityCollect.matchesLayer(node.visibleLayer, mask, exports.VisibleLayer.All)) opOut.push(node);
        }
        const trOut = [];
        for (let i = 0, n = trIn.length; i < n; i++) {
          const node = trIn[i];
          if (EntityCollect.matchesLayer(node.visibleLayer, mask, exports.VisibleLayer.All)) trOut.push(node);
        }
        return { opaque: opOut, transparent: trOut };
      }
      /**
       * Layer-visibility predicate shared by every pass / collector that
       * filters renderables by composition layer. Returns true when
       * `layer`, `layerMask`, and `cullingMask` share at least one set
       * bit — i.e. the renderable is opted into a layer that both the
       * pass and the camera want to see.
       *
       * Centralising the bitwise idiom here keeps the semantics
       * consistent between {@link EntityCollect.getLayerLists} (RenderNode
       * path) and {@link ComponentCollect.collectByTypeLayered}
       * (ComponentBase path); callers should not re-implement the
       * `(a & b & c) !== 0` test by hand.
       *
       * @param layer       The renderable's own layer membership value
       *                    (e.g. `RenderNode.visibleLayer`).
       * @param layerMask   Pass-side mask (e.g. {@link RenderGraphPass.layerMask}).
       * @param cullingMask Camera-side mask (e.g. {@link Camera3D.cullingMask}).
       *                    Pass {@link VisibleLayer.All} when the caller has
       *                    already AND-ed the camera mask into `layerMask`.
       */
      static matchesLayer(layer, layerMask, cullingMask = exports.VisibleLayer.All) {
        return ((layer | 0) & (layerMask & cullingMask)) !== 0;
      }
      getOpRenderGroup(scene) {
        return this._op_renderGroup.get(scene);
      }
      getTrRenderGroup(scene) {
        return this._tr_renderGroup.get(scene);
      }
      getGraphicList() {
        return this._graphics;
      }
      getRenderShaderCollect(view) {
        let viewList = this._renderShaderCollect.renderShaderUpdateList.get(view);
        return viewList;
      }
      // Engine3D.dispose() calls this so the singleton's scene-keyed maps
      // don't accumulate one entry per disposed engine. Each entry pins a
      // Scene3D plus its render-node / light / probe / sky arrays.
      removeScene(scene) {
        this._sceneLights?.delete(scene);
        this._sceneGIProbes?.delete(scene);
        this._op_RenderNodes?.delete(scene);
        this._tr_RenderNodes?.delete(scene);
        this._octreeRenderNodes?.delete(scene);
        this._reflections?.delete(scene);
        this._sceneCaptureCameras?.delete(scene);
        this._op_renderGroup?.delete(scene);
        this._tr_renderGroup?.delete(scene);
        this._skyMap?.delete(scene);
      }
      // Engine3D.dispose() also calls this — `_renderShaderCollect` is keyed by
      // View3D (not Scene3D) so removeScene() above can't reach it, and a stale
      // view-keyed entry here pins the view's camera, scene graph, and every
      // RenderNode that was ever enqueued for this view.
      removeView(view) {
        this._renderShaderCollect?.removeView(view);
      }
    }

    class RTResourceConfig {
      /** Key for the packed/compressed G-buffer texture. */
      static compressGBufferTex_NAME = "compressGBufferTex_NAME";
      /** Key for the scene color attachment. */
      static colorBufferTex_NAME = "colorBufferTex";
      /** Key for the world-position G-buffer attachment. */
      static positionBufferTex_NAME = "positionBufferTex";
      /** Key for the world-normal G-buffer attachment. */
      static normalBufferTex_NAME = "normalBufferTex";
      /** Key for the material-parameter G-buffer attachment. */
      static materialBufferTex_NAME = "materialBufferTex";
      /** Key for the main depth (z) buffer texture. */
      static zBufferTexture_NAME = "zBufferTexture";
      /** Key for the z-prepass depth texture. */
      static zPreDepthTexture_NAME = "zPreDepthTexture";
      /** Key for the post-processing output texture. */
      static outTex_NAME = "outTex";
    }

    class RenderTexture extends Texture {
      /** Resolve target view used when this render texture is multisampled. */
      resolveTarget;
      /** Number of MSAA samples; 0 means no multisampling. */
      sampleCount;
      /** Whether the texture resizes automatically with the context. */
      autoResize;
      /** Whether the texture is cleared at the start of a render pass. */
      clear;
      /**
       * create virtual texture
       * @param width width of texture
       * @param height height of texture
       * @param format GPUTextureFormat, default value is rgba8unorm
       * @param useMipmap whether or not gen mipmap
       * @returns
       */
      constructor(width, height, format = GPUTextureFormat.rgba8unorm, useMipMap = false, usage, numberLayer = 1, sampleCount = 0, clear = true, autoResize = true, ctx) {
        super(width, height, numberLayer);
        this.name = UUID();
        this.autoResize = autoResize;
        this.useMipmap = useMipMap;
        this.sampleCount = sampleCount;
        this.format = format;
        this.numberLayer = numberLayer;
        this.clear = clear;
        if (usage != void 0) {
          this.usage = usage;
        } else {
          this.usage = usage | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST;
        }
        this.resize(width, height, ctx);
        if (this.autoResize) {
          this._boundCtx.addEventListener(CResizeEvent.RESIZE, (e) => {
            let { width: width2, height: height2 } = e.data;
            this.resize(width2, height2);
            this._textureChange = true;
          }, this);
        }
      }
      /**
       * Recreate the GPU texture and sampler for the new size and current format.
       * @param width new texture width
       * @param height new texture height
       * @param ctx optional graphics context to bind to
       */
      resize(width, height, ctx) {
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        if (this.gpuTexture) {
          Texture.delayDestroyTexture(this._boundCtx, this.gpuTexture);
          this.gpuTexture = null;
          this.view = null;
        }
        this.width = width;
        this.height = height;
        this.createTextureDescriptor(width, height, 1, this.format, this.usage, this.numberLayer, this.sampleCount);
        this.useMipmap = false;
        this.visibility = GPUShaderStage.COMPUTE | GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT;
        if (this.format == GPUTextureFormat.rgba32float) {
          this.samplerBindingLayout.type = `non-filtering`;
          this.textureBindingLayout.sampleType = `unfilterable-float`;
          this.gpuSampler = device.createSampler({});
        } else if (this.format == GPUTextureFormat.depth32float) {
          this.samplerBindingLayout.type = `filtering`;
          this.sampler_comparisonBindingLayout.type = `comparison`;
          this.textureBindingLayout.sampleType = `depth`;
          this.gpuSampler = device.createSampler({});
          this.gpuSampler_comparison = device.createSampler({
            compare: "less",
            label: "sampler_comparison"
          });
        } else if (this.format == GPUTextureFormat.depth24plus || this.format == GPUTextureFormat.depth24plus_stencil8 || this.format == GPUTextureFormat.depth32float_stencil8) {
          this.samplerBindingLayout = {
            type: `filtering`
          };
          this.sampler_comparisonBindingLayout = {
            type: "comparison"
          };
          this.textureBindingLayout.sampleType = `depth`;
          this.gpuSampler = device.createSampler({});
          this.gpuSampler_comparison = device.createSampler({
            compare: "less",
            label: "sampler_comparison"
          });
        } else {
          this.samplerBindingLayout.type = `filtering`;
          this.textureBindingLayout.sampleType = `float`;
          if (this.sampleCount > 0) {
            this.textureBindingLayout.multisampled = true;
          }
          this.minFilter = "linear";
          this.magFilter = "linear";
          this.mipmapFilter = `linear`;
          this.addressModeU = GPUAddressMode.clamp_to_edge;
          this.addressModeV = GPUAddressMode.clamp_to_edge;
          this.gpuSampler = device.createSampler(this);
        }
        this._textureChange = true;
        this.noticeChange();
      }
      /**
      * create rt texture
      * @param width texture width
      * @param height texture height
      * @param data  texture pixel data
      * @param useMipmap texture use mipmap switch
      * @returns
      */
      create(width, height, useMiamp = true) {
        let device = this._boundCtx.device;
        const bytesPerRow = width * 4;
        let td = new Float32Array(width * height * 4);
        const textureDataBuffer = device.createBuffer({
          size: td.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, td);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
      }
      /**
       * Create a copy of this render texture with the same configuration.
       * @returns the cloned render texture
       */
      clone() {
        let texture = new RenderTexture(this.width, this.height, this.format, this.useMipmap, this.usage, this.numberLayer, this.sampleCount, this.clear, this.autoResize);
        texture.name = "clone_" + texture.name;
        return texture;
      }
      /**
       * Copy this texture's contents back into a CPU buffer.
       * @returns the mapped array buffer of the texture data
       */
      readTextureToImage() {
        const ctx = this._boundCtx;
        let device = ctx.device;
        let w = ctx.windowWidth;
        let h = ctx.windowHeight;
        let td = new Float32Array(w * h * 4);
        const textureBuffer = device.createBuffer({
          size: td.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        const commandEncoder = ctx.gpuContext.beginCommandEncoder();
        commandEncoder.copyTextureToBuffer(
          {
            texture: this.getGPUTexture()
          },
          {
            buffer: textureBuffer
          },
          [w, h]
        );
        let arryBuffer = textureBuffer.getMappedRange(0, td.byteLength);
        return arryBuffer;
      }
    }

    class RTResourceMap {
      static _registries = /* @__PURE__ */ new WeakMap();
      rtTextureMap = /* @__PURE__ */ new Map();
      static forContext(ctx) {
        let reg = this._registries.get(ctx);
        if (!reg) {
          reg = new RTResourceMap();
          this._registries.set(ctx, reg);
        }
        return reg;
      }
      static createRTTexture(ctx, name, rtWidth, rtHeight, format, useMipmap = false, sampleCount = 0) {
        let reg = this.forContext(ctx);
        let rt = reg.rtTextureMap.get(name);
        if (!rt) {
          if (name == RTResourceConfig.colorBufferTex_NAME) {
            rt = new RenderTexture(rtWidth, rtHeight, format, useMipmap, void 0, 1, sampleCount, false, true, ctx);
          } else {
            rt = new RenderTexture(rtWidth, rtHeight, format, useMipmap, void 0, 1, sampleCount, true, true, ctx);
          }
          rt.name = name;
          reg.rtTextureMap.set(name, rt);
        }
        return rt;
      }
      static createRTTextureArray(ctx, name, rtWidth, rtHeight, format, length = 1, useMipmap = false, sampleCount = 0) {
        let reg = this.forContext(ctx);
        let rt = reg.rtTextureMap.get(name);
        if (!rt) {
          rt = new RenderTexture(rtWidth, rtHeight, format, useMipmap, void 0, length, sampleCount, true, true, ctx);
          rt.name = name;
          reg.rtTextureMap.set(name, rt);
        }
        return rt;
      }
      static getTexture(ctx, name) {
        return this.forContext(ctx).rtTextureMap.get(name);
      }
      static CreateSplitTexture(ctx, id) {
        let colorTex = this.getTexture(ctx, RTResourceConfig.colorBufferTex_NAME);
        let tex = this.getTexture(ctx, id + "_split");
        if (!tex) {
          tex = this.createRTTexture(ctx, id + "_split", colorTex.width, colorTex.height, colorTex.format, false);
        }
        return tex;
      }
      static WriteSplitColorTexture(ctx, id) {
        let colorTex = this.getTexture(ctx, RTResourceConfig.colorBufferTex_NAME);
        let tex = this.getTexture(ctx, id + "_split");
        const gpu = ctx.gpuContext;
        const commandEncoder = gpu.beginCommandEncoder();
        commandEncoder.copyTextureToTexture(
          {
            texture: colorTex.getGPUTexture(),
            mipLevel: 0,
            origin: { x: 0, y: 0, z: 0 }
          },
          {
            texture: tex.getGPUTexture(),
            mipLevel: 0,
            origin: { x: 0, y: 0, z: 0 }
          },
          {
            width: tex.width,
            height: tex.height,
            depthOrArrayLayers: 1
          }
        );
        gpu.endCommandEncoder(commandEncoder);
      }
    }

    class OctreeEntity {
      renderer;
      owner;
      uuid;
      constructor(renderer) {
        this.renderer = renderer;
        this.uuid = renderer.object3D.instanceID;
      }
      leaveNode() {
        if (this.owner) {
          this.owner.entities.delete(this.uuid);
          this.owner = null;
        }
      }
      enterNode(node) {
        this.owner && this.leaveNode();
        this.owner = node;
        node.entities.set(this.uuid, this);
      }
      update(root) {
        let stayWithOwner = this.owner?.tryInsertEntity(this);
        if (!stayWithOwner) {
          this.leaveNode();
          root.tryInsertEntity(this);
        }
        return this.owner;
      }
    }

    class ProfilerUtil {
      static profilerLabelMap = /* @__PURE__ */ new Map();
      /** Per-view draw-statistic records keyed by the owning View3D. */
      static viewMap = /* @__PURE__ */ new Map();
      /** Scratch counters available for ad-hoc debugging. */
      static testObj = {
        testValue1: 0,
        testValue2: 0,
        testValue3: 0,
        testValue4: 0
      };
      /** Ensure a draw-stat record exists for the view and reset all pass counters to zero. */
      static startView(view) {
        let countInfo = this.viewMap.get(view);
        if (!countInfo) {
          countInfo = {};
          for (const key in PassType) {
            let i = parseInt(key);
            if (i >= 0) ; else {
              countInfo[key] = {
                vertexCount: 0,
                indicesCount: 0,
                instanceCount: 0,
                triCount: 0,
                drawCount: 0,
                pipelineCount: 0
              };
            }
          }
          this.viewMap.set(view, countInfo);
        }
        for (const key in PassType) {
          let i = parseInt(key);
          if (i >= 0) ; else {
            countInfo[key].vertexCount = 0;
            countInfo[key].indicesCount = 0;
            countInfo[key].triCount = 0;
            countInfo[key].instanceCount = 0;
            countInfo[key].drawCount = 0;
            countInfo[key].pipelineCount = 0;
          }
        }
      }
      /** Reset and return the draw-stat record for the view. */
      static viewCount(view) {
        this.startView(view);
        return this.viewMap.get(view);
      }
      /** Accumulate vertex count for a pass of the view. */
      static viewCount_vertex(view, pass, v) {
        this.viewMap.get(view)[pass].vertexCount += v;
      }
      /** Accumulate index count for a pass of the view. */
      static viewCount_indices(view, pass, v) {
        this.viewMap.get(view)[pass].indicesCount += v;
      }
      /** Accumulate triangle count for a pass of the view. */
      static viewCount_tri(view, pass, v) {
        this.viewMap.get(view)[pass].triCount += v;
      }
      /** Accumulate instance count for a pass of the view. */
      static viewCount_instance(view, pass, v) {
        this.viewMap.get(view)[pass].instanceCount += v;
      }
      /** Increment the draw-call count for a pass of the view. */
      static viewCount_draw(view, pass) {
        this.viewMap.get(view)[pass].drawCount++;
      }
      /** Increment the pipeline-switch count for a pass of the view. */
      static viewCount_pipeline(view, pass) {
        this.viewMap.get(view)[pass].pipelineCount++;
      }
      /** Drop the view's draw-stat record. */
      // Engine3D.dispose() calls this so profiler counters don't leak the
      // View3D (and its draw-stat record) for every disposed engine.
      static removeView(view) {
        this.viewMap.delete(view);
      }
      /** Begin (or restart) timing the named label. */
      static start(id) {
        let profilerLabel = this.profilerLabelMap.get(id);
        if (!profilerLabel) {
          profilerLabel = {
            lable: id,
            start: 0,
            end: 0,
            total: 0,
            count: 0,
            child: /* @__PURE__ */ new Map()
          };
          this.profilerLabelMap.set(id, profilerLabel);
        }
        profilerLabel.start = performance.now();
        profilerLabel.end = performance.now();
        profilerLabel.count = 0;
        profilerLabel.child.clear();
      }
      /** Stop timing the named label and record its total elapsed time. */
      static end(id) {
        let profilerLabel = this.profilerLabelMap.get(id);
        if (profilerLabel) {
          profilerLabel.end = performance.now();
          profilerLabel.total = profilerLabel.end - profilerLabel.start;
        }
      }
      /** Increment a label's call count and optionally begin timing a child label. */
      static countStart(id, id2 = "") {
        let profilerLabel = this.profilerLabelMap.get(id);
        if (profilerLabel) {
          profilerLabel.count++;
          if (id2 != "") {
            let node = profilerLabel.child.get(id2);
            if (!node) {
              node = {
                lable: id2,
                start: 0,
                end: 0,
                total: 0,
                count: 0
              };
            }
            node.start = performance.now();
            node.end = performance.now();
            node.count = 0;
            profilerLabel.child.set(id2, node);
          }
        }
      }
      /** Stop timing a child label and record its elapsed time and count. */
      static countEnd(id, id2) {
        let profilerLabel = this.profilerLabelMap.get(id);
        if (profilerLabel) {
          if (id2 != "") {
            let node = profilerLabel.child.get(id2);
            if (!node) {
              node = {
                lable: id2,
                start: 0,
                end: 0,
                total: 0,
                count: 0
              };
            }
            node.end = performance.now();
            node.total = node.end - node.start;
            node.count++;
          }
        }
      }
      /** Log the named label's total elapsed time to the console. */
      static print(id) {
        let profilerLabel = this.profilerLabelMap.get(id);
        if (profilerLabel) {
          console.log("performance", id, profilerLabel.total + " ms");
        }
      }
    }

    var __defProp$2 = Object.defineProperty;
    var __getOwnPropDesc$q = Object.getOwnPropertyDescriptor;
    var __decorateClass$q = (decorators, target, key, kind) => {
      var result = __getOwnPropDesc$q(target, key) ;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(target, key, result) ) || result;
      if (result) __defProp$2(target, key, result);
      return result;
    };
    class RenderNode extends ComponentBase {
      instanceCount = 0;
      lodLevel = 0;
      alwaysRender = false;
      instanceID;
      drawType = 0;
      _geometry;
      _materials = [];
      _castShadow = true;
      _castReflection = true;
      _castGI = false;
      _rendererMask = RendererMask.Default;
      _inRenderer = false;
      _readyPipeline = false;
      _combineShaderRefection;
      _ignoreEnvMap;
      _ignorePrefilterMap;
      __renderOrder = 0;
      //cameraDepth + _renderOrder
      _renderOrder = 0;
      _passInit = /* @__PURE__ */ new Map();
      isRenderOrderChange;
      needSortOnCameraZ;
      _octreeBinder;
      /**
       * Batching mode for this renderer. Drives whether the node is
       * collected into the default per-node opaque/transparent lists or
       * into a batched render-group (see {@link EntityBatchCollect}).
       *
       * Historically this field was named `_renderLayer`; that name was
       * vacated for the bitmask-based layer system, which now lives at
       * {@link ComponentBase.visibleLayer}.
       */
      _batchMode = BatchMode.None;
      _computes;
      init(param) {
        this.renderOrder = 0;
        this.instanceID = GetCountInstanceID().toString();
        this._computes = [];
      }
      attachSceneOctree(octree) {
        this._octreeBinder = { octree, entity: new OctreeEntity(this) };
        this.transform.eventDispatcher.addEventListener(Transform.LOCAL_ONCHANGE, this.updateOctreeEntity, this);
      }
      detachSceneOctree() {
        if (this._octreeBinder) {
          this._octreeBinder.entity?.leaveNode();
          this.transform.eventDispatcher.removeEventListener(Transform.LOCAL_ONCHANGE, this.updateOctreeEntity, this);
          this._octreeBinder = null;
        }
      }
      updateOctreeEntity(e) {
        this._octreeBinder?.entity?.update(this._octreeBinder.octree);
      }
      copyComponent(from) {
        super.copyComponent(from);
        this.geometry = from._geometry;
        this.materials = from._materials.slice();
        this.drawType = from.drawType;
        this.alwaysRender = from.alwaysRender;
        this.needSortOnCameraZ = from.needSortOnCameraZ;
        this.isRenderOrderChange = from.isRenderOrderChange;
        this.castShadow = from.castShadow;
        this.castGI = from.castGI;
        this.rendererMask = from.rendererMask;
        return this;
      }
      get batchMode() {
        return this._batchMode;
      }
      set batchMode(value) {
        this._batchMode = value;
      }
      get geometry() {
        return this._geometry;
      }
      set geometry(value) {
        if (this._geometry != value) {
          this._readyPipeline = false;
          if (this._geometry) {
            Reference.getInstance().detached(this._geometry, this);
          }
          if (value) {
            Reference.getInstance().attached(value, this);
          }
        }
        this._geometry = value;
      }
      addMask(mask) {
        this._rendererMask = RendererMaskUtil.addMask(this.rendererMask, mask);
      }
      removeMask(mask) {
        this._rendererMask = RendererMaskUtil.removeMask(this.rendererMask, mask);
      }
      hasMask(mask) {
        return RendererMaskUtil.hasMask(this.rendererMask, mask);
      }
      get rendererMask() {
        return this._rendererMask;
      }
      set rendererMask(value) {
        this._rendererMask = value;
      }
      get renderOrder() {
        return this._renderOrder;
      }
      set renderOrder(value) {
        if (value != this._renderOrder) {
          this.isRenderOrderChange = true;
          this.__renderOrder = value;
        }
        this._renderOrder = value;
      }
      get materials() {
        return this._materials;
      }
      set materials(value) {
        this._readyPipeline = false;
        for (let i = 0; i < this._materials.length; i++) {
          let mat = this._materials[i];
          Reference.getInstance().detached(mat, this);
          if (mat.shader && mat.shader.computes)
            this.removeComputes(mat.shader.computes);
        }
        for (let i = 0; i < value.length; i++) {
          let mat = value[i];
          Reference.getInstance().attached(mat, this);
          if (mat.shader && mat.shader.computes)
            this.addComputes(mat.shader.computes);
        }
        this._materials = value;
        let sort = 0;
        for (let i = 0; i < value.length; i++) {
          const element = value[i];
          const passArray = element.getPass(PassType.COLOR);
          const pass = passArray[0];
          if (pass.shaderState.transparent) {
            sort = sort > pass.renderOrder ? sort : pass.renderOrder;
          }
        }
        this.renderOrder = sort;
        if (!this._readyPipeline) {
          this.initPipeline();
        }
      }
      addComputes(computes) {
        this._computes.push(...computes);
      }
      removeComputes(computes) {
        for (const com of computes) {
          let index = this._computes.indexOf(com);
          if (index != -1) {
            this._computes.splice(index, 1);
          }
        }
      }
      addRendererMask(tag) {
        this._rendererMask = RendererMaskUtil.addMask(this._rendererMask, tag);
      }
      removeRendererMask(tag) {
        this._rendererMask = RendererMaskUtil.removeMask(this._rendererMask, tag);
      }
      onEnable() {
        if (!this._readyPipeline) {
          this.initPipeline();
        }
        EntityCollect.instance.addRenderNode(this.transform.scene3D, this);
        this.updateOctreeEntity();
      }
      onDisable() {
        this._enable = false;
        EntityCollect.instance.removeRenderNode(this.transform.scene3D, this);
        super.onDisable?.();
      }
      /**
       * Recompute renderOrder from current pass states and re-bucket
       * this renderer in EntityCollect (opaque vs transparent map).
       *
       * Called when a material's alphaMode flips at runtime — the
       * pass.renderOrder changes (3000 ↔ 0), but EntityCollect classifies
       * once at addRenderNode time. Without this nudge the renderer
       * stays in its old list and gets drawn through the wrong pipeline
       * (e.g. WBOIT continues drawing a HASH-toggled material).
       *
       * Materials hop into this via Reference.getReference(material)
       * to find every renderer holding them; sample code can also call
       * it directly after manual state changes.
       */
      refreshRenderClassification() {
        if (!this._enable) return;
        const scene = this.transform?.scene3D;
        if (!scene) return;
        let sort = 0;
        for (let i = 0; i < this._materials.length; i++) {
          const passArray = this._materials[i].getPass(PassType.COLOR);
          if (!passArray || passArray.length === 0) continue;
          const pass = passArray[0];
          if (pass.renderOrder >= 3e3) {
            sort = sort > pass.renderOrder ? sort : pass.renderOrder;
          }
        }
        this.renderOrder = sort;
        this.castNeedPass();
        EntityCollect.instance.addRenderNode(scene, this);
      }
      selfCloneMaterials(key) {
        let newMaterials = [];
        for (let i = 0, c = this.materials.length; i < c; i++) {
          const material = this.materials[i].clone();
          newMaterials.push(material);
        }
        this.materials = newMaterials;
        this._readyPipeline = false;
        this.initPipeline();
        return this;
      }
      initPipeline() {
        const ctx = this.transform?.view3D?.engine3D?.context3D;
        if (!ctx) return;
        if (this._geometry && this._materials.length > 0) {
          for (let j = 0; j < this._materials.length; j++) {
            const material = this._materials[j];
            let passList = material.getPass(PassType.COLOR);
            for (let i = 0; i < passList.length; i++) {
              const pass = passList[i];
              if (!pass.shaderReflection) {
                bindCtx(pass, ctx);
                pass.preCompile(this._geometry);
              }
              this._geometry.generate(pass.shaderReflection);
            }
            this.object3D.bound = this._geometry.bounds.clone();
          }
          this._readyPipeline = true;
          let sort = 0;
          for (let i = 0; i < this.materials.length; i++) {
            const element = this.materials[i];
            const passArray = element.getPass(PassType.COLOR);
            const pass = passArray[0];
            if (pass.renderOrder >= 3e3) {
              sort = sort > pass.renderOrder ? sort : pass.renderOrder;
            } else {
              sort = Math.max(sort - 3e3, 0);
            }
            this.castNeedPass();
          }
          this.renderOrder = sort;
          if (this.enable && this.transform && this.transform.scene3D) {
            EntityCollect.instance.addRenderNode(this.transform.scene3D, this);
          }
        }
      }
      castNeedPass() {
        if (this.castGI) {
          for (let i = 0; i < this.materials.length; i++) {
            const mat = this.materials[i];
            PassGenerate.createGIPass(this, mat.shader);
          }
        }
        for (let i = 0; i < this.materials.length; i++) {
          const mat = this.materials[i];
          if (mat.castShadow) {
            PassGenerate.createShadowPass(this, mat.shader);
          }
        }
        if (this.castReflection) {
          for (let i = 0; i < this.materials.length; i++) {
            const mat = this.materials[i];
            if (mat.castReflection) {
              PassGenerate.createReflectionPass(this, mat.shader);
            }
          }
        }
        let ignoreDepthPass = RendererMaskUtil.hasMask(this.rendererMask, RendererMask.IgnoreDepthPass);
        const zPrePass = this.transform.view3D?.engine3D?.setting.render.zPrePass ?? false;
        if (!ignoreDepthPass && zPrePass) {
          for (let i = 0; i < this.materials.length; i++) {
            const mat = this.materials[i];
            PassGenerate.createDepthPass(this, mat.shader);
          }
        } else {
          for (let i = 0; i < this.materials.length; i++) {
            const mat = this.materials[i];
            mat.shader.removeShaderByIndex(PassType.DEPTH, 0);
          }
        }
        for (let i = 0; i < this.materials.length; i++) {
          const mat = this.materials[i];
          if (mat.oitMode === "weighted") {
            PassGenerate.createOITPass(this, mat.shader);
          } else if (mat.oitMode === "depth-peel") {
            PassGenerate.createDepthPeelPasses(this, mat.shader);
          }
        }
      }
      get castShadow() {
        return this._castShadow;
      }
      set castShadow(value) {
        this._castShadow = value;
      }
      /**
       * Shadow cache classification.
       *
       * - `'auto'` (default): renderer is drawn to the shadow map every frame
       *   as part of the single-pass render — matches historical behaviour.
       * - `'static'`: renderer is drawn only to the cached static depth layer,
       *   rebuilt lazily when the light moves or the scene explicitly marks
       *   the static cache dirty. Use for buildings, terrain, prop meshes that
       *   don't move.
       * - `'dynamic'`: renderer is drawn every frame on top of the copied-in
       *   static layer. Use for characters, physics objects, anything that
       *   moves.
       *
       * Only consulted when `engine.setting.shadow.enableStaticCache === true`;
       * otherwise all renderers behave as `'auto'`.
       */
      shadowCacheMode = "auto";
      get castGI() {
        return this._castGI;
      }
      set castGI(value) {
        this._castGI = value;
      }
      get castReflection() {
        return this._castReflection;
      }
      set castReflection(value) {
        this._castReflection = value;
      }
      renderPass(view, passType, renderContext) {
        if (!this._geometry)
          return;
        let renderNode = this;
        let worldMatrix = renderNode.transform._worldMatrix;
        const gpu = view.engine3D.context3D.gpuContext;
        const nCount = Math.max(renderNode.materials.length, renderNode._geometry.subGeometries.length);
        for (let i = 0; i < nCount; i++) {
          const material = i >= renderNode.materials.length ? renderNode.materials[0] : renderNode.materials[i];
          if (!material || !material.enable)
            continue;
          let passes = material.getPass(passType);
          if (!passes || passes.length == 0)
            continue;
          gpu.bindGeometryBuffer(renderContext.encoder, renderNode._geometry);
          ProfilerUtil.viewCount_vertex(view, PassType[passType], renderNode._geometry.vertexCount);
          for (let j = 0; j < passes.length; j++) {
            if (!passes || passes.length == 0)
              continue;
            let matPass = passes[j];
            const renderShader = matPass;
            if (renderShader.pipeline) {
              if (renderShader.shaderState.splitTexture) {
                renderContext.endRenderPass();
                RTResourceMap.WriteSplitColorTexture(view.engine3D.context3D, renderNode.instanceID);
                renderContext.beginOpaqueRenderPass();
                gpu.bindCamera(renderContext.encoder, view.camera);
                gpu.bindGeometryBuffer(renderContext.encoder, renderNode._geometry);
              }
              let noneShare = gpu.bindPipeline(renderContext.encoder, renderShader);
              if (noneShare) {
                ProfilerUtil.viewCount_pipeline(view, PassType[passType]);
              }
              let subGeometry = i >= renderNode._geometry.subGeometries.length ? renderNode._geometry.subGeometries[0] : renderNode._geometry.subGeometries[i];
              let lodInfos = subGeometry.lodLevels;
              let lodInfo = lodInfos[renderNode.lodLevel];
              if (renderNode.instanceCount > 0) {
                ProfilerUtil.viewCount_instance(view, PassType[passType], renderNode.instanceCount);
                ProfilerUtil.viewCount_indices(view, PassType[passType], lodInfo.indexCount);
                ProfilerUtil.viewCount_tri(view, PassType[passType], lodInfo.indexCount / 3 * renderNode.instanceCount);
                gpu.drawIndexed(renderContext.encoder, lodInfo.indexCount, renderNode.instanceCount, lodInfo.indexStart, 0, 0);
              } else {
                ProfilerUtil.viewCount_indices(view, PassType[passType], lodInfo.indexCount);
                ProfilerUtil.viewCount_tri(view, PassType[passType], lodInfo.indexCount / 3);
                gpu.drawIndexed(renderContext.encoder, lodInfo.indexCount, 1, lodInfo.indexStart, 0, worldMatrix.index);
              }
              ProfilerUtil.viewCount_draw(view, PassType[passType]);
            }
          }
        }
      }
      /**
       * render pass at passType
       * @param pass
       * @param encoder
       * @returns
       */
      renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle = false) {
        if (!this.enable)
          return;
        if (!this._geometry)
          return;
        let node = this;
        let worldMatrix = node.object3D.transform._worldMatrix;
        const gpu = view.engine3D.context3D.gpuContext;
        const subGeometries = node._geometry.subGeometries;
        const nCount = Math.max(this.materials.length, subGeometries.length);
        for (let i = 0; i < nCount; i++) {
          const material = i >= this.materials.length ? this.materials[0] : this.materials[i];
          if (!material.castShadow && passType == PassType.SHADOW)
            continue;
          let passes = material.getPass(passType);
          if (!passes || passes.length == 0)
            continue;
          if (this.drawType == 2) {
            for (let matPass of passes) {
              if (matPass.pipeline) {
                gpu.bindPipeline(encoder, matPass);
                gpu.draw(encoder, 6, 1, 0, worldMatrix.index);
              }
            }
          } else {
            gpu.bindGeometryBuffer(encoder, node._geometry);
            for (let matPass of passes) {
              if (matPass.pipeline) {
                gpu.bindPipeline(encoder, matPass);
                const subGeometry = i >= subGeometries.length ? subGeometries[0] : subGeometries[i];
                let lodInfos = subGeometry.lodLevels;
                let lodInfo = lodInfos[node.lodLevel];
                if (this.instanceCount > 0) {
                  gpu.drawIndexed(encoder, lodInfo.indexCount, this.instanceCount, lodInfo.indexStart, 0, 0);
                } else {
                  gpu.drawIndexed(encoder, lodInfo.indexCount, 1, lodInfo.indexStart, 0, worldMatrix.index);
                }
              }
            }
          }
        }
      }
      recordRenderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle = false) {
        if (!this.enable) return;
        let node = this;
        const gpu = view.engine3D.context3D.gpuContext;
        const subGeometries = node._geometry.subGeometries;
        const nCount = Math.max(this.materials.length, subGeometries.length);
        for (let i = 0; i < nCount; i++) {
          const material = i >= this.materials.length ? this.materials[0] : this.materials[i];
          let passes = material.getPass(passType);
          if (!passes || passes.length == 0) continue;
          let worldMatrix = node.object3D.transform._worldMatrix;
          for (let j = 0; j < passes.length; j++) {
            const renderShader = passes[j];
            gpu.bindPipeline(encoder, renderShader);
            const subGeometry = i >= subGeometries.length ? subGeometries[0] : subGeometries[i];
            let lodInfos = subGeometry.lodLevels;
            let lodInfo = lodInfos[node.lodLevel];
            gpu.drawIndexed(encoder, lodInfo.indexCount, 1, lodInfo.indexStart, 0, worldMatrix.index);
          }
        }
      }
      noticeShaderChange() {
        if (this.enable) {
          this.onEnable();
          this._passInit.forEach((v, k) => {
            this._passInit.set(k, false);
          });
        }
      }
      preInit(_rendererType) {
        return this._passInit.get(_rendererType);
      }
      nodeUpdate(view, passType, renderPassState, clusterLightingBuffer) {
        let node = this;
        let envMap = view.scene.envMap;
        for (let j = 0; j < node.materials.length; j++) {
          let material = node.materials[j];
          let passes = material.getPass(passType);
          if (passes) {
            for (let i = 0; i < passes.length; i++) {
              const pass = passes[i];
              const renderShader = pass;
              if (renderShader.shaderState.splitTexture) {
                let splitTexture = RTResourceMap.CreateSplitTexture(view.engine3D.context3D, node.instanceID);
                renderShader.setTexture("splitTexture_Map", splitTexture);
              }
              if (!node._ignoreEnvMap && renderShader.envMap != envMap) {
                renderShader.setTexture(`envMap`, envMap);
              }
              if (!renderShader.prefilterMap) {
                renderShader.setTexture(`prefilterMap`, envMap);
              }
              let reflectionEntries = GlobalBindGroup.getReflectionEntries(view.scene);
              if (reflectionEntries && reflectionEntries.reflectionMap) {
                if (!renderShader.reflectionMap) {
                  renderShader.setTexture(`reflectionMap`, reflectionEntries.reflectionMap);
                }
                if (!renderShader.getStorageBuffer(`reflectionBuffer`)) {
                  renderShader.setStorageBuffer(`reflectionBuffer`, reflectionEntries.storageGPUBuffer);
                }
              }
              if (renderShader.pipeline) {
                renderShader.apply(view.engine3D.context3D, node._geometry, renderPassState, () => node.noticeShaderChange());
                continue;
              }
              let bdrflutTex = Engine3D.resFor(view.engine3D?.context3D).getTexture(`BRDFLUT`);
              renderShader.setTexture(`brdflutMap`, bdrflutTex);
              const graph = view.renderGraph;
              if (graph) {
                if (graph.pool.has("_MainShadowMap")) {
                  const depth2DArrayTexture = graph.pool.get("_MainShadowMap");
                  if (depth2DArrayTexture) {
                    renderShader.setTexture(`shadowMap`, depth2DArrayTexture);
                  }
                }
                if (graph.pool.has("_PointShadowCubeArray")) {
                  const cubeArrayTexture = graph.pool.get("_PointShadowCubeArray");
                  if (cubeArrayTexture) {
                    renderShader.setTexture(`pointShadowMap`, cubeArrayTexture);
                  }
                }
              }
              let iesTexture = IESProfilesPool.for(view.engine3D.context3D).iesTexture;
              if (iesTexture) {
                renderShader.setTexture(`iesTextureArrayMap`, iesTexture);
              }
              if (renderPassState.irradianceBuffer && renderPassState.irradianceBuffer.length > 0) {
                renderShader.setTexture(`irradianceMap`, renderPassState.irradianceBuffer[0]);
                renderShader.setTexture(`irradianceDepthMap`, renderPassState.irradianceBuffer[1]);
              }
              let lightUniformEntries = GlobalBindGroup.getLightEntries(view.scene);
              if (lightUniformEntries) {
                renderShader.setStorageBuffer(`lightBuffer`, lightUniformEntries.storageGPUBuffer);
                if (lightUniformEntries.irradianceVolume) {
                  renderShader.setUniformBuffer(`irradianceData`, lightUniformEntries.irradianceVolume.irradianceVolumeBuffer);
                }
              }
              if (clusterLightingBuffer) {
                renderShader.setStorageBuffer(`clustersUniform`, clusterLightingBuffer.clustersUniformBuffer);
                renderShader.setStorageBuffer(`lightAssignBuffer`, clusterLightingBuffer.lightAssignBuffer);
                renderShader.setStorageBuffer(`assignTable`, clusterLightingBuffer.assignTableBuffer);
                renderShader.setStorageBuffer(`clusterBuffer`, clusterLightingBuffer.clusterBuffer);
              }
              renderShader.apply(view.engine3D.context3D, node._geometry, renderPassState);
              this._passInit.set(passType, true);
            }
          }
        }
      }
      beforeDestroy(force) {
        if (this._geometry) {
          Reference.getInstance().detached(this._geometry, this);
          if (!Reference.getInstance().hasReference(this._geometry)) {
            this._geometry.destroy(force);
          }
        }
        for (let i = 0; i < this._materials.length; i++) {
          const mat = this._materials[i];
          Reference.getInstance().detached(mat, this);
          if (!Reference.getInstance().hasReference(mat)) {
            mat.destroy(force);
          }
        }
        super.beforeDestroy(force);
      }
      destroy(force) {
        super.destroy(force);
        this._geometry = void 0;
        this._materials.length = 0;
        this._combineShaderRefection = void 0;
      }
    }
    __decorateClass$q([
      EditorInspector
    ], RenderNode.prototype, "materials");
    __decorateClass$q([
      EditorInspector
    ], RenderNode.prototype, "castShadow");
    __decorateClass$q([
      EditorInspector
    ], RenderNode.prototype, "castGI");

    var __defProp$1 = Object.defineProperty;
    var __getOwnPropDesc$p = Object.getOwnPropertyDescriptor;
    var __decorateClass$p = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$p(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$1(target, key, result);
      return result;
    };
    exports.MeshRenderer = class MeshRenderer extends RenderNode {
      /**
       * Enabling this option allows the grid to display any shadows cast on the grid.
       */
      receiveShadow;
      morphData;
      constructor() {
        super();
      }
      onEnable() {
        super.onEnable();
      }
      onDisable() {
        super.onDisable();
      }
      cloneTo(obj) {
        let component = obj.addComponent(exports.MeshRenderer);
        component.copyComponent(this);
      }
      copyComponent(from) {
        super.copyComponent(from);
        this.receiveShadow = from.receiveShadow;
        return this;
      }
      get geometry() {
        return this._geometry;
      }
      set geometry(value) {
        super.geometry = value;
        if (value) {
          let isMorphTarget = value.morphTargetDictionary != null;
          if (isMorphTarget) {
            this.morphData ||= new MorphTargetData();
            this.morphData.morphTargetsRelative = value.morphTargetsRelative;
            this.morphData.initMorphTarget(value);
          }
          this.morphData && (this.morphData.enable = isMorphTarget);
          if (this.morphData?.enable) {
            this.addRendererMask(RendererMask.MorphTarget);
          } else {
            this.removeRendererMask(RendererMask.MorphTarget);
          }
          this.object3D.bound = this._geometry.bounds.clone();
        } else {
          if (this.morphData) {
            this.morphData.enable = false;
          }
          this.removeRendererMask(RendererMask.MorphTarget);
        }
        if (!this._readyPipeline) {
          this.initPipeline();
          if (this._computes) {
            this.onCompute = mergeFunctions(this.onCompute, (view) => {
              for (let i = 0; i < this._computes.length; i++) {
                const compute = this._computes[i];
                compute.onUpdate(view);
              }
            });
          }
        }
      }
      get material() {
        return this._materials[0];
      }
      set material(value) {
        this.materials = [value];
      }
      /**
       * Set deformation animation parameters
       */
      setMorphInfluence(key, value) {
        if (this.morphData && this.morphData.enable) {
          let index = this._geometry.morphTargetDictionary[key];
          if (index >= 0) {
            this.morphData.updateInfluence(index, value);
          }
        }
      }
      setMorphInfluenceIndex(index, value) {
        if (this.morphData && this.morphData.enable) {
          if (index >= 0) {
            this.morphData.updateInfluence(index, value);
          }
        }
      }
      onCompute(view, command) {
        if (this.morphData && this.morphData.enable) {
          this.morphData.computeMorphTarget(view, command);
        }
      }
      /**
       * @internal
       * @param passType
       * @param renderPassState
       * @param scene3D
       * @param clusterLightingRender
       * @param probes
       */
      nodeUpdate(view, passType, renderPassState, clusterLightingBuffer) {
        if (this.morphData && this.morphData.enable) {
          for (let i = 0; i < this.materials.length; i++) {
            const material = this.materials[i];
            let passes = material.getPass(passType);
            if (passes) {
              for (let j = 0; j < passes.length; j++) {
                this.morphData.applyRenderShader(passes[j]);
              }
            }
          }
        }
        super.nodeUpdate(view, passType, renderPassState, clusterLightingBuffer);
      }
      destroy(force) {
        super.destroy(force);
      }
      // public onGraphic(view?: View3D) {
      //     let graphic3D = view.scene.getChildByName('graphic3D')
      //     if(!graphic3D)
      //         return
      //     if (this._geometry)
      //         graphic3D.drawMeshWireframe(this._geometry.instanceID, this._geometry, this.transform, Color.COLOR_RED);
      // }
    };
    __decorateClass$p([
      EditorInspector
    ], exports.MeshRenderer.prototype, "geometry", 1);
    __decorateClass$p([
      EditorInspector
    ], exports.MeshRenderer.prototype, "material", 1);
    exports.MeshRenderer = __decorateClass$p([
      RegisterComponent(exports.MeshRenderer, "MeshRenderer")
    ], exports.MeshRenderer);

    class BoundUtil {
      static maxVector = new Vector3(Number.MAX_VALUE * 0.1, Number.MAX_VALUE * 0.1, Number.MAX_VALUE * 0.1);
      static minVector = this.maxVector.clone().multiplyScalar(-1);
      static genMeshMaxVector = Vector3.ZERO.clone();
      static genMeshMinVector = Vector3.ZERO.clone();
      static genMeshVectorList8 = [new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3(), new Vector3()];
      /**
       * Merge the bounding boxes that have been added to the world matrix based on the mesh of the children node
       */
      static genMeshBounds(obj, bound) {
        let tempMin = this.genMeshMinVector;
        let tempMax = this.genMeshMaxVector;
        let tempPoints = this.genMeshVectorList8;
        bound ||= new BoundingBox(Vector3.ZERO, Vector3.ZERO);
        bound.setFromMinMax(this.maxVector, this.minVector);
        let cmpts = obj.getComponents(exports.MeshRenderer);
        for (const cmpt of cmpts) {
          if (cmpt && cmpt.geometry) {
            let matrix = cmpt.object3D.transform.worldMatrix;
            tempMin.copy(cmpt.geometry.bounds.min);
            tempMax.copy(cmpt.geometry.bounds.max);
            tempPoints[0].set(tempMin.x, tempMin.y, tempMin.z);
            tempPoints[1].set(tempMin.x, tempMin.y, tempMax.z);
            tempPoints[2].set(tempMin.x, tempMax.y, tempMin.z);
            tempPoints[3].set(tempMin.x, tempMax.y, tempMax.z);
            tempPoints[4].set(tempMax.x, tempMin.y, tempMin.z);
            tempPoints[5].set(tempMax.x, tempMin.y, tempMax.z);
            tempPoints[6].set(tempMax.x, tempMax.y, tempMin.z);
            tempPoints[7].set(tempMax.x, tempMax.y, tempMax.z);
            for (const p of tempPoints) {
              Matrix4.transformPoint(matrix, p, p);
              bound.expandByPoint(p);
            }
          }
        }
        tempMax.copy(bound.max);
        tempMin.copy(bound.min);
        bound.setFromMinMax(tempMin, tempMax);
        return bound;
      }
      static transformBound(matrix, source, bound) {
        let tempMin = this.genMeshMinVector.copy(source.min);
        let tempMax = this.genMeshMaxVector.copy(source.max);
        let tempPoints = this.genMeshVectorList8;
        bound ||= new BoundingBox(Vector3.ZERO, Vector3.ZERO);
        bound.setFromMinMax(this.maxVector, this.minVector);
        tempPoints[0].set(tempMin.x, tempMin.y, tempMin.z);
        tempPoints[1].set(tempMin.x, tempMin.y, tempMax.z);
        tempPoints[2].set(tempMin.x, tempMax.y, tempMin.z);
        tempPoints[3].set(tempMin.x, tempMax.y, tempMax.z);
        tempPoints[4].set(tempMax.x, tempMin.y, tempMin.z);
        tempPoints[5].set(tempMax.x, tempMin.y, tempMax.z);
        tempPoints[6].set(tempMax.x, tempMax.y, tempMin.z);
        tempPoints[7].set(tempMax.x, tempMax.y, tempMax.z);
        for (const p of tempPoints) {
          Matrix4.transformPoint(matrix, p, p);
          bound.expandByPoint(p);
        }
        tempMax.copy(bound.max);
        tempMin.copy(bound.min);
        bound.setFromMinMax(tempMin, tempMax);
        return bound;
      }
    }

    class Entity extends CEventDispatcher {
      /**
       *
       * The name of the object. The default value is an empty string.
       */
      name = "";
      _instanceID = "";
      _numChildren;
      /**
       * The unique identifier of the object.
       */
      get instanceID() {
        return this._instanceID;
      }
      /**
       *
       * The Transform attached to this object.
       */
      transform;
      /**
       *
       * Renderer components
       */
      renderNode;
      /**
       *
       * An array containing sub objects of an object
       */
      entityChildren;
      /**
       *
       * List of components attached to an object
       */
      components;
      waitDisposeComponents;
      /**
       *
       * The bounding box of an object
       */
      _bound;
      _boundWorld;
      _isBoundChange = true;
      _dispose = false;
      get dispose() {
        return this._dispose;
      }
      /**
       *
       * Starting from the object itself, search for the object and its children, and return the first child object with a matching name.
       * For most objects, the name is an empty string by default. You must manually set it to use this method.
       * @param name input name
       * @returns result Entity
       */
      getObjectByName(name) {
        let isPath = name.indexOf("/") >= 0;
        if (!isPath) {
          return this.getChildByName(name, false);
        } else {
          let list = name.split("/");
          let currentEntity = this;
          while (list.length > 0 && currentEntity) {
            let shortName = list.shift();
            currentEntity = currentEntity.getChildByName(shortName, false);
            if (!currentEntity) {
              return null;
            }
          }
          return currentEntity;
        }
      }
      /**
       *
       * @constructor
       */
      constructor() {
        super();
        this.entityChildren = [];
        this.components = /* @__PURE__ */ new Map();
        this._instanceID = GetCountInstanceID().toString();
        this.waitDisposeComponents = [];
      }
      /**
       *
       * Returns the number of child objects of an object
       */
      get numChildren() {
        return this._numChildren;
      }
      /**
       *
       * Add an object as a child of this object. You can add any number of objects.
       * Any current parent object on the object passed here will be deleted, as an object can only have at most one parent object.
       * @param child target child entity
       * @returns
       */
      addChild(child) {
        if (child == null) {
          throw new Error("child is null!");
        }
        if (child === this) {
          throw new Error("child is self!");
        }
        let index = this.entityChildren.indexOf(child);
        if (index == -1) {
          child.removeFromParent();
          child.transform.parent = this.transform;
          this.entityChildren.push(child);
          this._numChildren = this.entityChildren.length;
          this.noticeComponents(`onAddChild`, child);
          return child;
        }
        return null;
      }
      /**
       *
       * Remove the child objects of the object. You can remove any number of objects.
       * @param child Removed objects
       */
      removeChild(child) {
        if (child === null) return;
        if (child === this) throw new Error("add child is self!");
        let index = this.entityChildren.indexOf(child);
        if (index != -1) {
          this.entityChildren.splice(index, 1);
          child.transform.parent = null;
          this._numChildren = this.entityChildren.length;
          this.noticeComponents(`onRemoveChild`, child);
        }
      }
      /**
       *
       * Remove all children of the current object
       */
      removeAllChild() {
        while (this.numChildren > 0) {
          this.removeChild(this.entityChildren[0]);
        }
      }
      /**
       *
       * Remove the current node from the parent
       * @returns this
       */
      removeSelf() {
        return this.removeFromParent();
      }
      /**
       *
       * Search for child nodes of objects and remove child objects with matching indexes.
       * @param index assign index
       * @returns
       */
      removeChildByIndex(index) {
        if (index >= 0 && index < this.entityChildren.length) {
          this.removeChild(this.entityChildren[index]);
        } else {
          console.error("remove child by index , index out of range");
        }
      }
      /**
       *
       * Does the current object contain a certain object
       * @param child certain object
       * @returns boolean
       */
      hasChild(child) {
        let index = this.entityChildren.indexOf(child);
        return index != -1;
      }
      /**
       *
       * Remove the current node from the parent
       * @returns this
       */
      removeFromParent() {
        let parent = this.transform.parent;
        if (parent && parent.object3D) {
          parent.object3D.removeChild(this);
        }
        return this;
      }
      /**
       *
       * Search for object children and return the first child object with a matching index.
       * @param index matching index
       * @returns child entity
       */
      getChildByIndex(index) {
        let outObj = null;
        if (index < this.entityChildren.length) {
          outObj = this.entityChildren[index];
        }
        return outObj;
      }
      /**
       *
       * Search for object children and return a child object with a matching name.
       * @param name matching name
       * @param loopChild Whether to traverse the children of the child object. The default value is true
       * @returns result
       */
      getChildByName(name, loopChild = true) {
        let out = null;
        for (const iterator of this.entityChildren) {
          if (iterator.name == name) {
            out = iterator;
            return out;
          } else if (loopChild) {
            out = iterator.getChildByName(name, loopChild);
            if (out) {
              return out;
            }
          }
        }
        return out;
      }
      /**
       * @internal
       */
      update() {
      }
      /**
       *
       * @private
       * @returns
       */
      instantiate() {
        return null;
      }
      onTransformLocalChange(e) {
        this._isBoundChange = true;
      }
      get bound() {
        (this._isBoundChange || !this._bound) && this.updateBound();
        return this._boundWorld;
      }
      set bound(value) {
        this._bound = value;
        this._boundWorld = this._bound.clone();
        this._isBoundChange = true;
      }
      updateBound() {
        if (!this._bound) {
          this._bound = new BoundingBox();
          this._boundWorld = this._bound.clone();
          this._isBoundChange = true;
        }
        if (this._isBoundChange) {
          BoundUtil.transformBound(this.transform.worldMatrix, this._bound, this._boundWorld);
          this._isBoundChange = false;
        }
        return this._boundWorld;
      }
      /**
       *
       * @private
       * @returns
       */
      waitUpdate() {
        if (this._dispose) {
          if (this.transform.parent) {
            this.transform.parent.object3D.removeChild(this);
          }
          this.components.forEach((v, k) => {
            v.enable = false;
            v.beforeDestroy();
            v.destroy();
          });
          this.components.clear();
        } else {
          ComponentCollect.waitStartComponent.forEach((v, k) => {
            while (v.length > 0) {
              const element = v.shift();
              element[`__start`]();
              ComponentCollect.waitStartComponent.delete(element.object3D);
            }
          });
        }
      }
      noticeComponents(key, data) {
        for (let item of this.components.values()) {
          let typeKey = key;
          item[typeKey]?.(data);
        }
      }
      /**
       * release current object
       */
      destroy(force) {
        if (!this._dispose) {
          this.components.forEach((c) => {
            c.beforeDestroy(force);
          });
          this.components.forEach((c) => {
            c.destroy(force);
          });
          this.components.clear();
          const children = this.entityChildren.slice();
          for (const c of children) c.destroy(force);
          this.removeAllChild();
          this.transform.parent = null;
          this._dispose = true;
          super.destroy();
        }
      }
    }

    var __getOwnPropDesc$o = Object.getOwnPropertyDescriptor;
    var __decorateClass$o = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$o(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.Object3D = class Object3D extends Entity {
      _isScene3D;
      prefabRef;
      serializeTag;
      /**
       * Instantiate a 3D object
       */
      constructor() {
        super();
        this.transform = this.addComponent(Transform);
        this.transform.eventDispatcher.addEventListener(Transform.LOCAL_ONCHANGE, this.onTransformLocalChange, this);
      }
      get isScene3D() {
        return this._isScene3D;
      }
      /**
       *
       * Traverse all sub objects starting from the object itself.
       *  If there are still sub objects in the sub object, recursively traverse.
       * @param callFunction execution body. Will execute sub objects as parameters
       * @returns
       */
      forChild(call) {
        this.entityChildren.forEach((element) => {
          call(element);
          element.forChild(call);
        });
      }
      /**
       *
       * Create a new component and add it to the object, and return an instance of the component.
       *  If a component of this type already exists, it will not be added and will return null.
       * @param c class of component
       * @return result component
       */
      addComponent(c, param) {
        if (!this.components.has(c)) {
          let instance = new c();
          instance.object3D = this;
          this.components.set(c, instance);
          instance[`__init`](param);
          ComponentCollect.appendWaitStart(instance);
          return instance;
        }
        return this.components.get(c);
      }
      /**
       *
       * Returns an instance of a component object of the specified type.
       *  If there are no components of that type, a new component is created and added to the object.
       * @param c class of component
       * @returns result component
       */
      getOrAddComponent(c) {
        let component = this.components.get(c);
        if (!component) {
          component = this.addComponent(c);
        }
        return component;
      }
      /**
       *
       * Remove components of the specified type
       * @param c class of component
       */
      removeComponent(c) {
        if (this.components.has(c)) {
          let component = this.components.get(c);
          ComponentCollect.removeWaitStart(this, component);
          this.components.delete(c);
          component[`__stop`]();
          component.beforeDestroy();
          component.destroy();
        }
      }
      /**
       *
       * Is there a component of the specified type
       * @param c type of component
       * @returns boolean
       */
      hasComponent(c) {
        return this.components.has(c);
      }
      /**
       *
       * Returns a component of the specified type.
       * @param c class of component
       * @returns result component
       */
      getComponent(c) {
        return this.components.get(c);
      }
      /**
       *
       * Returns a component object of the specified type from the parent node.
       *  If there are no components of that type,
       *  calls the parent object lookup of the parent object
       * @param c class of component
       * @returns reulst component
       */
      getComponentFromParent(c) {
        if (!this.parent) {
          return null;
        }
        let component = this.parent.object3D.getComponent(c);
        if (component) {
          return component;
        }
        return this.parent.object3D.getComponentFromParent(c);
      }
      /**
       *
       * Returns an array of component objects of the specified type.
       *  If there are no components of that type, search in the list of self body class objects
       * @param c class of component
       * @returns result components
       */
      getComponentsInChild(c) {
        let list = [];
        let component = this.components.get(c);
        if (component) {
          list.push(component);
        }
        for (let i = 0; i < this.entityChildren.length; i++) {
          let child = this.entityChildren[i];
          let coms = child.getComponentsInChild(c);
          list.push(...coms);
        }
        return list;
      }
      /**
       *
       * Returns all components of the specified type contained in the current object and its children.
       *  If there are children in the child object, recursively search.
       * @param c class of component
       * @param outList result component list
       * @param includeInactive Whether to include invisible objects, default to false
       * @returns {outList}
       */
      getComponents(c, outList, includeInactive) {
        outList ||= [];
        let component = this.getComponent(c);
        if (component && (component.enable || includeInactive)) {
          outList.push(component);
        }
        for (let i = 0, count = this.entityChildren.length; i < count; i++) {
          let child = this.entityChildren[i];
          if (child && child instanceof exports.Object3D) {
            child.getComponents(c, outList, includeInactive);
          }
        }
        return outList;
      }
      /**
       *
       * Quickly obtain components and no longer access child nodes after obtaining them at a certain node
       * @template T
       * @param {{ new(): T; }} c class of component
       * @param ret List of incoming T
       * @param includeInactive Whether to include invisible objects, default to false
       * @return {*}  {T}
       * @memberof Object3D
       */
      getComponentsExt(c, ret, includeInactive) {
        ret ||= [];
        let component = this.components.get(c);
        if (component && (component.enable || includeInactive)) {
          ret.push(component);
        } else {
          for (const node of this.entityChildren) {
            if (node instanceof exports.Object3D) {
              node.getComponentsExt(c, ret, includeInactive);
            }
          }
        }
        return ret;
      }
      getComponentsByProperty(key, value, findedAndBreak = true, ret, includeInactive) {
        ret ||= [];
        let findComponent;
        for (const component of this.components.values()) {
          if (component && (component.enable || includeInactive)) {
            if (component[key] === value) {
              ret.push(component);
              findComponent = true;
            }
          }
        }
        if (!(findComponent && findedAndBreak)) {
          for (const node of this.entityChildren) {
            if (node instanceof exports.Object3D) {
              node.getComponentsByProperty(key, value, findedAndBreak, ret, includeInactive);
            }
          }
        }
        return ret;
      }
      /**
       *
       * clone a Object3D
       * @returns
       */
      clone() {
        return this.instantiate();
      }
      /**
       *
       * @private
       * @returns
       */
      instantiate() {
        let tmp = new exports.Object3D();
        tmp.name = this.name;
        tmp.serializeTag = this.serializeTag;
        tmp.prefabRef = this.prefabRef;
        this.entityChildren.forEach((v, k) => {
          let tmpChild = v.instantiate();
          tmp.addChild(tmpChild);
        });
        this.components.forEach((v, k) => {
          v.cloneTo(tmp);
        });
        return tmp;
      }
      //****************
      //****************
      //****************
      //****************
      /**
       * Get the position of an object relative to its parent
       */
      get localPosition() {
        return this.transform.localPosition;
      }
      /**
       * Set the position of an object relative to its parent
       */
      set localPosition(value) {
        this.transform.localPosition = value;
      }
      /**
       * Get the rotation attribute of an object relative to its parent
       */
      get localRotation() {
        return this.transform.localRotation;
      }
      /**
       * Set the rotation attribute of an object relative to its parent
       */
      set localRotation(value) {
        this.transform.localRotation = value;
      }
      /**
       * Get the scaling attribute of an object relative to its parent
       */
      get localScale() {
        return this.transform.localScale;
      }
      /**
       * Set the scaling attribute of an object relative to its parent
       */
      set localScale(value) {
        this.transform.localScale = value;
      }
      /**
       * Get the rotation attribute of an object relative to its parent, which is a quaternion
       */
      get localQuaternion() {
        return this.transform.localRotQuat;
      }
      /**
       * Set the rotation attribute of an object relative to its parent, which is a quaternion
       */
      set localQuaternion(value) {
        this.transform.localRotQuat = value;
      }
      /**
       * Notify transformation attribute updates
       */
      notifyChange() {
        this.transform.notifyChange();
      }
      /**
       *
       * Transform component of object parent
       */
      get parent() {
        return this.transform.parent;
      }
      /**
       *
       * parent object3D
       */
      get parentObject() {
        return this.transform.parent.object3D;
      }
      /**
       *
       * Set the x coordinate relative to the local coordinates of the parent container.
       */
      set x(value) {
        this.transform.x = value;
      }
      /**
       *
       * Get the x coordinate relative to the local coordinates of the parent container.
       */
      get x() {
        return this.transform.x;
      }
      /**
       * Set the y coordinate relative to the local coordinates of the parent container.
       */
      set y(value) {
        this.transform.y = value;
      }
      /**
       *
       * Get the y coordinate relative to the local coordinates of the parent container.
       */
      get y() {
        return this.transform.y;
      }
      /**
       * Set the z coordinate relative to the local coordinates of the parent container.
       */
      set z(value) {
        this.transform.z = value;
      }
      /**
       * Get the z coordinate relative to the local coordinates of the parent container.
       */
      get z() {
        return this.transform.z;
      }
      /**
       * Set the x scale relative to the local coordinates of the parent container.
       */
      set scaleX(value) {
        this.transform.scaleX = value;
      }
      /**
       *
       * Get the x scale relative to the local coordinates of the parent container.
       */
      get scaleX() {
        return this.transform.scaleX;
      }
      /**
       *
       * Set the y scale relative to the local coordinates of the parent container.
       */
      set scaleY(value) {
        this.transform.scaleY = value;
      }
      /**
       *
       * Get the y scale relative to the local coordinates of the parent container.
       */
      get scaleY() {
        return this.transform.scaleY;
      }
      /**
       *
       * Set the z scale relative to the local coordinates of the parent container.
       */
      set scaleZ(value) {
        this.transform.scaleZ = value;
      }
      /**
       *
       * Get the z scale relative to the local coordinates of the parent container.
       */
      get scaleZ() {
        return this.transform.scaleZ;
      }
      /**
       *
       * Set the x rotation relative to the local coordinates of the parent container.
       */
      set rotationX(value) {
        this.transform.rotationX = value;
      }
      /**
       *
       * Get the x rotation relative to the local coordinates of the parent container.
       */
      get rotationX() {
        return this.transform.rotationX;
      }
      /**
       *
       * Set the y rotation relative to the local coordinates of the parent container.
       */
      set rotationY(value) {
        this.transform.rotationY = value;
      }
      /**
       *
       * Get the y rotation relative to the local coordinates of the parent container.
       */
      get rotationY() {
        return this.transform.rotationY;
      }
      /**
       *
       * Set the z rotation relative to the local coordinates of the parent container.
       */
      set rotationZ(value) {
        this.transform.rotationZ = value;
      }
      /**
       *
       * Set the z rotation relative to the local coordinates of the parent container.
       */
      get rotationZ() {
        return this.transform.rotationZ;
      }
      /**
       * @internal
       */
      fixedUpdate() {
      }
      /**
       * @internal
       */
      lateUpdate() {
      }
      /**
       *
       * Recursive child nodes and execute specified function
       * @param callback specified function
       */
      traverse(callback) {
        callback(this);
        for (let i = 0, l = this.entityChildren.length; i < l; i++) {
          let item = this.entityChildren[i];
          if (item instanceof exports.Object3D) {
            item.traverse(callback);
          }
        }
      }
      /**
       *
       * Release self
       */
      destroy(force) {
        this.transform.eventDispatcher.removeEventListener(Transform.LOCAL_ONCHANGE, this.onTransformLocalChange, this);
        super.destroy(force);
      }
    };
    exports.Object3D = __decorateClass$o([
      DecorateObject3D
    ], exports.Object3D);
    function DecorateObject3D(ctor, _) {
      return class extends exports.Object3D {
        set active(value) {
          this.transform.enable = value > 0;
        }
        get active() {
          return this.transform.enable ? 1 : 0;
        }
        get materialColor() {
          let component = this.getComponent(exports.MeshRenderer);
          return component?.material?.shader.getDefaultColorShader().baseColor;
        }
        set materialColor(color) {
          let material = this.getComponent(exports.MeshRenderer)?.material;
          material && (material.shader.getDefaultColorShader().baseColor = color);
        }
        notifyMaterialColorChange(materialIndex, key) {
          let materials = this.getComponent(exports.MeshRenderer).materials;
          materials?.[materialIndex]?.shader.getDefaultColorShader().uniforms[key].onChange();
        }
      };
    }

    const ctxOf = (camera) => {
      const ctx = camera?._boundCtx ?? camera?.transform?.view3D?.engine3D?.context3D;
      if (!ctx) {
        throw new Error(`CameraUtil: camera has no bound Context3D. Attach the camera to a scene/view before projecting.`);
      }
      return ctx;
    };
    class CameraUtil {
      /**
       * create a Camera3D component
       * @param parent parent object3D
       * @param name set name to the owner of this camera3D
       * @returns
       */
      static createCamera3DObject(parent, name) {
        return this.createCamera3D(null, parent, name);
      }
      /**
       * @internal
       * @param object3D
       * @param parent
       * @param name
       * @returns
       */
      static createCamera3D(object3D, parent, name) {
        object3D ||= new exports.Object3D();
        parent && parent.addChild(object3D);
        name && (object3D.name = name);
        return object3D.getOrAddComponent(Camera3D);
      }
      /**
       * @internal
       * @param sX
       * @param sY
       * @param sZ
       * @param camera
       * @returns
       */
      static UnProjection(sX, sY, sZ = 1, camera) {
        let mouse = new Vector3(sX, sY, 0);
        let sc = 1;
        let ina = Vector3.HELP_0;
        let ctx = ctxOf(camera);
        let ox = ctx.canvas.offsetLeft;
        let oy = ctx.canvas.offsetTop;
        let w = ctx.canvas.clientWidth;
        let h = ctx.canvas.clientHeight;
        ina.x = ((mouse.x - ox) * sc / w - 0.5) * 2;
        ina.y = -((mouse.y - oy) * sc / h - 0.5) * 2;
        ina.z = sZ;
        let outP = new Vector3(0, 0, 0);
        let projectWorld = Matrix4.helpMatrix2;
        projectWorld.copy(camera.projectionMatrix);
        projectWorld.invert();
        let cameraToWorld = Matrix4.helpMatrix;
        cameraToWorld.identity();
        cameraToWorld.multiply(projectWorld);
        cameraToWorld.multiply(camera.transform.worldMatrix);
        cameraToWorld.perspectiveMultiplyPoint3(ina, outP);
        return outP;
      }
      /**
       * @internal
       * @param point
       * @param camera
       * @param target
       * @returns
       */
      static Projection(point, camera, target) {
        let outP = target ? target : new Vector3(0, 0, 0);
        let cameraToWorld = Matrix4.helpMatrix;
        cameraToWorld.copy(camera.viewMatrix);
        cameraToWorld.multiply(camera.projectionMatrix);
        cameraToWorld.perspectiveMultiplyPoint3(point, outP);
        let ctx = ctxOf(camera);
        let w = ctx.canvas.clientWidth / 2;
        let h = ctx.canvas.clientHeight / 2;
        outP.x = outP.x * w + w;
        outP.y = h - outP.y * h;
        return outP;
      }
      /**
       * @internal
       * @param sceneX
       * @param sceneY
       * @param z
       * @param camera
       * @param target
       * @returns
       */
      static UnProjection2(sceneX, sceneY, z, camera, target) {
        let outP = target ? target : new Vector3(0, 0, 0);
        let cameraToWorld = Matrix4.helpMatrix;
        cameraToWorld.copy(camera.pvMatrixInv);
        let ctx = ctxOf(camera);
        let w = ctx.canvas.clientWidth / 2;
        let h = ctx.canvas.clientHeight / 2;
        outP.x = (sceneX - w) / w;
        outP.y = (h - sceneY) / h;
        outP.z = z;
        cameraToWorld.perspectiveMultiplyPoint3(outP, outP);
        return outP;
      }
    }

    class BoundingSphere {
      /** The center of the sphere. */
      center = new Vector3();
      /** Half-size extents (provided for {@link IBound} compatibility). */
      extents;
      //= new Vector3();
      /** Maximum corner of the enclosing box (for {@link IBound} compatibility). */
      max;
      //= new Vector3();
      /** Minimum corner of the enclosing box (for {@link IBound} compatibility). */
      min;
      // = new Vector3();
      /** Full size of the enclosing box (for {@link IBound} compatibility). */
      size;
      //= new Vector3();
      /** Scratch vector A used by intersection tests. */
      tmpVecA = new Vector3();
      /** Scratch vector B used by intersection tests. */
      tmpVecB = new Vector3();
      /** Scratch vector C used by intersection tests. */
      tmpVecC = new Vector3();
      /** Scratch vector D used by intersection tests. */
      tmpVecD = new Vector3();
      /** Radius of the sphere. */
      radius = 0;
      /** Scratch vector holding the difference between two points. */
      diffBetweenPoints = new Vector3();
      /** The object that owns this bound. */
      owner;
      /** The owner's forward direction in world space. */
      forward = new Vector3(0, 0, 1);
      /** The sphere center in world space. */
      worldCenter;
      /** The sphere size in world space. */
      worldSize;
      /**
       * @internal
       */
      _center = new Vector3();
      constructor(center, radius) {
        this.center = center || new Vector3(0, 0, 0);
        this.radius = radius === void 0 ? 0.5 : radius;
      }
      /**
       * Recompute the bound from the source data. Not implemented for spheres.
       */
      updateBound() {
        throw new Error("Method not implemented.");
      }
      /**
       * Whether the given point lies inside the sphere.
       * @param point the point to test
       */
      containsPoint(point) {
        Vector3.sub(this.tmpVecA, point, this.center);
        var lenSq = this.center.lengthSquared;
        var r = this.radius;
        return lenSq < r * r;
      }
      /**
       * @function
       * @name pc.BoundingSphere#intersectsRay
       * @description Test if a ray intersects with the sphere.
       * @param {pc.Ray} ray Ray to test against (direction must be normalized).
       * @param {pc.Vec3} [point] If there is an intersection, the intersection point will be copied into here.
       * @returns {Boolean} True if there is an intersection.
       */
      intersectsRay(ray, point) {
        var m = this.tmpVecA.copy(ray.origin).sub(this.center);
        var b = m.dotProduct(this.tmpVecB.copy(ray.direction).normalize());
        var c = m.dotProduct(m) - this.radius * this.radius;
        if (c > 0 && b > 0) return null;
        var discr = b * b - c;
        if (discr < 0) return false;
        var t = Math.abs(-b - Math.sqrt(discr));
        if (point) point.copy(ray.direction).multiplyScalar(t).add(ray.origin);
        return true;
      }
      /**
       * @function
       * @name pc.BoundingSphere#intersectsBoundingSphere
       * @description Test if a Bounding Sphere is overlapping, enveloping, or inside this Bounding Sphere.
       * @param {pc.BoundingSphere} sphere Bounding Sphere to test.
       * @returns {Boolean} true if the Bounding Sphere is overlapping, enveloping, or inside this Bounding Sphere and false otherwise.
       */
      intersectsBoundingSphere(sphere) {
        Vector3.sub(this.tmpVecA, sphere.center, this.center);
        var totalRadius = sphere.radius + this.radius;
        if (this.tmpVecA.lengthSquared <= totalRadius * totalRadius) {
          return true;
        }
        return false;
      }
      /**
       * Recompute the sphere from the given object's transform.
       * @param obj the owning object
       */
      calculateTransform(obj) {
        this.update(obj);
      }
      /**
       * Whether the object's sphere bound is inside the given frustum.
       * @param obj the object whose bound is tested
       * @param frustum the frustum to test against
       */
      inFrustum(obj, frustum) {
        return frustum.containsSphere(obj);
      }
      /**
       * Create a copy of this bounding sphere.
       * @returns a new sphere with the same center and radius
       */
      clone() {
        return new BoundingSphere(this.center.clone(), this.radius);
      }
      /**
       * Update the world-space center and forward direction from the object's transform.
       * @param obj the owning object
       */
      update(obj) {
        this.owner = obj;
        Vector3.add(this._center, obj.transform.worldMatrix.position, this.center);
        this.forward = obj.transform.forward;
      }
      /**
       * @internal
       */
      merge(bound) {
        throw new Error("BoundingSphere merge is not ready!");
      }
      /**
       * Set the sphere from a center and radius.
       * @param center the center of the sphere
       * @param size the radius of the sphere
       */
      setFromCenterAndSize(center, size) {
        this.center.copy(center);
        this.radius = size;
      }
    }

    class Frustum {
      planes;
      corners;
      boundingBox = new BoundingBox();
      constructor() {
        this.planes = [];
        this.corners = [];
        for (var i = 0; i < 6; i++) this.planes[i] = new Vector3();
        for (var i = 0; i < 2 * 2 * 2; i++) this.corners[i] = new Vector3();
      }
      updateBoundBox(pvInv) {
        this.boundingBox.makeEmpty();
        let min = this.boundingBox.min;
        let max = this.boundingBox.max;
        let i = 0;
        for (let x = 0; x < 2; ++x) {
          for (let y = 0; y < 2; ++y) {
            for (let z = 0; z < 2; ++z) {
              let pt = this.corners[i];
              i++;
              pt.set(2 * x - 1, 2 * y - 1, z, 1);
              Matrix4.transformVector4(pvInv, pt, pt);
              pt.multiplyScalar(1 / pt.w);
              min.x = Math.min(pt.x, min.x);
              min.y = Math.min(pt.y, min.y);
              min.z = Math.min(pt.z, min.z);
              max.x = Math.max(pt.x, max.x);
              max.y = Math.max(pt.y, max.y);
              max.z = Math.max(pt.z, max.z);
            }
          }
        }
        this.boundingBox.setFromMinMax(min, max);
        return this;
      }
      setFrustumCorners(pvInv) {
        let i = 0;
        for (let x = 0; x < 2; ++x) {
          for (let y = 0; y < 2; ++y) {
            for (let z = 0; z < 2; ++z) {
              let pt = this.corners[i];
              pt.set(2 * x - 1, 2 * y - 1, z, 1);
              Matrix4.transformVector4(pvInv, pt, pt);
              pt.multiplyScalar(1 / pt.w);
              i++;
            }
          }
        }
      }
      update(vpMatrix) {
        var vpm = vpMatrix.rawData;
        this.planes[0].x = vpm[3] - vpm[0];
        this.planes[0].y = vpm[7] - vpm[4];
        this.planes[0].z = vpm[11] - vpm[8];
        this.planes[0].w = vpm[15] - vpm[12];
        var t = Math.sqrt(this.planes[0].x * this.planes[0].x + this.planes[0].y * this.planes[0].y + this.planes[0].z * this.planes[0].z);
        this.planes[0].x /= t;
        this.planes[0].y /= t;
        this.planes[0].z /= t;
        this.planes[0].w /= t;
        this.planes[1].x = vpm[3] + vpm[0];
        this.planes[1].y = vpm[7] + vpm[4];
        this.planes[1].z = vpm[11] + vpm[8];
        this.planes[1].w = vpm[15] + vpm[12];
        t = Math.sqrt(this.planes[1].x * this.planes[1].x + this.planes[1].y * this.planes[1].y + this.planes[1].z * this.planes[1].z);
        this.planes[1].x /= t;
        this.planes[1].y /= t;
        this.planes[1].z /= t;
        this.planes[1].w /= t;
        this.planes[2].x = vpm[3] + vpm[1];
        this.planes[2].y = vpm[7] + vpm[5];
        this.planes[2].z = vpm[11] + vpm[9];
        this.planes[2].w = vpm[15] + vpm[13];
        t = Math.sqrt(this.planes[2].x * this.planes[2].x + this.planes[2].y * this.planes[2].y + this.planes[2].z * this.planes[2].z);
        this.planes[2].x /= t;
        this.planes[2].y /= t;
        this.planes[2].z /= t;
        this.planes[2].w /= t;
        this.planes[3].x = vpm[3] - vpm[1];
        this.planes[3].y = vpm[7] - vpm[5];
        this.planes[3].z = vpm[11] - vpm[9];
        this.planes[3].w = vpm[15] - vpm[13];
        t = Math.sqrt(this.planes[3].x * this.planes[3].x + this.planes[3].y * this.planes[3].y + this.planes[3].z * this.planes[3].z);
        this.planes[3].x /= t;
        this.planes[3].y /= t;
        this.planes[3].z /= t;
        this.planes[3].w /= t;
        this.planes[4].x = vpm[3] - vpm[2];
        this.planes[4].y = vpm[7] - vpm[6];
        this.planes[4].z = vpm[11] - vpm[10];
        this.planes[4].w = vpm[15] - vpm[14];
        t = Math.sqrt(this.planes[4].x * this.planes[4].x + this.planes[4].y * this.planes[4].y + this.planes[4].z * this.planes[4].z);
        this.planes[4].x /= t;
        this.planes[4].y /= t;
        this.planes[4].z /= t;
        this.planes[4].w /= t;
        this.planes[5].x = vpm[3] + vpm[2];
        this.planes[5].y = vpm[7] + vpm[6];
        this.planes[5].z = vpm[11] + vpm[10];
        this.planes[5].w = vpm[15] + vpm[14];
        t = Math.sqrt(this.planes[5].x * this.planes[5].x + this.planes[5].y * this.planes[5].y + this.planes[5].z * this.planes[5].z);
        this.planes[5].x /= t;
        this.planes[5].y /= t;
        this.planes[5].z /= t;
        this.planes[5].w /= t;
      }
      containsPoint(point) {
        for (var p = 0; p < 6; p++) {
          if (this.planes[p].x * point.x + this.planes[p].y * point.y + this.planes[p].z * point.z + this.planes[p].w <= 0) return false;
        }
        return true;
      }
      isVisible(object3D) {
        if (object3D.bound instanceof BoundingSphere) {
          const worldPos = object3D.transform.worldPosition;
          const sr = object3D.bound.radius;
          const scx = object3D.bound.center.x + worldPos.x;
          const scy = object3D.bound.center.y + worldPos.y;
          const scz = object3D.bound.center.z + worldPos.z;
          for (let plane of this.planes) {
            const d = plane.x * scx + plane.y * scy + plane.z * scz + plane.w;
            if (d <= -sr) {
              return false;
            }
          }
          return true;
        }
        return this.containsBoundingBox(object3D.bound);
      }
      containsBoundingBox(bound) {
        const box = bound;
        for (const plane of this.planes) {
          const a = plane.x;
          const b = plane.y;
          const c = plane.z;
          const d = plane.w;
          const x = a > 0 ? box.max.x : box.min.x;
          const y = b > 0 ? box.max.y : box.min.y;
          const z = c > 0 ? box.max.z : box.min.z;
          const distance = a * x + b * y + c * z + d;
          if (distance < 0) {
            return false;
          }
        }
        return true;
      }
      containsSphere(object3D) {
        let sphere = object3D.bound;
        let c = 0;
        let d;
        let worldPos = object3D.transform.worldPosition;
        let sr = sphere.radius;
        let scx = sphere.center.x + worldPos.x;
        let scy = sphere.center.y + worldPos.y;
        let scz = sphere.center.z + worldPos.z;
        for (let plane of this.planes) {
          d = plane.x * scx + plane.y * scy + plane.z * scz + plane.w;
          if (d <= -sr) return 0;
          if (d > sr) c++;
        }
        return c === 6 ? 2 : 1;
      }
    }

    var CameraType = /* @__PURE__ */ ((CameraType2) => {
      CameraType2[CameraType2["ortho"] = 0] = "ortho";
      CameraType2[CameraType2["perspective"] = 1] = "perspective";
      CameraType2[CameraType2["shadow"] = 2] = "shadow";
      return CameraType2;
    })(CameraType || {});

    class Camera3D extends ComponentBase {
      /**
       * The primary camera used for rendering the main view.
       */
      static mainCamera;
      /**
       * The graphics context this camera is bound to. Used for multi-engine
       * setups; `null` until the camera is bound to a {@link Context3D}.
       */
      _boundCtx = null;
      /**
       * camera Perspective
       */
      fov = 60;
      /**
       * camera use name
       */
      name;
      /**
       * Viewport width and height Scale
       */
      aspect = 1;
      /**
       * camera near plane
       */
      near = 1;
      /**
       * camera far plane
       */
      far = 5e3;
      /**
       * orth camera right plane
       */
      left = -100;
      /**
       * orth camera left plane
       */
      right = 100;
      /**
       * orth camera top plane
       */
      top = 100;
      /**
       * orth camera bottom plane
       */
      bottom = -100;
      /**
       * orth view size
       */
      frustumSize = 0;
      /**
       * orth view depth range
       */
      frustumDepth = 0;
      /**
       * camera view port size
       */
      viewPort = new Rect();
      /**
       * camera frustum
       */
      frustum;
      // public sh_bak: Float32Array = new Float32Array([
      //     2.485296, 2.52417, 2.683965, 3.544894,
      //     0.2323964, 0.1813751, 0.08516902, -4.860471E-05,
      //     -0.2744142, -0.04131086, 0.2248164, -0.005996059,
      //     0.1551732, 0.137717, 0.1002693, -0.0006728604,
      //     0.2209381, 0.2109673, 0.1770538, -1.395991E-05,
      //     0.3529238, 0.2824739, 0.1817433, -0.0005164869,
      //     -0.1344275, -0.1289607, -0.1347626, 7.825881E-06,
      //     0.2125785, 0.1779549, 0.124602, 0.000503074,
      //     -0.1039777, -0.09676537, -0.07681116, -0.0004372867,
      // ]);
      /**
       * Spherical-harmonics coefficients of the ambient/diffuse environment lighting.
       */
      sh = new Float32Array(36);
      /**
       * this camera is shadow camera
       */
      isShadowCamera = false;
      /**
       * The light this camera renders the shadow map for, when it is a shadow camera.
       */
      shadowLight;
      /**
       * Layer-mask of layers this camera should see. Combined at pass
       * execute time with `node.visibleLayer` and the active pass's
       * `layerMask` via bitwise AND:
       *
       *     (node.visibleLayer & pass.layerMask & camera.cullingMask) !== 0
       *
       * Defaults to {@link VisibleLayer.All} so untouched cameras keep
       * the historical "see everything" behaviour. Sub-cameras
       * (minimaps, reflection probes, picking-only views) can clear
       * specific bits to suppress unwanted layers.
       *
       * Camera-side filtering is layered on top of pass-side filtering:
       * a layer must clear both masks AND the node's own membership to
       * be drawn.
       */
      cullingMask = exports.VisibleLayer.All;
      /**
      * @internal
      */
      _projectionMatrixInv = new Matrix4();
      _projectionMatrix = new Matrix4();
      _viewMatrix = new Matrix4();
      _viewMatrixInv = new Matrix4();
      _unprojection = new Matrix4();
      _pvMatrixInv = new Matrix4();
      _pvMatrix = new Matrix4();
      _halfw;
      _halfh;
      _ray;
      /**
       * @internal
       */
      get projectionMatrix() {
        return this._projectionMatrix;
      }
      /**
       * camera look at from where point
       */
      lookTarget;
      /**
       * camera type 
       */
      type = CameraType.perspective;
      constructor() {
        super();
      }
      init() {
        super.init();
        this._ray = new Ray();
        this.frustum = new Frustum();
        this.lookTarget = new Vector3(0, 0, 0);
        let ctx = this._deriveCtx();
        if (ctx) {
          this._bindToCtx(ctx);
        }
        this.updateProjection();
      }
      _deriveCtx() {
        return this._boundCtx ?? this.transform?.view3D?.engine3D?.context3D ?? null;
      }
      _resizeListenerAttached = false;
      _bindToCtx(ctx) {
        this._boundCtx = ctx;
        this.viewPort.x = 0;
        this.viewPort.y = 0;
        this.viewPort.w = ctx.presentationSize[0];
        this.viewPort.h = ctx.presentationSize[1];
        if (!this._resizeListenerAttached) {
          ctx.addEventListener(CResizeEvent.RESIZE, this.updateProjection, this);
          this._resizeListenerAttached = true;
        }
      }
      updateProjection() {
        let ctx = this._deriveCtx();
        if (ctx) {
          if (!this._resizeListenerAttached) this._bindToCtx(ctx);
          this.aspect = ctx.aspect;
        }
        if (this.type == CameraType.perspective) {
          this.perspective(this.fov, this.aspect, this.near, this.far);
        } else if (this.type == CameraType.ortho) {
          if (this.frustumSize && this.frustumDepth)
            this.ortho(this.frustumSize, this.frustumDepth);
          else if (this.frustumSize)
            this.ortho2(this.frustumSize, this.near, this.far);
          else
            this.orthoOffCenter(this.left, this.right, this.bottom, this.top, this.near, this.far);
        }
      }
      /**
       * Compute a legacy auto shadow-bias baseline for the given depth texture size.
       *
       * Legacy auto baseline used by DDGI / GodRay compute paths.
       * Real-time shadow now derives bias per-light via ShadowBiasCalculator.
       * @param depthTexSize the side length of the shadow depth texture
       * @returns the computed shadow bias
       */
      getShadowBias(depthTexSize) {
        let sizeOnePixel = 2 * this.getShadowWorldExtents() / depthTexSize;
        let depth = Math.max(this.far - this.near, 1e-6);
        return sizeOnePixel * 1.5 / depth;
      }
      /**
       * Get the rounded world-space extent of the camera frustum, used to scale shadow bias.
       * @returns the world-space extent value
       */
      getShadowWorldExtents() {
        return Math.round(0.05 * this.frustum.boundingBox.extents.length);
      }
      /**
       * Create a perspective camera
       * @param fov 
       * @param aspect 
       * @param near  
       * @param far 
       */
      perspective(fov, aspect, near, far) {
        this.fov = fov;
        this.aspect = aspect;
        this.near = Math.max(1e-3, near);
        this.far = far;
        this._projectionMatrix.perspective(this.fov, this.aspect, this.near, this.far);
        this.type = CameraType.perspective;
        this._captureJitterBase();
      }
      /**
       * set an orthographic camera with a frustumSize(viewHeight) and frustumSizeDepth
       * @param frustumSize the frustum view height
       * @param frustumSizeDepth the frustum view depth
       */
      ortho(frustumSize, frustumDepth) {
        this.frustumSize = frustumSize;
        this.frustumDepth = frustumDepth;
        let w = frustumSize * this.aspect;
        let h = frustumSize;
        let left = -w / 2;
        let right = w / 2;
        let top = h / 2;
        let bottom = -h / 2;
        let dis = Vector3.distance(this.object3D.localPosition, this.lookTarget);
        let near = dis - frustumDepth;
        let far = dis + frustumDepth;
        this.orthoOffCenter(left, right, bottom, top, near, far);
      }
      /**
       * set an orthographic camera with a frustumSize(viewHeight) and specific near & far
       * @param frustumSize the frustum view height
       * @param near camera near plane
       * @param far camera far plane
       */
      ortho2(frustumSize, near, far) {
        this.frustumSize = frustumSize;
        let w = frustumSize * this.aspect;
        let h = frustumSize;
        let left = -w / 2;
        let right = w / 2;
        let top = h / 2;
        let bottom = -h / 2;
        this.orthoOffCenter(left, right, bottom, top, near, far);
      }
      /**
       * set an orthographic camera with specified frustum space
       * @param left camera left plane
       * @param right camera right plane
       * @param bottom camera bottom plane
       * @param top camera top plane
       * @param near camera near plane
       * @param far camera far plane
       */
      orthoOffCenter(left, right, bottom, top, near, far) {
        this.near = near;
        this.far = far;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.type = CameraType.ortho;
        this._projectionMatrix.orthoOffCenter(this.left, this.right, this.bottom, this.top, this.near, this.far);
        this._captureJitterBase();
      }
      /**
       *
       * view invert matrix
       */
      get viewMatrix() {
        this._viewMatrix.copy(this.transform.worldMatrix);
        this._viewMatrix.invert();
        return this._viewMatrix;
      }
      /**
       *
       * shadow camera view invert matrix
       */
      get shadowViewMatrix() {
        this._viewMatrix.copy(this.transform.worldMatrix);
        this._viewMatrix.appendScale(1, 1, 1);
        this._viewMatrix.invert();
        return this._viewMatrix;
      }
      /**
       * world space object to screen 
       * @param n world space
       * @param target Creating an orthogonal camera with 2D screen coordinates that default to null will return a new object
       */
      object3DToScreenRay(n, target = null) {
        if (!target) {
          target = new Vector3(0, 0, 0, 1);
        }
        this._halfw = this.viewPort.width * 0.5;
        this._halfh = this.viewPort.height * 0.5;
        MathUtil.transformVector(this.viewMatrix, n, target);
        this.project(target, target);
        target.x = this._halfw + target.x * this._halfw;
        target.y = this.viewPort.height - (this._halfh - target.y * this._halfh);
        return target;
      }
      /**
       * Convert 2D screen coordinates to 3D coordinates as world space
       * @param n 2D screen coordinates
       * @param target 3D coordinates as world space
       */
      screenRayToObject3D(n, target = null) {
        if (!target) {
          target = new Vector3();
        }
        this._halfw = this.viewPort.width * 0.5;
        this._halfh = this.viewPort.height * 0.5;
        let fScreenPtX = n.x;
        let fScreenPtY = n.y;
        target.x = fScreenPtX / this.viewPort.width - 0.25;
        target.y = fScreenPtY / this.viewPort.height - 0.25;
        this.unProject(target.x, target.y, n.z, target);
        return target;
      }
      /**
       * get project * view matrix
       */
      get pvMatrix() {
        matrixMultiply(this._projectionMatrix, this.viewMatrix, this._pvMatrix);
        return this._pvMatrix;
      }
      /**
       * get the inverse of (projection * world) matrix
       */
      get pvMatrix2() {
        matrixMultiply(this._projectionMatrix, this.transform.worldMatrix, this._pvMatrix);
        let matrix = this._pvMatrixInv.copy(this.pvMatrix);
        matrix.invert();
        return matrix;
      }
      /**
       * get (project * view) invert matrix
       */
      get pvMatrixInv() {
        let matrix = this._pvMatrixInv.copy(this.pvMatrix);
        matrix.invert();
        return matrix;
      }
      /**
       * get the inverse of the view matrix
       */
      get vMatrixInv() {
        let matrix = this._viewMatrixInv.copy(this.viewMatrix);
        matrix.invert();
        return matrix;
      }
      /**
       * get the matrix transforming camera/clip space back to world space
       */
      get cameraToWorld() {
        let cameraToWorld = Matrix4.helpMatrix;
        cameraToWorld.identity();
        cameraToWorld.copy(this.projectionMatrixInv);
        cameraToWorld.multiply(this.vMatrixInv);
        return cameraToWorld;
      }
      /**
       * get the matrix transforming NDC space to view space (inverse projection)
       */
      get ndcToView() {
        let cameraToWorld = Matrix4.helpMatrix;
        cameraToWorld.identity();
        cameraToWorld.copy(this.projectionMatrixInv);
        return cameraToWorld;
      }
      /**
       * get project invert matrix
       */
      get projectionMatrixInv() {
        this._projectionMatrixInv.copy(this._projectionMatrix);
        this._projectionMatrixInv.invert();
        return this._projectionMatrixInv;
      }
      /**
       * Enter a 3D coordinate point to obtain the projected coordinate point
       * @param nX 3D x
       * @param nY 3D y
       * @param sZ 3D z
       * @param target The projected coordinate point can be empty
       * @returns Coordinates after projection
       */
      unProject(nX, nY, sZ, target) {
        if (!target) target = new Vector3();
        target.x = nX;
        target.y = -nY;
        target.z = sZ;
        target.w = 1;
        target.x *= sZ;
        target.y *= sZ;
        this._unprojection.copy(this._projectionMatrix);
        this._unprojection.invert();
        MathUtil.transformVector(this._unprojection, target, target);
        target.z = sZ;
        return target;
      }
      /**
       * Enter the projected coordinate points to obtain a 3D coordinate point.
       * @param n Coordinate points after photography
       * @param target 3D coordinate points
       * @returns 3D coordinate points
       */
      project(n, target) {
        this._projectionMatrix.perspectiveMultiplyPoint3(n, target);
        target.x = target.x / target.w;
        target.y = -target.y / target.w;
        target.z = n.z;
        return target;
      }
      /**
       * Enter the 2D coordinates of the screen to obtain a ray that starts from the camera position and passes through the corresponding 3D position of the screen.
       * @param viewPortPosX Screen x coordinate
       * @param viewPortPosY Screen y coordinate
       * @returns ray
       */
      screenPointToRay(viewPortPosX, viewPortPosY) {
        let ray = this._ray;
        let start = CameraUtil.UnProjection(viewPortPosX, viewPortPosY, 0.01, this);
        let end = CameraUtil.UnProjection(viewPortPosX, viewPortPosY, 1, this);
        end = end.sub(start).normalize();
        ray.origin.copy(start);
        ray.direction = end;
        return ray;
      }
      /**
       * Convert screen coordinates to world coordinates
       * @param viewPortPosX Screen x coordinate
       * @param viewPortPosY Screen y coordinate
       * @param z Screen z coordinate
       * @returns World coordinates
       */
      screenPointToWorld(viewPortPosX, viewPortPosY, z) {
        let pos = CameraUtil.UnProjection(viewPortPosX, viewPortPosY, z, this);
        return pos;
      }
      /**
       * Convert world coordinates to screen coordinates
       * @param viewPortPosX Screen x coordinate
       * @param viewPortPosY Screen y coordinate
       * @param z Screen z coordinate
       * @returns World coordinates
       */
      worldToScreenPoint(point, target) {
        let pos = CameraUtil.Projection(point, this, target);
        return pos;
      }
      /**
       * Current object's gaze position (global) (modified by its own global transformation)
       * @param pos Own position (global)
       * @param target Location of the target (global)
       * @param up Upward direction
       */
      lookAt(pos, target, up = Vector3.Y_AXIS) {
        this.transform.lookAt(pos, target, up);
        if (target) this.lookTarget.copy(target);
      }
      /**
       * @internal
       */
      onUpdate() {
        if (this._useJitterProjection) {
          this.getJitteredProjectionMatrix();
        }
        this.frustum.update(this.pvMatrix);
        this.frustum.updateBoundBox(this.pvMatrixInv);
      }
      // for jitter projection
      _haltonSeq;
      _jitterOffsetList;
      _useJitterProjection = false;
      _jitterFrameIndex = 0;
      _sampleIndex = 0;
      _jitterX = 0;
      _jitterY = 0;
      _jitterOffsetX;
      _jitterOffsetY;
      /**
       * get the current TAA jitter frame index
       */
      get jitterFrameIndex() {
        return this._jitterFrameIndex;
      }
      /**
       * get the current frame's TAA jitter offset on the X axis (in NDC)
       */
      get jitterX() {
        return this._jitterX;
      }
      /**
       * get the current frame's TAA jitter offset on the Y axis (in NDC)
       */
      get jitterY() {
        return this._jitterY;
      }
      /**
       * Enable or disable TAA jitter on the projection matrix.
       * @param value whether jitter projection should be applied each frame
       */
      enableJitterProjection(value) {
        this._jitterFrameIndex = 0;
        this._useJitterProjection = value;
        this._haltonSeq ||= new HaltonSeq();
        this._jitterOffsetList = [];
        for (let i = 0; i < 32; i++) {
          let offset = this.generateRandomOffset();
          this._jitterOffsetList.push(offset);
        }
        this._jitterOffsetList.reverse();
        this._captureJitterBase();
      }
      /**
       * Snapshot the projection-matrix slot we drive with TAA jitter, so
       * each frame writes `base + this-frame-jitter` instead of adding
       * onto the previously-jittered matrix (which would accumulate as
       * an unbounded random walk).
       *
       * Slot depends on camera type:
       *   - perspective: (row=0, col=2) and (row=1, col=2). After the
       *     perspective divide (clip.w = -z), the z-coefficient term
       *     produces a constant NDC offset.
       *   - ortho: (row=0, col=3) and (row=1, col=3) — the translation
       *     column. clip.w = 1 here, so any z-coefficient shift would
       *     scale linearly with depth (different layers would jitter
       *     different amounts, breaking TAA reprojection). Translation-
       *     column shift gives a constant NDC offset like perspective.
       */
      _captureJitterBase() {
        if (!this._useJitterProjection) return;
        const col = this.type === CameraType.ortho ? 3 : 2;
        this._jitterOffsetX = this._projectionMatrix.get(0, col);
        this._jitterOffsetY = this._projectionMatrix.get(1, col);
      }
      generateRandomOffset() {
        let offset = new Vector2(HaltonSeq.get((this._sampleIndex & 1023) + 1, 2) - 0.5, HaltonSeq.get((this._sampleIndex & 1023) + 1, 3) - 0.5);
        const k_SampleCount = 32;
        if (++this._sampleIndex >= k_SampleCount) this._sampleIndex = 0;
        return offset;
      }
      getJitteredProjectionMatrix() {
        let setting = this._boundCtx.engine.setting.render.postProcessing.taa;
        let temporalJitterScale = setting.temporalJitterScale;
        let offsetIndex = this._jitterFrameIndex % setting.jitterSeedCount;
        let num1 = this._jitterOffsetList[offsetIndex].x * temporalJitterScale;
        let num2 = this._jitterOffsetList[offsetIndex].y * temporalJitterScale;
        this._jitterX = num1 / this.viewPort.width;
        this._jitterY = num2 / this.viewPort.height;
        const baseX = this._jitterOffsetX ?? 0;
        const baseY = this._jitterOffsetY ?? 0;
        const col = this.type === CameraType.ortho ? 3 : 2;
        this._projectionMatrix.set(0, col, baseX + this._jitterX);
        this._projectionMatrix.set(1, col, baseY + this._jitterY);
        this._jitterFrameIndex++;
      }
      /**
       * Get the camera's forward direction in world space.
       * @param target optional vector to store the result
       * @returns the normalized world-space forward direction
       */
      getWorldDirection(target) {
        target ||= new Vector3();
        const e = this.transform._worldMatrix.rawData;
        return target.set(-e[8], -e[9], -e[10]).normalize();
      }
      /**
       * Release the matrix slots held by this camera and destroy the component.
       * @param force whether to force-destroy
       */
      destroy(force) {
        for (const m of [this._projectionMatrix, this._projectionMatrixInv, this._viewMatrix, this._viewMatrixInv, this._unprojection, this._pvMatrix, this._pvMatrixInv]) {
          if (m) Matrix4.freeIndex(m);
        }
        this._projectionMatrix = null;
        this._projectionMatrixInv = null;
        this._viewMatrix = null;
        this._viewMatrixInv = null;
        this._unprojection = null;
        this._pvMatrix = null;
        this._pvMatrixInv = null;
        super.destroy(force);
      }
    }

    function splitDouble(value, scale) {
      let doubleHigh;
      const dividend = scale;
      if (value >= 0) {
        doubleHigh = Math.floor(value / dividend) * dividend;
        const high2 = doubleHigh;
        const low2 = value - doubleHigh;
        return [high2, low2];
      }
      doubleHigh = Math.floor(-value / dividend) * dividend;
      const high = -doubleHigh;
      const low = value + doubleHigh;
      return [high, low];
    }
    function splitDouble_Vector3(value, scale) {
      let xHL = splitDouble(value.x, scale);
      let yHL = splitDouble(value.y, scale);
      let zHL = splitDouble(value.z, scale);
      let hi = new Vector3(xHL[0], yHL[0], zHL[0]);
      let low = new Vector3(xHL[1], yHL[1], zHL[1]);
      return [hi, low];
    }
    function subtractSplitDoubles(aH, aL, bH, bL) {
      let hi = new Vector3(
        aH.x - bH.x,
        aH.y - bH.y,
        aH.z - bH.z
      );
      let low = new Vector3(
        aL.x - bL.x,
        aL.y - bL.y,
        aL.z - bL.z
      );
      return new Vector3(
        hi.x + low.x,
        hi.y + low.y,
        hi.z + low.z
      );
    }

    var LightType = /* @__PURE__ */ ((LightType2) => {
      LightType2[LightType2["None"] = 0] = "None";
      LightType2[LightType2["PointLight"] = 1] = "PointLight";
      LightType2[LightType2["DirectionLight"] = 2] = "DirectionLight";
      LightType2[LightType2["SpotLight"] = 3] = "SpotLight";
      LightType2[LightType2["SkyLight"] = 4] = "SkyLight";
      return LightType2;
    })(LightType || {});
    class LightData extends Struct {
      static lightSize = 28;
      index = -1;
      /**
       * Light source type
       * @see LightType
       *  */
      lightType = -1;
      /**
      * 
      * Light source radius
      */
      radius = 1e-3;
      /**
       *
       * The illumination distance of the light source, which is 0, means that the intensity of the light will not decrease due to the distance
       */
      linear = 8;
      lightPosition = new Vector3();
      lightMatrixIndex = -1;
      /**
       * Light source direction
       */
      direction = new Vector3();
      quadratic = 0.032;
      /**
      *
      * The color of the light source
      */
      lightColor = new Color(1, 1, 1, 1);
      /**
       *
       * The intensity of light exposure
       */
      intensity = 1;
      /**
       *
       * Inner cone angle of light source
       */
      innerAngle = 0;
      /**
       *
       * Outer cone angle of light source
       */
      outerAngle = 1;
      /**
       *
       * The size of the light source range and the distance emitted from the center of the light source object. Only Point and Spotlight have this parameter.
       */
      range = 100;
      /**
       *
       * shadow at shadow map index
       */
      castShadowIndex = -1;
      /**
       * Tangent direction of light
       */
      lightTangent = Vector3.FORWARD;
      /**
       * Whether to use lighting ies
       */
      iesIndex = -1;
      // shadowBias / normalBias arrays are sized and initialized in LightBase.start()
      // once the owning engine's setting.shadow.maxCascades is known.
      shadowBias = [];
      normalBias = [];
      // Cube shadow-map depth normalization factor (world units). Writer stores
      // `length(worldPos - lightPos) / shadowFar` into the shadow map; sampler
      // uses the same value to decode. Populated by GlobalUniformGroup from the
      // PointLight/SpotLight's shadowCameraFar (fallback = range).
      shadowFar = 0;
      csmShadowMapNum = 0;
      csmShadowMapIndex = -1;
      // Per-light soft-shadow / PCSS light-size multiplier.
      // -1 means "fall back to globalUniform.shadowSoft". Consumed by
      // DirectShadow_frag and PointShadow_frag SOFT branches.
      softness = -1;
    }

    class ShadowLightsCollect {
      static maxNumDirectionShadow = 8;
      static maxNumPointShadow = 8;
      static directionLightList;
      static pointLightList;
      static shadowLights;
      static init() {
        this.directionLightList = /* @__PURE__ */ new Map();
        this.pointLightList = /* @__PURE__ */ new Map();
        this.shadowLights = /* @__PURE__ */ new Map();
      }
      static createBuffer(view) {
        if (!this.shadowLights.has(view.scene)) {
          let list = new Float32Array(16);
          this.shadowLights.set(view.scene, list);
        }
      }
      static getShadowLightList(light) {
        if (!light.transform.view3D) return null;
        if (light.lightData.lightType == LightType.DirectionLight) {
          let list = this.directionLightList.get(light.transform.view3D.scene);
          if (!list) {
            list = [];
            this.directionLightList.set(light.transform.view3D.scene, list);
          }
          return list;
        } else if (light.lightData.lightType == LightType.PointLight) {
          let list = this.pointLightList.get(light.transform.view3D.scene);
          if (!list) {
            list = [];
            this.pointLightList.set(light.transform.view3D.scene, list);
          }
          return list;
        } else if (light.lightData.lightType == LightType.SpotLight) {
          let list = this.pointLightList.get(light.transform.view3D.scene);
          if (!list) {
            list = [];
            this.pointLightList.set(light.transform.view3D.scene, list);
          }
          return list;
        }
      }
      static getShadowLightWhichScene(scene, type) {
        if (type == LightType.DirectionLight) {
          let list = this.directionLightList.get(scene);
          if (!list) {
            list = [];
            this.directionLightList.set(scene, list);
          }
          return list;
        } else if (type == LightType.PointLight) {
          let list = this.pointLightList.get(scene);
          if (!list) {
            list = [];
            this.pointLightList.set(scene, list);
          }
          return list;
        }
      }
      static getDirectShadowLightWhichScene(scene) {
        let list = this.directionLightList.get(scene);
        if (!list) {
          list = [];
          this.directionLightList.set(scene, list);
        }
        return list;
      }
      static getPointShadowLightWhichScene(scene) {
        let list = this.pointLightList.get(scene);
        if (!list) {
          list = [];
          this.pointLightList.set(scene, list);
        }
        return list;
      }
      static addShadowLight(light) {
        if (!light.transform.view3D) return null;
        let scene = light.transform.view3D.scene;
        if (light.lightData.lightType == LightType.DirectionLight) {
          let list = this.directionLightList.get(scene);
          if (!list) {
            list = [];
            this.directionLightList.set(scene, list);
          }
          if (!light.shadowCamera) {
            light.shadowCamera = CameraUtil.createCamera3DObject(null, "shadowCamera");
            light.shadowCamera.shadowLight = light;
            light.shadowCamera.isShadowCamera = true;
            let shadowBound = -1e3;
            light.shadowCamera.orthoOffCenter(shadowBound, -shadowBound, shadowBound, -shadowBound, 1, 1e4);
          }
          if (!light.shadowCamera._boundCtx) {
            const lightCtx = light.transform.view3D?.engine3D?.context3D;
            if (lightCtx) light.shadowCamera._boundCtx = lightCtx;
          }
          if (list.indexOf(light) == -1) {
            list.push(light);
          }
          return list;
        } else if (light.lightData.lightType == LightType.PointLight || light.lightData.lightType == LightType.SpotLight) {
          let list = this.pointLightList.get(scene);
          if (list && list.length >= 8) {
            return list;
          }
          if (!list) {
            list = [];
            this.pointLightList.set(scene, list);
          }
          if (list.indexOf(light) == -1) {
            list.push(light);
          }
          return list;
        }
      }
      static removeShadowLight(light) {
        light.lightData.castShadowIndex = -1;
        if (!light.transform.view3D) return null;
        if (light.lightData.lightType == LightType.DirectionLight) {
          let list = this.directionLightList.get(light.transform.view3D.scene);
          if (list) {
            let index = list.indexOf(light);
            if (index != -1) {
              list.splice(index, 1);
            }
          }
          light.lightData.castShadowIndex = -1;
          return list;
        } else if (light.lightData.lightType == LightType.PointLight || light.lightData.lightType == LightType.SpotLight) {
          let list = this.pointLightList.get(light.transform.view3D.scene);
          if (list) {
            let index = list.indexOf(light);
            if (index != -1) {
              list.splice(index, 1);
            }
          }
          light.lightData.castShadowIndex = -1;
          return list;
        }
      }
      // Called from Engine3D.dispose() — the scene-keyed maps here would
      // otherwise grow one entry per disposed engine and pin every Scene3D
      // (plus its light list) forever.
      static removeScene(scene) {
        this.directionLightList?.delete(scene);
        this.pointLightList?.delete(scene);
        this.shadowLights?.delete(scene);
      }
      static update(view) {
        let shadowLights = this.shadowLights.get(view.scene);
        let directionLightList = ShadowLightsCollect.directionLightList.get(view.scene);
        let pointLightList = ShadowLightsCollect.pointLightList.get(view.scene);
        let nDirShadowStart = 0;
        let nDirShadowEnd = 0;
        let nPointShadowStart = 0;
        let nPointShadowEnd = 0;
        shadowLights.fill(0);
        if (directionLightList) {
          let j = 0;
          for (let i = 0; i < directionLightList.length; i++) {
            const light = directionLightList[i];
            shadowLights[i] = light.lightData.index;
            if (light.enableCSM) {
              light.lightData.castShadowIndex = j;
              j += light.lightData.csmShadowMapNum;
            } else {
              light.lightData.castShadowIndex = j++;
            }
          }
          if (j > view.engine3D.setting.shadow.maxShadowMapNum) {
            console.error("ShadowLightsCollect: max shadow map num reached, please increase engine.setting.shadow.maxShadowMapNum");
          }
          nDirShadowEnd = directionLightList.length;
        }
        if (pointLightList) {
          nPointShadowStart = nDirShadowEnd;
          let j = 0;
          for (let i = nPointShadowStart; i < pointLightList.length; i++) {
            const light = pointLightList[i];
            shadowLights[i] = light.lightData.index;
            light.lightData.castShadowIndex = j++;
          }
          nPointShadowEnd = nPointShadowStart + pointLightList.length;
        }
        let cameraGroup = GlobalBindGroup.getAllCameraGroup();
        cameraGroup.forEach((group) => {
          group.dirShadowStart = nDirShadowStart;
          group.dirShadowEnd = nDirShadowEnd;
          group.pointShadowStart = nPointShadowStart;
          group.pointShadowEnd = nPointShadowEnd;
          group.shadowLights = shadowLights;
        });
      }
    }

    class ShadowBiasCalculator {
      /**
       * Resolve per-cascade NDC depth bias for a directional light's cascade.
       * Returns a value suitable for `depthRef - shadowBias` in the shader.
       */
      static resolveDirectShadowBias(light, cascadeIndex) {
        const baseline = ShadowBiasCalculator.directBaselineBias(light);
        const scale = ShadowBiasCalculator.directCascadeScale(light, cascadeIndex);
        return baseline * scale;
      }
      /**
       * Resolve per-cascade world-space normal bias for a directional light.
       * Same value across all cascades; smaller cascades naturally have less
       * acne so a single world-space offset works.
       */
      static resolveDirectNormalBias(light, cascadeIndex) {
        const baseline = ShadowBiasCalculator.directBaselineNormalBias(light);
        const scale = ShadowBiasCalculator.directCascadeScale(light, cascadeIndex);
        return baseline * scale;
      }
      /**
       * Resolve point light shadow bias (world-space distance offset).
       */
      static resolvePointShadowBias(light, pointShadowMapSize) {
        const v = light._shadowBias;
        if (typeof v === "number") return v;
        const texelSize = 2 * (light.lightData.range || 1) / Math.max(pointShadowMapSize, 1);
        return texelSize * 0.5;
      }
      /**
       * Resolve point light normal bias (world-space distance offset).
       */
      static resolvePointNormalBias(light, pointShadowMapSize) {
        const v = light._normalBias;
        if (typeof v === "number") return v;
        const texelSize = 2 * (light.lightData.range || 1) / Math.max(pointShadowMapSize, 1);
        return texelSize * 0.05;
      }
      static directBaselineBias(light) {
        const v = light._shadowBias;
        if (typeof v === "number") return v;
        const cam = light.enableCSM && light.csmShadowCamera?.length ? light.csmShadowCamera[0] : light.shadowCamera;
        if (!cam) return 5e-4;
        const extent = Math.max(Math.abs(cam.right - cam.left), Math.abs(cam.top - cam.bottom));
        const depth = Math.max(cam.far - cam.near, 1e-6);
        const texelSize = extent / Math.max(light.shadowMapWidth || 1, 1);
        return texelSize * 1.5 / depth;
      }
      static directBaselineNormalBias(light) {
        const v = light._normalBias;
        if (typeof v === "number") return v;
        const cam = light.enableCSM && light.csmShadowCamera?.length ? light.csmShadowCamera[0] : light.shadowCamera;
        if (!cam) return 0.05;
        const extent = Math.max(Math.abs(cam.right - cam.left), Math.abs(cam.top - cam.bottom));
        const texelSize = extent / Math.max(light.shadowMapWidth || 1, 1);
        return texelSize * 2;
      }
      /**
       * Per-cascade scale factor relative to cascade 0. Larger cascades cover
       * more world space per texel, so they need proportionally more bias to
       * avoid acne. Cascade 0 returns 1.0.
       */
      static directCascadeScale(light, cascadeIndex) {
        if (!light.enableCSM || !light.csmShadowCamera || light.csmShadowCamera.length <= cascadeIndex) return 1;
        const base = light.csmShadowCamera[0];
        const cur = light.csmShadowCamera[cascadeIndex];
        if (!base || !cur) return 1;
        const baseW = base.right - base.left;
        const curW = cur.right - cur.left;
        if (baseW <= 0) return 1;
        return curW / baseW;
      }
    }

    class GlobalUniformGroup {
      uuid;
      usage;
      globalBindGroup;
      uniformGPUBuffer;
      matrixBindGroup;
      uniformByteLength;
      matrixesByteLength;
      shadowMatrixRaw;
      csmMatrixRaw = new Float32Array(CSM.Cascades * 16);
      csmShadowBias = new Float32Array(4);
      shadowLights = new Float32Array(16);
      dirShadowStart = 0;
      dirShadowEnd = 0;
      pointShadowStart = 0;
      pointShadowEnd = 0;
      _ctx;
      /**
       *
       * @param ctx owning Context3D
       * @param matrixBindGroup global matrix bindgroup
       */
      constructor(ctx, matrixBindGroup) {
        this.uuid = UUID();
        this.usage = GPUBufferUsage.UNIFORM | GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST;
        this._ctx = ctx;
        const setting = ctx.engine.setting;
        this.shadowMatrixRaw = new Float32Array(setting.shadow.maxShadowMapNum * 16);
        this.uniformGPUBuffer = new UniformGPUBuffer(8192 + 9 * 4 * 4 + 8 + 1 + 4 + setting.shadow.maxShadowMapNum * 16);
        this.uniformGPUBuffer.visibility = GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
        this.matrixBindGroup = matrixBindGroup;
        this.createBindGroup();
      }
      createBindGroup() {
        this.uniformByteLength = this.uniformGPUBuffer.memory.shareDataBuffer.byteLength;
        this.matrixesByteLength = Matrix4.block * 4 * Matrix4.maxCount + Matrix4.maxCount * 32;
        let ctx = this._ctx;
        if (!this.uniformGPUBuffer._boundCtx) bindCtx(this.uniformGPUBuffer, ctx);
        const matrixBuf = this.matrixBindGroup.matrixBufferDst;
        if (matrixBuf && !matrixBuf._boundCtx) bindCtx(matrixBuf, ctx);
        this.globalBindGroup = ctx.device.createBindGroup({
          label: `global_bindGroupLayout`,
          layout: GlobalBindGroupLayout.getGlobalDataBindGroupLayout(ctx),
          entries: [
            {
              binding: 0,
              resource: {
                buffer: this.uniformGPUBuffer.buffer,
                offset: 0,
                // this.uniformGPUBuffer.memory.shareDataBuffer.byteOffset,
                size: this.uniformByteLength
              }
            },
            {
              binding: 1,
              resource: {
                buffer: this.matrixBindGroup.matrixBufferDst.buffer,
                offset: 0,
                size: this.matrixesByteLength
              }
            }
          ]
        });
      }
      temp_pvMatrix = new Matrix4();
      temp_viewMatrix = new Matrix4();
      temp_worldMatrix = new Matrix4();
      // Return the 3 scratch Matrix4 slots to the static table. Called from
      // GlobalBindGroup.removeContext() when the owning engine is disposed;
      // without this each reinit leaks 3 slots per camera.
      destroy() {
        if (this.temp_pvMatrix) Matrix4.freeIndex(this.temp_pvMatrix);
        if (this.temp_viewMatrix) Matrix4.freeIndex(this.temp_viewMatrix);
        if (this.temp_worldMatrix) Matrix4.freeIndex(this.temp_worldMatrix);
        this.temp_pvMatrix = null;
        this.temp_viewMatrix = null;
        this.temp_worldMatrix = null;
      }
      setCamera(camera) {
        this.uniformGPUBuffer.setMatrix(`_projectionMatrix`, camera.projectionMatrix);
        if (this._ctx.engine.setting.useRTE) {
          const mainCamera = Camera3D.mainCamera || camera;
          this.temp_worldMatrix.copy(camera.transform.worldMatrix);
          const rtePos = Vector3.sub(camera.transform.worldPosition, mainCamera.transform.worldPosition);
          this.temp_worldMatrix.rawData[12] = rtePos.x;
          this.temp_worldMatrix.rawData[13] = rtePos.y;
          this.temp_worldMatrix.rawData[14] = rtePos.z;
          this.temp_viewMatrix.copy(this.temp_worldMatrix);
          this.temp_viewMatrix.invert();
          this.uniformGPUBuffer.setMatrix(`_viewMatrix`, this.temp_viewMatrix);
          this.uniformGPUBuffer.setMatrix(`_cameraWorldMatrix`, this.temp_worldMatrix);
          this.uniformGPUBuffer.setMatrix(`projMatInv`, camera.projectionMatrixInv);
          let cameraToWorld = Matrix4.helpMatrix.copy(camera.projectionMatrixInv);
          this.temp_viewMatrix.invert();
          cameraToWorld.multiply(this.temp_viewMatrix);
          this.uniformGPUBuffer.setMatrix(`viewToWorld`, cameraToWorld);
        } else {
          this.uniformGPUBuffer.setMatrix(`_viewMatrix`, camera.viewMatrix);
          this.uniformGPUBuffer.setMatrix(`_cameraWorldMatrix`, camera.transform.worldMatrix);
          this.uniformGPUBuffer.setMatrix(`projMatInv`, camera.projectionMatrixInv);
          this.uniformGPUBuffer.setMatrix(`viewToWorld`, camera.cameraToWorld);
        }
        let shadowLightList = ShadowLightsCollect.getDirectShadowLightWhichScene(camera.transform.scene3D);
        this.csmShadowBias.fill(1e-4);
        this.shadowMatrixRaw.fill(0);
        this.csmMatrixRaw.fill(0);
        if (!camera.isShadowCamera) {
          const maxShadowMapNum = this._ctx.engine.setting.shadow.maxShadowMapNum;
          let shadowMatrixRawIndex = 0;
          for (let i = 0; i < maxShadowMapNum; i++) {
            if (i < shadowLightList.length) {
              const shadowLight = shadowLightList[i];
              if (shadowLight.enableCSM && shadowLight.lightData.csmShadowMapIndex >= 0) {
                for (let csm = 0; csm < shadowLight.lightData.csmShadowMapNum; csm++) {
                  let shadowCamera = shadowLight.csmShadowCamera[csm];
                  if (this._ctx.engine.setting.useRTE) {
                    let viewMatrix = this.temp_viewMatrix.copy(shadowCamera.transform.worldMatrix);
                    let rtePos = Vector3.sub(shadowCamera.transform.worldPosition, camera.transform.worldPosition);
                    viewMatrix.rawData[12] = rtePos.x;
                    viewMatrix.rawData[13] = rtePos.y;
                    viewMatrix.rawData[14] = rtePos.z;
                    viewMatrix.invert();
                    matrixMultiply(shadowCamera.projectionMatrix, viewMatrix, this.temp_pvMatrix);
                    this.shadowMatrixRaw.set(this.temp_pvMatrix.rawData, shadowMatrixRawIndex * 16);
                  } else {
                    this.shadowMatrixRaw.set(shadowCamera.pvMatrix.rawData, shadowMatrixRawIndex * 16);
                  }
                  shadowLight.lightData.shadowBias[csm] = ShadowBiasCalculator.resolveDirectShadowBias(shadowLight, csm);
                  shadowLight.lightData.normalBias[csm] = ShadowBiasCalculator.resolveDirectNormalBias(shadowLight, csm);
                  shadowMatrixRawIndex++;
                }
              } else {
                let shadowCamera = shadowLight.shadowCamera;
                if (this._ctx.engine.setting.useRTE) {
                  let viewMatrix = this.temp_viewMatrix.copy(shadowCamera.transform.worldMatrix);
                  let rtePos = Vector3.sub(shadowCamera.transform.worldPosition, camera.transform.worldPosition, Vector3.HELP_6);
                  viewMatrix.rawData[12] = rtePos.x;
                  viewMatrix.rawData[13] = rtePos.y;
                  viewMatrix.rawData[14] = rtePos.z;
                  viewMatrix.invert();
                  matrixMultiply(shadowCamera.projectionMatrix, viewMatrix, this.temp_pvMatrix);
                  this.shadowMatrixRaw.set(this.temp_pvMatrix.rawData, shadowMatrixRawIndex * 16);
                } else {
                  this.shadowMatrixRaw.set(shadowCamera.pvMatrix.rawData, shadowMatrixRawIndex * 16);
                }
                shadowLight.lightData.shadowBias[0] = ShadowBiasCalculator.resolveDirectShadowBias(shadowLight, 0);
                shadowLight.lightData.normalBias[0] = ShadowBiasCalculator.resolveDirectNormalBias(shadowLight, 0);
                shadowMatrixRawIndex++;
              }
            } else if (shadowMatrixRawIndex < maxShadowMapNum) {
              this.shadowMatrixRaw.set(camera.transform.worldMatrix.rawData, shadowMatrixRawIndex * 16);
              shadowMatrixRawIndex++;
            }
          }
          const pointShadowList = ShadowLightsCollect.getPointShadowLightWhichScene(camera.transform.scene3D);
          if (pointShadowList && pointShadowList.length) {
            const pmSize = this._ctx.engine.setting.shadow.pointShadowSize;
            for (let i = 0; i < pointShadowList.length; i++) {
              const pLight = pointShadowList[i];
              pLight.lightData.shadowBias[0] = ShadowBiasCalculator.resolvePointShadowBias(pLight, pmSize);
              pLight.lightData.normalBias[0] = ShadowBiasCalculator.resolvePointNormalBias(pLight, pmSize);
              const sFar = pLight.shadowCameraFar;
              pLight.lightData.shadowFar = sFar && sFar > 0 ? sFar : pLight.lightData.range || 1;
            }
          }
        }
        this.uniformGPUBuffer.setFloat32Array(`shadowMatrix`, this.shadowMatrixRaw);
        let shadowMapSize = this._ctx.engine.setting.shadow.shadowSize;
        this.uniformGPUBuffer.setFloat32Array(`csmShadowBias`, this.csmShadowBias);
        this.uniformGPUBuffer.setFloat32Array(`csmMatrix`, this.csmMatrixRaw);
        this.uniformGPUBuffer.setFloat32Array(`shadowLights`, this.shadowLights);
        let reflectionSetting = this._ctx.engine.setting.reflectionSetting;
        let reflectionCount = EntityCollect.instance.getReflections(camera.transform.scene3D).length;
        this.uniformGPUBuffer.setFloat(`reflectionProbeSize`, reflectionSetting.reflectionProbeSize);
        this.uniformGPUBuffer.setFloat(`reflectionProbeMaxCount`, reflectionSetting.reflectionProbeMaxCount);
        this.uniformGPUBuffer.setFloat(`reflectionMapWidth`, reflectionSetting.width);
        this.uniformGPUBuffer.setFloat(`reflectionMapHeight`, reflectionSetting.height);
        this.uniformGPUBuffer.setFloat(`reflectionCount`, reflectionCount);
        this.uniformGPUBuffer.setFloat(`test2`, ProfilerUtil.testObj.testValue2);
        this.uniformGPUBuffer.setFloat(`test3`, ProfilerUtil.testObj.testValue3);
        this.uniformGPUBuffer.setFloat(`test4`, ProfilerUtil.testObj.testValue4);
        if (this._ctx.engine.setting.useRTE) {
          const cameraPos = Vector3.HELP_0.set(
            this.temp_worldMatrix.rawData[12],
            this.temp_worldMatrix.rawData[13],
            this.temp_worldMatrix.rawData[14]
          );
          this.uniformGPUBuffer.setVector3(`CameraPos`, cameraPos);
        } else {
          this.uniformGPUBuffer.setVector3(`CameraPos`, camera.transform.worldPosition);
        }
        this.uniformGPUBuffer.setFloat(`frame`, Time.frame);
        this.uniformGPUBuffer.setFloat32Array(`SH`, camera.sh);
        this.uniformGPUBuffer.setFloat(`time`, Time.time);
        this.uniformGPUBuffer.setFloat(`delta`, Time.delta);
        this.uniformGPUBuffer.setFloat(`shadowBias`, camera.getShadowBias(shadowMapSize));
        this.uniformGPUBuffer.setFloat(`skyExposure`, this._ctx.engine.setting.sky.skyExposure);
        this.uniformGPUBuffer.setFloat(`renderPassState`, this._ctx.engine.setting.render.renderPassState);
        this.uniformGPUBuffer.setFloat(`quadScale`, this._ctx.engine.setting.render.quadScale);
        this.uniformGPUBuffer.setFloat(`hdrExposure`, this._ctx.engine.setting.render.hdrExposure);
        this.uniformGPUBuffer.setInt32(`renderState_left`, this._ctx.engine.setting.render.renderState_left);
        this.uniformGPUBuffer.setInt32(`renderState_right`, this._ctx.engine.setting.render.renderState_right);
        this.uniformGPUBuffer.setFloat(`renderState_split`, this._ctx.engine.setting.render.renderState_split);
        const ownerC = camera?.transform?.view3D?.engine3D;
        const inputC = ownerC?.inputSystem;
        const ctxC = ownerC?.context3D;
        let mouseX = (inputC?.mouseX ?? 0) * (ctxC?.pixelRatio ?? 1);
        let mouseY = (inputC?.mouseY ?? 0) * (ctxC?.pixelRatio ?? 1);
        this.uniformGPUBuffer.setFloat(`mouseX`, mouseX);
        this.uniformGPUBuffer.setFloat(`mouseY`, mouseY);
        this.uniformGPUBuffer.setFloat(`windowWidth`, ctxC?.windowWidth ?? 0);
        this.uniformGPUBuffer.setFloat(`windowHeight`, ctxC?.windowHeight ?? 0);
        this.uniformGPUBuffer.setFloat(`near`, camera.near);
        this.uniformGPUBuffer.setFloat(`far`, camera.far);
        this.uniformGPUBuffer.setFloat(`pointShadowBias`, 0);
        this.uniformGPUBuffer.setFloat(`shadowMapSize`, shadowMapSize);
        this.uniformGPUBuffer.setFloat(`shadowSoft`, this._ctx.engine.setting.shadow.shadowSoft);
        this.uniformGPUBuffer.setFloat(`pcfKernelScale`, this._ctx.engine.setting.shadow.pcfKernelScale ?? 1);
        this.uniformGPUBuffer.setFloat(`enableCSM`, 0);
        this.uniformGPUBuffer.setFloat(`csmMargin`, this._ctx.engine.setting.shadow.csmMargin);
        this.uniformGPUBuffer.setInt32(`nDirShadowStart`, this.dirShadowStart);
        this.uniformGPUBuffer.setInt32(`nDirShadowEnd`, this.dirShadowEnd);
        this.uniformGPUBuffer.setInt32(`nPointShadowStart`, this.pointShadowStart);
        this.uniformGPUBuffer.setInt32(`nPointShadowEnd`, this.pointShadowEnd);
        this.uniformGPUBuffer.setVector3(`cameraForward`, camera.transform.forward);
        this.uniformGPUBuffer.setVector4Array(`frustumPlanes`, camera.frustum.planes);
        this.uniformGPUBuffer.setVector3(`_retain`, Vector3.ZERO);
        if (this._ctx.engine.setting.useRTE) {
          const mainCamera = Camera3D.mainCamera || camera;
          const cameraPos = mainCamera.transform.worldPosition;
          const valueHL = splitDouble_Vector3(cameraPos, this._ctx.engine.setting.RTEScale);
          const cameraPosH = valueHL[0];
          const cameraPosL = valueHL[1];
          this.uniformGPUBuffer.setVector3(`cameraPositionH`, cameraPosH);
          this.uniformGPUBuffer.setUint32(`maxModelsCount`, Matrix4.maxCount);
          this.uniformGPUBuffer.setVector3(`cameraPositionL`, cameraPosL);
          this.uniformGPUBuffer.setUint32(`cameraMatrixIndex`, camera.transform.worldMatrix.index);
          this.uniformGPUBuffer.setUint32(`useRTE`, 1);
        } else {
          this.uniformGPUBuffer.setVector3(`cameraPositionH`, Vector3.ZERO);
          this.uniformGPUBuffer.setUint32(`maxModelsCount`, Matrix4.maxCount);
          this.uniformGPUBuffer.setVector3(`cameraPositionL`, Vector3.ZERO);
          this.uniformGPUBuffer.setUint32(`cameraMatrixIndex`, 0);
          this.uniformGPUBuffer.setUint32(`useRTE`, 0);
        }
        this.uniformGPUBuffer.apply();
      }
      setShadowCamera(camera) {
        this.setCamera(camera);
      }
      setShadowLight() {
      }
    }

    class DDGIIrradianceVolume {
      setting;
      probesBufferData;
      //offset xyz frame
      probesBuffer;
      isVolumeFrameChange = true;
      randomOrientation;
      startPosition = new Vector3();
      isVolumeChange = true;
      irradianceVolumeBuffer;
      //__make random direction
      directionDistance = 20;
      randomSeedCount = 3;
      useRandomIndex = 0;
      centerDirection = new Vector3(0, 0, this.directionDistance).normalize(1);
      arroundPositions = [];
      //__end
      updateOrientation() {
        this.useRandomIndex++;
        if (this.useRandomIndex >= this.arroundPositions.length)
          this.useRandomIndex = 0;
        Matrix4.fromToRotation(this.centerDirection, this.arroundPositions[this.useRandomIndex], this.randomOrientation);
        return this.randomOrientation;
      }
      init(setting) {
        this.setting = setting;
        this.randomOrientation = new Matrix4(false);
        this.randomOrientation.identity();
        this.irradianceVolumeBuffer = new UniformGPUBuffer(80);
        this.createFramesBuffer();
        this.arroundPositions.push(this.centerDirection.clone());
        for (let i = 0; i < this.randomSeedCount; i++) {
          let angle = Math.PI * 2 * i / this.randomSeedCount;
          let v = new Vector3(Math.sin(angle), Math.cos(angle), this.directionDistance).normalize(1);
          this.arroundPositions.push(v);
        }
      }
      setVolumeDataChange() {
        this.isVolumeChange = true;
      }
      // `randomOrientation` is the only Matrix4 this volume owns directly.
      // Called by LightEntries.destroy() during engine teardown.
      destroy() {
        if (this.randomOrientation) {
          Matrix4.freeIndex(this.randomOrientation);
          this.randomOrientation = null;
        }
      }
      updateProbes(probes) {
        let frameArray = this.probesBufferData;
        for (let probe of probes) {
          let offset = probe.index * 4;
          frameArray[offset + 3] = probe.drawCallFrame;
        }
      }
      createFramesBuffer() {
        if (!this.probesBufferData) {
          let size = this.setting.probeXCount * this.setting.probeYCount * this.setting.probeZCount;
          this.probesBufferData = new Float32Array(size * 4);
          this.probesBufferData.fill(-1);
          this.probesBuffer = new StorageGPUBuffer(size * 4, GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST);
        }
      }
      uploadBuffer() {
        if (this.isVolumeChange) {
          this.fillIrradianceData();
          this.isVolumeChange = false;
          this.isVolumeFrameChange = true;
        }
        this.probesBuffer.setFloat32Array("uniformFramesBuffer", this.probesBufferData);
      }
      calcPosition(x, y, z, result) {
        let setting = this.setting;
        let space = this.setting.probeSpace;
        result = result || new Vector3();
        result.x = x * space - space * (setting.probeXCount - 1) * 0.5 + setting.offsetX;
        result.y = y * space - space * (setting.probeYCount - 1) * 0.5 + setting.offsetY;
        result.z = z * space - space * (setting.probeZCount - 1) * 0.5 + setting.offsetZ;
        return result;
      }
      debugX = 0;
      debugY = 0;
      debugZ = 0;
      fillIrradianceData() {
        let setting = this.setting;
        let start = this.calcPosition(0, 0, 0, this.startPosition);
        this.irradianceVolumeBuffer.setFloat("orientationIndex", this.randomOrientation.index);
        this.irradianceVolumeBuffer.setFloat("hysteresis", setting.hysteresis);
        this.irradianceVolumeBuffer.setFloat("OctRTSideSize", setting.octRTSideSize);
        this.irradianceVolumeBuffer.setFloat("OctRTMaxSize", setting.octRTMaxSize);
        this.irradianceVolumeBuffer.setFloat("startX", start.x);
        this.irradianceVolumeBuffer.setFloat("startY", start.y);
        this.irradianceVolumeBuffer.setFloat("startZ", start.z);
        this.irradianceVolumeBuffer.setFloat("ProbeSpace", setting.probeSpace);
        this.irradianceVolumeBuffer.setFloat("probeXCount", setting.probeXCount);
        this.irradianceVolumeBuffer.setFloat("probeYCount", setting.probeYCount);
        this.irradianceVolumeBuffer.setFloat("probeZCount", setting.probeZCount);
        this.irradianceVolumeBuffer.setFloat("maxDistance", setting.probeSpace * 1.732);
        this.irradianceVolumeBuffer.setFloat("depthSharpness", setting.depthSharpness);
        this.irradianceVolumeBuffer.setFloat("ProbeSourceTextureSize", setting.probeSourceTextureSize);
        this.irradianceVolumeBuffer.setFloat("ProbeSize", setting.probeSize);
        this.irradianceVolumeBuffer.setFloat("bounceIntensity", setting.bounceIntensity);
        this.irradianceVolumeBuffer.setFloat("probeRoughness", setting.probeRoughness);
        this.irradianceVolumeBuffer.setFloat("normalBias", setting.normalBias);
        this.irradianceVolumeBuffer.setFloat("irradianceChebyshevBias", setting.irradianceChebyshevBias);
        this.irradianceVolumeBuffer.setFloat("rayNumber", setting.rayNumber);
        this.irradianceVolumeBuffer.setFloat("irradianceDistanceBias", setting.irradianceDistanceBias);
        this.irradianceVolumeBuffer.setFloat("indirectIntensity", setting.indirectIntensity);
        this.irradianceVolumeBuffer.setFloat("ddgiGamma", setting.ddgiGamma);
        this.irradianceVolumeBuffer.setFloat("lerpHysteresis", setting.lerpHysteresis);
        this.irradianceVolumeBuffer.setFloat("debugX", this.debugX);
        this.irradianceVolumeBuffer.setFloat("debugY", this.debugY);
        this.irradianceVolumeBuffer.setFloat("debugZ", this.debugZ);
        this.irradianceVolumeBuffer.apply();
      }
    }

    class LightEntries {
      storageGPUBuffer;
      irradianceVolume;
      _lightList = [];
      constructor(scene) {
        const setting = scene.view.engine3D.setting;
        const lightDataSize = LightData.lightSize + setting.shadow.maxCascades * 2;
        this.storageGPUBuffer = new StorageGPUBuffer(
          lightDataSize * setting.light.maxLight,
          GPUBufferUsage.COPY_SRC
        );
        this.irradianceVolume = new DDGIIrradianceVolume();
        this.irradianceVolume.init(setting.gi);
        for (let i = 0; i < setting.light.maxLight; i++) {
          let memory = this.storageGPUBuffer.memory.allocation_node(lightDataSize * 4);
          this._lightList.push(memory);
        }
        this.storageGPUBuffer.visibility = GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
      }
      update(view) {
        this.storageGPUBuffer.clean();
        const mainCameraPos = Camera3D.mainCamera.transform.worldPosition;
        let lights = EntityCollect.instance.getLights(view.scene);
        for (let i = 0; i < lights.length; i++) {
          const lightComponent = lights[i];
          const light = lightComponent.lightData;
          light.index = i;
          if (lightComponent.iesProfile) {
            const iesPool = IESProfilesPool.for(view.engine3D.context3D);
            light.iesIndex = iesPool.register(lightComponent.iesProfile);
          }
          if (view.engine3D.setting.useRTE) {
            const oldPos = light.lightPosition;
            Vector3.sub(light.lightPosition, mainCameraPos, Vector3.HELP_0);
            light.lightPosition = Vector3.HELP_0;
            this.writeLightBytes(light, this._lightList[i]);
            light.lightPosition = oldPos;
          } else {
            this.writeLightBytes(light, this._lightList[i]);
          }
        }
        this.storageGPUBuffer.apply();
      }
      // Release the DDGI volume's Matrix4 slot. Called from
      // GlobalBindGroup.removeScene() during engine dispose.
      destroy() {
        this.irradianceVolume?.destroy();
        this.irradianceVolume = null;
      }
      writeLightBytes(light, memory) {
        memory.offset = 0;
        memory.writeFloat(light.index);
        memory.writeInt32(light.lightType);
        memory.writeFloat(light.radius);
        memory.writeFloat(light.linear);
        memory.writeVector3(light.lightPosition);
        memory.writeFloat(light.lightMatrixIndex);
        memory.writeVector3(light.direction);
        memory.writeFloat(light.quadratic);
        memory.writeRGBColor(light.lightColor);
        memory.writeFloat(light.intensity);
        memory.writeFloat(light.innerAngle);
        memory.writeFloat(light.outerAngle);
        memory.writeFloat(light.range);
        memory.writeInt32(light.castShadowIndex);
        memory.writeVector3(light.lightTangent);
        memory.writeFloat(light.iesIndex);
        memory.writeFloat(light.csmShadowMapNum);
        memory.writeFloat(light.csmShadowMapIndex);
        memory.writeFloat(light.shadowFar);
        memory.writeFloat(light.softness);
        memory.writeArray(light.shadowBias);
        memory.writeArray(light.normalBias);
      }
    }

    class ReflectionEntries {
      storageGPUBuffer;
      reflectionMap;
      sourceReflectionMap;
      count;
      constructor() {
        this.storageGPUBuffer = new StorageGPUBuffer((3 + 3) * 128);
      }
      update(view) {
        this.storageGPUBuffer.clean();
        let reflections = EntityCollect.instance.getReflections(view.scene);
        for (let i = 0; i < reflections.length; i++) {
          const reflection = reflections[i];
          reflection.gid = i;
          this.storageGPUBuffer.setFloat("gid", reflection.gid);
          this.storageGPUBuffer.setVector3("worldPosition", reflection.transform.worldPosition);
          this.storageGPUBuffer.setFloat("radius", reflection.radius);
          this.storageGPUBuffer.setVector3("bound", reflection.transform.worldPosition);
        }
        this.count = reflections.length;
        this.storageGPUBuffer.apply();
      }
    }

    class MatrixGPUBuffer extends GPUBufferBase {
      size;
      constructor(size, usage = 0, data) {
        super();
        this.bufferType = GPUBufferType.StorageGPUBuffer;
        this.size = size;
        this.createBuffer(GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | usage, size, data, "MatrixGPUBuffer");
      }
      writeBufferByHeap(floatArray, len) {
        let mapAsyncArray;
        if (floatArray instanceof Float64Array) {
          mapAsyncArray = new Float32Array(floatArray);
        } else {
          mapAsyncArray = floatArray;
        }
        void this.buffer;
        let device = this._boundCtx.device;
        if (mapAsyncArray.length > 0) {
          let tBuffer = null;
          while (this.mapAsyncReady.length) {
            tBuffer = this.mapAsyncReady.shift();
            if (tBuffer["usedSize"] == mapAsyncArray.byteLength)
              break;
            tBuffer.destroy();
            this.mapAsyncBuffersOutstanding--;
            tBuffer = null;
          }
          if (!tBuffer) {
            tBuffer = device.createBuffer({
              size: mapAsyncArray.byteLength,
              usage: GPUBufferUsage.COPY_SRC | GPUBufferUsage.MAP_WRITE,
              mappedAtCreation: true
            });
            tBuffer["usedSize"] = mapAsyncArray.byteLength;
            this.mapAsyncBuffersOutstanding++;
            if (this.mapAsyncBuffersOutstanding > 10) {
              console.warn(` Warning: mapAsync requests from ${this.mapAsyncBuffersOutstanding} frames ago have not resolved yet.  MB of staging buffers allocated.`);
            }
          }
          let a = new Float32Array(mapAsyncArray.buffer, mapAsyncArray.byteOffset, len);
          let b = new Float32Array(tBuffer.getMappedRange(0, len * 4));
          b.set(a);
          tBuffer.unmap();
          const commandEncoder = device.createCommandEncoder();
          commandEncoder.copyBufferToBuffer(tBuffer, 0, this.buffer, 0, len * 4);
          device.queue.submit([commandEncoder.finish()]);
          tBuffer.mapAsync(GPUMapMode.WRITE).then(
            () => this.mapAsyncReady.push(tBuffer),
            (err) => {
              if (err?.name !== "AbortError") throw err;
            }
          );
        }
      }
    }

    class MatrixBindGroup {
      uuid;
      index;
      usage;
      groupBufferSize;
      matrixBufferDst;
      constructor(ctx) {
        this.uuid = UUID();
        this.groupBufferSize = 0;
        this.usage = GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST;
        this.cacheWorldMatrix(ctx);
      }
      cacheWorldMatrix(ctx) {
        this.groupBufferSize = Matrix4.maxCount * Matrix4.blockBytes;
        this.matrixBufferDst = new MatrixGPUBuffer(this.groupBufferSize / 4 + Matrix4.maxCount * 8);
        bindCtx(this.matrixBufferDst, ctx);
        this.matrixBufferDst.visibility = GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
        this.matrixBufferDst.buffer.label = this.groupBufferSize.toString();
      }
      writeBuffer(len) {
        const ctx = this.matrixBufferDst._boundCtx;
        const setting = ctx?.engine?.setting;
        if (setting?.doublePrecision) {
          Matrix4.dynamicMatrixBytes_32bit.set(Matrix4.dynamicMatrixBytes);
          this.matrixBufferDst.mapAsyncWrite(Matrix4.dynamicMatrixBytes_32bit, len);
        } else {
          this.matrixBufferDst.mapAsyncWrite(Matrix4.dynamicMatrixBytes, len);
        }
        if (setting?.useRTE) {
          if (ctx) {
            ctx.device.queue.writeBuffer(this.matrixBufferDst.buffer, Matrix4.maxCount * (16 * 4), Matrix4.matrixWorldPositionHLDatas);
          }
        }
      }
    }

    class GlobalBindGroup {
      static _cameraBindGroups = /* @__PURE__ */ new Map();
      static _lightEntriesMap = /* @__PURE__ */ new Map();
      static _reflectionEntriesMap = /* @__PURE__ */ new Map();
      static getModelMatrixBindGroup(ctx) {
        return ctx.cache(GlobalBindGroup, () => new MatrixBindGroup(ctx));
      }
      static init(ctx) {
        this.getModelMatrixBindGroup(ctx);
      }
      static getAllCameraGroup() {
        return this._cameraBindGroups;
      }
      static getCameraGroup(camera) {
        let cameraBindGroup = this._cameraBindGroups.get(camera);
        if (!cameraBindGroup) {
          const ctx = this._ctxFromCamera(camera);
          cameraBindGroup = new GlobalUniformGroup(ctx, this.getModelMatrixBindGroup(ctx));
          this._cameraBindGroups.set(camera, cameraBindGroup);
        }
        if (camera.isShadowCamera) {
          cameraBindGroup.setShadowCamera(camera);
        } else {
          cameraBindGroup.setCamera(camera);
        }
        return cameraBindGroup;
      }
      static updateCameraGroup(camera) {
        let cameraBindGroup = this._cameraBindGroups.get(camera);
        if (!cameraBindGroup) {
          const ctx = this._ctxFromCamera(camera);
          cameraBindGroup = new GlobalUniformGroup(ctx, this.getModelMatrixBindGroup(ctx));
          this._cameraBindGroups.set(camera, cameraBindGroup);
        }
        if (camera.isShadowCamera) {
          cameraBindGroup.setShadowCamera(camera);
        } else {
          cameraBindGroup.setCamera(camera);
        }
      }
      static getLightEntries(scene) {
        if (!scene) {
          console.warn(`getLightEntries scene is null`);
        }
        let lightEntries = this._lightEntriesMap.get(scene);
        if (!lightEntries) {
          lightEntries = new LightEntries(scene);
          this._lightEntriesMap.set(scene, lightEntries);
        }
        return this._lightEntriesMap.get(scene);
      }
      static getReflectionEntries(scene) {
        if (!scene) {
          console.warn(`getLightEntries scene is null`);
        }
        let reflectionEntries = this._reflectionEntriesMap.get(scene);
        if (!reflectionEntries) {
          reflectionEntries = new ReflectionEntries();
          this._reflectionEntriesMap.set(scene, reflectionEntries);
        }
        return this._reflectionEntriesMap.get(scene);
      }
      static _ctxFromCamera(camera) {
        const ctx = camera._boundCtx ?? camera.transform?.view3D?.engine3D?.context3D ?? null;
        if (!ctx) {
          throw new Error(`Camera3D has no bound Context3D — attach camera to a scene/view before use.`);
        }
        return ctx;
      }
      // Called from Engine3D.dispose(). Purges every camera entry whose
      // _boundCtx matches the disposed context, plus the scene-keyed entries.
      // Without this, a long-running app that creates/drops engines leaks a
      // Scene3D + per-camera GlobalUniformGroup per cycle.
      static removeContext(ctx) {
        for (const cam of [...this._cameraBindGroups.keys()]) {
          if (cam._boundCtx === ctx) {
            this._cameraBindGroups.get(cam)?.destroy();
            this._cameraBindGroups.delete(cam);
          }
        }
      }
      static removeScene(scene) {
        this._lightEntriesMap.get(scene)?.destroy();
        this._lightEntriesMap.delete(scene);
        this._reflectionEntriesMap.delete(scene);
      }
    }

    class AccelerateInterpolator {
      _factor;
      _doubleFactor;
      constructor() {
        this._factor = 1;
        this._doubleFactor = 2;
      }
      get accelerateInterpolator() {
        return this._factor;
      }
      set accelerateInterpolator(factor) {
        this._factor = factor;
        this._doubleFactor = 2 * this._factor;
      }
      getInterpolation(input) {
        if (this._factor == 1) {
          return input * input;
        } else {
          return Math.pow(input, this._doubleFactor);
        }
      }
    }
    class DecelerateInterpolator {
      _factor = 1;
      constructor() {
      }
      get decelerateInterpolator() {
        return this._factor;
      }
      set decelerateInterpolator(factor) {
        this._factor = factor;
      }
      getInterpolation(input) {
        let result;
        if (this._factor == 1) {
          result = 1 - (1 - input) * (1 - input);
        } else {
          result = 1 - Math.pow(1 - input, 2 * this._factor);
        }
        return result;
      }
    }
    class AccelerateDecelerateInterpolator {
      _factor = 1;
      constructor() {
      }
      getInterpolation(input) {
        return Math.cos((input + 1) * Math.PI) / 2 + 0.5;
      }
    }
    class LinearInterpolator {
      getInterpolation(input) {
        return input;
      }
    }
    class JumperInterpolator {
      getInterpolation(t) {
        return 4.9 * t + 4.9 * t;
      }
    }
    class BounceInterpolator {
      constructor() {
      }
      static bounce(t) {
        return t * t * 9.8;
      }
      getInterpolation(t) {
        t *= 1.1226;
        if (t < 0.3535) return BounceInterpolator.bounce(t);
        else if (t < 0.7408) return BounceInterpolator.bounce(t - 0.54719) + 0.7;
        else if (t < 0.9644) return BounceInterpolator.bounce(t - 0.8526) + 0.9;
        else return BounceInterpolator.bounce(t - 1.0435) + 0.95;
      }
      getBounceInterpolation(t) {
        if (t < 0.5) return BounceInterpolator.bounce(t);
        else return BounceInterpolator.bounce(t - 1);
      }
      geJumpUp(v0, t) {
        if (t < 0.5) {
          t = t / 0.5;
          return v0 * t - BounceInterpolator.bounce(t);
        } else if (t < 0.8) {
          t = (t - 0.5) / (0.8 - 0.5);
          return (v0 * t - BounceInterpolator.bounce(t)) * 0.3;
        } else if (t < 1) {
          t = (t - 0.8) / (1 - 0.8);
          return (v0 * t - BounceInterpolator.bounce(t)) * 0.15;
        } else return v0 * t - BounceInterpolator.bounce(t);
      }
    }
    class AnticipateInterpolator {
      _tension;
      constructor() {
        this._tension = 2;
      }
      get anticipateInterpolator() {
        return this._tension;
      }
      set anticipateInterpolator(tension) {
        this._tension = tension;
      }
      getInterpolation(t) {
        return t * t * ((this._tension + 1) * t - this._tension);
      }
    }
    class AnticipateOvershootInterpolator {
      _tension;
      constructor() {
        this._tension = 1 * 1.5;
      }
      anticipateOvershootInterpolator(tension) {
        this._tension = tension * 1.5;
      }
      anticipateOvershootInterpolator2(tension, extraTension) {
        this._tension = tension * extraTension;
      }
      getInterpolation(t) {
        if (t < 0.5) return 0.5 * AnticipateOvershootInterpolator.a(t * 2, this._tension);
        else return 0.5 * (AnticipateOvershootInterpolator.o(t * 2 - 2, this._tension) + 2);
      }
      static a(t, s) {
        return t * t * ((s + 1) * t - s);
      }
      static o(t, s) {
        return t * t * ((s + 1) * t + s);
      }
    }
    class CycleInterpolator {
      _cycles;
      constructor(cycles) {
        this._cycles = cycles;
      }
      getInterpolation(t) {
        return Math.sin(2 * this._cycles * Math.PI * t);
      }
    }
    class OvershootInterpolator {
      _tension;
      constructor() {
        this._tension = 2;
      }
      getInterpolation(t) {
        t -= 1;
        return t * t * ((this._tension + 1) * t + this._tension) + 1;
      }
    }
    var InterpolatorEnum = /* @__PURE__ */ ((InterpolatorEnum2) => {
      InterpolatorEnum2[InterpolatorEnum2["AccelerateInterpolator"] = 0] = "AccelerateInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["DecelerateInterpolator"] = 1] = "DecelerateInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["AccelerateDecelerateInterpolator"] = 2] = "AccelerateDecelerateInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["LinearInterpolator"] = 3] = "LinearInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["BounceInterpolator"] = 4] = "BounceInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["AnticipateInterpolator"] = 5] = "AnticipateInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["AnticipateOvershootInterpolator"] = 6] = "AnticipateOvershootInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["CycleInterpolator"] = 7] = "CycleInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["OvershootInterpolator"] = 8] = "OvershootInterpolator";
      InterpolatorEnum2[InterpolatorEnum2["JumperInterpolator"] = 9] = "JumperInterpolator";
      return InterpolatorEnum2;
    })(InterpolatorEnum || {});
    class Interpolator {
      /**
       * @internal
       */
      static interpolators = [];
      /**
       * @internal
       */
      complete = false;
      /**
       * @internal
       */
      onComplete;
      /**
       * @internal
       */
      onProgress;
      /**
       * @internal
       */
      target;
      /**
       * @internal
       */
      property;
      /**
       * @internal
       */
      targetProperty;
      /**
       * @internal
       */
      durtion;
      /**
       * @internal
       */
      interpolatorEnum;
      /**
       * @internal
       */
      delayTime = 0;
      _interpolator;
      _ct = 0;
      _p = 0;
      /**
       * Creates an animation from the current property to the specified target property.
       * @param target Objects that need to be animated
       * @param property Animation parameter
       * @param durtion Animation duration, usually seconds
       * @param interpolatorEnum Interpolator type
       * @returns 
       */
      static to(target, property, durtion, interpolatorEnum = 0 /* AccelerateInterpolator */) {
        var interpolator = new Interpolator();
        interpolator.target = target;
        interpolator.property = property;
        interpolator.durtion = durtion;
        interpolator.interpolatorEnum = interpolatorEnum;
        interpolator.start();
        interpolator.delayTime = property["delayTime"] ? property["delayTime"] : 0;
        if (property["onComplete"]) interpolator.onComplete = property["onComplete"];
        if (property["onProgress"]) interpolator.onProgress = property["onProgress"];
        this.interpolators.push(interpolator);
        return interpolator;
      }
      /**
       * @internal
       */
      static tick(delta) {
        let interpolators = Interpolator.interpolators;
        for (let inter of interpolators) {
          if (inter.complete) {
            Interpolator.remove(inter, true);
          } else {
            inter.tick(delta);
          }
        }
      }
      /**
       * @internal
       */
      static remove(interpolator, dispose) {
        let interpolators = Interpolator.interpolators;
        let index = interpolators.indexOf(interpolator);
        if (index != -1) interpolators.splice(index, 1);
        if (dispose) interpolator.dispose();
      }
      /**
       * Remove a list of interpolators from the active pool.
       * @param interpolators interpolators to remove
       * @param dispose whether to dispose each removed interpolator
       */
      static removeList(interpolators, dispose) {
        interpolators.forEach((v) => {
          this.remove(v, dispose);
        });
      }
      /**
       * @internal
       */
      start() {
        window["AccelerateInterpolator"] = AccelerateInterpolator;
        window["DecelerateInterpolator"] = DecelerateInterpolator;
        window["AccelerateDecelerateInterpolator"] = AccelerateDecelerateInterpolator;
        window["LinearInterpolator"] = LinearInterpolator;
        window["BounceInterpolator"] = BounceInterpolator;
        window["AnticipateInterpolator"] = AnticipateInterpolator;
        window["AnticipateOvershootInterpolator"] = AnticipateOvershootInterpolator;
        window["CycleInterpolator"] = CycleInterpolator;
        window["OvershootInterpolator"] = OvershootInterpolator;
        window["JumperInterpolator"] = JumperInterpolator;
        this._interpolator = new window[InterpolatorEnum[this.interpolatorEnum]]();
        this.targetProperty = {};
        for (let p in this.property) {
          this.targetProperty[p] = this.target[p];
        }
      }
      /**
       * @internal
       */
      tick(delta) {
        if (this.delayTime <= 0) {
          this._p = Math.min(this._ct / this.durtion, 1);
          let v = this._interpolator.getInterpolation(this._p);
          let property = this.property;
          let target = this.target;
          let targetProperty = this.targetProperty;
          let ct;
          let tt;
          for (let p in property) {
            tt = property[p];
            ct = targetProperty[p];
            target[p] = ct + (tt - ct) * v;
          }
          if (this.onProgress != null) this.onProgress(this._p);
          if (this._ct >= this.durtion) {
            this.complete = true;
            if (this.onComplete != null) {
              this.onComplete(this.target);
            }
          }
          this._ct += delta;
        } else {
          this.delayTime -= delta;
        }
      }
      /**
       * @internal
       */
      dispose() {
        this.onComplete = null;
        this.onProgress = null;
        this.target = null;
        this.property = null;
        this.targetProperty = null;
        this.interpolatorEnum = null;
        this._interpolator = null;
        Interpolator.remove(this);
      }
    }

    class ClusterConfig {
      /** Number of cluster tiles across the screen width. */
      static clusterTileX = 16;
      /** Number of cluster tiles across the screen height. */
      static clusterTileY = 16;
      /** Number of depth slices along the view direction. */
      static clusterTileZ = 32;
    }

    let ClusterBoundsSource_cs = (
      /* wgsl */
      `
  #include "GlobalUniform"

        struct ClusterBox{
            minPoint:vec4<f32>,
            maxPoint:vec4<f32>
        }

        struct ClustersUniform{
            clusterTileX:f32,
            clusterTileY:f32,
            clusterTileZ:f32,
            numLights:f32,
            maxNumLightsPerCluster:f32,
            near:f32,
            far:f32,
            screenWidth:f32,
            screenHeight:f32,
            clusterPix:f32
        }
     
        @group(0) @binding(1) var<uniform> clustersUniform : ClustersUniform;
        @group(0) @binding(2) var<storage,read_write> clusterBuffer : array<ClusterBox>;


        var<private> clusterTileX:f32 ;
        var<private> clusterTileY:f32 ;
        var<private> clusterTileZ:f32 ;
        fn convertNDCToView( v4:vec4<f32> ) -> vec4<f32> {
            var v = globalUniform.projMatInv * v4 ;
            v = v / v.w ;
            return v ;
        }

        fn ScreenToView(screen : vec4<f32>) -> vec4<f32> {
            let texCoord = screen.xy / vec2<f32>(clustersUniform.screenWidth, clustersUniform.screenHeight);
            let clip = vec4<f32>(vec2<f32>(texCoord.x, 1.0 - texCoord.y) * 2.0 - vec2<f32>(1.0, 1.0), screen.z, screen.w);
            return convertNDCToView(clip);
        }

        fn gridToIndex(i:vec3<u32>) -> u32{
            return i.z * u32(clusterTileX) * u32(clusterTileY) + i.y * u32(clusterTileX) + i.x ;
        }

        fn LineIntersectionToZPlane( eye:vec3<f32> , ndcPoint :vec3<f32> , z:f32) -> vec3<f32>
        {
            var normal = vec3<f32>(0.0, 0.0, 1.0);
            var dir = ndcPoint - eye;
            var t = (z - dot(normal, eye)) / dot(normal, dir);
            var result = eye + t * dir;
            return result;
        }

        @compute @workgroup_size(${ClusterConfig.clusterTileX},${ClusterConfig.clusterTileY},1)
        fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(local_invocation_id) local_invocation_id : vec3<u32> ){

            let i = local_invocation_id.x ;
            let j = local_invocation_id.y ;
            let k = workgroup_id.x ;

            clusterTileX = clustersUniform.clusterTileX;
            clusterTileY = clustersUniform.clusterTileY;
            clusterTileZ = clustersUniform.clusterTileZ;

            let clusterGrid = vec3<u32>(i,j,k);
            let tileIndex = gridToIndex(clusterGrid);
            let eyePos = vec3<f32>(0.0, 0.0, 0.0);

            let tx = clusterTileX;
            let ty = clusterTileY;
            let tz = clusterTileZ ;
            let near = clustersUniform.near ;
            let far = clustersUniform.far ;

            let titleSize = vec2<f32>( globalUniform.windowWidth / tx , globalUniform.windowHeight / ty ) ;

            var maxPointSs = vec4<f32>(vec2<f32>(f32(i) + 1.0, f32(j) + 1.0) * titleSize, 0.0, 1.0);
	        var minPointSs = vec4<f32>(vec2<f32>(f32(i) , f32(j)) * titleSize, 0.0, 1.0);

            var maxPointVs = ScreenToView(maxPointSs).xyz;
	        var minPointVs = ScreenToView(minPointSs).xyz;
 
            var tileNear = clustersUniform.near * pow(clustersUniform.far / clustersUniform.near, f32(k) / clustersUniform.clusterTileZ);
	        var tileFar = clustersUniform.near * pow(clustersUniform.far / clustersUniform.near, (f32(k) + 1.0) / clustersUniform.clusterTileZ);

            var minPointNear = LineIntersectionToZPlane(eyePos, minPointVs, tileNear);
            var minPointFar = LineIntersectionToZPlane(eyePos, minPointVs, tileFar);
            var maxPointNear = LineIntersectionToZPlane(eyePos, maxPointVs, tileNear);
            var maxPointFar = LineIntersectionToZPlane(eyePos, maxPointVs, tileFar);

            var minPointAABB = min(min(minPointNear, minPointFar), min(maxPointNear, maxPointFar));
            var maxPointAABB = max(max(minPointNear, minPointFar), max(maxPointNear, maxPointFar));

            var clusterBox : ClusterBox ;
            clusterBox.minPoint = vec4<f32>(minPointAABB,f32(tileIndex)) ;
            clusterBox.maxPoint = vec4<f32>(maxPointAABB,f32(tileIndex)) ;
            clusterBuffer[tileIndex] = clusterBox;
        }
`
    );

    let ClusterLighting_cs = (
      /*wgsl*/
      `
#include "GlobalUniform"

#include "LightData"

struct ClusterBox{
    min:vec4<f32>,
    max:vec4<f32>
}

struct LightIndex
{
    count:f32,
    start:f32,
    empty0:f32,
    empty1:f32,
};

struct ClustersUniform{
    clusterTileX:f32,
    clusterTileY:f32,
    clusterTileZ:f32,
    numLights:f32,
    maxNumLightsPerCluster:f32,
    near:f32,
    far:f32,
    screenWidth:f32,
    screenHeight:f32,
    clusterPix:f32, 
}

var<private> clusterTileX:f32 ;
var<private> clusterTileY:f32 ;
var<private> clusterTileZ:f32 ;

// @group(0) @binding(1) var<storage, read> models : Uniforms;
@group(0) @binding(1) var<uniform> clustersUniform : ClustersUniform;
@group(0) @binding(2) var<storage,read> clusterBuffer : array<ClusterBox>;
@group(0) @binding(3) var<storage,read> lightBuffer : array<LightData>; 
@group(0) @binding(4) var<storage,read_write> lightAssignBuffer : array<f32>;
@group(0) @binding(5) var<storage,read_write> assignTable : array<LightIndex>;

fn gridToIndex(i:vec3<u32>) -> u32{
    return i.z * u32(clusterTileX) * u32(clusterTileY) + i.y * u32(clusterTileX) + i.x ;
}

fn GetSqdisPointAABB( pos:vec3<f32>,  cluster:ClusterBox  ) -> f32
{
    var sqDistance = 0.0;
    for (var i = 0u; i < 3u; i+=1u)
    {
        var v = pos[i];
        if (v < cluster.min[i])
        {
            let diff = cluster.min[i] - v;
            sqDistance += diff * diff;
        }

        if (v > cluster.max[i])
        {
            let diff =  v - cluster.max[i];
            sqDistance += diff * diff;
        }
    }
    return sqDistance;
}

fn TestSphereAABB( box:ClusterBox, light:LightData ) -> bool
{
    let lightPos = light.position.xyz;
    var radius = light.range * 2.0 ;
    var spherePos = globalUniform.viewMat * vec4<f32>(lightPos.xyz, 1.0) ;
    spherePos = spherePos / spherePos.w ;
    let sqDistance = GetSqdisPointAABB(spherePos.xyz , box);
    return sqDistance <= (radius*radius);
}

@compute @workgroup_size(${ClusterConfig.clusterTileX},${ClusterConfig.clusterTileY},1)
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(local_invocation_id) local_invocation_id : vec3<u32> ){
    // cluster ID 
    let i = local_invocation_id.x ;
    let j = local_invocation_id.y ;
    let k = workgroup_id.x ;

    clusterTileX = clustersUniform.clusterTileX;
    clusterTileY = clustersUniform.clusterTileY;
    clusterTileZ = clustersUniform.clusterTileZ;

    var clusterId_3D = vec3<u32>(i,j,k);
    var clusterId_1D = gridToIndex(clusterId_3D);

    var box:ClusterBox = clusterBuffer[clusterId_1D];

    var startIndex = i32(clusterId_1D) * i32(clustersUniform.maxNumLightsPerCluster) ;
    var endIndex = startIndex;

    for(var lightID = 0 ; lightID < i32(clustersUniform.numLights) ; lightID+=1)
    {
        let li:LightData = lightBuffer[lightID];
        if(!TestSphereAABB(box, li)) {
            continue;
        }
        lightAssignBuffer[endIndex] = f32(lightID);
        endIndex++;
    }

    var idx: LightIndex;
    idx.count = f32(endIndex-startIndex);
    idx.start = f32(startIndex);
    idx.empty0 = f32(clusterId_1D);
    idx.empty1 = f32(clustersUniform.maxNumLightsPerCluster);
    assignTable[clusterId_1D] = idx;
}
`
    );

    class ComputeGPUBuffer extends GPUBufferBase {
      constructor(size, data) {
        super();
        this.bufferType = GPUBufferType.ComputeGPUBuffer;
        this.createBuffer(GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST, size, data, "ComputeGPUBuffer");
      }
    }

    class ClusterLightingBuffer {
      /** Per-cluster bounds (two vec4 per cluster). */
      clusterBuffer;
      /** Flat list of light indices assigned across all clusters. */
      lightAssignBuffer;
      /** Per-cluster (start, count) into {@link lightAssignBuffer}. */
      assignTableBuffer;
      /** Uniform block describing the cluster grid and screen/depth params. */
      clustersUniformBuffer;
      constructor(numClusters, maxNumLightsPerCluster) {
        this.clusterBuffer = new ComputeGPUBuffer(numClusters * /*two vec4*/
        2 * /*vec4*/
        4);
        this.clustersUniformBuffer = new UniformGPUBuffer(10);
        this.clustersUniformBuffer.visibility = GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
        this.lightAssignBuffer = new ComputeGPUBuffer(numClusters * maxNumLightsPerCluster);
        this.lightAssignBuffer.visibility = GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
        this.assignTableBuffer = new ComputeGPUBuffer(numClusters * 4);
        this.assignTableBuffer.visibility = GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
      }
      /** Upload the current grid, screen size, light count and near/far into the uniform buffer. */
      update(width, height, clusterPix, clusterTileX, clusterTileY, clusterTileZ, numLights, maxNumLightsPerCluster, near, far) {
        this.clustersUniformBuffer.setFloat("clusterTileX", clusterTileX);
        this.clustersUniformBuffer.setFloat("clusterTileY", clusterTileY);
        this.clustersUniformBuffer.setFloat("clusterTileZ", clusterTileZ);
        this.clustersUniformBuffer.setFloat("numLights", numLights);
        this.clustersUniformBuffer.setFloat("maxNumLightsPerCluster", maxNumLightsPerCluster);
        this.clustersUniformBuffer.setFloat("near", near);
        this.clustersUniformBuffer.setFloat("far", far);
        this.clustersUniformBuffer.setFloat("screenWidth", width);
        this.clustersUniformBuffer.setFloat("screenHeight", height);
        this.clustersUniformBuffer.setFloat("clusterPix", clusterPix);
        this.clustersUniformBuffer.apply();
      }
    }

    class RenderGraphPass extends CEventDispatcher {
      /** Material-side pass types consumed. Optional; defaults to none
       *  for pure compute / copy passes. */
      materialPasses = [];
      /** Runtime kill switch. `graph.disablePass(name)` flips this. A
       *  disabled pass is treated as if it weren't in the graph: it's
       *  filtered out before validation + topo sort, and skipped during
       *  execute. Disabling a producer whose output is read by another
       *  enabled pass makes the next `compile()` throw
       *  `UnresolvedResourceError`. */
      enabled = true;
      /** Which scene layers this pass consumes, as a bitmask. Default
       *  {@link VisibleLayer.All} reproduces the legacy "draw every
       *  collected node" behaviour. Custom passes (or custom
       *  {@link RendererJob}s wiring built-in passes) override this to
       *  restrict the pass to specific composition layers — combined
       *  with the active camera's `cullingMask` at execute time via
       *  bitwise AND, then matched against each node's `visibleLayer`:
       *
       *      (node.visibleLayer & pass.layerMask & camera.cullingMask) !== 0
       *
       *  Use {@link collectLayered} from inside `execute()` to fetch the
       *  filtered opaque/transparent lists; it threads `layerMask` and
       *  the camera mask through {@link EntityCollect.getLayerLists}. */
      layerMask = exports.VisibleLayer.All;
      /** Names this pass reads. Populated on the first
       *  `RenderGraph.compile()` that processes this pass, from the
       *  `b.read(...)` calls inside its `setup()`. Empty frozen array
       *  before compile. */
      reads;
      /** Names this pass writes (creator + mutator combined). Populated
       *  on the first `RenderGraph.compile()` from the `b.write(...)`
       *  calls inside `setup()`. Empty frozen array before compile. */
      writes;
      /** Subset of `writes` for which this pass was the creator (called
       *  `b.write(name, factory)`, not `b.write(name)`). The validator's
       *  single-creator rule operates on this set. */
      creates;
      /** Explicit ordering dependencies on other pass names, set either
       *  from `setup()` via `b.dependsOn(name)` or by direct assignment
       *  before the next compile. Each entry adds a topo-sort edge
       *  `<name> → this`, independent of any resource edge. Use for
       *  side-effect dependencies the graph can't see (indirect buffers,
       *  off-screen RTs consumed via materials, etc.).
       *
       *  Beyond the edge, an entry here also positions this pass in the
       *  compiled schedule: the effective scheduling key collapses to
       *  "just after the latest dep", so a late-added pass with explicit
       *  dependencies runs next to its dep instead of trailing at the
       *  end of the queue. See {@link topoSort} for the full rule. */
      dependencies;
      /** Allocate GPU resources, declare graph-level dependencies via
       *  `b.read` / `b.write`. Called from `RenderGraph.compile()` —
       *  setup is deferred from `add()` so `add()` call order doesn't
       *  constrain resource-dependency order. Forward references (reads
       *  to a resource a later-added pass creates) are resolved through
       *  a multi-round retry loop in `compile()`. */
      setup(_b) {
      }
      /** Optional teardown hook called from `graph.destroy()` — release
       *  orphan Object3Ds / view quads / device resources that the pass
       *  owns directly. */
      destroy() {
      }
      /**
       * Helper for subclasses: fetch opaque + transparent lists filtered
       * by this pass's {@link layerMask} and a camera's `cullingMask`.
       * Replaces the legacy
       * `EntityCollect.instance.getRenderNodes(view.scene, camera)`
       * call inside `execute()` — passes that don't override
       * `layerMask` get identical results because the default
       * `VisibleLayer.All` mask is a no-op intersection.
       *
       * Shadow / reflection / GI-probe / scene-capture passes that
       * render through a non-main camera should pass that camera
       * explicitly so its own `cullingMask` (rather than the view's
       * main camera) participates in the bitwise AND.
       */
      collectLayered(view, camera) {
        const cam = camera ?? view.camera;
        const camMask = cam?.cullingMask ?? exports.VisibleLayer.All;
        return EntityCollect.instance.getLayerLists(view.scene, cam, this.layerMask, camMask);
      }
    }

    const CLUSTER_LIGHTING_BUFFER = "_ClusterLightingBuffer";
    class ClusterLightingPass extends RenderGraphPass {
      name = "ClusterLightingPass";
      clusterLightingBuffer;
      maxNumLightsPerCluster = 64;
      clusterPix = 1;
      _generateCompute;
      _lightingCompute;
      _useCamera = null;
      _currentLightCount = 0;
      setup(b) {
        const view = b.view;
        const ctx = b.context3D;
        const numClusters = ClusterConfig.clusterTileX * ClusterConfig.clusterTileY * ClusterConfig.clusterTileZ;
        const size = ctx.presentationSize;
        const camera = view.camera;
        this.clusterLightingBuffer = new ClusterLightingBuffer(numClusters, this.maxNumLightsPerCluster);
        this.clusterLightingBuffer.update(
          size[0],
          size[1],
          this.clusterPix,
          ClusterConfig.clusterTileX,
          ClusterConfig.clusterTileY,
          ClusterConfig.clusterTileZ,
          0,
          this.maxNumLightsPerCluster,
          camera.near,
          camera.far
        );
        this._generateCompute = new ComputeShader(ClusterBoundsSource_cs);
        this._generateCompute.setUniformBuffer(`clustersUniform`, this.clusterLightingBuffer.clustersUniformBuffer);
        this._generateCompute.setStorageBuffer(`clusterBuffer`, this.clusterLightingBuffer.clusterBuffer);
        this._lightingCompute = new ComputeShader(ClusterLighting_cs);
        const lightBuffer = GlobalBindGroup.getLightEntries(view.scene);
        this._lightingCompute.setStorageBuffer(`models`, GlobalBindGroup.getModelMatrixBindGroup(ctx).matrixBufferDst);
        this._lightingCompute.setUniformBuffer(`clustersUniform`, this.clusterLightingBuffer.clustersUniformBuffer);
        this._lightingCompute.setStorageBuffer(`clusterBuffer`, this.clusterLightingBuffer.clusterBuffer);
        this._lightingCompute.setStorageBuffer(`lightBuffer`, lightBuffer.storageGPUBuffer);
        this._lightingCompute.setStorageBuffer(`lightAssignBuffer`, this.clusterLightingBuffer.lightAssignBuffer);
        this._lightingCompute.setStorageBuffer(`assignTable`, this.clusterLightingBuffer.assignTableBuffer);
        b.write(CLUSTER_LIGHTING_BUFFER, () => this.clusterLightingBuffer);
      }
      execute(ctx) {
        const view = ctx.view;
        const lights = EntityCollect.instance.getLights(view.scene);
        if (this._useCamera !== view.camera) {
          this._useCamera = view.camera;
          const camGroup = GlobalBindGroup.getCameraGroup(view.camera);
          this._generateCompute.setUniformBuffer(`globalUniform`, camGroup.uniformGPUBuffer);
          this._lightingCompute.setUniformBuffer(`globalUniform`, camGroup.uniformGPUBuffer);
        }
        if (this._currentLightCount !== lights.length) {
          this._currentLightCount = lights.length;
          this.clusterLightingBuffer.clustersUniformBuffer.setFloat("numLights", lights.length);
          this.clusterLightingBuffer.clustersUniformBuffer.apply();
          this._generateCompute.workerSizeX = ClusterConfig.clusterTileZ;
          this._lightingCompute.workerSizeX = ClusterConfig.clusterTileZ;
        }
        const size = view.engine3D.context3D.presentationSize;
        this.clusterLightingBuffer.update(
          size[0],
          size[1],
          this.clusterPix,
          ClusterConfig.clusterTileX,
          ClusterConfig.clusterTileY,
          ClusterConfig.clusterTileZ,
          lights.length,
          this.maxNumLightsPerCluster,
          view.camera.near,
          view.camera.far
        );
        const gpu = view.engine3D.context3D.gpuContext;
        const command = gpu.beginCommandEncoder();
        gpu.computeCommand(command, [this._generateCompute, this._lightingCompute]);
        gpu.endCommandEncoder(command);
      }
    }

    function renderGroupBundleKey(group, passType, stateVersion) {
      return `${passType}|${stateVersion}|${group.nodeVersion}`;
    }

    function dependOnIfRegistered(b, ...names) {
      for (const n of names) {
        if (b.graph.getPass(n)) b.dependsOn(n);
      }
    }
    function buildBundles(view, camera, passType, passState, batch, cluster, isShadowCamera = false) {
      if (!batch) return [];
      const gpu = view.engine3D.context3D.gpuContext;
      const stateVersion = passState.stateVersion;
      const bundles = [];
      batch.renderGroup.forEach((v) => {
        const cacheKey = renderGroupBundleKey(v, passType, stateVersion);
        if (v.bundleMap.has(cacheKey)) {
          bundles.push(v.bundleMap.get(cacheKey));
          return;
        }
        const encoder = gpu.recordBundleEncoder(passState.renderBundleEncoderDescriptor);
        if (isShadowCamera) {
          GlobalBindGroup.updateCameraGroup(camera);
        }
        gpu.bindCamera(encoder, camera);
        if (v.renderNodes && v.renderNodes.length > 0) {
          gpu.bindGeometryBuffer(encoder, v.renderNodes[0].geometry);
          for (const node of v.renderNodes) {
            if (!node.transform.enable) continue;
            node.recordRenderPass2(view, passType, passState, cluster, encoder);
          }
        }
        const bundle = encoder.finish();
        v.bundleMap.set(cacheKey, bundle);
        bundles.push(bundle);
      });
      return bundles;
    }
    function buildOpBundles(view, camera, passType, passState, cluster, isShadowCamera = false) {
      const batch = EntityCollect.instance.getOpRenderGroup(view.scene);
      return buildBundles(view, camera, passType, passState, batch, cluster, isShadowCamera);
    }
    function buildTrBundles(view, camera, passType, passState, cluster, isShadowCamera = false) {
      const batch = EntityCollect.instance.getTrRenderGroup(view.scene);
      return buildBundles(view, camera, passType, passState, batch, cluster, isShadowCamera);
    }
    function preInitPassPipelines(view, passType, passState, cluster, predicate) {
      const renderShaderCollect = EntityCollect.instance.getRenderShaderCollect(view);
      if (!renderShaderCollect) return;
      for (const renderList of renderShaderCollect) {
        const nodeMap = renderList[1];
        for (const [, node] of nodeMap) {
          if (predicate && !predicate(node)) continue;
          if (!node.isDestroyed && node.preInit(passType)) {
            node.nodeUpdate(view, passType, passState, cluster ?? null);
            break;
          }
        }
      }
    }

    class RendererPassState {
      label = "";
      customSize = false;
      zPreTexture = null;
      depthTexture = null;
      renderTargetTextures;
      outColor = -1;
      renderTargets;
      rtTextureDescriptors;
      irradianceBuffer;
      multisample = 0;
      multiTexture;
      /** Per-color-attachment MSAA side-band textures, populated by
       *  {@link WebGPUDescriptorCreator} when `multisample > 0` and the
       *  pass has multiple color attachments. Index matches `renderTargets`.
       *  Unused entries stay undefined so begin-pass can distinguish. */
      multiTextures;
      depthViewIndex = 0;
      depthCleanValue = 0;
      isOutTarget = true;
      camera3D;
      rtFrame;
      renderPassDescriptor;
      renderBundleEncoderDescriptor;
      depthLoadOp;
      /** Monotonically increasing counter. Bumped by
       *  WebGPUDescriptorCreator whenever the owning pass descriptor
       *  or bundle descriptor is built / rebuilt. Consumers (render
       *  bundle caches) use it as part of the composite cache key so
       *  bundles from a stale state are not reused. */
      stateVersion = 0;
      getLastRenderTexture(ctx) {
        if (this.renderTargets) {
          return this.renderTargets.length > 0 ? this.renderTargets[0] : Engine3D.resFor(ctx).redTexture;
        } else {
          return Engine3D.resFor(ctx).redTexture;
        }
      }
    }

    class WebGPUDescriptorCreator {
      /** Per-Context3D cache of RTFrame→RendererPassState so descriptors built
       *  against one device are not reused for another. */
      static _perContextPassState = /* @__PURE__ */ new WeakMap();
      static _passStateMap(ctx) {
        let m = this._perContextPassState.get(ctx);
        if (!m) {
          m = /* @__PURE__ */ new Map();
          this._perContextPassState.set(ctx, m);
        }
        return m;
      }
      static createRendererPassState(ctx, rtFrame, loadOp = null) {
        const passMap = WebGPUDescriptorCreator._passStateMap(ctx);
        let rps = passMap.get(rtFrame);
        if (!rps) {
          rps = new RendererPassState();
          rps.label = rtFrame.label;
          rps.customSize = rtFrame.customSize;
          rps.rtFrame = rtFrame;
          rps.zPreTexture = rtFrame.zPreTexture;
          rps.depthTexture = rtFrame.depthTexture;
          rps.depthViewIndex = rtFrame.depthViewIndex;
          rps.isOutTarget = rtFrame.isOutTarget;
          rps.depthCleanValue = rtFrame.depthCleanValue;
          rps.depthLoadOp = rtFrame.depthLoadOp;
          rps.stateVersion = 1;
          rps.multisample = rtFrame.sampleCount | 0;
          passMap.set(rtFrame, rps);
        }
        if (rtFrame && rtFrame.renderTargets.length > 0) {
          if (rps.renderTargets !== rtFrame.renderTargets) {
            rps.stateVersion++;
          }
          rps.renderTargets = rtFrame.renderTargets;
          rps.rtTextureDescriptors = rtFrame.rtDescriptors;
          rps.renderPassDescriptor = WebGPUDescriptorCreator.getRenderPassDescriptor(ctx, rps);
          if (rps.renderPassDescriptor.depthStencilAttachment) {
            rps.renderPassDescriptor.depthStencilAttachment.depthLoadOp = rtFrame.depthLoadOp;
          }
          rps.depthLoadOp = rtFrame.depthLoadOp;
          rps.renderBundleEncoderDescriptor = WebGPUDescriptorCreator.getRenderBundleDescriptor(ctx, rps);
          rps.renderTargetTextures = [];
          for (let i = 0; i < rtFrame.renderTargets.length; i++) {
            const element = rtFrame.renderTargets[i];
            rps.renderTargetTextures[i] = {
              format: element.format
            };
            if (element.name.indexOf(RTResourceConfig.colorBufferTex_NAME) != -1) {
              rps.outColor = i;
            }
          }
          if (rps.multisample > 0) {
            rps.multiTextures = [];
            for (let i = 0; i < rtFrame.renderTargets.length; i++) {
              const rt = rtFrame.renderTargets[i];
              rps.multiTextures[i] = ctx.device.createTexture({
                label: `${rps.label || "MSAA"}_ms_${i}`,
                size: { width: rt.width, height: rt.height },
                sampleCount: rps.multisample,
                format: rt.format,
                usage: GPUTextureUsage.RENDER_ATTACHMENT
              });
            }
          }
        } else {
          rps.renderPassDescriptor = WebGPUDescriptorCreator.getRenderPassDescriptor(ctx, rps, loadOp);
          rps.renderBundleEncoderDescriptor = WebGPUDescriptorCreator.getRenderBundleDescriptor(ctx, rps);
          if (rtFrame && rtFrame.depthTexture) {
            rps.renderTargetTextures = [];
            rps.outColor = -1;
          } else {
            rps.renderTargetTextures = [
              {
                format: ctx.presentationFormat
              }
            ];
            rps.outColor = 0;
          }
        }
        return rps;
      }
      /**
       * Get RenderPass Descriptor
       * Use AttachMentTextures , Texture Format Is Key
       * @param attachMentTextures
       * @param useDepth
       * @param cleanColor
       * @returns
       */
      // static getRenderPassDescriptor(attachMentTextures: VirtualTexture[], renderPassState:RenderPassState): any {
      static getRenderPassDescriptor(ctx, renderPassState, loadOp = null) {
        if (renderPassState.renderPassDescriptor) return renderPassState.renderPassDescriptor;
        ctx.presentationSize;
        let attachMentTexture = [];
        if (renderPassState.renderTargets && renderPassState.renderTargets.length > 0) {
          [renderPassState.renderTargets[0].width, renderPassState.renderTargets[0].height];
          for (let i = 0; i < renderPassState.renderTargets.length; i++) {
            const texture = renderPassState.renderTargets[i];
            const rtDesc = renderPassState.rtTextureDescriptors[i];
            attachMentTexture.push({
              view: texture.getGPUView(),
              resolveTarget: void 0,
              loadOp: rtDesc.loadOp,
              clearValue: rtDesc.clearValue,
              storeOp: rtDesc.storeOp
            });
          }
        } else {
          if (!renderPassState.customSize) {
            let clearValue = ctx.canvasConfig && ctx.canvasConfig.alpha ? [1, 1, 1, 0] : [0, 0, 0, 1];
            if (renderPassState.isOutTarget == true) {
              attachMentTexture.push({
                view: void 0,
                resolveTarget: void 0,
                loadOp: ctx.canvasConfig && ctx.canvasConfig.alpha || loadOp != null ? `load` : `clear`,
                clearValue,
                storeOp: "store"
              });
            }
          }
        }
        let renderPassDescriptor = null;
        if (renderPassState.depthTexture || renderPassState.zPreTexture) {
          if (renderPassState.zPreTexture) {
            renderPassState.depthTexture = renderPassState.zPreTexture;
          }
          const hasStencil = typeof renderPassState.depthTexture.format === "string" && renderPassState.depthTexture.format.includes("stencil");
          const dsAttach = {
            view: renderPassState.depthTexture.getGPUView(),
            depthLoadOp: renderPassState.zPreTexture ? `load` : renderPassState.depthLoadOp,
            depthClearValue: renderPassState.zPreTexture ? 1 : renderPassState.depthCleanValue,
            depthStoreOp: "store"
          };
          if (hasStencil) {
            dsAttach.stencilLoadOp = renderPassState.zPreTexture ? "load" : "clear";
            dsAttach.stencilClearValue = 0;
            dsAttach.stencilStoreOp = "store";
          }
          renderPassDescriptor = {
            label: `${renderPassState.label} renderPassDescriptor zPreTexture${renderPassState.zPreTexture ? `load` : `clear`}`,
            colorAttachments: attachMentTexture,
            depthStencilAttachment: dsAttach
          };
        } else {
          renderPassDescriptor = {
            colorAttachments: attachMentTexture,
            label: "renderPassDescriptor not writeDepth"
          };
        }
        renderPassState.renderPassDescriptor = renderPassDescriptor;
        return renderPassDescriptor;
      }
      /**
       * Get RenderPass Descriptor
       * Use AttachMentTextures , Texture Format Is Key
       * @param attachMentTextures
       * @param useDepth
       * @param cleanColor
       * @returns
       */
      static getRenderBundleDescriptor(ctx, renderPassState) {
        if (renderPassState.renderBundleEncoderDescriptor) return renderPassState.renderBundleEncoderDescriptor;
        ctx.presentationSize;
        let attachMentTexture = [];
        if (renderPassState.renderTargets && renderPassState.renderTargets.length > 0) {
          [renderPassState.renderTargets[0].width, renderPassState.renderTargets[0].height];
          for (let i = 0; i < renderPassState.renderTargets.length; i++) {
            const renderTarget = renderPassState.renderTargets[i];
            attachMentTexture.push(renderTarget.format);
          }
        }
        let renderPassDescriptor = null;
        if (renderPassState.depthTexture) {
          renderPassDescriptor = {
            colorFormats: attachMentTexture,
            depthStencilFormat: renderPassState.depthTexture.format
          };
        } else {
          renderPassDescriptor = {
            colorFormats: attachMentTexture
          };
        }
        renderPassState.renderBundleEncoderDescriptor = renderPassDescriptor;
        return renderPassState.renderBundleEncoderDescriptor;
      }
    }

    class RTDescriptor {
      /** Store operation applied at the end of the render pass. */
      storeOp = "store";
      /** Load operation applied at the start of the render pass. */
      loadOp = `clear`;
      /** Clear color used when the load operation is `clear`. */
      clearValue = [0, 0, 0, 0];
    }

    class RTFrame {
      /** Optional debug label for this frame. */
      label;
      /** When true the attachments are a fixed custom size rather than tracking the canvas. */
      customSize = false;
      /** The color attachments rendered into by this frame. */
      renderTargets;
      /** Per-attachment load/store/clear descriptors, parallel to {@link renderTargets}. */
      rtDescriptors;
      /** Optional z-prepass depth texture sampled by this frame. */
      zPreTexture;
      /** The depth (or depth+stencil) attachment for this frame. */
      depthTexture;
      /** Array-layer / face index of the depth view to attach. */
      depthViewIndex = 0;
      /** Clear value used when the depth load op is `clear`. */
      depthCleanValue = 1;
      /** Load op for the depth attachment (`clear` by default). */
      depthLoadOp = `clear`;
      /** Whether this frame writes the final output target (vs. an intermediate). */
      isOutTarget = true;
      /** MSAA sample count — 0 disables MSAA (default). When non-zero,
       *  {@link WebGPUDescriptorCreator} allocates side-band multisample
       *  textures and flags the pass state so pipelines compile with the
       *  matching sample count. */
      sampleCount = 0;
      constructor(attachments, rtDescriptors, depthTexture, zPreTexture, isOutTarget = true) {
        this.renderTargets = attachments;
        this.rtDescriptors = rtDescriptors;
        this.depthTexture = depthTexture;
        this.zPreTexture = zPreTexture;
        this.isOutTarget = isOutTarget;
      }
      /** Copy this frame's attachments, descriptors and depth/z textures into `rtFrame`. */
      clone2Frame(rtFrame) {
        rtFrame.renderTargets.push(...this.renderTargets.concat());
        for (let i = 0; i < this.rtDescriptors.length; i++) {
          const des = this.rtDescriptors[i];
          let rtDes = new RTDescriptor();
          rtDes.loadOp = des.loadOp;
          rtDes.storeOp = des.storeOp;
          rtDes.clearValue = des.clearValue;
          rtFrame.rtDescriptors.push(rtDes);
        }
        rtFrame.depthTexture = this.depthTexture;
        rtFrame.zPreTexture = this.zPreTexture;
        rtFrame.customSize = this.customSize;
      }
      /** Return a new RTFrame copied from this one via {@link clone2Frame}. */
      clone() {
        let rtFrame = new RTFrame([], []);
        this.clone2Frame(rtFrame);
        return rtFrame;
      }
    }

    class GBufferFrame extends RTFrame {
      /** Shared key for the main color-pass G-buffer. */
      static colorPass_GBuffer = "ColorPassGBuffer";
      /** Shared key for the reflection-probe G-buffer. */
      static reflections_GBuffer = "reflections_GBuffer";
      /** Cache of G-buffers for the most recently queried context (see {@link getGBufferFrame}). */
      static gBufferMap = /* @__PURE__ */ new Map();
      static _perContext = /* @__PURE__ */ new WeakMap();
      static _mapFor(ctx) {
        let m = GBufferFrame._perContext.get(ctx);
        if (!m) {
          m = /* @__PURE__ */ new Map();
          GBufferFrame._perContext.set(ctx, m);
        }
        return m;
      }
      // public static bufferTexture: boolean = false;
      _colorBufferTex;
      _compressGBufferTex;
      constructor() {
        super([], []);
      }
      /**
       * Allocate this G-buffer's attachments and depth texture. Optionally
       * creates the color attachment (`outColor`), always creates the
       * compressed G-buffer attachment, and creates a depth (or
       * depth+stencil) texture unless `depthTexture` is supplied. `sampleCount`
       * is captured on the frame so the render pass state can pick up the MSAA
       * sample count without re-reading the engine setting.
       */
      createGBuffer(ctx, key, rtWidth, rtHeight, _autoResize = true, outColor = true, depthTexture, sampleCount = 0) {
        let attachments = this.renderTargets;
        let reDescriptors = this.rtDescriptors;
        this.sampleCount = sampleCount;
        if (outColor) {
          let colorDec = new RTDescriptor();
          colorDec.loadOp = "clear";
          this._colorBufferTex = RTResourceMap.createRTTexture(ctx, key + RTResourceConfig.colorBufferTex_NAME, rtWidth, rtHeight, GPUTextureFormat.rgba16float, true);
          attachments.push(this._colorBufferTex);
          reDescriptors.push(colorDec);
        }
        this._compressGBufferTex = new RenderTexture(rtWidth, rtHeight, GPUTextureFormat.rgba32float, false, void 0, 1, 0, true, true, ctx);
        attachments.push(this._compressGBufferTex);
        if (depthTexture) {
          this.depthTexture = depthTexture;
        } else {
          const depthFormat = ctx.engine?.setting.render.useStencil ? GPUTextureFormat.depth24plus_stencil8 : GPUTextureFormat.depth32float;
          this.depthTexture = new RenderTexture(rtWidth, rtHeight, depthFormat, false, void 0, 1, sampleCount, true, true, ctx);
          this.depthTexture.name = key + `_depthTexture`;
        }
        let compressGBufferRTDes;
        compressGBufferRTDes = new RTDescriptor();
        reDescriptors.push(compressGBufferRTDes);
      }
      /** The world-position attachment (render target index 1). */
      getPositionMap() {
        return this.renderTargets[1];
      }
      /** The world-normal attachment (render target index 2). */
      getNormalMap() {
        return this.renderTargets[2];
      }
      /** The scene color attachment, or undefined when created with `outColor=false`. */
      getColorTexture() {
        return this._colorBufferTex;
      }
      /** The packed/compressed G-buffer attachment. */
      getCompressGBufferTexture() {
        return this._compressGBufferTex;
      }
      /**
       * @internal
       */
      static getGBufferFrame(key, ctx, fixedWidth = 0, fixedHeight = 0, outColor = true, depthTexture, sampleCount = 0) {
        let map = GBufferFrame._mapFor(ctx);
        GBufferFrame.gBufferMap = map;
        let gBuffer;
        if (!map.has(key)) {
          gBuffer = new GBufferFrame();
          let size = ctx.presentationSize;
          gBuffer.createGBuffer(
            ctx,
            key,
            fixedWidth == 0 ? size[0] : fixedWidth,
            fixedHeight == 0 ? size[1] : fixedHeight,
            fixedWidth != 0 && fixedHeight != 0,
            outColor,
            depthTexture,
            sampleCount
          );
          map.set(key, gBuffer);
        } else {
          gBuffer = map.get(key);
        }
        return gBuffer;
      }
      /** Create a new GBufferFrame sharing this frame's attachment/descriptor setup. */
      clone() {
        let gBufferFrame = new GBufferFrame();
        this.clone2Frame(gBufferFrame);
        return gBufferFrame;
      }
    }

    class RenderContext {
      /** The command encoder currently open for this frame. */
      command;
      /** The render-pass encoder currently open for this frame. */
      encoder;
      /** The per-context GPU helper this render context issues through. */
      gpu;
      ctx;
      rendererPassStates;
      rtFrame;
      constructor(ctx, rtFrame) {
        this.ctx = ctx;
        this.rtFrame = rtFrame;
        this.rendererPassStates = [];
      }
      /** Reset the accumulated pass states and the GPU bind cache for a new frame. */
      clean() {
        this.rendererPassStates.length = 0;
        this.gpu.cleanCache();
      }
      /**
       * Push a renderer pass state for the current frame and return it.
       * When earlier states already exist this is a continuation pass that
       * loads (rather than clears) prior attachment contents; otherwise it
       * applies the given color/depth load ops to the frame's first pass.
       */
      beginContinueRendererPassState(color_loadOp = "load", depth_loadOp = "load") {
        if (this.rendererPassStates.length > 0) {
          let splitRtFrame = this.rtFrame.clone();
          for (const iterator of splitRtFrame.rtDescriptors) {
            iterator.loadOp = `load`;
          }
          splitRtFrame.depthLoadOp = depth_loadOp;
          let splitRendererPassState = WebGPUDescriptorCreator.createRendererPassState(this.ctx, splitRtFrame, color_loadOp);
          this.rendererPassStates.push(splitRendererPassState);
          return splitRendererPassState;
        } else {
          this.rtFrame.depthLoadOp = depth_loadOp;
          let splitRendererPassState = WebGPUDescriptorCreator.createRendererPassState(this.ctx, this.rtFrame, color_loadOp);
          if (splitRendererPassState.renderPassDescriptor?.colorAttachments?.[0]) {
            splitRendererPassState.renderPassDescriptor.colorAttachments[0].loadOp = color_loadOp;
          }
          this.rendererPassStates.push(splitRendererPassState);
          return splitRendererPassState;
        }
      }
      /** The most recently pushed renderer pass state (the active one). */
      get rendererPassState() {
        return this.rendererPassStates[this.rendererPassStates.length - 1];
      }
      /** Begin the opaque pass: clear color + depth, then open a fresh command and encoder. */
      beginOpaqueRenderPass() {
        this.beginContinueRendererPassState("clear", "clear");
        this.begineNewCommand();
        this.beginNewEncoder();
      }
      /** Begin a transparent pass: load color + depth (continuation), then open a fresh command and encoder. */
      beginTransparentRenderPass() {
        this.beginContinueRendererPassState("load", "load");
        this.begineNewCommand();
        this.beginNewEncoder();
      }
      /** Begin a special-purpose continuation pass: load color + depth, then open a fresh command and encoder. */
      specialtRenderPass() {
        this.beginContinueRendererPassState("load", "load");
        this.begineNewCommand();
        this.beginNewEncoder();
      }
      /** End the current render pass: close the encoder then submit the command. */
      endRenderPass() {
        this.endEncoder();
        this.endCommand();
      }
      /** Open a new command encoder for this frame. */
      begineNewCommand() {
        this.command = this.gpu.beginCommandEncoder();
        return this.command;
      }
      /** Submit and clear the current command encoder. */
      endCommand() {
        this.gpu.endCommandEncoder(this.command);
        this.command = null;
      }
      /** Begin a render-pass encoder for the active pass state on the open command. */
      beginNewEncoder() {
        this.encoder = this.gpu.beginRenderPass(this.command, this.rendererPassState);
        return this.encoder;
      }
      /** End and clear the current render-pass encoder. */
      endEncoder() {
        this.gpu.endPass(this.encoder);
        this.encoder = null;
      }
    }

    const MAIN_DEPTH_TEXTURE = "_MainDepthTexture";
    const Z_BUFFER_TEXTURE = "_ZBufferTexture";
    const PRE_DEPTH_RT = "_PreDepthRT";
    class PreDepthPass extends RenderGraphPass {
      name = "PreDepthPass";
      zBufferTexture;
      _passType = PassType.DEPTH;
      _rtFrame;
      _target;
      /** Live {@link RendererPassState} for the in-flight pass — set on
       *  every {@link execute} between begin and end. */
      _passState = null;
      get rendererPassState() {
        return this._passState;
      }
      setup(b) {
        const ctx = b.context3D;
        const [w, h] = ctx.presentationSize;
        this.zBufferTexture = RTResourceMap.createRTTexture(
          ctx,
          RTResourceConfig.zBufferTexture_NAME,
          Math.floor(w),
          Math.floor(h),
          GPUTextureFormat.rgba16float,
          false
        );
        const depthTex = RTResourceMap.createRTTexture(
          ctx,
          RTResourceConfig.zPreDepthTexture_NAME,
          Math.floor(w),
          Math.floor(h),
          GPUTextureFormat.depth32float,
          false
        );
        const clearDesc = new RTDescriptor();
        clearDesc.clearValue = [0, 0, 0, 0];
        clearDesc.loadOp = "clear";
        this._rtFrame = new RTFrame([], [], depthTex, null, false);
        this._rtFrame.label = "PreDepth";
        b.adoptRenderTarget(PRE_DEPTH_RT, this._rtFrame, { label: "PreDepth" });
        this._target = b.useRenderTarget(PRE_DEPTH_RT);
        b.write(MAIN_DEPTH_TEXTURE, () => this._rtFrame.depthTexture);
        b.write(Z_BUFFER_TEXTURE, () => this.zBufferTexture);
      }
      execute(ctx) {
        const view = ctx.view;
        const occlusion = ctx.occlusion;
        const camera = view.camera;
        ProfilerUtil.start("DepthPass Renderer");
        const opened = this._target.beginPass(ctx, {});
        const { encoder, passState } = opened;
        this._passState = passState;
        passState.camera3D = camera;
        const layered = this.collectLayered(view);
        const opBundles = buildOpBundles(view, camera, this._passType, passState);
        if (opBundles.length > 0) encoder.executeBundles(opBundles);
        preInitPassPipelines(view, this._passType, passState);
        this._drawOpaque(view, encoder, layered.opaque, occlusion, passState);
        this._target.endPass(ctx, opened);
        this._passState = null;
        ProfilerUtil.end("DepthPass Renderer");
      }
      _drawOpaque(view, encoder, nodes, _occlusion, passState) {
        view.engine3D.context3D.gpuContext.bindCamera(encoder, view.camera);
        const render = view.engine3D.setting.render;
        const max = Math.min(nodes.length, render.drawOpMax);
        for (let i = render.drawOpMin; i < max; ++i) {
          const node = nodes[i];
          if (!node.transform.enable) continue;
          if (!node.enable) continue;
          if (node.isDestroyed) continue;
          if (!node.preInit(this._passType)) {
            node.nodeUpdate(view, this._passType, passState);
          }
          node.renderPass2(view, this._passType, passState, void 0, encoder);
        }
      }
    }

    function drawNodesEncoder(view, encoder, passState, nodes, cluster, options = {}) {
      const passType = options.passType ?? PassType.COLOR;
      const oitFilter = options.oitFilter ?? null;
      const transmissionFilter = options.transmissionFilter ?? null;
      preInitPassPipelines(view, passType, passState, cluster);
      const render = view.engine3D.setting.render;
      const max = Math.min(nodes.length, render.drawOpMax);
      for (let i = render.drawOpMin; i < max; ++i) {
        const node = nodes[i];
        if (!node.transform.enable) continue;
        if (!node.enable) continue;
        if (node.isDestroyed) continue;
        if (oitFilter !== null) {
          const mat = node.materials?.[0];
          if (oitFilter === "sorted" && mat?.oitMode === "weighted") continue;
          if (oitFilter === "weighted" && mat?.oitMode !== "weighted") continue;
        }
        if (transmissionFilter !== null) {
          const mat = node.materials?.[0];
          const hasTransmission = typeof mat?.transmissionFactor === "number" && mat.transmissionFactor > 0;
          if (transmissionFilter === "exclude" && hasTransmission) continue;
          if (transmissionFilter === "only" && !hasTransmission) continue;
        }
        if (!node.preInit(passType)) {
          node.nodeUpdate(view, passType, passState, cluster);
        }
        node.renderPass2(view, passType, passState, cluster, encoder, false);
      }
    }
    const TRANSPARENT_DRAW_CTX = "_TransparentDrawContext";
    function drawNodes(view, renderContext, passState, nodes, cluster, options = {}) {
      const passType = options.passType ?? PassType.COLOR;
      const oitFilter = options.oitFilter ?? null;
      const transmissionFilter = options.transmissionFilter ?? null;
      preInitPassPipelines(view, passType, passState, cluster);
      const render = view.engine3D.setting.render;
      const max = Math.min(nodes.length, render.drawOpMax);
      for (let i = render.drawOpMin; i < max; ++i) {
        const node = nodes[i];
        if (!node.transform.enable) continue;
        if (!node.enable) continue;
        if (node.isDestroyed) continue;
        if (oitFilter !== null) {
          const mat = node.materials?.[0];
          if (oitFilter === "sorted" && mat?.oitMode === "weighted") continue;
          if (oitFilter === "weighted" && mat?.oitMode !== "weighted") continue;
        }
        if (transmissionFilter !== null) {
          const mat = node.materials?.[0];
          const hasTransmission = typeof mat?.transmissionFactor === "number" && mat.transmissionFactor > 0;
          if (transmissionFilter === "exclude" && hasTransmission) continue;
          if (transmissionFilter === "only" && !hasTransmission) continue;
        }
        if (!node.preInit(passType)) {
          node.nodeUpdate(view, passType, passState, cluster);
        }
        node.renderPass(view, passType, renderContext);
      }
    }
    function drawTransmissionContinuation(view, cluster, state, opaqueList) {
      const gpu = view.engine3D.context3D.gpuContext;
      state.renderContext.gpu = gpu;
      const camera = view.camera;
      GlobalBindGroup.updateCameraGroup(camera);
      state.rendererPassState.camera3D = camera;
      if (!opaqueList || opaqueList.length === 0) return;
      state.renderContext.beginTransparentRenderPass();
      const encoder = state.renderContext.encoder;
      gpu.bindCamera(encoder, camera);
      drawNodes(
        view,
        state.renderContext,
        state.rendererPassState,
        opaqueList,
        cluster,
        { transmissionFilter: "only" }
      );
      state.renderContext.endRenderPass();
    }
    function drawSortedTransparent(view, cluster, state, filter, transparentList) {
      const gpu = view.engine3D.context3D.gpuContext;
      state.renderContext.gpu = gpu;
      const camera = view.camera;
      GlobalBindGroup.updateCameraGroup(camera);
      state.rendererPassState.camera3D = camera;
      state.renderContext.beginTransparentRenderPass();
      const encoder = state.renderContext.encoder;
      const trBundles = filter === "all" ? buildTrBundles(view, camera, PassType.COLOR, state.rendererPassState, cluster) : [];
      if (trBundles.length > 0) {
        encoder.executeBundles(trBundles);
      }
      gpu.bindCamera(encoder, camera);
      if (transparentList && transparentList.length > 0) {
        drawNodes(
          view,
          state.renderContext,
          state.rendererPassState,
          transparentList,
          cluster,
          { oitFilter: filter === "all" ? null : "sorted" }
        );
      }
      const graphics = EntityCollect.instance.getGraphicList();
      for (const g of graphics) {
        g.nodeUpdate(view, PassType.COLOR, state.splitRendererPassState, cluster);
        g.renderPass2(view, PassType.COLOR, state.splitRendererPassState, cluster, encoder);
      }
      state.renderContext.endRenderPass();
    }

    const MAIN_COLOR_RT = "_MainColorRT";
    class GBufferResourcePass extends RenderGraphPass {
      name = "GBufferResourcePass";
      rendererPassState;
      splitRendererPassState;
      renderContext;
      /** Typed RT handle wrapping the shared {@link GBufferFrame}. Adopt
       *  mode — owns no textures. Consumers reach it through the pool
       *  via `b.useRenderTarget(MAIN_COLOR_RT)`. */
      mainColorRT;
      _ctx;
      setup(b) {
        this._ctx = b.context3D;
        const rtFrame = this._allocateRtFrame(b);
        this.mainColorRT = b.adoptRenderTarget(MAIN_COLOR_RT, rtFrame, { label: "MainColor" });
        this._buildRenderStates(b, rtFrame);
        this._publish(b);
      }
      _allocateRtFrame(b) {
        const view = b.view;
        const ctx = b.context3D;
        const setting = view.engine3D.setting;
        const rawMsaa = setting.render.msaa | 0;
        let msaa = rawMsaa;
        if (msaa !== 0 && msaa !== 2 && msaa !== 4 && msaa !== 8) {
          console.warn(`[transparency] engine.setting.render.msaa = ${rawMsaa} is not a supported sample count. Valid values: 0 | 2 | 4 | 8. Falling back to 0 (MSAA disabled).`);
          msaa = 0;
        }
        if (msaa > 0 && setting.render.useCompressGBuffer) {
          console.warn(`[transparency] msaa=${msaa} with useCompressGBuffer=true. The rgba32float g-buffer cannot be MSAA-resolved; post-effects that read it (SSR, SSAO, GTAO, GodRay, GlobalFog, DepthOfField, TAA) will see undefined contents. Either disable MSAA or disable useCompressGBuffer.`);
        }
        const rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, ctx, 0, 0, true, void 0, msaa);
        if (setting.render.zPrePass) {
          b.read(MAIN_DEPTH_TEXTURE);
          rtFrame.zPreTexture = b.graph.pool.get(MAIN_DEPTH_TEXTURE);
        }
        return rtFrame;
      }
      _buildRenderStates(b, rtFrame) {
        const ctx = b.context3D;
        this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, rtFrame);
        const splitRtFrame = rtFrame.clone();
        splitRtFrame.depthLoadOp = "load";
        for (const desc of splitRtFrame.rtDescriptors) desc.loadOp = "load";
        this.splitRendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, splitRtFrame);
        this.renderContext = new RenderContext(ctx, rtFrame);
      }
      _publish(b) {
        b.write(
          COLOR_BUFFER,
          () => GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._ctx).getColorTexture()
        );
        b.write(
          NORMAL_BUFFER,
          () => GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._ctx).getCompressGBufferTexture()
        );
        b.write(TRANSPARENT_DRAW_CTX, () => ({
          rendererPassState: this.rendererPassState,
          splitRendererPassState: this.splitRendererPassState,
          renderContext: this.renderContext
        }));
      }
      execute(_ctx) {
      }
    }

    class Depth2DTextureArray extends Texture {
      /**
       * @constructor
       * @width texture width (pixel)
       * @width texture height (pixel)
       * @width texture format, default value is depth32float
       */
      constructor(width, height, format = GPUTextureFormat.depth32float, numberLayer = 4, ctx) {
        super(width, height, numberLayer);
        this.format = format;
        this.mipmapCount = 1;
        this._ensureBound(ctx);
        this.init();
      }
      internalCreateBindingLayoutDesc() {
        this.textureBindingLayout.sampleType = `depth`;
        this.textureBindingLayout.viewDimension = `2d-array`;
        this.samplerBindingLayout.type = `non-filtering`;
        this.sampler_comparisonBindingLayout.type = `comparison`;
      }
      internalCreateTexture() {
        this.textureDescriptor = {
          format: this.format,
          size: { width: this.width, height: this.height, depthOrArrayLayers: this.numberLayer },
          dimension: "2d",
          usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.TEXTURE_BINDING
        };
        this.gpuTexture = this.getGPUTexture();
      }
      internalCreateView() {
        this.viewDescriptor = {
          dimension: `2d-array`
        };
        this.view = this.getGPUView();
      }
      internalCreateSampler() {
        this._ensureBound();
        const device = this._boundCtx.device;
        this.gpuSampler = device.createSampler({});
        this.gpuSampler_comparison = device.createSampler({
          compare: "less",
          minFilter: "linear",
          magFilter: "linear",
          label: "sampler_comparison"
        });
      }
    }

    class VirtualTexture extends Texture {
      /** Resolve target view used when this texture is multisampled. */
      resolveTarget;
      /** Number of MSAA samples; 0 means no multisampling. */
      sampleCount;
      // storeOp: string = 'store';
      // loadOp: GPULoadOp = `load`;
      // clearValue: GPUColor = [0, 0, 0, 0];
      /**
       * Create a copy of this texture with the same configuration.
       * @returns the cloned virtual texture
       */
      clone() {
        let texture = new VirtualTexture(this.width, this.height, this.format, this.useMipmap, this.usage, this.numberLayer, this.sampleCount);
        texture.name = "clone_" + texture.name;
        return texture;
      }
      /**
       * create virtual texture
       * @param width width of texture
       * @param height height of texture
       * @param format GPUTextureFormat, default value is rgba8unorm
       * @param useMipmap whether or not gen mipmap
       * @returns
       */
      constructor(width, height, format = GPUTextureFormat.rgba8unorm, useMipMap = false, usage, numberLayer = 1, sampleCount = 0, mipmapCount = 1, ctx) {
        super(width, height, numberLayer);
        this._ensureBound(ctx);
        this.name = UUID();
        this.useMipmap = useMipMap;
        this.sampleCount = sampleCount;
        this.format = format;
        this.numberLayer = numberLayer;
        this.mipmapCount = mipmapCount;
        if (usage != void 0) {
          this.usage = usage;
        } else {
          this.usage = usage | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST;
        }
        this.resize(width, height);
      }
      /**
       * Recreate the GPU texture and sampler for the new size and current format.
       * @param width new texture width
       * @param height new texture height
       */
      resize(width, height) {
        let device = this._boundCtx.device;
        if (this.gpuTexture) {
          Texture.delayDestroyTexture(this._boundCtx, this.gpuTexture);
          this.gpuTexture = null;
          this.view = null;
        }
        this.width = width;
        this.height = height;
        this.createTextureDescriptor(width, height, this.mipmapCount, this.format, this.usage, this.numberLayer, this.sampleCount);
        this.useMipmap = false;
        this.visibility = GPUShaderStage.COMPUTE | GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT;
        if (this.format == GPUTextureFormat.rgba32float) {
          this.samplerBindingLayout.type = `non-filtering`;
          this.textureBindingLayout.sampleType = `unfilterable-float`;
          this.gpuSampler = device.createSampler({});
        } else if (this.format == GPUTextureFormat.depth32float) {
          this.samplerBindingLayout.type = `filtering`;
          this.sampler_comparisonBindingLayout.type = `comparison`;
          this.textureBindingLayout.sampleType = `depth`;
          this.gpuSampler = device.createSampler({});
          this.gpuSampler_comparison = device.createSampler({
            compare: "less",
            label: "sampler_comparison"
          });
        } else if (this.format == GPUTextureFormat.depth24plus) {
          this.samplerBindingLayout = {
            type: `filtering`
          };
          this.sampler_comparisonBindingLayout = {
            type: "comparison"
          };
          this.textureBindingLayout.sampleType = `depth`;
          this.gpuSampler = device.createSampler({});
          this.gpuSampler_comparison = device.createSampler({
            compare: "less",
            label: "sampler_comparison"
          });
        } else {
          this.samplerBindingLayout.type = `filtering`;
          this.textureBindingLayout.sampleType = `float`;
          if (this.sampleCount > 0) {
            this.textureBindingLayout.multisampled = true;
          }
          this.minFilter = `linear`;
          this.magFilter = "linear";
          this.mipmapFilter = `nearest`;
          this.maxAnisotropy = 1;
          this.addressModeU = GPUAddressMode.mirror_repeat;
          this.addressModeV = GPUAddressMode.mirror_repeat;
          this.gpuSampler = device.createSampler(this);
        }
        this._textureChange = true;
      }
      /**
      * create rt texture
      * @param width texture width
      * @param height texture height
      * @param data  texture pixel data
      * @param useMipmap texture use mipmap switch
      * @returns
      */
      create(width, height, useMiamp = true) {
        let device = this._boundCtx.device;
        const bytesPerRow = width * 4;
        let td = new Float32Array(width * height * 4);
        const textureDataBuffer = device.createBuffer({
          size: td.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, td);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
      }
      /**
       * Copy this texture's contents back into a CPU buffer.
       * @returns the mapped array buffer of the texture data
       */
      readTextureToImage() {
        const ctx = this._boundCtx;
        let device = ctx.device;
        let w = ctx.windowWidth;
        let h = ctx.windowHeight;
        let td = new Float32Array(w * h * 4);
        const textureBuffer = device.createBuffer({
          size: td.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        const commandEncoder = ctx.gpuContext.beginCommandEncoder();
        commandEncoder.copyTextureToBuffer(
          {
            texture: this.getGPUTexture()
          },
          {
            buffer: textureBuffer
          },
          [w, h]
        );
        let arryBuffer = textureBuffer.getMappedRange(0, td.byteLength);
        return arryBuffer;
      }
    }

    class OcclusionSystem {
      frustumCullingList;
      zVisibleList;
      _renderList;
      static enable = true;
      _view;
      constructor(view) {
        this._view = view;
        this._renderList = /* @__PURE__ */ new Map();
      }
      /**
       * Get GPU Test Occlusion test
       * @param index
       * @returns
       */
      occlusionRenderNodeTest(index) {
        if (!this._view?.engine3D?.setting.occlusionQuery.enable) return 1;
        if (this.frustumCullingList) {
          return this.frustumCullingList[index];
        } else {
          return 0;
        }
      }
      /**
       * Get GPU Pixel depth visible Test
       * @param index
       * @returns
       */
      zDepthRenderNodeTest(index) {
        if (this.zVisibleList) {
          return this.zVisibleList[index];
        } else {
          return 0;
        }
      }
      update(camera, scene) {
      }
      collect(nodes, camera) {
      }
      renderCommitTesting(camera, renderNode) {
        return true;
      }
    }

    const MAIN_SHADOW_MAP = "_MainShadowMap";
    class ShadowPass extends RenderGraphPass {
      name = "ShadowPass";
      depth2DArrayTexture;
      shadowPassCount = 0;
      _passType = PassType.SHADOW;
      _rendererPassStates = [];
      _activeRendererPassState = null;
      // Static-cache infra — allocated lazily when
      // setting.shadow.enableStaticCache is true and first frame hits the
      // static-cache code path.
      _staticCacheReady = false;
      _staticDepthTextures = [];
      _staticPassStates = [];
      _dynamicPassStates = [];
      _staticDirtyLayers = [];
      _forceUpdate = false;
      _debugProbeDone = false;
      _shadowPos = new Vector3();
      _shadowCameraTarget = new Vector3();
      setup(b) {
        const ctx = b.context3D;
        const shadow = ctx.engine.setting.shadow;
        const w = shadow.maxShadowMapWidth;
        const h = shadow.maxShadowMapHeight;
        const maxShadowMapNum = shadow.maxShadowMapNum;
        this.depth2DArrayTexture = new Depth2DTextureArray(w, h, GPUTextureFormat.depth32float, maxShadowMapNum, ctx);
        Reference.getInstance().attached(this.depth2DArrayTexture, this);
        for (let i = 0; i < maxShadowMapNum; i++) {
          const rtFrame = new RTFrame([], []);
          const tex = new VirtualTexture(w, h, GPUTextureFormat.depth32float, false, void 0, 1, 0, 1, ctx);
          tex.name = `shadowDepthTexture_${i}`;
          rtFrame.depthTexture = tex;
          rtFrame.label = "shadowRender";
          rtFrame.customSize = true;
          rtFrame.depthCleanValue = 1;
          this._rendererPassStates[i] = WebGPUDescriptorCreator.createRendererPassState(ctx, rtFrame);
        }
        b.write(MAIN_SHADOW_MAP, () => this.depth2DArrayTexture);
        dependOnIfRegistered(b, "GPUCullPass");
      }
      /** External API: mark a static-cache layer dirty. */
      markStaticShadowDirty(shadowIndex = -1) {
        if (!this._staticCacheReady) return;
        if (shadowIndex < 0) {
          for (let i = 0; i < this._staticDirtyLayers.length; i++) this._staticDirtyLayers[i] = true;
        } else if (shadowIndex < this._staticDirtyLayers.length) {
          this._staticDirtyLayers[shadowIndex] = true;
        }
      }
      execute(ctx) {
        ShadowLightsCollect.update(ctx.view);
        this._render(ctx.view, ctx.occlusion);
      }
      _render(view, occlusion) {
        const shadowSetting = view.engine3D.setting.shadow;
        if (!shadowSetting.enable) return;
        void this._debugProbeShadowMap(view);
        const camera = view.camera;
        const scene = view.scene;
        this.shadowPassCount = 0;
        if (!shadowSetting.needUpdate) return;
        if (Time.frame % shadowSetting.updateFrameRate !== 0) return;
        const shadowLightList = ShadowLightsCollect.getDirectShadowLightWhichScene(scene);
        let sizeW = shadowSetting.shadowSize;
        let sizeH = shadowSetting.shadowSize;
        for (const light of shadowLightList) {
          const dirLight = light;
          const shadowIndex = dirLight.shadowIndex;
          this._activeRendererPassState = this._rendererPassStates[shadowIndex];
          sizeW = this._activeRendererPassState.depthTexture.width;
          sizeH = this._activeRendererPassState.depthTexture.height;
          preInitPassPipelines(view, this._passType, this._activeRendererPassState);
          const useStaticCache = shadowSetting.enableStaticCache === true;
          const autoOrDirty = dirLight.castShadow && dirLight.needUpdateShadow || this._forceUpdate || dirLight.castShadow && shadowSetting.autoUpdate;
          if (useStaticCache && dirLight.castShadow) {
            this._ensureStaticCache(view.engine3D.context3D, sizeW, sizeH);
            if (dirLight.needUpdateShadow || this._forceUpdate) {
              if (dirLight.enableCSM) {
                for (let csm = 0; csm < dirLight.cascadeNum; csm++) {
                  this._staticDirtyLayers[shadowIndex + csm] = true;
                }
              } else {
                this._staticDirtyLayers[shadowIndex] = true;
              }
              dirLight.needUpdateShadow = false;
            }
            if (dirLight.enableCSM) {
              dirLight.updateShadowCameraCSM(view.camera);
              dirLight.lightData.csmShadowMapIndex = shadowIndex;
              for (let csm = 0; csm < dirLight.cascadeNum; csm++) {
                const layer = shadowIndex + csm;
                const shadowCamera = dirLight.csmShadowCamera[csm];
                shadowCamera._boundCtx ||= view.engine3D.context3D;
                this._renderLayerSplit(view, shadowCamera, occlusion, layer, sizeW, sizeH);
              }
            } else {
              const extents = camera.getShadowWorldExtents();
              this._poseShadowCamera(dirLight, camera, dirLight.direction, dirLight.shadowCamera, extents, camera.lookTarget);
              this._renderLayerSplit(view, dirLight.shadowCamera, occlusion, shadowIndex, sizeW, sizeH);
            }
          } else if (autoOrDirty) {
            dirLight.needUpdateShadow = false;
            if (dirLight.enableCSM) {
              dirLight.updateShadowCameraCSM(view.camera);
              dirLight.lightData.csmShadowMapIndex = shadowIndex;
              for (let csm = 0; csm < dirLight.cascadeNum; csm++) {
                const layer = shadowIndex + csm;
                this._activeRendererPassState = this._rendererPassStates[layer];
                const shadowCamera = dirLight.csmShadowCamera[csm];
                shadowCamera._boundCtx ||= view.engine3D.context3D;
                this._renderShadow(view, shadowCamera, occlusion, this._activeRendererPassState);
                this._copyDepthTexture(view, this._activeRendererPassState.depthTexture, this.depth2DArrayTexture, layer, sizeW, sizeH);
              }
            } else {
              const extents = camera.getShadowWorldExtents();
              this._activeRendererPassState = this._rendererPassStates[shadowIndex];
              this._poseShadowCamera(dirLight, camera, dirLight.direction, dirLight.shadowCamera, extents, camera.lookTarget);
              this._renderShadow(view, dirLight.shadowCamera, occlusion, this._activeRendererPassState);
              this._copyDepthTexture(view, this._activeRendererPassState.depthTexture, this.depth2DArrayTexture, shadowIndex, sizeW, sizeH);
            }
          }
        }
        this._forceUpdate = false;
      }
      _ensureStaticCache(ctx, w, h) {
        if (this._staticCacheReady) return;
        const maxShadowMapNum = ctx.engine.setting.shadow.maxShadowMapNum;
        this._staticDirtyLayers = new Array(maxShadowMapNum).fill(true);
        for (let i = 0; i < maxShadowMapNum; i++) {
          const staticTex = new VirtualTexture(w, h, GPUTextureFormat.depth32float, false, void 0, 1, 0, 1, ctx);
          staticTex.name = `shadowStaticCache_${i}`;
          this._staticDepthTextures[i] = staticTex;
          const rtStatic = new RTFrame([], []);
          rtStatic.depthTexture = staticTex;
          rtStatic.label = "shadowStaticRebuild";
          rtStatic.customSize = true;
          rtStatic.depthCleanValue = 1;
          rtStatic.depthLoadOp = "clear";
          this._staticPassStates[i] = WebGPUDescriptorCreator.createRendererPassState(ctx, rtStatic);
          const rtDynamic = new RTFrame([], []);
          rtDynamic.depthTexture = this._rendererPassStates[i].depthTexture;
          rtDynamic.label = "shadowDynamicAppend";
          rtDynamic.customSize = true;
          rtDynamic.depthCleanValue = 1;
          rtDynamic.depthLoadOp = "load";
          this._dynamicPassStates[i] = WebGPUDescriptorCreator.createRendererPassState(ctx, rtDynamic);
        }
        this._staticCacheReady = true;
      }
      _renderLayerSplit(view, shadowCamera, occlusion, layer, w, h) {
        if (this._staticDirtyLayers[layer]) {
          this._activeRendererPassState = this._staticPassStates[layer];
          this._renderShadow(view, shadowCamera, occlusion, this._activeRendererPassState, "static");
          this._staticDirtyLayers[layer] = false;
        }
        this._copyDepthTexture(view, this._staticDepthTextures[layer], this._rendererPassStates[layer].depthTexture, 0, w, h);
        this._activeRendererPassState = this._dynamicPassStates[layer];
        this._renderShadow(view, shadowCamera, occlusion, this._activeRendererPassState, "dynamic");
        this._copyDepthTexture(view, this._rendererPassStates[layer].depthTexture, this.depth2DArrayTexture, layer, w, h);
      }
      _renderShadow(view, shadowCamera, occlusion, state, kind = "all") {
        shadowCamera._boundCtx ||= view.engine3D.context3D;
        const gpu = view.engine3D.context3D.gpuContext;
        const layered = this.collectLayered(view, shadowCamera);
        const command = gpu.beginCommandEncoder();
        const encoder = gpu.beginRenderPass(command, state);
        shadowCamera.transform.updateWorldMatrix();
        if (OcclusionSystem.enable) {
          occlusion.update(shadowCamera, view.scene);
          const localInfo = EntityCollect.instance.getRenderNodes(view.scene, shadowCamera);
          occlusion.collect(localInfo, shadowCamera);
        }
        GlobalBindGroup.updateCameraGroup(shadowCamera);
        gpu.bindCamera(encoder, shadowCamera);
        if (kind === "all") {
          const opBundles = buildOpBundles(view, shadowCamera, this._passType, state, void 0, true);
          const trBundles = buildTrBundles(view, shadowCamera, this._passType, state, void 0, true);
          if (opBundles.length > 0) encoder.executeBundles(opBundles);
          this._drawShadowNodes(view, shadowCamera, encoder, layered.opaque, kind);
          if (trBundles.length > 0) encoder.executeBundles(trBundles);
          this._drawShadowNodes(view, shadowCamera, encoder, layered.transparent, kind);
        } else {
          this._drawShadowNodes(view, shadowCamera, encoder, layered.opaque, kind);
          this._drawShadowNodes(view, shadowCamera, encoder, layered.transparent, kind);
        }
        gpu.endPass(encoder);
        gpu.endCommandEncoder(command);
      }
      _drawShadowNodes(view, shadowCamera, encoder, nodes, kind) {
        if (!nodes) return;
        GlobalBindGroup.updateCameraGroup(shadowCamera);
        view.engine3D.context3D.gpuContext.bindCamera(encoder, shadowCamera);
        const render = view.engine3D.setting.render;
        const max = Math.min(nodes.length, render.drawOpMax);
        for (let i = render.drawOpMin; i < max; ++i) {
          const node = nodes[i];
          if (!node.transform.enable) continue;
          if (!node.enable) continue;
          if (!node.castShadow) continue;
          if (node.isDestroyed) continue;
          if (kind === "static") {
            if (node.shadowCacheMode !== "static") continue;
          } else if (kind === "dynamic") {
            if (node.shadowCacheMode === "static") continue;
          }
          if (!node.preInit(this._passType)) {
            node.nodeUpdate(view, this._passType, this._activeRendererPassState, void 0);
          }
          node.renderPass2(view, this._passType, this._activeRendererPassState, void 0, encoder);
        }
      }
      _copyDepthTexture(view, src, dst, dstIndex, w, h) {
        const gpu = view.engine3D.context3D.gpuContext;
        const cmd = gpu.beginCommandEncoder();
        cmd.copyTextureToTexture(
          { texture: src.getGPUTexture(), mipLevel: 0, origin: { x: 0, y: 0, z: 0 } },
          { texture: dst.getGPUTexture(), mipLevel: 0, origin: { x: 0, y: 0, z: dstIndex } },
          { width: w, height: h, depthOrArrayLayers: 1 }
        );
        gpu.endCommandEncoder(cmd);
      }
      _poseShadowCamera(dirLight, viewCamera, direction, shadowCamera, _extents, _lookAt) {
        this._shadowPos.copy(dirLight.transform.worldPosition);
        this._shadowCameraTarget.copy(direction).normalize(viewCamera.far);
        Vector3.add(this._shadowCameraTarget, this._shadowPos, this._shadowCameraTarget);
        shadowCamera.transform.lookAt(this._shadowPos, this._shadowCameraTarget);
        shadowCamera.orthoOffCenter(shadowCamera.left, shadowCamera.right, shadowCamera.bottom, shadowCamera.top, shadowCamera.near, shadowCamera.far);
      }
      /** One-shot diagnostic: probes the first shadow VirtualTexture
       *  after frame 60 to confirm whether the shadow pass actually
       *  writes anything (or whether the depth attachment stays at its
       *  clear value). Mac Metal vs Windows Dawn D3D12 sometimes
       *  diverge here. Remove once the gap is understood. */
      async _debugProbeShadowMap(view) {
        if (this._debugProbeDone || Time.frame < 60) return;
        const ps = this._rendererPassStates[0];
        const tex = ps?.depthTexture;
        if (!tex) return;
        this._debugProbeDone = true;
        try {
          const ctx = view.engine3D.context3D;
          const device = ctx.device;
          const gpu = ctx.gpuContext;
          const w = tex.width, h = tex.height;
          const bytesPerRow = Math.ceil(w * 4 / 256) * 256;
          const buf = device.createBuffer({
            size: bytesPerRow * h,
            usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ
          });
          const cmd = gpu.beginCommandEncoder();
          cmd.copyTextureToBuffer(
            { texture: tex.getGPUTexture(), aspect: "depth-only" },
            { buffer: buf, bytesPerRow, rowsPerImage: h },
            { width: w, height: h, depthOrArrayLayers: 1 }
          );
          gpu.endCommandEncoder(cmd);
          await buf.mapAsync(GPUMapMode.READ);
          const copy = new Float32Array(buf.getMappedRange().slice(0));
          buf.unmap();
          buf.destroy();
          let mn = Infinity, mx = -Infinity, sum = 0, nonOneCount = 0;
          const stride = bytesPerRow / 4;
          for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
              const d = copy[y * stride + x];
              if (d < mn) mn = d;
              if (d > mx) mx = d;
              sum += d;
              if (d < 0.9999) nonOneCount++;
            }
          }
          const total = w * h;
          const mean = sum / total;
        } catch (e) {
          console.log("[ShadowMapDebug] readback failed:", e?.message ?? e);
          this._debugProbeDone = false;
        }
      }
    }

    class PointShadowCubeCamera extends exports.Object3D {
      up_camera;
      down_camera;
      left_camera;
      right_camera;
      front_camera;
      back_camera;
      set label(v) {
        this.up_camera.name = v + "up";
        this.down_camera.name = v + "down";
        this.left_camera.name = v + "left";
        this.right_camera.name = v + "right";
        this.front_camera.name = v + "front";
        this.back_camera.name = v + "back";
      }
      /**
       *
       * @constructor
       * @param near distance from origin to near plane of frustum
       * @param far distance from origin to far plane of frustum
       */
      constructor(near = 1e-3, far = 1e4, fov = 90, isShadow = false) {
        super();
        this.initCubeCamera(near, far, fov, isShadow);
      }
      initCubeCamera(near, far, fov = 90, isShadow = false) {
        this.up_camera = CameraUtil.createCamera3DObject(this, "up");
        this.down_camera = CameraUtil.createCamera3DObject(this, "down");
        this.left_camera = CameraUtil.createCamera3DObject(this, "left");
        this.right_camera = CameraUtil.createCamera3DObject(this, "right");
        this.front_camera = CameraUtil.createCamera3DObject(this, "front");
        this.back_camera = CameraUtil.createCamera3DObject(this, "back");
        this.up_camera.isShadowCamera = isShadow;
        this.down_camera.isShadowCamera = isShadow;
        this.left_camera.isShadowCamera = isShadow;
        this.right_camera.isShadowCamera = isShadow;
        this.front_camera.isShadowCamera = isShadow;
        this.back_camera.isShadowCamera = isShadow;
        let aspect = 1;
        this.up_camera.perspective(fov, aspect, near, far);
        this.up_camera.lookAt(Vector3.ZERO, Vector3.UP, Vector3.BACK);
        this.up_camera.object3D.scaleX = -1;
        this.down_camera.perspective(fov, aspect, near, far);
        this.down_camera.lookAt(Vector3.ZERO, Vector3.DOWN, Vector3.FORWARD);
        this.down_camera.object3D.scaleX = -1;
        this.left_camera.perspective(fov, aspect, near, far);
        this.left_camera.lookAt(Vector3.ZERO, Vector3.LEFT);
        this.left_camera.object3D.scaleX = -1;
        this.right_camera.perspective(fov, aspect, near, far);
        this.right_camera.lookAt(Vector3.ZERO, Vector3.RIGHT);
        this.right_camera.object3D.scaleX = -1;
        this.front_camera.perspective(fov, aspect, near, far);
        this.front_camera.lookAt(Vector3.ZERO, Vector3.FORWARD);
        this.front_camera.object3D.scaleX = -1;
        this.back_camera.perspective(fov, aspect, near, far);
        this.back_camera.lookAt(Vector3.ZERO, Vector3.BACK);
        this.back_camera.object3D.scaleX = -1;
        this.up_camera.type = CameraType.shadow;
        this.down_camera.type = CameraType.shadow;
        this.left_camera.type = CameraType.shadow;
        this.right_camera.type = CameraType.shadow;
        this.front_camera.type = CameraType.shadow;
        this.back_camera.type = CameraType.shadow;
      }
      /** Bind all 6 face cameras to a specific Context3D. Needed when the
       *  cube camera never joins a scene graph. */
      bindCtx(ctx) {
        this.up_camera._boundCtx ||= ctx;
        this.down_camera._boundCtx ||= ctx;
        this.left_camera._boundCtx ||= ctx;
        this.right_camera._boundCtx ||= ctx;
        this.front_camera._boundCtx ||= ctx;
        this.back_camera._boundCtx ||= ctx;
        return this;
      }
    }

    class DepthCubeArrayTexture extends Texture {
      /**
       * @constructor
       */
      constructor(width, height, numberLayer, ctx) {
        super(width, height, numberLayer);
        this.format = GPUTextureFormat.depth32float;
        this.mipmapCount = 1;
        this._ensureBound(ctx);
        this.init();
      }
      internalCreateBindingLayoutDesc() {
        this.textureBindingLayout.sampleType = `depth`;
        this.textureBindingLayout.viewDimension = `cube-array`;
        this.samplerBindingLayout.type = `non-filtering`;
        this.sampler_comparisonBindingLayout.type = `comparison`;
      }
      internalCreateTexture() {
        this.textureDescriptor = {
          format: this.format,
          size: { width: this.width, height: this.height, depthOrArrayLayers: 6 * this.numberLayer },
          dimension: "2d",
          usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.TEXTURE_BINDING
        };
        this.gpuTexture = this.getGPUTexture();
      }
      internalCreateView() {
        this.viewDescriptor = {
          dimension: `cube-array`
        };
        this.view = this.getGPUView();
      }
      internalCreateSampler() {
        this._ensureBound();
        const device = this._boundCtx.device;
        this.gpuSampler = device.createSampler({
          minFilter: GPUFilterMode.nearest,
          magFilter: GPUFilterMode.nearest
        });
        this.gpuSampler_comparison = device.createSampler({
          compare: "less",
          label: "sampler_comparison"
        });
      }
    }

    const POINT_SHADOW_CUBE_ARRAY = "_PointShadowCubeArray";
    class PointShadowPass extends RenderGraphPass {
      name = "PointShadowPass";
      cubeArrayTexture;
      colorTexture;
      shadowSize = 1024;
      shadowPassCount = 0;
      _passType = PassType.POINT_SHADOW;
      _shadowCameraDic = /* @__PURE__ */ new Map();
      _forceUpdate = false;
      setup(b) {
        const ctx = b.context3D;
        this.cubeArrayTexture = new DepthCubeArrayTexture(this.shadowSize, this.shadowSize, 8, ctx);
        this.colorTexture = new VirtualTexture(this.shadowSize, this.shadowSize, GPUTextureFormat.bgra8unorm, false, void 0, 1, 0, 1, ctx);
        Reference.getInstance().attached(this.cubeArrayTexture, this);
        b.write(POINT_SHADOW_CUBE_ARRAY, () => this.cubeArrayTexture);
        dependOnIfRegistered(b, "GPUCullPass");
      }
      execute(ctx) {
        const view = ctx.view;
        const occlusion = ctx.occlusion;
        if (!view.engine3D.setting.shadow.enable) return;
        const gpu = view.engine3D.context3D.gpuContext;
        this.shadowPassCount = 0;
        const scene = view.scene;
        const shadowLights = ShadowLightsCollect.getPointShadowLightWhichScene(scene);
        for (const light of shadowLights) {
          if (light.lightData.lightType === LightType.DirectionLight) continue;
          const shouldRender = light.lightData.castShadowIndex > -1 && (light.needUpdateShadow || this._forceUpdate || Time.frame < 5 || light.realTimeShadow);
          if (!shouldRender) continue;
          light.needUpdateShadow = false;
          const info = this._getShadowCamera(view, light);
          const worldPos = light.transform.worldPosition;
          info.cubeCamera.x = worldPos.x;
          info.cubeCamera.y = worldPos.y;
          info.cubeCamera.z = worldPos.z;
          info.cubeCamera.transform.updateWorldMatrix(true);
          const faces = [
            info.cubeCamera.right_camera,
            info.cubeCamera.left_camera,
            info.cubeCamera.up_camera,
            info.cubeCamera.down_camera,
            info.cubeCamera.front_camera,
            info.cubeCamera.back_camera
          ];
          for (let face = 0; face < 6; face++) {
            const camera = faces[face];
            occlusion.update(camera, scene);
            const layered = this.collectLayered(view, camera);
            this._renderFaceOnce(face, info, view, camera, layered.opaque, layered.transparent, occlusion);
          }
          const command = gpu.beginCommandEncoder();
          for (let i = 0; i < 6; i++) {
            command.copyTextureToTexture(
              { texture: info.depthTexture[i].getGPUTexture(), mipLevel: 0, origin: { x: 0, y: 0, z: 0 } },
              { texture: this.cubeArrayTexture.getGPUTexture(), mipLevel: 0, origin: { x: 0, y: 0, z: light.shadowIndex * 6 + i } },
              { width: this.shadowSize, height: this.shadowSize, depthOrArrayLayers: 1 }
            );
          }
          gpu.endCommandEncoder(command);
        }
        this._forceUpdate = false;
      }
      _getShadowCamera(view, light) {
        const lbAny = light;
        const near = lbAny.shadowCameraNear && lbAny.shadowCameraNear > 0 ? lbAny.shadowCameraNear : 0.01;
        const farOverride = lbAny.shadowCameraFar;
        const lightRange = light.lightData?.range;
        const far = farOverride && farOverride > 0 ? farOverride : lightRange && lightRange > 0 ? lightRange : view.camera.far;
        const existing = this._shadowCameraDic.get(light);
        if (existing) {
          const cam = existing.cubeCamera;
          const faces = [cam.right_camera, cam.left_camera, cam.up_camera, cam.down_camera, cam.front_camera, cam.back_camera];
          for (const f of faces) {
            if (f && (f.near !== near || f.far !== far)) {
              f.perspective(90, 1, near, far);
            }
          }
          return existing;
        }
        const camera = new PointShadowCubeCamera(near, far, 90, true);
        camera.bindCtx(view.engine3D.context3D);
        camera.label = light.name;
        const depths = [];
        const renderContexts = [];
        for (let i = 0; i < 6; i++) {
          const depthTex = new VirtualTexture(this.shadowSize, this.shadowSize, this.cubeArrayTexture.format, false, void 0, 1, 0, 1, view.engine3D.context3D);
          depthTex.name = `shadowDepthTexture_${light.name}${i}_face`;
          const rtFrame = new RTFrame([this.colorTexture], [new RTDescriptor()]);
          rtFrame.depthTexture = depthTex;
          rtFrame.label = "shadowRender";
          rtFrame.customSize = true;
          depths[i] = depthTex;
          renderContexts[i] = new RenderContext(view.engine3D.context3D, rtFrame);
        }
        const info = {
          cubeCamera: camera,
          depthTexture: depths,
          renderContext: renderContexts
        };
        this._shadowCameraDic.set(light, info);
        return info;
      }
      _renderFaceOnce(face, info, view, shadowCamera, opaqueList, transparentList, occlusion) {
        const renderContext = info.renderContext[face];
        renderContext.gpu = view.engine3D.context3D.gpuContext;
        renderContext.clean();
        renderContext.beginOpaqueRenderPass();
        renderContext.encoder.setViewport(0, 0, this.shadowSize, this.shadowSize, 0, 1);
        renderContext.encoder.setScissorRect(0, 0, this.shadowSize, this.shadowSize);
        shadowCamera.onUpdate();
        shadowCamera.transform.updateWorldMatrix(true);
        for (const node of opaqueList) {
          if (!node.isDestroyed && node.preInit(this._passType)) {
            node.nodeUpdate(view, this._passType, renderContext.rendererPassState, null);
            break;
          }
        }
        this._drawNodes(view, shadowCamera, renderContext, opaqueList, occlusion);
        this._drawNodes(view, shadowCamera, renderContext, transparentList, occlusion);
        renderContext.endRenderPass();
      }
      _drawNodes(view, camera, renderContext, nodes, _occlusion) {
        GlobalBindGroup.updateCameraGroup(camera);
        view.engine3D.context3D.gpuContext.bindCamera(renderContext.encoder, camera);
        let cameraWorldPosition = camera.transform.worldPosition;
        if (view.engine3D.setting.useRTE) {
          const mainCamera = Camera3D.mainCamera;
          cameraWorldPosition = Vector3.sub(camera.transform.worldPosition, mainCamera.transform.worldPosition);
        }
        preInitPassPipelines(view, this._passType, renderContext.rendererPassState);
        const render = view.engine3D.setting.render;
        const max = Math.min(nodes.length, render.drawOpMax);
        for (let i = render.drawOpMin; i < max; ++i) {
          const node = nodes[i];
          if (!node.transform.enable) continue;
          if (!node.enable) continue;
          if (!node.castShadow) continue;
          if (node.isDestroyed) continue;
          if (!node.preInit(this._passType)) {
            node.nodeUpdate(view, this._passType, renderContext.rendererPassState, void 0);
          }
          for (const material of node.materials) {
            const passes = material.getPass(this._passType);
            if (!passes || passes.length === 0) continue;
            for (const pass of passes) {
              if (pass.pipeline) {
                pass.setUniformFloat("cameraFar", camera.far);
                pass.setUniformVector3("lightWorldPos", cameraWorldPosition);
                pass.materialDataUniformBuffer.apply();
              }
            }
          }
          node.renderPass(view, this._passType, renderContext);
        }
      }
    }

    let PreFilteredEnvironment_cs = (
      /*wgsl*/
      `
    // input reflection buffer texture
    // sample prefiltered cube uv texture 
    // storge info to oct map 
    #include "GenerayRandomDir"
    #include "BitUtil"
    #include "MathShader"
    #include "ColorUtil_frag"
    
    struct UniformData{
        probeSize : f32 ,
        probeCount : f32 ,
        width : f32 ,
        height : f32 ,
    }

    @group(0) @binding(0) var inputTex : texture_2d<f32>;
    @group(0) @binding(1) var outputTexture : texture_storage_2d<rgba16float, write>;//rgba32float rgba16float
    @group(1) @binding(0) var<uniform> uniformData:UniformData;//rgba32float

    var<private> reflectionSize : vec2f ; 
    var<private> PROBE_SOURCESIZE : vec2f ; 
    var<private> PROBEMAP_SOURCESIZE : vec2f ; 
    var<private> aspect : vec2f ; 
    var<private> spaceV : f32 ; 
    
    var<private> i32InputFragCoord : vec2i;
    var<private> PI_2 : f32 = 3.1415926 * 2.0 ;
    var<private> PI : f32 = 3.1415926 ;

    var<private> probeSize : f32 = 256.0 ;
    var<private> probeCount : f32 = 8.0 ;
    var<private> faceCount : f32 = 6.0 ;
    var<private> mipCount : f32 = 8.0 ;

    const NUM_SAMPLES = 256u;
    var<private> inputSize : vec2f ; 
    var<private> outSize : vec2f ; 

    fn useSphereReflection(){
        probeSize = uniformData.probeSize ;
        probeCount = uniformData.probeCount;
        reflectionSize = vec2f(textureDimensions(inputTex).xy);
        PROBE_SOURCESIZE = reflectionSize / vec2f(faceCount,probeCount);
        PROBEMAP_SOURCESIZE = reflectionSize ;
        aspect = PROBE_SOURCESIZE / PROBEMAP_SOURCESIZE;
        spaceV = 1.0 / probeCount ;
    }

    @compute @workgroup_size( 16 , 16 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        var color : vec4f ;
        useSphereReflection();
        inputSize = vec2f(textureDimensions(inputTex).xy);
        outSize = vec2f(textureDimensions(outputTexture).xy);
        
        i32InputFragCoord = vec2<i32>( globalInvocation_id.xy ) ;

        let i = f32(globalInvocation_id.z) ;
        let count = floor(i / mipCount) ;
        preOneMip(count,floor(i % mipCount));
    }

    fn preOneMip( gid:f32,mip:f32 ){
        let isuv = vec2f(i32InputFragCoord) ;
        let suv = isuv * (inputSize/outSize);
        let probeID = i32(floor(suv.y / probeSize));
        let mipID = i32((isuv.x / probeSize));
        if(probeID == i32(gid) && mipID == i32(mip)){

            let sphereUV = vec2f((isuv.x+0.5) % (probeSize),(isuv.y+0.5) % probeSize) / vec2f( (probeSize), probeSize ) ;
            var dir: vec3<f32> = octDecode(sphereUV * 2.0 - 1.0) ;
            var preColor = PreFilterEnvMap(mip/mipCount + 0.05,dir,gid);
            textureStore(outputTexture,vec2i(i32InputFragCoord),preColor);
        }
    }

    fn PreFilterEnvMap( roughness2:f32,  R:vec3f , gid:f32 ) -> vec4f
    {
        var resColor = vec3f(0.0f);  
        var resDepth = 0.0;  

        var totalColorWeight = 0.0f;   
        var totalDepthWeight = 0.0f;   
        
        var normal = normalize(R);
        var toEye = normal;
        
        var roughness = roughness2;
        
        for(var i=1u;i<=NUM_SAMPLES;i+=1u)
        {
            var xi:vec2f = hammersley(i, NUM_SAMPLES) ; 
            
            var halfway = ImportanceSampleGGX(xi,roughness,normal);
            var lightVec = 2.0f * dot( toEye,halfway ) * halfway - toEye;
            
            var NdotL = dot( normal, lightVec )  ;
            var NdotH = max(0.0,dot( normal, halfway ))  ;
            var HdotV = max(0.0,dot( halfway, toEye ))  ;
            
            if( NdotL > 0.0 )
            {
                var D = specularD(roughness,NdotH);
                var pdf = (D * NdotH / (4.0 * HdotV)) + 0.0001f  ;

                var saSample = 1.0f / (f32(NUM_SAMPLES) * pdf + 0.00001f);
                lightVec = normalize(lightVec);

                var buffer = getReflectionsMap(lightVec,gid); 
                var rgb = unpack4x8unorm(u32(buffer.z)).rgb;
                var m = unpack4x8unorm(u32(buffer.w)).z;
                var rgbmColor = DecodeRGBM(vec4f(rgb,m));
                resDepth += buffer.x ;
                resColor += rgbmColor * NdotL;

                totalColorWeight += NdotL;
                totalDepthWeight += 1.0;
            }
        }

        resDepth = resDepth / max(totalDepthWeight,0.001f);
        resColor = resColor / max(totalColorWeight,0.001f);
        
        let rgbm = EncodeRGBM(resColor) ; 
        let gBuffer = vec4f(
            resDepth,
            0.0,
            f32(pack4x8unorm(vec4f(rgbm.rgb,0.0))),
            f32(pack4x8unorm(vec4f(0.0,0.0,rgbm.w,0.0))),
        ) ;
        // return gBuffer ;
        return vec4f(resColor,1.0) ;
    } 

    fn getReflectionsMap(n:vec3<f32>,gid:f32) -> vec4f {
        var uv = getSampleProbeUV(n,gid);
        let color = textureLoad(inputTex, vec2i(uv*inputSize) , 0);
        return color ;
    }

    fn getSampleProbeUV(dir:vec3<f32>,gid:f32) -> vec2<f32> {
        let faceId = dir_to_faceId(dir);
        var targetUV:vec2<f32> = convert_xyz_to_cube_uv(dir.x, dir.y, dir.z);
        targetUV.x = 1.0 - targetUV.x;
        let threshould = 0.5 / PROBE_SOURCESIZE;
        targetUV = clamp(targetUV, vec2<f32>(threshould), vec2<f32>(1.0 - threshould));
        targetUV.x = f32(faceId) + targetUV.x;
        let aspect:vec2f = PROBE_SOURCESIZE / PROBEMAP_SOURCESIZE;
        targetUV = targetUV * aspect ;
        targetUV.y = targetUV.y + (spaceV * gid);
        return targetUV ;
     }

    fn radicalInverse_VdC( bits2:u32) -> f32
    {
        var bits = bits2; 
        bits = (bits << 16u) | (bits >> 16u);
        bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
        bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
        bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
        bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
        return f32(bits) * 2.3283064365386963e-10f; // / 0x100000000
    }

    fn hammersley( i:u32, N:u32) -> vec2f
    {
        return vec2f(f32(i) / f32(N), radicalInverse_VdC(i));
    }

    fn ImportanceSampleGGX( xi:vec2f,  roughness:f32,  N:vec3f) -> vec3f
    {
        var alpha2 = roughness * roughness * roughness * roughness;
        
        var phi = 2.0f * 3.1415926 * xi.x  ;
        var cosTheta = sqrt( (1.0f - xi.y) / (1.0f + (alpha2 - 1.0f) * xi.y ));
        var sinTheta = sqrt( 1.0f - cosTheta*cosTheta );
        
        var h : vec3f ;
        h.x = sinTheta * cos( phi );
        h.y = sinTheta * sin( phi );
        h.z = cosTheta;
        
        var up = vec3f(1,0,0) ;
        if(abs(N.z) < 0.9999){
            up = vec3f(0,0,1) ;
        }

        var tangentX = normalize( cross( up, N ) );
        var tangentY = cross( N, tangentX );
        return (tangentX * h.x + tangentY * h.y + N * h.z);
    } 

    fn  specularD( roughness:f32,  NoH:f32) -> f32
    {
        var NoH2 = NoH * NoH;
        var r2 = roughness * roughness;
        return r2 / pow(NoH2 * (r2 - 1.0) + 1.0, 2.0);
    }
    
`
    );

    class CubeCamera extends exports.Object3D {
      up_camera;
      down_camera;
      left_camera;
      right_camera;
      front_camera;
      back_camera;
      _near;
      _far;
      /**
       *
       * Construct a cube camera with 6 perspective cameras,
       * @param near  near plane
       * @param far far plane
       */
      constructor(near = 1e-3, far = 1e4, fov = 90, isShadow = false) {
        super();
        this.initCubeCamera(near, far, fov, isShadow);
      }
      initCubeCamera(near, far, fov = 90, isShadow = false) {
        this.up_camera = CameraUtil.createCamera3DObject(this, "up");
        this.down_camera = CameraUtil.createCamera3DObject(this, "down");
        this.left_camera = CameraUtil.createCamera3DObject(this, "left");
        this.right_camera = CameraUtil.createCamera3DObject(this, "right");
        this.front_camera = CameraUtil.createCamera3DObject(this, "front");
        this.back_camera = CameraUtil.createCamera3DObject(this, "back");
        this.up_camera.isShadowCamera = isShadow;
        this.down_camera.isShadowCamera = isShadow;
        this.left_camera.isShadowCamera = isShadow;
        this.right_camera.isShadowCamera = isShadow;
        this.front_camera.isShadowCamera = isShadow;
        this.back_camera.isShadowCamera = isShadow;
        let aspect = 1;
        this.up_camera.perspective(fov, aspect, near, far);
        this.up_camera.lookAt(Vector3.ZERO, Vector3.UP, Vector3.DOWN);
        this.down_camera.perspective(fov, aspect, near, far);
        this.down_camera.lookAt(Vector3.ZERO, Vector3.DOWN, Vector3.DOWN);
        this.left_camera.perspective(fov, aspect, near, far);
        this.left_camera.lookAt(Vector3.ZERO, Vector3.LEFT);
        this.right_camera.perspective(fov, aspect, near, far);
        this.right_camera.lookAt(Vector3.ZERO, Vector3.RIGHT);
        this.front_camera.perspective(fov, aspect, near, far);
        this.front_camera.lookAt(Vector3.ZERO, Vector3.FORWARD);
        this.back_camera.perspective(fov, aspect, near, far);
        this.back_camera.lookAt(Vector3.ZERO, Vector3.BACK);
        this.up_camera.type = CameraType.shadow;
        this.down_camera.type = CameraType.shadow;
        this.left_camera.type = CameraType.shadow;
        this.right_camera.type = CameraType.shadow;
        this.front_camera.type = CameraType.shadow;
        this.back_camera.type = CameraType.shadow;
      }
      set near(value) {
        this._near = value;
        this.up_camera.near = value;
        this.down_camera.near = value;
        this.left_camera.near = value;
        this.right_camera.near = value;
        this.front_camera.near = value;
        this.back_camera.near = value;
      }
      get near() {
        return this._near;
      }
      set far(value) {
        this._far = value;
        this.up_camera.far = value;
        this.down_camera.far = value;
        this.left_camera.far = value;
        this.right_camera.far = value;
        this.front_camera.far = value;
        this.back_camera.far = value;
      }
      get far() {
        return this._far;
      }
      /** Bind all 6 face cameras to a specific Context3D. Needed when the
       *  CubeCamera is used by a renderer/probe that never adds it to a
       *  scene graph — without this, `GlobalBindGroup._ctxFromCamera` has
       *  no ancestor chain to walk. */
      bindCtx(ctx) {
        this.up_camera._boundCtx ||= ctx;
        this.down_camera._boundCtx ||= ctx;
        this.left_camera._boundCtx ||= ctx;
        this.right_camera._boundCtx ||= ctx;
        this.front_camera._boundCtx ||= ctx;
        this.back_camera._boundCtx ||= ctx;
        return this;
      }
      destroy(force) {
        super.destroy(force);
        this.up_camera = null;
        this.down_camera = null;
        this.left_camera = null;
        this.right_camera = null;
        this.front_camera = null;
        this.back_camera = null;
      }
    }

    const REFLECTION_CUBE_MAP = "_ReflectionCubeMap";
    class ReflectionPass extends RenderGraphPass {
      name = "ReflectionPass";
      outTexture;
      gBuffer;
      sizeW;
      sizeH;
      probeSize;
      probeCount;
      mipCount = 8;
      _passType = PassType.REFLECTION;
      _cubeCamera;
      _renderContext;
      _rendererPassState;
      _preFilteredCompute;
      _preFilteredUniform;
      _onChange = true;
      _needUpdate = true;
      setup(b) {
        const view = b.view;
        const ctx = b.context3D;
        const reflectionSetting = view.engine3D.setting.reflectionSetting;
        this.probeSize = reflectionSetting.reflectionProbeSize;
        this.probeCount = reflectionSetting.reflectionProbeMaxCount;
        this.sizeW = reflectionSetting.width;
        this.sizeH = reflectionSetting.height;
        this._cubeCamera = new CubeCamera(0.01, 5e3);
        this._cubeCamera.bindCtx(ctx);
        this.gBuffer = GBufferFrame.getGBufferFrame(GBufferFrame.reflections_GBuffer, ctx, this.sizeW, this.sizeH, false);
        this._rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, this.gBuffer);
        this._renderContext = new RenderContext(ctx, this.gBuffer);
        const usage = GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING;
        this.outTexture = new VirtualTexture(this.probeSize * this.mipCount, this.sizeH, GPUTextureFormat.rgba16float, false, usage, 1, 0, 1, ctx);
        this.outTexture.name = "reflection_outTexture";
        this._preFilteredUniform = new UniformGPUBuffer(4 + this.probeCount * 4);
        this._preFilteredUniform.setFloat("probeSize", this.probeSize);
        this._preFilteredUniform.setFloat("probeCount", this.probeCount);
        this._preFilteredUniform.setFloat("width", this.sizeW);
        this._preFilteredUniform.setFloat("height", this.sizeH);
        this._preFilteredUniform.apply();
        this._preFilteredCompute = new ComputeShader(PreFilteredEnvironment_cs);
        this._preFilteredCompute.setSamplerTexture("inputTex", this.gBuffer.getCompressGBufferTexture());
        this._preFilteredCompute.setStorageTexture("outputTexture", this.outTexture);
        this._preFilteredCompute.setUniformBuffer("uniformData", this._preFilteredUniform);
        b.write(REFLECTION_CUBE_MAP, () => this.outTexture);
      }
      /** Mark the cube-face cache dirty so the next frame re-renders all
       *  probes. Called from LightBase when a light moves. */
      forceUpdate() {
        this._onChange = true;
      }
      execute(ctx) {
        this._render(ctx.view, ctx.occlusion);
        this._compute(ctx.view);
      }
      _compute(view) {
        if (!this._needUpdate) return;
        this._needUpdate = false;
        const gpu = view.engine3D.context3D.gpuContext;
        const reflectionEntries = GlobalBindGroup.getReflectionEntries(view.scene);
        reflectionEntries.reflectionMap = this.outTexture;
        this._preFilteredCompute.workerSizeX = Math.ceil(this.probeSize * this.mipCount / 16);
        this._preFilteredCompute.workerSizeY = Math.ceil(this.sizeH / 16);
        this._preFilteredCompute.workerSizeZ = this.mipCount * reflectionEntries.count;
        const command = gpu.beginCommandEncoder();
        gpu.computeCommand(command, [this._preFilteredCompute]);
        gpu.endCommandEncoder(command);
      }
      _render(view, occlusion) {
        this._renderContext.gpu = view.engine3D.context3D.gpuContext;
        this._renderContext.clean();
        const reflections = EntityCollect.instance.getReflections(view.scene);
        const space = this.probeSize;
        const cluster = view.renderGraph?.getPass("ClusterLightingPass")?.clusterLightingBuffer;
        for (let i = 0; i < reflections.length; i++) {
          const reflection = reflections[i];
          const shouldRender = reflection.autoUpdate && (reflection.needUpdate || this._onChange) || Time.frame < 10;
          if (!shouldRender) continue;
          reflection.needUpdate = false;
          this._needUpdate = true;
          this._renderContext.beginOpaqueRenderPass();
          const encoder = this._renderContext.encoder;
          const offsetY = i * space;
          reflection.transform.updateWorldMatrix();
          const worldPos = reflection.transform.worldPosition;
          this._cubeCamera.x = worldPos.x;
          this._cubeCamera.y = worldPos.y;
          this._cubeCamera.z = worldPos.z;
          this._cubeCamera.far = 1e4;
          this._cubeCamera.transform.updateWorldMatrix();
          const faces = [
            this._cubeCamera.right_camera,
            this._cubeCamera.left_camera,
            this._cubeCamera.up_camera,
            this._cubeCamera.down_camera,
            this._cubeCamera.front_camera,
            this._cubeCamera.back_camera
          ];
          for (let f = 0; f < 6; f++) {
            encoder.setViewport(space * f, offsetY, space, space, 0, 1);
            this._renderFace(view, faces[f], encoder, occlusion, cluster);
          }
          this._renderContext.endRenderPass();
        }
        this._onChange = false;
      }
      _renderFace(view, camera, encoder, occlusion, cluster) {
        const gpu = view.engine3D.context3D.gpuContext;
        const scene = view.scene;
        camera.transform.scene3D = scene;
        this._rendererPassState.camera3D = camera;
        const layered = this.collectLayered(view, camera);
        GlobalBindGroup.updateCameraGroup(camera);
        const sky = EntityCollect.instance.getSky(scene);
        if (sky) {
          gpu.bindCamera(encoder, camera);
          if (!sky.preInit(this._passType)) {
            sky.nodeUpdate(view, this._passType, this._rendererPassState, cluster);
          }
          sky.renderPass2(view, this._passType, this._rendererPassState, cluster, encoder);
        }
        gpu.bindCamera(encoder, camera);
        if (layered.opaque.length > 0) {
          this._drawNodes(view, layered.opaque, occlusion, cluster);
        }
        if (layered.transparent.length > 0) {
          this._drawNodes(view, layered.transparent, occlusion, cluster);
        }
      }
      _drawNodes(view, nodes, _occlusion, cluster) {
        preInitPassPipelines(view, this._passType, this._rendererPassState, cluster, (n) => !n.hasMask(RendererMask.ReflectionDebug));
        for (const node of nodes) {
          if (node.hasMask(RendererMask.ReflectionDebug)) continue;
          if (!node.transform.enable) continue;
          if (!node.enable) continue;
          if (node.isDestroyed) continue;
          if (!node.preInit(this._passType)) {
            node.nodeUpdate(view, this._passType, this._rendererPassState, cluster);
          }
          node.renderPass(view, this._passType, this._renderContext);
        }
      }
      destroy() {
        this._cubeCamera?.destroy();
      }
    }

    class ProbeGBufferFrame extends RTFrame {
      constructor(rtWidth, rtHeight, autoResize = true, ctx) {
        super([], []);
        this.crateGBuffer(rtWidth, rtHeight, autoResize, ctx);
      }
      /** Allocate the probe G-buffer's position/normal/color attachments and depth texture. */
      crateGBuffer(rtWidth, rtHeight, autoResize, ctx) {
        let attachments = this.renderTargets;
        let rtDescriptors = this.rtDescriptors;
        let positionMap = new RenderTexture(rtWidth, rtHeight, GPUTextureFormat.rgba16float, false, void 0, 1, 0, true, autoResize, ctx);
        positionMap.name = `positionMap`;
        let posDec = new RTDescriptor();
        posDec.loadOp = `load`;
        let normalMap = new RenderTexture(rtWidth, rtHeight, GPUTextureFormat.rgba16float, false, void 0, 1, 0, true, autoResize, ctx);
        normalMap.name = `normalMap`;
        let normalDec = new RTDescriptor();
        normalDec.loadOp = `load`;
        let colorMap = new RenderTexture(rtWidth, rtHeight, GPUTextureFormat.rgba16float, false, void 0, 1, 0, true, autoResize, ctx);
        colorMap.name = `colorMap`;
        let colorDec = new RTDescriptor();
        colorDec.loadOp = `load`;
        let depthTexture = new RenderTexture(rtWidth, rtHeight, GPUTextureFormat.depth32float, false, void 0, 1, 0, true, autoResize, ctx);
        depthTexture.name = `depthTexture`;
        let depthDec = new RTDescriptor();
        depthDec.loadOp = `load`;
        attachments.push(positionMap);
        attachments.push(normalMap);
        attachments.push(colorMap);
        rtDescriptors.push(posDec);
        rtDescriptors.push(normalDec);
        rtDescriptors.push(colorDec);
        this.depthTexture = depthTexture;
      }
    }

    let DDGIIrradiance_shader = (
      /*wgsl*/
      `
#include "GenerayRandomDir"
#include "MathShader"
#include "IrradianceVolumeData_frag"
var<private> PI: f32 = 3.14159265359;

struct ProbeData{
  offsetX:f32,
  offsetY:f32,
  offsetZ:f32,
  frame:f32,
}

 struct Uniforms {
     matrix : array<mat4x4<f32>>
 };

struct RayProbeBuffer{
  WPosition: vec3<f32>,
  WNormal:vec3<f32>,
  WRadiance:vec4<f32>,
}

struct CacheHitData{
  color:vec4<f32>,
  depth:vec4<f32>,
}

//  struct RayInfo{
//   rays:array<vec4<f32>,4096>
//  }

@group(0) @binding(0) var<storage, read> probes : array<ProbeData>;
@group(0) @binding(1) var<storage, read_write> irradianceBuffer : array<vec4<f32>>;
@group(0) @binding(2) var<storage, read_write> depthBuffer : array<vec4<f32>>;
@group(0) @binding(3) var<uniform> uniformData : IrradianceVolumeData ;
@group(0) @binding(4) var probeIrradianceMap : texture_storage_2d<rgba16float, write>;
@group(0) @binding(5) var probeDepthMap : texture_storage_2d<rgba16float, write>;
@group(0) @binding(6) var<storage, read_write> depthRaysBuffer : array<vec4<f32>>;

@group(1) @binding(0) var positionMap : texture_2d<f32>;
@group(1) @binding(1) var normalMap : texture_2d<f32>;
@group(1) @binding(2) var colorMap : texture_2d<f32>;

@group(2) @binding(0)
var<storage, read> models : Uniforms;

var<private> probeID: u32 ;
var<private> workgroup_idx: u32 ;
var<private> workgroup_idy: u32 ;
var<private> hysteresis: f32 = 0.98 ;
var<private> epsilon: f32 = 1e-6 ;
var<private> probeLocation:vec3<f32> = vec3<f32>(0.0);
var<private> energyConservation: f32 = 0.85 ;
var<private> resultIrradiance: vec4<f32> ;
var<private> resultDepth: vec4<f32> ;
var<private> RAYS_PER_PROBE: f32 = 144.0 ;
var<private> OCT_RT_SIZE: u32;
var<private> PROBE_OCT_RT_SIZE: u32;
var<private> OCT_SIDE_SIZE_u32: u32;
var<private> OCT_SIDE_SIZE_f32: f32;
var<private> OCT_RT_SIZE_f32: f32;
var<private> PROBE_SOURCESIZE: f32;
var<private> PROBEMAP_SOURCESIZE: f32;
var<private> quaternion:vec4<f32> = vec4<f32>(0.0, -0.7071067811865475, 0.7071067811865475, 0.0);
var<private> randomMatrix:mat4x4<f32>;

@compute @workgroup_size( 8 , 8 , 1 )
fn CsMain(@builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
   RAYS_PER_PROBE = f32(i32(uniformData.rayNumber));
   OCT_RT_SIZE = u32(uniformData.OctRTMaxSize);
   OCT_RT_SIZE_f32 = f32(uniformData.OctRTMaxSize);
   OCT_SIDE_SIZE_u32 = u32(uniformData.OctRTSideSize);
   OCT_SIDE_SIZE_f32 = f32(uniformData.OctRTSideSize);
   PROBE_SOURCESIZE = f32(uniformData.ProbeSize);
   PROBEMAP_SOURCESIZE = f32(uniformData.ProbeSourceTextureSize);
   hysteresis = uniformData.hysteresis;
    // probe index
    probeID = globalInvocation_id.z ;
    // pixel coord
    workgroup_idx = globalInvocation_id.x ;
    workgroup_idy = globalInvocation_id.y;

    probeLocation = calcProbePosition(probeID);

    resultIrradiance = vec4<f32>(0.0);
    resultDepth = vec4<f32>(0.0,0.0,0.0,0.0);

    var tdr = normalize(getCurrentDir());
    let orientationIndex = u32(uniformData.orientationIndex);
    randomMatrix = models.matrix[orientationIndex];

    var distancePprobeUV = getSampleProbeUV(tdr.xyz);
    var rayUv:vec2<i32> = vec2<i32>(distancePprobeUV.xy * f32(PROBEMAP_SOURCESIZE - 1.0));
    let rayHitPosition = textureLoad(positionMap, rayUv, 0).xyz ;
    
    for(var i:f32 = 0.0; i < RAYS_PER_PROBE ; i = i + 1.0 ){
      radianceProbeOnce(i, tdr);
    }

    if (resultIrradiance.w > epsilon) {
      var color = vec3<f32>(resultIrradiance.xyz/(2.0*resultIrradiance.w)) ;
      color = pow(color.rgb, vec3<f32>(1.0 / uniformData.ddgiGamma));
      resultIrradiance = vec4<f32>(color,1.0-hysteresis);
    }

    // if nonzero
    if (resultDepth.w > epsilon) {
      resultDepth = vec4<f32>(resultDepth.xyz/(2.0*resultDepth.w),1.0-hysteresis) ;
    }

   let pixelCoord = getWriteOctUVByID();

   var lerpDataResult:CacheHitData;

   lerpDataResult.color = resultIrradiance;

   lerpDataResult.depth = resultDepth;

   lerpDataResult = lerpHitData(lerpDataResult, pixelCoord);

   writeRayHitData(pixelCoord, lerpDataResult);

   storePixelAtCoord(probeIrradianceMap, pixelCoord , vec4<f32>(lerpDataResult.color.xyz, 1.0), true);

   storePixelAtCoord(probeDepthMap, pixelCoord , vec4<f32>(resultDepth.xy, 0.0, 1.0), false);
}

fn lerpHitData(data:CacheHitData, coord:vec2<i32>) -> CacheHitData{
   let frameIndex = probes[probeID].frame;
   var newData:CacheHitData = data;

   //if(frameIndex > 1.0){
      var oldData = readRayHitData(coord);
      newData.color = mix(oldData.color, newData.color, uniformData.lerpHysteresis);
      newData.depth = mix(oldData.depth, newData.depth, uniformData.lerpHysteresis);
   //}
   return newData;
}

fn square(v:vec3<f32>) -> vec3<f32>{
   var v3 = v;
   v3.x = v3.x * v3.x;
   v3.y = v3.y * v3.y;
   v3.z = v3.z * v3.z;
   return v3;
}

 fn testSample() ->vec4<f32>{
   var ux = f32(workgroup_idx) / OCT_SIDE_SIZE_f32;
   var uy = f32(workgroup_idy) / OCT_SIDE_SIZE_f32;
   var uv = vec2<f32>(ux,uy) * 2.0 - 1.0 ;
   var dir = octDecode(uv);
   var probeUV = getSampleProbeUV(dir.xyz);
   var rayProbeBuffer = getCurrentRayHitBuffer(probeUV);
   return rayProbeBuffer.WRadiance;
 }

 fn gridCoordToProbeIndex(grid:vec3<i32>) -> i32
 {
     return grid.x + grid.z * i32(uniformData.gridXCount) + grid.y * i32(uniformData.gridXCount * uniformData.gridZCount);
 }

fn storePixelAtCoord(texture:texture_storage_2d<rgba16float, write>, coord:vec2<i32>, color:vec4<f32>, isColor:bool){
   let sideCnt = i32(OCT_SIDE_SIZE_u32);
   let sideBorderCnt = sideCnt + 2;
   let indexXY = coord / sideCnt;
   let modeXY = coord % sideCnt;

   var newCoord = indexXY * sideBorderCnt + modeXY;
   textureStore(texture, newCoord + 1, color);

   var borderCoord = vec2<i32>(-1);
   // left / right borders
   if(modeXY.x % (sideCnt - 1) == 0){
     borderCoord = modeXY;
     borderCoord.y = sideCnt - borderCoord.y;
     if(modeXY.x == sideCnt - 1){
       borderCoord.x = sideBorderCnt - 1;
     }
     borderCoord = indexXY * sideBorderCnt + borderCoord;
     textureStore(texture, borderCoord, color);
   }
   // top / bottom borders
   if(modeXY.y % (sideCnt - 1) == 0){
     borderCoord = modeXY;
     borderCoord.x = sideCnt - borderCoord.x;
     if(modeXY.y == sideCnt - 1){
         borderCoord.y = sideBorderCnt - 1;
     }
     borderCoord = indexXY * sideBorderCnt + borderCoord;
     textureStore(texture, borderCoord, color);
   }
   // corner pixels
   if(modeXY.x % (sideCnt - 1) == 0 && modeXY.y % (sideCnt - 1) == 0){
      var cornerCoord = modeXY;
      if(modeXY.x == 0){
         cornerCoord.x = sideBorderCnt - 1;
      }else{
         cornerCoord.x = 0;
      }
       if(modeXY.y == 0){
         cornerCoord.y = sideBorderCnt - 1;
      }else{
         cornerCoord.y = 0;
      }
      cornerCoord = indexXY * sideBorderCnt + cornerCoord;
      textureStore(texture, cornerCoord, color);
   }
}

fn calcProbePosition(id:u32) -> vec3<f32>{
   var probeLocation = vec3<f32>(0.0);
   var blockCount = u32(uniformData.gridXCount * uniformData.gridZCount) ;
   var grid = vec3<u32>(0u);
   grid.x = (id % blockCount) % u32(uniformData.gridXCount);
   grid.y = id / blockCount;
   grid.z = (id % blockCount) / u32(uniformData.gridXCount);
   probeLocation.x = f32(grid.x) * uniformData.ProbeSpace + uniformData.startX;
   probeLocation.y = f32(grid.y) * uniformData.ProbeSpace + uniformData.startY;
   probeLocation.z = f32(grid.z) * uniformData.ProbeSpace + uniformData.startZ;
   return probeLocation;
}

fn getWriteOctUVByID() -> vec2<i32>
{
   var blockCount = u32(uniformData.gridXCount * uniformData.gridZCount) ;
   var offsetX = (probeID % blockCount) % u32(uniformData.gridXCount) ;
   var offsetY = u32(uniformData.gridZCount - 1.0) - (probeID % blockCount) / u32(uniformData.gridXCount) ;
   var offsetZ = probeID / blockCount ;
   var pixelCoord = vec2<i32>(i32(workgroup_idx), i32(workgroup_idy));
   pixelCoord.x = pixelCoord.x + i32(offsetX * OCT_SIDE_SIZE_u32);
   pixelCoord.y = pixelCoord.y + i32(offsetY * OCT_SIDE_SIZE_u32 + offsetZ * u32(uniformData.gridZCount) * OCT_SIDE_SIZE_u32);

   pixelCoord = offsetByCol(pixelCoord, OCT_SIDE_SIZE_f32, OCT_RT_SIZE, vec3<f32>(uniformData.gridXCount, uniformData.gridYCount, uniformData.gridZCount));
   return pixelCoord;
}

fn offsetByCol(pixelCoord0:vec2<i32>, octSideSize:f32, mapHeight:u32, counts:vec3<f32>) -> vec2<i32>
{
 var pixelCoord = pixelCoord0;
 let blockSize:vec2<i32> = vec2<i32>(i32(octSideSize * counts.x),  i32(octSideSize * counts.z));
 let blockSizeYBorder:i32 = i32((octSideSize + 2.0) * counts.z);
 let blockMaxRowBorder:i32 = i32(mapHeight) / blockSizeYBorder;
 let pixelCountYMax:i32 = blockMaxRowBorder * i32(octSideSize * counts.z);
 let col:i32 = pixelCoord.y / pixelCountYMax;

 pixelCoord.x = col * i32(octSideSize * counts.x) + pixelCoord.x;
 pixelCoord.y = pixelCoord.y % pixelCountYMax;

 return pixelCoord;
}

fn radianceProbeOnce(rayID:f32, tdr:vec3<f32>){
   var texelDirection = sphericalFibonacci(rayID, RAYS_PER_PROBE ) ;
   var rayDirection = normalize( vec3<f32>((randomMatrix * vec4<f32>(texelDirection, 1.0)).xyz));
   var probeUV = getSampleProbeUV(rayDirection.xyz);
   var rayWriteUV = getWriteRayInfoUV();

   var rayProbeBuffer = getCurrentRayHitBuffer(probeUV);
   var rayHitLocation = rayProbeBuffer.WPosition + normalize(rayProbeBuffer.WNormal) * 0.01;

   var rayProbeDistance = length(probeLocation - rayHitLocation) ;
   // rayProbeDistance = min(uniformData.ProbeSpace * 4.0, rayProbeDistance) ;

   // if (dot(rayProbeBuffer.WNormal, rayProbeBuffer.WNormal) < epsilon) {
   //   rayProbeDistance = epsilon ;
   // }

   let rid = i32(probeID) * i32(RAYS_PER_PROBE) + i32(rayID) ;
   depthRaysBuffer[rid] = vec4<f32>(rayDirection.xyz,rayProbeDistance) ;

   // Detect misses and force depth
   var i_weight = max(0.0, dot(tdr,rayDirection) );
   var d_weight = pow(i_weight, uniformData.depthSharpness);
   
   if (i_weight >= epsilon) {
     //  var weightColor = pow(weight, (2.0 - uniformData.probeRoughness) * 2.0);
      resultIrradiance += vec4(rayProbeBuffer.WRadiance.rgb, i_weight );
     
   }
   if(d_weight>= epsilon){
       resultDepth += vec4(rayProbeDistance * d_weight, rayProbeDistance * rayProbeDistance * d_weight, 0.0 , i_weight);
   }
}

fn getCurrentRayHitBuffer(probeUV:vec2<f32>) -> RayProbeBuffer {
  var rayProbeBuffer : RayProbeBuffer ;
  var uv:vec2<i32> = vec2<i32>(probeUV.xy * f32(PROBEMAP_SOURCESIZE - 1.0));
  rayProbeBuffer.WPosition = textureLoad(positionMap, uv, 0).xyz ;
  rayProbeBuffer.WNormal = normalize(textureLoad(normalMap, uv, 0).xyz * 2.0 - 1.0);
  rayProbeBuffer.WRadiance = textureLoad(colorMap, uv, 0).xyzw * energyConservation;
  return rayProbeBuffer ;
}

fn getSampleProbeUV(dir0:vec3<f32>) -> vec2<f32> {
   var dir = applyQuaternion(dir0, quaternion);
   let faceId = dir_to_faceId(dir);
   var targetUV:vec2<f32> = convert_xyz_to_cube_uv(dir.x, dir.y, dir.z);
   targetUV.x = 1.0 - targetUV.x;
   let threshould = 0.5 / PROBE_SOURCESIZE;
   targetUV = clamp(targetUV, vec2<f32>(threshould), vec2<f32>(1.0 - threshould));

   targetUV.x = f32(faceId) + targetUV.x;

   let aspect:f32 = PROBE_SOURCESIZE / PROBEMAP_SOURCESIZE;
   targetUV = targetUV * aspect ;

   var fullCol = u32(PROBEMAP_SOURCESIZE) / u32(PROBE_SOURCESIZE);
   var offsetSampleUv = vec2<f32>( f32(probeID / fullCol) * 6.0 , f32(probeID % fullCol)) * aspect;
   return targetUV + offsetSampleUv;
}

fn getWriteRayInfoUV() -> vec2<i32> {
  var writeUV = vec2<i32>(i32(workgroup_idy),i32(probeID)) ;
  return writeUV ;
}

fn writeRayHitData( uv:vec2<i32> , data:CacheHitData){
  let index = uv.y * i32(OCT_RT_SIZE) + uv.x ;
  irradianceBuffer[index] = data.color ;
  depthBuffer[index] = data.depth ;
}

fn readRayHitData( uv:vec2<i32> ) -> CacheHitData{
  var data:CacheHitData;
  let index = uv.y * i32(OCT_RT_SIZE) + uv.x ;
  data.color = irradianceBuffer[index] ;
  data.depth = depthBuffer[index] ;
  return data;
}

fn getCurrentDir() -> vec3<f32> {
  var ux = f32(workgroup_idx) / OCT_SIDE_SIZE_f32;
  var uy = f32(workgroup_idy) / OCT_SIDE_SIZE_f32;
  var uv = vec2<f32>(ux,uy) * 2.0 - 1.0 ;
  var dir = octDecode(uv) ;
  return normalize(dir) ;
}


`
    );

    class DDGIIrradianceComputePass {
      irradianceBuffer;
      depthBuffer;
      probeIrradianceMap;
      probeDepthMap;
      volume;
      computeShader;
      depthRaysBuffer;
      _ctx;
      constructor(ctx, volume) {
        this._ctx = ctx;
        this.volume = volume;
        this.initPipeline();
      }
      initPipeline() {
        this.computeShader = new ComputeShader(DDGIIrradiance_shader);
        let giSetting = this._ctx.engine.setting.gi;
        let pixelCount = giSetting.octRTMaxSize * giSetting.octRTMaxSize;
        this.irradianceBuffer = new StorageGPUBuffer(pixelCount * 4, GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST);
        this.computeShader.setStorageBuffer(`irradianceBuffer`, this.irradianceBuffer);
        this.depthBuffer = new StorageGPUBuffer(pixelCount * 4, GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST);
        this.computeShader.setStorageBuffer(`depthBuffer`, this.depthBuffer);
        this.depthRaysBuffer = new StorageGPUBuffer(4096 * 4 * 2 * 2 * 2, GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC);
        this.computeShader.setStorageBuffer(`depthRaysBuffer`, this.depthRaysBuffer);
        this.computeShader.setStorageBuffer(`probes`, this.volume.probesBuffer);
        this.computeShader.setUniformBuffer(`uniformData`, this.volume.irradianceVolumeBuffer);
        this.computeShader.setStorageBuffer("models", GlobalBindGroup.getModelMatrixBindGroup(this._ctx).matrixBufferDst);
      }
      setTextures(inputs, probeIrradianceMap, probeDepthMap) {
        this.probeIrradianceMap = probeIrradianceMap;
        this.probeDepthMap = probeDepthMap;
        let worldPosMap = inputs[0];
        let worldNormalMap = inputs[1];
        let colorMap = inputs[2];
        this.computeShader.setStorageTexture(`probeIrradianceMap`, this.probeIrradianceMap);
        this.computeShader.setStorageTexture(`probeDepthMap`, this.probeDepthMap);
        this.computeShader.setSamplerTexture(`positionMap`, worldPosMap);
        this.computeShader.setSamplerTexture(`normalMap`, worldNormalMap);
        this.computeShader.setSamplerTexture(`colorMap`, colorMap);
      }
      readBuffer() {
        return this.depthRaysBuffer.readBuffer();
      }
      compute(view, renderPassState) {
        const gpu = view.engine3D.context3D.gpuContext;
        let setting = this.volume.setting;
        let command = gpu.beginCommandEncoder();
        let probes = EntityCollect.instance.getProbes(view.scene);
        this.computeShader.workerSizeX = setting.octRTSideSize / 8;
        this.computeShader.workerSizeY = setting.octRTSideSize / 8;
        this.computeShader.workerSizeZ = probes.length;
        gpu.computeCommand(command, [this.computeShader]);
        gpu.endCommandEncoder(command);
      }
    }

    let DDGILighting_shader = (
      /*wgsl*/
      `
var<private> PI: f32 = 3.14159265359;

#include "GlobalUniform"
#include "MathShader"
#include "FastMathShader"
#include "ColorUtil_frag"

struct ConstUniform{
   screenWidth:f32,
   screenHeight:f32
}

#include "LightData"

struct Uniforms {
     matrix : array<mat4x4<f32>>
 };

const PointLightType = 1;
const DirectLightType = 2;
const SpotLightType = 3;

@group(0) @binding(auto) var outputBuffer : texture_storage_2d<rgba16float, write>;
@group(0) @binding(auto) var prefilterMapSampler: sampler;
@group(0) @binding(auto) var prefilterMap: texture_cube<f32>;

@group(1) @binding(auto) var positionMapSampler : sampler;
@group(1) @binding(auto) var positionMap : texture_2d<f32>;

@group(1) @binding(auto) var normalMapSampler : sampler;
@group(1) @binding(auto) var normalMap : texture_2d<f32>;

@group(1) @binding(auto) var colorMapSampler : sampler;
@group(1) @binding(auto) var colorMap : texture_2d<f32>;

@group(1) @binding(auto) var shadowMapSampler : sampler_comparison;
@group(1) @binding(auto) var shadowMap : texture_depth_2d_array;
@group(1) @binding(auto) var pointShadowMapSampler: sampler_comparison;
@group(1) @binding(auto) var pointShadowMap: texture_depth_cube_array ;

@group(2) @binding(0)
var<storage,read> lightBuffer: array<LightData>;

@group(2) @binding(1)
var<storage, read> models : Uniforms;

struct ShadowStruct{
 directShadowVisibility:f32,
 pointShadows:array<f32,8>,
}

var<private> shadowStrut: ShadowStruct ;
var<private> ulitColor:vec3<f32>;
var<private> wPosition:vec3<f32>;
var<private> wNormal:vec3<f32>;

const LUMEN = 10.764;

fn samplePosition(uv:vec2<f32>) -> vec4<f32>
{
   return textureSampleLevel(positionMap, positionMapSampler,uv, 0.0);
}

fn sampleNormal(uv:vec2<f32>) -> vec4<f32>
{
  return textureSampleLevel(normalMap, normalMapSampler, uv, 0.0);
}

fn sampleColor(uv:vec2<f32>) -> vec4<f32>
{
   var oc:vec4<f32> = textureSampleLevel(colorMap, colorMapSampler, uv, 0.0);
   ulitColor = vec3(oc.xyz);
   return oc;
}

const csmCount:i32 = ${CSM.Cascades} ;
fn directShadowMaping(P:vec3<f32>, N:vec3<f32>, shadowBias: f32)  {
  let enableCSM:bool = globalUniform.enableCSM > 0.5;
  var light = lightBuffer[0];
  var visibility = 1.0;
    var shadowIndex = i32(light.castShadow);
    if (shadowIndex >= 0 ) {
      var shadowMatrix:mat4x4<f32>;
      if(enableCSM && csmCount > 1){
        for(var csm:i32 = 0; csm < csmCount; csm ++){
          var csmShadowBias = globalUniform.csmShadowBias[csm];
          shadowMatrix = globalUniform.csmMatrix[csm];
          let csmShadowResult = directShadowMapingIndex(light, shadowMatrix, P, N, csm, csmShadowBias);
          if(csmShadowResult.y < 0.5){
            visibility = csmShadowResult.x;
            break;
          }
        }
      }else{
        shadowMatrix = globalUniform.shadowMatrix[shadowIndex];
        visibility = directShadowMapingIndex(light, shadowMatrix, P, N, shadowIndex, shadowBias).x;
      }
    }
  shadowStrut.directShadowVisibility = visibility;
}

fn directShadowMapingIndex(light:LightData, matrix:mat4x4<f32>, P:vec3<f32>, N:vec3<f32>, depthTexIndex:i32, shadowBias:f32) -> vec2<f32>
{
  var visibility = 1.0;
  var isOutSideArea:f32 = 1.0;
  var shadowPosTmp = matrix * vec4<f32>(P.xyz, 1.0);
  var shadowPos = shadowPosTmp.xyz / shadowPosTmp.w;
  var varying_shadowUV = shadowPos.xy * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5, 0.5);
  if (varying_shadowUV.x <= 1.0
    && varying_shadowUV.x >= 0.0
    && varying_shadowUV.y <= 1.0
    && varying_shadowUV.y >= 0.0
    && shadowPosTmp.z <= 1.0
    && shadowPosTmp.z >= 0.0)
  {
    isOutSideArea = 0.0;
    var uvOnePixel = 1.0 / vec2<f32>(globalUniform.shadowMapSize);
    var NoL = abs(dot(N, normalize(light.direction)));
    var bias = shadowBias / max(NoL, 0.000001);
    visibility = textureSampleCompareLevel(shadowMap, shadowMapSampler, varying_shadowUV, depthTexIndex, shadowPos.z - bias);
    visibility += 0.001;
  }
  return vec2<f32>(visibility, isOutSideArea);
}

fn pointShadowMapCompare(shadowBias:f32){
   for(var i:i32 = i32(0) ; i < i32(8); i = i + 1 )
   { 
       var v = 1.0 ;
       let light = lightBuffer[i] ;
       if(light.castShadow < 0 ){
         shadowStrut.pointShadows[i] = v ;
         continue ;
       }

       let frgToLight = wPosition - light.position.xyz;
       var dir:vec3<f32> = normalize(frgToLight)  ;

       var len = length(frgToLight) ;
       let compareZ = (len - shadowBias) / globalUniform.far;
       var depth = textureSampleCompareLevel(pointShadowMap,pointShadowMapSampler,dir.xyz,i,compareZ); 
       if(depth < 0.5){
          v = 0.0 ; 
       }
       shadowStrut.pointShadows[i] = v ;
   }
} 

fn directLighting( albedo:vec3<f32> , WP :vec3<f32>, N:vec3<f32> , V:vec3<f32> , light:LightData , shadowBias:f32  ) -> vec3<f32> {
 var L = -normalize(light.direction.xyz) ;
 var NoL = max(dot(N,L),0.0);
 let lightCC = pow( light.lightColor.rgb,vec3<f32>(2.2));
 var lightColor = getHDRColor( lightCC , light.linear ) ;
 var att = light.intensity / LUMEN ;
 if(light.castShadow>=0){
     lightColor *= shadowStrut.directShadowVisibility ;
 }
 let finalLight = (albedo / PI) * lightColor * NoL * att * 2.0 ;
 return finalLight ;
}

fn pointLighting( albedo:vec3<f32>,WP:vec3<f32>, N:vec3<f32>, V:vec3<f32>, light:LightData ) -> vec3<f32> {
 let lightPos = models.matrix[u32(light.lightMatrixIndex)][3].xyz;
 var dir = lightPos.xyz - WP ;
 let dist = length(dir);
 var color = vec3<f32>(0.0) ;

 if(dist != 0.0){
   dir *= 1.0 / dist ;
 }

 if( abs(dist) < light.range ){
     var L = dir ;
     var atten = 1.0 ;
     atten = 1.0 - smoothstep(0.0,light.range,dist) ;
     atten *= 1.0 / max(light.radius,0.0001) ;

     var lightColor = light.lightColor.rgb  ;
     lightColor = getHDRColor(lightColor , light.linear ) * light.intensity / LUMEN * 2.0;
     color = (albedo / PI) * lightColor.rgb * atten ;
 }

 return  color *0.0;
}

fn spotLight( albedo:vec3<f32>,WP:vec3<f32>, N:vec3<f32>, V:vec3<f32>, light:LightData ) -> vec3<f32> {
 let lightPos = models.matrix[u32(light.lightMatrixIndex)][3].xyz;
 var dir = lightPos.xyz - WP ;
 let dist = length(dir) ;

 if(dist != 0.0){
   dir *= 1.0 / dist ;
 }

 var color = vec3<f32>(0.0) ;
 if( abs(dist) < light.range * 2.0 ){
     var L = dir ;
     let theta = dot(-L, normalize(light.direction));
     let angle = acos(theta) ;
     var atten = 1.0 ;
     atten = 1.0 - smoothstep(0.0,light.range,dist) ;
     atten *= 1.0 / max(light.radius,0.1) ;
     if(angle < light.outerCutOff){
       if(angle > light.innerCutOff){
         atten *= 1.0 - smoothstep(light.innerCutOff, light.outerCutOff, angle) ;
       }
     }else{
       atten = 0.0 ;
     }
     var lightColor = light.lightColor.rgb  ;
     lightColor = getHDRColor(lightColor , light.linear ) * light.intensity / LUMEN * 2.0;
     color = (albedo / PI) * lightColor.rgb * atten ;
   }
 return  color ;
}

fn CalcUV_01(coord:vec2<i32>, texSize:vec2<u32>) -> vec2<f32>
{
  let u = (f32(coord.x) + 0.5) / f32(texSize.x);
  let v = (f32(coord.y) + 0.5) / f32(texSize.y);
  return vec2<f32>(u, v);
}

fn coordFun(fragCoord:vec2<i32>)-> vec4<f32>{
 let uv_01 = CalcUV_01(fragCoord, texSize);
 var pos = samplePosition(uv_01);

 var normalMap = sampleNormal(uv_01);
 var normal = normalize( normalMap.xyz * 2.0 - 1.0 );

 var color = sampleColor(uv_01);
 var emissive = vec4<f32>(pos.a,normalMap.a,color.a,0.0) * 1.0 ;
 if(pos.w + 1.0 > 10000.0){
   return vec4<f32>(color);
 }
 var V = normalize(pos.xyz - globalUniform.cameraWorldMatrix[3].xyz);
 var N = normal.xyz ;

 wPosition = pos.xyz;
 wNormal = N;

 directShadowMaping(wPosition, wNormal, globalUniform.shadowBias);
 pointShadowMapCompare(globalUniform.shadowBias);

 var lighting = vec3<f32>(0.0);
 let lightCount = 32 ;
 for(var i:i32 = 0 ; i < lightCount ; i = i + 1 )
 {
     let light = lightBuffer[i];
     switch (light.lightType) {
         case PointLightType: {
             lighting += pointLighting(color.rgb,pos.xyz,N,V,light);
         }
         case DirectLightType: {
             lighting += directLighting(color.rgb,pos.xyz,N,V,light,globalUniform.shadowBias);
         }
         case SpotLightType: {
             lighting += spotLight(color.rgb,pos.xyz,N,V,light);
         }
         default: {
         }
     }
 }

 // lighting = vec3<f32>(1.0) / (vec3<f32>(1.0) + lighting.rgb) * lighting.rgb;

 var skyLight: vec3<f32> = globalUniform.skyExposure * (textureSampleLevel(prefilterMap, prefilterMapSampler, N.xyz, 8.0 ).rgb);
 // skyLight = LinearToGammaSpace(skyLight);
 // skyLight = (color.rgb / 3.1415926 ) * skyLight;
 // skyLight = vec3<f32>(1.0) / (vec3<f32>(1.0) + skyLight.rgb) * skyLight.rgb;

 lighting = lighting.rgb ;//+ skyLight.rgb ;

 return vec4<f32>(lighting.rgb,color.w)+emissive;
}

// fn vertexToCoord(vertexPosition:vec3<f32>) -> vec4<f32>{
//   var worldPos = vec4<f32>(vertexPosition.xyz, 1.0);
//   var fragPosition = globalUniform.viewMat * worldPos ;
//   // var position = globalUniform.projMat * fragPosition ;
//   return fragPosition;
// }

var<private> texSize: vec2<u32>;

@compute @workgroup_size( 8 , 8 , 1 )
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
   var fragCoord = vec2<i32>(globalInvocation_id.xy);
   texSize = textureDimensions(colorMap).xy;
   var color = coordFun(fragCoord);
   // color = vec4(pow(color.rgb,vec3<f32>(1.0/2.4)),1.0);
   textureStore(outputBuffer, fragCoord, color);
}

`
    );

    class DDGILightingPass {
      computeShader;
      worldPosMap;
      worldNormalMap;
      colorMap;
      shadowMap;
      pointShadowMap;
      lightingTexture;
      constructor(ctx) {
        let giSetting = ctx.engine.setting.gi;
        this.lightingTexture = new RenderTexture(giSetting.probeSourceTextureSize, giSetting.probeSourceTextureSize, GPUTextureFormat.rgba16float, false, GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.STORAGE_BINDING, 1, 0, true, true, ctx);
      }
      create(view) {
        let lightUniformEntries = GlobalBindGroup.getLightEntries(view.scene);
        this.computeShader = new ComputeShader(DDGILighting_shader);
        let cameraBindGroup = GlobalBindGroup.getCameraGroup(view.camera);
        this.computeShader.setUniformBuffer("globalUniform", cameraBindGroup.uniformGPUBuffer);
        this.computeShader.setStorageTexture("outputBuffer", this.lightingTexture);
        this.computeShader.setStorageBuffer("lightBuffer", lightUniformEntries.storageGPUBuffer);
        this.computeShader.setStorageBuffer("models", GlobalBindGroup.getModelMatrixBindGroup(view.engine3D.context3D).matrixBufferDst);
        this.computeShader.setSamplerTexture("positionMap", this.worldPosMap);
        this.computeShader.setSamplerTexture("normalMap", this.worldNormalMap);
        this.computeShader.setSamplerTexture("colorMap", this.colorMap);
        this.computeShader.setSamplerTexture("shadowMap", this.shadowMap);
        this.computeShader.setSamplerTexture("pointShadowMap", this.pointShadowMap);
        this.computeShader.setSamplerTexture("prefilterMap", Engine3D.resFor(view.engine3D.context3D).defaultSky);
      }
      setInputs(inputs) {
        this.worldPosMap = inputs[0];
        this.worldNormalMap = inputs[1];
        this.colorMap = inputs[2];
        this.shadowMap = inputs[3];
        this.pointShadowMap = inputs[4];
      }
      compute(view, renderPassState) {
        if (!this.computeShader) {
          this.create(view);
        }
        const gpu = view.engine3D.context3D.gpuContext;
        let command = gpu.beginCommandEncoder();
        let giSetting = view.engine3D.setting.gi;
        this.computeShader.workerSizeX = giSetting.probeSourceTextureSize / 8;
        this.computeShader.workerSizeY = giSetting.probeSourceTextureSize / 8;
        this.computeShader.workerSizeZ = 1;
        gpu.computeCommand(command, [this.computeShader]);
        gpu.endCommandEncoder(command);
      }
    }

    let MultiBouncePass_cs = (
      /*wgsl*/
      `
  #include "MathShader"
  #include "IrradianceVolumeData_frag"

  struct IrradianceField {
      probeStartPosition: vec4<f32>,
      probeCounts:vec4<f32>,
      probeStep:f32,
      irradianceTextureWidth:f32,
      irradianceTextureHeight:f32,
      irradianceProbeSideLength:f32,
  };

  @group(0) @binding(0) var outputBuffer : texture_storage_2d<rgba16float, write>;
  @group(0) @binding(1) var<uniform> uniformData : IrradianceVolumeData ;

  @group(1) @binding(0) var normalMapSampler : sampler;
  @group(1) @binding(1) var normalMap : texture_2d<f32>;

  @group(1) @binding(2) var colorMapSampler : sampler;
  @group(1) @binding(3) var colorMap : texture_2d<f32>;

  @group(1) @binding(4) var litMapSampler : sampler;
  @group(1) @binding(5) var litMap : texture_2d<f32>;

  @group(1) @binding(6) var irradianceMapSampler : sampler;
  @group(1) @binding(7) var irradianceMap : texture_2d<f32>;

  var<private> wsn:vec3<f32>;
  var<private> ulitColor:vec4<f32>;
  var<private> litColor:vec4<f32>;
  var<private> irradianceFieldSurface : IrradianceField ;
  var<private> probeID:u32;

  var<private> quaternion:vec4<f32> = vec4<f32>(0.0, -0.7071067811865475, 0.7071067811865475, 0.0);

  fn getIrradianceFieldSurface() -> IrradianceField{
    let data = uniformData;
    irradianceFieldSurface.probeStartPosition = vec4<f32>(data.startX, data.startY, data.startZ, 0.0);
    irradianceFieldSurface.probeCounts = vec4<f32>(data.gridXCount, data.gridYCount, data.gridZCount, 0.0);
    irradianceFieldSurface.probeStep = data.ProbeSpace;
    irradianceFieldSurface.irradianceTextureWidth = data.OctRTMaxSize;
    irradianceFieldSurface.irradianceTextureHeight = data.OctRTMaxSize;
    irradianceFieldSurface.irradianceProbeSideLength = data.OctRTSideSize;
    return irradianceFieldSurface;
  }

  fn rotateDir(n:vec3<f32>) -> vec3<f32>{
     return normalize(applyQuaternion(-n, quaternion));
  }

  fn sampleLitColor(uv:vec2<i32>) -> vec4<f32>
  {
      var oc1:vec4<f32> = textureSampleLevel(litMap, litMapSampler, vec2<f32>(0.0), 0.0);
      var oc:vec4<f32> = textureLoad(litMap, uv, 0);
      return oc;
  }

  fn sampleNormal(uv:vec2<i32>) -> vec4<f32>
  {
      var oc1:vec4<f32> = textureSampleLevel(normalMap, normalMapSampler, vec2<f32>(0.0), 0.0);
      var oc:vec4<f32> = textureLoad(normalMap, uv, 0);
      return oc;
  }

  fn sampleColor(uv:vec2<i32>) -> vec4<f32>
  {
      var oc1:vec4<f32> = textureSampleLevel(colorMap, colorMapSampler, vec2<f32>(0.0), 0.0);
      var oc:vec4<f32> = textureLoad(colorMap, uv, 0);
      return oc;
  }

  fn sampleProbe(fragCoord:vec2<u32>){
    var uv = vec2<i32>(i32(fragCoord.x), i32(fragCoord.y)) ;

    litColor = sampleLitColor(uv);

    var normalMap = sampleNormal(uv);
    wsn = normalMap.xyz * 2.0 - 1.0;

    ulitColor = sampleColor(uv);
  }

  @compute @workgroup_size( 8 , 8 , 1 )
  fn CsMain(@builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
  {
    getIrradianceFieldSurface();
    var fragCoord = vec2<u32>( globalInvocation_id.x, globalInvocation_id.y);
    probeID = globalInvocation_id.z;
    fragCoord = fragCoord + getCoordOffset(probeID);

    sampleProbe(fragCoord);

    let irradiance = getIrradianceColor();
    let result = blendIrradianceColor(irradiance);
    textureStore(outputBuffer, vec2<i32>(fragCoord), result);
  }

  fn blendIrradianceColor(irradiance:vec4<f32>) -> vec4<f32>{
     var bounceColor = irradiance * ulitColor;
     let bounceIntensity = getBounceIntensity(uniformData.bounceIntensity);
     let conservation1 = 1.0 / sqrt((1.0 + bounceIntensity * 0.55));
     let conservation2 = 1.0 / sqrt((1.0 + bounceIntensity));
     var result = litColor * conservation2 + bounceColor * sqrt(bounceIntensity) * conservation1;
     return vec4<f32>(result.xyz, litColor.w);
  }

  fn getBounceIntensity(intensity:f32) -> f32 {
    var value = clamp(intensity, 0.0, 1.0) * 10.0;
    return value;
  }

  fn getCoordOffset(id:u32) -> vec2<u32>{
      var fullCol = u32(uniformData.ProbeSourceTextureSize / uniformData.ProbeSize);
      var offsetSampleUv = vec2<u32>( (id / fullCol) * 6u , id % fullCol) * u32(uniformData.ProbeSize);
      return offsetSampleUv;
  }

  fn getIrradianceColor() -> vec4<f32>{
     var probeIrradiance: vec4<f32> = vec4<f32>(0.0);
     if(length(wsn) > 0.01){
       probeIrradiance = getIrrdiaceIndex(i32(probeID), wsn);
     }
     return probeIrradiance;
  }

  fn getIrrdiaceIndex(index:i32, wsn:vec3<f32>) -> vec4<f32>{
    var wsN = rotateDir(wsn.xyz);
    var texCoord:vec2<f32> = textureCoordFromDirection(wsN,
      index,
      irradianceFieldSurface.irradianceTextureWidth,
      irradianceFieldSurface.irradianceTextureHeight,
      irradianceFieldSurface.irradianceProbeSideLength);

    var probeIrradiance: vec3<f32> = textureSampleLevel(irradianceMap, irradianceMapSampler, texCoord, 0.0).xyz;
    return vec4<f32>(probeIrradiance, 1.0);
  }

  fn textureCoordFromDirection(dir:vec3<f32>, probeIndex:i32, width:f32, height:f32, sideLength:f32) -> vec2<f32>
  {
      var uv = getWriteOctUVByID(dir, u32(probeIndex), sideLength) ;
      uv.x = uv.x / irradianceFieldSurface.irradianceTextureWidth;
      uv.y = uv.y / irradianceFieldSurface.irradianceTextureHeight;
      return uv ;
  }

  fn getWriteOctUVByID(dir:vec3<f32> , probeID:u32, size: f32) -> vec2<f32>
  {
      var blockCount = u32(irradianceFieldSurface.probeCounts.x * irradianceFieldSurface.probeCounts.z) ;
      var offsetX = (probeID % blockCount) % u32(irradianceFieldSurface.probeCounts.x) ;
      var offsetY = u32(irradianceFieldSurface.probeCounts.z - 1.0) - (probeID % blockCount) / u32(irradianceFieldSurface.probeCounts.x) ;
      var offsetZ = probeID / blockCount ;

      var pixelCoord = (( octEncode(dir) + 1.0 ) * 0.5) * vec2<f32>(size,size) ;

      var blockOffset = vec2<f32>(0.0);
      blockOffset.x = f32(offsetX) * size;
      blockOffset.y = f32(offsetY) * size + f32(offsetZ) * f32(irradianceFieldSurface.probeCounts.z) * size;

      let mapHeight = u32(irradianceFieldSurface.irradianceTextureHeight);
      var probeCounts:vec3<f32> = vec3<f32>(irradianceFieldSurface.probeCounts.xyz);

      var gridOffsetFrom = vec2<i32>(blockOffset) + 1;
      var gridOffsetTo = offsetByCol(gridOffsetFrom, size, mapHeight, probeCounts);

      pixelCoord = pixelCoord + vec2<f32>(gridOffsetTo - 1) + vec2<f32>(vec2<i32>(vec2<f32>(gridOffsetTo) / size) * 2);

      return pixelCoord + 1.0 ;
  }

  fn offsetByCol(pixelCoord0:vec2<i32>, octSideSize:f32, mapHeight:u32, counts:vec3<f32>) -> vec2<i32>
  {
    var pixelCoord = pixelCoord0;
    let blockSize:vec2<i32> = vec2<i32>(i32(octSideSize * counts.x),  i32(octSideSize * counts.z));
    let blockSizeYBorder:i32 = i32((octSideSize + 2.0) * counts.z);
    let blockMaxRowBorder:i32 = i32(mapHeight) / blockSizeYBorder;
    let pixelCountYMax:i32 = blockMaxRowBorder * i32(octSideSize * counts.z);
    let col:i32 = pixelCoord.y / pixelCountYMax;

    pixelCoord.x = col * i32(octSideSize * counts.x) + pixelCoord.x;
    pixelCoord.y = pixelCoord.y % pixelCountYMax;

    return pixelCoord;
  }
`
    );

    class DDGIMultiBouncePass {
      blendTexture;
      volume;
      computerShader;
      constructor(volume, ctx) {
        this.volume = volume;
        this.initPipeline(ctx);
      }
      initPipeline(ctx) {
        let giSetting = ctx.engine.setting.gi;
        this.blendTexture = new RenderTexture(giSetting.probeSourceTextureSize, giSetting.probeSourceTextureSize, GPUTextureFormat.rgba16float, false, GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.STORAGE_BINDING, 1, 0, true, true, ctx);
        this.computerShader = new ComputeShader(MultiBouncePass_cs);
        this.computerShader.setStorageTexture("outputBuffer", this.blendTexture);
        this.computerShader.setUniformBuffer("uniformData", this.volume.irradianceVolumeBuffer);
      }
      setInputs(inputs) {
        let worldNormalMap = inputs[0];
        let colorMap = inputs[1];
        let lightingMap = inputs[2];
        let irradianceMap = inputs[3];
        this.computerShader.setSamplerTexture("normalMap", worldNormalMap);
        this.computerShader.setSamplerTexture("colorMap", colorMap);
        this.computerShader.setSamplerTexture("litMap", lightingMap);
        this.computerShader.setSamplerTexture("irradianceMap", irradianceMap);
      }
      compute(view, renderPassState) {
        const gpu = view.engine3D.context3D.gpuContext;
        let command = gpu.beginCommandEncoder();
        let setting = this.volume.setting;
        let probesCount = setting.probeXCount * setting.probeYCount * setting.probeZCount;
        let probeSourceSize = setting.probeSize;
        this.computerShader.workerSizeX = probeSourceSize * 6 / 8;
        this.computerShader.workerSizeY = probeSourceSize / 8;
        this.computerShader.workerSizeZ = probesCount;
        gpu.computeCommand(command, [this.computerShader]);
        gpu.endCommandEncoder(command);
      }
    }

    const DDGI_IRRADIANCE_MAP = "_DDGIIrradianceMap";
    const DDGI_DEPTH_MAP = "_DDGIDepthMap";
    const GIRenderStartEvent = new CEvent("GIRenderStartEvent");
    const GIRenderCompleteEvent = new CEvent("GIRenderCompleteEvent");
    class ProbeRenderResult {
      count = 0;
      complete = false;
    }
    class GIPass extends RenderGraphPass {
      name = "GIPass";
      positionMap;
      normalMap;
      colorMap;
      irradianceColorMap;
      irradianceDepthMap;
      probeNext;
      sizeW;
      sizeH;
      lightingPass = null;
      bouncePass = null;
      irradianceComputePass = null;
      _passType = PassType.GI;
      _volume;
      _cubeCamera;
      _renderContext;
      _rendererPassState;
      _probeGBufferFrame;
      _probeCountPerFrame = 1;
      _nextProbeIndex = -1;
      _tempProbeList = [];
      _isRenderCloudGI = false;
      _renderStatus = "none";
      _probeRenderResult = new ProbeRenderResult();
      setup(b) {
        const view = b.view;
        const ctx = b.context3D;
        const lightEntries = GlobalBindGroup.getLightEntries(view.scene);
        this._volume = lightEntries.irradianceVolume;
        const giSetting = this._volume.setting;
        this.sizeW = giSetting.probeSourceTextureSize;
        this.sizeH = giSetting.probeSourceTextureSize;
        this.probeNext = giSetting.probeSourceTextureSize / giSetting.probeSize;
        this._cubeCamera = new CubeCamera(0.01, 5e3);
        this._cubeCamera.bindCtx(ctx);
        const usage = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST;
        this.irradianceDepthMap = new RenderTexture(giSetting.octRTMaxSize, giSetting.octRTMaxSize, GPUTextureFormat.rgba16float, false, usage, 1, 0, true, true, ctx);
        this.irradianceDepthMap.name = "irradianceDepthMap";
        this.irradianceColorMap = new RenderTexture(giSetting.octRTMaxSize, giSetting.octRTMaxSize, GPUTextureFormat.rgba16float, false, usage, 1, 0, true, true, ctx);
        this.irradianceColorMap.name = "irradianceColorMap";
        this._probeGBufferFrame = new ProbeGBufferFrame(this.sizeW, this.sizeH, false, ctx);
        this.positionMap = this._probeGBufferFrame.renderTargets[0];
        this.normalMap = this._probeGBufferFrame.renderTargets[1];
        this.colorMap = this._probeGBufferFrame.renderTargets[2];
        this._rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, this._probeGBufferFrame);
        this._renderContext = new RenderContext(ctx, this._probeGBufferFrame);
        b.read(MAIN_SHADOW_MAP);
        b.read(POINT_SHADOW_CUBE_ARRAY);
        const shadowMap = b.graph.pool.get(MAIN_SHADOW_MAP);
        const pointShadowMap = b.graph.pool.get(POINT_SHADOW_CUBE_ARRAY);
        this.setInputTextures(shadowMap, pointShadowMap);
        b.write(DDGI_IRRADIANCE_MAP, () => this.irradianceColorMap);
        b.write(DDGI_DEPTH_MAP, () => this.irradianceDepthMap);
      }
      /** Wire shadow-map inputs into the lighting / bounce / irradiance
       *  compute child passes. Called from `setup` after the shadow
       *  textures are registered in the pool. Public so cloud-GI / test
       *  harnesses can re-wire if needed. */
      setInputTextures(shadowMap, pointShadowMap) {
        const ctx = this.irradianceColorMap._boundCtx;
        if (!this.lightingPass) {
          this.lightingPass = new DDGILightingPass(ctx);
          this.bouncePass = new DDGIMultiBouncePass(this._volume, ctx);
          this.irradianceComputePass = new DDGIIrradianceComputePass(ctx, this._volume);
        }
        this.lightingPass.setInputs([this.positionMap, this.normalMap, this.colorMap, shadowMap, pointShadowMap]);
        this.bouncePass.setInputs([this.normalMap, this.colorMap, this.lightingPass.lightingTexture, this.irradianceColorMap]);
        this.irradianceComputePass.setTextures([this.positionMap, this.normalMap, this.bouncePass.blendTexture], this.irradianceColorMap, this.irradianceDepthMap);
      }
      execute(ctx) {
        const view = ctx.view;
        if (!view.engine3D.setting.gi.enable) return;
        this._volume.updateOrientation();
        this._volume.isVolumeFrameChange = false;
        this._volume.uploadBuffer();
        this._renderProbes(view);
        const probeBeRendered = this._probeRenderResult.count > 0;
        if (EntityCollect.instance.state.giLightingChange || probeBeRendered || view.engine3D.setting.gi.realTimeGI) {
          EntityCollect.instance.state.giLightingChange = false;
          this.lightingPass?.compute(view, this._rendererPassState);
          this.bouncePass?.compute(view, this._rendererPassState);
          this.irradianceComputePass?.compute(view, this._rendererPassState);
        }
        if (this._probeRenderResult.complete) {
          this.dispatchEvent(GIRenderCompleteEvent);
        }
      }
      startRenderGI(index = 0) {
        if (this._nextProbeIndex === -1 && index === 0) {
          this.dispatchEvent(GIRenderStartEvent);
        }
        this._nextProbeIndex = index;
        this._renderStatus = "rendering";
      }
      startRenderCloudGI() {
        this.dispatchEvent(GIRenderStartEvent);
        this._nextProbeIndex = 0;
        this._renderStatus = "rendering";
        this._isRenderCloudGI = true;
      }
      /** Cloud-GI / scripted reload entry point: write irradiance arrays
       *  directly into the GPU textures. Used by the GPU buffer reader
       *  pipeline. Layout must match the irradianceColorMap dimensions. */
      setIrradianceData(colorData, depthData, width, height) {
        if (width !== this.irradianceColorMap.width || height !== this.irradianceColorMap.height) {
          console.error("irradiance image size not match !");
          return;
        }
        this._writeToTexture(this.irradianceColorMap, colorData, width, height);
        this._writeToTexture(this.irradianceDepthMap, depthData, width, height);
      }
      _renderProbes(view) {
        const autoRenderProbe = view.engine3D.setting.gi.autoRenderProbe;
        let execRender = false;
        if (autoRenderProbe) {
          if (this._nextProbeIndex === -1) this.startRenderGI();
          execRender = true;
        } else {
          execRender = this._renderStatus === "rendering";
        }
        this._probeRenderResult.count = 0;
        this._probeRenderResult.complete = false;
        if (!execRender) return;
        const probeList = EntityCollect.instance.getProbes(view.scene);
        this._renderContext.gpu = view.engine3D.context3D.gpuContext;
        this._renderContext.clean();
        this._renderContext.beginOpaqueRenderPass();
        this._tempProbeList.length = 0;
        let remainCount = Math.min(this._probeCountPerFrame, probeList.length);
        this._probeRenderResult.count = remainCount;
        while (remainCount > 0) {
          const probe = probeList[this._nextProbeIndex];
          this._updateProbe(view, probe, this._renderContext.encoder);
          remainCount--;
          this._nextProbeIndex++;
          if (probe.drawCallFrame < 3) this._tempProbeList.push(probe);
        }
        if (this._tempProbeList.length > 0) {
          this._volume.updateProbes(this._tempProbeList);
        }
        const isComplete = this._nextProbeIndex >= probeList.length;
        if (isComplete && this._isRenderCloudGI) {
          this._updateProbe(view, probeList[0], this._renderContext.encoder);
        }
        this._renderContext.endRenderPass();
        if (isComplete) {
          this._nextProbeIndex = -1;
          this._renderStatus = "complete";
          this._probeRenderResult.complete = true;
        }
      }
      _updateProbe(view, probe, encoder) {
        const lights = EntityCollect.instance.getLights(view.scene);
        const cubeSize = this._volume.setting.probeSize;
        probe.drawCallFrame += 1;
        this._cubeCamera.x = probe.x;
        this._cubeCamera.y = probe.y;
        this._cubeCamera.z = probe.z;
        if (this._volume.setting.debugCamera) {
          this._cubeCamera.x = view.camera.transform.x;
          this._cubeCamera.y = view.camera.transform.y;
          this._cubeCamera.z = view.camera.transform.z;
          this._cubeCamera.rotationX = view.camera.transform.rotationX;
          this._cubeCamera.rotationY = view.camera.transform.rotationY;
          this._cubeCamera.rotationZ = view.camera.transform.rotationZ;
        } else {
          this._cubeCamera.rotationX = probe.rotationX;
          this._cubeCamera.rotationY = probe.rotationY;
          this._cubeCamera.rotationZ = probe.rotationZ;
        }
        const offsetX = Math.floor(probe.index / this.probeNext) * (cubeSize * 6);
        const offsetY = Math.floor(probe.index % this.probeNext) * cubeSize;
        const faces = [
          this._cubeCamera.right_camera,
          this._cubeCamera.left_camera,
          this._cubeCamera.up_camera,
          this._cubeCamera.down_camera,
          this._cubeCamera.front_camera,
          this._cubeCamera.back_camera
        ];
        for (let f = 0; f < 6; f++) {
          encoder.setViewport(cubeSize * f + offsetX, offsetY, cubeSize, cubeSize, 0, 1);
          this._renderProbeFace(view, faces[f], encoder, lights);
        }
      }
      _renderProbeFace(view, probeCamera, encoder, _lights) {
        this._volume.uploadBuffer();
        const layered = this.collectLayered(view, probeCamera);
        view.engine3D.context3D.gpuContext.bindCamera(encoder, probeCamera);
        const setting = view.engine3D.setting;
        let drawMin = Math.max(0, setting.render.drawOpMin);
        let drawMax = Math.min(setting.render.drawOpMax, layered.opaque.length);
        const renderShaderCollect = EntityCollect.instance.getRenderShaderCollect(view);
        if (renderShaderCollect) {
          for (const renderList of renderShaderCollect) {
            const nodeMap = renderList[1];
            for (const [, node] of nodeMap) {
              if (!node.isDestroyed && node.preInit(this._passType)) {
                node.nodeUpdate(view, this._passType, this._rendererPassState, null);
                break;
              }
            }
          }
        }
        for (let i = drawMin; i < drawMax; ++i) {
          const node = layered.opaque[i];
          if (node.enable && node.transform.enable && !node.isDestroyed) {
            if (!node.preInit(this._passType)) {
              node.nodeUpdate(view, this._passType, this._rendererPassState, null);
            }
            node.renderPass2(view, this._passType, this._rendererPassState, null, encoder);
          }
        }
        const sky = EntityCollect.instance.getSky(view.scene);
        if (sky) {
          if (!sky.preInit(this._passType)) {
            sky.nodeUpdate(view, this._passType, this._rendererPassState, null);
          }
          sky.renderPass2(view, this._passType, this._rendererPassState, null, encoder);
        }
        drawMin = Math.max(0, setting.render.drawTrMin);
        drawMax = Math.min(setting.render.drawTrMax, layered.transparent.length);
        for (let i = drawMin; i < drawMax; ++i) {
          const node = layered.transparent[i];
          if (node.enable && node.transform.enable && !node.isDestroyed) {
            if (!node.preInit(this._passType)) {
              node.nodeUpdate(view, this._passType, this._rendererPassState, null);
            }
            node.renderPass2(view, this._passType, this._rendererPassState, null, encoder);
          }
        }
      }
      _writeToTexture(texture, array, width, height) {
        const ctx = texture._boundCtx;
        const device = ctx.device;
        const buffer = device.createBuffer({
          size: array.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(buffer, 0, array);
        const commandEncoder = ctx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          { buffer, bytesPerRow: width * 16 },
          { texture: texture.getGPUTexture() },
          { width, height, depthOrArrayLayers: 1 }
        );
        ctx.gpuContext.endCommandEncoder(commandEncoder);
      }
      destroy() {
        this._cubeCamera?.destroy();
      }
    }

    const COLOR_BUFFER = "_ColorBuffer";
    const NORMAL_BUFFER = "_NormalBuffer";
    class ColorPass extends RenderGraphPass {
      constructor(config = { giEnabled: false }) {
        super();
        this.config = config;
        this._giEnabled = config.giEnabled;
      }
      name = "ColorPass";
      /** Bound color render target. Encoder opened per frame in
       *  {@link execute} via `target.beginPass(...)`. */
      _target;
      /** Live {@link RendererPassState} for the in-flight pass — set on
       *  every {@link execute} between begin and end. */
      _passState = null;
      _passType = PassType.COLOR;
      _giEnabled;
      get rendererPassState() {
        return this._passState;
      }
      setup(b) {
        this._target = b.borrowRenderTarget(MAIN_COLOR_RT);
        this.declareShadingReads(b);
        this.declareSideEffects(b);
      }
      /** Per-frame loadOp/clearValue options applied when opening the
       *  bound target. Default returns `undefined` so the framework's
       *  auto-derive rule applies. Override to force e.g.
       *  `colorLoadOps:['load']` for a chained opaque pass that draws on
       *  top of a previous half. */
      getRenderTargetOptions() {
        return void 0;
      }
      /** Declare the per-frame shading inputs this pass reads. Override
       *  to add/remove shading deps (e.g. skip shadow read in a depth-only
       *  variant). */
      declareShadingReads(b) {
        b.read(CLUSTER_LIGHTING_BUFFER);
        b.read(MAIN_SHADOW_MAP);
        b.read(POINT_SHADOW_CUBE_ARRAY);
        b.read(REFLECTION_CUBE_MAP);
        if (this._giEnabled) {
          b.read(DDGI_IRRADIANCE_MAP);
          b.read(DDGI_DEPTH_MAP);
        }
      }
      /** Declare any non-resource ordering constraints. SceneCapturePass
       *  renders off-screen RTs that this frame's lit materials sample
       *  directly via SceneCaptureCameraComponent (no graph-pool handle).
       *  GPUCullPass (when present) populates the indirect draw buffers
       *  consumed through GlobalBindGroup. Neither flows as a `b.read`, so
       *  we declare the ordering explicitly. */
      declareSideEffects(b) {
        dependOnIfRegistered(b, "SceneCapturePass", "GPUCullPass");
      }
      execute(ctx) {
        const view = ctx.view;
        const camera = view.camera;
        const cluster = this._getCluster(view);
        const opened = this._target.beginPass(ctx, this.getRenderTargetOptions() ?? {});
        const { encoder, passState } = opened;
        this._passState = passState;
        if (this._giEnabled) {
          const irradianceColor = ctx.get(DDGI_IRRADIANCE_MAP);
          const irradianceDepth = ctx.get(DDGI_DEPTH_MAP);
          if (irradianceColor && irradianceDepth) {
            passState.irradianceBuffer = [irradianceColor, irradianceDepth];
          }
        }
        GlobalBindGroup.updateCameraGroup(camera);
        passState.camera3D = camera;
        const layered = this.collectLayered(view);
        const opBundles = buildOpBundles(view, camera, this._passType, passState, cluster);
        const gpu = view.engine3D.context3D.gpuContext;
        if (opBundles.length > 0) {
          encoder.executeBundles(opBundles);
        }
        gpu.bindCamera(encoder, camera);
        if (layered.opaque.length > 0) {
          drawNodesEncoder(
            view,
            encoder,
            passState,
            layered.opaque,
            cluster,
            { transmissionFilter: "exclude", passType: this._passType }
          );
        }
        this._target.endPass(ctx, opened);
        this._passState = null;
      }
      _getCluster(view) {
        return view.renderGraph?.getPass("ClusterLightingPass")?.clusterLightingBuffer;
      }
    }

    const TMP_VEC3 = new Vector3();
    const TMP_QUAT = new Quaternion();
    const UP_AXIS = new Vector3(0, 1, 0);
    class DecalComponent extends ComponentBase {
      /** Decal texture sampled in the composite pass. Any engine
       *  {@link Texture} works — load images with
       *  `Engine3D.res.loadTexture(url, …, 'srgb')` for a pooled
       *  {@link BitmapTexture2D}, or feed a Canvas2D source via
       *  `bitmapTexture.source = canvas`. Swapping at runtime is allowed
       *  — the pass rebuilds the texture view on the next frame. */
      texture = null;
      /** Tint multiplier (RGB) and alpha multiplier (A) applied in the FS. */
      tint = new Color(1, 1, 1, 1);
      /** Maximum angle (degrees) between the volume's local +Y and the
       *  receiving surface's normal for the decal to project onto it.
       *  90 (the default) disables the filter entirely so the decal wraps
       *  every face it touches. Smaller values restrict the decal to
       *  faces roughly aligned with decal-up — closer to a rigid "stamp". */
      maxAngleDeg = 90;
      /** Orient `obj`'s local +Y to point along `normal` (world space).
       *  Convenience helper for placing a decal on a curved surface. */
      static alignTopToward(obj, normal) {
        const n = TMP_VEC3.copy(normal);
        if (n.length < 1e-6) return;
        n.normalize();
        obj.localQuaternion = TMP_QUAT.setFromUnitVectors(UP_AXIS, n);
      }
      init(param) {
        if (param?.texture) this.texture = param.texture;
        if (param?.tint) this.tint = param.tint;
        if (param?.maxAngleDeg !== void 0) this.maxAngleDeg = param.maxAngleDeg;
      }
    }

    const COLOR_FORMAT = "rgba16float";
    const DS_FORMAT = "depth24plus-stencil8";
    const UNIFORM_BYTES = 4 * 64 + 16 + 16;
    const TMP_UNIFORM_F32 = new Float32Array(UNIFORM_BYTES / 4);
    class DecalShadowVolumePass extends RenderGraphPass {
      name = "DecalShadowVolumePass";
      _device;
      _useLogDepth = false;
      _cubeVB;
      _cubeIB;
      _cubeIdxCount;
      _decalSampler;
      _depthStencilTex = null;
      _depthStencilSize = [0, 0];
      _blitPipeline;
      _markPipeline;
      _compositePipeline;
      _blitBGLayout;
      _markBGLayout;
      _compositeBGLayout;
      _decalGpu = /* @__PURE__ */ new WeakMap();
      // Scratch list reused per-frame to avoid GC churn — populated by
      // ComponentCollect.collectByTypeLayered each execute().
      _decalScratch = [];
      _mVP;
      _mInvVP;
      _mModel;
      _mInvModel;
      setup(b) {
        this._device = b.context3D.device;
        this._useLogDepth = !!b.context3D.engine?.setting?.render?.useLogDepth;
        this._mVP = new Matrix4();
        this._mInvVP = new Matrix4();
        this._mModel = new Matrix4();
        this._mInvModel = new Matrix4();
        b.read(MAIN_DEPTH_TEXTURE);
        b.write(COLOR_BUFFER);
        b.useRenderTarget(MAIN_COLOR_RT);
        const geo = buildUnitCubeGeometry();
        this._cubeIdxCount = geo.indexCount;
        this._cubeVB = this._device.createBuffer({
          label: "DecalShadowVolume:CubeVB",
          size: geo.vertices.byteLength,
          usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST
        });
        this._device.queue.writeBuffer(this._cubeVB, 0, geo.vertices);
        this._cubeIB = this._device.createBuffer({
          label: "DecalShadowVolume:CubeIB",
          size: geo.indices.byteLength,
          usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST
        });
        this._device.queue.writeBuffer(this._cubeIB, 0, geo.indices);
        this._decalSampler = this._device.createSampler({
          magFilter: "linear",
          minFilter: "linear",
          addressModeU: "clamp-to-edge",
          addressModeV: "clamp-to-edge"
        });
        this._createPipelines();
      }
      destroy() {
        this._cubeVB?.destroy();
        this._cubeIB?.destroy();
        this._depthStencilTex?.destroy();
        this._depthStencilTex = null;
      }
      execute(ctx) {
        const view = ctx.view;
        const camera = view.camera;
        const camMask = camera?.cullingMask ?? 4294967295;
        const mask = (this.layerMask & camMask) >>> 0;
        ComponentCollect.collectByTypeLayered(view, DecalComponent, mask, this._decalScratch);
        if (this._decalScratch.length === 0) return;
        const engine = view.engine3D;
        const device = this._device;
        const gpu = engine.context3D.gpuContext;
        const colorTex = ctx.get(COLOR_BUFFER);
        const sceneDepthTex = ctx.get(MAIN_DEPTH_TEXTURE);
        if (!colorTex || !sceneDepthTex) return;
        const [W, H] = engine.context3D.presentationSize;
        const dsTex = this._ensureDepthStencil(W, H);
        const dsView = dsTex.createView({ aspect: "all" });
        const sceneDepthView = sceneDepthTex.getGPUView();
        const colorView = colorTex.getGPUTexture().createView();
        const vp = this._mVP.multiplyMatrices(camera.projectionMatrix, camera.viewMatrix);
        const invVP = this._mInvVP.copy(vp);
        invVP.invert();
        const near = camera.near;
        const far = camera.far;
        const command = gpu.beginCommandEncoder();
        {
          const blitBG = device.createBindGroup({
            layout: this._blitBGLayout,
            entries: [{ binding: 0, resource: sceneDepthView }]
          });
          const enc = command.beginRenderPass({
            label: "DecalShadowVolume:DepthBlit",
            colorAttachments: [],
            depthStencilAttachment: {
              view: dsView,
              depthLoadOp: "clear",
              depthClearValue: 1,
              depthStoreOp: "store",
              stencilLoadOp: "clear",
              stencilClearValue: 0,
              stencilStoreOp: "store"
            }
          });
          enc.setPipeline(this._blitPipeline);
          enc.setBindGroup(0, blitBG);
          enc.draw(3);
          enc.end();
        }
        let drawIdx = 0;
        for (const decal of this._decalScratch) {
          if (!decal.texture) continue;
          if (!decal.transform || !decal.transform.enable) continue;
          const gpuRes = this._updateDecalUniform(decal, vp, invVP, near, far);
          if (!gpuRes) continue;
          const label = decal.object3D?.name || `#${drawIdx++}`;
          {
            const bg = device.createBindGroup({
              layout: this._markBGLayout,
              entries: [{ binding: 0, resource: { buffer: gpuRes.uniformBuffer } }]
            });
            const enc = command.beginRenderPass({
              label: `DecalShadowVolume:Mark[${label}]`,
              colorAttachments: [],
              depthStencilAttachment: {
                view: dsView,
                depthLoadOp: "load",
                depthStoreOp: "store",
                stencilLoadOp: "clear",
                stencilClearValue: 0,
                stencilStoreOp: "store"
              }
            });
            enc.setPipeline(this._markPipeline);
            enc.setBindGroup(0, bg);
            enc.setVertexBuffer(0, this._cubeVB);
            enc.setIndexBuffer(this._cubeIB, "uint16");
            enc.setStencilReference(0);
            enc.drawIndexed(this._cubeIdxCount);
            enc.end();
          }
          {
            const bg = device.createBindGroup({
              layout: this._compositeBGLayout,
              entries: [
                { binding: 0, resource: { buffer: gpuRes.uniformBuffer } },
                { binding: 1, resource: sceneDepthView },
                { binding: 2, resource: gpuRes.textureView },
                { binding: 3, resource: this._decalSampler }
              ]
            });
            const enc = command.beginRenderPass({
              label: `DecalShadowVolume:Composite[${label}]`,
              colorAttachments: [{
                view: colorView,
                loadOp: "load",
                storeOp: "store"
              }],
              depthStencilAttachment: {
                view: dsView,
                depthReadOnly: true,
                stencilReadOnly: true
              }
            });
            enc.setPipeline(this._compositePipeline);
            enc.setBindGroup(0, bg);
            enc.setVertexBuffer(0, this._cubeVB);
            enc.setIndexBuffer(this._cubeIB, "uint16");
            enc.setStencilReference(0);
            enc.drawIndexed(this._cubeIdxCount);
            enc.end();
          }
        }
        gpu.endCommandEncoder(command);
      }
      _ensureDepthStencil(w, h) {
        if (this._depthStencilTex && this._depthStencilSize[0] === w && this._depthStencilSize[1] === h) {
          return this._depthStencilTex;
        }
        this._depthStencilTex?.destroy();
        this._depthStencilTex = this._device.createTexture({
          label: "DecalShadowVolume:DS",
          size: [w, h, 1],
          format: DS_FORMAT,
          usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING
        });
        this._depthStencilSize = [w, h];
        return this._depthStencilTex;
      }
      _updateDecalUniform(decal, vp, invVP, near, far) {
        const tex = decal.texture;
        if (!tex) return null;
        const m = this._mModel.copy(decal.transform.worldMatrix);
        const invM = this._mInvModel.copy(m);
        invM.invert();
        let gpuRes = this._decalGpu.get(decal);
        if (gpuRes && gpuRes.boundTexture !== tex) {
          gpuRes.textureView = tex.getGPUView();
          gpuRes.boundTexture = tex;
        }
        if (!gpuRes) {
          const uniformBuffer = this._device.createBuffer({
            label: "DecalShadowVolume:Uniform",
            size: UNIFORM_BYTES,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
          });
          gpuRes = {
            uniformBuffer,
            textureView: tex.getGPUView(),
            boundTexture: tex
          };
          this._decalGpu.set(decal, gpuRes);
        }
        const cpu = TMP_UNIFORM_F32;
        cpu.set(vp.rawData, 0);
        cpu.set(invVP.rawData, 16);
        cpu.set(m.rawData, 32);
        cpu.set(invM.rawData, 48);
        cpu[64] = decal.tint.r;
        cpu[65] = decal.tint.g;
        cpu[66] = decal.tint.b;
        cpu[67] = decal.tint.a;
        cpu[68] = decal.maxAngleDeg >= 89.99 ? -2 : Math.cos(decal.maxAngleDeg * Math.PI / 180);
        cpu[69] = near;
        cpu[70] = far;
        cpu[71] = 0;
        this._device.queue.writeBuffer(gpuRes.uniformBuffer, 0, cpu.buffer, cpu.byteOffset, UNIFORM_BYTES);
        return gpuRes;
      }
      _createPipelines() {
        const device = this._device;
        const defines = {
          USE_LOGDEPTH: this._useLogDepth
        };
        const blitCode = Preprocessor.parse(BLIT_WGSL, defines);
        const markCode = Preprocessor.parse(MARK_WGSL, defines);
        const compositeCode = Preprocessor.parse(COMPOSITE_WGSL, defines);
        this._blitBGLayout = device.createBindGroupLayout({
          entries: [
            { binding: 0, visibility: GPUShaderStage.FRAGMENT, texture: { sampleType: "depth" } }
          ]
        });
        const blitShader = device.createShaderModule({ code: blitCode });
        this._blitPipeline = device.createRenderPipeline({
          label: "DecalShadowVolume:BlitPipeline",
          layout: device.createPipelineLayout({ bindGroupLayouts: [this._blitBGLayout] }),
          vertex: { module: blitShader, entryPoint: "vs" },
          fragment: { module: blitShader, entryPoint: "fs", targets: [] },
          primitive: { topology: "triangle-list", cullMode: "none" },
          depthStencil: {
            format: DS_FORMAT,
            depthCompare: "always",
            depthWriteEnabled: true
          }
        });
        this._markBGLayout = device.createBindGroupLayout({
          entries: [
            { binding: 0, visibility: GPUShaderStage.VERTEX, buffer: { type: "uniform" } }
          ]
        });
        const markShader = device.createShaderModule({ code: markCode });
        this._markPipeline = device.createRenderPipeline({
          label: "DecalShadowVolume:MarkPipeline",
          layout: device.createPipelineLayout({ bindGroupLayouts: [this._markBGLayout] }),
          vertex: {
            module: markShader,
            entryPoint: "vs",
            buffers: [{
              arrayStride: 12,
              attributes: [{ shaderLocation: 0, offset: 0, format: "float32x3" }]
            }]
          },
          fragment: { module: markShader, entryPoint: "fs", targets: [] },
          // cullMode='none' so both stencilFront / stencilBack are hit.
          primitive: { topology: "triangle-list", cullMode: "none", frontFace: "ccw" },
          depthStencil: {
            format: DS_FORMAT,
            depthCompare: "less",
            depthWriteEnabled: false,
            stencilReadMask: 255,
            stencilWriteMask: 255,
            stencilFront: {
              compare: "always",
              failOp: "keep",
              depthFailOp: "decrement-wrap",
              passOp: "keep"
            },
            stencilBack: {
              compare: "always",
              failOp: "keep",
              depthFailOp: "increment-wrap",
              passOp: "keep"
            }
          }
        });
        this._compositeBGLayout = device.createBindGroupLayout({
          entries: [
            { binding: 0, visibility: GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT, buffer: { type: "uniform" } },
            { binding: 1, visibility: GPUShaderStage.FRAGMENT, texture: { sampleType: "depth" } },
            { binding: 2, visibility: GPUShaderStage.FRAGMENT, texture: { sampleType: "float" } },
            { binding: 3, visibility: GPUShaderStage.FRAGMENT, sampler: { type: "filtering" } }
          ]
        });
        const compositeShader = device.createShaderModule({ code: compositeCode });
        this._compositePipeline = device.createRenderPipeline({
          label: "DecalShadowVolume:CompositePipeline",
          layout: device.createPipelineLayout({ bindGroupLayouts: [this._compositeBGLayout] }),
          vertex: {
            module: compositeShader,
            entryPoint: "vs",
            buffers: [{
              arrayStride: 12,
              attributes: [{ shaderLocation: 0, offset: 0, format: "float32x3" }]
            }]
          },
          fragment: {
            module: compositeShader,
            entryPoint: "fs",
            targets: [{
              format: COLOR_FORMAT,
              blend: {
                color: { srcFactor: "src-alpha", dstFactor: "one-minus-src-alpha", operation: "add" },
                alpha: { srcFactor: "one", dstFactor: "one-minus-src-alpha", operation: "add" }
              },
              writeMask: GPUColorWrite.ALL
            }]
          },
          // Back-face draw so the screen region is still covered when
          // the camera is inside the volume.
          primitive: { topology: "triangle-list", cullMode: "front", frontFace: "ccw" },
          depthStencil: {
            format: DS_FORMAT,
            depthCompare: "always",
            depthWriteEnabled: false,
            stencilReadMask: 255,
            stencilWriteMask: 0,
            stencilFront: { compare: "not-equal", failOp: "keep", depthFailOp: "keep", passOp: "keep" },
            stencilBack: { compare: "not-equal", failOp: "keep", depthFailOp: "keep", passOp: "keep" }
          }
        });
      }
    }
    function buildUnitCubeGeometry() {
      const vertices = new Float32Array([
        -0.5,
        -0.5,
        -0.5,
        0.5,
        -0.5,
        -0.5,
        0.5,
        0.5,
        -0.5,
        -0.5,
        0.5,
        -0.5,
        -0.5,
        -0.5,
        0.5,
        0.5,
        -0.5,
        0.5,
        0.5,
        0.5,
        0.5,
        -0.5,
        0.5,
        0.5
      ]);
      const indices = new Uint16Array([
        0,
        2,
        1,
        0,
        3,
        2,
        4,
        5,
        6,
        4,
        6,
        7,
        0,
        1,
        5,
        0,
        5,
        4,
        3,
        6,
        2,
        3,
        7,
        6,
        1,
        2,
        6,
        1,
        6,
        5,
        0,
        4,
        7,
        0,
        7,
        3
      ]);
      return { vertices, indices, indexCount: indices.length };
    }
    const BLIT_WGSL = (
      /* wgsl */
      `
@group(0) @binding(0) var srcDepth: texture_depth_2d;

struct VOut {
    @builtin(position) pos: vec4f,
};

@vertex
fn vs(@builtin(vertex_index) idx: u32) -> VOut {
    var p = array<vec2f, 3>(vec2f(-1.0, -1.0), vec2f(3.0, -1.0), vec2f(-1.0, 3.0));
    var out: VOut;
    out.pos = vec4f(p[idx], 0.0, 1.0);
    return out;
}

@fragment
fn fs(in: VOut) -> @builtin(frag_depth) f32 {
    let coord = vec2i(i32(in.pos.x), i32(in.pos.y));
    return textureLoad(srcDepth, coord, 0);
}
`
    );
    const MARK_WGSL = (
      /* wgsl */
      `
struct Uniforms {
    vp:       mat4x4f,
    invVP:    mat4x4f,
    model:    mat4x4f,
    invModel: mat4x4f,
    tint:     vec4f,
    params:   vec4f,
};

@group(0) @binding(0) var<uniform> u: Uniforms;

@vertex
fn vs(@location(0) pos: vec3f) -> @builtin(position) vec4f {
    var clipPos = u.vp * (u.model * vec4f(pos, 1.0));
    #if USE_LOGDEPTH
        // Match the engine's log-z encoding (MathShader::log2Depth01):
        //   ndc.z = log2(1 + w) / log2(far + 1),  w = clip.w.
        // Same value the Common_frag FS writes into _MainDepthTexture,
        // so depthCompare='less' on the stencil mark is comparing apples
        // to apples.
        let far = u.params.z;
        let ndcZ = log2(max(1e-6, 1.0 + clipPos.w)) / log2(far + 1.0);
        clipPos.z = ndcZ * clipPos.w;
    #endif
    return clipPos;
}

@fragment
fn fs() {
    // No color output — fixed-function stencil updates only.
}
`
    );
    const COMPOSITE_WGSL = (
      /* wgsl */
      `
struct Uniforms {
    vp:       mat4x4f,
    invVP:    mat4x4f,
    model:    mat4x4f,
    invModel: mat4x4f,
    tint:     vec4f,
    params:   vec4f,
};

@group(0) @binding(0) var<uniform>      u:           Uniforms;
@group(0) @binding(1) var               sceneDepth:  texture_depth_2d;
@group(0) @binding(2) var               decalTex:    texture_2d<f32>;
@group(0) @binding(3) var               decalSamp:   sampler;

struct VOut {
    @builtin(position) pos: vec4f,
};

@vertex
fn vs(@location(0) pos: vec3f) -> VOut {
    var out: VOut;
    var clipPos = u.vp * (u.model * vec4f(pos, 1.0));
    #if USE_LOGDEPTH
        // Same encoding as MARK_WGSL — keeps the composite quad's depth
        // test (when one exists) in lock-step with _MainDepthTexture.
        let far = u.params.z;
        let ndcZ = log2(max(1e-6, 1.0 + clipPos.w)) / log2(far + 1.0);
        clipPos.z = ndcZ * clipPos.w;
    #endif
    out.pos = clipPos;
    return out;
}

@fragment
fn fs(in: VOut) -> @location(0) vec4f {
    let dim   = textureDimensions(sceneDepth);
    let pixel = vec2i(i32(in.pos.x), i32(in.pos.y));
    if (pixel.x < 0 || pixel.y < 0 || pixel.x >= i32(dim.x) || pixel.y >= i32(dim.y)) {
        discard;
    }
    let rawDepth = textureLoad(sceneDepth, pixel, 0);

    #if USE_LOGDEPTH
        // _MainDepthTexture stores ndc.z = log2(1+w) / log2(far+1) where
        // w = view-space distance — the encoding shared by VertexFunction_vert
        // (log2Depth) and Common_frag (log2DepthFixPersp); see also
        // GBufferStand::inverseLog2Depth which inverts the same curve for
        // gBuffer.x. Recover w, then re-project to the standard perspective
        // ndc.z so invVP rebuilds world position the same way as the
        // no-logdepth path.
        let near = u.params.y;
        let far  = u.params.z;
        let w    = pow(far + 1.0, rawDepth) - 1.0;
        let depth = (far / (far - near)) * (1.0 - near / max(w, 1e-6));
    #else
        let depth = rawDepth;
    #endif

    let uvScreen = (vec2f(in.pos.xy) + vec2f(0.5)) / vec2f(dim);
    let ndc = vec4f(uvScreen.x * 2.0 - 1.0, 1.0 - uvScreen.y * 2.0, depth, 1.0);
    let worldH = u.invVP * ndc;
    let world  = worldH.xyz / worldH.w;

    let localH = u.invModel * vec4f(world, 1.0);
    let local  = localH.xyz;
    if (abs(local.x) > 0.5 || abs(local.y) > 0.5 || abs(local.z) > 0.5) {
        discard;
    }

    let uv = vec2f(local.x + 0.5, 1.0 - (local.z + 0.5));
    let texCol = textureSample(decalTex, decalSamp, uv);

    let edgeFade = 1.0 - smoothstep(0.35, 0.5, abs(local.y));

    let rgb = texCol.rgb * u.tint.rgb;
    let a   = texCol.a * u.tint.a * edgeFade;
    return vec4f(rgb * a, a);
}
`
    );

    let GPUFrustumCull_cs = (
      /*wgsl*/
      `
    struct MeshMeta {
        // xyz = world AABB min, w = bitcast<f32>(matrixIdx)
        boundsMinMatrixIdx: vec4<f32>,
        // xyz = world AABB max, w = bitcast<f32>(indexCount)
        boundsMaxIndexCount: vec4<f32>,
        // x = bitcast<f32>(firstIndex), y = bitcast<f32>(baseVertex),
        // z = bitcast<f32>(instanceCount), w = bitcast<f32>(enableFlag)
        drawArgs: vec4<f32>,
    };

    struct DrawIndirectArgs {
        indexCount: u32,
        instanceCount: u32,
        firstIndex: u32,
        baseVertex: i32,
        firstInstance: u32,
    };

    struct CullSettings {
        // Six camera frustum planes (vec4 each: xyz=normal, w=offset).
        frustumPlanes: array<vec4<f32>, 6>,
        // viewProj for projecting the AABB into screen space (Hi-Z).
        viewProj: mat4x4<f32>,
        meshCount: u32,
        useHiZ: u32,
        hiZMipCount: u32,
        _pad1: u32,
        // Screen size for converting NDC → pixel coords.
        screenSize: vec2<f32>,
        _pad2: vec2<f32>,
    };

    @group(0) @binding(0) var<uniform> cullSettings: CullSettings;
    @group(0) @binding(1) var<storage, read> meshes: array<MeshMeta>;
    @group(0) @binding(2) var<storage, read_write> visibility: array<u32>;
    @group(0) @binding(3) var<storage, read_write> drawCmds: array<DrawIndirectArgs>;
    @group(0) @binding(4) var<storage, read_write> drawCount: array<atomic<u32>, 1>;
    @group(0) @binding(5) var hizPyramid: texture_2d<f32>;

    fn aabbOutsidePlane(planeNormal: vec3<f32>, planeOffset: f32, bMin: vec3<f32>, bMax: vec3<f32>) -> bool {
        // Pick the AABB corner farthest along the plane normal — if even
        // that corner is on the negative side of the plane, the whole
        // box is culled.
        let p = vec3<f32>(
            select(bMin.x, bMax.x, planeNormal.x > 0.0),
            select(bMin.y, bMax.y, planeNormal.y > 0.0),
            select(bMin.z, bMax.z, planeNormal.z > 0.0),
        );
        return dot(planeNormal, p) + planeOffset < 0.0;
    }

    @compute @workgroup_size(64, 1, 1)
    fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
        let i = gid.x;
        if (i >= cullSettings.meshCount) { return; }
        let m = meshes[i];

        // Disabled mesh (renderer destroyed / hidden) — output 0 visibility.
        let enableFlag = bitcast<u32>(m.drawArgs.w);
        if (enableFlag == 0u) {
            visibility[i] = 0u;
            return;
        }

        let bMin = m.boundsMinMatrixIdx.xyz;
        let bMax = m.boundsMaxIndexCount.xyz;

        // Frustum test against all 6 planes.
        var inFrustum: bool = true;
        for (var p: i32 = 0; p < 6; p = p + 1) {
            let plane = cullSettings.frustumPlanes[p];
            if (aabbOutsidePlane(plane.xyz, plane.w, bMin, bMax)) {
                inFrustum = false;
                break;
            }
        }

        if (!inFrustum) {
            visibility[i] = 0u;
            return;
        }

        // Hi-Z occlusion test. Project the 8 AABB corners with the
        // camera viewProj, take screen-space min/max + min ndc-z (the
        // closest point of the AABB toward the camera), then compare
        // against the max-z stored in the appropriate Hi-Z mip.
        if (cullSettings.useHiZ == 1u) {
            var minUV = vec2<f32>(1.0, 1.0);
            var maxUV = vec2<f32>(0.0, 0.0);
            var minNDCz = 1.0;
            var anyBehind = false;
            for (var c: i32 = 0; c < 8; c = c + 1) {
                let cx = select(bMin.x, bMax.x, (c & 1) != 0);
                let cy = select(bMin.y, bMax.y, (c & 2) != 0);
                let cz = select(bMin.z, bMax.z, (c & 4) != 0);
                let clip = cullSettings.viewProj * vec4<f32>(cx, cy, cz, 1.0);
                if (clip.w <= 0.0) { anyBehind = true; continue; }
                let ndc = clip.xyz / clip.w;
                let uv = vec2<f32>(ndc.x * 0.5 + 0.5, -ndc.y * 0.5 + 0.5);
                minUV = min(minUV, uv);
                maxUV = max(maxUV, uv);
                minNDCz = min(minNDCz, ndc.z);
            }
            // If any corner is behind the near plane, conservatively keep
            // the mesh — perspective-flipped corners give bogus UVs.
            if (!anyBehind && minUV.x < maxUV.x && minUV.y < maxUV.y) {
                let extentPx = max((maxUV.x - minUV.x) * cullSettings.screenSize.x,
                                   (maxUV.y - minUV.y) * cullSettings.screenSize.y);
                let mipLevel = clamp(i32(ceil(log2(max(extentPx, 1.0)))), 0, i32(cullSettings.hiZMipCount) - 1);
                let mipSize = vec2<f32>(textureDimensions(hizPyramid, mipLevel));
                let centerUV = (minUV + maxUV) * 0.5;
                let coord = vec2<i32>(clamp(centerUV * mipSize, vec2<f32>(0.0), mipSize - 1.0));
                let hiZ = textureLoad(hizPyramid, coord, mipLevel).r;
                // If the AABB's CLOSEST z is FARTHER than the farthest
                // surface in this region, the mesh is occluded.
                if (minNDCz > hiZ) {
                    visibility[i] = 0u;
                    return;
                }
            }
        }

        // Visible — append draw command via atomic counter.
        visibility[i] = 1u;
        let slot = atomicAdd(&drawCount[0], 1u);
        let indexCount = bitcast<u32>(m.boundsMaxIndexCount.w);
        let firstIndex = bitcast<u32>(m.drawArgs.x);
        let baseVertex = i32(bitcast<u32>(m.drawArgs.y));
        let instanceCount = bitcast<u32>(m.drawArgs.z);
        let matrixIdx = bitcast<u32>(m.boundsMinMatrixIdx.w);

        drawCmds[slot] = DrawIndirectArgs(
            indexCount,
            instanceCount,
            firstIndex,
            baseVertex,
            matrixIdx, // firstInstance hijacked to carry matrix slot
        );
    }
`
    );

    class GPUCullSystem {
      _ctx;
      /** Capacity of the metadata SSBO. Resized on demand. */
      _capacity = 0;
      _meshCount = 0;
      /** Backing CPU staging array (Float32Array view); indexes are
       *  `meshIdx * STRIDE`. STRIDE = 12 floats = 3 vec4. */
      static STRIDE = 12;
      _staging = null;
      _meshMetadataBuffer = null;
      _visibilityBuffer = null;
      _drawCmdsBuffer = null;
      _drawCountBuffer = null;
      _settingsBuffer = null;
      _compute = null;
      _viewProj = new Matrix4().identity();
      _useHiZ = false;
      /** Map of RenderNode instanceID → SSBO slot. */
      _slotMap = /* @__PURE__ */ new Map();
      constructor(ctx) {
        this._ctx = ctx;
      }
      get meshCount() {
        return this._meshCount;
      }
      get visibilityBuffer() {
        return this._visibilityBuffer;
      }
      get drawCmdsBuffer() {
        return this._drawCmdsBuffer;
      }
      get drawCountBuffer() {
        return this._drawCountBuffer;
      }
      /** Toggle Hi-Z occlusion testing (in addition to frustum culling).
       *  Caller is responsible for ensuring the `_HiZPyramid` texture
       *  exists in the engine's RTResourceMap before flipping to true. */
      set useHiZ(v) {
        this._useHiZ = v;
      }
      get useHiZ() {
        return this._useHiZ;
      }
      _ensureCapacity(want) {
        if (want <= this._capacity) return;
        const newCap = Math.max(64, Math.ceil(want * 1.5));
        const stride = GPUCullSystem.STRIDE;
        const newStaging = new Float32Array(newCap * stride);
        if (this._staging) newStaging.set(this._staging);
        this._staging = newStaging;
        this._capacity = newCap;
        this._meshMetadataBuffer = null;
        this._visibilityBuffer = null;
        this._drawCmdsBuffer = null;
        this._compute = null;
      }
      /** Register a RenderNode in the cull system, returning its SSBO slot.
       *  Idempotent; calling with an existing node updates its metadata. */
      registerNode(node) {
        if (!node.geometry || !node.object3D?.bound) return -1;
        let slot = this._slotMap.get(node.instanceID);
        if (slot === void 0) {
          slot = this._meshCount++;
          this._slotMap.set(node.instanceID, slot);
          this._ensureCapacity(this._meshCount);
        }
        this._writeMetadata(slot, node);
        return slot;
      }
      unregisterNode(node) {
        const slot = this._slotMap.get(node.instanceID);
        if (slot === void 0) return;
        this._slotMap.delete(node.instanceID);
        const stride = GPUCullSystem.STRIDE;
        const base = slot * stride;
        if (this._staging) this._staging[base + 11] = 0;
      }
      _writeMetadata(slot, node) {
        const stride = GPUCullSystem.STRIDE;
        const base = slot * stride;
        const buf = this._staging;
        const bound = node.object3D.bound;
        const bMin = bound.min ?? bound.center;
        const bMax = bound.max ?? bound.center;
        buf[base + 0] = bMin.x;
        buf[base + 1] = bMin.y;
        buf[base + 2] = bMin.z;
        buf[base + 3] = bitcastU32ToF32(node.transform?._worldMatrix?.index ?? 0);
        buf[base + 4] = bMax.x;
        buf[base + 5] = bMax.y;
        buf[base + 6] = bMax.z;
        const sub0 = node.geometry?.subGeometries?.[0];
        const lod0 = sub0?.lodLevels?.[0];
        const indexCount = lod0?.indexCount ?? 0;
        const firstIndex = lod0?.indexStart ?? 0;
        buf[base + 7] = bitcastU32ToF32(indexCount);
        buf[base + 8] = bitcastU32ToF32(firstIndex);
        buf[base + 9] = bitcastU32ToF32(0);
        buf[base + 10] = bitcastU32ToF32(node.instanceCount > 0 ? node.instanceCount : 1);
        buf[base + 11] = bitcastU32ToF32(node.enable ? 1 : 0);
      }
      /** Dispatch the cull compute pass for the given camera. */
      execute(view) {
        if (this._meshCount === 0) return;
        const ctx = this._ctx;
        if (!this._compute) {
          ShaderLib.register("GPUFrustumCull_cs", GPUFrustumCull_cs);
          this._compute = new ComputeShader(GPUFrustumCull_cs);
          this._settingsBuffer = new UniformGPUBuffer(32);
          this._compute.setUniformBuffer("cullSettings", this._settingsBuffer);
          this._meshMetadataBuffer = new StorageGPUBuffer(this._capacity * GPUCullSystem.STRIDE);
          this._compute.setStorageBuffer("meshes", this._meshMetadataBuffer);
          this._visibilityBuffer = new StorageGPUBuffer(this._capacity);
          this._compute.setStorageBuffer("visibility", this._visibilityBuffer);
          this._drawCmdsBuffer = new StorageGPUBuffer(this._capacity * 5);
          this._compute.setStorageBuffer("drawCmds", this._drawCmdsBuffer);
          this._drawCountBuffer = new StorageGPUBuffer(1);
          this._compute.setStorageBuffer("drawCount", this._drawCountBuffer);
          const hiz2 = RTResourceMap.getTexture(this._ctx, "_HiZPyramid");
          if (hiz2) {
            this._compute.setSamplerTexture("hizPyramid", hiz2);
          }
          this._compute.workerSizeX = Math.max(1, Math.ceil(this._capacity / 64));
          this._compute.workerSizeY = 1;
          this._compute.workerSizeZ = 1;
        }
        this._meshMetadataBuffer.setFloat32Array("data", this._staging);
        this._meshMetadataBuffer.apply();
        const planes = view.camera.frustum?.planes;
        for (let p = 0; p < 6; p++) {
          const plane = planes ? planes[p] : null;
          const nx = plane?.normal?.x ?? 0;
          const ny = plane?.normal?.y ?? 0;
          const nz = plane?.normal?.z ?? 0;
          const d = plane?.distance ?? 0;
          this._settingsBuffer.setFloat(`frustumPlanes[${p}].x`, nx);
          this._settingsBuffer.setFloat(`frustumPlanes[${p}].y`, ny);
          this._settingsBuffer.setFloat(`frustumPlanes[${p}].z`, nz);
          this._settingsBuffer.setFloat(`frustumPlanes[${p}].w`, d);
        }
        this._viewProj.multiplyMatrices(view.camera.projectionMatrix, view.camera.viewMatrix);
        this._settingsBuffer.setMatrix("viewProj", this._viewProj);
        this._settingsBuffer.setFloat("meshCount", this._meshCount);
        const hiz = RTResourceMap.getTexture(this._ctx, "_HiZPyramid");
        const useHiZNow = this._useHiZ && !!hiz;
        this._settingsBuffer.setFloat("useHiZ", useHiZNow ? 1 : 0);
        this._settingsBuffer.setFloat("hiZMipCount", hiz ? Math.max(1, Math.floor(Math.log2(Math.max(hiz.width, hiz.height))) + 1) : 1);
        this._settingsBuffer.setFloat("_pad1", 0);
        const [sw, sh] = this._ctx.presentationSize;
        this._settingsBuffer.setFloat("screenSize.x", sw);
        this._settingsBuffer.setFloat("screenSize.y", sh);
        this._settingsBuffer.setFloat("_pad2.x", 0);
        this._settingsBuffer.setFloat("_pad2.y", 0);
        this._settingsBuffer.apply();
        const zeros = new Uint32Array([0]);
        ctx.device.queue.writeBuffer(this._drawCountBuffer.buffer, 0, zeros);
        const gpu = ctx.gpuContext;
        const command = gpu.beginCommandEncoder();
        gpu.computeCommand(command, [this._compute]);
        gpu.endCommandEncoder(command);
      }
    }
    function bitcastU32ToF32(u) {
      const buf = new ArrayBuffer(4);
      new Uint32Array(buf)[0] = u >>> 0;
      return new Float32Array(buf)[0];
    }

    const VISIBILITY_BUFFER = "_VisibilityBuffer";
    const DRAW_CMDS_BUFFER = "_DrawCmds";
    const DRAW_COUNT_BUFFER = "_DrawCount";
    class GPUCullPass extends RenderGraphPass {
      name = "GPUCullPass";
      _system;
      /** Track which Scene3D's RenderNode set we last synced from to know
       *  when the scene swap requires a full repopulate. */
      _lastSyncedScene = null;
      setup(b) {
        this._system = new GPUCullSystem(b.context3D);
        b.write(VISIBILITY_BUFFER, () => this._system.visibilityBuffer);
        b.write(DRAW_CMDS_BUFFER, () => this._system.drawCmdsBuffer);
        b.write(DRAW_COUNT_BUFFER, () => this._system.drawCountBuffer);
      }
      execute(ctx) {
        const scene = ctx.view.scene;
        const collectInfo = EntityCollect.instance.getRenderNodes(scene, ctx.view.camera);
        if (this._lastSyncedScene !== scene) {
          this._lastSyncedScene = scene;
        }
        const ops = collectInfo.opaqueList ?? [];
        const trs = collectInfo.transparentList ?? [];
        for (const node of ops) this._system.registerNode(node);
        for (const node of trs) this._system.registerNode(node);
        this._system.execute(ctx.view);
      }
      get system() {
        return this._system;
      }
    }

    class VertexGPUBuffer extends GPUBufferBase {
      node;
      constructor(size) {
        super();
        this.bufferType = GPUBufferType.VertexGPUBuffer;
        this.createVertexBuffer(GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | GPUBufferUsage.VERTEX, size);
      }
      createVertexBuffer(usage, size) {
        this.createBuffer(usage, size, void 0, "VertexGPUBuffer");
        this.node = this.memory.allocation_node(this.byteSize);
      }
    }

    var GeometryVertexType = /* @__PURE__ */ ((GeometryVertexType2) => {
      GeometryVertexType2[GeometryVertexType2["split"] = 0] = "split";
      GeometryVertexType2[GeometryVertexType2["compose"] = 1] = "compose";
      GeometryVertexType2[GeometryVertexType2["compose_bin"] = 2] = "compose_bin";
      return GeometryVertexType2;
    })(GeometryVertexType || {});

    class GeometryVertexBuffer {
      vertexCount = 0;
      vertexGPUBuffer;
      geometryType = GeometryVertexType.split;
      /**
       * Set to `true` whenever `vertexGPUBuffer` is replaced by a fresh
       * allocation (first build or a packing-size change). Consumers that
       * captured the GPU buffer handle — e.g. compute pipelines writing
       * deformed/generated vertices — must observe this flag and rebind,
       * otherwise they keep writing into an orphaned buffer while the
       * renderer draws the new one. The owner resets it after handling.
       */
      bufferChanged = false;
      _vertexBufferLayouts;
      _attributeSlotLayouts;
      _attributeLocation;
      /** Float count the current `vertexGPUBuffer` was allocated with, used
       *  to reuse the same GPU buffer when the packing size is unchanged. */
      _allocFloatCount = -1;
      /**
       * Canonical interleaved packing for `compose` geometry, keyed by
       * attribute NAME and shared by every consuming pass. Built once as the
       * union of all attributes any pass's shader reflection has declared
       * (append-only, so byte offsets never move). Decouples the buffer's
       * physical byte layout — a property of the geometry data — from each
       * pass's VertexState, which assigns its own shader locations via
       * `@location(auto)`. Two passes that disagree on locations (e.g. a
       * color pass with TANGENT vs a shadow pass without) therefore share one
       * stable buffer instead of forcing a re-pack/re-alloc or identical
       * defines. `_composeStride` is the per-vertex float count.
       */
      _composeCanonical = [];
      _composeStride = 0;
      /**
       * Canonical packing for `compose_bin` geometry. Unlike `compose`, the
       * byte layout here is fixed by the source interleave (a single pre-packed
       * `all` buffer), so offsets cannot be assigned from shader-reflection
       * order — the loader records the real per-attribute offset/stride via
       * {@link setComposeBinLayout}. `_composeBinStride` is the per-vertex float
       * count (== geometry.vertexDim). When unset, `createComposBinVertexBuffer`
       * falls back to the legacy reflection-order behaviour.
       */
      _composeBinLayout = null;
      _composeBinStride = 0;
      /**
       * Record the real interleave layout of a `compose_bin` geometry's packed
       * vertex buffer (attribute name → byte offset within the stride), so each
       * pass's VertexState can be derived independently of how many attributes
       * that pass's shader declares.
       */
      setComposeBinLayout(layout) {
        this._composeBinLayout = layout;
        let stride = 0;
        for (let i = 0; i < layout.length; i++) stride += layout[i].stride;
        this._composeBinStride = stride;
      }
      constructor() {
        this._vertexBufferLayouts = [];
        this._attributeLocation = {};
        this._attributeSlotLayouts = [];
      }
      get vertexBufferLayouts() {
        return this._vertexBufferLayouts;
      }
      /**
       * Vertex buffer layout for a specific pass's pipeline VertexState. For
       * `compose` geometry this is derived per-pass from the pass's shader
       * reflection: each attribute the pass declares is mapped to its own
       * `shaderLocation` but the canonical (by-name) byte offset and the
       * shared canonical `arrayStride`, so a pass simply strides over the
       * attributes it does not read. For `split` / `compose_bin` it falls
       * back to the shared layout (their per-pass decoupling is not done
       * yet). Consumed by RenderShaderPass.createPipeline; draw-time binding
       * still uses {@link vertexBufferLayouts}.
       */
      getPipelineLayout(shaderReflection) {
        let canonical;
        let stride;
        if (this.geometryType === GeometryVertexType.compose) {
          canonical = this._composeCanonical;
          stride = this._composeStride;
        } else if (this.geometryType === GeometryVertexType.compose_bin && this._composeBinLayout) {
          canonical = this._composeBinLayout;
          stride = this._composeBinStride;
        } else {
          return this._vertexBufferLayouts;
        }
        let attributes = [];
        for (let i = 0; i < shaderReflection.attributes.length; i++) {
          const attributeInfo = shaderReflection.attributes[i];
          if (attributeInfo.name == `index`) continue;
          if (attributeInfo.type == `builtin`) continue;
          const c = canonical.find((x) => x.name == attributeInfo.name);
          if (!c) continue;
          attributes.push({
            name: attributeInfo.name,
            format: attributeInfo.format,
            offset: c.offset,
            shaderLocation: attributeInfo.location,
            stride: VertexAttributeSize[attributeInfo.format]
          });
        }
        return [{
          name: `composeStruct`,
          arrayStride: stride * 4,
          stepMode: `vertex`,
          attributes,
          offset: 0,
          size: this.vertexCount * stride * 4
        }];
      }
      /**
       * Allocate the backing GPU vertex buffer, reusing the existing one
       * when the required float count is unchanged so its handle stays
       * stable across the per-pass `generate()` calls. The buffer's
       * interleaved/split packing is a property of the geometry data, not
       * of any single consuming pass, so re-running `generate()` for a
       * different pass must not orphan a buffer that compute consumers
       * already bound. Only a genuine size change forces a new allocation,
       * which is signalled via `bufferChanged`.
       */
      allocVertexBuffer(floatCount) {
        if (this.vertexGPUBuffer && this._allocFloatCount === floatCount) return;
        this.vertexGPUBuffer = new VertexGPUBuffer(floatCount);
        this._allocFloatCount = floatCount;
        this.bufferChanged = true;
      }
      /**
       * Whether `createVertexBuffer` must run for this pass's reflection (on
       * top of the geometry's own `_onChange`). For `compose` this is true
       * only when the reflection introduces an attribute not yet in the
       * canonical packing — after the union converges, repeated passes
       * short-circuit so a compute-written buffer is not re-uploaded with
       * rest-pose data. For `split` / `compose_bin` it preserves the legacy
       * "a declared shader slot is missing from the layout" check.
       */
      needsRebuild(shaderReflection) {
        if (this.geometryType === GeometryVertexType.compose) {
          return shaderReflection.attributes.some((a) => a.name !== "index" && a.type !== "builtin" && !this._composeCanonical.some((c) => c.name == a.name));
        }
        if (this.geometryType === GeometryVertexType.compose_bin && this._composeBinLayout) {
          return shaderReflection.attributes.some((a) => a.name !== "index" && a.type !== "builtin" && !this._composeBinLayout.some((c) => c.name == a.name));
        }
        const layouts = this._vertexBufferLayouts;
        return shaderReflection.attributes.some((a) => a.name !== "index" && a.type !== "builtin" && layouts?.[a.location] === void 0);
      }
      createVertexBuffer(vertexDataInfos, shaderReflection) {
        switch (this.geometryType) {
          case GeometryVertexType.split:
            this.createSplitVertexBuffer(vertexDataInfos, shaderReflection);
            break;
          case GeometryVertexType.compose:
            this.createComposeVertexBuffer(vertexDataInfos, shaderReflection);
            break;
          case GeometryVertexType.compose_bin:
            this.createComposBinVertexBuffer(vertexDataInfos, shaderReflection);
            break;
        }
      }
      createSplitVertexBuffer(vertexDataInfos, shaderReflection) {
        let vertexOffset = 0;
        for (let i = 0; i < shaderReflection.attributes.length; i++) {
          const attributeInfo = shaderReflection.attributes[i];
          if (attributeInfo.name == `index`) continue;
          this._attributeLocation[attributeInfo.name] = attributeInfo.location;
          let attributeLayout = {
            name: attributeInfo.name,
            format: attributeInfo.format,
            offset: 0,
            shaderLocation: attributeInfo.location,
            stride: VertexAttributeSize[attributeInfo.format]
          };
          this._attributeSlotLayouts[attributeInfo.location] = [attributeLayout];
          let vertexInfo = vertexDataInfos.get(attributeInfo.name);
          if (!vertexInfo) {
            vertexInfo = {
              attribute: attributeInfo.name,
              data: new Float32Array(attributeInfo.size * this.vertexCount)
            };
            vertexDataInfos.set(attributeInfo.name, vertexInfo);
          }
          let len = vertexInfo.data.length / attributeLayout.stride;
          if (this.vertexCount != 0 && this.vertexCount != len) {
            console.error(" vertex count not match attribute count");
          }
          this.vertexCount = len;
          this._vertexBufferLayouts[attributeInfo.location] = {
            name: attributeInfo.name,
            arrayStride: attributeInfo.size * 4,
            stepMode: `vertex`,
            attributes: this._attributeSlotLayouts[attributeInfo.location],
            offset: vertexOffset * 4,
            size: this.vertexCount * attributeInfo.size * 4
          };
          vertexOffset += this.vertexCount * attributeInfo.size;
        }
        this.allocVertexBuffer(vertexOffset);
      }
      createComposeVertexBuffer(vertexDataInfos, shaderReflection) {
        for (let i = 0; i < shaderReflection.attributes.length; i++) {
          const attributeInfo = shaderReflection.attributes[i];
          if (attributeInfo.name == `index` || attributeInfo.type == `builtin`) continue;
          const info = vertexDataInfos.get(attributeInfo.name);
          if (info && info.data) {
            let len = info.data.length / VertexAttributeSize[attributeInfo.format];
            if (this.vertexCount != 0 && this.vertexCount != len) {
              console.error(" vertex count not match attribute count");
            }
            this.vertexCount = len;
          }
        }
        for (let i = 0; i < shaderReflection.attributes.length; i++) {
          const attributeInfo = shaderReflection.attributes[i];
          if (attributeInfo.name == `index` || attributeInfo.type == `builtin`) continue;
          const size = VertexAttributeSize[attributeInfo.format];
          if (!this._composeCanonical.some((c) => c.name == attributeInfo.name)) {
            this._composeCanonical.push({
              name: attributeInfo.name,
              format: attributeInfo.format,
              offset: this._composeStride * 4,
              shaderLocation: this._composeCanonical.length,
              stride: size
            });
            this._composeStride += size;
          }
          if (!vertexDataInfos.get(attributeInfo.name)) {
            vertexDataInfos.set(attributeInfo.name, {
              attribute: attributeInfo.name,
              data: new Float32Array(size * this.vertexCount)
            });
          }
        }
        this._attributeSlotLayouts[0] = this._composeCanonical;
        this._attributeLocation = {};
        for (let k = 0; k < this._composeCanonical.length; k++) {
          this._attributeLocation[this._composeCanonical[k].name] = k;
        }
        this._vertexBufferLayouts[0] = {
          name: `composeStruct`,
          arrayStride: this._composeStride * 4,
          stepMode: `vertex`,
          attributes: this._composeCanonical,
          offset: 0,
          size: this.vertexCount * this._composeStride * 4
        };
        this.allocVertexBuffer(this.vertexCount * this._composeStride);
      }
      createComposBinVertexBuffer(vertexDataInfos, shaderReflection) {
        const att_all = vertexDataInfos.get(VertexAttributeName.all);
        if (this._composeBinLayout && this._composeBinStride > 0) {
          const stride = this._composeBinStride;
          this.vertexCount = att_all.data.length / stride;
          this._attributeSlotLayouts[0] = this._composeBinLayout;
          this._attributeLocation = {};
          for (let k = 0; k < this._composeBinLayout.length; k++) {
            this._attributeLocation[this._composeBinLayout[k].name] = k;
          }
          this._vertexBufferLayouts[0] = {
            name: `composeStruct`,
            arrayStride: stride * 4,
            stepMode: `vertex`,
            attributes: this._composeBinLayout,
            offset: 0,
            size: this.vertexCount * stride * 4
          };
          this.allocVertexBuffer(this.vertexCount * stride);
          return;
        }
        this._attributeSlotLayouts[0] = [];
        let attributeOffset = 0;
        for (let i = 0; i < shaderReflection.attributes.length; i++) {
          const attributeInfo = shaderReflection.attributes[i];
          if (attributeInfo.name == `index`) continue;
          if (attributeInfo.type == `builtin`) continue;
          this._attributeLocation[attributeInfo.name] = attributeInfo.location;
          let attributeLayout = {
            name: attributeInfo.name,
            format: attributeInfo.format,
            offset: attributeOffset * 4,
            shaderLocation: attributeInfo.location,
            stride: VertexAttributeSize[attributeInfo.format]
          };
          this._attributeSlotLayouts[0][attributeInfo.location] = attributeLayout;
          let vertexInfo = vertexDataInfos.get(attributeInfo.name);
          if (!vertexInfo) {
            vertexInfo = {
              attribute: attributeInfo.name,
              data: new Float32Array(attributeInfo.size * this.vertexCount)
            };
            vertexDataInfos.set(attributeInfo.name, vertexInfo);
          }
          if (vertexInfo.data) {
            let len2 = vertexInfo.data.length / attributeLayout.stride;
            if (this.vertexCount != 0 && this.vertexCount != len2) {
              console.error(" vertex count not match attribute count");
            }
            this.vertexCount = len2;
          }
          attributeOffset += attributeInfo.size;
        }
        let len = att_all.data.length / attributeOffset;
        this.vertexCount = len;
        this._vertexBufferLayouts[0] = {
          name: `composeStruct`,
          arrayStride: attributeOffset * 4,
          stepMode: `vertex`,
          attributes: this._attributeSlotLayouts[0],
          offset: 0,
          size: this.vertexCount * attributeOffset * 4
        };
        this.allocVertexBuffer(this.vertexCount * attributeOffset);
      }
      upload(attribute, vertexDataInfo) {
        if (!this.vertexGPUBuffer) return;
        switch (this.geometryType) {
          case GeometryVertexType.split:
            {
              let location = this._attributeLocation[attribute];
              let vertexBufferLayout = this._vertexBufferLayouts[location];
              this.vertexGPUBuffer.node.setFloat32Array(vertexBufferLayout.offset / 4, vertexDataInfo.data);
            }
            break;
          case GeometryVertexType.compose:
            {
              for (let i = 0; i < this.vertexCount; i++) {
                const attributeLayout = this._attributeSlotLayouts[0][this._attributeLocation[attribute]];
                for (let k = 0; k < attributeLayout.stride; k++) {
                  let atData = vertexDataInfo.data[i * attributeLayout.stride + k];
                  let index = i * (this._vertexBufferLayouts[0].arrayStride / 4) + attributeLayout.offset / 4 + k;
                  this.vertexGPUBuffer.node.setFloat(atData, index);
                }
              }
            }
            break;
          case GeometryVertexType.compose_bin:
            this.vertexGPUBuffer.node.setFloat32Array(0, vertexDataInfo.data);
            break;
        }
        this.vertexGPUBuffer?.apply();
      }
      updateAttributes(vertexDataInfos) {
        switch (this.geometryType) {
          case GeometryVertexType.split:
            {
              for (let i = 0; i < this._vertexBufferLayouts.length; i++) {
                const vertexBufferLayout = this._vertexBufferLayouts[i];
                let attributeData = vertexDataInfos.get(vertexBufferLayout.name);
                this.vertexGPUBuffer.node.setFloat32Array(vertexBufferLayout.offset / 4, attributeData.data);
              }
            }
            break;
          case GeometryVertexType.compose:
            {
              for (let i = 0; i < this.vertexCount; i++) {
                this._attributeSlotLayouts.forEach((v) => {
                  for (let j = 0; j < v.length; j++) {
                    const attributeLayout = v[j];
                    let attributeData = vertexDataInfos.get(attributeLayout.name);
                    for (let k = 0; k < attributeLayout.stride; k++) {
                      let atData = attributeData.data[i * attributeLayout.stride + k];
                      let index = i * (this._vertexBufferLayouts[0].arrayStride / 4) + attributeLayout.offset / 4 + k;
                      this.vertexGPUBuffer.node.setFloat(atData, index);
                    }
                  }
                });
              }
            }
            break;
          case GeometryVertexType.compose_bin:
            {
              let attributeData = vertexDataInfos.get(VertexAttributeName.all);
              this.vertexGPUBuffer.node.setFloat32Array(0, attributeData.data);
            }
            break;
        }
        this.vertexGPUBuffer.apply();
      }
      compute() {
      }
      destroy() {
        this.vertexCount = null;
        this.geometryType = null;
        this._vertexBufferLayouts = null;
        this._attributeSlotLayouts = null;
        this._attributeLocation = null;
        if (this.vertexGPUBuffer)
          this.vertexGPUBuffer.destroy();
        this.vertexGPUBuffer = null;
        this._allocFloatCount = -1;
        this.bufferChanged = false;
        this._composeCanonical = null;
        this._composeStride = 0;
        this._composeBinLayout = null;
        this._composeBinStride = 0;
      }
    }

    class IndicesGPUBuffer extends GPUBufferBase {
      indicesNode;
      constructor(data) {
        super();
        this.bufferType = GPUBufferType.IndicesGPUBuffer;
        this.createIndicesBuffer(GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | GPUBufferUsage.INDEX | GPUBufferUsage.INDIRECT, data);
      }
      createIndicesBuffer(usage, data) {
        const size = data ? data.length : 0;
        this.createBuffer(usage, size, void 0, "IndicesGPUBuffer");
        if (data) {
          this.indicesNode = this.memory.allocation_node(data.length * 4);
          this.indicesNode.setArrayBuffer(0, data);
        }
      }
    }

    class GeometryIndicesBuffer {
      uuid = "";
      name;
      indicesGPUBuffer;
      indicesFormat = `uint16`;
      indicesCount = 0;
      constructor() {
      }
      createIndicesBuffer(indicesData) {
        if (indicesData.data instanceof Uint16Array) {
          this.indicesFormat = `uint16`;
        } else if (indicesData.data instanceof Uint32Array) {
          this.indicesFormat = `uint32`;
        }
        this.indicesCount = indicesData.data.length;
        this.indicesGPUBuffer = new IndicesGPUBuffer(indicesData.data);
      }
      upload(data) {
        this.indicesGPUBuffer.indicesNode.setArrayBuffer(0, data);
        this.indicesGPUBuffer.apply();
      }
      compute() {
      }
      destroy() {
        this.uuid = null;
        this.name = null;
        this.indicesFormat = null;
        this.indicesCount = null;
        this.indicesGPUBuffer.destroy();
        this.indicesGPUBuffer = null;
      }
      /**
       * Get indices from geometry data 
       * Get position attribute from geometry data 
       * Get normal attribute from geometry data 
       * Get tangent attribute from geometry data 
       * Get uv0 attribute from geometry data 
       * Get uv1 attribute from geometry data 
       * Get uv2 attribute from geometry data 
       * 
       * Change position data to GPUBuffer and apply
       * Change normal data to GPUBuffer and apply
       * Change tangent data to GPUBuffer and apply
       * Change uv0 data to GPUBuffer and apply
       * Change uv1 data to GPUBuffer and apply
       * Change uv2 data to GPUBuffer and apply
       */
    }

    class SubGeometry {
      /** The LOD levels making up this sub-geometry. */
      lodLevels;
    }
    class GeometryBase {
      /** Unique identifier of this geometry instance. */
      instanceID;
      /** Human-readable name of this geometry. */
      name;
      /** Sub-geometries with their per-LOD draw descriptors. */
      subGeometries = [];
      /** Whether morph targets are stored as relative offsets. */
      morphTargetsRelative;
      /** Maps morph-target names to their attribute indices. */
      morphTargetDictionary;
      /** Names of the skin joints used by this geometry. */
      skinNames;
      /** Inverse bind-pose matrices for skinning. */
      bindPose;
      /** Blend-shape (morph target) data for this geometry. */
      blendShapeData;
      /** Number of floats per vertex for interleaved buffers. */
      vertexDim;
      /** Number of vertices in this geometry. */
      vertexCount = 0;
      _bounds;
      _attributeMap;
      _attributes;
      _indicesBuffer;
      _vertexBuffer;
      _onChange = true;
      _wireframeLines;
      constructor() {
        this.instanceID = UUID();
        this._attributeMap = /* @__PURE__ */ new Map();
        this._attributes = [];
        this._vertexBuffer = new GeometryVertexBuffer();
      }
      /** Get the GPU index buffer of this geometry. */
      get indicesBuffer() {
        return this._indicesBuffer;
      }
      /** Get the GPU vertex buffer of this geometry. */
      get vertexBuffer() {
        return this._vertexBuffer;
      }
      /** Get the list of vertex attribute names present on this geometry. */
      get vertexAttributes() {
        return this._attributes;
      }
      /** Get the map from attribute name to its vertex attribute data. */
      get vertexAttributeMap() {
        return this._attributeMap;
      }
      /** Get the vertex layout type of this geometry. */
      get geometryType() {
        return this._vertexBuffer.geometryType;
      }
      /** Set the vertex layout type of this geometry. */
      set geometryType(value) {
        this._vertexBuffer.geometryType = value;
      }
      /** Get the bounding box of this geometry, computing it from positions on first access. */
      get bounds() {
        if (!this._bounds) {
          this._bounds = new BoundingBox(new Vector3(), new Vector3(1, 1, 1));
          this._bounds.min.x = Number.MAX_VALUE;
          this._bounds.min.y = Number.MAX_VALUE;
          this._bounds.min.z = Number.MAX_VALUE;
          this._bounds.max.x = -Number.MAX_VALUE;
          this._bounds.max.y = -Number.MAX_VALUE;
          this._bounds.max.z = -Number.MAX_VALUE;
          let attributes = this.getAttribute(VertexAttributeName.position);
          if (attributes && attributes.data) {
            for (let i = 0; i < attributes.data.length / 3; i++) {
              const px = attributes.data[i * 3 + 0];
              const py = attributes.data[i * 3 + 1];
              const pz = attributes.data[i * 3 + 2];
              if (this._bounds.min.x > px) {
                this._bounds.min.x = px;
              }
              if (this._bounds.min.y > py) {
                this._bounds.min.y = py;
              }
              if (this._bounds.min.z > pz) {
                this._bounds.min.z = pz;
              }
              if (this._bounds.max.x < px) {
                this._bounds.max.x = px;
              }
              if (this._bounds.max.y < py) {
                this._bounds.max.y = py;
              }
              if (this._bounds.max.z < pz) {
                this._bounds.max.z = pz;
              }
            }
          }
          this._bounds.setFromMinMax(this._bounds.min, this._bounds.max);
        }
        return this._bounds;
      }
      /** Set the bounding box of this geometry. */
      set bounds(value) {
        this._bounds = value;
      }
      /**
       * add subGeometry from lod level 
       * @param lodLevels @see LODDescriptor
       */
      addSubGeometry(...lodLevels) {
        let sub = new SubGeometry();
        sub.lodLevels = lodLevels;
        this.subGeometries.push(sub);
        return sub;
      }
      /**
       * Build the GPU vertex buffer + buffer-layout array from this
       * geometry's attribute data, driven by the consuming pass's
       * `ShaderReflection`. The layout array is indexed by shader slot
       * (`attribute.location`), so the LAYOUT contents depend on which
       * attributes the shader actually declares.
       *
       * Originally this was gated purely on `_onChange` — i.e. ran once
       * after the geometry's attribute data was set. That broke
       * multi-pass materials: when a single geometry is consumed by a
       * color pass that declares N attributes (say position / normal /
       * uv) AND a depth pass that declares N+1 (adding TEXCOORD_1 at
       * slot 3 via VertexAttributes #include), the color pass ran
       * first, populated slots 0..N-1, and cleared `_onChange`. The
       * depth pass's `generate` call was then a no-op, so the pipeline
       * built with `vertexBufferLayouts` was missing slot N — WebGPU
       * rejects it with "Vertex attribute slot X used in shader is not
       * present in VertexState".
       *
       * The fix: rebuild also when the incoming reflection requires a
       * slot the current layout array doesn't yet have. The data is
       * already in `_attributeMap`; `createVertexBuffer` will pick up
       * the missing slot. We keep the `_onChange` short-circuit for the
       * normal "shader requirements unchanged" case so dynamic geometry
       * updates don't pay a per-frame `createVertexBuffer` cost.
       */
      generate(shaderReflection) {
        if (!this._onChange) {
          if (!this._vertexBuffer?.needsRebuild(shaderReflection)) return;
        }
        this._onChange = false;
        this._indicesBuffer.upload(this.getAttribute(VertexAttributeName.indices).data);
        this._vertexBuffer.createVertexBuffer(this._attributeMap, shaderReflection);
        this._vertexBuffer.updateAttributes(this._attributeMap);
        this.vertexCount = this._vertexBuffer.vertexCount;
      }
      /**
       * Set the index data of this geometry, creating its index buffer.
       * @param data the index buffer data
       */
      setIndices(data) {
        if (!this._attributeMap.has(VertexAttributeName.indices)) {
          let vertexInfo = {
            attribute: VertexAttributeName.indices,
            data
          };
          this._attributeMap.set(VertexAttributeName.indices, vertexInfo);
          this._indicesBuffer = new GeometryIndicesBuffer();
          this._indicesBuffer.createIndicesBuffer(vertexInfo);
        }
      }
      /**
       * Set the position (vertex) data of this geometry.
       * @param data the position buffer data
       */
      setVertexs(data) {
        let vertexInfo = {
          attribute: VertexAttributeName.position,
          data
        };
        this._attributeMap.set(vertexInfo.attribute, vertexInfo);
        this._attributes.push(vertexInfo.attribute);
      }
      /**
       * Set the data of a named vertex attribute (or indices/position).
       * @param attribute the attribute name
       * @param data the attribute buffer data
       */
      setAttribute(attribute, data) {
        if (attribute == VertexAttributeName.indices) {
          this.setIndices(data);
        } else if (attribute == VertexAttributeName.position) {
          this.setVertexs(data);
        } else {
          let vertexInfo = {
            attribute,
            data
          };
          this._attributeMap.set(attribute, vertexInfo);
          this._attributes.push(attribute);
        }
      }
      /**
       * Get the data of a named vertex attribute.
       * @param attribute the attribute name
       */
      getAttribute(attribute) {
        return this._attributeMap.get(attribute);
      }
      /**
       * Whether this geometry has the given named attribute.
       * @param attribute the attribute name
       */
      hasAttribute(attribute) {
        return this._attributeMap.has(attribute);
      }
      /**
       * Generate (and cache) the line list describing this geometry's wireframe.
       * @returns the wireframe line vertices, or null if not available
       */
      genWireframe() {
        if (this._wireframeLines) return this._wireframeLines;
        if (this.geometryType == GeometryVertexType.split || this.geometryType == GeometryVertexType.compose) {
          let positionAttribute = this.getAttribute(VertexAttributeName.position);
          let indexAttribute = this.getAttribute(VertexAttributeName.indices);
          if (indexAttribute && positionAttribute && indexAttribute.data.length > 0) {
            let vertexData = positionAttribute.data;
            let lines = [];
            for (let i = 0; i < indexAttribute.data.length / 3; i++) {
              const i1 = indexAttribute.data[i * 3 + 0];
              const i2 = indexAttribute.data[i * 3 + 1];
              const i3 = indexAttribute.data[i * 3 + 2];
              let p1 = new Vector3(vertexData[i1 * 3 + 0], vertexData[i1 * 3 + 1], vertexData[i1 * 3 + 2]);
              let p2 = new Vector3(vertexData[i2 * 3 + 0], vertexData[i2 * 3 + 1], vertexData[i2 * 3 + 2]);
              let p3 = new Vector3(vertexData[i3 * 3 + 0], vertexData[i3 * 3 + 1], vertexData[i3 * 3 + 2]);
              lines.push(p1, p2);
              lines.push(p2, p3);
              lines.push(p3, p1);
            }
            this._wireframeLines = lines;
            return lines;
          }
        } else if (this.geometryType == GeometryVertexType.compose_bin) {
          let vertexAttribute = this.getAttribute(VertexAttributeName.all);
          let strip = this.vertexDim;
          let indexAttribute = this.getAttribute(VertexAttributeName.indices);
          if (indexAttribute && vertexAttribute && indexAttribute.data.length > 0) {
            let vertexData = vertexAttribute.data;
            let lines = [];
            for (let i = 0; i < indexAttribute.data.length / 3; i++) {
              const i1 = indexAttribute.data[i * 3 + 0];
              const i2 = indexAttribute.data[i * 3 + 1];
              const i3 = indexAttribute.data[i * 3 + 2];
              let p1 = new Vector3(vertexData[i1 * strip + 0], vertexData[i1 * strip + 1], vertexData[i1 * strip + 2]);
              let p2 = new Vector3(vertexData[i2 * strip + 0], vertexData[i2 * strip + 1], vertexData[i2 * strip + 2]);
              let p3 = new Vector3(vertexData[i3 * strip + 0], vertexData[i3 * strip + 1], vertexData[i3 * strip + 2]);
              lines.push(p1, p2);
              lines.push(p2, p3);
              lines.push(p3, p1);
            }
            this._wireframeLines = lines;
            return lines;
          }
        }
        return null;
      }
      /**
       * Run the compute step on this geometry's index and vertex buffers.
       */
      compute() {
        if (this._indicesBuffer) {
          this._indicesBuffer.compute();
        }
        if (this._vertexBuffer) {
          this._vertexBuffer.compute();
        }
      }
      static crossA = Vector3.UP.clone();
      static crossB = Vector3.UP.clone();
      static crossRet = Vector3.UP.clone();
      static point1 = Vector3.UP.clone();
      static point2 = Vector3.UP.clone();
      static point3 = Vector3.UP.clone();
      /**
       * Compute per-vertex normals from the position and index data and upload them.
       * @returns this geometry for chaining
       */
      computeNormals() {
        let posAttrData = this.getAttribute(VertexAttributeName.position);
        let normalAttrData = this.getAttribute(VertexAttributeName.normal);
        let indexAttrData = this.getAttribute(VertexAttributeName.indices);
        if (!posAttrData || !normalAttrData || !indexAttrData) {
          return this;
        }
        let trianglesCount = indexAttrData.data.length / 3;
        let point1 = GeometryBase.point1;
        let point2 = GeometryBase.point2;
        let point3 = GeometryBase.point3;
        let crossA = GeometryBase.crossA;
        let crossB = GeometryBase.crossB;
        let crossRet = GeometryBase.crossRet;
        for (let i = 0; i < trianglesCount; i++) {
          let index1 = indexAttrData.data[i * 3];
          let index2 = indexAttrData.data[i * 3 + 1];
          let index3 = indexAttrData.data[i * 3 + 2];
          point1.set(posAttrData.data[index1 * 3], posAttrData.data[index1 * 3 + 1], posAttrData.data[index1 * 3 + 2]);
          point2.set(posAttrData.data[index2 * 3], posAttrData.data[index2 * 3 + 1], posAttrData.data[index2 * 3 + 2]);
          point3.set(posAttrData.data[index3 * 3], posAttrData.data[index3 * 3 + 1], posAttrData.data[index3 * 3 + 2]);
          Vector3.sub(point1, point2, crossA).normalize();
          Vector3.sub(point1, point3, crossB).normalize();
          Vector3.cross(crossA, crossB, crossRet);
          let normal = crossRet.normalize();
          normalAttrData.data[index1 * 3] = normalAttrData.data[index2 * 3] = normalAttrData.data[index3 * 3] = normal.x;
          normalAttrData.data[index1 * 3 + 1] = normalAttrData.data[index2 * 3 + 1] = normalAttrData.data[index3 * 3 + 1] = normal.y;
          normalAttrData.data[index1 * 3 + 2] = normalAttrData.data[index2 * 3 + 2] = normalAttrData.data[index3 * 3 + 2] = normal.z;
        }
        this._vertexBuffer.upload(VertexAttributeName.normal, normalAttrData);
        return this;
      }
      /**
       * Whether this geometry is a built-in primitive.
       */
      isPrimitive() {
        return false;
      }
      /**
       * Release the buffers and data held by this geometry.
       * @param force whether to force-destroy
       */
      destroy(force) {
        this.instanceID = null;
        this.name = null;
        this.subGeometries = null;
        this.morphTargetDictionary = null;
        this._bounds?.destroy();
        this._bounds = null;
        this._attributeMap = null;
        this._attributes = null;
        this._indicesBuffer?.destroy();
        this._vertexBuffer?.destroy();
        this._indicesBuffer = null;
        this._vertexBuffer = null;
      }
    }

    class PlaneGeometry extends GeometryBase {
      /**
       * Width of the plane
       */
      width;
      /**
       * Height of the plane
       */
      height;
      /**
       * Number of width segments of a plane
       */
      segmentW;
      /**
       * Number of height segments of a plane
       */
      segmentH;
      /**
       * Define the normal vector of a plane
       */
      up;
      /**
       *
       * @constructor
       * @param width Width of the plane
       * @param height Height of the plane
       * @param segmentW Number of width segments of a plane
       * @param segmentH Number of height segments of a plane
       * @param up Define the normal vector of a plane
       */
      constructor(width, height, segmentW = 1, segmentH = 1, up = Vector3.Y_AXIS) {
        super();
        this.width = width;
        this.height = height;
        this.segmentW = segmentW;
        this.segmentH = segmentH;
        this.up = up;
        this.buildGeometry(this.up);
      }
      buildGeometry(axis) {
        var x, y;
        var numIndices;
        var base;
        var tw = this.segmentW + 1;
        (this.segmentH + 1) * tw;
        this.bounds = new BoundingBox(Vector3.ZERO.clone(), new Vector3(this.width, 1, this.height));
        numIndices = this.segmentH * this.segmentW * 6;
        let vertexCount = (this.segmentW + 1) * (this.segmentH + 1);
        let position_arr = new Float32Array(vertexCount * 3);
        let normal_arr = new Float32Array(vertexCount * 3);
        let uv_arr = new Float32Array(vertexCount * 2);
        let indices_arr;
        let totalIndexCount = this.segmentW * this.segmentH * 2 * 3;
        if (totalIndexCount >= Uint16Array.length) {
          indices_arr = new Uint32Array(this.segmentW * this.segmentH * 2 * 3);
        } else {
          indices_arr = new Uint16Array(this.segmentW * this.segmentH * 2 * 3);
        }
        numIndices = 0;
        var indexP = 0;
        var indexN = 0;
        var indexU = 0;
        for (var yi = 0; yi <= this.segmentH; ++yi) {
          for (var xi = 0; xi <= this.segmentW; ++xi) {
            x = (xi / this.segmentW - 0.5) * this.width;
            y = (yi / this.segmentH - 0.5) * this.height;
            switch (axis) {
              case Vector3.Y_AXIS:
                position_arr[indexP++] = x;
                position_arr[indexP++] = 0;
                position_arr[indexP++] = y;
                normal_arr[indexN++] = 0;
                normal_arr[indexN++] = 1;
                normal_arr[indexN++] = 0;
                break;
              case Vector3.Z_AXIS:
                position_arr[indexP++] = x;
                position_arr[indexP++] = -y;
                position_arr[indexP++] = 0;
                normal_arr[indexN++] = 0;
                normal_arr[indexN++] = 0;
                normal_arr[indexN++] = 1;
                break;
              case Vector3.X_AXIS:
                position_arr[indexP++] = 0;
                position_arr[indexP++] = x;
                position_arr[indexP++] = y;
                normal_arr[indexN++] = 1;
                normal_arr[indexN++] = 0;
                normal_arr[indexN++] = 0;
                break;
              default:
                position_arr[indexP++] = x;
                position_arr[indexP++] = 0;
                position_arr[indexP++] = y;
                normal_arr[indexN++] = 0;
                normal_arr[indexN++] = 1;
                normal_arr[indexN++] = 0;
                break;
            }
            uv_arr[indexU++] = xi / this.segmentW;
            uv_arr[indexU++] = yi / this.segmentH;
            if (xi != this.segmentW && yi != this.segmentH) {
              base = xi + yi * tw;
              indices_arr[numIndices++] = base + 1;
              indices_arr[numIndices++] = base;
              indices_arr[numIndices++] = base + tw;
              indices_arr[numIndices++] = base + 1;
              indices_arr[numIndices++] = base + tw;
              indices_arr[numIndices++] = base + tw + 1;
            }
          }
        }
        this.setIndices(indices_arr);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indices_arr.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
      }
    }

    class Material {
      /**
       *
       * Material Unique Identifier
       */
      instanceID;
      /**
        *
        * name of this material
        */
      name;
      /** Whether this material is enabled for rendering. */
      enable = true;
      _oitMode = "sorted";
      /** Order-independent transparency mode opt-in.
       *
       *  - `'sorted'` (default): back-to-front sorted alpha-blend. Cheap,
       *    correct between meshes, but in-mesh triangle order is geometry-
       *    based not depth-based so self-overlapping meshes (spheres,
       *    torus) show banding.
       *  - `'weighted'`: McGuire-Bavoil 2013 Weighted-Blended OIT. Single-
       *    pass, order-independent, no in-mesh banding. Approximate —
       *    accum.rgb/accum.a degenerates to a depth-weighted average so
       *    α=1 looks averaged-milky at small scene scales (the front-vs-
       *    back depth-weight ratio saturates the paper's z/200 norm).
       *    Use for unbounded transparent layer counts: particles, smoke,
       *    foliage, hair cards.
       *  - `'depth-peel'`: Dual depth peeling. Multi-pass
       *    (passCount × 2 layers), order-correct over operator. α=1 is
       *    cleanly opaque — front fragment dominates because subsequent
       *    layers get multiplied by (1 - frontColor.a) = 0. Hard layer
       *    count limit (default 10). Use for hero glass, scientific
       *    visualization, layered architectural geometry.
       *
       *  All three only take effect when `engine.setting.render.useOIT`
       *  is true (otherwise everything falls through the sorted path).
       *
       *  Setter notifies attached renderers so the corresponding derived
       *  pass(es) get lazily generated when flipping mode at runtime.
       *  Without this, callers had to follow up with an alphaMode setter
       *  call to provoke `refreshRenderClassification` → `castNeedPass`.
       *
       *  Documented at Material-level (not LitMaterial) so any future
       *  material subclass (particle, decal) can opt in. */
      get oitMode() {
        return this._oitMode;
      }
      /** Set the order-independent transparency mode, notifying renderers to re-classify the affected passes. */
      set oitMode(value) {
        if (this._oitMode === value) return;
        this._oitMode = value;
        this._notifyRenderClassificationDirty();
      }
      _defaultSubShader;
      /** The shader instance backing this material. */
      _shader;
      constructor() {
        this.instanceID = UUID();
      }
      /** Set the shader for this material and cache its default sub-shader. */
      set shader(shader) {
        this._shader = shader;
        this._defaultSubShader = shader.getDefaultShaders()[0];
      }
      /** Get the shader bound to this material. */
      get shader() {
        return this._shader;
      }
      /** Whether the default sub-shader renders both faces (no back-face culling). */
      get doubleSide() {
        return this._defaultSubShader.doubleSide;
      }
      /** Enable or disable double-sided rendering on the default sub-shader. */
      set doubleSide(value) {
        this._defaultSubShader.doubleSide = value;
      }
      /** Whether this material casts shadows. */
      get castShadow() {
        return this._defaultSubShader.shaderState.castShadow;
      }
      /** Enable or disable shadow casting for this material. */
      set castShadow(value) {
        let shaderState = this._defaultSubShader.shaderState;
        if (value != shaderState.castShadow) {
          shaderState.castShadow = value;
        }
      }
      /** Whether this material receives shadows from other casters. */
      get acceptShadow() {
        return this._defaultSubShader.shaderState.acceptShadow;
      }
      /** Enable or disable shadow receiving for this material. */
      set acceptShadow(value) {
        let shaderState = this._defaultSubShader.shaderState;
        if (shaderState.acceptShadow != value) {
          shaderState.acceptShadow = value;
          this._defaultSubShader.noticeShaderChange();
          this._defaultSubShader.noticeValueChange();
        }
      }
      /** Whether this material contributes to reflection probes. */
      get castReflection() {
        return this._defaultSubShader.shaderState.castReflection;
      }
      /** Enable or disable reflection casting for this material. */
      set castReflection(value) {
        this._defaultSubShader.shaderState.castReflection = value;
      }
      /** The blend mode of the default sub-shader. */
      get blendMode() {
        return this._defaultSubShader.blendMode;
      }
      /** Set the blend mode of the default sub-shader. */
      set blendMode(value) {
        this._defaultSubShader.blendMode = value;
      }
      /** The depth comparison function of the default sub-shader. */
      get depthCompare() {
        return this._defaultSubShader.depthCompare;
      }
      /** Set the depth comparison function across all passes of this material. */
      set depthCompare(value) {
        this._defaultSubShader.depthCompare = value;
        for (let item of this._shader.passShader.values()) {
          for (let s of item) {
            s.depthCompare = value;
          }
        }
      }
      /** Whether this material is rendered as transparent. */
      get transparent() {
        return this._defaultSubShader.shaderState.transparent;
      }
      /** Enable or disable transparency, moving the pass to the transparent queue when enabled. */
      set transparent(value) {
        this._defaultSubShader.shaderState.transparent = value;
        if (value) {
          this._defaultSubShader.renderOrder = 3e3;
        }
      }
      /** The face culling mode of the default sub-shader. */
      get cullMode() {
        return this._defaultSubShader.cullMode;
      }
      /** Set the face culling mode across all passes of this material. */
      set cullMode(value) {
        if (this._defaultSubShader.cullMode != value) {
          for (let list of this._shader.passShader.values()) {
            for (let pass of list) {
              pass.cullMode = value;
            }
          }
          this._defaultSubShader.cullMode = value;
        }
      }
      /** Whether depth writing is enabled for the default sub-shader. */
      get depthWriteEnabled() {
        return this._defaultSubShader.depthWriteEnabled;
      }
      /** Enable or disable depth writing for the default sub-shader. */
      set depthWriteEnabled(value) {
        this._defaultSubShader.depthWriteEnabled = value;
      }
      /**
       * Stencil front face state
       */
      get stencilFront() {
        return this._defaultSubShader.stencilFront;
      }
      /** Set the stencil front face state. */
      set stencilFront(value) {
        this._defaultSubShader.stencilFront = value;
      }
      /**
       * Stencil back face state
       */
      get stencilBack() {
        return this._defaultSubShader.stencilBack;
      }
      /** Set the stencil back face state. */
      set stencilBack(value) {
        this._defaultSubShader.stencilBack = value;
      }
      /**
       * Stencil read mask
       */
      get stencilReadMask() {
        return this._defaultSubShader.stencilReadMask;
      }
      /** Set the stencil read mask. */
      set stencilReadMask(value) {
        this._defaultSubShader.stencilReadMask = value;
      }
      /**
       * Stencil write mask
       */
      get stencilWriteMask() {
        return this._defaultSubShader.stencilWriteMask;
      }
      /** Set the stencil write mask. */
      set stencilWriteMask(value) {
        this._defaultSubShader.stencilWriteMask = value;
      }
      /**
       * Stencil reference value
       */
      get stencilRef() {
        return this._defaultSubShader.stencilRef;
      }
      /** Set the stencil reference value. */
      set stencilRef(value) {
        this._defaultSubShader.stencilRef = value;
      }
      /** Enable or disable billboard orientation via the USE_BILLBOARD shader define. */
      set useBillboard(value) {
        this._defaultSubShader.setDefine("USE_BILLBOARD", value);
      }
      /** The primitive topology of the default sub-shader. */
      get topology() {
        return this._defaultSubShader.topology;
      }
      /** Set the primitive topology of the default sub-shader. */
      set topology(value) {
        this._defaultSubShader.topology = value;
      }
      /** Set the base color uniform. */
      set baseColor(color) {
        this.shader.setUniformColor(`baseColor`, color);
      }
      /** Get the base color uniform. */
      get baseColor() {
        return this.shader.getUniformColor("baseColor");
      }
      /**
       * get render pass by renderType
       * @param passType 
       * @returns 
       */
      getPass(passType) {
        return this._shader.getSubShaders(passType);
      }
      /**
       * get all color render pass
       * @returns 
       */
      getAllPass() {
        return this._shader.getSubShaders(PassType.COLOR);
      }
      /**
       * clone one material
       * @returns Material
       */
      clone() {
        let newMat = new Material();
        newMat.shader = this.shader.clone();
        return newMat;
      }
      /** Release this material's shader and clear its identifying fields. */
      destroy(force) {
        this.name = null;
        this.instanceID = null;
        this._shader.destroy(force);
        this._shader = null;
      }
      /** Set a shader define flag on this material's shader. */
      setDefine(define, value) {
        this.shader.setDefine(define, value);
      }
      /** Get the value of a shader define flag. */
      getDefine(define) {
        return this.shader.getDefine(define);
      }
      /** Bind a texture to the named shader property. */
      setTexture(propertyName, texture) {
        this._shader.setTexture(propertyName, texture);
      }
      /** Bind a storage GPU buffer to the named shader property. */
      setStorageBuffer(propertyName, buffer) {
        this._shader.setStorageBuffer(propertyName, buffer);
      }
      /** Bind a uniform GPU buffer to the named shader property. */
      setUniformBuffer(propertyName, buffer) {
        this._shader.setStorageBuffer(propertyName, buffer);
      }
      /** Set a float uniform on the named shader property. */
      setUniformFloat(propertyName, value) {
        this._shader.setUniformFloat(propertyName, value);
      }
      /** Set a 32-bit integer uniform on the named shader property. */
      setUniformInt32(propertyName, value) {
        this._shader.setUniformInt32(propertyName, value);
      }
      /** Set a Vector2 uniform on the named shader property. */
      setUniformVector2(propertyName, value) {
        this._shader.setUniformVector2(propertyName, value);
      }
      /** Set a Vector3 uniform on the named shader property. */
      setUniformVector3(propertyName, value) {
        this._shader.setUniformVector3(propertyName, value);
      }
      /** Set a Vector4 uniform on the named shader property. */
      setUniformVector4(propertyName, value) {
        this._shader.setUniformVector4(propertyName, value);
      }
      /** Set a color uniform on the named shader property. */
      setUniformColor(propertyName, value) {
        this._shader.setUniformColor(propertyName, value);
      }
      /** Get the float value of the named uniform. */
      getUniformFloat(str) {
        return this._shader.getUniform(str).data;
      }
      /** Get the 32-bit integer value of the named uniform. */
      getUniformInt32(str) {
        return this._shader.getUniform(str).data;
      }
      /** Get the Vector2 value of the named uniform. */
      getUniformV2(str) {
        return this._shader.getUniformVector2(str);
      }
      /** Get the Vector3 value of the named uniform. */
      getUniformV3(str) {
        return this._shader.getUniformVector3(str);
      }
      /** Get the Vector4 value of the named uniform. */
      getUniformV4(str) {
        return this._shader.getUniformVector4(str);
      }
      /** Get the color value of the named uniform. */
      getUniformColor(str) {
        return this._shader.getUniformColor(str);
      }
      /** Get the texture bound to the named shader property. */
      getTexture(str) {
        return this._shader.getTexture(str);
      }
      /** Get the storage buffer bound to the named shader property. */
      getStorageBuffer(str) {
        return this._shader.getStorageBuffer(str);
      }
      /** Get the struct storage buffer bound to the named shader property. */
      getStructStorageBuffer(str) {
        return this._shader.getStructStorageBuffer(str);
      }
      /** Get the uniform buffer bound to the named shader property. */
      getUniformBuffer(str) {
        return this._shader.getUniformBuffer(str);
      }
      /** Upload pending uniform changes to the GPU. */
      applyUniform() {
        this._shader.applyUniform();
      }
      /**
       * Re-bucket every renderer holding this material into the right
       * EntityCollect queue (opaque vs transparent). Subclass alphaMode
       * setters call this after flipping pass.renderOrder so live
       * `alphaMode = 'BLEND'` ↔ `'HASH'` toggles take effect on the
       * frame they fire — no rebuild required.
       *
       * Walks `Reference.getReference(this)` (the material→user back-
       * channel populated by RenderNode `set materials`) and calls
       * `refreshRenderClassification()` on each user. The duck-type
       * check avoids importing RenderNode here (cyclic).
       */
      _notifyRenderClassificationDirty() {
        const refs = Reference.getInstance().getReference(this);
        if (!refs) return;
        refs.forEach((_, target) => {
          if (target && typeof target.refreshRenderClassification === "function") {
            target.refreshRenderClassification();
          }
        });
      }
    }

    class Shader {
      /** Compute passes attached to this shader. */
      computes;
      /** Render passes grouped by pass type. */
      passShader;
      constructor() {
        this.computes = [];
        this.passShader = /* @__PURE__ */ new Map();
      }
      /**
       * Add a render pass to this shader.
       * @param renderShader the render pass to add
       * @param index optional insertion index; appended when -1
       */
      addRenderPass(renderShader, index = -1) {
        let subShader = this.passShader.get(renderShader.passType) || [];
        if (index == -1) {
          subShader.push(renderShader);
        } else {
          subShader.splice(index, -1, renderShader);
        }
        this.passShader.set(renderShader.passType, subShader);
      }
      /**
       * Remove a render pass from this shader.
       * @param renderShader the render pass to remove
       * @param index optional index within the pass type bucket
       */
      removeShader(renderShader, index = -1) {
        let subShader = this.passShader.get(renderShader.passType);
        if (subShader) {
          if (index == -1) {
            let index2 = subShader.indexOf(renderShader);
            if (index2 != -1) {
              subShader.splice(index2);
            }
          } else {
            subShader.splice(index, 1);
          }
        }
      }
      /**
       * Remove a render pass by pass type and index.
       * @param passType the pass type bucket
       * @param index optional index; removes the whole bucket when -1
       */
      removeShaderByIndex(passType, index = -1) {
        let subShader = this.passShader.get(passType);
        if (subShader) {
          if (index == -1) {
            this.passShader.delete(passType);
          } else {
            subShader.splice(index, 1);
          }
        }
      }
      /**
       * Get the render passes registered for the given pass type.
       * @param passType the pass type bucket
       */
      getSubShaders(passType) {
        return this.passShader.get(passType) || [];
      }
      /**
       * Whether any render pass is registered for the given pass type.
       * @param passType the pass type bucket
       */
      hasSubShaders(passType) {
        let subs = this.passShader.get(passType);
        return subs.length > 0;
      }
      /**
       * Get the default (COLOR) render passes.
       */
      getDefaultShaders() {
        return this.passShader.get(PassType.COLOR);
      }
      /**
       * Get the first default (COLOR) render pass.
       */
      getDefaultColorShader() {
        return this.passShader.get(PassType.COLOR)[0];
      }
      /**
       * Set a preprocessor define on all render passes.
       * @param arg0 the define name
       * @param arg1 the define value
       */
      setDefine(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setDefine(arg0, arg1);
          }
        }
      }
      /**
       * Get the value of a preprocessor define from the render passes.
       * @param arg0 the define name
       */
      getDefine(arg0) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            if (rd.defineValue[arg0] != null)
              return rd.defineValue[arg0];
          }
        }
        return false;
      }
      /**
       * Whether any render pass declares the given preprocessor define.
       * @param arg0 the define name
       */
      hasDefine(arg0) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            let has = rd.hasDefine(arg0);
            if (has)
              return has;
          }
        }
        return false;
      }
      /**
       * Remove a preprocessor define from all render passes.
       * @param arg0 the define name
       */
      deleteDefine(arg0) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.deleteDefine(arg0);
          }
        }
      }
      /**
       * Set a uniform value on all render passes.
       * @param arg0 the uniform name
       * @param arg1 the uniform value
       */
      setUniform(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniform(arg0, arg1);
          }
        }
      }
      /**
       * Set a float uniform on all render passes.
       * @param arg0 the uniform name
       * @param arg1 the float value
       */
      setUniformFloat(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniformFloat(arg0, arg1);
          }
        }
      }
      /**
       * Set a 32-bit integer uniform on all render passes.
       * @param arg0 the uniform name
       * @param arg1 the integer value
       */
      setUniformInt32(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniformInt32(arg0, arg1);
          }
        }
      }
      /**
       * Set a Vector2 uniform on all render passes.
       * @param arg0 the uniform name
       * @param arg1 the vector value
       */
      setUniformVector2(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniformVector2(arg0, arg1);
          }
        }
      }
      /**
       * Set a Vector3 uniform on all render passes.
       * @param arg0 the uniform name
       * @param arg1 the vector value
       */
      setUniformVector3(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniformVector3(arg0, arg1);
          }
        }
      }
      /**
       * Set a Vector4 uniform on all render passes.
       * @param arg0 the uniform name
       * @param arg1 the vector value
       */
      setUniformVector4(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniformVector4(arg0, arg1);
          }
        }
      }
      /**
       * Set a color uniform on all render passes.
       * @param arg0 the uniform name
       * @param arg1 the color value
       */
      setUniformColor(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniformColor(arg0, arg1);
          }
        }
      }
      /**
       * Get a uniform value from the default color pass.
       * @param arg0 the uniform name
       */
      getUniform(arg0) {
        return this.getDefaultColorShader().getUniform(arg0);
      }
      /**
       * Get a float uniform from the default color pass.
       * @param arg0 the uniform name
       */
      getUniformFloat(arg0) {
        return this.getDefaultColorShader().getUniformFloat(arg0);
      }
      /**
       * Get a Vector2 uniform from the default color pass.
       * @param arg0 the uniform name
       */
      getUniformVector2(arg0) {
        return this.getDefaultColorShader().getUniformVector2(arg0);
      }
      /**
       * Get a Vector3 uniform from the default color pass.
       * @param arg0 the uniform name
       */
      getUniformVector3(arg0) {
        return this.getDefaultColorShader().getUniformVector3(arg0);
      }
      /**
       * Get a Vector4 uniform from the default color pass.
       * @param arg0 the uniform name
       */
      getUniformVector4(arg0) {
        return this.getDefaultColorShader().getUniformVector4(arg0);
      }
      /**
       * Get a color uniform from the default color pass.
       * @param arg0 the uniform name
       */
      getUniformColor(arg0) {
        return this.getDefaultColorShader().getUniformColor(arg0);
      }
      /**
       * Set a texture on all render passes and enable its `USE_*` define.
       * @param arg0 the texture name
       * @param arg1 the texture
       */
      setTexture(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setTexture(arg0, arg1);
          }
        }
        this.setDefine(`USE_${arg0.toLocaleUpperCase()}`, true);
      }
      /**
       * Get a texture from the default color pass.
       * @param arg0 the texture name
       */
      getTexture(arg0) {
        return this.getDefaultColorShader().textures[arg0];
      }
      /**
       * Set a uniform buffer on all render passes.
       * @param arg0 the buffer name
       * @param arg1 the uniform buffer
       */
      setUniformBuffer(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setUniformBuffer(arg0, arg1);
          }
        }
      }
      /**
       * Get a uniform buffer from the default color pass.
       * @param arg0 the buffer name
       */
      getUniformBuffer(arg0) {
        return this.getDefaultColorShader().getBuffer(arg0);
      }
      /**
       * Set a storage buffer on all render passes.
       * @param arg0 the buffer name
       * @param arg1 the storage buffer
       */
      setStorageBuffer(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setStorageBuffer(arg0, arg1);
          }
        }
      }
      /**
       * Get a storage buffer from the default color pass.
       * @param arg0 the buffer name
       */
      getStorageBuffer(arg0) {
        return this.getDefaultColorShader().getBuffer(arg0);
      }
      /**
       * Set a struct storage buffer on all render passes.
       * @param arg0 the buffer name
       * @param arg1 the struct storage buffer
       */
      setStructStorageBuffer(arg0, arg1) {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.setStructStorageBuffer(arg0, arg1);
          }
        }
      }
      /**
       * Get a struct storage buffer from the default color pass.
       * @param arg0 the buffer name
       */
      getStructStorageBuffer(arg0) {
        return this.getDefaultColorShader().getBuffer(arg0);
      }
      /**
       * Notify all render passes that uniform values have changed.
       */
      noticeValueChange() {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.noticeValueChange();
          }
        }
      }
      /**
       * Destroy all render passes and clear the pass map.
       * @param force force destruction of GPU resources
       */
      destroy(force) {
        for (const passList of this.passShader.values()) {
          for (const pass of passList) {
            pass.destroy(force);
          }
        }
        this.passShader.clear();
      }
      /**
       * Deep-clone this shader, copying every render pass.
       */
      clone() {
        let newShader = new Shader();
        for (const passes of this.passShader.values()) {
          for (const pass of passes) {
            newShader.addRenderPass(pass.clone());
          }
        }
        return newShader;
      }
      /**
       * Apply pending uniform values to all render passes.
       */
      applyUniform() {
        for (const pass of this.passShader) {
          for (const rd of pass[1]) {
            rd.applyUniform();
          }
        }
      }
    }

    var __getOwnPropDesc$n = Object.getOwnPropertyDescriptor;
    var __decorateClass$n = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$n(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.QuadShader = class QuadShader extends Shader {
      constructor(ctx, vs = "QuadGlsl_vs", fs = "QuadGlsl_fs") {
        super();
        let colorShader = new RenderShaderPass(vs, fs);
        this.addRenderPass(colorShader);
        let shaderState = colorShader.shaderState;
        colorShader.blendMode = BlendMode.NONE;
        shaderState.frontFace = `cw`;
        shaderState.depthWriteEnabled = false;
        shaderState.depthCompare = GPUCompareFunction.always;
        shaderState.multisample = 0;
        this.setTexture("baseMap", Engine3D.resFor(ctx).blackTexture);
        this.setUniformFloat(`x`, 0);
        this.setUniformFloat(`y`, 0);
        this.setUniformFloat(`width`, 100);
        this.setUniformFloat(`height`, 100);
      }
    };
    exports.QuadShader = __decorateClass$n([
      RegisterShader
    ], exports.QuadShader);

    class ViewQuad extends exports.Object3D {
      width = 128;
      height = 128;
      quadRenderer;
      material;
      // uniforms: { [key: string]: UniformNode };
      rendererPassState;
      quadShader;
      _boundCtx = null;
      constructor(ctx, vs = "QuadGlsl_vs", fs = "QuadGlsl_fs", rtFrame, multisample = 0, f = false) {
        super();
        let renderTexture = rtFrame ? rtFrame.renderTargets : [];
        this.material = new Material();
        this.quadShader = new exports.QuadShader(ctx, vs, fs);
        this.material.shader = this.quadShader;
        this.quadRenderer = this.addComponent(exports.MeshRenderer);
        this.quadRenderer.material = this.material;
        this.quadRenderer.castGI = false;
        this.quadRenderer.castShadow = false;
        this.quadRenderer.drawType = f ? 2 : 0;
        this.quadRenderer.geometry = new PlaneGeometry(100, 100, 1, 1);
        this.quadRenderer.material = this.material;
        this.quadRenderer[`__start`]();
        this.quadRenderer[`_enable`] = true;
        this.quadRenderer[`onEnable`]();
        bindCtx(this, ctx);
        this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, rtFrame, `load`);
        if (multisample > 0) {
          this.rendererPassState.multisample = this.quadShader.getDefaultColorShader().shaderState.multisample;
          this.rendererPassState.multiTexture = ctx.device.createTexture({
            size: {
              width: ctx.presentationSize[0],
              height: ctx.presentationSize[1]
            },
            sampleCount: multisample,
            format: renderTexture.length > 0 ? renderTexture[0].format : ctx.presentationFormat,
            usage: GPUTextureUsage.RENDER_ATTACHMENT
          });
        }
        ctx.addEventListener(CResizeEvent.RESIZE, (e) => {
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, rtFrame, `load`);
          if (multisample > 0) {
            this.rendererPassState.multisample = this.quadShader.getDefaultColorShader().shaderState.multisample;
            this.rendererPassState.multiTexture = ctx.device.createTexture({
              size: {
                width: ctx.presentationSize[0],
                height: ctx.presentationSize[1]
              },
              sampleCount: multisample,
              format: renderTexture.length > 0 ? renderTexture[0].format : ctx.presentationFormat,
              usage: GPUTextureUsage.RENDER_ATTACHMENT
            });
          }
        }, this);
      }
      /**
       * By inputting a map to viewQuad and setting corresponding 
       * processing shaders, the corresponding results are output for off-screen rendering
       * Can also be directly used as the final display rendering result rendering canvas
       * @param viewQuad 
       * @see ViewQuad
       * @param scene3D 
       * @see Scene3D
       * @param command 
       */
      renderTarget(view, viewQuad, command) {
        const gpu = view.engine3D.context3D.gpuContext;
        let camera = view.camera;
        let encoder = gpu.beginRenderPass(command, viewQuad.rendererPassState);
        gpu.bindCamera(encoder, camera);
        viewQuad.quadRenderer.nodeUpdate(view, PassType.COLOR, viewQuad.rendererPassState, null);
        viewQuad.quadRenderer.renderPass2(view, PassType.COLOR, viewQuad.rendererPassState, null, encoder);
        gpu.endPass(encoder);
      }
      /**
       * Output to screen through screen based shading
       * @param viewQuad 
       * @see ViewQuad
       * @param scene3D 
       * @see Scene3D
       * @param command 
       * @param colorTexture 
       */
      renderToViewQuad(view, viewQuad, command, colorTexture) {
        const gpu = view.engine3D.context3D.gpuContext;
        let camera = view.camera;
        viewQuad.quadShader.setTexture("baseMap", colorTexture);
        let encoder = gpu.beginRenderPass(command, viewQuad.rendererPassState);
        gpu.bindCamera(encoder, camera);
        viewQuad.quadRenderer.nodeUpdate(view, PassType.COLOR, viewQuad.rendererPassState, null);
        viewQuad.quadRenderer.renderPass2(view, PassType.COLOR, viewQuad.rendererPassState, null, encoder);
        gpu.endPass(encoder);
      }
    }

    class PostBase {
      enable = true;
      /** When true, PostPass iterates this post AFTER every regular
       *  post regardless of attach order — used by TonemapPost so the
       *  ACES curve always lands on the fully-composited HDR signal. */
      isFinalPass = false;
      postRenderer;
      rendererPassState;
      _boundCtx = null;
      _resourceCreated = false;
      rtViewQuad;
      virtualTexture;
      constructor() {
        this.rtViewQuad = /* @__PURE__ */ new Map();
        this.virtualTexture = /* @__PURE__ */ new Map();
      }
      bindView(view) {
        let ctx = view.engine3D.context3D;
        bindCtx(this, ctx);
        ctx.addEventListener(CResizeEvent.RESIZE, this.onResize, this);
        this._resizeListenerCtx = ctx;
        if (!this._resourceCreated) {
          this._resourceCreated = true;
          this.createResource(view);
        }
      }
      /** Per-engine setting tree. Safe to use from any Post method body and
       *  from sample code after `addPost(...)` — `_boundCtx` is set before
       *  any `onAttach` / `render` / getter access by user code. */
      get setting() {
        return this._boundCtx.engine.setting;
      }
      _resizeListenerCtx = null;
      createResource(view) {
      }
      createRTTexture(name, rtWidth, rtHeight, format, useMipmap = false, sampleCount = 0) {
        let rt = RTResourceMap.createRTTexture(this._boundCtx, name, rtWidth, rtHeight, format, useMipmap, sampleCount);
        rt.name = name;
        this.virtualTexture.set(name, rt);
        Reference.getInstance().attached(rt, this);
        return rt;
      }
      createViewQuad(name, shaderName, outRtTexture, msaa = 0) {
        let rtFrame = new RTFrame([outRtTexture], [new RTDescriptor()]);
        let viewQuad = new ViewQuad(this._boundCtx, "Quad_vert_wgsl", shaderName, rtFrame, msaa);
        this.rtViewQuad.set(name, viewQuad);
        return viewQuad;
      }
      getLastRenderTexture() {
        let colorTexture;
        let renderTargets = this._boundCtx.gpuContext.lastRenderPassState.renderTargets;
        if (renderTargets.length > 0) {
          colorTexture = renderTargets[0];
        } else {
          colorTexture = RTResourceMap.getTexture(this._boundCtx, RTResourceConfig.colorBufferTex_NAME);
        }
        return colorTexture;
      }
      /**
       * Per-compute upstream texture tracker. Keyed by ComputeShader + binding
       * name; remembers the last upstream texture each binding was wired to so
       * we can detect when the chain changed and rebind cheaply.
       *
       * Lives on PostBase rather than the ComputeShader because the notion of
       * "upstream" is a post-chain concept (resolved via getLastRenderTexture),
       * not a property of the compute shader itself.
       */
      _upstreamBindings = /* @__PURE__ */ new WeakMap();
      /**
       * Bind `binding` on `compute` to whatever `getLastRenderTexture()`
       * resolves this frame, and invalidate the compute's group-0 bind group
       * if the upstream texture identity changed since last frame.
       *
       * The framework's enable-toggle contract (PostPass.execute skips
       * disabled posts so the next enabled post sees their predecessor's
       * `lastRenderPassState`) only works if downstream posts re-read the
       * upstream every frame. Lazy-init latching (the historical pattern,
       * `setSamplerTexture('inTex', this.getLastRenderTexture())` once during
       * resource creation) bakes the *initial* upstream into the bind group
       * and never updates it — toggling an upstream post off then leaves the
       * downstream sampler pointing at a no-longer-updated texture and the
       * screen freezes.
       *
       * Call this once per binding per render(). Cost is two map lookups + a
       * reference compare when nothing changed; bind group rebuild only fires
       * when the upstream texture object actually flipped.
       */
      bindUpstream(compute, binding) {
        const upstream = this.getLastRenderTexture();
        let map = this._upstreamBindings.get(compute);
        if (!map) {
          map = /* @__PURE__ */ new Map();
          this._upstreamBindings.set(compute, map);
        }
        if (map.get(binding) !== upstream) {
          compute.setSamplerTexture(binding, upstream);
          compute.bindGroups[0] = null;
          map.set(binding, upstream);
        }
        return upstream;
      }
      compute(view) {
      }
      onAttach(view) {
      }
      onDetach(view) {
      }
      onResize() {
      }
      render(view, command) {
      }
      destroy(force) {
        this.postRenderer = null;
        if (this._resizeListenerCtx) {
          this._resizeListenerCtx.removeEventListener(CResizeEvent.RESIZE, this.onResize, this);
          this._resizeListenerCtx = null;
        }
        if (this.rtViewQuad) {
          for (const quad of this.rtViewQuad.values()) {
            quad.destroy(force);
          }
          this.rtViewQuad.clear();
          this.rtViewQuad = null;
        }
        if (this.virtualTexture) {
          for (const tex of this.virtualTexture.values()) {
            Reference.getInstance().detached(tex, this);
            tex.destroy(force);
          }
          this.virtualTexture.clear();
          this.virtualTexture = null;
        }
      }
    }

    let FXAAShader = (
      /*wgsl*/
      `
    #include 'BitUtil'
    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    };

    var<private> varying_uv: vec2<f32>;
    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d<f32>;
    // @group(1) @binding(2)
    // var gBuffer: texture_2d<f32>;

    struct MaterialUniform{
        u_texel: vec2<f32>,
        u_strength: f32,
    }

    @group(2) @binding(0)
    var<uniform> materialUniform: MaterialUniform;


    fn LinearToGammaSpace(linRGB0: vec3<f32>) -> vec3<f32> {
        var linRGB = max(linRGB0, vec3(0.0, 0.0, 0.0));
        linRGB.r = pow(linRGB.r,0.416666667);
        linRGB.g = pow(linRGB.g,0.416666667);
        linRGB.b = pow(linRGB.b,0.416666667);
        return max(1.055 * linRGB - 0.055, vec3(0.0, 0.0, 0.0));
    }

    fn texture2D( uv:vec2<f32> , offset:vec2<f32> ) -> vec4<f32> {
        let buffer = textureSample(baseMap, baseMapSampler, uv.xy + offset ).rgba ;
        return buffer ;
    }

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var v_vTexcoord = fragUV ;
        // v_vTexcoord.x = 1.0 - v_vTexcoord.x ;
        v_vTexcoord.y = 1.0 - v_vTexcoord.y ;

        var reducemul = 1.0 / 8.0;
        var reducemin = 1.0 / 128.0;

        var basecol = texture2D(v_vTexcoord , vec2<f32>(0.0)).rgba;
        var baseNW = texture2D(v_vTexcoord , -materialUniform.u_texel).rgb;
        var baseNE = texture2D(v_vTexcoord , vec2<f32>(materialUniform.u_texel.x, -materialUniform.u_texel.y)).rgb;
        var baseSW = texture2D(v_vTexcoord , vec2<f32>(-materialUniform.u_texel.x, materialUniform.u_texel.y)).rgb;
        var baseSE = texture2D(v_vTexcoord , materialUniform.u_texel ).rgb;

        // var gray = vec3<f32>(0.299, 0.587, 0.114);
        var gray = vec3<f32>(0.213, 0.715, 0.072);
        var monocol = dot(basecol.rgb, gray);
        var monoNW = dot(baseNW, gray);
        var monoNE = dot(baseNE, gray);
        var monoSW = dot(baseSW, gray);
        var monoSE = dot(baseSE, gray);

        var monomin = min(monocol, min(min(monoNW, monoNE), min(monoSW, monoSE)));
        var monomax = max(monocol, max(max(monoNW, monoNE), max(monoSW, monoSE)));

        var dir = vec2<f32>(-((monoNW + monoNE) - (monoSW + monoSE)), ((monoNW + monoSW) - (monoNE + monoSE)));
        var dirreduce = max((monoNW + monoNE + monoSW + monoSE) * reducemul * 0.25, reducemin);
        var dirmin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirreduce);
        dir = min(vec2<f32>(materialUniform.u_strength), max(vec2<f32>(-materialUniform.u_strength), dir * dirmin)) * materialUniform.u_texel;

        var resultA = 0.5 * (texture2D(v_vTexcoord , dir * -0.166667).rgb  +
                            texture2D(v_vTexcoord , dir * 0.166667).rgb);
                            
        var resultB = resultA * 0.5 + 0.25 * (texture2D( v_vTexcoord , dir * -0.5).rgb +
                                            texture2D( v_vTexcoord , dir * 0.5).rgb);
        var monoB = dot(resultB.rgb, gray);
        
        var color:vec3<f32> ;
        if(monoB < monomin || monoB > monomax) {
            color = resultA ;//* v_vColour;
        } else {
            color = resultB ;//* v_vColour;
        }
        return FragmentOutput(vec4<f32>(color.rgb,basecol.a));
    }
`
    );

    class FXAAPost extends PostBase {
      postQuad;
      renderTexture;
      constructor() {
        super();
        ShaderLib.register("FXAA_Shader", FXAAShader);
      }
      createResource(view) {
        let [w, h] = this._boundCtx.presentationSize;
        this.renderTexture = this.createRTTexture(`FXAAPost`, w, h, GPUTextureFormat.rgba16float);
        this.postQuad = this.createViewQuad(`fxaa`, "FXAA_Shader", this.renderTexture);
        this.postQuad.quadShader.setUniform("u_texel", new Vector2(1 / w, 1 / h));
        this.postQuad.quadShader.setUniform("u_strength", 4);
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        this.renderTexture.resize(w, h);
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.fxaa.enable = true;
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.fxaa.enable = false;
      }
      render(view, command) {
        this.compute(view);
        this.rtViewQuad.forEach((viewQuad, k) => {
          let lastTexture = this._boundCtx.gpuContext.lastRenderPassState.getLastRenderTexture(this._boundCtx);
          viewQuad.renderToViewQuad(view, viewQuad, command, lastTexture);
        });
      }
    }

    let TonemapShader = (
      /*wgsl*/
      `
    ${ColorUtil}

    struct FragmentOutput {
        @location(auto) o_Target: vec4<f32>
    };

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d<f32>;

    struct MaterialUniform {
        exposure: f32,
        mode: f32,
    };

    @group(2) @binding(0)
    var<uniform> materialUniform: MaterialUniform;

    @fragment
    fn main(@location(auto) fragUV: vec2<f32>) -> FragmentOutput {
        var uv = fragUV;
        uv.y = 1.0 - uv.y;
        let raw = textureSample(baseMap, baseMapSampler, uv);

        var rgb = raw.rgb * materialUniform.exposure;
        if (materialUniform.mode > 0.5) {
            rgb = ACESToneMapping(rgb, 1.0);
        }
        return FragmentOutput(vec4<f32>(rgb, raw.a));
    }
`
    );

    class TonemapPost extends PostBase {
      postQuad;
      renderTexture;
      constructor() {
        super();
        this.isFinalPass = true;
        ShaderLib.register("Tonemap_Shader", TonemapShader);
      }
      createResource(view) {
        let [w, h] = this._boundCtx.presentationSize;
        this.renderTexture = this.createRTTexture(`TonemapPost`, w, h, GPUTextureFormat.rgba16float);
        this.postQuad = this.createViewQuad(`tonemap`, "Tonemap_Shader", this.renderTexture);
        this.applyUniforms();
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        this.renderTexture.resize(w, h);
      }
      onAttach(view) {
        const tm = this.setting.render.tonemap;
        if (tm) tm.enable = true;
      }
      onDetach(view) {
        const tm = this.setting.render.tonemap;
        if (tm) tm.enable = false;
      }
      render(view, command) {
        const tm = this.setting.render.tonemap;
        if (tm && !tm.enable) {
          return;
        }
        this.applyUniforms();
        this.rtViewQuad.forEach((viewQuad) => {
          let lastTexture = this._boundCtx.gpuContext.lastRenderPassState.getLastRenderTexture(this._boundCtx);
          viewQuad.renderToViewQuad(view, viewQuad, command, lastTexture);
        });
      }
      applyUniforms() {
        if (!this.postQuad) return;
        const tm = this.setting.render.tonemap;
        const exposure = tm ? tm.exposure : 1;
        const mode = tm && tm.mode === "None" ? 0 : 1;
        this.postQuad.quadShader.setUniform("exposure", exposure);
        this.postQuad.quadShader.setUniform("mode", mode);
      }
    }

    const FINAL_COLOR = "_FinalColor";
    class PostPass extends RenderGraphPass {
      name = "PostPass";
      postList = /* @__PURE__ */ new Map();
      debugTextures = [];
      _ctx;
      _rendererPassState;
      setup(b) {
        const view = b.view;
        const ctx = b.context3D;
        this._ctx = ctx;
        ShaderLib.register("FullQuad_vert_wgsl", FullQuad_vert_wgsl);
        const gbufferFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, ctx);
        this._rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, gbufferFrame);
        this.attachPost(view, new FXAAPost());
        if (view.engine3D.setting.render.tonemap?.enable !== false) {
          this.attachPost(view, new TonemapPost());
        }
        b.read(COLOR_BUFFER);
        b.write(FINAL_COLOR, () => {
          const gpu = this._ctx.gpuContext;
          if (gpu.lastRenderPassState) {
            return gpu.lastRenderPassState.getLastRenderTexture(this._ctx);
          }
          return GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._ctx).getColorTexture();
        });
      }
      attachPost(view, post) {
        post.postRenderer = this;
        const clsName = post.constructor.name;
        if (!this.postList.has(clsName)) {
          this.postList.set(clsName, post);
          post.bindView(view);
          post.onAttach(view);
        }
      }
      detachPost(view, post) {
        const clsName = post.constructor.name;
        const had = this.postList.has(clsName);
        if (had) {
          this.postList.delete(clsName);
          post.onDetach(view);
          post.postRenderer = null;
        }
        return had;
      }
      /** Legacy compat — some posts call into this pass state from
       *  `bindView`. The colorPass GBuffer is a stable input shared
       *  across the whole chain. */
      get rendererPassState() {
        return this._rendererPassState;
      }
      execute(ctx) {
        const view = ctx.view;
        const gpu = view.engine3D.context3D.gpuContext;
        gpu.lastRenderPassState = this._rendererPassState;
        this.postList.forEach((v) => {
          if (v.enable) v.compute(view);
        });
        const command = gpu.beginCommandEncoder();
        this.postList.forEach((v) => {
          if (v.enable && !v.isFinalPass) {
            v.render(view, command);
            if (v.rendererPassState) {
              gpu.lastRenderPassState = v.rendererPassState;
            }
          }
        });
        this.postList.forEach((v) => {
          if (v.enable && v.isFinalPass) {
            v.render(view, command);
            if (v.rendererPassState) {
              gpu.lastRenderPassState = v.rendererPassState;
            }
          }
        });
        gpu.endCommandEncoder(command);
      }
      /** Tears down every attached PostBase instance. Called via the
       *  graph's destroy() walk. */
      destroy() {
        for (const post of this.postList.values()) {
          post.destroy?.();
        }
        this.postList.clear();
      }
    }

    function createPresentQuad(ctx) {
      const frag = ctx.canvasConfig?.alpha ? `Quad_premultiply_frag_wgsl` : `Quad_opaque_frag_wgsl`;
      return new ViewQuad(ctx, `Quad_vert_wgsl`, frag, new RTFrame([], []), 0, false);
    }
    function presentTexture(view, quad, texture) {
      const gpu = view.engine3D.context3D.gpuContext;
      const command = gpu.beginCommandEncoder();
      quad.renderToViewQuad(view, quad, command, texture);
      gpu.endCommandEncoder(command);
    }

    const CANVAS_TEXTURE = "_CanvasTexture";
    class GUIPass extends RenderGraphPass {
      name = "GUIPass";
      _presentQuad;
      setup(b) {
        b.read(FINAL_COLOR);
        b.write(CANVAS_TEXTURE, () => null);
        this._presentQuad = createPresentQuad(b.context3D);
      }
      execute(ctx) {
        const finalColor = ctx.get(FINAL_COLOR);
        presentTexture(ctx.view, this._presentQuad, finalColor);
      }
      destroy() {
        this._presentQuad?.destroy();
        this._presentQuad = null;
      }
    }

    let HiZ_Init_cs = (
      /*wgsl*/
      `
    @group(0) @binding(0) var srcTex: texture_2d<f32>;
    @group(0) @binding(1) var dstTex: texture_storage_2d<r32float, write>;

    @compute @workgroup_size(8, 8, 1)
    fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
        let dstSize = textureDimensions(dstTex);
        if (gid.x >= dstSize.x || gid.y >= dstSize.y) { return; }
        // Compressed gbuffer packs depth into .x. Read at the same
        // coord (mip 0 of the pyramid is full scene resolution).
        let depth = textureLoad(srcTex, vec2<i32>(gid.xy), 0).x;
        textureStore(dstTex, vec2<i32>(gid.xy), vec4<f32>(depth, 0.0, 0.0, 0.0));
    }
`
    );
    let HiZ_Reduce_cs = (
      /*wgsl*/
      `
    @group(0) @binding(0) var srcTex: texture_2d<f32>;
    @group(0) @binding(1) var dstTex: texture_storage_2d<r32float, write>;

    @compute @workgroup_size(8, 8, 1)
    fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
        let dstSize = textureDimensions(dstTex);
        if (gid.x >= dstSize.x || gid.y >= dstSize.y) { return; }
        let srcSize = textureDimensions(srcTex);
        // 2:1 downsample with max reduction. Clamp source coords to
        // src bounds so odd-sized mips don't read out-of-range.
        let srcCoord = vec2<i32>(i32(gid.x) * 2, i32(gid.y) * 2);
        let maxX = i32(srcSize.x) - 1;
        let maxY = i32(srcSize.y) - 1;
        let c00 = vec2<i32>(min(srcCoord.x, maxX), min(srcCoord.y, maxY));
        let c01 = vec2<i32>(min(srcCoord.x + 1, maxX), min(srcCoord.y, maxY));
        let c10 = vec2<i32>(min(srcCoord.x, maxX), min(srcCoord.y + 1, maxY));
        let c11 = vec2<i32>(min(srcCoord.x + 1, maxX), min(srcCoord.y + 1, maxY));
        let s00 = textureLoad(srcTex, c00, 0).r;
        let s01 = textureLoad(srcTex, c01, 0).r;
        let s10 = textureLoad(srcTex, c10, 0).r;
        let s11 = textureLoad(srcTex, c11, 0).r;
        let maxZ = max(max(s00, s01), max(s10, s11));
        textureStore(dstTex, vec2<i32>(gid.xy), vec4<f32>(maxZ, 0.0, 0.0, 0.0));
    }
`
    );

    class TextureIdentityWatcher {
      _last = /* @__PURE__ */ new Map();
      /**
       * Inspect the current `GPUTexture` identity of every entry and
       * report whether any changed since the last call. Always updates
       * the recorded identities to the current values so the next
       * `update()` compares against the new baseline.
       *
       * Returns `true` on the very first call (every key transitions
       * from "never seen" to a concrete identity), so callers that
       * combine this with `!this._bindGroup` get the right "build on
       * first execute" behavior without extra plumbing.
       */
      update(entries) {
        let changed = false;
        for (const { key, tex } of entries) {
          const cur = tex.getGPUTexture();
          const prev = this._last.get(key);
          if (prev !== cur) {
            changed = true;
            this._last.set(key, cur);
          }
        }
        return changed;
      }
      /** Forget every recorded identity. After this the next `update`
       *  call reports `true` for every entry, forcing a rebuild — useful
       *  on device-lost or graph rewire. */
      reset() {
        this._last.clear();
      }
    }

    const HIZ_PYRAMID = "_HiZPyramid";
    class HiZPass extends RenderGraphPass {
      name = "HiZPass";
      _ctx;
      _handle;
      _pyramid = null;
      _numMips = 1;
      _initPipeline = null;
      _reducePipeline = null;
      _bindGroupLayout = null;
      _initBindGroup = null;
      _reduceBindGroups = [];
      // Identities of the GPUTextures the cached bind groups reference.
      // The compressGBuffer source has autoResize=true and is recreated by
      // the canvas-resize listener; the pyramid wrapper is owned by the
      // transient pool and may be re-allocated when presentationSize
      // changes between compiles. Compare-and-rebuild on identity change.
      _lastCompressGpuTex = null;
      _lastPyramidGpuTex = null;
      _watcher = new TextureIdentityWatcher();
      setup(b) {
        this._ctx = b.context3D;
        GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._ctx);
        const [w, h] = this._ctx.presentationSize;
        const mips = this._mipCount(w, h);
        this._handle = b.declareTexture(HIZ_PYRAMID, {
          // r32float is in WebGPU's default storage-texture format
          // set (r16float is NOT — needs the `r16float-renderable`
          // proposal). Single channel; precision more than
          // sufficient for [0,1] NDC z.
          format: GPUTextureFormat.r32float,
          width: "screen",
          height: "screen",
          mipLevelCount: mips,
          aliasable: false,
          publishToLegacyMap: true,
          // Explicit usage: STORAGE_BINDING (init/reduce pipelines
          // write the output mips) + TEXTURE_BINDING (reduce step
          // samples the previous mip) + COPY_SRC/COPY_DST for
          // dev-time debug captures.
          usage: GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST,
          label: HIZ_PYRAMID
        });
        b.write(this._handle, "storage");
      }
      _mipCount(w, h) {
        return 1 + Math.floor(Math.log2(Math.max(w, h)));
      }
      _ensurePipelines() {
        if (this._initPipeline && this._reducePipeline && this._bindGroupLayout) return;
        const device = this._ctx.device;
        this._bindGroupLayout = device.createBindGroupLayout({
          label: "HiZBindGroupLayout",
          entries: [
            { binding: 0, visibility: GPUShaderStage.COMPUTE, texture: { sampleType: "unfilterable-float" } },
            { binding: 1, visibility: GPUShaderStage.COMPUTE, storageTexture: { access: "write-only", format: "r32float", viewDimension: "2d" } }
          ]
        });
        const pipelineLayout = device.createPipelineLayout({
          label: "HiZPipelineLayout",
          bindGroupLayouts: [this._bindGroupLayout]
        });
        this._initPipeline = device.createComputePipeline({
          label: "HiZ_Init",
          layout: pipelineLayout,
          compute: {
            module: device.createShaderModule({ code: HiZ_Init_cs }),
            entryPoint: "CsMain"
          }
        });
        this._reducePipeline = device.createComputePipeline({
          label: "HiZ_Reduce",
          layout: pipelineLayout,
          compute: {
            module: device.createShaderModule({ code: HiZ_Reduce_cs }),
            entryPoint: "CsMain"
          }
        });
      }
      _ensureBindGroups() {
        const device = this._ctx.device;
        const pyramid = this._pyramid;
        const compressGBuffer = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._ctx).getCompressGBufferTexture();
        const compressGpuTex = compressGBuffer.getGPUTexture();
        const pyramidGpuTex = pyramid.getGPUTexture();
        const fresh = this._initBindGroup && this._reduceBindGroups.length === this._numMips - 1 && this._lastCompressGpuTex === compressGpuTex && this._lastPyramidGpuTex === pyramidGpuTex;
        if (fresh) return;
        this._initBindGroup = device.createBindGroup({
          label: "HiZ_InitBG",
          layout: this._bindGroupLayout,
          entries: [
            { binding: 0, resource: compressGpuTex.createView({ format: compressGBuffer.format, dimension: "2d", baseMipLevel: 0, mipLevelCount: 1 }) },
            { binding: 1, resource: pyramidGpuTex.createView({ format: pyramid.format, dimension: "2d", baseMipLevel: 0, mipLevelCount: 1 }) }
          ]
        });
        this._reduceBindGroups = [];
        for (let i = 0; i < this._numMips - 1; i++) {
          const srcView = pyramidGpuTex.createView({
            format: pyramid.format,
            dimension: "2d",
            baseMipLevel: i,
            mipLevelCount: 1
          });
          const dstView = pyramidGpuTex.createView({
            format: pyramid.format,
            dimension: "2d",
            baseMipLevel: i + 1,
            mipLevelCount: 1
          });
          this._reduceBindGroups.push(device.createBindGroup({
            label: `HiZ_ReduceBG_mip${i + 1}`,
            layout: this._bindGroupLayout,
            entries: [
              { binding: 0, resource: srcView },
              { binding: 1, resource: dstView }
            ]
          }));
        }
        this._lastCompressGpuTex = compressGpuTex;
        this._lastPyramidGpuTex = pyramidGpuTex;
      }
      execute(ctx) {
        this._pyramid = ctx.getTexture(this._handle);
        this._numMips = this._pyramid.textureDescriptor?.mipLevelCount ?? 1;
        if (this._watcher.update([{ key: "pyramid", tex: this._pyramid }])) {
          this._initBindGroup = null;
          this._reduceBindGroups = [];
        }
        this._ensurePipelines();
        this._ensureBindGroups();
        const gpu = this._ctx.gpuContext;
        const command = gpu.beginCommandEncoder();
        const pass = command.beginComputePass({ label: "HiZGenerate" });
        const w = this._pyramid.width;
        const h = this._pyramid.height;
        pass.setPipeline(this._initPipeline);
        pass.setBindGroup(0, this._initBindGroup);
        pass.dispatchWorkgroups(Math.ceil(w / 8), Math.ceil(h / 8), 1);
        let mipW = Math.max(1, w >> 1);
        let mipH = Math.max(1, h >> 1);
        pass.setPipeline(this._reducePipeline);
        for (let i = 0; i < this._reduceBindGroups.length; i++) {
          pass.setBindGroup(0, this._reduceBindGroups[i]);
          pass.dispatchWorkgroups(Math.max(1, Math.ceil(mipW / 8)), Math.max(1, Math.ceil(mipH / 8)), 1);
          mipW = Math.max(1, mipW >> 1);
          mipH = Math.max(1, mipH >> 1);
        }
        pass.end();
        gpu.endCommandEncoder(command);
      }
    }

    let MotionVector_cs = (
      /*wgsl*/
      `
    #include "GlobalUniform"
    #include "GBufferStand"

    const PI: f32 = 3.1415926;

    struct MVData {
        prevViewProj: mat4x4<f32>,
    };

    @group(0) @binding(2) var<uniform> mvData: MVData;
    @group(0) @binding(3) var inTex: texture_2d<f32>;
    @group(0) @binding(4) var outTex: texture_storage_2d<rgba16float, write>;

    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> fragUV: vec2<f32>;
    var<private> gBuffer: GBuffer;

    @compute @workgroup_size(8, 8, 1)
    fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
        fragCoord = vec2<i32>(gid.xy);
        texSize = textureDimensions(inTex).xy;
        if (fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)) { return; }
        fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1u);

        useNormalMatrixInv();
        gBuffer = getGBuffer(fragCoord);
        let visible = getRoughnessFromGBuffer(gBuffer);
        if (visible <= 0.0) {
            // sky / unwritten pixel: zero motion vector
            textureStore(outTex, fragCoord, vec4<f32>(0.0, 0.0, 0.0, 0.0));
            return;
        }

        // Reconstruct world position from current-frame depth.
        let worldPos = getWorldPositionFromGBuffer(gBuffer, fragUV);

        // Project with prev frame's viewProj to get prev-frame UV.
        let prevClip = mvData.prevViewProj * vec4<f32>(worldPos, 1.0);
        if (prevClip.w <= 0.0) {
            textureStore(outTex, fragCoord, vec4<f32>(0.0, 0.0, 0.0, 0.0));
            return;
        }
        let prevNdc = prevClip.xyz / prevClip.w;
        let prevUv = vec2<f32>(prevNdc.x * 0.5 + 0.5, -prevNdc.y * 0.5 + 0.5);

        let motion = fragUV - prevUv;
        textureStore(outTex, fragCoord, vec4<f32>(motion.x, motion.y, 0.0, 0.0));
    }
`
    );

    const MOTION_VECTOR = "_MotionVector";
    class MotionVectorPass extends RenderGraphPass {
      name = "MotionVectorPass";
      _ctx;
      _mvHandle;
      _compute = null;
      _mvData = null;
      _prevViewProj = new Matrix4().identity();
      _currViewProj = new Matrix4().identity();
      _scratch = new Matrix4().identity();
      /** Detects pool-driven texture identity swaps (resize, re-alias)
       *  so we know when to invalidate the cached compute shader. */
      _watcher = new TextureIdentityWatcher();
      /** Last presentationSize seen by `_ensureCompute`; mismatch triggers
       *  a workgroup count refresh (the texture is also refreshed via
       *  the watcher, but workgroup math depends on logical size, not
       *  identity). */
      _lastWorkerW = 0;
      _lastWorkerH = 0;
      setup(b) {
        this._ctx = b.context3D;
        this._mvHandle = b.declareTexture(MOTION_VECTOR, {
          format: GPUTextureFormat.rgba16float,
          width: "screen",
          height: "screen",
          label: MOTION_VECTOR
        });
        b.write(this._mvHandle, "storage");
      }
      _ensureCompute(ctx, mv) {
        const [w, h] = this._ctx.presentationSize;
        const sizeChanged = w !== this._lastWorkerW || h !== this._lastWorkerH;
        if (this._compute && !sizeChanged) return;
        if (!this._compute) {
          ShaderLib.register("MotionVector_cs", MotionVector_cs);
          this._compute = new ComputeShader(MotionVector_cs);
          this._mvData = new UniformGPUBuffer(16);
          this._compute.setUniformBuffer("mvData", this._mvData);
          const cameraGroup = GlobalBindGroup.getCameraGroup(ctx.view.camera);
          this._compute.setUniformBuffer("globalUniform", cameraGroup.uniformGPUBuffer);
          const rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._ctx);
          this._compute.setSamplerTexture("gBufferTexture", rtFrame.getCompressGBufferTexture());
          this._compute.setSamplerTexture("inTex", rtFrame.getColorTexture());
          this._compute.setStorageTexture("outTex", mv);
        } else {
          this._compute.setStorageTexture("outTex", mv);
        }
        this._compute.workerSizeX = Math.ceil(w / 8);
        this._compute.workerSizeY = Math.ceil(h / 8);
        this._compute.workerSizeZ = 1;
        this._lastWorkerW = w;
        this._lastWorkerH = h;
      }
      execute(ctx) {
        const mv = ctx.getTexture(this._mvHandle);
        const dirty = this._watcher.update([{ key: "mv", tex: mv }]);
        if (dirty) this._compute = null;
        this._ensureCompute(ctx, mv);
        const camera = ctx.view.camera;
        this._scratch.multiplyMatrices(camera.projectionMatrix, camera.viewMatrix);
        this._mvData.setMatrix("prevViewProj", this._prevViewProj);
        this._mvData.apply();
        const gpu = this._ctx.gpuContext;
        const command = gpu.beginCommandEncoder();
        gpu.computeCommand(command, [this._compute]);
        gpu.endCommandEncoder(command);
        this._prevViewProj.copy(this._scratch);
        this._currViewProj.copy(this._scratch);
      }
    }

    class SceneCapturePass extends RenderGraphPass {
      name = "SceneCapturePass";
      materialPasses = [PassType.COLOR];
      _passType = PassType.COLOR;
      setup(b) {
        b.read(MAIN_SHADOW_MAP);
        b.read(POINT_SHADOW_CUBE_ARRAY);
        dependOnIfRegistered(b, "GPUCullPass");
      }
      execute(ctx) {
        const view = ctx.view;
        const scene = view.scene;
        if (!scene) return;
        const captures = EntityCollect.instance.getSceneCaptureCameras(scene);
        if (!captures || captures.length === 0) return;
        const cluster = view.renderGraph?.getPass("ClusterLightingPass")?.clusterLightingBuffer;
        for (const cap of captures) {
          if (!cap.enable) continue;
          if (cap.updateMode === "manual" && !cap.needUpdate) continue;
          const camera = cap.camera;
          if (!camera) continue;
          this._renderOne(view, cap, camera, ctx.occlusion, cluster);
          if (cap.updateMode === "manual") cap.needUpdate = false;
        }
        if (view.camera) {
          GlobalBindGroup.updateCameraGroup(view.camera);
        }
      }
      _renderOne(view, cap, camera, occlusion, cluster) {
        const ctx3D = view.engine3D.context3D;
        const { rendererPassState, renderContext } = cap._ensureRenderTargets(ctx3D);
        camera.transform.scene3D = view.scene;
        camera.transform.updateWorldMatrix();
        GlobalBindGroup.updateCameraGroup(camera);
        rendererPassState.camera3D = camera;
        const layered = this.collectLayered(view, camera);
        const gpu = view.engine3D.context3D.gpuContext;
        renderContext.gpu = gpu;
        renderContext.clean();
        renderContext.beginOpaqueRenderPass();
        const opaqueEncoder = renderContext.encoder;
        if (cap.includeSky) {
          const sky = EntityCollect.instance.getSky(view.scene);
          if (sky) {
            gpu.bindCamera(opaqueEncoder, camera);
            if (!sky.preInit(this._passType)) {
              sky.nodeUpdate(view, this._passType, rendererPassState, cluster);
            }
            sky.renderPass2(view, this._passType, rendererPassState, cluster, opaqueEncoder);
          }
        }
        gpu.bindCamera(opaqueEncoder, camera);
        if (layered.opaque.length > 0) {
          this._drawNodes(view, renderContext, layered.opaque, cap, occlusion, cluster);
        }
        if (cap.includeTransparent && layered.transparent.length > 0) {
          this._drawNodes(view, renderContext, layered.transparent, cap, occlusion, cluster);
        }
        renderContext.endRenderPass();
      }
      _drawNodes(view, renderContext, nodes, cap, _occlusion, cluster) {
        preInitPassPipelines(view, this._passType, renderContext.rendererPassState, cluster, (n) => this._maskAccepts(cap, n));
        for (const node of nodes) {
          if (!this._maskAccepts(cap, node)) continue;
          if (!node.transform.enable) continue;
          if (!node.enable) continue;
          if (node.isDestroyed) continue;
          if (!node.preInit(this._passType)) {
            node.nodeUpdate(view, this._passType, renderContext.rendererPassState, cluster);
          }
          node.renderPass(view, this._passType, renderContext);
        }
      }
      _maskAccepts(cap, node) {
        const rm = node.rendererMask;
        if ((rm & cap.captureMask) === 0) return false;
        if (cap.excludeMask !== 0 && (rm & cap.excludeMask) !== 0) return false;
        return true;
      }
    }

    const SCENE_COLOR_PYRAMID = "_SceneColorPyramid";
    class SceneColorPyramidPass extends RenderGraphPass {
      name = "SceneColorPyramidPass";
      _ctx;
      _handle;
      _watcher = new TextureIdentityWatcher();
      setup(b) {
        this._ctx = b.context3D;
        b.read(COLOR_BUFFER);
        const [w, h] = this._ctx.presentationSize;
        const mips = this._mipCountFor(w, h);
        this._handle = b.declareTexture(SCENE_COLOR_PYRAMID, {
          format: GPUTextureFormat.rgba16float,
          width: "screen",
          height: "screen",
          mipLevelCount: mips,
          aliasable: false,
          publishToLegacyMap: true,
          // Explicit usage — TextureMipmapGenerator.webGPUGenerateMipmap
          // (called in execute() below to refresh mips 1..N) opens a
          // render pass per mip with the mip as colorAttachment[0],
          // which requires RENDER_ATTACHMENT. Hint-derived usage
          // ('sample' → TEXTURE_BINDING + COPY) misses this bit, so
          // the mipgen pass throws a usage-mismatch validation error.
          // Bits:
          //   RENDER_ATTACHMENT — mipgen blits per mip
          //   TEXTURE_BINDING   — transmission samplers
          //   COPY_DST          — mip-0 copyTextureToTexture from _ColorBuffer
          //   COPY_SRC          — dev-time debug captures
          usage: GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST,
          label: SCENE_COLOR_PYRAMID
        });
        b.write(this._handle, "sample");
      }
      _mipCountFor(w, h) {
        return Math.floor(Math.log2(Math.max(w, h))) + 1;
      }
      execute(ctx) {
        const colorBuffer = ctx.get(COLOR_BUFFER);
        if (!colorBuffer) return;
        const pyramid = ctx.getTexture(this._handle);
        this._watcher.update([{ key: "pyramid", tex: pyramid }]);
        const gpu = ctx.view.engine3D.context3D.gpuContext;
        const command = gpu.beginCommandEncoder();
        command.copyTextureToTexture(
          { texture: colorBuffer.getGPUTexture(), mipLevel: 0, origin: { x: 0, y: 0, z: 0 } },
          { texture: pyramid.getGPUTexture(), mipLevel: 0, origin: { x: 0, y: 0, z: 0 } },
          { width: colorBuffer.width, height: colorBuffer.height, depthOrArrayLayers: 1 }
        );
        gpu.endCommandEncoder(command);
        TextureMipmapGenerator.webGPUGenerateMipmap(pyramid);
      }
    }

    class SkyPass extends RenderGraphPass {
      name = "SkyPass";
      _passType = PassType.COLOR;
      setup(b) {
        b.read(TRANSPARENT_DRAW_CTX);
        b.read(CLUSTER_LIGHTING_BUFFER);
        b.write(COLOR_BUFFER);
        b.useRenderTarget(MAIN_COLOR_RT);
      }
      execute(ctx) {
        const view = ctx.view;
        const sky = EntityCollect.instance.getSky(view.scene);
        if (!sky) return;
        const drawCtx = ctx.get(TRANSPARENT_DRAW_CTX);
        const camera = view.camera;
        const cluster = this._getCluster(view);
        const gpu = view.engine3D.context3D.gpuContext;
        drawCtx.renderContext.gpu = gpu;
        drawCtx.rendererPassState.camera3D = camera;
        GlobalBindGroup.updateCameraGroup(camera);
        drawCtx.renderContext.beginContinueRendererPassState("load", "load");
        drawCtx.renderContext.begineNewCommand();
        drawCtx.renderContext.beginNewEncoder();
        const encoder = drawCtx.renderContext.encoder;
        gpu.bindCamera(encoder, camera);
        if (!sky.preInit(this._passType)) {
          sky.nodeUpdate(view, this._passType, drawCtx.rendererPassState, cluster);
        }
        sky.renderPass2(view, this._passType, drawCtx.rendererPassState, cluster, encoder);
        drawCtx.renderContext.endRenderPass();
      }
      _getCluster(view) {
        return view.renderGraph?.getPass("ClusterLightingPass")?.clusterLightingBuffer;
      }
    }

    class SortedTransparentPass extends RenderGraphPass {
      constructor(filter = "all") {
        super();
        this.filter = filter;
      }
      name = "SortedTransparentPass";
      setup(b) {
        b.read(SCENE_COLOR_PYRAMID);
        b.read(TRANSPARENT_DRAW_CTX);
        b.write(COLOR_BUFFER);
        b.useRenderTarget(MAIN_COLOR_RT);
        dependOnIfRegistered(b, "GPUCullPass");
      }
      execute(ctx) {
        const state = ctx.get(TRANSPARENT_DRAW_CTX);
        const cluster = ctx.graph.getPass("ClusterLightingPass")?.clusterLightingBuffer;
        const layered = this.collectLayered(ctx.view);
        drawSortedTransparent(ctx.view, cluster, state, this.filter, layered.transparent);
      }
    }

    class TransmissionOpaquePass extends RenderGraphPass {
      name = "TransmissionOpaquePass";
      setup(b) {
        b.read(SCENE_COLOR_PYRAMID);
        b.read(TRANSPARENT_DRAW_CTX);
        b.write(COLOR_BUFFER);
        b.useRenderTarget(MAIN_COLOR_RT);
        dependOnIfRegistered(b, "GPUCullPass");
      }
      execute(ctx) {
        const state = ctx.get(TRANSPARENT_DRAW_CTX);
        const cluster = ctx.graph.getPass("ClusterLightingPass")?.clusterLightingBuffer;
        const layered = this.collectLayered(ctx.view);
        drawTransmissionContinuation(ctx.view, cluster, state, layered.opaque);
      }
    }

    const DDP_FRONT_TEX = "_DDPFront";
    const DDP_FRONT_DEPTH_TEX = "_DDPFrontDepth";
    const DDP_DEPTH_TEX_0 = "_DDPDepth0";
    const DDP_DEPTH_TEX_1 = "_DDPDepth1";
    const DDP_FRONT_TEX_0 = "_DDPFront0";
    const DDP_FRONT_TEX_1 = "_DDPFront1";
    const DDP_BACK_TEX = "_DDPBack";
    const DDP_TEX_NAMES = [
      DDP_FRONT_TEX,
      DDP_FRONT_DEPTH_TEX,
      DDP_DEPTH_TEX_0,
      DDP_DEPTH_TEX_1,
      DDP_FRONT_TEX_0,
      DDP_FRONT_TEX_1,
      DDP_BACK_TEX
    ];
    const DDP_DEFAULT_PASS_COUNT = 5;
    class TransparentDualDepthPeelingPass extends RenderGraphPass {
      name = "TransparentDualDepthPeelingPass";
      _ctx;
      _passType = PassType.OIT_DEPTH_PEEL_FRONT;
      _rendererPassState = null;
      _frontHandle;
      _depthHandle;
      _watcher = new TextureIdentityWatcher();
      setup(b) {
        this._ctx = b.context3D;
        b.read(COLOR_BUFFER);
        b.read(SCENE_COLOR_PYRAMID);
        this._frontHandle = b.declareTexture(DDP_FRONT_TEX, {
          format: GPUTextureFormat.rgba16float,
          width: "screen",
          height: "screen",
          label: DDP_FRONT_TEX
        });
        b.write(this._frontHandle, "attachment");
        this._depthHandle = b.declareTexture(DDP_FRONT_DEPTH_TEX, {
          format: GPUTextureFormat.depth24plus,
          width: "screen",
          height: "screen",
          label: DDP_FRONT_DEPTH_TEX
        });
        b.write(this._depthHandle, "attachment");
        dependOnIfRegistered(b, "GPUCullPass");
      }
      execute(ctx) {
        const front = ctx.getTexture(this._frontHandle);
        const depth = ctx.getTexture(this._depthHandle);
        const dirty = this._watcher.update([
          { key: "front", tex: front },
          { key: "depth", tex: depth }
        ]);
        if (dirty) this._rendererPassState = null;
        this._ensureRtFrame(front, depth);
        const view = ctx.view;
        const cluster = ctx.graph.getPass("ClusterLightingPass")?.clusterLightingBuffer;
        const gpu = view.engine3D.context3D.gpuContext;
        const camera = view.camera;
        GlobalBindGroup.updateCameraGroup(camera);
        const passState = this._rendererPassState;
        passState.camera3D = camera;
        const transparents = this.collectLayered(view).transparent;
        const command = gpu.beginCommandEncoder();
        const savedLastPS = gpu.lastRenderPassState;
        const encoder = gpu.beginRenderPass(command, passState);
        gpu.bindCamera(encoder, camera);
        for (const node of transparents) {
          const mat = node.materials?.[0];
          if (!mat || mat.oitMode !== "depth-peel") continue;
          node.nodeUpdate(view, this._passType, passState, cluster);
          node.renderPass2(view, this._passType, passState, cluster, encoder);
        }
        gpu.endPass(encoder);
        gpu.endCommandEncoder(command);
        gpu.lastRenderPassState = savedLastPS;
      }
      _ensureRtFrame(front, depth) {
        if (this._rendererPassState) return;
        const ctx = this._ctx;
        front.name = DDP_FRONT_TEX;
        depth.name = DDP_FRONT_DEPTH_TEX;
        const frontDesc = new RTDescriptor();
        frontDesc.loadOp = "clear";
        frontDesc.clearValue = [0, 0, 0, 0];
        const rtFrame = new RTFrame([front], [frontDesc], depth, void 0, true);
        rtFrame.depthLoadOp = "clear";
        rtFrame.depthClearValue = 1;
        rtFrame.label = "DDPFront";
        this._rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, rtFrame);
        this._rendererPassState.label = "DDPFront";
        this._rendererPassState.outColor = 0;
      }
    }

    const DDPResolveShader = (
      /*wgsl*/
      `
@group(0) @binding(0) var frontSampler: sampler;
@group(0) @binding(1) var frontTexture: texture_2d<f32>;

struct VsOut {
    @builtin(position) pos: vec4<f32>,
    @location(0) uv: vec2<f32>,
};

// Big-triangle fullscreen vertex layout — three vertices cover the
// viewport without needing a vertex buffer.
@vertex
fn vs_main(@builtin(vertex_index) vid: u32) -> VsOut {
    var positions = array<vec2<f32>, 3>(
        vec2<f32>(-1.0, -3.0),
        vec2<f32>(-1.0,  1.0),
        vec2<f32>( 3.0,  1.0),
    );
    let p = positions[vid];
    var out: VsOut;
    out.pos = vec4<f32>(p, 0.0, 1.0);
    out.uv = (p * 0.5 + vec2<f32>(0.5, 0.5)) * vec2<f32>(1.0, -1.0) + vec2<f32>(0.0, 1.0);
    return out;
}

@fragment
fn fs_main(in: VsOut) -> @location(0) vec4<f32> {
    let front = textureSample(frontTexture, frontSampler, in.uv);
    return front;
}
`
    );

    class TransparentDualDepthPeelingResolvePass extends RenderGraphPass {
      name = "TransparentDualDepthPeelingResolvePass";
      _ctx;
      _pipeline = null;
      _bindGroupLayout = null;
      _sampler = null;
      setup(b) {
        this._ctx = b.context3D;
        b.read(DDP_FRONT_TEX, "sample");
        b.write(COLOR_BUFFER);
        b.useRenderTarget(MAIN_COLOR_RT);
      }
      _ensurePipeline(colorBuffer) {
        if (this._pipeline) return;
        const device = this._ctx.device;
        const module = device.createShaderModule({
          label: "DDPResolveShader",
          code: DDPResolveShader
        });
        this._sampler = device.createSampler({
          magFilter: "linear",
          minFilter: "linear",
          addressModeU: "clamp-to-edge",
          addressModeV: "clamp-to-edge"
        });
        this._bindGroupLayout = device.createBindGroupLayout({
          label: "DDPResolveBindGroupLayout",
          entries: [
            { binding: 0, visibility: GPUShaderStage.FRAGMENT, sampler: { type: "filtering" } },
            { binding: 1, visibility: GPUShaderStage.FRAGMENT, texture: { sampleType: "float" } }
          ]
        });
        const pipelineLayout = device.createPipelineLayout({
          label: "DDPResolvePipelineLayout",
          bindGroupLayouts: [this._bindGroupLayout]
        });
        this._pipeline = device.createRenderPipeline({
          label: "DDPResolvePipeline",
          layout: pipelineLayout,
          vertex: { module, entryPoint: "vs_main" },
          fragment: {
            module,
            entryPoint: "fs_main",
            targets: [{
              format: colorBuffer.format,
              // Pre-multiplied over operator: front pass writes
              // (rgb·α, α); hardware blend produces
              // final = src.rgb·1 + dst·(1 - src.a)
              blend: {
                color: { srcFactor: "one", dstFactor: "one-minus-src-alpha", operation: "add" },
                alpha: { srcFactor: "one", dstFactor: "one-minus-src-alpha", operation: "add" }
              }
            }]
          },
          primitive: { topology: "triangle-list" }
        });
      }
      execute(ctx) {
        const front = ctx.getTexture(DDP_FRONT_TEX);
        const colorBuffer = ctx.get(COLOR_BUFFER);
        if (!front || !colorBuffer) return;
        this._ensurePipeline(colorBuffer);
        const gpu = ctx.view.engine3D.context3D.gpuContext;
        const command = gpu.beginCommandEncoder();
        const bindGroup = this._ctx.device.createBindGroup({
          label: "DDPResolveBindGroup",
          layout: this._bindGroupLayout,
          entries: [
            { binding: 0, resource: this._sampler },
            { binding: 1, resource: front.getGPUTexture().createView() }
          ]
        });
        const passDesc = {
          label: "DDPResolvePass",
          colorAttachments: [{
            // Wrapper's prepared single-mip view (see OITResolve
            // for the same fix's rationale).
            view: colorBuffer.getGPUView(),
            loadOp: "load",
            storeOp: "store",
            clearValue: [0, 0, 0, 0]
          }]
        };
        const encoder = command.beginRenderPass(passDesc);
        encoder.setPipeline(this._pipeline);
        encoder.setBindGroup(0, bindGroup);
        encoder.draw(3, 1, 0, 0);
        encoder.end();
        gpu.endCommandEncoder(command);
      }
    }

    const OIT_ACCUM_TEX = "_OITAccum";
    const OIT_REVEAL_TEX = "_OITReveal";
    class TransparentOITPass extends RenderGraphPass {
      name = "TransparentOITPass";
      _ctx;
      _passType = PassType.OIT_ACCUM;
      _rendererPassState = null;
      _zPreTexture = null;
      _accumHandle;
      _revealHandle;
      /** Detect pool-driven attachment identity swaps (canvas resize ⇒
       *  pool re-allocates same-bucket-but-different-size slot, or
       *  re-aliasing across compiles). Forces RTFrame + RendererPassState
       *  rebuild on hit. */
      _watcher = new TextureIdentityWatcher();
      setup(b) {
        this._ctx = b.context3D;
        b.read(COLOR_BUFFER);
        b.read(SCENE_COLOR_PYRAMID);
        if (b.view.engine3D.setting.render.zPrePass) {
          b.read(MAIN_DEPTH_TEXTURE);
          this._zPreTexture = b.graph.pool.get(MAIN_DEPTH_TEXTURE);
        }
        this._accumHandle = b.declareTexture(OIT_ACCUM_TEX, {
          format: GPUTextureFormat.rgba16float,
          width: "screen",
          height: "screen",
          label: OIT_ACCUM_TEX
        });
        b.write(this._accumHandle, "attachment");
        this._revealHandle = b.declareTexture(OIT_REVEAL_TEX, {
          format: GPUTextureFormat.r8unorm,
          width: "screen",
          height: "screen",
          label: OIT_REVEAL_TEX
        });
        b.write(this._revealHandle, "attachment");
        dependOnIfRegistered(b, "GPUCullPass");
      }
      execute(ctx) {
        const accum = ctx.getTexture(this._accumHandle);
        const reveal = ctx.getTexture(this._revealHandle);
        const dirty = this._watcher.update([
          { key: "accum", tex: accum },
          { key: "reveal", tex: reveal }
        ]);
        if (dirty) this._rendererPassState = null;
        this._ensureRtFrame(accum, reveal);
        const view = ctx.view;
        const cluster = ctx.graph.getPass("ClusterLightingPass")?.clusterLightingBuffer;
        const gpu = view.engine3D.context3D.gpuContext;
        const camera = view.camera;
        GlobalBindGroup.updateCameraGroup(camera);
        const passState = this._rendererPassState;
        passState.camera3D = camera;
        const transparents = this.collectLayered(view).transparent;
        const command = gpu.beginCommandEncoder();
        const savedLastPS = gpu.lastRenderPassState;
        const encoder = gpu.beginRenderPass(command, passState);
        gpu.bindCamera(encoder, camera);
        for (const node of transparents) {
          const mat = node.materials?.[0];
          if (!mat || mat.oitMode !== "weighted") continue;
          node.nodeUpdate(view, this._passType, passState, cluster);
          node.renderPass2(view, this._passType, passState, cluster, encoder);
        }
        gpu.endPass(encoder);
        gpu.endCommandEncoder(command);
        gpu.lastRenderPassState = savedLastPS;
      }
      _ensureRtFrame(accum, reveal) {
        if (this._rendererPassState) return;
        const ctx = this._ctx;
        const colorGBuffer = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, ctx);
        accum.name = OIT_ACCUM_TEX;
        reveal.name = OIT_REVEAL_TEX;
        const accumDesc = new RTDescriptor();
        accumDesc.loadOp = "clear";
        accumDesc.clearValue = [0, 0, 0, 0];
        const revealDesc = new RTDescriptor();
        revealDesc.loadOp = "clear";
        revealDesc.clearValue = [1, 1, 1, 1];
        const rtFrame = new RTFrame(
          [accum, reveal],
          [accumDesc, revealDesc],
          colorGBuffer.depthTexture,
          this._zPreTexture ?? void 0,
          true
        );
        rtFrame.depthLoadOp = "load";
        rtFrame.label = "OITAccum";
        this._rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, rtFrame);
        this._rendererPassState.label = "OITAccum";
        this._rendererPassState.outColor = 0;
      }
    }

    let OITResolveShader = (
      /*wgsl*/
      `
    @group(0) @binding(0)
    var oitAccumSampler: sampler;
    @group(0) @binding(1)
    var oitAccum: texture_2d<f32>;
    @group(0) @binding(2)
    var oitRevealSampler: sampler;
    @group(0) @binding(3)
    var oitReveal: texture_2d<f32>;

    struct VSOut {
        @builtin(position) pos: vec4<f32>,
        @location(0) uv: vec2<f32>,
    };

    @vertex
    fn vs_main(@builtin(vertex_index) vid: u32) -> VSOut {
        // Three big-triangle covers the screen; UV interpolated to 0..1
        // across the visible region.
        var pos = array<vec2<f32>, 3>(
            vec2<f32>(-1.0, -1.0),
            vec2<f32>( 3.0, -1.0),
            vec2<f32>(-1.0,  3.0),
        );
        var uv = array<vec2<f32>, 3>(
            vec2<f32>(0.0, 1.0),
            vec2<f32>(2.0, 1.0),
            vec2<f32>(0.0, -1.0),
        );
        var out: VSOut;
        out.pos = vec4<f32>(pos[vid], 0.0, 1.0);
        out.uv = uv[vid];
        return out;
    }

    @fragment
    fn fs_main(in: VSOut) -> @location(0) vec4<f32> {
        let accum = textureSample(oitAccum, oitAccumSampler, in.uv);
        let reveal = textureSample(oitReveal, oitRevealSampler, in.uv).r;
        // Empty pixel: nothing accumulated, leave the background alone.
        if (accum.a == 0.0) {
            discard;
        }
        let avg = accum.rgb / max(accum.a, 1e-4);
        // Output pre-multiplied — the host pipeline uses
        // SRC=ONE, DST=ONE_MINUS_SRC_ALPHA so the final value is
        //   bg * (1 - visibility) + (avg * visibility)
        // which is exactly the WBOIT compositing formula.
        let visibility = 1.0 - reveal;
        return vec4<f32>(avg * visibility, visibility);
    }
`
    );

    class TransparentResolvePass extends RenderGraphPass {
      name = "TransparentResolvePass";
      _ctx;
      _pipeline = null;
      _bindGroupLayout = null;
      _sampler = null;
      setup(b) {
        this._ctx = b.context3D;
        b.read(OIT_ACCUM_TEX, "sample");
        b.read(OIT_REVEAL_TEX, "sample");
        b.write(COLOR_BUFFER);
        b.useRenderTarget(MAIN_COLOR_RT);
      }
      _ensurePipeline(colorBuffer) {
        if (this._pipeline) return;
        const device = this._ctx.device;
        const module = device.createShaderModule({
          label: "OITResolveShader",
          code: OITResolveShader
        });
        this._sampler = device.createSampler({
          magFilter: "linear",
          minFilter: "linear",
          addressModeU: "clamp-to-edge",
          addressModeV: "clamp-to-edge"
        });
        this._bindGroupLayout = device.createBindGroupLayout({
          label: "OITResolveBindGroupLayout",
          entries: [
            { binding: 0, visibility: GPUShaderStage.FRAGMENT, sampler: { type: "filtering" } },
            { binding: 1, visibility: GPUShaderStage.FRAGMENT, texture: { sampleType: "float" } },
            { binding: 2, visibility: GPUShaderStage.FRAGMENT, sampler: { type: "filtering" } },
            { binding: 3, visibility: GPUShaderStage.FRAGMENT, texture: { sampleType: "float" } }
          ]
        });
        const pipelineLayout = device.createPipelineLayout({
          label: "OITResolvePipelineLayout",
          bindGroupLayouts: [this._bindGroupLayout]
        });
        this._pipeline = device.createRenderPipeline({
          label: "OITResolvePipeline",
          layout: pipelineLayout,
          vertex: { module, entryPoint: "vs_main" },
          fragment: {
            module,
            entryPoint: "fs_main",
            targets: [{
              format: colorBuffer.format,
              // Pre-multiplied composite: shader outputs
              // (avg * visibility, visibility), and hardware
              // blends with (1 - visibility) on the existing
              // background — net effect is the WBOIT formula.
              blend: {
                color: { srcFactor: "one", dstFactor: "one-minus-src-alpha", operation: "add" },
                alpha: { srcFactor: "one", dstFactor: "one-minus-src-alpha", operation: "add" }
              }
            }]
          },
          primitive: { topology: "triangle-list" }
        });
      }
      execute(ctx) {
        const accum = ctx.getTexture(OIT_ACCUM_TEX);
        const reveal = ctx.getTexture(OIT_REVEAL_TEX);
        const colorBuffer = ctx.get(COLOR_BUFFER);
        if (!accum || !reveal || !colorBuffer) return;
        this._ensurePipeline(colorBuffer);
        const gpu = ctx.view.engine3D.context3D.gpuContext;
        const command = gpu.beginCommandEncoder();
        const bindGroup = this._ctx.device.createBindGroup({
          label: "OITResolveBindGroup",
          layout: this._bindGroupLayout,
          entries: [
            { binding: 0, resource: this._sampler },
            { binding: 1, resource: accum.getGPUTexture().createView() },
            { binding: 2, resource: this._sampler },
            { binding: 3, resource: reveal.getGPUTexture().createView() }
          ]
        });
        const passDesc = {
          label: "OITResolvePass",
          colorAttachments: [{
            // Use the wrapper's prepared single-mip view rather
            // than `getGPUTexture().createView()` (defaults to all
            // mips). Multi-mip views as attachments are rejected
            // by WebGPU; the prepared view is cached too.
            view: colorBuffer.getGPUView(),
            loadOp: "load",
            storeOp: "store",
            clearValue: [0, 0, 0, 0]
          }]
        };
        const encoder = command.beginRenderPass(passDesc);
        encoder.setPipeline(this._pipeline);
        encoder.setBindGroup(0, bindGroup);
        encoder.draw(3, 1, 0, 0);
        encoder.end();
        gpu.endCommandEncoder(command);
      }
    }

    class GraphCompileError extends Error {
      constructor(message) {
        super(message);
        this.name = new.target.name;
      }
    }
    class CyclicDependencyError extends GraphCompileError {
      cycle;
      constructor(cycle) {
        super(`RenderGraph: cyclic dependency detected — ${cycle.join(" → ")} → ${cycle[0]}. Break the cycle by removing one reads/writes edge, or split the resource into two named handles.`);
        this.cycle = cycle;
      }
    }
    class UnresolvedResourceError extends GraphCompileError {
      pass;
      resource;
      constructor(pass, resource) {
        super(`RenderGraph: pass '${pass}' reads '${resource}' but no creator pass was found. Add a pass that calls b.write('${resource}', factory) in its setup().`);
        this.pass = pass;
        this.resource = resource;
      }
    }
    class MissingCreatorError extends GraphCompileError {
      pass;
      resource;
      constructor(pass, resource) {
        super(`RenderGraph: pass '${pass}' declares write to '${resource}' (mutator) but no creator pass was found. Add a pass that calls b.write('${resource}', factory) in its setup(), or change this pass to be the creator.`);
        this.pass = pass;
        this.resource = resource;
      }
    }
    class WrongResourceKindError extends GraphCompileError {
      pass;
      resource;
      expected;
      actual;
      constructor(pass, resource, expected, actual) {
        super(`RenderGraph: pass '${pass}' uses '${resource}' as kind '${expected}', but the pool entry is kind '${actual}'. Did the creator pass use a different builder method (e.g. b.write vs b.createRenderTarget), or is '${resource}' the wrong name?`);
        this.pass = pass;
        this.resource = resource;
        this.expected = expected;
        this.actual = actual;
      }
    }
    class DuplicateCreatorError extends GraphCompileError {
      resource;
      creators;
      constructor(resource, creators) {
        super(`RenderGraph: resource '${resource}' has multiple creators: ${creators.map((c) => `'${c}'`).join(", ")}. Only one pass may call b.write('${resource}', factory). Other passes that also write must drop the factory and become mutators (b.write('${resource}')).`);
        this.resource = resource;
        this.creators = [...creators];
      }
    }
    class GraphValidator {
      /** name → creator pass name (single creator per resource). */
      _creators = /* @__PURE__ */ new Map();
      /** name → all writer pass names (creator + mutators), in registration order. */
      _writers = /* @__PURE__ */ new Map();
      /** name → reader pass names. */
      _consumers = /* @__PURE__ */ new Map();
      _byName = /* @__PURE__ */ new Map();
      /** Tracks duplicate creators so validateSingleCreator can report all of them. */
      _duplicateCreators = /* @__PURE__ */ new Map();
      constructor(passes) {
        for (const p of passes) {
          if (this._byName.has(p.name)) {
            throw new GraphCompileError(`RenderGraph: duplicate pass name '${p.name}'. Use distinct names or call graph.replace('${p.name}', NewCtor) instead of add.`);
          }
          this._byName.set(p.name, p);
          for (const c of p.creates) {
            if (!this._duplicateCreators.has(c)) this._duplicateCreators.set(c, []);
            this._duplicateCreators.get(c).push(p.name);
            if (!this._creators.has(c)) this._creators.set(c, p.name);
          }
          for (const w of p.writes) {
            if (!this._writers.has(w)) this._writers.set(w, []);
            this._writers.get(w).push(p.name);
          }
          for (const r of p.reads) {
            if (!this._consumers.has(r)) this._consumers.set(r, []);
            this._consumers.get(r).push(p.name);
          }
        }
      }
      /** Each name must have at most one creator. Mutator-only resources
       *  (no creator) are caught by validateResolvable. */
      validateSingleCreator() {
        for (const [name, list] of this._duplicateCreators) {
          if (list.length > 1) {
            throw new DuplicateCreatorError(name, list);
          }
        }
      }
      /** Every read and every mutator-write must point to a resource
       *  with a creator. */
      validateResolvable() {
        for (const [resource, consumers] of this._consumers) {
          if (this._creators.has(resource)) continue;
          throw new UnresolvedResourceError(consumers[0], resource);
        }
        for (const [resource, writers] of this._writers) {
          if (this._creators.has(resource)) continue;
          const mutator = writers[0];
          throw new MissingCreatorError(mutator, resource);
        }
      }
    }
    function topoSort(passes, byName, insertedOrder) {
      const writers = /* @__PURE__ */ new Map();
      for (const p of passes) {
        for (const w of p.writes) {
          if (!writers.has(w)) writers.set(w, []);
          writers.get(w).push(p.name);
        }
      }
      for (const [, list] of writers) {
        list.sort((a, b) => insertedOrder(byName.get(a)) - insertedOrder(byName.get(b)));
      }
      const inDegree = /* @__PURE__ */ new Map();
      const adj = /* @__PURE__ */ new Map();
      for (const p of passes) {
        inDegree.set(p.name, 0);
        adj.set(p.name, []);
      }
      const addEdge = (from, to) => {
        if (from === to) return;
        adj.get(from).push(to);
        inDegree.set(to, inDegree.get(to) + 1);
      };
      for (const [, list] of writers) {
        for (let i = 1; i < list.length; i++) {
          addEdge(list[i - 1], list[i]);
        }
      }
      for (const p of passes) {
        for (const r of p.reads) {
          const ws = writers.get(r);
          if (!ws || ws.length === 0) continue;
          const readerOrder = insertedOrder(p);
          let picked = null;
          for (let i = ws.length - 1; i >= 0; i--) {
            if (insertedOrder(byName.get(ws[i])) <= readerOrder) {
              picked = ws[i];
              break;
            }
          }
          if (!picked) picked = ws[0];
          addEdge(picked, p.name);
        }
      }
      for (const p of passes) {
        if (!p.dependencies) continue;
        for (const dep of p.dependencies) {
          if (!byName.has(dep)) continue;
          addEdge(dep, p.name);
        }
      }
      const eff = /* @__PURE__ */ new Map();
      const epsilon = 1 / (passes.length + 1);
      const byInsertion = [...passes].sort((a, b) => insertedOrder(a) - insertedOrder(b));
      for (const p of byInsertion) {
        let key = insertedOrder(p);
        if (p.dependencies && p.dependencies.size > 0) {
          let maxDepKey = -Infinity;
          for (const depName of p.dependencies) {
            if (depName === p.name) continue;
            const dep = byName.get(depName);
            if (!dep) continue;
            const depKey = eff.get(depName) ?? insertedOrder(dep);
            if (depKey > maxDepKey) maxDepKey = depKey;
          }
          if (maxDepKey > -Infinity) key = maxDepKey + epsilon;
        }
        eff.set(p.name, key);
      }
      const ready = [];
      for (const p of passes) {
        if (inDegree.get(p.name) === 0) ready.push(p);
      }
      const cmp = (a, b) => {
        const da = eff.get(a.name);
        const db = eff.get(b.name);
        if (da !== db) return da - db;
        return insertedOrder(a) - insertedOrder(b);
      };
      ready.sort(cmp);
      const order = [];
      while (ready.length > 0) {
        const next = ready.shift();
        order.push(next.name);
        for (const child of adj.get(next.name)) {
          const d = inDegree.get(child) - 1;
          inDegree.set(child, d);
          if (d === 0) {
            ready.push(byName.get(child));
            ready.sort(cmp);
          }
        }
      }
      if (order.length !== passes.length) {
        const remaining = /* @__PURE__ */ new Set();
        for (const p of passes) if (inDegree.get(p.name) > 0) remaining.add(p.name);
        const cycle = _extractCycle(remaining, adj);
        throw new CyclicDependencyError(cycle);
      }
      return order;
    }
    function _extractCycle(remaining, adj) {
      const start = remaining.values().next().value;
      const path = [];
      const seen = /* @__PURE__ */ new Map();
      let cur = start;
      while (!seen.has(cur)) {
        seen.set(cur, path.length);
        path.push(cur);
        const next = adj.get(cur).find((n) => remaining.has(n));
        if (!next) break;
        cur = next;
      }
      const idx = seen.get(cur);
      return idx !== void 0 ? path.slice(idx) : path;
    }

    class RenderGraphResourcePool {
      _ctx;
      _registry = /* @__PURE__ */ new Map();
      _kinds = /* @__PURE__ */ new Map();
      /** Sidecar marking which resources are persistent (externally
       *  owned and never aliased / pool-allocated). Used by the
       *  transient subsystem to skip these during {@link LifetimeAnalyzer}
       *  + pool allocation, and by tooling to render imported handles
       *  distinctly. */
      _persistent = /* @__PURE__ */ new Set();
      constructor(ctx) {
        this._ctx = ctx;
      }
      get context() {
        return this._ctx;
      }
      /** Register a getter under `name`. Subsequent `get(name)` /
       *  `has(name)` calls resolve through this getter. Calling twice
       *  with the same name overwrites the previous getter — the
       *  graph's single-creator validator catches the production case;
       *  in tests this is convenient for swapping fakes.
       *  The optional `kind` defaults to `'opaque'` so existing
       *  call-sites that pre-date the typed builders keep working. */
      register(name, getter, kind = "opaque") {
        this._registry.set(name, getter);
        this._kinds.set(name, kind);
      }
      /** Mark `name` as persistent — the transient pool will not allocate
       *  or alias a wrapper for it. The persistent flag is independent of
       *  the kind tag: any kind can be marked persistent. Calling on an
       *  unregistered name still records the flag (set on `register`). */
      markPersistent(name) {
        this._persistent.add(name);
      }
      isPersistent(name) {
        return this._persistent.has(name);
      }
      /** Drop the getter for `name`. Idempotent — silently no-ops if the
       *  name isn't registered. Called from `RenderGraph.remove()` and
       *  from `RenderGraph.replace()`'s pre-install cleanup so old
       *  getters don't outlive their owning pass. */
      unregister(name) {
        this._registry.delete(name);
        this._kinds.delete(name);
        this._persistent.delete(name);
      }
      /** Resolve a named resource. Throws if no getter is registered. */
      get(name) {
        const getter = this._registry.get(name);
        if (!getter) {
          throw new Error(`RenderGraphResourcePool.get('${name}') — resource not registered. Has a pass declared b.write('${name}', factory) in its setup()?`);
        }
        return getter();
      }
      has(name) {
        return this._registry.has(name);
      }
      /** Return the kind tag for `name`, or `null` if unregistered. */
      kindOf(name) {
        return this._kinds.get(name) ?? null;
      }
      /** Drop all registrations. Called from `graph.destroy()` and on
       *  device-lost. The actual GPU resources are owned by the
       *  creator passes (or external maps), which manage their own
       *  destruction. */
      dispose() {
        this._registry.clear();
        this._kinds.clear();
        this._persistent.clear();
      }
    }

    class RenderGraphRenderTarget {
      /** Pool handle name. */
      name;
      desc;
      rtFrame;
      colorTextures;
      depthTexture;
      sampleCount;
      /** True if this RT owns the underlying textures (allocate mode).
       *  False for adopt mode — textures are owned by the upstream
       *  {@link RTFrame} source (e.g. {@link GBufferFrame}). */
      owned;
      /** Per-frame flag flipped by the first {@link beginPass} call against
       *  this RT, reset by {@link RenderGraph.execute} at the start of every
       *  frame. Drives the load-op auto-derive rule (first writer => 'clear'
       *  default, subsequent => 'load' default). */
      /** @internal */
      _firstWriterFiredThisFrame = false;
      /** Cache of `(loadOp/clearValue combination)` → cloned {@link RTFrame}
       *  + cached {@link RendererPassState}. Keyed by a stable string built
       *  from the resolved open options. Each entry's clonedFrame.renderTargets
       *  array identity is stable across frames, so
       *  {@link WebGPUDescriptorCreator}'s internal `stateVersion` does not
       *  bump on every begin — only on actual rebuilds (e.g. resize). */
      /** @internal */
      _stateCache = /* @__PURE__ */ new Map();
      /** Names of passes that have called `b.useRenderTarget(this.name)`.
       *  Populated in registration order; used by tooling (`dumpDot`) and
       *  by the validator's dev-mode assertion. */
      /** @internal */
      _writers = [];
      /** Use {@link fromRTFrame} or {@link allocate} — direct construction
       *  is reserved for internal use. */
      constructor(name, desc, rtFrame, owned) {
        this.name = name;
        this.desc = desc;
        this.rtFrame = rtFrame;
        this.colorTextures = rtFrame.renderTargets;
        this.depthTexture = rtFrame.depthTexture ?? null;
        this.sampleCount = rtFrame.sampleCount | 0;
        this.owned = owned;
      }
      /**
       * Adopt an externally-allocated {@link RTFrame}. The wrapper does
       * not own the textures; only descriptor / cache state is reset on
       * {@link destroy}. Typical use: {@link GBufferResourcePass} wraps a
       * {@link GBufferFrame}.
       */
      static fromRTFrame(name, rtFrame, opts) {
        const colors = rtFrame.renderTargets.map((tex, i) => ({
          name: tex.name || `color${i}`,
          format: tex.format,
          clearValue: rtFrame.rtDescriptors[i]?.clearValue,
          storeOp: rtFrame.rtDescriptors[i]?.storeOp,
          texture: tex
        }));
        const depth = rtFrame.depthTexture ? {
          format: rtFrame.depthTexture.format,
          depthClearValue: rtFrame.depthCleanValue,
          texture: rtFrame.depthTexture
        } : void 0;
        const desc = {
          label: opts?.label ?? rtFrame.label ?? name,
          customSize: rtFrame.customSize,
          sampleCount: rtFrame.sampleCount,
          colors,
          depth,
          isOutTarget: rtFrame.isOutTarget
        };
        return new RenderGraphRenderTarget(
          name,
          desc,
          rtFrame,
          /*owned*/
          false
        );
      }
      /**
       * Allocate fresh textures via {@link RTResourceMap} (auto-resize
       * inherited) and assemble a private {@link RTFrame}. The
       * per-attachment cache key in `RTResourceMap` is
       * `"<rt-name>::<attachment-name>"` to avoid colliding with other
       * registries that use bare attachment names.
       */
      static allocate(name, ctx, desc) {
        const presentation = ctx.presentationSize;
        const width = desc.width && desc.width > 0 ? desc.width : presentation[0];
        const height = desc.height && desc.height > 0 ? desc.height : presentation[1];
        const sampleCount = desc.sampleCount ?? 0;
        const colorTextures = [];
        const rtDescriptors = [];
        for (const c of desc.colors) {
          const tex = c.texture ?? RTResourceMap.createRTTexture(
            ctx,
            `${name}::${c.name}`,
            width,
            height,
            c.format,
            /*useMipmap*/
            false,
            sampleCount
          );
          colorTextures.push(tex);
          const rtDesc = new RTDescriptor();
          rtDesc.loadOp = "clear";
          rtDesc.storeOp = c.storeOp ?? "store";
          rtDesc.clearValue = c.clearValue ?? [0, 0, 0, 0];
          rtDescriptors.push(rtDesc);
        }
        let depthTexture;
        if (desc.depth) {
          depthTexture = desc.depth.texture ?? RTResourceMap.createRTTexture(
            ctx,
            `${name}::depth`,
            width,
            height,
            desc.depth.format,
            /*useMipmap*/
            false,
            sampleCount
          );
        }
        const rtFrame = new RTFrame(
          colorTextures,
          rtDescriptors,
          depthTexture,
          void 0,
          desc.isOutTarget ?? false
        );
        rtFrame.label = desc.label;
        rtFrame.sampleCount = sampleCount;
        rtFrame.customSize = desc.customSize ?? false;
        if (desc.depth) {
          rtFrame.depthCleanValue = desc.depth.depthClearValue ?? 1;
        }
        return new RenderGraphRenderTarget(
          name,
          desc,
          rtFrame,
          /*owned*/
          true
        );
      }
      /**
       * Open a render pass on this target. Resolves the load-op combination
       * against the auto-derive rule (first-writer ⇒ clear, subsequent ⇒
       * load) unless `opts` overrides it, looks up (or builds) the cached
       * {@link RendererPassState} for that resolved bucket, opens a fresh
       * {@link GPUCommandEncoder} + render-pass encoder, and returns the
       * encoder + state.
       *
       * Each invocation opens an **independent** command encoder. WebGPU
       * does not require encoders to be shared across passes for
       * `loadOp='load'` chaining — the attachment contents carry over, not
       * the encoder identity.
       *
       * Pair every successful call with {@link endPass} (typically in a
       * `try/finally`).
       */
      beginPass(ctx, opts) {
        const engineCtx = ctx.view.engine3D.context3D;
        const firstWriter = !this._firstWriterFiredThisFrame;
        const colorCount = this.rtFrame.rtDescriptors.length;
        const resolvedColorLoadOps = new Array(colorCount);
        for (let i = 0; i < colorCount; i++) {
          const userOp = opts.colorLoadOps?.[i];
          resolvedColorLoadOps[i] = userOp ?? (firstWriter ? "clear" : "load");
        }
        const resolvedDepthLoadOp = opts.depthLoadOp ?? (firstWriter ? "clear" : "load");
        const graph = ctx.graph;
        const resolvedColorStoreOps = new Array(colorCount);
        for (let i = 0; i < colorCount; i++) {
          const base = this.rtFrame.rtDescriptors[i]?.storeOp ?? "store";
          const colorName = this.desc.colors[i]?.name;
          const canDiscard = colorName && graph?.isLastUseInCurrentPass(colorName);
          resolvedColorStoreOps[i] = canDiscard ? "discard" : base;
        }
        const key = RenderGraphRenderTarget._stateKey(opts, resolvedColorLoadOps, resolvedDepthLoadOp, resolvedColorStoreOps);
        let entry = this._stateCache.get(key);
        if (!entry) {
          const clonedFrame = this.rtFrame.clone();
          clonedFrame.label = `${this.rtFrame.label ?? this.name}::${key}`;
          clonedFrame.depthLoadOp = resolvedDepthLoadOp;
          clonedFrame.depthCleanValue = opts.depthClearValue ?? this.rtFrame.depthCleanValue;
          clonedFrame.sampleCount = this.rtFrame.sampleCount;
          clonedFrame.customSize = this.rtFrame.customSize;
          clonedFrame.isOutTarget = this.rtFrame.isOutTarget;
          for (let i = 0; i < colorCount; i++) {
            const d = clonedFrame.rtDescriptors[i];
            d.loadOp = resolvedColorLoadOps[i];
            d.storeOp = resolvedColorStoreOps[i];
            const override = opts.colorClearValues?.[i];
            if (override !== void 0) {
              d.clearValue = override;
            }
          }
          const passState = WebGPUDescriptorCreator.createRendererPassState(engineCtx, clonedFrame);
          entry = { rtFrame: clonedFrame, passState };
          this._stateCache.set(key, entry);
        } else {
          WebGPUDescriptorCreator.createRendererPassState(engineCtx, entry.rtFrame);
        }
        const gpu = engineCtx.gpuContext;
        const command = gpu.beginCommandEncoder();
        const encoder = gpu.beginRenderPass(command, entry.passState);
        this._firstWriterFiredThisFrame = true;
        return { encoder, command, passState: entry.passState };
      }
      /**
       * Close a pass opened with {@link beginPass} and submit the per-pass
       * command buffer.
       */
      endPass(ctx, opened) {
        const gpu = ctx.view.engine3D.context3D.gpuContext;
        gpu.endPass(opened.encoder);
        gpu.endCommandEncoder(opened.command);
      }
      static _stateKey(opts, colorLoadOps, depthLoadOp, colorStoreOps) {
        let s = "";
        for (let i = 0; i < colorLoadOps.length; i++) {
          s += colorLoadOps[i];
          s += "|";
        }
        s += depthLoadOp;
        s += "|";
        s += opts.depthClearValue ?? "";
        s += "|";
        for (let i = 0; i < colorStoreOps.length; i++) {
          s += colorStoreOps[i];
          s += "|";
        }
        if (opts.colorClearValues) {
          for (const cv of opts.colorClearValues) {
            s += JSON.stringify(cv);
            s += ",";
          }
        }
        return s;
      }
      /**
       * Release per-RT framework state. Owned textures are not destroyed
       * here — {@link RTResourceMap} retains them so that a subsequent
       * graph rebuild can reuse them without reallocating. Pass authors
       * that want explicit destruction must do it themselves.
       */
      destroy(_ctx) {
        this._stateCache.clear();
        this._writers.length = 0;
        this._firstWriterFiredThisFrame = false;
      }
    }

    class RenderGraphRenderPass {
      name;
      target;
      desc;
      openOptions;
      pipeline = null;
      bindGroupLayouts = null;
      /** Runtime fields — valid between {@link begin} and {@link end}. */
      encoder = null;
      command = null;
      passState = null;
      constructor(name, target, desc, openOptions = {}) {
        this.name = name;
        this.target = target;
        this.desc = desc;
        this.openOptions = openOptions;
      }
      /**
       * Lazily build the pipeline (first call), open a fresh command +
       * render-pass encoder on the bound target with the resolved
       * load-op combination, bind the pipeline, and return the encoder.
       * Pass authors then call {@link draw} (or drive the returned
       * encoder directly) before invoking {@link end}.
       */
      begin(ctx) {
        if (this.encoder) {
          throw new Error(`RenderGraphRenderPass '${this.name}': begin() called twice without end().`);
        }
        const engineCtx = ctx.view.engine3D.context3D;
        this._ensurePipeline(engineCtx);
        const opened = this.target.beginPass(ctx, this.openOptions);
        this.encoder = opened.encoder;
        this.command = opened.command;
        this.passState = opened.passState;
        this.encoder.setPipeline(this.pipeline);
        return this.encoder;
      }
      /**
       * Convenience: bind groups + (optional) vertex/index buffers +
       * dispatch one draw or drawIndexed call. Equivalent to manually
       * iterating `setBindGroup` / `setVertexBuffer` / `setIndexBuffer`
       * and calling the matching `draw*` on {@link encoder}.
       */
      draw(call) {
        if (!this.encoder) {
          throw new Error(`RenderGraphRenderPass '${this.name}': draw() called outside begin()/end().`);
        }
        const enc = this.encoder;
        for (let i = 0; i < call.bindGroups.length; i++) {
          enc.setBindGroup(i, call.bindGroups[i]);
        }
        if (call.vertexBuffers) {
          for (let i = 0; i < call.vertexBuffers.length; i++) {
            enc.setVertexBuffer(i, call.vertexBuffers[i]);
          }
        }
        if (call.indexBuffer) {
          enc.setIndexBuffer(
            call.indexBuffer.buffer,
            call.indexBuffer.format,
            call.indexBuffer.offset,
            call.indexBuffer.size
          );
        }
        const d = call.draw;
        if (d.kind === "drawIndexed") {
          enc.drawIndexed(
            d.indexCount,
            d.instanceCount ?? 1,
            d.firstIndex ?? 0,
            d.baseVertex ?? 0,
            d.firstInstance ?? 0
          );
        } else {
          enc.draw(
            d.vertexCount,
            d.instanceCount ?? 1,
            d.firstVertex ?? 0,
            d.firstInstance ?? 0
          );
        }
      }
      /**
       * Close the render-pass encoder and submit the per-pass command
       * buffer. Clears runtime fields so a stale handle from the previous
       * frame surfaces as a clear error rather than encoder misuse.
       */
      end(ctx) {
        if (this.encoder && this.command && this.passState) {
          this.target.endPass(ctx, {
            encoder: this.encoder,
            command: this.command,
            passState: this.passState
          });
        }
        this.encoder = null;
        this.command = null;
        this.passState = null;
      }
      _ensurePipeline(ctx) {
        if (this.pipeline) return;
        const device = ctx.device;
        this.bindGroupLayouts = this.desc.bindGroupLayouts.map((l) => device.createBindGroupLayout(l));
        const layout = device.createPipelineLayout({ bindGroupLayouts: this.bindGroupLayouts });
        const module = device.createShaderModule({
          code: this.desc.shaderCode,
          label: `${this.desc.label}_module`
        });
        const vertex = {
          module,
          entryPoint: this.desc.vertexEntry ?? "main"
        };
        if (this.desc.vertexBuffers) vertex.buffers = this.desc.vertexBuffers;
        if (this.desc.constants) vertex.constants = this.desc.constants;
        const fragment = {
          module,
          entryPoint: this.desc.fragmentEntry ?? "main",
          targets: this._resolveFragmentTargets()
        };
        if (this.desc.constants) fragment.constants = this.desc.constants;
        const descriptor = {
          label: this.desc.label,
          layout,
          vertex,
          fragment
        };
        if (this.desc.primitive) descriptor.primitive = this.desc.primitive;
        const depthStencil = this._resolveDepthStencil();
        if (depthStencil) descriptor.depthStencil = depthStencil;
        const multisample = this._resolveMultisample();
        if (multisample) descriptor.multisample = multisample;
        this.pipeline = device.createRenderPipeline(descriptor);
      }
      _resolveFragmentTargets() {
        const colorCount = this.target.rtFrame.rtDescriptors.length;
        const userTargets = this.desc.fragmentTargets;
        const out = new Array(colorCount);
        for (let i = 0; i < colorCount; i++) {
          const format = this.target.colorTextures[i].format;
          const user = userTargets?.[i];
          if (user) {
            out[i] = { ...user, format: user.format ?? format };
          } else {
            out[i] = { format };
          }
        }
        return out;
      }
      _resolveDepthStencil() {
        const depthTex = this.target.depthTexture;
        const user = this.desc.depthStencil;
        if (!depthTex) {
          if (user) {
            throw new Error(
              `RenderGraphRenderPass '${this.name}': desc.depthStencil set but target '${this.target.name}' has no depth attachment.`
            );
          }
          return void 0;
        }
        const format = depthTex.format;
        if (user) {
          return { ...user, format: user.format ?? format };
        }
        return { format, depthWriteEnabled: false, depthCompare: "always" };
      }
      _resolveMultisample() {
        const targetSamples = this.target.sampleCount | 0;
        const user = this.desc.multisample;
        if (user) {
          return { ...user, count: user.count ?? (targetSamples > 0 ? targetSamples : 1) };
        }
        if (targetSamples > 0) return { count: targetSamples };
        return void 0;
      }
    }

    class RenderGraphComputePass {
      name;
      desc;
      pipeline = null;
      bindGroupLayouts = null;
      /** Runtime fields — valid between {@link begin} and {@link end}. */
      encoder = null;
      command = null;
      constructor(name, desc) {
        this.name = name;
        this.desc = desc;
      }
      /**
       * Open a fresh command encoder + compute pass encoder. Lazily
       * builds the pipeline on first call. The pipeline survives across
       * frames; layouts can be reused for bind-group creation by pass
       * authors via {@link bindGroupLayouts}.
       */
      begin(ctx) {
        if (this.encoder) {
          throw new Error(`RenderGraphComputePass '${this.name}': begin() called twice without end().`);
        }
        const engineCtx = ctx.view.engine3D.context3D;
        this._ensurePipeline(engineCtx);
        const gpu = engineCtx.gpuContext;
        this.command = gpu.beginCommandEncoder();
        this.encoder = this.command.beginComputePass({ label: this.desc.label });
        this.encoder.setPipeline(this.pipeline);
        return this.encoder;
      }
      /**
       * Convenience: bind the provided bind groups (one per layout
       * index) and dispatch. Equivalent to manually iterating
       * `setBindGroup` + calling `dispatchWorkgroups` on
       * {@link encoder}.
       */
      dispatch(call) {
        if (!this.encoder) {
          throw new Error(`RenderGraphComputePass '${this.name}': dispatch() called outside begin()/end().`);
        }
        for (let i = 0; i < call.bindGroups.length; i++) {
          this.encoder.setBindGroup(i, call.bindGroups[i]);
        }
        this.encoder.dispatchWorkgroups(call.workgroups[0], call.workgroups[1], call.workgroups[2]);
      }
      end(ctx) {
        const gpu = ctx.view.engine3D.context3D.gpuContext;
        if (this.encoder) this.encoder.end();
        if (this.command) gpu.endCommandEncoder(this.command);
        this.encoder = null;
        this.command = null;
      }
      _ensurePipeline(ctx) {
        if (this.pipeline) return;
        const device = ctx.device;
        this.bindGroupLayouts = this.desc.bindGroupLayouts.map((l) => device.createBindGroupLayout(l));
        const layout = device.createPipelineLayout({ bindGroupLayouts: this.bindGroupLayouts });
        const module = device.createShaderModule({
          code: this.desc.shaderCode,
          label: `${this.desc.label}_module`
        });
        const compute = {
          module,
          entryPoint: this.desc.entryPoint ?? "CsMain"
        };
        if (this.desc.constants) {
          compute.constants = this.desc.constants;
        }
        this.pipeline = device.createComputePipeline({
          label: this.desc.label,
          layout,
          compute
        });
      }
    }

    class TransientResourceRegistry {
      /** logical name → declaration. Single-creator: redeclaring the
       *  same name throws. */
      _declarations = /* @__PURE__ */ new Map();
      /** logical name → unioned GPUTextureUsage / GPUBufferUsage bitfield
       *  contributed by every `read/write/readWrite` access hint targeting
       *  this resource. Combined with the desc's explicit `usage` (when
       *  not `'auto'`) inside the analyzer. */
      _hintUsage = /* @__PURE__ */ new Map();
      /**
       * Register a transient texture declaration.
       * @throws if `name` has already been declared (single-creator).
       */
      declareTexture(name, desc, creatorPass) {
        this._assertUnique(name, creatorPass);
        this._declarations.set(name, {
          name,
          kind: "texture",
          desc,
          persistent: false,
          creatorPass
        });
      }
      /**
       * Register a transient buffer declaration.
       * @throws if `name` has already been declared (single-creator).
       */
      declareBuffer(name, desc, creatorPass) {
        this._assertUnique(name, creatorPass);
        this._declarations.set(name, {
          name,
          kind: "buffer",
          desc,
          persistent: false,
          creatorPass
        });
      }
      /**
       * Register an externally-owned texture as a persistent resource.
       * The pool will not allocate, will not alias, and will not destroy
       * the underlying GPU texture. `getTexture(name)` returns `tex`
       * verbatim.
       */
      importExternalTexture(name, tex, creatorPass) {
        this._assertUnique(name, creatorPass);
        this._declarations.set(name, {
          name,
          kind: "texture",
          // Best-effort desc reflection. The analyzer only consults
          // the desc for bucketing transient resources; persistent
          // entries skip allocation entirely, so most fields are
          // advisory and labels only.
          desc: {
            format: tex.format,
            width: tex.width,
            height: tex.height,
            sampleCount: tex.sampleCount,
            numberLayer: tex.numberLayer,
            usage: tex.usage,
            aliasable: false,
            label: tex.name
          },
          persistent: true,
          creatorPass,
          externalTexture: tex
        });
      }
      /**
       * Register an externally-owned GPU buffer as a persistent resource.
       */
      importExternalBuffer(name, buf, creatorPass) {
        this._assertUnique(name, creatorPass);
        this._declarations.set(name, {
          name,
          kind: "buffer",
          desc: {
            size: buf.byteSize ?? 0,
            usage: buf.usage,
            aliasable: false
          },
          persistent: true,
          creatorPass,
          externalBuffer: buf
        });
      }
      /**
       * Record one `read` / `write` / `readWrite` access hint for a
       * resource. Hint bits are OR'd into the per-name hint usage map;
       * the analyzer combines this with the desc's `usage` (when `'auto'`)
       * to produce the final allocation usage.
       *
       * Targets that aren't registered in this registry are silently
       * ignored — they're legacy `b.write(name, getter)` resources that
       * live in `RenderGraphResourcePool` only and don't participate in
       * transient allocation.
       */
      recordAccessHint(name, kind, hint, mode) {
        if (!this._declarations.has(name)) return;
        const prev = this._hintUsage.get(name) ?? 0;
        this._hintUsage.set(name, prev | hintToUsageBit(kind, hint));
      }
      /** Read-only view of registered declarations. */
      get declarations() {
        return this._declarations;
      }
      /** Per-name unioned usage contribution from access hints. */
      hintUsageOf(name) {
        return this._hintUsage.get(name) ?? 0;
      }
      has(name) {
        return this._declarations.has(name);
      }
      get(name) {
        return this._declarations.get(name);
      }
      /**
       * Drop the declaration + access hints for `name`. Called from
       * `RenderGraph.remove()` / `RenderGraph.replace()` so a re-added
       * pass can re-declare its outputs without tripping the
       * single-creator check.
       */
      unregister(name) {
        this._declarations.delete(name);
        this._hintUsage.delete(name);
      }
      /**
       * Drop every declaration and hint. Called on graph destroy and
       * device-lost.
       */
      dispose() {
        this._declarations.clear();
        this._hintUsage.clear();
      }
      _assertUnique(name, creatorPass) {
        const prior = this._declarations.get(name);
        if (prior) {
          throw new Error(
            `RenderGraph.transient: resource '${name}' already declared by pass '${prior.creatorPass}' — pass '${creatorPass}' must use a different name. Only one pass may declare/import a given transient name.`
          );
        }
      }
    }
    function hintToUsageBit(kind, hint, mode) {
      if (kind === "texture") {
        let bits2 = GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST;
        switch (hint) {
          case "sample":
            bits2 |= GPUTextureUsage.TEXTURE_BINDING;
            break;
          case "storage":
            bits2 |= GPUTextureUsage.STORAGE_BINDING;
            break;
          case "attachment":
            bits2 |= GPUTextureUsage.RENDER_ATTACHMENT;
            break;
        }
        return bits2;
      }
      let bits = GPUBufferUsage.COPY_SRC | GPUBufferUsage.COPY_DST;
      switch (hint) {
        case "sample":
        case "attachment":
          break;
        case "storage":
          bits |= GPUBufferUsage.STORAGE;
          break;
      }
      return bits;
    }

    class TransientTexturePool {
      _ctx;
      _buckets = /* @__PURE__ */ new Map();
      /** Per-name dedicated slots for aliasable:false resources. These
       *  bypass bucket reuse so consumers can cache bind groups against
       *  a stable `GPUTexture` identity across compiles. */
      _dedicatedByName = /* @__PURE__ */ new Map();
      _currentBytes = 0;
      _peakBytes = 0;
      constructor(ctx) {
        this._ctx = ctx;
      }
      /**
       * Allocate (or reuse) physical wrappers for every transient
       * lifetime. Persistent (imported) lifetimes are ignored — those
       * are registered directly by the builder when the external
       * texture is imported.
       */
      assign(lifetimes) {
        for (const list of this._buckets.values()) {
          for (const pt of list) {
            pt.inUseUntilIdx = -1;
            pt.inUseByName = null;
          }
        }
        const bindings = /* @__PURE__ */ new Map();
        const debug = /* @__PURE__ */ new Map();
        const texLifetimes = lifetimes.filter((lt) => lt.kind === "texture" && !lt.persistent);
        const sorted = [...texLifetimes].sort((a, b) => {
          if (a.firstUseIdx !== b.firstUseIdx) return a.firstUseIdx - b.firstUseIdx;
          return a.name < b.name ? -1 : 1;
        });
        for (const lt of sorted) {
          const desc = lt.desc;
          const w = lt.resolvedWidth;
          const h = lt.resolvedHeight;
          const usage = lt.resolvedUsage;
          if (!usage) {
            console.warn(
              `[RenderGraph] transient texture '${lt.name}' resolved to usage=0 — no read/write access hints recorded and no explicit usage on the desc. Allocating with TEXTURE_BINDING as a safe default.`
            );
          }
          const finalUsage = usage || GPUTextureUsage.TEXTURE_BINDING;
          const bucketKey = computeBucketKey(desc, w, h, finalUsage);
          const aliasable = desc.aliasable !== false;
          let slot;
          let aliased = false;
          let dedicated = false;
          if (!aliasable) {
            const existing = this._dedicatedByName.get(lt.name);
            if (existing && existing.bucketKey === bucketKey) {
              slot = existing;
            } else if (existing && inPlaceResizable(existing.bucketKey, bucketKey)) {
              this._currentBytes -= existing.estimatedBytes;
              existing.rt.resize(w, h);
              this._patchMipLevels(existing.rt, desc);
              existing.bucketKey = bucketKey;
              existing.estimatedBytes = estimateTextureBytes(desc, w, h);
              this._currentBytes += existing.estimatedBytes;
              if (this._currentBytes > this._peakBytes) this._peakBytes = this._currentBytes;
              slot = existing;
            } else {
              if (existing) this._destroySlot(existing);
              slot = this._allocateSlot(lt, desc, w, h, finalUsage, bucketKey);
              this._dedicatedByName.set(lt.name, slot);
            }
            dedicated = true;
          } else {
            let bucket = this._buckets.get(bucketKey);
            if (!bucket) {
              bucket = [];
              this._buckets.set(bucketKey, bucket);
            }
            slot = this._findReusableSlot(bucket, lt.firstUseIdx) ?? this._appendNewSlot(bucket, lt, desc, w, h, finalUsage, bucketKey);
            aliased = slot.inUseByName !== null && slot.inUseByName !== lt.name;
            slot.inUseUntilIdx = lt.lastUseIdx;
            slot.inUseByName = lt.name;
          }
          bindings.set(lt.name, slot.rt);
          debug.set(lt.name, { bucketKey, aliased, dedicated });
        }
        const liveDedicated = new Set(sorted.filter((lt) => lt.desc.aliasable === false).map((lt) => lt.name));
        for (const [name, slot] of this._dedicatedByName) {
          if (!liveDedicated.has(name)) {
            this._destroySlot(slot);
            this._dedicatedByName.delete(name);
          }
        }
        for (const [key, list] of this._buckets) {
          if (!list.some((slot) => slot.inUseByName !== null)) {
            for (const slot of list) this._destroySlot(slot);
            this._buckets.delete(key);
          }
        }
        return { bindings, debug };
      }
      /** Destroy every pooled wrapper. Called on graph destroy and
       *  device-lost. */
      dispose() {
        for (const list of this._buckets.values()) {
          for (const slot of list) this._destroySlot(slot);
        }
        this._buckets.clear();
        for (const slot of this._dedicatedByName.values()) this._destroySlot(slot);
        this._dedicatedByName.clear();
        this._currentBytes = 0;
      }
      stats() {
        let slotCount = this._dedicatedByName.size;
        for (const list of this._buckets.values()) slotCount += list.length;
        return {
          currentBytes: this._currentBytes,
          peakBytes: this._peakBytes,
          bucketCount: this._buckets.size,
          slotCount
        };
      }
      _findReusableSlot(bucket, firstUseIdx) {
        let best = null;
        for (const slot of bucket) {
          if (slot.inUseByName !== null) continue;
          if (slot.inUseUntilIdx >= firstUseIdx) continue;
          if (best === null || slot.inUseUntilIdx < best.inUseUntilIdx) best = slot;
        }
        return best;
      }
      _appendNewSlot(bucket, lt, desc, w, h, usage, bucketKey) {
        const slot = this._allocateSlot(lt, desc, w, h, usage, bucketKey);
        bucket.push(slot);
        return slot;
      }
      _allocateSlot(lt, desc, w, h, usage, bucketKey) {
        const rt = new RenderTexture(
          w,
          h,
          desc.format,
          (desc.mipLevelCount ?? 1) > 1,
          usage,
          desc.numberLayer ?? 1,
          desc.sampleCount ?? 0,
          /*clear*/
          true,
          /*autoResize*/
          false,
          this._ctx
        );
        rt.name = desc.label ?? lt.name;
        this._patchMipLevels(rt, desc);
        const estimatedBytes = estimateTextureBytes(desc, w, h);
        this._currentBytes += estimatedBytes;
        if (this._currentBytes > this._peakBytes) this._peakBytes = this._currentBytes;
        return {
          rt,
          bucketKey,
          inUseUntilIdx: lt.lastUseIdx,
          inUseByName: lt.name,
          estimatedBytes
        };
      }
      /**
       * Force the GPUTextureDescriptor's actual mip count — the
       * RenderTexture ctor + resize() path forces useMipmap=false and
       * rebuilds the descriptor with mipLevelCount=1. Phase 4 removes this
       * workaround at the RenderTexture level.
       *
       * Patch only `textureDescriptor.mipLevelCount` + null the cached
       * gpuTexture/view so the next materialize uses the new mip count. Do
       * NOT also touch `mipmapCount` / `viewDescriptor` / `useMipmap` on the
       * wrapper — those propagate into `textureBindingLayout.sampleType`
       * rebuilds that flip r32float from `unfilterable-float` (correct) to
       * filterable `float` (rejected by validation). HiZ + downstream
       * r32float consumers bind via their own explicit views + bind-group
       * layouts so the wrapper-level sample-type defaults don't matter for
       * them; for rgba16float pyramids the defaults already match
       * (filterable). Re-applied after an in-place resize because resize()
       * rebuilds the descriptor back to mipLevelCount=1.
       *
       * The requested count is clamped to the maximum a full mip chain
       * supports at the texture's current size (`1 + floor(log2(max(w,h)))`).
       * Passes that bake their mip count once at setup time from the initial
       * presentation size (e.g. HiZPass) would otherwise keep requesting that
       * fixed count after the canvas shrinks below the next power of two,
       * tripping WebGPU's "mip level count exceeds the maximum for its size"
       * validation and aborting the frame — a resize crash distinct from the
       * stale-bind-group one. Consumers that need the real count read it back
       * from `textureDescriptor.mipLevelCount` (HiZPass.execute), so clamping
       * here keeps their generation loops in range too.
       */
      _patchMipLevels(rt, desc) {
        const requested = desc.mipLevelCount ?? 1;
        if (requested <= 1) return;
        const maxForSize = 1 + Math.floor(Math.log2(Math.max(rt.width, rt.height)));
        const mips = Math.min(requested, maxForSize);
        const rtAny = rt;
        if (rtAny.textureDescriptor) {
          rtAny.textureDescriptor.mipLevelCount = mips;
        }
        rtAny.gpuTexture = null;
        rtAny.view = null;
      }
      _destroySlot(slot) {
        const gpu = slot.rt.gpuTexture;
        if (gpu) Texture.delayDestroyTexture(this._ctx, gpu);
        slot.rt.gpuTexture = null;
        slot.rt.view = null;
        this._currentBytes -= slot.estimatedBytes;
        if (this._currentBytes < 0) this._currentBytes = 0;
      }
    }
    function computeBucketKey(desc, w, h, usage) {
      const mip = desc.mipLevelCount ?? 1;
      const sample = desc.sampleCount ?? 0;
      const layers = desc.numberLayer ?? 1;
      return `${desc.format}|${w}x${h}|s${sample}|l${layers}|m${mip}|u${usage}`;
    }
    function inPlaceResizable(a, b) {
      if (a === b) return false;
      const strip = (k) => {
        const p = k.split("|");
        p.splice(4, 1);
        p.splice(1, 1);
        return p.join("|");
      };
      return strip(a) === strip(b);
    }
    function estimateTextureBytes(desc, w, h) {
      const bpp = bytesPerPixel(desc.format);
      const layers = desc.numberLayer ?? 1;
      const samples = Math.max(1, desc.sampleCount ?? 0);
      const mips = desc.mipLevelCount ?? 1;
      let total = 0;
      let mw = w, mh = h;
      for (let m = 0; m < mips; m++) {
        total += mw * mh * bpp * layers * samples;
        mw = Math.max(1, mw >> 1);
        mh = Math.max(1, mh >> 1);
      }
      return total;
    }
    function bytesPerPixel(format) {
      switch (format) {
        case "r8unorm":
        case "r8snorm":
        case "r8uint":
        case "r8sint":
          return 1;
        case "r16uint":
        case "r16sint":
        case "r16float":
        case "rg8unorm":
        case "rg8snorm":
        case "rg8uint":
        case "rg8sint":
          return 2;
        case "r32uint":
        case "r32sint":
        case "r32float":
        case "rg16uint":
        case "rg16sint":
        case "rg16float":
        case "rgba8unorm":
        case "rgba8unorm-srgb":
        case "rgba8snorm":
        case "rgba8uint":
        case "rgba8sint":
        case "bgra8unorm":
        case "bgra8unorm-srgb":
        case "rgb10a2unorm":
        case "rg11b10ufloat":
        case "depth24plus":
        case "depth32float":
          return 4;
        case "rg32uint":
        case "rg32sint":
        case "rg32float":
        case "rgba16uint":
        case "rgba16sint":
        case "rgba16float":
        case "depth32float-stencil8":
          return 8;
        case "rgba32uint":
        case "rgba32sint":
        case "rgba32float":
          return 16;
        default:
          return 4;
      }
    }

    class TransientBufferPool {
      _ctx;
      _buckets = /* @__PURE__ */ new Map();
      _dedicatedByName = /* @__PURE__ */ new Map();
      _currentBytes = 0;
      _peakBytes = 0;
      constructor(ctx) {
        this._ctx = ctx;
      }
      assign(lifetimes) {
        for (const list of this._buckets.values()) {
          for (const slot of list) {
            slot.inUseUntilIdx = -1;
            slot.inUseByName = null;
          }
        }
        const bindings = /* @__PURE__ */ new Map();
        const debug = /* @__PURE__ */ new Map();
        const bufLifetimes = lifetimes.filter((lt) => lt.kind === "buffer" && !lt.persistent).sort((a, b) => {
          if (a.firstUseIdx !== b.firstUseIdx) return a.firstUseIdx - b.firstUseIdx;
          return a.name < b.name ? -1 : 1;
        });
        for (const lt of bufLifetimes) {
          const desc = lt.desc;
          const requested = lt.resolvedSize;
          const rounded = roundUpToPow2(Math.max(16, requested));
          const usage = lt.resolvedUsage || desc.usage;
          const bucketKey = `${rounded}|u${usage}`;
          const aliasable = desc.aliasable !== false;
          let slot;
          let aliased = false;
          let dedicated = false;
          let grew = false;
          if (!aliasable) {
            const existing = this._dedicatedByName.get(lt.name);
            if (existing && existing.bucketKey === bucketKey) {
              slot = existing;
            } else {
              if (existing) this._destroySlot(existing);
              slot = this._allocateSlot(lt, usage, rounded, bucketKey);
              this._dedicatedByName.set(lt.name, slot);
            }
            dedicated = true;
          } else {
            let bucket = this._buckets.get(bucketKey);
            if (!bucket) {
              bucket = [];
              this._buckets.set(bucketKey, bucket);
            }
            const reused = this._findReusableSlot(bucket, lt.firstUseIdx);
            if (reused) {
              slot = reused;
              if (slot.actualSize < requested) {
                slot.buf.resizeBuffer(rounded);
                this._currentBytes += rounded - slot.actualSize;
                slot.actualSize = rounded;
                grew = true;
              }
              aliased = slot.inUseByName !== null && slot.inUseByName !== lt.name;
            } else {
              slot = this._allocateSlot(lt, usage, rounded, bucketKey);
              bucket.push(slot);
            }
            slot.inUseUntilIdx = lt.lastUseIdx;
            slot.inUseByName = lt.name;
            if (this._currentBytes > this._peakBytes) this._peakBytes = this._currentBytes;
          }
          bindings.set(lt.name, slot.buf);
          debug.set(lt.name, { bucketKey, aliased, dedicated, grew });
        }
        const liveDedicated = new Set(bufLifetimes.filter((lt) => lt.desc.aliasable === false).map((lt) => lt.name));
        for (const [name, slot] of this._dedicatedByName) {
          if (!liveDedicated.has(name)) {
            this._destroySlot(slot);
            this._dedicatedByName.delete(name);
          }
        }
        for (const [key, list] of this._buckets) {
          if (!list.some((slot) => slot.inUseByName !== null)) {
            for (const slot of list) this._destroySlot(slot);
            this._buckets.delete(key);
          }
        }
        return { bindings, debug };
      }
      dispose() {
        for (const list of this._buckets.values()) {
          for (const slot of list) this._destroySlot(slot);
        }
        this._buckets.clear();
        for (const slot of this._dedicatedByName.values()) this._destroySlot(slot);
        this._dedicatedByName.clear();
        this._currentBytes = 0;
      }
      stats() {
        let slotCount = this._dedicatedByName.size;
        for (const list of this._buckets.values()) slotCount += list.length;
        return {
          currentBytes: this._currentBytes,
          peakBytes: this._peakBytes,
          bucketCount: this._buckets.size,
          slotCount
        };
      }
      _findReusableSlot(bucket, firstUseIdx) {
        let best = null;
        for (const slot of bucket) {
          if (slot.inUseByName !== null) continue;
          if (slot.inUseUntilIdx >= firstUseIdx) continue;
          if (best === null || slot.inUseUntilIdx < best.inUseUntilIdx) best = slot;
        }
        return best;
      }
      _allocateSlot(lt, usage, size, bucketKey) {
        const buf = new GPUBufferBase();
        buf.usage = usage;
        buf.byteSize = size;
        buf._boundCtx = this._ctx;
        this._currentBytes += size;
        if (this._currentBytes > this._peakBytes) this._peakBytes = this._currentBytes;
        return {
          buf,
          bucketKey,
          actualSize: size,
          inUseUntilIdx: lt.lastUseIdx,
          inUseByName: lt.name
        };
      }
      _destroySlot(slot) {
        try {
          slot.buf.destroy();
        } catch {
        }
        this._currentBytes -= slot.actualSize;
        if (this._currentBytes < 0) this._currentBytes = 0;
      }
    }
    function roundUpToPow2(n) {
      if (n <= 1) return 1;
      let p = 1;
      while (p < n) p <<= 1;
      return p;
    }

    class LifetimeAnalyzer {
      /**
       * Analyze one compile window.
       *
       * @param order Topo-sorted pass names from {@link topoSort}.
       * @param byName Pass lookup map.
       * @param registry Per-graph transient registry populated during setup.
       * @param presentationSize `[width, height]` of the owning view's
       *   canvas. Used to resolve `'screen'` / `'screen/2'` size tokens.
       */
      static analyze(order, byName, registry, presentationSize) {
        const lifetimes = /* @__PURE__ */ new Map();
        for (const [name, decl] of registry.declarations) {
          lifetimes.set(name, seedLifetime(decl, order.length));
        }
        for (let i = 0; i < order.length; i++) {
          const pass = byName.get(order[i]);
          if (!pass) continue;
          widenAll(pass.reads, i, lifetimes);
          widenAll(pass.writes, i, lifetimes);
          const lifetimeReads = pass._lifetimeReads;
          const lifetimeWrites = pass._lifetimeWrites;
          if (lifetimeReads) widenAll(lifetimeReads, i, lifetimes);
          if (lifetimeWrites) widenAll(lifetimeWrites, i, lifetimes);
        }
        const out = [];
        for (const lt of lifetimes.values()) {
          if (!lt.persistent && lt.lastUseIdx < 0) {
            console.warn(
              `[RenderGraph] transient resource '${lt.name}' was declared but is unused this compile window — no enabled pass reads or writes it. Skipping pool allocation.`
            );
            continue;
          }
          resolveSizeAndUsage(lt, registry, presentationSize);
          out.push(lt);
        }
        return out;
      }
    }
    function seedLifetime(decl, orderLength) {
      const persistent = decl.persistent;
      const firstUseIdx = decl.persistent ? 0 : Number.POSITIVE_INFINITY;
      const lastUseIdx = decl.persistent ? Math.max(0, orderLength - 1) : -1;
      return {
        name: decl.name,
        kind: decl.kind,
        desc: decl.desc,
        firstUseIdx,
        lastUseIdx,
        resolvedUsage: 0,
        persistent
      };
    }
    function widenAll(names, passIdx, lifetimes) {
      for (const n of names) {
        const lt = lifetimes.get(n);
        if (!lt) continue;
        if (passIdx < lt.firstUseIdx) lt.firstUseIdx = passIdx;
        if (passIdx > lt.lastUseIdx) lt.lastUseIdx = passIdx;
      }
    }
    function resolveSizeAndUsage(lt, registry, presentationSize) {
      if (lt.kind === "texture") {
        const desc = lt.desc;
        lt.resolvedWidth = resolveSizeSpec(desc.width, presentationSize[0]);
        lt.resolvedHeight = resolveSizeSpec(desc.height, presentationSize[1]);
      } else {
        const desc = lt.desc;
        lt.resolvedSize = desc.size;
      }
      const hintBits = registry.hintUsageOf(lt.name);
      const explicit = lt.desc.usage;
      if (typeof explicit === "number") {
        lt.resolvedUsage = explicit | hintBits;
        const missing = hintBits & ~explicit;
        if (missing !== 0) {
          console.warn(
            `[RenderGraph] transient '${lt.name}' explicit usage 0x${explicit.toString(16)} is missing bits 0x${missing.toString(16)} that are required by recorded access hints. Final usage will be 0x${lt.resolvedUsage.toString(16)} — consider switching to usage:'auto' or extending the explicit mask.`
          );
        }
      } else {
        lt.resolvedUsage = hintBits;
      }
    }
    function resolveSizeSpec(spec, canvasDim) {
      if (typeof spec === "number") return Math.max(1, Math.floor(spec));
      switch (spec) {
        case "screen":
          return Math.max(1, Math.floor(canvasDim));
        case "screen/2":
          return Math.max(1, Math.floor(canvasDim / 2));
        case "screen/4":
          return Math.max(1, Math.floor(canvasDim / 4));
        case "screen/8":
          return Math.max(1, Math.floor(canvasDim / 8));
      }
      throw new Error(`[RenderGraph] unknown SizeSpec: ${String(spec)}`);
    }

    function makeTextureHandle(name) {
      return { name };
    }
    function makeBufferHandle(name) {
      return { name };
    }
    function resourceName(target) {
      return typeof target === "string" ? target : target.name;
    }

    const PASS_META = Symbol("RenderGraphPass.meta");
    class _PendingSetupError extends Error {
      constructor(resourceName2) {
        super(`RenderGraph: setup pending — '${resourceName2}' not yet registered.`);
        this.resourceName = resourceName2;
        this.name = "_PendingSetupError";
      }
    }
    class _SetupDraft {
      reads = [];
      writes = [];
      creates = [];
      deps;
      /** name → would-be pool entry (overwrites real pool on commit). */
      poolEntries = /* @__PURE__ */ new Map();
      /** name → newly-allocated RT (added to `_renderTargets` on commit). */
      rtEntries = /* @__PURE__ */ new Map();
      /** name → transient kind for this attempt (for in-flight single-
       *  creator + recordAccessHint visibility). */
      transientKinds = /* @__PURE__ */ new Map();
      /** Deferred transient registry mutations (declare/import). Captured
       *  as closures so commit replays them in setup order. */
      transientOps = [];
      /** Deferred `_writers.push` calls — only for tooling, but kept in
       *  draft so they're not applied on a failed attempt. */
      rtWriterPushes = [];
      /** Deferred access-hint records (`recordAccessHint`). */
      hintOps = [];
      /** Deferred `_eagerAllocateAndPublish` calls (publishToLegacyMap). */
      eagerPublishes = [];
      constructor(initialDeps) {
        this.deps = new Set(initialDeps ?? []);
      }
    }
    class RenderGraph {
      _view;
      _ctx;
      _pool;
      _passes = [];
      _byName = /* @__PURE__ */ new Map();
      /** name → RenderGraphRenderTarget for every typed RT registered
       *  through `b.createRenderTarget` / `b.adoptRenderTarget`. Lets
       *  {@link execute} reset the per-frame first-writer flag in O(RT)
       *  rather than scanning the pool. */
      _renderTargets = /* @__PURE__ */ new Map();
      /** Per-graph transient resource subsystem. Populated by `b.declareTexture`
       *  / `b.declareBuffer` / `b.importExternalTexture` during pass setup;
       *  consumed by {@link LifetimeAnalyzer} + the physical pools in
       *  {@link compile}. */
      _transient = new TransientResourceRegistry();
      _texturePool;
      _bufferPool;
      /** Latest lifetime analysis output. Held across frames so future
       *  Phase 6 work (storeOp='discard' derivation, debug dumpDot)
       *  can consult per-resource intervals without re-running analyze. */
      _lifetimes = [];
      /** Per-resource last-use compile-order index. Used by
       *  {@link RenderGraphRenderTarget.beginPass} to auto-derive
       *  `storeOp='discard'` for attachments whose last writer is the
       *  current pass and which have no downstream reader. Built each
       *  compile; missing entries imply "no transient lifetime known
       *  → must store" (safe default). */
      _lastUseByName = /* @__PURE__ */ new Map();
      /** Index into `_compiled` of the pass currently in `execute()`.
       *  Set per-pass during {@link execute} so
       *  {@link RenderGraphRenderTarget.beginPass} can compare against
       *  `_lastUseByName` without threading an extra parameter through
       *  every encoder-open API. */
      _currentPassIdx = -1;
      /** logical name → pool-resolved RenderTexture for the current
       *  compile window. Cleared each {@link compile} and repopulated
       *  from {@link TransientTexturePool.assign}. */
      _textureBindings = /* @__PURE__ */ new Map();
      _bufferBindings = /* @__PURE__ */ new Map();
      _compiled = null;
      _dirty = true;
      _insertCounter = 0;
      _batchDepth = 0;
      _onDeviceLost;
      _onCanvasResize;
      constructor(view) {
        this._view = view;
        this._ctx = view.engine3D.context3D;
        this._pool = new RenderGraphResourcePool(this._ctx);
        this._texturePool = new TransientTexturePool(this._ctx);
        this._bufferPool = new TransientBufferPool(this._ctx);
        this._onDeviceLost = () => {
          this._pool.dispose();
          this._texturePool.dispose();
          this._bufferPool.dispose();
          this._textureBindings.clear();
          this._bufferBindings.clear();
          this._dirty = true;
        };
        this._onCanvasResize = () => {
          this._dirty = true;
        };
        if (typeof this._ctx.addEventListener === "function") {
          this._ctx.addEventListener(Context3D.DEVICE_LOST, this._onDeviceLost, this);
          this._ctx.addEventListener(CResizeEvent.RESIZE, this._onCanvasResize, this);
        }
      }
      get context() {
        return this._ctx;
      }
      get view() {
        return this._view;
      }
      get pool() {
        return this._pool;
      }
      get passes() {
        return this._passes;
      }
      /**
       * Construct a pass and queue it for the next `compile()`. The
       * factory passes ctor args through to `new Ctor(...args)`; the
       * pass's `setup()` is NOT run here — it runs at compile time so
       * `add()` call order is independent of resource-dependency order.
       *
       * Returns the constructed pass so callers can hold a reference if
       * needed — but the canonical way to reach a pass after add is
       * `graph.getPass<T>(name)`. Note that `pass.reads`/`writes`/
       * `creates` are empty arrays until the first `compile()` runs the
       * pass's setup.
       */
      add(Ctor, ...args) {
        const pass = new Ctor(...args);
        this._registerPending(pass);
        return pass;
      }
      /** Replace a pass by name. The replacement is queued for setup at
       *  the next `compile()` — same deferred-setup contract as `add()`.
       *  The old pass's `destroy()` is called immediately and any resource
       *  handles it owns are unregistered from the pool, but only if it
       *  had completed setup (otherwise it owns nothing yet). */
      replace(name, Ctor, ...args) {
        const idx = this._passes.findIndex((p) => p.name === name);
        if (idx < 0) throw new Error(`RenderGraph.replace: pass '${name}' not found.`);
        const prev = this._passes[idx];
        const prevMeta = prev[PASS_META];
        prev.destroy();
        if (prevMeta?.setupDone) {
          for (const n of prev.creates) this._releaseCreated(n);
        }
        const pass = new Ctor(...args);
        pass.reads = Object.freeze([]);
        pass.writes = Object.freeze([]);
        pass.creates = Object.freeze([]);
        pass[PASS_META] = {
          insertedOrder: prevMeta?.insertedOrder ?? this._insertCounter++,
          setupDone: false
        };
        this._passes.splice(idx, 1, pass);
        this._byName.delete(name);
        this._byName.set(pass.name, pass);
        this._dirty = true;
        return pass;
      }
      /** Remove a pass by name. Idempotent — returns `false` if `name`
       *  isn't registered (callers can use this for unconditional
       *  cleanup). On a hit: `pass.destroy()` runs, every name in
       *  `pass.creates` is dropped from the pool, and the pass is
       *  unlinked from the graph. The next `compile()` rebuilds without
       *  it, and `UnresolvedResourceError` surfaces for any consumer that
       *  still references the removed pass's outputs. */
      remove(name) {
        const idx = this._passes.findIndex((p) => p.name === name);
        if (idx < 0) return false;
        const pass = this._passes[idx];
        const meta = pass[PASS_META];
        pass.destroy();
        if (meta?.setupDone) {
          for (const n of pass.creates) this._releaseCreated(n);
        }
        this._passes.splice(idx, 1);
        this._byName.delete(name);
        this._dirty = true;
        return true;
      }
      /** Runtime kill switch. Disabled passes are treated as if they
       *  weren't in the graph: they don't participate in validation or
       *  topo sort, and they're skipped during execute. Disabling a
       *  producer whose output is read by another enabled pass will make
       *  the next `compile()` throw `UnresolvedResourceError`. Use this
       *  for temporary off switches you intend to flip back on; use
       *  {@link remove} for permanent removal. */
      disablePass(name) {
        const p = this._byName.get(name);
        if (!p) throw new Error(`RenderGraph.disablePass: pass '${name}' not found.`);
        if (p.enabled) {
          p.enabled = false;
          this._dirty = true;
        }
        return this;
      }
      enablePass(name) {
        const p = this._byName.get(name);
        if (!p) throw new Error(`RenderGraph.enablePass: pass '${name}' not found.`);
        if (!p.enabled) {
          p.enabled = true;
          this._dirty = true;
        }
        return this;
      }
      /** Look up a pass by name. */
      getPass(name) {
        return this._byName.get(name) ?? null;
      }
      /** Open a mutation batch. `compile()` short-circuits until the
       *  matching `endUpdate()` runs, so a sequence of `add` / `remove` /
       *  `replace` / `disablePass` / `enablePass` calls produces at most
       *  one validation + topo sort. Pairs are reentrant: nesting two
       *  `beginUpdate()` calls requires two `endUpdate()` calls to flush.
       *  Calling `execute()` mid-batch is allowed but will run against
       *  the last compiled order (i.e. ignores in-flight mutations);
       *  flush the batch before the next frame if you want the new
       *  structure to take effect. */
      beginUpdate() {
        this._batchDepth++;
        return this;
      }
      /** Close a mutation batch opened with {@link beginUpdate}. When the
       *  outermost batch closes, `compile()` runs if any mutation
       *  happened inside. */
      endUpdate() {
        if (this._batchDepth <= 0) {
          throw new Error("RenderGraph.endUpdate: no matching beginUpdate.");
        }
        this._batchDepth--;
        if (this._batchDepth === 0 && this._dirty) this.compile();
        return this;
      }
      /** Validate + topologically sort. Idempotent — short-circuits if
       *  no mutation since the last compile. Throws GraphCompileError
       *  subclasses on validation failure.
       *
       *  Disabled passes are filtered out before validation and topo sort
       *  — `disable === remove` from the validator's point of view. This
       *  means disabling a producer whose output is read by another
       *  enabled pass throws `UnresolvedResourceError` here, instead of
       *  silently leaving the consumer with stale/zero data at execute.
       *  Use `remove(name)` for permanent removal; use `disablePass(name)`
       *  + matching `disablePass` on every reader for a temporary off
       *  switch. */
      compile() {
        if (this._batchDepth > 0) return;
        if (!this._dirty && this._compiled) return;
        this._runPendingSetups();
        const activePasses = this._passes.filter((p) => p.enabled);
        const activeByName = /* @__PURE__ */ new Map();
        for (const p of activePasses) activeByName.set(p.name, p);
        const validator = new GraphValidator(activePasses);
        validator.validateSingleCreator();
        validator.validateResolvable();
        this._compiled = topoSort(activePasses, activeByName, this._insertedOrder.bind(this));
        this._lifetimes = LifetimeAnalyzer.analyze(
          this._compiled,
          activeByName,
          this._transient,
          this._ctx.presentationSize
        );
        const texAssign = this._texturePool.assign(this._lifetimes);
        const bufAssign = this._bufferPool.assign(this._lifetimes);
        this._textureBindings = texAssign.bindings;
        this._bufferBindings = bufAssign.bindings;
        const legacyMap = RTResourceMap.forContext(this._ctx);
        for (const [name, rt] of texAssign.bindings) {
          this._pool.register(name, () => rt, "texture");
          const decl = this._transient.get(name);
          const desc = decl?.desc;
          if (desc?.publishToLegacyMap) {
            legacyMap.rtTextureMap.set(name, rt);
          }
        }
        for (const [name, buf] of bufAssign.bindings) {
          this._pool.register(name, () => buf, "buffer");
        }
        this._lastUseByName.clear();
        for (const lt of this._lifetimes) {
          if (lt.persistent) continue;
          this._lastUseByName.set(lt.name, lt.lastUseIdx);
        }
        this._dirty = false;
        if (this._lifetimes.length > 0) {
          this._texturePool.stats();
        }
      }
      /** Run one frame. Lazy-compiles on first call (or after a
       *  mutation). Disabled passes are skipped. In dev mode each
       *  execute is wrapped in a `device.pushErrorScope('validation')`
       *  so the offending pass name shows up next to any WebGPU error. */
      execute(occlusion, frameIndex) {
        this.compile();
        const order = this._compiled;
        const pool = this._pool;
        const view = this._view;
        const graph = this;
        for (const rt of this._renderTargets.values()) {
          rt._firstWriterFiredThisFrame = false;
        }
        const ctx = {
          view,
          occlusion,
          graph,
          frameIndex,
          get(name) {
            return pool.get(name);
          },
          getTexture(name) {
            const n = resourceName(name);
            const kind = pool.kindOf(n);
            if (kind !== "texture" && kind !== "opaque") {
              throw new WrongResourceKindError("<ctx.getTexture>", n, "texture", kind ?? "unregistered");
            }
            return pool.get(n);
          },
          getBuffer(name) {
            const n = resourceName(name);
            const kind = pool.kindOf(n);
            if (kind !== "buffer" && kind !== "opaque") {
              throw new WrongResourceKindError("<ctx.getBuffer>", n, "buffer", kind ?? "unregistered");
            }
            return pool.get(n);
          },
          getRenderTarget(name) {
            const kind = pool.kindOf(name);
            if (kind !== "rendertarget") {
              throw new WrongResourceKindError("<ctx.getRenderTarget>", name, "rendertarget", kind ?? "unregistered");
            }
            return pool.get(name);
          },
          beginRenderPass(handle) {
            return handle.begin(this);
          },
          endRenderPass(handle) {
            handle.end(this);
          },
          beginComputePass(handle) {
            return handle.begin(this);
          },
          endComputePass(handle) {
            handle.end(this);
          }
        };
        const device = this._ctx.device;
        const devMode = this._ctx.engine?.setting.render.debug === true;
        if (devMode && device) device.pushErrorScope("validation");
        for (let i = 0; i < order.length; i++) {
          const name = order[i];
          const p = this._byName.get(name);
          if (!p.enabled) continue;
          this._currentPassIdx = i;
          p.execute(ctx);
        }
        this._currentPassIdx = -1;
        if (devMode && device) {
          void device.popErrorScope().then((err) => {
            if (err) {
              console.error(`[RenderGraph] validation error in frame ${frameIndex}: ${err.message}. Passes ran: ${order.join(" → ")}.`);
            }
          }).catch(() => {
          });
        }
      }
      /** Graphviz DOT representation of the compiled graph. Stable
       *  iteration order so snapshot tests can diff against a fixture.
       *  Edges go from the LAST writer of each resource to each reader;
       *  multiple mutators of the same resource appear as a chain.
       *  Explicit `dependencies` edges are rendered as dotted lines. */
      dumpDot() {
        this.compile();
        const lines = ["digraph RenderGraph {"];
        lines.push("  rankdir=LR;");
        lines.push("  node [shape=box, style=rounded];");
        for (const name of this._compiled) {
          lines.push(`  "${name}";`);
        }
        const writers = this._buildSortedWriters();
        for (const [name, ws] of writers) {
          for (let i = 1; i < ws.length; i++) {
            const prev = ws[i - 1];
            const curr = ws[i];
            if (prev !== curr) lines.push(`  "${prev}" -> "${curr}" [style=dashed, label="mutate(${name})"];`);
          }
        }
        for (const reader of this._compiled) {
          const p = this._byName.get(reader);
          for (const r of p.reads) {
            const ws = writers.get(r);
            if (!ws || ws.length === 0) continue;
            const last = ws[ws.length - 1];
            if (last !== reader) lines.push(`  "${last}" -> "${reader}" [label="${r}"];`);
          }
          if (p.dependencies) {
            for (const dep of p.dependencies) {
              if (!this._byName.has(dep)) continue;
              lines.push(`  "${dep}" -> "${reader}" [style=dotted, label="dependsOn"];`);
            }
          }
        }
        lines.push("}");
        return lines.join("\n");
      }
      /** Tear down all passes, the resource pool, and the device-lost
       *  listener. Called from RendererJob.destroy on engine dispose. */
      destroy() {
        if (typeof this._ctx.removeEventListener === "function") {
          this._ctx.removeEventListener(Context3D.DEVICE_LOST, this._onDeviceLost, this);
          this._ctx.removeEventListener(CResizeEvent.RESIZE, this._onCanvasResize, this);
        }
        for (const p of this._passes) p.destroy();
        for (const rt of this._renderTargets.values()) rt.destroy(this._ctx);
        this._renderTargets.clear();
        this._passes.length = 0;
        this._byName.clear();
        this._compiled = null;
        this._dirty = true;
        this._pool.dispose();
        this._transient.dispose();
        this._texturePool.dispose();
        this._bufferPool.dispose();
        this._textureBindings.clear();
        this._bufferBindings.clear();
      }
      /**
       * Snapshot of the transient pools' current allocations + HWM stats.
       * Use this to monitor whether lifetime-aliasing is actually saving
       * memory after migrating a pass to `b.declareTexture`. The numbers
       * are rough estimates (4 bpp fallback for unknown formats) — useful
       * for ratio comparisons, not absolute accounting.
       */
      transientStats() {
        return {
          texture: this._texturePool.stats(),
          buffer: this._bufferPool.stats(),
          lifetimes: this._lifetimes.length
        };
      }
      /**
       * @internal Test/debug accessor for the transient registry.
       */
      get transientRegistry() {
        return this._transient;
      }
      /**
       * Phase 6 storeOp='discard' helper. Returns `true` when the named
       * transient resource's last-use compile-order index equals the pass
       * currently in `execute()` — meaning a render pass writing to it
       * right now can drop the store (no later pass will read the
       * attachment, so the store is wasted bandwidth on tile-based GPUs).
       *
       * Returns `false` for any non-transient resource (no lifetime info)
       * or when called outside of `execute()`. The safe default
       * (return false → keep storeOp='store') means missing lifetime
       * info never accidentally discards live data — discards only fire
       * when the analyzer has definitively scoped a resource and the
       * pass position matches the last-use boundary.
       *
       * @internal
       */
      isLastUseInCurrentPass(name) {
        if (this._currentPassIdx < 0) return false;
        const lastIdx = this._lastUseByName.get(name);
        return lastIdx !== void 0 && lastIdx === this._currentPassIdx;
      }
      /**
       * Back-compat helper for `desc.publishToLegacyMap` resources that
       * need to be readable through `RTResourceMap.getTexture(name)` BEFORE
       * the first {@link compile} runs (e.g. transmission materials whose
       * constructors look up `_SceneColorPyramid` during scene setup).
       *
       * Allocates the dedicated pool slot eagerly (the wrapper identity
       * is stable because `aliasable:false` resources always go through
       * the per-name dedicated path), registers it in the graph pool,
       * and publishes the wrapper into the legacy map. The next compile
       * re-runs through {@link TransientTexturePool.assign} and returns
       * the same wrapper from `_dedicatedByName`, then re-publishes
       * (idempotent set).
       *
       * @internal
       */
      _eagerAllocateAndPublish(name, desc) {
        const [pw, ph] = this._ctx.presentationSize;
        const w = typeof desc.width === "number" ? desc.width : desc.width === "screen" ? pw : desc.width === "screen/2" ? Math.max(1, Math.floor(pw / 2)) : desc.width === "screen/4" ? Math.max(1, Math.floor(pw / 4)) : desc.width === "screen/8" ? Math.max(1, Math.floor(pw / 8)) : pw;
        const h = typeof desc.height === "number" ? desc.height : desc.height === "screen" ? ph : desc.height === "screen/2" ? Math.max(1, Math.floor(ph / 2)) : desc.height === "screen/4" ? Math.max(1, Math.floor(ph / 4)) : desc.height === "screen/8" ? Math.max(1, Math.floor(ph / 8)) : ph;
        const usage = typeof desc.usage === "number" ? desc.usage : GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.RENDER_ATTACHMENT | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST;
        const lt = {
          name,
          kind: "texture",
          desc,
          firstUseIdx: 0,
          lastUseIdx: 0,
          resolvedUsage: usage,
          resolvedWidth: w,
          resolvedHeight: h,
          persistent: false
        };
        const single = this._texturePool.assign([lt]);
        const rt = single.bindings.get(name);
        if (!rt) {
          return;
        }
        this._pool.register(name, () => rt, "texture");
        const legacyMap = RTResourceMap.forContext(this._ctx);
        legacyMap.rtTextureMap.set(name, rt);
      }
      /**
       * Push a freshly-constructed pass into the queue. Stamps insertion
       * order and an empty per-pass meta so `_insertedOrder` returns a
       * stable value even before the pass's setup runs. The actual
       * `pass.setup(builder)` is deferred to the next `compile()` via
       * {@link _runPendingSetups}.
       *
       * Duplicate pass names are tolerated here — the validator surfaces
       * `'duplicate pass name'` at compile time so the error path lines
       * up with every other compile-time check.
       */
      _registerPending(pass) {
        pass.reads = Object.freeze([]);
        pass.writes = Object.freeze([]);
        pass.creates = Object.freeze([]);
        pass[PASS_META] = {
          insertedOrder: this._insertCounter++,
          setupDone: false
        };
        this._passes.push(pass);
        this._byName.set(pass.name, pass);
        this._dirty = true;
      }
      /**
       * Run `setup()` for every pass added but not yet committed. The
       * loop iterates rounds in insertion order; a pass whose setup
       * throws {@link _PendingSetupError} (forward-referenced resource
       * or dependsOn target) is deferred to a later round. A round
       * that makes zero progress proves the missing names are genuinely
       * unresolvable — re-surface the first culprit as
       * {@link UnresolvedResourceError} for an actionable message.
       */
      _runPendingSetups() {
        const all = this._passes.filter((p) => !p[PASS_META].setupDone);
        if (all.length === 0) return;
        let remaining = all.slice();
        let lastError = null;
        const maxRounds = all.length * 2 + 2;
        let round = 0;
        while (remaining.length > 0) {
          if (++round > maxRounds) {
            throw new Error(
              `RenderGraph.compile: pending setups did not converge after ${round} rounds. Remaining: ${remaining.map((p) => p.name).join(", ")}.`
            );
          }
          const stillPending = [];
          let progress = false;
          for (const pass of remaining) {
            let draft;
            try {
              draft = this._runSetupTransactional(pass);
            } catch (e) {
              if (e instanceof _PendingSetupError) {
                stillPending.push(pass);
                lastError = { pass, error: e };
                continue;
              }
              throw e;
            }
            this._commitDraft(pass, draft);
            pass[PASS_META].setupDone = true;
            progress = true;
          }
          if (!progress) {
            const { pass, error } = lastError;
            throw new UnresolvedResourceError(pass.name, error.resourceName);
          }
          remaining = stillPending;
        }
      }
      /**
       * Single transactional attempt of `pass.setup(builder)`. Builder
       * mutations accumulate into a fresh {@link _SetupDraft} instead of
       * directly mutating `_pool` / `_renderTargets` / `_transient`. The
       * caller commits the draft via {@link _commitDraft} when setup
       * returns without throwing; on `_PendingSetupError` the draft is
       * dropped and the pass is retried after a sibling commit publishes
       * the missing name.
       *
       * The builder's visibility checks consult both the committed graph
       * state AND the in-flight draft so self-references within a single
       * setup (e.g. `b.declareTexture` followed by `b.write(handle)`) are
       * resolved against names declared earlier in the same call.
       */
      _runSetupTransactional(pass) {
        const draft = new _SetupDraft(pass.dependencies);
        const ctx = this._ctx;
        const hasName = (n) => this._pool.has(n) || draft.poolEntries.has(n);
        const kindOfName = (n) => {
          const e = draft.poolEntries.get(n);
          if (e) return e.kind;
          return this._pool.kindOf(n);
        };
        const getRT = (n) => {
          const r = draft.rtEntries.get(n);
          if (r) return r;
          if (this._pool.kindOf(n) === "rendertarget") {
            return this._pool.get(n);
          }
          return null;
        };
        const isTransientDeclared = (n) => this._transient.has(n) || draft.transientKinds.has(n);
        const transientKindOf = (n) => {
          const k = draft.transientKinds.get(n);
          if (k) return k;
          return this._transient.get(n)?.kind;
        };
        const placeholderGetter = (name) => () => {
          throw new Error(
            `RenderGraph: transient resource '${name}' has not been materialized yet — it can only be resolved via ctx.getTexture/getBuffer(name) inside execute(), not via pool.get during setup.`
          );
        };
        const recordHintIfTransient = (name, mode, access) => {
          const kind = transientKindOf(name);
          if (!kind) return;
          const hint = access ?? (mode === "read" ? "sample" : "storage");
          draft.hintOps.push(() => this._transient.recordAccessHint(name, kind, hint, mode));
        };
        const registerRT = (n, rt) => {
          draft.poolEntries.set(n, { getter: () => rt, kind: "rendertarget", persistent: false });
          draft.rtEntries.set(n, rt);
          draft.writes.push(n);
          draft.creates.push(n);
          draft.rtWriterPushes.push({ rt, passName: pass.name });
          return rt;
        };
        const builder = {
          context3D: ctx,
          view: this._view,
          graph: this,
          read: (target, access) => {
            const n = resourceName(target);
            if (!hasName(n)) throw new _PendingSetupError(n);
            draft.reads.push(n);
            recordHintIfTransient(n, "read", access);
          },
          write: (target, getterOrAccess) => {
            if (typeof getterOrAccess === "function") {
              const n2 = resourceName(target);
              const getter = getterOrAccess;
              draft.writes.push(n2);
              draft.creates.push(n2);
              draft.poolEntries.set(n2, {
                getter,
                kind: "opaque",
                persistent: false
              });
              return getter();
            }
            const n = resourceName(target);
            if (!hasName(n)) throw new _PendingSetupError(n);
            draft.writes.push(n);
            recordHintIfTransient(n, "write", getterOrAccess);
            return void 0;
          },
          readWrite: (target, access) => {
            const n = resourceName(target);
            if (!hasName(n)) throw new _PendingSetupError(n);
            draft.reads.push(n);
            draft.writes.push(n);
            recordHintIfTransient(n, "read", access);
            recordHintIfTransient(n, "write", access);
          },
          declareTexture: (n, desc) => {
            if (isTransientDeclared(n)) {
              throw new Error(
                `RenderGraph.transient: resource '${n}' already declared — pass '${pass.name}' must use a different name.`
              );
            }
            draft.transientKinds.set(n, "texture");
            draft.transientOps.push(() => this._transient.declareTexture(n, desc, pass.name));
            draft.creates.push(n);
            draft.poolEntries.set(n, { getter: placeholderGetter(n), kind: "texture", persistent: false });
            if (desc.publishToLegacyMap && desc.aliasable === false) {
              draft.eagerPublishes.push({ name: n, desc });
            }
            return makeTextureHandle(n);
          },
          declareBuffer: (n, desc) => {
            if (isTransientDeclared(n)) {
              throw new Error(
                `RenderGraph.transient: resource '${n}' already declared — pass '${pass.name}' must use a different name.`
              );
            }
            draft.transientKinds.set(n, "buffer");
            draft.transientOps.push(() => this._transient.declareBuffer(n, desc, pass.name));
            draft.poolEntries.set(n, { getter: placeholderGetter(n), kind: "buffer", persistent: false });
            draft.creates.push(n);
            return makeBufferHandle(n);
          },
          importExternalTexture: (n, tex) => {
            if (isTransientDeclared(n)) {
              throw new Error(
                `RenderGraph.transient: resource '${n}' already declared — pass '${pass.name}' must use a different name.`
              );
            }
            draft.transientKinds.set(n, "texture");
            draft.transientOps.push(() => this._transient.importExternalTexture(n, tex, pass.name));
            draft.poolEntries.set(n, { getter: () => tex, kind: "texture", persistent: true });
            draft.writes.push(n);
            draft.creates.push(n);
            return makeTextureHandle(n);
          },
          importExternalBuffer: (n, buf) => {
            if (isTransientDeclared(n)) {
              throw new Error(
                `RenderGraph.transient: resource '${n}' already declared — pass '${pass.name}' must use a different name.`
              );
            }
            draft.transientKinds.set(n, "buffer");
            draft.transientOps.push(() => this._transient.importExternalBuffer(n, buf, pass.name));
            draft.poolEntries.set(n, { getter: () => buf, kind: "buffer", persistent: true });
            draft.writes.push(n);
            draft.creates.push(n);
            return makeBufferHandle(n);
          },
          dependsOn: (passName) => {
            if (!this._byName.has(passName)) {
              throw new Error(
                `RenderGraph: pass '${pass.name}' calls b.dependsOn('${passName}') but no pass named '${passName}' is registered. Add the upstream pass to the graph before calling compile().`
              );
            }
            draft.deps.add(passName);
          },
          dependsOnIfPresent: (passName) => {
            if (this._byName.has(passName)) draft.deps.add(passName);
          },
          createRenderTarget: (n, desc) => {
            return registerRT(n, RenderGraphRenderTarget.allocate(n, ctx, desc));
          },
          adoptRenderTarget: (n, rtFrame, opts) => {
            return registerRT(n, RenderGraphRenderTarget.fromRTFrame(n, rtFrame, opts));
          },
          useRenderTarget: (n) => {
            if (!hasName(n)) throw new _PendingSetupError(n);
            const kind = kindOfName(n);
            if (kind !== "rendertarget") {
              throw new WrongResourceKindError(pass.name, n, "rendertarget", kind ?? "unregistered");
            }
            const rt = getRT(n);
            draft.writes.push(n);
            draft.rtWriterPushes.push({ rt, passName: pass.name });
            return rt;
          },
          borrowRenderTarget: (n) => {
            if (!hasName(n)) throw new _PendingSetupError(n);
            const kind = kindOfName(n);
            if (kind !== "rendertarget") {
              throw new WrongResourceKindError(pass.name, n, "rendertarget", kind ?? "unregistered");
            }
            const rt = getRT(n);
            draft.rtWriterPushes.push({ rt, passName: pass.name });
            return rt;
          },
          createRenderPass: (name, target, desc, openOptions) => {
            return new RenderGraphRenderPass(name, target, desc, openOptions);
          },
          createComputePass: (name, desc) => {
            return new RenderGraphComputePass(name, desc);
          }
        };
        pass.setup(builder);
        return draft;
      }
      /**
       * Apply a successful draft to real graph state. Pool registrations
       * land first so subsequent passes' setup can resolve names through
       * `_pool.has`. Transient declarations + access hints + writer-push
       * tooling and the publishToLegacyMap eager allocations run after.
       * The pass's frozen `reads` / `writes` / `creates` arrays and
       * `dependencies` set are finalized last.
       */
      _commitDraft(pass, draft) {
        for (const [name, e] of draft.poolEntries) {
          this._pool.register(name, e.getter, e.kind);
          if (e.persistent) this._pool.markPersistent(name);
        }
        for (const [name, rt] of draft.rtEntries) {
          this._renderTargets.set(name, rt);
        }
        for (const op of draft.transientOps) op();
        for (const e of draft.rtWriterPushes) {
          e.rt._writers.push(e.passName);
        }
        for (const op of draft.hintOps) op();
        for (const e of draft.eagerPublishes) {
          this._eagerAllocateAndPublish(e.name, e.desc);
        }
        pass.reads = Object.freeze(draft.reads.slice());
        pass.writes = Object.freeze(draft.writes.slice());
        pass.creates = Object.freeze(draft.creates.slice());
        if (draft.deps.size > 0) {
          pass.dependencies = draft.deps;
        }
      }
      _insertedOrder(p) {
        return p[PASS_META]?.insertedOrder ?? -1;
      }
      /** Drop a name from the pool. If the entry is a typed
       *  {@link RenderGraphRenderTarget} also call its `destroy` hook
       *  and remove it from the per-frame reset map. Transient
       *  declarations are unregistered from the registry so the
       *  single-creator check stays clean for any subsequent re-add. */
      _releaseCreated(name) {
        if (this._pool.kindOf(name) === "rendertarget") {
          const rt = this._renderTargets.get(name);
          if (rt) {
            rt.destroy(this._ctx);
            this._renderTargets.delete(name);
          }
        }
        this._pool.unregister(name);
        this._transient.unregister(name);
        this._textureBindings.delete(name);
        this._bufferBindings.delete(name);
      }
      /** name → writers sorted by insertion order. Used by `dumpDot`
       *  to render the writer chain for each resource. */
      _buildSortedWriters() {
        const writers = /* @__PURE__ */ new Map();
        for (const p of this._passes) {
          for (const w of p.writes) {
            if (!writers.has(w)) writers.set(w, []);
            writers.get(w).push(p.name);
          }
        }
        for (const [, list] of writers) {
          list.sort((a, b) => this._insertedOrder(this._byName.get(a)) - this._insertedOrder(this._byName.get(b)));
        }
        return writers;
      }
    }

    class RendererJob {
      graph;
      occlusionSystem;
      pauseRender = false;
      pickFire;
      renderState = false;
      _view;
      _frameIndex = 0;
      constructor(view) {
        this._view = view;
        this.occlusionSystem = new OcclusionSystem(view);
        this.graph = new RenderGraph(view);
      }
      get view() {
        return this._view;
      }
      set view(view) {
        this._view = view;
      }
      start() {
        this.renderState = true;
        if (this._view.engine3D.setting.render.debug) this.debug();
        this.graph.compile();
      }
      stop() {
      }
      pause() {
        this.pauseRender = true;
      }
      resume() {
        this.pauseRender = false;
      }
      debug() {
      }
      /** Drive one frame through the graph. Pre-graph bookkeeping that
       *  sits outside any pass (camera, light / reflection entries,
       *  occlusion snapshot) runs inline; everything else is owned by
       *  passes registered into `this.graph`. */
      renderFrame() {
        const view = this._view;
        Camera3D.mainCamera = view.camera;
        ProfilerUtil.startView(view);
        GlobalBindGroup.getLightEntries(view.scene).update(view);
        GlobalBindGroup.getReflectionEntries(view.scene).update(view);
        this.occlusionSystem.update(view.camera, view.scene);
        this.graph.execute(this.occlusionSystem, this._frameIndex++);
      }
      /** Attach a post-processing effect. Routes into the graph's
       *  PostPass; if no PostPass is in the graph (e.g. a custom job
       *  without a post chain), this is a no-op. */
      addPost(post) {
        const postPass = this.graph.getPass("PostPass");
        postPass?.attachPost(this._view, post);
        return post;
      }
      removePost(post) {
        const postPass = this.graph.getPass("PostPass");
        if (!postPass) return;
        if (Array.isArray(post)) {
          for (const p of post) postPass.detachPost(this._view, p);
        } else {
          postPass.detachPost(this._view, post);
        }
      }
      destroy(_force) {
        this.graph.destroy();
      }
    }

    class ForwardRendererJob extends RendererJob {
      constructor(view) {
        super(view);
        const setting = view.engine3D.setting;
        const giEnabled = !!setting.gi.enable;
        const useOIT = !!setting.render.useOIT;
        const useGPUCull = !!setting.render.gpuCull;
        const useDecals = !!setting.render.decals;
        this.graph.add(ClusterLightingPass);
        if (setting.render.zPrePass) {
          this.graph.add(PreDepthPass);
        }
        this.graph.add(HiZPass);
        this.graph.add(MotionVectorPass);
        if (useGPUCull) {
          this.graph.add(GPUCullPass);
        }
        this.graph.add(ShadowPass);
        this.graph.add(PointShadowPass);
        this.graph.add(ReflectionPass);
        if (giEnabled) {
          this.graph.add(GIPass);
        }
        this.graph.add(SceneCapturePass);
        this.graph.add(GBufferResourcePass);
        this.graph.add(ColorPass, { giEnabled });
        this.graph.add(SkyPass);
        this.graph.add(SceneColorPyramidPass);
        this.graph.add(TransmissionOpaquePass);
        if (useDecals) {
          this.graph.add(DecalShadowVolumePass);
        }
        this.graph.add(SortedTransparentPass, useOIT ? "sorted" : "all");
        if (useOIT) {
          this.graph.add(TransparentOITPass);
          this.graph.add(TransparentDualDepthPeelingPass);
          this.graph.add(TransparentResolvePass);
          this.graph.add(TransparentDualDepthPeelingResolvePass);
        }
        this.graph.add(PostPass);
        this.graph.add(GUIPass);
      }
    }

    class StringUtil {
      static _filterChar = [" ", "  ", ";", "\n", "\r", "	", "\n", "\r", "	"];
      /**
       *
       * Does the string exist
       * @param fields List of detected string
       * @param str source string
       * @returns Return the index position where it is located. If it does not exist, return -1
       */
      static hasString(fields, str) {
        for (var i = 0; i < fields.length; ++i) {
          if (fields[i] == str) {
            return i;
          }
        }
        return -1;
      }
      /**
       * Gets an ellipsis terminated string representation that exceeds the range
       * @param str source string
       * @param len range of string
       * @returns result string
       */
      static getEllipsis(str, len = 4) {
        let name = str;
        if (name.length > len) name = name.slice(0, len) + "...";
        return name;
      }
      /**
       * get name based on URL
       * @param url source url
       * @returns name
       */
      static getURLName(url) {
        var urlArray;
        urlArray = url.split("/");
        let name = urlArray[urlArray.length - 1];
        name = name.split(".")[0];
        return name;
      }
      /**
       * get suffix of file name from url
       * @param url source url
       * @returns suffix
       */
      static getFileFormat(url) {
        var startPos = url.lastIndexOf(".");
        startPos++;
        var endPos = url.length;
        if (url.indexOf("?", startPos) !== -1) {
          endPos = url.indexOf("?", startPos);
        }
        var fileFormat = url.substr(startPos, endPos - startPos);
        fileFormat = fileFormat.toLowerCase();
        return fileFormat;
      }
      /**
       * get information stored in a string
       * @param line source string
       * @param data result data reference
       */
      static readLineProperty(line, data) {
        line.trim().split(" ").forEach((v, i) => {
          let strArr = v.split("=");
          if (strArr.length > 1) {
            let key = strArr[0];
            let value = strArr[1];
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              if (value.indexOf('"') == -1) {
                data[key] = parseFloat(strArr[1]);
              } else {
                data[key] = value.replace('"', "").replace('"', "");
              }
            }
          }
        });
      }
      static getPath(url) {
        var s_pos = url.lastIndexOf("/");
        s_pos++;
        return url.substring(0, s_pos);
      }
      static normalizePath(url) {
        var tmp = url.replaceAll(`//`, `/`);
        tmp = tmp.replaceAll(`\\`, `/`);
        return tmp;
      }
      // public static ab2str(byte: ByteArray, block:number = 65535):string {
      //   //  return String.fromCharCode.apply(null, new Uint8Array(buf));
      //     var str: string = "";
      //     var oldPos: number = byte.position;
      //     var length: number = block;
      //     while (byte.position < byte.length) {
      //         length = block;
      //         if (byte.length - byte.position < length) {
      //             length = byte.length - byte.position;
      //         }
      //         str += byte.readUTFBytes(length);
      //     }
      //     byte.position = oldPos;
      //     return str;
      // }
      // public static str2ab(str: string):ByteArray {
      //     var byte: ByteArray = new ByteArray();
      //     byte.writeUTFBytes(str);
      //     return byte;
      // }
      /**
       * Used to cut specified characters
       * @param str source string
       * @param char cut string
       * @returns result string array
       */
      static getStringList(str, char = ";") {
        return str.split(char);
      }
      /**
       * Format timestamp data
       * @param time timestamp
       * @returns
       */
      static formatTime(time) {
        let t = time / 1e3;
        let temp = t / 60;
        let m = Math.floor(temp);
        let s = Math.floor(temp - m);
        return [m.toString(), s.toString()];
      }
      /**
       * trim
       * @param str source string
       * @returns result string
       */
      static trim(str) {
        return str.replace(/^\s+/g, "").replace(/\s+$/g, "");
      }
      /**
       * Determine if the string is empty, null, '' or 'null'
       * @param value source string
       * @returns boolean
       */
      static isEmpty(value) {
        return !value || typeof value == "undefined" || value == null || typeof value === "string" && this.trim(value) === "" || value === "null";
      }
      /**
       * Handle strings that exceed the length range, such as adding strings that exceed the range
       * @param str source string
       * @param len length
       * @returns result string
       */
      static strCut(str, len) {
        if (str.length * 2 <= len) {
          return str;
        }
        var strlen = 0;
        var s = "";
        for (var i = 0; i < str.length; i++) {
          s = s + str.charAt(i);
          if (str.charCodeAt(i) > 128) {
            strlen = strlen + 2;
            if (strlen >= len) {
              return s.substring(0, s.length - 1) + "...";
            }
          } else {
            strlen = strlen + 1;
            if (strlen >= len) {
              return s.substring(0, s.length - 2) + "...";
            }
          }
        }
        return s;
      }
      /**
       * According to the splicing request parameters
       * @param key key string
       * @param value value string
       * @param isEncodeURI isEncodeURI
       * @returns result string
       */
      static toQueryPair(key, value, isEncodeURI = false) {
        return key + "=" + (isEncodeURI ? encodeURIComponent(value) : value);
      }
      /**
       * format a string
       * @param str source string
       * @param params Pass in a regular processing parameter array
       * @returns result string
       */
      static stringFormat(str, ...params) {
        if (arguments.length === 0) throw new Error("please give arg at least one !");
        if (arguments.length === 2 && typeof arguments[1] === "object") {
          for (let key in arguments[1]) {
            let reg = new RegExp("({" + key + "})", "g");
            str = str.replace(reg, arguments[1][key]);
          }
        } else {
          for (let i = 0; i < params.length; i++) {
            if (params[i] == void 0) {
              return str;
            } else {
              let reg = new RegExp("({[" + i + "]})", "g");
              str = str.replace(reg, params[i]);
            }
          }
        }
        return str;
      }
      /**
       * Convert JSON objects to strings
       * @param json object of json
       * @param options
       * @returns result string
       */
      static parseJson2String(json, options) {
        let reg = null, formatted = "", pad = 0, PADDING = "    ";
        options = options || {};
        options.newlineAfterColonIfBeforeBraceOrBracket = options.newlineAfterColonIfBeforeBraceOrBracket === true ? true : false;
        options.spaceAfterColon = options.spaceAfterColon === false ? false : true;
        if (typeof json !== "string") {
          json = JSON.stringify(json);
        } else {
          json = JSON.parse(json);
          json = JSON.stringify(json);
        }
        reg = /([\{\}])/g;
        json = json.replace(reg, "\r\n$1\r\n");
        reg = /([\[\]])/g;
        json = json.replace(reg, "\r\n$1\r\n");
        reg = /(\,)/g;
        json = json.replace(reg, "$1\r\n");
        reg = /(\r\n\r\n)/g;
        json = json.replace(reg, "\r\n");
        reg = /\r\n\,/g;
        json = json.replace(reg, ",");
        if (!options.newlineAfterColonIfBeforeBraceOrBracket) {
          reg = /\:\r\n\{/g;
          json = json.replace(reg, ":{");
          reg = /\:\r\n\[/g;
          json = json.replace(reg, ":[");
        }
        if (options.spaceAfterColon) {
          reg = /\:/g;
          json = json.replace(reg, ":");
        }
        json.split("\r\n").forEach(function(node, index) {
          let i = 0, indent = 0, padding = "";
          if (node.match(/\{$/) || node.match(/\[$/)) {
            indent = 1;
          } else if (node.match(/\}/) || node.match(/\]/)) {
            if (pad !== 0) {
              pad -= 1;
            }
          } else {
            indent = 0;
          }
          for (i = 0; i < pad; i++) {
            padding += PADDING;
          }
          formatted += padding + node + "\r\n";
          pad += indent;
        });
        return formatted;
      }
      /**
       * Compatibility mode - version comparison
       * @param v1 Version 1
       * @param v2 Version 2
       * @returns Returns 1, -1, or 0, indicating that the version number is greater, less, or equal, respectively
       */
      static compareVersion(v1, v2) {
        v1 = v1.split(".");
        v2 = v2.split(".");
        let len = Math.max(v1.length, v2.length);
        while (v1.length < len) {
          v1.push("0");
        }
        while (v2.length < len) {
          v2.push("0");
        }
        for (let i = 0; i < len; i++) {
          let num1 = parseInt(v1[i]);
          let num2 = parseInt(v2[i]);
          if (num1 > num2) {
            return 1;
          } else if (num1 < num2) {
            return -1;
          }
        }
        return 0;
      }
      /**
       * Generate non repeating random string codes
       * @returns result
       */
      static buildRandomCode() {
        let words = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let len = words.length;
        let str = "";
        for (let i = 0; i < 26; i++) {
          let rand = Math.floor(Math.random() * len);
          str += words.charAt(rand);
        }
        let millisecond = (/* @__PURE__ */ new Date()).getTime();
        return `${millisecond}-${str}`;
      }
      /**
       * UUID
       * @returns UUID
       */
      static UUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
          return v.toString(16);
        });
      }
      /**
       * make hash code
       * @param str source value
       * @returns hash code
       */
      static stringToHash(str) {
        let hash = 0;
        if (str.length == 0) return hash;
        for (let i = 0; i < str.length; i++) {
          const char = str.charCodeAt(i);
          hash = (hash << 5) - hash + char;
          hash = hash & hash;
        }
        return hash;
      }
      /**
       * Convert GLTF URL Address
       * @param base baseURL
       * @param url source url
       * @returns result url
       */
      static parseUrl(base, url) {
        return url.match(/^(blob|http|https):/) ? url : base + url;
      }
      // public static readLineProperty(line:string){
      //     fnt.trim().split('\r\n').forEach((v,i)=>{
      //         if(i<2){
      //             FntParser.readLineProperty(v,fontData);
      //         }else{
      //             if(i<fontData.pages+2){
      //                 let page = new FontPage();
      //                 FntParser.readLineProperty(v,page);
      //                 fontData.fontPage.push(page);
      //             }else if(i<fontData.pages+3){
      //                 FntParser.readLineProperty(v,fontData);
      //             }else{
      //                 if(fontData.count>0){
      //                     let char = new FontChar();
      //                     FntParser.readLineProperty(v,char);
      //                     fontData.fontChar[char.id] = char ;
      //                     fontData.count--;
      //                 }
      //             }
      //         }
      //     })
      // }
    }

    class BitmapTexture2D extends Texture {
      _source;
      premultiplyAlpha = "none";
      /**
       * Color-space contract for the underlying bytes. `'srgb'` →
       * `rgba8unorm-srgb` format (hardware decode on sample);
       * `'linear'` → `rgba8unorm` (raw, no conversion). Default
       * `'linear'` preserves legacy behavior — migrate sRGB-encoded
       * color textures by passing `'srgb'` at the call site.
       */
      colorSpace;
      /**
       * @constructor
       * @param useMipmap Set whether to use mipmap
       * @param ctx Optional Context3D — binds the texture to this engine's device
       *            so GPU materialization has a target. Required whenever the caller
       *            already knows which engine owns the texture (loaders, Res, GLTF).
       * @param colorSpace `'srgb'` to enable hardware sRGB decode (use for
       *            baseColor / emissive textures), `'linear'` (default) for
       *            normal / mask / metallic-roughness / AO / height data.
       */
      constructor(useMipmap = true, ctx, colorSpace = "linear") {
        super();
        this.useMipmap = useMipmap;
        this.colorSpace = colorSpace;
        this.lodMinClamp = 0;
        this.lodMaxClamp = 4;
        if (ctx) bindCtx(this, ctx);
      }
      /** GPU texture format derived from `colorSpace`. `'srgb'` →
       *  `rgba8unorm-srgb`, `'linear'` → `rgba8unorm`. */
      get _ldrFormat() {
        return this.colorSpace === "srgb" ? GPUTextureFormat.rgba8unorm_srgb : GPUTextureFormat.rgba8unorm;
      }
      /**
       * get raw data of this texture
       */
      get source() {
        return this._source;
      }
      /**
       * set raw data of this texture
       */
      set source(value) {
        this._source = value;
        if (!this.format) {
          this.format = this._ldrFormat;
        }
        if (this._source instanceof HTMLImageElement) {
          this._source.decode().then(async () => {
            if (this._source instanceof HTMLImageElement) {
              const imageBitmap = await createImageBitmap(this._source, { imageOrientation: this.flipY ? "flipY" : "from-image", premultiplyAlpha: "none" });
              this.generate(imageBitmap);
            }
          });
        } else {
          if (this._source instanceof HTMLCanvasElement || this._source instanceof ImageBitmap) {
            this.generate(this._source);
          }
        }
      }
      /**
       * load texture data from web url
       * @param url web url
       * @param loaderFunctions callback function when load complete
       */
      async load(url, loaderFunctions) {
        if (url && !/^[a-z][a-z0-9+.-]*:/i.test(url) && !url.startsWith("/") && typeof location !== "undefined") {
          url = "/" + url;
        }
        this.name = StringUtil.getURLName(url);
        if (url.indexOf(";base64") != -1) {
          const img = document.createElement("img");
          let start = url.indexOf("data:image");
          let uri = url.substring(start, url.length);
          img.src = uri;
          await img.decode();
          img.width = Math.max(img.width, 32);
          img.height = Math.max(img.height, 32);
          const imageBitmap = await createImageBitmap(img, {
            resizeWidth: img.width,
            resizeHeight: img.height,
            imageOrientation: this.flipY ? "flipY" : "from-image",
            premultiplyAlpha: "none"
          });
          this.format = this._ldrFormat;
          this.generate(imageBitmap);
        } else {
          return new Promise((succ, fial) => {
            fetch(url, {
              headers: Object.assign({
                "Accept": "image/avif,image/webp,*/*"
              }, loaderFunctions?.headers)
            }).then((r) => {
              LoaderBase.read(url, r, loaderFunctions).then((chunks) => {
                let img = new Blob([chunks], { type: "image/jpeg" });
                chunks = null;
                this.loadFromBlob(img).then(() => {
                  succ(true);
                });
              });
            });
          });
        }
        return true;
      }
      imageData;
      /**
      * load data from Blob
      * @param imgData blob data which contains image
      */
      async loadFromBlob(imgData) {
        this.imageData = imgData;
        let imageBitmap = await createImageBitmap(imgData, { imageOrientation: this.flipY ? "flipY" : "from-image", premultiplyAlpha: "none" });
        if (imageBitmap.width < 32 || imageBitmap.height < 32) {
          let width = Math.max(imageBitmap.width, 32);
          let height = Math.max(imageBitmap.height, 32);
          imageBitmap = await createImageBitmap(imageBitmap, {
            resizeWidth: width,
            resizeHeight: height,
            imageOrientation: this.flipY ? "flipY" : "from-image",
            premultiplyAlpha: "none"
          });
        }
        this.format = this._ldrFormat;
        this.generate(imageBitmap);
        return true;
      }
    }

    function _normalizeAssetUrl(url) {
      if (!url) return url;
      if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return url;
      if (url.startsWith("/")) return url;
      if (typeof location === "undefined") return url;
      return "/" + url;
    }
    class LoaderBase {
      baseUrl = "";
      initUrl;
      ctx;
      _progress = 0;
      constructor(ctx) {
        this.ctx = ctx;
      }
      /**
       * @private
       */
      async loadBinData(url, loaderFunctions) {
        url = _normalizeAssetUrl(url);
        this.baseUrl = StringUtil.getPath(url);
        this.initUrl = url;
        return new Promise(async (succ, fail) => {
          fetch(url, { headers: loaderFunctions?.headers }).then(async (response) => {
            if (response.ok) {
              let chunks = await LoaderBase.read(url, response, loaderFunctions);
              let buffer = chunks.buffer;
              chunks = null;
              succ(buffer);
            } else {
              throw Error("request rejected with status " + response.status);
            }
          }).catch((e) => {
            if (loaderFunctions?.onError) {
              loaderFunctions.onError(e);
            }
            fail(e);
          });
        });
      }
      /**
       *
       * @private
       */
      async loadAsyncBitmapTexture(url, loaderFunctions) {
        url = _normalizeAssetUrl(url);
        this.baseUrl = StringUtil.getPath(url);
        this.initUrl = url;
        let bitmapTexture = new BitmapTexture2D(true, this.ctx);
        bitmapTexture.url = url;
        bitmapTexture.name = StringUtil.getURLName(url);
        await bitmapTexture.load(url, loaderFunctions);
        Engine3D.resFor(this.ctx).addTexture(url, bitmapTexture);
        return bitmapTexture;
      }
      /**
       *
       * @private
       */
      async loadJson(url, loaderFunctions) {
        url = _normalizeAssetUrl(url);
        this.baseUrl = StringUtil.getPath(url);
        this.initUrl = url;
        return new Promise(async (succ, fail) => {
          fetch(url, { headers: loaderFunctions?.headers }).then(async (response) => {
            if (response.ok) {
              let chunks = await LoaderBase.read(url, response, loaderFunctions);
              let utf8decoder = new TextDecoder("utf-8");
              const jsonString = utf8decoder.decode(chunks);
              chunks = null;
              succ(JSON.parse(jsonString));
            } else {
              throw Error("request rejected with status" + response.status);
            }
          }).catch((e) => {
            if (loaderFunctions?.onError) {
              loaderFunctions.onError(e);
            }
            fail(e);
          });
        });
      }
      /**
       * @private
       */
      async loadTxt(url, loaderFunctions) {
        url = _normalizeAssetUrl(url);
        this.baseUrl = StringUtil.getPath(url);
        return new Promise(async (succ, fail) => {
          fetch(url).then(async (response) => {
            if (response.ok) {
              let chunks = await LoaderBase.read(url, response, loaderFunctions);
              let utf8decoder = new TextDecoder("utf-8");
              const textString = utf8decoder.decode(chunks);
              chunks = null;
              succ({ data: textString });
            } else {
              throw Error("request rejected with status" + response.status);
            }
          }).catch((e) => {
            if (loaderFunctions?.onError) {
              loaderFunctions.onError(e);
            }
            fail(e);
          });
        });
      }
      /**
       * @private
       */
      static async read(url, response, loaderFunctions) {
        const reader = response.body.getReader();
        const contentLength = +response.headers.get("Content-Length");
        let receivedLength = 0;
        let chunks = [];
        let receivedArr = [];
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            if (contentLength > 0) {
              if (loaderFunctions && loaderFunctions.onComplete) {
                loaderFunctions.onComplete.call(this, url);
              }
            }
            break;
          }
          chunks.push(value);
          receivedLength += value.length;
          if (contentLength > 0) {
            if (loaderFunctions && loaderFunctions.onProgress) {
              loaderFunctions.onProgress.call(this, receivedLength, contentLength, url);
            }
          } else {
            receivedArr.push(value.length);
          }
        }
        if (receivedArr.length > 0) {
          for (let i = 0; i < chunks.length; i++) {
            if (loaderFunctions && loaderFunctions.onProgress) {
              loaderFunctions.onProgress.call(this, receivedArr[i], receivedLength, url);
            }
            if (receivedArr[i] == receivedLength) {
              if (loaderFunctions && loaderFunctions.onComplete) {
                loaderFunctions.onComplete.call(this, url);
              }
            }
          }
        }
        let chunksAll = new Uint8Array(receivedLength);
        let position = 0;
        for (let chunk of chunks) {
          chunksAll.set(chunk, position);
          position += chunk.length;
        }
        return chunksAll;
      }
    }

    var ParserFormat = /* @__PURE__ */ ((ParserFormat2) => {
      ParserFormat2[ParserFormat2["TEXT"] = 0] = "TEXT";
      ParserFormat2[ParserFormat2["BIN"] = 1] = "BIN";
      ParserFormat2[ParserFormat2["JSON"] = 2] = "JSON";
      return ParserFormat2;
    })(ParserFormat || {});

    class FileLoader extends LoaderBase {
      constructor(ctx) {
        super(ctx);
      }
      /**
       * Load the file from the URL
       * @param url file URL
       * @param c File parser
       * @param loaderFunctions loader callback
       * @see LoaderFunctions
       * @returns
       */
      async load(url, c, loaderFunctions, userData) {
        switch (c.format) {
          case ParserFormat.BIN: {
            return new Promise(async (succ, fail) => {
              this.loadBinData(url, loaderFunctions).then(async (data) => {
                let parser = new c();
                parser.userData = userData;
                parser.baseUrl = this.baseUrl;
                parser.initUrl = url;
                parser.ctx = this.ctx;
                await parser.parseBuffer(data);
                if (parser.verification()) {
                  succ(parser);
                } else {
                  throw new Error("parser error");
                }
              }).catch((e) => {
                fail(e);
              });
            });
          }
          case ParserFormat.JSON: {
            return new Promise((succ, fail) => {
              this.loadJson(url, loaderFunctions).then(async (ret) => {
                let parser = new c();
                parser.userData = userData;
                parser.baseUrl = this.baseUrl;
                parser.initUrl = url;
                parser.loaderFunctions = loaderFunctions;
                parser.ctx = this.ctx;
                await parser.parseJson(ret);
                succ(parser);
              }).catch((e) => {
                fail(e);
              });
            });
          }
          case ParserFormat.TEXT: {
            return new Promise((succ, fail) => {
              this.loadTxt(url, loaderFunctions).then(async (ret) => {
                let parser = new c();
                parser.userData = userData;
                parser.baseUrl = this.baseUrl;
                parser.initUrl = url;
                parser.loaderFunctions = loaderFunctions;
                parser.ctx = this.ctx;
                if (!ret[`data`]) {
                  fail(`text load is empty!`);
                } else {
                  await parser.parseString(ret[`data`]);
                  succ(parser);
                }
              }).catch((e) => {
                fail(e);
              });
            });
          }
        }
      }
    }

    class ParserBase {
      static format = ParserFormat.BIN;
      baseUrl;
      initUrl;
      loaderFunctions;
      userData;
      data;
      /** Context3D this parser is operating under. Populated by FileLoader
       *  so default-texture lookups (`Engine3D.resFor(this.ctx)`) resolve
       *  against the owning engine's device rather than the global shim. */
      ctx;
      parseString(str) {
      }
      parseJson(obj) {
      }
      parseBuffer(buffer) {
      }
      parseTexture(buffer) {
        throw this.parserError("Method not implemented.", -1);
      }
      parse(data) {
      }
      verification(ret) {
        throw this.parserError("Method not implemented.", -1);
      }
      parserError(info, id) {
        console.error(`error id:${id} ${info}`);
      }
      // public static getTypedArrayTypeFromGLType(componentType:number){
      //   switch (componentType) {
      //     case 5126:
      //       return Float32Array;
      //       break;
      //       case 5125:
      //         return Uint8Array;
      //         break;
      //     default:
      //       break;
      //   }
      // }
    }

    class GLTF_Info {
      asset;
      accessors;
      buffers;
      bufferViews;
      materials;
      meshes;
      nodes;
      scene = 0;
      scenes;
      textures;
      cameras;
      skins;
      resources;
      images;
      samplers;
      animations;
      extensions;
    }
    class GLTF_Scene {
      nodes;
    }
    class GLTF_Light {
      name;
      type;
      color;
      intensity;
      range;
      spot;
      isParsed;
    }
    class GLTF_Node {
      name;
      rotation;
      scale;
      translation;
      children;
      matrix;
      mesh = -1;
      isParsed;
      dnode;
      camera;
      skin;
      nodeId;
      primitives;
      extensions;
      light;
    }
    class GLTF_Primitives {
      attributes;
      indices;
      material;
      mode;
      name;
      targets;
      extensions;
      morphTargetsRelative;
    }
    class GLTF_Mesh {
      name;
      primitives;
      isParsed;
      dprimitives;
      weights;
      extras;
    }
    class GLTF_Accessors {
      bufferView;
      componentType;
      count;
      type;
      max;
      min;
      isParsed;
      daccessor;
      normalized;
      sparse;
      byteOffset;
      computeResult;
    }

    const isArrayBuffer = window.SharedArrayBuffer ? function isArrayBufferOrSharedArrayBuffer(ary) {
      return ary && ary.buffer && (ary.buffer instanceof ArrayBuffer || ary.buffer instanceof window.SharedArrayBuffer);
    } : function isArrayBuffer2(ary) {
      return ary && ary.buffer && ary.buffer instanceof ArrayBuffer;
    };
    const BYTE = 5120;
    const UNSIGNED_BYTE = 5121;
    const SHORT = 5122;
    const UNSIGNED_SHORT = 5123;
    const INT = 5124;
    const UNSIGNED_INT = 5125;
    const FLOAT = 5126;
    const UNSIGNED_SHORT_4_4_4_4 = 32819;
    const UNSIGNED_SHORT_5_5_5_1 = 32820;
    const UNSIGNED_SHORT_5_6_5 = 33635;
    const HALF_FLOAT = 5131;
    const UNSIGNED_INT_2_10_10_10_REV = 33640;
    const UNSIGNED_INT_10F_11F_11F_REV = 35899;
    const UNSIGNED_INT_5_9_9_9_REV = 35902;
    const FLOAT_32_UNSIGNED_INT_24_8_REV = 36269;
    const UNSIGNED_INT_24_8 = 34042;
    const glTypeToTypedArray = {};
    {
      const tt = glTypeToTypedArray;
      tt[BYTE] = Int8Array;
      tt[UNSIGNED_BYTE] = Uint8Array;
      tt[SHORT] = Int16Array;
      tt[UNSIGNED_SHORT] = Uint16Array;
      tt[INT] = Int32Array;
      tt[UNSIGNED_INT] = Uint32Array;
      tt[FLOAT] = Float32Array;
      tt[UNSIGNED_SHORT_4_4_4_4] = Uint16Array;
      tt[UNSIGNED_SHORT_5_5_5_1] = Uint16Array;
      tt[UNSIGNED_SHORT_5_6_5] = Uint16Array;
      tt[HALF_FLOAT] = Uint16Array;
      tt[UNSIGNED_INT_2_10_10_10_REV] = Uint32Array;
      tt[UNSIGNED_INT_10F_11F_11F_REV] = Uint32Array;
      tt[UNSIGNED_INT_5_9_9_9_REV] = Uint32Array;
      tt[FLOAT_32_UNSIGNED_INT_24_8_REV] = Uint32Array;
      tt[UNSIGNED_INT_24_8] = Uint32Array;
    }
    function getGLTypeFromTypedArrayType(typedArrayType) {
      switch (typedArrayType) {
        case Int8Array:
          return BYTE;
        case Uint8Array:
          return UNSIGNED_BYTE;
        case Uint8ClampedArray:
          return UNSIGNED_BYTE;
        case Int16Array:
          return SHORT;
        case Uint16Array:
          return UNSIGNED_SHORT;
        case Int32Array:
          return INT;
        case Uint32Array:
          return UNSIGNED_INT;
        case Float32Array:
          return FLOAT;
        default:
          throw new Error("unsupported typed array type");
      }
    }
    function getGLTypeFromTypedArray(typedArray) {
      if (typedArray instanceof Int8Array) return BYTE;
      if (typedArray instanceof Uint8Array) return UNSIGNED_BYTE;
      if (typedArray instanceof Uint8ClampedArray) return UNSIGNED_BYTE;
      if (typedArray instanceof Int16Array) return SHORT;
      if (typedArray instanceof Uint16Array) return UNSIGNED_SHORT;
      if (typedArray instanceof Int32Array) return INT;
      if (typedArray instanceof Uint32Array) return UNSIGNED_INT;
      if (typedArray instanceof Float32Array) return FLOAT;
      throw new Error("unsupported typed array type");
    }
    function getTypedArrayTypeFromGLType(type) {
      const arrayType = glTypeToTypedArray[type];
      if (!arrayType) throw new Error("unkonw gl type");
      return arrayType;
    }
    function getTypedArray(array, Type = Float32Array) {
      if (isArrayBuffer(array)) return array;
      return new Type(array);
    }

    class KHR_draco_mesh_compression {
      static _workerCode;
      static _workers = /* @__PURE__ */ new Map();
      static async apply(parser, primitive) {
        if (!primitive.extensions) {
          return;
        }
        const extensionArgs = primitive.extensions["KHR_draco_mesh_compression"];
        if (!extensionArgs) {
          return;
        }
        let worker = this._workers.get(parser.gltf);
        if (!worker) {
          worker = new Worker(await this.initDecoder());
          this._workers.set(parser.gltf, worker);
        }
        worker.postMessage({
          type: "init",
          decoderConfig: {
            // wasmBinary: dracoDecoderWasm
          }
        });
        let buffer = parser.parseBufferView(extensionArgs.bufferView);
        if (!buffer.result) {
          let result = await new Promise((resolve, reject) => {
            worker.onmessage = (e) => {
              const msg = e.data;
              if (msg.type == "decode") {
                resolve(msg.result);
              } else if (msg.type == "error") {
                reject(msg.error);
              }
            };
            worker.postMessage({
              type: "decoder",
              buffer,
              attributes: extensionArgs.attributes
            }, [buffer]);
          });
          buffer.result = result;
        }
        return buffer.result;
      }
      static unload(gltf) {
        let worker = this._workers.get(gltf);
        if (worker) {
          worker.terminate();
          this._workers.delete(gltf);
        }
      }
      static async initDecoder() {
        if (!this._workerCode) {
          let dracoDecoderJs = await new FileLoader().loadTxt("https://cdn.orillusion.com/draco_decoder_gltf.js");
          const blob = new Blob([dracoDecoderJs["data"], "", `(${dracoDecoderWoeker})()`], { type: "application/javascript" });
          this._workerCode = URL.createObjectURL(blob);
        }
        return this._workerCode;
      }
    }
    function dracoDecoderWoeker() {
      let decoderConfig;
      let decoderPending;
      onmessage = (e) => {
        const msg = e.data;
        switch (msg.type) {
          case "init":
            decoderConfig = msg.decoderConfig;
            decoderPending = new Promise((resolve, reject) => {
              decoderConfig.onModuleLoaded = (draco) => {
                resolve({
                  draco
                });
              };
              DracoDecoderModule(decoderConfig);
            });
            break;
          case "decoder":
            const buffer = msg.buffer;
            const attributes = msg.attributes;
            decoderPending.then((module) => {
              const draco = module.draco;
              let decoder = new draco.Decoder();
              let decoderBuffer = new draco.DecoderBuffer();
              decoderBuffer.Init(new Int8Array(buffer), buffer.byteLength);
              let status, dracoGeometry;
              try {
                const geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
                if (geometryType == draco.TRIANGULAR_MESH) {
                  dracoGeometry = new draco.Mesh();
                  status = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
                } else {
                  self.postMessage(new Error("INVALID_GEOMETRY_TYPE:" + geometryType));
                }
                if (!status.ok()) {
                  self.postMessage(new Error("DracoDecode:" + status.error_msg()));
                }
                let result = {};
                for (const attributeName in attributes) {
                  let attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributes[attributeName]);
                  const numComponents = attribute.num_components();
                  const numPoints = dracoGeometry.num_points();
                  const numValues = numPoints * numComponents;
                  const byteLength = numValues * Float32Array.BYTES_PER_ELEMENT;
                  const dataType = draco.DT_FLOAT32;
                  const ptr = draco._malloc(byteLength);
                  decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
                  const array = new Float32Array(draco.HEAPF32.buffer, ptr, numValues).slice();
                  draco._free(ptr);
                  result[attributeName] = {
                    data: array,
                    numComponents,
                    normalize: false
                  };
                }
                {
                  const numFaces = dracoGeometry.num_faces();
                  const numIndices = numFaces * 3;
                  const byteLength = numIndices * 4;
                  const ptr = draco._malloc(byteLength);
                  decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
                  const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
                  draco._free(ptr);
                  result["indices"] = {
                    data: index,
                    numComponents: 1,
                    normalize: false
                  };
                }
                self.postMessage({
                  type: "decode",
                  result
                });
              } catch (error) {
                self.postMessage({
                  type: "error",
                  error: error.message
                });
              } finally {
                draco.destroy(dracoGeometry);
                draco.destroy(decoder);
                draco.destroy(decoderBuffer);
              }
            });
            break;
        }
      };
    }

    class GLTFSubParserCamera {
      gltf;
      constructor(gltf) {
        this.gltf = gltf;
      }
      parse(cameraId) {
        const camera = this.gltf.cameras[cameraId];
        if (!camera)
          return this.errorMiss("camera", cameraId);
        if (camera.isParsed)
          return camera.dcamera;
        camera.isParsed = true;
        camera.dcamera = false;
        const { name, type, perspective, orthographic } = camera;
        if (type === "perspective" && perspective) {
          const { aspectRatio, yfov, zfar, znear } = perspective;
          camera.dcamera = Object.assign(
            {},
            {
              name,
              type,
              yfov,
              znear,
              aspectRatio,
              zfar
            }
          );
        } else if (type === "orthographic" && orthographic) {
          const { xmag, ymag, zfar, znear } = orthographic;
          camera.dcamera = Object.assign(
            {},
            {
              name,
              type,
              xmag,
              ymag,
              zfar,
              znear
            }
          );
        }
        return camera.dcamera;
      }
      errorMiss(e, info) {
        throw new Error(e + info);
      }
    }

    class GLTFParser extends ParserBase {
      static format = ParserFormat.JSON;
      _gltf;
      async parseJson(obj) {
        this._gltf = new GLTF_Info();
        this._gltf = { ...this._gltf, ...obj };
        this._gltf.resources = {};
        await Promise.all([this.load_gltf_bin(), this.load_gltf_textures()]);
        let subParser = new GLTFSubParser(this.ctx);
        let nodes = await subParser.parse(this.initUrl, this._gltf, this._gltf.scene);
        subParser.destroy();
        subParser = null;
        if (nodes) {
          this.data = nodes.rootNode;
          return nodes.rootNode;
        }
        this._gltf = null;
        return null;
      }
      /**
       * Verify parsing validity
       * @param ret
       * @returns
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("Method not implemented.");
      }
      static _counter = 0;
      static getMeshNameCounter() {
        return function getMeshNameCounter() {
          return `GLTF_NO_NAME_PRIMITIVE_${GLTFParser._counter++}`;
        };
      }
      static getModelNameCounter() {
        let counter = 0;
        return function getModelNameCounter() {
          return `GLTF_NO_NAME_MESH_${counter++}`;
        };
      }
      static getTexCoordDefine(texNum) {
        return `UV_NUM ${texNum}`;
      }
      static getVertexColorDefine(num) {
        return `HAS_VERTEXCOLOR ${num}`;
      }
      static getBaseColorTextureDefine() {
        return "HAS_BASECOLORMAP";
      }
      static getMetalRoughnessDefine() {
        return "HAS_METALROUGHNESSMAP";
      }
      static getNormalMapDefine() {
        return "HAS_NORMALMAP";
      }
      static getEmissiveMapDefine() {
        return "HAS_EMISSIVEMAP";
      }
      static getOcclusionMapDefine() {
        return "HAS_OCCLUSIONMAP";
      }
      static getMorphTargetsDefine(targetNum) {
        return `MORPH_TARGET_NUM ${targetNum}`;
      }
      static getMorphtargetPositionDefine() {
        return "HAS_MORPH_POSITION";
      }
      static getMorphtargetNormalDefine() {
        return "HAS_MORPH_NORMAL";
      }
      static getMorphtargetTangentDefine() {
        return "HAS_MORPH_TANGENT";
      }
      static getJointsNumDefine(num) {
        return `JOINTS_NUM ${num}`;
      }
      static getJointVec8Define() {
        return "JOINT_VEC8";
      }
      static getHasNormalDefine() {
        return "HAS_NORMAL";
      }
      static getHasTangentDefine() {
        return "HAS_TANGENT";
      }
      static getHasNormalMapDefine() {
        return "HAS_NORMAL_MAP";
      }
      static getAlphaMaskDefine() {
        return "ALPHA_MASK";
      }
      static getAlphaBlendDefine() {
        return "ALPHA_BLEND";
      }
      static defaultMaterial = {
        name: "GLTF_DEFAULT_MATERIAL",
        alphaCutoff: 0.33,
        alphaMode: "MASK",
        pbrMetallicRoughness: {
          name: "GLTF_DEFAULT_MATERIAL",
          defines: [],
          doubleSided: false,
          baseColorFactor: [1, 1, 1, 1],
          metallicFactor: 1,
          roughnessFactor: 1,
          emissiveFactor: [0, 0, 0]
        }
      };
      async load_gltf_bin() {
        if (this._gltf.buffers && this._gltf.buffers.length > 0) {
          let binArray = [];
          for (let i = 0; i < this._gltf.buffers.length; i++) {
            const element = this._gltf.buffers[i];
            if (element.uri.substring(0, 5) !== "data:") {
              let url = StringUtil.parseUrl(this.baseUrl, element.uri);
              if (this.loaderFunctions?.onUrl)
                url = await this.loaderFunctions.onUrl(url);
              let promise = new FileLoader(this.ctx).loadBinData(url, this.loaderFunctions).then((loader) => {
                this._gltf.resources[element.uri] = loader;
              });
              binArray.push(promise);
            }
          }
          await Promise.all(binArray);
        }
      }
      async load_gltf_textures() {
        this._gltf;
        if (this._gltf.images) {
          let textureArray = [];
          for (let i = 0; i < this._gltf.images.length; i++) {
            const element = this._gltf.images[i];
            if (element.uri) {
              let url = StringUtil.parseUrl(this.baseUrl, element.uri);
              if (this.loaderFunctions?.onUrl)
                url = await this.loaderFunctions.onUrl(url);
              let promise = new FileLoader(this.ctx).loadAsyncBitmapTexture(url, this.loaderFunctions).then((texture) => {
                texture.name = StringUtil.getURLName(element.uri);
                this._gltf.resources[texture.name] = texture;
              });
              textureArray.push(promise);
            }
          }
          await Promise.all(textureArray);
        }
      }
    }

    class GLTFSubParserMesh {
      gltf;
      subParser;
      constructor(subParser) {
        this.gltf = subParser.gltf;
        this.subParser = subParser;
      }
      async parse(meshId) {
        const mesh = this.gltf.meshes[meshId];
        if (!mesh)
          return this.errorMiss("mesh", meshId);
        if (mesh.isParsed)
          return mesh.dprimitives;
        const primitives = mesh.primitives;
        const extras = mesh.extras;
        const dprimitives = [];
        for (let i = 0; i < primitives.length; i++) {
          const primitive = primitives[i];
          const { attributes, indices, material, mode, name, targets, morphTargetsRelative, extensions } = primitive;
          let tmpName = mesh.name;
          for (let tn in attributes) {
            tmpName += tn;
          }
          tmpName += `indices:${indices}`;
          tmpName += `material:${material}`;
          const dprimitive = {
            attribArrays: { indices: [] },
            weights: [],
            defines: [],
            material: null,
            drawMode: null,
            meshName: null,
            modelName: null,
            morphTargetsRelative: false,
            targetNames: extras ? extras.targetNames : null
          };
          let hasNormal = false;
          let texCoordNum = 0;
          let jointVec8 = false;
          let overlayAccessors;
          if (extensions && extensions.KHR_draco_mesh_compression) {
            overlayAccessors = await KHR_draco_mesh_compression.apply(this.subParser, primitive);
          }
          for (const attribute in attributes) {
            const accessor = overlayAccessors ? overlayAccessors[attribute] : this.parseAccessor(attributes[attribute]);
            if (accessor) {
              let attribName;
              switch (attribute) {
                case "POSITION":
                  attribName = VertexAttributeName.position;
                  break;
                case "NORMAL":
                  attribName = VertexAttributeName.normal;
                  hasNormal = true;
                  break;
                case "TEXCOORD_0":
                  attribName = VertexAttributeName.uv;
                  texCoordNum++;
                  break;
                case "JOINTS_0":
                  attribName = VertexAttributeName.joints0;
                  break;
                case "JOINTS_1":
                  attribName = VertexAttributeName.joints1;
                  jointVec8 = true;
                  break;
                case "WEIGHTS_0":
                  attribName = VertexAttributeName.weights0;
                  break;
                case "WEIGHTS_1":
                  attribName = VertexAttributeName.weights1;
                  break;
                default:
                  attribName = attribute;
              }
              dprimitive.attribArrays[attribName] = accessor;
            }
          }
          if (hasNormal) dprimitive.defines.push(GLTFParser.getHasNormalDefine());
          if (texCoordNum) dprimitive.defines.push(GLTFParser.getTexCoordDefine(texCoordNum));
          if (jointVec8) dprimitive.defines.push(GLTFParser.getJointVec8Define());
          if (indices !== void 0) {
            const accessor = overlayAccessors ? overlayAccessors["indices"] : this.parseAccessor(indices);
            if (accessor) dprimitive.attribArrays.indices = accessor;
          }
          const dmaterial = await this.parseMaterial(material);
          if (dmaterial) {
            dprimitive.material = dmaterial;
            dprimitive.defines = dprimitive.defines.concat(dmaterial.defines);
          }
          dprimitive.drawMode = mode === void 0 ? 4 : mode;
          dprimitive.meshName = () => {
            return tmpName;
          };
          dprimitive.modelName = mesh.name || GLTFParser.getModelNameCounter();
          if (targets) {
            dprimitive.defines.push(GLTFParser.getMorphTargetsDefine(targets.length));
            dprimitive.morphTargetsRelative = true;
            let hasPositions = false;
            let hasNormals = false;
            let hasTangents = false;
            for (let j = 0; j < targets.length; j++) {
              const target = targets[j];
              Object.keys(target).forEach((attribute) => {
                const accessor = this.parseAccessor(target[attribute]);
                if (accessor) {
                  let attribName;
                  switch (attribute) {
                    case "POSITION":
                      attribName = GLTFType.MORPH_POSITION_PREFIX + j;
                      hasPositions = true;
                      break;
                    case "NORMAL":
                      attribName = GLTFType.MORPH_NORMAL_PREFIX + j;
                      hasNormals = true;
                      break;
                    case "TANGENT":
                      attribName = GLTFType.MORPH_TANGENT_PREFIX + j;
                      hasTangents = true;
                      break;
                    default:
                      attribName = false;
                  }
                  if (!attribName) console.error(`glTF has unsupported morph target attribute ${attribute}`);
                  else dprimitive.attribArrays[attribName] = accessor;
                }
              });
            }
            if (hasPositions) dprimitive.defines.push(GLTFParser.getMorphtargetPositionDefine());
            if (hasNormals) dprimitive.defines.push(GLTFParser.getMorphtargetNormalDefine());
            if (hasTangents) dprimitive.defines.push(GLTFParser.getMorphtargetTangentDefine());
            dprimitive.weights = mesh.weights || new Array(targets.length).fill(0);
          }
          dprimitives.push(dprimitive);
        }
        mesh.dprimitives = dprimitives;
        mesh.isParsed = true;
        return mesh.dprimitives;
      }
      parseAccessor(accessorId) {
        return this.subParser.parseAccessor(accessorId);
      }
      parseMaterial(material) {
        return this.subParser.parseMaterial(material);
      }
      errorMiss(e, info) {
        throw new Error(e + info);
      }
    }

    class GLTFSubParserMaterial {
      gltf;
      subParser;
      constructor(subParser) {
        this.gltf = subParser.gltf;
        this.subParser = subParser;
      }
      async parse(materialId) {
        let material;
        if (materialId == void 0) {
          material = GLTFParser.defaultMaterial;
        } else {
          material = this.gltf.materials[materialId];
        }
        if (!material)
          return this.errorMiss("material", materialId);
        if (material.isParsed)
          return material.dmaterial;
        let { name, pbrMetallicRoughness, normalTexture, occlusionTexture, emissiveTexture, emissiveFactor, alphaMode, alphaCutoff, doubleSided, extensions } = material;
        const dmaterial = {
          name,
          defines: [],
          doubleSided: !!doubleSided,
          baseColorFactor: [1, 1, 1, 1],
          emissiveFactor: null,
          alphaCutoff: 0,
          enableBlend: false,
          baseColorTexture: null,
          metallicRoughnessTexture: null,
          normalTexture: null,
          occlusionTexture: null,
          emissiveTexture: null,
          extensions: null,
          baseMapOffsetSize: null,
          normalMapOffsetSize: null,
          emissiveMapOffsetSize: null,
          roughnessMapOffsetSize: null,
          metallicMapOffsetSize: null,
          aoMapOffsetSize: null,
          metallicFactor: 0,
          roughnessFactor: 1
        };
        if (pbrMetallicRoughness) {
          const { baseColorFactor, metallicFactor, roughnessFactor, baseColorTexture, metallicRoughnessTexture } = pbrMetallicRoughness;
          Object.assign(dmaterial, {
            baseColorFactor: baseColorFactor || [1, 1, 1, 1],
            metallicFactor: metallicFactor === void 0 ? 1 : metallicFactor,
            roughnessFactor: roughnessFactor === void 0 ? 0.5 : roughnessFactor
          });
          if (baseColorTexture) {
            let ext = baseColorTexture.extensions;
            if (ext) {
              let KHR_texture_transform = ext.KHR_texture_transform;
              if (KHR_texture_transform) {
                let offsetSize = new Vector4(
                  KHR_texture_transform.offset ? KHR_texture_transform.offset[0] : 0,
                  KHR_texture_transform.offset ? KHR_texture_transform.offset[1] : 0,
                  KHR_texture_transform.scale ? KHR_texture_transform.scale[0] : 1,
                  KHR_texture_transform.scale ? KHR_texture_transform.scale[1] : 1
                );
                dmaterial.baseMapOffsetSize = offsetSize;
              }
            }
            const texture = await this.parseTexture(baseColorTexture.index, "srgb");
            if (texture) {
              dmaterial.baseColorTexture = texture;
            } else {
              dmaterial.baseColorTexture = Engine3D.resFor(this.subParser.ctx).redTexture;
            }
          }
          if (normalTexture) {
            let ext = normalTexture.extensions;
            if (ext) {
              let KHR_texture_transform = ext.KHR_texture_transform;
              if (KHR_texture_transform) {
                let offsetSize = new Vector4(
                  KHR_texture_transform.offset ? KHR_texture_transform.offset[0] : 0,
                  KHR_texture_transform.offset ? KHR_texture_transform.offset[1] : 0,
                  KHR_texture_transform.scale ? KHR_texture_transform.scale[0] : 1,
                  KHR_texture_transform.scale ? KHR_texture_transform.scale[1] : 1
                );
                dmaterial.normalMapOffsetSize = offsetSize;
              }
            }
            const texture = await this.parseTexture(normalTexture.index);
            if (texture) {
              dmaterial.normalTexture = texture;
            } else {
              dmaterial.normalTexture = Engine3D.resFor(this.subParser.ctx).normalTexture;
            }
          }
          if (metallicRoughnessTexture) {
            let ext = metallicRoughnessTexture.extensions;
            if (ext) {
              let KHR_texture_transform = ext.KHR_texture_transform;
              if (KHR_texture_transform) {
                let offsetSize = new Vector4(
                  KHR_texture_transform.offset ? KHR_texture_transform.offset[0] : 0,
                  KHR_texture_transform.offset ? KHR_texture_transform.offset[1] : 0,
                  KHR_texture_transform.scale ? KHR_texture_transform.scale[0] : 1,
                  KHR_texture_transform.scale ? KHR_texture_transform.scale[1] : 1
                );
                dmaterial.roughnessMapOffsetSize = offsetSize;
              }
            }
            const texture = await this.parseTexture(metallicRoughnessTexture.index);
            if (texture) {
              dmaterial.metallicRoughnessTexture = texture;
            } else {
              dmaterial.metallicRoughnessTexture = Engine3D.resFor(this.subParser.ctx).blackTexture;
            }
          }
        } else {
          Object.assign(dmaterial, {
            baseColorFactor: [1, 1, 1, 1],
            metallicFactor: 0,
            roughnessFactor: 0.5
          });
        }
        if (extensions && extensions.KHR_materials_transmission && extensions.KHR_materials_transmission.transmissionTexture) {
          const texInfo = extensions.KHR_materials_transmission.transmissionTexture;
          const tex = await this.parseTexture(texInfo.index);
          if (tex) dmaterial.transmissionTextureResolved = tex;
        }
        if (extensions && extensions.KHR_materials_volume && extensions.KHR_materials_volume.thicknessTexture) {
          const texInfo = extensions.KHR_materials_volume.thicknessTexture;
          const tex = await this.parseTexture(texInfo.index);
          if (tex) dmaterial.thicknessTextureResolved = tex;
        }
        if (dmaterial.baseColorFactor && dmaterial.baseColorFactor[3] < 1) {
          alphaMode = alphaMode === "MASK" ? "MASK" : "BLEND";
        }
        if (alphaMode && alphaMode !== "OPAQUE") {
          if (alphaMode === "MASK") {
            dmaterial.defines.push(GLTFParser.getAlphaMaskDefine());
            dmaterial.alphaCutoff = alphaCutoff === void 0 ? 0.5 : alphaCutoff;
          }
          if (alphaMode === "BLEND") {
            dmaterial.defines.push(GLTFParser.getAlphaBlendDefine());
            dmaterial.enableBlend = true;
          }
        }
        if (normalTexture) {
          const texture = await this.parseTexture(normalTexture.index);
          if (texture) {
            dmaterial.normalTexture = texture;
          } else {
            dmaterial.normalTexture = Engine3D.resFor(this.subParser.ctx).normalTexture;
          }
        }
        if (occlusionTexture) {
          const texture = await this.parseTexture(occlusionTexture.index);
          if (texture) {
            dmaterial.occlusionTexture = texture;
          }
        }
        if (emissiveFactor) {
          dmaterial.emissiveFactor = emissiveFactor;
        }
        if (emissiveTexture) {
          const texture = await this.parseTexture(emissiveTexture.index, "srgb");
          if (texture) {
            dmaterial.emissiveTexture = texture;
          } else {
            dmaterial.emissiveTexture = Engine3D.resFor(this.subParser.ctx).blackTexture;
          }
        }
        if (extensions) {
          dmaterial.extensions = extensions;
        }
        material.isParsed = true;
        material.dmaterial = dmaterial;
        return dmaterial;
      }
      async parseTexture(index, colorSpace = "linear") {
        return this.subParser.parseTexture(index, colorSpace);
      }
      errorMiss(e, info) {
        throw new Error(e + info);
      }
    }

    class GLTFSubParserSkin {
      gltf;
      subParser;
      constructor(subParser) {
        this.gltf = subParser.gltf;
        this.subParser = subParser;
      }
      parse(skinId) {
        const skin = this.gltf.skins[skinId];
        if (!skin)
          return this.errorMiss("skin", skinId);
        if (skin.isParsed)
          return skin.dskin;
        const { name, joints, inverseBindMatrices, skeleton } = skin;
        if (!joints)
          return this.errorMiss("skin.joints", skinId);
        skin.isParsed = true;
        skin.dskin = false;
        let dskin = {
          name,
          skeleton: null,
          inverseBindMatrices: null,
          joints,
          defines: [GLTFParser.getJointsNumDefine(joints.length)]
        };
        if (skeleton !== void 0 && skeleton !== null) {
          dskin.skeleton = skeleton;
        } else {
          const jointSet = new Set(joints);
          const parentOf = new Array(this.gltf.nodes.length).fill(-1);
          for (let i = 0; i < this.gltf.nodes.length; i++) {
            const n = this.gltf.nodes[i];
            if (n.children) {
              for (const c of n.children) parentOf[c] = i;
            }
          }
          const rootJoints = [];
          for (const j of joints) {
            if (!jointSet.has(parentOf[j])) rootJoints.push(j);
          }
          let rootNodeId = -1;
          if (rootJoints.length === 1) {
            rootNodeId = rootJoints[0];
          } else if (rootJoints.length > 1) {
            rootNodeId = rootJoints[0];
          }
          if (rootNodeId === -1) {
            for (let i = 0; i < this.gltf.nodes.length; i++) {
              if (this.gltf.nodes[i].name == "root") {
                rootNodeId = i;
                break;
              }
            }
            if (rootNodeId === -1) {
              const scene = this.gltf.scenes[this.gltf.scene];
              rootNodeId = scene.nodes[scene.nodes.length - 1];
            }
          }
          dskin.skeleton = rootNodeId;
        }
        dskin.inverseBindMatrices = GLTFType.IDENTITY_INVERSE_BIND_MATRICES;
        if (inverseBindMatrices !== void 0) {
          const accessor = this.parseAccessor(inverseBindMatrices);
          if (accessor) {
            const array = accessor.data;
            const matrices = [];
            for (let i = 0; i < array.length; i += 16) matrices.push(array.slice(i, i + 16));
            dskin.inverseBindMatrices = matrices;
          } else dskin = null;
        }
        skin.dskin = dskin;
        return skin.dskin;
      }
      parseAccessor(accessorId) {
        return this.subParser.parseAccessor(accessorId);
      }
      errorMiss(e, info) {
        throw new Error(e + info);
      }
    }

    class Joint {
      /**
       * Name of bone joint
       */
      name = "";
      /**
       * Bone joint index
       */
      index = 0;
      /**
       * Bone instanceID
       */
      instanceID = "";
      /**
       * The parent of a bone joint
       */
      parent = null;
      /**
       * Bone joint child object
       */
      // public children: Array<Joint> = [];
      /**
       * The scaling value of the bone joint
       */
      scale = new Vector3();
      /**
       * The rotation Angle of the bone and joint
       */
      rotation = new Quaternion();
      /**
       * The position of the bone joint
       */
      translation = new Vector3();
      constructor(name = "") {
        this.name = name;
      }
    }

    class JointPose {
      index;
      worldMatrix;
      constructor(index, useGlobalMatrix = false) {
        this.index = index;
        this.worldMatrix = new Matrix4(!useGlobalMatrix);
      }
    }

    class SkeletonPose {
      /**
      * time of this pose in owner animation clip 
      */
      time;
      _skeleton;
      _jointsPose;
      mJointMatrixIndexTable;
      constructor(skeleton, useGlobalMatrix = false) {
        this._skeleton = skeleton;
        this._jointsPose = new Array(skeleton.numJoint);
        this.mJointMatrixIndexTable = new Array(skeleton.numJoint);
        for (let index = 0; index < skeleton.numJoint; index++) {
          let joint = new JointPose(index, useGlobalMatrix);
          this._jointsPose[index] = joint;
          this.mJointMatrixIndexTable[index] = joint.worldMatrix.index;
        }
      }
      /**
      * build this pose from float32 array data
      */
      buildSkeletonPose(poseData) {
        let scale = new Vector3();
        let rotation = new Quaternion();
        let translation = new Vector3();
        let jointLocalMatrix = new Array(this._skeleton.numJoint);
        this.time = poseData[11] > 0 ? poseData[11] : poseData[24];
        for (let jointIndex = 0; jointIndex < this._skeleton.numJoint; jointIndex++) {
          let byteOffset = 12 * jointIndex * 4;
          let jointData = new Float32Array(poseData.buffer, poseData.byteOffset + byteOffset, 12);
          let localMatrix = new Matrix4();
          scale.set(jointData[0], jointData[1], jointData[2]);
          rotation.set(jointData[4], jointData[5], jointData[6], jointData[7]);
          translation.set(jointData[8], jointData[9], jointData[10]);
          makeMatrix44(rotation.getEulerAngles(), translation, scale, localMatrix);
          jointLocalMatrix[jointIndex] = localMatrix;
          let joint = new JointPose(jointIndex);
          const nParentIndex = this._skeleton.getJointParentIndex(jointIndex);
          if (nParentIndex < 0) {
            joint.worldMatrix.copy(localMatrix);
          } else {
            let parentJoint = this._jointsPose[nParentIndex];
            multiplyMatrices4x4REF(parentJoint.worldMatrix, localMatrix, joint.worldMatrix);
          }
          this._jointsPose[jointIndex] = joint;
        }
      }
      /** 
      * Returns joints count of owner skeleton
      */
      get numJoint() {
        return this._skeleton.numJoint;
      }
      /** 
      * Returns all joint pose
      */
      get joints() {
        return this._jointsPose;
      }
      /** 
      * Returns list of matrix's index
      */
      get jointMatrixIndexTable() {
        return this.mJointMatrixIndexTable;
      }
      /** 
      * Returns lerped skeletonPose from pose a to pose b
      * @param a selected pose No.1
      * @param b selected pose No.2
      * @param weight number
      */
      lerp(a, b, weight) {
        if (a && b) {
          for (let index = 0; index < this._jointsPose.length; index++) {
            let jointA = a._jointsPose[index];
            let jointB = b._jointsPose[index];
            let jointDst = this._jointsPose[index];
            jointDst.worldMatrix.lerp(jointA.worldMatrix, jointB.worldMatrix, weight);
          }
        } else {
          for (let index = 0; index < this._jointsPose.length; index++) {
            let jointA = a._jointsPose[index];
            let jointDst = this._jointsPose[index];
            jointDst.worldMatrix.copy(jointA.worldMatrix);
          }
        }
      }
      /** 
      * Copy skeleton pose from other skeleton pose
      * @param other source skeleton pose
      */
      copy(other) {
        for (let index = 0; index < this._jointsPose.length; index++) {
          this._jointsPose[index].worldMatrix.copy(other._jointsPose[index].worldMatrix);
        }
      }
      /** 
      * Reset this skeleton pose
      */
      reset() {
        for (let index = 0; index < this._jointsPose.length; index++) {
          this._jointsPose[index].worldMatrix.identity();
        }
      }
    }

    class OAnimationEvent extends CEvent {
      animator;
      constructor(name, time) {
        super();
        this.type = name;
        this.time = time;
      }
    }

    class SkeletonAnimationClip {
      name = "";
      _skeleton;
      _skeletonPoses;
      _animationClipData;
      _events;
      constructor(name, skeleton, numFrame, bufferData) {
        this.name = name;
        this._skeleton = skeleton;
        this._animationClipData = bufferData;
        if (numFrame > 0 && bufferData) {
          this._skeletonPoses = new Array(numFrame);
          let skeletonPoseLength = 12 * skeleton.numJoint;
          for (let nFrame = 0; nFrame < numFrame; nFrame++) {
            let byteOffset = skeletonPoseLength * nFrame * 4;
            let poseData = new Float32Array(bufferData.buffer, byteOffset, skeletonPoseLength);
            let skeletonPose = new SkeletonPose(skeleton);
            skeletonPose.buildSkeletonPose(poseData);
            this._skeletonPoses[nFrame] = skeletonPose;
          }
        }
      }
      /*
      * Animation total time in seconds
      */
      get totalTime() {
        return this._skeletonPoses[this._skeletonPoses.length - 1].time;
      }
      /*
      * Frame rate at which keyframes are sampled.
      */
      get frameRate() {
        return this.totalTime / this._skeletonPoses.length;
      }
      /*
      * Returns owner skeleton
      */
      get skeleton() {
        return this._skeleton;
      }
      /*
      * Returns key frame count 
      */
      get numFrame() {
        return this._skeletonPoses.length - 1;
      }
      /*
      * Returns float32 array of this animation clip
      */
      get animationClipData() {
        return this._animationClipData;
      }
      /*
      * Returns skeletonPose at target frame
      */
      getSkeletonPose(frame) {
        return this._skeletonPoses[frame];
      }
      /** 
      * Returns lerped skeletonPose between currFrame and nextFrame
      * @param currFrame selected frame No.1
      * @param nextFrame selected frame No.2
      * @param weight number
      * @param dst  result SkeletonPose
      */
      getLerpSkeletonPose(currFrame, nextFrame, weight, dst) {
        let skeletonPoseA = this.getSkeletonPose(currFrame);
        let skeletonPoseB = this.getSkeletonPose(nextFrame);
        dst.lerp(skeletonPoseA, skeletonPoseB, weight);
        return dst;
      }
      /** 
      * create one skeletonAnimationClip from startTime to endTime
      * @param name the name of new animation clip
      * @param startTime set time of animation clip start from
      * @param endTime set time of animation clip end of
      */
      createSubClip(name, startTime, endTime) {
        var result = new SkeletonAnimationClip(name, this._skeleton, 0, null);
        const startFrame = Math.max(Math.floor(startTime / this.frameRate), 0);
        const endFrame = Math.min(Math.floor(endTime / this.frameRate), this._skeletonPoses.length - 1);
        result._skeletonPoses = this._skeletonPoses.slice(startFrame, endFrame);
        const skeletonPoseByteLength = 12 * this._skeleton.numJoint * 4;
        this._animationClipData = new Float32Array(this._animationClipData.buffer, startFrame * skeletonPoseByteLength, (endFrame - startFrame) * skeletonPoseByteLength);
        return result;
      }
      /** 
      * register a event in this animation clip.
      * @param eventName event name
      * @param startTime number
      */
      addEvent(eventName, triggerTime) {
        if (!this._events) {
          this._events = new Array();
        }
        this._events.push(new OAnimationEvent(eventName, triggerTime));
      }
      /** 
      * remove a event in this animation clip
      * @param eventName event name
      */
      removeEvent(eventName) {
        if (this._events) {
          this._events = this._events.filter((items) => items.type != eventName);
        }
      }
      /** 
      * Returns all AnimationEvent of this animationClip
      * @param eventName event name
      */
      getEvents() {
        return this._events;
      }
    }

    class GLTFSubParserSkeleton {
      gltf;
      subParser;
      constructor(subParser) {
        this.gltf = subParser.gltf;
        this.subParser = subParser;
      }
      parse(skeletonID) {
        let avatarData = new PrefabAvatarData();
        avatarData.name = "Id:" + skeletonID;
        avatarData.count = 0;
        avatarData.boneData = [];
        avatarData.boneMap = /* @__PURE__ */ new Map();
        this.buildSkeleton(avatarData, void 0, skeletonID);
        return avatarData;
      }
      parseSkeletonAnimation(avatarData, animation) {
        let result = new PropertyAnimationClip();
        result.clipName = animation.name;
        result.useSkeletonPos = false;
        result.useSkeletonScale = false;
        for (let channel of animation.channels) {
          let sampler = animation.samplers[channel.sampler];
          const inputAccessor = this.subParser.parseAccessor(sampler.input);
          const outputAccessor = this.subParser.parseAccessor(sampler.output);
          let nodeId = channel.target.node;
          let property = channel.target.path;
          let node = this.gltf.nodes[nodeId];
          if (!node) {
            continue;
          }
          if (!avatarData.boneMap.has(node.name)) {
            continue;
          }
          let bone = avatarData.boneMap.get(node.name);
          switch (property) {
            case "scale":
              {
                let animationCurveT = new AnimationCurveT(outputAccessor.numComponents);
                animationCurveT.path = "";
                animationCurveT.attribute = "";
                animationCurveT.propertys = animationCurveT.attribute.split(".");
                animationCurveT.preInfinity = 0;
                animationCurveT.postInfinity = 0;
                animationCurveT.rotationOrder = 0;
                result.useSkeletonScale = true;
                result.scaleCurves.set(bone.bonePath, animationCurveT);
                for (let i = 0; i < inputAccessor.data.length; i++) {
                  const t = inputAccessor.data[i];
                  const offset = i * outputAccessor.numComponents;
                  let keyframe = new KeyframeT(0);
                  keyframe.time = t;
                  const v = new Vector3().set(
                    outputAccessor.data[offset + 0],
                    outputAccessor.data[offset + 1],
                    outputAccessor.data[offset + 2]
                  );
                  keyframe.split(ValueEnumType.vector3, v, "value");
                  animationCurveT.addKeyFrame(keyframe);
                }
              }
              break;
            case "rotation":
              {
                let animationCurveT = new AnimationCurveT(outputAccessor.numComponents);
                animationCurveT.path = "";
                animationCurveT.attribute = "";
                animationCurveT.propertys = animationCurveT.attribute.split(".");
                animationCurveT.preInfinity = 0;
                animationCurveT.postInfinity = 0;
                animationCurveT.rotationOrder = 0;
                result.rotationCurves.set(bone.bonePath, animationCurveT);
                for (let i = 0; i < inputAccessor.data.length; i++) {
                  const t = inputAccessor.data[i];
                  const offset = i * outputAccessor.numComponents;
                  let keyframe = new KeyframeT(0);
                  keyframe.time = t;
                  const v = new Quaternion().set(
                    outputAccessor.data[offset + 0],
                    outputAccessor.data[offset + 1],
                    outputAccessor.data[offset + 2],
                    outputAccessor.data[offset + 3]
                  );
                  keyframe.split(ValueEnumType.quaternion, v, "value");
                  animationCurveT.addKeyFrame(keyframe);
                }
              }
              break;
            case "translation":
              {
                let animationCurveT = new AnimationCurveT(outputAccessor.numComponents);
                animationCurveT.path = "";
                animationCurveT.attribute = "";
                animationCurveT.propertys = animationCurveT.attribute.split(".");
                animationCurveT.preInfinity = 0;
                animationCurveT.postInfinity = 0;
                animationCurveT.rotationOrder = 0;
                result.useSkeletonPos = true;
                result.positionCurves.set(bone.bonePath, animationCurveT);
                for (let i = 0; i < inputAccessor.data.length; i++) {
                  const t = inputAccessor.data[i];
                  const offset = i * outputAccessor.numComponents;
                  let keyframe = new KeyframeT(0);
                  keyframe.time = t;
                  const v = new Vector3().set(
                    outputAccessor.data[offset + 0],
                    outputAccessor.data[offset + 1],
                    outputAccessor.data[offset + 2]
                  );
                  keyframe.split(ValueEnumType.vector3, v, "value");
                  animationCurveT.addKeyFrame(keyframe);
                }
              }
              break;
          }
        }
        return result;
      }
      parseSkeletonAnimationOld(skeleton, animation) {
        let inputAccessor = this.subParser.parseAccessor(animation.samplers[0].input);
        let numFrame = inputAccessor.data.length;
        let frameRate = inputAccessor.data[1] - inputAccessor.data[0];
        inputAccessor.data[inputAccessor.data.length - 1];
        let skeletonPoseLength = 12 * skeleton.numJoint;
        let bufferData = new Float32Array(skeletonPoseLength * numFrame);
        for (var index = 0; index < skeleton.numJoint; index++) {
          for (var nFrame = 0; nFrame < numFrame; nFrame++) {
            var dstOffset = skeletonPoseLength * nFrame + 12 * index;
            bufferData[dstOffset + 0] = 1;
            bufferData[dstOffset + 1] = 1;
            bufferData[dstOffset + 2] = 1;
            bufferData[dstOffset + 3] = 1;
          }
        }
        for (let channel of animation.channels) {
          let sampler = animation.samplers[channel.sampler];
          const inputAccessor2 = this.subParser.parseAccessor(sampler.input);
          const outputAccessor = this.subParser.parseAccessor(sampler.output);
          let nodeId = channel.target.node;
          let property = channel.target.path;
          let node = this.gltf.nodes[nodeId];
          if (!node) {
            continue;
          }
          let joint = skeleton.getJointByName(node.name);
          if (!joint) ; else {
            switch (property) {
              case "scale":
                if (numFrame * outputAccessor.numComponents == outputAccessor.data.length) {
                  for (var nFrame = 0; nFrame < numFrame; nFrame++) {
                    var srcOffset = nFrame * outputAccessor.numComponents;
                    var dstOffset = skeletonPoseLength * nFrame + 12 * joint.index;
                    bufferData[dstOffset + 0] = outputAccessor.data[srcOffset + 0];
                    bufferData[dstOffset + 1] = outputAccessor.data[srcOffset + 1];
                    bufferData[dstOffset + 2] = outputAccessor.data[srcOffset + 2];
                    bufferData[dstOffset + 3] = 1;
                  }
                } else if (inputAccessor2.data.length == 2) {
                  let time = 0;
                  inputAccessor2.data[0];
                  let t1 = inputAccessor2.data[1];
                  var srcOffsetA = 0 * outputAccessor.numComponents;
                  Vector3.HELP_0.set(
                    outputAccessor.data[srcOffsetA + 0],
                    outputAccessor.data[srcOffsetA + 1],
                    outputAccessor.data[srcOffsetA + 2]
                  );
                  var srcOffsetB = 1 * outputAccessor.numComponents;
                  Vector3.HELP_1.set(
                    outputAccessor.data[srcOffsetB + 0],
                    outputAccessor.data[srcOffsetB + 1],
                    outputAccessor.data[srcOffsetB + 2]
                  );
                  for (var nFrame = 0; nFrame < numFrame; nFrame++) {
                    let t = time / t1;
                    Vector3.HELP_2.lerp(Vector3.HELP_0, Vector3.HELP_1, t);
                    var dstOffset = skeletonPoseLength * nFrame + 12 * joint.index;
                    bufferData[dstOffset + 0] = Vector3.HELP_2.x;
                    bufferData[dstOffset + 1] = Vector3.HELP_2.y;
                    bufferData[dstOffset + 2] = Vector3.HELP_2.z;
                    bufferData[dstOffset + 3] = 1;
                    time += frameRate;
                  }
                } else throw new Error("Unsupported animation sampler interpolation.");
                break;
              case "rotation":
                if (numFrame * outputAccessor.numComponents == outputAccessor.data.length) {
                  for (var nFrame = 0; nFrame < numFrame; nFrame++) {
                    var srcOffset = nFrame * outputAccessor.numComponents;
                    var dstOffset = skeletonPoseLength * nFrame + 12 * joint.index + 4;
                    bufferData[dstOffset + 0] = outputAccessor.data[srcOffset + 0];
                    bufferData[dstOffset + 1] = outputAccessor.data[srcOffset + 1];
                    bufferData[dstOffset + 2] = outputAccessor.data[srcOffset + 2];
                    bufferData[dstOffset + 3] = outputAccessor.data[srcOffset + 3];
                  }
                } else if (inputAccessor2.data.length == 2) {
                  let time = 0;
                  inputAccessor2.data[0];
                  let t1 = inputAccessor2.data[1];
                  var srcOffsetA = 0 * outputAccessor.numComponents;
                  Vector3.HELP_0.set(
                    outputAccessor.data[srcOffsetA + 0],
                    outputAccessor.data[srcOffsetA + 1],
                    outputAccessor.data[srcOffsetA + 2],
                    outputAccessor.data[srcOffsetA + 3]
                  );
                  var srcOffsetB = 1 * outputAccessor.numComponents;
                  Vector3.HELP_1.set(
                    outputAccessor.data[srcOffsetB + 0],
                    outputAccessor.data[srcOffsetB + 1],
                    outputAccessor.data[srcOffsetB + 2],
                    outputAccessor.data[srcOffsetB + 3]
                  );
                  for (var nFrame = 0; nFrame < numFrame; nFrame++) {
                    let t = time / t1;
                    Vector3.HELP_2.lerp(Vector3.HELP_0, Vector3.HELP_1, t);
                    var dstOffset = skeletonPoseLength * nFrame + 12 * joint.index + 4;
                    bufferData[dstOffset + 0] = Vector3.HELP_2.x;
                    bufferData[dstOffset + 1] = Vector3.HELP_2.y;
                    bufferData[dstOffset + 2] = Vector3.HELP_2.z;
                    bufferData[dstOffset + 3] = Vector3.HELP_2.w;
                    time += frameRate;
                  }
                } else throw new Error("Unsupported animation sampler interpolation.");
                break;
              case "translation":
                if (numFrame * outputAccessor.numComponents == outputAccessor.data.length) {
                  for (var nFrame = 0; nFrame < numFrame; nFrame++) {
                    var srcOffset = nFrame * outputAccessor.numComponents;
                    var dstOffset = skeletonPoseLength * nFrame + 12 * joint.index + 8;
                    bufferData[dstOffset + 0] = outputAccessor.data[srcOffset + 0];
                    bufferData[dstOffset + 1] = outputAccessor.data[srcOffset + 1];
                    bufferData[dstOffset + 2] = outputAccessor.data[srcOffset + 2];
                    bufferData[dstOffset + 3] = inputAccessor2.data[nFrame * inputAccessor2.numComponents];
                  }
                } else if (inputAccessor2.data.length == 2) {
                  let time = 0;
                  inputAccessor2.data[0];
                  let t1 = inputAccessor2.data[1];
                  var srcOffsetA = 0 * outputAccessor.numComponents;
                  Vector3.HELP_0.set(
                    outputAccessor.data[srcOffsetA + 0],
                    outputAccessor.data[srcOffsetA + 1],
                    outputAccessor.data[srcOffsetA + 2]
                  );
                  var srcOffsetB = 1 * outputAccessor.numComponents;
                  Vector3.HELP_1.set(
                    outputAccessor.data[srcOffsetB + 0],
                    outputAccessor.data[srcOffsetB + 1],
                    outputAccessor.data[srcOffsetB + 2]
                  );
                  for (var nFrame = 0; nFrame < numFrame; nFrame++) {
                    let t = time / t1;
                    Vector3.HELP_2.lerp(Vector3.HELP_0, Vector3.HELP_1, t);
                    var dstOffset = skeletonPoseLength * nFrame + 12 * joint.index + 8;
                    bufferData[dstOffset + 0] = Vector3.HELP_2.x;
                    bufferData[dstOffset + 1] = Vector3.HELP_2.y;
                    bufferData[dstOffset + 2] = Vector3.HELP_2.z;
                    bufferData[dstOffset + 3] = time;
                    time += frameRate;
                  }
                } else throw new Error("Unsupported animation sampler interpolation.");
                break;
            }
          }
        }
        let animationClip = new SkeletonAnimationClip(animation.name, skeleton, numFrame, bufferData);
        return animationClip;
      }
      buildSkeleton(avatarData, parent, nodeId) {
        let node = this.gltf.nodes[nodeId];
        if (!node.name) {
          node.name = "Bone" + avatarData.count;
        }
        let boneData = new PrefabBoneData();
        boneData.boneName = node.name;
        boneData.bonePath = parent ? parent.bonePath + "/" + node.name : node.name;
        boneData.parentBoneName = parent ? parent.boneName : "";
        boneData.boneID = avatarData.count++;
        boneData.parentBoneID = parent ? parent.boneID : -1;
        boneData.instanceID = "";
        boneData.parentInstanceID = "";
        boneData.s = new Vector3(1, 1, 1);
        if (node.scale) {
          boneData.s.set(node.scale[0], node.scale[1], node.scale[2]);
        }
        boneData.q = new Quaternion();
        if (node.rotation) {
          boneData.q.set(node.rotation[0], node.rotation[1], node.rotation[2], node.rotation[3]);
        }
        boneData.t = new Vector3();
        if (node.translation) {
          boneData.t.set(node.translation[0], node.translation[1], node.translation[2]);
        }
        avatarData.boneData.push(boneData);
        avatarData.boneMap.set(boneData.boneName, boneData);
        if (node.children) {
          for (let children of node.children) {
            this.buildSkeleton(avatarData, boneData, children);
          }
        }
      }
      buildSkeletonOld(skeleton, parent, nodeId, depth = 0) {
        let node = this.gltf.nodes[nodeId];
        if (!node.name) {
          node.name = "Node_" + nodeId;
        }
        let joint = new Joint(node.name);
        joint.parent = parent;
        if (node.scale) {
          joint.scale.set(node.scale[0], node.scale[1], node.scale[2]);
        }
        if (node.rotation) {
          joint.rotation.set(node.rotation[0], node.rotation[1], node.rotation[2], node.rotation[3]);
        }
        if (node.translation) {
          joint.translation.set(node.translation[0], node.translation[1], node.translation[2]);
        }
        skeleton.addJoint(joint);
        if (node.children) {
          for (let children of node.children) {
            this.buildSkeletonOld(skeleton, joint, children, depth + 1);
          }
        }
      }
    }

    class GILighting {
      static list = [];
      static add(light) {
        let index = this.list.indexOf(light);
        if (index == -1) {
          this.list.push(light);
        }
      }
      static remove(light) {
        let index = this.list.indexOf(light);
        if (index != -1) {
          this.list.splice(index, 1);
        }
      }
    }

    class LightBase extends ComponentBase {
      /**
       * light name
       */
      name;
      /**
       * light size
       */
      size = 1;
      /**
       * Per-light PCSS penumbra multiplier. Default -1 means "fall back to the
       * global `engine.setting.shadow.shadowSoft`". Set a positive value to
       * override on this light only (e.g. a large area light casts a wider
       * penumbra than a small spotlight). Live-tunable — the value is
       * republished to the GPU each frame via LightEntries.
       */
      get softness() {
        return this.lightData?.softness ?? -1;
      }
      set softness(value) {
        if (this.lightData) this.lightData.softness = value;
      }
      /**
       * light shadow map size
       */
      shadowMapWidth = 0;
      shadowMapHeight = 0;
      /**
       * light source data
       */
      lightData;
      /**
       * fix light direction
       */
      dirFix = 1;
      /**
       * Callback function when binding changes
       */
      bindOnChange;
      needUpdateShadow = true;
      /**
       * Whether to enable real-time rendering of shadows
       */
      realTimeShadow = true;
      _castGI = false;
      _castShadow = false;
      _shadowBoundWidth = 0;
      _shadowBoundHeight = 0;
      _iesProfiles;
      constructor() {
        super();
      }
      init() {
        this.transform.object3D.bound = new BoundingBox(new Vector3(), new Vector3());
        this.lightData = new LightData();
        this.lightData.lightMatrixIndex = this.transform.worldMatrix.index;
      }
      onChange() {
        if (!this.object3D) return;
        if (this.bindOnChange) this.bindOnChange();
        this.transform.object3D.bound.setFromCenterAndSize(this.transform.worldPosition, new Vector3(this.size, this.size, this.size));
        if (this._castGI) {
          EntityCollect.instance.state.giLightingChange = true;
        }
        if (this._castShadow) {
          this.needUpdateShadow = true;
          ShadowLightsCollect.addShadowLight(this);
        } else {
          ShadowLightsCollect.removeShadowLight(this);
        }
        const view = this.transform.view3D;
        if (view) {
          const reflectionPass = view.renderGraph?.getPass("ReflectionPass");
          reflectionPass?.forceUpdate();
        }
      }
      start() {
        const shadow = this.transform.view3D?.engine3D?.setting.shadow;
        if (shadow) {
          if (!this.shadowMapWidth) this.shadowMapWidth = shadow.shadowSize;
          if (!this.shadowMapHeight) this.shadowMapHeight = shadow.shadowSize;
          if (!this.lightData.shadowBias || this.lightData.shadowBias.length === 0) {
            this.lightData.shadowBias = new Array(shadow.maxCascades).fill(0);
          }
          if (!this.lightData.normalBias || this.lightData.normalBias.length === 0) {
            this.lightData.normalBias = new Array(shadow.maxCascades).fill(0);
          }
        }
        this.transform.onPositionChange = () => this.onPositionChange();
        this.transform.onRotationChange = () => this.onRotChange();
        this.onPositionChange();
        this.onRotChange();
      }
      onPositionChange() {
        this.lightData.lightPosition.copy(this.transform.worldPosition);
        this.onChange();
      }
      onRotChange() {
        if (this.dirFix == 1) {
          this.lightData.direction.copy(this.transform.forward);
        } else {
          this.lightData.direction.copy(this.transform.back);
        }
        this.lightData.lightTangent.copy(this.transform.up);
        this.onChange();
      }
      onScaleChange() {
        this.onChange();
      }
      onEnable() {
        this.onChange();
        EntityCollect.instance.addLight(this.transform.scene3D, this);
      }
      onDisable() {
        this.onChange();
        EntityCollect.instance.removeLight(this.transform.scene3D, this);
        ShadowLightsCollect.removeShadowLight(this);
      }
      set iesProfiles(iesProfiles) {
        this._iesProfiles = iesProfiles;
        this.lightData.iesIndex = iesProfiles ? iesProfiles.index : -1;
        this.onChange();
      }
      get iesProfile() {
        return this._iesProfiles;
      }
      /**
       * Get the red component of the lighting color
       */
      get r() {
        return this.lightData.lightColor.r;
      }
      /**
       * Set the red component of the lighting color
       */
      set r(value) {
        this.lightData.lightColor.r = value;
        this.onChange();
      }
      /**
       * Get the green component of the lighting color
       */
      get g() {
        return this.lightData.lightColor.g;
      }
      /**
       * Set the green component of the lighting color
       */
      set g(value) {
        this.lightData.lightColor.g = value;
        this.onChange();
      }
      /**
       * Get the blue component of the lighting color
       */
      get b() {
        return this.lightData.lightColor.b;
      }
      /**
       * Set the blue component of the lighting color
       */
      set b(value) {
        this.lightData.lightColor.b = value;
        this.onChange();
      }
      /**
       * Get light source color
       * @return Color
       */
      get lightColor() {
        return this.lightData.lightColor;
      }
      /**
       * Set light source color
       * @param Color
       */
      set lightColor(value) {
        this.lightData.lightColor = value;
        this.onChange();
      }
      /**
       * Get light source color
       * @return Color
       */
      get color() {
        return this.lightData.lightColor;
      }
      /**
       * Set light source color
       * @param Color
       */
      set color(value) {
        this.lightData.lightColor = value;
        this.onChange();
      }
      /**
       * Get Illumination intensity of light source
       * @return number
       */
      get intensity() {
        return this.lightData.intensity;
      }
      /**
       * Set Illumination intensity of light source
       * @param value
       */
      set intensity(value) {
        this.lightData.intensity = value;
        this.onChange();
      }
      /**
       * Cast Light Shadow
       * @param value 
       *  */
      set castShadow(value) {
        if (value != this._castShadow) {
          this._castShadow = value;
          this.onChange();
        }
      }
      get castShadow() {
        return this._castShadow;
      }
      /**
       * get shadow index at shadow map list
       */
      get shadowIndex() {
        return this.lightData.castShadowIndex;
      }
      /**
      * get gi is enable 
      * @return boolean
      *  */
      get castGI() {
        return this._castGI;
      }
      /**
       * set gi is enable 
       * @param value  
       *  */
      set castGI(value) {
        if (value) {
          GILighting.add(this);
        } else {
          GILighting.remove(this);
        }
        this._castGI = value;
        if (value) this.onChange();
      }
      /**
       * light source direction
       * @return Vector3
       *  */
      get direction() {
        return this.lightData.direction;
      }
      destroy(force) {
        this.bindOnChange = null;
        EntityCollect.instance.removeLight(this.transform.scene3D, this);
        ShadowLightsCollect.removeShadowLight(this);
        this.transform.eventDispatcher.removeEventListener(Transform.ROTATION_ONCHANGE, this.onRotChange, this);
        this.transform.eventDispatcher.removeEventListener(Transform.SCALE_ONCHANGE, this.onScaleChange, this);
        super.destroy(force);
      }
    }

    var __getOwnPropDesc$m = Object.getOwnPropertyDescriptor;
    var __decorateClass$m = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$m(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.DirectLight = class DirectLight extends LightBase {
      /** Orthographic camera used to render the (non-CSM) shadow map. */
      shadowCamera;
      // Debug visualization toggles (wired from GUIUtil). Split so CSM cascade draw
      // and non-CSM orthographic shadow-bound draw can be toggled independently.
      /** Draw the CSM cascade frustums for debugging. */
      debugCSM = false;
      /** Draw the non-CSM orthographic shadow bounds for debugging. */
      debugShadowBound = false;
      /** Per-cascade shadow cameras when CSM is enabled. */
      csmShadowCamera = [];
      /** Cascaded shadow map frustum splitter. */
      frustumCSM;
      /** When true, the CSM cascades are recomputed every frame. */
      csmAutoUpdate = true;
      /** Optional custom cascade split distribution function. */
      csmSplitFunction;
      _enableCSM = false;
      constructor() {
        super();
        this.shadowCamera = CameraUtil.createCamera3DObject(null, "shadowCamera");
        this.shadowCamera.shadowLight = this;
        this.shadowCamera.isShadowCamera = true;
      }
      /** Initialize the shadow camera frustum to a usable default cube. */
      start() {
        super.start();
        this.castGI = true;
        const bound = this.transform.view3D?.engine3D.setting.shadow.shadowBound;
        this._shadowBoundWidth = bound;
        this._shadowBoundHeight = bound;
        this.shadowCamera.left = -bound * 0.5;
        this.shadowCamera.right = bound * 0.5;
        this.shadowCamera.bottom = -bound * 0.5;
        this.shadowCamera.top = bound * 0.5;
        this.shadowCamera.near = 0.01;
        this.shadowCamera.far = bound;
      }
      /**
       * Recompute the per-cascade shadow cameras from the render camera's
       * frustum, using a rotation-invariant sphere fit plus texel snapping
       * to keep cascade shadows stable as the camera moves.
       * @param renderCamera the main rendering camera
       */
      updateShadowCameraCSM(renderCamera) {
        if (!this.csmAutoUpdate) return;
        this.frustumCSM.update(renderCamera.projectionMatrix, renderCamera.pvMatrixInv, renderCamera.near, renderCamera.far, this.transform.view3D.engine3D.setting.shadow, this.csmSplitFunction);
        const mapSize = this.shadowMapWidth || 1;
        const forward = Vector3.negate(this.direction, Vector3.HELP_3).normalize();
        const refUp = Math.abs(forward.y) < 0.99 ? Vector3.UP : Vector3.FORWARD;
        const right = Vector3.cross(refUp, forward, Vector3.HELP_4).normalize();
        const realUp = Vector3.cross(forward, right, Vector3.HELP_5).normalize();
        const sphereCenter = Vector3.HELP_0;
        const snappedCenter = Vector3.HELP_2;
        const shadowPos = Vector3.HELP_6;
        const shadowCameraTarget = Vector3.HELP_1;
        const coverageSafetyFactor = 1.25;
        for (let i = 0; i < this.cascadeNum; i++) {
          const corners = this.frustumCSM.children[i].getWorldCorners();
          sphereCenter.set(0, 0, 0);
          for (let c = 0; c < 8; c++) Vector3.add(sphereCenter, corners[c], sphereCenter);
          sphereCenter.multiplyScalar(1 / 8);
          let radius = 0;
          for (let c = 0; c < 8; c++) {
            const d = Vector3.distance(sphereCenter, corners[c]);
            if (d > radius) radius = d;
          }
          radius = Math.ceil(radius * coverageSafetyFactor);
          const texelSize = 2 * radius / mapSize;
          const cx = Vector3.dot(sphereCenter, right);
          const cy = Vector3.dot(sphereCenter, realUp);
          const cz = Vector3.dot(sphereCenter, forward);
          const snapX = Math.round(cx / texelSize) * texelSize;
          const snapY = Math.round(cy / texelSize) * texelSize;
          snappedCenter.set(0, 0, 0);
          Vector3.addScaledVector(snappedCenter, right, snapX, snappedCenter);
          Vector3.addScaledVector(snappedCenter, realUp, snapY, snappedCenter);
          Vector3.addScaledVector(snappedCenter, forward, cz, snappedCenter);
          shadowPos.copy(this.direction).normalize(renderCamera.far);
          Vector3.add(snappedCenter, shadowPos, shadowCameraTarget);
          Vector3.sub(snappedCenter, shadowPos, shadowPos);
          const castPullback = renderCamera.far;
          this.csmShadowCamera[i].near = -castPullback;
          this.csmShadowCamera[i].far = renderCamera.far * 2;
          this.csmShadowCamera[i].transform.lookAt(shadowPos, shadowCameraTarget);
          this.csmShadowCamera[i].orthoOffCenter(-radius, radius, -radius, radius, -castPullback, renderCamera.far * 2);
        }
      }
      // RFC-003 Layer C: 'auto' lets ShadowBiasCalculator derive a texelSize-based
      // value from the cascade frustum + shadow map size. Setting a number overrides
      // it (NDC depth units for shadowBias, world units for normalBias).
      _shadowBias = "auto";
      _normalBias = "auto";
      /** Whether cascaded shadow maps (CSM) are enabled for this light. */
      get enableCSM() {
        return this._enableCSM;
      }
      /** Enable or disable cascaded shadow maps (defaults to 4 cascades). */
      set enableCSM(value) {
        if (this._enableCSM != value) {
          if (value) {
            if (this.cascadeNum == 0) {
              this.cascadeNum = 4;
            }
          } else if (this.lightData.csmShadowMapIndex != -1) {
            this.lightData.csmShadowMapIndex = -1;
          }
          this._enableCSM = value;
          this.onChange();
        }
      }
      /** Number of CSM cascades. */
      get cascadeNum() {
        return this.lightData.csmShadowMapNum;
      }
      /** Set the number of CSM cascades (min 1), rebuilding the cascade cameras. */
      set cascadeNum(value) {
        value = Math.max(value, 1);
        if (this.lightData.csmShadowMapNum != value) {
          this.csmShadowCamera = [];
          this.frustumCSM = new FrustumCSM(value);
          for (let i = 0; i < value; i++) {
            const csmCamera = CameraUtil.createCamera3DObject(null, `csmShadowCamera_${i}`);
            csmCamera.shadowLight = this;
            csmCamera.isShadowCamera = true;
            this.csmShadowCamera.push(csmCamera);
          }
          this.lightData.csmShadowMapNum = value;
        }
      }
      /** Shadow depth bias; 'auto' derives a texel-size-based value. */
      get shadowBias() {
        return this._shadowBias;
      }
      /** Set the shadow depth bias (NDC depth units), or 'auto'. */
      set shadowBias(value) {
        if (this._shadowBias != value) {
          this._shadowBias = value;
          this.onChange();
        }
      }
      /** Shadow normal bias; 'auto' derives a texel-size-based value. */
      get normalBias() {
        return this._normalBias;
      }
      /** Set the shadow normal bias (world units), or 'auto'. */
      set normalBias(value) {
        if (this._normalBias != value) {
          this._normalBias = value;
          this.onChange();
        }
      }
      /** Width of the orthographic shadow bound (ignored when CSM is on). */
      get shadowBoundWidth() {
        return this._shadowBoundWidth;
      }
      /** Set the orthographic shadow bound width (ignored when CSM is on). */
      set shadowBoundWidth(value) {
        if (this._shadowBoundWidth != value && !this.enableCSM) {
          this._shadowBoundWidth = value;
          const halfValue = value * 0.5;
          this.shadowCamera.left = -halfValue;
          this.shadowCamera.right = halfValue;
          this.onChange();
        }
      }
      /** Height of the orthographic shadow bound (ignored when CSM is on). */
      get shadowBoundHeight() {
        return this._shadowBoundHeight;
      }
      /** Set the orthographic shadow bound height (ignored when CSM is on). */
      set shadowBoundHeight(value) {
        if (this._shadowBoundHeight != value && !this.enableCSM) {
          this._shadowBoundHeight = value;
          const halfValue = value * 0.5;
          this.shadowCamera.bottom = -halfValue;
          this.shadowCamera.top = halfValue;
          this.onChange();
        }
      }
      /** Near plane of the orthographic shadow bound (ignored when CSM is on). */
      get shadowBoundNear() {
        return this.shadowCamera.near;
      }
      /** Set the orthographic shadow bound near plane (ignored when CSM is on). */
      set shadowBoundNear(value) {
        if (this.shadowCamera.near != value && !this.enableCSM) {
          this.shadowCamera.near = value;
          this.onChange();
        }
      }
      /** Far plane of the orthographic shadow bound (ignored when CSM is on). */
      get shadowBoundFar() {
        return this.shadowCamera.far;
      }
      /** Set the orthographic shadow bound far plane (ignored when CSM is on). */
      set shadowBoundFar(value) {
        if (this.shadowCamera.far != value && !this.enableCSM) {
          this.shadowCamera.far = value;
          this.onChange();
        }
      }
      /** Initialize as a directional light and assign a default name. */
      init() {
        super.init();
        if (this.object3D.name == "") {
          this.object3D.name = "DirectionLight_" + UUID();
        }
        this.radius = Number.MAX_SAFE_INTEGER;
        this.lightData.lightType = LightType.DirectionLight;
        this.lightData.linear = 0;
        this.lightData.quadratic = 0.3;
      }
      /**
       *
       * Get the radius of a directional light source
       */
      get radius() {
        return this.lightData.range;
      }
      /**
       * Set the radius of a directional light source
       */
      set radius(value) {
        this.lightData.range = value;
        this.onChange();
      }
      /**
       * Get the indirect (global illumination) contribution factor of this
       * directional light.
       */
      get indirect() {
        return this.lightData.quadratic;
      }
      /**
       * Set the indirect (global illumination) contribution factor of this
       * directional light.
       */
      set indirect(value) {
        this.lightData.quadratic = value;
        this.onChange();
      }
      // /**
      //  * Set cast shadow
      //  * @param value
      //  **/
      // public set castShadow(value: boolean) {
      //     if (value != this._castShadow) {
      //         this.onChange();
      //     }
      //     this._castShadow = value;
      // }
      // /**
      //  * get cast shadow
      //  * @return boolean
      //  * */
      // public get castShadow(): boolean {
      //     return this.lightData.castShadowIndex as number >= 0;
      // }
      onChange() {
        super.onChange();
      }
      /** Destroy the light and its (parentless) shadow/CSM cameras. */
      destroy(force) {
        super.destroy(force);
        this.shadowCamera?.object3D?.destroy(force);
        this.shadowCamera = null;
        if (this.csmShadowCamera) {
          for (const cam of this.csmShadowCamera) cam?.object3D?.destroy(force);
          this.csmShadowCamera.length = 0;
        }
      }
    };
    exports.DirectLight = __decorateClass$m([
      RegisterComponent(exports.DirectLight, "DirectLight")
    ], exports.DirectLight);

    var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
    var __decorateClass$l = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.PointLight = class PointLight extends LightBase {
      // RFC-003 Layer C: 'auto' lets ShadowBiasCalculator derive the bias from
      // light range + cube map size. Setting a number overrides it (world units).
      _shadowBias = "auto";
      _normalBias = "auto";
      // Debug visualization: when true, GUIUtil draws a wireframe sphere at
      // `range` showing the point light's shadow-affected volume (analog of
      // DirectLight.debugShadowBound).
      debugShadowRange = false;
      // Cube shadow camera near/far (world units). Far also normalizes the stored
      // depth: stored = length(worldPos - lightPos) / shadowCameraFar. A value of
      // 0 means "auto": PointLightShadowRenderer derives shadowCameraFar from
      // light.range. Exposing these lets the user shrink the depth range to the
      // light's actual reach and gain precision without touching the main camera.
      shadowCameraNear = 0.01;
      shadowCameraFar = 0;
      // 0 = auto (use range)
      get shadowBias() {
        return this._shadowBias;
      }
      set shadowBias(value) {
        if (this._shadowBias != value) {
          this._shadowBias = value;
          this.onChange();
        }
      }
      get normalBias() {
        return this._normalBias;
      }
      set normalBias(value) {
        if (this._normalBias != value) {
          this._normalBias = value;
          this.onChange();
        }
      }
      constructor() {
        super();
      }
      init() {
        super.init();
        this.lightData.lightType = LightType.PointLight;
        if (this.object3D.name == "") {
          this.object3D.name = "PointLight" + UUID();
        }
      }
      /**
       *
       * Get the range of the light source
       * @return {number}
       */
      get range() {
        return this.lightData.range;
      }
      /**
       *
       * Set the range of the light source
       * @param {number}
       */
      set range(value) {
        this.lightData.range = value;
        this.onChange();
      }
      /**
       *
       * Get the illumination distance of the light source
       * @type {number}
       * @memberof PointLight
       */
      get at() {
        return this.lightData.linear;
      }
      /**
       *
       * Set the illumination distance of the light source
       * @param {value} It will decay linearly from the maximum value to the current light position at a distance of 0, 
       * with a default value of 0. This means that the intensity of the light will not decrease due to distance
       * @memberof PointLight
       */
      set at(value) {
        this.lightData.linear = value;
        this.onChange();
      }
      /**
       * Get the radius to control the light
       */
      get radius() {
        return this.lightData.radius;
      }
      /**
       * Set the radius of the control light
       */
      set radius(value) {
        this.lightData.radius = value;
        this.onChange();
      }
      /**
       * Get the radius to control the light
       */
      get quadratic() {
        return this.lightData.quadratic;
      }
      /**
       * Set the radius of the control light
       */
      set quadratic(value) {
        this.lightData.quadratic = value;
        this.onChange();
      }
      start() {
        this.transform.rotationX = 90;
        super.start();
      }
      onUpdate() {
      }
      onGraphic(view) {
      }
      /**
       *  enable GUI debug
       */
      debug() {
      }
      debugDraw(show) {
      }
    };
    exports.PointLight = __decorateClass$l([
      RegisterComponent(exports.PointLight, "PointLight")
    ], exports.PointLight);

    var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
    var __decorateClass$k = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SpotLight = class SpotLight extends LightBase {
      // RFC-003 Layer C: 'auto' lets ShadowBiasCalculator derive the bias from
      // light range + cube map size. Setting a number overrides it (world units).
      _shadowBias = "auto";
      _normalBias = "auto";
      // Debug visualization: wireframe cone showing the spot's range / cone angle.
      debugShadowRange = false;
      // See PointLight for semantics. shadowCameraFar = 0 means "auto" (use range).
      shadowCameraNear = 0.01;
      shadowCameraFar = 0;
      get shadowBias() {
        return this._shadowBias;
      }
      set shadowBias(value) {
        if (this._shadowBias != value) {
          this._shadowBias = value;
          this.onChange();
        }
      }
      get normalBias() {
        return this._normalBias;
      }
      set normalBias(value) {
        if (this._normalBias != value) {
          this._normalBias = value;
          this.onChange();
        }
      }
      constructor() {
        super();
      }
      init() {
        super.init();
        this.lightData.lightType = LightType.SpotLight;
        if (this.object3D.name == "") {
          this.object3D.name = "SpotLight" + UUID();
        }
      }
      /**
       * Get the inner cone angle of the light source (as a percentage relative to the outer cone angle)
       */
      get innerAngle() {
        return this.lightData.innerAngle / this.lightData.outerAngle * 100;
      }
      /**
       *
       * Set the inner cone angle of the light source (as a percentage relative to the outer cone angle)
       * @param {value} 0.0 - 100.0
       */
      set innerAngle(value) {
        this.lightData.innerAngle = clamp$2(value, 0, 100) / 100 * this.lightData.outerAngle;
        this.onChange();
      }
      /**
       * Get the outer cone angle of the light source
       * @return number
       */
      get outerAngle() {
        return this.lightData.outerAngle * RADIANS_TO_DEGREES * 2;
      }
      /**
       * Set the outer cone angle of the light source
       * @param {value} 1.0 - 179.0
       */
      set outerAngle(value) {
        this.lightData.outerAngle = clamp$2(value, 1, 179) * DEGREES_TO_RADIANS * 0.5;
        this.onChange();
      }
      /**
       *
       * Get the radius of the light source
       * @return number
       */
      get radius() {
        return this.lightData.radius;
      }
      /**
       *
       * Set the radius of the light source
       * @param {value}
       */
      set radius(value) {
        this.lightData.radius = value;
        this.onChange();
      }
      /**
       * Get the range of the light source
       */
      get range() {
        return this.lightData.range;
      }
      /**
       *
       * Set the range of the light source
       * @param {value}
       */
      set range(value) {
        this.lightData.range = value;
        this.onChange();
      }
      /**
       * Get the illumination distance of the light source
       */
      get at() {
        return this.lightData.linear;
      }
      /**
       * Set the illumination distance of the light source
       */
      set at(value) {
        this.lightData.linear = value;
        this.onChange();
      }
      start() {
        super.start();
        this.lightData.lightType = LightType.SpotLight;
      }
      onUpdate() {
      }
      onGraphic(view) {
      }
      /**
       * enable GUI debug
       */
      debug() {
      }
      debugDraw(show) {
      }
    };
    exports.SpotLight = __decorateClass$k([
      RegisterComponent(exports.SpotLight, "SpotLight")
    ], exports.SpotLight);

    class KHR_materials_clearcoat {
      static apply(gltf, dmaterial, tMaterial) {
        let extensions = dmaterial.extensions;
        if (extensions && extensions[`KHR_materials_clearcoat`]) {
          tMaterial.shader.getDefaultColorShader().setDefine("USE_CLEARCOAT", true);
          let KHR_materials_clearcoat2 = extensions[`KHR_materials_clearcoat`];
          if (`clearcoatFactor` in KHR_materials_clearcoat2) {
            dmaterial.clearcoatFactor = KHR_materials_clearcoat2[`clearcoatFactor`];
            tMaterial.clearcoatFactor = dmaterial.clearcoatFactor;
          }
          if (`clearcoatRoughnessFactor` in KHR_materials_clearcoat2) {
            dmaterial.clearcoatRoughnessFactor = KHR_materials_clearcoat2[`clearcoatRoughnessFactor`];
            tMaterial.clearcoatRoughnessFactor = dmaterial.clearcoatRoughnessFactor;
          }
        }
      }
    }

    class KHR_materials_emissive_strength {
      static apply(gltf, dmaterial, tMaterial, ctx) {
        let extensions = dmaterial.extensions;
        if (extensions && extensions[`KHR_materials_emissive_strength`]) {
          tMaterial.emissiveIntensity = extensions[`KHR_materials_emissive_strength`].emissiveStrength;
          if (tMaterial.emissiveMap == Engine3D.resFor(ctx).blackTexture) {
            tMaterial.emissiveMap = Engine3D.resFor(ctx).whiteTexture;
          }
        } else {
          tMaterial.emissiveIntensity = 1;
        }
      }
    }

    class StandShader extends Shader {
      _ctx;
      constructor(ctx) {
        super();
        this._ctx = ctx;
        let colorShader = new RenderShaderPass("PBRLItShader", "PBRLItShader");
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        colorShader.passType = PassType.COLOR;
        this.addRenderPass(colorShader);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = true;
        shaderState.castShadow = true;
        shaderState.receiveEnv = true;
        shaderState.acceptGI = true;
        shaderState.useLight = true;
        this.setDefine("USE_BRDF", true);
        this.setDefine("USE_ROUGHNESS_G", true);
        this.setDefine("USE_METALLIC_B", true);
        this.setDefine("USE_ALPHA_A", true);
        this.setDefault();
      }
      setDefault() {
        this.setUniformFloat(`shadowBias`, 35e-5);
        this.setUniformColor(`baseColor`, new Color(0.75, 0.75, 0.75, 1));
        this.setUniformColor(`emissiveColor`, new Color(0, 0, 0));
        this.setUniformVector4(`materialF0`, new Vector4(0.04, 0.04, 0.04, 1));
        this.setUniformColor(`specularColor`, new Color(1, 1, 1, 1));
        this.setUniformFloat(`envIntensity`, 1);
        this.setUniformFloat(`normalScale`, 1);
        this.setUniformFloat(`roughness`, 1);
        this.setUniformFloat(`metallic`, 1);
        this.setUniformFloat(`ao`, 1);
        this.setUniformFloat(`roughness_min`, 0);
        this.setUniformFloat(`roughness_max`, 1);
        this.setUniformFloat(`metallic_min`, 0);
        this.setUniformFloat(`metallic_max`, 1);
        this.setUniformFloat(`emissiveIntensity`, 0);
        this.setUniformFloat(`alphaCutoff`, 0);
        this.setUniformFloat(`ior`, 1.5);
        this.setUniformFloat(`clearcoatFactor`, 0);
        this.setUniformFloat(`clearcoatRoughnessFactor`, 0);
        this.setUniformColor(`clearcoatColor`, new Color(1, 1, 1));
        this.setUniformFloat(`clearcoatWeight`, 0);
        this.setUniformFloat(`clearcoatIor`, 1.5);
        this.setUniformFloat(`transmissionFactor`, 0);
        this.setUniformFloat(`thicknessFactor`, 0);
        this.setUniformFloat(`attenuationDistance`, 1e20);
        this.setUniformFloat(`transmissionAlphaMode`, 0);
        this.setUniformColor(`attenuationColor`, new Color(1, 1, 1, 1));
        this.setUniformVector4(`baseMapOffsetSize`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`normalMapOffsetSize`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`emissiveMapOffsetSize`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`roughnessMapOffsetSize`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`metallicMapOffsetSize`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`aoMapOffsetSize`, new Vector4(0, 0, 1, 1));
        const res = Engine3D.resFor(this._ctx);
        this.baseMap = res.whiteTexture;
        this.normalMap = res.normalTexture;
        this.maskMap = res.maskTexture;
        const pyramid = this._ctx ? RTResourceMap.getTexture(this._ctx, "_SceneColorPyramid") : null;
        this.setTexture("sceneColorPyramid", pyramid ?? res.whiteTexture);
      }
      /**
       * The base (albedo) color map.
       */
      get baseMap() {
        return this.getDefaultColorShader().getTexture(`baseMap`);
      }
      /**
       * The base (albedo) color map.
       */
      set baseMap(value) {
        this.getDefaultColorShader().setTexture(`baseMap`, value);
      }
      /**
       * The base (albedo) color tint.
       */
      get baseColor() {
        return this.getDefaultColorShader().getUniform(`baseColor`);
      }
      /**
       * The base (albedo) color tint.
       */
      set baseColor(value) {
        this.getDefaultColorShader().setUniformColor(`baseColor`, value);
      }
      /**
       * The tangent-space normal map.
       */
      get normalMap() {
        return this.getDefaultColorShader().getTexture(`normalMap`);
      }
      /**
       * The tangent-space normal map.
       */
      set normalMap(value) {
        this.getDefaultColorShader().setTexture(`normalMap`, value);
      }
      /**
       * Whether the surface is rendered double-sided.
       */
      get doubleSide() {
        return this.getDefaultColorShader().doubleSide;
      }
      /**
       * Whether the surface is rendered double-sided.
       */
      set doubleSide(value) {
        this.getDefaultColorShader().doubleSide = value;
      }
      /**
       * The alpha cutoff threshold used for alpha-clip rendering.
       */
      get alphaCutoff() {
        return this.getDefaultColorShader().shaderState.alphaCutoff;
      }
      /**
       * The alpha cutoff threshold used for alpha-clip rendering. Setting this
       * also enables the `USE_ALPHACUT` shader define.
       */
      set alphaCutoff(value) {
        this.getDefaultColorShader().setDefine("USE_ALPHACUT", true);
        this.getDefaultColorShader().shaderState.alphaCutoff = value;
        this.getDefaultColorShader().setUniform(`alphaCutoff`, value);
      }
      /**
       * The emissive color.
       */
      get emissiveColor() {
        return this.getDefaultColorShader().getUniform(`emissiveColor`);
      }
      /**
       * The emissive color.
       */
      set emissiveColor(value) {
        this.getDefaultColorShader().setUniform(`emissiveColor`, value);
      }
      /**
       * The emissive intensity multiplier.
       */
      get emissiveIntensity() {
        return this.getDefaultColorShader().getUniform(`emissiveIntensity`);
      }
      /**
       * The emissive intensity multiplier.
       */
      set emissiveIntensity(value) {
        this.getDefaultColorShader().setUniform(`emissiveIntensity`, value);
      }
      /**
       * get transformUV1
       */
      get transformUV1() {
        return this.getDefaultColorShader().uniforms[`transformUV1`].vector4;
      }
      /**
       * set transformUV1
       */
      set transformUV1(value) {
        this.getDefaultColorShader().setUniform(`transformUV1`, value);
      }
      /**
       * get transformUV2
       */
      get uvTransform_2() {
        return this.getDefaultColorShader().uniforms[`transformUV2`].vector4;
      }
      /**
       * set transformUV2
       */
      set uvTransform_2(value) {
        this.getDefaultColorShader().setUniform(`transformUV2`, value);
      }
      /**
       * Whether depth writes are enabled for the color pass.
       */
      get depthWriteEnabled() {
        return this.getDefaultColorShader().shaderState.depthWriteEnabled;
      }
      /**
       * Whether depth writes are enabled for the color pass.
       */
      set depthWriteEnabled(value) {
        this.getDefaultColorShader().shaderState.depthWriteEnabled = value;
      }
      /**
       * get reflectivity
       */
      get materialF0() {
        return this.getDefaultColorShader().uniforms[`materialF0`].vector4;
      }
      /**
       * set reflectivity
       */
      set materialF0(value) {
        this.getDefaultColorShader().setUniform(`materialF0`, value);
      }
      /**
       * The specular color / reflectivity tint.
       */
      get specularColor() {
        return this.getDefaultColorShader().uniforms[`specularColor`].color;
      }
      /**
       * The specular color / reflectivity tint.
       */
      set specularColor(value) {
        this.getDefaultColorShader().setUniform(`specularColor`, value);
      }
      /**
       * get roughness
       */
      get roughness() {
        return this.getDefaultColorShader().uniforms[`roughness`].value;
      }
      /**
       * set roughness
       */
      set roughness(value) {
        this.getDefaultColorShader().setUniform(`roughness`, value);
      }
      /**
       * get metallic
       */
      get metallic() {
        return this.getDefaultColorShader().uniforms[`metallic`].value;
      }
      /**
       * set metallic
       */
      set metallic(value) {
        this.getDefaultColorShader().setUniform(`metallic`, value);
      }
      /**
       * get Ambient Occlussion, dealing with the effect of ambient light on object occlusion
       */
      get ao() {
        return this.getDefaultColorShader().uniforms[`ao`].value;
      }
      /**
       * set Ambient Occlussion, dealing with the effect of ambient light on object occlusion
       */
      set ao(value) {
        this.getDefaultColorShader().setUniform(`ao`, value);
      }
      /**
       * get min metallic
       */
      get metallic_min() {
        return this.getDefaultColorShader().uniforms[`metallic_min`].value;
      }
      /**
       * set min metallic
       */
      set metallic_min(value) {
        this.getDefaultColorShader().setUniform(`metallic_min`, value);
      }
      /**
       * get max metallic
       */
      get metallic_max() {
        return this.getDefaultColorShader().uniforms[`metallic_max`].value;
      }
      /**
       * set max metallic
       */
      set metallic_max(value) {
        this.getDefaultColorShader().setUniform(`metallic_max`, value);
      }
      /**
       * get min roughness
       */
      get roughness_min() {
        return this.getDefaultColorShader().uniforms[`roughness_min`].value;
      }
      /**
       * set min roughness
       */
      set roughness_min(value) {
        this.getDefaultColorShader().setUniform(`roughness_min`, value);
      }
      /**
       * get max roughness
       */
      get roughness_max() {
        return this.getDefaultColorShader().uniforms[`roughness_max`].value;
      }
      /**
       * set max roughness
       */
      set roughness_max(value) {
        this.getDefaultColorShader().setUniform(`roughness_max`, value);
      }
      /**
       * Get the influence of Normal mapping on materials
       */
      get normalScale() {
        return this.getDefaultColorShader().uniforms[`normalScale`].value;
      }
      /**
       * Set the influence of Normal mapping on materials
       */
      set normalScale(value) {
        this.getDefaultColorShader().setUniform(`normalScale`, value);
      }
      /**
       * get Mask Map
       * R_chanel -> AoMap 
       * G_chanel -> Roughness
       * B_chanel -> Metallic
       * A_chanel -> C
       */
      get maskMap() {
        return this.getDefaultColorShader().textures[`maskMap`];
      }
      /**
       * set Mask Map
       * R_chanel -> AoMap 
       * G_chanel -> Roughness
       * B_chanel -> Metallic
       * A_chanel -> C
       */
      set maskMap(value) {
        this.getDefaultColorShader().setDefine(`USE_MR`, true);
        this.getDefaultColorShader().setTexture(`maskMap`, value);
      }
      /**
       * set Ambient Occlussion Map, dealing with the effect of ambient light on object occlusion
       */
      set aoMap(value) {
        if (!value) return;
        this.getDefaultColorShader().setTexture(`aoMap`, value);
        if (value != Engine3D.resFor(this._ctx).whiteTexture) {
          this.getDefaultColorShader().setDefine(`USE_AOTEX`, true);
        }
      }
      /**
       * get Ambient Occlussion Map, dealing with the effect of ambient light on object occlusion
       */
      get aoMap() {
        return this.getDefaultColorShader().textures[`aoMap`];
      }
      /**
       * set clearCoatRoughnessMap
       */
      set clearCoatRoughnessMap(value) {
        if (!value) return;
        this.getDefaultColorShader().setTexture(`clearCoatRoughnessMap`, value);
        this.getDefaultColorShader().setDefine(`USE_CLEARCOAT_ROUGHNESS`, true);
      }
      /**
       * get clearCoatRoughnessMap
       */
      get clearCoatRoughnessMap() {
        return this.getDefaultColorShader().textures[`clearCoatRoughnessMap`];
      }
      /**
       * get brdf query map
       */
      get brdfLUT() {
        return this.getDefaultColorShader().textures[`brdfLUT`];
      }
      /**
       * set brdf query map
       */
      set brdfLUT(value) {
        this.getDefaultColorShader().setTexture(`brdfLUT`, value);
        this.getDefaultColorShader().setTexture(`brdflutMap`, value);
      }
      /**
       * get emissive map
       */
      get emissiveMap() {
        return this.getDefaultColorShader().textures[`emissiveMap`];
      }
      /**
       * set emissive map
       */
      set emissiveMap(value) {
        this.getDefaultColorShader().setTexture(`emissiveMap`, value);
      }
      /**
       * set intensity of environment light or color of sampled by texture
       */
      set envIntensity(value) {
        this.getDefaultColorShader().setUniformFloat(`envIntensity`, value);
      }
      /**
       * get intensity of environment light or color of sampled by texture
       */
      get envIntensity() {
        return this.getDefaultColorShader().uniforms[`envIntensity`].value;
      }
      /**
       * set factor of refractive
       */
      set ior(value) {
        this.getDefaultColorShader().setUniformFloat(`ior`, value);
      }
      /**
       * get factor of refractive
       */
      get ior() {
        return this.getDefaultColorShader().uniforms[`ior`].value;
      }
      /**
       * valid USE_CLEARCOAT define in shader
       */
      useCleanCoat() {
        this.getDefaultColorShader().setDefine("USE_CLEARCOAT", true);
      }
      /**
       * Set the factor of the clearcoat
       */
      set clearcoatFactor(value) {
        this.getDefaultColorShader().setUniformFloat(`clearcoatFactor`, value);
        this.useCleanCoat();
      }
      /**
       * get the factor of the clearcoat
       */
      get clearcoatFactor() {
        return this.getDefaultColorShader().uniforms[`clearcoatFactor`].value;
      }
      /**
       * set the factor of the clearcoat Roughness
       */
      set clearcoatRoughnessFactor(value) {
        this.getDefaultColorShader().setUniformFloat(`clearcoatRoughnessFactor`, value);
        this.useCleanCoat();
      }
      /**
       * get the factor of the clearcoat Roughness
       */
      get clearcoatRoughnessFactor() {
        return this.getDefaultColorShader().uniforms[`clearcoatRoughnessFactor`].value;
      }
      /**
       * set the weight of the clearcoat
       */
      set clearcoatWeight(value) {
        this.getDefaultColorShader().setUniformFloat(`clearcoatWeight`, value);
        this.useCleanCoat();
      }
      /**
       * get the weight of the clearcoat
       */
      get clearcoatWeight() {
        return this.getDefaultColorShader().uniforms[`clearcoatWeight`].value;
      }
      /**
       * get the color of the clearcoat
       */
      set clearcoatColor(value) {
        this.getDefaultColorShader().setUniformColor(`clearcoatColor`, value);
        this.useCleanCoat();
      }
      /**
       * set the color of the clearcoat
       */
      get clearcoatColor() {
        return this.getDefaultColorShader().uniforms[`clearcoatColor`].color;
      }
    }

    class LitMaterial extends Material {
      _alphaMode = "OPAQUE";
      _ctx;
      constructor(ctx) {
        super();
        this._ctx = ctx;
        let shader = new StandShader(ctx);
        this.shader = shader;
      }
      /** Clone this material into a new LitMaterial, copying PBR uniforms and textures. */
      clone() {
        let litMaterial = new LitMaterial();
        let colorPass = litMaterial.shader.getDefaultColorShader();
        let sourceShader = this.shader.getDefaultColorShader();
        colorPass.defineValue = { ...sourceShader.defineValue };
        colorPass.setUniform(`shadowBias`, sourceShader.getUniform(`shadowBias`));
        colorPass.setUniform(`baseColor`, sourceShader.getUniform(`baseColor`));
        colorPass.setUniform(`specularColor`, sourceShader.getUniform(`specularColor`));
        colorPass.setUniform(`emissiveColor`, sourceShader.getUniform(`emissiveColor`));
        colorPass.setUniform(`materialF0`, sourceShader.getUniform(`materialF0`));
        colorPass.setUniform(`envIntensity`, sourceShader.getUniform(`envIntensity`));
        colorPass.setUniform(`normalScale`, sourceShader.getUniform(`normalScale`));
        colorPass.setUniform(`roughness`, sourceShader.getUniform(`roughness`));
        colorPass.setUniform(`metallic`, sourceShader.getUniform(`metallic`));
        colorPass.setUniform(`ao`, sourceShader.getUniform(`ao`));
        colorPass.setUniform(`roughness_min`, sourceShader.getUniform(`roughness_min`));
        colorPass.setUniform(`roughness_max`, sourceShader.getUniform(`roughness_max`));
        colorPass.setUniform(`metallic_min`, sourceShader.getUniform(`metallic_min`));
        colorPass.setUniform(`metallic_max`, sourceShader.getUniform(`metallic_max`));
        colorPass.setUniform(`emissiveIntensity`, sourceShader.getUniform(`emissiveIntensity`));
        colorPass.setUniform(`alphaCutoff`, sourceShader.getUniform(`alphaCutoff`));
        colorPass.setUniform(`ior`, sourceShader.getUniform(`ior`));
        colorPass.setUniform(`clearcoatFactor`, sourceShader.getUniform(`clearcoatFactor`));
        colorPass.setUniform(`clearcoatRoughnessFactor`, sourceShader.getUniform(`clearcoatRoughnessFactor`));
        colorPass.setUniform(`clearcoatColor`, sourceShader.getUniform(`clearcoatColor`));
        colorPass.setUniform(`clearcoatWeight`, sourceShader.getUniform(`clearcoatWeight`));
        colorPass.setUniform(`clearcoatIor`, sourceShader.getUniform(`clearcoatIor`));
        colorPass.setTexture(`baseMap`, sourceShader.getTexture(`baseMap`));
        colorPass.setTexture(`normalMap`, sourceShader.getTexture(`normalMap`));
        colorPass.setTexture(`emissiveMap`, sourceShader.getTexture(`emissiveMap`));
        colorPass.setTexture(`aoMap`, sourceShader.getTexture(`aoMap`));
        colorPass.setTexture(`maskMap`, sourceShader.getTexture(`maskMap`));
        colorPass.setTexture(`empty`, sourceShader.getTexture(`empty`));
        colorPass.setUniform(`baseMapOffsetSize`, sourceShader.getUniform(`baseMapOffsetSize`));
        colorPass.setUniform(`normalMapOffsetSize`, sourceShader.getUniform(`normalMapOffsetSize`));
        colorPass.setUniform(`emissiveMapOffsetSize`, sourceShader.getUniform(`emissiveMapOffsetSize`));
        colorPass.setUniform(`roughnessMapOffsetSize`, sourceShader.getUniform(`roughnessMapOffsetSize`));
        colorPass.setUniform(`metallicMapOffsetSize`, sourceShader.getUniform(`metallicMapOffsetSize`));
        colorPass.setUniform(`aoMapOffsetSize`, sourceShader.getUniform(`aoMapOffsetSize`));
        return litMaterial;
      }
      /** Set the albedo/base color texture. */
      set baseMap(texture) {
        this.shader.setTexture(`baseMap`, texture);
      }
      /** Get the albedo/base color texture. */
      get baseMap() {
        return this.shader.getTexture(`baseMap`);
      }
      /** Set the mask texture. */
      set maskMap(texture) {
        this.shader.setTexture(`maskMap`, texture);
      }
      /** Get the mask texture. */
      get maskMap() {
        return this.shader.getTexture(`maskMap`);
      }
      /** Set the normal map texture. */
      set normalMap(texture) {
        this.shader.setTexture(`normalMap`, texture);
      }
      /** Get the normal map texture. */
      get normalMap() {
        return this.shader.getTexture(`normalMap`);
      }
      /** Set the emissive texture. */
      set emissiveMap(texture) {
        this.shader.setTexture(`emissiveMap`, texture);
      }
      /** Get the emissive texture. */
      get emissiveMap() {
        return this.shader.getTexture(`emissiveMap`);
      }
      /** Set the ambient occlusion texture. */
      set aoMap(texture) {
        this.shader.setTexture(`aoMap`, texture);
      }
      /** Get the ambient occlusion texture. */
      get aoMap() {
        return this.shader.getTexture(`aoMap`);
      }
      /** Set the clearcoat roughness texture and enable the clearcoat shader path. */
      set clearCoatRoughnessMap(texture) {
        this.shader.setTexture(`clearCoatRoughnessMap`, texture);
        this.shader.setDefine(`USE_CLEARCOAT`, true);
        this.shader.setDefine(`USE_CLEARCOAT_ROUGHNESS`, true);
      }
      /** Get the clearcoat roughness texture. */
      get clearCoatRoughnessMap() {
        return this.shader.getTexture(`clearCoatRoughnessMap`);
      }
      /** Set the clearcoat tint color and enable the clearcoat shader path. */
      set clearcoatColor(value) {
        this.shader.setUniformColor(`clearcoatColor`, value);
        this.shader.setDefine(`USE_CLEARCOAT`, true);
      }
      /** Get the clearcoat tint color. */
      get clearcoatColor() {
        return this.shader.getUniformColor(`clearcoatColor`);
      }
      /** Set the clearcoat weight and enable the clearcoat shader path. */
      set clearcoatWeight(value) {
        this.shader.setUniformFloat(`clearcoatWeight`, value);
        this.shader.setDefine(`USE_CLEARCOAT`, true);
      }
      /** Get the clearcoat weight. */
      get clearcoatWeight() {
        return this.shader.getUniformFloat(`clearcoatWeight`);
      }
      /** Set the clearcoat factor and enable the clearcoat shader path. */
      set clearcoatFactor(value) {
        this.shader.setUniformFloat(`clearcoatFactor`, value);
        this.shader.setDefine(`USE_CLEARCOAT`, true);
      }
      /** Get the clearcoat factor. */
      get clearcoatFactor() {
        return this.shader.getUniformFloat(`clearcoatFactor`);
      }
      /** Set the clearcoat roughness factor and enable the clearcoat shader path. */
      set clearcoatRoughnessFactor(value) {
        this.shader.setUniformFloat(`clearcoatRoughnessFactor`, value);
        this.shader.setDefine(`USE_CLEARCOAT`, true);
      }
      /** Get the clearcoat roughness factor. */
      get clearcoatRoughnessFactor() {
        return this.shader.getUniformFloat(`clearcoatRoughnessFactor`);
      }
      /** Set the index of refraction. */
      set ior(value) {
        this.shader.setUniformFloat(`ior`, value);
      }
      /** Get the index of refraction. */
      get ior() {
        return this.shader.getUniformFloat(`ior`);
      }
      /** Set the alpha cutoff threshold and enable the alpha-cut shader path. */
      set alphaCutoff(value) {
        this.shader.setUniform(`alphaCutoff`, value);
        this.shader.setDefine("USE_ALPHACUT", true);
      }
      /** Get the alpha cutoff threshold. */
      get alphaCutoff() {
        return this.shader.getUniform(`alphaCutoff`);
      }
      /** Transmission (KHR_materials_transmission). Setting a non-zero
       *  value turns on the USE_TRANSMISSION shader path — the fragment
       *  samples the SceneColorPyramid at the fragment's screen position
       *  and mixes it into the opaque output.
       *
       *  Transmission materials stay on the OPAQUE queue (renderOrder
       *  < 3000) — the alpha channel is folded into the transmitted
       *  color in the shader. That's the standard PBR-pipeline
       *  contract for refractive surfaces. */
      /** glTF KHR_materials_transmission `transmissionTexture` — R channel
       *  is multiplied with `transmissionFactor` per fragment, so the same
       *  material can have opaque + glassy regions (e.g. a frosted window
       *  with painted bezels). Setting it implies USE_TRANSMISSION. */
      set transmissionMap(texture) {
        this.shader.setTexture(`transmissionMap`, texture);
        this.shader.setDefine(`USE_TRANSMISSIONMAP`, true);
        this.shader.setDefine(`USE_TRANSMISSION`, true);
      }
      /** Get the transmission texture. */
      get transmissionMap() {
        return this.shader.getTexture(`transmissionMap`);
      }
      /** Set the transmission factor, toggling the transmission shader path and resolving the scene color pyramid. */
      set transmissionFactor(value) {
        this.shader.setUniformFloat(`transmissionFactor`, value);
        this.shader.setDefine(`USE_TRANSMISSION`, value > 0);
        if (value > 0) {
          let ctx = this._ctx;
          if (!ctx) {
            try {
              ctx = Engine3D._defaultContext();
            } catch {
              ctx = void 0;
            }
          }
          const pyramid = ctx ? RTResourceMap.getTexture(ctx, "_SceneColorPyramid") : null;
          if (pyramid) {
            this.shader.setTexture("sceneColorPyramid", pyramid);
          } else {
            this.shader.setTexture("sceneColorPyramid", Engine3D.resFor(ctx).whiteTexture);
          }
        }
      }
      /** Get the transmission factor. */
      get transmissionFactor() {
        return this.shader.getUniformFloat(`transmissionFactor`);
      }
      /** Set the volume thickness factor used for transmission attenuation. */
      set thicknessFactor(value) {
        this.shader.setUniformFloat(`thicknessFactor`, value);
      }
      /** Get the volume thickness factor. */
      get thicknessFactor() {
        return this.shader.getUniformFloat(`thicknessFactor`);
      }
      /** glTF KHR_materials_volume `thicknessTexture` — G channel scales
       *  `thicknessFactor` per fragment, so a single material can vary
       *  from thin (bright, near source color) to thick (heavily
       *  attenuated) across its surface. Setting it enables the
       *  USE_THICKNESSMAP shader path. */
      set thicknessMap(texture) {
        this.shader.setTexture(`thicknessMap`, texture);
        this.shader.setDefine(`USE_THICKNESSMAP`, true);
      }
      /** Get the thickness texture. */
      get thicknessMap() {
        return this.shader.getTexture(`thicknessMap`);
      }
      /** Distance (in world units) after which the transmitted radiance
       *  has been attenuated to `1/e` of its initial intensity. Use
       *  `Number.POSITIVE_INFINITY` to disable attenuation. */
      set attenuationDistance(value) {
        const clamped = isFinite(value) ? value : 1e20;
        this.shader.setUniformFloat(`attenuationDistance`, clamped);
      }
      /** Get the attenuation distance, returning Infinity when attenuation is effectively disabled. */
      get attenuationDistance() {
        const v = this.shader.getUniformFloat(`attenuationDistance`);
        return v >= 1e18 ? Number.POSITIVE_INFINITY : v;
      }
      /** Set the attenuation (transmission absorption) color. */
      set attenuationColor(value) {
        this.shader.setUniformColor(`attenuationColor`, value);
      }
      /** Get the attenuation (transmission absorption) color. */
      get attenuationColor() {
        return this.shader.getUniformColor(`attenuationColor`);
      }
      /** When set to true, the transmission shader path attenuates this
       *  fragment's output alpha by transmission as well as RGB so an
       *  `alpha:true` swapchain composites whatever's behind the canvas
       *  (HTML page background, video element, ...) through the glass.
       *  Off by default — opaque-queue draws keep alpha=1 so demos that
       *  share an opaque canvas with other geometry don't inherit
       *  unwanted blending. */
      set transmissionAlphaMode(value) {
        this.shader.setUniformFloat(`transmissionAlphaMode`, value ? 1 : 0);
      }
      /** Whether transmission also attenuates the output alpha for see-through compositing. */
      get transmissionAlphaMode() {
        return this.shader.getUniformFloat(`transmissionAlphaMode`) > 0.5;
      }
      /** glTF-aligned alpha handling. See {@link AlphaMode}. */
      get alphaMode() {
        return this._alphaMode;
      }
      /** Set the glTF-aligned alpha mode, configuring blend/discard state and render queue accordingly. */
      set alphaMode(mode) {
        if (this._alphaMode === mode) return;
        this._alphaMode = mode;
        const colorPass = this.shader.getDefaultColorShader();
        const state = colorPass.shaderState;
        switch (mode) {
          case "OPAQUE":
            state.transparent = false;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHACUT", false);
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 0;
            break;
          case "MASK":
            state.transparent = false;
            state.alphaToCoverageEnabled = true;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHACUT", true);
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 0;
            break;
          case "HASH":
            state.transparent = false;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHACUT", false);
            colorPass.setDefine("USE_ALPHAHASH", true);
            colorPass.renderOrder = 0;
            break;
          case "BLEND":
            state.transparent = true;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NORMAL;
            state.depthWriteEnabled = false;
            colorPass.setDefine("USE_ALPHACUT", false);
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 3e3;
            break;
        }
        this._notifyRenderClassificationDirty();
      }
      /**
       * set base color (tint color)
       */
      set baseColor(color) {
        this.shader.setUniformColor(`baseColor`, color);
      }
      /**
       * get base color (tint color)
       */
      get baseColor() {
        return this.shader.getUniformColor("baseColor");
      }
      /** Get the surface roughness. */
      get roughness() {
        return this.shader.getUniformFloat("roughness");
      }
      /** Set the surface roughness. */
      set roughness(value) {
        this.shader.setUniformFloat("roughness", value);
      }
      /** Get the metallic factor. */
      get metallic() {
        return this.shader.getUniformFloat("metallic");
      }
      /** Set the metallic factor. */
      set metallic(value) {
        this.shader.setUniformFloat("metallic", value);
      }
      /** Get the emissive color. */
      get emissiveColor() {
        return this.shader.getUniformColor("emissiveColor");
      }
      /** Set the emissive color. */
      set emissiveColor(value) {
        this.shader.setUniformColor("emissiveColor", value);
      }
      /** Get the emissive intensity. */
      get emissiveIntensity() {
        return this.shader.getUniformFloat("emissiveIntensity");
      }
      /** Set the emissive intensity. */
      set emissiveIntensity(value) {
        this.shader.setUniformFloat("emissiveIntensity", value);
      }
      /** Get the ambient occlusion factor. */
      get ao() {
        return this.shader.getUniform(`ao`);
      }
      /** Set the ambient occlusion factor. */
      set ao(value) {
        this.shader.setUniform(`ao`, value);
      }
    }

    class KHR_materials_ior {
      static apply(_gltf, dmaterial, tMaterial) {
        const extensions = dmaterial.extensions;
        if (!extensions || !extensions[`KHR_materials_ior`]) return;
        const ext = extensions[`KHR_materials_ior`];
        const ior = typeof ext[`ior`] === "number" ? ext[`ior`] : 1.5;
        dmaterial.ior = ior;
        if (tMaterial instanceof LitMaterial) {
          tMaterial.ior = ior;
        }
      }
    }

    class KHR_materials_transmission {
      static apply(_gltf, dmaterial, tMaterial) {
        const extensions = dmaterial.extensions;
        if (!extensions || !extensions[`KHR_materials_transmission`]) return;
        const ext = extensions[`KHR_materials_transmission`];
        const factor = typeof ext[`transmissionFactor`] === "number" ? ext[`transmissionFactor`] : 0;
        dmaterial.transmissionFactor = factor;
        if (tMaterial instanceof LitMaterial) {
          tMaterial.transmissionFactor = factor;
          if (dmaterial.transmissionTextureResolved) {
            tMaterial.transmissionMap = dmaterial.transmissionTextureResolved;
          }
        }
      }
    }

    class KHR_materials_unlit {
      static apply(gltf, dmaterial, tMaterial) {
        let extensions = dmaterial.extensions;
        if (extensions && extensions[`KHR_materials_unlit`]) {
          tMaterial.supportLight = true;
        } else {
          tMaterial.supportLight = false;
        }
      }
    }

    class KHR_materials_volume {
      static apply(_gltf, dmaterial, tMaterial) {
        const extensions = dmaterial.extensions;
        if (!extensions || !extensions[`KHR_materials_volume`]) return;
        const ext = extensions[`KHR_materials_volume`];
        const thickness = typeof ext[`thicknessFactor`] === "number" ? ext[`thicknessFactor`] : 0;
        const attenDist = typeof ext[`attenuationDistance`] === "number" ? ext[`attenuationDistance`] : Number.POSITIVE_INFINITY;
        const attenColorArr = Array.isArray(ext[`attenuationColor`]) ? ext[`attenuationColor`] : [1, 1, 1];
        const attenColor = new Color(attenColorArr[0] ?? 1, attenColorArr[1] ?? 1, attenColorArr[2] ?? 1, 1);
        dmaterial.thicknessFactor = thickness;
        dmaterial.attenuationDistance = attenDist;
        dmaterial.attenuationColor = attenColor;
        if (tMaterial instanceof LitMaterial) {
          tMaterial.thicknessFactor = thickness;
          tMaterial.attenuationDistance = attenDist;
          tMaterial.attenuationColor = attenColor;
        }
        if (ext[`thicknessTexture`]) {
          dmaterial.thicknessTexture = ext[`thicknessTexture`];
          if (dmaterial.thicknessTextureResolved && tMaterial instanceof LitMaterial) {
            tMaterial.thicknessMap = dmaterial.thicknessTextureResolved;
          }
        }
      }
    }

    class GLTFSubParserConverter {
      gltf;
      subParser;
      _testCount = 8;
      _hasCastShadow = false;
      constructor(subParser) {
        this.gltf = subParser.gltf;
        this.subParser = subParser;
      }
      async convertNodeToObject3D(nodeInfo, parentNode) {
        const node = new exports.Object3D();
        node.name = nodeInfo.name;
        node[GLTFType.GLTF_NODE_INDEX_PROPERTY] = nodeInfo.nodeId;
        nodeInfo["nodeObj"] = node;
        if (nodeInfo.matrix) {
          nodeInfo.translation = [0, 0, 0];
          nodeInfo.rotation = [0, 0, 0, 1];
          nodeInfo.scale = [1, 1, 1];
        }
        if (nodeInfo.translation) {
          node.transform.x = nodeInfo.translation[0];
          node.transform.y = nodeInfo.translation[1];
          node.transform.z = nodeInfo.translation[2];
        }
        if (nodeInfo.rotation) {
          let qat = new Quaternion();
          qat.setFromArray(nodeInfo.rotation);
          node.transform.localRotQuat = qat;
        }
        if (nodeInfo.scale) {
          node.transform.scaleX = nodeInfo.scale[0];
          node.transform.scaleY = nodeInfo.scale[1];
          node.transform.scaleZ = nodeInfo.scale[2];
        }
        parentNode.addChild(node);
        if (nodeInfo.light) {
          this.convertLight(nodeInfo, node);
        }
        if (nodeInfo.primitives) {
          this.convertprimitives(nodeInfo, node);
        }
        if (nodeInfo["skeleton"]) {
          this.convertSkeletonAnim(node, nodeInfo["skeleton"]);
        }
        return node;
      }
      convertSkeletonAnim(node, skeletonInfo) {
        let avatarData = this.subParser.parseSkeleton(skeletonInfo.skeleton);
        Engine3D.resFor(this.subParser.ctx).addObj(avatarData.name, avatarData);
        let clips = [];
        if (this.gltf.animations) {
          for (let i = 0; i < this.gltf.animations.length; i++) {
            let animation = this.gltf.animations[i];
            if (!animation.name) animation.name = i.toString();
            let clip = this.subParser.parseSkeletonAnimation(avatarData, animation);
            clips.push(clip);
          }
        }
        let animator = node.addComponent(exports.AnimatorComponent);
        animator.avatar = avatarData.name;
        animator.clips = clips;
        if (skeletonInfo._pendingSkinned) {
          for (const smr of skeletonInfo._pendingSkinned) {
            smr.skeletonAnimation = animator;
          }
          skeletonInfo._pendingSkinned = null;
        }
      }
      convertLight(nodeInfo, node) {
        switch (nodeInfo.light.type) {
          case `directional`:
            let directLight = node.addComponent(exports.DirectLight);
            node.name = nodeInfo.light.name;
            directLight.intensity = nodeInfo.light.intensity * 0.1;
            directLight.radius = Number.MAX_SAFE_INTEGER;
            directLight.dirFix = -1;
            if (!this._hasCastShadow) {
              this._hasCastShadow = true;
              directLight.castShadow = this._hasCastShadow;
            }
            directLight.lightColor = nodeInfo.light.color ? new Color(nodeInfo.light.color[0], nodeInfo.light.color[1], nodeInfo.light.color[2]) : new Color(1, 1, 1, 1);
            break;
          case `point`:
            if (this._testCount > 0) {
              let point = node.addComponent(exports.PointLight);
              point.name = nodeInfo.light.name;
              point.intensity = nodeInfo.light.intensity ? nodeInfo.light.intensity * 8 * 2 : 1;
              point.radius = 8;
              point.at = 2;
              point.range = nodeInfo.light.range ? nodeInfo.light.range : 8;
              point.lightColor = nodeInfo.light.color ? new Color(nodeInfo.light.color[0], nodeInfo.light.color[1], nodeInfo.light.color[2]) : new Color(1, 1, 1, 1);
            }
            this._testCount--;
            break;
          case `spot`:
            let spot = node.addComponent(exports.SpotLight);
            spot.name = nodeInfo.light.name;
            spot.intensity = nodeInfo.light.intensity * 5;
            spot.radius = 1;
            spot.dirFix = -1;
            spot.at = 2;
            spot.range = nodeInfo.light.range ? nodeInfo.light.range : 8;
            spot.outerAngle = nodeInfo.light.spot.outerConeAngle * RADIANS_TO_DEGREES;
            spot.lightColor = nodeInfo.light.color ? new Color(nodeInfo.light.color[0], nodeInfo.light.color[1], nodeInfo.light.color[2]) : new Color(1, 1, 1, 1);
            break;
        }
      }
      convertprimitives(nodeInfo, node) {
        for (let i = 0; i < nodeInfo.primitives.length; i++) {
          const primitive = nodeInfo.primitives[i];
          primitive.modelName;
          let md = primitive.material;
          if (md.name == void 0) {
            md.name = UUID();
          }
          let mat;
          let materialKey = `matkey_${md.name}`;
          if (md && this.gltf.resources[materialKey]) {
            mat = this.gltf.resources[materialKey];
          } else {
            let newMat = mat = new LitMaterial();
            this.gltf.resources[materialKey] = newMat;
            newMat.name = md.name;
            let gltfMat = md;
            if (gltfMat) {
              const { baseColorTexture, baseColorFactor, metallicFactor, roughnessFactor, doubleSided, metallicRoughnessTexture, normalTexture, occlusionTexture, emissiveTexture, emissiveFactor, enableBlend, alphaCutoff } = gltfMat;
              let physicMaterial = newMat = this.applyMaterialExtensions(gltfMat, newMat);
              if (`enableBlend` in gltfMat) {
                if (gltfMat[`enableBlend`]) {
                  let defines = gltfMat.defines;
                  if (defines?.includes("ALPHA_BLEND")) {
                    physicMaterial.blendMode = BlendMode.ALPHA;
                  } else {
                    physicMaterial.blendMode = BlendMode.NORMAL;
                  }
                  physicMaterial.castShadow = false;
                } else {
                  physicMaterial.blendMode = BlendMode.NONE;
                }
              }
              if (`alphaCutoff` in gltfMat && alphaCutoff > 0 && alphaCutoff < 1) {
                physicMaterial.setUniformFloat("alphaCutoff", alphaCutoff);
                physicMaterial.blendMode = BlendMode.NORMAL;
                physicMaterial.transparent = true;
              }
              if (gltfMat.baseMapOffsetSize) {
                physicMaterial.setUniformVector4("baseMapOffsetSize", gltfMat.baseMapOffsetSize);
              }
              if (gltfMat.normalMapOffsetSize) {
                physicMaterial.setUniformVector4("normalMapOffsetSize", gltfMat.normalMapOffsetSize);
              }
              if (gltfMat.emissiveMapOffsetSize) {
                physicMaterial.setUniformVector4("emissiveMapOffsetSize", gltfMat.emissiveMapOffsetSize);
              }
              if (gltfMat.roughnessMapOffsetSize) {
                physicMaterial.setUniformVector4("roughnessMapOffsetSize", gltfMat.roughnessMapOffsetSize);
              }
              if (gltfMat.metallicMapOffsetSize) {
                physicMaterial.setUniformVector4("metallicMapOffsetSize", gltfMat.metallicMapOffsetSize);
              }
              if (gltfMat.aoMapOffsetSize) {
                physicMaterial.setUniformVector4("aoMapOffsetSize", gltfMat.aoMapOffsetSize);
              }
              physicMaterial.setUniformColor("baseColor", new Color(baseColorFactor[0], baseColorFactor[1], baseColorFactor[2], baseColorFactor[3]));
              physicMaterial.setUniformFloat("roughness", roughnessFactor);
              physicMaterial.setUniformFloat("metallic", metallicFactor);
              physicMaterial.setUniformFloat("ao", 1);
              physicMaterial.doubleSide = doubleSided;
              if (baseColorTexture) {
                physicMaterial.setTexture("baseMap", baseColorTexture);
                if (baseColorTexture.format === "rgba8unorm-srgb") {
                  physicMaterial.shader.setDefine("USE_SRGB_ALBEDO", true);
                }
              }
              if (normalTexture) {
                physicMaterial.setTexture("normalMap", normalTexture);
              }
              if (metallicRoughnessTexture) {
                physicMaterial.setTexture("maskMap", metallicRoughnessTexture);
              }
              if (emissiveTexture) {
                physicMaterial.setTexture("emissiveMap", emissiveTexture);
              }
              if (emissiveFactor && (emissiveFactor[0] > 0 || emissiveFactor[1] > 0 || emissiveFactor[2] > 0)) {
                if (!physicMaterial.shader.getTexture("emissiveMap")) {
                  physicMaterial.shader.setTexture("emissiveMap", Engine3D.resFor(this.subParser.ctx).whiteTexture);
                }
                physicMaterial.shader.setDefine("USE_EMISSIVEMAP", true);
                physicMaterial.setUniformColor("emissiveColor", new Color(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], emissiveFactor[3]));
                if (physicMaterial.blendMode != BlendMode.NONE) {
                  physicMaterial.blendMode = BlendMode.ADD;
                }
                let emissiveIntensity = mat.getUniformFloat("emissiveIntensity");
                if (!emissiveIntensity || emissiveIntensity <= 0) {
                  mat.setUniformFloat("emissiveIntensity", 1);
                }
              }
            }
          }
          const { attribArrays, modelName, drawMode } = primitive;
          let geometry;
          if (!attribArrays[`indices`].data) {
            let indices = [];
            let count = attribArrays["position"].data.length / 3 / 3;
            for (let i2 = 0; i2 < count; i2++) {
              let a = i2 * 3;
              indices.push(a + 2);
              indices.push(a + 0);
              indices.push(a + 1);
            }
            attribArrays[`indices`] = {
              data: new Uint8Array(indices),
              normalize: false,
              numComponents: 1
            };
          }
          if (!attribArrays[`normal`]) {
            let normal = [];
            let count = attribArrays["position"].data.length / 3;
            for (let i2 = 0; i2 < count; i2++) {
              normal.push(0);
              normal.push(0);
              normal.push(0);
            }
            attribArrays[`normal`] = {
              data: new Float32Array(normal),
              normalize: false,
              numComponents: 3
            };
          }
          if (attribArrays[`indices`].data && attribArrays[`indices`].data.length > 3) {
            let meshName2 = primitive.meshName();
            if (this.gltf.resources[meshName2]) {
              geometry = this.gltf.resources[meshName2];
            }
            const model = new exports.Object3D();
            model.name = modelName + i;
            let skinSkeletonId = void 0;
            if (nodeInfo.skin) {
              skinSkeletonId = nodeInfo.skin.skeleton;
            }
            const hasSkin = nodeInfo.skin && attribArrays[VertexAttributeName.joints0] != void 0 && skinSkeletonId !== void 0 && this.gltf.nodes[skinSkeletonId];
            if (hasSkin) {
              geometry ||= this.createGeometryBase(modelName, attribArrays, primitive, nodeInfo.skin);
              this.gltf.resources[meshName2] = geometry;
              const skeletonNode = this.gltf.nodes[skinSkeletonId];
              if (skeletonNode.dnode && skeletonNode.dnode["nodeObj"]) {
                this.convertSkeletonAnim(node, nodeInfo.skin);
              } else {
                if (!skeletonNode.dnode) skeletonNode.dnode = {};
                const existing = skeletonNode.dnode["skeleton"];
                if (!existing || (nodeInfo.skin.joints?.length ?? 0) > (existing.joints?.length ?? 0)) {
                  skeletonNode.dnode["skeleton"] = nodeInfo.skin;
                }
              }
              let smr = model.addComponent(exports.SkinnedMeshRenderer2);
              smr.geometry = geometry;
              smr.material = mat.clone();
              const animOnSkeleton = skeletonNode.dnode && skeletonNode.dnode["nodeObj"] ? skeletonNode.dnode["nodeObj"].getComponent(exports.AnimatorComponent) : null;
              if (animOnSkeleton) {
                smr.skeletonAnimation = animOnSkeleton;
              } else {
                const queueOwner = skeletonNode.dnode && skeletonNode.dnode["skeleton"] || nodeInfo.skin;
                if (!queueOwner._pendingSkinned) queueOwner._pendingSkinned = [];
                queueOwner._pendingSkinned.push(smr);
              }
            } else {
              geometry ||= this.createGeometryBase(modelName, attribArrays, primitive);
              this.gltf.resources[meshName2] = geometry;
              if (geometry.hasAttribute(VertexAttributeName.joints0)) {
                geometry.vertexAttributeMap.delete(VertexAttributeName.joints0);
              }
              let mc = model.addComponent(exports.MeshRenderer);
              mc.castShadow = true;
              mc.castGI = true;
              mc.geometry = geometry;
              mc.material = mat;
              if (nodeInfo.skin && !attribArrays[VertexAttributeName.joints0]) {
                mc.enable = false;
              }
            }
            nodeInfo.skin && nodeInfo.skin.defines || [];
            node.addChild(model);
          }
        }
      }
      createGeometryBase(name, attribArrays, primitive, skin) {
        if ("indices" in attribArrays) {
          let bigIndices = attribArrays[`indices`].data.length > 65534;
          if (bigIndices) {
            attribArrays[`indices`].data = new Uint32Array(attribArrays[`indices`].data);
          } else {
            attribArrays[`indices`].data = new Uint16Array(attribArrays[`indices`].data);
          }
        }
        let geometry = new GeometryBase();
        geometry.name = name;
        if ("indices" in attribArrays) {
          let bigIndices = attribArrays[`indices`].data.length > 65535;
          if (bigIndices) {
            attribArrays[`indices`].data = new Uint32Array(attribArrays[`indices`].data);
          } else {
            attribArrays[`indices`].data = new Uint16Array(attribArrays[`indices`].data);
          }
        }
        if (primitive.morphTargetsRelative) {
          let blendShapeData = new BlendShapeData();
          let targetNames2 = primitive.targetNames;
          if (targetNames2 && targetNames2.length > 0) {
            blendShapeData.shapeNames = [];
            blendShapeData.shapeIndexs = [];
            for (let i = 0; i < targetNames2.length; i++) {
              blendShapeData.shapeNames.push(targetNames2[i]);
              blendShapeData.shapeIndexs.push(i);
            }
          }
          blendShapeData.vertexCount = attribArrays["position"].data.length / 3;
          blendShapeData.blendCount = blendShapeData.shapeNames.length;
          blendShapeData.blendShapePropertyDatas = [];
          blendShapeData.blendShapeMap = /* @__PURE__ */ new Map();
          for (let i = 0; i < blendShapeData.blendCount; i++) {
            let propertyData = new BlendShapePropertyData();
            propertyData.shapeName = blendShapeData.shapeNames[i];
            propertyData.shapeIndex = blendShapeData.shapeIndexs[i];
            propertyData.frameCount = 1;
            propertyData.blendPositionList = attribArrays[GLTFType.MORPH_POSITION_PREFIX + i].data;
            propertyData.blendNormalList = attribArrays[GLTFType.MORPH_NORMAL_PREFIX + i].data;
            blendShapeData.blendShapePropertyDatas.push(propertyData);
            blendShapeData.blendShapeMap.set(propertyData.shapeName, propertyData);
          }
          geometry.blendShapeData = blendShapeData;
        }
        geometry.morphTargetsRelative = primitive.morphTargetsRelative;
        let targetNames = primitive.targetNames;
        if (targetNames && targetNames.length > 0) {
          let morphTargetDictionary = geometry.morphTargetDictionary = {};
          for (let i = 0; i < targetNames.length; i++) {
            morphTargetDictionary[targetNames[i]] = i;
          }
        }
        if (geometry.morphTargetDictionary) {
          let vertexCount = attribArrays["position"].data.length / 3;
          let vIndexArray = new Float32Array(vertexCount);
          for (let i = 0; i < vertexCount; i++) {
            vIndexArray[i] = i;
          }
          attribArrays[`vIndex`] = {
            data: vIndexArray,
            normalize: false,
            numComponents: 1
          };
        }
        const wAttr0 = attribArrays[VertexAttributeName.weights0];
        const wAttr1 = attribArrays[VertexAttributeName.weights1];
        if (wAttr0?.data) {
          const toFloat32 = (acc) => {
            if (!acc || acc.data instanceof Float32Array) return;
            const src = acc.data;
            const dst = new Float32Array(src.length);
            const scale = acc.normalize ? src instanceof Uint8Array ? 1 / 255 : src instanceof Uint16Array ? 1 / 65535 : src instanceof Int8Array ? 1 / 127 : src instanceof Int16Array ? 1 / 32767 : 1 : 1;
            for (let i = 0; i < src.length; i++) dst[i] = src[i] * scale;
            acc.data = dst;
            acc.normalize = false;
          };
          toFloat32(wAttr0);
          toFloat32(wAttr1);
          const w0 = wAttr0.data;
          const w1 = wAttr1?.data ?? null;
          const vCount = w0.length / 4;
          for (let v = 0; v < vCount; v++) {
            let s = w0[v * 4] + w0[v * 4 + 1] + w0[v * 4 + 2] + w0[v * 4 + 3];
            if (w1) s += w1[v * 4] + w1[v * 4 + 1] + w1[v * 4 + 2] + w1[v * 4 + 3];
            if (s <= 1e-6) {
              w0[v * 4] = 1;
              w0[v * 4 + 1] = 0;
              w0[v * 4 + 2] = 0;
              w0[v * 4 + 3] = 0;
              if (w1) {
                w1[v * 4] = 0;
                w1[v * 4 + 1] = 0;
                w1[v * 4 + 2] = 0;
                w1[v * 4 + 3] = 0;
              }
            } else if (Math.abs(s - 1) > 1e-4) {
              const inv = 1 / s;
              w0[v * 4] *= inv;
              w0[v * 4 + 1] *= inv;
              w0[v * 4 + 2] *= inv;
              w0[v * 4 + 3] *= inv;
              if (w1) {
                w1[v * 4] *= inv;
                w1[v * 4 + 1] *= inv;
                w1[v * 4 + 2] *= inv;
                w1[v * 4 + 3] *= inv;
              }
            }
          }
        }
        for (const attributeName in attribArrays) {
          const m = attributeName.match(/^TEXCOORD_(\d+)$/);
          if (m && parseInt(m[1]) >= 2) {
            delete attribArrays[attributeName];
            continue;
          }
          let attributeData = attribArrays[attributeName];
          geometry.setAttribute(attributeName, attributeData.data);
        }
        if (skin) {
          geometry.skinNames = new Array(skin.joints.length);
          for (let i = 0; i < skin.joints.length; i++) {
            const id = skin.joints[i];
            const node = this.gltf.nodes[id];
            geometry.skinNames[i] = node.name;
          }
          geometry.bindPose = new Array(skin.inverseBindMatrices.length);
          for (let i = 0; i < skin.inverseBindMatrices.length; i++) {
            const m = skin.inverseBindMatrices[i];
            let mat = new Matrix4();
            mat.rawData.set(m);
            geometry.bindPose[i] = mat;
          }
        }
        let indicesAttribute = geometry.getAttribute(VertexAttributeName.indices);
        geometry.addSubGeometry(
          {
            indexStart: 0,
            indexCount: indicesAttribute.data.length,
            vertexStart: 0,
            index: 0,
            vertexCount: 0,
            firstStart: 0,
            topology: 0
          }
        );
        return geometry;
      }
      applyMaterialExtensions(dmaterial, mat) {
        if (dmaterial.extensions) {
          KHR_materials_clearcoat.apply(this.gltf, dmaterial, mat);
          KHR_materials_unlit.apply(this.gltf, dmaterial, mat);
          KHR_materials_emissive_strength.apply(this.gltf, dmaterial, mat, this.subParser.ctx);
          KHR_materials_ior.apply(this.gltf, dmaterial, mat);
          KHR_materials_transmission.apply(this.gltf, dmaterial, mat);
          KHR_materials_volume.apply(this.gltf, dmaterial, mat);
        }
        return mat;
      }
      parseSkinJoints(skin) {
        let skinJointsName = [];
        for (let nodeId of skin.joints) {
          let node = this.gltf.nodes[nodeId];
          skinJointsName.push(node.name);
        }
        return skinJointsName;
      }
    }

    class GLTFSubParser {
      currentSceneName;
      gltf;
      initUrl;
      ctx;
      _generator;
      _version;
      _BASE64_MARKER = ";base64,";
      _cameraParser = null;
      _meshParser = null;
      _materialParser = null;
      _skinParser = null;
      _skeletonParser = null;
      _converter = null;
      constructor(ctx) {
        this.ctx = ctx;
      }
      get version() {
        if (this.version) return this.version;
        else if (this.gltf) {
          if (!this.gltf.asset) return this.errorMiss("asset");
          this._version = this.gltf.asset.version;
          if (this.gltf.asset.minVersion) this._version += `\r minVersion${this.gltf.asset.minVersion}`;
          return this.version;
        }
        console.warn("glTF not loaded.");
        return null;
      }
      async parse(initUrl, gltf, sceneId) {
        this.gltf = gltf;
        this.initUrl = initUrl;
        const { version, generator } = this.gltf.asset;
        this._generator = generator;
        if (version !== "2.0") {
          console.error(`GLTFParser only support glTF 2.0 for now! Received glTF version: ${this.version}`);
          return false;
        }
        const result = {
          nodes: await this.parseScene(sceneId),
          animations: this.parseAnimations(),
          name: this.currentSceneName
        };
        return await this.convertToNode(result);
      }
      destroy() {
        KHR_draco_mesh_compression.unload(this.gltf);
        this.gltf = null;
      }
      async parseScene(sceneId) {
        const loadScene = sceneId || this.gltf.scene || 0;
        const scene = this.gltf.scenes[loadScene];
        if (typeof scene === "undefined")
          return this.errorMiss("scene", loadScene);
        this.currentSceneName = scene.name || "GLTF_NO_NAME_SCENE";
        const result = [];
        const nodes = scene.nodes;
        for (let i = 0; i < nodes.length; i++) {
          const node = await this.parseNode(nodes[i]);
          if (node) result.push(node);
        }
        return result;
      }
      async parseNode(nodeId) {
        const node = this.gltf.nodes[nodeId];
        if (!node)
          return this.errorMiss("node", nodeId);
        if (node.isParsed)
          return node.dnode;
        const { name, matrix, translation, rotation, scale } = node;
        const dnode = {
          name,
          matrix,
          translation,
          rotation,
          scale,
          nodeId,
          camera: null,
          primitives: null,
          skin: null,
          children: null,
          light: null
        };
        if (node.camera !== void 0)
          dnode.camera = this.parseCamera(node.camera);
        if (node.mesh !== void 0)
          dnode.primitives = await this.parseMesh(node.mesh);
        if (node.extensions !== void 0)
          this.applyNodeExtensions(node, dnode);
        if (node.skin !== void 0) {
          const skin = this.parseSkin(node.skin);
          if (skin) dnode.skin = skin;
        }
        dnode.children = [];
        if (node.children) for (let i = 0; i < node.children.length; i++) {
          dnode.children.push(await this.parseNode(node.children[i]));
        }
        node.dnode = dnode;
        node.isParsed = true;
        return node.dnode;
      }
      errorMiss(e, info) {
        throw new Error(e + info);
      }
      parseCamera(cameraId) {
        if (!this._cameraParser) {
          this._cameraParser = new GLTFSubParserCamera(this.gltf);
        }
        return this._cameraParser.parse(cameraId);
      }
      async parseMesh(meshId) {
        if (!this._meshParser) {
          this._meshParser = new GLTFSubParserMesh(this);
        }
        return this._meshParser.parse(meshId);
      }
      async parseTexture(index, colorSpace = "linear") {
        let textureInfo = this.gltf.textures[index];
        if (textureInfo && !textureInfo.dtexture) {
          if (textureInfo && textureInfo.source != null) {
            let image = this.gltf.images[textureInfo.source];
            if (image.uri) {
              let name = image.uri;
              name = StringUtil.getURLName(name);
              let preloaded = this.gltf.resources[name];
              if (colorSpace === "srgb" && preloaded && preloaded.format !== "rgba8unorm-srgb") {
                const url = preloaded.url ?? image.uri;
                textureInfo.dtexture = await Engine3D.resFor(this.ctx).loadTexture(url, void 0, void 0, "srgb");
              } else {
                textureInfo.dtexture = preloaded;
              }
            } else if (image.bufferView) {
              const name = image?.name;
              let bitmapTexture = this.gltf.resources[name];
              if (!bitmapTexture) {
                let buffer = this.parseBufferView(image.bufferView);
                bitmapTexture = new BitmapTexture2D(true, this.ctx, colorSpace);
                let img = new Blob([buffer], { type: image.mimeType });
                await bitmapTexture.loadFromBlob(img);
              }
              textureInfo.dtexture = bitmapTexture;
            } else {
              textureInfo.dtexture = this.gltf.resources[image.name];
            }
          } else if (textureInfo.name) {
            let name = StringUtil.getURLName(textureInfo.name);
            textureInfo.dtexture = this.gltf.resources[name];
          }
        }
        if (!textureInfo.dtexture) {
          console.log("miss texture , please check texture!", index, textureInfo);
        }
        return textureInfo.dtexture;
      }
      async parseMaterial(materialId) {
        if (!this._materialParser) {
          this._materialParser = new GLTFSubParserMaterial(this);
        }
        return this._materialParser.parse(materialId);
      }
      parseAnimations() {
        const result = [];
        return result;
      }
      async parseObject3D(nodeInfo, parentNode) {
        if (!this._converter) {
          this._converter = new GLTFSubParserConverter(this);
        }
        return this._converter.convertNodeToObject3D(nodeInfo, parentNode);
      }
      parseSkeleton(skeletonID) {
        if (!this._skeletonParser) {
          this._skeletonParser = new GLTFSubParserSkeleton(this);
        }
        return this._skeletonParser.parse(skeletonID);
      }
      parseSkeletonAnimation(avatarData, animation) {
        if (!this._skeletonParser) {
          this._skeletonParser = new GLTFSubParserSkeleton(this);
        }
        return this._skeletonParser.parseSkeletonAnimation(avatarData, animation);
      }
      async traverse(parentNode, nodeInfos) {
        for (let i = 0; i < nodeInfos.length; i++) {
          const node = await this.parseObject3D(nodeInfos[i], parentNode);
          await this.traverse(node, nodeInfos[i].children);
        }
      }
      async convertToNode(infos) {
        const rootNode = new exports.Object3D();
        rootNode.name = infos.name;
        const nodes = infos.nodes;
        infos.animations;
        const textures = [];
        const cameras = [];
        await this.traverse(rootNode, nodes);
        let animas;
        return {
          rootNode,
          textures,
          animations: animas,
          cameras
        };
      }
      parseSkin(skinId) {
        if (!this._skinParser) {
          this._skinParser = new GLTFSubParserSkin(this);
        }
        return this._skinParser.parse(skinId);
      }
      parseAccessor(accessorId) {
        const accessor = this.gltf.accessors[accessorId];
        if (!accessor) return this.errorMiss("accessor", accessorId);
        if (accessor.isParsed) return accessor.daccessor;
        accessor.isParsed = true;
        accessor.daccessor = false;
        const normalize = !!accessor.normalized;
        const bufferView = this.gltf.bufferViews[accessor.bufferView];
        const byteStride = bufferView && bufferView.byteStride;
        const arrayType = getTypedArrayTypeFromGLType(accessor.componentType);
        let numComponents = 1;
        switch (accessor.type) {
          case "SCALAR":
            numComponents = 1;
            break;
          case "VEC2":
            numComponents = 2;
            break;
          case "VEC3":
            numComponents = 3;
            break;
          case "VEC4":
          case "MAT2":
            numComponents = 4;
            break;
          case "MAT3":
            numComponents = 9;
            break;
          case "MAT4":
            numComponents = 16;
            break;
          default:
            numComponents = 0;
            break;
        }
        if (numComponents === 0) {
          console.error(`glTF has unknown data type in accessor: ${accessor.type}`);
          return false;
        }
        const componentsBytes = numComponents * arrayType.BYTES_PER_ELEMENT;
        let buffer;
        if (bufferView !== void 0) {
          buffer = this.parseBufferView(accessor.bufferView);
          if (!buffer) return accessor.daccessor;
        } else buffer = new Uint8Array(componentsBytes * accessor.count).buffer;
        let typedArray = this.getTypedArrayFromArrayBuffer(buffer, byteStride, accessor.byteOffset || 0, arrayType, numComponents, accessor.count);
        if (accessor.sparse) {
          const { count, indices, values } = accessor.sparse;
          typedArray = new arrayType(typedArray);
          const indicesByteOffset = indices.byteOffset || 0;
          const indicesBufferView = this.gltf.bufferViews[indices.bufferView];
          const indicesArrayType = getTypedArrayTypeFromGLType(indices.componentType);
          const indicesBuffer = this.parseBufferView(indices.bufferView);
          const indicesArray = this.getTypedArrayFromArrayBuffer(indicesBuffer, indicesBufferView.byteStride, indicesByteOffset, indicesArrayType, 1, count);
          const valuesByteOffset = values.byteOffset || 0;
          const valuesBufferView = this.gltf.bufferViews[values.bufferView];
          const valuesBuffer = this.parseBufferView(values.bufferView);
          const valuesArray = this.getTypedArrayFromArrayBuffer(valuesBuffer, valuesBufferView.byteStride, valuesByteOffset, arrayType, numComponents, count);
          for (let i = 0; i < indicesArray.length; i++) typedArray.set(valuesArray.slice(i * numComponents, i * numComponents + numComponents), indicesArray[i] * numComponents);
        }
        accessor.computeResult = {
          typedArray,
          arrayType,
          numComponents
        };
        accessor.daccessor = {
          data: typedArray,
          numComponents,
          normalize
        };
        return accessor.daccessor;
      }
      getTypedArrayFromArrayBuffer(buffer, byteStride, byteOffset, arrayType, numComponents, count) {
        let typedArray;
        const componentsBytes = numComponents * arrayType.BYTES_PER_ELEMENT;
        if (byteStride && componentsBytes !== byteStride) {
          const arrayLength = numComponents * count;
          typedArray = new arrayType(arrayLength);
          for (let i = 0; i < count; i++) {
            const componentVals = new arrayType(buffer, byteOffset + i * byteStride, numComponents);
            for (let j = 0; j < numComponents; j++) typedArray[i * numComponents + j] = componentVals[j];
          }
        } else typedArray = new arrayType(buffer, byteOffset, count * numComponents);
        return typedArray;
      }
      parseBufferView(bufferViewId) {
        const bufferView = this.gltf.bufferViews[bufferViewId];
        if (!bufferView) return this.errorMiss("bufferView", bufferViewId);
        if (bufferView.isParsed) return bufferView.dbufferView;
        bufferView.isParsed = true;
        bufferView.dbufferView = false;
        const buffer = this.parseBuffer(bufferView.buffer);
        if (buffer) {
          const { byteOffset, byteLength } = bufferView;
          const bufferArray = new Uint8Array(buffer, byteOffset || 0, byteLength);
          bufferView.dbufferView = new Uint8Array(bufferArray).buffer;
        }
        return bufferView.dbufferView;
      }
      parseBuffer(bufferId) {
        const buffer = this.gltf.buffers[bufferId];
        if (!buffer) return this.errorMiss("buffer", bufferId);
        if (buffer.isParsed) return buffer.dbuffer;
        buffer.isParsed = true;
        buffer.dbuffer = false;
        if (buffer.uri.substring(0, 5) !== "data:") {
          const uri = buffer.uri;
          const arrayBuffer = this.gltf.resources[uri];
          if (arrayBuffer)
            if (arrayBuffer.byteLength === buffer.byteLength) {
              buffer.dbuffer = this.gltf.resources[uri];
            } else console.error(`load gltf resource "${uri}" at buffers[${bufferId} failed, ArrayBuffer.byteLength not equals buffer's byteLength]`);
          else console.error(`load gltf resource "${uri}" at buffers[${bufferId}] failed`);
        } else {
          const base64Idx = buffer.uri.indexOf(this._BASE64_MARKER) + this._BASE64_MARKER.length;
          const blob = window.atob(buffer.uri.substring(base64Idx));
          const bytes = new Uint8Array(blob.length);
          for (let i = 0; i < blob.length; i++) bytes[i] = blob.charCodeAt(i);
          buffer.dbuffer = bytes.buffer;
        }
        return buffer.dbuffer;
      }
      getLight(lightID) {
        let info = this.gltf.extensions.KHR_lights_punctual.lights[lightID];
        return info;
      }
      applyNodeExtensions(node, dNode) {
        let extensions = node.extensions;
        if (extensions[`KHR_lights_punctual`] && this.gltf.extensions.KHR_lights_punctual) {
          dNode.light = this.getLight(extensions[`KHR_lights_punctual`].light);
        }
      }
    }

    class GLBHeader {
      magic;
      version;
      length;
    }
    class GLBChunk {
      chunkLength;
      chunkType;
      chunkData;
    }
    class GLBParser extends ParserBase {
      static format = ParserFormat.BIN;
      _gltf;
      async parseBuffer(buffer) {
        let byteArray = new Uint8Array(buffer);
        byteArray["pos"] = 0;
        const fileHeader = this.parseHeader(byteArray);
        if (fileHeader.magic != 1179937895) {
          console.error(`invalid GLB file`);
          return false;
        }
        if (fileHeader.version !== 2) {
          console.error(`GLBParser only support glTF 2.0 for now! Received glTF version: ${fileHeader.version}`);
          return false;
        }
        let chunks = [];
        while (byteArray["pos"] < byteArray.length) {
          let chunk = this.parseChunk(byteArray);
          chunks.push(chunk);
        }
        if (chunks[0].chunkType != 1313821514) {
          console.error(`invalid GLBChunk`);
          return false;
        }
        let gltfJSON = "";
        let maxCount = 65535;
        let chunkJSONData = chunks[0].chunkData;
        for (let i = 0; i < chunkJSONData.length; i += maxCount) {
          let count = chunkJSONData.length - i;
          count = Math.min(count, maxCount);
          let newUint = chunkJSONData.subarray(i, i + count);
          gltfJSON += String.fromCharCode(...newUint);
        }
        let obj = JSON.parse(gltfJSON);
        this._gltf = new GLTF_Info();
        this._gltf = { ...this._gltf, ...obj };
        this._gltf.resources = {};
        for (let i = 0; i < this._gltf.buffers.length; i++) {
          let buffer2 = this._gltf.buffers[i];
          buffer2.isParsed = true;
          buffer2.dbuffer = chunks[i + 1].chunkData.buffer;
        }
        if (this._gltf.images) {
          for (let i = 0; i < this._gltf.images.length; i++) {
            let image = this._gltf.images[i];
            image.name = image.name || "bufferView_" + image.bufferView.toString();
            const bufferView = this._gltf.bufferViews[image.bufferView];
            const buffer2 = this._gltf.buffers[bufferView.buffer];
            let dataBuffer = new Uint8Array(buffer2.dbuffer, bufferView.byteOffset, bufferView.byteLength);
            let imgData = new Blob([dataBuffer], { type: image.mimeType });
            let dtexture = new BitmapTexture2D(true, this.ctx);
            await dtexture.loadFromBlob(imgData);
            dtexture.name = image.name;
            this._gltf.resources[image.name] = dtexture;
          }
        }
        let subParser = new GLTFSubParser();
        let nodes = await subParser.parse(this.initUrl, this._gltf, this._gltf.scene);
        if (nodes) {
          this.data = nodes.rootNode;
          return nodes.rootNode;
        }
        return null;
      }
      async parseJsonAndBuffer(obj, bin) {
        this._gltf = new GLTF_Info();
        this._gltf = { ...this._gltf, ...obj };
        this._gltf.resources = {};
        let dbuffer = this._gltf.buffers[0];
        dbuffer.isParsed = true;
        dbuffer.dbuffer = bin;
        if (this._gltf.images) {
          for (let i = 0; i < this._gltf.images.length; i++) {
            let image = this._gltf.images[i];
            image.name = image.name || "bufferView_" + image.bufferView.toString();
            const bufferView = this._gltf.bufferViews[image.bufferView];
            const buffer = this._gltf.buffers[bufferView.buffer];
            let dataBuffer = new Uint8Array(buffer.dbuffer, bufferView.byteOffset, bufferView.byteLength);
            let imgData = new Blob([dataBuffer], { type: image.mimeType });
            let dtexture = new BitmapTexture2D(true, this.ctx);
            await dtexture.loadFromBlob(imgData);
            dtexture.name = image.name;
            this._gltf.resources[image.name] = dtexture;
          }
        }
        let subParser = new GLTFSubParser();
        let nodes = await subParser.parse(this.initUrl, this._gltf, this._gltf.scene);
        if (nodes) {
          this.data = nodes.rootNode;
          return nodes.rootNode;
        }
        return null;
      }
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("Method not implemented.");
      }
      parseHeader(buffer) {
        let pos = buffer["pos"];
        let result = new GLBHeader();
        let data = new Uint32Array(buffer.buffer, pos, 3);
        buffer["pos"] += data.byteLength;
        result.magic = data[0];
        result.version = data[1];
        result.length = data[2];
        return result;
      }
      parseChunk(buffer) {
        let pos = buffer["pos"];
        let result = new GLBChunk();
        let data = new Uint32Array(buffer.buffer, pos, 2);
        pos = buffer["pos"] += data.byteLength;
        result.chunkLength = data[0];
        result.chunkType = data[1];
        result.chunkData = new Uint8Array(buffer.buffer, pos, result.chunkLength);
        const bytes = new Uint8Array(result.chunkLength);
        for (let i = 0; i < result.chunkLength; i++) bytes[i] = result.chunkData[i];
        result.chunkData = bytes;
        buffer["pos"] += result.chunkLength;
        return result;
      }
    }

    class OBJParser extends ParserBase {
      static format = ParserFormat.TEXT;
      textData = "";
      source_vertices;
      source_normals;
      source_tangents;
      source_textureCoords;
      // private source_faces:Face[];
      // public faces: {
      //   indices: string[],
      //   texture: string[],
      //   normal: string[]
      // }[];
      matLibs;
      geometrys;
      activeGeo;
      facesMaterialsIndex;
      mtl;
      mtlUrl;
      // public geometryDatas:GeometryData[];
      async parseString(obj) {
        this.source_vertices = [];
        this.source_normals = [];
        this.source_tangents = [];
        this.source_textureCoords = [];
        this.matLibs = {};
        this.geometrys = {};
        this.textData = obj;
        await Promise.all([this.parserOBJ(), this.loadMTL()]);
        this.parser_mesh();
        return `null`;
      }
      applyVector2(fi, sourceData, destData) {
        if (sourceData[fi] && sourceData[fi].length > 0) {
          destData.push(sourceData[fi][0]);
          destData.push(sourceData[fi][1]);
        } else {
          destData.push(0);
          destData.push(0);
        }
      }
      applyVector3(fi, sourceData, destData) {
        destData.push(sourceData[fi][0]);
        destData.push(sourceData[fi][1]);
        destData.push(sourceData[fi][2]);
      }
      applyVector4(fi, sourceData, destData) {
        destData.push(sourceData[fi][0]);
        destData.push(sourceData[fi][1]);
        destData.push(sourceData[fi][2]);
        destData.push(sourceData[fi][3]);
      }
      async loadMTL() {
        let fileLoad = new FileLoader(this.ctx);
        let sourceData = await fileLoad.loadTxt(this.baseUrl + this.mtlUrl);
        let sourceStr = sourceData[`data`];
        let mat;
        let str = sourceStr.split("\r\n");
        for (let i = 0; i < str.length; i++) {
          let line = str[i];
          var commentStart = line.indexOf("#");
          if (commentStart != -1) {
            line = line.substring(0, commentStart);
          }
          line = line.trim();
          var splitedLine = line.split(/\s+/);
          if (splitedLine[0] === "newmtl") {
            mat = { name: splitedLine[1] };
            this.matLibs[splitedLine[1]] = mat;
          } else {
            if (splitedLine[0].indexOf(`map_`) != -1) {
              mat[splitedLine[0]] = splitedLine[1];
              if (!mat.textures) {
                mat.textures = [splitedLine[splitedLine.length - 1]];
              }
              mat.textures.push(splitedLine[splitedLine.length - 1]);
            } else if (splitedLine.length == 2) {
              mat[splitedLine[0]] = Number(splitedLine[1]);
            } else if (splitedLine.length == 3) {
              mat[splitedLine[0]] = [Number(splitedLine[1]), Number(splitedLine[2])];
            } else if (splitedLine.length == 4) {
              mat[splitedLine[0]] = [Number(splitedLine[1]), Number(splitedLine[2]), Number(splitedLine[3])];
            }
          }
        }
        for (const key in this.matLibs) {
          const mat2 = this.matLibs[key];
          if (mat2.textures && mat2.textures.length > 0) {
            for (let i = 0; i < mat2.textures.length; i++) {
              const texUrl = StringUtil.normalizePath(this.baseUrl + mat2.textures[i]);
              await Engine3D.resFor(this.ctx).loadTexture(texUrl);
            }
          }
        }
        sourceData = null;
        return true;
      }
      async load_textures() {
      }
      parserLine(line) {
        var commentStart = line.indexOf("#");
        if (commentStart != -1) {
          if (line.indexOf(`# object`) != -1) {
            var splitedLine = line.split(/\s+/);
            let type = splitedLine[1];
            let geoName = splitedLine[2];
            this.activeGeo = {
              type,
              name: geoName[1],
              source_mat: ``,
              source_faces: []
            };
            this.geometrys[geoName] = this.activeGeo;
          }
          line = line.substring(0, commentStart);
        }
        line = line.trim();
        var splitedLine = line.split(/\s+/);
        if (splitedLine[0] === "v") {
          var vertex = [Number(splitedLine[1]), Number(splitedLine[2]), Number(splitedLine[3]), splitedLine[4] ? 1 : Number(splitedLine[4])];
          this.source_vertices.push(vertex);
        } else if (splitedLine[0] === "vt") {
          var textureCoord = [Number(splitedLine[1]), Number(splitedLine[2]), splitedLine[3] ? 1 : Number(splitedLine[3])];
          this.source_textureCoords.push(textureCoord);
        } else if (splitedLine[0] === "vn") {
          var normal = [Number(splitedLine[1]), Number(splitedLine[2]), Number(splitedLine[3])];
          this.source_normals.push(normal);
        } else if (splitedLine[0] === "f") {
          var face = {
            indices: [],
            texture: [],
            normal: []
          };
          for (var i = 1; i < splitedLine.length; ++i) {
            var dIndex = splitedLine[i].indexOf("//");
            var splitedFaceIndices = splitedLine[i].split(/\W+/);
            if (dIndex > 0) {
              face.indices.push(splitedFaceIndices[0]);
              face.normal.push(splitedFaceIndices[1]);
            } else {
              if (splitedFaceIndices.length === 1) {
                face.indices.push(splitedFaceIndices[0]);
              } else if (splitedFaceIndices.length === 2) {
                face.indices.push(splitedFaceIndices[0]);
                face.texture.push(splitedFaceIndices[1]);
              } else if (splitedFaceIndices.length === 3) {
                face.indices.push(splitedFaceIndices[0]);
                face.texture.push(splitedFaceIndices[1]);
                face.normal.push(splitedFaceIndices[2]);
              }
            }
          }
          this.activeGeo.source_faces.push(face);
        } else if (splitedLine[0] === "usemtl") {
          this.activeGeo.source_mat = splitedLine[1];
        } else if (splitedLine[0] === `mtllib`) {
          this.mtlUrl = splitedLine[1];
        }
      }
      async parserOBJ() {
        let str = this.textData.split("\r\n");
        for (let i = 0; i < str.length; i++) {
          const element = str[i];
          this.parserLine(element);
        }
        this.textData = ``;
        return true;
      }
      async parser_mesh() {
        let root = new exports.Object3D();
        for (const key in this.geometrys) {
          const geoData = this.geometrys[key];
          geoData.vertex_arr = [];
          geoData.normal_arr = [];
          geoData.uv_arr = [];
          geoData.indeice_arr = [];
          let index = 0;
          for (let i = 0; i < geoData.source_faces.length; i++) {
            const face = geoData.source_faces[i];
            let f0 = parseInt(face.indices[0]) - 1;
            let f1 = parseInt(face.indices[1]) - 1;
            let f2 = parseInt(face.indices[2]) - 1;
            let n0 = parseInt(face.normal[0]) - 1;
            let n1 = parseInt(face.normal[1]) - 1;
            let n2 = parseInt(face.normal[2]) - 1;
            let u0 = parseInt(face.texture[0]) - 1;
            let u1 = parseInt(face.texture[1]) - 1;
            let u2 = parseInt(face.texture[2]) - 1;
            this.applyVector3(f0, this.source_vertices, geoData.vertex_arr);
            this.applyVector3(n0, this.source_normals, geoData.normal_arr);
            this.applyVector2(u0, this.source_textureCoords, geoData.uv_arr);
            geoData.indeice_arr[index] = index++;
            this.applyVector3(f1, this.source_vertices, geoData.vertex_arr);
            this.applyVector3(n1, this.source_normals, geoData.normal_arr);
            this.applyVector2(u1, this.source_textureCoords, geoData.uv_arr);
            geoData.indeice_arr[index] = index++;
            this.applyVector3(f2, this.source_vertices, geoData.vertex_arr);
            this.applyVector3(n2, this.source_normals, geoData.normal_arr);
            this.applyVector2(u2, this.source_textureCoords, geoData.uv_arr);
            geoData.indeice_arr[index] = index++;
            if (face.indices.length > 3) {
              let f3 = parseInt(face.indices[3]) - 1;
              let n3 = parseInt(face.normal[3]) - 1;
              let u3 = parseInt(face.texture[3]) - 1;
              this.applyVector3(f0, this.source_vertices, geoData.vertex_arr);
              this.applyVector3(n0, this.source_normals, geoData.normal_arr);
              this.applyVector2(u0, this.source_textureCoords, geoData.uv_arr);
              geoData.indeice_arr[index] = index++;
              this.applyVector3(f2, this.source_vertices, geoData.vertex_arr);
              this.applyVector3(n2, this.source_normals, geoData.normal_arr);
              this.applyVector2(u2, this.source_textureCoords, geoData.uv_arr);
              geoData.indeice_arr[index] = index++;
              this.applyVector3(f3, this.source_vertices, geoData.vertex_arr);
              this.applyVector3(n3, this.source_normals, geoData.normal_arr);
              this.applyVector2(u3, this.source_textureCoords, geoData.uv_arr);
              geoData.indeice_arr[index] = index++;
            }
          }
          let geo = new GeometryBase();
          geo.setIndices(new Uint32Array(geoData.indeice_arr));
          geo.setAttribute(VertexAttributeName.position, new Float32Array(geoData.vertex_arr));
          geo.setAttribute(VertexAttributeName.normal, new Float32Array(geoData.normal_arr));
          geo.setAttribute(VertexAttributeName.uv, new Float32Array(geoData.uv_arr));
          geo.setAttribute(VertexAttributeName.TEXCOORD_1, new Float32Array(geoData.uv_arr));
          geo.addSubGeometry({
            indexStart: 0,
            indexCount: geoData.indeice_arr.length,
            vertexStart: 0,
            vertexCount: 0,
            firstStart: 0,
            index: 0,
            topology: 0
          });
          let mat = new LitMaterial(this.ctx);
          let matData = this.matLibs[geoData.source_mat];
          mat.baseMap = Engine3D.resFor(this.ctx).getTexture(StringUtil.normalizePath(this.baseUrl + matData.map_Kd));
          let obj = new exports.Object3D();
          let mr = obj.addComponent(exports.MeshRenderer);
          mr.geometry = geo;
          mr.material = mat;
          root.addChild(obj);
        }
        this.data = root;
      }
      /**
       * Verify parsing validity
       * @param ret
       * @returns
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("Method not implemented.");
      }
    }

    let BlurEffectCreatorSample_cs = (
      /*wgsl*/
      `
    struct ImageSize {
        srcWidth: i32,
            srcHeight : i32,
                dstWidth : i32,
                    dstHeight : i32,
    };

    @group(0) @binding(0) var<uniform>size : ImageSize;
    @group(0) @binding(1) var inputTexture: texture_2d<f32>;
    @group(0) @binding(2) var outputTexture: texture_storage_2d<rgba8unorm, write>;

    @compute @workgroup_size(8, 8, 1)
    fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
        var uv: vec2<f32> = vec2<f32>(f32(GlobalInvocationID.x) / f32(size.dstWidth), f32(GlobalInvocationID.y) / f32(size.dstHeight));
        uv = uv * vec2<f32>(f32(size.srcWidth), f32(size.srcHeight));
        var dstId: vec2<i32> = vec2<i32>(i32(GlobalInvocationID.x), i32(GlobalInvocationID.y));
        var srcId: vec2<i32> = vec2<i32>(i32(GlobalInvocationID.x * 2u), i32(GlobalInvocationID.y * 2u));
        textureStore(outputTexture, dstId, textureLoad(inputTexture, srcId, 0));
    }
`
    );
    let BlurEffectCreatorBlur_cs = (
      /*wgsl*/
      `
    struct ImageSize {
        srcWidth: i32,
            srcHeight : i32,
                dstWidth : i32,
                    dstHeight : i32,
    };

    @group(0) @binding(0) var<uniform>size : ImageSize;
    @group(0) @binding(1) var inputTexture: texture_2d<f32>;
    @group(0) @binding(2) var outputTexture: texture_storage_2d<rgba8unorm, write>;

    fn repeat_i32(id: i32, max: i32) -> i32 {
        var ret = id;
        if (id < 0) {
            ret = max + id;
        }
        if (id >= max) {
            ret = id - max;
        }
        return ret;
    }

    fn clamp_i32(id: i32, max: i32) -> i32 {
        var ret = id;
        if (id < 0) {
            ret = 0;
        }
        if (id >= max) {
            ret = max - 1;
        }
        return ret;
    }

    fn blur(idx: u32) -> vec4 < f32 > {
        var id: vec2<i32>;
        id.y = i32(idx) / size.srcWidth;
        id.x = i32(idx) - i32(id.y) * size.srcWidth;
        var _BlurSpread: i32 = 1;
        var result = vec4<f32>(0.0, 0.0, 0.0, 0.0);
        let g: array < f32, 3u > = array<f32, 3u > (0.4026, 0.2442, 0.0545);
        var uv: vec2<i32>;
        for(var h: i32 = 0; h< 5; h = h + 1) {
        let offsetU: i32 = (h - 2) * _BlurSpread;
        uv.x = id.x + offsetU;
        uv.x = clamp_i32(uv.x, size.srcWidth);
        for (var v: i32 = 0; v < 5; v = v + 1) {
            let offsetV: i32 = (v - 2) * _BlurSpread;
            uv.y = id.y + offsetV;
            uv.y = clamp(uv.y, 0, size.srcHeight);
            let weightU: i32 = abs(h - 2);
            let weightV: i32 = abs(v - 2);
            let resultWeight: f32 = g[weightU] * g[weightV];
            var colorf32: vec4<f32> = textureLoad(inputTexture, uv, 0);
            let sampleColor: vec4<f32> = vec4<f32>(colorf32 * resultWeight);
            result = result + sampleColor;
        }
    }

    return result;
    }

    @compute @workgroup_size(8, 8, 1)
    fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
        var uv: vec2<f32> = vec2<f32>(f32(GlobalInvocationID.x) / f32(size.dstWidth), f32(GlobalInvocationID.y) / f32(size.dstHeight));
        uv = uv * vec2<f32>(f32(size.srcWidth), f32(size.srcHeight));
        let srcIdx = i32(uv.y) * size.srcWidth + i32(uv.x);
        var dstId: vec2<i32> = vec2<i32>(i32(GlobalInvocationID.x), i32(GlobalInvocationID.y));
        textureStore(outputTexture, dstId, blur(u32(srcIdx)));
    }
`
    );

    class BlurTexture2DBufferCreator {
      //Image is the texture of converting from rgba8unorm to rgba8unorm
      static blurImageFromTexture(image, dstWidth, dstHeight, blur, ctx) {
        const device = ctx.device;
        const gpu = ctx.gpuContext;
        let code = blur ? BlurEffectCreatorBlur_cs : BlurEffectCreatorSample_cs;
        const computePipeline = device.createComputePipeline({
          layout: `auto`,
          compute: {
            module: device.createShaderModule({
              code
            }),
            entryPoint: "main"
          }
        });
        const configStride = 4 * 4;
        const configBuffer = device.createBuffer({
          size: configStride,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(configBuffer, 0, new Uint32Array([image.width, image.height, dstWidth, dstHeight]));
        const outputTexture = device.createTexture({
          size: [dstWidth, dstHeight, 1],
          mipLevelCount: 1,
          format: "rgba8unorm",
          usage: GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.RENDER_ATTACHMENT,
          label: `blurImageFromTexture`
        });
        let entries0 = [
          {
            binding: 0,
            resource: {
              buffer: configBuffer,
              size: 4 * 4
            }
          },
          {
            binding: 1,
            resource: image.gpuTexture.createView({
              format: "rgba8unorm",
              dimension: "2d",
              baseMipLevel: 0,
              mipLevelCount: 1
            })
          },
          {
            binding: 2,
            resource: outputTexture.createView({
              format: "rgba8unorm",
              dimension: "2d",
              baseMipLevel: 0,
              mipLevelCount: 1
            })
          }
        ];
        const computeBindGroup0 = device.createBindGroup({
          layout: computePipeline.getBindGroupLayout(0),
          entries: entries0
        });
        const commandEncoder = gpu.beginCommandEncoder();
        const computePass = commandEncoder.beginComputePass();
        computePass.setPipeline(computePipeline);
        computePass.setBindGroup(0, computeBindGroup0);
        computePass.dispatchWorkgroups(Math.floor(dstWidth / 8), Math.floor(dstHeight / 8));
        computePass.end();
        gpu.endCommandEncoder(commandEncoder);
        configBuffer.destroy();
        return outputTexture;
      }
    }

    class TextureCube extends Texture {
      /**
       * texture width, default value is 4
       */
      width = 4;
      /**
       * texture height, default value is 4
       */
      height = 4;
      /**
       * depth or array layers, default value is 6
       */
      depthOrArrayLayers = 6;
      /**
       * GPUShaderStage
       */
      visibility = GPUShaderStage.FRAGMENT;
      /**
       * GPUTextureBindingLayout
       */
      textureBindingLayout = {
        viewDimension: "cube",
        multisampled: false
      };
      /**
       * GPUSamplerBindingLayout
       */
      samplerBindingLayout = {
        type: "filtering"
      };
      /**
       * @constructor
       */
      constructor() {
        super(4, 4);
        this.addressModeU = GPUAddressMode.clamp_to_edge;
        this.addressModeV = GPUAddressMode.clamp_to_edge;
        this.addressModeW = GPUAddressMode.clamp_to_edge;
        this.magFilter = this.minFilter = "linear";
        this.mipmapFilter = "linear";
        this.visibility = GPUShaderStage.FRAGMENT;
      }
      /**
       * createTextureDescriptor
       */
      createTextureDescriptor(width, height, mipLevelCount, format, usage = GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.RENDER_ATTACHMENT, sizeCount = 1) {
        this.width = width;
        this.height = height;
        this.format = format;
        this.usage = usage;
        this.textureDescriptor = {
          size: { width, height, depthOrArrayLayers: 6 },
          mipLevelCount,
          format,
          usage,
          dimension: "2d"
        };
        if (sizeCount > 1) {
          this.viewDescriptor = {
            dimension: `cube-array`
          };
        } else {
          this.viewDescriptor = {
            dimension: this.textureBindingLayout.viewDimension
          };
        }
      }
    }

    class TextureCubeStdCreator {
      static createCube = (
        /*wgsl*/
        `

struct SettingUniform {
  faceIndex : i32,
  srcHeight : i32,
  dstWidth : i32,
  dstHeight : i32
};

@group(0) @binding(0) var<uniform> settingUniform : SettingUniform;
@group(0) @binding(1) var inputTex : texture_2d<f32>;
@group(0) @binding(2) var outTex : texture_storage_2d<rgba8unorm, write>;

@compute @workgroup_size(8, 8, 1)
fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
  let coord = vec2<i32>(GlobalInvocationID.xy);
  
  let outTexSize = textureDimensions(outTex).xy;
  let outTexel = 1.0 / vec2<f32>(outTexSize - 1);
  
  let uv_0 = vec2<f32>(coord) * outTexel;
  var oc = samplePixel(settingUniform.faceIndex, uv_0);
  textureStore(outTex, coord, oc);
}

fn samplePixel(face:i32, uv01:vec2<f32>) -> vec4<f32> {
    let rectangle_v2_f32 = round(vec2<f32>(0.25, 0.33333) * vec2<f32>(textureDimensions(inputTex).xy));
    let rectangle = vec2<i32>(rectangle_v2_f32);
    
    var offsetIndex = vec2<i32>(0);
    if(face == 0){
        offsetIndex.x = 2;
        offsetIndex.y = 1;
    }else if(face == 1){
        offsetIndex.x = 0;
        offsetIndex.y = 1;
    }else if(face == 2){
        offsetIndex.x = 1;
        offsetIndex.y = 0;
    }else if(face == 3){
        offsetIndex.x = 1;
        offsetIndex.y = 2;
    }else if(face == 4){
        offsetIndex.x = 1;
        offsetIndex.y = 1;
    }else if(face == 5){
        offsetIndex.x = 3;
        offsetIndex.y = 1;
    }
    
    let coordOffset = rectangle * offsetIndex;
    let coordIndex = vec2<i32>(vec2<f32>(rectangle - 1) * uv01);
    var oc = textureLoad(inputTex, coordOffset + coordIndex, 0);
    return oc;
}
`
      );
      static createFace(index, size, inTex, outTex) {
        const ctx = inTex._boundCtx ?? outTex._boundCtx;
        const device = ctx.device;
        const gpu = ctx.gpuContext;
        const state = ctx.cache(TextureCubeStdCreator, () => ({
          configBuffer: null,
          blurSettingBuffer: null,
          pipeline: null
        }));
        if (state.pipeline == null) {
          state.pipeline = device.createComputePipeline({
            layout: `auto`,
            compute: {
              module: device.createShaderModule({
                code: TextureCubeStdCreator.createCube
              }),
              entryPoint: "main"
            }
          });
        }
        const computePipeline = state.pipeline;
        const configStride = 4 * 4;
        state.configBuffer ||= device.createBuffer({
          size: configStride,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(state.configBuffer, 0, new Uint32Array([index, 0, 0, 0]));
        state.blurSettingBuffer ||= device.createBuffer({
          size: configStride,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(state.blurSettingBuffer, 0, new Float32Array([0, 0, 0, 0]));
        let entries0 = [
          {
            binding: 0,
            resource: {
              buffer: state.configBuffer,
              size: 4 * 4
            }
          },
          {
            binding: 1,
            resource: inTex.getGPUView()
          },
          {
            binding: 2,
            resource: outTex.getGPUView()
          }
        ];
        const computeBindGroup0 = device.createBindGroup({
          layout: computePipeline.getBindGroupLayout(0),
          entries: entries0
        });
        const commandEncoder = gpu.beginCommandEncoder();
        const computePass = commandEncoder.beginComputePass();
        computePass.setPipeline(computePipeline);
        computePass.setBindGroup(0, computeBindGroup0);
        computePass.dispatchWorkgroups(size / 8, size / 8);
        computePass.end();
        gpu.endCommandEncoder(commandEncoder);
      }
    }

    class BitmapTextureCube extends TextureCube {
      _images;
      _url;
      /** Color-space contract (see {@link TextureColorSpace}). Defaults
       *  to `'linear'` for legacy parity; pass `'srgb'` for sRGB-encoded
       *  panorama / HDR-LDR cube faces so the sampler hardware-decodes. */
      colorSpace;
      constructor(colorSpace = "linear") {
        super();
        this.useMipmap = true;
        this.colorSpace = colorSpace;
      }
      /** Picks `rgba8unorm-srgb` when `colorSpace === 'srgb'`, else
       *  `rgba8unorm`. Used at every place where the cube's `format`
       *  field used to be hard-coded to `rgba8unorm`. */
      get _ldrFormat() {
        return this.colorSpace === "srgb" ? GPUTextureFormat.rgba8unorm_srgb : GPUTextureFormat.rgba8unorm;
      }
      generateImages(images, ctx) {
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        this.width = this.height = 32;
        if ("width" in images[0]) {
          this.width = this.height = images[0].width;
        }
        let mipmapSize = Math.min(this.width, this.height);
        this.mipmapCount = 1;
        while (mipmapSize > 16) {
          mipmapSize /= 2;
          this.mipmapCount++;
        }
        this.textureBindingLayout.viewDimension = "cube";
        this.samplerBindingLayout.type = "filtering";
        this.createTextureDescriptor(this.width, this.height, this.mipmapCount, this.format);
        this.textureDescriptor.size = { width: this.width, height: this.height, depthOrArrayLayers: 6 };
        this.textureDescriptor.dimension = "2d";
        this.gpuTexture = this.getGPUTexture();
        let faceTextures = [];
        let lastFaceTextures = faceTextures;
        let mipWidth = this.width;
        let mipHeight = this.height;
        if (images[0] instanceof Texture) {
          for (let i = 0; i < 6; i++) {
            let t = images[i];
            faceTextures[i] = t.getGPUTexture();
          }
          this.uploadMipmapGPUTexture(0, this.width, this.width, faceTextures);
        } else {
          this.uploadBaseImages(this.width, images);
          for (let i = 0; i < 6; i++) {
            let t = new BitmapTexture2D(false, this._boundCtx, this.colorSpace);
            t.format = this.format;
            t.source = images[i];
            faceTextures[i] = t.getGPUTexture();
          }
        }
        for (let i = 1; i < this.mipmapCount; i++) {
          lastFaceTextures = faceTextures;
          faceTextures = [];
          let dstBuffer = { width: mipWidth, height: mipHeight, gpuTexture: null };
          mipWidth = mipWidth / 2;
          mipHeight = mipHeight / 2;
          for (let faceId = 0; faceId < 6; faceId++) {
            dstBuffer.gpuTexture = lastFaceTextures[faceId];
            faceTextures[faceId] = BlurTexture2DBufferCreator.blurImageFromTexture(dstBuffer, mipWidth, mipHeight, false, this._boundCtx);
          }
          this.uploadMipmapGPUTexture(i, mipWidth, mipHeight, faceTextures);
        }
        this.gpuSampler = device.createSampler(this);
      }
      uploadBaseImages(size, textures, ctx) {
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        for (let i = 0; i < 6; i++) {
          device.queue.copyExternalImageToTexture(
            { source: textures[i] },
            {
              texture: this.gpuTexture,
              mipLevel: 0,
              origin: { x: 0, y: 0, z: i }
            },
            { width: size, height: size, depthOrArrayLayers: 1 }
          );
        }
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
      }
      uploadMipmapGPUTexture(mip, width, height, textures) {
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        for (let i = 0; i < 6; i++) {
          commandEncoder.copyTextureToTexture(
            {
              texture: textures[i],
              mipLevel: 0,
              origin: { x: 0, y: 0, z: 0 }
            },
            {
              texture: this.gpuTexture,
              mipLevel: mip,
              origin: { x: 0, y: 0, z: i }
            },
            {
              width,
              height,
              depthOrArrayLayers: 1
            }
          );
        }
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
      }
      /**
       * get images of this texture
       */
      get images() {
        return this._images;
      }
      /**
      * set images of this texture
      */
      set images(value) {
        this._images = value;
        if (this._images[0] instanceof HTMLImageElement) {
          let loadImage = function(index, image) {
            image.decode().then(async () => {
              bitmaps[index] = await createImageBitmap(image);
              remain--;
              if (remain == 0) {
                that.generateImages(bitmaps);
              }
            });
          };
          let bitmaps = [];
          let remain = 6;
          let that = this;
          for (let i = 0; i < 6; i++) {
            loadImage(i, this._images[i]);
          }
        } else {
          if (this._images instanceof HTMLCanvasElement || this._images instanceof ImageBitmap) {
            this.generateImages(this._images);
          }
        }
      }
      /**
       * load texture data from array of web url.
       * make sure there are six images in a group,
       * and the order is: [+X, -X, +Y, -Y, +Z, -Z]
       * @param urls array of image url
       */
      async load(urls, ctx) {
        this._url = urls;
        if (ctx) this._ensureBound(ctx);
        let remain = 6;
        let bitmaps = [];
        this.format = this._ldrFormat;
        let that = this;
        async function loadImage(index, url) {
          const img = document.createElement("img");
          img.src = /^https?:|^data:|^blob:|^\//.test(url) ? url : new URL(url, (window.parent || window).location.origin + "/").href;
          img.setAttribute("crossOrigin", "");
          await img.decode();
          bitmaps[index] = await createImageBitmap(img);
          remain--;
          if (remain == 0) {
            that.generateImages(bitmaps);
            return true;
          }
        }
        for (let i = 0; i < 6; i++) {
          await loadImage(i, urls[i]);
        }
        return true;
      }
      /**
        * load texture data from url.
        * the image is assembled from six images into cross shaped image.
        * @param url the path of image
        */
      async loadStd(url, ctx) {
        this._url = url;
        this.format = this._ldrFormat;
        if (ctx) this._ensureBound(ctx);
        const img = document.createElement("img");
        img.src = /^https?:|^data:|^blob:|^\//.test(url) ? url : new URL(url, (window.parent || window).location.origin + "/").href;
        img.setAttribute("crossOrigin", "");
        await img.decode();
        let srcTexture = new BitmapTexture2D(false, this._boundCtx, this.colorSpace);
        srcTexture.name = StringUtil.getURLName(url);
        srcTexture.format = this._ldrFormat;
        srcTexture.source = await createImageBitmap(img);
        let cubeSize = Math.round(Math.log2(srcTexture.width / 4));
        cubeSize = Math.pow(2, cubeSize);
        this.width = this.height = cubeSize;
        let textureList = [];
        for (let i = 0; i < 6; i++) {
          let item = new VirtualTexture(
            cubeSize,
            cubeSize,
            this.format,
            false,
            GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING,
            1,
            0,
            1,
            this._boundCtx
          );
          item.name = "face " + i;
          textureList.push(item);
          TextureCubeStdCreator.createFace(i, this.width, srcTexture, item);
        }
        this.generateImages(textureList);
        return true;
      }
    }

    var CubeMapFaceEnum = /* @__PURE__ */ ((CubeMapFaceEnum2) => {
      CubeMapFaceEnum2[CubeMapFaceEnum2["Left"] = 0] = "Left";
      CubeMapFaceEnum2[CubeMapFaceEnum2["Right"] = 1] = "Right";
      CubeMapFaceEnum2[CubeMapFaceEnum2["Bottom"] = 2] = "Bottom";
      CubeMapFaceEnum2[CubeMapFaceEnum2["Top"] = 3] = "Top";
      CubeMapFaceEnum2[CubeMapFaceEnum2["Back"] = 4] = "Back";
      CubeMapFaceEnum2[CubeMapFaceEnum2["Front"] = 5] = "Front";
      return CubeMapFaceEnum2;
    })(CubeMapFaceEnum || {});
    class TextureCubeUtils {
      static getRotationToFace(face) {
        let quaternion = Quaternion.identity().clone();
        let target = new Vector3();
        let matrix = new Matrix4().identity();
        let up = new Vector3();
        switch (face) {
          case 3 /* Top */:
            target.set(0, -1, 0);
            up.set(0, 0, -1);
            break;
          case 2 /* Bottom */:
            target.set(0, 1, 0);
            up.set(0, 0, 1);
            break;
          case 1 /* Right */:
            target.set(1, 0, 0);
            up.set(0, 1, 0);
            break;
          case 0 /* Left */:
            target.set(-1, 0, 0);
            up.set(0, 1, 0);
            break;
          case 4 /* Back */:
            target.set(0, 0, -1);
            up.set(0, 1, 0);
            break;
          case 5 /* Front */:
            Matrix4.freeIndex(matrix);
            return Quaternion.identity();
        }
        matrix.lookAt(new Vector3(), target, up);
        quaternion.setFromRotationMatrix(matrix);
        Matrix4.freeIndex(matrix);
        return quaternion;
      }
    }

    let ErpImage2CubeMapCreateCube_cs = (
      /*wgsl*/
      `
  struct ImageSize {
    srcWidth : i32,
    srcHeight : i32,
    dstWidth : i32,
    dstHeight : i32
  };

  @group(0) @binding(0) var<uniform> size : ImageSize;
  @group(0) @binding(1) var<storage,read_write> faceRotation: array<vec4<f32>>;
  @group(0) @binding(2) var inputTexSampler : sampler;
  @group(0) @binding(3) var inputTex : texture_2d<f32>;

  @group(1) @binding(0) var outputBuffer0 : texture_storage_2d_array<rgba16float, write>;

  fn SampleSphericalMap(v: vec3<f32>) -> vec2<f32> {
      var uv:vec2<f32> = vec2<f32>(atan2(v.z, v.x), asin(v.y));
      //uv = (uv * (vec2<f32>(0.1590999960899353, 0.3183000087738037) + vec2<f32>(0.0010000000474974513)));
      uv = uv * vec2<f32>(0.1590999960899353, 0.3183000087738037);
      uv = uv + vec2<f32>(0.5);
      uv = clamp(uv, vec2<f32>(0.0), vec2<f32>(1.0));
      return uv;
  }


  fn applyQuaternion(position:vec3<f32>, q:vec4<f32>) -> vec3<f32>{
      let x:f32 = position.x;
      let y:f32 = position.y;
      let z:f32 = position.z;

      let qx:f32 = q.x;
      let qy:f32 = q.y;
      let qz:f32 = q.z;
      let qw:f32 = q.w;

      let ix:f32 = qw * x + qy * z - qz * y;
      let iy:f32 = qw * y + qz * x - qx * z;
      let iz:f32 = qw * z + qx * y - qy * x;
      let iw:f32 = -qx * x - qy * y - qz * z;

      var ret: vec3<f32>;
      ret.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
      ret.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
      ret.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;

      return ret;
  }

  fn convertIdToDir3(uv_i32:vec2<i32>, quaternion:vec4<f32>) -> vec3<f32>{
      var uv_f32:vec2<f32> = vec2<f32>(uv_i32.xy);
      var halfSize:f32 = f32(size.dstWidth / 2) - 0.5;
      var worldDirection:vec3<f32> = vec3<f32>(uv_f32.x - halfSize, uv_f32.y - halfSize, -halfSize);
      worldDirection = normalize(worldDirection);
      worldDirection = applyQuaternion(worldDirection, quaternion);
      return worldDirection;
  }

  @compute @workgroup_size(8, 8, 1)
  fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
    let coord = vec2<i32>(GlobalInvocationID.xy);
    let quaternion = faceRotation[GlobalInvocationID.z];
    var worldDirection:vec3<f32> = convertIdToDir3(coord, quaternion);
    let uv_f32:vec2<f32> = SampleSphericalMap(worldDirection);
    let oc = textureSampleLevel(inputTex, inputTexSampler, uv_f32 , 0.0);
    textureStore(outputBuffer0, coord, i32(GlobalInvocationID.z), oc);
  }
`
    );

    let ErpImage2CubeMapRgbe2rgba_cs = (
      /*wgsl*/
      `
  struct ImageSize {
    srcWidth : i32,
    srcHeight : i32,
    dstWidth : i32,
    dstHeight : i32
  };

  @group(0) @binding(0) var<uniform> size : ImageSize;
  @group(0) @binding(1) var<storage, read> tex_in: array<vec4<f32>>;
  @group(0) @binding(2) var outputBuffer : texture_storage_2d<rgba16float, write>;

  @compute @workgroup_size(8, 8, 1)
  fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
    let fragCoord = vec2<i32>(i32(GlobalInvocationID.x), i32(GlobalInvocationID.y));
    var oc:vec4<f32> = tex_in[fragCoord.y * size.srcWidth + fragCoord.x] / 256.0;
    var e = pow(2.0, oc.w * 255.0 - 128.0);
    oc = oc * e;
    oc = scaleByThreshold(oc, 40.0);
    textureStore(outputBuffer, fragCoord , vec4<f32>(oc.xyz, 1.0) );
  }

  fn scaleByThreshold(color:vec4<f32>, threshold:f32) -> vec4<f32>{
    var oc = color;
    let brightness = length(vec3<f32>(oc.xyz));
    var scale = brightness / threshold;
    if(scale > 1.0){
        scale = 1.0 / pow(scale, 0.7);
        oc = oc * scale;
    }
    oc.a = 1.0;
    return oc;
  }
`
    );

    class ErpImage2CubeMap {
      static convertRGBE2RGBA(image, data) {
        const ctx = image._boundCtx;
        const device = ctx.device;
        const gpu = ctx.gpuContext;
        const computePipeline = device.createComputePipeline({
          layout: `auto`,
          compute: {
            module: device.createShaderModule({
              code: ErpImage2CubeMapRgbe2rgba_cs
            }),
            entryPoint: "main"
          }
        });
        const configBuffer = device.createBuffer({
          size: 4 * 4,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(configBuffer, 0, new Uint32Array([image.width, image.height, image.width, image.height]));
        const input = device.createBuffer({
          size: data.byteLength,
          usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(input, 0, data);
        let entries0 = [
          {
            binding: 0,
            resource: {
              buffer: configBuffer,
              size: 4 * 4
            }
          },
          {
            binding: 1,
            resource: {
              buffer: input,
              size: data.byteLength
            }
          },
          {
            binding: 2,
            resource: image.getGPUView()
          }
        ];
        const computeBindGroup0 = device.createBindGroup({
          layout: computePipeline.getBindGroupLayout(0),
          entries: entries0
        });
        const commandEncoder = gpu.beginCommandEncoder();
        const computePass = commandEncoder.beginComputePass();
        computePass.setPipeline(computePipeline);
        computePass.setBindGroup(0, computeBindGroup0);
        computePass.dispatchWorkgroups(Math.floor(image.width / 8), Math.floor(image.height / 8));
        computePass.end();
        gpu.endCommandEncoder(commandEncoder);
        configBuffer.destroy();
      }
      //Image is the float32 color value converted from rgbe to rgba
      static makeTextureCube(image, dstSize, dstView) {
        const ctx = image._boundCtx;
        const device = ctx.device;
        const gpu = ctx.gpuContext;
        const state = ctx.cache(ErpImage2CubeMap, () => ({
          makeFaceTexturePipeline: null,
          configBuffer: null,
          quaternionBuffer: null
        }));
        state.makeFaceTexturePipeline ||= device.createComputePipeline({
          layout: `auto`,
          compute: {
            module: device.createShaderModule({
              code: ErpImage2CubeMapCreateCube_cs
            }),
            entryPoint: "main"
          }
        });
        const computePipeline = state.makeFaceTexturePipeline;
        const configStride = 4 * 4;
        state.configBuffer ||= device.createBuffer({
          size: configStride,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(state.configBuffer, 0, new Uint32Array([image.width, image.height, dstSize, dstSize]));
        const quaternionSize = 4 * 6;
        if (!state.quaternionBuffer) {
          state.quaternionBuffer = device.createBuffer({
            size: quaternionSize * 4 * 6,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
          });
          let qArray = new Float32Array(4 * 6);
          for (let i = 0; i < 6; i++) {
            let q = TextureCubeUtils.getRotationToFace(i);
            qArray[i * 4 + 0] = q.x;
            qArray[i * 4 + 1] = q.y;
            qArray[i * 4 + 2] = q.z;
            qArray[i * 4 + 3] = q.w;
          }
          device.queue.writeBuffer(state.quaternionBuffer, 0, qArray);
        }
        let entries0 = [
          {
            binding: 0,
            resource: {
              buffer: state.configBuffer,
              size: 4 * 4
            }
          },
          {
            binding: 1,
            resource: {
              buffer: state.quaternionBuffer,
              size: quaternionSize * 4
            }
          },
          {
            binding: 2,
            resource: image.gpuSampler
          },
          {
            binding: 3,
            resource: image.getGPUView()
          }
        ];
        let entries1 = [
          {
            binding: 0,
            resource: dstView
          }
        ];
        const computeBindGroup0 = device.createBindGroup({
          layout: computePipeline.getBindGroupLayout(0),
          entries: entries0
        });
        const computeBindGroup1 = device.createBindGroup({
          layout: computePipeline.getBindGroupLayout(1),
          entries: entries1
        });
        const commandEncoder = gpu.beginCommandEncoder();
        const computePass = commandEncoder.beginComputePass();
        computePass.setPipeline(computePipeline);
        computePass.setBindGroup(0, computeBindGroup0);
        computePass.setBindGroup(1, computeBindGroup1);
        computePass.dispatchWorkgroups(dstSize / 8, dstSize / 8, 6);
        computePass.end();
        gpu.endCommandEncoder(commandEncoder);
      }
    }

    class HDRTexture extends Texture {
      constructor() {
        super(32, 32, null);
        this.isHDRTexture = true;
      }
      /**
       * fill this texture by array of numbers;the format as [red0, green0, blue0, e0, red1, green1, blue1, e1...]
       * @param width assign the texture width
       * @param height assign the texture height
       * @param data color of each pixel
       * @param useMipmap gen mipmap or not
       * @returns
       */
      create(width = 32, height = 32, data = null, useMipmap = true, ctx) {
        this.width = width;
        this.height = height;
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        const bit = 2;
        const bytesPerRow = width * 4 * bit;
        let fixedData = data;
        this.format = GPUTextureFormat.rgba16float;
        this.useMipmap = useMipmap;
        this.updateTextureDescription();
        this.updateGPUTexture();
        const textureDataBuffer = device.createBuffer({
          size: fixedData.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, fixedData);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
        if (!this.useMipmap) {
          this.samplerBindingLayout.type = `filtering`;
          this.textureBindingLayout.sampleType = `float`;
        }
        this.gpuSampler = device.createSampler(this);
        return this;
      }
      /**
       * load one hdr image
       * @param url the url of hdr image
       * @param loaderFunctions callback when load complete
       * @returns
       */
      async load(url, loaderFunctions, ctx) {
        let loader = new FileLoader(ctx);
        let parser = await loader.load(url, RGBEParser, loaderFunctions);
        return parser.getHDRTexture();
      }
    }

    const _floatView = new Float32Array(1);
    const _int32View = new Int32Array(_floatView.buffer);
    let toHalfFloat = function(val) {
      _floatView[0] = val;
      const x = _int32View[0];
      let bits = x >> 16 & 32768;
      let m = x >> 12 & 2047;
      const e = x >> 23 & 255;
      if (e < 103) return bits;
      if (e > 142) {
        bits |= 31744;
        bits |= (e == 255 ? 1 : 0) && x & 8388607;
        return bits;
      }
      if (e < 114) {
        m |= 2048;
        bits |= (m >> 114 - e) + (m >> 113 - e & 1);
        return bits;
      }
      bits |= e - 112 << 10 | m >> 1;
      bits += m & 1;
      return bits;
    };

    var RGBEErrorCode = /* @__PURE__ */ ((RGBEErrorCode2) => {
      RGBEErrorCode2[RGBEErrorCode2["RGBE_RETURN_FAILURE"] = -1] = "RGBE_RETURN_FAILURE";
      RGBEErrorCode2[RGBEErrorCode2["rgbe_read_error"] = 1] = "rgbe_read_error";
      RGBEErrorCode2[RGBEErrorCode2["rgbe_write_error"] = 2] = "rgbe_write_error";
      RGBEErrorCode2[RGBEErrorCode2["rgbe_format_error"] = 3] = "rgbe_format_error";
      RGBEErrorCode2[RGBEErrorCode2["rgbe_memory_error"] = 4] = "rgbe_memory_error";
      return RGBEErrorCode2;
    })(RGBEErrorCode || {});
    class RGBEHeader {
      valid;
      string;
      comments;
      programtype;
      format;
      gamma;
      exposure;
      width;
      height;
    }
    class RGBEParser extends ParserBase {
      // static format: string = 'bin';
      _rgbeArray;
      _width;
      _height;
      _RGBE_RETURN_FAILURE = -1;
      // parserType: GPUTextureFormat = GPUTextureFormat.rgba16float;
      _parserType = GPUTextureFormat.rgba8uint;
      parseBuffer(buffer) {
        let ret_texture;
        let byteArray = new Uint8Array(buffer);
        byteArray["pos"] = 0;
        const rgbe_header_info = this.paserHeader(byteArray);
        if (rgbe_header_info instanceof RGBEHeader) {
          const w = this._width = rgbe_header_info.width;
          const h = this._height = rgbe_header_info.height;
          let image_rgba_data = this.parserPixel(byteArray.subarray(byteArray["pos"]), w, h);
          if (image_rgba_data instanceof Uint8Array) {
            this._rgbeArray = image_rgba_data;
            switch (this._parserType) {
            }
            this.data = ret_texture;
            return ret_texture;
          }
        }
        return null;
      }
      /**
       * Verify parsing validity
       * @param ret
       * @returns
       */
      verification() {
        if (this.data && this.data instanceof Texture) {
          return true;
        } else if (this._rgbeArray) {
          return true;
        }
        throw new Error("Method not implemented.");
      }
      getTexture() {
        return this.data;
      }
      getCubeTexture() {
        let size = this._width / 4;
        let cubeTexture = new HDRTextureCube().createFromHDRData(size, {
          width: this._width,
          height: this._height,
          array: this._rgbeArray
        }, this.ctx);
        return cubeTexture;
      }
      getHDRTexture() {
        let texture = new HDRTexture().create(this._width, this._height, this._rgbeArray.buffer);
        return texture;
      }
      parseError(rgbe_error_code, msg) {
        switch (rgbe_error_code) {
          case 1 /* rgbe_read_error */:
            console.error("Read Error: " + (msg || ""));
            break;
          case 2 /* rgbe_write_error */:
            console.error("Write Error: " + (msg || ""));
            break;
          case 3 /* rgbe_format_error */:
            console.error("Bad File Format: " + (msg || ""));
            break;
          default:
          case 4 /* rgbe_memory_error */:
            console.error("Error: " + (msg || ""));
        }
        return -1 /* RGBE_RETURN_FAILURE */;
      }
      parserBlock(buffer, lineLimit, consume) {
        const chunkSize = 128;
        lineLimit = !lineLimit ? 1024 : lineLimit;
        let p = buffer["pos"], i = -1, len = 0, s = "", chunk = String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
        const next = "\n";
        while (0 > (i = chunk.indexOf(next)) && len < lineLimit && p < buffer.byteLength) {
          s += chunk;
          len += chunk.length;
          p += chunkSize;
          chunk += String.fromCharCode.apply(null, new Uint16Array(buffer.subarray(p, p + chunkSize)));
        }
        if (-1 < i) {
          if (false !== consume) buffer["pos"] += len + i + 1;
          return s + chunk.slice(0, i);
        }
        return false;
      }
      paserHeader(buffer) {
        const magic_token_re = /^#\?(\S+)/, gamma_re = /^\s*GAMMA\s*=\s*(\d+(\.\d+)?)\s*$/, exposure_re = /^\s*EXPOSURE\s*=\s*(\d+(\.\d+)?)\s*$/, format_re = /^\s*FORMAT=(\S+)\s*$/, dimensions_re = /^\s*\-Y\s+(\d+)\s+\+X\s+(\d+)\s*$/, header = new RGBEHeader();
        let line, match;
        if (buffer["pos"] >= buffer.byteLength || !(line = this.parserBlock(buffer))) {
          return this.parseError(1 /* rgbe_read_error */, "no header found");
        }
        if (!(match = line.match(magic_token_re))) {
          return this.parseError(3 /* rgbe_format_error */, "bad initial token");
        }
        const RGBE_VALID_PROGRAMTYPE = 1;
        const RGBE_VALID_FORMAT = 2;
        const RGBE_VALID_DIMENSIONS = 4;
        header.valid |= RGBE_VALID_PROGRAMTYPE;
        header.programtype = match[1];
        header.string += line + "\n";
        while (true) {
          line = this.parserBlock(buffer);
          if (false === line) break;
          header.string += line + "\n";
          if ("#" === line.charAt(0)) {
            header.comments += line + "\n";
            continue;
          }
          if (match = line.match(gamma_re)) {
            header.gamma = Math.floor(parseFloat(match[1]) * 10) / 10;
          }
          if (match = line.match(exposure_re)) {
            header.exposure = Math.floor(parseFloat(match[1]) * 10) / 10;
          }
          if (match = line.match(format_re)) {
            header.valid |= RGBE_VALID_FORMAT;
            header.format = match[1];
          }
          if (match = line.match(dimensions_re)) {
            header.valid |= RGBE_VALID_DIMENSIONS;
            header.height = parseInt(match[1], 10);
            header.width = parseInt(match[2], 10);
          }
          if (header.valid & RGBE_VALID_FORMAT && header.valid & RGBE_VALID_DIMENSIONS) break;
        }
        if (!(header.valid & RGBE_VALID_FORMAT)) {
          this.parseError(3 /* rgbe_format_error */, "missing format specifier");
          return null;
        }
        if (!(header.valid & RGBE_VALID_DIMENSIONS)) {
          this.parseError(3 /* rgbe_format_error */, "missing image size specifier");
          return null;
        }
        return header;
      }
      parserPixel(buffer, w, h) {
        const scanline_width = w;
        if (
          // run length encoding is not allowed so read flat
          scanline_width < 8 || scanline_width > 32767 || // this file is not run length encoded
          2 !== buffer[0] || 2 !== buffer[1] || buffer[2] & 128
        ) {
          return new Uint8Array(buffer);
        }
        if (scanline_width !== (buffer[2] << 8 | buffer[3])) {
          return this.parseError(3 /* rgbe_format_error */, "wrong scanline width");
        }
        const data_rgba = new Uint8Array(4 * w * h);
        if (!data_rgba.length) {
          return this.parseError(4 /* rgbe_memory_error */, "unable to allocate buffer space");
        }
        let offset = 0, pos = 0;
        const ptr_end = 4 * scanline_width;
        const rgbeStart = new Uint8Array(4);
        const scanline_buffer = new Uint8Array(ptr_end);
        let num_scanlines = h;
        while (num_scanlines > 0 && pos < buffer.byteLength) {
          if (pos + 4 > buffer.byteLength) {
            return this.parseError(1 /* rgbe_read_error */, "");
          }
          rgbeStart[0] = buffer[pos++];
          rgbeStart[1] = buffer[pos++];
          rgbeStart[2] = buffer[pos++];
          rgbeStart[3] = buffer[pos++];
          if (2 != rgbeStart[0] || 2 != rgbeStart[1] || (rgbeStart[2] << 8 | rgbeStart[3]) != scanline_width) {
            return this.parseError(3 /* rgbe_format_error */, "bad rgbe scanline format");
          }
          let ptr = 0, count;
          while (ptr < ptr_end && pos < buffer.byteLength) {
            count = buffer[pos++];
            const isEncodedRun = count > 128;
            if (isEncodedRun) count -= 128;
            if (0 === count || ptr + count > ptr_end) {
              return this.parseError(3 /* rgbe_format_error */, "bad scanline data");
            }
            if (isEncodedRun) {
              const byteValue = buffer[pos++];
              for (let i = 0; i < count; i++) {
                scanline_buffer[ptr++] = byteValue;
              }
            } else {
              scanline_buffer.set(buffer.subarray(pos, pos + count), ptr);
              ptr += count;
              pos += count;
            }
          }
          const l = scanline_width;
          for (let i = 0; i < l; i++) {
            let off = 0;
            data_rgba[offset] = scanline_buffer[i + off];
            off += scanline_width;
            data_rgba[offset + 1] = scanline_buffer[i + off];
            off += scanline_width;
            data_rgba[offset + 2] = scanline_buffer[i + off];
            off += scanline_width;
            data_rgba[offset + 3] = scanline_buffer[i + off];
            offset += 4;
          }
          num_scanlines--;
        }
        return data_rgba;
      }
      rbgeToFloat(sourceArray, sourceOffset, destArray, destOffset) {
        const e = sourceArray[sourceOffset + 3];
        const scale = Math.pow(2, e - 128) / 255;
        destArray[destOffset + 0] = sourceArray[sourceOffset + 0] * scale;
        destArray[destOffset + 1] = sourceArray[sourceOffset + 1] * scale;
        destArray[destOffset + 2] = sourceArray[sourceOffset + 2] * scale;
        destArray[destOffset + 3] = 1;
      }
      rbgeToHalfFloat(sourceArray, sourceOffset, destArray, destOffset) {
        const e = sourceArray[sourceOffset + 3];
        const scale = Math.pow(2, e - 128) / 255;
        destArray[destOffset + 0] = toHalfFloat(sourceArray[sourceOffset + 0] * scale);
        destArray[destOffset + 1] = toHalfFloat(sourceArray[sourceOffset + 1] * scale);
        destArray[destOffset + 2] = toHalfFloat(sourceArray[sourceOffset + 2] * scale);
        destArray[destOffset + 3] = toHalfFloat(1);
      }
    }

    let IBLEnvMapCreator_cs = (
      /*wgsl*/
      `
    struct ImageSize {
        srcWidth : i32,
        srcHeight : i32,
        dstWidth : i32,
        dstHeight : i32
    };
    
    @group(0) @binding(0) var<uniform> size : ImageSize;
    @group(0) @binding(1) var<storage,read_write> faceRotation: array<vec4<f32>>;
    @group(0) @binding(2) var inputTexSampler : sampler;
    @group(0) @binding(3) var inputTex : texture_2d<f32>;
    
    @group(1) @binding(0) var<uniform> blurSetting : vec4<f32>;
    @group(1) @binding(1) var outputBuffer0 : texture_storage_2d_array<rgba16float, write>;
    
    var<private> PI: f32 = 3.14159265359;
    
    fn applyQuaternion(position:vec3<f32>, q:vec4<f32>) -> vec3<f32>{
        let x:f32 = position.x;
        let y:f32 = position.y;
        let z:f32 = position.z;
    
        let qx:f32 = q.x;
        let qy:f32 = q.y;
        let qz:f32 = q.z;
        let qw:f32 = q.w;
    
        let ix:f32 = qw * x + qy * z - qz * y;
        let iy:f32 = qw * y + qz * x - qx * z;
        let iz:f32 = qw * z + qx * y - qy * x;
        let iw:f32 = -qx * x - qy * y - qz * z;
    
        var ret: vec3<f32>;
        ret.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        ret.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        ret.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    
        return ret;
    }
    
    fn convertIdToDir3(uv_i32:vec2<i32>, quaternion:vec4<f32>) -> vec3<f32>{
        var uv_f32:vec2<f32> = vec2<f32>(uv_i32.xy);
        var halfSize:f32 = f32(size.dstWidth / 2);
        var worldDirection:vec3<f32> = vec3<f32>(uv_f32.x - halfSize, uv_f32.y - halfSize, -halfSize);
        worldDirection = normalize(worldDirection);
        worldDirection = applyQuaternion(worldDirection, quaternion);
        return worldDirection;
    }
    
    fn VanDerCorpus(n0:u32, base0:u32) -> f32
    {
        var n = n0;
        var base = base0;
        var invBase:f32 = 1.0 / f32(base);
        var denom:f32   = 1.0;
        var result:f32  = 0.0;
    
        for(var i:u32 = 0u; i < 32u; i = i + 1u)
        {
            if(n > 0u)
            {
                denom   = f32(n) % 2.0;
                result = result + denom * invBase;
                invBase = invBase / 2.0;
                n       = u32(f32(n) / 2.0);
            }
        }
    
        return result;
    }
    
    fn HammersleyNoBitOps(i:u32, N:u32) -> vec2<f32>
    {
        return vec2(f32(i)/f32(N), VanDerCorpus(i, 2u));
    }
    
    fn hammersley( i : u32 ,  N : u32 ) -> vec2<f32>
    {
        // Radical inverse based on http://holger.dammertz.org/stuff/notes_HammersleyOnHemisphere.html
        var bits = (i << 16u) | (i >> 16u);
        bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
        bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
        bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
        bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
        var rdi = f32(bits) * 2.3283064365386963e-10;
        return vec2<f32>(f32(i) /f32(N), rdi);
    }
    
    fn ImportanceSampleGGX( Xi:vec2<f32>, N:vec3<f32>, roughness:f32) ->vec3<f32>
    {
        var a = roughness*roughness;
    
        var phi = 2.0 * PI * Xi.x;
        var cosTheta = sqrt((1.0 - Xi.y) / (1.0 + (a*a - 1.0) * Xi.y));
        var sinTheta = sqrt(1.0 - cosTheta*cosTheta);
    
        // from spherical coordinates to cartesian coordinates
        var H:vec3<f32>;
        H.x = cos(phi) * sinTheta;
        H.y = sin(phi) * sinTheta;
        H.z = cosTheta;
    
        // from tangent-space vector to world-space sample vector
        var up:vec3<f32>;
        if(abs(N.z) < 0.999)
        {
            up = vec3<f32>(0.0, 0.0, 1.0);
        }
        else
        {
            up = vec3<f32>(1.0, 0.0, 0.0);
        }
        var tangent:vec3<f32>  = normalize(cross(up, N));
        var bitangent:vec3<f32> = cross(N, tangent);
        var sampleVec:vec3<f32> = tangent * H.x + bitangent * H.y + N * H.z;
        return normalize(sampleVec);
    }
    
    fn multiSample(normal:vec3<f32>, roughness:f32) -> vec4<f32>
    {
        var N: vec3<f32> = normalize(normal);
        var R: vec3<f32> = N;
        var V: vec3<f32> = R;
    
        let SAMPLE_COUNT:u32 = 1024u;
        var totalWeight:f32 = 0.0;
        var prefilteredColor:vec3<f32> = vec3<f32>(0.0, 0.0, 0.0);
        for(var i:u32 = 0u; i < SAMPLE_COUNT; i = i + 1u)
        {
            var Xi:vec2<f32> = hammersley(i, SAMPLE_COUNT);
            var H :vec3<f32> = ImportanceSampleGGX(Xi, N, roughness);
            var L :vec3<f32> = normalize(2.0 * dot(V, H) * H - V);
    
            var NdotL:f32 = max(dot(N, L), 0.0);
            if(NdotL > 0.0)
            {
                var att = 1.0 ;//( f32(SAMPLE_COUNT - i) / f32(SAMPLE_COUNT)) ;
    
                prefilteredColor = prefilteredColor + sampleColor(L).rgb * NdotL;
                prefilteredColor = prefilteredColor * att ;
                totalWeight      = totalWeight + NdotL;
            }
        }
        prefilteredColor = prefilteredColor / totalWeight;
    
        return vec4<f32>(prefilteredColor, 1.0);
    }
    
    fn SampleSphericalMap(v: vec3<f32>) -> vec2<f32> {
        var uv:vec2<f32> = vec2<f32>(atan2(v.z, v.x), asin(v.y));
        //uv = (uv * (vec2<f32>(0.1590999960899353, 0.3183000087738037) + vec2<f32>(0.0010000000474974513)));
        uv = uv * vec2<f32>(0.1590999960899353, 0.3183000087738037);
        uv = uv + vec2<f32>(0.5);
        uv = clamp(uv, vec2<f32>(0.0), vec2<f32>(1.0));
        return uv;
    }
    
    fn sampleColor(d:vec3<f32>) -> vec4<f32>
    {
        let uv_f32:vec2<f32> = SampleSphericalMap(d);
        let oc = textureSampleLevel(inputTex, inputTexSampler, uv_f32 , 0.0);
        //let dir = vec3<f32>(-d.x, -d.y, d.z);
        //var oc:vec4<f32> = textureSampleLevel(cubeMap, cubeMapSampler, dir, 0.0);
        return oc;
    }
    
    @compute @workgroup_size(8, 8, 1)
    fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
        let coord = vec2<i32>(GlobalInvocationID.xy);
        let quaternion = faceRotation[GlobalInvocationID.z];
        var worldDirection:vec3<f32> = convertIdToDir3(coord, quaternion);
        var oc:vec4<f32> = multiSample(worldDirection, blurSetting.x);
        textureStore(outputBuffer0, coord, i32(GlobalInvocationID.z), oc);
    }

`
    );

    class IBLEnvMapCreator {
      static importantSample(image, dstSize, roughness, dstView) {
        const ctx = image.erpTexture._boundCtx;
        const device = ctx.device;
        const gpu = ctx.gpuContext;
        const state = ctx.cache(IBLEnvMapCreator, () => ({
          configBuffer: null,
          quaternionBuffer: null,
          blurSettingBuffer: null,
          pipeline: null,
          quaternionUploaded: false
        }));
        if (state.pipeline == null) {
          state.pipeline = device.createComputePipeline({
            layout: `auto`,
            compute: {
              module: device.createShaderModule({
                code: IBLEnvMapCreator_cs
              }),
              entryPoint: "main"
            }
          });
        }
        const computePipeline = state.pipeline;
        const configStride = 4 * 4;
        state.configBuffer ||= device.createBuffer({
          size: configStride,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(state.configBuffer, 0, new Uint32Array([image.width, image.height, dstSize, dstSize]));
        const quaternionSize = 4 * 6;
        if (!state.quaternionBuffer) {
          state.quaternionBuffer = device.createBuffer({
            size: quaternionSize * 4 * 6,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST
          });
          let qArray = new Float32Array(4 * 6);
          for (let i = 0; i < 6; i++) {
            let q = TextureCubeUtils.getRotationToFace(i);
            qArray[i * 4 + 0] = q.x;
            qArray[i * 4 + 1] = q.y;
            qArray[i * 4 + 2] = q.z;
            qArray[i * 4 + 3] = q.w;
          }
          device.queue.writeBuffer(state.quaternionBuffer, 0, qArray);
        }
        state.blurSettingBuffer ||= device.createBuffer({
          size: configStride,
          usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
        device.queue.writeBuffer(state.blurSettingBuffer, 0, new Float32Array([roughness, 0, 0, 0]));
        const inputImageBuffer = image.erpTexture;
        let entries0 = [
          {
            binding: 0,
            resource: {
              buffer: state.configBuffer,
              size: 4 * 4
            }
          },
          {
            binding: 1,
            resource: {
              buffer: state.quaternionBuffer,
              size: quaternionSize * 4
            }
          },
          {
            binding: 2,
            resource: inputImageBuffer.gpuSampler
          },
          {
            binding: 3,
            resource: inputImageBuffer.getGPUView()
          }
        ];
        let entries1 = [
          {
            binding: 0,
            resource: {
              buffer: state.blurSettingBuffer,
              size: 4 * 4
            }
          },
          {
            binding: 1,
            resource: dstView
          }
        ];
        const computeBindGroup0 = device.createBindGroup({
          layout: computePipeline.getBindGroupLayout(0),
          entries: entries0
        });
        const computeBindGroup1 = device.createBindGroup({
          layout: computePipeline.getBindGroupLayout(1),
          entries: entries1
        });
        const commandEncoder = gpu.beginCommandEncoder();
        const computePass = commandEncoder.beginComputePass();
        computePass.setPipeline(computePipeline);
        computePass.setBindGroup(0, computeBindGroup0);
        computePass.setBindGroup(1, computeBindGroup1);
        computePass.dispatchWorkgroups(dstSize / 8, dstSize / 8, 6);
        computePass.end();
        gpu.endCommandEncoder(commandEncoder);
      }
    }

    class TextureCubeFaceData {
      /**
       * Cache of per-mip-level GPU texture and array texture-view references.
       */
      faceTextureRef;
      _texture;
      constructor(texture) {
        this._texture = texture;
        this.faceTextureRef = {};
      }
      /**
       * fill this texture by a texture2D, which is a 360 panorama image
       * assign mipmap level
       * @param mip mipmap level
       * @param texture a panorama image
       * @returns
       */
      uploadTexture(mip, texture) {
        let gpuSource = this.getGpuSource(mip);
        ErpImage2CubeMap.makeTextureCube(texture, this._texture.width, gpuSource.v);
        return this;
      }
      /**
       * @private
       * @param texture texture reference
       * @returns this
       */
      uploadErpTexture(texture) {
        let gpuSource = this.getGpuSource(0);
        ErpImage2CubeMap.makeTextureCube(texture, this._texture.width, gpuSource.v);
        this.generateMipmap(texture);
        return this;
      }
      /**
       * get GPU texture raw data
       * @param mip mipmap level
       * @returns GPU texture raw data, including t: GPUTexture and v: GPUTextureView
       */
      getGpuSource(mip) {
        let source = this.faceTextureRef[mip];
        if (!source) {
          source = {
            t: this._texture.getGPUTexture(),
            v: this._texture.getGPUTexture().createView({
              format: this._texture.format,
              dimension: "2d-array",
              baseMipLevel: mip,
              mipLevelCount: 1,
              arrayLayerCount: 6
            })
          };
          this.faceTextureRef[mip] = source;
        }
        return source;
      }
      /**
       * @private generateMipmap
       * @param texture texture reference
       */
      generateMipmap(texture) {
        let mipmap = 1;
        while (mipmap < this._texture.mipmapCount) {
          this.generateMipmapAtLevel(mipmap, texture);
          mipmap++;
        }
      }
      /**
       * @private Generate a specified level of Mipmap
       * @param mipmap mipmap level
       * @param erpTexture ERP Texture Object
       * @param pow power
       */
      generateMipmapAtLevel(mipmap, erpTexture, pow = 3) {
        let mipFaceSize = this._texture.width / Math.pow(2, mipmap);
        let image = { width: mipFaceSize, height: mipFaceSize, erpTexture };
        let roughness = (mipmap + 1) / this._texture.mipmapCount;
        roughness = Math.pow(roughness, pow);
        let gpuSource = this.getGpuSource(mipmap);
        IBLEnvMapCreator.importantSample(image, mipFaceSize, roughness, gpuSource.v);
      }
    }

    class HDRTextureCube extends TextureCube {
      _url;
      _faceData;
      /**
       * create a cube texture, it's high dynamic range texture
       */
      constructor() {
        super();
        this.useMipmap = true;
        this.format = GPUTextureFormat.rgba16float;
        this.isHDRTexture = true;
        this._faceData = new TextureCubeFaceData(this);
      }
      /**
       * fill this texture by array of numbers;the format as [red0, green0, blue0, alpha0, red1, green1, blue1, alpha1...]
       * @param size assign the cube texture size
       * @param data raw data of cubeTexture; the format is { width: number; height: number; array: Uint8Array }
       * @returns
       */
      createFromHDRData(size, data, ctx) {
        let texture = new VirtualTexture(data.width, data.height, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, ctx);
        let float32Array = new Float32Array(data.array);
        ErpImage2CubeMap.convertRGBE2RGBA(texture, float32Array);
        this.createFromTexture(size, texture, ctx);
        return this;
      }
      /**
       * fill this texture by a texture2D, which is a 360 panorama image
       * @param size assign the cube texture size
       * @param texture the image texture
       * @returns
       */
      createFromTexture(size, texture, ctx) {
        this.width = this.height = size;
        this.textureBindingLayout.viewDimension = "cube";
        let mipmapSize = this.width;
        this.mipmapCount = 1;
        while (mipmapSize > 16) {
          mipmapSize /= 2;
          this.mipmapCount++;
        }
        this.createTextureDescriptor(size, size, this.mipmapCount, this.format);
        this.textureDescriptor.size = { width: size, height: size, depthOrArrayLayers: 6 };
        this.textureDescriptor.dimension = "2d";
        this._ensureBound(ctx);
        this.gpuSampler = this._boundCtx.device.createSampler(this);
        this._faceData.uploadErpTexture(texture);
        return this;
      }
      /**
      * load texture data from web url, which is a 360 panorama image
      * @param url web url
      * @param loaderFunctions callback function when load complete
      */
      async load(url, loaderFunctions, ctx) {
        this._url = url;
        let loader = new FileLoader(ctx);
        let parser = await loader.load(url, RGBEParser, loaderFunctions);
        return parser.getCubeTexture();
      }
    }

    function arrayToString(array) {
      const utf8decoder = new TextDecoder();
      return utf8decoder.decode(array);
    }

    class FeatureTable {
      buffer;
      binOffset;
      binLength;
      header;
      constructor(buffer, start, headerLength, binLength) {
        this.buffer = buffer;
        this.binOffset = start + headerLength;
        this.binLength = binLength;
        let header = null;
        if (headerLength !== 0) {
          const headerData = new Uint8Array(buffer, start, headerLength);
          header = JSON.parse(arrayToString(headerData));
        } else {
          header = {};
        }
        this.header = header;
      }
      getKeys() {
        return Object.keys(this.header);
      }
      getData(key, count, defaultComponentType = null, defaultType = null) {
        const header = this.header;
        if (!(key in header)) {
          return null;
        }
        const feature = header[key];
        if (!(feature instanceof Object)) {
          return feature;
        } else if (Array.isArray(feature)) {
          return feature;
        } else {
          const { buffer, binOffset, binLength } = this;
          const byteOffset = feature.byteOffset || 0;
          const featureType = feature.type || defaultType;
          const featureComponentType = feature.componentType || defaultComponentType;
          if ("type" in feature && defaultType && feature.type !== defaultType) {
            throw new Error("FeatureTable: Specified type does not match expected type.");
          }
          let stride;
          switch (featureType) {
            case "SCALAR":
              stride = 1;
              break;
            case "VEC2":
              stride = 2;
              break;
            case "VEC3":
              stride = 3;
              break;
            case "VEC4":
              stride = 4;
              break;
            default:
              throw new Error(`FeatureTable : Feature type not provided for "${key}".`);
          }
          let data;
          const arrayStart = binOffset + byteOffset;
          const arrayLength = count * stride;
          switch (featureComponentType) {
            case "BYTE":
              data = new Int8Array(buffer, arrayStart, arrayLength);
              break;
            case "UNSIGNED_BYTE":
              data = new Uint8Array(buffer, arrayStart, arrayLength);
              break;
            case "SHORT":
              data = new Int16Array(buffer, arrayStart, arrayLength);
              break;
            case "UNSIGNED_SHORT":
              data = new Uint16Array(buffer, arrayStart, arrayLength);
              break;
            case "INT":
              data = new Int32Array(buffer, arrayStart, arrayLength);
              break;
            case "UNSIGNED_INT":
              data = new Uint32Array(buffer, arrayStart, arrayLength);
              break;
            case "FLOAT":
              data = new Float32Array(buffer, arrayStart, arrayLength);
              break;
            case "DOUBLE":
              data = new Float64Array(buffer, arrayStart, arrayLength);
              break;
            default:
              throw new Error(`FeatureTable : Feature component type not provided for "${key}".`);
          }
          const dataEnd = arrayStart + arrayLength * data.BYTES_PER_ELEMENT;
          if (dataEnd > binOffset + binLength) {
            throw new Error("FeatureTable: Feature data read outside binary body length.");
          }
          return data;
        }
      }
    }
    class BatchTable extends FeatureTable {
      batchSize;
      constructor(buffer, batchSize, start, headerLength, binLength) {
        super(buffer, start, headerLength, binLength);
        this.batchSize = batchSize;
      }
      getData(key, componentType = null, type = null) {
        return super.getData(key, this.batchSize, componentType, type);
      }
    }

    function readMagicBytes(bufferOrDataView) {
      let view;
      if (bufferOrDataView instanceof DataView) {
        view = bufferOrDataView;
      } else {
        view = new DataView(bufferOrDataView);
      }
      if (String.fromCharCode(view.getUint8(0)) === "{") {
        return null;
      }
      let magicBytes = "";
      for (let i = 0; i < 4; i++) {
        magicBytes += String.fromCharCode(view.getUint8(i));
      }
      return magicBytes;
    }

    class B3DMLoaderBase {
      async parse(buffer) {
        const dataView = new DataView(buffer);
        const magic = readMagicBytes(dataView);
        console.assert(magic === "b3dm");
        const version = dataView.getUint32(4, true);
        console.assert(version === 1);
        const byteLength = dataView.getUint32(8, true);
        console.assert(byteLength === buffer.byteLength);
        const featureTableJSONByteLength = dataView.getUint32(12, true);
        const featureTableBinaryByteLength = dataView.getUint32(16, true);
        const batchTableJSONByteLength = dataView.getUint32(20, true);
        const batchTableBinaryByteLength = dataView.getUint32(24, true);
        const featureTableStart = 28;
        const featureTable = new FeatureTable(
          buffer,
          featureTableStart,
          featureTableJSONByteLength,
          featureTableBinaryByteLength
        );
        const batchTableStart = featureTableStart + featureTableJSONByteLength + featureTableBinaryByteLength;
        const batchTable = new BatchTable(
          buffer,
          featureTable.getData("BATCH_LENGTH"),
          batchTableStart,
          batchTableJSONByteLength,
          batchTableBinaryByteLength
        );
        const glbStart = batchTableStart + batchTableJSONByteLength + batchTableBinaryByteLength;
        const glbBytes = new Uint8Array(buffer, glbStart, byteLength - glbStart);
        return {
          version,
          featureTable,
          batchTable,
          glbBytes
        };
      }
    }

    class B3DMLoader extends B3DMLoaderBase {
      adjustmentTransform;
      gltfBuffer;
      static tempMatrix;
      constructor() {
        super();
        this.adjustmentTransform = new Matrix4().identity();
        B3DMLoader.tempMatrix ||= new Matrix4().identity();
      }
      async parse(buffer, customLoader) {
        const b3dm = await super.parse(buffer);
        this.gltfBuffer = b3dm.glbBytes.slice().buffer;
        if (customLoader) {
          let ret = await customLoader(this.gltfBuffer);
          if (ret) {
            return ret;
          }
        }
        let glbLoader = new B3DMParseUtil();
        let model = await glbLoader.parseBinary(this.gltfBuffer);
        let { batchTable, featureTable } = b3dm;
        const rtcCenter = featureTable.getData("RTC_CENTER");
        if (rtcCenter) {
          model.x += rtcCenter[0];
          model.y += rtcCenter[1];
          model.z += rtcCenter[2];
        }
        let transform = model.getComponent(Transform);
        transform.updateWorldMatrix();
        let tempMatrix = B3DMLoader.tempMatrix;
        tempMatrix.compose(transform.localPosition, transform.localRotQuat, transform.localScale);
        tempMatrix.multiply(this.adjustmentTransform);
        let prs = tempMatrix.decompose(Orientation3D.QUATERNION);
        transform.localRotQuat.copy(prs[1]);
        transform.localRotQuat = transform.localRotQuat;
        transform.localPosition.copy(prs[0]);
        transform.localPosition = transform.localPosition;
        transform.localScale.copy(prs[2]);
        transform.localScale = transform.localScale;
        transform.updateWorldMatrix();
        model["batchTable"] = batchTable;
        model["featureTable"] = featureTable;
        return model;
      }
      static decodeText(array) {
        if (typeof TextDecoder !== "undefined") {
          return new TextDecoder().decode(array);
        }
        let s = "";
        for (let i = 0, il = array.length; i < il; i++) {
          s += String.fromCharCode(array[i]);
        }
        try {
          return decodeURIComponent(escape(s));
        } catch (e) {
          return s;
        }
      }
    }

    class B3DMParser extends ParserBase {
      static format = ParserFormat.JSON;
      /**
       * Parse a `.b3dm` binary buffer into an {@link Object3D}.
       * @param buffer Raw `.b3dm` binary data.
       * @param customLoader Optional hook to load the embedded glTF/GLB payload.
       */
      async parseBuffer(buffer, customLoader) {
        let loader = new B3DMLoader();
        loader.adjustmentTransform = this.userData;
        this.data = await loader.parse(buffer, customLoader);
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("Method not implemented.");
      }
    }
    const BINARY_EXTENSION_HEADER_MAGIC = "glTF";
    const BINARY_EXTENSION_HEADER_LENGTH = 12;
    const BINARY_EXTENSION_CHUNK_TYPES = { JSON: 1313821514, BIN: 5130562 };
    const EXTENSIONS = {
      KHR_BINARY_GLTF: "KHR_binary_glTF",
      KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
      KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
      KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
      KHR_MATERIALS_IOR: "KHR_materials_ior",
      KHR_MATERIALS_PBR_SPECULAR_GLOSSINESS: "KHR_materials_pbrSpecularGlossiness",
      KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
      KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
      KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
      KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
      KHR_MATERIALS_VOLUME: "KHR_materials_volume",
      KHR_TEXTURE_BASISU: "KHR_texture_basisu",
      KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
      KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
      EXT_TEXTURE_WEBP: "EXT_texture_webp",
      EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression"
    };
    class GLTFBinaryExtension {
      name;
      content;
      body;
      header;
      constructor(data) {
        this.name = EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
        this.header = {
          magic: B3DMLoader.decodeText(new Uint8Array(data.slice(0, 4))),
          version: headerView.getUint32(4, true),
          length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) {
          throw new Error("GLTFLoader: Unsupported glTF-Binary header.");
        } else if (this.header.version < 2) {
          throw new Error("GLTFLoader: Legacy binary file detected.");
        }
        const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while (chunkIndex < chunkContentsLength) {
          const chunkLength = chunkView.getUint32(chunkIndex, true);
          chunkIndex += 4;
          const chunkType = chunkView.getUint32(chunkIndex, true);
          chunkIndex += 4;
          if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
            const contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
            this.content = B3DMLoader.decodeText(contentArray);
          } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
            const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
            this.body = data.slice(byteOffset, byteOffset + chunkLength);
          }
          chunkIndex += chunkLength;
        }
        if (this.content === null) {
          throw new Error("GLTFLoader: JSON content not found.");
        }
      }
    }
    class B3DMParseUtil {
      _binary;
      async parseBinary(bytes) {
        this._binary = bytes;
        const magic = B3DMLoader.decodeText(new Uint8Array(this._binary, 0, 4));
        const extensions = {};
        let content;
        let info;
        if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
          try {
            info = extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(this._binary);
          } catch (error) {
            return;
          }
          content = extensions[EXTENSIONS.KHR_BINARY_GLTF].content;
        } else {
          content = B3DMLoader.decodeText(new Uint8Array(this._binary));
        }
        const json = JSON.parse(content);
        let obj3d = await this.parseGLB(json, info.body);
        return obj3d;
      }
      async parseGLB(json, bin) {
        let loader = new GLBParser();
        let obj3d = await loader.parseJsonAndBuffer(json, bin);
        return obj3d;
      }
    }

    class I3DMLoaderBase {
      async parse(buffer) {
        const dataView = new DataView(buffer);
        const magic = readMagicBytes(dataView);
        console.assert(magic === "i3dm");
        const version = dataView.getUint32(4, true);
        console.assert(version === 1);
        const byteLength = dataView.getUint32(8, true);
        console.assert(byteLength === buffer.byteLength);
        const featureTableJSONByteLength = dataView.getUint32(12, true);
        const featureTableBinaryByteLength = dataView.getUint32(16, true);
        const batchTableJSONByteLength = dataView.getUint32(20, true);
        const batchTableBinaryByteLength = dataView.getUint32(24, true);
        dataView.getUint32(28, true);
        const featureTableStart = 32;
        const featureTable = new FeatureTable(
          buffer,
          featureTableStart,
          featureTableJSONByteLength,
          featureTableBinaryByteLength
        );
        const batchTableStart = featureTableStart + featureTableJSONByteLength + featureTableBinaryByteLength;
        const batchTable = new BatchTable(
          buffer,
          featureTable.getData("INSTANCES_LENGTH"),
          batchTableStart,
          batchTableJSONByteLength,
          batchTableBinaryByteLength
        );
        const glbStart = batchTableStart + batchTableJSONByteLength + batchTableBinaryByteLength;
        const glbBytes = new Uint8Array(buffer, glbStart, byteLength - glbStart);
        return {
          version,
          featureTable,
          batchTable,
          glbBytes
        };
      }
    }

    class InstancedMesh extends exports.Object3D {
      _geometry;
      _material;
      _instanceList;
      constructor(geometry, material, length) {
        super();
        this._geometry = geometry;
        this._material = material;
        this._instanceList = [];
        for (let i = 0; i < length; i++) {
          let component;
          let child = new exports.Object3D();
          component = child.addComponent(exports.MeshRenderer);
          component.geometry = this._geometry;
          component.material = this._material;
          this.addChild(child);
          this._instanceList.push(child);
        }
      }
      /**
       * Set the local transform of the instance at the given index from a matrix.
       * @param index the instance index
       * @param matrix the transform matrix to decompose and apply
       * @returns this instance for chaining
       */
      setMatrixAt(index, matrix) {
        let instance = this._instanceList[index];
        let prs = matrix.decompose(Orientation3D.QUATERNION);
        let transform = instance.transform;
        transform.localRotQuat.copy(prs[1]);
        transform.localRotQuat = transform.localRotQuat;
        transform.localPosition.copy(prs[0]);
        transform.localPosition = transform.localPosition;
        transform.localScale.copy(prs[2]);
        transform.localScale = transform.localScale;
        return this;
      }
      // public setMatrixAt1(index: number, matrix: Matrix4) {
      //     let instance = this.getIndex(index);
      //     let p = new Vector3();
      //     let r = new Quaternion();
      //     let s = new Vector3();
      //     matrix.decompose1(p, r, s);
      //     let childTransform = instance.transform;
      //     childTransform.localRotQuat = r;
      //     childTransform.localPosition = p;
      //     childTransform.localScale = s;
      // }
    }

    class I3DMLoader extends I3DMLoaderBase {
      static tempFwd;
      static tempUp;
      static tempRight;
      static tempPos;
      static tempQuat;
      static tempSca;
      static tempMat;
      adjustmentTransform;
      _gltfBuffer;
      constructor() {
        super();
        I3DMLoader.tempFwd ||= new Vector3();
        I3DMLoader.tempUp ||= new Vector3();
        I3DMLoader.tempRight ||= new Vector3();
        I3DMLoader.tempPos ||= new Vector3();
        I3DMLoader.tempQuat ||= new Quaternion();
        I3DMLoader.tempSca ||= new Vector3();
        I3DMLoader.tempMat ||= new Matrix4();
        this.adjustmentTransform = new Matrix4().identity();
      }
      async parse(buffer) {
        const i3dm = await super.parse(buffer);
        this._gltfBuffer = i3dm.glbBytes.slice().buffer;
        let glbLoader = new B3DMParseUtil();
        let model = await glbLoader.parseBinary(this._gltfBuffer);
        let { batchTable, featureTable } = i3dm;
        const adjustmentTransform = this.adjustmentTransform;
        const INSTANCES_LENGTH = featureTable.getData("INSTANCES_LENGTH");
        const POSITION = featureTable.getData("POSITION", INSTANCES_LENGTH, "FLOAT", "VEC3");
        const NORMAL_UP = featureTable.getData("NORMAL_UP", INSTANCES_LENGTH, "FLOAT", "VEC3");
        const NORMAL_RIGHT = featureTable.getData("NORMAL_RIGHT", INSTANCES_LENGTH, "FLOAT", "VEC3");
        const SCALE_NON_UNIFORM = featureTable.getData("SCALE_NON_UNIFORM", INSTANCES_LENGTH, "FLOAT", "VEC3");
        const SCALE = featureTable.getData("SCALE", INSTANCES_LENGTH, "FLOAT", "SCALAR");
        const instanceMap = /* @__PURE__ */ new Map();
        const instances = [];
        model.traverse((child) => {
          let renderer;
          renderer = child ? child.getComponent(exports.MeshRenderer) : null;
          if (renderer) {
            const { geometry, material } = renderer;
            const instancedMesh = new InstancedMesh(geometry, material, INSTANCES_LENGTH);
            instancedMesh.localPosition = instancedMesh.localPosition.copy(child.localPosition);
            instancedMesh.localRotation = instancedMesh.localRotation.copy(child.localRotation);
            instancedMesh.localScale = instancedMesh.localScale.copy(child.localScale);
            instances.push(instancedMesh);
            instanceMap.set(child, instancedMesh);
          }
        });
        const averageVector = new Vector3();
        for (let i = 0; i < INSTANCES_LENGTH; i++) {
          averageVector.x += POSITION[i * 3 + 0] / INSTANCES_LENGTH;
          averageVector.y += POSITION[i * 3 + 1] / INSTANCES_LENGTH;
          averageVector.z += POSITION[i * 3 + 2] / INSTANCES_LENGTH;
        }
        instanceMap.forEach((instancedMesh, oldObject) => {
          const parent = oldObject.parent ? oldObject.parentObject : null;
          if (parent) {
            parent.removeChild(oldObject);
            parent.addChild(instancedMesh);
            instancedMesh.transform.updateWorldMatrix();
            Matrix4.transformVector4(instancedMesh.transform.worldMatrix, averageVector, instancedMesh.localPosition);
          }
        });
        const temp = I3DMLoader;
        for (let i = 0; i < INSTANCES_LENGTH; i++) {
          temp.tempMat.identity();
          temp.tempPos.set(
            POSITION[i * 3 + 0] - averageVector.x,
            POSITION[i * 3 + 1] - averageVector.y,
            POSITION[i * 3 + 2] - averageVector.z
          );
          if (NORMAL_UP) {
            temp.tempUp.set(NORMAL_UP[i * 3 + 0], NORMAL_UP[i * 3 + 1], NORMAL_UP[i * 3 + 2]);
            temp.tempRight.set(NORMAL_RIGHT[i * 3 + 0], NORMAL_RIGHT[i * 3 + 1], NORMAL_RIGHT[i * 3 + 2]);
            Vector3.cross(temp.tempRight, temp.tempUp, temp.tempFwd);
            temp.tempFwd.normalize();
            temp.tempMat.makeBasis(temp.tempRight, temp.tempUp, temp.tempFwd);
            temp.tempQuat.setFromRotationMatrix(temp.tempMat);
          } else {
            temp.tempQuat.set(0, 0, 0, 1);
          }
          if (SCALE) {
            temp.tempSca.setScalar(SCALE[i]);
          } else if (SCALE_NON_UNIFORM) {
            temp.tempSca.set(
              SCALE_NON_UNIFORM[i * 3 + 0],
              SCALE_NON_UNIFORM[i * 3 + 1],
              SCALE_NON_UNIFORM[i * 3 + 2]
            );
          } else {
            temp.tempSca.set(1, 1, 1);
          }
          temp.tempMat.compose(temp.tempPos, temp.tempQuat, temp.tempSca);
          temp.tempMat.multiplyMatrices(temp.tempMat, adjustmentTransform);
          for (let j = 0, l = instances.length; j < l; j++) {
            const instance = instances[j];
            instance.setMatrixAt(i, temp.tempMat);
          }
        }
        model["batchTable"] = batchTable;
        model["featureTable"] = featureTable;
        return model;
      }
    }

    class I3DMParser extends ParserBase {
      static format = ParserFormat.BIN;
      /**
       * Parse an i3dm binary buffer and store the resulting model in `this.data`.
       * @param buffer The raw i3dm file contents.
       */
      async parseBuffer(buffer) {
        let loader = new I3DMLoader();
        loader.adjustmentTransform = this.userData;
        this.data = await loader.parse(buffer);
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("Method not implemented.");
      }
    }

    class LDRTextureCube extends TextureCube {
      _faceData;
      _url;
      /**
       * constructor: create a cube texture, it's low dynamic range texture
       */
      get ldrImageUrl() {
        return this._url;
      }
      constructor() {
        super();
        this.useMipmap = true;
        this.format = GPUTextureFormat.rgba16float;
        this._faceData = new TextureCubeFaceData(this);
      }
      /**
      * load texture data from web url, which is a 360 panorama image
      * @param url web url
      * @param loaderFunctions callback function when load complete
      */
      async load(url, loaderFunctions, ctx) {
        this._url = url;
        let bitmapTexture = new BitmapTexture2D(false, ctx, "srgb");
        await bitmapTexture.load(url, loaderFunctions);
        this.createFromLDRTexture(bitmapTexture, ctx);
        return this;
      }
      /**
       *
       * Create a texture cube
       * @param srcTexture The cube texture will be created from this 2D texture
       * @returns this
       */
      createFromLDRTexture(srcTexture, ctx) {
        let size = Math.log2(srcTexture.width / 4);
        size = Math.pow(2, Math.round(size));
        this.createFromTexture(size, srcTexture, ctx);
        return this;
      }
      /**
       *
       * create cube texture by environment image
       * @param size size of cube texture
       * @param texture source texture
       */
      createFromTexture(size, texture, ctx) {
        this.width = this.height = size;
        this.textureBindingLayout.viewDimension = "cube";
        let mipmapSize = this.width;
        this.mipmapCount = 1;
        while (mipmapSize > 16) {
          mipmapSize /= 2;
          this.mipmapCount++;
        }
        this.createTextureDescriptor(size, size, this.mipmapCount, this.format);
        this.textureDescriptor.size = { width: size, height: size, depthOrArrayLayers: 6 };
        this.textureDescriptor.dimension = "2d";
        this._ensureBound(ctx);
        this.gpuSampler = this._boundCtx.device.createSampler(this);
        this._faceData.uploadErpTexture(texture);
        return this;
      }
    }

    let BRDFLUT = (
      /*wgsl*/
      `
var<private>PI: f32 = 3.141592653589793;

// fn saturate( x : f32 ) -> f32 {
//     return clamp(x, 0.0, 1.0);
// }

fn hammersley(i : u32, N : u32) -> vec2<f32>
{
    // Radical inverse based on http://holger.dammertz.org/stuff/notes_HammersleyOnHemisphere.html
    var bits = (i << 16u) | (i >> 16u);
    bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
    bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
    bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
    bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
    var rdi = f32(bits) * 2.3283064365386963e-10;
    return vec2<f32>(f32(i) / f32(N), rdi);
}

fn G_Smith(NoV: f32, NoL : f32, roughness : f32) -> f32
{
    var k = (roughness * roughness) / 2.0;
    var GGXL = NoL / (NoL * (1.0 - k) + k);
    var GGXV = NoV / (NoV * (1.0 - k) + k);
    return GGXL * GGXV;
}

fn V_SmithGGXCorrelated(NoV: f32, NoL : f32, roughness : f32) -> f32
{
    var a2 = pow(roughness, 4.0);
    var GGXV = NoL * sqrt(NoV * NoV * (1.0 - a2) + a2);
    var GGXL = NoV * sqrt(NoL * NoL * (1.0 - a2) + a2);
    return 0.5 / (GGXV + GGXL);
}


// Based on Karis 2014
fn importanceSampleGGX(Xi: vec2<f32>, roughness: f32, N: vec3<f32>) -> vec3<f32>
{
    var a = roughness * roughness;
    // Sample in spherical coordinates
    var Phi = 2.0 * PI * Xi.x;
    var CosTheta = sqrt((1.0 - Xi.y) / (1.0 + (a * a - 1.0) * Xi.y));
    var SinTheta = sqrt(1.0 - CosTheta * CosTheta);
    // Construct tangent space vector
    var H: vec3<f32>;
    H.x = SinTheta * cos(Phi);
    H.y = SinTheta * sin(Phi);
    H.z = CosTheta;

    // Tangent to world space
    var UpVector = vec3<f32>(1.0, 0.0, 0.0);
    if (abs(N.z) < 0.999) {
        UpVector = vec3<f32>(0.0, 0.0, 1.0);
    }
    var TangentX = normalize(cross(UpVector, N));
    var TangentY = cross(N, TangentX);
    return TangentX * H.x + TangentY * H.y + N * H.z;
}


// Karis 2014
fn integrateBRDF(roughness: f32, NoV: f32) -> vec2<f32>
{
    var V: vec3<f32>;
    V.x = sqrt(1.0 - NoV * NoV); // sin
    V.y = 0.0;
    V.z = NoV; // cos

    // N points straight upwards for this integration
    var N = vec3<f32>(0.0, 0.0, 1.0);

    var A = 0.0;
    var B = 0.0;
    var numSamples = 1024u;

    for (var i = 0u; i < numSamples; i += 1u) {
        var Xi = hammersley(i, numSamples);
        // Sample microfacet direction
        var H = importanceSampleGGX(Xi, roughness, N);

        // Get the light direction
        var L = 2.0 * dot(V, H) * H - V;

        var NoL = saturate(dot(N, L));
        var NoH = saturate(dot(N, H));
        var VoH = saturate(dot(V, H));

        if (NoL > 0.0) {
            var V_pdf = V_SmithGGXCorrelated(NoV, NoL, roughness) * VoH * NoL / NoH;
            var Fc = pow(1.0 - VoH, 5.0);
            A += (1.0 - Fc) * V_pdf;
            B += Fc * V_pdf;
        }
    }

    return 4.0 * vec2<f32>(A, B) / f32(numSamples);
}

@group(0) @binding(0) var brdflutTexture: texture_storage_2d<rgba8unorm, write>;
@compute @workgroup_size(8, 8, 1)
// fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(local_invocation_id) local_invocation_id : vec3<u32> ){
fn CsMain(@builtin(global_invocation_id) global_invocation_id : vec3<u32>){
    var fragCoord = vec2<u32>(global_invocation_id.x, global_invocation_id.y);

    var fragColor = vec4<f32>(0.0);
    // Output to screen
    var res = integrateBRDF(f32(fragCoord.y + 1u) / 256.0, f32(fragCoord.x + 1u) / 256.0);
    fragColor = vec4<f32>(res.x, res.y, 0.0, 1.0);

    textureStore(brdflutTexture, vec2<i32>(fragCoord.xy), fragColor);
}
`
    );

    class BRDFLUTGenerate {
      compute;
      constructor() {
        this.compute = new ComputeShader(BRDFLUT);
      }
      generateBRDFLUTTexture(ctx) {
        let texture = new VirtualTexture(256, 256, GPUTextureFormat.rgba8unorm, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, ctx);
        this.compute.setStorageTexture("brdflutTexture", texture);
        this.compute.workerSizeX = 256 / 8;
        this.compute.workerSizeY = 256 / 8;
        const gpu = texture._boundCtx.gpuContext;
        let commandEncoder = gpu.beginCommandEncoder();
        gpu.computeCommand(commandEncoder, [this.compute]);
        gpu.endCommandEncoder(commandEncoder);
        return texture;
      }
    }

    class Uint8ArrayTexture extends Texture {
      _dataBuffer;
      /**
       * create texture by number array, which format is uint8
       * @param width width of texture
       * @param height height of texture
       * @param data uint8 array
       * @param useMipmap whether or not gen mipmap
       * @returns
       */
      create(width, height, data, useMipmap = false, ctx) {
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        const bytesPerRow = Math.ceil(width * 4 / 256) * 256;
        this.format = GPUTextureFormat.rgba8unorm;
        this.mipmapCount = Math.floor(useMipmap ? Math.log2(width) : 1);
        this.createTextureDescriptor(width, height, this.mipmapCount, this.format);
        const textureDataBuffer = this._dataBuffer = device.createBuffer({
          size: data.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, data);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
        if (useMipmap) {
          TextureMipmapGenerator.webGPUGenerateMipmap(this);
        }
        return this;
      }
      /**
       * validate the change of this texture
       */
      updateTexture(width, height, data) {
        let device = this._boundCtx.device;
        const bytesPerRow = Math.ceil(width * 4 / 256) * 256;
        this.mipmapCount = Math.floor(Math.log2(width) );
        this._dataBuffer && this._dataBuffer.destroy();
        this._dataBuffer = null;
        const textureDataBuffer = this._dataBuffer = device.createBuffer({
          size: data.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, data);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
        this.gpuSampler = device.createSampler(this);
        if (this.mipmapCount > 1) {
          TextureMipmapGenerator.webGPUGenerateMipmap(this);
        }
      }
    }

    var SpriteModifyFlags = /* @__PURE__ */ ((SpriteModifyFlags2) => {
      SpriteModifyFlags2[SpriteModifyFlags2["texture"] = 1] = "texture";
      SpriteModifyFlags2[SpriteModifyFlags2["region"] = 2] = "region";
      SpriteModifyFlags2[SpriteModifyFlags2["pivot"] = 4] = "pivot";
      return SpriteModifyFlags2;
    })(SpriteModifyFlags || {});
    class Sprite {
      /** Optional name, typically the atlas region id this sprite came from. */
      name = "";
      _texture = null;
      /** Normalized sub-rect of `texture` in UV space — (offsetX, offsetY, scaleX, scaleY). */
      _region = new Vector4(0, 0, 1, 1);
      /** Default anchor point in [0,1]² — (0.5, 0.5) = centered. Renderers can override. */
      _pivot = new Vector2(0.5, 0.5);
      _listeners = [];
      constructor(opts) {
        if (opts) {
          if (opts.texture) this._texture = opts.texture;
          if (opts.region) this._region.copy(opts.region);
          if (opts.pivot) this._pivot.copy(opts.pivot);
          if (opts.name) this.name = opts.name;
        }
      }
      /** Source texture for this sprite. */
      get texture() {
        return this._texture;
      }
      /** Set the source texture, notifying listeners on change. */
      set texture(value) {
        if (this._texture !== value) {
          this._texture = value;
          this._dispatch(1 /* texture */);
        }
      }
      /** Normalized sub-rect of the texture in UV space — (offsetX, offsetY, scaleX, scaleY). */
      get region() {
        return this._region;
      }
      /** Set the UV region (copied), notifying listeners. */
      set region(v) {
        this._region.copy(v);
        this._dispatch(2 /* region */);
      }
      /** Default anchor point in [0,1]² — (0.5, 0.5) = centered. */
      get pivot() {
        return this._pivot;
      }
      /** Set the pivot (copied), notifying listeners. */
      set pivot(v) {
        this._pivot.copy(v);
        this._dispatch(4 /* pivot */);
      }
      /** Subscribe to sprite field changes. Renderers use this to invalidate their cached UV data. */
      onChange(fn) {
        if (this._listeners.indexOf(fn) < 0) this._listeners.push(fn);
      }
      /** Unsubscribe a previously registered change listener. */
      offChange(fn) {
        const i = this._listeners.indexOf(fn);
        if (i >= 0) this._listeners.splice(i, 1);
      }
      _dispatch(flags) {
        const arr = this._listeners;
        for (let i = 0; i < arr.length; i++) arr[i](flags);
      }
      /** Shallow clone — texture is shared (not duplicated), all vector fields are copied. */
      clone() {
        const out = new Sprite();
        out.name = this.name;
        out._texture = this._texture;
        out._region.copy(this._region);
        out._pivot.copy(this._pivot);
        return out;
      }
      /** Convenience: build a Sprite from a bare texture, full region, centered pivot. */
      static fromTexture(texture, name) {
        return new Sprite({ texture, name });
      }
    }

    class TextureAtlas {
      /** The shared base texture that all sprites in this atlas reference. */
      texture;
      /** Named sprites parsed from the atlas, keyed by region id. */
      sprites;
      /** Optional atlas name. */
      name = "";
      constructor(texture) {
        this.texture = texture;
        this.sprites = /* @__PURE__ */ new Map();
      }
      /** Look up a named sprite. Returns `undefined` if the atlas has no such region. */
      get(id) {
        return this.sprites.get(id);
      }
      /** Register a sprite. `region` is normalized UV. */
      add(id, region) {
        const sprite = new Sprite({
          texture: this.texture,
          region,
          name: id
        });
        this.sprites.set(id, sprite);
        return sprite;
      }
      /** Register a sprite from a pixel-space rect in the source texture. */
      addPixelRect(id, pixelRect, atlasWidth, atlasHeight) {
        const region = new Vector4(
          pixelRect.x / atlasWidth,
          pixelRect.y / atlasHeight,
          pixelRect.w / atlasWidth,
          pixelRect.h / atlasHeight
        );
        return this.add(id, region);
      }
    }

    class AtlasParser extends ParserBase {
      static format = ParserFormat.TEXT;
      _json;
      _texture;
      /**
       * Parse the atlas JSON, load its sibling `.png` texture, and build
       * the {@link TextureAtlas}.
       * @param data Raw atlas descriptor JSON string.
       */
      async parseString(data) {
        this._json = JSON.parse(data);
        let textureUrl = this.userData.replace(".json", ".png");
        this._texture = await Engine3D.resFor(this.ctx).loadTexture(textureUrl, null, true);
        this.parseAtlas();
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("verify failed.");
      }
      parseAtlas() {
        const atlasW = this._json.size.x;
        const atlasH = this._json.size.y;
        const textureAtlas = new TextureAtlas(this._texture);
        textureAtlas.name = this.baseUrl;
        let atlasInfo = this._json.atlas;
        for (const key in atlasInfo) {
          const entry = atlasInfo[key];
          const rect = entry.textureRect;
          const region = new Vector4(
            rect.x / atlasW,
            rect.y / atlasH,
            rect.z / atlasW,
            rect.w / atlasH
          );
          textureAtlas.add(key, region);
        }
        this.data = textureAtlas;
      }
    }

    class Res {
      _texturePool;
      _materialPool;
      _prefabPool;
      // private _prefabLoaderPool: Map<string, PrefabLoader>;
      _gltfPool;
      _geometryPool;
      _obj;
      /** Context this Res instance is bound to. Parsers launched via this Res
       *  thread this ctx through so their default-texture lookups resolve
       *  against the same device. */
      _ctx;
      /**
       * @constructor
       */
      constructor(ctx) {
        this._ctx = ctx;
        this._texturePool = /* @__PURE__ */ new Map();
        this._materialPool = /* @__PURE__ */ new Map();
        this._prefabPool = /* @__PURE__ */ new Map();
        this._geometryPool = /* @__PURE__ */ new Map();
        this._gltfPool = /* @__PURE__ */ new Map();
        this._obj = /* @__PURE__ */ new Map();
      }
      /**
       * get a parsed glTF info object by url
       * @param url file path
       * @returns the cached GLTF_Info, or undefined if not loaded
       */
      getGltf(url) {
        return this._gltfPool.get(url);
      }
      /**
      * add a obj with reference of url
      * @param url file path
      * @param texture source obj
      */
      addObj(url, obj) {
        this._obj.set(url, obj);
      }
      /**
       * get obj by url
       * @param url file path
       * @returns
       */
      getObj(url) {
        return this._obj.get(url);
      }
      /**
       * add a texture with reference of url
       * @param url file path
       * @param texture source texture
       */
      addTexture(url, texture) {
        this._texturePool.set(url, texture);
      }
      /**
       * get texture by url
       * @param url file path
       * @returns
       */
      getTexture(url) {
        return this._texturePool.get(url);
      }
      addGeometry(url, geo) {
        this._geometryPool.set(url, geo);
      }
      getGeometry(url) {
        return this._geometryPool.get(url);
      }
      /**
       * add a material with reference of name
       * @param name material name
       * @param mat  target material
       */
      addMat(name, mat) {
        return this._materialPool.set(name, mat);
      }
      /**
       * get material by name
       * @param name material name
       * @returns
       */
      getMat(name) {
        return this._materialPool.get(name);
      }
      /**
       * add prefab with reference name
       * @param name prefab name
       * @param rootScene root object of prefab
       */
      addPrefab(name, rootScene) {
        this._prefabPool.set(name, rootScene);
      }
      /**
       * get prefab by name
       * @param name prefab name
       * @returns
       */
      getPrefab(name) {
        return this._prefabPool.get(name).instantiate();
      }
      /**
       * load a file with a custom parser and return its parsed data
       * @param url the url of file
       * @param c the parser class to use
       * @param loaderFunctions optional load callbacks
       * @returns the parser's data
       */
      async load(url, c, loaderFunctions) {
        let loader = new FileLoader(this._ctx);
        let parser = await loader.load(url, c, loaderFunctions);
        let ret = parser.data;
        return ret;
      }
      /**
       * load a gltf file
       * @param url the url of file
       * @param loaderFunctions callback
       * @returns
       */
      async loadGltf(url, loaderFunctions) {
        if (this._prefabPool.has(url)) {
          return this._prefabPool.get(url);
        }
        let parser;
        let ext = url.substring(url.lastIndexOf(".")).toLowerCase();
        let loader = new FileLoader(this._ctx);
        if (ext == ".gltf") {
          parser = await loader.load(url, GLTFParser, loaderFunctions);
        } else {
          parser = await loader.load(url, GLBParser, loaderFunctions);
        }
        let obj = parser.data;
        this._prefabPool.set(url, obj);
        this._gltfPool.set(url, parser.gltf);
        return obj;
      }
      /**
       * load obj file
       * @param url obj file path
       * @param loaderFunctions callback
       * @returns
       */
      async loadObj(url, loaderFunctions) {
        if (this._prefabPool.has(url)) {
          return this._prefabPool.get(url);
        }
        let parser;
        let ext = url.substring(url.lastIndexOf(".")).toLowerCase();
        let loader = new FileLoader(this._ctx);
        if (ext == ".obj") {
          parser = await loader.load(url, OBJParser, loaderFunctions);
        }
        let obj = parser.data;
        this._prefabPool.set(url, obj);
        return obj;
      }
      /**
       * load b3dm file by url
       * @param url path of file
       * @param loaderFunctions callback
       * @returns
       */
      async loadB3DM(url, loaderFunctions, userData) {
        if (this._prefabPool.has(url)) {
          return this._prefabPool.get(url);
        }
        let loader = new FileLoader(this._ctx);
        let parser = await loader.load(url, B3DMParser, loaderFunctions, userData);
        let obj = parser.data;
        this._prefabPool.set(url, obj);
        return obj;
      }
      /**
       * load i3dm file by url
       * @param url path of i3dm file
       * @param loaderFunctions callback
       * @returns
       */
      async loadI3DM(url, loaderFunctions, userData) {
        if (this._prefabPool.has(url)) {
          return this._prefabPool.get(url);
        }
        let loader = new FileLoader(this._ctx);
        let parser = await loader.load(url, I3DMParser, loaderFunctions, userData);
        let obj = parser.data;
        this._prefabPool.set(url, obj);
        return obj;
      }
      /**
       * load texture by url
       * @param url texture path
       * @param loaderFunctions callback
       * @param flipY use flip y or not
       * @param colorSpace `'srgb'` to load as `rgba8unorm-srgb` (use
       *               for baseColor / emissive / decal maps that store
       *               sRGB-encoded color); `'linear'` (default) keeps
       *               legacy `rgba8unorm` behavior — required for
       *               normal maps, metallic-roughness packs, AO,
       *               masks, height / displacement, and any other
       *               non-color buffer. The default stays `'linear'`
       *               for back-compat until the sRGB pipeline
       *               migration is complete; pass `'srgb'` explicitly
       *               from glTF / sample call sites that load color.
       * @returns
       */
      async loadTexture(url, loaderFunctions, flipY, colorSpace = "linear") {
        const cacheKey = colorSpace === "srgb" ? url + "#srgb" : url;
        if (this._texturePool.has(cacheKey)) {
          return this._texturePool.get(cacheKey);
        }
        let texture = new BitmapTexture2D(true, this._ctx, colorSpace);
        texture.flipY = flipY;
        await texture.load(url, loaderFunctions);
        this._texturePool.set(cacheKey, texture);
        return texture;
      }
      async loadTextureCount(urls, count, loaderFunctions, flipY) {
        return new Promise(
          async (suc, fail) => {
            let total = 0;
            let loadTexture = [];
            if (count == 0) {
              suc(loadTexture);
            }
            for (let j = 0; j < count; j++) {
              const url = urls.shift();
              this.loadTexture(url, loaderFunctions, flipY).then((t) => {
                loadTexture.push(t);
                total++;
                if (total == count) {
                  suc(loadTexture);
                }
              });
            }
          }
        );
      }
      async loadBitmapTextures(urls, count = 5, loaderFunctions, flipY) {
        let loadTexture = [];
        let loadCount = Math.floor(urls.length / count) + 1;
        let last = Math.floor(urls.length % count);
        for (let i = 0; i < loadCount; i++) {
          let list = await this.loadTextureCount(urls, i == loadCount - 1 ? last : count, loaderFunctions, flipY);
          loadTexture.push(...list);
        }
        return loadTexture;
      }
      /**
       * load a hdr texture
       * @param url texture url
       * @param loaderFunctions callback
       * @returns
       */
      async loadHDRTexture(url, loaderFunctions) {
        if (this._texturePool.has(url)) {
          return this._texturePool.get(url);
        }
        let hdrTexture = new HDRTexture();
        hdrTexture = await hdrTexture.load(url, loaderFunctions, this._ctx);
        this._texturePool.set(url, hdrTexture);
        return hdrTexture;
      }
      /**
       * load hdr cube texture
       * @param url file url
       * @param loaderFunctions callback
       * @returns
       */
      async loadHDRTextureCube(url, loaderFunctions) {
        if (this._texturePool.has(url)) {
          return this._texturePool.get(url);
        }
        let hdrTexture = new HDRTextureCube();
        hdrTexture = await hdrTexture.load(url, loaderFunctions, this._ctx);
        this._texturePool.set(url, hdrTexture);
        return hdrTexture;
      }
      /**
       * load ldr cube texture
       * @param url file path
       * @param loaderFunctions callback
       * @returns
       */
      async loadLDRTextureCube(url, loaderFunctions) {
        if (this._texturePool.has(url)) {
          return this._texturePool.get(url);
        }
        let ldrTextureCube = new LDRTextureCube();
        ldrTextureCube = await ldrTextureCube.load(url, loaderFunctions, this._ctx);
        this._texturePool.set(url, ldrTextureCube);
        return ldrTextureCube;
      }
      /**
       * load texture data from array of web url.
       * make sure there are six images in a group,
       * and the order is: [+X, -X, +Y, -Y, +Z, -Z]
       * @param urls 
       */
      async loadTextureCubeMaps(urls) {
        let url = urls[0];
        if (this._texturePool.has(url)) {
          return this._texturePool.get(url);
        }
        let textureCube = new BitmapTextureCube();
        await textureCube.load(urls, this._ctx);
        this._texturePool.set(urls[0], textureCube);
        return textureCube;
      }
      /**
       * load texture data from url.
       * the image is assembled from six images into cross shaped image.
       * @param url the path of image
       */
      async loadTextureCubeStd(url, loaderFunctions) {
        if (this._texturePool.has(url)) {
          return this._texturePool.get(url);
        }
        let cubeMap = new BitmapTextureCube();
        await cubeMap.loadStd(url, this._ctx);
        return cubeMap;
      }
      /**
       * load json data from url.
       * @param url the path of image
       */
      async loadJSON(url, loaderFunctions) {
        return await new FileLoader(this._ctx).loadJson(url, loaderFunctions).then(async (ret) => {
          return ret;
        }).catch((e) => {
          console.error(e);
        });
      }
      /**
       * Load a texture atlas (PNG + JSON) by URL. Returns a {@link TextureAtlas}
       * whose `get(id)` yields `TextureAtlasRegion` instances — feed those
       * directly into `Sprite.texture = region` to render a sub-image.
       */
      async loadAtlas(url, loaderFunctions) {
        let loader = new FileLoader(this._ctx);
        let parser = await loader.load(url, AtlasParser, loaderFunctions, url);
        return parser.data;
      }
      /** Default flat normal-map texture. */
      normalTexture;
      /** Default mask texture. */
      maskTexture;
      /** Default solid white texture. */
      whiteTexture;
      /** Default solid black texture. */
      blackTexture;
      /** Default solid red texture. */
      redTexture;
      /** Default solid blue texture. */
      blueTexture;
      /** Default solid green texture. */
      greenTexture;
      /** Default solid yellow texture. */
      yellowTexture;
      /** Default solid gray texture. */
      grayTexture;
      /** Default sky cube texture. */
      defaultSky;
      /** Default lit material. */
      defaultMaterial;
      /**
       * create a texture
       * @param width width of texture
       * @param height height of texture
       * @param r component-red
       * @param g component-green
       * @param b component-blue
       * @param a component-alpha（0 for transparent，1 for opaque）
       * @param name name string
       * @returns
       */
      createTexture(width, height, r, g, b, a, name) {
        let w = 32;
        let h = 32;
        let textureData = new Uint8Array(w * h * 4);
        this.fillColor(textureData, width, height, r, g, b, a);
        let texture = new Uint8ArrayTexture();
        texture.name = name;
        texture.create(16, 16, textureData, true, this._ctx);
        if (name) {
          this.addTexture(name, texture);
        }
        return texture;
      }
      /**
       * fill slod color to this texture
       * @param array data of texture
       * @param w width of texture
       * @param h height of texture
       * @param r component-red
       * @param g component-green
       * @param b component-blue
       * @param a component-alpha（0 for transparent，1 for opaque）
       */
      fillColor(array, w, h, r, g, b, a) {
        Res.fillColor(array, w, h, r, g, b, a);
      }
      /** Pure data fill — no GPU state, safe to call without a Res instance. */
      static fillColor(array, w, h, r, g, b, a) {
        for (let i = 0; i < w; i++) {
          for (let j = 0; j < h; j++) {
            let pixelIndex = j * w + i;
            array[pixelIndex * 4 + 0] = r;
            array[pixelIndex * 4 + 1] = g;
            array[pixelIndex * 4 + 2] = b;
            array[pixelIndex * 4 + 3] = a;
          }
        }
      }
      /**
       * Initialize a common texture object. Provide a universal solid color texture object.
       * @param ctx Optional Context3D — when provided, default materials bind to it
       *            so the caller doesn't need `engine.use()`.
       */
      initDefault(ctx) {
        this.normalTexture = this.createTexture(32, 32, 255 * 0.5, 255 * 0.5, 255, 255, "default-normalTexture");
        this.maskTexture = this.createTexture(32, 32, 255, 255 * 0.5, 255, 255, "default-maskTexture");
        this.whiteTexture = this.createTexture(32, 32, 255, 255, 255, 255, "default-whiteTexture");
        this.blackTexture = this.createTexture(32, 32, 0, 0, 0, 255, "default-blackTexture");
        this.redTexture = this.createTexture(32, 32, 255, 0, 0, 255, "default-redTexture");
        this.blueTexture = this.createTexture(32, 32, 0, 0, 255, 255, "default-blueTexture");
        this.greenTexture = this.createTexture(32, 32, 0, 255, 0, 255, "default-greenTexture");
        this.yellowTexture = this.createTexture(32, 32, 0, 255, 255, 255, "default-yellowTexture");
        this.grayTexture = this.createTexture(32, 32, 128, 128, 128, 255, "default-grayTexture");
        const boundCtx = ctx ?? this._ctx;
        let brdf = new BRDFLUTGenerate();
        let brdf_texture = brdf.generateBRDFLUTTexture(boundCtx);
        let BRDFLUT = brdf_texture.name = "BRDFLUT";
        this.addTexture(BRDFLUT, brdf_texture);
        this.defaultSky = new HDRTextureCube();
        this.defaultSky.createFromTexture(128, this.blackTexture, boundCtx);
        Reference.getInstance().attached(this.defaultSky, this);
        Reference.getInstance().attached(brdf_texture, this);
        Reference.getInstance().attached(this.normalTexture, this);
        Reference.getInstance().attached(this.maskTexture, this);
        Reference.getInstance().attached(this.whiteTexture, this);
        Reference.getInstance().attached(this.blackTexture, this);
        Reference.getInstance().attached(this.redTexture, this);
        Reference.getInstance().attached(this.blueTexture, this);
        Reference.getInstance().attached(this.greenTexture, this);
        Reference.getInstance().attached(this.yellowTexture, this);
        Reference.getInstance().attached(this.grayTexture, this);
        this.defaultMaterial = new LitMaterial(ctx);
      }
    }

    class PostProcessingComponent extends ComponentBase {
      _postList;
      /** Initialize the internal effect registry. */
      init(param) {
        this._postList = /* @__PURE__ */ new Map();
      }
      /** Lifecycle hook invoked when the component starts. */
      start() {
      }
      /** Lifecycle hook invoked when the component stops. */
      stop() {
      }
      /** Activate all registered post effects when the component is enabled. */
      onEnable() {
        this.activePost();
      }
      /** Deactivate all registered post effects when the component is disabled. */
      onDisable() {
        this.unActivePost();
      }
      activePost() {
        let view = this.transform.view3D;
        let job = view.engine3D.renderJobs.get(view);
        this._postList.forEach((v) => {
          job.addPost(v);
        });
      }
      unActivePost() {
        let view = this.transform.view3D;
        let job = view.engine3D.renderJobs.get(view);
        this._postList.forEach((v) => {
          job.removePost(v);
        });
      }
      /**
       * Add a post-processing effect by its class. Returns the created
       * instance, or undefined if an effect of that type already exists.
       * @param c the post effect class to instantiate
       */
      addPost(c) {
        if (this._postList.has(c)) return;
        let post = new c();
        this._postList.set(c, post);
        if (this._enable)
          this.activePost();
        return post;
      }
      /**
       * Remove a previously added post-processing effect by its class.
       * @param c the post effect class to remove
       */
      removePost(c) {
        if (!this._postList.has(c)) return;
        let post = this._postList.get(c);
        this._postList.delete(c);
        let view = this.transform.view3D;
        let job = view.engine3D.renderJobs.get(view);
        job.removePost(post);
      }
      /**
       * Get a registered post-processing effect by its class.
       * @param c the post effect class to look up
       * @returns the effect instance, or null if not registered
       */
      getPost(c) {
        if (!this._postList.has(c)) return null;
        return this._postList.get(c);
      }
    }

    function _isPlainObject(v) {
      if (v === null || typeof v !== "object" || Array.isArray(v)) return false;
      const proto = Object.getPrototypeOf(v);
      return proto === Object.prototype || proto === null;
    }
    function _deepMerge(target, source) {
      if (!source) return target;
      for (const key of Object.keys(source)) {
        const sv = source[key];
        if (sv === void 0) continue;
        const tv = target[key];
        if (_isPlainObject(sv) && _isPlainObject(tv)) {
          _deepMerge(tv, sv);
        } else {
          target[key] = sv;
        }
      }
      return target;
    }
    class Engine3D {
      /** Factory for the baseline EngineSetting. Returns a fresh deep copy
       *  so per-instance mutations never bleed into sibling engines. Class
       *  instances (Color) are constructed fresh too. */
      static _defaultSetting() {
        return {
          useRTE: false,
          RTEScale: 1,
          doublePrecision: false,
          occlusionQuery: { enable: true, debug: false },
          pick: { enable: true, mode: `bound`, detail: `mesh` },
          render: {
            debug: false,
            renderPassState: 4,
            renderState_left: 5,
            renderState_right: 5,
            renderState_split: 0.5,
            quadScale: 1,
            // 1.0 = physically neutral linear-HDR multiplier on
            // env IBL paths (BxDF_frag indirectionDiffuse +
            // indirectionSpec). The legacy 1.5 was a magic
            // boost from the era when intermediate sample paths
            // were soft-compressed to LDR; in the linear-HDR
            // pipeline (post-bb408b8) IBL stays full HDR all the
            // way to TonemapPost, so 1.0 is the correct default.
            hdrExposure: 1,
            drawOpMin: 0,
            drawOpMax: Number.MAX_SAFE_INTEGER,
            drawTrMin: 0,
            drawTrMax: Number.MAX_SAFE_INTEGER,
            // Z-prepass on by default. PassGenerate.createDepthPass
            // + RenderShaderPass gate at line ~864 make the
            // infrastructure load-bearing — every opaque fragment
            // that would have run a heavy PBR shader then lost the
            // depth test now gets rejected by hardware early-Z.
            // Negligible cost on sparse scenes; 1.5-2× win on
            // dense ones. Set false explicitly only if a scene
            // relies on color writes that ignore depth.
            zPrePass: true,
            useLogDepth: false,
            useCompressGBuffer: false,
            msaa: 0,
            useOIT: false,
            decals: false,
            useStencil: false,
            gpuCull: false,
            tonemap: {
              enable: true,
              // ACES Filmic at exposure 1.0 — the standard
              // HDR-to-display tonemap, matching Filament's
              // neutral default. Acts on the composited linear
              // HDR scene right before the sRGB-view swapchain
              // encode.
              exposure: 1,
              mode: "ACES"
            },
            postProcessing: {
              bloom: {
                downSampleStep: 3,
                downSampleBlurSize: 9,
                downSampleBlurSigma: 1,
                upSampleBlurSize: 9,
                upSampleBlurSigma: 1,
                luminanceThreshole: 1,
                bloomIntensity: 1,
                hdr: 1
              },
              globalFog: {
                debug: false,
                enable: false,
                fogType: 0,
                fogHeightScale: 0.1,
                start: 400,
                end: 10,
                density: 0.02,
                ins: 0.5,
                skyFactor: 0.5,
                skyRoughness: 0.4,
                overrideSkyFactor: 0.8,
                fogColor: new Color(96 / 255, 117 / 255, 133 / 255, 1),
                falloff: 0.7,
                rayLength: 200,
                scatteringExponent: 2.7,
                dirHeightLine: 10
              },
              godRay: {
                blendColor: true,
                rayMarchCount: 16,
                scatteringExponent: 5,
                intensity: 0.5
              },
              ssao: { enable: false, radius: 0.15, bias: -0.1, aoPower: 2, debug: true },
              outline: { enable: false, strength: 1, groupCount: 4, outlinePixel: 2, fadeOutlinePixel: 4, textureScale: 1, useAddMode: false, debug: true },
              taa: { enable: false, jitterSeedCount: 8, blendFactor: 0.1, sharpFactor: 0.6, sharpPreBlurFactor: 0.5, temporalJitterScale: 0.13, debug: true },
              gtao: { enable: false, darkFactor: 1, maxDistance: 5, maxPixel: 50, rayMarchSegment: 6, multiBounce: false, usePosFloat32: true, blendColor: true, debug: true },
              ssr: { enable: false, pixelRatio: 1, fadeEdgeRatio: 0.2, rayMarchRatio: 0.5, fadeDistanceMin: 600, fadeDistanceMax: 2e3, roughnessThreshold: 0.5, powDotRN: 0.2, mixThreshold: 0.1, debug: true },
              fxaa: { enable: false },
              skyline: {
                enable: false,
                lineColor: new Color(1, 0, 0, 1),
                lineWidth: 2,
                depthThreshold: 1e-3,
                strength: 1
              },
              depthOfView: { enable: false, iterationCount: 3, pixelOffset: 1, near: 150, far: 300 },
              volumetricFog: {
                enable: false,
                density: 0.05,
                scatteringIntensity: 1,
                anisotropy: 0.6,
                maxDistance: 100,
                stepCount: 32,
                ambient: { r: 0.02, g: 0.02, b: 0.04 }
              }
            }
          },
          shadow: {
            enable: true,
            type: "HARD",
            shadowSize: 2048,
            pointShadowSize: 1024,
            shadowSoft: 5e-3,
            pcfKernelScale: 1,
            needUpdate: true,
            autoUpdate: true,
            updateFrameRate: 1,
            csmMargin: 0.1,
            csmScatteringExp: 0.7,
            csmAreaScale: 0.4,
            maxCascades: 4,
            maxShadowMapNum: 8,
            maxShadowMapWidth: 2048,
            maxShadowMapHeight: 2048,
            shadowBound: 256,
            debug: false,
            contactShadow: {
              enable: false,
              maxStepCount: 16,
              maxDistance: 0.5,
              thickness: 0.05,
              bias: 0.01,
              intensity: 1
            }
          },
          gi: {
            enable: false,
            offsetX: 0,
            offsetY: 0,
            offsetZ: 0,
            probeSpace: 64,
            probeXCount: 4,
            probeYCount: 2,
            probeZCount: 4,
            probeSize: 32,
            probeSourceTextureSize: 2048,
            octRTMaxSize: 2048,
            octRTSideSize: 16,
            maxDistance: 64 * 1.73,
            normalBias: 0.25,
            depthSharpness: 1,
            hysteresis: 0.98,
            lerpHysteresis: 0.01,
            irradianceChebyshevBias: 0.01,
            rayNumber: 144,
            irradianceDistanceBias: 32,
            indirectIntensity: 1,
            ddgiGamma: 2.2,
            bounceIntensity: 0.025,
            probeRoughness: 1,
            realTimeGI: false,
            debug: false,
            autoRenderProbe: false
          },
          sky: { type: "HDRSKY", sky: null, skyExposure: 1, defaultFar: 65536, defaultNear: 1 },
          light: { maxLight: 4096 },
          material: { materialChannelDebug: false, materialDebug: false },
          loader: { numConcurrent: 20 },
          reflectionSetting: { reflectionProbeMaxCount: 8, reflectionProbeSize: 256, width: 256 * 6, height: 8 * 256, enable: true }
        };
      }
      /**
       * Per-Context3D Res accessor. Pass the owning engine's `context3D`
       * explicitly to target a specific device.
       *
       * When `ctx` is omitted AND exactly one Engine3D has been created,
       * falls back to that engine's context — keeps the single-engine path
       * (`new LitMaterial()`, etc.) ergonomic. For multi-engine apps the
       * caller MUST pass `ctx`; otherwise this throws because picking one
       * arbitrarily would silently bind resources to the wrong device.
       *
       * The `Res` instance is cached before `initDefault()` runs because
       * `initDefault()` creates a `LitMaterial` whose default shader reads
       * `engine.res` recursively — the re-entrant call must see the same
       * (partially-initialized) instance instead of looping the factory.
       */
      static resFor(ctx) {
        const useCtx = ctx ?? Engine3D._defaultContext();
        const r = useCtx.cache(Engine3D, () => new Res(useCtx));
        if (!r._didInitDefault) {
          r._didInitDefault = true;
          r.initDefault(useCtx);
        }
        return r;
      }
      /**
       * Return a Context3D when the caller didn't thread one. Used for
       * single-engine ergonomics (built-in material ctors with no arg).
       * Throws when 0 or 2+ engines exist.
       */
      static _defaultContext() {
        if (Engine3D._instances.size === 1) {
          return Engine3D._instances.values().next().value.context3D;
        }
        if (Engine3D._instances.size === 0) {
          throw new Error(`Engine3D.resFor: no engine created yet — call Engine3D.init() first.`);
        }
        throw new Error(
          `Engine3D.resFor: ${Engine3D._instances.size} engines exist — pass ctx explicitly so resources bind to the intended device.`
        );
      }
      /** @internal Non-throwing variant of `_defaultContext` — the sole
       *  engine's ctx, or null when zero / multiple engines exist. Fed to
       *  Context3D's default-ctx resolver for gfx-layer fallbacks. */
      static _soleContext() {
        return Engine3D._instances.size === 1 ? Engine3D._instances.values().next().value.context3D : null;
      }
      /** All registered engine instances (for the shared render loop). */
      static _instances = /* @__PURE__ */ new Set();
      static _sharedInit = false;
      static _rafId = 0;
      static _time = 0;
      // -------- instance fields --------
      context3D;
      id;
      /**
       * Per-engine configuration tree. Defaults live in `Engine3D._defaultSetting()`;
       * overrides come from `descriptor.setting` at `Engine3D.init()` time and
       * are deep-merged on top. Mutating at runtime (`engine.setting.shadow.enable = false`)
       * takes effect on the next frame for values read each frame; values baked
       * into GPU resources at `create()` time (shadow map dimensions, reflection
       * probe size, etc.) need re-creation.
       */
      setting;
      views = [];
      renderJobs = /* @__PURE__ */ new Map();
      inputSystem;
      running = false;
      /** Per-instance pause flag. When true the shared render loop skips this
       *  engine's frame while other engines keep rendering. Toggled by the
       *  instance `pause()` / `resume()` methods (and, for all instances at
       *  once, the static `pause()` / `resume()`). */
      _paused = false;
      /**
       * Per-engine resource manager. All GPU resources created through
       * `engine.res` (shaders, textures, loaders) bind to this engine's
       * Context3D.
       */
      get res() {
        return Engine3D.resFor(this.context3D);
      }
      _frameRateValue = 0;
      _frameRate = 360;
      _beforeRender = null;
      _renderLoop = null;
      _lateRender = null;
      /** Number of frames this instance has rendered since start. */
      frameCount = 0;
      static _nextId = 0;
      constructor(settingOverride) {
        this.id = ++Engine3D._nextId;
        this.setting = _deepMerge(Engine3D._defaultSetting(), settingOverride);
        this.setting.reflectionSetting.width = this.setting.reflectionSetting.reflectionProbeSize * 6;
        this.setting.reflectionSetting.height = this.setting.reflectionSetting.reflectionProbeSize * this.setting.reflectionSetting.reflectionProbeMaxCount;
        this.context3D = new Context3D();
        this.context3D.engine = this;
      }
      /** Multi-instance factory. Each returned engine owns its own canvas, render
       *  loop, and `setting` tree. Pass any subset of EngineSetting via
       *  `descriptor.setting` — it is deep-merged onto the defaults. */
      static async init(descriptor = {}) {
        let inst = new Engine3D(descriptor.setting);
        await Engine3D._initSharedSubsystems(inst.setting);
        await inst._initInstance(descriptor);
        return inst;
      }
      /** One-time process-wide init (shader text templates, wasm matrix pool).
       *  Runs exactly once, seeded from the first engine's setting — subsequent
       *  engines inherit those process-wide choices (doublePrecision, shader
       *  templates) regardless of their own setting. */
      static async _initSharedSubsystems(seedSetting) {
        if (this._sharedInit) return;
        console.log("Engine Version", version);
        if (!window.isSecureContext) {
          console.warn("WebGPU is only supported in secure contexts (HTTPS or localhost)");
        }
        await WasmMatrix.init(Matrix4.allocCount, seedSetting.doublePrecision);
        ShaderLib.init(seedSetting);
        ShadowLightsCollect.init();
        this._sharedInit = true;
      }
      // -------- instance methods --------
      async _initInstance(descriptor) {
        await this.context3D.init(descriptor.canvasConfig);
        ShaderUtil.init(this.context3D);
        GlobalBindGroup.init(this.context3D);
        void Engine3D.resFor(this.context3D);
        GBufferFrame.getGBufferFrame(
          GBufferFrame.reflections_GBuffer,
          this.context3D,
          this.setting.reflectionSetting.width,
          this.setting.reflectionSetting.height,
          false
        );
        this._beforeRender = descriptor.beforeRender ?? null;
        this._renderLoop = descriptor.renderLoop ?? null;
        this._lateRender = descriptor.lateRender ?? null;
        this.inputSystem = new InputSystem();
        this.inputSystem.initCanvas(this.context3D.canvas);
        Engine3D._instances.add(this);
      }
      get frameRate() {
        return this._frameRate;
      }
      set frameRate(value) {
        this._frameRate = value;
        this._frameRateValue = 1e3 / value;
        if (value >= 360) this._frameRateValue = 0;
      }
      get size() {
        return this.context3D.presentationSize;
      }
      get aspect() {
        return this.context3D.aspect;
      }
      get width() {
        return this.context3D.windowWidth;
      }
      get height() {
        return this.context3D.windowHeight;
      }
      /**
       * Release this engine's GPU device, DOM canvas, ResizeObserver and
       * input listeners. Required for long-running apps that create/drop
       * engines (tests, editor previews, modal viewers) — without it, the
       * browser's per-origin GPU adapter pool is exhausted after a handful
       * of iterations. Safe to call more than once.
       */
      dispose() {
        Engine3D._instances.delete(this);
        for (const view of this.views) {
          ComponentCollect.removeView(view);
          ProfilerUtil.removeView(view);
          EntityCollect.instance.removeView(view);
          if (view.scene) {
            EntityCollect.instance.removeScene(view.scene);
            ShadowLightsCollect.removeScene(view.scene);
            GlobalBindGroup.removeScene(view.scene);
          }
          if (view.camera && Camera3D.mainCamera === view.camera) {
            Camera3D.mainCamera = null;
          }
        }
        GlobalBindGroup.removeContext(this.context3D);
        for (const job of this.renderJobs.values()) job.destroy?.();
        ComponentCollect.removeNullViewEntriesForCtx(this.context3D);
        this.views = [];
        this.renderJobs.clear();
        this.inputSystem?.dispose();
        this.context3D.dispose();
      }
      // -------- render view setup --------
      _startRenderJob(view, JobCtor = ForwardRendererJob) {
        view.engine3D = this;
        if (view.camera) {
          view.camera._boundCtx ||= this.context3D;
          view.camera.updateProjection();
          const csm = view.camera.csm;
          if (csm?.children) {
            for (const child of csm.children) {
              child.shadowCamera._boundCtx ||= this.context3D;
            }
          }
        }
        const renderJob = new JobCtor(view);
        this.renderJobs.set(view, renderJob);
        if (this.setting.pick.mode == `pixel`) {
          let postProcessing = view.scene.getOrAddComponent(PostProcessingComponent);
          postProcessing.addPost(FXAAPost);
        }
        if (this.setting.pick.mode == `pixel` || this.setting.pick.mode == `bound`) {
          view.enablePick = true;
        }
        return renderJob;
      }
      startRenderView(view, JobCtor) {
        this.views = [view];
        let job = this._startRenderJob(view, JobCtor);
        if (!job.renderState) job.start();
        Engine3D._ensureLoop();
        return job;
      }
      startRenderViews(views, JobCtor) {
        this.views = views;
        for (let v of views) {
          const job = this._startRenderJob(v, JobCtor);
          if (!job.renderState) job.start();
        }
        Engine3D._ensureLoop();
      }
      getRenderJob(view) {
        return this.renderJobs.get(view);
      }
      /** Pause every engine instance. The shared render loop keeps ticking
       *  until the current frame finishes, then stops on its own once every
       *  instance is paused (see `_tick`). Resume any instance to restart it. */
      static pause() {
        for (const inst of Engine3D._instances) inst._paused = true;
      }
      /** Resume every engine instance and restart the shared render loop. */
      static resume() {
        for (const inst of Engine3D._instances) inst._paused = false;
        Engine3D._ensureLoop();
      }
      /** Pause only this engine instance. Other instances keep rendering. */
      pause() {
        this._paused = true;
      }
      /** Resume only this engine instance, restarting the shared render loop
       *  if it stopped while every instance was paused. */
      resume() {
        this._paused = false;
        Engine3D._ensureLoop();
      }
      // -------- shared render loop --------
      static _ensureLoop() {
        if (this._rafId === 0) {
          this._rafId = requestAnimationFrame((t) => this._tick(t));
        }
      }
      static async _tick(time) {
        let minGate = 0;
        for (let inst of this._instances) {
          if (inst._paused) continue;
          if (inst._frameRateValue > 0 && (minGate === 0 || inst._frameRateValue < minGate)) {
            minGate = inst._frameRateValue;
          }
        }
        if (minGate > 0) {
          let delta = time - this._time;
          if (delta < minGate) {
            let t = performance.now();
            await new Promise((res) => setTimeout(() => {
              time += performance.now() - t;
              res(true);
            }, minGate - delta));
          }
          this._time = time;
        }
        Time.delta = time - Time.time;
        Time.time = time;
        Time.frame += 1;
        Interpolator.tick(Time.delta);
        let anyActive = false;
        for (let inst of this._instances) {
          if (inst._paused) continue;
          anyActive = true;
          await inst._renderOnce(time);
        }
        this._rafId = 0;
        if (anyActive) this._ensureLoop();
      }
      async _renderOnce(_time) {
        if (this.context3D.lost) return;
        this.frameCount++;
        let views = this.views;
        let ctxSize = this.context3D.presentationSize;
        for (let i = 0; i < views.length; i++) {
          const view = views[i];
          view.scene.waitUpdate();
          view.camera.viewPort.setTo(0, 0, ctxSize[0], ctxSize[1]);
        }
        if (this._beforeRender) await this._beforeRender();
        const viewSet = new Set(views);
        const runViewMap = (src) => {
          if (!src) return;
          for (const [k, v] of src) {
            if (!viewSet.has(k)) continue;
            for (const [comp, cb] of v) {
              if (comp.enable) cb(k);
            }
          }
        };
        runViewMap(ComponentCollect.componentsBeforeUpdateList);
        let command = this.context3D.device.createCommandEncoder();
        if (ComponentCollect.componentsComputeList) {
          for (const [k, v] of ComponentCollect.componentsComputeList) {
            if (!viewSet.has(k)) continue;
            for (const [comp, cb] of v) {
              if (comp.enable) cb(k, command);
            }
          }
        }
        this.context3D.device.queue.submit([command.finish()]);
        runViewMap(ComponentCollect.componentsUpdateList);
        if (ComponentCollect.graphicComponent) {
          for (const [k, v] of ComponentCollect.graphicComponent) {
            if (!viewSet.has(k)) continue;
            for (const [comp, cb] of v) {
              if (k && comp.enable) cb(k);
            }
          }
        }
        if (this._renderLoop) await this._renderLoop();
        WasmMatrix.updateAllContinueTransform(0, Matrix4.useCount, Time.delta, this.setting.useRTE ? this.setting.RTEScale : 0);
        let globalMatrixBindGroup = GlobalBindGroup.getModelMatrixBindGroup(this.context3D);
        globalMatrixBindGroup.writeBuffer(Matrix4.useCount * 16);
        this.renderJobs.forEach((v) => {
          if (!v.renderState) v.start();
          v.renderFrame();
        });
        runViewMap(ComponentCollect.componentsLateUpdateList);
        if (this._lateRender) await this._lateRender();
      }
    }
    _registerDefaultCtxResolver(Engine3D._soleContext);

    let BLUR_CsShader = (
      /* wgsl */
      `
#include "GlobalUniform"

struct UniformData {
  radius: f32 ,
  bias: f32,
  aoPower: f32 ,
  blurSize: f32 ,
};

// @group(0) @binding(0) var<uniform> standUniform: GlobalUniform;
@group(0) @binding(0) var<uniform> uniformData: UniformData;
@group(0) @binding(1) var colorMap : texture_2d<f32>;
// @group(0) @binding(2) var ssaoMapSampler : sampler;
@group(0) @binding(2) var ssaoMap : texture_2d<f32>;
@group(0) @binding(3) var outTex : texture_storage_2d<rgba16float, write>;

@compute @workgroup_size( 8 , 8 )
fn CsMain( @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
  var fragCoord = vec2<i32>( globalInvocation_id.xy );

  var texSize = vec2<f32>(textureDimensions(ssaoMap).xy);
  var texCoord = vec2<f32>(fragCoord) / texSize ;

  let blurSize = i32(uniformData.blurSize);

  var result = vec4<f32>(0.0) ;
  var ii = 0.0 ;
  for (var i = -2; i < 2 ; i+=1) {
     for (var j = -2; j < 2 ; j+=1) {
        var offset = vec2<i32>( i , j ) ;
        result += textureLoad(ssaoMap, fragCoord + offset, 0 );
        // result += textureSampleLevel(ssaoMap,ssaoMapSampler, vec2<f32>( fragCoord + offset) / texSize , 0.0 );
        ii += 1.0 ;
     }
  }
  var fResult = result.r / ii ;
  var color = textureLoad(colorMap, fragCoord , 0 );
  textureStore(outTex, fragCoord , vec4(color.rgb * fResult,1.0) );
}
`
    );

    let BloomCfg = (
      /*wgsl*/
      `
struct BloomCfg{
  downSampleStep: f32,
  downSampleBlurSize: f32,
  downSampleBlurSigma: f32,
  upSampleBlurSize: f32,
  upSampleBlurSigma: f32,
  luminanceThreshole: f32,
  bloomIntensity: f32,
  slot: f32,
}
@group(0) @binding(0) var<uniform> bloomCfg: BloomCfg;
`
    );
    let CalcUV_01$1 = (
      /*wgsl*/
      `
  fn CalcUV_01(coord:vec2<i32>, texSize:vec2<u32>) -> vec2<f32>
  {
    let u = (f32(coord.x) + 0.5) / f32(texSize.x);
    let v = (f32(coord.y) + 0.5) / f32(texSize.y);
    return vec2<f32>(u, v);
  }

`
    );
    let GaussWeight2D$1 = (
      /*wgsl*/
      `
fn GaussWeight2D(x:f32, y:f32, sigma:f32) -> f32
  {
      let PI = 3.14159265358;
      let E  = 2.71828182846;
      let sigma_2 = pow(sigma, 2);
  
      let a = -(x*x + y*y) / (2.0 * sigma_2);
      return pow(E, a) / (2.0 * PI * sigma_2);
  }
`
    );
    let GaussBlur$1 = function(GaussNxN, inTex, inTexSampler) {
      var code = (
        /*wgsl*/
        `

  fn ${GaussNxN}(uv:vec2<f32>, n:i32, stride:vec2<f32>, sigma:f32) -> vec3<f32>
  {
      var color = vec3<f32>(0.0);
      let r:i32 = n / 2;
      var weight:f32 = 0.0;
  
      for(var i:i32=-r; i<=r; i+=1)
      {
          for(var j=-r; j<=r; j+=1)
          {
              let w = GaussWeight2D(f32(i), f32(j), sigma);
              var coord:vec2<f32> = uv + vec2<f32>(f32(i), f32(j)) * stride ;
              color += textureSampleLevel(${inTex}, ${inTexSampler}, coord, 0.0).xyz * w;
              weight += w;
          }
      }
  
      color /= weight;
      return color;
  }`
      );
      return code;
    };
    let threshold = (
      /*wgsl*/
      `
${ColorUtil}
${BloomCfg}

@group(0) @binding(1) var inTex : texture_2d<f32>;
@group(0) @binding(2) var outTex : texture_storage_2d<rgba16float, write>;

var<private> texSize: vec2<u32>;
var<private> fragCoord: vec2<i32>;

@compute @workgroup_size( 8 , 8 , 1 )
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
  fragCoord = vec2<i32>( globalInvocation_id.xy );
  texSize = textureDimensions(inTex).xy;
  if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
      return;
  }
  var color = textureLoad(inTex, fragCoord, 0);
  // Sanitize NaN / +Inf from upstream PBR / SSR before the bloom pyramid
  // can blow up. Without this, a single bad pixel feeds (lum - threshold) /
  // max(lum, eps) which turns +Inf into Inf/Inf = NaN, the gauss blur
  // then propagates the NaN through the downsample / upsample chain,
  // and the postCompute bilinear sample paints a hard-edged ~355x355
  // square of zeros on the final composite (NaN tonemaps to 0).
  //
  // Detection uses clamp + self-equality. clamp(NaN) is impl-defined on
  // some WebGPU backends (returns NaN, returns 0, or returns the bound),
  // so a plain "x not equal x" NaN test was unreliable. Clamp first to
  // kill +/-Inf deterministically, then select-on-self-equality as a
  // second line in case clamp(NaN) leaks through.
  let clamped = clamp(color.rgb, vec3<f32>(-65504.0), vec3<f32>(65504.0));
  let is_finite = clamped == clamped;
  let safe_rgb = select(vec3<f32>(0.0), clamped, is_finite);
  // Soft-knee threshold: weight in [0,1]. Scaling by raw (lum - threshold)
  // unbounded-amplifies HDR specular highlights into the bloom buffer
  // (a 5-nit pixel becomes a 4x bloom seed; the upsample chain then sums
  // ~3 mips of that, blowing past what ACES can recover and causing the
  // big over-exposed halos seen on shiny PBR samples). Normalizing by lum
  // keeps the bloom buffer a soft-masked copy of the scene rather than
  // an amplified one.
  var lum = dot(vec3<f32>(0.2126, 0.7152, 0.0722), safe_rgb);
  var weight = max(0.0, lum - bloomCfg.luminanceThreshole) / max(lum, 1e-4);
  // weight alone only fixes the amplification — it still lets an
  // arbitrarily bright seed (weight approaches 1 as lum grows) pass its
  // raw HDR magnitude straight into the blur/downsample/upsample
  // pyramid. That pyramid spatially smears the value across a whole
  // blur radius *before* it ever reaches a tonemap curve, since the
  // single global ACES pass now runs once at the very end of the whole
  // frame (see TonemapPost) instead of once per post effect like in
  // 0.8 — so a lone blown-out highlight (specular, emissive, an SSR
  // mirror of a light) turns into a wide saturated-white halo instead
  // of a tight glow. Bound the seed's own magnitude here, the same way
  // 0.8's threshold pass did via this same ACESToneMapping helper,
  // before the soft-knee weight is applied.
  var toned = ACESToneMapping(safe_rgb, 1.0);
  var ret = toned * weight;
  textureStore(outTex, fragCoord, vec4<f32>(ret, color.w));
}
`
    );
    let downSample = (
      /*wgsl*/
      `
${BloomCfg}

@group(0) @binding(1) var inTex : texture_2d<f32>;
@group(0) @binding(2) var inTexSampler: sampler;
@group(0) @binding(3) var outTex : texture_storage_2d<rgba16float, write>;

var<private> texSize: vec2<u32>;
var<private> fragCoord: vec2<i32>;

${GaussWeight2D$1}
${GaussBlur$1("GaussNxN", "inTex", "inTexSampler")}
${CalcUV_01$1}

@compute @workgroup_size( 8 , 8 , 1 )
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
  fragCoord = vec2<i32>( globalInvocation_id.xy );
  texSize = textureDimensions(outTex).xy;
  if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
      return;
  }
  var color = vec4<f32>(0.0, 0.0, 0.0, 1.0);
  var uv = CalcUV_01(fragCoord, texSize);
  let stride = vec2<f32>(1.0) / vec2<f32>(f32(texSize.x), f32(texSize.y));   //  texel size of last level
  let rgb = GaussNxN(uv, i32(bloomCfg.downSampleBlurSize), stride, bloomCfg.downSampleBlurSigma);
  color = vec4<f32>(rgb, color.w);
  textureStore(outTex, fragCoord, color);
}
`
    );
    let upSample$1 = (
      /*wgsl*/
      `
${BloomCfg}

@group(0) @binding(1) var _MainTex : texture_2d<f32>;
@group(0) @binding(2) var _MainTexSampler: sampler;
@group(0) @binding(3) var _PrevMip : texture_2d<f32>;
@group(0) @binding(4) var _PrevMipSampler: sampler;
@group(0) @binding(5) var outTex : texture_storage_2d<rgba16float, write>;

var<private> texSize: vec2<u32>;
var<private> fragCoord: vec2<i32>;

${GaussWeight2D$1}
${GaussBlur$1("GaussNxN_0", "_MainTex", "_MainTexSampler")}
${GaussBlur$1("GaussNxN_1", "_PrevMip", "_PrevMipSampler")}
${CalcUV_01$1}

@compute @workgroup_size( 8 , 8 , 1 )
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
  fragCoord = vec2<i32>( globalInvocation_id.xy );
  texSize = textureDimensions(outTex).xy;
  if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
      return;
  }
  var color = vec4<f32>(0.0, 0.0, 0.0, 1.0);
  var uv = CalcUV_01(fragCoord, texSize);
  
  // half stride
  let prev_stride = vec2<f32>(0.5) / vec2<f32>(f32(texSize.x), f32(texSize.y));
  let curr_stride = vec2<f32>(1.0) / vec2<f32>(f32(texSize.x), f32(texSize.y));

  let rgb1 = GaussNxN_0(uv, i32(bloomCfg.upSampleBlurSize), prev_stride, bloomCfg.upSampleBlurSigma);
  let rgb2 = GaussNxN_1(uv, i32(bloomCfg.upSampleBlurSize), curr_stride, bloomCfg.upSampleBlurSigma);
  color = vec4<f32>(rgb1+rgb2, color.w);
  textureStore(outTex, fragCoord, color);
}
`
    );
    let post = (
      /*wgsl*/
      `
${ColorUtil}
${BloomCfg}
${CalcUV_01$1}

@group(0) @binding(1) var _MainTex : texture_2d<f32>;
@group(0) @binding(2) var _BloomTex : texture_2d<f32>;
@group(0) @binding(3) var _BloomTexSampler :  sampler;
@group(0) @binding(4) var outTex : texture_storage_2d<rgba16float, write>;

var<private> texSize: vec2<u32>;
var<private> fragCoord: vec2<i32>;

@compute @workgroup_size( 8 , 8 , 1 )
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
  fragCoord = vec2<i32>( globalInvocation_id.xy );
  texSize = textureDimensions(outTex).xy;
  if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
      return;
  }
  var color = textureLoad(_MainTex, fragCoord, 0);
  let uv = vec2<f32>(f32(fragCoord.x), f32(fragCoord.y)) / vec2<f32>(f32(texSize.x - 1), f32(texSize.y - 1));

  // var bloom = textureLoad(_BloomTex, fragCoord, 0).xyz;
  var bloom = textureSampleLevel(_BloomTex, _BloomTexSampler, uv, 0.0).xyz * bloomCfg.bloomIntensity;

  // ACES + gamma now happen in the final TonemapPost. Just additively
  // composite the linear HDR bloom onto the scene; the post-pass
  // tonemap reads the combined HDR signal and produces the
  // shoulder-compressed output for both scene and bloom in one pass.
  color = vec4<f32>(color.xyz + bloom.xyz, color.w);
  textureStore(outTex, fragCoord, color);
}
`
    );

    let ContactShadow_cs = (
      /*wgsl*/
      `
    #include "GlobalUniform"
    #include "GBufferStand"
    #include "LightData"

    const PI: f32 = 3.1415926;

    struct ContactShadowSettings {
        maxStepCount: f32,
        maxDistance: f32,
        thickness: f32,
        bias: f32,
        intensity: f32,
        _pad0: f32,
        _pad1: f32,
        _pad2: f32,
    };

    @group(0) @binding(2) var<uniform> csSettings: ContactShadowSettings;
    @group(0) @binding(3) var<storage, read> lightBuffer: array<LightData>;
    @group(0) @binding(4) var inTex: texture_2d<f32>;
    @group(0) @binding(5) var outTex: texture_storage_2d<rgba16float, write>;

    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> fragUV: vec2<f32>;
    var<private> gBuffer: GBuffer;

    fn findFirstDirLight() -> i32 {
        // Scan the shadowLights packed indices for the first valid entry.
        // 8 matches the ShadowCommon dirCount const (avoid the include
        // since it pulls shadowMap bindings we don't need here).
        for (var i: i32 = 0; i < 8; i = i + 1) {
            let ldx = globalUniform.shadowLights[u32(i) / 4u][u32(i) % 4u];
            if (ldx >= 0.0) { return i32(ldx); }
        }
        return -1;
    }

    @compute @workgroup_size(8, 8, 1)
    fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
        fragCoord = vec2<i32>(gid.xy);
        texSize = textureDimensions(inTex).xy;
        if (fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)) { return; }
        fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1u);

        let oc = textureLoad(inTex, fragCoord, 0);
        gBuffer = getGBuffer(fragCoord);
        let visible = getRoughnessFromGBuffer(gBuffer);
        if (visible <= 0.0) {
            // sky pixel — no contact shadow
            textureStore(outTex, fragCoord, oc);
            return;
        }

        let lightIdx = findFirstDirLight();
        if (lightIdx < 0) {
            textureStore(outTex, fragCoord, oc);
            return;
        }
        let light = lightBuffer[u32(lightIdx)];

        // Reconstruct world position + view-space ray origin
        useNormalMatrixInv();
        let worldPos = getWorldPositionFromGBuffer(gBuffer, fragUV);
        let normal = getWorldNormalFromGBuffer(gBuffer);

        // Light direction points FROM light → surface, so we ray-march
        // TOWARD the light by negating it.
        let toLight = normalize(-light.direction);
        let NoL = dot(normal, toLight);
        if (NoL <= 0.05) {
            // Back-facing surface: no contact shadow needed (fully shadowed
            // by self-occlusion which the lighting already handles).
            textureStore(outTex, fragCoord, oc);
            return;
        }

        // Slope-scaled bias: at grazing NoL the ray walks far along the
        // plane per step, so the origin offset must grow to clear the
        // thickness band before noise can fake a hit.
        let scaledBias = csSettings.bias / max(NoL, 0.2);
        let originVS = (globalUniform.viewMat * vec4<f32>(worldPos + normal * scaledBias, 1.0)).xyz;

        let toLightVS = normalize((globalUniform.viewMat * vec4<f32>(toLight, 0.0)).xyz);

        let stepCount = i32(clamp(csSettings.maxStepCount, 4.0, 64.0));
        let stepLen = csSettings.maxDistance / f32(stepCount);

        var occluded: f32 = 0.0;
        for (var s: i32 = 1; s <= stepCount; s = s + 1) {
            let samplePosVS = originVS + toLightVS * (stepLen * f32(s));
            let sampleClip = globalUniform.projMat * vec4<f32>(samplePosVS, 1.0);
            if (sampleClip.w <= 0.0) { break; }
            let sampleNDC = sampleClip.xyz / sampleClip.w;
            let sampleUV = sampleNDC.xy * vec2<f32>(0.5, -0.5) + 0.5;
            if (sampleUV.x < 0.0 || sampleUV.x > 1.0 || sampleUV.y < 0.0 || sampleUV.y > 1.0) { break; }

            let sampleCoord = vec2<i32>(sampleUV * vec2<f32>(texSize));
            let sampleGB = getGBuffer(sampleCoord);
            if (getRoughnessFromGBuffer(sampleGB) <= 0.0) { continue; } // sky

            let sceneWorldPos = getWorldPositionFromGBuffer(sampleGB, sampleUV);

            // Self-surface reject. Two-stage filter:
            //   (a) absolute floor: anything within 10cm above the
            //       tangent plane is treated as same-surface. Empirically
            //       the back-projection at far-ground origins (view-Z
            //       >100m) yields scene worldPos.y deviating by ~3-7cm
            //       from the true ground plane, which is enough to slip
            //       past any 1-2cm bias and fire a thickness-band hit.
            //       The original fp32-precision argument predicts mm
            //       noise; the empirical mismatch is an order larger,
            //       hence the conservative floor.
            //   (b) angular: shallower than ~4 deg above the plane is
            //       same-surface; auto-scales with sample distance so
            //       the test still bites at intermediate ranges.
            // Trade-off: contact shadow within 10cm of the receiver is
            // lost. Sub-10cm details (finger-on-table) would need a
            // different reconstruction strategy (read depth32 directly
            // rather than the fp32-encoded-NDC-z GBuffer slot).
            let toSample = sceneWorldPos - worldPos;
            let sampleDist2 = dot(toSample, toSample);
            let sinElev = dot(toSample, normal);
            if (sinElev <= 0.0 || sinElev < 0.1 || sinElev * sinElev < sampleDist2 * 0.005) { continue; }

            // LH view space (clip.w = +viewZ): points in front of camera
            // have z > 0; "ray behind surface" ⇔ ray.z > scene.z.
            let sceneViewZ = (globalUniform.viewMat * vec4<f32>(sceneWorldPos, 1.0)).z;
            let zDiff = samplePosVS.z - sceneViewZ;
            if (zDiff > 0.0 && zDiff < csSettings.thickness) {
                let falloff = 1.0 - f32(s) / f32(stepCount);
                occluded = max(occluded, falloff);
                break;
            }
        }

        let shadowFactor = 1.0 - occluded * csSettings.intensity;
        textureStore(outTex, fragCoord, vec4<f32>(oc.rgb * shadowFactor, oc.a));
    }
`
    );

    let DepthOfView_cs = (
      /*wgsl*/
      `
#include "GlobalUniform"
#include "GBufferStand"

  struct BlurSetting{
    near: f32,
    far: f32,
    pixelOffset: f32,
  }
 
  @group(0) @binding(2) var<uniform> blurSetting: BlurSetting;
  @group(0) @binding(3) var inTexSampler : sampler;
  @group(0) @binding(4) var inTex : texture_2d<f32>;
  @group(0) @binding(5) var outTex : texture_storage_2d<rgba16float, write>;

  var<private> cameraPosition: vec3<f32>;
  var<private> texSize: vec2<u32>;
  var<private> fragCoord: vec2<i32>;
  var<private> fragUV: vec2<f32>;
  var<private> texelSize: vec2<f32>;

  const PI = 3.1415926 ;

  @compute @workgroup_size( 8 , 8 , 1 )
  fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
  {
    
    fragCoord = vec2<i32>( globalInvocation_id.xy );
    texSize = textureDimensions(inTex).xy;
    
    if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
      return;
    }
    fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize);
    texelSize = 1.0 / vec2<f32>(texSize - 1);
    var gBuffer = getGBuffer( fragCoord ) ;
    useNormalMatrixInv();

    cameraPosition = globalUniform.CameraPos.xyz ;
    var wPosition = getWorldPositionFromGBuffer(gBuffer,fragUV); 
    var distance = length(wPosition - cameraPosition);
    var oc:vec4<f32> = textureLoad(inTex, fragCoord, 0);
    if(distance > blurSetting.near){
        var normal = getWorldNormalFromGBuffer(gBuffer); 
        var pixelScale = 0.5;
        if(gBuffer.x > 9999.0){
            distance = min(distance, blurSetting.far);
            pixelScale = (distance - blurSetting.near) / (blurSetting.far - blurSetting.near);
        }
        oc = mixBlurColor(oc, fragCoord, blurSetting.pixelOffset, pixelScale);
    }
    textureStore(outTex, fragCoord, oc);
  }

  fn mixBlurColor(orginColor:vec4<f32>, coord:vec2<i32>, pixelOffset:f32, scale:f32) -> vec4<f32> {

    let uv = vec2<f32>(coord);
    var uv0 = (uv + scale * vec2<f32>( pixelOffset,  pixelOffset)) * texelSize;
    var uv1 = (uv + scale * vec2<f32>(-pixelOffset,  pixelOffset)) * texelSize;
    var uv2 = (uv + scale * vec2<f32>(-pixelOffset, -pixelOffset)) * texelSize;
    var uv3 = (uv + scale * vec2<f32>( pixelOffset, -pixelOffset)) * texelSize;

    uv0.x = processUVEdge(uv0.x);
    uv0.y = processUVEdge(uv0.y);
    uv1.x = processUVEdge(uv1.x);
    uv1.y = processUVEdge(uv1.y);
    uv2.x = processUVEdge(uv2.x);
    uv2.y = processUVEdge(uv2.y);
    uv3.x = processUVEdge(uv3.x);
    uv3.y = processUVEdge(uv3.y);

    var ob = vec4<f32>(0.0);
    ob += textureSampleLevel(inTex, inTexSampler, uv0, 0.0);
    ob += textureSampleLevel(inTex, inTexSampler, uv1, 0.0);
    ob += textureSampleLevel(inTex, inTexSampler, uv2, 0.0);
    ob += textureSampleLevel(inTex, inTexSampler, uv3, 0.0);
    return mix(orginColor, ob * 0.25, scale);
  }

  fn processUVEdge(v: f32) -> f32{
      var value = v;
      if(value < 0.0){
        value = - value;
      }else if(value > 1.0){
        value = 2.0 - value;
      }
      return value;
  }
`
    );

    let GTAO_cs = (
      /*wgsl*/
      `
    #include "GlobalUniform"
    #include "GBufferStand"
    
    struct GTAO{
      maxDistance: f32,
      maxPixel: f32,
      darkFactor: f32,
      rayMarchSegment: f32,
      cameraNear: f32,
      cameraFar: f32,
      multiBounce: f32,
      blendColor: f32,
    }

    @group(0) @binding(2) var<uniform> gtaoData: GTAO;
    @group(0) @binding(3) var<storage, read_write> directions : array<vec2<f32>>;
    @group(0) @binding(4) var<storage, read_write> aoBuffer : array<f32>;
 
    @group(0) @binding(5) var inTex : texture_2d<f32>;
    @group(0) @binding(6) var outTex : texture_storage_2d<rgba16float, write>;
    
    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> fragUV: vec2<f32>;
    var<private> wPosition: vec3<f32>;
    var<private> wNormal: vec4<f32>;
    var<private> maxPixelScaled: f32;

    var<private> gBuffer: GBuffer;

    const PI = 3.1415926 ;
    
    @compute @workgroup_size( 8 , 8 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
      
      fragCoord = vec2<i32>( globalInvocation_id.xy );
      texSize = textureDimensions(inTex).xy;
      if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
        return;
      }
      
      fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1);
      useNormalMatrixInv();

      gBuffer = getGBuffer( fragCoord ) ;
      wNormal = vec4f(getWorldNormalFromGBuffer(gBuffer),1.0); 
      var visible = getRoughnessFromGBuffer(gBuffer);

      var oc = textureLoad(inTex, fragCoord, 0);
      let index = fragCoord.x + fragCoord.y * i32(texSize.x);
      let lastFactor = aoBuffer[index];
      var newFactor = 0.0;
      if(visible > 0.0){//sky
          wPosition = getWorldPositionFromGBuffer(gBuffer,fragUV);
          let ndc = globalUniform.projMat * globalUniform.viewMat * vec4<f32>(wPosition, 1.0);
          let ndcZ = ndc.z / ndc.w;
          maxPixelScaled = calcPixelByNDC(ndcZ);
          newFactor = rayMarch();
      }
      
      var factor:f32 = mix(lastFactor, newFactor, 0.6);
      aoBuffer[index] = factor;
      factor = blurFactor(factor);
      factor = saturate(1.0 - factor * gtaoData.darkFactor);
      var gtao = vec3<f32>(factor);
      if(gtaoData.multiBounce > 0.5){
          gtao = MultiBounce(factor, oc.xyz);
      }
      
      var outColor = gtao;
      if(gtaoData.blendColor > 0.5){
          outColor = oc.xyz * gtao;
      }
      // textureStore(outTex, fragCoord , vec4<f32>(vec3f(newFactor), oc.w));
      textureStore(outTex, fragCoord , vec4<f32>(outColor, oc.w));
    }
    
    fn MultiBounce(AO:f32, Albedo:vec3<f32>) -> vec3<f32>
    {
        var A = 2 * Albedo - 0.33;
        var B = -4.8 * Albedo + 0.64;
        var C = 2.75 * Albedo + 0.69;
        return max(vec3<f32>(AO), ((AO * A + B) * AO + C) * AO);
    }
    
    fn calcPixelByNDC(ndcZ:f32) -> f32{
      let nearAspect = gtaoData.cameraNear / (gtaoData.cameraFar - gtaoData.cameraNear);
      let aspect = (1.0 + nearAspect) / (ndcZ + nearAspect);
      var viewPortMax = min(f32(texSize.x), f32(texSize.y));
      var maxPixel = min(viewPortMax, gtaoData.maxPixel * aspect);
      maxPixel = max(0.1, maxPixel);
      return maxPixel;
    }
    
    fn blurFactor(centerFactor:f32) -> f32{
      var coord0 = clamp(fragCoord + vec2<i32>(1, 0) , vec2<i32>(0), vec2<i32>(texSize - 1));
      var coord1 = clamp(fragCoord + vec2<i32>(-1, 0), vec2<i32>(0), vec2<i32>(texSize - 1));
      var coord2 = clamp(fragCoord + vec2<i32>(0, 1) , vec2<i32>(0), vec2<i32>(texSize - 1));
      var coord3 = clamp(fragCoord + vec2<i32>(0, -1), vec2<i32>(0), vec2<i32>(texSize - 1));
      var index0 = coord0.x + coord0.y * i32(texSize.x);
      var index1 = coord1.x + coord1.y * i32(texSize.x);
      var index2 = coord2.x + coord2.y * i32(texSize.x);
      var index3 = coord3.x + coord3.y * i32(texSize.x);
      let factor0:f32 = aoBuffer[index0];
      let factor1:f32 = aoBuffer[index1];
      let factor2:f32 = aoBuffer[index2];
      let factor3:f32 = aoBuffer[index3];
      var factor = 0.25 * (factor0 + factor1 + factor2 + factor3);
      factor = mix(factor, centerFactor, 0.8);
      return factor;
    }
    
    fn rayMarch() -> f32{
      let originNormal = normalize(vec3<f32>(wNormal.xyz));
      let stepPixel = maxPixelScaled / gtaoData.rayMarchSegment;
      var weight:f32 = 0.0;
      var totalWeight:f32 = 0.00001;
      for(var i:i32 = 0; i < 8; i += 1){
          let dirVec2 = directions[i];
          for(var j:f32 = 1.1; j < maxPixelScaled; j += stepPixel){
              var sampleCoord = vec2<i32>(dirVec2 * j) + fragCoord;
              if(sampleCoord.x >= 0 && sampleCoord.y >= 0 
                && sampleCoord.x < i32(texSize.x) 
                && sampleCoord.y < i32(texSize.y) )
              {
                totalWeight += 1.0;

                let subGBuffer = getGBuffer( sampleCoord ) ;
                let samplePosition = getWorldPositionFromGBuffer(subGBuffer,vec2f(sampleCoord)/vec2f(texSize));
                var visible = getRoughnessFromGBuffer(subGBuffer);
                if(visible>0.0){
                  let distanceVec2 = samplePosition.xyz - wPosition;
                  let distance = length(distanceVec2);
                  if(distance < gtaoData.maxDistance ){
                    let sampleDir = normalize(distanceVec2);
                    var factor = saturate( dot(sampleDir, originNormal));
                    factor *= 1.0 - distance / gtaoData.maxDistance;
                    weight += factor;
                  }
                }
              }
          }
      }
      weight /= totalWeight;
      return weight;
    }
  `
    );

    let GodRay_cs = (
      /*wgsl*/
      `

    #include "GlobalUniform"
    #include "GBufferStand"

    #include "LightData"

    struct Uniforms {
      matrix : array<mat4x4<f32>>
    };

    struct CacheGodRay {
      pos:vec3<f32>,
      value:f32,
    };

    struct GodRayUniform{
      intensity: f32,
      rayMarchCount: f32,
      viewPortWidth: f32,
      viewPortHeight: f32,

      blendColor: f32,
      scatteringExponent: f32,
    }

    @group(0) @binding(2) var<uniform> godRayUniform: GodRayUniform;
    @group(0) @binding(3) var inTex : texture_2d<f32>;
    @group(0) @binding(4) var outTex : texture_storage_2d<rgba16float, write>;
    @group(0) @binding(5) var shadowMapSampler : sampler_comparison;
    @group(0) @binding(6) var shadowMap : texture_depth_2d_array;

    @group(1) @binding(0)
    var<storage,read> lightBuffer: array<LightData>;
    @group(1) @binding(1)
    var<storage, read> models : Uniforms;

    @group(2) @binding(0) var<storage, read_write> historyGodRayData: array<CacheGodRay>;
    
    struct ShadowStruct{
      directShadowVisibility:f32,
      pointShadows:array<f32,8>,
     }

    var<private> viewDirection: vec3<f32> ;
    var<private> texSize: vec2<u32>;
    var<private> fragUV: vec2<f32>;
    var<private> fragCoord: vec2<i32>;
    var<private> wPosition: vec3<f32>;
    var<private> wNormal: vec4<f32>;
    var<private> directLight: LightData;
    var<private> shadowStrut: ShadowStruct ;

    var<private> gBuffer: GBuffer;

    const PI = 3.1415926 ;

    const csmCount:i32 = ${CSM.Cascades} ;
    fn directShadowMaping(P:vec3<f32>, N:vec3<f32>, shadowBias: f32)  {
      let enableCSM:bool = globalUniform.enableCSM > 0.5;
      var light = lightBuffer[0];
      var visibility = 1.0;
      var shadowIndex = i32(light.castShadow);
      if (shadowIndex >= 0 ) {
        var shadowMatrix:mat4x4<f32>;
        if(enableCSM && csmCount > 1){
          for(var csm:i32 = 0; csm < csmCount; csm ++){
            var csmShadowBias = globalUniform.csmShadowBias[csm];
            shadowMatrix = globalUniform.csmMatrix[csm];
            let csmShadowResult = directShadowMapingIndex(light, shadowMatrix, P, N, csm, csmShadowBias);
            if(csmShadowResult.y < 0.5){
              visibility = csmShadowResult.x;
              break;
            }
          }
        }else{
          shadowMatrix = globalUniform.shadowMatrix[shadowIndex];
          visibility = directShadowMapingIndex(light, shadowMatrix, P, N, shadowIndex, shadowBias).x;
        }
      }
      shadowStrut.directShadowVisibility = visibility;
    }
    
    fn directShadowMapingIndex(light:LightData, matrix:mat4x4<f32>, P:vec3<f32>, N:vec3<f32>, depthTexIndex:i32, shadowBias:f32) -> vec2<f32>
    {
      var visibility = 1.0;
      var isOutSideArea:f32 = 1.0;
      var shadowPosTmp = matrix * vec4<f32>(P.xyz, 1.0);
      var shadowPos = shadowPosTmp.xyz / shadowPosTmp.w;
      var varying_shadowUV = shadowPos.xy * vec2<f32>(0.5, -0.5) + vec2<f32>(0.5, 0.5);
      if (varying_shadowUV.x <= 1.0
        && varying_shadowUV.x >= 0.0
        && varying_shadowUV.y <= 1.0
        && varying_shadowUV.y >= 0.0
        && shadowPosTmp.z <= 1.0
        && shadowPosTmp.z >= 0.0)
      {
        isOutSideArea = 0.0;
        var uvOnePixel = 1.0 / vec2<f32>(globalUniform.shadowMapSize);
        var NoL = abs(dot(N, normalize(light.direction)));
        var bias = shadowBias / max(NoL, 0.000001);
        visibility = textureSampleCompareLevel(shadowMap, shadowMapSampler, varying_shadowUV, depthTexIndex, shadowPos.z - bias);
        visibility += 0.001;
      }
      return vec2<f32>(visibility, isOutSideArea);
    }

    @compute @workgroup_size( 8 , 8 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
      fragCoord = vec2<i32>( globalInvocation_id.xy );

      texSize = textureDimensions(inTex).xy;
      if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
          return;
      }
      fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1);
      useNormalMatrixInv();

      gBuffer = getGBuffer( fragCoord ) ;
      wNormal = vec4f(getWorldNormalFromGBuffer(gBuffer),1.0); 
      var visible = getRoughnessFromGBuffer(gBuffer);

      var oc = textureLoad(inTex, fragCoord, 0);
      var outColor = oc.xyz;
      directLight = lightBuffer[0] ;
      if(directLight.castShadow >= 0){
        let index = fragCoord.x + fragCoord.y * i32(texSize.x);
        var historyData = historyGodRayData[index];
        let lightColor = directLight.lightColor;
        
        var godRayFactor = 0.0;
        if(visible > 0.0 ){
          //not sky
          let lightPos = models.matrix[u32(directLight.lightMatrixIndex)][3].xyz;
          wPosition = getWorldPositionFromGBuffer(gBuffer,fragUV);
          viewDirection = normalize(globalUniform.CameraPos - wPosition) ;
          godRayFactor = rayMarch();
          godRayFactor = updateGodRay(historyData, godRayFactor);
        }
        historyData.pos = wPosition;
        historyData.value = godRayFactor;
        historyGodRayData[index] = historyData;

        outColor = oc.xyz + vec3<f32>(godRayFactor * godRayUniform.intensity * lightColor);
      }
      textureStore(outTex, fragCoord , vec4<f32>(outColor, oc.w));
    }

    fn updateGodRay(historyData:CacheGodRay, newFactor:f32) -> f32 {
      var changeFactor = 0.2;
      if(length(historyData.pos - wPosition) > 0.01){
        changeFactor = 0.4;
      }
      var factor = mix(historyData.value, newFactor, changeFactor);
      
      let pixelOffset = 1 + i32(globalUniform.frame) % 3;
      let coordRange = vec2<i32>(texSize);
      let coordIndex0 = getCoordIndex(fragCoord.x + pixelOffset, fragCoord.y - pixelOffset, coordRange);
      let coordIndex1 = getCoordIndex(fragCoord.x - pixelOffset, fragCoord.y - pixelOffset, coordRange);
      let coordIndex2 = getCoordIndex(fragCoord.x, fragCoord.y + pixelOffset * 2, coordRange);

      let oldOC0 = historyGodRayData[coordIndex0].value;
      let oldOC1 = historyGodRayData[coordIndex1].value;
      let oldOC2 = historyGodRayData[coordIndex2].value;

      let opRound = (oldOC0 + oldOC1 + oldOC2) * 0.3333333;
      factor = mix(opRound, factor, 0.5);

      return factor;
    }

    fn getCoordIndex(x0:i32, y0:i32, size:vec2<i32>) -> i32{
      let x = clamp(x0, 0, size.x - 1);
      let y = clamp(y0, 0, size.y - 1);
      return y * size.x + x;
    }
    
    
    fn rayMarch() -> f32{
      var godRayFactor = 0.0;
      let L = normalize(directLight.direction);
      let rayMarchCount = godRayUniform.rayMarchCount;
      if(godRayUniform.blendColor > 0.5){
        let eyePosition = globalUniform.CameraPos;
        var samplePosition = eyePosition;
        var lastSamplePosition = eyePosition;
        
        var frameOffset = f32(i32(globalUniform.frame) % 4);
        frameOffset *= 0.25;
        var N = normalize(wNormal.xyz);
        for(var i:f32 = 1.0; i < rayMarchCount; i += 1.0){
          var t = (i + frameOffset) / rayMarchCount;
          lastSamplePosition = samplePosition;
          samplePosition = mix(eyePosition, wPosition, t * t);

          // var shadowVisibility = directionShadowMapping(samplePosition, globalUniform.shadowBias);
          directShadowMaping(samplePosition.xyz, N, globalUniform.shadowBias);
          var shadowVisibility = shadowStrut.directShadowVisibility;
          if(shadowVisibility > 0.5){
            var stepFactor = calcGodRayValue(samplePosition, L, viewDirection);
            stepFactor *= length(lastSamplePosition - samplePosition);
            godRayFactor += stepFactor;
          }
        }
        godRayFactor /= length(wPosition - eyePosition);
      }
      return godRayFactor;
    }

    fn calcGodRayValue(pos:vec3<f32>, L:vec3<f32>, V:vec3<f32>) -> f32{
      var halfLoV = normalize(L + V);
      var LoV = saturate(dot(V,halfLoV));
      LoV = pow(LoV, godRayUniform.scatteringExponent);
      var distance = length(pos - globalUniform.CameraPos) / (globalUniform.far);
      distance = 1.0 - saturate(distance);
      distance *= distance;
      return LoV * distance;
    }
  `
    );

    let MergeRGBA_cs = (
      /*wgsl*/
      `
    @group(0) @binding(0) var textureR : texture_2d<f32>;
    @group(0) @binding(1) var textureG : texture_2d<f32>;
    @group(0) @binding(2) var textureB : texture_2d<f32>;
    @group(0) @binding(3) var textureA : texture_2d<f32>;
    @group(0) @binding(4) var outTex : texture_storage_2d<rgba8unorm, write>;

    @compute @workgroup_size(8, 8, 1)
    fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
        let size = textureDimensions(outTex);
        let fragCoord : vec2<i32> = vec2<i32>(GlobalInvocationID.xy); 
        var uv:vec2<f32>;
        uv.x = f32(fragCoord.x)/f32(size.x);
        uv.y = f32(fragCoord.y)/f32(size.y);
        var oc:vec4<f32> = textureSampleLevel(atlasTexture, atlasTextureSampler, targetUV, 0.0);

        let sizeR = textureDimensions(textureR);
        let sizeG = textureDimensions(textureG);
        let sizeB = textureDimensions(textureB);
        let sizeA = textureDimensions(textureA);
        
        var tr = textureLoad(textureR, vec2<i32>(uv * sizeR) , 0 ) ;
        var tg = textureLoad(textureG, vec2<i32>(uv * sizeG) , 0 ) ;
        var tb = textureLoad(textureB, vec2<i32>(uv * sizeB) , 0 ) ;
        var ta = textureLoad(textureA, vec2<i32>(uv * sizeA) , 0 ) ;

        let color = vec4<f32>(tr,tg,tb,ta);
        textureStore(outTex, fragCoord , vec4(color));
    }

`
    );

    let OutLineBlendColor_cs = (
      /*wgsl*/
      `
   struct OutlineSettingData{
      strength: f32,
      useAddMode: f32,
      outlinePixel: f32,
      fadeOutlinePixel: f32,
      lowTexWidth: f32,
      lowTexHeight: f32,
      slot0: f32,
      slot1: f32,
   }

   @group(0) @binding(0) var<uniform> outlineSetting: OutlineSettingData;
   @group(0) @binding(1) var inTex : texture_2d<f32>;
   @group(0) @binding(2) var lowTexSampler : sampler;
   @group(0) @binding(3) var lowTex : texture_2d<f32>;
   @group(0) @binding(4) var outlineTex : texture_storage_2d<rgba16float, write>;
   
   var<private> texSize: vec2<u32>;
   var<private> fragCoord: vec2<i32>;


   fn CalcUV_01(coord:vec2<i32>, texSize:vec2<u32>) -> vec2<f32>
   {
      let u = (f32(coord.x) + 0.5) / f32(texSize.x);
      let v = (f32(coord.y) + 0.5) / f32(texSize.y);
      return vec2<f32>(u, v);
   }

   @compute @workgroup_size( 8 , 8 , 1 )
   fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
   {
      fragCoord = vec2<i32>( globalInvocation_id.xy );
      texSize = textureDimensions(outlineTex).xy;
      if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
         return;
      }

      let uv01 = CalcUV_01(fragCoord, texSize);
      var outLineColor = textureSampleLevel(lowTex, lowTexSampler, uv01, 0.0);

      outLineColor.x *= outlineSetting.strength;
      outLineColor.y *= outlineSetting.strength;
      outLineColor.z *= outlineSetting.strength;

      var inColor = textureLoad(inTex, fragCoord, 0);
      var blendColor:vec3<f32> = vec3<f32>(0.0);
      if(outlineSetting.useAddMode > 0.5){
         blendColor = inColor.xyz + outLineColor.xyz * outLineColor.w;
      }else{
         blendColor = mix(inColor.xyz, outLineColor.xyz, outLineColor.w);
      }
      textureStore(outlineTex, fragCoord, vec4<f32>(blendColor, inColor.w));
   }

`
    );

    let OutlineCalcOutline_cs = (
      /*wgsl*/
      `
#include "GlobalUniform"
#include "GBufferStand"

  struct OutlineSettingData{
    strength: f32,
    useAddMode: f32,
    outlinePixel: f32,
    fadeOutlinePixel: f32,
    lowTexWidth: f32,
    lowTexHeight: f32,
    slot0: f32,
    slot1: f32,
  }

  struct OutlineSlotData{
    color: vec3<f32>,
    count: f32,
  }

  struct OutlineWeightData{
    slotIndex:f32,
    outerSlotIndex:f32,
    entityIndex:f32,
    weight:f32
  }

  struct OutlineEntities{
    list: array<f32, 16u>,
  }

  @group(0) @binding(2) var<uniform> outlineSetting: OutlineSettingData;
  @group(0) @binding(3) var<storage, read_write> slotsBuffer : array<OutlineSlotData>;
  @group(0) @binding(4) var<storage, read_write> weightBuffer : array<OutlineWeightData>;
  @group(0) @binding(5) var<storage, read_write> entitiesBuffer : array<OutlineEntities>;

  var<private> texSize: vec2<u32>;
  var<private> lowSize: vec2<i32>;
  var<private> fragCoord: vec2<i32>;
  var<private> fragUV: vec2<f32>;
  var<private> fragCoordLow: vec2<i32>;
  var<private> coordIndex: i32;

  var<private> fragOutline: OutlineWeightData;
  const PI = 3.1415926 ;

  @compute @workgroup_size( 8 , 8 , 1 )
  fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
  {
    useNormalMatrixInv();
    fragCoordLow = vec2<i32>( globalInvocation_id.xy );
    texSize = textureDimensions(gBufferTexture).xy;
    fragUV = vec2<f32>(fragCoordLow) / vec2<f32>(texSize);

    lowSize = vec2<i32>(i32(outlineSetting.lowTexWidth), i32(outlineSetting.lowTexHeight));
    let scaleValue = f32(texSize.x) / f32(lowSize.x);
    fragCoord.x = i32(f32(fragCoordLow.x) * scaleValue);
    fragCoord.y = i32(f32(fragCoordLow.y) * scaleValue);

    if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
        return;
    }
    if(fragCoordLow.x >= lowSize.x || fragCoordLow.y >= lowSize.y){
        return;
    }
    
    coordIndex = fragCoordLow.x + fragCoordLow.y * lowSize.x;
    fragOutline = weightBuffer[coordIndex];

    var gBuffer = getGBuffer( fragCoord ) ;
    fragOutline.entityIndex = f32(getIDFromGBuffer_i32(gBuffer));
    fragOutline.slotIndex = -1.0;
    fragOutline.outerSlotIndex = -1.0;
    fragOutline.weight = 0.0;
    
    if(fragOutline.entityIndex >= 0.0){
      fragOutline.slotIndex = f32(matchOutlineSlot());
    }
    weightBuffer[coordIndex] = fragOutline;
  }

  fn matchOutlineSlot() -> i32
  {
    for(var i:i32 = 0; i < 8; i ++){
        var slotData:OutlineSlotData = slotsBuffer[i];
        var entities:array<f32, 16u> = entitiesBuffer[i].list;
        let count:i32 = i32(slotData.count);
        for(var j:i32 = 0; j < count; j ++){
            var outlineIndex = entities[j];
            if(abs(fragOutline.entityIndex - outlineIndex) < 0.1){ 
                return i;
            }
        }
    }
    return -1;
  }
`
    );

    let Outline_cs = (
      /*wgsl*/
      `
    struct OutlineSettingData{
        strength: f32,
        useAddMode: f32,
        outlinePixel: f32,
        fadeOutlinePixel: f32,
        lowTexWidth: f32,
        lowTexHeight: f32,
        slot0: f32,
        slot1: f32,
    }
    
    struct OutlineSlotData{
        color: vec3<f32>,
        count: f32,
    }
    
    struct OutlineWeightData{
        slotIndex:f32,
        outerSlotIndex:f32,
        entityIndex:f32,
        weight:f32
    }

    @group(0) @binding(0) var<uniform> outlineSetting: OutlineSettingData;
    @group(0) @binding(1) var<storage, read_write> slotsBuffer : array<OutlineSlotData>;
    @group(0) @binding(2) var<storage, read_write> weightBuffer : array<OutlineWeightData>;
    @group(0) @binding(3) var<storage, read_write> oldOutlineColor : array<vec4<f32>>;
    @group(0) @binding(4) var lowTex : texture_storage_2d<rgba16float, write>;
    
    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> coordIndex: i32;
    var<private> fragOutline: OutlineWeightData;
    
    @compute @workgroup_size( 8 , 8 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        fragCoord = vec2<i32>( globalInvocation_id.xy );
        texSize = textureDimensions(lowTex).xy;
        if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
            return;
        }
        
        coordIndex = fragCoord.x + fragCoord.y * i32(texSize.x);
        fragOutline = weightBuffer[coordIndex];
        
        var newOC = vec4<f32>(0.0);
        
        calcOutline();
        let outerSlotIndex:i32 = i32(round(fragOutline.outerSlotIndex));
        if(outerSlotIndex >= 0){
            let outLineColor = slotsBuffer[outerSlotIndex].color;
            newOC = vec4<f32>(outLineColor, fragOutline.weight);
        }
        
        let coordIndex0 = fragCoord.x + 1 + (fragCoord.y + 1) * i32(texSize.x);
        let coordIndex1 = fragCoord.x - 1 + (fragCoord.y + 1) * i32(texSize.x);
        let coordIndex2 = fragCoord.x + (fragCoord.y - 1) * i32(texSize.x);

        let oldOC = oldOutlineColor[coordIndex];
        let oldOC0 = oldOutlineColor[coordIndex0];
        let oldOC1 = oldOutlineColor[coordIndex1];
        let oldOC2 = oldOutlineColor[coordIndex2];
        
        newOC = mix((oldOC + oldOC0 + oldOC1 + oldOC2) * 0.25, newOC, 0.5);
        oldOutlineColor[coordIndex] = newOC;
        textureStore(lowTex, fragCoord, newOC);
    }
    
    fn calcOutline()
    {
        let outlinePixel = outlineSetting.outlinePixel;
        let pixelRadius = outlinePixel + outlineSetting.fadeOutlinePixel;
        let minX = max(0.0, f32(fragCoord.x) - pixelRadius);
        let maxX = min(f32(texSize.x), f32(fragCoord.x) + pixelRadius);
        let minY = max(0.0, f32(fragCoord.y) - pixelRadius);
        let maxY = min(f32(texSize.y), f32(fragCoord.y) + pixelRadius);
        var coordTemp_f32 = vec2<f32>(0.0);
        var coordCurrent_f32 = vec2<f32>(fragCoord);
        var tempCoordIndex = 0;
        var tempWeightData: OutlineWeightData;
        for(var x:f32 = minX; x < maxX; x += 1.0){
            for(var y:f32 = minY; y < maxY; y += 1.0){
                coordTemp_f32.x = x;
                coordTemp_f32.y = y;
                let distanceToOuter = length(coordTemp_f32 - coordCurrent_f32);
                if(distanceToOuter < pixelRadius){
                    var coord_i32 = vec2<i32>(coordTemp_f32);
                    tempCoordIndex = coord_i32.x + coord_i32.y * i32(texSize.x);
                    tempWeightData = weightBuffer[tempCoordIndex];
                    let outlineGap = abs(tempWeightData.slotIndex - fragOutline.slotIndex);
                    if(outlineGap > 0.1){
                        if(tempWeightData.slotIndex > fragOutline.slotIndex){
                            if(abs(tempWeightData.slotIndex - fragOutline.outerSlotIndex) < 0.1){
                                fragOutline.weight = max(fragOutline.weight, calcWeight(pixelRadius, distanceToOuter, outlinePixel));
                                fragOutline.outerSlotIndex = tempWeightData.slotIndex;
                                weightBuffer[tempCoordIndex] = tempWeightData;
                            }else if(tempWeightData.slotIndex > fragOutline.outerSlotIndex){
                                fragOutline.weight = calcWeight(pixelRadius, distanceToOuter, outlinePixel);
                                fragOutline.outerSlotIndex = tempWeightData.slotIndex;
                                weightBuffer[tempCoordIndex] = tempWeightData;
                            }
                        }
                    }
                }
            }
        }
    }
    
    fn calcWeight(totalRadius:f32, distance:f32, innerRadius:f32) -> f32{
        if(distance < innerRadius){
            return 1.0;
        }
        var ret = 1.0 - (distance - innerRadius)  / (totalRadius - innerRadius);

        return ret;
    }
`
    );

    let Picker_cs = (
      /*wgsl*/
      `

    #include "GlobalUniform"
    #include "GBufferStand"

    struct PickResult{
        pick_meshID:f32,
        pick_meshID2:f32,
        pick_UV:vec2<f32>,

        pick_Position:vec4<f32>,
        pick_Normal:vec4<f32>,
        pick_Tangent:vec4<f32>,

        v4:vec4<f32>,
        v5:vec4<f32>,
        v6:vec4<f32>,
        v7:vec4<f32>
    }

    @group(0) @binding(2) var<storage,read_write> outBuffer: PickResult;
    const PI = 3.1415926 ;

    @compute @workgroup_size( 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
    var result:PickResult ;
    let texSize = textureDimensions(gBufferTexture).xy;
    let screenPoint = vec2<f32>(globalUniform.mouseX/globalUniform.windowWidth,globalUniform.mouseY/globalUniform.windowHeight);

    let mouseUV = screenPoint * vec2<f32>(texSize.xy);
    let fragCoord =  vec2<i32>(i32(mouseUV.x), i32(mouseUV.y));
    var gBuffer = getGBuffer( fragCoord ) ;
    let pick_meshID = getIDFromGBuffer_i32(gBuffer);
    outBuffer.pick_meshID = f32(pick_meshID) ;
    outBuffer.pick_meshID2 = f32(pick_meshID) ;
    outBuffer.pick_Tangent = vec4<f32>(2.0,2.0,2.0,2.0) ;
    outBuffer.pick_UV = vec2<f32>(globalUniform.mouseX,globalUniform.mouseY) ;
    let wPosition = getWorldPositionFromGBuffer(gBuffer,screenPoint);
    let wNormal = getWorldNormalFromGBuffer(gBuffer);
    outBuffer.pick_Position = vec4<f32>(wPosition, 1.0) ;
    outBuffer.pick_Normal = vec4<f32>(wNormal, 1.0) ;
    }
`
    );

    let PreFilteredEnvironment_cs2 = (
      /*wgsl*/
      `
    // input reflection buffer texture
    // sample prefiltered cube uv texture 
    // storge info to oct map 
    #include "GenerayRandomDir"
    #include "BitUtil"
    #include "MathShader"
    
    struct UniformData{
        roughness : f32 ,
        roughness1 : f32 ,
        roughness2 : f32 ,
        roughness3 : f32 ,
    }

    @group(0) @binding(0) var inputTex : texture_2d<f32>;
    @group(0) @binding(1) var outputTexture : texture_storage_2d<rgba32float, write>;//rgba32float
    @group(1) @binding(0) var<uniform> uniformData:UniformData;//rgba32float

    var<private> reflectionSize : vec2f ; 
    var<private> PROBE_SOURCESIZE : vec2f ; 
    var<private> PROBEMAP_SOURCESIZE : vec2f ; 
    var<private> aspect : vec2f ; 
    var<private> spaceV : f32 ; 
    
    var<private> i32InputFragCoord : vec2i;
    var<private> PI_2 : f32 = 3.1415926 * 2.0 ;
    var<private> PI : f32 = 3.1415926 ;
    var<private> RAYS_PER_PROBE : f32 = 32.0 ;

    var<private> screenSize : vec2f ; 

    fn useSphereReflection(){
        reflectionSize = vec2f(textureDimensions(inputTex).xy);
        PROBE_SOURCESIZE = reflectionSize / vec2f(6.0,8.0);
        PROBEMAP_SOURCESIZE = reflectionSize ;
        aspect = PROBE_SOURCESIZE / PROBEMAP_SOURCESIZE;
        spaceV = 1.0 / 8.0;
    }

    @compute @workgroup_size( 16 , 16 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        var color : vec4f ;
        useSphereReflection();
        screenSize = vec2f(textureDimensions(outputTexture).xy);
        
        i32InputFragCoord = vec2<i32>( globalInvocation_id.xy ) ;
        let i = globalInvocation_id.z ;
        let roughness = uniformData.roughness ;

        let suv = vec2f(i32InputFragCoord) ;
        let subUV = vec2f((suv.x+0.5) % (256.0*6.0),(suv.y+0.5) % 256.0) / vec2f( (256.0*6.0), 256.0 ) ;
        let faceID = i32((suv.x / 256.0));
        let probeID = i32(floor(suv.y / 256.0));
        
        var sphereUV = subUV ;//(suv / screenSize) ;
        var dir: vec3<f32> = UvToDir(sphereUV) ;//* 0.5 + 0.5 ;

        var preColor = PreFilterEnvMap(roughness,dir,0.0);
        
        // var cc = vec4f(getReflectionsMap(dir,0.0),1.0) ;
        color.y = vec3fToFloat(preColor.xyz);
        color.z = vec3fToFloat(dir);
        
        textureStore(outputTexture,i32InputFragCoord,color);
    }

    fn getReflectionsMap(n:vec3<f32>,gid:f32) -> vec3f {
        var uv = getSampleProbeUV(n,gid);
        let color = textureLoad(inputTex, vec2i(uv*screenSize) , 0);
        return floatToVec3f(color.y) ;
    }

    fn getSampleProbeUV(dir:vec3<f32>,gid:f32) -> vec2<f32> {
        let faceId = dir_to_faceId(dir);
        var targetUV:vec2<f32> = convert_xyz_to_cube_uv(dir.x, dir.y, dir.z);
        targetUV.x = 1.0 - targetUV.x;
        // targetUV.y = 1.0 - targetUV.y;
        let threshould = 0.5 / PROBE_SOURCESIZE;
        targetUV = clamp(targetUV, vec2<f32>(threshould), vec2<f32>(1.0 - threshould));
     
        targetUV.x = f32(faceId) + targetUV.x;
     
        let aspect:vec2f = PROBE_SOURCESIZE / PROBEMAP_SOURCESIZE;
        targetUV = targetUV * aspect ;

        targetUV.y = targetUV.y + (spaceV*gid);
     
        return targetUV ;
     }


    
fn radicalInverse_VdC( bits2:u32) -> f32
{
    var bits = bits2; 
    bits = (bits << 16u) | (bits >> 16u);
    bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
    bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
    bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
    bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
    return f32(bits) * 2.3283064365386963e-10f; // / 0x100000000
}


fn hammersley( i:u32, N:u32) -> vec2f
{
    return vec2f(f32(i) / f32(N), radicalInverse_VdC(i));
}

fn ImportanceSampleGGX( xi:vec2f,  roughness:f32,  N:vec3f) -> vec3f
{
    var alpha2 = roughness * roughness * roughness * roughness;
     
    var phi = 2.0f * 3.1415926 * xi.x  ;
    var cosTheta = sqrt( (1.0f - xi.y) / (1.0f + (alpha2 - 1.0f) * xi.y ));
    var sinTheta = sqrt( 1.0f - cosTheta*cosTheta );
     
    var h : vec3f ;
    h.x = sinTheta * cos( phi );
    h.y = sinTheta * sin( phi );
    h.z = cosTheta;
     
    var up = vec3f(1,0,0) ;
    if(abs(N.z) < 0.9999){
        up = vec3f(0,0,1) ;
    }
    var tangentX = normalize( cross( up, N ) );
    var tangentY = cross( N, tangentX );
     
    return (tangentX * h.x + tangentY * h.y + N * h.z);
} 

const NUM_SAMPLES = 512u;
fn PreFilterEnvMap( roughness2:f32,  R:vec3f , gid:f32 ) -> vec3f
{
    var res = vec3f(0.0f);  
    var totalWeight = 0.0f;   
     
    var normal = normalize(R);
    var toEye = normal;
     
    var roughness = roughness2;
    //roughness = max(0.02f,roughness);
     
    for(var i=1u;i<=NUM_SAMPLES;i+=1u)
    {
        var xi:vec2f = hammersley(i, NUM_SAMPLES) ; 
         
        var halfway = ImportanceSampleGGX(xi,roughness,normal);
        var lightVec = 2.0f * dot( toEye,halfway ) * halfway - toEye;
         
        var NdotL = dot( normal, lightVec )  ;
        var NdotH = max(0.0,dot( normal, halfway ))  ;
        var HdotV = max(0.0,dot( halfway, toEye ))  ;
         
        if( NdotL > 0.0 )
        {
            var D = specularD(roughness,NdotH);
            var pdf = (D * NdotH / (4.0 * HdotV)) + 0.0001f  ;

            var saSample = 1.0f / (f32(NUM_SAMPLES) * pdf + 0.00001f);
            lightVec = normalize(lightVec);
            // res += sampleBuffer(lightVec,gid).rgb *NdotL;
            res += vec3f(getReflectionsMap(lightVec,0.0)) * NdotL;;
            totalWeight += NdotL;


            // var uv = convert_xyz_to_cube_uv(lightVec.x,lightVec.y,lightVec.z) ;

            // // let uv_f32:vec2<f32> = subUV * vec2f(256.0*6.0,256.0*8.0);
            // var bc = textureLoad(inputTex, vec2i(uv) , 0);

            // res += floatToVec3f(bc.y) ; 
            // totalWeight += 1.0;
        }
    }
     
    return res / max(totalWeight,0.001f);
} 

fn  specularD( roughness:f32,  NoH:f32) -> f32
{
    var NoH2 = NoH * NoH;
    var r2 = roughness * roughness;
    return r2 / pow(NoH2 * (r2 - 1.0) + 1.0, 2.0);
}
    
`
    );

    let PreIntegratedLut = (
      /*wgsl*/
      `
var<private>PI: f32 = 3.141592653589793;

fn Scatter( r:f32) -> vec3f
{
    return Gaussian(0.0064 * 1.414, r) * vec3f(0.233, 0.455, 0.649)
           + Gaussian(0.0484 * 1.414, r) * vec3f(0.100, 0.336, 0.344)
           + Gaussian(0.1870 * 1.414, r) * vec3f(0.118, 0.198, 0.000)
           + Gaussian(0.5670 * 1.414, r) * vec3f(0.113, 0.007, 0.007)
           + Gaussian(1.9900 * 1.414, r) * vec3f(0.358, 0.004, 0.00001)
           + Gaussian(7.4100 * 1.414, r) * vec3f(0.078, 0.00001, 0.00001);
}

fn Gaussian( v:f32 , r:f32 ) -> f32
{
    return 1.0 / sqrt(2.0 * PI * v) * exp(-(r * r) / (2.0 * v));
}

fn Integrate( cosTheta : f32 ,  skinRadius: f32 ) -> vec3f
{
    var theta = acos(cosTheta);  // theta -> the angle from lighting direction
    var totalWeights = vec3f(0.0);
    var totalLight = vec3f(0.0);

    var a = -(PI / 2.0);
    let inc = 0.05;

    while ( a <= (PI / 2.0) ) {
        var sampleAngle = theta + a;
        var diffuse = clamp(cos(sampleAngle),0.0,1.0);

        // calc distance
        var sampleDist = abs(2.0 * skinRadius * sin(a * 0.5));

        // estimated by Gaussian pdf
        var weights = Scatter(sampleDist);

        totalWeights += weights;
        totalLight += diffuse * weights;
        a += inc;
    }

    var result = vec3f(totalLight.x / totalWeights.x, totalLight.y / totalWeights.y, totalLight.z / totalWeights.z);
    return result;
}

@group(0) @binding(0) var sssMap: texture_storage_2d<rgba8unorm, write>;

@compute @workgroup_size(8, 8, 1)
// fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(local_invocation_id) local_invocation_id : vec3<u32> ){
fn CsMain(@builtin(global_invocation_id) global_invocation_id : vec3<u32>){
    var fragCoord = vec2<u32>(global_invocation_id.x, global_invocation_id.y);

    var fragColor = vec4<f32>(1.0,1.0,0.0,1.0);
    // // Output to screen
    // var res = integrateBRDF(f32(fragCoord.y + 1u) / 256.0, f32(fragCoord.x + 1u) / 256.0);
    // fragColor = vec4<f32>(res.x, res.y, 0.0, 1.0);

    var NDotL = mix(-1.0, 1.0, f32(fragCoord.x) / 256.0) ; 
    var oneOverR = 2.0 * 1.0 / (f32((fragCoord.y + 1u)) / 256.0);  

    //Integrate Diffuse Scattering
    var diff = Integrate(NDotL, oneOverR);
    // fragColor = vec4f(diff,1.0);
    fragColor = vec4f(vec3f(diff),1.0);
    textureStore(sssMap, vec2<i32>(fragCoord.xy), fragColor);
}
`
    );

    let SSAO_cs = (
      /*wgsl*/
      `
#include "GlobalUniform"
  struct UniformData {
    radius: f32 ,
    bias: f32,
    aoPower: f32 ,
    blurSize: f32 ,
  };

  @group(0) @binding(0) var<uniform> standUniform: GlobalUniform;
  @group(0) @binding(1) var<uniform> uniformData: UniformData;
  @group(0) @binding(2) var<storage,read> sampleData: array<vec4<f32>>;

  // @group(0) @binding(3) var colorMap : texture_2d<f32>;
  @group(0) @binding(3) var positionMap : texture_2d<f32>;
  @group(0) @binding(4) var normalMap : texture_2d<f32>;

  @group(0) @binding(5) var noiseMapSampler: sampler;
  @group(0) @binding(6) var noiseMap : texture_2d<f32>;

  @group(0) @binding(7) var outTex : texture_storage_2d<rgba16float, write>;

  var<private> kernelSize: i32 = 32 ;

  @compute @workgroup_size( 8 , 8 )
  fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
  {
    var fragCoord = vec2<i32>( globalInvocation_id.xy );

    var texSize = textureDimensions(positionMap).xy;
    var texCoord = vec2<f32>(fragCoord) / vec2<f32>(texSize);

    var fragColor = vec4<f32>(1.0);

    var viewMat = standUniform.viewMat  ;
    // var color = textureLoad(colorMap, fragCoord , 0 ) ;
    var wPos = textureLoad(positionMap, fragCoord , 0 ) ;

    var fragPosition = viewMat * vec4<f32>(wPos.xyz,1.0);
    fragPosition = vec4(fragPosition.xyz / fragPosition.w,1.0) ;

    var texNormal = textureLoad(normalMap, fragCoord , 0 ) ;
    var sampleNormal = texNormal.xyz ;
    sampleNormal = sampleNormal * 2.0 - 1.0;
    var fragNormal = viewMat * vec4<f32>((sampleNormal.xyz),0.0);

    var pes = vec2<f32>(texSize.xy) / 4.0 ;
    var noiseTex:vec4<f32> = textureSampleLevel(noiseMap, noiseMapSampler, texCoord * pes , 0.0);
    var randomVec  = (viewMat * vec4<f32>(normalize(noiseTex.xyz),0.0)).xyz;

    var tangent = normalize(randomVec - fragNormal.xyz * dot(randomVec , fragNormal.xyz));
    var bTangent = cross(fragNormal.xyz, tangent) + 0.0001 ;
    var tbn = mat3x3<f32>(tangent, bTangent, fragNormal.xyz);

    var offset:vec4<f32>;
    var samplePos :vec3<f32>;
    var offsetPosition:f32;
    var sample_depth_v:vec4<f32>;
    var occlusion:f32 = 0.0;
    var rangeCheck:f32 = 0.0 ;
    var radius:f32 = uniformData.radius * 32.0 * fragPosition.z ;

    for(var i:i32 = 0; i < 32 ; i = i + 1 ){
      samplePos  = (tbn * sampleData[i].xyz ) ;
      samplePos  = fragPosition.xyz + samplePos * radius ;

      offset = vec4(samplePos, 1.0);
      offset = standUniform.projMat * offset;

      var off = offset.xyz / offset.w;
      off = (off.xyz * 0.5 ) + 0.5 ;
      off.y = 1.0 - off.y ;
      var offsetUV = vec2<i32>(off.xy * vec2<f32>(texSize.xy));

      sample_depth_v = textureLoad(positionMap, offsetUV.xy , 0 ) ;
      sample_depth_v = vec4<f32>((viewMat * vec4<f32>(sample_depth_v.xyz,1.0)).xyz,1.0);
      offsetPosition = sample_depth_v.z / sample_depth_v.w ;

      rangeCheck = smoothstep(0.0, 1.0, radius / abs(offsetPosition - fragPosition.z ));
      // rangeCheck = smoothstep(0.0, 1.0, radius / uniformData.bias);

      var a = 1.0 ;
      if(offsetPosition >= (samplePos.z + uniformData.bias)){
        a = 0.0 ;
      }
      a = a * rangeCheck ;
      occlusion = occlusion + a ;
    }

    occlusion = 1.0 - ( occlusion / f32(kernelSize) * texNormal.w );
    occlusion = pow(occlusion, uniformData.aoPower) ;

    // color = color * occlusion ;

    textureStore(outTex, fragCoord , vec4(occlusion));
  }
`
    );

    let SSGI2_cs = (
      /*wgsl*/
      `
    #include "GlobalUniform"
    #include "MathShader"
    #include "FastMathShader"
    #include "BitUtil"
    #include "ColorUtil_frag"
    #include "GBufferStand"

    struct FrameBuffer{
      frameCount : f32 ,
      indirectIns : f32 ,
      delay : f32 ,
      frameCount4 : f32 ,
      d1 : f32 ,
      d2 : f32 ,
      d3 : f32 ,
      d4 : f32 ,
  }
    
    @group(0) @binding(3) var combineTexture : texture_2d<f32>;
    @group(0) @binding(5) var newTexture : texture_storage_2d<rgba16float, write>;

    @group(0) @binding(6) var<storage,read> updateBuffer: FrameBuffer ;

    var<private> i32InputSize: vec2<i32> ;
    var<private> i32GbufferSize: vec2<i32> ;

    var<private> f32InputSize: vec2<f32> ;
    var<private> f32GBufferSize: vec2<f32> ;

    var<private> i32InputFragCoord: vec2<i32> ;
    var<private> i32GbufferFragCoord: vec2<i32> ;

    var<private> f32InputFragCoord: vec2<f32> ;
    var<private> f32GbufferFragCoord: vec2<f32> ;

    var<private> f32InputUV: vec2<f32> ;
    var<private> f32GbufferUV: vec2<f32> ;

    var<private> inputToGBuffer: vec2<f32> ;

    var<private> gBuffer: GBuffer ;
    var<private> wColor: vec3<f32>;

    var<private> halfPi: f32 ;

    const PI: f32 = 3.141592653;
    const I64: f32 = 1.0/64.0;
    // const halfPi = 20.371832715762602978417121711682 ;
    const offsetCount = 20u ;
    
    @compute @workgroup_size( 16 , 16 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
      i32InputFragCoord = vec2<i32>( globalInvocation_id.xy ) ;
      f32InputFragCoord = vec2<f32>( globalInvocation_id.xy ) ;

      i32InputSize = vec2i(textureDimensions(newTexture).xy);
      i32GbufferSize = vec2i(textureDimensions(gBufferTexture).xy);

      f32InputSize = vec2f(i32InputSize);
      f32GBufferSize = vec2f(i32GbufferSize);

      inputToGBuffer = 1.0/(f32InputSize / f32GBufferSize) ;

      f32InputUV = f32InputFragCoord / f32InputSize ;

      f32GbufferUV = f32InputUV  ;

      f32GbufferFragCoord = f32GbufferUV * f32GBufferSize;
      i32GbufferFragCoord = vec2i(f32GbufferFragCoord) ; 

      gBuffer = getGBuffer(i32GbufferFragCoord) ;
      wColor = getRGBMColorFromGBuffer(gBuffer);
      var n = getViewNormalFromGBuffer(gBuffer);
      var p = getWorldPositionFromGBuffer(gBuffer,f32GbufferUV);

      let f = -globalUniform.far;
      if(gBuffer.x <= f ){
        textureStore(newTexture, i32InputFragCoord , vec4f(0.0) );
        return ;
      }

      halfPi = 1.0 / (PI*0.5) * f32(offsetCount);

      var trackColor:vec4f = vec4f(0.0);

      trackColor = ray(i32InputFragCoord,f32InputFragCoord);
      // trackColor = vec4f(n.xyz,1.0);

      textureStore(newTexture, i32InputFragCoord , trackColor );
    }

    fn ray(i32InputFragCoord:vec2<i32>,f32InputFragCoord:vec2<f32>) -> vec4f {
      var Output = vec4f(0.0);
      let i64pi = I64*PI ;
      let iFrame = updateBuffer.frameCount;
      var lastColor2 = textureLoad(combineTexture, i32InputFragCoord , 0) ;
      if (iFrame > 1.0 ) {
          var CurrentFrame = f32(iFrame);
          var SSOffset = vec2f(0.0);
          
          gBuffer = getGBuffer(i32GbufferFragCoord) ;
          var VColor = getRGBMColorFromGBuffer(gBuffer);
          var VNormal = getViewNormalFromGBuffer(gBuffer) ;
          var VPPos = getViewPositionFromGBuffer(gBuffer,f32GbufferUV) ;
          var ModFC = f32InputFragCoord % 4.;
          var RandPhiOffset = ARand21(vec2f(1.234)+ (CurrentFrame*3.26346) % 7.2634 );
          var RandPhi2 = (((floor(ModFC.x)+floor(ModFC.y)*4.0+CurrentFrame*5.0) % 16.0)+RandPhiOffset)*2.0*PI*I64 ;
       
          var stepScale = ceil( 128.0 / f32(offsetCount) ) ;
          var skyColor = vec4f(0.0,0.0,0.0,1.0);
          var ii = 0.0;
          var i=0u;
          for (; i < 4u; i+=1u) {
            let RandPhi = f32(i+1u) * (RandPhi2 + PI * 0.5);
            let SSDir = (vec2f(cos(RandPhi),sin(RandPhi)));

            var StepDist = stepScale ;
            let StepCoeff = 0.15+0.15*ARand21(f32InputUV*(1.4+f32(iFrame)*3.26346%6.2634));

            var BitMask = 0u;
            var s = 1u ;
            for (; s<= offsetCount ; s+=1u)
            {
                let SUV : vec2f = f32InputFragCoord + SSDir * StepDist;

                //round 2d offset
                let CurrentStep = max( 1.0 , (StepDist * StepCoeff) );
                StepDist += CurrentStep;

                //fullsize 
                let offsetUV = (SUV / f32InputSize) ;
                let i32InputUV = vec2i( offsetUV * f32GBufferSize );
                let stepGBuffer = getGBuffer(vec2i(i32InputUV));
                var SSVC = getRGBMColorFromGBuffer(stepGBuffer);
                
                var uuv = (SUV * inputToGBuffer);
                uuv = uuv / f32GBufferSize ;
                var SVPPos = getViewPositionFromGBuffer(stepGBuffer,uuv) ;
                var SWPos = getWorldPositionFromGBuffer(stepGBuffer,uuv) ;
                var SNormal = getViewNormalFromGBuffer(stepGBuffer) ;

                let f = (globalUniform.far - globalUniform.near) - 1000.0;
                if(stepGBuffer.x <= f ){
                  let svvd = SVPPos.xyz-VPPos ;
                  var NorDot = dot(VNormal,(svvd))-0.001;
  
                  if(stepGBuffer.x < -1.1 || NorDot < 1.570796 )
                  {
                     continue ;
                  }
  
                  var TanDist = (length(svvd-NorDot*VNormal));

                  if(TanDist <= 0.00001 )
                  {
                      continue ;
                  }
  
                  var Angle1f = atan2(NorDot,TanDist);
                  var Angle2f = atan2((NorDot-0.03*max(1.0,StepDist*0.07)),TanDist);
  
                  var Angle1 = max(0.0,ceil(Angle1f*halfPi));
                  var Angle2 = max(0.0,floor(Angle2f*halfPi));
  
                  var SBitMask = (u32(pow(2.0,Angle1-Angle2))-1u) << u32(Angle2);
                  
                  let b1 = f32(countOneBits(SBitMask & (~BitMask)))/max(1.0,Angle1-Angle2) ;
                  let b2 = pow(cos(Angle2*i64pi),2.0)-pow(cos(Angle1*i64pi),2.0);
                  let b3 = sqrt(max(0.0,dot(SNormal,-svvd))) ;
                  let fb = b1 * b2 * b3 ;
                  
                  var lastColor2 = textureLoad(combineTexture, vec2i(SUV) , 0) ;
                  Output = vec4f(Output.xyz + vec3f(fb * (SSVC.xyz + lastColor2.xyz * 0.15)  ) , 1.0);
                  BitMask = BitMask | SBitMask;
                }
              }
          }
      }else{
        Output = vec4f( wColor.xyz , 1.0 );
      }

      return Output ;
    }
  `
    );

    let SSGI_cs = (
      /*wgsl*/
      `
    #include "GlobalUniform"
    #include "GBufferStand"

    const PI: f32 = 3.1415926;

    struct SSGISettings {
        intensity: f32,
        radius: f32,
        sliceCount: f32,
        stepCount: f32,
    };

    @group(0) @binding(2) var<uniform> ssgiSettings: SSGISettings;
    @group(0) @binding(3) var inTex: texture_2d<f32>;
    @group(0) @binding(4) var outTex: texture_storage_2d<rgba16float, write>;

    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> fragUV: vec2<f32>;
    var<private> gBuffer: GBuffer;

    @compute @workgroup_size(8, 8, 1)
    fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
        fragCoord = vec2<i32>(gid.xy);
        texSize = textureDimensions(inTex).xy;
        if (fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)) { return; }
        fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1u);

        let oc = textureLoad(inTex, fragCoord, 0);
        gBuffer = getGBuffer(fragCoord);
        useNormalMatrixInv();
        let visible = getRoughnessFromGBuffer(gBuffer);
        if (visible <= 0.0) {
            textureStore(outTex, fragCoord, oc);
            return;
        }

        let normal = getWorldNormalFromGBuffer(gBuffer);

        // Azimuthal march. For each slice, march along the screen-space
        // direction, sample the color buffer at each step, weight by
        // the cosine of the surface normal vs the sampled direction.
        let sliceCount = i32(clamp(ssgiSettings.sliceCount, 2.0, 8.0));
        let stepCount = i32(clamp(ssgiSettings.stepCount, 4.0, 16.0));
        var giAccum = vec3<f32>(0.0);
        let radiusUV = ssgiSettings.radius / f32(min(texSize.x, texSize.y));

        for (var slice: i32 = 0; slice < sliceCount; slice = slice + 1) {
            let theta = (f32(slice) + 0.5) * (2.0 * PI / f32(sliceCount));
            let dir = vec2<f32>(cos(theta), sin(theta));
            for (var s: i32 = 1; s <= stepCount; s = s + 1) {
                let t = f32(s) / f32(stepCount);
                let sampleUV = clamp(fragUV + dir * radiusUV * t, vec2<f32>(0.001), vec2<f32>(0.999));
                let sampleCoord = vec2<i32>(sampleUV * vec2<f32>(texSize));
                let bounce = textureLoad(inTex, sampleCoord, 0).rgb;
                // Weight by inverse distance; very simple — no horizon test
                // (deferred to a follow-up that consumes _HiZPyramid).
                let w = (1.0 - t) * (1.0 / f32(stepCount));
                giAccum = giAccum + bounce * w;
            }
        }
        giAccum = giAccum / f32(sliceCount);
        let result = oc.rgb + giAccum * ssgiSettings.intensity;
        textureStore(outTex, fragCoord, vec4<f32>(result, oc.a));
    }
`
    );

    let SSR_BlendColor_cs = (
      /*wgsl*/
      `
  #include 'GlobalUniform'

  @group(0) @binding(2) var<storage, read_write> rayTraceBuffer : array<RayTraceRetData>;
  @group(0) @binding(3) var colorMap : texture_2d<f32>;
  @group(0) @binding(4) var ssrMapSampler : sampler;
  @group(0) @binding(5) var ssrMap : texture_2d<f32>;
  @group(0) @binding(6) var outTex : texture_storage_2d<rgba16float, write>;

  var<private> colorTexSize: vec2<u32>;
  var<private> ssrTexSize: vec2<u32>;
  var<private> fragCoord: vec2<i32>;
  var<private> ssrCoord: vec2<i32>;

  struct RayTraceRetData{
    skyColor:vec3<f32>,
    roughness:f32,

    hitCoord:vec2<f32>,
    alpha:f32,
    fresnel:f32,
  }

  fn CalcUV_01(coord:vec2<i32>, texSize:vec2<u32>) -> vec2<f32>
  {
    let u = (f32(coord.x) + 0.5) / f32(texSize.x);
    let v = (f32(coord.y) + 0.5) / f32(texSize.y);
    return vec2<f32>(u, v);
  }

  const PI = 3.1415926;
  @compute @workgroup_size( 8 , 8 , 1 )
  fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
  {
    fragCoord = vec2<i32>( globalInvocation_id.xy );
    colorTexSize = textureDimensions(colorMap).xy;
    ssrTexSize = textureDimensions(ssrMap).xy;
    if(fragCoord.x >= i32(colorTexSize.x) || fragCoord.y >= i32(colorTexSize.y)){
        return;
    }
    let scale:f32 = f32(ssrTexSize.x) / f32(colorTexSize.x);
    ssrCoord = vec2<i32>(vec2<f32>(fragCoord.xy) * scale);
    let index = ssrCoord.x + ssrCoord.y * i32(ssrTexSize.x);
    let hitData = rayTraceBuffer[index];
    var lastColor = textureLoad(colorMap, fragCoord , 0);
    let time = globalUniform.time;

    var uv01 = CalcUV_01(fragCoord, colorTexSize);
    
    var ssrColor = textureSampleLevel(ssrMap, ssrMapSampler, uv01, 0.0);
    var outColor = mix(lastColor, ssrColor, hitData.fresnel) ;
    textureStore(outTex, fragCoord , outColor );
  }

`
    );

    let SSR_IS_cs = (
      /*wgsl*/
      `
#include 'BitUtil'

  struct SSRUniformData {
    ssrBufferSizeX: f32,
    ssrBufferSizeY: f32,
    colorMapSizeX: f32,
    colorMapSizeY: f32,

    fadeEdgeRatio: f32,
    rayMarchRatio: f32,
    fadeDistanceMin: f32,
    fadeDistanceMax: f32,
    
    mixThreshold: f32,
    roughnessThreshold: f32,
    reflectionRatio: f32,
    powDotRN: f32,

    randomSeedX: f32,
    randomSeedY: f32,
    slot1: f32,
    slot2: f32,
  };

  struct RayTraceRetData{
    skyColor:vec3<f32>,
    roughness:f32,

    hitCoord:vec2<f32>,
    alpha:f32,
    fresnel:f32,
  }

  @group(0) @binding(0) var<uniform> ssrUniform: SSRUniformData;
  @group(0) @binding(1) var<storage, read_write> rayTraceBuffer : array<RayTraceRetData>;
  @group(0) @binding(2) var<storage, read_write> ssrColorData : array<vec4<f32>>;
  @group(0) @binding(3) var<storage, read_write> historyPosition : array<vec4<f32>>;

  @group(0) @binding(4) var colorMap: texture_2d<f32>;
  @group(0) @binding(5) var outTex : texture_storage_2d<rgba16float, write>;

  var<private> ssrBufferCoord: vec2<i32>;
  var<private> colorTexSize: vec2<i32>;
  var<private> bufferData: RayTraceRetData;
  var<private> ssrBufferSize: vec2<i32>;
  var<private> coordIndex: i32;

  @compute @workgroup_size( 8 , 8 , 1 )
  fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
  {
    ssrBufferCoord = vec2<i32>( globalInvocation_id.xy );
    ssrBufferSize = vec2<i32>(i32(ssrUniform.ssrBufferSizeX), i32(ssrUniform.ssrBufferSizeY));
    colorTexSize = vec2<i32>(i32(ssrUniform.colorMapSizeX), i32(ssrUniform.colorMapSizeY));

    if(ssrBufferCoord.x >= ssrBufferSize.x || ssrBufferCoord.y >= ssrBufferSize.y){
        return;
    }

    coordIndex = ssrBufferCoord.x + ssrBufferCoord.y * ssrBufferSize.x;
    bufferData = rayTraceBuffer[coordIndex];
    var oc = vec4<f32>(0.0, 0.0, 0.0, -1.0);
    
    var mixFactor = historyPosition[coordIndex].w;
    
    if(bufferData.alpha >= 0.0 && bufferData.roughness < ssrUniform.roughnessThreshold){
      let prefilterColor = bufferData.skyColor;
      var ssrColor = textureLoad(colorMap, vec2<i32>(bufferData.hitCoord), 0);
      ssrColor.w = bufferData.alpha;
      oc = ssrColor;
    }
    let skyColor = vec4<f32>(bufferData.skyColor, 1.0);
    oc = mix(oc, skyColor, 1.0 - bufferData.alpha);
    
    let lastColor = ssrColorData[coordIndex];
    var newColor = mix(oc, lastColor, mixFactor);
    newColor.w = oc.w;
    
    ssrColorData[coordIndex] = newColor;
    
    textureStore(outTex, ssrBufferCoord , newColor);
  }
`
    );

    let SSR_RayTrace_cs = (
      /*wgsl*/
      `
  #include "GlobalUniform"
  #include "MathShader"
  #include "BitUtil"
  #include "GBufferStand"

  struct SSRUniformData {
    ssrBufferSizeX: f32,
    ssrBufferSizeY: f32,
    colorMapSizeX: f32,
    colorMapSizeY: f32,

    fadeEdgeRatio: f32,
    rayMarchRatio: f32,
    fadeDistanceMin: f32,
    fadeDistanceMax: f32,
    
    mixThreshold: f32,
    roughnessThreshold: f32,
    reflectionRatio: f32,
    powDotRN: f32,

    randomSeedX: f32,
    randomSeedY: f32,
    slot1: f32,
    slot2: f32,
  };

  struct HitData{
    hitPos:vec3<f32>,
    hitNormal:vec3<f32>,
    fadeAlpha:vec4<f32>,
    hitCoord:vec2<i32>,
    hitResult:i32,
    hitSky:i32,
  };

  struct RayTraceRetData{
    skyColor:vec3<f32>,
    roughness:f32,

    hitCoord:vec2<f32>,
    alpha:f32,
    fresnel:f32,
  }

  @group(0) @binding(2) var<uniform> ssrUniform: SSRUniformData;
  @group(0) @binding(3) var<storage, read_write> rayTraceBuffer : array<RayTraceRetData>;
  @group(0) @binding(4) var<storage, read_write> historyPosition : array<vec4<f32>>;

  @group(0) @binding(5) var prefilterMap: texture_cube<f32>;
  @group(0) @binding(6) var prefilterMapSampler: sampler;

  var<private> rayOrigin: vec3<f32>;
  var<private> rayDirection: vec3<f32>;
  var<private> cameraPosition: vec3<f32>;
  var<private> reflectionDir: vec3<f32>;
  var<private> colorTexSize: vec2<i32>;
  var<private> fragCoordColor: vec2<i32>;
  var<private> ssrBufferCoord: vec2<i32>;
  var<private> ssrBufferSize: vec2<i32>;
  var<private> hitData: HitData;
  var<private> rayTraceRet: RayTraceRetData;
  var<private> worldPosition: vec3<f32>;
  var<private> worldNormal: vec3<f32>;
  var<private> roughness: f32;
  var<private> fresnel: f32;

  var<private> historyPos: vec3<f32>;
  var<private> coordIndex: i32;

  var<private> sampleUV: vec2<f32>;
  var <private> PI: f32 = 3.14159;

  @compute @workgroup_size( 8 , 8 , 1 )
  fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
  {
    ssrBufferCoord = vec2<i32>( globalInvocation_id.xy);
    ssrBufferSize = vec2<i32>(i32(ssrUniform.ssrBufferSizeX), i32(ssrUniform.ssrBufferSizeY));
    if(ssrBufferCoord.x >= ssrBufferSize.x || ssrBufferCoord.y >= ssrBufferSize.y){
      return;
    }
    useNormalMatrixInv();
    coordIndex = ssrBufferCoord.x + ssrBufferCoord.y * ssrBufferSize.x;

    colorTexSize = vec2<i32>(i32(ssrUniform.colorMapSizeX), i32(ssrUniform.colorMapSizeY));
    fragCoordColor = convertColorCoordFromSSRCoord(ssrBufferCoord);

    hitData.fadeAlpha = vec4<f32>(0.0);
    hitData.hitCoord = vec2<i32>(0);
    hitData.hitResult = 0;
    hitData.hitNormal = vec3<f32>(0.0, 1.0, 0.0);
    hitData.hitSky = 1;

    sampleUV =  vec2f(fragCoordColor) / vec2f(colorTexSize) ;
    //gBufferTexture
    let gBuffer : GBuffer = getGBuffer( vec2i(fragCoordColor) );
    worldPosition = getWorldPositionFromGBuffer(gBuffer,sampleUV) ;
    historyPos = historyPosition[coordIndex].xyz;
    
    var mixFactor = 0.2;
    if(length(historyPos - worldPosition) < ssrUniform.mixThreshold){
        mixFactor = 0.9;
    }
    historyPosition[coordIndex] = vec4<f32>(worldPosition, mixFactor);
    
    worldNormal = getWorldNormalFromGBuffer(gBuffer) ;

    let roughness = getRoughnessFromGBuffer(gBuffer);
    // Sky pixels are encoded with roughness == 0 in this engine's GBuffer
    // (see ContactShadow_cs's visible<=0 sky-skip path). Without this
    // early-out the else branch below samples getSkyColor() at a garbage
    // reflectionDir from an invalid worldPosition, and SSR_IS_cs's
    // mix(oc, skyColor, 1 - alpha) with alpha = -1 extrapolates to 2x sky,
    // which BlendColor then mixes back into real sky and brightens the
    // sun-side corner.
    if (roughness <= 0.0) {
      rayTraceRet.skyColor = vec3<f32>(0.0);
      rayTraceRet.roughness = roughness;
      rayTraceRet.hitCoord = vec2<f32>(0.0);
      rayTraceRet.alpha = 0.0;
      rayTraceRet.fresnel = 0.0;
      let index:i32 = ssrBufferCoord.x + ssrBufferCoord.y * ssrBufferSize.x;
      rayTraceBuffer[index] = rayTraceRet;
      return;
    }
    fresnel = (1.0 - roughness) * ssrUniform.reflectionRatio;
    fresnel *= fresnel;
    cameraPosition = vec3<f32>(globalUniform.cameraWorldMatrix[3].xyz);
    rayOrigin = vec3<f32>(worldPosition.xyz);

    rayDirection = normalize(vec3<f32>(worldPosition.xyz - cameraPosition));
    
    var randomSeed = fract(ssrUniform.randomSeedX + worldPosition.x);
    rand_seed.x = randomSeed;
    rand_seed.y = fract(ssrUniform.randomSeedY + worldPosition.y + worldPosition.z);
    randomSeed = rand();
    
    let normalRandom = makeRandomDirection(worldNormal, u32(randomSeed * 256.0), 256, roughness);
    
    reflectionDir = normalize(reflect(rayDirection, normalRandom));

    if(roughness > 0.0 && roughness < ssrUniform.roughnessThreshold){
      let uvOrigin = vec2<f32>(f32(fragCoordColor.x), f32(fragCoordColor.y));
      let rayMarchPosition = rayOrigin + reflectionDir * 100.0;
      var uvRayMarch = globalUniform.projMat * (globalUniform.viewMat * vec4<f32>(rayMarchPosition, 1.0));
      var uvOffset = (vec2<f32>(uvRayMarch.xy / uvRayMarch.w) + 1.0) * 0.5;
      uvOffset.y = 1.0 - uvOffset.y;
      uvOffset = uvOffset * vec2<f32>(colorTexSize) - uvOrigin;
      uvOffset = normalize(uvOffset);

      rayTrace(uvOffset);
      if(hitData.hitResult == 1){
          hidingArtifact();
          rayTraceRet.alpha = hitData.fadeAlpha.x * hitData.fadeAlpha.y * hitData.fadeAlpha.z * hitData.fadeAlpha.w;
          if(hitData.hitSky == 1){
            rayTraceRet.alpha = 0.0;
          }
      }else{
        rayTraceRet.alpha = 0.0;
      }
      rayTraceRet.skyColor = getSkyColor();
    }else{
      // Mirror (roughness == 0) and out-of-range roughness skip the
      // ray-trace loop. Legacy code wrote skyColor = 0 here, which
      // SSR_IS_cs's mix(oc, skyColor, 1 - alpha) then EXTRAPOLATES
      // past via alpha = -1 (mix factor 2) — producing oc.rgb = 0
      // and a hard-edged black artifact on every roughness-0 surface.
      // Sample the sky directly so mirrors at least show the sky
      // reflection (correct under perfect-mirror semantics).
      rayTraceRet.alpha = -1.0;
      rayTraceRet.skyColor = getSkyColor();
    }

    rayTraceRet.roughness = roughness;
    rayTraceRet.fresnel = fresnel;
    rayTraceRet.hitCoord = vec2<f32>(hitData.hitCoord);

    let index:i32 = ssrBufferCoord.x + ssrBufferCoord.y * ssrBufferSize.x;
    rayTraceBuffer[index] = rayTraceRet;
  }

  fn makeRandomDirection(srcDirection:vec3<f32>, i:u32, SAMPLE_COUNT:u32, roughness:f32) -> vec3<f32>
  {
    var N: vec3<f32> = normalize(srcDirection);
    var Xi:vec2<f32> = hammersley(i, SAMPLE_COUNT);
    return ImportanceSampleGGX(Xi, N, roughness);
  }

  fn hammersley( i : u32 ,  N : u32 ) -> vec2<f32>
  {
    // Radical inverse based on http://holger.dammertz.org/stuff/notes_HammersleyOnHemisphere.html
    var bits = (i << 16u) | (i >> 16u);
    bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
    bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
    bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
    bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
    var rdi = f32(bits) * 2.3283064365386963e-10;
    return vec2<f32>(f32(i) /f32(N), rdi);
  }

  fn ImportanceSampleGGX( Xi:vec2<f32>, N:vec3<f32>, roughness:f32) ->vec3<f32>
  {
    var a = roughness*roughness;

    var phi = 2.0 * PI * Xi.x;
    var cosTheta = sqrt((1.0 - Xi.y) / (1.0 + (a*a - 1.0) * Xi.y));
    var sinTheta = sqrt(1.0 - cosTheta*cosTheta);

    // from spherical coordinates to cartesian coordinates
    var H:vec3<f32>;
    H.x = cos(phi) * sinTheta;
    H.y = sin(phi) * sinTheta;
    H.z = cosTheta;

    // from tangent-space vector to world-space sample vector
  var up:vec3<f32>;
    if(abs(N.z) < 0.999)
    {
        up = vec3<f32>(0.0, 0.0, 1.0);
    }
    else
    {
        up = vec3<f32>(1.0, 0.0, 0.0);
    }
  var tangent:vec3<f32>  = normalize(cross(up, N));
  var bitangent:vec3<f32> = cross(N, tangent);
  var sampleVec:vec3<f32> = tangent * H.x + bitangent * H.y + N * H.z;
  return normalize(sampleVec);
  }

  var<private> rand_seed :vec2<f32> = vec2<f32>(0.0);
  fn rand() -> f32 {
    rand_seed.x = fract(cos(dot(rand_seed, vec2<f32>(23.14077926, 232.61690225))) * 136.8168);
    rand_seed.y = fract(cos(dot(rand_seed, vec2<f32>(54.47856553, 345.84153136))) * 534.7645);
    return rand_seed.y;
  }

  fn getSkyColor() -> vec3<f32>{
    let calcRoughness = clamp(roughness, 0.0, 1.0);
    let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
    let prefilterColor = textureSampleLevel(prefilterMap, prefilterMapSampler, reflectionDir, calcRoughness * MAX_REFLECTION_LOD);
    // Linear HDR — composite into the SSR result in linear space.
    return prefilterColor.xyz * globalUniform.skyExposure;
  }

  fn convertColorCoordFromSSRCoord(coord:vec2<i32>) -> vec2<i32>{
    let color_ssr_ratio = ssrUniform.colorMapSizeX / ssrUniform.ssrBufferSizeX;
    let targetCoord = vec2<f32>(coord) * color_ssr_ratio;
    return vec2<i32>(targetCoord);
  }

  fn hidingArtifact(){
    let texSizeF32 = vec2<f32>(f32(colorTexSize.x), f32(colorTexSize.y));
    let halfTexSizeF32 = texSizeF32 * 0.5;

    //near screen edge
    var distance2Center = abs(vec2<f32>(f32(hitData.hitCoord.x), f32(hitData.hitCoord.y)) - halfTexSizeF32);
    let halfEdgeSize:f32 = min(texSizeF32.x, texSizeF32.y) * clamp(0.01, ssrUniform.fadeEdgeRatio, 1.0) * 0.5;
    var distance2Edge = min(vec2<f32>(halfEdgeSize), halfTexSizeF32 - distance2Center);
    var ratioXY = distance2Edge / halfEdgeSize;
    hitData.fadeAlpha.x = sqrt(ratioXY.x * ratioXY.y);

    //back face hit
    var backFaceBias = max(0.0, dot(hitData.hitNormal, -reflectionDir));
    hitData.fadeAlpha.y = pow(backFaceBias, max(0.0001, ssrUniform.powDotRN));

    //screen distance ratio
    let maxLength = max(f32(colorTexSize.x), f32(colorTexSize.y)) * ssrUniform.rayMarchRatio;
    let screenPointer = hitData.hitCoord - fragCoordColor;
    var screenDistance = length(vec2<f32>(f32(screenPointer.x), f32(screenPointer.y)));
    screenDistance = clamp(screenDistance / maxLength, 0.0, 1.0);
    hitData.fadeAlpha.z = 1.0 - screenDistance;

    //position distance ratio
    var fadeDistance = length(vec3<f32>(hitData.hitPos - cameraPosition));
    var dFar = ssrUniform.fadeDistanceMax;
    var dNear = ssrUniform.fadeDistanceMin;
    dFar = max(1.0, dFar);
    dNear = clamp(dNear, 0.001, dFar - 0.001);
    fadeDistance = clamp(fadeDistance, dNear, dFar);
    fadeDistance = (fadeDistance - dNear) / (dFar - dNear);
    hitData.fadeAlpha.w = 1.0 - fadeDistance;
  }

  fn rayTrace(rayMarchDir:vec2<f32>){
    let stepLength = 4.0;
    let maxLength = max(f32(colorTexSize.x), f32(colorTexSize.y)) * ssrUniform.rayMarchRatio;
    for(var i:f32 = 1.0; i < maxLength; i = i + stepLength){
        let offsetFloat32 = i * rayMarchDir;
        var uv = fragCoordColor + vec2<i32>(i32(offsetFloat32.x), i32(offsetFloat32.y));
        let hitRet = rayInterestScene(uv);
        if(hitRet > 0){
          hitData.hitResult = hitRet;
          break;
        }
    }
    if(hitData.hitResult == 1){
        let fromUV = hitData.hitCoord;
        for(var i:f32 = -stepLength; i <= 0.0; i = i + 1.0){
          let offsetFloat32 = i * rayMarchDir;
          var uv = fromUV + vec2<i32>(i32(offsetFloat32.x), i32(offsetFloat32.y));
          let hitRet = rayInterestScene(uv);
          if(hitRet == 1){
            let gBuffer = getGBuffer(hitData.hitCoord);
            if(getRoughnessFromGBuffer(gBuffer) >= 0.0){
              hitData.hitSky = 0;
            }
            
            let WN = getWorldNormalFromGBuffer(gBuffer);
            hitData.hitNormal = normalize(WN);
            break;
          }
        }
    }
  }

  fn rayInterestScene(uv:vec2<i32>) -> i32 {
    if(uv.x < 0 || uv.y < 0 || uv.x >= colorTexSize.x || uv.y >= colorTexSize.y){
      return 2;
    }else{
      let gBuffer = getGBuffer(uv);
      let hitPos = getWorldPositionFromGBuffer(gBuffer , vec2f(uv) / vec2f(colorTexSize) );
      let testDir = normalize(vec3<f32>(hitPos.xyz - rayOrigin));
      let cosValue = dot(reflectionDir, testDir);

      if(cosValue > 0.9996){
        let cross1 = cross(reflectionDir, -rayDirection);
        let cross2 = cross(reflectionDir, testDir);
        if(dot(cross1, cross2) > 0.0){
          hitData.hitPos = vec3<f32>(hitPos.xyz);
          hitData.hitCoord = uv;
          return 1;
        }
      }
    }
    return 0;
  }
`
    );

    let Skyline_cs = (
      /*wgsl*/
      `
const PI: f32 = 3.141592653589793;
#include "MathShader"
#include "FastMathShader"
#include "BitUtil"
#include "ColorUtil_frag"

@group(0) @binding(1) var gBufferTexture : texture_2d<f32>;

struct SkylineSettingData {
    lineColor: vec4<f32>,
    lineWidth: f32,
    depthThreshold: f32,
    strength: f32,
    slot: f32,
}

@group(0) @binding(2) var<uniform> skylineSetting: SkylineSettingData;
@group(0) @binding(3) var inTex: texture_2d<f32>;
@group(0) @binding(4) var outTex: texture_storage_2d<rgba16float, write>;

var<private> texSize: vec2<u32>;
var<private> fragCoord: vec2<i32>;

fn getGBufferData(fragCoord: vec2<i32>) -> vec4<f32> {
    return textureLoad(gBufferTexture, fragCoord, 0);
}

fn getRoughnessValue(gBufferData: vec4<f32>) -> f32 {
    let channel = float_to_r11g11b9(gBufferData.y);
    return channel.z;
}

fn isSkyPixel(coord: vec2<i32>) -> bool {
    if (coord.x < 0 || coord.y < 0 || coord.x >= i32(texSize.x) || coord.y >= i32(texSize.y)) {
        return false;
    }
    let gBufferData = getGBufferData(coord);
    // Sky pixels have roughness <= 0
    let roughness = getRoughnessValue(gBufferData);
    return roughness <= 0.0;
}

fn detectSkylineEdge(coord: vec2<i32>, lineWidth: i32) -> f32 {
    let centerIsSky = isSkyPixel(coord);
    
    // We only draw the line on object pixels that are adjacent to sky
    if (centerIsSky) {
        return 0.0; // Don't draw line on sky pixels
    }
    
    // Check if this object pixel is at the boundary with sky
    var edgeWeight: f32 = 0.0;
    let width = lineWidth;
    
    // Sample in a square pattern around the pixel
    for (var dy: i32 = -width; dy <= width; dy = dy + 1) {
        for (var dx: i32 = -width; dx <= width; dx = dx + 1) {
            if (dx == 0 && dy == 0) {
                continue;
            }
            let sampleCoord = coord + vec2<i32>(dx, dy);
            if (isSkyPixel(sampleCoord)) {
                // Calculate weight based on distance
                let dist = sqrt(f32(dx * dx + dy * dy));
                let weight = 1.0 - (dist / f32(width + 1));
                edgeWeight = max(edgeWeight, weight);
            }
        }
    }
    
    return edgeWeight;
}

@compute @workgroup_size(8, 8, 1)
fn CsMain(@builtin(workgroup_id) workgroup_id: vec3<u32>, @builtin(global_invocation_id) globalInvocation_id: vec3<u32>) {
    fragCoord = vec2<i32>(globalInvocation_id.xy);
    texSize = textureDimensions(inTex).xy;
    
    if (fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)) {
        return;
    }
    
    let lineWidth = i32(skylineSetting.lineWidth);
    let edgeWeight = detectSkylineEdge(fragCoord, lineWidth);
    
    // Get original color
    let originalColor = textureLoad(inTex, fragCoord, 0);
    
    // Blend with line color based on edge weight and strength
    var finalColor: vec4<f32>;
    if (edgeWeight > 0.0) {
        let blendFactor = edgeWeight * skylineSetting.strength;
        finalColor = vec4<f32>(
            mix(originalColor.rgb, skylineSetting.lineColor.rgb, blendFactor),
            originalColor.a
        );
    } else {
        finalColor = originalColor;
    }
    
    textureStore(outTex, fragCoord, finalColor);
}
`
    );

    let TAACopyTex_cs = (
      /*wgsl*/
      `
    @group(0) @binding(0) var<storage, read_write> preColor : array<vec4<f32>>;
    @group(0) @binding(1) var preColorTex : texture_storage_2d<rgba16float, write>;

    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> coordIndex: i32;
    
    @compute @workgroup_size( 8 , 8 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
      fragCoord = vec2<i32>( globalInvocation_id.xy );
      texSize = textureDimensions(preColorTex).xy;
      if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
          return;
      }
      coordIndex = fragCoord.x + fragCoord.y * i32(texSize.x);
      textureStore(preColorTex, fragCoord , preColor[coordIndex]);
    }
 `
    );

    let TAASharpTex_cs = (
      /*wgsl*/
      `
    struct TAAData{
      preProjMatrix: mat4x4<f32>,
      preViewMatrix: mat4x4<f32>,
      jitterFrameIndex: f32,
      blendFactor: f32,
      sharpFactor: f32,
      sharpPreBlurFactor: f32,
      jitterX: f32,
      jitterY: f32,
      slot0: f32,
      slot1: f32,
    }
    @group(0) @binding(0) var<uniform> taaData: TAAData;
    @group(0) @binding(1) var inTex : texture_2d<f32>;
    @group(0) @binding(2) var outTex : texture_storage_2d<rgba16float, write>;

    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;

    @compute @workgroup_size( 8 , 8 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
      fragCoord = vec2<i32>( globalInvocation_id.xy );
      texSize = textureDimensions(outTex).xy;
      if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
          return;
      }
      
      let c0 = textureLoad(inTex, vec2<i32>(fragCoord.x, fragCoord.y - 1), 0);
      let c1 = textureLoad(inTex, vec2<i32>(fragCoord.x, fragCoord.y + 1), 0);
      let c2 = textureLoad(inTex, vec2<i32>(fragCoord.x - 1, fragCoord.y), 0);
      let c3 = textureLoad(inTex, vec2<i32>(fragCoord.x + 1, fragCoord.y), 0);
      
      var roundColor = (c0 + c1 + c2 + c3) * 0.25;
      let originColor = textureLoad(inTex, fragCoord, 0);
      let blurColor = mix(roundColor, originColor, taaData.sharpPreBlurFactor);
      var oc = (originColor - blurColor * taaData.sharpFactor) / (1.0 - taaData.sharpFactor);
      oc = clamp(oc, vec4<f32>(0.0), oc);
      textureStore(outTex, fragCoord , oc);
    }
`
    );

    let TAA_cs = (
      /*wgsl*/
      `
#include "GlobalUniform"
#include "GBufferStand"

struct TAAData{
  preProjMatrix: mat4x4<f32>,
  preViewMatrix: mat4x4<f32>,
  jitterFrameIndex: f32,
  blendFactor: f32,
  sharpFactor: f32,
  sharpPreBlurFactor: f32,
  jitterX: f32,
  jitterY: f32,
  slot0: f32,
  slot1: f32,
}

@group(0) @binding(2) var<uniform> taaData: TAAData;
@group(0) @binding(3) var<storage, read_write> preColorBuffer : array<vec4<f32>>;
@group(0) @binding(4) var preColorTexSampler : sampler;
@group(0) @binding(5) var preColorTex : texture_2d<f32>;
@group(0) @binding(6) var inTexSampler : sampler;
@group(0) @binding(7) var inTex : texture_2d<f32>;
@group(0) @binding(8) var outTex : texture_storage_2d<rgba16float, write>;

const PI = 3.1415926 ;
const FLT_EPS = 5.960464478e-8;  // 2^-24, machine epsilon: 1 + EPS = 1 (half of the ULP for 1.0f)

var<private> texSize: vec2<u32>;
var<private> fragCoord: vec2<i32>;
var<private> fragUV: vec2<f32>;
var<private> coordIndex: i32;
var<private> color_min: vec4<f32>;
var<private> color_max: vec4<f32>;
var<private> color_avg: vec4<f32>;
var<private> re_proj_uv01: vec2<f32>;

@compute @workgroup_size( 8 , 8 , 1 )
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
  fragCoord = vec2<i32>( globalInvocation_id.xy );
  texSize = textureDimensions(inTex).xy;
  if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
      return;
  }
  useNormalMatrixInv();
  fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1);
  let frame = globalUniform.frame;
  coordIndex = fragCoord.x + fragCoord.y * i32(texSize.x);
  
  let oc = blendColor();
  preColorBuffer[coordIndex] = oc;
  textureStore(outTex, fragCoord , oc);
}

fn blendColor() -> vec4<f32>
{
  var preCoord = fragCoord;
  var mixWeight = 1.0;
  re_proj_uv01 = vec2<f32>(0.0);
  var reProjectionCoord:vec2<f32> = vec2<f32>(fragCoord);
  //var jitterUVOffset = 0.5 * vec2<f32>(taaData.jitterX, -taaData.jitterY);
  if(taaData.jitterFrameIndex > 0.5){
      let gBuffer : GBuffer = getGBuffer(fragCoord);
      var wPos = getWorldPositionFromGBuffer(gBuffer,fragUV) ;
      let roughness = getRoughnessFromGBuffer(gBuffer);
      let ndc = taaData.preProjMatrix * (taaData.preViewMatrix * vec4<f32>(wPos.xyz, 1.0));
      re_proj_uv01 = vec2<f32>(ndc.x, -ndc.y) / ndc.w;
      re_proj_uv01 = (re_proj_uv01 + 1.0) * 0.5;
      
      if(roughness > 0.0 && re_proj_uv01.x >= 0.0 && re_proj_uv01.x <= 1.0 && re_proj_uv01.y >= 0.0 && re_proj_uv01.y <= 1.0){
          mixWeight = taaData.blendFactor;
          //reProjectionCoord = re_proj_uv01 + jitterUVOffset;
          reProjectionCoord.x = re_proj_uv01.x * f32(texSize.x - 1);
          reProjectionCoord.y = re_proj_uv01.y * f32(texSize.y - 1);
          preCoord = vec2<i32>(reProjectionCoord);
      }else{ 
          //outside of screen
          mixWeight = 1.0;
      }
  }
  
  var curUV01 = fragUV;
  //curUV01 += jitterUVOffset;
  
  let curColor = textureSampleLevel(inTex, inTexSampler, curUV01, 0.0);
  
  let preIndex = preCoord.x + preCoord.y * i32(texSize.x);
  var preColor = textureSampleLevel(preColorTex, preColorTexSampler, re_proj_uv01, 0.0);
  
  //minmax9(fragCoord);
  minmax4(fragCoord);
  
  preColor = clip_aabb(color_min.xyz, color_max.xyz, color_avg, preColor);
  var outColor = mix(preColor, curColor, mixWeight);
  return outColor;
}

fn clampCoord(coord0:vec2<i32>) -> vec2<i32>{
  return clamp(coord0, vec2<i32>(0), vec2<i32>(texSize - 1));
}

fn minmax4(coord:vec2<i32>) {
      let uv0 = clampCoord(vec2<i32>(coord.x - 1, coord.y));
      let uv1 = clampCoord(vec2<i32>(coord.x, coord.y - 1));
      let uv2 = clampCoord(vec2<i32>(coord.x, coord.y + 1));
      let uv3 = clampCoord(vec2<i32>(coord.x + 1, coord.y));
      
      let c0 = textureLoad(inTex, uv0, 0);
      let c1 = textureLoad(inTex, uv1, 0);
      let c2 = textureLoad(inTex, uv2, 0);
      let c3 = textureLoad(inTex, uv3, 0);
      
      color_min = min(c0, min(c1, min(c2, c3)));
      color_max = max(c0, max(c1, max(c2, c3)));
      color_avg = (c0 + c1 + c2 + c3) * 0.25;
  }
  
 fn minmax9(coord:vec2<i32>) {
      let uv0 = clampCoord(vec2<i32>(coord.x - 1, coord.y - 1));
      let uv1 = clampCoord(vec2<i32>(coord.x - 1, coord.y));
      let uv2 = clampCoord(vec2<i32>(coord.x - 1, coord.y + 1));
      let uv3 = clampCoord(vec2<i32>(coord.x, coord.y - 1));
      let uv4 = clampCoord(vec2<i32>(coord.x, coord.y));
      let uv5 = clampCoord(vec2<i32>(coord.x, coord.y + 1));
      let uv6 = clampCoord(vec2<i32>(coord.x + 1, coord.y - 1));
      let uv7 = clampCoord(vec2<i32>(coord.x + 1, coord.y));
      let uv8 = clampCoord(vec2<i32>(coord.x + 1, coord.y + 1));
      
      let ctl = textureLoad(inTex, uv0, 0);
      let ctc = textureLoad(inTex, uv1, 0);
      let ctr = textureLoad(inTex, uv2, 0);
      let cml = textureLoad(inTex, uv3, 0);
      let cmc = textureLoad(inTex, uv4, 0);
      let cmr = textureLoad(inTex, uv5, 0);
      let cbl = textureLoad(inTex, uv6, 0);
      let cbc = textureLoad(inTex, uv7, 0);
      let cbr = textureLoad(inTex, uv8, 0);
      
      color_min = min(ctl, min(ctc, min(ctr, min(cml, min(cmc, min(cmr, min(cbl, min(cbc, cbr))))))));
      color_max = max(ctl, max(ctc, max(ctr, max(cml, max(cmc, max(cmr, max(cbl, max(cbc, cbr))))))));
      color_avg = (ctl + ctc + ctr + cml + cmc + cmr + cbl + cbc + cbr) / 9.0;
  }
  
  fn clip_aabb(aabb_max:vec3<f32>, aabb_min:vec3<f32>, color_avg:vec4<f32>, input_texel:vec4<f32>) -> vec4<f32>
  {
      var p_clip:vec3<f32> = 0.5 * (aabb_max + aabb_min);
      var e_clip:vec3<f32> = 0.5 * (aabb_max - aabb_min) + FLT_EPS;
      var v_clip:vec4<f32> = input_texel - vec4<f32>(p_clip, color_avg.w);
      var v_unit:vec3<f32> = v_clip.xyz / e_clip;
      var a_unit:vec3<f32> = abs(v_unit);
      var ma_unit:f32 = max(a_unit.x, max(a_unit.y, a_unit.z));

      if (ma_unit > 1.0){
          return vec4<f32>(p_clip, color_avg.w) + v_clip / ma_unit;
      }else{
          return input_texel;
      }
  }`
    );

    let VolumetricFog_cs = (
      /*wgsl*/
      `
    #include "GlobalUniform"
    #include "GBufferStand"
    #include "LightData"

    const PI: f32 = 3.1415926;

    struct FogSettings {
        density: f32,
        scatteringIntensity: f32,
        anisotropy: f32,        // Henyey-Greenstein g, [-0.99, 0.99]
        maxDistance: f32,
        stepCount: f32,
        ambientR: f32,
        ambientG: f32,
        ambientB: f32,
    };

    @group(0) @binding(2) var<uniform> fogSettings: FogSettings;
    @group(0) @binding(3) var<storage, read> lightBuffer: array<LightData>;
    @group(0) @binding(4) var inTex: texture_2d<f32>;
    @group(0) @binding(5) var outTex: texture_storage_2d<rgba16float, write>;

    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> fragUV: vec2<f32>;
    var<private> gBuffer: GBuffer;

    // Henyey-Greenstein phase function. cosTheta is the cosine of the
    // angle between the view ray and the light direction.
    fn henyeyGreenstein(cosTheta: f32, g: f32) -> f32 {
        let g2 = g * g;
        let denom = 1.0 + g2 - 2.0 * g * cosTheta;
        return (1.0 - g2) / (4.0 * 3.1415926 * pow(max(denom, 1e-6), 1.5));
    }

    fn findFirstDirLightIndex() -> i32 {
        // 8 matches the ShadowCommon dirCount const (avoid the include
        // since it pulls shadowMap bindings we don't need here).
        for (var i: i32 = 0; i < 8; i = i + 1) {
            let ldx = globalUniform.shadowLights[u32(i) / 4u][u32(i) % 4u];
            if (ldx >= 0.0) { return i32(ldx); }
        }
        return -1;
    }

    @compute @workgroup_size(8, 8, 1)
    fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
        fragCoord = vec2<i32>(gid.xy);
        texSize = textureDimensions(inTex).xy;
        if (fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)) { return; }
        fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1u);

        let oc = textureLoad(inTex, fragCoord, 0);
        gBuffer = getGBuffer(fragCoord);
        useNormalMatrixInv();

        // Reconstruct view-ray direction at this UV
        let camPos = globalUniform.CameraPos.xyz;
        let worldPosOnSurface = getWorldPositionFromGBuffer(gBuffer, fragUV);
        let viewRay = worldPosOnSurface - camPos;
        let rayLen = min(length(viewRay), fogSettings.maxDistance);
        let rayDir = select(vec3<f32>(0.0, 0.0, 1.0), viewRay / max(length(viewRay), 1e-4), length(viewRay) > 1e-4);

        // Pick the dominant directional light for shadow + scattering.
        let lightIdx = findFirstDirLightIndex();
        var lightDir = vec3<f32>(0.0, -1.0, 0.0);
        var lightColor = vec3<f32>(0.0);
        if (lightIdx >= 0) {
            let light = lightBuffer[u32(lightIdx)];
            lightDir = light.direction;
            lightColor = light.lightColor.rgb * light.intensity;
        }
        let toLight = normalize(-lightDir);
        let cosTheta = dot(rayDir, toLight);
        let phase = henyeyGreenstein(cosTheta, fogSettings.anisotropy);

        // Ray march. Jitter start to break banding.
        let stepCount = i32(clamp(fogSettings.stepCount, 8.0, 128.0));
        let stepLen = rayLen / f32(stepCount);
        let jitter = fract(sin(dot(fragUV, vec2<f32>(12.9898, 78.233))) * 43758.5453);

        var scattering = vec3<f32>(0.0);
        var transmittance: f32 = 1.0;
        let ambient = vec3<f32>(fogSettings.ambientR, fogSettings.ambientG, fogSettings.ambientB);

        for (var s: i32 = 0; s < stepCount; s = s + 1) {
            let t = (f32(s) + jitter) * stepLen;
            let samplePos = camPos + rayDir * t;
            // Beer-Lambert: density along step.
            let stepTransmittance = exp(-fogSettings.density * stepLen);

            // In-scattering = phase * lightColor * density (sun term).
            // CSM shadow sampling along the march is on the upgrade path
            // for this shader — wiring shadowMap2DArray + comparison
            // sampler into a compute pipeline is straightforward but
            // adds ~5 bindings + matrix lookups + cascade selection;
            // deferred to keep MVP small. The phase function already
            // biases scattering toward the sun direction so god-ray
            // shafts read correctly when looking near the light.
            let inscatter = (phase * lightColor + ambient) * fogSettings.density * stepLen;
            scattering = scattering + inscatter * transmittance * fogSettings.scatteringIntensity;
            transmittance = transmittance * stepTransmittance;
            if (transmittance < 0.01) { break; }
        }

        // Composite directly into output: sceneColor scaled by
        // transmittance + emitted scattering. Equivalent to
        // mix(scattering, sceneColor, transmittance).
        let outRGB = oc.rgb * transmittance + scattering;
        textureStore(outTex, fragCoord, vec4<f32>(outRGB, oc.a));
    }
`
    );

    let Combine_cs = (
      /* wgsl */
      `
    #include "GlobalUniform"
    #include "BitUtil"
    #include 'ColorUtil_frag'
    #include 'GBufferStand'

    struct FrameBuffer{
        frameCount : f32 ,
        indirectIns : f32 ,
        delay : f32 ,
        colorIns : f32 ,
        d1 : f32 ,
        d2 : f32 ,
        d3 : f32 ,
        d4 : f32 ,
    }
    

    // @group(0) @binding(0) var inputATexture : texture_2d<f32>;
    // @group(0) @binding(1) var inputATextureSampler : sampler;
    @group(0) @binding(2) var inputBTexture : texture_2d<f32>;
    @group(0) @binding(3) var inputBTextureSampler : sampler;
    
    @group(0) @binding(4) var outTexture : texture_storage_2d<rgba16float, write>;
    @group(0) @binding(5) var<storage,read> updateBuffer: FrameBuffer ;

    var<private> fragCoord:vec2<u32>;

    const PI = 3.1415926 ;
    
    @compute @workgroup_size( 16 , 16 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        fragCoord = globalInvocation_id.xy;
        let textsize = vec2f(textureDimensions(inputBTexture).xy);
        let size = vec2f(textureDimensions(outTexture).xy);
        let inputUV = vec2f(fragCoord) / size ;
        let inputUV2 = vec2<i32>(inputUV * textsize) ;

        let time = globalUniform.time ;

        let gBuffer = getGBuffer(vec2i(fragCoord));
        let b = textureSampleLevel( inputBTexture, inputBTextureSampler, inputUV , 0.0 );

        let albedoColor = getAbldeoFromGBuffer(gBuffer) / PI ;
        let bufferColor = getRGBMColorFromGBuffer(gBuffer)  ;
        var colorA = bufferColor.xyz * updateBuffer.colorIns ;
        var color = b.xyz * updateBuffer.indirectIns * albedoColor ;


        // color = LinearToGammaSpace(color);
        // var currentPixel:vec4f = vec4f((colorA.xyz + color.xyz ) , 1.0) ;
        var currentPixel:vec4f = vec4f(colorA.xyz + color , 1.0) ;
        // var currentPixel:vec4f = vec4f(bufferColor , 1.0) ;
        // var currentPixel:vec4f = vec4f(1.0,0.0,0.0, 1.0) ;
        textureStore(outTexture, fragCoord , currentPixel );
    }

  

`
    );

    let Denoising_cs = (
      /* wgsl */
      `
    // #include "GlobalUniform"

    struct FrameBuffer{
        frameCount : f32 ,
        indirectIns : f32 ,
        delay : f32 ,
        frameCount4 : i32 ,
    }
    
    @group(0) @binding(1) var<storage,read_write> updateBuffer: FrameBuffer ;
    @group(0) @binding(2) var newTexture : texture_2d<f32>;
    @group(0) @binding(3) var oldTexture : texture_2d<f32>;
    @group(0) @binding(4) var combineTexture : texture_storage_2d<rgba16float, write>;
    var<private> fragCoord:vec2<u32>;
    
    @compute @workgroup_size( 16 , 16 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        fragCoord = globalInvocation_id.xy;

        // if(updateBuffer.frameCount < 256){
            let newPixel = textureLoad( newTexture, fragCoord, 0 );
            let oldPixel = textureLoad( oldTexture, fragCoord, 0 );
    
            let weight = updateBuffer.delay ;
            var currentPixel:vec4f;
            currentPixel = vec4f(newPixel.xyz * weight + (1.0-weight) * oldPixel.xyz , 1.0 );
            textureStore(combineTexture, fragCoord , currentPixel );
    }

  

`
    );

    let TestComputeLoadBuffer = (
      /* wgsl */
      `
    #include "GlobalUniform"
    #include "MathShader"
    #include "FastMathShader"
    #include "BitUtil"
    #include "ColorUtil_frag"
    #include "GBufferStand"

    struct Uniform{
        state:i32,
        state1:i32,
        state2:i32,
        state3:i32,
    }

    @group(0) @binding(auto) var outputTexture : texture_storage_2d<rgba16float, write>;
    @group(0) @binding(auto) var reflectionsGBufferTexture : texture_2d<f32>;
    @group(0) @binding(auto) var currentRenderTexture : texture_2d<f32>;
    @group(0) @binding(auto) var envMap : texture_2d<f32>;
    @group(0) @binding(auto) var<uniform> uniformData : Uniform;
    
    var<private> fragCoord:vec2<u32>;
    var<private> screenSize:vec2<u32>;
    var<private> fragColor:vec4f;
    const PI = 3.1415926 ;
    
    var<private> colorSet : array<vec3<f32>, 9> = array<vec3<f32>, 9>(
        vec3<f32>(1.0, 0.0, 0.0),
        vec3<f32>(1.0, 0.5, 0.0),
        vec3<f32>(0.5, 1.0, 0.0),
        vec3<f32>(0.0, 1.0, 0.0),
        vec3<f32>(0.0, 1.0, 0.5),
        vec3<f32>(0.0, 0.5, 1.0),
        vec3<f32>(0.0, 0.0, 1.0),
        vec3<f32>(0.5, 0.0, 1.0),
        vec3<f32>(1.0, 0.0, 0.5)
    );

    @compute @workgroup_size( 16 , 16 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        
        fragCoord = globalInvocation_id.xy;
        screenSize = vec2u(textureDimensions(outputTexture));

        useNormalMatrixInv();

        let color = textureLoad(currentRenderTexture, fragCoord , 0);
        fragColor = color ;

        var outPixel:vec3f ;
        var a = globalUniform.time ;

        var state = uniformData.state ;
        //render normal color
        let gBuffer : GBuffer = getGBuffer( vec2i(fragCoord) );
        switch (state) {
            case 0:{
                break;
            }
            case 1:{
                fragColor = vec4f(getAbldeoFromGBuffer(gBuffer).rgb,1.0) ;
                break;
            }
            case 2:{
                fragColor = vec4f(getViewNormalFromGBuffer(gBuffer),1.0) ;
                break;
            }
            case 3:{
                fragColor = vec4f(getWorldNormalFromGBuffer(gBuffer),1.0) ;
                break;
            }
            case 4:{
                fragColor = vec4f(vec3f(getRoughnessFromGBuffer(gBuffer)),1.0) ;
                break;
            }
            case 5:{
                fragColor = vec4f(vec3f(getMetaillicFromGBuffer(gBuffer)),1.0) ;
                break;
            }    
            case 6:{
                fragColor = vec4f(vec3f(getAlphaFromGBuffer(gBuffer)),1.0) ;
                break;
            }
            case 7:{
                let id = (f32(getIDFromGBuffer_i32(gBuffer)) * f_r22g8.r) % 9.0;
                fragColor = vec4f(colorSet[u32(id)],1.0) ;
                break;
            }
            
            default:{
                break;
            }
        }

        let size = f32(uniformData.state1) ; 
        let renderRec1 = vec4f(0.0,0.0,size,size);
        renderBufferToViewPort(reflectionsGBufferTexture,renderRec1);

        let size2 = f32(uniformData.state2) ; 
        let renderRec2 = vec4f(0.0,size,size2,size2);
        renderColorBufferToViewPort(envMap,renderRec2);
      
        //not chage final color out put 
        textureStore(outputTexture, fragCoord , fragColor );
    }

    fn renderBufferToViewPort( texture:texture_2d<f32> , viewRectangle:vec4f) {
        let size = vec2f(textureDimensions(texture));
        let f32FragCoord = vec2f(fragCoord);
        if(insideRectangle(f32FragCoord,viewRectangle)){
            let uv = clipViewUV(viewRectangle,size,f32FragCoord);
            let gBuffer = textureGBuffer(texture,uv);
            let color = getRGBMColorFromGBuffer(gBuffer);
            fragColor = vec4f(color,1.0); 
        }
    }

    fn renderColorBufferToViewPort( texture:texture_2d<f32> , viewRectangle:vec4f) {
        let size = vec2f(textureDimensions(texture));
        let f32FragCoord = vec2f(fragCoord);
        if(insideRectangle(f32FragCoord,viewRectangle)){
            let uv = clipViewUV(viewRectangle,size,f32FragCoord);
            let color = textureLoad(texture, uv , 0).rgb;
            fragColor = vec4f(color,1.0); 
        }
    }

    fn textureGBuffer( texture:texture_2d<f32> , fragCoord:vec2u ) -> GBuffer {
        let bufferTex = textureLoad(texture, fragCoord , 0) ;
        var gBuffer:GBuffer ;
        gBuffer.x = bufferTex.x ;
        gBuffer.y = bufferTex.y ;
        gBuffer.z = bufferTex.z ;
        gBuffer.w = bufferTex.w ;
        return gBuffer ;
    }

 
`
    );

    let textureCompress = (colorMap, sourceTexture, destTexture, workX, workY, workZ = 1) => {
      let begin = 0;
      let bindInputTexture = "";
      let preG = "";
      preG += /* wgsl */
      `
        fn acesFilm( x:vec3f) -> vec3f {
            return clamp((x*(2.51*x+vec3f(0.03)))/(x*(2.43*x+vec3f(0.59))+vec3f(0.14)),vec3f(0.0),vec3f(1.0));
        }
    `;
      for (let i = 0; i < sourceTexture.length; i++) {
        sourceTexture[i];
        let inTextureName = `source${i}Map`;
        let inTextureSamplerName = `source${i}MapSampler`;
        bindInputTexture += /* wgsl */
        `
            @group(0) @binding(${(begin + i) * 2 + 0}) var ${inTextureName} : texture_2d<f32>;

            @group(0) @binding(${(begin + i) * 2 + 1}) var ${inTextureSamplerName} : sampler;
        `;
        preG += GaussBlur(`GaussBlur_${inTextureName}_1`, inTextureName, inTextureSamplerName);
        preG += GaussBlur(`GaussBlur_${inTextureName}_0`, inTextureName, inTextureSamplerName);
      }
      begin += sourceTexture.length;
      let bindOutputTexture = "";
      for (let i = 0; i < destTexture.length; i++) {
        bindOutputTexture += /* wgsl */
        `@group(0) @binding(${(begin + i) * 2 + 0}) var dest${i}Map : texture_storage_2d<rgba16float, write>;
`;
      }
      let loadMainColor = "";
      if (colorMap) {
        begin += destTexture.length;
        bindInputTexture += /* wgsl */
        `@group(0) @binding(${begin * 2 + 0}) var colorMap : texture_2d<f32>;

       
        `;
        loadMainColor += /* wgsl */
        `
            mainColor = textureLoad( colorMap ,fragCoord, 0) ;
        `;
      }
      let compute_workgroup_size = (
        /* wgsl */
        `@compute @workgroup_size(${workX}, ${workY},${workZ})`
      );
      let copyTexture = copyToTexture(sourceTexture.length, colorMap ? true : false);
      let compute_shader = (
        /* wgsl */
        `
        ${GaussWeight2D}
        ${CalcUV_01}
        ${bindInputTexture}
        ${bindOutputTexture}
        ${preG}
        
        var<private> fragCoord: vec2<i32>;
        var<private> texSize: vec2<u32>;

        var<private> mainColor: vec4f;

        ${compute_workgroup_size}
        fn CsMain(@builtin(global_invocation_id) globalInvocation_id : vec3<u32>){
            fragCoord = vec2<i32>( globalInvocation_id.xy );
            texSize = textureDimensions(dest0Map).xy;
            if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
                return;
            }
            
            ${loadMainColor}

            ${copyTexture}
        }
    `
      );
      return compute_shader;
    };
    let copyToTexture = (len, combineMainColor) => {
      let code = ``;
      for (let i = 0; i < len; i++) {
        code += upSample(`GaussBlur_source${i}Map`, `dest${i}Map`, combineMainColor);
      }
      return code;
    };
    let upSample = (funName, outeTextureName, combineMainColor) => {
      let code = (
        /* wgsl */
        `
        var color = vec4<f32>(0.0, 0.0, 0.0, 1.0);
        var uv = CalcUV_01(fragCoord, texSize);
        
        // half stride
        let prev_stride = vec2<f32>(0.5) / vec2<f32>(f32(texSize.x), f32(texSize.y));
        let curr_stride = vec2<f32>(1.0) / vec2<f32>(f32(texSize.x), f32(texSize.y));

        let rgb1 = ${funName}_1(uv, i32(1), prev_stride, 1.0);
        let rgb2 = ${funName}_0(uv, i32(1), curr_stride, 1.0);
        color = vec4<f32>((rgb1 + rgb2) * 0.5 , color.w) ;
        // color *= 3.1415926 ;
        color = vec4f(pow(acesFilm(max(vec3f(0.),color.xyz)),vec3f(0.45)),1.) * 0.5  ;   
        ${combineMainColor ? "color = (color + mainColor) ;" : ""}
        // color = color / (1.0+color) * 2.0 ;
        textureStore(${outeTextureName}, fragCoord, color );
    `
      );
      return code;
    };
    let CalcUV_01 = (
      /*wgsl*/
      `
  fn CalcUV_01(coord:vec2<i32>, texSize:vec2<u32>) -> vec2<f32>
  {
    let u = (f32(coord.x) + 0.5) / f32(texSize.x);
    let v = (f32(coord.y) + 0.5) / f32(texSize.y);
    return vec2<f32>(u, v);
  }
`
    );
    let GaussWeight2D = (
      /*wgsl*/
      `
fn GaussWeight2D(x:f32, y:f32, sigma:f32) -> f32
  {
      let PI = 3.14159265358;
      let E  = 2.71828182846;
      let sigma_2 = pow(sigma, 2);
  
      let a = -(x*x + y*y) / (2.0 * sigma_2);
      return pow(E, a) / (2.0 * PI * sigma_2);
  }
`
    );
    let GaussBlur = function(GaussNxN, inTex, inTexSampler) {
      var code = (
        /*wgsl*/
        `
  
  fn ${GaussNxN}(uv:vec2<f32>, n:i32, stride:vec2<f32>, sigma:f32) -> vec3<f32>
  {
      var color = vec3<f32>(0.0);
      let r:i32 = n / 2;
      var weight:f32 = 0.0;
  
      for(var i:i32=-r; i<=r; i+=1)
      {
          for(var j=-r; j<=r; j+=1)
          {
              let w = GaussWeight2D(f32(i), f32(j), sigma);
              var coord:vec2<f32> = uv + vec2<f32>(f32(i), f32(j)) * stride;
              // color += tex2D(tex, coord).rgb * w;
              color += textureSampleLevel(${inTex}, ${inTexSampler}, coord, 0.0).xyz * w;
              weight += w;
          }
      }
  
      color /= weight;
      return color;
  }`
      );
      return code;
    };

    let tw = (
      /* wgsl */
      `

    @group(0) @binding(1) var inputTexture : texture_2d<f32>;
    @group(0) @binding(2) var outputTexture : texture_storage_2d<rgba16float, write>;

    // @group(0) @binding(3) var posTexture : texture_2d<f32>;
    // @group(0) @binding(4) var normalTexture : texture_2d<f32>;
    // @group(0) @binding(5) var colorTexture : texture_2d<f32>;

    var<private> fragCoord:vec2<u32>;
    // var<private> wPosition: vec4<f32>;
    // var<private> wNormal: vec4<f32>;
    // var<private> wColor: vec4<f32>;
    
    // var<private> finalMatrix: mat4x4<f32>;
    // var<private> ORI_NORMALMATRIX: mat3x3<f32>;

    
    @compute @workgroup_size( 16 , 16 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        fragCoord = globalInvocation_id.xy;

        wColor = textureLoad(colorTexture, fragCoord , 0);
      

        finalMatrix = globalUniform.projMat * globalUniform.viewMat ;
        let nMat = mat3x3<f32>(finalMatrix[0].xyz,finalMatrix[1].xyz,finalMatrix[2].xyz) ;
        ORI_NORMALMATRIX = transpose(inverse( nMat ));

        wPosition = textureLoad(posTexture, fragCoord, 0);
        wNormal = textureLoad(normalTexture, fragCoord, 0);
        var VPPos = (finalMatrix * vec4f(wPosition.xyz,1.0)).xyz ;
        var VPNormal = normalize(ORI_NORMALMATRIX * wNormal.xyz) ;

        var LastPixel = textureLoad(inputTexture,fragCoord,0);

        var NewPixel:vec4f = wColor ;
        var NewRadius = max(1.,ceil(1.99-LastPixel.w*0.25));
        var RadiusCoeff = max(1.,2.25-LastPixel.w*0.25);
        if (NewRadius>0.5) {
            var NewWeight = 1.;
            for (var x=-NewRadius; x<NewRadius+0.5; x+=1.0) {
                for (var y=-NewRadius; y<NewRadius+0.5; y+=1.0) {
                    var SUV:vec2f = vec2f(fragCoord)+vec2f(x,y)*RadiusCoeff;
                    if (x*x+y*y<0.01) {
                        continue;
                    }

                    var SVPos:vec3f = textureLoad(posTexture, vec2<u32>(SUV), 0);
                    var SVNormal:vec3f = textureLoad(posTexture, vec2<u32>(SUV), 0).xyz * 2.0 - 1.0;
                    var SWeight = max(0.0001,float(dot(Normal,SVPos-VPPos)<0.01))*
                                    max(0.01,float(dot(Normal,normalize(SVNormal))>0.9));
                    NewPixel += texture(iChannel1,SUV*IRES) * SWeight;
                    NewWeight += SWeight;
                }
            }
            NewPixel /= NewWeight;
        }
    }

`
    );

    let FrustumCulling_cs = (
      /*wgsl*/
      `
#include "GlobalUniform"

struct RenderBound{
    index:f32,
}

struct Uniforms {
    matrix : array<mat4x4<f32>>
};

//@group(0) @binding(0) var<uniform> globalUniform: GlobalUniform;
@group(0) @binding(1) var<storage, read> models : Uniforms;
@group(0) @binding(2) var<storage, read> planes: array<vec4<f32>,7>;
@group(0) @binding(3) var<storage, read> cullingList: array<RenderBound>;
@group(0) @binding(4) var<storage,read_write> outBuffer: array<f32>;


var<private> boundPoints : array<vec4<f32>,8> ;   

fn IsInClipSpace( coord : vec4<f32> ) -> bool {
    return -coord.w <= coord.x && coord.x <= coord.w
        && -coord.w <= coord.y && coord.y <= coord.w
        && -coord.w <= coord.z && coord.z <= coord.w;
}

fn IsOutsideThePlane( plane: vec4<f32>, pointPosition : vec3<f32> ) -> bool{
    if(dot(plane.xyz, pointPosition) + plane.w > 0.0){
        return true;
    }
    return false;
}

fn containsBox( size:vec3<f32> , center:vec3<f32> ) -> f32 {
    var c = 0.0 ;
    var d = 0.0 ;

    var r = max(size.x, size.y);
    var sr = max(r , size.z);
    var scx = center.x;
    var scy = center.y;
    var scz = center.z;

    for(var p:i32 = 0; p < 6 ; p = p + 1 ){
        var plane = planes[p];
        d = plane.x * scx + plane.y * scy + plane.z * scz + plane.w;
        if (d <= -sr) {
        return 0.0;
        }
        if (d > sr) {
        c+=1.0;
        }
    }

    if( c >= 6.0 ){
        return 2.0 ;
    }else{
        return 1.0 ;
    }
}

@compute @workgroup_size( 128 )
fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
{
    let id = globalInvocation_id.x ;
    if(id + 1u > u32(planes[6].x) ){
        outBuffer[id] = f32(0.0); 
        return ;
    }

    let renderBound = cullingList[id];
    let boundID = i32(renderBound.index) ;
    var plane = planes[0];

    let worldMatrix = models.matrix[boundID];
    let projMat = globalUniform.projMat ;

    let const_boundMin : vec3<f32> = vec3<f32>(-0.5,-0.5,-0.5) ;   
    let const_boundMax : vec3<f32> = vec3<f32>(0.5,0.5,0.5) ;   

    let boundMin = worldMatrix * vec4<f32>(const_boundMin, 1.0);
    let boundMax = worldMatrix * vec4<f32>(const_boundMax, 1.0);

    let size = abs( boundMax.xyz - boundMin.xyz ) * 0.65 ;
    let center = worldMatrix[3].xyz ;

    var isIn :f32 = 0.0 ;

    isIn = containsBox(size,center);

    outBuffer[id] = f32(isIn); 
}
`
    );

    let ZPassShader_cs = (
      /*wgsl*/
      `
    @group(0) @binding(0) var<storage,read_write> visibleBuffer: array<f32>;
    @group(0) @binding(1) var zBufferTexture : texture_2d<f32>;

    @compute @workgroup_size(8, 8, 1)
    fn CsMain( @builtin(global_invocation_id) globalInvocation_id : vec3<u32> ) {
        var fragCoord = vec2<i32>( globalInvocation_id.xy );
        let md = textureLoad(zBufferTexture,fragCoord,0);

        let meshID = i32(floor( md.w + 0.1 ));
        if (meshID >= 0) {
            visibleBuffer[meshID] = 1.0 ;
        }
    }
`
    );

    let ColorPassFragmentOutput = (
      /*wgsl*/
      `
    struct FragmentOutput {
        @location(auto) color: vec4<f32>,
        #if USE_WORLDPOS
            @location(auto) worldPos: vec4<f32>,
        #endif
        #if USEGBUFFER
            @location(auto) worldNormal: vec4<f32>,
            @location(auto) material: vec4<f32>,
        #endif

        #if USE_OUTDEPTH
            @builtin(frag_depth) out_depth: f32
        #endif
    };
`
    );

    let VertexAttributeIndexShader = (
      /*wgsl*/
      `
    #include "WorldMatrixUniform"
    struct VertexAttributes{
        @builtin(instance_index) index : u32,

        @location(auto) position: vec3<f32>,
        @location(auto) normal: vec3<f32>,
        @location(auto) uv: vec2<f32>,
        @location(auto) TEXCOORD_1: vec2<f32>,
        @location(auto) vIndex: f32,
        @location(auto) index2: f32,
        
    }

    struct VertexOutput {
        @location(auto) @interpolate(flat) index: f32,
        @location(auto) varying_UV0: vec2<f32>,
        @location(auto) varying_UV1: vec2<f32>,
        @location(auto) varying_ViewPos: vec4<f32>,
        @location(auto) varying_Clip: vec4<f32>,
        @location(auto) varying_WPos: vec4<f32>,
        @location(auto) varying_WNormal: vec3<f32>,
        @location(auto) varying_Color: vec4<f32>,
        #if USE_SHADOWMAPING
            @location(auto) varying_ShadowPos: vec4<f32>,
        #endif
        @builtin(position) member: vec4<f32>
    };

    struct TransformVertex{
        position:vec3<f32>,
        normal:vec3<f32>,
    }

    struct GraphicNodeStruct{
        matrixIndex:f32,
        texIndex:f32,
        tex2Index:f32,
        tex3Index:f32,

        fillRotation:f32,
        empty0:f32,
        empty1:f32,
        empty2:f32,

        baseColor:vec4f,
        lineColor:vec4f,
        emissiveColor:vec4f,
        uvRect:vec4f,
        uvRect2:vec4f,
        uvSpeed:vec4f,
    }

    var<private> ORI_VertexOut: VertexOutput ;
    var<private> worldMatrix: mat4x4<f32> ;
    var<private> graphicNode: GraphicNodeStruct ;

    fn ORI_Vert(vertex:VertexAttributes){
        var vertexPosition = vertex.position;
        var vertexNormal = vertex.normal;

        ORI_VertexOut.index = f32(vertex.vIndex) ;
        graphicNode = graphicBuffer[u32(round(vertex.vIndex))];
        let node_Matrix_M = models.matrix[u32(round(graphicNode.matrixIndex))];

        #if USE_TANGENT
            ORI_VertexOut.varying_Tangent = vertex.TANGENT ;
        #endif

        ORI_MATRIX_M = node_Matrix_M * ORI_MATRIX_M ;

        #if USE_BILLBOARD
            let billboardMatrix: mat3x3<f32> = calculateBillboardMatrix2(globalUniform.CameraPos.xyz,ORI_MATRIX_M[3].xyz,globalUniform.cameraWorldMatrix[1].xyz);
            vertexPosition = billboardMatrix * vertexPosition.xyz;
        #endif

        worldMatrix = ORI_MATRIX_M ;

        let nMat = mat3x3<f32>(ORI_MATRIX_M[0].xyz,ORI_MATRIX_M[1].xyz,ORI_MATRIX_M[2].xyz) ;
        ORI_NORMALMATRIX = transpose(inverse( nMat ));

        var worldPos = (ORI_MATRIX_M * vec4<f32>(vertexPosition.xyz, 1.0));

        #if TRANSFORMVERTEX
            var transformVertex = transformVertex(worldPos.xyz,vertexNormal,vertex);
            worldPos = vec4<f32>(transformVertex.position ,worldPos.w);
            vertexNormal = transformVertex.normal ;
        #endif

        var viewPosition = ORI_MATRIX_V * worldPos;
        var clipPosition = ORI_MATRIX_P * viewPosition ;

        #if USE_LOGDEPTH
            clipPosition.z = log2Depth(clipPosition.w, globalUniform.near, globalUniform.far);
        #endif

        ORI_VertexOut.varying_UV0 = vertex.uv.xy ;
        ORI_VertexOut.varying_UV1 = vertex.TEXCOORD_1.xy;
        ORI_VertexOut.varying_ViewPos = viewPosition ;
        ORI_VertexOut.varying_Clip = clipPosition;
        ORI_VertexOut.varying_WPos = worldPos;
        ORI_VertexOut.varying_WNormal = normalize( vertexNormal.xyz);
        ORI_VertexOut.member = clipPosition ;
    }
`
    );

    let Sky_glsl_vs = `
#version 450
layout(location = 0) in vec3 position;
layout(location = 1) in vec3 normal;
layout(location = 2) in vec2 uv;

layout(location = 0) out vec2 fragUV;
layout(location = 1) out vec4 vWorldPos;
layout(location = 2) out vec3 vWorldNormal;

layout(set = 0, binding = 0) 
uniform ConstUniform {
    mat4 projMat;
    mat4 viewMat;
    mat4 shadowMatrix;
};

layout(set = 1, binding = 0) 
buffer Uniforms {
    mat4[] modeMat;
};

 mat4 inverse( in mat4 m ){
    return mat4(
        m[0][0], m[1][0], m[2][0], 0.0,
        m[0][1], m[1][1], m[2][1], 0.0,
        m[0][2], m[1][2], m[2][2], 0.0,
        -dot(m[0].xyz,m[3].xyz),
        -dot(m[1].xyz,m[3].xyz),
        -dot(m[2].xyz,m[3].xyz),
        1.0 );
}

void main(){
    fragUV = uv;
    mat4 modelMat = modeMat[gl_InstanceID]; 
    mat4 vm = viewMat * modelMat;
	mat3 normalMatrix = mat3(vm[0].xyz,vm[1].xyz,vm[2].xyz);
	vec3 eNormal = normalize( normalMatrix * normal );
    
    vWorldPos = modelMat * vec4(position.xyz,1.0) ;

    mat4 fixedViewMat = viewMat ;
    fixedViewMat[3] = vec4(0.0,0.0,-8.0,1.0);
    vec4 mvPosition = modelMat * vec4( position.xyz, 1.0 );
    gl_Position = projMat * fixedViewMat * mvPosition;
}

`;
    let Sky_glsl_fs = `
#version 450

layout(location = 0) in vec2 fragUV;
layout(location = 1) in vec4 vWorldPos;
layout(location = 2) in vec3 vWorldNormal;

layout(location = 0) out vec4 o_Target;

layout(set = 2, binding = 0) 
uniform sampler baseMapSampler;
layout(set = 2, binding = 1) 
uniform texture2D baseMap;

layout(set = 3, binding = 0) uniform uniformData {
    vec3 eyesPos;
    float exposure;
    float roughness;
};

vec3 LinearToGammaSpace(in vec3 linRGB)
{
    vec3 _linRGB = vec3(linRGB) ;
    _linRGB = max(linRGB, vec3(0.0, 0.0, 0.0));
    _linRGB.r = pow(linRGB.r,0.416666667);
    _linRGB.g = pow(linRGB.g,0.416666667);
    _linRGB.b = pow(linRGB.b,0.416666667);
    return max(1.055 * _linRGB - 0.055, vec3(0.0));
}

void main(){
    int maxMipLevel = textureQueryLevels(baseMap, fragUV).x ;
    vec4 textureColor = textureCubeLod( sampler2D(baseMap, baseMapSampler), normalize(vWorldPos.xyz), roughness * float(maxMipLevel) ) ;
    o_Target = vec4(LinearToGammaSpace(textureColor.rgb),1.0) * exposure ;
}

`;

    let LUT_glsl = `
#version 450

layout(location = 0) in vec2 fragUV;

layout(location = 0) out vec4 o_Target;

layout(set = 0, binding = 0) uniform ConstUniform {
    mat4 projMat;
    mat4 viewMat;
    mat4 shadowMatrix;
    mat4 cameraWorldMatrix ;
    mat4 projMatInv ;
    float frame;
    float time;
    float detail;
    float shadowBias;
    float skyExposure;
    float renderPassState;
    float quadScale;
    float intensity;
};

layout(set = 2, binding = 0) uniform sampler baseMapSampler;
layout(set = 2, binding = 1) uniform texture2D baseMap;

layout(set = 2, binding = 2) uniform sampler lutMapSample;
layout(set = 2, binding = 3) uniform texture2D lutMap;

layout(set = 3, binding = 0) uniform UniformData{
    float intensity ;
};

void main() {
    vec2 uv = fragUV.xy;
    uv.y = 1.0 - uv.y;
    vec4 col = texture(sampler2D(baseMap, baseMapSampler), uv * quadScale);
    // vec3 col = vec3(pow(base.xyz,vec3(1.0/2.2)));

    float Bcolor = col.b * 63.0;
	vec2 quad1;
    quad1.y = floor(floor(Bcolor) / 8.0);
    quad1.x = floor(Bcolor) - (quad1.y * 8.0);

    vec2 quad2;
    quad2.y = floor(ceil(Bcolor) / 8.0);
    quad2.x = ceil(Bcolor) - (quad2.y * 8.0);

    const float tmp = (0.125-(0.5/512.0)) ;
    const float tmp2 = 0.5/512.0 ;

    vec2 uv1;
    vec2 uv2;
	uv1.x = ((quad1.x)*0.125)+ tmp2 + (tmp* col.r);
	uv1.y = (((quad1.y)*0.125) + tmp2 + (tmp* col.g));

	uv2.x = ((quad2.x)*0.125)+ tmp2 + (tmp* col.r);
	uv2.y = (((quad2.y)*0.125)+ tmp2 + (tmp* col.g));

    vec4 color1 = texture(sampler2D(lutMap, lutMapSample), uv1);
    vec4 color2 = texture(sampler2D(lutMap, lutMapSample), uv2);

    vec4 newColor = mix(color1, color2, fract(Bcolor));
    // vec3 outC = pow(newColor.xyz,vec3(2.2));

    o_Target = vec4(newColor.rgb, col.a );
    // o_Target = vec4(1.0);
}
`;

    let ColorLitShader = (
      /*wgsl*/
      `
        #include "Common_vert"
        #include "Common_frag"
        #include "BxDF_frag"

        fn vert(inputData:VertexAttributes) -> VertexOutput {
            ORI_Vert(inputData) ;
            return ORI_VertexOut ;
        }

        fn frag(){
            ORI_ShadingInput.BaseColor = materialUniform.baseColor ;
            ORI_ShadingInput.Roughness = materialUniform.roughness  ;
            ORI_ShadingInput.Metallic = materialUniform.metallic ;
            ORI_ShadingInput.Specular = 0.5 ;
            ORI_ShadingInput.AmbientOcclusion = 1.0 ;
            ORI_ShadingInput.EmissiveColor = vec4<f32>(0.0);

            ORI_ShadingInput.Normal = ORI_VertexVarying.vWorldNormal.rgb ;

            useShadow();

            BxDFShading();
        }
    `
    );

    let GIProbeShader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "UnLit_frag"
    #include "Irradiance_frag"
    #include "MathShader"
    
    struct MaterialUniform {
      probeUniform:vec4<f32>,
    };

    @group(2) @binding(0)
    var<uniform> materialUniform: MaterialUniform;

    var<private> probeID: i32 ;
    var<private> debugType: i32 ;
    
    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        probeID = i32(materialUniform.probeUniform.x);
        debugType = i32(materialUniform.probeUniform.y);
        if(debugType == 0){
            ORI_ShadingInput.BaseColor = debugProbe(probeID);
        }else if(debugType == 1){
            ORI_ShadingInput.BaseColor = getIrradiance();
        }else if(debugType == 2){
            ORI_ShadingInput.BaseColor = debugProbeDepth(probeID);
        }
        UnLit();
    }
    `
    );

    let GlassShader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "UnLit_frag"
    #include "UnLitMaterialUniform_frag"

    // @group(1) @binding(auto)
    // var noes_MapSampler: sampler;
    // @group(1) @binding(auto)
    // var noes_Map: texture_2d<f32>;

    @group(1) @binding(auto)
    var splitTexture_MapSampler: sampler;
    @group(1) @binding(auto)
    var splitTexture_Map: texture_2d<f32>;

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        var screenUV = ORI_VertexVarying.fragPosition.xy / ORI_VertexVarying.fragPosition.w;
        screenUV = (screenUV.xy + 1.0) * 0.5;
        screenUV.y = 1.0 - screenUV.y;

        screenUV.x = clamp(sin(screenUV.x * 1.0),0.0,1.0) ;
        screenUV.y = clamp(sin(screenUV.y * 1.0),0.0,1.0) ;
        // screenUV.y = cos(ORI_VertexVarying.fragPosition.y/7.15);

        let frameMap = textureSample(splitTexture_Map,splitTexture_MapSampler,screenUV);
        // let noesMap = textureSample(noes_Map,noes_MapSampler,screenUV);

        ORI_ShadingInput.BaseColor = vec4<f32>( frameMap.rgb , 1.0) ;
        UnLit();
    }
`
    );

    let Hair_shader_op = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "Hair_frag"

    @group(1) @binding(auto)
    var baseMapSampler: sampler;
    @group(1) @binding(auto)
    var baseMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var idMapSampler: sampler;
    @group(1) @binding(auto)
    var idMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var depthMapSampler: sampler;
    @group(1) @binding(auto)
    var depthMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var rootMapSampler: sampler;
    @group(1) @binding(auto)
    var rootMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var alphaMapSampler: sampler;
    @group(1) @binding(auto)
    var alphaMap: texture_2d<f32>;

    #if USE_CUSTOMUNIFORM
    struct MaterialUniform {
      transformUV1:vec4<f32>,
      transformUV2:vec4<f32>,

      baseColor0: vec4<f32>,
      baseColor1: vec4<f32>,
      emissiveColor: vec4<f32>,
      materialF0: vec4<f32>,
      specularColor: vec4<f32>,
      envIntensity: f32,
      normalScale: f32,
      roughness: f32,
      metallic: f32,

      ao: f32,
      roughness_min: f32,
      roughness_max: f32,
      metallic_min: f32,

      metallic_max: f32,
      emissiveIntensity: f32,
      alphaCutoff: f32,
      ior: f32,

      backlit: f32,
      area: f32,
    };
#endif
    
    var<private> debugOut : vec4f = vec4f(0.0) ;
    var<private> uv : vec2f = vec2f(0.0) ;

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        var transformUV1 = materialUniform.transformUV1;
        var transformUV2 = materialUniform.transformUV2;
        uv = transformUV1.zw * ORI_VertexVarying.fragUV0 + transformUV1.xy; 

        ORI_ShadingInput.Roughness = materialUniform.roughness;
        ORI_ShadingInput.Metallic = materialUniform.metallic;
        

        #if USE_HAIRCOLOR
            let root = textureSample(rootMap, rootMapSampler, uv ).r ;
            ORI_ShadingInput.BaseColor = mix(materialUniform.baseColor0,materialUniform.baseColor1,root)  ;
        #else
            #if USE_SRGB_ALBEDO
                ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
            #else 
                ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
            #endif
        #endif

        fragData.Alpha = 1.0 ;
        #if USE_ALPHA_A
        // fragData.Alpha =  textureSampleLevel(alphaMap, alphaMapSampler, uv , 0.0 ).r ;
            // let shake = (globalUniform.frame % 5.0) / 5.0 * 2.0 ;
            fragData.Alpha =  textureSample(alphaMap, alphaMapSampler, uv ).r ;
        #endif

        #if USE_ALPHACUT 
            if( (fragData.Alpha - materialUniform.alphaCutoff) < 0.0 ){
                #if USEGBUFFER
                    ORI_FragmentOutput.worldPos = vec4<f32>(0.0,0.0,0.0,1.0);
                    ORI_FragmentOutput.worldNormal = vec4<f32>(0.0,0.0,0.0,1.0);
                    ORI_FragmentOutput.material = vec4<f32>(0.0,0.0,0.0,1.0);
                #endif
                discard;
            }
        #endif

        useShadow();

        ORI_ShadingInput.Specular = 1.0 ;

        let idMap = textureSampleLevel(idMap, idMapSampler, uv , 0.0 );
        var hairNormal = HairNormal(idMap.r).rgb ;
        hairNormal = transformHairNormal( hairNormal) ;  
        ORI_ShadingInput.HairNormal = hairNormal ;

        ORI_ShadingInput.Normal = unPackRGNormal(vec3f(0.5,0.5,1.0),1.0,1.0) ;

        ORI_ShadingInput.BaseColor.a = fragData.Alpha;
        
        BSSSRDFShading();
    }
`
    );
    let Hair_shader_tr = (
      /*wgsl*/
      `
#include "Common_vert"
#include "Common_frag"
#include "Hair_frag"

@group(1) @binding(auto)
var baseMapSampler: sampler;
@group(1) @binding(auto)
var baseMap: texture_2d<f32>;

@group(1) @binding(auto)
var idMapSampler: sampler;
@group(1) @binding(auto)
var idMap: texture_2d<f32>;

@group(1) @binding(auto)
var depthMapSampler: sampler;
@group(1) @binding(auto)
var depthMap: texture_2d<f32>;

@group(1) @binding(auto)
var rootMapSampler: sampler;
@group(1) @binding(auto)
var rootMap: texture_2d<f32>;

@group(1) @binding(auto)
var alphaMapSampler: sampler;
@group(1) @binding(auto)
var alphaMap: texture_2d<f32>;

#if USE_CUSTOMUNIFORM
struct MaterialUniform {
  transformUV1:vec4<f32>,
  transformUV2:vec4<f32>,

  baseColor0: vec4<f32>,
  baseColor1: vec4<f32>,
  emissiveColor: vec4<f32>,
  materialF0: vec4<f32>,
  specularColor: vec4<f32>,
  envIntensity: f32,
  normalScale: f32,
  roughness: f32,
  metallic: f32,

  ao: f32,
  roughness_min: f32,
  roughness_max: f32,
  metallic_min: f32,

  metallic_max: f32,
  emissiveIntensity: f32,
  alphaCutoff: f32,
  ior: f32,

  backlit: f32,
  area: f32,
};
#endif

var<private> debugOut : vec4f = vec4f(0.0) ;
var<private> uv : vec2f = vec2f(0.0) ;

fn vert(inputData:VertexAttributes) -> VertexOutput {
    ORI_Vert(inputData) ;
    return ORI_VertexOut ;
}

fn frag(){
    var transformUV1 = materialUniform.transformUV1;
    var transformUV2 = materialUniform.transformUV2;
    uv = transformUV1.zw * ORI_VertexVarying.fragUV0 + transformUV1.xy; 

    ORI_ShadingInput.Roughness = materialUniform.roughness;
    ORI_ShadingInput.Metallic = materialUniform.metallic;

    #if USE_HAIRCOLOR
        let root = textureSample(rootMap, rootMapSampler, uv ).r ;
        ORI_ShadingInput.BaseColor = mix(materialUniform.baseColor0,materialUniform.baseColor1,root)  ;
    #else
        #if USE_SRGB_ALBEDO
            ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
        #else 
            ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
        #endif
    #endif

    fragData.Alpha = 1.0 ;
    #if USE_ALPHA_A
        fragData.Alpha =  textureSampleLevel(alphaMap, alphaMapSampler, uv , 0.0 ).r ;
    #endif

    #if USE_ALPHACUT 
        if( (((1.0 - fragData.Alpha) - (1.0 - materialUniform.alphaCutoff))) < 0.0 ){
            #if USEGBUFFER
                ORI_FragmentOutput.worldPos = vec4<f32>(0.0,0.0,0.0,1.0);
                ORI_FragmentOutput.worldNormal = vec4<f32>(0.0,0.0,0.0,1.0);
                ORI_FragmentOutput.material = vec4<f32>(0.0,0.0,0.0,1.0);
            #endif
            discard;
        }
    #endif

    #if USE_SHADOWMAPING
        useShadow();
    #endif

    ORI_ShadingInput.Specular = 1.0 ;

    let idMap = textureSampleLevel(idMap, idMapSampler, uv , 0.0 );
    var hairNormal = HairNormal(idMap.r).rgb ;
    hairNormal = transformHairNormal( hairNormal) ;  
    ORI_ShadingInput.HairNormal = hairNormal ;

    ORI_ShadingInput.Normal = unPackRGNormal(vec3f(0.5,0.5,1.0),1.0,1.0) ;

    ORI_ShadingInput.BaseColor.a = fragData.Alpha;
    
    BSSSRDFShading();
}
`
    );

    let MirrorShader = (
      /* wgsl */
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "UnLit_frag"
    #include "UnLitMaterialUniform_frag"

    @group(1) @binding(auto)
    var mirrorMap_Sampler: sampler;
    @group(1) @binding(auto)
    var mirrorMap: texture_2d<f32>;

    fn vert(inputData: VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData);
        return ORI_VertexOut;
    }

    fn frag() {
        var ndc = ORI_VertexVarying.fragPosition.xy / ORI_VertexVarying.fragPosition.w;
        var uv = vec2<f32>((1.0 - ndc.x) * 0.5, (1.0 - ndc.y) * 0.5);
        let mirror = textureSample(mirrorMap, mirrorMap_Sampler, uv);
        ORI_ShadingInput.BaseColor = vec4<f32>(mirror.rgb * materialUniform.baseColor.rgb, 1.0);
        UnLit();
    }
`
    );

    let OutlinePass = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "UnLit_frag"

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d<f32>;


    struct MaterialUniform {
        baseColor:vec4<f32>,
        lineWeight:f32
    };

    @group(2) @binding(0)
    var<uniform> materialUniform: MaterialUniform;

    fn vert(vertex:VertexAttributes) -> VertexOutput {
        var vertexPosition = vertex.position;
        var vertexNormal = vertex.normal;

                #if USE_MORPHTARGETS
                    vertexPosition = vertexPosition * morphTargetData.morphBaseInfluence + vertex.a_morphPositions_0 * morphTargetData.morphInfluence0;
                    #if USE_MORPHNORMALS
                        vertexNormal = vertexNormal * morphTargetData.morphBaseInfluence + vertex.a_morphNormals_0 * morphTargetData.morphInfluence0;
                    #endif
                #endif

                #if USE_SKELETON
                    #if USE_JOINT_VEC8
                        let skeletonNormal = getSkeletonWorldMatrix_8(vertex.joints0, vertex.weights0, vertex.joints1, vertex.weights1);
                        ORI_MATRIX_M *= skeletonNormal ;
                        // vertexNormal = vec4<f32>(vec4<f32>(vertexNormal,0.0) * skeletonNormal).xyz; 
                    #else
                        let skeletonNormal = getSkeletonWorldMatrix_4(vertex.joints0, vertex.weights0);
                        ORI_MATRIX_M *= skeletonNormal ;
                        // vertexNormal = vec4<f32>(vec4<f32>(vertexNormal,0.0) * skeletonNormal).xyz; 
                    #endif
                #endif


                #if USE_TANGENT
                    ORI_VertexOut.varying_Tangent = vertex.TANGENT ;
                #endif

                ORI_NORMALMATRIX = transpose(inverse( mat3x3<f32>(ORI_MATRIX_M[0].xyz,ORI_MATRIX_M[1].xyz,ORI_MATRIX_M[2].xyz) ));

                let worldNormal = normalize(ORI_NORMALMATRIX * vertexNormal.xyz) ;

                vertexPosition = vertexPosition + worldNormal * materialUniform.lineWeight ;

                var worldPos = (ORI_MATRIX_M * vec4<f32>(vertexPosition.xyz, 1.0));
                var viewPosition = ORI_MATRIX_V * worldPos;
                var clipPosition = ORI_MATRIX_P * viewPosition ;

                #if USE_LOGDEPTH
                    clipPosition.z = log2Depth(clipPosition.w, globalUniform.near, globalUniform.far);
                #endif

                ORI_VertexOut.varying_UV0 = vertex.uv.xy ;
                ORI_VertexOut.varying_UV1 = vertex.TEXCOORD_1.xy;
                ORI_VertexOut.varying_ViewPos = viewPosition / viewPosition.w;
                ORI_VertexOut.varying_Clip = clipPosition ;
                ORI_VertexOut.varying_WPos = worldPos ;
                ORI_VertexOut.varying_WPos.w = f32(vertex.index);
                ORI_VertexOut.varying_WNormal = worldNormal ;
                ORI_VertexOut.member = clipPosition ;


        return ORI_VertexOut ;
    }

    fn frag(){
        let color = textureSample(baseMap,baseMapSampler,ORI_VertexVarying.fragUV0) ;
        ORI_ShadingInput.BaseColor = color * materialUniform.baseColor ;
        ORI_ShadingInput.Roughness = 0.5  ;
        ORI_ShadingInput.Metallic = 0.5 ;
        ORI_ShadingInput.Specular = 0.5 ;
        ORI_ShadingInput.AmbientOcclusion = 1.0 ;
        ORI_ShadingInput.EmissiveColor = vec4<f32>(0.0);
        ORI_ShadingInput.Normal = ORI_VertexVarying.vWorldNormal.rgb ;
        UnLit();
    }
`
    );

    let PBRLitSSSShader = (
      /*wgsl*/
      `
    #include "Common_vert"
    #include "Common_frag"
    #include "BsDF_frag"

    @group(1) @binding(auto)
    var baseMapSampler: sampler;
    @group(1) @binding(auto)
    var baseMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var normalMapSampler: sampler;
    @group(1) @binding(auto)
    var normalMap: texture_2d<f32>;

    #if USE_CUSTOMUNIFORM
        struct MaterialUniform {
          transformUV1:vec4<f32>,
          transformUV2:vec4<f32>,

          baseColor: vec4<f32>,
          emissiveColor: vec4<f32>,
          materialF0: vec4<f32>,
          specularColor: vec4<f32>,
          envIntensity: f32,
          normalScale: f32,
          roughness: f32,
          metallic: f32,

          ao: f32,
          roughness_min: f32,
          roughness_max: f32,
          metallic_min: f32,

          metallic_max: f32,
          emissiveIntensity: f32,
          alphaCutoff: f32,
          ior: f32,

          clearcoatColor: vec4<f32>,

          clearcoatWeight: f32,
          clearcoatFactor: f32,
          clearcoatRoughnessFactor: f32,
          skinPower: f32,
          
          skinColor: vec4<f32>,
          skinColorIns: f32,
          curveFactor: f32,
        };
    #endif
    // #if USE_ARMC
        // @group(1) @binding(auto)
        // var maskMapSampler: sampler;
        // @group(1) @binding(auto)
        // var maskMap: texture_2d<f32>;
    // #endif

    // #if USE_MR
        @group(1) @binding(auto)
        var maskMapSampler: sampler;
        @group(1) @binding(auto)
        var maskMap: texture_2d<f32>;
    // #endif

    #if USE_AOTEX
        @group(1) @binding(auto)
        var aoMapSampler: sampler;
        @group(1) @binding(auto)
        var aoMap: texture_2d<f32>;
    #endif

    @group(1) @binding(auto)
    var emissiveMapSampler: sampler;
    @group(1) @binding(auto)
    var emissiveMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var sssMapSampler: sampler;
    @group(1) @binding(auto)
    var sssMap: texture_2d<f32>;

    @group(1) @binding(auto)
    var lutMapSampler: sampler;
    @group(1) @binding(auto)
    var lutMap: texture_2d<f32>;

    var<private> debugOut : vec4f = vec4f(0.0) ;

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        var transformUV1 = materialUniform.transformUV1;
        var transformUV2 = materialUniform.transformUV2;

        var uv = transformUV1.zw * ORI_VertexVarying.fragUV0 + transformUV1.xy; 

        #if USE_SRGB_ALBEDO
            ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
            ORI_ShadingInput.BaseColor = vec4f(ORI_ShadingInput.BaseColor.rgb/ORI_ShadingInput.BaseColor.a,ORI_ShadingInput.BaseColor.a)  ;
            ORI_ShadingInput.BaseColor = vec4<f32>(gammaToLiner(ORI_ShadingInput.BaseColor.rgb) * materialUniform.baseColor.rgb, ORI_ShadingInput.BaseColor.w * materialUniform.baseColor.a)  ;
        #else
            ORI_ShadingInput.BaseColor = textureSample(baseMap, baseMapSampler, uv )  ;
            ORI_ShadingInput.BaseColor = vec4f(ORI_ShadingInput.BaseColor.rgb/ORI_ShadingInput.BaseColor.a,ORI_ShadingInput.BaseColor.a)  ;
            ORI_ShadingInput.BaseColor = vec4<f32>(gammaToLiner(ORI_ShadingInput.BaseColor.rgb) * materialUniform.baseColor.rgb, ORI_ShadingInput.BaseColor.w * materialUniform.baseColor.a)  ;
        #endif

        var maskTex = textureSample(maskMap, maskMapSampler, uv ) ;
       
        #if USE_ALPHA_A
            ORI_ShadingInput.BaseColor.a =  ORI_ShadingInput.BaseColor.a * (maskTex.a) ;
            ORI_ShadingInput.BaseColor =  vec4f(ORI_ShadingInput.BaseColor.rgb/ORI_ShadingInput.BaseColor.a,ORI_ShadingInput.BaseColor.a) ;
        #endif

        #if USE_ALPHACUT 
            if( (ORI_ShadingInput.BaseColor.a - materialUniform.alphaCutoff) <= 0.0 ){
                ORI_FragmentOutput.color = vec4<f32>(0.0,0.0,0.0,1.0);
                ORI_FragmentOutput.worldPos = vec4<f32>(0.0,0.0,0.0,1.0);
                ORI_FragmentOutput.worldNormal = vec4<f32>(0.0,0.0,0.0,1.0);
                ORI_FragmentOutput.material = vec4<f32>(0.0,0.0,0.0,1.0);
                discard;
            }
        #endif

        useShadow();

        // maskTex =vec4f( gammaToLiner(maskTex.rgb), maskTex.a );

        var roughnessChannel:f32 = 1.0 ;
        #if USE_ROUGHNESS_A
            roughnessChannel = maskTex.a ;
        #else if USE_ROUGHNESS_R
            roughnessChannel = maskTex.r ;
        #else if USE_ROUGHNESS_G
            roughnessChannel = maskTex.g ;
        #else if USE_ROUGHNESS_B
            roughnessChannel = maskTex.b ;
        #else if USE_ALBEDO_A
            roughnessChannel = ORI_ShadingInput.BaseColor.a ;
        #endif  

        #if USE_SMOOTH
            var roughness = ( 1.0 - roughnessChannel ) * materialUniform.roughness;
            ORI_ShadingInput.Roughness = clamp(roughness , 0.0001 , 1.0);
        #else
            ORI_ShadingInput.Roughness = clamp(roughnessChannel * materialUniform.roughness ,0.0001,1.0);
        #endif 

        var metallicChannel:f32 = 1.0 ;
        #if USE_METALLIC_A
            metallicChannel = maskTex.a ;
        #else if USE_METALLIC_R
            metallicChannel = maskTex.r ;
        #else if USE_METALLIC_G
            metallicChannel = maskTex.g ;
        #else if USE_METALLIC_B
            metallicChannel = maskTex.b ;
        #endif    
        ORI_ShadingInput.Metallic = metallicChannel * metallicChannel * materialUniform.metallic ;
   
        var aoChannel:f32 = 1.0 ;
        #if USE_AOTEX
            var aoMap = textureSample(aoMap, aoMapSampler, uv );
            aoChannel = aoMap.g ;
        #else
            #if USE_AO_A
                aoChannel = maskTex.a ;
            #else if USE_AO_R
                aoChannel = maskTex.r ;
            #else if USE_AO_G
                aoChannel = maskTex.g ;
            #else if USE_AO_B
                aoChannel = maskTex.b ;
            #endif  
        #endif

        // ORI_ShadingInput.BaseColor.a = maskTex.a ;

        ORI_ShadingInput.AmbientOcclusion = aoChannel ;

        ORI_ShadingInput.Specular = 1.0 ;

        var emissiveColor = textureSample(emissiveMap, emissiveMapSampler , ORI_VertexVarying.fragUV0.xy) ;

        emissiveColor = vec4<f32>(gammaToLiner(emissiveColor.rgb),emissiveColor.w);

        ORI_ShadingInput.EmissiveColor = vec4<f32>(materialUniform.emissiveColor.rgb * emissiveColor.rgb * materialUniform.emissiveIntensity,1.0);

     

        var Normal = textureSample(normalMap,normalMapSampler,uv).rgb ;

        let normal = unPackRGNormal(Normal,1.0,1.0) ;  
        
        ORI_ShadingInput.Normal = normal ;

        var sssColor = vec3f(pow(textureSample(sssMap, sssMapSampler, uv ).r,materialUniform.skinPower)) * materialUniform.skinColor.rgb ;
        let sunLight = lightBuffer[0] ;
        let sunLightIntensity = (sunLight.intensity )  ;
        let ndl = 1.0 - clamp(dot(normalize(normal),-normalize(sunLight.direction)),0.0,1.0) * 0.5 + 0.5 ;//1.0 - saturate( dot(normalize(normal),normalize(sunLight.direction)) ) * 0.5 + 0.5 ;
        ORI_ShadingInput.SSS += 0.5 * vec3f(sssColor * sunLightIntensity * materialUniform.skinColorIns * ndl * sunLight.lightColor.rgb ) ;
     
        var curve = clamp(materialUniform.curveFactor * (length(fwidth(ORI_ShadingInput.Normal.xyz)) / length(fwidth(ORI_VertexVarying.vWorldPos.xyz*100.0))),0.0,1.0);
        var NDotL = dot(ORI_ShadingInput.Normal, -sunLight.direction );
        var sssColor2 = textureSample(lutMap, lutMapSampler ,vec2f(NDotL * 0.5 + 0.5, materialUniform.curveFactor * sssColor.r)).rgb * sunLight.lightColor.rgb * sunLightIntensity ;
        ORI_ShadingInput.SSS = sssColor2.rgb * ORI_ShadingInput.BaseColor.rgb ;
     
        BsDFShading();

        // ORI_FragmentOutput.color = vec4f(vec3f(0.5*ORI_ShadingInput.SSS),1.0)  ;
    }
`
    );

    let PavementShader = (
      /*wgsl*/
      `
        #include "Common_vert"
        #include "Common_frag"
        #include "BxDF_frag"

        @group(1) @binding(auto)
        var rtColorTex: texture_2d<f32>;

        @group(1) @binding(auto)
        var baseMapSampler: sampler;
        @group(1) @binding(auto)
        var baseMap: texture_2d<f32>;

        @group(1) @binding(auto)
        var normalMapSampler: sampler;
        @group(1) @binding(auto)
        var normalMap: texture_2d<f32>;

        @group(1) @binding(auto)
        var displaceMapSampler: sampler;
        @group(1) @binding(auto)
        var displaceMap: texture_2d<f32>;

        @group(1) @binding(auto)
        var aoMapSampler: sampler;
        @group(1) @binding(auto)
        var aoMap: texture_2d<f32>;
 
        @group(1) @binding(auto)
        var reflectMapSampler: sampler;
        @group(1) @binding(auto)
        var reflectMap: texture_2d<f32>;

        fn vert(inputData:VertexAttributes) -> VertexOutput {
            ORI_Vert(inputData) ;
            // let displaceDimensions = textureDimensions(displaceMap) ;
            // let displace = textureGather(0,displaceMap,displaceMapSampler,inputData.uv) ;
            // ORI_VertexOut.member.y += displace.r * 10.0;
            return ORI_VertexOut ;
        }

        fn frag(){
            var screenUV = ORI_VertexVarying.fragPosition.xy / ORI_VertexVarying.fragPosition.w;
            screenUV = (screenUV.xy + 1.0) * 0.5;
            screenUV.y = 1.0 - screenUV.y;

            let FrameMap = textureSample(rtColorTex,baseMapSampler,screenUV);

            let Albedo = textureSample(baseMap,baseMapSampler,ORI_VertexVarying.fragUV0);
            var Normal = textureSample(normalMap,normalMapSampler,ORI_VertexVarying.fragUV0).rgb ;
            Normal.y = 1.0 - Normal.y ;
            let Displace = textureSample(displaceMap,displaceMapSampler,ORI_VertexVarying.fragUV0).rgb ;
            let Ao = textureSample(aoMap,aoMapSampler,ORI_VertexVarying.fragUV0).r ;
            let ReflectMap = 1.0 - textureSample(reflectMap,reflectMapSampler,ORI_VertexVarying.fragUV0).r ;

            ORI_ShadingInput.BaseColor = FrameMap * materialUniform.baseColor * vec4<f32>(LinearToGammaSpace(Albedo.rgb),1.0);
            ORI_ShadingInput.Roughness = ReflectMap * materialUniform.roughness  ;
            ORI_ShadingInput.Metallic = materialUniform.metallic ;
            ORI_ShadingInput.Specular = 0.5 ;
            ORI_ShadingInput.AmbientOcclusion = Ao;
            ORI_ShadingInput.EmissiveColor = vec4<f32>(0.0);

            let normal = unPackRGNormal(Normal,Displace.r*materialUniform.normalScale,1.0) ;
            ORI_ShadingInput.Normal = normal ;

            BxDFShading();
        }
    `
    );

    let PointShadowDebug = (
      /*wgsl*/
      `
        #include "Common_vert"
        #include "Common_frag"
        #include "UnLit_frag"

        @group(1) @binding(auto) var pointShadowMapSampler: sampler;
        @group(1) @binding(auto) var pointShadowMap: texture_depth_cube ;

        struct MaterialUniform {
            center: vec3<f32>,
        };
      
        @group(2) @binding(0)
        var<uniform> materialUniform: MaterialUniform;

        fn vert(inputData:VertexAttributes) -> VertexOutput {
            ORI_Vert(inputData) ;
            return ORI_VertexOut ;
        }
 
        fn frag(){

            var center = materialUniform.center ; 

            var dir = normalize(ORI_VertexVarying.vWorldPos.xyz - center) ;
            var depth = textureSample(pointShadowMap,pointShadowMapSampler,dir.xyz) ;
            depth = depth * globalUniform.far ;

            ORI_ShadingInput.BaseColor = vec4<f32>(depth*255.0,0.0,0.0,1.0)  ;
            UnLit();
        }
    `
    );

    let UnLitTextureArray = (
      /*wgsl*/
      `
    // #include "Common_vert"
    #include "Common_frag"
    #include "UnLit_frag"
    #include "UnLitMaterialUniform_frag"

    #include "WorldMatrixUniform"
    #include "VertexAttributeIndexShader"
    #include "GlobalUniform"
    #include "Inline_vert"
    #include "ColorUtil_frag"

    const DEGREES_TO_RADIANS : f32 = 3.1415926 / 180.0 ;
    const PI : f32 = 3.1415926 ;

    #if USE_CUSTOMUNIFORM
        struct MaterialUniform {
            transformUV1:vec4<f32>,
            transformUV2:vec4<f32>,
            baseColor: vec4<f32>,
            alphaCutoff: f32,
        };
    #endif

    @group(1) @binding(0)
    var baseMapSampler: sampler;
    @group(1) @binding(1)
    var baseMap: texture_2d_array<f32>;

    @group(2) @binding(5)
    var<storage,read> graphicBuffer : array<GraphicNodeStruct>;
    
    @vertex
    fn VertMain( vertex:VertexAttributes ) -> VertexOutput {
        vertex_inline(vertex);
        vert(vertex);
        return ORI_VertexOut ;
    }

    fn vert(inputData:VertexAttributes) -> VertexOutput {
        ORI_Vert(inputData) ;
        return ORI_VertexOut ;
    }

    fn frag(){
        var transformUV1 = materialUniform.transformUV1;
        var transformUV2 = materialUniform.transformUV2;

        // var irradiance = vec3<f32>(0.0) ;
        // let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
        // irradiance += (globalUniform.skyExposure * textureSampleLevel(prefilterMap, prefilterMapSampler, ORI_VertexVarying.vWorldNormal.xyz, 0.8 * (MAX_REFLECTION_LOD) ).rgb);

        graphicNode = graphicBuffer[u32(round(ORI_VertexVarying.index))];
        
        var uv = transformUV1.zw * ORI_VertexVarying.fragUV0 + transformUV1.xy;
        //The fragUV1.x is 1.0 when the vertex belongs to line.
        if(ORI_VertexVarying.fragUV1.x > 0.5){
            uv = graphicNode.uvRect2.zw * uv.xy + graphicNode.uvRect2.xy;
            uv += graphicNode.uvSpeed.zw * globalUniform.time;
        }else{
            uv = graphicNode.uvRect.zw * uv.xy + graphicNode.uvRect.xy;
            uv += graphicNode.uvSpeed.xy * globalUniform.time;
            let rad = graphicNode.fillRotation;
            if(rad != 0.0){
                let zrot = mat3x3<f32>(
                    cos(rad),-sin(rad),0.0,
                    sin(rad), cos(rad),0.0,
                    0.0,0.0,1.0
                );
                uv = (zrot * vec3f(uv, 0.0)).xy;
            }
        }
        var graphicTextureID = graphicNode.texIndex;
        var graphicNodeColor = graphicNode.baseColor;
        if(ORI_VertexVarying.fragUV1.x > 0.5){
            graphicTextureID = graphicNode.tex2Index;
            graphicNodeColor = graphicNode.lineColor;
        }
        var color = textureSample(baseMap,baseMapSampler,uv, u32(round(graphicTextureID)) );
        // sRGB-encoded texture array → decode to linear (matches
        // UnLit / Lambert / Sprite). Skip when hardware-decoded.
        #if !USE_SRGB_ALBEDO
            color = vec4f(gammaToLiner(color.rgb), color.a);
        #endif
        color = color * materialUniform.baseColor * graphicNodeColor ;
        // let color = textureSample(baseMap,baseMapSampler,uv, u32(round(ORI_VertexVarying.index)));

        // ORI_ViewDir = normalize( globalUniform.CameraPos.xyz - ORI_VertexVarying.vWorldPos.xyz);
        // let att = dot( ORI_ViewDir , ORI_VertexVarying.vWorldNormal.xyz );

        // irradiance = LinearToGammaSpace(irradiance.rgb) * color.rgb ;//* att ;

        color += graphicNode.emissiveColor ;
        if(color.w < materialUniform.alphaCutoff){
            discard ;
        }

        // let outColor = vec4f( color.rgb * (att * 0.5 + 0.5 ) , 1.0 ) * materialUniform.baseColor ;
        let outColor = vec4f( color.rgb , 1.0 ) * materialUniform.baseColor ;
        
        // ORI_ShadingInput.BaseColor = color  ;
        ORI_ShadingInput.BaseColor = vec4f(outColor.xyz,1.0)  ;
        UnLit();
    }
`
    );

    let MaterialUniform = (
      /*wgsl*/
      `
    struct MaterialUniform{
       #if USE_BRDF
        #include "PhysicMaterialUniform_frag"
       #endif

       #if USE_ColorLit
       #endif

       #if USE_UnLit
       #endif
    }

    @group(2) @binding(0)
    var<uniform> materialUniform: MaterialUniform;
`
    );

    let GlobalFog_shader = (
      /* wgsl */
      `
    var<private> PI: f32 = 3.14159265359;
    #include "GlobalUniform"
    #include "GBufferStand" 
    
    #include "LightData"

    struct FogUniformData {
        fogColor : vec4<f32>,
        
        fogType : f32 ,
        fogHeightScale : f32 , 
        start: f32,
        end: f32,

        density : f32 ,
        ins : f32 ,
        falloff : f32 ,
        rayLength : f32 ,

        scatteringExponent : f32 ,
        dirHeightLine : f32 ,
        skyFactor: f32,
        skyRoughness: f32,

        overrideSkyFactor: f32,
        isSkyHDR: f32,
        slot0: f32,
        slot1: f32,
    };


    @group(0) @binding(2) var<uniform> fogUniform: FogUniformData;
    @group(0) @binding(3) var<storage,read> lightBuffer: array<LightData>;
    @group(0) @binding(4) var inTex: texture_2d<f32>;
    @group(0) @binding(5) var prefilterMap: texture_cube<f32>;
    @group(0) @binding(6) var prefilterMapSampler: sampler;
    @group(0) @binding(7) var outTex : texture_storage_2d<rgba16float, write>;

    var<private> texSize: vec2<u32>;
    var<private> fragCoord: vec2<i32>;
    var<private> fragUV: vec2<f32>;

    var<private> texPosition: vec4<f32>;
    var<private> texNormal: vec4<f32>;
    var<private> texColor: vec4<f32>;

    fn getGroundWithSkyColor(worldPosition:vec3<f32>, skyRoughness:f32, isHDRTexture:bool) -> vec3<f32>
    {
        let rayDirection = normalize(vec3<f32>(worldPosition.xyz - globalUniform.CameraPos.xyz));
        let calcRoughness = clamp(skyRoughness, 0.0, 1.0);
        let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
        let prefilterColor = textureSampleLevel(prefilterMap, prefilterMapSampler, rayDirection, calcRoughness * MAX_REFLECTION_LOD);
        // prefilterMap stores linear HDR; keep linear so the fog
        // composite stays in linear space for the swapchain encode.
        return prefilterColor.xyz * globalUniform.skyExposure;
    }

    fn getSkyBluredColor(skyRoughness:f32, isHDRTexture:bool) -> vec3<f32>
    {
        var worldPosition = vec4f(getSkyPositionFromGBuffer(fragUV), 1.0);
        let rayDirection = normalize(vec3<f32>(worldPosition.xyz - globalUniform.CameraPos.xyz));
        let calcRoughness = clamp(skyRoughness, 0.0, 1.0);
        let MAX_REFLECTION_LOD  = f32(textureNumLevels(prefilterMap)) ;
        let prefilterColor = textureSampleLevel(prefilterMap, prefilterMapSampler, rayDirection, calcRoughness * MAX_REFLECTION_LOD);
        return prefilterColor.xyz * globalUniform.skyExposure;
    }

    @compute @workgroup_size( 8 , 8 , 1 )
    fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
    {
        fragCoord = vec2<i32>( globalInvocation_id.xy );
        texSize = textureDimensions(inTex).xy;
        if(fragCoord.x >= i32(texSize.x) || fragCoord.y >= i32(texSize.y)){
            return;
        }

        fragUV = vec2<f32>(fragCoord) / vec2<f32>(texSize - 1);

        var gBuffer = getGBuffer( fragCoord ) ;
        texNormal = vec4f(getWorldNormalFromGBuffer(gBuffer),1.0); 
        texPosition =  vec4f(getWorldPositionFromGBuffer(gBuffer,fragUV), 1.0);
        texColor = textureLoad(inTex, fragCoord, 0);
    
        var opColor = vec3<f32>(0.0);
        if(getRoughnessFromGBuffer(gBuffer) <= 0.0){
            //for sky
            if(fogUniform.overrideSkyFactor > 0.01){
                opColor = blendSkyColor();
            }else{
                opColor = texColor.xyz;
            }
        }else{
            //for ground
            var fogFactor = calcFogFactor();
            if(fogUniform.skyFactor > 0.01 || fogUniform.overrideSkyFactor > 0.01){
                opColor = blendGroundColor(fogFactor);
            }else{
            }
            
            opColor = mix(texColor.rgb, fogUniform.fogColor.xyz, fogFactor);
            let sunLight = lightBuffer[0] ;
            var inScatteringValue = inScatterIng(sunLight.direction, texPosition.xyz, sunLight.lightColor);
            opColor += inScatteringValue;
        }

        textureStore(outTex, fragCoord , vec4<f32>(opColor.xyz, texColor.a));
    }

    fn calcFogFactor() -> f32 
    {
        var cameraPos = globalUniform.cameraWorldMatrix[3].xyz  ;
        let dis = distance(cameraPos, texPosition.xyz);
        var heightFactor = computeFog(dis) + cFog(-texPosition.y);
        return clamp(fogUniform.ins * heightFactor,0.0,1.0);
    }

        
    fn blendGroundColor(fogFactor:f32) -> vec3<f32>
    {
        var skyColorBlur = getGroundWithSkyColor(texPosition.xyz, fogUniform.skyRoughness, fogUniform.isSkyHDR > 0.5);
        let skyFactor = clamp(fogUniform.skyFactor - fogUniform.overrideSkyFactor * 0.5, 0.0, 1.0);
        var fogColor = mix(fogUniform.fogColor.xyz, skyColorBlur, skyFactor);
        return mix(texColor.rgb, fogColor.rgb, fogFactor);
    }

    fn blendSkyColor() -> vec3<f32>
    {
        let overrideSkyFactor = sqrt(fogUniform.overrideSkyFactor);
        var skyColorBlur = getSkyBluredColor(overrideSkyFactor * 0.3, fogUniform.isSkyHDR > 0.5);
        return mix(fogUniform.fogColor.xyz, skyColorBlur, 1.0 - overrideSkyFactor);
    }


    fn computeFog(z:f32) -> f32 
    {
        var fog = 0.0;
        if( fogUniform.fogType < 0.5 ){
            fog = (fogUniform.end - z) / (fogUniform.end - fogUniform.start);
        }else if(fogUniform.fogType < 1.5 ){
            fog = exp2(-fogUniform.density * z);
        }else if(fogUniform.fogType == 2.5 ){
            fog = fogUniform.density * z;
            fog = exp2(-fog * fog);
        }
        return max(fog,0.0);
    }

    fn cFog(y:f32) -> f32 
    {
        let fogDensity = fogUniform.density * exp(fogUniform.fogHeightScale * y);
        let fogFactor = (1.0 - exp2(-fogUniform.falloff)) / fogUniform.falloff ;
        let fog = fogDensity * fogFactor * max(fogUniform.rayLength - fogUniform.start, 0.0); 
        return max(fog,0.0);
    }

    fn inScatterIng(sunDir:vec3<f32>, worldPos:vec3<f32>, sunColor:vec3<f32>) -> vec3<f32> 
    {
        let viewDir = normalize(globalUniform.CameraPos.xyz - worldPos.xyz) ;
        let VoL = saturate(dot(viewDir,sunDir)) ;
        var scatter = pow(VoL,fogUniform.scatteringExponent);
        scatter *= (1.0-saturate(exp2(-fogUniform.dirHeightLine)));
        return vec3<f32>(scatter*sunColor);
    }

`
    );

    class AtmosphericScatteringSky_shader {
      static cs = (
        /* wgsl */
        `
    #include 'ColorUtil_frag'
    struct UniformData {
        width: f32,
        height: f32,
        sunU: f32,
        sunV: f32,
        eyePos: f32,
        sunRadius: f32,         // = 500.0;
        sunRadiance: f32,       // = 20.0;
        mieG: f32,              // = 0.76;
        mieHeight: f32,         // = 1200;
        sunBrightness: f32,     // = 1.0;
        displaySun: f32,        // > 0.5: true
        skyColor: vec4<f32>,        // sky color
      };

      @group(0) @binding(0) var<uniform> uniformBuffer: UniformData;
      @group(0) @binding(1) var outTexture : texture_storage_2d<rgba16float, write>;

      var<private> uv01: vec2<f32>;
      var<private> fragCoord: vec2<i32>;
      var<private> texSizeF32: vec2<f32>;

      var<private> PI:f32 = 3.1415926535;
      var<private> PI_2:f32 = 0.0;
      var<private> EPSILON:f32 = 0.0000001;
      var<private> SAMPLES_NUMS:i32 = 16;

      var<private> transmittance:vec3<f32>;
      var<private> insctrMie:vec3<f32>;
      var<private> insctrRayleigh:vec3<f32>;

      @compute @workgroup_size( 8 , 8 , 1 )
      fn CsMain( @builtin(workgroup_id) workgroup_id : vec3<u32> , @builtin(global_invocation_id) globalInvocation_id : vec3<u32>)
      {
        fragCoord = vec2<i32>(globalInvocation_id.xy);
        texSizeF32 = vec2<f32>( uniformBuffer.width, uniformBuffer.height);
        uv01 = vec2<f32>(globalInvocation_id.xy) / texSizeF32;
        uv01.y = 1.0 - uv01.y - EPSILON;
        PI_2 = PI * 2.0;
        textureStore(outTexture, fragCoord , mainImage(uv01));//vec4(uv01, 0.0, 1.0));
      }

      struct ScatteringParams
      {
        sunRadius:f32,
        sunRadiance:f32,

        mieG:f32,
        mieHeight:f32,

        rayleighHeight:f32,

        waveLambdaMie:vec3<f32>,
        waveLambdaOzone:vec3<f32>,
        waveLambdaRayleigh:vec3<f32>,

        earthRadius:f32,
        earthAtmTopRadius:f32,
        earthCenter:vec3<f32>,
      }

      fn ComputeSphereNormal(coord:vec2<f32>, phiStart:f32, phiLength:f32, thetaStart:f32, thetaLength:f32) -> vec3<f32>
      {
        var normal:vec3<f32>;
        normal.x = -sin(thetaStart + coord.y * thetaLength) * sin(phiStart + coord.x * phiLength);
        normal.y = -cos(thetaStart + coord.y * thetaLength);
        normal.z = -sin(thetaStart + coord.y * thetaLength) * cos(phiStart + coord.x * phiLength);
        return normalize(normal);
      }

      fn ComputeRaySphereIntersection(position:vec3<f32>, dir:vec3<f32>, center:vec3<f32>, radius:f32) -> vec2<f32>
      {
        var origin:vec3<f32> = position - center;
        var B = dot(origin, dir);
        var C = dot(origin, origin) - radius * radius;
        var D = B * B - C;

        var minimaxIntersections:vec2<f32>;
        if (D < 0.0)
        {
          minimaxIntersections = vec2<f32>(-1.0, -1.0);
        }
        else
        {
          D = sqrt(D);
          minimaxIntersections = vec2<f32>(-B - D, -B + D);
        }

        return minimaxIntersections;
      }

      fn ComputeWaveLambdaRayleigh(lambda: vec3<f32>) -> vec3<f32>
      {
        var n:f32 = 1.0003;
        var N:f32 = 2.545E25;
        var pn:f32 = 0.035;
        var n2:f32 = n * n;
        var pi3:f32 = PI * PI * PI;
        var rayleighConst:f32 = (8.0 * pi3 * pow(n2 - 1.0,2.0)) / (3.0 * N) * ((6.0 + 3.0 * pn) / (6.0 - 7.0 * pn));
        return vec3<f32>(rayleighConst) / (lambda * lambda * lambda * lambda);
      }

      fn ComputePhaseMie(theta: f32, g:f32) -> f32
      {
        var g2 = g * g;
        return (1.0 - g2) / pow(1.0 + g2 - 2.0 * g * saturate(theta), 1.5) / (4.0 * PI);
      }

      fn ComputePhaseRayleigh(theta: f32) -> f32
      {
        var theta2 = theta * theta;
        return (theta2 * 0.75 + 0.75) / (4.0 * PI);
      }

      fn ChapmanApproximation(X: f32, h: f32, cosZenith: f32) -> f32
      {
        var c = sqrt(X + h);
        var c_exp_h = c * exp(-h);

        if (cosZenith >= 0.0)
        {
          return c_exp_h / (c * cosZenith + 1.0);
        }
        else
        {
          var x0 = sqrt(1.0 - cosZenith * cosZenith) * (X + h);
          var c0 = sqrt(x0);

          return 2.0 * c0 * exp(X - x0) - c_exp_h / (1.0 - c * cosZenith);
        }
      }

      fn GetOpticalDepthSchueler(h: f32, H: f32, earthRadius: f32, cosZenith: f32) -> f32
      {
        return H * ChapmanApproximation(earthRadius / H, h / H, cosZenith);
      }

      fn GetTransmittance(setting: ScatteringParams, L:vec3<f32>, V: vec3<f32>) -> vec3<f32>
      {
        var ch = GetOpticalDepthSchueler(L.y, setting.rayleighHeight, setting.earthRadius, V.y);
        return exp(-(setting.waveLambdaMie + setting.waveLambdaRayleigh) * ch);
      }

      fn ComputeOpticalDepth(setting: ScatteringParams, samplePoint: vec3<f32>, V: vec3<f32>, L: vec3<f32>, neg: f32) -> vec2<f32>
      {
        var rl = length(samplePoint);
        var h = rl - setting.earthRadius;
        var r: vec3<f32> = samplePoint / rl;

        var cos_chi_sun = dot(r, L);
        var cos_chi_ray = dot(r, V * neg);

        var opticalDepthSun = GetOpticalDepthSchueler(h, setting.rayleighHeight, setting.earthRadius, cos_chi_sun);
        var opticalDepthCamera = GetOpticalDepthSchueler(h, setting.rayleighHeight, setting.earthRadius, cos_chi_ray) * neg;

        return vec2<f32>(opticalDepthSun, opticalDepthCamera);
      }

      fn AerialPerspective(setting:ScatteringParams, start: vec3<f32>, end: vec3<f32>, V: vec3<f32>, L: vec3<f32>, infinite:i32)
      {
        var inf_neg:f32 = 1.0;
        if( infinite == 0){
          inf_neg = -1.0;
        }

        var sampleStep: vec3<f32> = (end - start) / f32(SAMPLES_NUMS);
        var samplePoint: vec3<f32> = end - sampleStep;
        var sampleLambda: vec3<f32> = setting.waveLambdaMie + setting.waveLambdaRayleigh + setting.waveLambdaOzone;

        var sampleLength:f32 = length(sampleStep);

        var scattering:vec3<f32> = vec3<f32>(0.0);
        var lastOpticalDepth:vec2<f32> = ComputeOpticalDepth(setting, end, V, L, inf_neg);

        for (var i:i32 = 1; i < SAMPLES_NUMS; i = i + 1)
        {
          var opticalDepth: vec2<f32> = ComputeOpticalDepth(setting, samplePoint, V, L, inf_neg);

          var segment_s: vec3<f32> = exp(-sampleLambda * (opticalDepth.x + lastOpticalDepth.x));
          var segment_t: vec3<f32> = exp(-sampleLambda * (opticalDepth.y - lastOpticalDepth.y));

          transmittance *= segment_t;

          scattering = scattering * segment_t;
          scattering += exp(-(length(samplePoint) - setting.earthRadius) / setting.rayleighHeight) * segment_s;

          lastOpticalDepth = opticalDepth;
          samplePoint = samplePoint - sampleStep;
        }

        insctrMie = scattering * setting.waveLambdaMie * sampleLength;
        insctrRayleigh = scattering * setting.waveLambdaRayleigh * sampleLength;
      }

      fn ComputeSkyboxChapman(setting: ScatteringParams, eye:vec3<f32>, V:vec3<f32>, L:vec3<f32>) -> f32
      {
        var neg:i32 = 1;
        var outerIntersections: vec2<f32> = ComputeRaySphereIntersection(eye, V, setting.earthCenter, setting.earthAtmTopRadius);
        if (outerIntersections.y < 0.0){
          return 0.0;
        }
        var innerIntersections: vec2<f32> = ComputeRaySphereIntersection(eye, V, setting.earthCenter, setting.earthRadius);
        if (innerIntersections.x > 0.0)
        {
          neg = 0;
          outerIntersections.y = innerIntersections.x;
        }

        let eye0 = eye - setting.earthCenter;

        var start : vec3<f32> = eye0 + V * max(0.0, outerIntersections.x);
        var end : vec3<f32>= eye0 + V * outerIntersections.y;

        AerialPerspective(setting, start, end, V, L, neg);

        //bool intersectionTest = innerIntersections.x < 0.0 && innerIntersections.y < 0.0;
        //return intersectionTest ? 1.0 : 0.0;

        if(innerIntersections.x < 0.0 && innerIntersections.y < 0.0){
          return 1.0;
        }
        return 0.0;
      }

      fn ComputeSkyInscattering(setting: ScatteringParams, eye: vec3<f32>, V: vec3<f32>, L: vec3<f32>) -> vec4<f32>
      {
        transmittance = vec3<f32>(1.0);
        insctrMie = vec3<f32>(0.0);
        insctrRayleigh = vec3<f32>(0.0);
        var intersectionTest:f32 = ComputeSkyboxChapman(setting, eye, V, L);

        var phaseTheta = dot(V, L);
        var phaseMie = ComputePhaseMie(phaseTheta, setting.mieG);
        var phaseRayleigh = ComputePhaseRayleigh(phaseTheta);
        var phaseNight = 1.0 - saturate(transmittance.x * EPSILON);

        var insctrTotalMie: vec3<f32> = insctrMie * phaseMie;
        var insctrTotalRayleigh: vec3<f32> = insctrRayleigh * phaseRayleigh;

        var sky: vec3<f32> = (insctrTotalMie + insctrTotalRayleigh) * setting.sunRadiance;
        if(uniformBuffer.displaySun > 0.5){
          var angle:f32 = clamp((1.0 - phaseTheta) * setting.sunRadius, 0.0000001, 0.9999999);
          var cosAngle:f32 = cos(angle * PI * 0.5);
          var edge:f32 = 0.0;
          if(angle >= 0.9){
            edge = smoothstep(0.9, 1.0, angle);
          }

          var limbDarkening: vec3<f32> = GetTransmittance(setting, -L, V);
          limbDarkening *= pow(vec3<f32>(cosAngle), vec3<f32>(0.420, 0.503, 0.652)) * mix(vec3<f32>(1.0), vec3<f32>(1.2,0.9,0.5), edge) * intersectionTest;
          sky += limbDarkening * uniformBuffer.sunBrightness; 
        }
        return vec4<f32>(sky, phaseNight * intersectionTest);
      }

      fn TonemapACES(x: vec3<f32>) -> vec3<f32>
      {
        var A:f32 = 2.51f;
        var B:f32 = 0.03f;
        var C:f32 = 2.43f;
        var D:f32 = 0.59f;
        var E:f32 = 0.14f;
        return (x * (A * x + B)) / (x * (C * x + D) + E);
      }

      fn noise(uv:vec2<f32>) -> f32
      {
        return fract(dot(sin(vec3<f32>(uv.xyx) * vec3<f32>(uv.xyy) * 1024.0), vec3<f32>(341896.483, 891618.637, 602649.7031)));
      }

      fn mainImage( uv:vec2<f32> ) -> vec4<f32>
      {
        let eyePosition = uniformBuffer.eyePos;
        var sun = vec2<f32>(uniformBuffer.sunU, uniformBuffer.sunV);
        var V: vec3<f32> = ComputeSphereNormal(uv, 0.0, PI_2, 0.0, PI);
        var L: vec3<f32> = ComputeSphereNormal(vec2<f32>(sun.x, sun.y), 0.0, PI_2, 0.0, PI);

        var setting: ScatteringParams;
        setting.sunRadius = uniformBuffer.sunRadius;//500.0;
        setting.sunRadiance = uniformBuffer.sunRadiance;//20.0;
        setting.mieG = uniformBuffer.mieG;//0.76;
        setting.mieHeight = uniformBuffer.mieHeight;// 1200.0;
        setting.rayleighHeight = 8000.0;
        setting.earthRadius = 6360000.0;
        setting.earthAtmTopRadius = 6420000.0;
        setting.earthCenter = vec3<f32>(0, -setting.earthRadius, 0);
        setting.waveLambdaMie = vec3<f32>(0.0000002);

        // wavelength with 680nm, 550nm, 450nm
        setting.waveLambdaRayleigh = ComputeWaveLambdaRayleigh(vec3<f32>(0.000000680, 0.000000550, 0.000000450));

        // see https://www.shadertoy.com/view/MllBR2
        setting.waveLambdaOzone = vec3<f32>(1.36820899679147, 3.31405330400124, 0.13601728252538)* 0.0000006 * 2.504;

        var eye:vec3<f32> = vec3<f32>(0,eyePosition,0);
        var sky0:vec4<f32> = ComputeSkyInscattering(setting, eye, V, L);
        var sky = vec3<f32>(sky0.rgb);

        // Emit linear HDR radiance. The cube is consumed as a linear env map:
        // CubeSky_Shader and the IBL path (BRDF_frag) only scale by skyExposure
        // and defer tone-mapping to the single global ACES PostPass + sRGB
        // swapchain encode. Baking ACES + gamma here double tone-mapped the
        // sky (washed-out look) and corrupted IBL, which expects linear input.
        sky = sky.rgb * 2.0;

        var fragColor:vec4<f32> = vec4<f32>((sky.rgb), 1.0);
        return fragColor;
      }
    `
      );
    }

    class AtmosphericScatteringSkySetting {
      /** Angular size of the sun disc. */
      sunRadius = 500;
      /** Radiance (brightness) of the sun. */
      sunRadiance = 11;
      /** Mie scattering anisotropy factor (forward-scattering bias). */
      mieG = 0.76;
      /** Scale height of the Mie (aerosol) layer. */
      mieHeight = 1200;
      /** Height of the viewer's eye above the planet surface. */
      eyePos = 1500;
      /** Sun direction's horizontal (azimuth) parameter, in [0, 1]. */
      sunX = 0.71;
      /** Sun direction's vertical (elevation) parameter, in [0, 1]. */
      sunY = 0.56;
      /** Overall brightness multiplier applied to the sun. */
      sunBrightness = 1;
      /** Whether the sun disc is drawn in the sky. */
      displaySun = true;
      /** Default edge size of the generated sky cube texture. */
      defaultTextureCubeSize = 512;
      /** Default width of the generated panorama 2D texture. */
      defaultTexture2DSize = 1024;
      /** Tint color applied to the sky. */
      skyColor = new Color(1, 1, 1, 1);
    }
    class AtmosphericScatteringSky extends LDRTextureCube {
      _internalTexture;
      _cubeSize;
      /** The scattering parameters driving this sky's appearance. */
      setting;
      /**
       * @constructor
       * @param setting AtmosphericScatteringSkySetting
       * @returns
       */
      constructor(setting, ctx) {
        super();
        this.setting = setting;
        this._cubeSize = setting.defaultTextureCubeSize;
        this._internalTexture = new AtmosphericTexture2D(setting.defaultTexture2DSize, setting.defaultTexture2DSize * 0.5, ctx);
        this._internalTexture.update(this.setting);
        this.createFromTexture(this._cubeSize, this._internalTexture, ctx);
        return this;
      }
      /** Get the underlying panorama 2D texture used to build the sky cube. */
      get texture2D() {
        return this._internalTexture;
      }
      /**
       * @internal
       * @returns
       */
      apply() {
        this._internalTexture.update(this.setting);
        this._faceData.uploadErpTexture(this._internalTexture);
        return this;
      }
    }
    class AtmosphericTexture2D extends VirtualTexture {
      _computeShader;
      _uniformBuffer;
      constructor(width, height, ctx) {
        super(width, height, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, ctx);
        this.initCompute(width, height);
      }
      initCompute(w, h) {
        this._uniformBuffer = new UniformGPUBuffer(16 * 4);
        this._uniformBuffer.apply();
        this._computeShader = new ComputeShader(AtmosphericScatteringSky_shader.cs);
        this._computeShader.setUniformBuffer("uniformBuffer", this._uniformBuffer);
        this._computeShader.setStorageTexture(`outTexture`, this);
        this._computeShader.workerSizeX = w / 8;
        this._computeShader.workerSizeY = h / 8;
      }
      update(setting) {
        this._uniformBuffer.setFloat("width", this.width);
        this._uniformBuffer.setFloat("height", this.height);
        this._uniformBuffer.setFloat("sunU", setting.sunX);
        this._uniformBuffer.setFloat("sunV", setting.sunY);
        this._uniformBuffer.setFloat("eyePos", setting.eyePos);
        this._uniformBuffer.setFloat("sunRadius", setting.sunRadius);
        this._uniformBuffer.setFloat("sunRadiance", setting.sunRadiance);
        this._uniformBuffer.setFloat("mieG", setting.mieG);
        this._uniformBuffer.setFloat("mieHeight", setting.mieHeight);
        this._uniformBuffer.setFloat("sunBrightness", setting.sunBrightness);
        this._uniformBuffer.setFloat("displaySun", setting.displaySun ? 1 : 0);
        this._uniformBuffer.setColor("skyColor", setting.skyColor);
        this._uniformBuffer.apply();
        let command = this._boundCtx.gpuContext.beginCommandEncoder();
        this._boundCtx.gpuContext.computeCommand(command, [this._computeShader]);
        this._boundCtx.gpuContext.endCommandEncoder(command);
        return this;
      }
    }

    var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
    var __decorateClass$j = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SkyShader = class SkyShader extends Shader {
      _fixOrthMatrix;
      // Stable JS-owned mirror of _fixOrthMatrix.rawData. The Matrix4's rawData
      // is a Float32Array view into wasm.HEAPF32.buffer, which detaches when
      // the WASM heap grows (e.g. scenes with >1k matrices). Binding rawData
      // directly as a uniform leaves UniformNode holding a dead view; we copy
      // values into _fixOrthData and bind THAT instead.
      _fixOrthData = new Float32Array(16);
      _cacheData = { enable: false, aspect: 1, near: 1, far: 1e3 };
      constructor() {
        super();
        this._fixOrthMatrix = new Matrix4();
        this._fixOrthData.set(this._fixOrthMatrix.rawData);
        let colorShader = new RenderShaderPass("sky_vs_frag_wgsl", "sky_fs_frag_wgsl");
        this.addRenderPass(colorShader);
        colorShader.setUniform("fixOrthProj", this._fixOrthData);
        colorShader.setUniform("enableFixOrthProj", 0);
        colorShader.setUniformFloat(`exposure`, 1);
        colorShader.setUniformFloat(`roughness`, 0);
        let shaderState = colorShader.shaderState;
        shaderState.frontFace = `ccw`;
        shaderState.cullMode = GPUCullMode.front;
        shaderState.depthWriteEnabled = false;
        shaderState.depthCompare = GPUCompareFunction.less_equal;
      }
      //fix orth matrix
      fixOrthProj(enable, aspect, near, far) {
        const cacheData = this._cacheData;
        if (cacheData.enable != enable || cacheData.aspect != aspect || cacheData.near != near || cacheData.far != far) {
          cacheData.enable = enable;
          cacheData.aspect = aspect;
          cacheData.near = near;
          cacheData.far = far;
          this.setUniform("enableFixOrthProj", enable ? 1 : 0);
          this._fixOrthMatrix.perspective(90, aspect, near, far);
          this._fixOrthData.set(this._fixOrthMatrix.rawData);
          this.setUniform("fixOrthProj", this._fixOrthData);
        }
      }
      destroy(force) {
        if (this._fixOrthMatrix) {
          Matrix4.freeIndex(this._fixOrthMatrix);
          this._fixOrthMatrix = null;
        }
        super.destroy(force);
      }
    };
    exports.SkyShader = __decorateClass$j([
      RegisterShader
    ], exports.SkyShader);

    class SkyMaterial extends Material {
      _skyShader;
      _exposure = 1;
      constructor() {
        super();
        this.shader = this._skyShader = new exports.SkyShader();
        this.shader.setUniformVector3(`eyesPos`, new Vector3());
        this.shader.setUniformFloat(`exposure`, 1);
        this.shader.setUniformFloat(`roughness`, 0);
      }
      fixOrthProj(enable, aspect, near, far) {
        this._skyShader.fixOrthProj(enable, aspect, near, far);
      }
      /**
       *  Set base map(main map)
       */
      set baseMap(texture) {
        this.setTexture(`baseMap`, texture);
        const key = "IS_HDR_SKY";
        let defaultShader = this._shader.getDefaultShaders()[0];
        if (defaultShader.defineValue[key] != texture?.isHDRTexture) {
          this._shader.setDefine(key, texture?.isHDRTexture ? true : false);
        }
      }
      /**
       * Get base map(main map)
      //  */
      get baseMap() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.getTexture(`baseMap`);
      }
      set envMap(texture) {
      }
      set shadowMap(texture) {
      }
      get exposure() {
        return this._exposure;
      }
      set exposure(value) {
        this._exposure = value;
        this.shader.setUniformFloat("exposure", value);
      }
      get roughness() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`roughness`].value;
      }
      set roughness(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`roughness`].value = value;
      }
    }

    class SphereGeometry extends GeometryBase {
      shape_vertices = [];
      shape_indices = [];
      /**
       * radius of sphere
       */
      radius;
      /**
       * Define the number of horizontal segments
       */
      widthSegments;
      /**
       * Define the number of vertical segments
       */
      heightSegments;
      /**
       * The starting point radian of the equatorial line of a sphere
       */
      phiStart;
      /**
       * The arc length of the equatorial line of a sphere
       */
      phiLength;
      /**
       * The radian of the starting point of the sphere's meridian
       */
      thetaStart;
      /**
       * Arc length of sphere meridian
       */
      thetaLength;
      /**
       *
       * @constructor
       * @param radius radius of sphere
       * @param widthSegments Define the number of horizontal segments
       * @param heightSegments Define the number of vertical segments
       * @param phiStart  The starting point radian of the equatorial line of a sphere
       * @param phiLength The arc length of the equatorial line of a sphere
       * @param thetaStart The radian of the starting point of the sphere's meridian
       * @param thetaLength Arc length of sphere meridian
       */
      constructor(radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength) {
        super();
        this.radius = radius;
        this.widthSegments = widthSegments;
        this.heightSegments = heightSegments;
        this.phiStart = phiStart;
        this.phiLength = phiLength;
        this.thetaStart = thetaStart;
        this.thetaLength = thetaLength;
        this.buildGeometry();
      }
      buildGeometry() {
        var i, j, triIndex = 0;
        let _segmentsH = this.heightSegments;
        let _segmentsW = this.widthSegments;
        let _radius = this.radius;
        var vertexCount = (_segmentsH + 1) * (_segmentsW + 1);
        let position_arr = new Float32Array(vertexCount * 3);
        let normal_arr = new Float32Array(vertexCount * 3);
        let uv_arr = new Float32Array(vertexCount * 2);
        let indice_arr = new Uint16Array(_segmentsW * _segmentsH * 2 * 3);
        let pi = 0;
        let ni = 0;
        let ui = 0;
        for (j = 0; j <= _segmentsH; ++j) {
          var horAngle = Math.PI * j / _segmentsH;
          var y = _radius * Math.cos(horAngle);
          var ringRadius = _radius * Math.sin(horAngle);
          for (i = 0; i <= _segmentsW; ++i) {
            var verAngle = 2 * Math.PI * i / _segmentsW;
            var x = ringRadius * Math.cos(verAngle);
            var z = ringRadius * Math.sin(verAngle);
            var normLen = 1 / Math.sqrt(x * x + y * y + z * z);
            position_arr[pi++] = x;
            position_arr[pi++] = y;
            position_arr[pi++] = z;
            normal_arr[ni++] = x * normLen;
            normal_arr[ni++] = y * normLen;
            normal_arr[ni++] = z * normLen;
            uv_arr[ui++] = i / _segmentsW;
            uv_arr[ui++] = j / _segmentsH;
            if (i > 0 && j > 0) {
              var a = (_segmentsW + 1) * j + i;
              var b = (_segmentsW + 1) * j + i - 1;
              var c = (_segmentsW + 1) * (j - 1) + i - 1;
              var d = (_segmentsW + 1) * (j - 1) + i;
              if (j == _segmentsH) {
                indice_arr[triIndex++] = a;
                indice_arr[triIndex++] = c;
                indice_arr[triIndex++] = d;
              } else if (j == 1) {
                indice_arr[triIndex++] = a;
                indice_arr[triIndex++] = b;
                indice_arr[triIndex++] = c;
              } else {
                indice_arr[triIndex++] = a;
                indice_arr[triIndex++] = b;
                indice_arr[triIndex++] = c;
                indice_arr[triIndex++] = a;
                indice_arr[triIndex++] = c;
                indice_arr[triIndex++] = d;
              }
            }
          }
        }
        this.setIndices(indice_arr);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indice_arr.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
        this.bounds = new BoundingBox(Vector3.ZERO, new Vector3(this.radius * 2, this.radius * 2, this.radius * 2));
      }
    }

    class Reflection extends RenderNode {
      /** Global reflection probe id assigned by the reflection system. */
      gid = 0;
      /** Whether this probe needs to be re-captured on the next frame. */
      needUpdate = true;
      /** When true, the probe re-captures automatically every frame. */
      autoUpdate = false;
      /** Radius of the probe's influence volume. */
      radius = 500;
      /** Initialize the reflection mask, bounds and position-change tracking. */
      init() {
        super.init();
        this.addRendererMask(RendererMask.Reflection);
        this.alwaysRender = true;
        this.object3D.bound = new BoundingBox(Vector3.ZERO.clone(), Vector3.MAX);
        mergeFunctions(this.transform.onPositionChange, () => {
          this.needUpdate = true;
        });
      }
      /** Register this probe as a render node when enabled. */
      onEnable() {
        EntityCollect.instance.addRenderNode(this.transform.scene3D, this);
      }
      /** Unregister this probe from the render node list when disabled. */
      onDisable() {
        EntityCollect.instance.removeRenderNode(this.transform.scene3D, this);
      }
      renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle = false) {
        super.renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle);
      }
    }

    class ReflectionShader extends Shader {
      constructor() {
        super();
        let colorShader = new RenderShaderPass("ReflectionShader_shader", "ReflectionShader_shader");
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        this.addRenderPass(colorShader);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = false;
        shaderState.castShadow = false;
        shaderState.receiveEnv = false;
        shaderState.acceptGI = false;
        shaderState.useLight = false;
        this.setDefine("USE_BRDF", true);
        this.setDefine("USE_AO_R", true);
        this.setDefine("USE_ROUGHNESS_G", true);
        this.setDefine("USE_METALLIC_B", true);
        this.setDefine("USE_ALPHA_A", true);
        this.setDefault();
      }
      setDefault() {
        this.setUniformVector4(`transformUV1`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`transformUV2`, new Vector4(0, 0, 1, 1));
        this.setUniformColor(`baseColor`, new Color());
        this.setUniformFloat(`alphaCutoff`, 0);
      }
      set _MainTex(value) {
        this.setTexture("baseMap", value);
      }
      set _BumpMap(value) {
        this.setTexture("normalMap", value);
      }
      set _MaskTex(value) {
        this.setTexture("maskMap", value);
      }
      set _UVTransform(value) {
        this.setUniformVector4("transformUV1", value);
      }
      set _Metallic(value) {
        this.setUniformFloat("metallic", value);
      }
      set _Roughness(value) {
        this.setUniformFloat("roughness", value);
      }
      set _MainColor(value) {
        this.setUniformColor("baseColor", value);
      }
      set _AlphaCutoff(value) {
        this.setUniformFloat("alphaCutoff", value);
      }
      set _DoubleSidedEnable(value) {
        let defaultShader = this.getDefaultColorShader();
        defaultShader.shaderState.cullMode = value ? GPUCullMode.none : defaultShader.shaderState.cullMode;
      }
      set _SurfaceType(value) {
        let defaultShader = this.getDefaultColorShader();
        if (value == 0) {
          defaultShader.blendMode = BlendMode.NONE;
        } else {
          defaultShader.blendMode = BlendMode.ALPHA;
        }
      }
      set _AlphaCutoffEnable(value) {
        if (value == 0) {
          this.setDefine("USE_ALPHACUT", false);
        } else {
          this.setDefine("USE_ALPHACUT", true);
        }
      }
    }

    class ReflectionMaterial extends Material {
      /**
       * @constructor
       */
      constructor(ctx) {
        super();
        this.shader = new ReflectionShader();
        this.baseMap = Engine3D.resFor(ctx).whiteTexture;
        this.setDefine("USE_CUSTOMUNIFORM", true);
        this.reflectionIndex = 0;
      }
      /** Sets the base color map texture. */
      set baseMap(texture) {
        this.shader.setTexture(`baseMap`, texture);
      }
      /** Gets the base color map texture. */
      get baseMap() {
        return this.shader.getTexture(`baseMap`);
      }
      /**
       * set base color (tint color)
       */
      set baseColor(color) {
        this.shader.setUniformColor(`baseColor`, color);
      }
      /** Sets the reflection strength index uniform. */
      set reflectionIndex(i) {
        this.shader.setUniformFloat(`reflectionIndex`, i);
      }
      /**
       * get base color (tint color)
       */
      get baseColor() {
        return this.shader.getUniformColor("baseColor");
      }
      /**
       * set environment texture, usually referring to cubemap
       */
      set envMap(texture) {
      }
      /**
       * @internal
       * set shadow map
       */
      set shadowMap(texture) {
      }
    }

    class SphereReflection extends Reflection {
      /** Initialize the probe with a spherical bound and reflection mask. */
      init() {
        super.init();
        this.castShadow = false;
        this.castGI = false;
        this.addRendererMask(RendererMask.Reflection);
        this.alwaysRender = true;
        this.object3D.bound = new BoundingSphere(Vector3.ZERO.clone(), this.radius);
      }
      /**
       * Spawn a debug sphere mesh that visualizes the captured reflection
       * at the given probe index.
       * @param index reflection probe index to visualize
       * @param view the view providing reflection settings and resources
       * @param scale uniform scale applied to the debug sphere
       */
      debug(index, view, scale = 1) {
        let obj = new exports.Object3D();
        let mr = obj.addComponent(exports.MeshRenderer);
        mr.addMask(RendererMask.ReflectionDebug);
        mr.geometry = new SphereGeometry(25, 30, 30);
        let reflectionSetting = view.engine3D.setting.reflectionSetting;
        let reflectionsGBufferFrame = GBufferFrame.getGBufferFrame(GBufferFrame.reflections_GBuffer, view.engine3D.context3D, reflectionSetting.width, reflectionSetting.height);
        let mat = new ReflectionMaterial();
        mat.reflectionIndex = index;
        mat.baseMap = reflectionsGBufferFrame.getCompressGBufferTexture();
        mr.material = mat;
        this.object3D.addChild(obj);
        obj.scaleX = scale;
        obj.scaleY = scale;
        obj.scaleZ = scale;
      }
      /** Register this probe as a render node when enabled. */
      onEnable() {
        super.onEnable();
      }
      /** Unregister this probe from the render node list when disabled. */
      onDisable() {
        super.onDisable();
      }
      renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle = false) {
        super.renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle);
      }
    }

    class SkyRenderer extends exports.MeshRenderer {
      /**
       * The material used in the Sky Box.
       */
      skyMaterial;
      init() {
        super.init();
        this.castShadow = false;
        this.castGI = true;
        this.addRendererMask(RendererMask.Sky);
        this.alwaysRender = true;
        this.object3D.bound = new BoundingBox(Vector3.ZERO.clone(), Vector3.MAX);
        this.skyMaterial ||= new SkyMaterial();
      }
      onEnable() {
        if (!this.geometry) {
          const defaultFar = this.transform.view3D?.engine3D?.setting.sky.defaultFar ?? 5e3;
          this.geometry = new SphereGeometry(defaultFar, 20, 20);
        }
        if (!this._readyPipeline) {
          this.initPipeline();
        } else {
          this.castNeedPass();
          if (!this._inRenderer && this.transform.scene3D) {
            EntityCollect.instance.setSky(this.transform.scene3D, this);
            this._inRenderer = true;
          }
        }
      }
      onDisable() {
        if (this._inRenderer && this.transform.scene3D) {
          this._inRenderer = false;
          EntityCollect.instance.setSky(this.transform.scene3D, null);
        }
        super.onDisable();
      }
      nodeUpdate(view, passType, renderPassState, clusterLightingBuffer) {
        super.nodeUpdate(view, passType, renderPassState, clusterLightingBuffer);
        const { type, aspect, near, far } = view.camera;
        this.skyMaterial.fixOrthProj(type == CameraType.ortho, aspect, near, far);
      }
      renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle = false) {
        super.renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle);
      }
      /**
       * set environment texture
       */
      set map(texture) {
        this.skyMaterial.baseMap = texture;
        if (this.skyMaterial.name == null) {
          this.skyMaterial.name = "skyMaterial";
        }
        this.material = this.skyMaterial;
      }
      /**
       * get environment texture
       */
      get map() {
        return this.skyMaterial.baseMap;
      }
      get exposure() {
        return this.skyMaterial.exposure;
      }
      set exposure(value) {
        if (this.skyMaterial)
          this.skyMaterial.exposure = value;
      }
      get roughness() {
        return this.skyMaterial.roughness;
      }
      set roughness(value) {
        if (this.skyMaterial)
          this.skyMaterial.roughness = value;
      }
      useSkyReflection() {
        let reflection = new exports.Object3D();
        let ref = reflection.addComponent(SphereReflection);
        ref.autoUpdate = false;
        reflection.x = 0;
        reflection.y = 300;
        reflection.z = 0;
        this.object3D.addChild(reflection);
      }
    }

    class HistoryData {
      rotateX;
      rotateY;
      sunX;
      sunY;
      constructor() {
        this.reset();
      }
      reset() {
        this.rotateX = this.rotateY = this.sunX = this.sunY = Number.MAX_VALUE;
        return this;
      }
      isRotateChange(rx, ry) {
        return Math.abs(this.rotateX - rx) >= 1e-3 || Math.abs(this.rotateY - ry) >= 1e-3;
      }
      isSkyChange(x, y) {
        return Math.abs(this.sunX - x) >= 1e-3 || Math.abs(this.sunY - y) >= 1e-3;
      }
      save(x, y, rx, ry) {
        this.sunX = x;
        this.sunY = y;
        this.rotateX = rx;
        this.rotateY = ry;
        return this;
      }
    }
    class AtmosphericComponent extends SkyRenderer {
      _atmosphericScatteringSky;
      _pendingSetting;
      _onChange = true;
      _relatedTransform;
      _historyData;
      /** CPU-side setting object. Available pre-GPU: setters mutate this; the
       *  GPU sky consumes it on first render. */
      get _setting() {
        return this._atmosphericScatteringSky?.setting ?? this._pendingSetting;
      }
      /** Horizontal sun position in normalized [0,1] sky coordinates. */
      get sunX() {
        return this._setting.sunX;
      }
      set sunX(value) {
        if (this._setting.sunX != value) {
          this._setting.sunX = value;
          this._onChange = true;
        }
      }
      /** Vertical sun position in normalized [0,1] sky coordinates. */
      get sunY() {
        return this._setting.sunY;
      }
      set sunY(value) {
        if (this._setting.sunY != value) {
          this._setting.sunY = value;
          this._onChange = true;
        }
      }
      /** Eye (viewer) altitude used by the atmospheric scattering model. */
      get eyePos() {
        return this._setting.eyePos;
      }
      set eyePos(value) {
        if (this._setting.eyePos != value) {
          this._setting.eyePos = value;
          this._onChange = true;
        }
      }
      /** Angular radius of the sun disc. */
      get sunRadius() {
        return this._setting.sunRadius;
      }
      set sunRadius(value) {
        if (this._setting.sunRadius != value) {
          this._setting.sunRadius = value;
          this._onChange = true;
        }
      }
      /** Radiance (intensity) of the sun. */
      get sunRadiance() {
        return this._setting.sunRadiance;
      }
      set sunRadiance(value) {
        if (this._setting.sunRadiance != value) {
          this._setting.sunRadiance = value;
          this._onChange = true;
        }
      }
      /** Overall brightness of the sun. */
      get sunBrightness() {
        return this._setting.sunBrightness;
      }
      set sunBrightness(value) {
        if (this._setting.sunBrightness != value) {
          this._setting.sunBrightness = value;
          this._onChange = true;
        }
      }
      /** Whether the sun disc is drawn in the sky. */
      get displaySun() {
        return this._setting.displaySun;
      }
      set displaySun(value) {
        if (this._setting.displaySun != value) {
          this._setting.displaySun = value;
          this._onChange = true;
        }
      }
      /** Initialize history tracking and the pending sky setting. */
      init() {
        super.init();
        this._historyData = new HistoryData();
        this._pendingSetting = new AtmosphericScatteringSkySetting();
      }
      _ensureSky(ctx) {
        if (this._atmosphericScatteringSky) return;
        this._atmosphericScatteringSky = new AtmosphericScatteringSky(this._pendingSetting, ctx);
        let scene = this.transform.scene3D;
        this.map = this._atmosphericScatteringSky;
        scene.envMap = this._atmosphericScatteringSky;
      }
      /** Ensure the GPU sky exists, then run base startup. */
      start(view) {
        const ctx = view?.engine3D?.context3D ?? this.transform?.view3D?.engine3D?.context3D;
        this._ensureSky(ctx);
        super.start();
      }
      /** Transform whose rotation is kept in sync with the sun direction. */
      get relativeTransform() {
        return this._relatedTransform;
      }
      set relativeTransform(value) {
        this._relatedTransform = value;
        this._historyData.reset();
      }
      /** Per-frame update: sync sun/transform rotation and re-bake the sky on change. */
      onUpdate(view) {
        const ctx = view?.engine3D?.context3D ?? this.transform?.view3D?.engine3D?.context3D;
        this._ensureSky(ctx);
        if (this._relatedTransform) {
          this._relatedTransform.rotationZ = 0;
          if (this._historyData.isRotateChange(this._relatedTransform.rotationX, this._relatedTransform.rotationY)) {
            this.sunX = (this._relatedTransform.rotationY + 90) / 360;
            this.sunY = this._relatedTransform.rotationX / 180 + 0.5;
          } else if (this._historyData.isSkyChange(this.sunX, this.sunY)) {
            this._relatedTransform.rotationY = this.sunX * 360 - 90;
            this._relatedTransform.rotationX = (this.sunY - 0.5) * 180;
          }
          this._historyData.save(this.sunX, this.sunY, this._relatedTransform.rotationX, this._relatedTransform.rotationY);
        }
        if (this._onChange && this._atmosphericScatteringSky) {
          this._onChange = false;
          this._atmosphericScatteringSky.apply();
        }
      }
      /** Destroy the component and release the GPU sky resources. */
      destroy(force) {
        super.destroy(force);
        this._atmosphericScatteringSky?.destroy();
        this._atmosphericScatteringSky = null;
        this._onChange = null;
      }
    }

    var BillboardType = /* @__PURE__ */ ((BillboardType2) => {
      BillboardType2[BillboardType2["None"] = 0] = "None";
      BillboardType2[BillboardType2["BillboardY"] = 9] = "BillboardY";
      BillboardType2[BillboardType2["BillboardXYZ"] = 10] = "BillboardXYZ";
      return BillboardType2;
    })(BillboardType || {});
    class BillboardComponent extends ComponentBase {
      /** Billboard orientation mode. */
      type;
      /** Camera reference used to derive the facing direction. */
      camera;
      _cameraPosition;
      constructor() {
        super();
        this._cameraPosition = new Vector3();
      }
      /**
       * Per-frame update: reorients the object to face the active camera.
       */
      onUpdate() {
        if (this.enable && this.transform.view3D.camera) {
          this.updateBillboardMatrix();
        }
      }
      updateBillboardMatrix() {
        if (this.type == 0 /* None */) return;
        let camera = this.transform.view3D.camera;
        this._cameraPosition.copy(camera.transform.back);
        if (this.type == 10 /* BillboardXYZ */) ; else if (this.type == 9 /* BillboardY */) {
          this._cameraPosition.y = 0;
        }
        this._cameraPosition.normalize();
        Vector3.add(this._cameraPosition, this.object3D.localPosition, this._cameraPosition);
        this.transform.lookAt(this.object3D.localPosition, this._cameraPosition, camera.transform.up);
      }
      /**
       * Clone this component's settings onto another object.
       * @param obj target object to attach a copy to
       */
      cloneTo(obj) {
        let component = obj.addComponent(BillboardComponent);
        component.type = this.type;
      }
    }

    var ColliderShapeType = /* @__PURE__ */ ((ColliderShapeType2) => {
      ColliderShapeType2[ColliderShapeType2["None"] = 0] = "None";
      ColliderShapeType2[ColliderShapeType2["Box"] = 1] = "Box";
      ColliderShapeType2[ColliderShapeType2["Capsule"] = 2] = "Capsule";
      ColliderShapeType2[ColliderShapeType2["Sphere"] = 3] = "Sphere";
      ColliderShapeType2[ColliderShapeType2["Mesh"] = 4] = "Mesh";
      return ColliderShapeType2;
    })(ColliderShapeType || {});
    class ColliderShape {
      _center;
      _size;
      _halfSize;
      _shapeType = 0 /* None */;
      static v3_help_0;
      static helpMatrix;
      static helpRay;
      constructor() {
        ColliderShape.v3_help_0 ||= new Vector3();
        ColliderShape.helpMatrix ||= new Matrix4();
        ColliderShape.helpRay ||= new Ray();
        this._center = new Vector3();
        this._size = new Vector3();
        this._halfSize = new Vector3();
      }
      get shapeType() {
        return this._shapeType;
      }
      /**
       * Set the position and size of collision objects
       * @param ct The position of the collision object in the local space of the object.
       * @param sz The size of the collision body in the X, Y, and Z directions.
       * @returns
       */
      setFromCenterAndSize(ct, sz) {
        ct && this._center.copy(ct);
        sz && this._size.copy(sz);
        return this;
      }
      /**
       * The position of the collision object in the local space of the object.
       */
      get center() {
        return this._center;
      }
      set center(value) {
        this._center.copy(value);
      }
      /**
       *
       * The size of the collision body in the X, Y, and Z directions.
       * @returns Vector3
       */
      get size() {
        return this._size;
      }
      set size(value) {
        this._size.copy(value);
        this._halfSize.copy(value).multiplyScalar(0.5);
      }
      /**
       * Half the size of the collision body.
       */
      get halfSize() {
        return this._halfSize;
      }
      /**
       * Ray pickup.Emit a ray from a designated location to detect objects colliding with the ray.
       * @param ray emit ray
       * @param fromMatrix matrix
       * @returns Pick result intersect: whether to collide;
       *  IntersectPoint: collision point;
       *  Distance: The distance from the origin of the ray to the collision point.
       */
      rayPick(ray, fromMatrix) {
        return null;
      }
    }

    class BoxColliderShape extends ColliderShape {
      _pickRet;
      box;
      /**
       * @constructor
       */
      constructor() {
        super();
        this._shapeType = ColliderShapeType.Box;
        this.box = new BoundingBox(new Vector3(), new Vector3());
      }
      /**
       * @internal
       * @param ray 
       * @param fromMatrix 
       * @returns 
       */
      rayPick(ray, fromMatrix) {
        let box = this.box;
        box.setFromCenterAndSize(this.center, this.size);
        let helpMatrix = ColliderShape.helpMatrix;
        helpMatrix.copy(fromMatrix).invert();
        let helpRay = ColliderShape.helpRay.copy(ray);
        helpRay.applyMatrix(helpMatrix);
        let pick = helpRay.intersectBox(this.box, ColliderShape.v3_help_0);
        if (pick) {
          if (!this._pickRet) {
            this._pickRet = { intersectPoint: new Vector3(), distance: 0 };
          }
          this._pickRet.intersectPoint = pick;
          this._pickRet.distance = Vector3.distance(helpRay.origin, ColliderShape.v3_help_0);
          return this._pickRet;
        }
        return null;
      }
    }

    class ColliderComponent extends ComponentBase {
      _shape;
      constructor() {
        super();
        this._shape = new BoxColliderShape();
      }
      /**
       * @internal
       */
      start() {
        const view = this.transform.scene3D?.view;
        if (view?.engine3D?.setting.pick.mode == `pixel`) {
          view.pickFire.mouseEnableMap.set(this.transform.worldMatrix.index, this);
        }
      }
      onEnable(view) {
        ComponentCollect.bindEnablePick(view, this, null);
      }
      onDisable(view) {
        ComponentCollect.unBindEnablePick(view, this);
      }
      /**
       * Returns the shape of collider
       */
      get shape() {
        return this._shape;
      }
      /**
       * Set the shape of collider
       */
      set shape(value) {
        this._shape = value;
      }
      /**
       * @internal
       * @param ray
       * @returns
       */
      rayPick(ray) {
        if (this._enable) {
          return this._shape.rayPick(ray, this.transform.worldMatrix);
        }
        return null;
      }
      beforeDestroy(force) {
        const view = this.transform.scene3D?.view;
        if (view?.engine3D?.setting.pick.mode == `pixel`) {
          view.pickFire.mouseEnableMap.delete(this.transform.worldMatrix.index);
        }
        super.beforeDestroy(force);
      }
    }

    class MirrorRenderShader extends Shader {
      constructor() {
        super();
        ShaderLib.register("MirrorShader", MirrorShader);
        const colorPass = new RenderShaderPass("MirrorShader", "MirrorShader");
        colorPass.passType = PassType.COLOR;
        colorPass.setShaderEntry("VertMain", "FragMain");
        this.addRenderPass(colorPass);
        const ss = colorPass.shaderState;
        ss.acceptShadow = false;
        ss.castShadow = false;
        ss.receiveEnv = false;
        ss.acceptGI = false;
        ss.useLight = false;
        ss.cullMode = GPUCullMode.back;
        this.setUniformVector4("transformUV1", new Vector4(0, 0, 1, 1));
        this.setUniformVector4("transformUV2", new Vector4(0, 0, 1, 1));
        this.setUniformColor("baseColor", new Color(1, 1, 1, 1));
        this.setUniformFloat("alphaCutoff", 0);
      }
    }
    class MirrorMaterial extends Material {
      /** Creates the material and binds a white placeholder until a capture RT is wired in. */
      constructor(_ctx) {
        super();
        this.shader = new MirrorRenderShader();
        const res = Engine3D.resFor(_ctx);
        this.mirrorMap = res.whiteTexture;
      }
      /** Capture render target sampled in screen space. Bind the texture
       *  produced by your mirror-camera's {@link SceneCaptureCameraComponent.getCaptureTexture}
       *  here. Defaults to a white placeholder. */
      set mirrorMap(texture) {
        this.shader.setTexture("mirrorMap", texture);
      }
      /** Gets the capture render target sampled in screen space. */
      get mirrorMap() {
        return this.shader.getTexture("mirrorMap");
      }
      /** Tint multiplied into the sampled reflection color (alpha
       *  ignored — the surface is opaque). Default white = unit
       *  passthrough. Use a slight desaturation / dim to read as
       *  "polished surface" rather than a 1:1 photo mirror. */
      set baseColor(color) {
        this.shader.setUniformColor("baseColor", color);
      }
      /** Gets the tint multiplied into the sampled reflection color. */
      get baseColor() {
        return this.shader.getUniformColor("baseColor");
      }
    }

    var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
    var __decorateClass$i = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SceneCaptureCameraComponent = class SceneCaptureCameraComponent extends ComponentBase {
      /** Capture render target width in pixels. Re-allocates the
       *  internal GBuffer on the next render if changed. */
      width = 512;
      /** Capture render target height in pixels. Re-allocates on
       *  change. */
      height = 512;
      /** Bitwise allowlist over {@link RendererMask}. A renderer is
       *  captured only if `(node.rendererMask & captureMask) !== 0`. */
      captureMask = 4294967295;
      /** Bitwise denylist over {@link RendererMask}. A renderer is
       *  skipped if `(node.rendererMask & excludeMask) !== 0`. */
      excludeMask = 0;
      /** RGBA clear color applied to the color attachment at the start
       *  of each capture. Depth always clears to 1.0. */
      clearColor = new Color(0, 0, 0, 1);
      /** Whether to render the scene's `AtmosphericComponent` / sky into
       *  the capture. Default true. */
      includeSky = true;
      /** Whether to render transparent renderers into the capture.
       *  Default true. */
      includeTransparent = true;
      /** See {@link SceneCaptureUpdateMode}. */
      updateMode = "always";
      /** Manual-mode trigger. SceneCapturePass clears this back to false
       *  after rendering. Ignored when `updateMode === 'always'`. */
      needUpdate = true;
      _camera = null;
      _gBuffer = null;
      _rendererPassState = null;
      _renderContext = null;
      _allocatedW = 0;
      _allocatedH = 0;
      /** Stable, per-component key for {@link GBufferFrame.getGBufferFrame}.
       *  Stamped lazily so unit tests that construct the component without
       *  a scene don't pull `Math.random()` into setup. */
      _gBufferKey = null;
      init() {
      }
      start() {
        this._camera = this.object3D.getComponent(Camera3D) ?? this.object3D.getComponentsInChild(Camera3D)?.[0] ?? null;
        if (!this._camera) {
          console.warn("[SceneCaptureCameraComponent] no Camera3D found on this Object3D or its descendants — capture will be a no-op.");
        }
      }
      onEnable(view) {
        if (!view) return;
        const scene = view.scene;
        if (scene) EntityCollect.instance.addSceneCaptureCamera(scene, this);
      }
      onDisable(view) {
        if (!view) return;
        const scene = view.scene;
        if (scene) EntityCollect.instance.removeSceneCaptureCamera(scene, this);
      }
      /** Active Camera3D driving the capture, or `null` if none was
       *  found at start(). SceneCapturePass skips components with a
       *  null camera. */
      get camera() {
        return this._camera;
      }
      /** Color render-target the capture writes into (rgba16float). The
       *  internal GBuffer is lazily allocated on first call; subsequent
       *  calls return the same handle so material samplers stay bound
       *  across frames. Re-allocates if {@link width} / {@link height}
       *  changed since the last allocation.
       *
       *  Returns null when called before any render has produced a
       *  GBuffer (i.e. the component isn't enabled or the pass hasn't
       *  fired yet). Most users want the post-render value — call this
       *  after `Engine3D.startRenderView` returns or read it inside an
       *  onUpdate hook.
       */
      getCaptureTexture() {
        return this._gBuffer?.getColorTexture() ?? null;
      }
      /** @internal — used by SceneCapturePass to lazily allocate /
       *  reuse the per-component render target chain. */
      _ensureRenderTargets(ctx) {
        if (this._gBuffer && this._rendererPassState && this._renderContext && this._allocatedW === this.width && this._allocatedH === this.height) {
          return {
            gBuffer: this._gBuffer,
            rendererPassState: this._rendererPassState,
            renderContext: this._renderContext
          };
        }
        if (this._gBuffer && this._rendererPassState && this._renderContext) {
          const w = this.width;
          const h = this.height;
          for (const rt of this._gBuffer.renderTargets) {
            rt.resize(w, h, ctx);
            rt.noticeChange?.();
          }
          if (this._gBuffer.depthTexture) {
            this._gBuffer.depthTexture.resize(w, h, ctx);
            this._gBuffer.depthTexture.noticeChange?.();
          }
          const colorDesc2 = this._gBuffer.rtDescriptors[0];
          if (colorDesc2) {
            colorDesc2.clearValue = [this.clearColor.r, this.clearColor.g, this.clearColor.b, this.clearColor.a];
          }
          this._allocatedW = w;
          this._allocatedH = h;
          return {
            gBuffer: this._gBuffer,
            rendererPassState: this._rendererPassState,
            renderContext: this._renderContext
          };
        }
        if (!this._gBufferKey) {
          this._gBufferKey = `sceneCapture_${this.object3D.instanceID}`;
        }
        this._gBuffer = GBufferFrame.getGBufferFrame(this._gBufferKey, ctx, this.width, this.height, true, void 0, 0);
        this._rendererPassState = WebGPUDescriptorCreator.createRendererPassState(ctx, this._gBuffer);
        const colorDesc = this._gBuffer.rtDescriptors[0];
        if (colorDesc) {
          colorDesc.clearValue = [this.clearColor.r, this.clearColor.g, this.clearColor.b, this.clearColor.a];
        }
        this._renderContext = new RenderContext(ctx, this._gBuffer);
        this._allocatedW = this.width;
        this._allocatedH = this.height;
        return {
          gBuffer: this._gBuffer,
          rendererPassState: this._rendererPassState,
          renderContext: this._renderContext
        };
      }
      destroy(force) {
        this._camera = null;
        this._gBuffer = null;
        this._rendererPassState = null;
        this._renderContext = null;
        super.destroy?.(force);
      }
    };
    exports.SceneCaptureCameraComponent = __decorateClass$i([
      RegisterComponent(exports.SceneCaptureCameraComponent, "SceneCaptureCameraComponent")
    ], exports.SceneCaptureCameraComponent);

    var __defProp = Object.defineProperty;
    var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
    var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __decorateClass$h = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    var __publicField = (obj, key, value) => __defNormalProp(obj, key + "" , value);
    exports.MirrorComponent = class MirrorComponent extends ComponentBase {
      /** Capture render-target width in pixels. Forwarded to
       *  {@link SceneCaptureCameraComponent.width}. Setting this after
       *  enable triggers an RT reallocation on the next frame. */
      width = 1024;
      /** Capture render-target height in pixels. */
      height = 1024;
      /** A world-space point lying on the mirror plane. Defaults to the
       *  host Object3D's world position on first start, so a flat floor
       *  needs no manual setup. Override before/after start to move the
       *  reflection plane independently of the host. */
      mirrorPlanePoint = new Vector3();
      /** Unit normal of the mirror plane in world space. Defaults to the
       *  host Object3D's world-space +Y axis (i.e. transform.up) on first
       *  start — matching a PlaneGeometry whose face is up. Override for
       *  tilted glass, vertical mirrors, etc. */
      mirrorPlaneNormal = new Vector3(0, 1, 0);
      /** The scene's main camera that this mirror reflects. When left
       *  null, resolves to {@link View3D.camera} on enable. Set
       *  explicitly if your scene swaps cameras at runtime. */
      mainCamera = null;
      /** World-space point the main camera looks at — the mirror camera
       *  is aimed at the reflection of this point across the mirror
       *  plane. Default is the world origin; override to match your
       *  camera controller's pivot (e.g. `HoverCameraController.setCamera`'s
       *  `target` argument). */
      mainTarget = new Vector3(0, 0, 0);
      _captureRoot = null;
      _captureCam = null;
      _capture = null;
      _material = null;
      _bound = false;
      _hostRenderer = null;
      _mirrorPos = new Vector3();
      _mirrorTarget = new Vector3();
      _mirrorUp = new Vector3();
      /** Live reference to the auto-created scene-capture component, in
       *  case advanced users want to tweak its properties (clearColor,
       *  includeSky, updateMode, …). Null until enable. */
      get captureComponent() {
        return this._capture;
      }
      /** The {@link MirrorMaterial} the component bound. Resolved from
       *  the host {@link MeshRenderer} on enable. Null if no
       *  MirrorMaterial was found (the component logs a warning and
       *  no-ops in that case). */
      get material() {
        return this._material;
      }
      start() {
        const view = this.transform?.view3D;
        if (!view) {
          console.warn("[MirrorComponent] no view3D in start — mirror disabled.");
          return;
        }
        this._setup(view);
      }
      onEnable(_view) {
        if (this._capture) this._capture.enable = true;
      }
      onDisable(_view) {
        if (this._capture) this._capture.enable = false;
      }
      onUpdate(_view) {
        if (!this._captureCam || !this._captureRoot || !this.mainCamera) return;
        this._reflectPoint(this.mainCamera.transform.worldPosition, this._mirrorPos);
        this._reflectPoint(this.mainTarget, this._mirrorTarget);
        this._reflectDirection(Vector3.UP, this._mirrorUp);
        this._captureRoot.transform.lookAt(this._mirrorPos, this._mirrorTarget, this._mirrorUp);
        this._captureRoot.transform.localPosition = this._mirrorPos;
        this._captureRoot.transform.updateWorldMatrix(true);
        if (!this._bound && this._material && this._capture) {
          const tex = this._capture.getCaptureTexture();
          if (tex) {
            this._material.mirrorMap = tex;
            this._bound = true;
          }
        }
      }
      _setup(view) {
        const tr = this.object3D.transform;
        this.mirrorPlanePoint.copy(tr.worldPosition);
        this.mirrorPlaneNormal.copy(tr.up).normalize();
        this._hostRenderer = this.object3D.getComponent(exports.MeshRenderer);
        if (!this._hostRenderer) {
          console.warn("[MirrorComponent] no MeshRenderer found on host Object3D — mirror disabled.");
          return;
        }
        const mat = this._hostRenderer.material;
        if (!(mat instanceof MirrorMaterial)) {
          console.warn("[MirrorComponent] host MeshRenderer.material must be a MirrorMaterial — mirror disabled.");
          return;
        }
        this._material = mat;
        this._hostRenderer.rendererMask = RendererMaskUtil.addMask(
          this._hostRenderer.rendererMask,
          exports.MirrorComponent.MIRROR_MASK
        );
        if (!this.mainCamera) {
          this.mainCamera = view.camera;
          this.mainTarget = view.camera.lookTarget;
        }
        if (!this.mainCamera) {
          console.warn("[MirrorComponent] no main camera — set mainCamera explicitly or attach the view first.");
          return;
        }
        this._captureRoot = new exports.Object3D();
        this._captureRoot.name = "MirrorComponent.captureRoot";
        this._captureCam = this._captureRoot.addComponent(Camera3D);
        this._captureCam.perspective(
          this.mainCamera.fov,
          this.mainCamera.aspect,
          this.mainCamera.near,
          this.mainCamera.far
        );
        this._capture = this._captureRoot.addComponent(exports.SceneCaptureCameraComponent);
        this._capture.width = this.width;
        this._capture.height = this.height;
        this._capture.excludeMask = exports.MirrorComponent.MIRROR_MASK;
        view.scene.addChild(this._captureRoot);
        this._bound = false;
      }
      /** Reflect a world-space point across (mirrorPlanePoint, mirrorPlaneNormal).
       *  A' = A − 2 · ((A − P) · N) · N. Result is written into `out`. */
      _reflectPoint(p, out) {
        const N = this.mirrorPlaneNormal;
        const P = this.mirrorPlanePoint;
        const dx = p.x - P.x, dy = p.y - P.y, dz = p.z - P.z;
        const d = dx * N.x + dy * N.y + dz * N.z;
        out.set(p.x - 2 * d * N.x, p.y - 2 * d * N.y, p.z - 2 * d * N.z);
      }
      /** Reflect a world-space direction across the mirror plane normal.
       *  D' = D − 2 · (D · N) · N. Result is written into `out`. */
      _reflectDirection(dir, out) {
        const N = this.mirrorPlaneNormal;
        const k = dir.x * N.x + dir.y * N.y + dir.z * N.z;
        out.set(dir.x - 2 * k * N.x, dir.y - 2 * k * N.y, dir.z - 2 * k * N.z);
      }
      destroy(force) {
        if (this._captureRoot) {
          const parent = this._captureRoot.parent && this._captureRoot.parent.object3D;
          if (parent) parent.removeChild(this._captureRoot);
        }
        this._captureRoot = null;
        this._captureCam = null;
        this._capture = null;
        this._material = null;
        this._hostRenderer = null;
        super.destroy?.(force);
      }
    };
    /**
     * Custom {@link RendererMask} bit reserved for "this is a mirror
     * surface and should not appear in other mirrors". Bit 11 is
     * unclaimed by the engine's built-in mask values (highest is
     * {@link RendererMask.Graphic3D} = `1 << 10`). Exposed so user
     * code can check / clear it on hand-managed renderers.
     */
    __publicField(exports.MirrorComponent, "MIRROR_MASK", 1 << 11);
    exports.MirrorComponent = __decorateClass$h([
      RegisterComponent(exports.MirrorComponent, "MirrorComponent")
    ], exports.MirrorComponent);

    class SkeletonAnimationClipState {
      loop = true;
      speed = 1;
      t = 0;
      time = 0;
      weight = 0;
      currFrame = 0;
      lastFrame = -1;
      nextFrame = 0;
      clip;
      animation;
      _isEnd = false;
      _currSkeletonPose;
      constructor(clip) {
        this.clip = clip;
        this._currSkeletonPose = new SkeletonPose(this.clip.skeleton);
      }
      reset() {
        this.time = 0;
        this.weight = 0;
        this._isEnd = false;
      }
      /** 
      * Returns animation clip's name.
      */
      get name() {
        return this.clip.name;
      }
      /** 
      * Returns current skeleton pose.
      */
      get currSkeletonPose() {
        return this._currSkeletonPose;
      }
      /** 
      * update animation clip, it will change key frame to sample animation clip.
      * @param delta time from last frame to now
      */
      update(delta) {
        this.time = (this.time + delta * this.speed) % this.clip.totalTime;
        let frameTime = this.time / this.clip.frameRate;
        this.currFrame = Math.trunc(frameTime);
        this.t = frameTime - this.currFrame;
        if (this.currFrame < 0) {
          this.currFrame = this.clip.numFrame + this.currFrame;
        }
        if (this.time >= 0) {
          this.nextFrame = (this.currFrame + 1) % this.clip.numFrame;
        } else {
          this.nextFrame = this.currFrame - 1;
          if (this.nextFrame < 0) {
            this.nextFrame = this.clip.numFrame + this.nextFrame;
          }
          this.t = 1 - this.t;
        }
        if (this._isEnd) {
          this.currFrame = this.nextFrame = this.speed < 0 ? 0 : this.clip.numFrame - 1;
        } else if (this.currFrame != this.lastFrame) {
          let endFrame = this.speed < 0 ? 0 : this.clip.numFrame;
          if (this.currFrame == endFrame) {
            if (this.loop) {
              this.currFrame = 0;
              this.nextFrame = 1;
              this.time = this.t = 0;
            } else {
              this.currFrame = this.nextFrame = this.speed < 0 ? 0 : this.clip.numFrame - 1;
              this._isEnd = true;
            }
          }
          var events = this.clip.getEvents();
          if (events) {
            for (let event of events) {
              var triggerFrame = Math.floor(event.time / this.clip.frameRate);
              triggerFrame = Math.min(triggerFrame, this.clip.numFrame);
              triggerFrame = Math.max(triggerFrame, 0);
              if (triggerFrame == this.currFrame) {
                event.animator = this.animation;
                this.animation.eventDispatcher.dispatchEvent(event);
                break;
              }
            }
          }
          this.lastFrame = this.currFrame;
        }
        this.clip.getLerpSkeletonPose(this.currFrame, this.nextFrame, this.t, this._currSkeletonPose);
      }
    }

    var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
    var __decorateClass$g = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SkeletonAnimationComponent = class SkeletonAnimationComponent extends ComponentBase {
      /**
       * Whether it is playing
       */
      isPlaying = true;
      /**
       * Global animation time scaling
       */
      timeScale = 1;
      _skeleton;
      _clips = [];
      _clipStates = /* @__PURE__ */ new Map();
      _mixSkeletonPose;
      _mixTempSkeletonPose;
      _currentClipState;
      _bindList = [];
      _jointMatrixIndexTableBuffer;
      _crossFadeState;
      constructor() {
        super();
      }
      start() {
      }
      /**
       * The name of the currently playing animation
       */
      get currName() {
        if (this._currentClipState) {
          return this._currentClipState.name;
        }
        return "";
      }
      /**
       * Skeleton data
       */
      set skeleton(value) {
        this._skeleton = value;
        this._mixSkeletonPose = new SkeletonPose(this._skeleton, true);
        this._mixTempSkeletonPose = new SkeletonPose(this._skeleton);
        const jointMatrixIndexTable = new Float32Array(this._mixSkeletonPose.jointMatrixIndexTable);
        this._jointMatrixIndexTableBuffer = new StorageGPUBuffer(this._skeleton.numJoint * 4, 0, jointMatrixIndexTable);
      }
      /**
       * Skeleton data
       */
      get skeleton() {
        return this._skeleton;
      }
      /**
       * Current final skeleton posture data
       */
      get finalSkeletonPose() {
        return this._mixSkeletonPose;
      }
      /**
       * Bone matrix index table data
       */
      get jointMatrixIndexTableBuffer() {
        return this._jointMatrixIndexTableBuffer;
      }
      /**
       * Get the bone index information by the bone name
       * @param skinJointsName bone name
       * @returns bone index
       */
      getJointIndexTable(skinJointsName) {
        let result = new Array();
        for (let i = 0; i < skinJointsName.length; i++) {
          const name = skinJointsName[i];
          let joint = this._skeleton.getJointByName(name);
          result[i] = joint ? joint.index : -1;
        }
        return result;
      }
      /**
       * Add a skeleton animation clip
       * @param clip Skeletal animation clip
       */
      addAnimationClip(clip) {
        if (!this._clipStates.has(clip.name)) {
          this._clips.push(clip);
          let clipState = new SkeletonAnimationClipState(clip);
          clipState.animation = this;
          this._clipStates.set(clip.name, clipState);
          if (!this._currentClipState) {
            this.setCurrentClipState(clipState);
          }
        }
      }
      /**
       * Gets the animation clip data object with the specified name
       * @param name Name of animation
       * @returns Animation clip data object
       */
      getAnimationClip(name) {
        var clipState = this.getAnimationClipState(name);
        if (clipState) {
          return clipState.clip;
        }
        return null;
      }
      /**
       * Gets all animation clip data objects
       * @returns Animation clip data object
       */
      getAnimationClips() {
        return this._clips;
      }
      /**
       * Gets the animation clip state object with the specified name
       * @param name Name of animation
       * @returns Animation clip state object
       */
      getAnimationClipState(name) {
        if (this._clipStates.has(name)) {
          return this._clipStates.get(name);
        }
        return null;
      }
      /**
       * Gets all animation clip state objects
       * @returns Animation clip state object
       */
      getAnimationClipStates() {
        return this._clipStates;
      }
      /**
       * stop playing
       */
      pause() {
        this.isPlaying = false;
      }
      /**
       * Resume playback
       */
      resume() {
        this.isPlaying = true;
      }
      /**
       * Play the specified animation
       * @param animName The data set name for the animation
       * @param speed Animation playback speed, default value is 1.0
       * @param reset When true, each play starts with the first frame
       * @returns
       */
      play(animName, speed = 1, reset = false) {
        if (this._currentClipState && this._currentClipState.name == animName) {
          if (reset) {
            this._currentClipState.reset();
          }
          return false;
        }
        let clipState = this.getAnimationClipState(animName);
        if (!clipState) {
          return false;
        }
        clipState.speed = speed;
        clipState.reset();
        this._clipStates.forEach((clipState2, name) => {
          clipState2.weight = 0;
        });
        this.setCurrentClipState(clipState);
        return true;
      }
      /**
       * Fades the current animation and fades into another animation state for a specified time.
       * @param animName The name of the animation to fade in.
       * @param crossTime The time of transition, in seconds.
       * @returns
       */
      crossFade(animName, crossTime) {
        if (crossTime < 0.01) {
          this.play(animName);
          return;
        }
        if (this._currentClipState.name == animName) {
          return;
        }
        let clipState = this.getAnimationClipState(animName);
        if (!clipState) {
          return;
        }
        clipState.reset();
        if (this._crossFadeState) {
          if (this._crossFadeState.inClip) {
            this._crossFadeState.inClip.weight = 0;
          }
          if (this._crossFadeState.outClip) {
            this._crossFadeState.outClip.weight = 0;
          }
          this._crossFadeState.reset(clipState, this._currentClipState, crossTime);
        } else {
          this._crossFadeState = new SkeletonAnimationCrossFadeState(
            clipState,
            this._currentClipState,
            crossTime
          );
        }
        this._currentClipState = clipState;
      }
      /**
       * Set the animation loop
       * @param animName The data set name for the animation
       * @param isLoop   If true, loop the animation
       */
      setAnimIsLoop(animName, isLoop) {
        if (this._clipStates.has(animName)) {
          this._clipStates.get(animName).loop = isLoop;
        }
      }
      /**
       * Add joint bindings to the object
       * @param jointName Name of joint
       * @param obj       Object of binding
       */
      addJointBind(jointName, obj) {
        this._bindList.push({
          jointName,
          obj
        });
      }
      /**
       * Removes the joint binding of the specified object
       * @param jointName Name of joint
       * @param obj Object of binding
       */
      removeJointBind(obj) {
        for (let index = 0; index < this._bindList.length; index++) {
          let item = this._bindList[index];
          if (item.obj == obj) {
            this._bindList.splice(index, 1);
            break;
          }
        }
      }
      /**
       * @internal
       */
      onUpdate() {
        if (!this.isPlaying) {
          return;
        }
        let delta = Time.delta * 1e-3 * this.timeScale;
        if (this._crossFadeState) {
          this._crossFadeState.update(delta);
        }
        var totalWeight = 0;
        var mixClipState = [];
        this._clipStates.forEach((clipState, name) => {
          if (clipState.weight > 0) {
            clipState.update(delta);
            totalWeight += clipState.weight;
            mixClipState.push(clipState);
          }
        });
        if (mixClipState.length > 0) {
          this._mixSkeletonPose.copy(mixClipState[0].currSkeletonPose);
          for (var i = 1; i < mixClipState.length; ++i) {
            const clipState = mixClipState[i];
            this._mixTempSkeletonPose.lerp(this._mixSkeletonPose, clipState.currSkeletonPose, clipState.weight / totalWeight);
            this._mixSkeletonPose.copy(this._mixTempSkeletonPose);
          }
        }
      }
      /**
       * Clones the current component to the specified object
       * @param obj target object
       */
      cloneTo(obj) {
        let animator = obj.addComponent(exports.SkeletonAnimationComponent);
        animator.skeleton = this.skeleton;
        for (var i = 0; i < this._clips.length; ++i) {
          animator.addAnimationClip(this._clips[i]);
        }
      }
      setCurrentClipState(clipState) {
        if (this._currentClipState == clipState) {
          return;
        }
        this._currentClipState = clipState;
        this._currentClipState.weight = 1;
      }
    };
    exports.SkeletonAnimationComponent = __decorateClass$g([
      RegisterComponent(exports.SkeletonAnimationComponent, "SkeletonAnimationComponent")
    ], exports.SkeletonAnimationComponent);
    class SkeletonAnimationCrossFadeState {
      inClip;
      outClip;
      currentTime;
      crossFadeTime;
      constructor(inClip, outClip, time) {
        this.reset(inClip, outClip, time);
      }
      reset(inClip, outClip, time) {
        this.inClip = inClip;
        this.outClip = outClip;
        this.currentTime = 0;
        this.crossFadeTime = time;
      }
      update(delta) {
        if (!this.inClip || !this.outClip) {
          return;
        }
        this.currentTime += delta;
        this.inClip.weight = Math.min(Math.abs(this.currentTime % this.crossFadeTime) / this.crossFadeTime, 1);
        this.outClip.weight = 1 - this.inClip.weight;
        if (Math.abs(this.currentTime) >= this.crossFadeTime) {
          this.inClip.weight = 1;
          this.outClip.weight = 0;
          this.inClip = null;
          this.outClip = null;
        }
      }
    }

    var LayerBlendMode = /* @__PURE__ */ ((LayerBlendMode2) => {
      LayerBlendMode2[LayerBlendMode2["Override"] = 0] = "Override";
      LayerBlendMode2[LayerBlendMode2["Additive"] = 1] = "Additive";
      return LayerBlendMode2;
    })(LayerBlendMode || {});
    class AnimationLayer {
      name;
      weight;
      blendMode;
      mask;
      /** Active clip name on this layer. Empty → layer is paused. */
      clipName = "";
      /** Layer-local playback time, in seconds. */
      time = 0;
      /** Layer-local time scale (multiplied into the global timeScale). */
      timeScale = 1;
      /** When false, time does not advance. */
      playing = true;
      // ----- Internal cache populated by AnimatorComponent.updateLayers() -----
      // ----- on the first frame the layer is processed. Mutable so the     -----
      // ----- AnimatorComponent can update them when clipName changes.      -----
      /** First-keyframe time of the resolved clip (for makeClipAdditive math). */
      _firstKeyTime = 0;
      /** Last-keyframe time of the resolved clip. */
      _lastKeyTime = 0;
      /** Whether the resolved clip is a static pose (short span / 2 keyframes). */
      _isStaticPose = false;
      /** Set to true once the layer has been resolved against its clip. */
      _resolved = false;
      constructor(name, weight = 1, blendMode = 0 /* Override */, mask = null) {
        this.name = name;
        this.weight = weight;
        this.blendMode = blendMode;
        this.mask = mask;
      }
    }

    var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
    var __decorateClass$f = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.AnimatorComponent = class AnimatorComponent extends ComponentBase {
      /** Global playback speed multiplier applied to all clips and layers. */
      timeScale = 1;
      /** GPU buffer mapping joints to their world-matrix indices. */
      jointMatrixIndexTableBuffer;
      /** Whether the blend-shape (morph) animation loops. */
      playBlendShapeLoop = false;
      inverseBindMatrices;
      _avatar;
      _rendererList;
      // Cache of resolved blend-shape setters: per renderer, a map keyed by
      // morph-target name to a closure that writes the influence value.
      // Compiled lazily on first dispatch (the renderer list isn't known until
      // start), then reused every frame to avoid string-property reflection.
      propertyCache;
      _clips;
      _clipsState;
      _clipsMap;
      _currentSkeletonClip;
      _currentBlendAnimClip;
      _skeletonTime = 0;
      _blendShapeTime = 0;
      _skeletonSpeed = 1;
      _blendShapeSpeed = 1;
      _skeletonStart = true;
      _blendShapeStart = true;
      root;
      _avatarName;
      _bonePos = new Vector3();
      _boneScale = new Vector3();
      _boneRot = new Quaternion();
      _crossFadeState;
      /** Stacked override / additive layers (excluding the implicit base layer 0). */
      _layers = [];
      /** Optional state machine. evaluate() runs every frame before sampling. */
      _stateMachine = null;
      /** IK solvers, run after layer mix. */
      _ikSolvers = [];
      _retargeter;
      /** Collect skinned/morph renderers in the hierarchy and prepare caches. */
      init(param) {
        this.propertyCache = /* @__PURE__ */ new Map();
        this._clipsMap = /* @__PURE__ */ new Map();
        this._clips = [];
        this._clipsState = [];
        this._rendererList = this.object3D.getComponentsInChild(exports.SkinnedMeshRenderer2);
        let mrs = this.object3D.getComponentsInChild(exports.MeshRenderer);
        for (let mr of mrs) {
          let o = mr;
          o.blendShape = mr.morphData;
          this._rendererList.push(o);
        }
        for (const renderer of this._rendererList) {
          let hasMorphTarget = RendererMaskUtil.hasMask(renderer.rendererMask, RendererMask.MorphTarget);
          if (hasMorphTarget) {
            renderer.selfCloneMaterials("MORPH_TARGET_UUID");
          }
        }
      }
      /** Re-parent the skeleton root once the (possibly cloned) hierarchy is wired. */
      start() {
        if (this.root && !this.root.parent) {
          const gltfParent = this.object3D.parent ? this.object3D.parent.object3D : null;
          if (gltfParent) {
            gltfParent.addChild(this.root);
          } else if (this.object3D.transform.scene3D) {
            this.object3D.transform.scene3D.addChild(this.root);
          }
        }
      }
      debug() {
      }
      /**
       * Play a skeleton animation clip immediately.
       * @param anim clip name
       * @param time start time in seconds
       * @param speed playback speed multiplier
       */
      playAnim(anim, time = 0, speed = 1) {
        let clipState = this.getAnimationClipState(anim);
        if (clipState) {
          if (this._currentSkeletonClip) {
            this._currentSkeletonClip.weight = 0;
          }
          this._currentSkeletonClip = clipState;
          this._currentSkeletonClip.weight = 1;
          this._skeletonTime = time;
          this._skeletonSpeed = speed;
          this._skeletonStart = true;
        } else {
          console.warn(`not has anim ${anim}`);
        }
      }
      /**
       * Cross-fade from the current clip to another over `crossTime` seconds.
       * @param anim destination clip name
       * @param crossTime fade duration in seconds
       */
      crossFade(anim, crossTime) {
        let clipState = this.getAnimationClipState(anim);
        if (!clipState) {
          console.warn(`not has anim ${anim}`);
          return;
        }
        if (crossTime < 0.01 || !this._currentSkeletonClip) {
          this.playAnim(anim);
          return;
        }
        if (this._currentSkeletonClip && this._currentSkeletonClip.clip.clipName === anim) {
          return;
        }
        let inClip = clipState;
        let outClip = this._currentSkeletonClip;
        if (this._crossFadeState) {
          if (this._crossFadeState.inClip) {
            this._crossFadeState.inClip.weight = 0;
          }
          if (this._crossFadeState.outClip) {
            this._crossFadeState.outClip.weight = 0;
          }
          this._crossFadeState.reset(inClip, outClip, crossTime);
        } else {
          this._crossFadeState = new SkeletonAnimCrossFadeState(inClip, outClip, crossTime);
        }
        this._currentSkeletonClip = inClip;
      }
      /**
       * Play a blend-shape (morph) animation clip.
       * @param shapeName blend-shape clip name
       * @param time start time in seconds
       * @param speed playback speed multiplier
       */
      playBlendShape(shapeName, time = 0, speed = 1) {
        if (this._clipsMap.has(shapeName)) {
          this._currentBlendAnimClip = this._clipsMap.get(shapeName);
          this._blendShapeTime = time;
          this._blendShapeSpeed = speed;
          this._blendShapeStart = true;
        } else {
          console.warn(`not has blendShape ${shapeName}`);
        }
      }
      /**
       * Drive another animator's skeleton from this one via retargeting.
       * Pass `null` to stop retargeting.
       * @param target the animator to drive, or null to clear
       * @param cfg optional retargeting configuration
       */
      retargetTo(target, cfg) {
        if (target) {
          for (const cs of target.clipsState) cs.weight = 0;
          target._currentSkeletonClip = null;
          this._retargeter = new Retargeter(this, target, cfg ?? {});
        } else {
          this._retargeter = null;
        }
      }
      /** Assign the avatar (skeleton) by registered resource name and build its pose. */
      set avatar(name) {
        this._avatarName = name;
        this.inverseBindMatrices = [];
        const ctx = this.transform?.view3D?.engine3D?.context3D;
        this._avatar = Engine3D.resFor(ctx).getObj(name);
        let jointMapping = this.buildSkeletonPose();
        const jointMatrixIndexTable = new Float32Array(jointMapping);
        this.jointMatrixIndexTableBuffer = new StorageGPUBuffer(this._avatar.count, 0, jointMatrixIndexTable);
      }
      /** Number of joints in the current avatar. */
      get numJoint() {
        return this._avatar.count;
      }
      /**
       * Map a list of skin joint names to their avatar bone IDs (-1 if absent).
       * @param skinJointsName joint names in skin order
       */
      getJointIndexTable(skinJointsName) {
        let result = new Array();
        for (let i = 0; i < skinJointsName.length; i++) {
          let joint = this._avatar.boneMap.get(skinJointsName[i]);
          result[i] = joint ? joint.boneID : -1;
        }
        return result;
      }
      skeltonPoseObject3D = {};
      skeltonTPoseObject3D = {};
      buildSkeletonPose() {
        let list = [];
        this.skeltonPoseObject3D = {};
        this.skeltonTPoseObject3D = {};
        for (const joint of this._avatar.boneData) {
          let obj = new exports.Object3D();
          Matrix4.getEuler(Vector3.HELP_6, joint.q, true, "ZYX");
          obj.localPosition = joint.t.clone();
          obj.localRotation = Vector3.HELP_6.clone();
          obj.localScale = Vector3.ONE;
          joint.s.clone();
          this.skeltonPoseObject3D[joint.boneName] = obj;
          this.skeltonTPoseObject3D[joint.bonePath] = obj.clone();
          if (joint.parentBoneName && joint.parentBoneName != "") {
            this.skeltonPoseObject3D[joint.parentBoneName].addChild(obj);
          } else {
            const gltfParent = this.object3D.parent ? this.object3D.parent.object3D : null;
            if (gltfParent) {
              gltfParent.addChild(obj);
            } else if (this.object3D.transform.scene3D) {
              this.object3D.transform.scene3D.addChild(obj);
            }
            this.root = obj;
          }
          list.push(obj.transform.worldMatrix.index);
          let local = new Matrix4();
          local.copy(obj.transform.worldMatrix);
          local.invert();
          this.inverseBindMatrices.push(local.rawData);
        }
        for (const joint of this._avatar.boneData) {
          const obj = this.skeltonPoseObject3D[joint.boneName];
          if (obj) obj.transform.updateWorldMatrix(true);
        }
        return list;
      }
      /** Assign the animation clips, building per-clip state and auto-playing the first. */
      set clips(clips) {
        this._clips = clips;
        for (const clip of clips) {
          this._clipsMap.set(clip.clipName, clip);
        }
        this._clipsState = [];
        for (const clip of clips) {
          this._clipsState.push(new PropertyAnimationClipState(clip));
        }
        if (!this._currentSkeletonClip && clips.length > 0) {
          this.playAnim(clips[0].clipName);
        }
      }
      /** The animation clips assigned to this animator. */
      get clips() {
        return this._clips;
      }
      /** Per-clip playback state (weights, etc.). */
      get clipsState() {
        return this._clipsState;
      }
      /** Clone this animator (avatar + clips) onto another object. */
      cloneTo(obj) {
        let animatorComponent = obj.addComponent(exports.AnimatorComponent);
        animatorComponent.avatar = this._avatarName;
        animatorComponent.clips = this._clips;
      }
      updateTime() {
        const delta = Time.delta * 1e-3;
        if (this._skeletonStart) {
          this._skeletonTime += delta * this._skeletonSpeed * this.timeScale;
          if (this._currentSkeletonClip && this._currentSkeletonClip.clip.loopTime) {
            this._skeletonTime = this._skeletonTime % this._currentSkeletonClip.clip.stopTime;
          }
        }
        if (this._blendShapeStart) {
          this._blendShapeTime += delta * this._blendShapeSpeed;
          if (this._currentBlendAnimClip) {
            if (this._currentBlendAnimClip.loopTime && this.playBlendShapeLoop) {
              this._blendShapeTime = this._blendShapeTime % this._currentBlendAnimClip.stopTime;
            } else {
              this._blendShapeTime = Math.min(this._blendShapeTime, this._currentBlendAnimClip.stopTime) - 1e-4;
            }
          }
        }
        if (this._crossFadeState) {
          this._crossFadeState.update(delta);
        }
      }
      /** Per-frame update: advance time, sample clips, apply layers, IK and morphs. */
      onUpdate(view) {
        const delta = Time.delta * 1e-3;
        if (this._stateMachine) this._stateMachine.evaluate(this, delta);
        this.updateTime();
        if (this._retargeter) {
          this._retargeter.apply();
        }
        let mixClip = [];
        for (let clipState of this._clipsState) {
          if (clipState.weight > 0) {
            mixClip.push(clipState);
          }
        }
        if (mixClip.length > 0) {
          this.updateSkeletonAnimMix(mixClip);
        } else {
          this.updateSkeletonAnim();
        }
        if (this._layers.length > 0) {
          this.updateLayers(delta);
        }
        for (const solver of this._ikSolvers) solver.solve(this);
        this.updateMorphAnim();
      }
      updateSkeletonAnim() {
        if (this._currentSkeletonClip) {
          let joints = this._avatar.boneData;
          let i = 0;
          let len = joints.length;
          const hasLayers = this._layers.length > 0;
          for (i = 0; i < len; i++) {
            const joint = joints[i];
            let obj = this.skeltonPoseObject3D[joint.boneName];
            if (this._currentSkeletonClip.clip.useSkeletonPos || hasLayers) {
              let pos = this.getPosition(joint.bonePath, this._skeletonTime);
              obj.transform.localPosition = pos;
            }
            let rot = this.getRotation(joint.bonePath, this._skeletonTime);
            obj.transform.localRotQuat = rot;
            if (this._currentSkeletonClip.clip.useSkeletonScale || hasLayers) {
              let scale = this.getScale(joint.bonePath, this._skeletonTime);
              obj.transform.localScale = scale;
            }
          }
        } else if (this._avatar) {
          const joints = this._avatar.boneData;
          for (let i = 0; i < joints.length; i++) {
            const obj = this.skeltonPoseObject3D[joints[i].boneName];
            if (obj) obj.transform.updateWorldMatrix(true);
          }
        }
      }
      updateMorphAnim() {
        if (this._currentBlendAnimClip && this._currentBlendAnimClip.floatCurves) {
          if (this._currentBlendAnimClip.floatCurves.size > 0 && this._rendererList) {
            for (const iterator of this._currentBlendAnimClip.floatCurves) {
              let key = iterator[0];
              let curve = iterator[1];
              let attributes = curve.propertys;
              let x = this._currentBlendAnimClip.floatCurves.get(key).getValue(this._blendShapeTime);
              let value = x / 100;
              this.updateBlendShape(attributes, key, value);
            }
          }
        }
      }
      /**
       * Apply a blend-shape influence to all renderers, caching the resolved
       * setter per renderer to avoid per-frame property reflection.
       * @param attributes property path to the setter
       * @param key morph target name (cache key)
       * @param value influence value in [0,1]
       */
      updateBlendShape(attributes, key, value) {
        for (const renderer of this._rendererList) {
          if (!renderer.blendShape) continue;
          let bucket = this.propertyCache.get(renderer);
          if (!bucket) {
            bucket = /* @__PURE__ */ new Map();
            this.propertyCache.set(renderer, bucket);
          }
          let setter = bucket.get(key);
          if (setter) {
            setter(value);
            continue;
          }
          let target = renderer;
          let resolved = true;
          for (const att of attributes) {
            if (!target[att]) {
              resolved = false;
              break;
            }
            target = target[att];
          }
          if (!resolved || target === renderer || typeof target !== "function") continue;
          const fn = target;
          bucket.set(key, fn);
          fn(value);
        }
      }
      updateSkeletonAnimMix(mixClip) {
        let totalWeight = 0;
        for (let clip of mixClip) {
          totalWeight += clip.weight;
        }
        if (mixClip.length > 0) {
          let joints = this._avatar.boneData;
          let len = joints.length;
          const hasLayers = this._layers.length > 0;
          const anyClipHasPos = hasLayers || mixClip.some((c) => c.clip.useSkeletonPos);
          const anyClipHasScale = hasLayers || mixClip.some((c) => c.clip.useSkeletonScale);
          for (let i = 0; i < len; i++) {
            const joint = joints[i];
            let obj = this.skeltonPoseObject3D[joint.boneName];
            if (anyClipHasPos) {
              this._bonePos.copy(this.getPosition(joint.bonePath, this._skeletonTime, mixClip[0].clip));
              for (let i2 = 1; i2 < mixClip.length; i2++) {
                const clipState = mixClip[i2];
                let pos = this.getPosition(joint.bonePath, this._skeletonTime, clipState.clip);
                Vector3.HELP_0.lerp(this._bonePos, pos, clipState.weight / totalWeight);
                this._bonePos.copy(Vector3.HELP_0);
              }
              obj.transform.localPosition = this._bonePos;
            }
            this._boneRot.copy(this.getRotation(joint.bonePath, this._skeletonTime, mixClip[0].clip));
            for (let i2 = 1; i2 < mixClip.length; i2++) {
              const clipState = mixClip[i2];
              let rot = this.getRotation(joint.bonePath, this._skeletonTime, clipState.clip);
              Quaternion.HELP_2.slerp(this._boneRot, rot, clipState.weight / totalWeight);
              this._boneRot.copy(Quaternion.HELP_2);
            }
            obj.transform.localRotQuat = this._boneRot;
            if (anyClipHasScale) {
              this._boneScale.copy(this.getScale(joint.bonePath, this._skeletonTime, mixClip[0].clip));
              for (let i2 = 1; i2 < mixClip.length; i2++) {
                const clipState = mixClip[i2];
                let scale = this.getScale(joint.bonePath, this._skeletonTime, clipState.clip);
                Vector3.HELP_0.lerp(this._boneScale, scale, clipState.weight / totalWeight);
                this._boneScale.copy(Vector3.HELP_0);
              }
              obj.transform.localScale = this._boneScale;
            }
          }
        }
      }
      getPosition(boneName, time, clip = this._currentSkeletonClip.clip) {
        if (clip.positionCurves.has(boneName)) {
          let t = clip.positionCurves.get(boneName).getValue(time);
          return t;
        }
        return this.skeltonTPoseObject3D[boneName].localPosition;
      }
      getRotation(boneName, time, clip = this._currentSkeletonClip.clip) {
        if (clip.rotationCurves.has(boneName)) {
          let v4 = clip.rotationCurves.get(boneName).getValue(time);
          Quaternion.HELP_0.set(v4.x, v4.y, v4.z, v4.w);
          return Quaternion.HELP_0;
        }
        return this.skeltonTPoseObject3D[boneName].localQuaternion;
      }
      getScale(boneName, time, clip = this._currentSkeletonClip.clip) {
        if (clip.scaleCurves.has(boneName)) {
          let x = clip.scaleCurves.get(boneName).getValue(time);
          return x;
        }
        return this.skeltonTPoseObject3D[boneName].localScale;
      }
      /**
       * Gets the animation clip data object with the specified name
       * @param name Name of animation
       * @returns Animation clip data object
       */
      getAnimationClipState(name) {
        for (let clipState of this._clipsState) {
          if (clipState.clip.clipName === name) {
            return clipState;
          }
        }
        return null;
      }
      /** Group the morph renderers by morph-target key. */
      cloneMorphRenderers() {
        let dst = {};
        for (const renderer of this._rendererList) {
          for (const key in renderer.geometry.morphTargetDictionary) {
            let renderList = dst[key] || [];
            renderList.push(renderer);
            dst[key] = renderList;
          }
        }
        return dst;
      }
      // ------------------------------------------------------------------
      //  Layer / Mask API (P1)
      // ------------------------------------------------------------------
      /** Get a stacked animation layer by name, or null if absent. */
      getLayer(name) {
        return this._layers.find((l) => l.name === name) || null;
      }
      /** All stacked layers (excluding the implicit base layer). */
      get layers() {
        return this._layers;
      }
      /** Add a stacked animation layer (ignored if a layer with that name exists). */
      addLayer(layer) {
        if (this._layers.find((l) => l.name === layer.name)) {
          console.warn(`AnimatorComponent: layer '${layer.name}' already exists`);
          return this.getLayer(layer.name);
        }
        this._layers.push(layer);
        return layer;
      }
      /** Remove a stacked animation layer by name. */
      removeLayer(name) {
        const idx = this._layers.findIndex((l) => l.name === name);
        if (idx >= 0) this._layers.splice(idx, 1);
      }
      /** Set the blend weight of a named layer. */
      setLayerWeight(name, weight) {
        const l = this.getLayer(name);
        if (l) l.weight = weight;
      }
      /**
       * Set (and start) the clip playing on a named layer.
       * @param name layer name
       * @param clipName clip to play on the layer
       * @param time start time in seconds
       * @param timeScale layer-local time scale
       */
      setLayerClip(name, clipName, time = 0, timeScale = 1) {
        const l = this.getLayer(name);
        if (!l) return;
        l.clipName = clipName;
        l.time = time;
        l.timeScale = timeScale;
        l.playing = true;
      }
      _layerRot = new Quaternion();
      _layerDeltaQuat = new Quaternion();
      _layerInvBaseQuat = new Quaternion();
      _layerSlerpedQuat = new Quaternion();
      _layerIdentityQuat = new Quaternion(0, 0, 0, 1);
      _layerOutQuat = new Quaternion();
      /**
       * After the base pose has been written to the joint Object3Ds, apply each
       * stacked layer in turn. Override layers lerp toward the layer pose;
       * Additive layers use `makeClipAdditive` math:
       *   delta = sample(layer.time) - sample(firstKeyTime)
       *   result = base + delta * weight
       *
       * For "static pose" clips (Mixamo's sneak_pose / sad_pose: only 2 keys,
       * span < 0.5s), the first key is the T-pose and the last key is the
       * pose. We pin `layer.time` to the LAST keyframe so the additive offset
       * is the full target pose, stable, with no high-frequency oscillation
       * from layer.time wrapping between the two keyframes.
       */
      updateLayers(delta) {
        for (const layer of this._layers) {
          if (layer.weight <= 0) continue;
          if (!layer.clipName) continue;
          const clip = this._clipsMap?.get(layer.clipName);
          if (!clip) continue;
          if (!layer._resolved) {
            this._resolveLayer(layer, clip);
          }
          if (layer._isStaticPose) {
            layer.time = layer._lastKeyTime;
          } else if (layer.playing) {
            layer.time += delta * layer.timeScale * this.timeScale;
            const span = layer._lastKeyTime - layer._firstKeyTime;
            if (clip.loopTime || span > 0 && layer.time > layer._lastKeyTime) {
              if (span > 0) {
                layer.time = layer._firstKeyTime + (layer.time - layer._firstKeyTime) % span;
              }
            }
          }
          const joints = this._avatar.boneData;
          for (let i = 0; i < joints.length; i++) {
            const joint = joints[i];
            if (layer.mask && !layer.mask.has(joint.boneName)) continue;
            const obj = this.skeltonPoseObject3D[joint.boneName];
            if (!obj) continue;
            const hasPos = clip.useSkeletonPos && clip.positionCurves.has(joint.bonePath);
            const hasRot = clip.rotationCurves.has(joint.bonePath);
            const hasScale = clip.useSkeletonScale && clip.scaleCurves.has(joint.bonePath);
            if (!hasPos && !hasRot && !hasScale) continue;
            const isAdditive = layer.blendMode === LayerBlendMode.Additive;
            const refTime = isAdditive ? layer._firstKeyTime : 0;
            if (layer.blendMode === LayerBlendMode.Override) {
              if (hasPos) {
                const p = clip.positionCurves.get(joint.bonePath).getValue(layer.time);
                Vector3.HELP_0.lerp(obj.localPosition, p, layer.weight);
                obj.localPosition = Vector3.HELP_0;
              }
              if (hasRot) {
                const v4 = clip.rotationCurves.get(joint.bonePath).getValue(layer.time);
                this._layerRot.set(v4.x, v4.y, v4.z, v4.w);
                Quaternion.HELP_2.slerp(obj.localQuaternion, this._layerRot, layer.weight);
                obj.localQuaternion = Quaternion.HELP_2;
              }
              if (hasScale) {
                const s = clip.scaleCurves.get(joint.bonePath).getValue(layer.time);
                Vector3.HELP_0.lerp(obj.localScale, s, layer.weight);
                obj.localScale = Vector3.HELP_0;
              }
            } else {
              if (hasPos) {
                const curve = clip.positionCurves.get(joint.bonePath);
                const p = curve.getValue(layer.time);
                const px = p.x, py = p.y, pz = p.z;
                const r = curve.getValue(refTime);
                const dx = px - r.x, dy = py - r.y, dz = pz - r.z;
                Vector3.HELP_0.set(
                  obj.localPosition.x + dx * layer.weight,
                  obj.localPosition.y + dy * layer.weight,
                  obj.localPosition.z + dz * layer.weight
                );
                obj.localPosition = Vector3.HELP_0;
              }
              if (hasRot) {
                const curve = clip.rotationCurves.get(joint.bonePath);
                const v4 = curve.getValue(layer.time);
                this._layerRot.set(v4.x, v4.y, v4.z, v4.w);
                const r4 = curve.getValue(refTime);
                this._layerInvBaseQuat.set(-r4.x, -r4.y, -r4.z, r4.w);
                this._layerDeltaQuat.multiply(this._layerInvBaseQuat, this._layerRot);
                this._layerSlerpedQuat.slerp(this._layerIdentityQuat, this._layerDeltaQuat, layer.weight);
                this._layerOutQuat.multiply(obj.localQuaternion, this._layerSlerpedQuat);
                obj.localQuaternion = this._layerOutQuat;
              }
            }
          }
        }
      }
      /**
       * Look at the clip's curves and decide whether it is a "static pose"
       * (sneak_pose, sad_pose: typically 2 keyframes, < 0.5s span — a baked
       * T-pose → target-pose pair) or a true animated overlay (agree,
       * headShake: tens of keyframes spanning multiple seconds).
       *
       * For static poses we pin layer.time to the last keyframe so the
       * additive sample is stable; for animated overlays we let layer.time
       * advance and wrap normally.
       */
      _resolveLayer(layer, clip) {
        let firstKey = Infinity, lastKey = -Infinity, maxKeys = 0;
        const inspect = (c) => {
          if (!c || !c.m_curves || c.m_curves.length === 0) return;
          const ax = c.m_curves[0].curve;
          if (!ax || ax.length === 0) return;
          maxKeys = Math.max(maxKeys, ax.length);
          firstKey = Math.min(firstKey, ax[0].time);
          lastKey = Math.max(lastKey, ax[ax.length - 1].time);
        };
        clip.positionCurves.forEach(inspect);
        clip.rotationCurves.forEach(inspect);
        clip.scaleCurves.forEach(inspect);
        if (firstKey === Infinity) firstKey = 0;
        if (lastKey === -Infinity) lastKey = 0;
        layer._firstKeyTime = firstKey;
        layer._lastKeyTime = lastKey;
        layer._isStaticPose = maxKeys <= 2 && lastKey - firstKey < 0.5;
        layer._resolved = true;
      }
      // ------------------------------------------------------------------
      //  StateMachine plug-in (P1)
      // ------------------------------------------------------------------
      /** Attach (or clear) a state machine evaluated each frame before sampling. */
      setStateMachine(fsm) {
        this._stateMachine = fsm;
      }
      /** The currently attached state machine, or null. */
      getStateMachine() {
        return this._stateMachine;
      }
      // ------------------------------------------------------------------
      //  IK API (P1)
      // ------------------------------------------------------------------
      /** Register an IK solver, run after layer mixing each frame. */
      addIK(solver) {
        this._ikSolvers.push(solver);
      }
      /** Unregister a previously added IK solver. */
      removeIK(solver) {
        const i = this._ikSolvers.indexOf(solver);
        if (i >= 0) this._ikSolvers.splice(i, 1);
      }
      /** Live joint Object3D by bone name. Used by IK solvers + retargeting. */
      getJointObject(boneName) {
        return this.skeltonPoseObject3D ? this.skeltonPoseObject3D[boneName] || null : null;
      }
      /** Rest-pose (T-pose) joint Object3D by bone path. */
      getRestJointObject(bonePath) {
        return this.skeltonTPoseObject3D ? this.skeltonTPoseObject3D[bonePath] || null : null;
      }
      /** The current avatar (skeleton) data, or null. */
      getAvatar() {
        return this._avatar || null;
      }
    };
    exports.AnimatorComponent = __decorateClass$f([
      RegisterComponent(exports.AnimatorComponent, "AnimatorComponent")
    ], exports.AnimatorComponent);
    class PropertyAnimationClipState {
      /** The animation clip this state wraps. */
      clip;
      /** Current blend weight of the clip in the mix. */
      weight = 0;
      /** Total duration of the clip in seconds. */
      get totalTime() {
        return this.clip.stopTime - this.clip.startTime;
      }
      constructor(clip) {
        this.clip = clip;
      }
    }
    class SkeletonAnimCrossFadeState {
      inClip;
      outClip;
      currentTime;
      crossFadeTime;
      constructor(inClip, outClip, time) {
        this.reset(inClip, outClip, time);
      }
      reset(inClip, outClip, time) {
        this.inClip = inClip;
        this.outClip = outClip;
        this.currentTime = 0;
        this.crossFadeTime = time;
      }
      update(delta) {
        if (!this.inClip || !this.outClip) {
          return;
        }
        this.currentTime += delta;
        this.inClip.weight = Math.min(Math.abs(this.currentTime % this.crossFadeTime) / this.crossFadeTime, 1);
        this.outClip.weight = 1 - this.inClip.weight;
        if (Math.abs(this.currentTime) >= this.crossFadeTime) {
          this.inClip.weight = 1;
          this.outClip.weight = 0;
          this.inClip = null;
          this.outClip = null;
        }
      }
    }

    class BoneMask {
      _bones = /* @__PURE__ */ new Set();
      get bones() {
        return this._bones;
      }
      get size() {
        return this._bones.size;
      }
      has(boneName) {
        return this._bones.has(boneName);
      }
      add(boneName) {
        this._bones.add(boneName);
        return this;
      }
      addAll(boneNames) {
        for (const n of boneNames) this._bones.add(n);
        return this;
      }
      remove(boneName) {
        this._bones.delete(boneName);
        return this;
      }
      clear() {
        this._bones.clear();
        return this;
      }
      /** Add `rootBone` and every descendant (recursively) to the mask. */
      addSubtree(avatar, rootBone) {
        const root = avatar.boneMap.get(rootBone);
        if (!root) return this;
        const visit = (b) => {
          this._bones.add(b.boneName);
          for (const child of avatar.boneData) {
            if (child.parentBoneName === b.boneName) visit(child);
          }
        };
        visit(root);
        return this;
      }
      removeSubtree(avatar, rootBone) {
        const root = avatar.boneMap.get(rootBone);
        if (!root) return this;
        const visit = (b) => {
          this._bones.delete(b.boneName);
          for (const child of avatar.boneData) {
            if (child.parentBoneName === b.boneName) visit(child);
          }
        };
        visit(root);
        return this;
      }
    }

    class FrameCache {
      index;
      //= lhsIndex;
      time;
      // = lhs.time + timeOffset;
      timeEnd;
      // = rhs.time + timeOffset;
      coeff = [];
      //= lhsIndex;
    }

    var WrapTimeMode = /* @__PURE__ */ ((WrapTimeMode2) => {
      WrapTimeMode2[WrapTimeMode2["PingPong"] = 0] = "PingPong";
      WrapTimeMode2[WrapTimeMode2["Repeat"] = 1] = "Repeat";
      WrapTimeMode2[WrapTimeMode2["Clamp"] = 2] = "Clamp";
      return WrapTimeMode2;
    })(WrapTimeMode || {});

    class Keyframe {
      /** Serialization format version of this keyframe. */
      serializedVersion = "2";
      /** Time of the keyframe in seconds. */
      time;
      /** Value of the keyframe at its time. */
      value;
      /** Incoming tangent slope. */
      inSlope = 0;
      /** Outgoing tangent slope. */
      outSlope = 0;
      /** Tangent mode flags controlling how slopes are computed. */
      tangentMode = 0;
      /** Weighted mode flags controlling whether in/out weights are used. */
      weightedMode = 0;
      /** Incoming tangent weight. */
      inWeight;
      /** Outgoing tangent weight. */
      outWeight;
      constructor(time = 0, value = 0) {
        this.time = time;
        this.value = value;
      }
      /** Populate this keyframe from a serialized object using inSlope/outSlope fields. */
      unSerialized(data) {
        this.serializedVersion = data["serializedVersion"];
        this.time = data["time"];
        this.value = data["value"];
        this.tangentMode = data["tangentMode"];
        this.inSlope = data["inSlope"] == "Infinity" ? NaN : data["inSlope"];
        this.outSlope = data["outSlope"] == "Infinity" ? NaN : data["outSlope"];
      }
      /** Populate this keyframe from a serialized object using inTangent/outTangent fields. */
      unSerialized2(data) {
        this.serializedVersion = data["serializedVersion"];
        this.time = data["time"];
        this.value = data["value"];
        this.tangentMode = data["tangentMode"];
        this.inSlope = data["inTangent"] == "Infinity" ? NaN : data["inTangent"];
        this.outSlope = data["outTangent"] == "Infinity" ? NaN : data["outTangent"];
      }
    }

    class AnimationCurve {
      _totalTime = 1;
      _cache = new FrameCache();
      _cacheOut = {
        lhsIndex: 0,
        rhsIndex: 0
      };
      _InvalidateCache = false;
      /** Ordered list of keyframes defining this curve. */
      curve = [];
      /** Serialized format version of this curve. */
      serializedVersion;
      /** Wrap mode applied for times before the first keyframe. */
      preWarpMode;
      /** Wrap mode applied for times after the last keyframe. */
      postWarpMode;
      /** Euler rotation order associated with this curve. */
      rotationOrder;
      /**
       * Last computed left/right keyframe indices from the most recent lookup.
       */
      get cacheOut() {
        return this._cacheOut;
      }
      constructor(frames, preWarpMode = WrapTimeMode.Repeat, postWarpMode = WrapTimeMode.Repeat) {
        if (frames) for (let i = 0; i < frames.length; i++) {
          const frame = frames[i];
          this.addKeyFrame(frame);
        }
        this.preWarpMode = preWarpMode;
        this.postWarpMode = postWarpMode;
      }
      /**
       * return this curve use total time
       */
      get totalTime() {
        return this._totalTime;
      }
      /**
       * get curve first keframe time
       */
      get first() {
        return this.curve[0];
      }
      /**
       * get curve last keyframe time
       */
      get last() {
        return this.curve[this.curve.length - 1];
      }
      /**
       * add keyFrame to curve keyframe last and calcTotalTime
       * @param keyFrame {@link Keyframe}  sea: one key frame data
       */
      addKeyFrame(keyFrame) {
        if (this.curve.indexOf(keyFrame) == -1) {
          this.curve.push(keyFrame);
        }
        this.calcTotalTime();
      }
      /**
       * remove keyframe from this curve
       * @param keyFrame {@link Keyframe} 
       */
      removeKeyFrame(keyFrame) {
        let index = this.curve.indexOf(keyFrame);
        if (index != -1) {
          this.curve.splice(index, 1);
        }
        this.calcTotalTime();
      }
      /**
       * calculate keyframe list in to timeline
       * @param cache {@link FrameCache} 
       * @param lhsIndex left frame index 
       * @param rhsIndex right frame index
       * @param timeOffset offset time default 0.0
       */
      calculateCacheData(cache, lhsIndex, rhsIndex, timeOffset = 0) {
        let m_Curve = this.curve;
        let lhs = m_Curve[lhsIndex];
        let rhs = m_Curve[rhsIndex];
        cache.index = lhsIndex;
        cache.time = lhs.time + timeOffset;
        cache.timeEnd = rhs.time + timeOffset;
        cache.index = lhsIndex;
        let dx, length;
        let dy;
        let m1, m2, d1, d2;
        dx = rhs.time - lhs.time;
        dx = Math.max(dx, 1e-4);
        dy = rhs.value - lhs.value;
        length = 1 / (dx * dx);
        m1 = lhs.outSlope;
        m2 = rhs.inSlope;
        d1 = m1 * dx;
        d2 = m2 * dx;
        cache.coeff[0] = (d1 + d2 - dy - dy) * length / dx;
        cache.coeff[1] = (dy + dy + dy - d1 - d1 - d2) * length;
        cache.coeff[2] = m1;
        cache.coeff[3] = lhs.value;
        this.setupStepped(cache.coeff, lhs, rhs);
      }
      /**
       * get caculate frames value 
       * @param time 
       * @returns 
       */
      getValue(time) {
        time = this.wrapTime(time);
        this.findCurve(time, this._cacheOut);
        this.calculateCacheData(this._cache, this._cacheOut.lhsIndex, this._cacheOut.rhsIndex, 0);
        return this.evaluateCache(this._cache, time);
      }
      /**
       * get caculate frames extent
       * @param time 
       * @returns 
       */
      getCurveFramesExtent(time) {
        time = this.wrapTime(time);
        this.findCurve(time, this._cacheOut);
        return { lhsIndex: this._cacheOut.lhsIndex, rhsIndex: this._cacheOut.rhsIndex, time };
      }
      /**
       * get has Keyframe list count
       * @returns  int 
       */
      getKeyCount() {
        return this.curve.length;
      }
      /**
       * Get a Keyframe Data by Index
       * @param index must int 
       * @returns Keyframe {@link Keyframe}
       */
      getKey(index) {
        return this.curve[index];
      }
      /**
       * Deserialize this curve from raw asset data (Unity-style field names).
       * @param data source object containing wrap modes and keyframes
       * @returns this curve
       */
      unSerialized(data) {
        this.preWarpMode = data["m_PreInfinity"];
        this.postWarpMode = data["m_PostInfinity"];
        this.rotationOrder = data["m_RotationOrder"];
        let len = data["m_Curve"].length;
        for (let i = 0; i < len; i++) {
          this.curve[i] = new Keyframe();
          this.curve[i].unSerialized(data["m_Curve"][i.toString()]);
        }
        this.calcTotalTime();
        return this;
      }
      /**
       * Deserialize this curve from an alternate data layout (preWrapMode/keys fields).
       * @param data source object containing wrap modes and keyframes
       * @returns this curve
       */
      unSerialized2(data) {
        this.preWarpMode = data["preWrapMode"];
        this.postWarpMode = data["postWrapMode"];
        let keyFrames = data["keyFrames"] || data["keys"];
        let len = keyFrames.length;
        for (let i = 0; i < len; i++) {
          this.curve[i] = new Keyframe();
          this.curve[i].unSerialized2(keyFrames[i.toString()]);
        }
        this.calcTotalTime();
        return this;
      }
      /**
       * Wrap a time value into the curve range according to the pre/post wrap modes.
       * @param curveT input time
       * @returns wrapped time within the curve bounds
       */
      wrapTime(curveT) {
        let m_Curve = this.curve;
        let begTime = m_Curve[0].time;
        let endTime = m_Curve[m_Curve.length - 1].time;
        if (curveT < begTime) {
          if (this.preWarpMode == WrapTimeMode.Clamp) curveT = begTime;
          else if (this.preWarpMode == WrapTimeMode.PingPong) curveT = PingPong(curveT, begTime, endTime);
          else curveT = RepeatSE(curveT, begTime, endTime);
        } else if (curveT > endTime) {
          if (this.postWarpMode == WrapTimeMode.Clamp) curveT = endTime;
          else if (this.postWarpMode == WrapTimeMode.PingPong) curveT = PingPong(curveT, begTime, endTime);
          else curveT = RepeatSE(curveT, begTime, endTime);
        }
        return curveT;
      }
      evaluateCache(cache, curveT) {
        let t = curveT - cache.time;
        let output = t * (t * (t * cache.coeff[0] + cache.coeff[1]) + cache.coeff[2]) + cache.coeff[3];
        return output;
      }
      findCurve(time, out) {
        let frames = this.curve;
        const n = frames.length;
        if (n <= 1) {
          out.lhsIndex = 0;
          out.rhsIndex = 0;
          return;
        }
        if (time <= frames[0].time) {
          out.lhsIndex = 0;
          out.rhsIndex = 1;
          return;
        }
        const last = n - 1;
        if (time >= frames[last].time) {
          out.lhsIndex = last - 1;
          out.rhsIndex = last;
          return;
        }
        for (let i = 1; i < n; i++) {
          let left = frames[i - 1];
          let right = frames[i];
          if (left.time <= time && right.time > time) {
            out.lhsIndex = i - 1;
            out.rhsIndex = i;
            return;
          }
        }
      }
      setupStepped(coeff, lhs, rhs) {
        if (isNaN(lhs.outSlope) || isNaN(rhs.inSlope)) {
          coeff[0] = 0;
          coeff[1] = 0;
          coeff[2] = 0;
          coeff[3] = lhs.value;
        }
      }
      invalidateCache() {
        this._InvalidateCache = true;
      }
      calcTotalTime() {
        let maxTime = 0;
        for (let curve of this.curve) {
          if (curve) {
            maxTime = Math.max(maxTime, curve.time);
          } else {
            console.error(curve);
          }
        }
        this._totalTime = maxTime;
      }
      /**
       * Scale the value and tangents of every keyframe in the curve, then invalidate its cache.
       * @param curve curve to scale
       * @param scale multiplier applied to each keyframe value and slope
       */
      static scaleCurveValue(curve, scale) {
        if (!curve._InvalidateCache) {
          for (let i = 0; i < curve.curve.length; i++) {
            let c = curve.curve[i];
            c.value *= scale;
            c.inSlope *= scale;
            c.outSlope *= scale;
          }
        }
        curve.invalidateCache();
      }
    }

    class AttributeAnimCurve extends AnimationCurve {
      attribute = "";
      propertyList;
      path;
      constructor() {
        super();
      }
      unSerialized(data) {
        let { attribute, path } = data;
        this.attribute = attribute;
        this.path = path;
        this.propertyList = attribute.split(".");
        super.unSerialized(data.curve);
        return this;
      }
    }

    class ObjectAnimClip {
      curve = {};
    }
    var WrapMode = /* @__PURE__ */ ((WrapMode2) => {
      WrapMode2[WrapMode2["Default"] = 0] = "Default";
      WrapMode2[WrapMode2["Clamp"] = 1] = "Clamp";
      WrapMode2[WrapMode2["Once"] = 1] = "Once";
      WrapMode2[WrapMode2["Loop"] = 2] = "Loop";
      WrapMode2[WrapMode2["PingPong"] = 4] = "PingPong";
      WrapMode2[WrapMode2["ClampForever"] = 8] = "ClampForever";
      return WrapMode2;
    })(WrapMode || {});
    class PropertyAnimClip {
      name;
      objAnimClip;
      totalTime = 0;
      time = 0;
      // private _startTime: number = 0;
      _stopTime = 0;
      _loopTime;
      _wrapMode;
      _sampleRate;
      get wrapMode() {
        if (!this._wrapMode) this._wrapMode = 0 /* Default */;
        return this._wrapMode;
      }
      set wrapMode(value) {
        this._wrapMode = value;
      }
      parse(jsonData) {
        this.objAnimClip = {};
        let clip = jsonData["AnimationClip"];
        let { m_Name, m_AnimationClipSettings, m_WrapMode, m_SampleRate } = clip;
        this.name = m_Name;
        this._wrapMode = m_WrapMode;
        this._sampleRate = m_SampleRate;
        this._loopTime = m_AnimationClipSettings.m_LoopTime;
        for (const key in clip.m_EditorCurves) {
          if (Object.prototype.hasOwnProperty.call(clip.m_EditorCurves, key)) {
            const curve = clip.m_EditorCurves[key];
            let attribute = curve.attribute;
            let attributeAnimCurve = new AttributeAnimCurve();
            attributeAnimCurve.unSerialized(curve);
            this.totalTime = Math.max(this.totalTime, attributeAnimCurve.totalTime);
            let objClip = this.objAnimClip[curve.path];
            if (!objClip) {
              objClip = new ObjectAnimClip();
              this.objAnimClip[curve.path] = objClip;
            }
            objClip.curve[attribute] = attributeAnimCurve;
          }
        }
      }
    }

    class PropertyAnimTag {
      transform;
      quaternion;
      materialColor;
    }
    class PropertyHelp {
      static Property = {
        "m_LocalPosition.x": "localPosition.x",
        "m_LocalPosition.y": "localPosition.y",
        "m_LocalPosition.z": "localPosition.z",
        "m_LocalRotation.x": "localQuaternion.x",
        "m_LocalRotation.y": "localQuaternion.y",
        "m_LocalRotation.z": "localQuaternion.z",
        "m_LocalRotation.w": "localQuaternion.w",
        "localEulerAnglesRaw.x": "localRotation.x",
        "localEulerAnglesRaw.y": "localRotation.y",
        "localEulerAnglesRaw.z": "localRotation.z",
        "m_LocalEulerAngles.x": "localRotation.x",
        "m_LocalEulerAngles.y": "localRotation.y",
        "m_LocalEulerAngles.z": "localRotation.z",
        "m_LocalScale.x": "localScale.x",
        "m_LocalScale.y": "localScale.y",
        "m_LocalScale.z": "localScale.z",
        "m_Color.r": "materialColor.r",
        "m_Color.g": "materialColor.g",
        "m_Color.b": "materialColor.b",
        "m_Color.a": "materialColor.a",
        "material._Color.r": "materialColor.r",
        "material._Color.g": "materialColor.g",
        "material._Color.b": "materialColor.b",
        "material._Color.a": "materialColor.a",
        "material._UnlitColor.r": "materialColor.r",
        "material._UnlitColor.g": "materialColor.g",
        "material._UnlitColor.b": "materialColor.b",
        "material._UnlitColor.a": "materialColor.a",
        "field of view": "camera3D.fov",
        m_IsActive: "active",
        m_Sprite: "sprite",
        m_FlipX: "flipX",
        m_FlipY: "flipY"
      };
      static Scale = {
        "m_LocalPosition.x": 1,
        "m_LocalPosition.y": 1,
        "m_LocalPosition.z": -1,
        "localEulerAnglesRaw.x": -1,
        //Deg2Rad(1),
        "localEulerAnglesRaw.y": 1,
        //Deg2Rad(1),
        "localEulerAnglesRaw.z": 1,
        //Deg2Rad(1),
        "m_LocalEulerAngles.x": -1,
        //Deg2Rad(1),
        "m_LocalEulerAngles.y": 1,
        //Deg2Rad(1),
        "m_LocalEulerAngles.z": 1,
        //Deg2Rad(1),
        "m_LocalRotation.x": 1,
        //Rad2Deg(1),
        "m_LocalRotation.y": 1,
        //Rad2Deg(1),
        "m_LocalRotation.z": -1,
        //Rad2Deg(1),
        "m_LocalRotation.w": -1,
        //Rad2Deg(1),
        "field of view": 1,
        m_IsActive: 1,
        m_Sprite: 1
      };
      static updatePropertyTag(tag, attribute) {
        tag.quaternion ||= this.tag_quaternion[attribute];
        tag.transform ||= this.tag_transform[attribute];
        tag.materialColor ||= this.tag_materialColor[attribute];
      }
      static tag_quaternion = {
        "m_LocalRotation.x": true,
        "m_LocalRotation.y": true,
        "m_LocalRotation.z": true,
        "m_LocalRotation.w": true
      };
      static tag_materialColor = {
        "material._Color.r": true,
        "material._Color.g": true,
        "material._Color.b": true,
        "material._Color.a": true,
        "material._UnlitColor.r": true,
        "material._UnlitColor.g": true,
        "material._UnlitColor.b": true,
        "material._UnlitColor.a": true
      };
      static tag_transform = {
        "m_LocalPosition.x": true,
        "m_LocalPosition.y": true,
        "m_LocalPosition.z": true,
        "m_LocalRotation.x": true,
        "m_LocalRotation.y": true,
        "m_LocalRotation.z": true,
        "m_LocalRotation.w": true,
        "localEulerAnglesRaw.x": true,
        "localEulerAnglesRaw.y": true,
        "localEulerAnglesRaw.z": true,
        "m_LocalEulerAngles.x": true,
        "m_LocalEulerAngles.y": true,
        "m_LocalEulerAngles.z": true,
        "m_LocalScale.x": true,
        "m_LocalScale.y": true,
        "m_LocalScale.z": true
      };
    }

    class AnimationMonitor {
      static Complete = 0;
      static Seek = 1;
      _rootObject3D;
      _animation;
      _propertyCache;
      _currentClip;
      _frame = 0;
      _time = 0;
      _isPlaying = true;
      speed = 1;
      _propertyTagDic;
      constructor(animation) {
        this._rootObject3D = animation.object3D;
        this._animation = animation;
        this._propertyTagDic = /* @__PURE__ */ new Map();
        this.reset();
      }
      reset() {
        this._propertyCache = {};
        this._propertyTagDic.clear();
      }
      get time() {
        return this._time;
      }
      get currentClip() {
        return this._currentClip;
      }
      play(clip, reset = true) {
        this._isPlaying = true;
        if (reset) {
          this._time = 0;
        }
        if (clip != this._currentClip) {
          if (clip) {
            this.parseAnimClip(clip);
          }
        }
        this._currentClip = clip;
        this.validProperty();
      }
      parseAnimClip(clip) {
        this.reset();
        for (const objPath in clip.objAnimClip) {
          let objClip = clip.objAnimClip[objPath];
          let bindObject3D = this._rootObject3D;
          let attsCache = {};
          if (objPath == "") {
            bindObject3D = this._rootObject3D;
          } else {
            bindObject3D = this._rootObject3D.getObjectByName(objPath);
          }
          if (!bindObject3D)
            continue;
          let tag = new PropertyAnimTag();
          this._propertyTagDic.set(bindObject3D, tag);
          let curve = objClip.curve;
          for (const attribute in curve) {
            PropertyHelp.updatePropertyTag(tag, attribute);
            let binder = this._propertyCache[objPath] ||= {};
            let atts = PropertyHelp.Property[attribute].split(".");
            let atts_0 = atts[0];
            if (atts.length > 1) {
              let value = attsCache[atts_0];
              if (!value) {
                value = attsCache[atts_0] = bindObject3D[atts_0];
              }
              binder[attribute] = { value, property: atts[1] };
            } else {
              binder[attribute] = { value: bindObject3D, property: atts[0] };
            }
          }
        }
        return this;
      }
      stop() {
        this._isPlaying = false;
        return this;
      }
      toggle() {
        this._isPlaying = !this._isPlaying;
        return this;
      }
      get isPlaying() {
        return this._isPlaying;
      }
      update(time, delta) {
        time = time * 1e-3;
        delta = delta * 1e-3;
        if (!this._currentClip || this._frame == time) return;
        if (!this._isPlaying) return;
        this._frame = time;
        let lastTime = this._time;
        this._time = this.calcTime(lastTime + delta * this.speed);
        this.validProperty();
        if (this._currentClip.wrapMode != WrapMode.Loop && this._currentClip.wrapMode != WrapMode.Default) {
          let complete = this.speed > 0 ? this._time >= this._currentClip.totalTime : this._time <= 0;
          if (complete) {
            this._isPlaying = false;
            this._animation["statusCall"](AnimationMonitor.Complete, lastTime, this._time);
          }
        }
        this._animation["statusCall"](AnimationMonitor.Seek, lastTime, this._time);
      }
      seek(time) {
        this._time = this.calcTime(time);
        this._rootObject3D && this.validProperty();
        return this;
      }
      calcTime(time) {
        if (this._currentClip.wrapMode == WrapMode.Loop || this._currentClip.wrapMode == WrapMode.Default) {
          time = repeat(time, this._currentClip.totalTime);
        } else {
          time = clamp$2(time, 0, this._currentClip.totalTime);
        }
        return time;
      }
      validProperty() {
        for (const objName in this._currentClip.objAnimClip) {
          let objClip = this._currentClip.objAnimClip[objName];
          let curve = objClip.curve;
          for (const attribute in curve) {
            const attributeAnim = curve[attribute];
            let target = this._propertyCache[objName][attribute];
            let ret = attributeAnim.getValue(this._time);
            if (attribute in PropertyHelp.Scale) {
              ret *= PropertyHelp.Scale[attribute];
            }
            target.value[target.property] = ret;
          }
        }
        this._propertyTagDic.forEach((v, k) => {
          this.applyProperty(v, k);
        });
      }
      applyProperty(tag, obj3d) {
        if (tag.quaternion) {
          Matrix4.getEuler(obj3d.transform.localRotation, obj3d.transform.localRotQuat, true, "ZYX");
        }
        if (tag.transform) {
          obj3d.transform.localPosition = obj3d.transform.localPosition;
          obj3d.transform.localRotation = obj3d.transform.localRotation;
          obj3d.transform.localScale = obj3d.transform.localScale;
        }
        let animObj = obj3d;
        if (tag.materialColor) {
          animObj.notifyMaterialColorChange(0, "baseColor");
        }
      }
    }

    class AnimatorEventKeyframe {
      clipName;
      data;
      time;
    }
    class PropertyAnimationEvent extends CEvent {
      static SEEK = "SEEK";
      static COMPLETE = "COMPLETE";
      animation;
      frame;
      constructor(animation, name) {
        super(name);
        this.animation = animation;
      }
    }

    class PropertyAnimation extends ComponentBase {
      _animator;
      _clips = [];
      /**
       * name of default animation clip
       */
      defaultClip;
      /**
       * is it play auto
       */
      autoPlay;
      _seekEvent;
      _completeEvent;
      _keyFrameList;
      constructor() {
        super();
        this._seekEvent = new PropertyAnimationEvent(this, PropertyAnimationEvent.SEEK);
        this._completeEvent = new PropertyAnimationEvent(this, PropertyAnimationEvent.COMPLETE);
        this._keyFrameList = {};
      }
      /**
       * register a event to animator
       * @param frame source AnimatorEventKeyframe
       */
      registerEventKeyFrame(frame) {
        let list = this._keyFrameList[frame.clipName];
        if (list == null) {
          this._keyFrameList[frame.clipName] = list = [];
        }
        list.push(frame);
      }
      /**
       * @internal
       */
      init() {
        this._animator = new AnimationMonitor(this);
      }
      /**
       * @internal
       */
      onUpdate() {
        if (this.enable) {
          this._animator.update(Time.time, Time.delta);
        }
      }
      /**
       * append a perperty animation clip
       * @param clip source PropertyAnimClip
       */
      appendClip(clip) {
        this._clips.push(clip);
        this.play(clip.name);
      }
      statusCall(tag, last, now) {
        if (tag == AnimationMonitor.Complete) {
          this.eventDispatcher.dispatchEvent(this._completeEvent);
        } else if (tag == AnimationMonitor.Seek) {
          if (last != now) {
            let frames = this._keyFrameList[this.currentClip.name];
            if (frames) {
              for (let frame of frames) {
                if (frame.time > last && frame.time <= now) {
                  this._seekEvent.data = this._seekEvent.frame = frame;
                  this.eventDispatcher.dispatchEvent(this._seekEvent);
                }
              }
            }
          }
        }
      }
      /**
       * set playing speed
       */
      set speed(value) {
        this._animator.speed = value;
      }
      /**
       * get playing speed
       */
      get speed() {
        return this._animator.speed;
      }
      /**
       * stop playing
       */
      stop() {
        this._animator.stop();
      }
      /**
       * stop or resume playing
       */
      toggle() {
        this._animator.toggle();
      }
      /**
       * get animation clip by clip name
       * @param clip name of PropertyAnimClip
       * @returns 
       */
      getClip(name) {
        let clip;
        for (let item of this._clips) {
          if (item.name == name) {
            clip = item;
            break;
          }
        }
        return clip;
      }
      /**
       * get animation clip which is playing now
       */
      get currentClip() {
        return this._animator.currentClip;
      }
      /**
       * get time of current animator
       */
      get time() {
        return this._animator.time;
      }
      /**
       * seek the animation to assign time
       * @param time assign time
       */
      seek(time) {
        this._animator.seek(time);
      }
      /**
       * play animation by given name
       * @param name animation name
       * @param reset if true, play the animation from time 0
       * @returns 
       */
      play(name, reset = true) {
        let clip = this.getClip(name);
        if (clip) {
          this._animator.play(clip, reset);
          return clip;
        }
        return null;
      }
      /**
       * @internal
       *
       */
      start() {
        if (this.autoPlay) {
          this.play(this.defaultClip);
        }
      }
      copyComponent(from) {
        this.autoPlay = from.autoPlay;
        this.defaultClip = from.defaultClip;
        let clips = from._clips;
        for (let i = 0, count = clips.length; i < count; i++) {
          this.appendClip(clips[i]);
        }
        return this;
      }
      /**
       * Create a new PropertyAnimation component, copy the properties of the current component, 
       * and add them to the target object.
       * @param obj target object3D
       */
      cloneTo(obj) {
        let animator = obj.addComponent(PropertyAnimation);
        animator.copyComponent(this);
      }
    }

    class BlendTree1D {
      _points;
      _value = 0;
      constructor(points) {
        this._points = [...points].sort((a, b) => a.threshold - b.threshold);
        if (this._points.length < 2) {
          throw new Error("BlendTree1D requires at least 2 motion points");
        }
      }
      /** Set the parameter value. Out-of-range values clamp to the endpoints. */
      setValue(v) {
        this._value = v;
      }
      getValue() {
        return this._value;
      }
      /**
       * Apply the blend: zero out every clip's weight, then write the two-point
       * lerp weights for the segment containing `value`.
       */
      apply(animator) {
        const v = this._value;
        for (const p of this._points) {
          const cs = animator.getAnimationClipState(p.clipName);
          if (cs) cs.weight = 0;
        }
        const pts = this._points;
        if (v <= pts[0].threshold) {
          const cs = animator.getAnimationClipState(pts[0].clipName);
          if (cs) cs.weight = 1;
          return;
        }
        if (v >= pts[pts.length - 1].threshold) {
          const cs = animator.getAnimationClipState(pts[pts.length - 1].clipName);
          if (cs) cs.weight = 1;
          return;
        }
        for (let i = 1; i < pts.length; i++) {
          const left = pts[i - 1];
          const right = pts[i];
          if (v < left.threshold || v > right.threshold) continue;
          const span = right.threshold - left.threshold;
          const t = span > 1e-6 ? (v - left.threshold) / span : 0;
          const lws = animator.getAnimationClipState(left.clipName);
          const rws = animator.getAnimationClipState(right.clipName);
          if (lws) lws.weight = 1 - t;
          if (rws) rws.weight = t;
          return;
        }
      }
    }

    class DefaultParams {
      _f = /* @__PURE__ */ new Map();
      _b = /* @__PURE__ */ new Map();
      _t = /* @__PURE__ */ new Set();
      getFloat(name) {
        return this._f.get(name) ?? 0;
      }
      setFloat(name, v) {
        this._f.set(name, v);
      }
      getBool(name) {
        return this._b.get(name) ?? false;
      }
      setBool(name, v) {
        this._b.set(name, v);
      }
      getTrigger(name) {
        return this._t.has(name);
      }
      setTrigger(name) {
        this._t.add(name);
      }
      consumeTrigger(name) {
        if (this._t.has(name)) {
          this._t.delete(name);
          return true;
        }
        return false;
      }
    }
    class StateMachine {
      _states = /* @__PURE__ */ new Map();
      _current;
      _transitionTime = 0;
      _transitioning = false;
      _params;
      constructor(states, initial, params) {
        if (states.length === 0) throw new Error("StateMachine requires at least one state");
        for (const s of states) this._states.set(s.name, s);
        const initName = initial ?? states[0].name;
        const init = this._states.get(initName);
        if (!init) throw new Error(`StateMachine: unknown initial state '${initName}'`);
        this._current = init;
        this._params = params ?? new DefaultParams();
      }
      get params() {
        return this._params;
      }
      get currentState() {
        return this._current;
      }
      get currentStateName() {
        return this._current.name;
      }
      /**
       * Convenience: ensure the underlying animator is playing the right clip.
       * Should be called once after attaching the FSM, or any time external
       * code wants to force a sync.
       */
      sync(animator) {
        animator.playAnim(this._current.clip, 0, this._current.speed ?? 1);
      }
      /** Called by AnimatorComponent.onUpdate every frame. */
      evaluate(animator, dt) {
        if (this._transitioning) {
          this._transitionTime += dt;
        }
        for (const t of this._current.transitions) {
          if (this._transitioning && !t.interruptible) continue;
          if (!t.condition(this._params)) continue;
          const next = this._states.get(t.to);
          if (!next) {
            console.warn(`StateMachine: transition target '${t.to}' not found`);
            continue;
          }
          if (t.duration > 1e-3) {
            animator.crossFade(next.clip, t.duration);
          } else {
            animator.playAnim(next.clip, t.offset ?? 0, next.speed ?? 1);
          }
          this._current = next;
          this._transitioning = t.duration > 1e-3;
          this._transitionTime = 0;
          return;
        }
      }
    }
    function makeAnimatorParams() {
      return new DefaultParams();
    }

    class CCDIK {
      name;
      effector;
      links;
      target;
      iterations;
      damping;
      threshold;
      weight;
      _origLocalQs = [];
      /**
       * Per-iter best-pose snapshot. Stabilizes the solve when target is
       * outside the chain's reachable set + the Euler/hinge constraints
       * push the chain into different attractors each iter (creating a
       * limit-cycle that visually flickers between 2-3 poses every frame).
       * After all iters we restore the pose with the smallest target
       * distance — solver becomes monotonic-by-output even when the
       * inner sweep is non-monotonic.
       */
      _bestPoseQs = [];
      _tmpQA = new Quaternion();
      _tmpQB = new Quaternion();
      _tmpQDelta = new Quaternion();
      _tmpV1 = new Vector3();
      _tmpV2 = new Vector3();
      _tmpAxis = new Vector3();
      _tmpTarget = new Vector3();
      _tmpEuler = new Vector3();
      _constrainedQ = new Quaternion();
      /** Convenience accessor — full bone name list root→tip (links reversed + effector last). */
      get chain() {
        const out = [];
        for (let i = this.links.length - 1; i >= 0; i--) out.push(this.links[i].boneName);
        out.push(this.effector);
        return out;
      }
      constructor(cfg) {
        this.name = cfg.name;
        this.effector = cfg.effector;
        this.links = cfg.links;
        this.target = cfg.target;
        this.iterations = cfg.iterations ?? 6;
        this.damping = cfg.damping ?? 1;
        this.threshold = cfg.threshold ?? 0.5;
        this.weight = cfg.weight;
        for (let i = 0; i <= this.links.length; i++) {
          this._origLocalQs.push(new Quaternion());
          this._bestPoseQs.push(new Quaternion());
        }
      }
      solve(animator) {
        const _dbg = this._dbg ?? false;
        if (_dbg) console.log(`[CCDIK ${this.name}] solve() weight=${this.weight}`);
        if (this.weight <= 0) {
          if (_dbg) console.log(`[CCDIK ${this.name}] skip: weight=${this.weight}`);
          return;
        }
        if (this.links.length < 1) {
          if (_dbg) console.log(`[CCDIK ${this.name}] skip: links.length=${this.links.length}`);
          return;
        }
        const effectorBone = animator.getJointObject(this.effector);
        if (!effectorBone) {
          if (_dbg) console.log(`[CCDIK ${this.name}] skip: getJointObject('${this.effector}') = null`);
          return;
        }
        const joints = [];
        for (let i = this.links.length - 1; i >= 0; i--) {
          const j = animator.getJointObject(this.links[i].boneName);
          if (!j) {
            if (_dbg) console.log(`[CCDIK ${this.name}] skip: getJointObject('${this.links[i].boneName}') = null`);
            return;
          }
          joints.push(j);
        }
        joints.push(effectorBone);
        for (let i = 0; i < joints.length; i++) {
          this._origLocalQs[i].copy(joints[i].localQuaternion);
          this._bestPoseQs[i].copy(joints[i].localQuaternion);
        }
        const tip = effectorBone;
        const tWp = readWorldPos$1(this.target);
        this._tmpTarget.set(tWp.x, tWp.y, tWp.z);
        if (_dbg) {
          const tipPos0 = tip.transform.worldPosition;
          console.log(`[CCDIK ${this.name}] target=(${this._tmpTarget.x.toFixed(3)},${this._tmpTarget.y.toFixed(3)},${this._tmpTarget.z.toFixed(3)}) effector-before=(${tipPos0.x.toFixed(3)},${tipPos0.y.toFixed(3)},${tipPos0.z.toFixed(3)}) dist=${Math.sqrt(sqDist(tipPos0, this._tmpTarget)).toFixed(3)}`);
        }
        let bestDistSq = sqDist(tip.transform.worldPosition, this._tmpTarget);
        let actualIters = 0;
        for (let iter = 0; iter < this.iterations; iter++) {
          actualIters = iter + 1;
          const tipPos = tip.transform.worldPosition;
          const distSq = sqDist(tipPos, this._tmpTarget);
          if (distSq < this.threshold * this.threshold) break;
          for (let bi = joints.length - 2; bi >= 0; bi--) {
            const bone = joints[bi];
            const bWp = bone.transform.worldPosition;
            const tipWp = tip.transform.worldPosition;
            this._tmpV1.set(tipWp.x - bWp.x, tipWp.y - bWp.y, tipWp.z - bWp.z);
            this._tmpV2.set(this._tmpTarget.x - bWp.x, this._tmpTarget.y - bWp.y, this._tmpTarget.z - bWp.z);
            if (this._tmpV1.length < 1e-5 || this._tmpV2.length < 1e-5) continue;
            this._tmpV1.normalize();
            this._tmpV2.normalize();
            this._tmpAxis.crossVectors(this._tmpV1, this._tmpV2);
            if (this._tmpAxis.length < 1e-5) continue;
            this._tmpAxis.normalize();
            const cosA = clamp$1(Vector3.dot(this._tmpV1, this._tmpV2), -1, 1);
            const angle = Math.acos(cosA) * this.damping;
            if (angle < 1e-4) continue;
            quatFromAxisAngle$1(this._tmpAxis, angle, this._tmpQDelta);
            const parentObj = bone.parent ? bone.parent.object3D : null;
            const parentWorldQ = composeWorldQuat$1(parentObj, this._tmpQA);
            quatInvert$1(parentWorldQ, this._tmpQA);
            const boneWorldQ = composeWorldQuat$1(bone, this._tmpQB);
            this._tmpQB.multiply(this._tmpQDelta, boneWorldQ);
            const newLocal = new Quaternion();
            newLocal.multiply(this._tmpQA, this._tmpQB);
            const linkIdx = this.links.length - 1 - bi;
            this._applyLinkConstraint(linkIdx, newLocal);
            bone.localQuaternion = newLocal;
          }
          const iterEndDistSq = sqDist(tip.transform.worldPosition, this._tmpTarget);
          if (iterEndDistSq < bestDistSq) {
            bestDistSq = iterEndDistSq;
            for (let i = 0; i < joints.length; i++) {
              this._bestPoseQs[i].copy(joints[i].localQuaternion);
            }
          }
        }
        for (let i = 0; i < joints.length; i++) {
          joints[i].localQuaternion = this._bestPoseQs[i];
        }
        if (this.weight < 1) {
          const blend = new Quaternion();
          for (let i = 0; i < joints.length; i++) {
            const cur = joints[i].localQuaternion;
            blend.slerp(this._origLocalQs[i], cur, this.weight);
            joints[i].localQuaternion = blend;
          }
        }
        if (_dbg) {
          const tipPos1 = tip.transform.worldPosition;
          console.log(`[CCDIK ${this.name}] iters=${actualIters}/${this.iterations} effector-after=(${tipPos1.x.toFixed(3)},${tipPos1.y.toFixed(3)},${tipPos1.z.toFixed(3)}) dist=${Math.sqrt(sqDist(tipPos1, this._tmpTarget)).toFixed(3)}`);
        }
      }
      /**
       * Apply hinge-axis or Euler-box constraint to `q` in place.
       *
       * Hinge math (when `hingeAxis` is set): swing-twist decomposition
       * around the axis, clamp twist angle to [minAngle, maxAngle], rebuild
       * `q` from clamped twist alone (swing is discarded — the joint is now
       * a clean 1-DOF hinge).
       *
       * Euler-box math (when `rotationMin`/`rotationMax` is set):
       *   1. Decompose `q` into Euler triple under `link.eulerOrder` using
       *      `Matrix4.getEuler` (radians).
       *   2. Convert min/max bounds to radians (if `link.radians` is false,
       *      the values are degrees and need conversion).
       *   3. Clamp componentwise and rebuild `q` from the clamped Euler
       *      under the same order via `_eulerToQuat`.
       */
      _applyLinkConstraint(linkIndex, q) {
        const link = this.links[linkIndex];
        if (!link) return;
        if (link.hingeAxis) {
          const ax = link.hingeAxis;
          const dot = q.x * ax.x + q.y * ax.y + q.z * ax.z;
          let angle = 2 * Math.atan2(dot, q.w);
          if (angle > Math.PI) angle -= 2 * Math.PI;
          else if (angle < -Math.PI) angle += 2 * Math.PI;
          const lo = link.minAngle ?? -Math.PI;
          const hi = link.maxAngle ?? Math.PI;
          angle = clamp$1(angle, lo, hi);
          const half = angle * 0.5;
          const s = Math.sin(half);
          q.set(ax.x * s, ax.y * s, ax.z * s, Math.cos(half));
          return;
        }
        if (link.rotationMin || link.rotationMax) {
          const order = link.eulerOrder ?? "XYZ";
          Matrix4.getEuler(this._tmpEuler, q, false, order);
          const k = link.radians ? 1 : Math.PI / 180;
          const lo = link.rotationMin;
          const hi = link.rotationMax;
          if (lo) {
            const lx = lo.x * k, ly = lo.y * k, lz = lo.z * k;
            if (this._tmpEuler.x < lx) this._tmpEuler.x = lx;
            if (this._tmpEuler.y < ly) this._tmpEuler.y = ly;
            if (this._tmpEuler.z < lz) this._tmpEuler.z = lz;
          }
          if (hi) {
            const hx = hi.x * k, hy = hi.y * k, hz = hi.z * k;
            if (this._tmpEuler.x > hx) this._tmpEuler.x = hx;
            if (this._tmpEuler.y > hy) this._tmpEuler.y = hy;
            if (this._tmpEuler.z > hz) this._tmpEuler.z = hz;
          }
          _eulerToQuat(this._tmpEuler.x, this._tmpEuler.y, this._tmpEuler.z, order, this._constrainedQ);
          q.copy(this._constrainedQ);
        }
      }
    }
    function readWorldPos$1(t) {
      if (t.transform !== void 0) return t.transform.worldPosition;
      return t;
    }
    function sqDist(a, b) {
      const dx = a.x - b.x, dy = a.y - b.y, dz = a.z - b.z;
      return dx * dx + dy * dy + dz * dz;
    }
    function clamp$1(x, lo, hi) {
      return x < lo ? lo : x > hi ? hi : x;
    }
    function quatFromAxisAngle$1(axis, angle, out) {
      const half = angle * 0.5;
      const s = Math.sin(half);
      out.set(axis.x * s, axis.y * s, axis.z * s, Math.cos(half));
      return out;
    }
    function quatInvert$1(q, out) {
      out.set(-q.x, -q.y, -q.z, q.w);
      return out;
    }
    const _qComposeTmp$1 = new Quaternion();
    function composeWorldQuat$1(obj, out) {
      if (!obj) {
        out.set(0, 0, 0, 1);
        return out;
      }
      const stack = [];
      let cur = obj;
      while (cur) {
        stack.push(cur);
        cur = cur.parent ? cur.parent.object3D : null;
      }
      out.copy(stack[stack.length - 1].localQuaternion);
      for (let i = stack.length - 2; i >= 0; i--) {
        _qComposeTmp$1.multiply(out, stack[i].localQuaternion);
        out.copy(_qComposeTmp$1);
      }
      return out;
    }
    function _eulerToQuat(x, y, z, order, out) {
      const c1 = Math.cos(x * 0.5), s1 = Math.sin(x * 0.5);
      const c2 = Math.cos(y * 0.5), s2 = Math.sin(y * 0.5);
      const c3 = Math.cos(z * 0.5), s3 = Math.sin(z * 0.5);
      switch (order) {
        case "XYZ":
          out.x = s1 * c2 * c3 + c1 * s2 * s3;
          out.y = c1 * s2 * c3 - s1 * c2 * s3;
          out.z = c1 * c2 * s3 + s1 * s2 * c3;
          out.w = c1 * c2 * c3 - s1 * s2 * s3;
          break;
        case "YXZ":
          out.x = s1 * c2 * c3 + c1 * s2 * s3;
          out.y = c1 * s2 * c3 - s1 * c2 * s3;
          out.z = c1 * c2 * s3 - s1 * s2 * c3;
          out.w = c1 * c2 * c3 + s1 * s2 * s3;
          break;
        case "ZXY":
          out.x = s1 * c2 * c3 - c1 * s2 * s3;
          out.y = c1 * s2 * c3 + s1 * c2 * s3;
          out.z = c1 * c2 * s3 + s1 * s2 * c3;
          out.w = c1 * c2 * c3 - s1 * s2 * s3;
          break;
        case "ZYX":
          out.x = s1 * c2 * c3 - c1 * s2 * s3;
          out.y = c1 * s2 * c3 + s1 * c2 * s3;
          out.z = c1 * c2 * s3 - s1 * s2 * c3;
          out.w = c1 * c2 * c3 + s1 * s2 * s3;
          break;
        case "YZX":
          out.x = s1 * c2 * c3 + c1 * s2 * s3;
          out.y = c1 * s2 * c3 + s1 * c2 * s3;
          out.z = c1 * c2 * s3 - s1 * s2 * c3;
          out.w = c1 * c2 * c3 - s1 * s2 * s3;
          break;
        case "XZY":
          out.x = s1 * c2 * c3 - c1 * s2 * s3;
          out.y = c1 * s2 * c3 - s1 * c2 * s3;
          out.z = c1 * c2 * s3 + s1 * s2 * c3;
          out.w = c1 * c2 * c3 + s1 * s2 * s3;
          break;
      }
      return out;
    }

    class TwoBoneIK {
      name;
      chain;
      target;
      pole;
      weight;
      _origRootQ = new Quaternion();
      _origMidQ = new Quaternion();
      _aPos = new Vector3();
      _bPos = new Vector3();
      _cPos = new Vector3();
      _tPos = new Vector3();
      _bendAxis = new Vector3();
      _midDelta = new Quaternion();
      _rootDelta = new Quaternion();
      _swingAxis = new Vector3();
      _curDir = new Vector3();
      _tgtDir = new Vector3();
      _midParentInvW = new Quaternion();
      _rootParentInvW = new Quaternion();
      _midWorldNew = new Quaternion();
      _midLocalNew = new Quaternion();
      _rootWorldNew = new Quaternion();
      _rootLocalNew = new Quaternion();
      _blendQ = new Quaternion();
      constructor(cfg) {
        this.name = cfg.name;
        this.chain = cfg.chain;
        this.target = cfg.target;
        this.pole = cfg.pole;
        this.weight = cfg.weight;
      }
      solve(animator) {
        if (this.weight <= 0) return;
        const root = animator.getJointObject(this.chain[0]);
        const mid = animator.getJointObject(this.chain[1]);
        const end = animator.getJointObject(this.chain[2]);
        if (!root || !mid || !end) return;
        this._origRootQ.copy(root.localQuaternion);
        this._origMidQ.copy(mid.localQuaternion);
        const aWp = root.transform.worldPosition;
        const bWp = mid.transform.worldPosition;
        const cWp = end.transform.worldPosition;
        this._aPos.set(aWp.x, aWp.y, aWp.z);
        this._bPos.set(bWp.x, bWp.y, bWp.z);
        this._cPos.set(cWp.x, cWp.y, cWp.z);
        const tWp = readWorldPos(this.target);
        this._tPos.set(tWp.x, tWp.y, tWp.z);
        const lenAB = Vector3.distance(this._aPos, this._bPos);
        const lenBC = Vector3.distance(this._bPos, this._cPos);
        if (lenAB < 1e-5 || lenBC < 1e-5) return;
        const maxReach = lenAB + lenBC - 1e-4;
        const lenAT = Math.min(Vector3.distance(this._aPos, this._tPos), maxReach);
        const lenAC = Vector3.distance(this._aPos, this._cPos);
        const cosBCurr = clamp((lenAB * lenAB + lenBC * lenBC - lenAC * lenAC) / (2 * lenAB * lenBC), -1, 1);
        const cosATCurr = clamp((lenAB * lenAB + lenAC * lenAC - lenBC * lenBC) / (2 * lenAB * lenAC), -1, 1);
        const cosBDes = clamp((lenAB * lenAB + lenBC * lenBC - lenAT * lenAT) / (2 * lenAB * lenBC), -1, 1);
        const cosATDes = clamp((lenAB * lenAB + lenAT * lenAT - lenBC * lenBC) / (2 * lenAB * lenAT), -1, 1);
        const aBcurr = Math.acos(cosBCurr);
        const aBdes = Math.acos(cosBDes);
        const aTcurr = Math.acos(cosATCurr);
        const aTdes = Math.acos(cosATDes);
        if (this.pole) {
          const polePos = readWorldPos(this.pole);
          const ac = subTo(this._cPos, this._aPos, _vTmp1);
          const ap = subTo(_vTmpPole.set(polePos.x, polePos.y, polePos.z), this._aPos, _vTmp2);
          this._bendAxis.crossVectors(ac, ap);
        } else {
          const ab = subTo(this._bPos, this._aPos, _vTmp1);
          const ac = subTo(this._cPos, this._aPos, _vTmp2);
          this._bendAxis.crossVectors(ab, ac);
        }
        if (this._bendAxis.length < 1e-5) {
          this._bendAxis.set(0, 1, 0);
        } else {
          this._bendAxis.normalize();
        }
        quatFromAxisAngle(this._bendAxis, aBdes - aBcurr, this._midDelta);
        const midParentWorldQ = composeWorldQuat(mid.parent ? mid.parent.object3D : null, _qTmp1);
        quatInvert(midParentWorldQ, this._midParentInvW);
        const midWorldQ = composeWorldQuat(mid, _qTmp2);
        this._midWorldNew.multiply(this._midDelta, midWorldQ);
        this._midLocalNew.multiply(this._midParentInvW, this._midWorldNew);
        subTo(this._cPos, this._aPos, this._curDir).normalize();
        subTo(this._tPos, this._aPos, this._tgtDir).normalize();
        this._swingAxis.crossVectors(this._curDir, this._tgtDir);
        const rootBend = quatFromAxisAngle(this._bendAxis, aTdes - aTcurr, _qTmp3);
        let rootSwing;
        if (this._swingAxis.length > 1e-5) {
          this._swingAxis.normalize();
          const swingAngle = Math.acos(clamp(Vector3.dot(this._curDir, this._tgtDir), -1, 1));
          rootSwing = quatFromAxisAngle(this._swingAxis, swingAngle, _qTmp4);
        } else {
          rootSwing = _qIdentity;
        }
        this._rootDelta.multiply(rootSwing, rootBend);
        const rootParentWorldQ = composeWorldQuat(root.parent ? root.parent.object3D : null, _qTmp1);
        quatInvert(rootParentWorldQ, this._rootParentInvW);
        const rootWorldQ = composeWorldQuat(root, _qTmp2);
        this._rootWorldNew.multiply(this._rootDelta, rootWorldQ);
        this._rootLocalNew.multiply(this._rootParentInvW, this._rootWorldNew);
        if (this.weight >= 1) {
          root.localQuaternion = this._rootLocalNew;
          mid.localQuaternion = this._midLocalNew;
        } else {
          this._blendQ.slerp(this._origRootQ, this._rootLocalNew, this.weight);
          root.localQuaternion = this._blendQ;
          this._blendQ.slerp(this._origMidQ, this._midLocalNew, this.weight);
          mid.localQuaternion = this._blendQ;
        }
      }
    }
    const _vTmp1 = new Vector3();
    const _vTmp2 = new Vector3();
    const _vTmpPole = new Vector3();
    const _qTmp1 = new Quaternion();
    const _qTmp2 = new Quaternion();
    const _qTmp3 = new Quaternion();
    const _qTmp4 = new Quaternion();
    const _qIdentity = new Quaternion(0, 0, 0, 1);
    function readWorldPos(t) {
      if (t.transform !== void 0) return t.transform.worldPosition;
      return t;
    }
    function clamp(x, lo, hi) {
      return x < lo ? lo : x > hi ? hi : x;
    }
    function subTo(a, b, out) {
      out.set(a.x - b.x, a.y - b.y, a.z - b.z);
      return out;
    }
    function quatFromAxisAngle(axis, angle, out) {
      const half = angle * 0.5;
      const s = Math.sin(half);
      out.set(axis.x * s, axis.y * s, axis.z * s, Math.cos(half));
      return out;
    }
    function quatInvert(q, out) {
      out.set(-q.x, -q.y, -q.z, q.w);
      return out;
    }
    const _qComposeTmp = new Quaternion();
    function composeWorldQuat(obj, out) {
      if (!obj) {
        out.set(0, 0, 0, 1);
        return out;
      }
      const stack = [];
      let cur = obj;
      while (cur) {
        stack.push(cur);
        cur = cur.parent ? cur.parent.object3D : null;
      }
      out.copy(stack[stack.length - 1].localQuaternion);
      for (let i = stack.length - 2; i >= 0; i--) {
        _qComposeTmp.multiply(out, stack[i].localQuaternion);
        out.copy(_qComposeTmp);
      }
      return out;
    }

    var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
    var __decorateClass$e = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SkinnedMeshRenderer2 = class SkinnedMeshRenderer2 extends exports.MeshRenderer {
      /** Ordered names of the joints this skin is bound to. */
      skinJointsName;
      mInverseBindMatrixData;
      mInverseBindMatrixBuffer;
      mSkeletonAnimation;
      mJointIndexTableBuffer;
      constructor() {
        super();
        this.addRendererMask(RendererMask.SkinnedMesh);
      }
      /** The skinned geometry; setting it extracts skin joint names and bind poses. */
      get geometry() {
        return this._geometry;
      }
      set geometry(value) {
        this.skinJointsName = value.skinNames;
        let matrixList = [];
        for (let i = 0; i < value.bindPose.length; i++) {
          matrixList.push(new Float32Array(value.bindPose[i].rawData.slice(0, 16)));
        }
        this.skinInverseBindMatrices = matrixList;
        super.geometry = value;
        this._forceSkeletonDefine();
      }
      /** The materials applied to this skinned mesh. */
      get materials() {
        return super.materials;
      }
      /**
       * Override the materials setter so we can stamp `USE_SKELETON = true`
       * on every material's pass(es) AFTER `super.materials` has run
       * `initPipeline`. Why this is needed:
       *
       *   - glTF often shares one LitMaterial across multiple primitives
       *     (Kira: skin-driven `Kira_Hair_A.0020` and the static
       *     `Kira_Hair_A` reuse the same `matkey_<name>` cached material).
       *   - The first time the material is attached to a non-skinned
       *     MeshRenderer, `initPipeline` calls `preCompile`, which runs
       *     `preDefine(geometry-without-joints0)` and writes
       *     `USE_SKELETON = false` into the pass's defineValue map.
       *   - When the same material is later attached to a
       *     SkinnedMeshRenderer2, `initPipeline` sees the pass already has
       *     `shaderReflection` and SKIPS preCompile entirely → the stale
       *     `USE_SKELETON = false` sticks, the vertex shader's skinning
       *     branch is preprocessed out, and the mesh renders unskinned at
       *     the mesh node's worldMatrix (Kira's "head + jacket detached
       *     from bones" symptom).
       *
       * `setDefine` flips `_shaderChange` / `_valueChange`, so the next
       * `nodeUpdate` re-runs `preCompile` (this time WITH the skin's
       * geometry that has joints0) and rebuilds the pipeline with
       * USE_SKELETON correctly applied.
       */
      set materials(value) {
        super.materials = value;
        this._forceSkeletonDefine();
      }
      _forceSkeletonDefine() {
        const list = this._materials;
        if (!list || list.length === 0) return;
        const passTypes = [PassType.COLOR, PassType.SHADOW, PassType.DEPTH, PassType.POINT_SHADOW];
        for (const mat of list) {
          const ps = mat?.shader?.passShader;
          if (!ps) continue;
          for (const pt of passTypes) {
            const passes = ps.get?.(pt);
            if (!passes) continue;
            for (const pass of passes) pass.setDefine("USE_SKELETON", true);
          }
        }
      }
      /** Resolve the driving AnimatorComponent from the hierarchy if not already set. */
      start() {
        super.start();
        if (this.skeletonAnimation) return;
        this.skeletonAnimation = this.object3D.getComponent(exports.AnimatorComponent);
        if (this.skeletonAnimation) return;
        let cursor = this.object3D;
        while (cursor) {
          const found = cursor.getComponentsInChild(exports.AnimatorComponent);
          if (found.length > 0) {
            this.skeletonAnimation = found[0];
            return;
          }
          const parent = cursor.parent && cursor.parent.object3D;
          if (!parent) break;
          cursor = parent;
        }
      }
      /** Blend-shape (morph) data, mapping target name to influence value. */
      get blendShape() {
        return this.morphData;
      }
      /** Register the renderer when enabled. */
      onEnable() {
        super.onEnable();
      }
      /** The AnimatorComponent driving this skin. */
      get skeletonAnimation() {
        return this.mSkeletonAnimation;
      }
      set skeletonAnimation(value) {
        this.mSkeletonAnimation = value;
        if (!value) {
          return;
        }
        if (!this.mJointIndexTableBuffer) {
          let skinJointIndexData = this.mSkeletonAnimation.getJointIndexTable(this.skinJointsName);
          this.mJointIndexTableBuffer = new StorageGPUBuffer(skinJointIndexData.length, 0, new Float32Array(skinJointIndexData));
          this.mJointIndexTableBuffer.visibility = GPUShaderStage.VERTEX | GPUShaderStage.COMPUTE;
        }
      }
      /** Per-joint inverse bind matrices used to skin the mesh. */
      get skinInverseBindMatrices() {
        return this.mInverseBindMatrixData;
      }
      set skinInverseBindMatrices(inverseBindMatrices) {
        this.mInverseBindMatrixData = inverseBindMatrices;
        var inverseBindMatricesData = new Float32Array(inverseBindMatrices.length * 16);
        for (let i = 0; i < inverseBindMatrices.length; i++) {
          let index = i * 16;
          let mat4x4 = inverseBindMatrices[i];
          inverseBindMatricesData.set(mat4x4, index);
        }
        this.mInverseBindMatrixBuffer = new StorageGPUBuffer(inverseBindMatricesData.byteLength, 0, inverseBindMatricesData);
        this.mInverseBindMatrixBuffer.visibility = GPUShaderStage.VERTEX | GPUShaderStage.COMPUTE;
      }
      /** GPU buffer holding the inverse bind matrices. */
      get inverseBindMatrixBuffer() {
        return this.mInverseBindMatrixBuffer;
      }
      /** GPU buffer mapping skin joints to skeleton joint indices. */
      get jointIndexTableBuffer() {
        return this.mJointIndexTableBuffer.buffer;
      }
      /** Clone this skinned mesh renderer (with cloned materials) onto another object. */
      cloneTo(obj) {
        let skinnedMesh = obj.addComponent(exports.SkinnedMeshRenderer2);
        let newMats = [];
        for (const mat of this.materials) {
          newMats.push(mat.clone());
        }
        skinnedMesh.materials = newMats;
        skinnedMesh.geometry = this.geometry;
        skinnedMesh.castShadow = this.castShadow;
        skinnedMesh.castGI = this.castGI;
        skinnedMesh.receiveShadow = this.receiveShadow;
        skinnedMesh.rendererMask = this.rendererMask;
        skinnedMesh.skinJointsName = this.skinJointsName;
        skinnedMesh.skinInverseBindMatrices = this.skinInverseBindMatrices;
        skinnedMesh.mJointIndexTableBuffer = this.mJointIndexTableBuffer;
      }
      /**
       * @internal
       * @param passType
       * @param renderPassState
       * @param scene3D
       * @param clusterLightingRender
       * @param probes
       */
      nodeUpdate(view, passType, renderPassState, clusterLightingBuffer) {
        for (let i = 0; i < this.materials.length; i++) {
          const material = this.materials[i];
          let passes = material.getPass(passType);
          if (passes) for (let i2 = 0; i2 < passes.length; i2++) {
            const renderShader = passes[i2];
            if (this.mSkeletonAnimation && !this._skinBoundShaders.has(renderShader)) {
              const hadPipeline = !!renderShader.pipeline;
              renderShader.setStorageBuffer("jointsMatrixIndexTable", this.mSkeletonAnimation.jointMatrixIndexTableBuffer);
              renderShader.setStorageBuffer("jointsInverseMatrix", this.mInverseBindMatrixBuffer);
              renderShader.setStorageBuffer("jointsIndexMapingTable", this.mJointIndexTableBuffer);
              if (hadPipeline) {
                renderShader.pipeline = null;
                renderShader._valueChange = true;
              }
              this._skinBoundShaders.add(renderShader);
            }
          }
        }
        super.nodeUpdate(view, passType, renderPassState, clusterLightingBuffer);
      }
      /** Per-renderShader memoization for skin-buffer binding (see nodeUpdate). */
      _skinBoundShaders = /* @__PURE__ */ new WeakSet();
    };
    exports.SkinnedMeshRenderer2 = __decorateClass$e([
      RegisterComponent(exports.SkinnedMeshRenderer2, "SkinnedMeshRenderer2")
    ], exports.SkinnedMeshRenderer2);

    class MorphTargetBlender extends ComponentBase {
      _targetRenderers = {};
      _vec3 = new Vector3();
      _matrix4 = new Matrix4();
      _quaternion = new Quaternion();
      /** Collect morph-capable renderers in the subtree and index them by morph key. */
      init(param) {
        let meshRenders = this.fetchMorphRenderers(this.object3D, exports.SkinnedMeshRenderer2);
        let meshRenders2 = this.fetchMorphRenderers(this.object3D, exports.MeshRenderer);
        meshRenders.push(...meshRenders2);
        for (const renderer of meshRenders) {
          let hasMorphTarget = RendererMaskUtil.hasMask(renderer.rendererMask, RendererMask.MorphTarget);
          if (hasMorphTarget) {
            renderer.selfCloneMaterials("MORPH_TARGET_UUID");
          }
          for (const key in renderer.geometry.morphTargetDictionary) {
            let renderList = this._targetRenderers[key] || [];
            renderList.push(renderer);
            this._targetRenderers[key] = renderList;
          }
        }
      }
      /** Get the renderers that own the given morph-target key. */
      getMorphRenderersByKey(key) {
        return this._targetRenderers[key];
      }
      /** Return a shallow copy of the morph-key to renderers map. */
      cloneMorphRenderers() {
        let dst = {};
        for (let key in this._targetRenderers) {
          dst[key] = this._targetRenderers[key];
        }
        return dst;
      }
      /**
       * Inject arkit data into the model and let all meshRender below the node accept morph animation
       * @param frame: BlendShape data output from ARKit.
       * @param keyMapper: Table mapping the relationship between the model's modelKey and ARKit's output arkitKey: {modelKey: arkitKey}.
       * @param multiplier: Scaling factor for movement data.
       * @returns
       */
      applyBlendShape(frame, keyMapper, multiplier = 1) {
        if (!frame) {
          console.warn("blendShape is null");
          return;
        }
        this._vec3.setFromArray(frame.transform.transform[3]);
        this._vec3.multiplyScalar(multiplier);
        this.object3D.transform.localPosition = this._vec3;
        this._vec3.setFromArray(frame.transform.transform[2]);
        this._matrix4.copyColFrom(2, this._vec3);
        this._vec3.setFromArray(frame.transform.transform[1]);
        this._matrix4.copyColFrom(1, this._vec3);
        this._vec3.setFromArray(frame.transform.transform[0]);
        this._matrix4.copyColFrom(0, this._vec3);
        this._matrix4.transpose();
        this._quaternion.setFromRotationMatrix(this._matrix4);
        this.object3D.localQuaternion = this._quaternion;
        for (let keyInModel in keyMapper) {
          let renderList = this._targetRenderers[keyInModel];
          let stdKey = keyMapper[keyInModel];
          let influence = frame.texture[stdKey];
          this.applyMorphTargetInfluence(keyInModel, influence, renderList);
        }
      }
      applyMorphTargetInfluence(key, influence, rendererList) {
        for (let renderer of rendererList) {
          renderer.setMorphInfluence(key, influence);
        }
      }
      fetchMorphRenderers(obj, c) {
        let sourceRenders = obj.getComponentsInChild(c);
        let result = [];
        for (let renderer of sourceRenders) {
          if (renderer.hasMask(RendererMask.MorphTarget)) {
            result.push(renderer);
          }
        }
        return result;
      }
    }

    class MorphTargetFrame {
      /** Per-blend-shape influence weights keyed by ARKit blend-shape name. */
      texture;
      /** Head and eye transforms captured for this frame. */
      transform;
    }

    var MorphTargetTransformKey = /* @__PURE__ */ ((MorphTargetTransformKey2) => {
      MorphTargetTransformKey2["mouthRollLower"] = "mouthRollLower";
      MorphTargetTransformKey2["browOuterUp_L"] = "browOuterUpLeft";
      MorphTargetTransformKey2["mouthSmile_L"] = "mouthSmileLeft";
      MorphTargetTransformKey2["jawRight"] = "jawRight";
      MorphTargetTransformKey2["eyeLookOut_L"] = "eyeLookOutLeft";
      MorphTargetTransformKey2["mouthFunnel"] = "mouthFunnel";
      MorphTargetTransformKey2["mouthUpperUp_R"] = "mouthUpperUpRight";
      MorphTargetTransformKey2["browDown_L"] = "browDownLeft";
      MorphTargetTransformKey2["jawLeft"] = "jawLeft";
      MorphTargetTransformKey2["mouthLowerDown_L"] = "mouthLowerDownLeft";
      MorphTargetTransformKey2["noseSneer_R"] = "noseSneerRight";
      MorphTargetTransformKey2["jawForward"] = "jawForward";
      MorphTargetTransformKey2["mouthLowerDown_R"] = "mouthLowerDownRight";
      MorphTargetTransformKey2["browInnerUp"] = "browInnerUp";
      MorphTargetTransformKey2["mouthRollUpper"] = "mouthRollUpper";
      MorphTargetTransformKey2["mouthStretch_R"] = "mouthStretchRight";
      MorphTargetTransformKey2["mouthPucker"] = "mouthPucker";
      MorphTargetTransformKey2["eyeBlink_L"] = "eyeBlinkLeft";
      MorphTargetTransformKey2["mouthUpperUp_L"] = "mouthUpperUpLeft";
      MorphTargetTransformKey2["mouthShrugUpper"] = "mouthShrugUpper";
      MorphTargetTransformKey2["eyeLookIn_R"] = "eyeLookInRight";
      MorphTargetTransformKey2["noseSneer_L"] = "noseSneerLeft";
      MorphTargetTransformKey2["mouthFrown_L"] = "mouthFrownLeft";
      MorphTargetTransformKey2["cheekSquint_L"] = "cheekSquintLeft";
      MorphTargetTransformKey2["eyeLookDown_L"] = "eyeLookDownLeft";
      MorphTargetTransformKey2["mouthDimple_L"] = "mouthDimpleLeft";
      MorphTargetTransformKey2["mouthFrown_R"] = "mouthFrownRight";
      MorphTargetTransformKey2["eyeLookIn_L"] = "eyeLookInLeft";
      MorphTargetTransformKey2["eyeLookOut_R"] = "eyeLookOutRight";
      MorphTargetTransformKey2["mouthLeft"] = "mouthLeft";
      MorphTargetTransformKey2["mouthStretch_L"] = "mouthStretchLeft";
      MorphTargetTransformKey2["mouthPress_L"] = "mouthPressLeft";
      MorphTargetTransformKey2["mouthDimple_R"] = "mouthDimpleRight";
      MorphTargetTransformKey2["eyeWide_R"] = "eyeWideRight";
      MorphTargetTransformKey2["browDown_R"] = "browDownRight";
      MorphTargetTransformKey2["eyeLookUp_R"] = "eyeLookUpRight";
      MorphTargetTransformKey2["eyeBlink_R"] = "eyeBlinkRight";
      MorphTargetTransformKey2["cheekSquint_R"] = "cheekSquintRight";
      MorphTargetTransformKey2["mouthRight"] = "mouthDimpleRight";
      MorphTargetTransformKey2["eyeLookDown_R"] = "eyeLookDownRight";
      MorphTargetTransformKey2["eyeLookUp_L"] = "eyeLookUpLeft";
      MorphTargetTransformKey2["eyeSquint_L"] = "eyeSquintLeft";
      MorphTargetTransformKey2["jawOpen"] = "jawOpen";
      MorphTargetTransformKey2["browOuterUp_R"] = "browOuterUpRight";
      MorphTargetTransformKey2["mouthClose"] = "mouthClose";
      MorphTargetTransformKey2["mouthShrugLower"] = "mouthShrugLower";
      MorphTargetTransformKey2["eyeWide_L"] = "eyeWideLeft";
      MorphTargetTransformKey2["tongueOut"] = "tongueOut";
      MorphTargetTransformKey2["eyeSquint_R"] = "eyeSquintRight";
      MorphTargetTransformKey2["cheekPuff"] = "cheekPuff";
      MorphTargetTransformKey2["mouthPress_R"] = "mouthPressRight";
      MorphTargetTransformKey2["mouthSmile_R"] = "mouthSmileRight";
      return MorphTargetTransformKey2;
    })(MorphTargetTransformKey || {});

    class Retargeter {
      _source;
      _target;
      _nameMap;
      _exclude;
      _useRestOffset;
      _preserveHipPosition;
      _heightScale;
      _alignTPoseFacing;
      _bonePrefixes;
      _resolved = null;
      /** target boneName → source boneName, for quick reverse lookup in apply(). */
      _tgtToSrc = /* @__PURE__ */ new Map();
      /** source bone bind worldQ (FK starting from source Character rotation). */
      _bindWorldS = /* @__PURE__ */ new Map();
      /**
       * target bone bind worldQ (FK starting from target Character
       * rotation, AFTER any auto-rotation `alignTPoseFacing` applied).
       */
      _bindWorldT = /* @__PURE__ */ new Map();
      /**
       * Per-bone world-space retarget offset cache (keyed by *target*
       * bone name): `inv(bindWorldS[srcBone]) * bindWorldT[tgtBone]`.
       * Applied as `target_world = sourceCurrentWorld * offset[bone]`,
       * so at TPose target stays at its own bind world (no mesh
       * distortion at any bone) and during motion source's world delta
       * from bind drives target.
       */
      _offset = /* @__PURE__ */ new Map();
      /** source rig root (Character node) rotation captured at buildMapping. */
      _rootRotS = new Quaternion();
      /** target rig root (Character node) rotation captured at buildMapping. */
      _rootRotT = new Quaternion();
      /** Hip pair name + bind localPosition for the position channel. */
      _hipSrcName = null;
      _hipTgtName = null;
      _bindHipLocalPosS = new Vector3();
      _bindHipLocalPosT = new Vector3();
      /** scratch reusable quaternions/vectors to avoid per-frame GC pressure. */
      _scratchInvParentT = new Quaternion();
      _scratchInvRootRotT = new Quaternion();
      _scratchOut = new Quaternion();
      _scratchHipDelta = new Vector3();
      _scratchHipPos = new Vector3();
      /** per-bone tracked currentWorldQ during apply(); reused, cleared each call. */
      _currentWorldS = /* @__PURE__ */ new Map();
      _currentWorldT = /* @__PURE__ */ new Map();
      constructor(source, target, cfg) {
        this._source = source;
        this._target = target;
        if (!cfg.nameMap) {
          this._nameMap = /* @__PURE__ */ new Map();
        } else if (cfg.nameMap instanceof Map) {
          this._nameMap = cfg.nameMap;
        } else {
          this._nameMap = new Map(Object.entries(cfg.nameMap));
        }
        this._exclude = cfg.excludeSourceBones ?? /* @__PURE__ */ new Set();
        this._useRestOffset = cfg.useRestOffset ?? true;
        this._preserveHipPosition = cfg.preserveHipPosition ?? false;
        this._heightScale = cfg.heightScale ?? 1;
        this._alignTPoseFacing = cfg.alignTPoseFacing ?? true;
        this._bonePrefixes = cfg.bonePrefixes ?? ["mixamorig:", "Armature|"];
      }
      /**
       * Build the source→target bone mapping + capture each rig's
       * Character (root) rotation, target's per-bone bind worldQ, and
       * the hip-pair bind translations. Called lazily on the first
       * `apply()`; can be re-called explicitly if either avatar
       * changes.
       */
      buildMapping() {
        const srcAvatar = this._source.getAvatar();
        const tgtAvatar = this._target.getAvatar();
        if (!srcAvatar || !tgtAvatar) {
          this._resolved = [];
          return;
        }
        const targetNames = /* @__PURE__ */ new Set();
        for (const b of tgtAvatar.boneData) targetNames.add(b.boneName);
        const out = [];
        this._tgtToSrc.clear();
        for (const srcBone of srcAvatar.boneData) {
          if (this._exclude.has(srcBone.boneName)) continue;
          const mapped = this._nameMap.get(srcBone.boneName);
          let tgtName = null;
          if (mapped && targetNames.has(mapped)) {
            tgtName = mapped;
          } else {
            const stripped = this._stripPrefix(srcBone.boneName);
            for (const t of targetNames) {
              if (t === srcBone.boneName || t.toLowerCase() === srcBone.boneName.toLowerCase() || this._stripPrefix(t).toLowerCase() === stripped.toLowerCase()) {
                tgtName = t;
                break;
              }
            }
          }
          if (!tgtName) continue;
          out.push({ srcName: srcBone.boneName, tgtName });
          this._tgtToSrc.set(tgtName, srcBone.boneName);
          targetNames.delete(tgtName);
        }
        this._resolved = out;
        const srcRootBone = srcAvatar.boneData.length > 0 ? this._source.getJointObject(srcAvatar.boneData[0].boneName) : null;
        const tgtRootBone = tgtAvatar.boneData.length > 0 ? this._target.getJointObject(out[0]?.tgtName ?? tgtAvatar.boneData[0].boneName) : null;
        const srcCharObj = srcRootBone?.parent ? srcRootBone.parent.object3D : null;
        const tgtCharObj = tgtRootBone?.parent ? tgtRootBone.parent.object3D : null;
        if (srcCharObj?.localQuaternion) this._rootRotS.copy(srcCharObj.localQuaternion);
        else this._rootRotS.set(0, 0, 0, 1);
        if (tgtCharObj?.localQuaternion) this._rootRotT.copy(tgtCharObj.localQuaternion);
        else this._rootRotT.set(0, 0, 0, 1);
        this._hipSrcName = null;
        this._hipTgtName = null;
        for (const pair of out) {
          const srcBone = srcAvatar.boneMap.get(pair.srcName);
          if (srcBone && (!srcBone.parentBoneName || srcBone.parentBoneName === "")) {
            const tgtBone = tgtAvatar.boneMap.get(pair.tgtName);
            if (tgtBone) {
              this._hipSrcName = pair.srcName;
              this._hipTgtName = pair.tgtName;
              this._bindHipLocalPosS.copy(srcBone.t);
              this._bindHipLocalPosT.copy(tgtBone.t);
            }
            break;
          }
        }
        if (!this._useRestOffset) return;
        computeBindWorldRotations(srcAvatar, this._rootRotS, this._bindWorldS);
        computeBindWorldRotations(tgtAvatar, this._rootRotT, this._bindWorldT);
        if (this._alignTPoseFacing && tgtCharObj) {
          const rootSrc = this._hipSrcName ?? out[0]?.srcName;
          const rootTgt = this._hipTgtName ?? out[0]?.tgtName;
          const bindWS = rootSrc ? this._bindWorldS.get(rootSrc) : void 0;
          const bindWT = rootTgt ? this._bindWorldT.get(rootTgt) : void 0;
          if (bindWS && bindWT) {
            const invBindWT = new Quaternion(-bindWT.x, -bindWT.y, -bindWT.z, bindWT.w);
            const qAlign = new Quaternion();
            qAlign.multiply(bindWS, invBindWT);
            const oldChar = new Quaternion();
            oldChar.copy(tgtCharObj.localQuaternion);
            const newChar = new Quaternion();
            newChar.multiply(qAlign, oldChar);
            tgtCharObj.localQuaternion = newChar;
            this._rootRotT.copy(newChar);
            computeBindWorldRotations(tgtAvatar, this._rootRotT, this._bindWorldT);
          }
        }
        this._offset.clear();
        for (const pair of out) {
          const bws = this._bindWorldS.get(pair.srcName);
          const bwt = this._bindWorldT.get(pair.tgtName);
          if (!bws || !bwt) continue;
          const off = new Quaternion();
          const invBws = new Quaternion(-bws.x, -bws.y, -bws.z, bws.w);
          off.multiply(invBws, bwt);
          this._offset.set(pair.tgtName, off);
        }
      }
      get resolvedMapping() {
        if (this._resolved === null) this.buildMapping();
        return this._resolved.map((r) => [r.srcName, r.tgtName]);
      }
      /**
       * Per-frame retarget. Call from your render loop AFTER the source
       * Animator's own update has run.
       */
      apply() {
        if (this._resolved === null) this.buildMapping();
        if (!this._resolved || this._resolved.length === 0) return;
        if (!this._useRestOffset) {
          for (const pair of this._resolved) {
            const sBone = this._source.getJointObject(pair.srcName);
            const tBone = this._target.getJointObject(pair.tgtName);
            if (sBone && tBone) tBone.localQuaternion = sBone.localQuaternion;
          }
          this._applyHipPosition();
          return;
        }
        const srcAvatar = this._source.getAvatar();
        const tgtAvatar = this._target.getAvatar();
        if (!srcAvatar || !tgtAvatar) return;
        const cwS = this._currentWorldS;
        cwS.clear();
        for (const bone of srcAvatar.boneData) {
          const obj = this._source.getJointObject(bone.boneName);
          if (!obj) continue;
          const w = new Quaternion();
          if (bone.parentBoneName && cwS.has(bone.parentBoneName)) {
            w.multiply(cwS.get(bone.parentBoneName), obj.localQuaternion);
          } else {
            w.multiply(this._rootRotS, obj.localQuaternion);
          }
          cwS.set(bone.boneName, w);
        }
        const cwT = this._currentWorldT;
        cwT.clear();
        for (const bone of tgtAvatar.boneData) {
          const obj = this._target.getJointObject(bone.boneName);
          if (!obj) continue;
          const parent = bone.parentBoneName && cwT.has(bone.parentBoneName) ? cwT.get(bone.parentBoneName) : this._rootRotT;
          const srcName = this._tgtToSrc.get(bone.boneName);
          const srcCurW = srcName ? cwS.get(srcName) : void 0;
          const offset = this._offset.get(bone.boneName);
          const w = new Quaternion();
          if (srcCurW && offset) {
            w.multiply(srcCurW, offset);
            this._scratchInvParentT.set(-parent.x, -parent.y, -parent.z, parent.w);
            this._scratchOut.multiply(this._scratchInvParentT, w);
            obj.localQuaternion = this._scratchOut;
          } else {
            w.multiply(parent, obj.localQuaternion);
          }
          cwT.set(bone.boneName, w);
        }
        this._applyHipPosition();
      }
      /**
       * Replay the source hip's bind-relative translation delta on the
       * target hip, transformed across the two rigs' Character frames
       * and scaled by `heightScale`. Skipped when `preserveHipPosition`
       * is true or when no hip pair was resolved at buildMapping.
       */
      _applyHipPosition() {
        if (this._preserveHipPosition) return;
        if (!this._hipSrcName || !this._hipTgtName) return;
        const sourceHip = this._source.getJointObject(this._hipSrcName);
        const targetHip = this._target.getJointObject(this._hipTgtName);
        if (!sourceHip || !targetHip) return;
        const sLocal = sourceHip.localPosition;
        this._scratchHipDelta.set(
          sLocal.x - this._bindHipLocalPosS.x,
          sLocal.y - this._bindHipLocalPosS.y,
          sLocal.z - this._bindHipLocalPosS.z
        );
        Quaternion.transformVector(this._rootRotS, this._scratchHipDelta, this._scratchHipDelta);
        this._scratchInvRootRotT.set(-this._rootRotT.x, -this._rootRotT.y, -this._rootRotT.z, this._rootRotT.w);
        Quaternion.transformVector(this._scratchInvRootRotT, this._scratchHipDelta, this._scratchHipDelta);
        this._scratchHipPos.set(
          this._bindHipLocalPosT.x + this._scratchHipDelta.x * this._heightScale,
          this._bindHipLocalPosT.y + this._scratchHipDelta.y * this._heightScale,
          this._bindHipLocalPosT.z + this._scratchHipDelta.z * this._heightScale
        );
        targetHip.localPosition = this._scratchHipPos;
      }
      /**
       * Strip the first matching prefix in `_bonePrefixes` (case-insensitive)
       * from a bone name. Used for fuzzy cross-rig name matching when no
       * explicit `nameMap` entry is provided.
       */
      _stripPrefix(name) {
        const lower = name.toLowerCase();
        for (const p of this._bonePrefixes) {
          if (lower.startsWith(p.toLowerCase())) return name.slice(p.length);
        }
        return name;
      }
    }
    function computeBindWorldRotations(avatar, rootRot, out) {
      out.clear();
      for (const bone of avatar.boneData) {
        const local = bone.q;
        const world = new Quaternion();
        if (bone.parentBoneName && out.has(bone.parentBoneName)) {
          const parentWorld = out.get(bone.parentBoneName);
          world.multiply(parentWorld, local);
        } else {
          world.multiply(rootRot, local);
        }
        out.set(bone.boneName, world);
      }
    }

    class Skeleton {
      /**
       * Link information for all joints
       */
      joints;
      constructor(joints = []) {
        this.joints = joints;
      }
      get numJoint() {
        return this.joints.length;
      }
      addJoint(joint) {
        joint.index = this.joints.push(joint) - 1;
      }
      getJointName(jointIndex) {
        return this.joints[jointIndex].name;
      }
      getJointParentIndex(jointIndex) {
        let joint = this.joints[jointIndex];
        return joint.parent ? joint.parent.index : -1;
      }
      getJointByName(name) {
        for (let joint of this.joints) {
          if (joint.name == name) {
            return joint;
          }
        }
        return null;
      }
    }

    class SkeletonAnimationCompute {
      _computePipeline;
      _computeBindGroup;
      _boundCtx = null;
      constructor(ctx, computeShader, entries) {
        bindCtx(this, ctx);
        let device = ctx.device;
        this._computePipeline = device.createComputePipeline({
          layout: `auto`,
          compute: {
            module: device.createShaderModule({
              code: computeShader
            }),
            entryPoint: "CsMain"
          }
        });
        this._computeBindGroup = device.createBindGroup({
          layout: this._computePipeline.getBindGroupLayout(0),
          entries
        });
      }
      compute(command, workgroupCountX, workgroupCountY, workgroupCountZ) {
        let computePass = command.beginComputePass();
        computePass.setPipeline(this._computePipeline);
        computePass.setBindGroup(0, this._computeBindGroup);
        computePass.dispatchWorkgroups(workgroupCountX, workgroupCountY, workgroupCountZ);
        computePass.end();
        return this;
      }
    }

    class SkeletonBlendComputeArgs extends MemoryDO {
      numJoint;
      numState;
      time;
      weight;
      argumentsData;
      _isDirty = false;
      _argumentsBuffer;
      _argumentsBufferEntries;
      _boundCtx = null;
      constructor(ctx) {
        super();
        this.allocationMemorySet([
          { name: `numJoint`, data: [0] },
          { name: `numState`, data: [0] },
          { name: `retain1`, data: [0] },
          { name: `retain2`, data: [0] },
          { name: `time`, data: [0, 0] },
          { name: `weight`, data: [0, 0] }
        ]);
        this.generateGPUBuffer(ctx);
      }
      getGPUBuffer() {
        return this._argumentsBuffer;
      }
      getGPUBindGroupEntry() {
        return this._argumentsBufferEntries;
      }
      updateGPUBuffer() {
        if (this._isDirty) {
          this._isDirty = false;
          if (!this._boundCtx) {
            throw new Error(`SkeletonBlendComputeArgs used before bindCtx — construct with a Context3D from the owning Engine3D.`);
          }
          this._boundCtx.device.queue.writeBuffer(this._argumentsBuffer, 0, this.shareDataBuffer);
        }
        return this;
      }
      allocationMemorySet(dataDic) {
        this.argumentsData = {};
        let count = 0;
        for (let i = 0; i < dataDic.length; i++) {
          const element = dataDic[i];
          count += element.data.length;
        }
        this.allocation(count * 4);
        let self = this;
        for (let i = 0; i < dataDic.length; i++) {
          const element = dataDic[i];
          const key = element.name;
          this.argumentsData[key] = this.allocation_node(element.data.length * 4);
          self[key] = this.argumentsData[key];
        }
      }
      generateGPUBuffer(ctx) {
        bindCtx(this, ctx);
        let device = ctx.device;
        this._argumentsBuffer = device.createBuffer({
          size: this.shareDataBuffer.byteLength,
          usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
          mappedAtCreation: false
        });
        this._argumentsBufferEntries = {
          binding: 0,
          resource: {
            buffer: this._argumentsBuffer,
            offset: 0,
            size: this.shareDataBuffer.byteLength
          }
        };
      }
    }

    class SkeletonTransformComputeArgs extends MemoryDO {
      numJoint;
      numFrame;
      retain0;
      retain1;
      argumentsData;
      _isDirty = false;
      _argumentsBuffer;
      _argumentsBufferEntries;
      _boundCtx = null;
      constructor(ctx) {
        super();
        this.allocationMemorySet([
          { name: `numJoint`, data: [0] },
          { name: `numFrame`, data: [0] },
          { name: `retain0`, data: [0] },
          { name: `retain1`, data: [0] }
        ]);
        this.generateGPUBuffer(ctx);
      }
      getGPUBuffer() {
        return this._argumentsBuffer;
      }
      getGPUBindGroupEntry() {
        return this._argumentsBufferEntries;
      }
      updateGPUBuffer() {
        if (this._isDirty) {
          this._isDirty = false;
          if (!this._boundCtx) {
            throw new Error(`SkeletonTransformComputeArgs used before bindCtx — construct with a Context3D from the owning Engine3D.`);
          }
          this._boundCtx.device.queue.writeBuffer(this._argumentsBuffer, 0, this.shareDataBuffer);
        }
      }
      allocationMemorySet(dataDic) {
        this.argumentsData = {};
        let count = 0;
        for (let i = 0; i < dataDic.length; i++) {
          const element = dataDic[i];
          count += element.data.length;
        }
        this.allocation(count * 4);
        let self = this;
        for (let i = 0; i < dataDic.length; i++) {
          const element = dataDic[i];
          const key = element.name;
          this.argumentsData[key] = this.allocation_node(element.data.length * 4);
          self[key] = this.argumentsData[key];
        }
      }
      generateGPUBuffer(ctx) {
        bindCtx(this, ctx);
        let device = ctx.device;
        this._argumentsBuffer = device.createBuffer({
          size: this.shareDataBuffer.byteLength,
          usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
          mappedAtCreation: false
        });
        this._argumentsBufferEntries = {
          binding: 0,
          resource: {
            buffer: this._argumentsBuffer,
            offset: 0,
            size: this.shareDataBuffer.byteLength
          }
        };
      }
    }

    let compute_skeleton_blend = (
      /* wgsl */
      `
  ${MathShader}

  struct Arguments {
    numJoint: f32,
    numState: f32,
    retain1: f32,
    retain2: f32,
    time: vec2<f32>,
    weight: vec2<f32>,
  };

  struct JointData {
    scale: vec4<f32>,
    rotation: vec4<f32>,
    translation: vec4<f32>,
  };

  @group(0) @binding(0) var<storage, read_write> args: Arguments;
  @group(0) @binding(1) var<storage, read_write> jointsFinalMatrix: array<mat4x4<f32>>;
  @group(0) @binding(2) var<storage, read_write> jointsWorldMatrix: array<mat4x4<f32>>;

  @compute @workgroup_size(1)
  fn CsMain(@builtin(workgroup_id) workgroup_id: vec3<u32>, @builtin(local_invocation_index) local_index: u32) {
    let numJoint = i32(args.numJoint);
    let numState = i32(args.numState);
    let nJointIndex = i32(workgroup_id.x);

    jointsFinalMatrix[nJointIndex] = mixMatrix4x4(jointsWorldMatrix[0 * numJoint + nJointIndex], jointsWorldMatrix[1 * numJoint + nJointIndex], args.time[0]) * args.weight[0];

    for (var i = 1; i < numState; i++) {
      jointsFinalMatrix[nJointIndex] += mixMatrix4x4(jointsWorldMatrix[(i * 2 + 0) * numJoint + nJointIndex], jointsWorldMatrix[(i * 2 + 1) * numJoint + nJointIndex], args.time[i]) * args.weight[i];
    }
  }
`
    );

    let compute_skeleton_transform = (
      /* wgsl */
      `
  ${MathShader}

  struct Arguments {
    numJoint: f32,
    numFrame: f32,
    retain0: f32,
    retain1: f32,
  };

  struct JointData {
    scale: vec4<f32>,
    rotation: vec4<f32>,
    translation: vec4<f32>,
  };

  @group(0) @binding(0) var<storage, read_write> args: Arguments;
  @group(0) @binding(1) var<storage, read_write> jointsKeyframe: array<JointData>;
  @group(0) @binding(2) var<storage, read_write> jointsWorldMatrix: array<mat4x4<f32>>;
  @group(0) @binding(3) var<storage, read_write> jointsParentIndex: array<f32>;

  @compute @workgroup_size(1)
  fn CsMain(@builtin(workgroup_id) workgroup_id: vec3<u32>, @builtin(local_invocation_index) local_index: u32) {
    let numJoint = i32(args.numJoint);
    let nFrameIndex = i32(workgroup_id.x);
    for (var nJointIndex = 0; nJointIndex < numJoint; nJointIndex++) {
      let dataIndex = nFrameIndex * numJoint + nJointIndex;
      let joint = jointsKeyframe[dataIndex];
      let jointLocalMatrix = MakeMatrix4x4(joint.scale.xyz, joint.rotation, joint.translation.xyz);

      let nParentIndex = i32(jointsParentIndex[nJointIndex]);
      if (nParentIndex < 0) {
        jointsWorldMatrix[dataIndex] = jointLocalMatrix;
      } else {
        jointsWorldMatrix[dataIndex] = jointsWorldMatrix[nFrameIndex * numJoint + nParentIndex] * jointLocalMatrix;
      }
    }
  }
`
    );

    class CameraControllerBase {
      _autoUpdate = true;
      _target;
      _lookAtObject;
      _origin = new Vector3(0, 0, 0);
      _speed = 300;
      /**
       *
       * @constructor
       * @param targetObject control object3D
       * @param lookAtObject observational object3D
       */
      constructor(targetObject = null, lookAtObject = null) {
        this._target = targetObject;
        this._lookAtObject = lookAtObject;
      }
      /**
       *
       * Get the control object3D
       * @returns Object3D
       */
      get target() {
        return this._target;
      }
      /**
       *
       * Set the control object3D
       * @param val Object3D
       */
      set target(val) {
        if (this._target == val) return;
        this._target = val;
      }
      /**
       *
       * Get observational object3D
       * @returns Object3D
       */
      get lookAtObject() {
        return this._lookAtObject;
      }
      /**
       *
       * Set observational object3D
       * @param val Object3D
       */
      set lookAtObject(val) {
        if (this._lookAtObject == val) return;
        this._lookAtObject = val;
      }
      /**
       *
       * Get moving speed
       * @returns number
       */
      get speed() {
        return this._speed;
      }
      /**
       *
       * Set moving speed
       * @returns number
       */
      set speed(val) {
        this._speed = val;
      }
      /**
       * update(tick)
       */
      update() {
      }
    }

    class FirstPersonCameraController extends ComponentBase {
      focus;
      distance = 5;
      _camera;
      constructor() {
        super();
      }
      _input() {
        const view = this.transform?.view3D;
        const owner = view?.engine3D;
        return owner?.inputSystem;
      }
      start() {
        this._camera = this.object3D.getOrAddComponent(Camera3D);
        if (!this._camera) {
          console.error("FirstPersonCameraController need camera");
          return;
        }
        if (!this.focus) {
          console.error("FirstPersonCameraController need target");
          return;
        }
        const input = this._input();
        if (!input) return;
        input.addEventListener(PointerEvent3D.POINTER_WHEEL, this.mouseWheel, this);
        input.addEventListener(PointerEvent3D.POINTER_UP, this.mouseUp, this);
        input.addEventListener(PointerEvent3D.POINTER_DOWN, this.mouseDown, this);
      }
      mouseDown(e) {
        this._input()?.addEventListener(PointerEvent3D.POINTER_MOVE, this.mouseMove, this);
      }
      mouseUp(e) {
        this._input()?.removeEventListener(PointerEvent3D.POINTER_MOVE, this.mouseMove, this);
      }
      mouseMove(e) {
        let temp = this.transform.localRotation;
        temp.y += e.movementX * 0.01;
        temp.x += e.movementY * 0.01;
        this.transform.localRotation = temp;
      }
      mouseWheel(e) {
        this.distance += (this._input()?.wheelDelta ?? 0) * 0.1;
      }
      onUpdate() {
        let vec = new Vector3();
        Vector3.multiplyScalar(this._camera.transform.forward, this.distance, vec);
        var focusPoint = this.focus.transform.worldPosition;
        this._camera.transform.localPosition = focusPoint;
      }
      destroy(force) {
        const input = this._input();
        if (input) {
          input.removeEventListener(PointerEvent3D.POINTER_WHEEL, this.mouseWheel, this);
          input.removeEventListener(PointerEvent3D.POINTER_UP, this.mouseUp, this);
          input.removeEventListener(PointerEvent3D.POINTER_DOWN, this.mouseDown, this);
        }
        super.destroy(force);
      }
    }

    var KeyCode = /* @__PURE__ */ ((KeyCode2) => {
      KeyCode2[KeyCode2["Key_BackSpace"] = 8] = "Key_BackSpace";
      KeyCode2[KeyCode2["Key_Tab"] = 9] = "Key_Tab";
      KeyCode2[KeyCode2["Key_Clear"] = 12] = "Key_Clear";
      KeyCode2[KeyCode2["Key_Enter"] = 13] = "Key_Enter";
      KeyCode2[KeyCode2["Key_Shift_L"] = 16] = "Key_Shift_L";
      KeyCode2[KeyCode2["Key_Control_L"] = 17] = "Key_Control_L";
      KeyCode2[KeyCode2["Key_Alt_L"] = 18] = "Key_Alt_L";
      KeyCode2[KeyCode2["Key_Pause"] = 19] = "Key_Pause";
      KeyCode2[KeyCode2["Key_CapsLock"] = 20] = "Key_CapsLock";
      KeyCode2[KeyCode2["Key_Escape"] = 21] = "Key_Escape";
      KeyCode2[KeyCode2["Key_Esc"] = 27] = "Key_Esc";
      KeyCode2[KeyCode2["Key_Space"] = 32] = "Key_Space";
      KeyCode2[KeyCode2["Key_Prior"] = 33] = "Key_Prior";
      KeyCode2[KeyCode2["Key_Next"] = 34] = "Key_Next";
      KeyCode2[KeyCode2["Key_End"] = 35] = "Key_End";
      KeyCode2[KeyCode2["Key_Home"] = 36] = "Key_Home";
      KeyCode2[KeyCode2["Key_Left"] = 37] = "Key_Left";
      KeyCode2[KeyCode2["Key_Up"] = 38] = "Key_Up";
      KeyCode2[KeyCode2["Key_Right"] = 39] = "Key_Right";
      KeyCode2[KeyCode2["Key_Down"] = 40] = "Key_Down";
      KeyCode2[KeyCode2["Key_Select"] = 41] = "Key_Select";
      KeyCode2[KeyCode2["Key_Print"] = 42] = "Key_Print";
      KeyCode2[KeyCode2["Key_Execute"] = 43] = "Key_Execute";
      KeyCode2[KeyCode2["Key_Insert"] = 45] = "Key_Insert";
      KeyCode2[KeyCode2["Key_Delete"] = 46] = "Key_Delete";
      KeyCode2[KeyCode2["Key_Help"] = 47] = "Key_Help";
      KeyCode2[KeyCode2["Key_0"] = 48] = "Key_0";
      KeyCode2[KeyCode2["Key_1"] = 49] = "Key_1";
      KeyCode2[KeyCode2["Key_2"] = 50] = "Key_2";
      KeyCode2[KeyCode2["Key_3"] = 51] = "Key_3";
      KeyCode2[KeyCode2["Key_4"] = 52] = "Key_4";
      KeyCode2[KeyCode2["Key_5"] = 53] = "Key_5";
      KeyCode2[KeyCode2["Key_6"] = 54] = "Key_6";
      KeyCode2[KeyCode2["Key_7"] = 55] = "Key_7";
      KeyCode2[KeyCode2["Key_8"] = 56] = "Key_8";
      KeyCode2[KeyCode2["Key_9"] = 57] = "Key_9";
      KeyCode2[KeyCode2["Key_A"] = 65] = "Key_A";
      KeyCode2[KeyCode2["Key_B"] = 66] = "Key_B";
      KeyCode2[KeyCode2["Key_C"] = 67] = "Key_C";
      KeyCode2[KeyCode2["Key_D"] = 68] = "Key_D";
      KeyCode2[KeyCode2["Key_E"] = 69] = "Key_E";
      KeyCode2[KeyCode2["Key_F"] = 70] = "Key_F";
      KeyCode2[KeyCode2["Key_G"] = 71] = "Key_G";
      KeyCode2[KeyCode2["Key_H"] = 72] = "Key_H";
      KeyCode2[KeyCode2["Key_I"] = 73] = "Key_I";
      KeyCode2[KeyCode2["Key_J"] = 74] = "Key_J";
      KeyCode2[KeyCode2["Key_K"] = 75] = "Key_K";
      KeyCode2[KeyCode2["Key_L"] = 76] = "Key_L";
      KeyCode2[KeyCode2["Key_M"] = 77] = "Key_M";
      KeyCode2[KeyCode2["Key_N"] = 78] = "Key_N";
      KeyCode2[KeyCode2["Key_O"] = 79] = "Key_O";
      KeyCode2[KeyCode2["Key_P"] = 80] = "Key_P";
      KeyCode2[KeyCode2["Key_Q"] = 81] = "Key_Q";
      KeyCode2[KeyCode2["Key_R"] = 82] = "Key_R";
      KeyCode2[KeyCode2["Key_S"] = 83] = "Key_S";
      KeyCode2[KeyCode2["Key_T"] = 84] = "Key_T";
      KeyCode2[KeyCode2["Key_U"] = 85] = "Key_U";
      KeyCode2[KeyCode2["Key_V"] = 86] = "Key_V";
      KeyCode2[KeyCode2["Key_W"] = 87] = "Key_W";
      KeyCode2[KeyCode2["Key_X"] = 88] = "Key_X";
      KeyCode2[KeyCode2["Key_Y"] = 89] = "Key_Y";
      KeyCode2[KeyCode2["Key_Z"] = 90] = "Key_Z";
      KeyCode2[KeyCode2["Key_KP_0"] = 96] = "Key_KP_0";
      KeyCode2[KeyCode2["Key_KP_1"] = 97] = "Key_KP_1";
      KeyCode2[KeyCode2["Key_KP_2"] = 98] = "Key_KP_2";
      KeyCode2[KeyCode2["Key_KP_3"] = 99] = "Key_KP_3";
      KeyCode2[KeyCode2["Key_KP_4"] = 100] = "Key_KP_4";
      KeyCode2[KeyCode2["Key_KP_5"] = 101] = "Key_KP_5";
      KeyCode2[KeyCode2["Key_KP_6"] = 102] = "Key_KP_6";
      KeyCode2[KeyCode2["Key_KP_7"] = 103] = "Key_KP_7";
      KeyCode2[KeyCode2["Key_KP_8"] = 104] = "Key_KP_8";
      KeyCode2[KeyCode2["Key_KP_9"] = 105] = "Key_KP_9";
      KeyCode2[KeyCode2["Key_Multiply"] = 106] = "Key_Multiply";
      KeyCode2[KeyCode2["Key_Add"] = 107] = "Key_Add";
      KeyCode2[KeyCode2["Key_Separator"] = 108] = "Key_Separator";
      KeyCode2[KeyCode2["Key_Subtract"] = 109] = "Key_Subtract";
      KeyCode2[KeyCode2["Key_Decimal"] = 110] = "Key_Decimal";
      KeyCode2[KeyCode2["Key_Divide"] = 111] = "Key_Divide";
      KeyCode2[KeyCode2["Key_F1"] = 112] = "Key_F1";
      KeyCode2[KeyCode2["Key_F2"] = 113] = "Key_F2";
      KeyCode2[KeyCode2["Key_F3"] = 114] = "Key_F3";
      KeyCode2[KeyCode2["Key_F4"] = 115] = "Key_F4";
      KeyCode2[KeyCode2["Key_F5"] = 116] = "Key_F5";
      KeyCode2[KeyCode2["Key_F6"] = 117] = "Key_F6";
      KeyCode2[KeyCode2["Key_F7"] = 118] = "Key_F7";
      KeyCode2[KeyCode2["Key_F8"] = 119] = "Key_F8";
      KeyCode2[KeyCode2["Key_F9"] = 120] = "Key_F9";
      KeyCode2[KeyCode2["Key_F10"] = 121] = "Key_F10";
      KeyCode2[KeyCode2["Key_F11"] = 122] = "Key_F11";
      KeyCode2[KeyCode2["Key_F12"] = 123] = "Key_F12";
      KeyCode2[KeyCode2["Key_F13"] = 124] = "Key_F13";
      KeyCode2[KeyCode2["Key_F14"] = 125] = "Key_F14";
      KeyCode2[KeyCode2["Key_F15"] = 126] = "Key_F15";
      KeyCode2[KeyCode2["Key_F16"] = 127] = "Key_F16";
      KeyCode2[KeyCode2["Key_F17"] = 128] = "Key_F17";
      KeyCode2[KeyCode2["Key_F18"] = 129] = "Key_F18";
      KeyCode2[KeyCode2["Key_F19"] = 130] = "Key_F19";
      KeyCode2[KeyCode2["Key_F20"] = 131] = "Key_F20";
      KeyCode2[KeyCode2["Key_F21"] = 132] = "Key_F21";
      KeyCode2[KeyCode2["Key_F22"] = 133] = "Key_F22";
      KeyCode2[KeyCode2["Key_F23"] = 134] = "Key_F23";
      KeyCode2[KeyCode2["Key_F24"] = 135] = "Key_F24";
      KeyCode2[KeyCode2["Key_Num_Lock"] = 136] = "Key_Num_Lock";
      KeyCode2[KeyCode2["Key_Scroll_Lock"] = 137] = "Key_Scroll_Lock";
      return KeyCode2;
    })(KeyCode || {});

    class FlyCameraController extends ComponentBase {
      /**
       *  Camera movement speed
       */
      moveSpeed = 2;
      /**
       *
       * Coordinates of specific objects
       */
      targetPos = new Vector3(0, 0, 10);
      /**
       *
       * Camera orientation coordinates
       */
      lookAtPos = new Vector3(0, 0, 0);
      /**
       * @internal
       */
      config = { shiftMoveScale: 20 };
      _moveScale = 1;
      _dir;
      _mouseFactory = 25;
      _factory = 1.5;
      _mouseDown = false;
      _lastPos;
      _keyState;
      constructor() {
        super();
        this._lastPos = new Vector3();
        this._keyState = {
          front: false,
          back: false,
          left: false,
          right: false,
          q: false,
          e: false
        };
        this.setCamera(new Vector3(0, 0, 100), new Vector3(0, 0, 0));
      }
      /**
       *
       * Initialize camera data
       * @param cameraPos source position 
       * @param lookAt target position
       */
      setCamera(cameraPos, lookAt) {
        this.targetPos.copy(cameraPos);
        this.lookAtPos.copy(lookAt);
        this.Reset();
      }
      /**
       * @internal
       */
      _input() {
        const view = this.transform?.view3D;
        const owner = view?.engine3D;
        return owner?.inputSystem;
      }
      start() {
        const input = this._input();
        if (input) {
          input.addEventListener(PointerEvent3D.POINTER_WHEEL, this.mouseWheel, this);
          input.addEventListener(PointerEvent3D.POINTER_UP, this.mouseUp, this);
          input.addEventListener(PointerEvent3D.POINTER_DOWN, this.mouseDown, this);
          input.addEventListener(KeyEvent.KEY_UP, this.keyUp, this);
          input.addEventListener(KeyEvent.KEY_DOWN, this.keyDown, this);
        }
        this.transform.lookAt(this.targetPos, this.lookAtPos);
      }
      mouseWheel(e) {
      }
      keyUp(e) {
        switch (e.keyCode) {
          case KeyCode.Key_W:
            this._keyState.front = false;
            break;
          case KeyCode.Key_S:
            this._keyState.back = false;
            break;
          case KeyCode.Key_A:
            this._keyState.left = false;
            break;
          case KeyCode.Key_D:
            this._keyState.right = false;
            break;
          case KeyCode.Key_Shift_L:
            this._moveScale = 1;
            break;
          case KeyCode.Key_Q:
            this._keyState.q = false;
            break;
          case KeyCode.Key_E:
            this._keyState.e = false;
            break;
          case KeyCode.Key_F:
            this.transform.lookAt(this.targetPos, this.lookAtPos);
            break;
        }
      }
      keyDown(e) {
        switch (e.keyCode) {
          case KeyCode.Key_W:
            this._keyState.front = true;
            break;
          case KeyCode.Key_S:
            this._keyState.back = true;
            break;
          case KeyCode.Key_A:
            this._keyState.left = true;
            break;
          case KeyCode.Key_D:
            this._keyState.right = true;
            break;
          case KeyCode.Key_Q:
            this._keyState.q = true;
            break;
          case KeyCode.Key_E:
            this._keyState.e = true;
            break;
          case KeyCode.Key_Shift_L:
            this._moveScale = this.config.shiftMoveScale;
        }
      }
      Reset() {
        const input = this._input();
        if (!input) return;
        this._lastPos.x = input.mouseLastX;
        this._lastPos.y = input.mouseLastY;
      }
      mouseDown(e) {
        this.Reset();
        this._mouseDown = true;
      }
      mouseUp(e) {
        this.Reset();
        this._mouseDown = false;
      }
      /**
       *
       * Get the smoothness of the camera by keyboard control
       */
      get factory() {
        return this._factory;
      }
      /**
       *
       * Set the smoothness of the camera by keyboard control
       */
      set factory(value) {
        this._factory = value;
      }
      /**
       *
       * Get the smoothness of the camera by mouse control
       */
      get mouseFactory() {
        return this._mouseFactory;
      }
      /**
       *
       * Set the smoothness of the camera by mouse control
       */
      set mouseFactory(value) {
        this._mouseFactory = value;
      }
      /**
       * @internal
       * @param target 
       * @param current 
       * @param t 
       * @returns 
       */
      internal(target, current, t) {
        return (current - target) * t;
      }
      onUpdate() {
        let transform = this.transform;
        let dt = clamp$2(Time.delta, 0, 0.016);
        if (this._mouseDown) {
          const input = this._input();
          if (input) {
            transform.rotationY -= this.internal(transform.rotationY + (input.mouseLastX - this._lastPos.x) * 0.25, transform.rotationY, dt * this._mouseFactory);
            transform.rotationX -= this.internal(transform.rotationX + (input.mouseLastY - this._lastPos.y) * 0.25, transform.rotationX, dt * this._mouseFactory);
          }
          this.Reset();
        }
        if (this._keyState.front) {
          let forward = transform.forward;
          transform.x -= this.internal(transform.x + forward.x * this.moveSpeed * this._moveScale, transform.x, dt * this._factory);
          transform.y -= this.internal(transform.y + forward.y * this.moveSpeed * this._moveScale, transform.y, dt * this._factory);
          transform.z -= this.internal(transform.z + forward.z * this.moveSpeed * this._moveScale, transform.z, dt * this._factory);
        }
        if (this._keyState.back) {
          let forward = transform.forward;
          transform.x += this.internal(transform.x + forward.x * this.moveSpeed * this._moveScale, transform.x, dt * this._factory);
          transform.y += this.internal(transform.y + forward.y * this.moveSpeed * this._moveScale, transform.y, dt * this._factory);
          transform.z += this.internal(transform.z + forward.z * this.moveSpeed * this._moveScale, transform.z, dt * this._factory);
        }
        if (this._keyState.left) {
          let right = transform.left;
          transform.x += this.internal(transform.x + right.x * this.moveSpeed * this._moveScale, transform.x, dt * this._factory);
          transform.y += this.internal(transform.y + right.y * this.moveSpeed * this._moveScale, transform.y, dt * this._factory);
          transform.z += this.internal(transform.z + right.z * this.moveSpeed * this._moveScale, transform.z, dt * this._factory);
        }
        if (this._keyState.right) {
          let right = transform.left;
          transform.x -= this.internal(transform.x + right.x * this.moveSpeed * this._moveScale, transform.x, dt * this._factory);
          transform.y -= this.internal(transform.y + right.y * this.moveSpeed * this._moveScale, transform.y, dt * this._factory);
          transform.z -= this.internal(transform.z + right.z * this.moveSpeed * this._moveScale, transform.z, dt * this._factory);
        }
        if (this._keyState.q) {
          transform.y = lerp(transform.y, transform.y - this.moveSpeed * this._moveScale, dt * this._factory);
        }
        if (this._keyState.e) {
          transform.y = lerp(transform.y, transform.y + this.moveSpeed * this._moveScale, dt * this._factory);
        }
      }
      /**
       * @internal
       */
      destroy(force) {
        const input = this._input();
        if (input) {
          input.removeEventListener(PointerEvent3D.POINTER_WHEEL, this.mouseWheel, this);
          input.removeEventListener(PointerEvent3D.POINTER_UP, this.mouseUp, this);
          input.removeEventListener(PointerEvent3D.POINTER_DOWN, this.mouseDown, this);
          input.removeEventListener(KeyEvent.KEY_UP, this.keyUp, this);
          input.removeEventListener(KeyEvent.KEY_DOWN, this.keyDown, this);
        }
        super.destroy(force);
      }
    }

    class Vector3Ex {
      /**
       * vector3 add
       * @param v1
       * @param v2
       * @param target
       * @returns
       */
      static add(v1, v2, target) {
        if (!target) {
          target = new Vector3();
        }
        target.x = v1.x + v2.x;
        target.y = v1.y + v2.y;
        target.z = v1.z + v2.z;
        return target;
      }
      /**
       * vector3 sub
       * @param v1
       * @param v2
       * @param target
       * @returns
       */
      static sub(v1, v2, target) {
        if (!target) {
          target = new Vector3();
        }
        target.x = v1.x - v2.x;
        target.y = v1.y - v2.y;
        target.z = v1.z - v2.z;
        return target;
      }
      /**
       * vector3 mul
       * @param v1
       * @param v2
       * @param target
       * @returns
       */
      static mul(v1, v2, target) {
        if (!target) {
          target = new Vector3();
        }
        target.x = v1.x * v2.x;
        target.y = v1.y * v2.y;
        target.z = v1.z * v2.z;
        return target;
      }
      /**
       * vector3 mul
       * @param v1
       * @param v2
       * @param target
       * @returns
       */
      static mulScale(v1, v, target) {
        if (!target) {
          target = new Vector3();
        }
        target.x = v1.x * v;
        target.y = v1.y * v;
        target.z = v1.z * v;
        return target;
      }
      /**
       * vector3 div
       * @param v1
       * @param v2
       * @param target
       * @returns
       */
      static div(v1, v2, target) {
        if (!target) {
          target = new Vector3();
        }
        target.x = v1.x / v2.x;
        target.y = v1.y / v2.y;
        target.z = v1.z / v2.z;
        return target;
      }
      /**
       * normalize
       * @param v1 source vector
       * @returns result vector
       */
      static normalize(v1) {
        let t = v1.clone();
        return t.normalize();
      }
      /**
       * dot
       * @param v1 first vector
       * @param v2 second vector
       * @returns result
       */
      static dot(v1, v2) {
        let v = Vector3.HELP_0;
        v.copy(v1);
        return v.dotProduct(v2);
      }
      /**
       * Calculate the angle between two vectors
       * @param v1 first vector
       * @param v2 second vector
       * @returns Angle result in radians
       */
      static calculateVectorAngle_xz(v1, v2) {
        return Math.acos((v1.x * v2.x + v1.y * v2.y) / Math.sqrt((v1.x * v1.x + v1.y * v1.y) * (v2.x * v2.x + v2.y * v2.y)));
      }
      /**
       *
       * Calculate the distance between two points
       * @static
       * @param {Vector3} v1 first vector
       * @param {Vector3} v2 second vector
       * @return {*} distance
       */
      static distance(v1, v2) {
        return Vector3.distance(v1, v2);
      }
      /**
       * make a Random 3D Vector
       * @param min The min random value of vector components
       * @param max The max random value of vector components
       * @returns random vector
       */
      static getRandomXYZ(min = -100, max = 100) {
        return new Vector3(Math.random() * (max - min) + min, Math.random() * (max - min) + min, Math.random() * (max - min) + min);
      }
      /**
       * make a Random 3D Vector
       * @param min The min random value of vector component-x
       * @param max The max random value of vector component-x
       * @param yMin The min random value of vector component-y
       * @param yMax The max random value of vector component-y
       * @returns random vector
       */
      static getRandomV3(min = -100, max = 100, yMin, yMax) {
        return new Vector3(Math.random() * max + min, Math.random() * yMax + yMin, Math.random() * max + min);
      }
      static sphere(radius) {
        let r = radius * Math.random();
        let randomDir = new Vector3(Math.random() * 1 - 0.5, Math.random() * 1 - 0.5, Math.random() * 1 - 0.5);
        randomDir.normalize();
        randomDir.multiplyScalar(r);
        return randomDir;
      }
      static sphereXYZ(radiusMin, radiusMax, x = 1, y = 1, z = 1) {
        let r = radiusMin + (radiusMax - radiusMin) * Math.random();
        let randomDir = new Vector3(Math.random() * x - x * 0.5, Math.random() * y - y * 0.5, Math.random() * z - z * 0.5);
        randomDir.normalize();
        randomDir.multiplyScalar(r);
        return randomDir;
      }
    }

    class HoverCameraController extends ComponentBase {
      /**
       * camera controlling
       */
      camera;
      /**
       * The closest distance that the mouse wheel can operate
       */
      minDistance = 0.1;
      /**
       * The farthest distance that the mouse wheel can operate
       */
      maxDistance = 500;
      /**
       * Smoothing coefficient of rolling angle
       */
      rollSmooth = 15;
      /**
       * Smoothing coefficient of dragging
       */
      dragSmooth = 20;
      /**
       * Smoothing coefficient of rolling
       */
      wheelSmooth = 10;
      /**
       * Mouse scrolling step coefficient
       */
      wheelStep = 2e-3;
      /**
       * Right mouse movement coefficient
       */
      mouseRightFactor = 0.25;
      /**
       * Left mouse movement coefficient
       */
      mouseLeftFactor = 20;
      /**
       * Whether to enable smooth mode
       */
      smooth = true;
      /**
       * @internal
       */
      _wheelStep = 2e-3;
      _distance = 0;
      /**
       * Distance between camera and target
       */
      distance = 10;
      _roll = 0;
      /**
       * Roll angle around y-axis
       */
      roll = 0;
      _pitch = 0;
      /**
       * Pitch angle around x-axis
       */
      pitch = 0;
      _currentPos;
      /**
       * @internal
       */
      _targetPos;
      _flowTarget;
      _flowOffset;
      _mouseLeftDown = false;
      _mouseRightDown = false;
      _bottomClamp = 89.99;
      _topClamp = -89.99;
      /**
       * Max angle of pitch
       */
      get bottomClamp() {
        return this._bottomClamp;
      }
      set bottomClamp(value) {
        this._bottomClamp = value > 89.99 ? 89.99 : value;
      }
      /**
       * Min angle of pitch
       */
      get topClamp() {
        return this._topClamp;
      }
      set topClamp(value) {
        this._topClamp = value < -89.99 ? -89.99 : value;
      }
      _tempDir = new Vector3();
      _tempPos = new Vector3();
      /**
       * @constructor
       */
      constructor() {
        super();
        this._currentPos = new exports.Object3D();
        this._targetPos = new exports.Object3D();
      }
      _input() {
        const view = this.transform?.view3D;
        const owner = view?.engine3D;
        return owner?.inputSystem;
      }
      /**
       * @internal
       */
      start() {
        this.camera = this.object3D.getOrAddComponent(Camera3D);
        const input = this._input();
        if (!input) return;
        input.addEventListener(PointerEvent3D.POINTER_DOWN, this.onMouseDown, this);
        input.addEventListener(PointerEvent3D.POINTER_MOVE, this.onMouseMove, this, null, 10);
        input.addEventListener(PointerEvent3D.POINTER_UP, this.onMouseUp, this, null, 10);
        input.addEventListener(PointerEvent3D.POINTER_WHEEL, this.onMouseWheel, this);
      }
      flowTarget(target, offset = Vector3.ZERO) {
        this._flowTarget = target;
        this._flowOffset ||= new Vector3();
        this._flowOffset.copy(offset);
      }
      getFlowTarget() {
        return this._flowTarget;
      }
      /**
       * Initialize Camera
       * @param roll  Roll angle around y-axis
       * @param pitch Pitch angle around x-axis
       * @param distance max distance to target
       * @param target coordinates of the target
       */
      setCamera(roll, pitch, distance, target) {
        this.roll = roll;
        this.pitch = pitch;
        this.distance = distance;
        if (this.maxDistance < distance * 1.5) {
          this.maxDistance = distance * 1.5;
        }
        if (target) {
          this._targetPos.transform.localPosition.copy(target);
        }
      }
      focusByBounds(obj) {
        let bounds = BoundUtil.genMeshBounds(obj);
        this.target = bounds.center;
      }
      /**
       * Set target position
       */
      set target(target) {
        this._targetPos.transform.localPosition.copy(target);
      }
      /**
       * Get target position
       * @return {Vector3}
       */
      get target() {
        return this._targetPos.transform.localPosition;
      }
      onMouseWheel(e) {
        if (!this.enable) return;
        this._wheelStep = this.wheelStep * Vector3Ex.distance(this._currentPos.transform.worldPosition, this.camera.transform.worldPosition) / 10;
        this.distance -= this._input().wheelDelta * this._wheelStep;
        this.distance = clamp$2(this.distance, this.minDistance, this.maxDistance);
      }
      onMouseDown(e) {
        if (!this.enable) return;
        switch (e.mouseCode) {
          case 0:
            this._mouseLeftDown = true;
            break;
          case 1:
            break;
          case 2:
            this._mouseRightDown = true;
            break;
        }
      }
      onMouseUp(e) {
        this._mouseLeftDown = false;
        this._mouseRightDown = false;
      }
      /**
       * @internal
       */
      onMouseMove(e) {
        if (!this.enable) return;
        if (this._mouseRightDown) {
          Vector3.HELP_1.x = -1 * e.movementX * Math.cos(this._roll * Math.PI / 180) - e.movementY * Math.sin(this._roll * Math.PI / 180);
          Vector3.HELP_1.z = -1 * e.movementY * Math.cos(this._roll * Math.PI / 180) + e.movementX * Math.sin(this._roll * Math.PI / 180);
          this._targetPos.x += Vector3.HELP_1.x * this.mouseRightFactor;
          this._targetPos.z += Vector3.HELP_1.z * this.mouseRightFactor;
        }
        if (this._mouseLeftDown) {
          this.roll -= e.movementX * Time.delta * 1e-3 * this.mouseLeftFactor;
          this.pitch -= e.movementY * Time.delta * 1e-3 * this.mouseLeftFactor;
          this.pitch = clamp$2(this.pitch, this._topClamp, this._bottomClamp);
        }
      }
      onBeforeUpdate(view) {
        if (!this.enable) return;
        if (this._flowTarget) {
          Vector3.HELP_0.copy(this._flowTarget.transform.worldPosition);
          Vector3.add(Vector3.HELP_0, this._flowOffset, Vector3.HELP_0);
          this.target = Vector3.HELP_0;
        }
        let dt = clamp$2(Time.delta, 0, 0.016);
        if (this.smooth) {
          this._currentPos.x += (this._targetPos.x - this._currentPos.x) * dt * this.dragSmooth;
          this._currentPos.y += (this._targetPos.y - this._currentPos.y) * dt * this.dragSmooth;
          this._currentPos.z += (this._targetPos.z - this._currentPos.z) * dt * this.dragSmooth;
          this._distance += (this.distance - this._distance) * dt * this.wheelSmooth;
          this._roll += (this.roll - this._roll) * dt * this.rollSmooth;
          this._pitch += (this.pitch - this._pitch) * dt * this.rollSmooth;
        } else {
          this._currentPos.x = this._targetPos.x;
          this._currentPos.y = this._targetPos.y;
          this._currentPos.z = this._targetPos.z;
          this._distance = this.distance;
          this._roll = this.roll;
          this._pitch = this.pitch;
        }
        this._tempDir.set(0, 0, 1);
        let q = Quaternion.HELP_0;
        q.setFromEuler(this._pitch, this._roll, 0);
        this._tempDir.applyQuaternion(q);
        this._tempPos = Vector3Ex.mulScale(this._tempDir, this._distance, this._tempPos);
        Vector3.add(this._tempPos, this._currentPos.transform.localPosition, this._tempPos);
        this.camera.lookAt(this._tempPos, this._currentPos.transform.localPosition, Vector3.UP);
      }
      /**
       * @internal
       */
      destroy(force) {
        const input = this._input();
        if (input) {
          input.removeEventListener(PointerEvent3D.POINTER_DOWN, this.onMouseDown, this);
          input.removeEventListener(PointerEvent3D.POINTER_MOVE, this.onMouseMove, this);
          input.removeEventListener(PointerEvent3D.POINTER_UP, this.onMouseUp, this);
          input.removeEventListener(PointerEvent3D.POINTER_WHEEL, this.onMouseWheel, this);
        }
        this._currentPos?.destroy(force);
        this._currentPos = null;
        this._targetPos?.destroy(force);
        this._targetPos = null;
        super.destroy(force);
        this.camera = null;
        this._flowTarget = null;
      }
    }

    class OrbitController extends ComponentBase {
      /**
       * internal camera
       */
      _camera;
      /**
       * Whether to enable automatic rotation
       */
      autoRotate = false;
      /**
       * Automatic rotation speed coefficient
       */
      autoRotateSpeed = 0.1;
      /**
       * Rotation speed coefficient
       */
      rotateFactor = 0.5;
      /**
       * Scale speed coefficient
       */
      zoomFactor = 0.1;
      /**
       * Angle translation velocity coefficient
       */
      panFactor = 0.25;
      _smooth = 5;
      _minDistance = 1;
      _maxDistance = 1e5;
      _maxPolarAngle = 90;
      _minPolarAngle = -90;
      _target = new Vector3(0, 0, 0);
      _cTarget = new Vector3(0, 0, 0);
      _position = new Vector3(0, 0, 0);
      _cPosition = new Vector3(0, 0, 0);
      _spherical = new Spherical();
      _isMouseDown = false;
      _lastMouseX = -1;
      _lastMouseY = -1;
      _isPanning = false;
      /**
       * @constructor
       */
      constructor() {
        super();
      }
      /**
       * Get the target position
       */
      get target() {
        return this._target;
      }
      /**
       * Set the target position
       */
      set target(v) {
        this._target = v;
      }
      /**
       * Get smoothing coefficient of controller
       */
      get smooth() {
        return this._smooth;
      }
      /**
       * Set smoothing coefficient of controller
       */
      set smooth(v) {
        this._smooth = Math.max(v, 1);
      }
      /**
       * Get the minimum distance between the camera and the target coordinate
       * @defaultValue 1
       */
      get minDistance() {
        return this._minDistance;
      }
      /**
       * Set the minimum distance between the camera and the target position
       * min value: 0.000002
       * max value: `this._maxDistance` {@link maxDistance}
       */
      set minDistance(v) {
        this._minDistance = clamp$2(v, 2e-6, this._maxDistance);
      }
      /**
       * Get the max distance between the camera and the target position
       * @defaultValue 100000
       */
      get maxDistance() {
        return this._maxDistance;
      }
      /**
       * Set the max distance between the camera and the target position
       * min - `this._maxDistance`
       * max - Infinity
       */
      set maxDistance(v) {
        this._maxDistance = clamp$2(v, this._minDistance, Infinity);
      }
      /**
       * Get the lower elevation limit of the camera from the xz plane
       * @defaultValue -90
       */
      get minPolarAngle() {
        return this._minPolarAngle;
      }
      /**
       * Set the lower elevation limit of the camera from the xz plane
       * min - -90
       * max - {@link maxPolarAngle}
       */
      set minPolarAngle(v) {
        this._minPolarAngle = clamp$2(v, -90, this._maxPolarAngle);
      }
      /**
       * Get the upper elevation limit of the camera from the xz plane
       * @defaultValue 90
       */
      get maxPolarAngle() {
        return this._maxPolarAngle;
      }
      /**
       * Set the upper elevation limit of the camera to the xz plane
       * min - less than {@link minPolarAngle}   
       * max - 90
       */
      set maxPolarAngle(v) {
        this._maxPolarAngle = clamp$2(v, this._minPolarAngle, 90);
      }
      get spherical() {
        return this._spherical;
      }
      /**
       * @internal
       */
      start() {
        this._camera = this.object3D.getComponent(Camera3D);
        this._position = this.object3D.transform.localPosition.clone();
        this._cPosition = this._position.clone();
        this._target = this._camera.lookTarget.clone();
        this._cTarget = this._target.clone();
        this._spherical.setCoords(this._position.x - this._target.x, this._position.y - this._target.y, this._position.z - this._target.z);
        this._camera.lookAt(this._cPosition, this._cTarget, Vector3.UP);
        this.addEventListener();
      }
      /**
       * @internal
       */
      onEnable() {
        this.addEventListener();
      }
      /**
       * @internal
       */
      onDisable() {
        this.removeEventListener();
      }
      /**
       * @internal
       */
      onUpdate() {
        let step = this._isPanning ? 1 : this.smooth;
        let changed = false;
        if (!this._cPosition.equals(this.object3D.transform.localPosition)) {
          this._position.copy(this.object3D.transform.localPosition);
          step = 1;
          changed = true;
        }
        if (!this._cTarget.equals(this._target)) {
          this._cTarget.copy(this._target);
          step = 1;
          changed = true;
        }
        if (changed) {
          this._spherical.setCoords(this._position.x - this._target.x, this._position.y - this._target.y, this._position.z - this._target.z);
          this.updateCamera();
        } else if (!this._isMouseDown && this.autoRotate) {
          this._spherical.theta -= this.autoRotateSpeed * Math.PI / 180;
          this.updateCamera();
        }
        let x = (this._position.x - this._cPosition.x) / step;
        let y = (this._position.y - this._cPosition.y) / step;
        let z = (this._position.z - this._cPosition.z) / step;
        this._cPosition.x = Math.abs(x) > 1e-10 ? this._cPosition.x + x : this._position.x;
        this._cPosition.y = Math.abs(y) > 1e-10 ? this._cPosition.y + y : this._position.y;
        this._cPosition.z = Math.abs(z) > 1e-10 ? this._cPosition.z + z : this._position.z;
        this._camera.lookAt(this._cPosition, this._cTarget, Vector3.UP);
      }
      /**
       * @internal
       */
      onWheel(e) {
        let deltaY = clamp$2(e.deltaY, -this._spherical.radius, this._spherical.radius);
        this._spherical.radius += deltaY * this.zoomFactor;
        this._spherical.radius = clamp$2(this._spherical.radius, this.minDistance, this.maxDistance);
        this.updateCamera();
        if (this._camera.type === CameraType.ortho) {
          this._camera.frustumSize += e.deltaY * this.zoomFactor;
          if (this._camera.frustumSize < this._minDistance)
            this._camera.frustumSize = this._minDistance;
          else if (this._camera.frustumSize > this._maxDistance)
            this._camera.frustumSize = this._maxDistance;
          this._camera.updateProjection();
        }
      }
      /**
       * @internal
       */
      onPointerDown(e) {
        this._isMouseDown = true;
        this._lastMouseX = e.mouseX;
        this._lastMouseY = e.mouseY;
        if (e.mouseCode === 2)
          this._isPanning = true;
      }
      /**
       * @internal
       */
      onPointerMove(e) {
        if (!this._isMouseDown || !this.enable) return;
        let mousex = e.mouseX;
        let mousey = e.mouseY;
        if (e.mouseCode === 0 && this._lastMouseX > 0 && this._lastMouseY > 0) {
          const ra = -(mousex - this._lastMouseX) * this.rotateFactor;
          const rb = (mousey - this._lastMouseY) * this.rotateFactor;
          this._spherical.theta += ra * Math.PI / 180;
          this._spherical.phi -= rb * Math.PI / 180;
          this._spherical.phi = clamp$2(this._spherical.phi, this.minPolarAngle, this.maxPolarAngle);
          this.updateCamera();
        } else if (e.mouseCode === 2) {
          Vector3Ex.mulScale(this.object3D.transform.up, e.movementY * this.panFactor * this._camera.aspect, Vector3.HELP_1);
          if (e.ctrlKey || e.metaKey) {
            this._target.y += Vector3.HELP_1.y;
          } else {
            this._target.x += Vector3.HELP_1.x;
            this._target.z += Vector3.HELP_1.z;
          }
          Vector3Ex.mulScale(this.object3D.transform.right, -e.movementX * this.panFactor, Vector3.HELP_1);
          this._target.x -= Vector3.HELP_1.x;
          this._target.z -= Vector3.HELP_1.z;
          this._cTarget.copy(this._target);
          this.updateCamera();
        }
        this._lastMouseX = mousex;
        this._lastMouseY = mousey;
      }
      /**
       * @internal
       */
      onPointerUp(e) {
        this._isMouseDown = false;
        if (e.mouseCode === 2) {
          this._isPanning = false;
        }
      }
      // private onPointerLeave() {
      //     this._isMouseDown = false;
      //     this._isPanning = false;
      // }
      /**
       * @internal
       */
      updateCamera() {
        this._spherical.makeSafe();
        let pos = this._spherical.getCoords();
        this._position.set(pos.x + this._target.x, pos.y + this._target.y, pos.z + this._target.z);
      }
      /**
       * @internal
       */
      _input() {
        const view = this.transform?.view3D;
        const owner = view?.engine3D;
        return owner?.inputSystem;
      }
      addEventListener() {
        const input = this._input();
        if (!input) return;
        input.addEventListener(PointerEvent3D.POINTER_WHEEL, this.onWheel, this);
        input.addEventListener(PointerEvent3D.POINTER_DOWN, this.onPointerDown, this);
        input.addEventListener(PointerEvent3D.POINTER_MOVE, this.onPointerMove, this);
        input.addEventListener(PointerEvent3D.POINTER_UP, this.onPointerUp, this);
      }
      /**
       * @internal
       */
      removeEventListener() {
        const input = this._input();
        if (!input) return;
        input.removeEventListener(PointerEvent3D.POINTER_WHEEL, this.onWheel, this);
        input.removeEventListener(PointerEvent3D.POINTER_DOWN, this.onPointerDown, this);
        input.removeEventListener(PointerEvent3D.POINTER_MOVE, this.onPointerMove, this);
        input.removeEventListener(PointerEvent3D.POINTER_UP, this.onPointerUp, this);
      }
    }
    const EPS = Math.PI / 180 / 100;
    class Spherical {
      radius;
      phi;
      theta;
      coords;
      constructor(radius = 1, phi = 0, theta = 0) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        this.coords = new Vector3();
        return this;
      }
      set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
      }
      // restrict phi to be between EPS and PI-EPS
      makeSafe() {
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
      }
      setFromVector3(v) {
        return this.setCoords(v.x, v.y, v.z);
      }
      setCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
          this.theta = 0;
          this.phi = 0;
        } else {
          this.theta = Math.atan2(x, z);
          this.phi = Math.acos(clamp$2(y / this.radius, -1, 1));
        }
        return this;
      }
      getCoords() {
        const sinPhiRadius = Math.sin(this.phi) * this.radius;
        this.coords.x = sinPhiRadius * Math.sin(this.theta);
        this.coords.y = Math.cos(this.phi) * this.radius;
        this.coords.z = sinPhiRadius * Math.cos(this.theta);
        return this.coords;
      }
    }

    class ThirdPersonCameraController extends ComponentBase {
      focus;
      _rotation = new Vector3(45, 0, 0);
      distance = 5;
      _camera;
      constructor() {
        super();
      }
      _input() {
        const view = this.transform?.view3D;
        const owner = view?.engine3D;
        return owner?.inputSystem;
      }
      start() {
        this._camera = this.object3D.getOrAddComponent(Camera3D);
        if (!this._camera) {
          console.error("ThirdPersonCameraController need camera");
          return;
        }
        if (!this.focus) {
          console.error("ThirdPersonCameraController need target");
          return;
        }
        const input = this._input();
        if (!input) return;
        input.addEventListener(PointerEvent3D.POINTER_WHEEL, this.mouseWheel, this);
        input.addEventListener(PointerEvent3D.POINTER_UP, this.mouseUp, this);
        input.addEventListener(PointerEvent3D.POINTER_DOWN, this.mouseDown, this);
      }
      mouseDown(e) {
        this._input()?.addEventListener(PointerEvent3D.POINTER_MOVE, this.mouseMove, this);
      }
      mouseUp(e) {
        this._input()?.removeEventListener(PointerEvent3D.POINTER_MOVE, this.mouseMove, this);
      }
      mouseMove(e) {
        this._rotation.y += e.movementX * 0.01;
        this._rotation.x += e.movementY * 0.01;
      }
      mouseWheel(e) {
        this.distance += (this._input()?.wheelDelta ?? 0) * 0.1;
      }
      onUpdate() {
        let vec = new Vector3();
        Vector3.multiplyScalar(this._camera.transform.forward, this.distance, vec);
        var focusPoint = this.focus.transform.worldPosition;
        this._camera.transform.localPosition = focusPoint.clone().sub(vec);
      }
      destroy(force) {
        const input = this._input();
        if (input) {
          input.removeEventListener(PointerEvent3D.POINTER_WHEEL, this.mouseWheel, this);
          input.removeEventListener(PointerEvent3D.POINTER_UP, this.mouseUp, this);
          input.removeEventListener(PointerEvent3D.POINTER_DOWN, this.mouseDown, this);
        }
        super.destroy(force);
      }
    }

    var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
    var __decorateClass$d = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.Light = class Light extends LightBase {
      constructor() {
        super();
      }
      /** Initialize the light data and assign a default name. */
      init() {
        super.init();
        this.lightData.lightType = LightType.PointLight;
        if (this.object3D.name == "") {
          this.object3D.name = "PointLight" + UUID();
        }
      }
      /**
       *
       * Get the range of the light source
       * @return {number}
       */
      get range() {
        return this.lightData.range;
      }
      /**
       *
       * Set the range of the light source
       * @param {number}
       */
      set range(value) {
        this.lightData.range = value;
        this.onChange();
      }
      /**
       *
       * Get the illumination distance of the light source
       * @type {number}
       * @memberof PointLight
       */
      get at() {
        return this.lightData.linear;
      }
      /**
       *
       * Set the illumination distance of the light source
       * @param {value} It will decay linearly from the maximum value to the current light position at a distance of 0, 
       * with a default value of 0. This means that the intensity of the light will not decrease due to distance
       * @memberof PointLight
       */
      set at(value) {
        this.lightData.linear = value;
        this.onChange();
      }
      /**
       * Get the radius to control the light
       */
      get radius() {
        return this.lightData.radius;
      }
      /**
       * Set the radius of the control light
       */
      set radius(value) {
        this.lightData.radius = value;
        this.onChange();
      }
      /**
       * Get the radius to control the light
       */
      get quadratic() {
        return this.lightData.quadratic;
      }
      /**
       * Set the radius of the control light
       */
      set quadratic(value) {
        this.lightData.quadratic = value;
        this.onChange();
      }
      /** Orient the light downward and run base startup logic. */
      start() {
        this.transform.rotationX = 90;
        super.start();
      }
      /** Per-frame update hook. */
      onUpdate() {
      }
      /** Draw debug gizmos (axis and range circles) for this light. */
      onGraphic(view) {
        let graphic3D = view.scene.getChildByName("graphic3D");
        if (!graphic3D)
          return;
        let custom = graphic3D.createCustomShape(
          `PointLight_${this.object3D.instanceID}`,
          this.transform
        );
        custom.buildAxis();
        custom.buildCircle(Vector3.ZERO, this.range, 32, Vector3.X_AXIS);
        custom.buildCircle(Vector3.ZERO, this.range, 32, Vector3.Y_AXIS);
        custom.buildCircle(Vector3.ZERO, this.range, 32, Vector3.Z_AXIS);
      }
      /**
       *  enable GUI debug
       */
      debug() {
      }
      /** Toggle the debug line visualization for this light. */
      debugDraw(show) {
      }
    };
    exports.Light = __decorateClass$d([
      RegisterComponent(exports.Light, "Light")
    ], exports.Light);

    var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
    var __decorateClass$c = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.EarthAtmShader = class EarthAtmShader extends Shader {
      constructor() {
        super();
        let colorShader = new RenderShaderPass("earthatm_vs_wgsl", "earthatm_fs_wgsl");
        this.addRenderPass(colorShader);
        const EARTH_RADIUS = 6371e3;
        const ATMOSPHERE_HEIGHT = 1e5;
        colorShader.setUniformFloat(`earthRadius`, EARTH_RADIUS);
        colorShader.setUniformFloat(`atmosphereRadius`, EARTH_RADIUS + ATMOSPHERE_HEIGHT);
        colorShader.setUniformFloat(`sunIntensity`, 30);
        colorShader.setUniformFloat(`mieG`, 0.98);
        colorShader.setUniformFloat(`sunDirectionX`, 0);
        colorShader.setUniformFloat(`sunDirectionY`, 1);
        colorShader.setUniformFloat(`sunDirectionZ`, 0);
        colorShader.setUniformFloat(`exposure`, 1);
        colorShader.setUniformFloat(`rayleighCoeffX`, 55e-7);
        colorShader.setUniformFloat(`rayleighCoeffY`, 13e-6);
        colorShader.setUniformFloat(`rayleighCoeffZ`, 224e-7);
        colorShader.setUniformFloat(`mieCoeff`, 5e-5);
        colorShader.setUniformFloat(`rayleighScale`, 8e3);
        colorShader.setUniformFloat(`mieScale`, 1200);
        colorShader.setUniformFloat(`earthCenterX`, 0);
        colorShader.setUniformFloat(`earthCenterY`, 0);
        colorShader.setUniformFloat(`earthCenterZ`, 0);
        colorShader.setUniformFloat(`padding1`, 0);
        colorShader.setUniformFloat(`padding2`, 0);
        colorShader.setUniformFloat(`padding3`, 0);
        let shaderState = colorShader.shaderState;
        shaderState.frontFace = `ccw`;
        shaderState.cullMode = GPUCullMode.front;
        shaderState.depthWriteEnabled = false;
        shaderState.depthCompare = GPUCompareFunction.less_equal;
        shaderState.blendMode = BlendMode.ALPHA;
      }
    };
    exports.EarthAtmShader = __decorateClass$c([
      RegisterShader
    ], exports.EarthAtmShader);

    class EarthAtmMaterial extends Material {
      _earthAtmShader;
      /** Creates the material and binds a placeholder cube texture to satisfy bindings. */
      constructor() {
        super();
        this.shader = this._earthAtmShader = new exports.EarthAtmShader();
        this.setTexture(`baseMap`, Engine3D.resFor().defaultSky);
      }
      /**
       * Get Earth radius in meters
       */
      get earthRadius() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`earthRadius`].value;
      }
      /**
       * Set Earth radius in meters (default: 6371000)
       */
      set earthRadius(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`earthRadius`].value = value;
      }
      /**
       * Get atmosphere outer radius in meters
       */
      get atmosphereRadius() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`atmosphereRadius`].value;
      }
      /**
       * Set atmosphere outer radius in meters
       * Typically earthRadius + 100000 for 100km atmosphere
       */
      set atmosphereRadius(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`atmosphereRadius`].value = value;
      }
      /**
       * Get sun direction (normalized vector pointing towards the sun)
       */
      get sunDirection() {
        let defaultShader = this._shader.getDefaultColorShader();
        return new Vector3(
          defaultShader.uniforms[`sunDirectionX`].value,
          defaultShader.uniforms[`sunDirectionY`].value,
          defaultShader.uniforms[`sunDirectionZ`].value
        );
      }
      /**
       * Set sun direction (will be normalized)
       */
      set sunDirection(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        const normalized = value.clone().normalize();
        defaultShader.uniforms[`sunDirectionX`].value = normalized.x;
        defaultShader.uniforms[`sunDirectionY`].value = normalized.y;
        defaultShader.uniforms[`sunDirectionZ`].value = normalized.z;
      }
      /**
       * Get sun intensity
       */
      get sunIntensity() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`sunIntensity`].value;
      }
      /**
       * Set sun intensity (default: 22.0)
       */
      set sunIntensity(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`sunIntensity`].value = value;
      }
      /**
       * Get Rayleigh scattering coefficients (wavelength dependent - RGB)
       */
      get rayleighCoeff() {
        let defaultShader = this._shader.getDefaultColorShader();
        return new Vector3(
          defaultShader.uniforms[`rayleighCoeffX`].value,
          defaultShader.uniforms[`rayleighCoeffY`].value,
          defaultShader.uniforms[`rayleighCoeffZ`].value
        );
      }
      /**
       * Set Rayleigh scattering coefficients
       * Default: (5.5e-6, 13.0e-6, 22.4e-6) for Earth-like atmosphere
       */
      set rayleighCoeff(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`rayleighCoeffX`].value = value.x;
        defaultShader.uniforms[`rayleighCoeffY`].value = value.y;
        defaultShader.uniforms[`rayleighCoeffZ`].value = value.z;
      }
      /**
       * Get Mie scattering coefficient
       */
      get mieCoeff() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`mieCoeff`].value;
      }
      /**
       * Set Mie scattering coefficient (default: 21e-6)
       */
      set mieCoeff(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`mieCoeff`].value = value;
      }
      /**
       * Get Rayleigh scale height in meters
       */
      get rayleighScale() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`rayleighScale`].value;
      }
      /**
       * Set Rayleigh scale height (default: 8000 meters)
       */
      set rayleighScale(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`rayleighScale`].value = value;
      }
      /**
       * Get Mie scale height in meters
       */
      get mieScale() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`mieScale`].value;
      }
      /**
       * Set Mie scale height (default: 1200 meters)
       */
      set mieScale(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`mieScale`].value = value;
      }
      /**
       * Get Mie scattering asymmetry factor (g)
       */
      get mieG() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`mieG`].value;
      }
      /**
       * Set Mie scattering asymmetry factor (default: 0.758)
       * Values close to 1 give strong forward scattering (sun glare)
       * Values close to 0 give isotropic scattering
       */
      set mieG(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`mieG`].value = value;
      }
      /**
       * Get exposure value for tone mapping
       */
      get exposure() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`exposure`].value;
      }
      /**
       * Set exposure value for tone mapping (default: 1.0)
       */
      set exposure(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`exposure`].value = value;
      }
      /**
       * Get Earth center position
       */
      get earthCenter() {
        let defaultShader = this._shader.getDefaultColorShader();
        return new Vector3(
          defaultShader.uniforms[`earthCenterX`].value,
          defaultShader.uniforms[`earthCenterY`].value,
          defaultShader.uniforms[`earthCenterZ`].value
        );
      }
      /**
       * Set Earth center position
       * This allows positioning the Earth in world space
       */
      set earthCenter(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`earthCenterX`].value = value.x;
        defaultShader.uniforms[`earthCenterY`].value = value.y;
        defaultShader.uniforms[`earthCenterZ`].value = value.z;
      }
      /** No-op; atmospheric scattering does not use an environment texture. */
      set envMap(texture) {
      }
      /** No-op; this material does not use a shadow map. */
      set shadowMap(texture) {
      }
    }

    class EarthAtmRenderer extends exports.MeshRenderer {
      /**
       * The material used in the Earth Atmosphere.
       */
      earthAtmMaterial;
      /**
       * Radius of the earth sky sphere (should be larger than atmosphere radius)
       */
      _radius = 6471e3;
      // Default: earthRadius + atmosphereHeight
      init() {
        super.init();
        this.castShadow = false;
        this.castGI = false;
        this.alwaysRender = true;
        this.object3D.bound = new BoundingBox(Vector3.ZERO.clone(), Vector3.MAX);
        this.geometry = new SphereGeometry(this._radius, 64, 64);
        this.earthAtmMaterial ||= new EarthAtmMaterial();
        this.earthAtmMaterial.transparent = true;
        this.earthAtmMaterial.blendMode = BlendMode.ALPHA;
        this.material = this.earthAtmMaterial;
      }
      /**
       * Get the radius of earth sky sphere
       */
      get radius() {
        return this._radius;
      }
      /**
       * Set the radius of earth sky sphere
       * Should be larger than atmosphereRadius to ensure proper rendering
       */
      set radius(value) {
        if (this._radius !== value) {
          this._radius = value;
          this.geometry = new SphereGeometry(this._radius, 64, 64);
        }
      }
      // ========== Earth Parameters ==========
      /**
       * Get Earth radius in meters
       */
      get earthRadius() {
        return this.earthAtmMaterial.earthRadius;
      }
      /**
       * Set Earth radius in meters (default: 6371000)
       */
      set earthRadius(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.earthRadius = value;
      }
      /**
       * Get atmosphere outer radius in meters
       */
      get atmosphereRadius() {
        return this.earthAtmMaterial.atmosphereRadius;
      }
      /**
       * Set atmosphere outer radius in meters
       * Typically earthRadius + 100000 for 100km atmosphere
       */
      set atmosphereRadius(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.atmosphereRadius = value;
      }
      /**
       * Get Earth center position in world space
       */
      get earthCenter() {
        return this.earthAtmMaterial.earthCenter;
      }
      /**
       * Set Earth center position in world space
       */
      set earthCenter(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.earthCenter = value;
      }
      // ========== Sun Parameters ==========
      /**
       * Get sun direction (normalized vector pointing towards the sun)
       */
      get sunDirection() {
        return this.earthAtmMaterial.sunDirection;
      }
      /**
       * Set sun direction (will be normalized)
       */
      set sunDirection(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.sunDirection = value;
      }
      /**
       * Get sun intensity
       */
      get sunIntensity() {
        return this.earthAtmMaterial.sunIntensity;
      }
      /**
       * Set sun intensity (default: 22.0)
       */
      set sunIntensity(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.sunIntensity = value;
      }
      // ========== Scattering Parameters ==========
      /**
       * Get Rayleigh scattering coefficients (wavelength dependent - RGB)
       */
      get rayleighCoeff() {
        return this.earthAtmMaterial.rayleighCoeff;
      }
      /**
       * Set Rayleigh scattering coefficients
       * Default: (5.5e-6, 13.0e-6, 22.4e-6) for Earth-like atmosphere
       */
      set rayleighCoeff(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.rayleighCoeff = value;
      }
      /**
       * Get Mie scattering coefficient
       */
      get mieCoeff() {
        return this.earthAtmMaterial.mieCoeff;
      }
      /**
       * Set Mie scattering coefficient (default: 21e-6)
       */
      set mieCoeff(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.mieCoeff = value;
      }
      /**
       * Get Rayleigh scale height in meters
       */
      get rayleighScale() {
        return this.earthAtmMaterial.rayleighScale;
      }
      /**
       * Set Rayleigh scale height (default: 8000 meters)
       */
      set rayleighScale(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.rayleighScale = value;
      }
      /**
       * Get Mie scale height in meters
       */
      get mieScale() {
        return this.earthAtmMaterial.mieScale;
      }
      /**
       * Set Mie scale height (default: 1200 meters)
       */
      set mieScale(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.mieScale = value;
      }
      /**
       * Get Mie scattering asymmetry factor (g)
       */
      get mieG() {
        return this.earthAtmMaterial.mieG;
      }
      /**
       * Set Mie scattering asymmetry factor (default: 0.758)
       * Values close to 1 give strong forward scattering (sun glare)
       * Values close to 0 give isotropic scattering
       */
      set mieG(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.mieG = value;
      }
      // ========== Display Parameters ==========
      /**
       * Get exposure value for tone mapping
       */
      get exposure() {
        return this.earthAtmMaterial.exposure;
      }
      /**
       * Set exposure value for tone mapping (default: 1.0)
       */
      set exposure(value) {
        if (this.earthAtmMaterial)
          this.earthAtmMaterial.exposure = value;
      }
      // ========== Helper Methods ==========
      /**
       * Set sun position using spherical coordinates
       * @param azimuth Azimuth angle in radians (horizontal angle from north)
       * @param elevation Elevation angle in radians (angle above horizon)
       */
      setSunPosition(azimuth, elevation) {
        const x = Math.cos(elevation) * Math.sin(azimuth);
        const y = Math.sin(elevation);
        const z = Math.cos(elevation) * Math.cos(azimuth);
        this.sunDirection = new Vector3(x, y, z);
      }
      /**
       * Configure for ground view (camera on Earth surface)
       * Sets appropriate defaults for viewing sky from ground
       */
      configureForGroundView() {
        this.earthRadius = 6371e3;
        this.atmosphereRadius = 6471e3;
        this.earthCenter = new Vector3(0, -6371e3, 0);
        this.sunIntensity = 22;
        this.radius = this.atmosphereRadius * 1.5;
      }
      /**
       * Configure for space view (camera in space looking at Earth)
       * Sets appropriate defaults for viewing Earth from space
       */
      configureForSpaceView() {
        this.earthRadius = 6371e3;
        this.atmosphereRadius = 6471e3;
        this.earthCenter = new Vector3(0, 0, 0);
        this.sunIntensity = 22;
        this.radius = this.atmosphereRadius * 1.5;
      }
    }

    var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
    var __decorateClass$b = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.EarthSkyShader = class EarthSkyShader extends Shader {
      constructor() {
        super();
        let colorShader = new RenderShaderPass("earthsky_vs_wgsl", "earthsky_fs_wgsl");
        this.addRenderPass(colorShader);
        colorShader.setUniformFloat(`exposure`, 1);
        colorShader.setUniformFloat(`roughness`, 0);
        colorShader.setUniformFloat(`yaw`, 0);
        colorShader.setUniformFloat(`pitch`, 0);
        let shaderState = colorShader.shaderState;
        shaderState.frontFace = `ccw`;
        shaderState.cullMode = GPUCullMode.front;
        shaderState.depthWriteEnabled = true;
        shaderState.depthCompare = GPUCompareFunction.less_equal;
      }
    };
    exports.EarthSkyShader = __decorateClass$b([
      RegisterShader
    ], exports.EarthSkyShader);

    class EarthSkyMaterial extends Material {
      _earthSkyShader;
      /** Creates the material and binds a default cube texture to avoid dimension mismatch. */
      constructor() {
        super();
        this.shader = this._earthSkyShader = new exports.EarthSkyShader();
        this.setTexture(`baseMap`, Engine3D.resFor().defaultSky);
      }
      /**
       * Set base map (cube texture)
       */
      set baseMap(texture) {
        this.setTexture(`baseMap`, texture);
        const key = "IS_HDR_SKY";
        let defaultShader = this._shader.getDefaultShaders()[0];
        if (defaultShader.defineValue[key] != texture?.isHDRTexture) {
          this._shader.setDefine(key, texture?.isHDRTexture ? true : false);
        }
      }
      /**
       * Get base map (cube texture)
       */
      get baseMap() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.getTexture(`baseMap`);
      }
      /** No-op; this material does not use an environment texture. */
      set envMap(texture) {
      }
      /** No-op; this material does not use a shadow map. */
      set shadowMap(texture) {
      }
      /**
       * Get exposure value
       */
      get exposure() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`exposure`].value;
      }
      /**
       * Set exposure value
       */
      set exposure(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`exposure`].value = value;
      }
      /**
       * Get roughness value
       */
      get roughness() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`roughness`].value;
      }
      /**
       * Set roughness value
       */
      set roughness(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`roughness`].value = value;
      }
      /**
       * Get yaw rotation angle (in radians)
       * Controls horizontal rotation of the sky, independent of camera rotation
       */
      get yaw() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`yaw`].value;
      }
      /**
       * Set yaw rotation angle (in radians)
       * Controls horizontal rotation of the sky, independent of camera rotation
       */
      set yaw(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`yaw`].value = value;
      }
      /**
       * Get pitch rotation angle (in radians)
       * Controls vertical rotation of the sky, independent of camera rotation
       */
      get pitch() {
        let defaultShader = this._shader.getDefaultColorShader();
        return defaultShader.uniforms[`pitch`].value;
      }
      /**
       * Set pitch rotation angle (in radians)
       * Controls vertical rotation of the sky, independent of camera rotation
       */
      set pitch(value) {
        let defaultShader = this._shader.getDefaultColorShader();
        defaultShader.uniforms[`pitch`].value = value;
      }
    }

    class EarthSkyRenderer extends exports.MeshRenderer {
      /**
       * The material used in the Earth Sky.
       */
      earthSkyMaterial;
      /**
       * Radius of the earth sky sphere
       */
      _radius = 100;
      init() {
        super.init();
        this.castShadow = false;
        this.castGI = false;
        this.alwaysRender = true;
        this.object3D.bound = new BoundingBox(Vector3.ZERO.clone(), Vector3.MAX);
        this.geometry = new SphereGeometry(this._radius, 64, 64);
        this.earthSkyMaterial ||= new EarthSkyMaterial();
        this.material = this.earthSkyMaterial;
      }
      /**
       * Get the radius of earth sky sphere
       */
      get radius() {
        return this._radius;
      }
      /**
       * Set the radius of earth sky sphere
       */
      set radius(value) {
        if (this._radius !== value) {
          this._radius = value;
          this.geometry = new SphereGeometry(this._radius, 64, 64);
        }
      }
      /**
       * Set environment texture (cube texture)
       */
      set map(texture) {
        this.earthSkyMaterial.baseMap = texture;
        if (this.earthSkyMaterial.name == null) {
          this.earthSkyMaterial.name = "earthSkyMaterial";
        }
        this.material = this.earthSkyMaterial;
      }
      /**
       * Get environment texture
       */
      get map() {
        return this.earthSkyMaterial.baseMap;
      }
      /**
       * Get exposure value
       */
      get exposure() {
        return this.earthSkyMaterial.exposure;
      }
      /**
       * Set exposure value
       */
      set exposure(value) {
        if (this.earthSkyMaterial)
          this.earthSkyMaterial.exposure = value;
      }
      /**
       * Get roughness value
       */
      get roughness() {
        return this.earthSkyMaterial.roughness;
      }
      /**
       * Set roughness value
       */
      set roughness(value) {
        if (this.earthSkyMaterial)
          this.earthSkyMaterial.roughness = value;
      }
      /**
       * Get yaw rotation angle (in radians)
       * Controls horizontal rotation of the sky, independent of camera rotation
       */
      get yaw() {
        return this.earthSkyMaterial.yaw;
      }
      /**
       * Set yaw rotation angle (in radians)
       * Controls horizontal rotation of the sky, independent of camera rotation
       */
      set yaw(value) {
        if (this.earthSkyMaterial)
          this.earthSkyMaterial.yaw = value;
      }
      /**
       * Get pitch rotation angle (in radians)
       * Controls vertical rotation of the sky, independent of camera rotation
       */
      get pitch() {
        return this.earthSkyMaterial.pitch;
      }
      /**
       * Set pitch rotation angle (in radians)
       * Controls vertical rotation of the sky, independent of camera rotation
       */
      set pitch(value) {
        if (this.earthSkyMaterial)
          this.earthSkyMaterial.pitch = value;
      }
    }

    class Probe extends exports.Object3D {
      index = 0;
      drawCallFrame = -1;
      constructor() {
        super();
      }
    }

    var GIProbeMaterialType = /* @__PURE__ */ ((GIProbeMaterialType2) => {
      GIProbeMaterialType2[GIProbeMaterialType2["CastGI"] = 0] = "CastGI";
      GIProbeMaterialType2[GIProbeMaterialType2["ReceiveGI"] = 1] = "ReceiveGI";
      GIProbeMaterialType2[GIProbeMaterialType2["CastDepth"] = 2] = "CastDepth";
      GIProbeMaterialType2[GIProbeMaterialType2["Other"] = 3] = "Other";
      return GIProbeMaterialType2;
    })(GIProbeMaterialType || {});
    class GIProbeMaterial extends Material {
      static count = 0;
      constructor(type = 0 /* CastGI */, index = 0, ctx) {
        super();
        ShaderLib.register("GIProbeShader", GIProbeShader);
        let newShader = new Shader();
        let colorShader = new RenderShaderPass("GIProbeShader", "GIProbeShader");
        colorShader.passType = PassType.COLOR;
        newShader.addRenderPass(colorShader);
        colorShader.setDefine("USE_BRDF", true);
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        colorShader.setUniformVector4("probeUniform", new Vector4(index, type, 0, 0));
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = false;
        shaderState.castShadow = false;
        shaderState.receiveEnv = false;
        shaderState.acceptGI = false;
        shaderState.useLight = false;
        const res = Engine3D.resFor(ctx);
        newShader.setTexture("baseMap", res.whiteTexture);
        newShader.setTexture("normalMap", res.normalTexture);
        newShader.setTexture("emissiveMap", res.blackTexture);
        this.shader = newShader;
      }
    }

    class GlobalIlluminationComponent extends ComponentBase {
      _probes;
      _volume;
      _debugMr = [];
      init(scene) {
        scene ||= this.transform?.view3D?.scene;
        const setting = scene?.view?.engine3D?.setting;
        if (setting) setting.gi.enable = true;
        this._volume = GlobalBindGroup.getLightEntries(scene).irradianceVolume;
        this.initProbe(scene);
      }
      initProbe(scene) {
        let xCount = this._volume.setting.probeXCount;
        let yCount = this._volume.setting.probeYCount;
        let zCount = this._volume.setting.probeZCount;
        let debugGeo = new SphereGeometry(4, 16, 16);
        let position = new Vector3();
        this._probes = [];
        for (let x = 0; x < xCount; x++) {
          for (let y = 0; y < yCount; y++) {
            for (let z = 0; z < zCount; z++) {
              let index = x + z * xCount + y * (xCount * zCount);
              let probe = new Probe();
              probe.index = index;
              probe.name = `${x}_${y}_${z}`;
              let mr = probe.addComponent(exports.MeshRenderer);
              mr.material = new GIProbeMaterial(GIProbeMaterialType.CastGI, index);
              mr.geometry = debugGeo;
              mr.castGI = false;
              mr.castShadow = false;
              this._debugMr.push(mr);
              this.object3D.addChild(probe);
              this._volume.calcPosition(x, y, z, position);
              probe.x = position.x;
              probe.y = position.y;
              probe.z = position.z;
              this._probes[index] = probe;
              this._debugMr.push(mr);
            }
          }
        }
        for (let i = 0; i < this._probes.length; i++) {
          EntityCollect.instance.addGIProbe(scene, this._probes[i]);
        }
        this.object3D.transform.enable = false;
        if (this._volume.setting.debug) {
          this.debug();
        }
      }
      debug() {
      }
      debugProbeRay(probeIndex, array) {
        const rayNumber = this.transform.scene3D.view.engine3D.setting.gi.rayNumber;
        let quat = new Quaternion(0, -0.7071067811865475, 0.7071067811865475, 0);
        for (let i = 0; i < rayNumber; i++) {
          let ii = probeIndex * rayNumber + i;
          let dir = new Vector3(
            -array[ii * 4 + 0],
            -array[ii * 4 + 1],
            -array[ii * 4 + 2],
            0
          );
          Quaternion.transformVector(quat, dir, dir);
          let len = array[ii * 4 + 3];
          let start = this._probes[probeIndex].transform.worldPosition.clone();
          let end = dir.multiplyScalar(len);
          Vector3.add(end, start, end);
        }
      }
      changeProbesVolumeData() {
        this._volume.setVolumeDataChange();
      }
      changeProbesPosition() {
        this._volume.setVolumeDataChange();
        let xCount = this._volume.setting.probeXCount;
        let yCount = this._volume.setting.probeYCount;
        let zCount = this._volume.setting.probeZCount;
        let position = new Vector3();
        for (let x = 0; x < xCount; x++) {
          for (let y = 0; y < yCount; y++) {
            for (let z = 0; z < zCount; z++) {
              let index = x + z * xCount + y * (xCount * zCount);
              let probe = this._probes[index];
              this._volume.calcPosition(x, y, z, position);
              probe.x = position.x;
              probe.y = position.y;
              probe.z = position.z;
            }
          }
        }
      }
      onUpdate() {
        const setting = this.transform.scene3D.view.engine3D.setting;
        setting.gi.maxDistance = setting.gi.probeSpace * 1.5;
        let camera = this.transform.scene3D.view.camera;
        let scale = Vector3.distance(camera.transform.worldPosition, camera.transform.targetPos) / 300;
        if (this._debugMr && this._debugMr.length > 0) {
          for (let i = 0; i < this._debugMr.length; i++) {
            const debugOBJ = this._debugMr[i].transform;
            debugOBJ.scaleX = scale;
            debugOBJ.scaleY = scale;
            debugOBJ.scaleZ = scale;
          }
        }
      }
    }

    class InstanceDrawComponent extends RenderNode {
      _keyRenderGroup;
      _keyBufferGroup;
      _keyIdsGroup;
      constructor() {
        super();
      }
      /** Initialize the internal grouping maps. */
      init(param) {
        this._keyRenderGroup = /* @__PURE__ */ new Map();
        this._keyBufferGroup = /* @__PURE__ */ new Map();
        this._keyIdsGroup = /* @__PURE__ */ new Map();
      }
      /**
       * Collect child mesh renderers, group them by geometry+material key,
       * disable their individual rendering, and upload per-instance matrix
       * index buffers.
       */
      start() {
        let meshRenders = [];
        this.object3D.getComponents(exports.MeshRenderer, meshRenders, true);
        for (let i = 0; i < meshRenders.length; i++) {
          const mr = meshRenders[i];
          mr.transform.updateWorldMatrix(true);
          mr.enable = false;
          let key = mr.geometry.instanceID;
          for (let j = 0; j < mr.materials.length; j++) {
            const mat = mr.materials[j];
            key += mat.instanceID;
          }
          if (!this._keyRenderGroup.has(key)) {
            let matrixBuffer = new StorageGPUBuffer(meshRenders.length);
            matrixBuffer.visibility = GPUShaderStage.VERTEX;
            this._keyRenderGroup.set(key, [mr]);
            this._keyBufferGroup.set(key, matrixBuffer);
            this._keyIdsGroup.set(key, [mr.transform.worldMatrix.index]);
          } else {
            this._keyRenderGroup.get(key).push(mr);
            this._keyIdsGroup.get(key).push(mr.transform.worldMatrix.index);
          }
        }
        this._keyBufferGroup.forEach((v, k) => {
          let ids = this._keyIdsGroup.get(k);
          let instanceMatrixBuffer = this._keyBufferGroup.get(k);
          instanceMatrixBuffer.setInt32Array("matrixIDs", new Int32Array(ids));
          instanceMatrixBuffer.apply();
        });
      }
      /** Clear the current grouping and rebuild it from the child renderers. */
      reset() {
        if (this._keyRenderGroup.size > 0) {
          this._keyRenderGroup.clear();
          this._keyBufferGroup.clear();
          this._keyIdsGroup.clear();
          this.start();
        }
      }
      /**
       * Per-pass update: enables the USE_INSTANCEDRAW shader define and binds
       * the per-group instance matrix buffer for each material pass.
       */
      nodeUpdate(view, passType, renderPassState, clusterLightingBuffer) {
        this._keyRenderGroup.forEach((v, k) => {
          let instanceMatrixBuffer = this._keyBufferGroup.get(k);
          let renderNode = v[0];
          for (let i = 0; i < renderNode.materials.length; i++) {
            let material = renderNode.materials[i];
            let passes = material.getPass(passType);
            if (passes) {
              for (let i2 = 0; i2 < passes.length; i2++) {
                const renderShader = passes[i2];
                renderShader.setDefine("USE_INSTANCEDRAW", true);
                renderShader.setStorageBuffer(`instanceDrawID`, instanceMatrixBuffer);
              }
            }
          }
          renderNode.nodeUpdate(view, passType, renderPassState, clusterLightingBuffer);
        });
      }
      /**
       * Encoder-direct instanced draw for the modern frame-graph pipeline.
       *
       * `drawNodesEncoder` (the main ColorPass draw path) calls `renderPass2`,
       * not the legacy `renderPass`. The base `RenderNode.renderPass2`
       * early-returns on `!_geometry`, and this component owns no geometry of
       * its own — so without this override the whole group is invisible (its
       * child MeshRenderers were already disabled in `start()`). Here we issue
       * one instanced draw per geometry+material group using the group's
       * representative node, mirroring the legacy `renderItem` logic but
       * writing straight to the pass encoder.
       */
      renderPass2(view, passType, rendererPassState, clusterLightingBuffer, encoder, useBundle = false) {
        if (!this.enable)
          return;
        const gpu = view.engine3D.context3D.gpuContext;
        this._keyRenderGroup.forEach((v) => {
          let renderNode = v[0];
          renderNode.instanceCount = v.length;
          let geometry = renderNode.geometry;
          let subGeometries = geometry.subGeometries;
          const nCount = Math.max(renderNode.materials.length, subGeometries.length);
          for (let i = 0; i < nCount; i++) {
            const material = i >= renderNode.materials.length ? renderNode.materials[0] : renderNode.materials[i];
            if (!material.castShadow && passType == PassType.SHADOW)
              continue;
            let passes = material.getPass(passType);
            if (!passes || passes.length == 0)
              continue;
            gpu.bindGeometryBuffer(encoder, geometry);
            for (let j = 0; j < passes.length; j++) {
              const renderShader = passes[j];
              if (!renderShader.pipeline)
                continue;
              gpu.bindPipeline(encoder, renderShader);
              const subGeometry = i >= subGeometries.length ? subGeometries[0] : subGeometries[i];
              let lodInfo = subGeometry.lodLevels[renderNode.lodLevel];
              gpu.drawIndexed(encoder, lodInfo.indexCount, renderNode.instanceCount, lodInfo.indexStart, 0, 0);
            }
          }
        });
      }
      /** Issue one instanced draw per group, with instance count = group size. */
      renderPass(view, passType, renderContext) {
        this._keyRenderGroup.forEach((v, k) => {
          let renderNode = v[0];
          renderNode.instanceCount = v.length;
          this.renderItem(view, passType, renderNode, renderContext);
        });
      }
      /** Bind geometry/pipeline and emit the indexed (optionally instanced) draw for a render node. */
      renderItem(view, passType, renderNode, renderContext) {
        const gpu = view.engine3D.context3D.gpuContext;
        let worldMatrix = renderNode.transform._worldMatrix;
        for (let i = 0; i < renderNode.materials.length; i++) {
          const material = renderNode.materials[i];
          let passes = material.getPass(passType);
          if (!passes || passes.length == 0)
            continue;
          for (let j = 0; j < passes.length; j++) {
            let matPass = passes[j];
            gpu.bindGeometryBuffer(renderContext.encoder, renderNode.geometry);
            const renderShader = matPass;
            if (renderShader.shaderState.splitTexture) {
              renderContext.endRenderPass();
              RTResourceMap.WriteSplitColorTexture(view.engine3D.context3D, renderNode.instanceID);
              renderContext.beginOpaqueRenderPass();
              gpu.bindCamera(renderContext.encoder, view.camera);
              gpu.bindGeometryBuffer(renderContext.encoder, renderNode.geometry);
            }
            gpu.bindPipeline(renderContext.encoder, renderShader);
            let subGeometries = renderNode.geometry.subGeometries;
            const subGeometry = subGeometries[i];
            let lodInfos = subGeometry.lodLevels;
            let lodInfo = lodInfos[renderNode.lodLevel];
            if (renderNode.instanceCount > 0) {
              gpu.drawIndexed(renderContext.encoder, lodInfo.indexCount, renderNode.instanceCount, lodInfo.indexStart, 0, 0);
            } else {
              gpu.drawIndexed(renderContext.encoder, lodInfo.indexCount, 1, lodInfo.indexStart, 0, worldMatrix.index);
            }
          }
        }
      }
      /** Release the grouping maps and unregister from pending-start collection. */
      beforeDestroy(force) {
        this._keyRenderGroup.clear();
        this._keyBufferGroup.clear();
        this._keyIdsGroup.clear();
        this._keyRenderGroup = this._keyBufferGroup = this._keyIdsGroup = void 0;
        ComponentCollect.removeWaitStart(this.object3D, this);
      }
    }

    var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
    var __decorateClass$a = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.MeshFilter = class MeshFilter extends exports.MeshRenderer {
      constructor() {
        super();
      }
      get geometry() {
        return null;
      }
      set geometry(value) {
      }
      cloneTo(obj) {
      }
      set meshURL(value) {
        const ctx = this.transform?.view3D?.engine3D?.context3D;
        let geometry = Engine3D.resFor(ctx).getGeometry(value);
        if (geometry) {
          this.geometry = geometry;
        } else {
          console.error("no geometry set", value);
        }
      }
    };
    exports.MeshFilter = __decorateClass$a([
      RegisterComponent(exports.MeshFilter, "MeshFilter")
    ], exports.MeshFilter);

    var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
    var __decorateClass$9 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SkinnedMeshRenderer = class SkinnedMeshRenderer extends exports.MeshRenderer {
      /** Ordered names of the joints this skin is bound to. */
      skinJointsName;
      mInverseBindMatrixData;
      mInverseBindMatrixBuffer;
      mSkeletonAnimation;
      mJointIndexTableBuffer;
      constructor() {
        super();
        this.addRendererMask(RendererMask.SkinnedMesh);
      }
      /** Resolve the driving skeleton animation component from the hierarchy. */
      start() {
        super.start();
        this.skeletonAnimation = this.object3D.getComponent(exports.SkeletonAnimationComponent);
        if (!this.skeletonAnimation) {
          let comps = this.object3D.parentObject.parentObject.getComponentsInChild(exports.SkeletonAnimationComponent);
          if (comps.length > 0) {
            this.skeletonAnimation = comps[0];
          }
          let parentObj = this.object3D;
          while (!this.skeletonAnimation && parentObj) {
            this.skeletonAnimation = parentObj.getComponentFromParent(exports.SkeletonAnimationComponent);
            if (parentObj.parent) {
              parentObj = parentObj.parent.object3D;
            }
          }
        }
      }
      /** Register the renderer when enabled. */
      onEnable() {
        super.onEnable();
      }
      /** The skeleton animation component driving this skin. */
      get skeletonAnimation() {
        return this.mSkeletonAnimation;
      }
      set skeletonAnimation(value) {
        this.mSkeletonAnimation = value;
        if (!value) {
          return;
        }
        if (!this.mJointIndexTableBuffer) {
          let skinJointIndexData = this.mSkeletonAnimation.getJointIndexTable(this.skinJointsName);
          this.mJointIndexTableBuffer = new StorageGPUBuffer(skinJointIndexData.length * 4, 0, new Float32Array(skinJointIndexData));
          this.mJointIndexTableBuffer.visibility = GPUShaderStage.VERTEX | GPUShaderStage.COMPUTE;
        }
      }
      /** Per-joint inverse bind matrices used to skin the mesh. */
      get skinInverseBindMatrices() {
        return this.mInverseBindMatrixData;
      }
      set skinInverseBindMatrices(inverseBindMatrices) {
        this.mInverseBindMatrixData = inverseBindMatrices;
        var inverseBindMatricesData = new Float32Array(inverseBindMatrices.length * 16);
        for (let i = 0; i < inverseBindMatrices.length; i++) {
          let index = i * 16;
          let mat4x4 = inverseBindMatrices[i];
          inverseBindMatricesData.set(mat4x4, index);
        }
        this.mInverseBindMatrixBuffer = new StorageGPUBuffer(inverseBindMatricesData.byteLength, 0, inverseBindMatricesData);
        this.mInverseBindMatrixBuffer.visibility = GPUShaderStage.VERTEX | GPUShaderStage.COMPUTE;
      }
      /** GPU buffer holding the inverse bind matrices. */
      get inverseBindMatrixBuffer() {
        return this.mInverseBindMatrixBuffer;
      }
      /** GPU buffer mapping skin joints to skeleton joint indices. */
      get jointIndexTableBuffer() {
        return this.mJointIndexTableBuffer.buffer;
      }
      /** Clone this skinned mesh renderer onto another object. */
      cloneTo(obj) {
        let skinnedMesh = obj.addComponent(exports.SkinnedMeshRenderer);
        skinnedMesh.geometry = this.geometry;
        skinnedMesh.material = this.material.clone();
        skinnedMesh.castShadow = this.castShadow;
        skinnedMesh.castGI = this.castGI;
        skinnedMesh.receiveShadow = this.receiveShadow;
        skinnedMesh.rendererMask = this.rendererMask;
        skinnedMesh.skinJointsName = this.skinJointsName;
        skinnedMesh.skinInverseBindMatrices = this.skinInverseBindMatrices;
        skinnedMesh.mJointIndexTableBuffer = this.mJointIndexTableBuffer;
      }
      /**
       * @internal
       * @param passType
       * @param renderPassState
       * @param scene3D
       * @param clusterLightingRender
       * @param probes
       */
      nodeUpdate(view, passType, renderPassState, clusterLightingBuffer) {
        for (let i = 0; i < this.materials.length; i++) {
          const material = this.materials[i];
          let passes = material.getPass(passType);
          if (passes) for (let i2 = 0; i2 < passes.length; i2++) {
            const renderShader = passes[i2];
            if (!renderShader.pipeline && this.mSkeletonAnimation) {
              renderShader.setStorageBuffer("jointsMatrixIndexTable", this.mSkeletonAnimation.jointMatrixIndexTableBuffer);
              renderShader.setStorageBuffer("jointsInverseMatrix", this.mInverseBindMatrixBuffer);
              renderShader.setStorageBuffer("jointsIndexMapingTable", this.mJointIndexTableBuffer);
            }
          }
        }
        super.nodeUpdate(view, passType, renderPassState, clusterLightingBuffer);
      }
    };
    exports.SkinnedMeshRenderer = __decorateClass$9([
      RegisterComponent(exports.SkinnedMeshRenderer, "SkinnedMeshRenderer")
    ], exports.SkinnedMeshRenderer);

    var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
    var __decorateClass$8 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SpriteShader = class SpriteShader extends Shader {
      constructor() {
        super();
        let colorPass = new RenderShaderPass("Sprite", "Sprite");
        colorPass.setShaderEntry(`VertMain`, `FragMain`);
        this.addRenderPass(colorPass);
        let state = colorPass.shaderState;
        state.acceptShadow = false;
        state.castShadow = false;
        state.receiveEnv = false;
        state.acceptGI = false;
        state.useLight = false;
        state.cullMode = GPUCullMode.none;
        state.depthWriteEnabled = false;
        colorPass.blendMode = BlendMode.NORMAL;
        this.setDefault();
      }
      /**
       * Apply the default uniform values for the sprite shader.
       */
      setDefault() {
        this.setUniformColor(`color`, new Color(1, 1, 1, 1));
        this.setUniformVector4(`uvRect`, new Vector4(0, 0, 1, 1));
        this.setUniformVector2(`size`, new Vector2(1, 1));
        this.setUniformVector2(`pivot`, new Vector2(0.5, 0.5));
        this.setUniformFloat(`distanceInvariant`, 0);
        this.setUniformFloat(`cornerRadius`, 0);
        this.setUniformFloat(`spritePad0`, 0);
        this.setUniformFloat(`spritePad1`, 0);
      }
      /**
       * The base color texture of the sprite.
       */
      set baseMap(value) {
        this.setTexture(`baseMap`, value);
      }
      get baseMap() {
        return this.getTexture(`baseMap`);
      }
    };
    exports.SpriteShader = __decorateClass$8([
      RegisterShader
    ], exports.SpriteShader);

    class SpriteMaterial extends Material {
      constructor(ctx) {
        super();
        this.shader = new exports.SpriteShader();
        this.transparent = true;
        this.baseMap = Engine3D.resFor(ctx).whiteTexture;
      }
      /** Set the base (albedo) texture sampled by the sprite. */
      set baseMap(texture) {
        this.shader.setTexture(`baseMap`, texture);
      }
      /** Get the base (albedo) texture sampled by the sprite. */
      get baseMap() {
        return this.shader.getTexture(`baseMap`);
      }
      /** Set the tint color multiplied with the base texture. */
      set color(value) {
        this.shader.setUniformColor(`color`, value);
      }
      /** Get the tint color multiplied with the base texture. */
      get color() {
        return this.shader.getUniformColor(`color`);
      }
      /** UV sub-region as (offsetX, offsetY, scaleX, scaleY) in [0,1] texture space. */
      set uvRect(value) {
        this.shader.setUniformVector4(`uvRect`, value);
      }
      /** Get the UV sub-region as (offsetX, offsetY, scaleX, scaleY) in [0,1] texture space. */
      get uvRect() {
        return this.shader.getUniformVector4(`uvRect`);
      }
      /** Quad size in world units (meters). */
      set size(value) {
        this.shader.setUniformVector2(`size`, value);
      }
      /** Get the quad size in world units (meters). */
      get size() {
        return this.shader.getUniformVector2(`size`);
      }
      /** Set the pivot point (anchor) of the quad in normalized [0,1] space. */
      set pivot(value) {
        this.shader.setUniformVector2(`pivot`, value);
      }
      /** Get the pivot point (anchor) of the quad in normalized [0,1] space. */
      get pivot() {
        return this.shader.getUniformVector2(`pivot`);
      }
      /**
       * When true, the sprite's on-screen size stays constant regardless of
       * camera distance (the vertex shader scales local position by the
       * distance from camera to the sprite's origin, divided by a reference
       * distance). Useful for world-space UI labels that need to stay
       * readable as the camera pans/zooms.
       */
      set distanceInvariantSize(value) {
        this.shader.setUniformFloat(`distanceInvariant`, value ? 1 : 0);
      }
      /** Get whether the sprite keeps a constant on-screen size regardless of camera distance. */
      get distanceInvariantSize() {
        return this.shader.getUniformFloat(`distanceInvariant`) > 0.5;
      }
      /** Rounded-corner radius in world units (same as `size`). 0 disables. */
      set cornerRadius(value) {
        this.shader.setUniformFloat(`cornerRadius`, value);
      }
      /** Get the rounded-corner radius in world units. */
      get cornerRadius() {
        return this.shader.getUniformFloat(`cornerRadius`);
      }
      /** Toggle the video-texture code path. SpriteRenderer sets this automatically when the texture is a `VideoTexture`. */
      set useVideoTexture(value) {
        this.shader.setDefine(`USE_VIDEO_TEXTURE`, value);
      }
      /** Get whether the video-texture code path is enabled. */
      get useVideoTexture() {
        return this.shader.getDefine(`USE_VIDEO_TEXTURE`);
      }
      /** No-op setter; sprites do not sample an environment map. */
      set envMap(_texture) {
      }
      /** No-op setter; sprites do not receive shadows. */
      set shadowMap(_texture) {
      }
    }

    var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
    var __decorateClass$7 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    class SpriteBatchEntry {
      id;
      /** World-space position of the entry's pivot anchor (local to the batch's Object3D). */
      position = new Vector3(0, 0, 0);
      /** Quad size in world units (meters). */
      size = new Vector2(1, 1);
      /** Anchor point in [0,1]². (0.5, 0.5) = centered. */
      pivot = new Vector2(0.5, 0.5);
      /** UV sub-region as (offsetX, offsetY, scaleX, scaleY) — atlas-friendly. */
      uvRect = new Vector4(0, 0, 1, 1);
      constructor(id) {
        this.id = id;
      }
    }
    exports.SpriteBatch = class SpriteBatch extends RenderNode {
      _entries = [];
      _dirty = true;
      _nextId = 0;
      _pendingTexture = null;
      _pendingColor = null;
      _batchMaterial = null;
      _batchGeometry = null;
      _capacity = 0;
      // CPU-side typed arrays — rebuilt on grow, mutated in place on same-capacity rebuild.
      _cpuPositions = null;
      _cpuNormals = null;
      _cpuUVs = null;
      _cpuIndices = null;
      init(param) {
        super.init(param);
        this.renderOrder = 3e3;
      }
      onEnable() {
        if (!this._batchMaterial) this._ensureResources();
        this._rebuildIfDirty();
        super.onEnable();
      }
      onUpdate(_view) {
        if (this._dirty) this._rebuildIfDirty();
      }
      _ensureResources() {
        const ctx = this.transform?.view3D?.engine3D?.context3D;
        if (!ctx) return;
        if (!this._batchMaterial) {
          const mat = new SpriteMaterial(ctx);
          if (this._pendingTexture) mat.baseMap = this._pendingTexture;
          if (this._pendingColor) mat.color = this._pendingColor;
          this._batchMaterial = mat;
          this.materials = [mat];
        }
      }
      // ---------- API ----------
      /** Single texture shared by every entry. Use `uvRect` in each entry to pick a sub-region (atlas). */
      set texture(tex) {
        if (this._batchMaterial) this._batchMaterial.baseMap = tex;
        else this._pendingTexture = tex;
      }
      get texture() {
        return this._batchMaterial?.baseMap ?? this._pendingTexture;
      }
      /** Global tint multiplied onto every sampled pixel. */
      set color(c) {
        if (this._batchMaterial) this._batchMaterial.color = c;
        else this._pendingColor = c;
      }
      get color() {
        return this._batchMaterial?.color ?? this._pendingColor;
      }
      get entries() {
        return this._entries;
      }
      add(spec = {}) {
        const e = new SpriteBatchEntry(this._nextId++);
        if (spec.position) e.position.copy(spec.position);
        if (spec.size) e.size.copy(spec.size);
        if (spec.pivot) e.pivot.copy(spec.pivot);
        if (spec.uvRect) e.uvRect.copy(spec.uvRect);
        this._entries.push(e);
        this._dirty = true;
        return e;
      }
      remove(entry) {
        const i = this._entries.indexOf(entry);
        if (i < 0) return false;
        this._entries.splice(i, 1);
        this._dirty = true;
        return true;
      }
      update(entry, patch) {
        if (patch.position) entry.position.copy(patch.position);
        if (patch.size) entry.size.copy(patch.size);
        if (patch.pivot) entry.pivot.copy(patch.pivot);
        if (patch.uvRect) entry.uvRect.copy(patch.uvRect);
        this._dirty = true;
      }
      clear() {
        this._entries.length = 0;
        this._dirty = true;
      }
      /** Force a geometry rebuild on the next onUpdate. Call after a bulk in-place mutation of existing entries. */
      markDirty() {
        this._dirty = true;
      }
      // ---------- Geometry build ----------
      _rebuildIfDirty() {
        if (!this._dirty) return;
        const ctx = this.transform?.view3D?.engine3D?.context3D;
        if (!ctx) return;
        this._rebuild(ctx);
        this._dirty = false;
      }
      _rebuild(_ctx) {
        const n = this._entries.length;
        const growing = !this._batchGeometry || n > this._capacity;
        if (growing) {
          const newCap = Math.max(n, this._capacity * 2, 1);
          this._allocArrays(newCap);
        }
        const positions = this._cpuPositions;
        const uvs = this._cpuUVs;
        const indices = this._cpuIndices;
        for (let i = 0; i < n; i++) {
          const e = this._entries[i];
          const left = e.position.x - e.pivot.x * e.size.x;
          const top = e.position.y - e.pivot.y * e.size.y;
          const right = left + e.size.x;
          const bottom = top + e.size.y;
          const z = e.position.z;
          const vOff = i * 4 * 3;
          positions[vOff + 0] = left;
          positions[vOff + 1] = top;
          positions[vOff + 2] = z;
          positions[vOff + 3] = right;
          positions[vOff + 4] = top;
          positions[vOff + 5] = z;
          positions[vOff + 6] = left;
          positions[vOff + 7] = bottom;
          positions[vOff + 8] = z;
          positions[vOff + 9] = right;
          positions[vOff + 10] = bottom;
          positions[vOff + 11] = z;
          const u0 = e.uvRect.x;
          const v0 = e.uvRect.y;
          const u1 = e.uvRect.x + e.uvRect.z;
          const v1 = e.uvRect.y + e.uvRect.w;
          const uvOff = i * 4 * 2;
          uvs[uvOff + 0] = u0;
          uvs[uvOff + 1] = v0;
          uvs[uvOff + 2] = u1;
          uvs[uvOff + 3] = v0;
          uvs[uvOff + 4] = u0;
          uvs[uvOff + 5] = v1;
          uvs[uvOff + 6] = u1;
          uvs[uvOff + 7] = v1;
          const iOff = i * 6;
          const baseV = i * 4;
          indices[iOff + 0] = baseV + 0;
          indices[iOff + 1] = baseV + 2;
          indices[iOff + 2] = baseV + 1;
          indices[iOff + 3] = baseV + 1;
          indices[iOff + 4] = baseV + 2;
          indices[iOff + 5] = baseV + 3;
        }
        if (growing) {
          this._materializeGeometry();
        } else {
          const geom = this._batchGeometry;
          const vb = geom.vertexBuffer;
          vb.upload(VertexAttributeName.position, { attribute: VertexAttributeName.position, data: positions });
          vb.upload(VertexAttributeName.uv, { attribute: VertexAttributeName.uv, data: uvs });
          vb.upload(VertexAttributeName.TEXCOORD_1, { attribute: VertexAttributeName.TEXCOORD_1, data: uvs });
          geom.indicesBuffer.upload(indices);
        }
        this._batchGeometry.subGeometries[0].lodLevels[0].indexCount = Math.max(n * 6, 0);
      }
      /** Allocate CPU-side typed arrays for a given capacity. No GPU work. */
      _allocArrays(capacity) {
        const vCount = capacity * 4;
        const positions = new Float32Array(vCount * 3);
        const normals = new Float32Array(vCount * 3);
        const uvs = new Float32Array(vCount * 2);
        const indices = vCount > 65535 ? new Uint32Array(capacity * 6) : new Uint16Array(capacity * 6);
        for (let k = 0; k < vCount; k++) normals[k * 3 + 2] = 1;
        this._capacity = capacity;
        this._cpuPositions = positions;
        this._cpuNormals = normals;
        this._cpuUVs = uvs;
        this._cpuIndices = indices;
      }
      /**
       * Materialize the CPU arrays into a fresh `GeometryBase` with a fully
       * populated GPU vertex buffer layout. Must be called AFTER entry data has
       * been written into the CPU arrays so the initial generate() uploads real
       * data and not zero-filled placeholders.
       */
      _materializeGeometry() {
        const positions = this._cpuPositions;
        const normals = this._cpuNormals;
        const uvs = this._cpuUVs;
        const indices = this._cpuIndices;
        const geom = new GeometryBase();
        geom.bounds = new BoundingBox(new Vector3(0, 0, 0), new Vector3(1e3, 1e3, 1e3));
        geom.setIndices(indices);
        geom.setAttribute(VertexAttributeName.position, positions);
        geom.setAttribute(VertexAttributeName.normal, normals);
        geom.setAttribute(VertexAttributeName.uv, uvs);
        geom.setAttribute(VertexAttributeName.TEXCOORD_1, uvs);
        geom.addSubGeometry({
          indexStart: 0,
          indexCount: indices.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
        geom.instanceID = `spriteBatch_${GetCountInstanceID()}`;
        const pass = this._batchMaterial?.getPass(PassType.COLOR)?.[0];
        if (pass?.shaderReflection) {
          geom.generate(pass.shaderReflection);
        }
        this._batchGeometry = geom;
        this.geometry = geom;
      }
    };
    exports.SpriteBatch = __decorateClass$7([
      RegisterComponent(exports.SpriteBatch, "SpriteBatch")
    ], exports.SpriteBatch);

    var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
    var __decorateClass$6 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.SpriteRenderer = class SpriteRenderer extends RenderNode {
      /** Bound Sprite asset. Never mutated by this renderer — per-instance tweaks live in the override fields below. */
      _sprite = null;
      /** Auto-managed Sprite backing the `setTexture()` ergonomics. Created lazily when the user assigns a bare texture. */
      _autoSprite = null;
      /** Bound change listener reference so we can unbind cleanly. */
      _spriteListener;
      // Per-renderer overrides that survive sprite-asset swaps. `null` = fall
      // through to the bound sprite's own field. This is how `set pivot(v)` /
      // `set uvRect(v)` remain local to a renderer even when `this.sprite =
      // otherAsset` re-binds.
      _pivotOverride = null;
      _uvRectOverride = null;
      _pendingColor = null;
      _pendingCornerRadius = null;
      /** Quad size in world units (meters). Defaults to (1, 1). */
      _size = new Vector2(1, 1);
      _distanceInvariantSize = false;
      constructor() {
        super();
        this._spriteListener = (flags) => this._onSpriteChange(flags);
      }
      init(param) {
        super.init(param);
        this.renderOrder = 3e3;
      }
      /** Shared unit quad on the Z axis, cached per Context3D. */
      static _sharedQuad(ctx) {
        return ctx.cache(exports.SpriteRenderer, () => new PlaneGeometry(1, 1, 1, 1, Vector3.Z_AXIS));
      }
      onEnable() {
        if (!this._geometry || this._materials.length === 0) {
          this._ensureResources();
        }
        super.onEnable();
      }
      onDisable() {
        super.onDisable();
      }
      _ensureResources() {
        const ctx = this.transform?.view3D?.engine3D?.context3D;
        if (!ctx) return;
        if (!this._geometry) {
          this.geometry = exports.SpriteRenderer._sharedQuad(ctx);
        }
        if (this._materials.length === 0) {
          const mat = new SpriteMaterial(ctx);
          this.material = mat;
          this._applySpriteToMaterial();
          this._applyOverridesToMaterial();
        }
      }
      // ---------- Sprite binding ----------
      /** The bound `Sprite` asset. `null` until either `sprite` is set explicitly or a shortcut setter runs. */
      get sprite() {
        return this._sprite;
      }
      set sprite(value) {
        if (this._sprite === value) return;
        if (this._sprite) this._sprite.offChange(this._spriteListener);
        this._sprite = value;
        if (value) {
          value.onChange(this._spriteListener);
        }
        this._applySpriteToMaterial();
      }
      /**
       * Shortcut: bind a bare texture as the sprite. The first call creates a
       * private auto-managed `Sprite`; subsequent calls update its texture in
       * place without allocating a new Sprite.
       */
      setTexture(texture) {
        if (!this._autoSprite) {
          this._autoSprite = new Sprite({ texture });
        } else {
          this._autoSprite.texture = texture;
        }
        if (this._sprite !== this._autoSprite) this.sprite = this._autoSprite;
      }
      /** Shortcut: assign a `Sprite` from a texture (auto-managed private sprite). */
      set texture(tex) {
        this.setTexture(tex);
      }
      get texture() {
        return this._sprite?.texture ?? null;
      }
      /**
       * Anchor point in [0,1]². Stored as a per-renderer override; the bound
       * sprite asset stays untouched. Swapping `sprite` preserves this.
       */
      get pivot() {
        return this._pivotOverride ?? this._sprite?.pivot ?? new Vector2(0.5, 0.5);
      }
      set pivot(value) {
        if (!this._pivotOverride) this._pivotOverride = new Vector2();
        this._pivotOverride.set(value.x, value.y);
        this._applyPivotToMaterial();
      }
      /**
       * UV sub-region as normalized `(offsetX, offsetY, scaleX, scaleY)`.
       * Stored as a per-renderer override.
       */
      get uvRect() {
        return this._uvRectOverride ?? this._sprite?.region ?? new Vector4(0, 0, 1, 1);
      }
      set uvRect(value) {
        if (!this._uvRectOverride) this._uvRectOverride = new Vector4();
        this._uvRectOverride.set(value.x, value.y, value.z, value.w);
        this._applyUVRectToMaterial();
      }
      // ---------- Per-renderer overrides ----------
      /** Rendering color (multiplied with the sampled texel). */
      get color() {
        return this._spriteMaterial()?.color ?? this._pendingColor;
      }
      set color(value) {
        const mat = this._spriteMaterial();
        if (mat) mat.color = value;
        else this._pendingColor = value;
      }
      /** Render size in world units (meters). */
      get size() {
        return this._size;
      }
      set size(value) {
        this._size.set(value.x, value.y);
        this._applySize();
      }
      /**
       * When true, the quad's on-screen size stays constant regardless of
       * camera distance. Works by scaling local vertex position with the
       * camera-to-sprite distance in the vertex shader.
       */
      get distanceInvariantSize() {
        return this._distanceInvariantSize;
      }
      set distanceInvariantSize(value) {
        this._distanceInvariantSize = value;
        const mat = this._spriteMaterial();
        if (mat) mat.distanceInvariantSize = value;
      }
      /**
       * Rounded-corner radius in the same world units as `size`. 0 disables
       * the rounding. The quad edge fades to 0 alpha via a signed-distance
       * mask — useful for card-style labels / icons in world space.
       */
      get cornerRadius() {
        const mat = this._spriteMaterial();
        return mat ? mat.cornerRadius : this._pendingCornerRadius ?? 0;
      }
      set cornerRadius(value) {
        const mat = this._spriteMaterial();
        if (mat) mat.cornerRadius = value;
        else this._pendingCornerRadius = value;
      }
      // ---------- Material / visibility ----------
      get material() {
        return this._spriteMaterial();
      }
      set material(value) {
        this.materials = [value];
        this._applySpriteToMaterial();
        this._applyOverridesToMaterial();
      }
      /** Alias for `enable` — `visible = false` stops rendering without destroying the component. */
      get visible() {
        return this.enable;
      }
      set visible(value) {
        this.enable = value;
      }
      // ---------- Internal ----------
      _spriteMaterial() {
        return this._materials[0] ?? null;
      }
      _applySpriteToMaterial() {
        const mat = this._spriteMaterial();
        if (!mat || !this._sprite) return;
        const sprite = this._sprite;
        if (sprite.texture) {
          const isVideo = sprite.texture?.isVideoTexture === true;
          if (mat.useVideoTexture !== isVideo) mat.useVideoTexture = isVideo;
          mat.baseMap = sprite.texture;
        }
        this._applyUVRectToMaterial();
        this._applyPivotToMaterial();
        this._applySize();
      }
      _applyPivotToMaterial() {
        const mat = this._spriteMaterial();
        if (!mat) return;
        const p = this._pivotOverride ?? this._sprite?.pivot;
        if (!p) return;
        mat.pivot = new Vector2(p.x, p.y);
      }
      _applyUVRectToMaterial() {
        const mat = this._spriteMaterial();
        if (!mat) return;
        const r = this._uvRectOverride ?? this._sprite?.region;
        if (!r) return;
        mat.uvRect = new Vector4(r.x, r.y, r.z, r.w);
      }
      _applyOverridesToMaterial() {
        const mat = this._spriteMaterial();
        if (!mat) return;
        if (this._pendingColor) mat.color = this._pendingColor;
        if (this._pendingCornerRadius !== null) mat.cornerRadius = this._pendingCornerRadius;
        mat.distanceInvariantSize = this._distanceInvariantSize;
      }
      _applySize() {
        const mat = this._spriteMaterial();
        if (!mat) return;
        mat.size = new Vector2(this._size.x, this._size.y);
      }
      _onSpriteChange(_flags) {
        if (!this._spriteMaterial()) return;
        this._applySpriteToMaterial();
      }
      cloneTo(obj) {
        const renderer = obj.addComponent(exports.SpriteRenderer);
        renderer.copyComponent(this);
      }
      copyComponent(from) {
        super.copyComponent(from);
        if (from._sprite) this.sprite = from._sprite;
        if (from._pivotOverride) this.pivot = from._pivotOverride;
        if (from._uvRectOverride) this.uvRect = from._uvRectOverride;
        this.size = from._size;
        if (from.color) this.color = from.color.clone();
        this.cornerRadius = from.cornerRadius;
        this.distanceInvariantSize = from._distanceInvariantSize;
        return this;
      }
    };
    exports.SpriteRenderer = __decorateClass$6([
      RegisterComponent(exports.SpriteRenderer, "SpriteRenderer")
    ], exports.SpriteRenderer);

    class CapsuleColliderShape extends ColliderShape {
      /**
       * The radius of the local width of the collision body.
       */
      radius = 2.5;
      /**
       * The total height of the collision body.
       */
      height = 10;
      constructor() {
        super();
        this._shapeType = ColliderShapeType.Capsule;
      }
      // constructor(center: Vector3, radius: number, height: number) {
      //   super(center, new Vector3(radius, radius, radius));
      //   this.radius = radius;
      //   this.height = height;
      // }
    }

    var LineClassification = /* @__PURE__ */ ((LineClassification2) => {
      LineClassification2[LineClassification2["COLLINEAR"] = 0] = "COLLINEAR";
      LineClassification2[LineClassification2["LINES_INTERSECT"] = 1] = "LINES_INTERSECT";
      LineClassification2[LineClassification2["SEGMENTS_INTERSECT"] = 2] = "SEGMENTS_INTERSECT";
      LineClassification2[LineClassification2["A_BISECTS_B"] = 3] = "A_BISECTS_B";
      LineClassification2[LineClassification2["B_BISECTS_A"] = 4] = "B_BISECTS_A";
      LineClassification2[LineClassification2["PARALELL"] = 5] = "PARALELL";
      return LineClassification2;
    })(LineClassification || {});
    var PointClassification = /* @__PURE__ */ ((PointClassification2) => {
      PointClassification2[PointClassification2["ON_LINE"] = 0] = "ON_LINE";
      PointClassification2[PointClassification2["LEFT_SIDE"] = 1] = "LEFT_SIDE";
      PointClassification2[PointClassification2["RIGHT_SIDE"] = 2] = "RIGHT_SIDE";
      return PointClassification2;
    })(PointClassification || {});
    class Line {
      static cacluteLine0 = new Line(null, null);
      static cacluteLine1 = new Line(null, null);
      start;
      end;
      color = new Color(1, 1, 1, 1);
      _normal;
      _normalCalculated = false;
      constructor(start, end) {
        this.start = start;
        this.end = end;
      }
      set(start, end) {
        this.start = start;
        this.end = end;
      }
      getCenter() {
        let help = Vector3.HELP_0;
        Vector3.sub(this.start, this.end, help);
        help.multiplyScalar(0.5);
        help.add(this.end);
        return help;
      }
      inverse() {
        let tmp = this.start;
        this.start = this.end;
        this.end = tmp;
      }
      equals(l) {
        if (this.start == l.start && this.end == l.end || this.start == l.end && this.end == l.start) return true;
        return false;
      }
      /**
       */
      toArray() {
        return [this.start.x, this.start.y, this.start.z, this.end.x, this.end.y, this.end.z];
      }
      /**
       * @param ps
       */
      static getLines(ps) {
        let arr = [];
        for (let index = 0; index < ps.length; index++) {
          let i0 = index;
          let i1 = repeat(index + 1, ps.length);
          let p0 = ps[i0];
          let p1 = ps[i1];
          arr.push(new Line(p0, p1));
        }
        return arr;
      }
      /**
       * Determine the relationship between two straight lines
       * this line A = x0, y0 and B = x1, y1
       * other is A = x2, y2 and B = x3, y3
       * @param other compare other line
       * @param pIntersectPoint (out)Returns the intersection point of two line segments
       * @return
       */
      intersection(other, pIntersectPoint = null) {
        var denom = (other.end.z - other.start.z) * (this.end.x - this.start.x) - (other.end.x - other.start.x) * (this.end.z - this.start.z);
        var u0 = (other.end.x - other.start.x) * (this.start.z - other.start.z) - (other.end.z - other.start.z) * (this.start.x - other.start.x);
        var u1 = (other.start.x - this.start.x) * (this.end.z - this.start.z) - (other.start.z - this.start.z) * (this.end.x - this.start.x);
        if (denom == 0) {
          if (u0 == 0 && u1 == 0) return 0 /* COLLINEAR */;
          else return 5 /* PARALELL */;
        } else {
          u0 = u0 / denom;
          u1 = u1 / denom;
          var x = this.start.x + u0 * (this.end.x - this.start.x);
          var z = this.start.z + u0 * (this.end.z - this.start.z);
          if (pIntersectPoint != null) {
            pIntersectPoint.x = x;
            pIntersectPoint.y = 0;
            pIntersectPoint.z = z;
          }
          if (u0 >= 0 && u0 <= 1 && u1 >= 0 && u1 <= 1) {
            return 2 /* SEGMENTS_INTERSECT */;
          } else if (u1 >= 0 && u1 <= 1) {
            return 3 /* A_BISECTS_B */;
          } else if (u0 >= 0 && u0 <= 1) {
            return 4 /* B_BISECTS_A */;
          }
          return 1 /* LINES_INTERSECT */;
        }
      }
      /**
       * Straight direction
       * @return
       */
      getDirection() {
        var pt = this.end.clone().sub(this.start);
        var direction = new Vector3(pt.x, pt.y);
        return direction.normalize();
      }
      copy(line) {
        if (!this.start) this.start = new Vector3();
        if (!this.end) this.end = new Vector3();
        this.start.copy(line.start);
        this.end.copy(line.end);
      }
      static IsEqual(d1, d2) {
        if (Math.abs(d1 - d2) < 1e-7) return true;
        return false;
      }
      static squreDistanceSegmentToSegment(lineA, lineB, mat) {
        let a_po = lineA.start;
        let a_p1 = lineA.end;
        let b_po = lineB.start;
        let b_p1 = lineB.end;
        let x1 = a_po.x;
        let y1 = a_po.y;
        let z1 = a_po.z;
        let x2 = a_p1.x;
        let y2 = a_p1.y;
        let z2 = a_p1.z;
        let x3 = b_po.x;
        let y3 = b_po.y;
        let z3 = b_po.z;
        let x4 = b_p1.x;
        let y4 = b_p1.y;
        let z4 = b_p1.z;
        let ux = x2 - x1;
        let uy = y2 - y1;
        let uz = z2 - z1;
        let vx = x4 - x3;
        let vy = y4 - y3;
        let vz = z4 - z3;
        let wx = x1 - x3;
        let wy = y1 - y3;
        let wz = z1 - z3;
        let a = ux * ux + uy * uy + uz * uz;
        let b = ux * vx + uy * vy + uz * vz;
        let c = vx * vx + vy * vy + vz * vz;
        let d = ux * wx + uy * wy + uz * wz;
        let e = vx * wx + vy * wy + vz * wz;
        let dt = a * c - b * b;
        let sd = dt;
        let td = dt;
        let sn = 0;
        let tn = 0;
        if (this.IsEqual(dt, 0)) {
          sn = 0;
          sd = 1;
          tn = e;
          td = c;
        } else {
          sn = b * e - c * d;
          tn = a * e - b * d;
          if (sn < 0) {
            sn = 0;
            tn = e;
            td = c;
          } else if (sn > sd) {
            sn = sd;
            tn = e + b;
            td = c;
          }
        }
        if (tn < 0) {
          tn = 0;
          if (-d < 0)
            sn = 0;
          else if (-d > a)
            sn = sd;
          else {
            sn = -d;
            sd = a;
          }
        } else if (tn > td) {
          tn = td;
          if (-d + b < 0) sn = 0;
          else if (-d + b > a) sn = sd;
          else {
            sn = -d + b;
            sd = a;
          }
        }
        let sc = 0;
        let tc = 0;
        if (this.IsEqual(sn, 0)) sc = 0;
        else sc = sn / sd;
        if (this.IsEqual(tn, 0)) tc = 0;
        else tc = tn / td;
        let dx = wx + sc * ux - tc * vx;
        let dy = wy + sc * uy - tc * vy;
        let dz = wz + sc * uz - tc * vz;
        return dx * dx + dy * dy + dz * dz;
      }
      /**
       * isNearLine
       */
      isNear(ray, maxDistance = 0, mat) {
        let tmpP0 = Vector3.HELP_0;
        let tmpP1 = Vector3.HELP_1;
        tmpP0.copy(ray.origin);
        tmpP1.copy(ray.direction);
        tmpP1.multiplyScalar(9999);
        Vector3.add(tmpP1, tmpP0, tmpP1);
        Line.cacluteLine0.set(tmpP0, tmpP1);
        Line.cacluteLine1.copy(this);
        if (mat) {
          mat.perspectiveMultiplyPoint3(Line.cacluteLine1.start, Line.cacluteLine1.start);
          mat.perspectiveMultiplyPoint3(Line.cacluteLine1.end, Line.cacluteLine1.end);
        }
        let dis = Line.squreDistanceSegmentToSegment(Line.cacluteLine0, Line.cacluteLine1, mat);
        if (dis + 1e-4 <= maxDistance) {
          ray.length = dis;
          return true;
        }
        ray.length = -999999;
        return false;
      }
    }

    class Triangle {
      static ID = -1;
      v1;
      v2;
      v3;
      u1;
      u2;
      u3;
      n1;
      n2;
      n3;
      t0;
      t;
      u;
      v;
      min = new Vector3();
      max = new Vector3();
      id = 0;
      constructor(v1, v2, v3) {
        this.id = Triangle.ID++ + 200;
        v1 && v2 && v3 && this.set(v1, v2, v3);
      }
      set(v1, v2, v3) {
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
        let min = this.min;
        let max = this.max;
        min.x = Math.min(this.v1.x, this.v2.x, this.v3.x);
        min.y = Math.min(this.v1.y, this.v2.y, this.v3.y);
        min.z = Math.min(this.v1.z, this.v2.z, this.v3.z);
        max.x = Math.max(this.v1.x, this.v2.x, this.v3.x);
        max.y = Math.max(this.v1.y, this.v2.y, this.v3.y);
        max.z = Math.max(this.v1.z, this.v2.z, this.v3.z);
        return this;
      }
      getNormal() {
        let v1 = this.v1;
        let v2 = this.v2;
        let v3 = this.v3;
        let edge1 = new Vector3(v2.x - v1.x, v2.y - v1.y, v2.z - v1.z);
        let edge2 = new Vector3(v3.x - v1.x, v3.y - v1.y, v3.z - v1.z);
        let normal = edge2.cross(edge1);
        normal.normalize();
        return normal;
      }
      turnBack() {
        let tmp = this.v3;
        this.v3 = this.v1;
        this.v1 = tmp;
      }
      getLines() {
        let v1 = this.v1;
        let v2 = this.v2;
        let v3 = this.v3;
        let l = [new Line(v1, v2), new Line(v2, v3), new Line(v3, v1)];
        return l;
      }
      equals(t) {
        let lines1 = this.getLines();
        let lines2 = t.getLines();
        let cnt = 0;
        for (let i = 0; i < lines1.length; i++) {
          for (let j = 0; j < lines2.length; j++) {
            if (lines1[i].equals(lines2[j])) cnt++;
          }
        }
        if (cnt == 3) return true;
        else return false;
      }
      /**
       * name
       */
      getCenter() {
        let min = this.min;
        let max = this.max;
        let center = new Vector3();
        center.x = (min.x + max.x) * 0.5;
        center.y = (min.y + max.y) * 0.5;
        center.z = (min.z + max.z) * 0.5;
        return center;
      }
      /**
       * @function
       * @returns {Boolean} return intersection.
       */
      intersects(other) {
        var aMax = this.max;
        var aMin = this.min;
        var bMax = other.max;
        var bMin = other.min;
        return aMin.x <= bMax.x && aMax.x >= bMin.x && aMin.y <= bMax.y && aMax.y >= bMin.y && aMin.z <= bMax.z && aMax.z >= bMin.z;
      }
      sign2D(p1, p2, p3) {
        return (p1.x - p3.x) * (p2.z - p3.z) - (p2.x - p3.x) * (p1.z - p3.z);
      }
      pointInTriangle2D(pt) {
        let v1 = this.v1;
        let v2 = this.v2;
        let v3 = this.v3;
        let d1, d2, d3;
        let has_neg, has_pos;
        d1 = this.sign2D(pt, v1, v2);
        d2 = this.sign2D(pt, v2, v3);
        d3 = this.sign2D(pt, v3, v1);
        has_neg = d1 < 0 || d2 < 0 || d3 < 0;
        has_pos = d1 > 0 || d2 > 0 || d3 > 0;
        return !(has_neg && has_pos);
      }
      toArray() {
        return [this.v1.x, this.v1.y, this.v1.z, this.v2.x, this.v2.y, this.v2.z, this.v3.x, this.v3.y, this.v3.z];
      }
    }

    class MeshColliderShape extends ColliderShape {
      /**
       * meshComponent
       */
      mesh;
      static triangle;
      _pickRet;
      constructor() {
        super();
        this._shapeType = ColliderShapeType.Mesh;
      }
      rayPick(ray, fromMatrix) {
        if (this.mesh) {
          MeshColliderShape.triangle ||= new Triangle(new Vector3(), new Vector3(), new Vector3());
          let positionAttribute = this.mesh.getAttribute(VertexAttributeName.position);
          let indexAttribute = this.mesh.getAttribute(VertexAttributeName.indices);
          let helpMatrix = ColliderShape.helpMatrix;
          helpMatrix.copy(fromMatrix).invert();
          let helpRay = ColliderShape.helpRay.copy(ray);
          helpRay.applyMatrix(helpMatrix);
          helpRay.intersectBox(this.mesh.bounds);
          let pick = helpRay.intersectBox(this.mesh.bounds, ColliderShape.v3_help_0);
          if (!pick) {
            return null;
          }
          if (indexAttribute && positionAttribute && indexAttribute.data.length > 0) {
            let vertexData = positionAttribute.data;
            for (let i = 0, c = indexAttribute.data.length / 3; i < c; i++) {
              let offsetIndex = i * 3;
              const i1 = indexAttribute.data[offsetIndex + 0] * 3;
              const i2 = indexAttribute.data[offsetIndex + 1] * 3;
              const i3 = indexAttribute.data[offsetIndex + 2] * 3;
              let triangle = MeshColliderShape.triangle;
              let p1 = triangle.v1.set(vertexData[i1 + 0], vertexData[i1 + 1], vertexData[i1 + 2]);
              let p2 = triangle.v2.set(vertexData[i2 + 0], vertexData[i2 + 1], vertexData[i2 + 2]);
              let p3 = triangle.v3.set(vertexData[i3 + 0], vertexData[i3 + 1], vertexData[i3 + 2]);
              triangle.set(p1, p2, p3);
              let pick2 = helpRay.intersectTriangle(helpRay.origin, helpRay.direction, triangle);
              if (pick2) {
                this._pickRet ||= { intersectPoint: new Vector3(), distance: 0 };
                this._pickRet.intersectPoint = pick2;
                this._pickRet.distance = Vector3.distance(helpRay.origin, pick2);
                let normalAttribute = this.mesh.getAttribute(VertexAttributeName.normal);
                if (normalAttribute) {
                  let normalData = normalAttribute.data;
                  let normal = new Vector3(normalData[i1], normalData[i1 + 1], normalData[i1 + 2]);
                  Matrix4.transformVector(fromMatrix, normal, normal);
                  normal.normalize();
                  this._pickRet.normal = normal;
                }
                return this._pickRet;
              }
            }
          }
        }
        return null;
      }
    }

    class SphereColliderShape extends ColliderShape {
      _pickRet;
      box;
      /**
       * radius of this collider
       */
      radius = 0.5;
      /**
       * @constructor
       * @param radius radius of this collider
       */
      constructor(radius) {
        super();
        this._shapeType = ColliderShapeType.Sphere;
        this.radius = radius;
        this.box = new BoundingSphere(new Vector3(), 1);
      }
      rayPick(ray, fromMatrix) {
        let box = this.box;
        box.setFromCenterAndSize(this.center, this.radius);
        let helpMatrix = ColliderShape.helpMatrix;
        helpMatrix.copy(fromMatrix).invert();
        let helpRay = ColliderShape.helpRay.copy(ray);
        helpRay.applyMatrix(helpMatrix);
        let pick = helpRay.intersectSphere(helpRay.origin, helpRay.direction, this.box.center, this.box.radius);
        if (pick) {
          if (!this._pickRet) {
            this._pickRet = { intersect: false, intersectPoint: new Vector3(), distance: 0 };
          }
          this._pickRet.intersect = true;
          this._pickRet.intersectPoint = pick;
          this._pickRet.distance = Vector3.distance(helpRay.origin, ColliderShape.v3_help_0);
          return this._pickRet;
        }
        return null;
      }
    }

    class Scene3D extends exports.Object3D {
      _envMap;
      skyObject;
      envMapChange = true;
      view;
      /**
       *
       * @constructor
       */
      constructor() {
        super();
        this.transform.scene3D = this;
        this.skyObject = new exports.Object3D();
        this.addChild(this.skyObject);
        this._isScene3D = true;
      }
      /**
       *
       * get environment texture. Lazily falls back to the default sky of the
       * engine this scene is attached to, so construction doesn't force a
       * device binding before the scene is assigned to a View3D.
       */
      get envMap() {
        if (!this._envMap) {
          const ctx = this.view?.engine3D?.context3D;
          if (ctx) this._envMap = Engine3D.resFor(ctx).defaultSky;
        }
        return this._envMap;
      }
      /**
       * set environment texture
       */
      set envMap(value) {
        if (this._envMap != value) {
          this.envMapChange = true;
        }
        this._envMap = value;
        const sky = EntityCollect.instance.getSky(this);
        if (sky && `map` in sky)
          sky.map = value;
      }
      /**
       * Exposure of Sky Box. A larger value produces a sky box with stronger exposure and a brighter appearance.
       *  A smaller value produces a sky box with weaker exposure and a darker appearance.
       */
      get exposure() {
        const sky = EntityCollect.instance.getSky(this);
        if (sky && `exposure` in sky)
          return sky.exposure;
        return 0;
      }
      /**
       * Set the exposure of the Sky Box.
       */
      set exposure(value) {
        const sky = EntityCollect.instance.getSky(this);
        if (sky && `exposure` in sky) {
          sky.exposure = value;
          const setting = this.view?.engine3D?.setting;
          if (setting) setting.sky.skyExposure = value;
        }
      }
      /**
       * Get the roughness of the Sky Box.
       */
      get roughness() {
        const sky = EntityCollect.instance.getSky(this);
        if (sky && `roughness` in sky) {
          return sky.roughness;
        }
      }
      /**
       * Set the roughness of the Sky Box.
       */
      set roughness(value) {
        const sky = EntityCollect.instance.getSky(this);
        if (sky && `roughness` in sky) {
          sky.roughness = value;
        }
      }
    }

    class PickCompute {
      _computeShader;
      _outBuffer;
      constructor() {
      }
      init(view) {
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, view.engine3D.context3D);
        this._computeShader = new ComputeShader(Picker_cs);
        this._computeShader.setDefine(`USE_LOGDEPTH`, !!view.engine3D.setting.render.useLogDepth);
        this._outBuffer = new ComputeGPUBuffer(32);
        this._computeShader.setStorageBuffer("outBuffer", this._outBuffer);
        this._computeShader.setSamplerTexture("gBufferTexture", rtFrame.getCompressGBufferTexture());
      }
      compute(view) {
        let stand = GlobalBindGroup.getCameraGroup(view.camera);
        this._computeShader.setStorageBuffer("globalUniform", stand.uniformGPUBuffer);
        const gpu = view.engine3D.context3D.gpuContext;
        let command = gpu.beginCommandEncoder();
        gpu.computeCommand(command, [this._computeShader]);
        gpu.endCommandEncoder(command);
        this._outBuffer.readBuffer();
      }
      /**
       * Returns matrix id belongs to this model
       * @returns
       */
      getPickMeshID() {
        var meshID = this._outBuffer.outFloat32Array[0] + 0.1;
        return Math.floor(meshID);
      }
      /**
       * Returns world position of pick result
       * @returns
       */
      getPickWorldPosition(target) {
        target ||= new Vector3();
        var x = this._outBuffer.outFloat32Array[4];
        var y = this._outBuffer.outFloat32Array[5];
        var z = this._outBuffer.outFloat32Array[6];
        target.set(x, y, z);
        if (Camera3D.mainCamera._boundCtx?.engine?.setting.useRTE) {
          Vector3.add(target, Camera3D.mainCamera.transform.worldPosition, target);
        }
        return target;
      }
      /**
       * Returns world position of pick result
       * @returns
       */
      getPickWorldNormal(target) {
        target ||= new Vector3();
        var x = this._outBuffer.outFloat32Array[8];
        var y = this._outBuffer.outFloat32Array[9];
        var z = this._outBuffer.outFloat32Array[10];
        target.set(x, y, z).normalize();
        return target;
      }
      /**
       * Returns screen coord of mouse
       * @returns
       */
      getPickScreenUV(target) {
        target ||= new Vector2();
        var x = this._outBuffer.outFloat32Array[2];
        var y = this._outBuffer.outFloat32Array[3];
        target.set(x, y);
        return target;
      }
    }

    class PickFire extends CEventDispatcher {
      /**
       * The ray used to pick 3D objects
       */
      ray;
      /**
       * whether it's touching
       */
      isTouching = false;
      _mouseCode;
      _pickEvent;
      _outEvent;
      _overEvent;
      _upEvent;
      _downEvent;
      _mouseMove;
      _pickCompute;
      //Recently Objects, picked by mousedown
      _lastDownTarget;
      /**
       * a map records the association information between meshID(matrix id) and ColliderComponent
       */
      mouseEnableMap;
      _view;
      constructor(view) {
        super();
        this._view = view;
        this.init();
      }
      /**
       * Initialize the pickup initiator and call it internally during engine initialization
       */
      init() {
        this.ray = new Ray();
        this.mouseEnableMap = /* @__PURE__ */ new Map();
        this._pickEvent = new PointerEvent3D(PointerEvent3D.PICK_CLICK);
        this._outEvent = new PointerEvent3D(PointerEvent3D.PICK_OUT);
        this._overEvent = new PointerEvent3D(PointerEvent3D.PICK_OVER);
        this._mouseMove = new PointerEvent3D(PointerEvent3D.PICK_MOVE);
        this._upEvent = new PointerEvent3D(PointerEvent3D.PICK_UP);
        this._downEvent = new PointerEvent3D(PointerEvent3D.PICK_DOWN);
      }
      _inputSystem() {
        const owner = this._view?.engine3D;
        return owner?.inputSystem;
      }
      /**
      * start this manager
      */
      start() {
        const input = this._inputSystem();
        if (!input) return;
        const pick = this._view.engine3D.setting.pick;
        if (pick.enable) {
          input.addEventListener(PointerEvent3D.POINTER_DOWN, this.onTouchStart, this);
          input.addEventListener(PointerEvent3D.POINTER_UP, this.onTouchEnd, this);
          input.addEventListener(PointerEvent3D.POINTER_CLICK, this.onTouchOnce, this);
          input.addEventListener(PointerEvent3D.POINTER_RIGHT_CLICK, this.onTouchOnce, this);
          input.addEventListener(PointerEvent3D.POINTER_MOVE, this.onTouchMove, this);
        }
        if (pick.mode == `pixel`) {
          this._pickCompute = new PickCompute();
          this._pickCompute.init(this._view);
        }
      }
      /**
       * stop this manager
       */
      stop() {
        const input = this._inputSystem();
        if (!input) return;
        input.removeEventListener(PointerEvent3D.POINTER_DOWN, this.onTouchStart, this);
        input.removeEventListener(PointerEvent3D.POINTER_UP, this.onTouchEnd, this);
        input.removeEventListener(PointerEvent3D.POINTER_CLICK, this.onTouchOnce, this);
        input.removeEventListener(PointerEvent3D.POINTER_RIGHT_CLICK, this.onTouchOnce, this);
        input.removeEventListener(PointerEvent3D.POINTER_MOVE, this.onTouchMove, this);
      }
      onTouchStart(e) {
        this.isTouching = true;
        this._mouseCode = e.mouseCode;
        this.pick(this._view.camera);
        let target = this.findNearestObj(this._interestList, this._view.camera);
        this._lastDownTarget = target;
        if (target) {
          Object.assign(this._downEvent, e);
          this._downEvent.type = PointerEvent3D.PICK_DOWN;
          this._downEvent.target = target.object3D;
          this._downEvent.data = this.getPickInfo();
          this.dispatchEvent(this._downEvent);
          if (target.object3D.containEventListener(PointerEvent3D.PICK_DOWN)) {
            target.object3D.dispatchEvent(this._downEvent);
          }
        }
      }
      onTouchEnd(e) {
        this.isTouching = false;
        this._mouseCode = e.mouseCode;
        this.pick(this._view.camera);
        let target = this.findNearestObj(this._interestList, this._view.camera);
        if (target) {
          Object.assign(this._upEvent, e);
          this._upEvent.type = PointerEvent3D.PICK_UP;
          this._upEvent.target = target.object3D;
          this._upEvent.data = this.getPickInfo();
          this.dispatchEvent(this._upEvent);
          if (target.object3D.containEventListener(PointerEvent3D.PICK_UP)) {
            target.object3D.dispatchEvent(this._upEvent);
          }
        }
      }
      _lastFocus;
      getPickInfo() {
        if (this._view.engine3D.setting.pick.mode == `pixel`) {
          return {
            worldPos: this._pickCompute.getPickWorldPosition(),
            worldNormal: this._pickCompute.getPickWorldNormal(),
            screenUv: this._pickCompute.getPickScreenUV(),
            meshID: this._pickCompute.getPickMeshID()
          };
        } else {
          let intersection = this._interestList[0];
          if (intersection) {
            return {
              worldPos: intersection.intersectPoint,
              worldNormal: intersection.normal,
              meshID: intersection.collider.transform.worldMatrix.index,
              distance: intersection.distance
            };
          }
          return {
            worldPos: Vector3.ZERO,
            worldNormal: Vector3.ZERO,
            meshID: -1,
            distance: 0
          };
        }
      }
      onTouchMove(e) {
        this.isTouching = true;
        this._mouseCode = e.mouseCode;
        this.pick(this._view.camera);
        let target = this.findNearestObj(this._interestList, this._view.camera);
        if (target) {
          Object.assign(this._mouseMove, e);
          this._mouseMove.type = PointerEvent3D.PICK_MOVE;
          this._mouseMove.target = target.object3D;
          this._mouseMove.data = this.getPickInfo();
          this.dispatchEvent(this._mouseMove);
          if (target.object3D.containEventListener(PointerEvent3D.PICK_MOVE)) {
            target.object3D.dispatchEvent(this._mouseMove);
          }
        }
        if (target != this._lastFocus) {
          if (this._lastFocus && this._lastFocus.object3D) {
            Object.assign(this._outEvent, e);
            this._outEvent.type = PointerEvent3D.PICK_OUT;
            this._outEvent.target = this._lastFocus.object3D;
            this._outEvent.data = this.getPickInfo();
            this.dispatchEvent(this._outEvent);
            if (this._lastFocus.object3D.containEventListener(PointerEvent3D.PICK_OUT)) {
              this._lastFocus.object3D.dispatchEvent(this._outEvent);
            }
          }
          if (target) {
            Object.assign(this._overEvent, e);
            this._overEvent.type = PointerEvent3D.PICK_OVER;
            this._overEvent.target = target.object3D;
            this._overEvent.data = this.getPickInfo();
            this.dispatchEvent(this._overEvent);
            if (target.object3D.containEventListener(PointerEvent3D.PICK_OVER)) {
              target.object3D.dispatchEvent(this._overEvent);
            }
          }
        }
        this._lastFocus = target;
      }
      onTouchOnce(e) {
        this.isTouching = true;
        this._mouseCode = e.mouseCode;
        this.pick(this._view.camera);
        let target = this.findNearestObj(this._interestList, this._view.camera);
        if (target) {
          let info = this.getPickInfo();
          Object.assign(this._pickEvent, e);
          this._pickEvent.type = PointerEvent3D.PICK_CLICK;
          this._pickEvent.target = target.object3D;
          this._pickEvent.data = info;
          this.dispatchEvent(this._pickEvent);
          if (target === this._lastDownTarget && target.object3D.containEventListener(PointerEvent3D.PICK_CLICK)) {
            target.object3D.dispatchEvent(this._pickEvent);
          }
        }
        this._lastDownTarget = null;
      }
      findNearestObj(list, camera) {
        list.sort((a, b) => {
          return a.distance > b.distance ? 1 : -1;
        });
        return list[0]?.collider;
      }
      _interestList = [];
      pick(camera) {
        this._interestList.length = 0;
        const mode = this._view.engine3D.setting.pick.mode;
        if (mode == `pixel`) {
          this._pickCompute.compute(this._view);
          let meshID = this._pickCompute.getPickMeshID();
          let iterator = this.mouseEnableMap.get(meshID);
          if (iterator) {
            let position = this._pickCompute.getPickWorldPosition();
            let distance = Vector3.distance(position, this.ray.origin);
            this._interestList.push({ distance, collider: iterator, intersectPoint: position });
          }
        } else if (mode == `bound`) {
          const input = this._inputSystem();
          this.ray = camera.screenPointToRay(input.mouseX, input.mouseY);
          let intersect;
          let colliders = ComponentCollect.componentsEnablePickerList.get(this._view);
          if (colliders) {
            for (const item of colliders) {
              let collider = item[0];
              if (collider.enable) {
                intersect = collider.rayPick(this.ray);
                if (intersect) {
                  intersect.collider = collider;
                  this._interestList.push(intersect);
                }
              }
            }
          }
        }
      }
    }

    class View3D extends CEventListener {
      _camera;
      _scene;
      _viewPort;
      _enablePick = false;
      _enable = true;
      pickFire;
      /**
       * Reference to the Engine3D instance that owns this view. Set by
       * `engine.startRenderView(view)`. Components that need per-instance state
       * (input system, context, etc.) read it via this back-pointer so
       * they work under multi-instance setups.
       */
      engine3D;
      constructor(x = 0, y = 0, width = 0, height = 0) {
        super();
        this._viewPort = new Vector4(x, y, width, height);
      }
      get enable() {
        return this._enable;
      }
      set enable(value) {
        this._enable = value;
      }
      get enablePick() {
        return this._enablePick;
      }
      set enablePick(value) {
        if (this._enablePick != value) {
          this.pickFire = new PickFire(this);
          this.pickFire.start();
        }
        this._enablePick = value;
      }
      get scene() {
        return this._scene;
      }
      set scene(value) {
        this._scene = value;
        value.view = this;
        ShadowLightsCollect.createBuffer(this);
      }
      get camera() {
        return this._camera;
      }
      set camera(value) {
        this._camera = value;
      }
      get viewPort() {
        return this._viewPort;
      }
      set viewPort(value) {
        this._viewPort = value;
      }
      /** Frame Graph bound to this view's engine. The view's render
       *  job owns it (constructed during `engine.startRenderView`).
       *  Returns null only when the engine has not yet started a
       *  render job for this view. */
      get renderGraph() {
        return this.engine3D?.getRenderJob(this)?.graph ?? null;
      }
    }

    class FrustumSection {
      corners;
      index;
      constructor(index) {
        this.index = index;
        this.corners = [];
        for (let i = 0; i < 4; i++) {
          this.corners.push(new Vector3());
        }
      }
    }
    class FrustumChild {
      bound;
      twoSections;
      name;
      color;
      shadowCamera;
      index;
      constructor(near, far, index) {
        this.bound = new BoundingBox();
        this.shadowCamera = CameraUtil.createCamera3DObject(null, "csmShadowCamera_" + index);
        this.shadowCamera.isShadowCamera = true;
        this.shadowCamera.orthoOffCenter(100, -100, 100, -100, 1, 1e4);
        this.twoSections = [near, far];
        this.index = index;
        if (index == 0) {
          this.color = new Color(1, 0, 0, 1);
        } else if (index == 1) {
          this.color = new Color(0, 1, 0, 1);
        } else if (index == 2) {
          this.color = new Color(0, 0, 1, 1);
        } else if (index == 3) {
          this.color = new Color(0, 1, 1, 1);
        }
        this.name = "child_" + index;
      }
      updateBound() {
        this.bound.makeEmpty();
        let min = this.bound.min;
        let max = this.bound.max;
        for (let section of this.twoSections) {
          for (let pt of section.corners) {
            min.x = Math.min(pt.x, min.x);
            min.y = Math.min(pt.y, min.y);
            min.z = Math.min(pt.z, min.z);
            max.x = Math.max(pt.x, max.x);
            max.y = Math.max(pt.y, max.y);
            max.z = Math.max(pt.z, max.z);
          }
        }
        this.bound.setFromMinMax(min, max);
        return this;
      }
      /**
       * Flat accessor for the 8 world-space corners of this cascade frustum
       * (4 near + 4 far). Used by CSM stabilize (sphere-fit + texel-snap) to
       * get a rotation-invariant bounding sphere without re-walking twoSections
       * on the caller side.
       */
      getWorldCorners() {
        return [
          this.twoSections[0].corners[0],
          this.twoSections[0].corners[1],
          this.twoSections[0].corners[2],
          this.twoSections[0].corners[3],
          this.twoSections[1].corners[0],
          this.twoSections[1].corners[1],
          this.twoSections[1].corners[2],
          this.twoSections[1].corners[3]
        ];
      }
    }
    class FrustumCSM {
      sections;
      children;
      name;
      constructor(blockCount) {
        this.sections = [];
        let sectionCount = blockCount + 1;
        for (let i = 0; i < sectionCount; i++) {
          this.sections.push(new FrustumSection(i));
        }
        this.children = [];
        for (let i = 0; i < blockCount; i++) {
          this.children.push(new FrustumChild(this.sections[i], this.sections[i + 1], i));
        }
      }
      update(p, pvInv, near, far, shadowSetting, splitFunction = void 0) {
        let blockCount = this.sections.length - 1;
        for (let z = 0; z <= blockCount; ++z) {
          let section = this.sections[z];
          let worldZ = 0;
          let cornerIndex = 0;
          if (splitFunction) {
            worldZ = splitFunction(near, far, z, this.sections.length);
          } else {
            worldZ = FrustumCSM.logSplit(near, far, z, this.sections.length);
            {
              let scale = (worldZ - near) / far;
              scale = scale ** shadowSetting.csmScatteringExp;
              worldZ = (far - near) * scale + near;
            }
            worldZ *= shadowSetting.csmAreaScale;
          }
          let depth = (p.rawData[10] * worldZ + p.rawData[14]) / worldZ;
          for (let x = 0; x < 2; ++x) {
            for (let y = 0; y < 2; ++y) {
              let pt = section.corners[cornerIndex];
              cornerIndex++;
              pt.set(2 * x - 1, 2 * y - 1, depth, 1);
              Matrix4.transformVector4(pvInv, pt, pt);
              pt.multiplyScalar(1 / pt.w);
            }
          }
        }
        for (let miniFrustum of this.children) {
          miniFrustum.updateBound();
        }
        return this;
      }
      static squareSplit(near, far, index, max) {
        let ratio = index / (max - 1);
        return ratio ** 4 * (far - near) + near;
      }
      static uniformSplit(near, far, index, max) {
        let ratio = index / (max - 1);
        return ratio * (far - near) + near;
      }
      static logSplit(near, far, index, max) {
        let ratio = near * (far / near) ** (index / (max - 1));
        return ratio;
      }
    }

    class Section {
      normal;
      fixNormal;
      center;
      rotateShape;
      distance = 0;
      index;
      constructor(i) {
        this.index = i;
        this.rotateShape = [];
      }
    }
    class ExtrudeGeometry extends GeometryBase {
      vScale;
      uNegate;
      sections;
      /**
       * for the points of start and end:
       * Please ensure that you do not actively clone the starting point to the end of the shape array;
       * closed: true.
       *       if you want them closed, it'll auto clone start point.
       * closed: false.
       *  
       * @param shaderReflection ShaderReflection
       */
      build(shape, isShapeClosed, path, vScale = 1, uNegate = true) {
        if (path.length < 2) {
          throw new Error("path length is not enough");
        }
        this.vScale = vScale;
        this.uNegate = uNegate;
        shape = shape.slice();
        isShapeClosed && shape.push(shape[0]);
        this.sections = this.buildSections(shape, path);
        this.buildGeometry(shape, this.sections);
        this.bounds = new BoundingBox(Vector3.ZERO.clone(), new Vector3(100, 100, 100));
        return this;
      }
      buildSections(shape, path) {
        let curPoint;
        let nextPoint;
        let normal;
        let sections = [];
        let sectionCount = path.length;
        for (let i = 0; i < sectionCount; i++) {
          let section = new Section(i);
          curPoint = path[i];
          nextPoint = path[i + 1];
          section.center = curPoint.clone();
          if (nextPoint == null) {
            section.normal = normal.clone();
            section.distance = 0;
          } else {
            normal = nextPoint.clone().sub(curPoint);
            section.distance = normal.length;
            section.normal = normal.normalize();
          }
          sections.push(section);
        }
        sections[0].fixNormal = sections[0].normal.clone();
        for (let i = 1; i < sectionCount; i++) {
          let lastSection = sections[i - 1];
          let curSection = sections[i];
          curSection.fixNormal = curSection.normal.clone().add(lastSection.normal).normalize();
        }
        let matrixRotate = new Matrix4().identity();
        for (let i = 0; i < sectionCount; i++) {
          let curSection = sections[i];
          let fromDirection;
          let sourceShape;
          if (i == 0) {
            fromDirection = Vector3.UP;
            sourceShape = shape;
          } else {
            let lastSection = sections[i - 1];
            fromDirection = lastSection.fixNormal;
            sourceShape = lastSection.rotateShape;
          }
          Matrix4.fromToRotation(fromDirection, curSection.fixNormal, matrixRotate);
          for (let i2 = 0, count = shape.length; i2 < count; i2++) {
            let newPoint = matrixRotate.multiplyPoint3(sourceShape[i2].clone());
            curSection.rotateShape.push(newPoint);
          }
        }
        return sections;
      }
      buildGeometry(shape, sections) {
        let sectionCount = sections.length;
        let shapeVertexCount = shape.length;
        let totalVertexCount = sectionCount * shapeVertexCount;
        let segmentCount = sectionCount - 1;
        let position_arr = new Float32Array(totalVertexCount * 3);
        let normal_arr = new Float32Array(totalVertexCount * 3);
        let uv_arr = new Float32Array(totalVertexCount * 2);
        let indices_arr = new Uint32Array(segmentCount * (shapeVertexCount - 1) * 6);
        let quadCount = shapeVertexCount - 1;
        let vDistance = 0;
        let uDistance = 0;
        let uList = [0];
        for (let i = 1; i < shapeVertexCount; i++) {
          uDistance += shape[i - 1].clone().sub(shape[i]).length;
          uList.push(uDistance);
        }
        for (let i = 0; i < sectionCount; i++) {
          let section = sections[i];
          for (let j = 0; j < shapeVertexCount; j++) {
            let pos_offset = (i * shapeVertexCount + j) * 3;
            let vertex = section.rotateShape[j].clone().add(section.center);
            position_arr[pos_offset] = vertex.x;
            position_arr[pos_offset + 1] = vertex.y;
            position_arr[pos_offset + 2] = vertex.z;
            normal_arr[pos_offset + 1] = 1;
            let uv_offset = (i * shapeVertexCount + j) * 2;
            let u = uList[j] / uDistance;
            uv_arr[uv_offset] = this.uNegate ? 1 - u : u;
            uv_arr[uv_offset + 1] = vDistance * this.vScale;
          }
          vDistance += section.distance;
        }
        let index = 0;
        for (let i = 0; i < segmentCount; i++) {
          let vertexOffset = i * shapeVertexCount;
          for (let j = 0; j < quadCount; j++) {
            let vertex_rb = j;
            let vertex_lb = j + 1;
            let vertex_rt = vertex_rb + shapeVertexCount;
            let vertex_lt = vertex_lb + shapeVertexCount;
            indices_arr[index++] = vertex_rb + vertexOffset;
            indices_arr[index++] = vertex_lb + vertexOffset;
            indices_arr[index++] = vertex_rt + vertexOffset;
            indices_arr[index++] = vertex_lb + vertexOffset;
            indices_arr[index++] = vertex_lt + vertexOffset;
            indices_arr[index++] = vertex_rt + vertexOffset;
          }
        }
        this.setIndices(indices_arr);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indices_arr.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
        this.computeNormals();
        return this;
      }
    }

    class VertexBufferLayout {
      name;
      offset;
      size;
      arrayStride;
      stepMode;
      attributes;
    }
    class VertexAttribute {
      name;
      format;
      offset;
      shaderLocation;
      stride;
    }

    var VertexAttributeStride = /* @__PURE__ */ ((VertexAttributeStride2) => {
      VertexAttributeStride2[VertexAttributeStride2["position"] = 3] = "position";
      VertexAttributeStride2[VertexAttributeStride2["normal"] = 3] = "normal";
      VertexAttributeStride2[VertexAttributeStride2["TANGENT"] = 4] = "TANGENT";
      VertexAttributeStride2[VertexAttributeStride2["uv"] = 2] = "uv";
      VertexAttributeStride2[VertexAttributeStride2["TEXCOORD_1"] = 2] = "TEXCOORD_1";
      VertexAttributeStride2[VertexAttributeStride2["color"] = 4] = "color";
      VertexAttributeStride2[VertexAttributeStride2["joints0"] = 4] = "joints0";
      VertexAttributeStride2[VertexAttributeStride2["weights0"] = 4] = "weights0";
      VertexAttributeStride2[VertexAttributeStride2["joints1"] = 4] = "joints1";
      VertexAttributeStride2[VertexAttributeStride2["weights1"] = 4] = "weights1";
      VertexAttributeStride2[VertexAttributeStride2["vIndex"] = 1] = "vIndex";
      VertexAttributeStride2[VertexAttributeStride2["weight"] = 1] = "weight";
      VertexAttributeStride2[VertexAttributeStride2["a_morphPositions_0"] = 3] = "a_morphPositions_0";
      return VertexAttributeStride2;
    })(VertexAttributeStride || {});

    class PoolNode {
      _use;
      _unUse;
      constructor() {
        this._use = [];
        this._unUse = [];
      }
      /**
       * Return a used instance to the free list so it can be reused.
       * @param node the instance to recycle
       */
      pushBack(node) {
        let index = this._use.indexOf(node);
        if (index != -1) {
          this._use.splice(index, 1);
          this._unUse.push(node);
        }
      }
      /**
       * Get the list of currently in-use instances.
       */
      getUseList() {
        return this._use;
      }
      /**
       * Get a free instance from the pool, creating a new one if none are available.
       * @param instance constructor used to create a new instance when the pool is empty
       * @param param optional constructor argument
       */
      getOne(instance, param) {
        let node;
        if (this._unUse.length > 0) {
          node = this._unUse[0];
          this._unUse.splice(0, 1);
          this._use.push(node);
          return node;
        } else {
          node = new instance(param);
          this._use.push(node);
        }
        return node;
      }
      /**
       * Whether the pool has any free instance available for reuse.
       */
      hasFree() {
        return this._unUse.length > 0;
      }
    }

    class MatrixDO {
      constructor() {
      }
    }

    class IKDTreeUserData {
      get data() {
        return null;
      }
      entity;
    }

    class KDTreeRange {
      min = 0;
      max = 0;
      set(min, max) {
        this.max = max;
        this.min = min;
        return this;
      }
      copy(src) {
        this.max = src.max;
        this.min = src.min;
        return this;
      }
      isInterestRange(src) {
        let fail = this.max > src.min || src.max < this.min;
        return !fail;
      }
    }
    class KDTreeSpace {
      _spaceDesc;
      getRange(dimension) {
        return this._spaceDesc[dimension];
      }
      initSpace(dimensions) {
        this._spaceDesc = {};
        for (let dimension of dimensions) {
          let range = this._spaceDesc[dimension] = new KDTreeRange();
          range.set(-Number.MAX_VALUE, Number.MAX_VALUE);
        }
        return this;
      }
      isContain(dimension, value) {
        let range = this._spaceDesc[dimension];
        return value >= range.min && value < range.max;
      }
      isInterestRange(dimension, range1) {
        let range2 = this._spaceDesc[dimension];
        if (range2) return range1.isInterestRange(range2);
        return false;
      }
      splitSpace(dimension, less, value) {
        let range = this._spaceDesc[dimension];
        if (less) range.max = value;
        else range.min = value;
        return this;
      }
      copySpace(space) {
        for (let key in space._spaceDesc) {
          let d = space._spaceDesc[key];
          this._spaceDesc[key].copy(d);
        }
        return this;
      }
    }

    class KDTreeConfig {
      static MaxEntityCountInLeaf = 4;
      static MaxLayer = 10;
      static ClearLeafLayer = KDTreeConfig.MaxLayer - 4;
    }
    class KDTreeUUID {
      static UUID = 0;
      uuid = "0";
      constructor() {
        this.uuid = (KDTreeUUID.UUID++).toString();
      }
    }
    class KDTreeNodeMap {
      map = {};
      _count = 0;
      get count() {
        return this._count;
      }
      push(entity) {
        let last = this.map[entity.uuid];
        if (!last) {
          this.map[entity.uuid] = entity;
          this._count++;
          return true;
        }
        return false;
      }
      remove(uuid) {
        let last = this.map[uuid];
        if (last) {
          delete this.map[uuid];
          this._count--;
          return true;
        }
        return false;
      }
    }
    class KDTreeNode extends KDTreeUUID {
      _dimensionIndex = 0;
      _dimensions;
      _dimension;
      _left;
      _right;
      _space;
      _parent;
      _entities;
      layer;
      get dimension() {
        return this._dimension;
      }
      constructor(layer = 0) {
        super();
        this.layer = layer;
        KDTreeNode.nodeCount++;
      }
      initNode(parent, dimensions, index) {
        this._dimensions = dimensions;
        this._dimensionIndex = index;
        this._dimension = dimensions[index];
        this._space = new KDTreeSpace().initSpace(dimensions);
        if (parent) this._space.copySpace(parent._space);
        this._parent = parent;
        this._entities = new KDTreeNodeMap();
        return this;
      }
      updateEntity(entity) {
        if (entity.isInNode(this, this._dimension)) {
          entity.attachTreeNode(this);
          this.autoSplit();
          if (this._left && this._right) {
            let nextIndex = (this._dimensionIndex + 1) % this._dimensions.length;
            let nextDimension = this._dimensions[nextIndex];
            if (entity.isInNode(this._right, nextDimension)) {
              this._right.updateEntity(entity);
            } else if (entity.isInNode(this._left, nextDimension)) {
              this._left.updateEntity(entity);
            }
          }
        }
      }
      buildRoot(list) {
        for (const obj of list) {
          obj.entity.attachTreeNode(this);
        }
        this.autoSplit();
      }
      _splitEntityList = [];
      autoSplit() {
        if (this._entities.count > KDTreeConfig.MaxEntityCountInLeaf && !this._right && !this._left && this.layer < KDTreeConfig.MaxLayer) {
          let tempList = this._splitEntityList;
          let nextIndex = (this._dimensionIndex + 1) % this._dimensions.length;
          let nextDimension = this._dimensions[nextIndex];
          let divide = 0;
          for (const key in this._entities.map) {
            let entity = this._entities.map[key];
            divide += entity.centerValue(nextDimension);
            tempList.push(entity);
          }
          divide /= this._entities.count;
          this._left = new KDTreeNode(this.layer + 1);
          this._right = new KDTreeNode(this.layer + 1);
          this._left.initNode(this, this._dimensions, nextIndex);
          this._right.initNode(this, this._dimensions, nextIndex);
          this._left.setSpace(true, divide);
          this._right.setSpace(false, divide);
          for (let entity of tempList) {
            if (entity.isInNode(this._right, nextDimension)) {
              entity.attachTreeNode(this._right);
            } else if (entity.isInNode(this._left, nextDimension)) {
              entity.attachTreeNode(this._left);
            }
          }
        }
        this._left && this._left.autoSplit();
        this._right && this._right.autoSplit();
      }
      setSpace(less, value) {
        if (this._parent) {
          this._space.splitSpace(this._dimension, less, value);
        }
        return this;
      }
      isEmpty() {
        return this._left == null && this._right == null && this._entities.count == 0;
      }
      pushEntity(entity) {
        return this._entities.push(entity);
      }
      removeEntity(entity) {
        return this._entities.remove(entity.uuid);
      }
      static nodeCount = 0;
      autoClear() {
        let that = this;
        while (that && that.layer > KDTreeConfig.ClearLeafLayer && that.clearLeaf()) {
          that = that._parent;
        }
      }
      clearLeaf() {
        let isEmpty0 = !this._left && !this._right;
        let isEmpty1 = !isEmpty0 && this._left.isEmpty() && this._right.isEmpty();
        if (isEmpty1) {
          this._left = this._right = null;
          KDTreeNode.nodeCount -= 2;
        }
        return isEmpty0 || isEmpty1;
      }
      isContain(value) {
        return this._space.isContain(this._dimension, value);
      }
      static rangeBox = new BoundingBox(new Vector3(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), new Vector3(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE));
      nodeIntersectsBox(box) {
        let x = this._space.getRange("x");
        let y = this._space.getRange("y");
        let z = this._space.getRange("z");
        let rangeBox = KDTreeNode.rangeBox;
        rangeBox.min.set(x.min, y.min, z.min);
        rangeBox.max.set(x.max, y.max, z.max);
        return rangeBox.intersectsBox(box);
      }
      nodeIntersectsRay(ray) {
        let x = this._space.getRange("x");
        let y = this._space.getRange("y");
        let z = this._space.getRange("z");
        let rangeBox = KDTreeNode.rangeBox;
        rangeBox.min.set(x.min, y.min, z.min);
        rangeBox.max.set(x.max, y.max, z.max);
        return true;
      }
      pointCast(point, squareDistance = 0, ret) {
        ret = ret || [];
        if (this._entities.count > 0) {
          let map = this._entities.map;
          for (let key in map) {
            let entity = map[key];
            let success = entity.entityContainPoint(point);
            if (!success && squareDistance > 0) {
              success = entity.squareDistanceTo(point, this._dimensions) <= squareDistance;
            }
            if (success) {
              ret.push(entity);
            }
          }
        }
        if (this._left && this._left.isContain(point[this._left.dimension])) {
          this._left.pointCast(point, squareDistance, ret);
        }
        if (this._right && this._right.isContain(point[this._right.dimension])) {
          this._right.pointCast(point, squareDistance, ret);
        }
      }
      boxCast(box, ret) {
        ret = ret || [];
        if (this._entities.count > 0) {
          let map = this._entities.map;
          for (let key in map) {
            let entity = map[key];
            if (entity.entityIntersectsBox(box)) {
              ret.push(entity);
            }
          }
        }
        if (this._left && this._left.nodeIntersectsBox(box)) {
          this._left.boxCast(box, ret);
        }
        if (this._right && this._right.nodeIntersectsBox(box)) {
          this._right.boxCast(box, ret);
        }
      }
      pointIntersect = new Vector3();
      rayCast(ray, ret, pts) {
        ret = ret || [];
        pts = pts || [];
        let target = this.pointIntersect;
        if (this._entities.count > 0) {
          let map = this._entities.map;
          for (let key in map) {
            let entity = map[key];
            if (entity.entityIntersectsRay(ray, target)) {
              pts.push(new Vector3().copy(target));
              ret.push(entity);
            }
          }
        }
        if (this._left && this._left.nodeIntersectsRay(ray)) {
          this._left.rayCast(ray, ret, pts);
        }
        if (this._right && this._right.nodeIntersectsRay(ray)) {
          this._right.rayCast(ray, ret, pts);
        }
      }
    }

    class KDTreeEntity extends KDTreeUUID {
      userData;
      node;
      constructor(data) {
        super();
        this.userData = data;
      }
      centerValue(dimension) {
        return 0;
      }
      isInNode(node, dimension) {
        return false;
      }
      entityContainPoint(point) {
        return false;
      }
      squareDistanceTo(point, dimensions) {
        return Number.MAX_VALUE;
      }
      entityIntersectsBox(box) {
        return false;
      }
      entityIntersectsRay(ray, target) {
        return false;
      }
      attachTreeNode(node) {
        if (this.node) this.detachTreeNode();
        this.node = node;
        return this.node.pushEntity(this);
      }
      detachTreeNode() {
        let success = this.node.removeEntity(this);
        this.node = null;
        return success;
      }
      updateNode(root) {
        let lastNode = this.node;
        if (lastNode) this.detachTreeNode();
        root.updateEntity(this);
        if (lastNode) lastNode.autoClear();
      }
    }

    class QuadAABB {
      minPosX = 0;
      minPosY = 0;
      maxPosX = 0;
      maxPosY = 0;
      testID = 0;
      points;
      offsetPosition;
      static TINY = 1e-6;
      constructor() {
        this.points = new Array();
        this.offsetPosition = new Vector3(0, 0, 0, 0);
        this.clear();
      }
      setAABox(cx, cy, sideX, sideY) {
        this.minPosX = cx - sideX / 2 - QuadAABB.TINY;
        this.maxPosX = cx + sideX / 2 + QuadAABB.TINY;
        this.minPosY = cy - sideY / 2 - QuadAABB.TINY;
        this.maxPosY = cy + sideY / 2 + QuadAABB.TINY;
        this.offsetPosition.setTo(0, 0, 0);
      }
      setOffset(vec) {
        this.maxPosX += vec.x - this.offsetPosition.x;
        this.minPosX += vec.x - this.offsetPosition.x;
        this.minPosY += vec.z - this.offsetPosition.z;
        this.maxPosY += vec.z - this.offsetPosition.z;
        this.offsetPosition.copy(vec);
      }
      setContainRect(minX, minY, maxX, maxY) {
        if (this.minPosX > minX) this.minPosX = minX;
        if (this.minPosY > minY) this.minPosY = minY;
        if (this.maxPosX < maxX) this.maxPosX = maxX;
        if (this.maxPosY < maxY) this.maxPosY = maxY;
      }
      clear() {
        var huge = 1e9;
        this.minPosX = this.minPosY = huge;
        this.maxPosX = this.maxPosY = -huge;
        this.points.length = 0;
        this.testID = 0;
        this.offsetPosition.setTo(0, 0, 0);
      }
      addPoint(pos) {
        if (this.points.indexOf(pos) == -1) {
          if (pos.x < this.minPosX)
            this.minPosX = pos.x - QuadAABB.TINY;
          if (pos.x > this.maxPosX)
            this.maxPosX = pos.x + QuadAABB.TINY;
          if (pos.z < this.minPosY)
            this.minPosY = pos.z - QuadAABB.TINY;
          if (pos.z > this.maxPosY)
            this.maxPosY = pos.z + QuadAABB.TINY;
          this.points.push(pos);
        }
      }
      clone() {
        var aabb = new QuadAABB();
        aabb.minPosX = this.minPosX;
        aabb.minPosY = this.minPosY;
        aabb.maxPosX = this.maxPosX;
        aabb.maxPosY = this.maxPosY;
        return aabb;
      }
      get radius() {
        return Math.sqrt((this.maxPosY - this.minPosY) * (this.maxPosY - this.minPosY) + (this.maxPosX - this.minPosX) * (this.maxPosX - this.minPosX));
      }
      get sideX() {
        return this.maxPosX - this.minPosX;
      }
      get sideY() {
        return this.maxPosY - this.minPosY;
      }
      get centreX() {
        return (this.maxPosX - this.minPosX) * 0.5 + this.minPosX;
      }
      get centreY() {
        return (this.maxPosY - this.minPosY) * 0.5 + this.minPosY;
      }
      overlapTest(box) {
        return this.minPosY >= box.maxPosY || this.maxPosY <= box.minPosY || this.minPosX >= box.maxPosX || this.maxPosX <= box.minPosX ? false : true;
      }
      isPointInside(pos) {
        return pos.x >= this.minPosX && pos.x <= this.maxPosX && pos.z >= this.minPosY && pos.z <= this.maxPosY;
      }
      isIntersectLineSegment(p1x, p1y, p2x, p2y) {
        var isIntersect = false;
        var A1 = p1y - p2y;
        var B1 = p2x - p1x;
        var C1 = p1x * p2y - p2x * p1y;
        var LineIntersectY = (-C1 - A1 * this.minPosX) / B1;
        if (LineIntersectY <= this.maxPosY && LineIntersectY >= this.minPosY)
          isIntersect = true;
        LineIntersectY = (-C1 - A1 * this.maxPosX) / B1;
        if (LineIntersectY <= this.maxPosY && LineIntersectY >= this.minPosY)
          isIntersect = true;
        var LineIntersectX = (-C1 - B1 * this.minPosY) / A1;
        if (LineIntersectX <= this.maxPosX && LineIntersectX >= this.minPosX)
          isIntersect = true;
        LineIntersectX = (-C1 - B1 * this.maxPosY) / A1;
        if (LineIntersectX <= this.maxPosX && LineIntersectX >= this.minPosX)
          isIntersect = true;
        return isIntersect;
      }
    }

    class QuadTreeCell {
      static NUM_CHILDREN = 4;
      childCellIndices;
      nodeIndices;
      aabb;
      points;
      constructor(aabox) {
        this.childCellIndices = new Array();
        this.childCellIndices.length = QuadTreeCell.NUM_CHILDREN;
        this.nodeIndices = new Array();
        this.clear();
        if (aabox) {
          this.aabb = aabox.clone();
        } else {
          this.aabb = new QuadAABB();
        }
      }
      /**
      * @language zh_CN
      * Indicates if we contain triangles (if not then we should/might have children)
      */
      isLeaf() {
        return this.childCellIndices[0] == -1;
      }
      clear() {
        for (var i = 0; i < QuadTreeCell.NUM_CHILDREN; i++) {
          this.childCellIndices[i] = -1;
        }
        this.nodeIndices.splice(0, this.nodeIndices.length);
      }
    }

    class QuadTree {
      _cells;
      _rootCell;
      _quadNodes;
      _aabb;
      _cellsToTest;
      _testID;
      constructor() {
        this._testID = 0;
        this._cells = new Array();
        this._quadNodes = new Array();
        this._cellsToTest = new Array();
        this._aabb = new QuadAABB();
      }
      getQuadNode(idx) {
        return this._quadNodes[idx];
      }
      clear() {
        this._cells.length = 0;
        this._quadNodes.length = 0;
      }
      initNodes(nodes) {
        this.clear();
        var i = 0;
        var count = nodes.length;
        while (i < count) {
          nodes[i].calcGlobalQuadAABB();
          this._quadNodes.push(nodes[i]);
          i++;
        }
      }
      buildQuadTree(maxNodesPerCell, minCellSize) {
        this._aabb.clear();
        for (var node of this._quadNodes) {
          if (node.isTriangle) {
            for (var vt of node.aabb.points) {
              this._aabb.addPoint(vt);
            }
          } else {
            this._aabb.setContainRect(node.aabb.minPosX, node.aabb.minPosY, node.aabb.maxPosX, node.aabb.maxPosY);
          }
        }
        this._cells.length = 0;
        this._rootCell = new QuadTreeCell(this._aabb);
        this._cells.push(this._rootCell);
        var numTriangles = this._quadNodes.length;
        for (var i = 0; i < numTriangles; i++) {
          this._cells[0].nodeIndices[i] = i;
        }
        var cellsToProcess = new Array();
        cellsToProcess.push(0);
        var iTri;
        var cellIndex;
        var childCell;
        while (cellsToProcess.length != 0) {
          cellIndex = cellsToProcess.pop();
          if (this._cells[cellIndex].nodeIndices.length <= maxNodesPerCell || this._cells[cellIndex].aabb.radius < minCellSize) {
            continue;
          }
          for (i = 0; i < QuadTreeCell.NUM_CHILDREN; i++) {
            this._cells[cellIndex].childCellIndices[i] = this._cells.length;
            cellsToProcess.push(this._cells.length);
            this._cells.push(new QuadTreeCell(this.createAABox(this._cells[cellIndex].aabb, i)));
            childCell = this._cells[this._cells.length - 1];
            numTriangles = this._cells[cellIndex].nodeIndices.length;
            for (var j = 0; j < numTriangles; j++) {
              iTri = this._cells[cellIndex].nodeIndices[j];
              if (this.doesNodeIntersectCell(this._quadNodes[iTri], childCell)) {
                childCell.nodeIndices.push(iTri);
              }
            }
          }
          this._cells[cellIndex].nodeIndices.length = 0;
        }
      }
      createAABox(aabb, id) {
        var centerX = aabb.centreX;
        var centerY = aabb.centreY;
        var dimX = aabb.sideX;
        var dimY = aabb.sideY;
        var result = new QuadAABB();
        switch (id) {
          case 0:
            result.setAABox(centerX + dimX / 4, centerY + dimY / 4, dimX / 2, dimY / 2);
            break;
          case 1:
            result.setAABox(centerX - dimX / 4, centerY + dimY / 4, dimX / 2, dimY / 2);
            break;
          case 2:
            result.setAABox(centerX - dimX / 4, centerY - dimY / 4, dimX / 2, dimY / 2);
            break;
          case 3:
            result.setAABox(centerX + dimX / 4, centerY - dimY / 4, dimX / 2, dimY / 2);
            break;
          default:
            result.setAABox(centerX + dimX / 4, centerY - dimY / 4, dimX / 2, dimY / 2);
            break;
        }
        return result;
      }
      doesNodeIntersectCell(node, cell) {
        var box = node.aabb;
        if (!box.overlapTest(cell.aabb)) {
          return false;
        }
        if (!node.isTriangle)
          return true;
        var points = box.points;
        var p1 = points[0];
        var p2 = points[1];
        var p3 = points[2];
        if (cell.aabb.isPointInside(p1) || cell.aabb.isPointInside(p2) || cell.aabb.isPointInside(p3)) {
          return true;
        }
        var isIntersect = this.pointInTriangle(cell.aabb.minPosX, cell.aabb.minPosY, p1, p2, p3) || this.pointInTriangle(cell.aabb.minPosX, cell.aabb.maxPosY, p1, p2, p3) || this.pointInTriangle(cell.aabb.maxPosX, cell.aabb.maxPosY, p1, p2, p3) || this.pointInTriangle(cell.aabb.maxPosX, cell.aabb.minPosY, p1, p2, p3);
        if (isIntersect)
          return true;
        isIntersect = cell.aabb.isIntersectLineSegment(p1.x, p1.z, p2.x, p2.z) || cell.aabb.isIntersectLineSegment(p1.x, p1.z, p3.x, p3.z) || cell.aabb.isIntersectLineSegment(p2.x, p2.z, p3.x, p3.z);
        return isIntersect;
      }
      getNodesIntersectingtAABox(result, aabb) {
        if (this._cells.length == 0)
          return 0;
        this._cellsToTest.length = 0;
        this._cellsToTest.push(0);
        this.incrementTestCounter();
        var cellIndex, nTris, cell;
        var nodeBox;
        var i = 0;
        while (this._cellsToTest.length != 0) {
          cellIndex = this._cellsToTest.pop();
          cell = this._cells[cellIndex];
          if (!aabb.overlapTest(cell.aabb)) {
            continue;
          }
          if (cell.isLeaf()) {
            nTris = cell.nodeIndices.length;
            for (i = 0; i < nTris; i++) {
              nodeBox = this.getQuadNode(cell.nodeIndices[i]).aabb;
              if (nodeBox.testID != this._testID) {
                nodeBox.testID = this._testID;
                if (aabb.overlapTest(nodeBox)) {
                  result.push(cell.nodeIndices[i]);
                }
              }
            }
          } else {
            for (i = 0; i < QuadTreeCell.NUM_CHILDREN; i++) {
              this._cellsToTest.push(cell.childCellIndices[i]);
            }
          }
        }
        return result.length;
      }
      pointInTriangle(x, y, triP1, triP2, triP3) {
        var p1 = triP1;
        var p2 = triP2;
        var p3 = triP3;
        var A1 = p1.z - p2.z;
        var B1 = p2.x - p1.x;
        var C1 = p1.x * p2.z - p2.x * p1.z;
        var A2 = p2.z - p3.z;
        var B2 = p3.x - p2.x;
        var C2 = p2.x * p3.z - p3.x * p2.z;
        var A3 = p3.z - p1.z;
        var B3 = p1.x - p3.x;
        var C3 = p3.x * p1.z - p1.x * p3.z;
        var isInTri = false;
        var D1 = A1 * x + B1 * y + C1;
        var D2 = A2 * x + B2 * y + C2;
        var D3 = A3 * x + B3 * y + C3;
        const Tiny = 0.01;
        if (D1 >= -Tiny && D2 >= -Tiny && D3 >= -Tiny || D1 <= Tiny && D2 <= Tiny && D3 <= Tiny)
          isInTri = true;
        return isInTri;
      }
      incrementTestCounter() {
        ++this._testID;
        if (this._testID == 0) {
          var numTriangles = this._quadNodes.length;
          for (var i = 0; i < numTriangles; i++) {
            this._quadNodes[i].aabb.testID = 0;
          }
          this._testID = 1;
        }
      }
    }

    class QuadRoot {
      _maxNodesPerCell;
      _minCellSize;
      _quadTree;
      _collisionNodesIdx;
      _segBox;
      _collisionNodes;
      constructor(maxNodesPerCell = 10, minCellSize = 500) {
        this._maxNodesPerCell = maxNodesPerCell;
        this._minCellSize = minCellSize;
        this._segBox = new QuadAABB();
        this._collisionNodesIdx = new Array();
        this._collisionNodes = new Array();
      }
      createQuadTree(nodes) {
        this._quadTree = new QuadTree();
        this._quadTree.initNodes(nodes);
        this._quadTree.buildQuadTree(this._maxNodesPerCell, this._minCellSize);
      }
      getNodesByAABB(minX, minY, maxX, maxY) {
        this._segBox.clear();
        this._segBox.maxPosX = maxX;
        this._segBox.maxPosY = maxY;
        this._segBox.minPosX = minX;
        this._segBox.minPosY = minY;
        this._collisionNodesIdx.length = 0;
        this._collisionNodes.length = 0;
        this._quadTree.getNodesIntersectingtAABox(this._collisionNodesIdx, this._segBox);
        var quadNode;
        for (var i = 0; i < this._collisionNodesIdx.length; i++) {
          quadNode = this._quadTree.getQuadNode(this._collisionNodesIdx[i]);
          this._collisionNodes.push(quadNode);
        }
        return this._collisionNodes;
      }
      getTriangleAtPoint(point, threshold = 5) {
        this._segBox.clear();
        this._segBox.setAABox(point.x, point.z, 1, 1);
        this._collisionNodesIdx.length = 0;
        this._collisionNodes.length = 0;
        this._quadTree.getNodesIntersectingtAABox(this._collisionNodesIdx, this._segBox);
        var minDistance = 4294967295;
        var curDistance = 0;
        var minTriangle;
        var quadNode;
        var triangle;
        var box;
        for (var i = 0; i < this._collisionNodesIdx.length; i++) {
          quadNode = this._quadTree.getQuadNode(this._collisionNodesIdx[i]);
          box = quadNode.aabb;
          if (!Vector3.pointInsideTriangle(point, box.points[0], box.points[1], box.points[2])) {
            continue;
          }
          triangle = quadNode;
          curDistance = Math.abs(triangle.plane.distance(point));
          if (curDistance > threshold)
            continue;
          if (quadNode == null || curDistance <= minDistance) {
            minTriangle = triangle;
            minDistance = curDistance;
          }
        }
        return minTriangle;
      }
    }

    var MouseCode = /* @__PURE__ */ ((MouseCode2) => {
      MouseCode2[MouseCode2["MOUSE_LEFT"] = 0] = "MOUSE_LEFT";
      MouseCode2[MouseCode2["MOUSE_MID"] = 1] = "MOUSE_MID";
      MouseCode2[MouseCode2["MOUSE_RIGHT"] = 2] = "MOUSE_RIGHT";
      return MouseCode2;
    })(MouseCode || {});

    class LoaderEvent extends CEvent {
      static LOADER_PROGRESS = "loaderProgress";
      static LOADER_COMPLETE = "loaderComplete";
    }

    class Object3DEvent extends CEvent {
      static ADDED = "added";
      static REMOVED = "removed";
      static CHILD_ADD_EVENT = "childAddEvent";
      static CHILD_REMOVED = "childRemoved";
    }

    class UIEvent extends CEvent {
      static SHOW = "show";
      static HIDE = "hide";
      static UPDATE = "update";
    }

    class MergeRGBACreator {
      static merge(textureR, textureG, textureB, textureA, ctx) {
        let w = 0;
        let h = 0;
        w = Math.max(textureR.width, w);
        w = Math.max(textureG.width, w);
        w = Math.max(textureB.width, w);
        w = Math.max(textureA.width, w);
        h = Math.max(textureR.height, h);
        h = Math.max(textureG.height, h);
        h = Math.max(textureB.height, h);
        h = Math.max(textureA.height, h);
        let outTex = new VirtualTexture(w, h, GPUTextureFormat.rgba8unorm, false, void 0, 1, 0, 1, ctx);
        let compute = new ComputeShader(MergeRGBA_cs);
        compute.setSamplerTexture("textureR", textureR);
        compute.setSamplerTexture("textureG", textureG);
        compute.setSamplerTexture("textureB", textureB);
        compute.setSamplerTexture("textureA", textureA);
        compute.setStorageTexture("outTex", outTex);
        compute.workerSizeX = Math.ceil(w / 8);
        compute.workerSizeY = Math.ceil(h / 8);
        const gpu = outTex._boundCtx.gpuContext;
        let command = gpu.beginCommandEncoder();
        gpu.computeCommand(command, [compute]);
        gpu.endCommandEncoder(command);
        return outTex;
      }
    }

    class TextureScaleCompute {
      /**
       * The underlying compute shader created from the input/output textures.
       */
      computeShader;
      /**
       * Configure the compute shader inputs and outputs.
       * @param colorMap optional color map sampled by the shader
       * @param inputs source textures bound as sampled textures
       * @param outputs destination textures bound as storage textures
       */
      setInputes(colorMap, inputs, outputs) {
        this.computeShader = new ComputeShader(textureCompress(colorMap, inputs, outputs, 8, 8, 1));
        for (let i = 0; i < inputs.length; i++) {
          this.computeShader.setSamplerTexture(`source${i}Map`, inputs[i]);
        }
        for (let i = 0; i < outputs.length; i++) {
          this.computeShader.setStorageTexture(`dest${i}Map`, outputs[i]);
        }
        if (colorMap) {
          this.computeShader.setSamplerTexture(`colorMap`, colorMap);
        }
        this.computeShader.workerSizeX = outputs[0].width / 8;
        this.computeShader.workerSizeY = outputs[0].height / 8;
        this.computeShader.workerSizeZ = 1;
      }
    }

    class RenderShaderCompute {
      sourceShader;
      compute;
      needUpdate = true;
      constructor(shaderStr, sourceShader) {
        this.sourceShader = sourceShader;
        this.compute = new ComputeShader(shaderStr);
        this.init();
      }
      init() {
      }
      onUpdate(view) {
        if (this.onFrame) {
          this.onFrame(view);
        }
        if (this.onOnce && this.needUpdate) {
          this.needUpdate = false;
          this.onFrame(view);
        }
      }
    }

    class PreIntegratedLutCompute extends RenderShaderCompute {
      constructor(shader) {
        super(PreIntegratedLut, shader);
      }
      init() {
        let texture = new VirtualTexture(256, 256, GPUTextureFormat.rgba8unorm, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING);
        this.compute.setStorageTexture("sssMap", texture);
        this.sourceShader.setTexture("lutMap", texture);
        return texture;
      }
      onFrame(view) {
        this.compute.workerSizeX = 256 / 8;
        this.compute.workerSizeY = 256 / 8;
        const gpu = view.engine3D.context3D.gpuContext;
        let commandEncoder = gpu.beginCommandEncoder();
        gpu.computeCommand(commandEncoder, [this.compute]);
        gpu.endCommandEncoder(commandEncoder);
      }
    }

    class ProbeEntries {
      gpuBuffer;
      probes;
      memoryDo;
      _probeInfoList;
      _boundCtx = null;
      initDataUniform(ctx, probes) {
        bindCtx(this, ctx);
        let device = this._boundCtx.device;
        this.memoryDo = new MemoryDO();
        this.probes = probes;
        this._probeInfoList = [];
        this.memoryDo.destroy();
        this.memoryDo.allocation(probes.length * 17 * 4);
        for (let i = 0; i < probes.length; i++) {
          var size = 17;
          let memoryInfo = this.memoryDo.allocation_node(size * 4);
          this._probeInfoList.push(memoryInfo);
          let probeWorldPos = probes[i].transform.worldPosition;
          memoryInfo.setArray(0, [probeWorldPos.x, probeWorldPos.y, probeWorldPos.z]);
        }
        this.gpuBuffer = device.createBuffer({
          size: this.memoryDo.shareDataBuffer.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.STORAGE,
          label: "ProbeBuffer",
          mappedAtCreation: false
        });
      }
      updateGPUBuffer() {
        let device = this._boundCtx.device;
        const bufferData = this.memoryDo.shareDataBuffer;
        let totalBytes = this.memoryDo.shareDataBuffer.byteLength;
        let offsetBytes = 0;
        const space = 5e3 * 64;
        while (offsetBytes < totalBytes) {
          device.queue.writeBuffer(this.gpuBuffer, offsetBytes, bufferData, offsetBytes, Math.floor(Math.min(space, totalBytes - offsetBytes)));
          offsetBytes += space;
        }
      }
    }

    class StructStorageGPUBuffer extends GPUBufferBase {
      constructor(struct, count, usage = 0) {
        super();
        this.bufferType = GPUBufferType.StructStorageGPUBuffer;
        this.createBufferByStruct(GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST | usage, struct, count);
      }
    }

    class TextureMipmapCompute {
      static codeMax = `
        @group(0) @binding(0) var inputTexture : texture_2d<f32>;
        @group(0) @binding(1) var inputTextureSampler : sampler;
        @group(0) @binding(2) var outputTexture : texture_storage_2d<rgba8unorm, write>;
        
        @compute @workgroup_size(8, 8)
        fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
            let dstSize = textureDimensions(outputTexture).xy;
            let uv01 = vec2<f32>(f32(GlobalInvocationID.x) / f32(dstSize.x - 1), f32(GlobalInvocationID.y) / f32(dstSize.y - 1));
            var fromColor = textureSampleLevel(inputTexture, inputTextureSampler, uv01, 0.0);
            let dstCoord = vec2<i32>(i32(GlobalInvocationID.x), i32(GlobalInvocationID.y));
            
            //fromColor = vec4<f32>(0.0, 0.0, 0.0, 1.0);
            //if(dstSize.x == 512){
            //    fromColor.x = 1.0;
            //}else  if(dstSize.x == 256){
            //    fromColor.y = 1.0;
            //}else if(dstSize.x == 128){
            //    fromColor.z = 1.0;
            //}
            
            textureStore(outputTexture, dstCoord, fromColor);
        }
    `;
      static codeMin = `
        @group(0) @binding(0) var inputTexture : texture_2d<f32>;
        @group(0) @binding(1) var inputTextureSampler : sampler;
        @group(0) @binding(2) var outputTexture : texture_storage_2d<rgba8unorm, write>;
        
        @compute @workgroup_size(1, 1)
        fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {
            let dstSize = textureDimensions(outputTexture).xy;
            let uv01 = vec2<f32>(f32(GlobalInvocationID.x) / f32(dstSize.x - 1), f32(GlobalInvocationID.y) / f32(dstSize.y - 1));
            var fromColor = textureSampleLevel(inputTexture, inputTextureSampler, uv01, 0.0);
            let dstCoord = vec2<i32>(i32(GlobalInvocationID.x), i32(GlobalInvocationID.y));
            
            textureStore(outputTexture, dstCoord, fromColor);
        }
    `;
      static _getPipelines(ctx) {
        return ctx.cache(TextureMipmapCompute, () => {
          const device = ctx.device;
          return {
            max: device.createComputePipeline({
              layout: `auto`,
              compute: {
                module: device.createShaderModule({ code: this.codeMax }),
                entryPoint: "main"
              }
            }),
            min: device.createComputePipeline({
              layout: `auto`,
              compute: {
                module: device.createShaderModule({ code: this.codeMin }),
                entryPoint: "main"
              }
            })
          };
        });
      }
      static createMipmap(texture, mipmapCount) {
        const pipelines = this._getPipelines(texture._boundCtx);
        let dstWidth = Math.ceil(texture.width * 0.5);
        let dstHeight = Math.ceil(texture.height * 0.5);
        let mipmapData = { mipmapCount, texture, srcView: null, mipLevel: 1, dstHeight, dstWidth };
        mipmapData.srcView = texture.getGPUTexture().createView({
          format: texture.format,
          dimension: "2d",
          baseMipLevel: 0,
          // Make sure we're getting the right mip level...
          mipLevelCount: 1
          // And only selecting one mip level
        });
        let isMax = texture.width > 1024 && texture.height > 1024;
        if (isMax) {
          this.mipmap(pipelines.max, mipmapData);
        } else {
          this.mipmap(pipelines.min, mipmapData);
        }
      }
      static mipmap(computePipeline, data) {
        const ctx = data.texture._boundCtx;
        const device = ctx.device;
        const gpu = ctx.gpuContext;
        const pipelines = this._getPipelines(ctx);
        const commandEncoder = gpu.beginCommandEncoder();
        let isCurrentMax = computePipeline == pipelines.max;
        let dstView;
        let isBreakToMin;
        for (let i = data.mipLevel; i < data.mipmapCount; i++) {
          let entries = [];
          let binding = 0;
          entries.push({
            binding: binding++,
            resource: data.srcView
          });
          entries.push({
            binding: binding++,
            resource: data.texture.gpuSampler
          });
          dstView = data.texture.getGPUTexture().createView({
            format: data.texture.format,
            dimension: "2d",
            baseMipLevel: i,
            mipLevelCount: 1
          });
          entries.push({
            binding: binding++,
            resource: dstView
          });
          const computeBindGroup = device.createBindGroup({
            layout: computePipeline.getBindGroupLayout(0),
            entries
          });
          const computePass = commandEncoder.beginComputePass();
          computePass.setPipeline(computePipeline);
          computePass.setBindGroup(0, computeBindGroup);
          let groupX = data.dstWidth;
          let groupY = data.dstHeight;
          if (isCurrentMax) {
            groupX = Math.max(1, Math.floor(data.dstWidth / 8));
            groupY = Math.max(1, Math.floor(data.dstHeight / 8));
          }
          computePass.dispatchWorkgroups(groupX, groupY);
          data.dstHeight *= 0.5;
          data.dstWidth *= 0.5;
          data.srcView = dstView;
          data.mipLevel = i + 1;
          isBreakToMin = isCurrentMax && (data.dstWidth < 8 || data.dstHeight < 8);
          computePass.end();
          if (isBreakToMin) {
            break;
          }
        }
        gpu.endCommandEncoder(commandEncoder);
        if (isBreakToMin) {
          this.mipmap(pipelines.min, data);
        }
      }
    }

    class MorePassShader {
      /** Shader name declared in the source. */
      name = "";
      /** Passes grouped by their pass type. */
      passMap = /* @__PURE__ */ new Map();
    }
    class PassShader {
      /** Pass type identifier (e.g. COLOR, SHADOW). */
      passType = "";
      /** Render state key/value pairs declared for this pass. */
      shaderState = /* @__PURE__ */ new Map();
      /** Vertex shader source code. */
      vertexShader = "";
      /** Fragment shader source code. */
      fragmentShader = "";
    }
    class MorePassParser {
      static passKeyword = "pass";
      static shaderKeyword = "Shader";
      static vertexKeyword = "vertex";
      static fragmentKeyword = "fragment";
      static passTypeKeyword = "PassType";
      /**
       * Parse a multi-pass shader source into a {@link MorePassShader}.
       * @param code the raw shader source code
       * @param defineValue preprocessor define values applied to each pass
       */
      static parser(code, defineValue) {
        code = Preprocessor.filterComment(code);
        let result = new MorePassShader();
        let index1 = code.indexOf(this.shaderKeyword);
        let index2 = code.indexOf("{", index1);
        let block = code.substring(index1 + this.shaderKeyword.length, index2).trim();
        result.name = block.substring(1, block.length - 1);
        block = code.substring(code.indexOf("{") + 1, code.lastIndexOf("}"));
        let passBlocks = this.splitPassBlock(block);
        for (let passCode of passBlocks) {
          let passShader = this.parserPassBlock(passCode);
          let passshaderList;
          if (result.passMap.has(passShader.passType)) {
            passshaderList = result.passMap.get(passShader.passType);
          } else {
            passshaderList = [];
            result.passMap.set(passShader.passType, passshaderList);
          }
          passshaderList.push(passShader);
          if (passShader.vertexShader.length > 0) {
            passShader.vertexShader = Preprocessor.parse(passShader.vertexShader, defineValue);
          }
          if (passShader.fragmentShader.length > 0) {
            passShader.fragmentShader = Preprocessor.parse(passShader.fragmentShader, defineValue);
          }
        }
        return result;
      }
      static splitPassBlock(code) {
        let offset = 0;
        let result = [];
        while (offset < code.length) {
          let index = code.indexOf(this.passKeyword, offset);
          if (index == -1) {
            result.push(code.substring(offset));
            break;
          }
          if (offset != 0) {
            result.push(code.substring(offset, index));
          }
          offset = index + this.passKeyword.length;
        }
        return result;
      }
      static parserPassBlock(code) {
        let passShader = new PassShader();
        let index1 = code.indexOf(this.passTypeKeyword);
        let index2 = code.indexOf('"', index1);
        index1 = code.indexOf('"', index2 + 1);
        passShader.passType = code.substring(index1 + 1, index2).trim();
        this.parserShaderState(passShader, code);
        index1 = code.indexOf(this.vertexKeyword);
        if (index1 != -1) {
          passShader.vertexShader = this.extractBlock(code.substring(index1 + this.vertexKeyword.length), "{", "}");
        }
        index1 = code.indexOf(this.fragmentKeyword);
        if (index1 != -1) {
          passShader.fragmentShader = this.extractBlock(code.substring(index1 + this.fragmentKeyword.length), "{", "}");
        }
        return passShader;
      }
      static parserShaderState(passShader, code) {
        let indexL = code.indexOf("ShaderState");
        if (indexL == -1)
          return false;
        indexL = code.indexOf("{", indexL);
        let indexR = code.indexOf("}", indexL);
        let codeBlock = code.substring(indexL + 1, indexR);
        let fields = codeBlock.split(",");
        for (let item of fields) {
          let keyValue = item.split(":");
          let key = keyValue[0].trim();
          let value = this.convertValue(keyValue[1].trim());
          passShader.shaderState.set(key, value);
        }
        return true;
      }
      static convertValue(str) {
        if (str.length == 4 && str.toLowerCase() == "true")
          return true;
        else if (str.length == 5 && str.toLowerCase() == "false")
          return false;
        else if (str[0] == '"')
          return str.substring(1, str.length - 1);
        return Number.parseInt(str);
      }
      static extractBlock(str, leftStr, rightStr) {
        let indexL = str.indexOf(leftStr);
        if (indexL == -1) {
          return "";
        }
        let depth = 0;
        let indexR = 0;
        str = str.substring(indexL);
        for (let char of str) {
          if (char == leftStr) {
            depth++;
          } else if (char == rightStr) {
            depth--;
          }
          if (depth <= 0) {
            break;
          }
          indexR++;
        }
        let block = str.substring(1, indexR).trim();
        return block;
      }
    }

    class GPUContextInstance {
      /** The Context3D (one engine) this instance is bound to. */
      ctx;
      /** Last geometry bound by {@link bindGeometryBuffer}; used to skip redundant vertex/index buffer rebinds. */
      lastGeometry = null;
      /** Last render pipeline set on the encoder; used to skip redundant setPipeline calls. */
      lastPipeline = null;
      /** Last shader pass bound by {@link bindPipeline}; used to detect material switches. */
      lastShader = null;
      /** Number of draw calls submitted since the last reset (profiling counter). */
      drawCount = 0;
      /** Number of render passes begun since the last reset (profiling counter). */
      renderPassCount = 0;
      /** Number of geometries processed since the last reset (profiling counter). */
      geometryCount = 0;
      /** Number of pipelines created since the last reset (profiling counter). */
      pipelineCount = 0;
      /** Number of matrix uploads since the last reset (profiling counter). */
      matrixCount = 0;
      /** Render-pass state of the most recently begun render pass. */
      lastRenderPassState = null;
      /** Command encoder currently open via {@link beginCommandEncoder}, or null. */
      LastCommand = null;
      /** Device that owns {@link LastCommand}; used to submit on the matching queue. */
      LastCommandDevice = null;
      constructor(ctx) {
        this.ctx = ctx;
      }
      /**
       * Bind a shader pass's pipeline and bind groups onto the encoder.
       * Skips the work and returns `false` when `renderShader` matches the
       * last bound shader; otherwise binds and returns `true`. Re-issues the
       * stencil reference on every material switch since it is render-pass
       * (not pipeline) state.
       */
      bindPipeline(encoder, renderShader) {
        if (this.lastShader != renderShader) {
          this.lastShader = renderShader;
        } else {
          return false;
        }
        if (this.lastPipeline != renderShader.pipeline) {
          this.lastPipeline = renderShader.pipeline;
          encoder.setPipeline(renderShader.pipeline);
        }
        if ("setStencilReference" in encoder) {
          encoder.setStencilReference(renderShader.shaderState.stencilRef ?? 0);
        }
        for (let i = 1; i < renderShader.bindGroups.length; i++) {
          const bindGroup = renderShader.bindGroups[i];
          if (bindGroup) {
            encoder.setBindGroup(i, bindGroup);
          }
        }
        return true;
      }
      /** Bind the camera's global bind group at slot 0. */
      bindCamera(encoder, camera) {
        let cameraBindGroup = GlobalBindGroup.getCameraGroup(camera);
        encoder.setBindGroup(0, cameraBindGroup.globalBindGroup);
      }
      /**
       * Bind a geometry's index and vertex buffers onto the encoder.
       * Skips the rebind when `geometry` matches the last bound geometry.
       * Lazily binds each GPU buffer to this context on first use.
       */
      bindGeometryBuffer(encoder, geometry) {
        if (this.lastGeometry != geometry) {
          this.lastGeometry = geometry;
          if (geometry.indicesBuffer) {
            const idx = geometry.indicesBuffer.indicesGPUBuffer;
            if (!idx._boundCtx) bindCtx(idx, this.ctx);
            encoder.setIndexBuffer(idx.buffer, geometry.indicesBuffer.indicesFormat);
          }
          let vertexBuffer = geometry.vertexBuffer.vertexGPUBuffer;
          if (vertexBuffer && !vertexBuffer._boundCtx) bindCtx(vertexBuffer, this.ctx);
          let vertexBufferLayouts = geometry.vertexBuffer.vertexBufferLayouts;
          for (let i = 0; i < vertexBufferLayouts.length; i++) {
            const vbLayout = vertexBufferLayouts[i];
            encoder.setVertexBuffer(i, vertexBuffer.buffer, vbLayout.offset, vbLayout.size);
          }
        }
      }
      /** Reset the cached geometry/pipeline/shader so the next bind always issues. */
      cleanCache() {
        this.lastGeometry = null;
        this.lastPipeline = null;
        this.lastShader = null;
      }
      /** Create a render pipeline on this context's device. */
      createPipeline(gpuRenderPipeline) {
        ProfilerUtil.countStart("GPUContext", "pipeline");
        return this.ctx.device.createRenderPipeline(gpuRenderPipeline);
      }
      /**
       * Open a new command encoder. Submits any previously open encoder
       * first, so only one encoder is in flight at a time per context.
       */
      beginCommandEncoder() {
        ProfilerUtil.countStart("GPUContext", "beginCommandEncoder");
        if (this.LastCommand) {
          this.LastCommandDevice.queue.submit([this.LastCommand.finish()]);
        }
        this.LastCommandDevice = this.ctx.device;
        this.LastCommand = this.LastCommandDevice.createCommandEncoder();
        return this.LastCommand;
      }
      /** Finish and submit `command` if it is the currently open encoder. */
      endCommandEncoder(command) {
        if (this.LastCommand == command) {
          this.LastCommandDevice.queue.submit([this.LastCommand.finish()]);
          this.LastCommand = null;
          this.LastCommandDevice = null;
          ProfilerUtil.countStart("GPUContext", "endCommandEncoder");
        }
      }
      /** Create a render bundle encoder on this context's device. */
      recordBundleEncoder(des) {
        return this.ctx.device.createRenderBundleEncoder(des);
      }
      /**
       * Begin a render pass from `renderPassState`. Resolves the attachment
       * views (depth, color RTs, MSAA side-bands + resolve targets, or the
       * swapchain present view when no RTs are set) before opening the pass.
       */
      beginRenderPass(command, renderPassState) {
        this.cleanCache();
        this.renderPassCount++;
        this.lastRenderPassState = renderPassState;
        if (renderPassState.depthTexture) {
          let depth = renderPassState.renderPassDescriptor.depthStencilAttachment;
          depth.view = renderPassState.depthTexture.getGPUView();
        }
        if (renderPassState.renderTargets && renderPassState.renderTargets.length > 0) {
          for (let i = 0; i < renderPassState.renderTargets.length; ++i) {
            const renderTarget = renderPassState.renderTargets[i];
            let att = renderPassState.renderPassDescriptor.colorAttachments[i];
            if (renderPassState.multisample > 0 && renderPassState.multiTextures && renderPassState.multiTextures[i]) {
              att.view = renderPassState.multiTextures[i].createView();
              const fmt = renderTarget.format;
              const resolvable = fmt === "rgba8unorm" || fmt === "rgba8unorm-srgb" || fmt === "bgra8unorm" || fmt === "bgra8unorm-srgb" || fmt === "rgba16float" || fmt === "r16float" || fmt === "rg16float" || fmt === "r8unorm" || fmt === "rg8unorm";
              if (resolvable) {
                att.resolveTarget = renderTarget.getGPUView();
              } else {
                att.resolveTarget = void 0;
              }
            } else if (renderPassState.multisample > 0 && renderPassState.renderTargets.length == 1) {
              att.view = renderPassState.multiTexture.createView();
              att.resolveTarget = renderTarget.getGPUView();
            } else {
              att.view = renderTarget.getGPUView();
            }
          }
          return command.beginRenderPass(renderPassState.renderPassDescriptor);
        } else {
          let att0 = renderPassState.renderPassDescriptor.colorAttachments[0];
          if (att0) {
            const viewDesc = {
              format: this.ctx.presentationFormat
            };
            if (renderPassState.multisample > 0) {
              att0.view = renderPassState.multiTexture.createView();
              att0.resolveTarget = this.ctx.context.getCurrentTexture().createView(viewDesc);
            } else {
              att0.view = this.ctx.context.getCurrentTexture().createView(viewDesc);
            }
          }
          return command.beginRenderPass(renderPassState.renderPassDescriptor);
        }
      }
      /**
       * Indirect indexed draw — the draw call counts (indexCount, instanceCount,
       * firstIndex, baseVertex, firstInstance) come from a GPU buffer at the
       * given offset. Companion of {@link drawIndexed}; used by GPU-driven
       * culling so the visibility decision and the draw submission both live
       * on the GPU.
       *
       * The `indirect-first-instance` adapter feature must be enabled if the
       * indirect buffer's `firstInstance` field is non-zero (Orillusion
       * requests it in Context3D init).
       */
      drawIndexedIndirect(encoder, indirectBuffer, indirectOffset) {
        encoder.drawIndexedIndirect(indirectBuffer, indirectOffset);
        this.drawCount++;
      }
      /**
       * Indexed draw with CPU-provided counts. No-ops when `indexCount` or
       * `instanceCount` is zero — WebGPU flags empty indexed draws as
       * unusual, and dynamic geometry starts with empty buffers.
       */
      drawIndexed(encoder, indexCount, instanceCount, firstIndex, baseVertex, firstInstance) {
        if (!indexCount || instanceCount !== void 0 && !instanceCount) return;
        encoder.drawIndexed(indexCount, instanceCount, firstIndex, baseVertex, firstInstance);
        this.drawCount++;
      }
      /** Non-indexed draw. No-ops when `vertexCount` or `instanceCount` is zero. */
      draw(encoder, vertexCount, instanceCount, firstVertex, firstInstance) {
        if (!vertexCount || instanceCount !== void 0 && !instanceCount) return;
        encoder.draw(vertexCount, instanceCount, firstVertex, firstInstance);
        this.drawCount++;
      }
      /** End the given render pass. */
      endPass(encoder) {
        encoder.insertDebugMarker("end");
        encoder.end();
      }
      /** Run a list of compute shaders inside a single compute pass on `command`. */
      computeCommand(command, computes) {
        let computePass = command.beginComputePass();
        for (let i = 0; i < computes.length; i++) {
          const compute = computes[i];
          compute.compute(computePass);
        }
        computePass.end();
      }
      /** Copy mip 0 of `source` into mip 0 of `dest`, sized to `dest`. */
      copyTexture(command, source, dest) {
        command.copyTextureToTexture(
          {
            texture: source.getGPUTexture(),
            mipLevel: 0,
            origin: { x: 0, y: 0, z: 0 }
          },
          {
            texture: dest.getGPUTexture(),
            mipLevel: 0,
            origin: { x: 0, y: 0, z: 0 }
          },
          {
            width: dest.width,
            height: dest.height,
            depthOrArrayLayers: 1
          }
        );
      }
    }
    _registerGpuContextFactory((ctx) => new GPUContextInstance(ctx));

    class VoxelConeTracingGI {
      _ctx;
      _resolution;
      constructor(ctx, resolution = 128) {
        this._ctx = ctx;
        this._resolution = resolution;
      }
      init() {
        void this._ctx;
        void this._resolution;
      }
      dispose() {
      }
    }

    class ClearDepthPass extends RenderGraphPass {
      name;
      _config;
      _target;
      _openOpts;
      constructor(config = {}) {
        super();
        this._config = config;
        this.name = config.name ?? "ClearDepthPass";
      }
      setup(b) {
        const rtName = this._config.rtName ?? MAIN_COLOR_RT;
        this._target = b.borrowRenderTarget(rtName);
        const colorLoadOps = new Array(this._target.colorTextures.length).fill("load");
        this._openOpts = {
          label: "ClearDepth",
          colorLoadOps,
          depthLoadOp: "clear"
        };
        if (this._config.after) {
          b.dependsOn(this._config.after);
        }
      }
      execute(ctx) {
        const opened = this._target.beginPass(ctx, this._openOpts);
        this._target.endPass(ctx, opened);
      }
    }

    class DeferredRendererJob extends RendererJob {
      constructor(_view) {
        super(_view);
        throw new Error(
          "DeferredRendererJob is a roadmap placeholder. Extend RendererJob and use `graph.add(...)` to compose your own deferred pipeline."
        );
      }
    }

    class GPUParticleSystem {
      _ctx;
      _maxParticles;
      _particleBuffer = null;
      _simulateCompute = null;
      constructor(ctx, maxParticles = 1e5) {
        this._ctx = ctx;
        this._maxParticles = maxParticles;
      }
      get particleBuffer() {
        return this._particleBuffer;
      }
      get maxParticles() {
        return this._maxParticles;
      }
      static STRIDE = 8;
      // floats per particle (4 + 4)
      init() {
        if (this._particleBuffer) return;
        this._particleBuffer = new StorageGPUBuffer(this._maxParticles * GPUParticleSystem.STRIDE);
        const data = new Float32Array(this._maxParticles * GPUParticleSystem.STRIDE);
        this._particleBuffer.setFloat32Array("data", data);
        this._particleBuffer.apply();
        const simulateCode = (
          /*wgsl*/
          `
            struct Particle {
                pos_life: vec4<f32>,
                vel_maxLife: vec4<f32>,
            };
            struct SimSettings {
                dt: f32,
                _pad0: f32, _pad1: f32, _pad2: f32,
            };
            @group(0) @binding(0) var<uniform> sim: SimSettings;
            @group(0) @binding(1) var<storage, read_write> particles: array<Particle>;

            @compute @workgroup_size(64, 1, 1)
            fn CsMain(@builtin(global_invocation_id) gid: vec3<u32>) {
                let i = gid.x;
                if (i >= arrayLength(&particles)) { return; }
                var p = particles[i];
                if (p.pos_life.w <= 0.0) { return; } // dead
                p.pos_life = vec4<f32>(p.pos_life.xyz + p.vel_maxLife.xyz * sim.dt, p.pos_life.w - sim.dt);
                particles[i] = p;
            }
        `
        );
        this._simulateCompute = new ComputeShader(simulateCode);
      }
    }

    let IrradianceDataReaderCompleteEvent = new CEvent("IrradianceDataReaderCompleteEvent");
    class DDGIIrradianceGPUBufferReader extends CEventDispatcher {
      readFlag = false;
      probeRenderer;
      opColorBuffer;
      opDepthBuffer;
      srcColorMap;
      srcDepthMap;
      /** CPU copy of the probe depth octahedral map. */
      opDepthArray;
      /** CPU copy of the probe irradiance (color) octahedral map. */
      opColorArray;
      /** Context3D this reader's GPU buffers are bound to. */
      _boundCtx = null;
      /** Allocate the readback buffers and subscribe to the GI pass's render-complete event. */
      initReader(ctx, probeRender, colorMap, depthMap) {
        this.probeRenderer = probeRender;
        this.srcColorMap = colorMap;
        this.srcDepthMap = depthMap;
        let giSetting = ctx.engine.setting.gi;
        let pixelCount = giSetting.octRTMaxSize * giSetting.octRTMaxSize;
        bindCtx(this, ctx);
        let device = this._boundCtx.device;
        this.opColorBuffer = device.createBuffer({
          size: pixelCount * 4 * 4,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ,
          mappedAtCreation: false
        });
        this.opColorArray = new Float32Array(pixelCount * 4);
        this.opDepthBuffer = device.createBuffer({
          size: pixelCount * 4 * 4,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ,
          mappedAtCreation: false
        });
        this.opDepthArray = new Float32Array(pixelCount * 4);
        this.probeRenderer.addEventListener(
          GIRenderCompleteEvent.type,
          () => {
            this.onProbeRenderComplete();
          },
          this
        );
      }
      async onProbeRenderComplete() {
        if (!this.readFlag) {
          this.readFlag = true;
          await this.read(this.srcColorMap.getGPUTexture(), this.opColorBuffer, this.opColorArray);
          await this.read(this.srcDepthMap.getGPUTexture(), this.opDepthBuffer, this.opDepthArray);
          this.readFlag = false;
          this.dispatchEvent(IrradianceDataReaderCompleteEvent);
        }
      }
      async read(srcTexture, dstBuffer, output) {
        const gpu = this._boundCtx.gpuContext;
        let command = gpu.beginCommandEncoder();
        command.copyTextureToBuffer({ texture: srcTexture }, { buffer: dstBuffer, bytesPerRow: srcTexture.width * 16 }, [srcTexture.width, srcTexture.height]);
        gpu.endCommandEncoder(command);
        await dstBuffer.mapAsync(GPUMapMode.READ);
        const copyArrayBuffer = dstBuffer.getMappedRange();
        output.set(new Float32Array(copyArrayBuffer), 0);
        dstBuffer.unmap();
      }
    }
    let irradianceDataReader = new DDGIIrradianceGPUBufferReader();

    class ZCullingCompute {
      computeShader;
      visibleBuffer;
      texture;
      constructor(ctx) {
        this.computeShader = new ComputeShader(ZPassShader_cs);
        this.visibleBuffer = new ComputeGPUBuffer(8192 * 2);
        this.computeShader.setStorageBuffer(`visibleBuffer`, this.visibleBuffer);
        this.texture = RTResourceMap.getTexture(ctx, RTResourceConfig.zBufferTexture_NAME);
        this.computeShader.setSamplerTexture(`zBufferTexture`, this.texture);
        this.computeShader.workerSizeX = Math.ceil(this.texture.width / 8);
        this.computeShader.workerSizeY = Math.ceil(this.texture.height / 8);
        this.computeShader.workerSizeZ = 1;
      }
      compute(view, occlusionSystem) {
        this.visibleBuffer.reset(true, 0);
        this.visibleBuffer.apply();
        const gpu = view.engine3D.context3D.gpuContext;
        let command = gpu.beginCommandEncoder();
        gpu.computeCommand(command, [this.computeShader]);
        this.visibleBuffer.readBuffer();
        occlusionSystem.zVisibleList = this.visibleBuffer.outFloat32Array;
      }
    }

    class BloomPost extends PostBase {
      /**
       * @internal
       */
      RT_BloomUp;
      RT_BloomDown;
      RT_threshold;
      // Separate RT for the final composite. RT_threshold used to double as
      // both the threshold-pass output and the post-pass scene+bloom output
      // in the same compute pass — same GPUTexture written by dispatch[0],
      // sampled by dispatch[1], rewritten by dispatch[last]. Spec-legal,
      // but some backends mishandle the implicit barrier on the workgroup
      // tile boundary and leave stale data persisted in the storage texture
      // — visible as hard-edged 8×8-aligned black squares that stick around
      // until the texture is destroyed. Giving the post pass its own RT
      // makes each storage texture single-role within the pass.
      RT_final;
      /**
       * @internal
       */
      thresholdCompute;
      downSampleComputes;
      upSampleComputes;
      postCompute;
      /**
       * @internal
       */
      bloomSetting;
      /**
       * @internal
       */
      rtFrame;
      constructor() {
        super();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.bloom.enable = true;
        this.createGUI();
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.bloom.enable = false;
        this.removeGUI();
      }
      createGUI() {
      }
      removeGUI() {
      }
      get downSampleBlurSize() {
        return this.setting.render.postProcessing.bloom.downSampleBlurSize;
      }
      set downSampleBlurSize(value) {
        this.setting.render.postProcessing.bloom.downSampleBlurSize = value;
      }
      get downSampleBlurSigma() {
        return this.setting.render.postProcessing.bloom.downSampleBlurSigma;
      }
      set downSampleBlurSigma(value) {
        this.setting.render.postProcessing.bloom.downSampleBlurSigma = value;
      }
      get upSampleBlurSize() {
        return this.setting.render.postProcessing.bloom.upSampleBlurSize;
      }
      set upSampleBlurSize(value) {
        this.setting.render.postProcessing.bloom.upSampleBlurSize = value;
      }
      get upSampleBlurSigma() {
        return this.setting.render.postProcessing.bloom.upSampleBlurSigma;
      }
      set upSampleBlurSigma(value) {
        this.setting.render.postProcessing.bloom.upSampleBlurSigma = value;
      }
      get luminanceThreshole() {
        return this.setting.render.postProcessing.bloom.luminanceThreshole;
      }
      set luminanceThreshole(value) {
        this.setting.render.postProcessing.bloom.luminanceThreshole = value;
      }
      get bloomIntensity() {
        return this.setting.render.postProcessing.bloom.bloomIntensity;
      }
      set bloomIntensity(value) {
        this.setting.render.postProcessing.bloom.bloomIntensity = value;
      }
      get hdr() {
        return this.setting.render.postProcessing.bloom.hdr;
      }
      set hdr(value) {
        this.setting.render.postProcessing.bloom.hdr = value;
      }
      createThreshouldCompute() {
        this.thresholdCompute = new ComputeShader(threshold);
        this.thresholdCompute.setSamplerTexture("inTex", this.getLastRenderTexture());
        this.thresholdCompute.setStorageTexture(`outTex`, this.RT_threshold);
        this.thresholdCompute.setUniformBuffer("bloomCfg", this.bloomSetting);
        this.thresholdCompute.workerSizeX = Math.ceil(this.RT_threshold.width / 8);
        this.thresholdCompute.workerSizeY = Math.ceil(this.RT_threshold.height / 8);
        this.thresholdCompute.workerSizeZ = 1;
      }
      createDownSampleComputes() {
        let setting = this.setting.render.postProcessing.bloom;
        const N = setting.downSampleStep;
        this.downSampleComputes = [];
        for (let i = 0; i < N; i++) {
          let compute = new ComputeShader(downSample);
          let dstTexture = this.RT_BloomDown[i];
          let srcTexture = i == 0 ? this.RT_threshold : this.RT_BloomDown[i - 1];
          compute.setSamplerTexture(`inTex`, srcTexture);
          compute.setStorageTexture(`outTex`, dstTexture);
          compute.setUniformBuffer("bloomCfg", this.bloomSetting);
          compute.workerSizeX = Math.ceil(dstTexture.width / 8);
          compute.workerSizeY = Math.ceil(dstTexture.height / 8);
          compute.workerSizeZ = 1;
          this.downSampleComputes.push(compute);
        }
      }
      createUpSampleComputes() {
        let setting = this.setting.render.postProcessing.bloom;
        const N = setting.downSampleStep;
        this.upSampleComputes = [];
        {
          let compute = new ComputeShader(upSample$1);
          let dstTexture = this.RT_BloomUp[0];
          let srcTexture = this.RT_BloomDown[N - 2];
          compute.setSamplerTexture(`_MainTex`, srcTexture);
          compute.setSamplerTexture(`_PrevMip`, this.RT_BloomDown[N - 1]);
          compute.setStorageTexture(`outTex`, dstTexture);
          compute.setUniformBuffer("bloomCfg", this.bloomSetting);
          compute.workerSizeX = Math.ceil(dstTexture.width / 8);
          compute.workerSizeY = Math.ceil(dstTexture.height / 8);
          compute.workerSizeZ = 1;
          this.upSampleComputes.push(compute);
        }
        for (let i = 1; i < N - 1; i++) {
          let compute = new ComputeShader(upSample$1);
          let dstTexture = this.RT_BloomUp[i];
          let srcTexture = this.RT_BloomDown[N - 2 - i];
          compute.setSamplerTexture(`_MainTex`, srcTexture);
          compute.setSamplerTexture(`_PrevMip`, this.RT_BloomUp[i - 1]);
          compute.setStorageTexture(`outTex`, dstTexture);
          compute.setUniformBuffer("bloomCfg", this.bloomSetting);
          compute.workerSizeX = Math.ceil(dstTexture.width / 8);
          compute.workerSizeY = Math.ceil(dstTexture.height / 8);
          compute.workerSizeZ = 1;
          this.upSampleComputes.push(compute);
        }
      }
      createPostCompute() {
        let setting = this.setting.render.postProcessing.bloom;
        const N = setting.downSampleStep;
        this.postCompute = new ComputeShader(post);
        this.postCompute.setSamplerTexture("_MainTex", this.getLastRenderTexture());
        this.postCompute.setSamplerTexture(`_BloomTex`, this.RT_BloomUp[N - 2]);
        this.postCompute.setStorageTexture(`outTex`, this.RT_final);
        this.postCompute.setUniformBuffer("bloomCfg", this.bloomSetting);
        this.postCompute.workerSizeX = Math.ceil(this.RT_final.width / 8);
        this.postCompute.workerSizeY = Math.ceil(this.RT_final.height / 8);
        this.postCompute.workerSizeZ = 1;
      }
      _createBloomResources() {
        let setting = this.setting.render.postProcessing.bloom;
        this.bloomSetting = new UniformGPUBuffer(4 * 2);
        let [screenWidth, screenHeight] = this._boundCtx.presentationSize;
        let usage = GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING;
        this.RT_threshold = new VirtualTexture(screenWidth, screenHeight, GPUTextureFormat.rgba16float, false, usage, 1, 0, 1, this._boundCtx);
        this.RT_final = new VirtualTexture(screenWidth, screenHeight, GPUTextureFormat.rgba16float, false, usage, 1, 0, 1, this._boundCtx);
        const N = setting.downSampleStep;
        {
          this.RT_BloomDown = [];
          let w = Math.ceil(screenWidth / 4);
          let h = Math.ceil(screenHeight / 4);
          for (let i = 0; i < N; i++) {
            this.RT_BloomDown[i] = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, usage, 1, 0, 1, this._boundCtx);
            w = Math.ceil(w / 2);
            h = Math.ceil(h / 2);
          }
        }
        {
          this.RT_BloomUp = [];
          for (let i = 0; i < N - 1; i++) {
            let w = this.RT_BloomDown[N - 2 - i].width;
            let h = this.RT_BloomDown[N - 2 - i].height;
            this.RT_BloomUp[i] = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, usage, 1, 0, 1, this._boundCtx);
          }
        }
        let bloomDesc = new RTDescriptor();
        bloomDesc.loadOp = `load`;
        this.rtFrame = new RTFrame([this.RT_final], [bloomDesc]);
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.thresholdCompute) {
          this._createBloomResources();
          this.createThreshouldCompute();
          this.createDownSampleComputes();
          this.createUpSampleComputes();
          this.createPostCompute();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
          this.rendererPassState.label = "Bloom";
        }
        this.bindUpstream(this.thresholdCompute, "inTex");
        this.bindUpstream(this.postCompute, "_MainTex");
        let cfg = this.setting.render.postProcessing.bloom;
        this.bloomSetting.setFloat("downSampleStep", cfg.downSampleStep);
        this.bloomSetting.setFloat("downSampleBlurSize", cfg.downSampleBlurSize);
        this.bloomSetting.setFloat("downSampleBlurSigma", cfg.downSampleBlurSigma);
        this.bloomSetting.setFloat("upSampleBlurSize", cfg.upSampleBlurSize);
        this.bloomSetting.setFloat("upSampleBlurSigma", cfg.upSampleBlurSigma);
        this.bloomSetting.setFloat("luminanceThreshole", cfg.luminanceThreshole);
        this.bloomSetting.setFloat("bloomIntensity", cfg.bloomIntensity);
        this.bloomSetting.setFloat("hdr", cfg.hdr);
        this.bloomSetting.apply();
        this._boundCtx.gpuContext.computeCommand(command, [this.thresholdCompute, ...this.downSampleComputes, ...this.upSampleComputes, this.postCompute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let cfg = this.setting.render.postProcessing.bloom;
        let [screenWidth, screenHeight] = this._boundCtx.presentationSize;
        this.RT_threshold.resize(screenWidth, screenHeight);
        this.RT_final.resize(screenWidth, screenHeight);
        const N = cfg.downSampleStep;
        let w = Math.ceil(screenWidth / 4);
        let h = Math.ceil(screenHeight / 4);
        for (let i = 0; i < N; i++) {
          this.RT_BloomDown[i].resize(w, h);
          w = Math.ceil(w / 2);
          h = Math.ceil(h / 2);
        }
        for (let i = 0; i < N - 1; i++) {
          let w2 = this.RT_BloomDown[N - 2 - i].width;
          let h2 = this.RT_BloomDown[N - 2 - i].height;
          this.RT_BloomUp[i].resize(w2, h2);
        }
        this.thresholdCompute.workerSizeX = Math.ceil(this.RT_threshold.width / 8);
        this.thresholdCompute.workerSizeY = Math.ceil(this.RT_threshold.height / 8);
        this.thresholdCompute.workerSizeZ = 1;
        for (let i = 0; i < N; i++) {
          let compute = this.downSampleComputes[i];
          let dstTexture = this.RT_BloomDown[i];
          compute.workerSizeX = Math.ceil(dstTexture.width / 8);
          compute.workerSizeY = Math.ceil(dstTexture.height / 8);
          compute.workerSizeZ = 1;
        }
        {
          let dstTexture = this.RT_BloomUp[0];
          let compute = this.upSampleComputes[0];
          compute.workerSizeX = Math.ceil(dstTexture.width / 8);
          compute.workerSizeY = Math.ceil(dstTexture.height / 8);
          compute.workerSizeZ = 1;
        }
        {
          for (let i = 1; i < N - 1; i++) {
            let dstTexture = this.RT_BloomUp[i];
            let compute = this.upSampleComputes[i];
            compute.workerSizeX = Math.ceil(dstTexture.width / 8);
            compute.workerSizeY = Math.ceil(dstTexture.height / 8);
            compute.workerSizeZ = 1;
          }
        }
        this.postCompute.workerSizeX = Math.ceil(this.RT_final.width / 8);
        this.postCompute.workerSizeY = Math.ceil(this.RT_final.height / 8);
        this.postCompute.workerSizeZ = 1;
      }
    }

    class ContactShadowPost extends PostBase {
      _outTex;
      _compute;
      _settingsBuffer;
      _rtFrame;
      constructor() {
        super();
      }
      onAttach(_view) {
        const cs = this.setting.shadow.contactShadow;
        if (cs) cs.enable = true;
      }
      onDetach(_view) {
        const cs = this.setting.shadow.contactShadow;
        if (cs) cs.enable = false;
      }
      _createResources() {
        const [w, h] = this._boundCtx.presentationSize;
        this._outTex = new VirtualTexture(
          w,
          h,
          GPUTextureFormat.rgba16float,
          false,
          GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING,
          1,
          0,
          1,
          this._boundCtx
        );
        this._outTex.name = "ContactShadowOut";
        const desc = new RTDescriptor();
        desc.loadOp = "load";
        this._rtFrame = new RTFrame([this._outTex], [desc]);
      }
      _createCompute(view) {
        ShaderLib.register("ContactShadow_cs", ContactShadow_cs);
        this._compute = new ComputeShader(ContactShadow_cs);
        this._settingsBuffer = new UniformGPUBuffer(8);
        this._compute.setUniformBuffer("csSettings", this._settingsBuffer);
        const lightEntries = GlobalBindGroup.getLightEntries(view.scene);
        this._compute.setStorageBuffer("lightBuffer", lightEntries.storageGPUBuffer);
        const rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, view.engine3D.context3D);
        this._compute.setSamplerTexture("gBufferTexture", rtFrame.getCompressGBufferTexture());
        this._compute.setSamplerTexture("inTex", this.getLastRenderTexture());
        this._compute.setStorageTexture("outTex", this._outTex);
        const cameraGroup = GlobalBindGroup.getCameraGroup(view.camera);
        this._compute.setUniformBuffer("globalUniform", cameraGroup.uniformGPUBuffer);
      }
      _uploadSettings() {
        const cs = this.setting.shadow.contactShadow;
        if (!cs) return;
        this._settingsBuffer.setFloat("maxStepCount", cs.maxStepCount ?? 16);
        this._settingsBuffer.setFloat("maxDistance", cs.maxDistance ?? 0.5);
        this._settingsBuffer.setFloat("thickness", cs.thickness ?? 0.05);
        this._settingsBuffer.setFloat("bias", cs.bias ?? 0.01);
        this._settingsBuffer.setFloat("intensity", cs.intensity ?? 1);
        this._settingsBuffer.setFloat("_pad0", 0);
        this._settingsBuffer.setFloat("_pad1", 0);
        this._settingsBuffer.setFloat("_pad2", 0);
        this._settingsBuffer.apply();
      }
      render(view, command) {
        if (!this._compute) {
          this._createResources();
          this._createCompute(view);
          this.onResize();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this._rtFrame, null);
          this.rendererPassState.label = "ContactShadow";
        }
        this.bindUpstream(this._compute, "inTex");
        this._uploadSettings();
        this._boundCtx.gpuContext.computeCommand(command, [this._compute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        const [w, h] = this._boundCtx.presentationSize;
        if (this._outTex) this._outTex.resize(w, h);
        if (this._compute) {
          this._compute.workerSizeX = Math.ceil(w / 8);
          this._compute.workerSizeY = Math.ceil(h / 8);
          this._compute.workerSizeZ = 1;
        }
      }
    }

    class DepthOfFieldPost extends PostBase {
      /**
       * @internal
       */
      blurTexture1;
      /**
       * @internal
       */
      blurTexture2;
      /**
       * @internal
       */
      blurComputes;
      /**
       * @internal
       */
      blurSettings;
      /**
       * @internal
       */
      outTexture;
      rtFrame;
      constructor() {
        super();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.depthOfView.enable = true;
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.depthOfView.enable = false;
      }
      get pixelOffset() {
        let setting = this.setting.render.postProcessing.depthOfView;
        return setting.pixelOffset;
      }
      set pixelOffset(value) {
        value = Math.max(0, value);
        let setting = this.setting.render.postProcessing.depthOfView;
        setting.pixelOffset = value;
      }
      get near() {
        let setting = this.setting.render.postProcessing.depthOfView;
        return setting.near;
      }
      set near(value) {
        value = Math.max(0, value);
        let setting = this.setting.render.postProcessing.depthOfView;
        setting.near = value;
      }
      get far() {
        let setting = this.setting.render.postProcessing.depthOfView;
        return setting.far;
      }
      set far(value) {
        value = Math.max(0, value);
        let setting = this.setting.render.postProcessing.depthOfView;
        setting.far = value;
      }
      createBlurCompute() {
        this.blurSettings = [];
        this.blurComputes = [];
        let cfg = this.setting.render.postProcessing.depthOfView;
        for (let i = 0; i < cfg.iterationCount; i++) {
          let blurSetting = new UniformGPUBuffer(4);
          let blurCompute = new ComputeShader(DepthOfView_cs);
          this.blurComputes.push(blurCompute);
          this.blurSettings.push(blurSetting);
          blurCompute.setUniformBuffer("blurSetting", blurSetting);
          let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
          blurCompute.setSamplerTexture(`gBufferTexture`, rtFrame.getCompressGBufferTexture());
          let input = i % 2 == 0 ? this.blurTexture1 : this.blurTexture2;
          let output = i % 2 == 1 ? this.blurTexture1 : this.blurTexture2;
          blurCompute.setSamplerTexture("inTex", input);
          blurCompute.setStorageTexture(`outTex`, output);
          blurCompute.workerSizeX = Math.ceil(this.blurTexture1.width / 8);
          blurCompute.workerSizeY = Math.ceil(this.blurTexture1.height / 8);
          blurCompute.workerSizeZ = 1;
          this.outTexture = output;
        }
        this.blurComputes[0].setSamplerTexture("inTex", this.getLastRenderTexture());
      }
      _createDofResources() {
        let presentationSize = this._boundCtx.presentationSize;
        let w = presentationSize[0];
        let h = presentationSize[1];
        this.blurTexture1 = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.blurTexture1.name = "dof1";
        let blur1Dec = new RTDescriptor();
        blur1Dec.clearValue = [0, 0, 0, 1];
        blur1Dec.loadOp = `clear`;
        this.blurTexture2 = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.blurTexture2.name = "dof2";
        let blur2Dec = new RTDescriptor();
        blur2Dec.clearValue = [0, 0, 0, 1];
        blur2Dec.loadOp = `clear`;
        this.rtFrame = new RTFrame([
          this.blurTexture1,
          this.blurTexture2
        ], [
          blur1Dec,
          blur2Dec
        ]);
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.blurComputes) {
          this._createDofResources();
          this.createBlurCompute();
          let standUniform = GlobalBindGroup.getCameraGroup(view.camera);
          for (let i = 0; i < this.blurComputes.length; i++) {
            const blurCompute = this.blurComputes[i];
            blurCompute.setUniformBuffer("globalUniform", standUniform.uniformGPUBuffer);
          }
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
        }
        this.bindUpstream(this.blurComputes[0], "inTex");
        let cfg = this.setting.render.postProcessing.depthOfView;
        cfg.far = Math.max(cfg.near, cfg.far) + 1e-4;
        for (let i = 0; i < cfg.iterationCount; i++) {
          let blurCompute = this.blurComputes[i];
          let blurSetting = this.blurSettings[i];
          blurSetting.setFloat("near", cfg.near);
          blurSetting.setFloat("far", cfg.far);
          blurSetting.setFloat("pixelOffset", (i + 1) * cfg.pixelOffset);
          blurSetting.apply();
          blurCompute.setStorageBuffer("blurSetting", blurSetting);
        }
        this._boundCtx.gpuContext.computeCommand(command, this.blurComputes);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let presentationSize = this._boundCtx.presentationSize;
        let w = presentationSize[0];
        let h = presentationSize[1];
        let cfg = this.setting.render.postProcessing.depthOfView;
        cfg.far = Math.max(cfg.near, cfg.far) + 1e-4;
        this.blurTexture1.resize(w, h);
        this.blurTexture2.resize(w, h);
        for (let i = 0; i < cfg.iterationCount; i++) {
          let compute = this.blurComputes[i];
          compute.workerSizeX = Math.ceil(this.blurTexture1.width / 8);
          compute.workerSizeY = Math.ceil(this.blurTexture1.height / 8);
          compute.workerSizeZ = 1;
        }
      }
    }

    class GBufferPost extends PostBase {
      /**
       * @internal
       */
      outTexture;
      rtFrame;
      view;
      gBufferTexture;
      testCompute;
      _state = 0;
      _state1 = 256;
      _state2 = 256;
      uniformBuffer;
      currentRenderTexture;
      constructor() {
        super();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.view = view;
      }
      /**
       * @internal
       */
      onDetach(view) {
      }
      /**
       * check state
       */
      set state(v) {
        this._state = v;
        this.uniformBuffer.setInt32("state", v);
        this.uniformBuffer.apply();
      }
      get state() {
        return this._state;
      }
      set size1(v) {
        this._state1 = v;
        this.uniformBuffer.setInt32("state1", v);
        this.uniformBuffer.apply();
      }
      get size1() {
        return this._state1;
      }
      set size2(v) {
        this._state2 = v;
        this.uniformBuffer.setInt32("state2", v);
        this.uniformBuffer.apply();
      }
      get size2() {
        return this._state2;
      }
      _createGBufferPostResources() {
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        this.currentRenderTexture = rtFrame.getColorTexture();
        this.gBufferTexture = rtFrame.getCompressGBufferTexture();
        let [w, h] = this._boundCtx.presentationSize;
        this.outTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.outTexture.name = "outTexture";
        let testDec = new RTDescriptor();
        testDec.loadOp = `load`;
        this.rtFrame = new RTFrame([
          this.outTexture
        ], [
          testDec
        ]);
      }
      createCompute() {
        this.uniformBuffer = new UniformGPUBuffer(4);
        this.uniformBuffer.setInt32("state", this._state);
        let globalUniform = GlobalBindGroup.getCameraGroup(this.view.camera);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        let gBufferTexture = rtFrame.getCompressGBufferTexture();
        let reflectionSetting = this.setting.reflectionSetting;
        let reflectionsGBufferFrame = GBufferFrame.getGBufferFrame(GBufferFrame.reflections_GBuffer, this._boundCtx, reflectionSetting.width, reflectionSetting.height);
        let reflectionsGBufferTexture = reflectionsGBufferFrame.getCompressGBufferTexture();
        let envMap = this.view.renderGraph?.pool.get(`_ReflectionCubeMap`);
        this.testCompute = new ComputeShader(TestComputeLoadBuffer);
        this.testCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
        this.testCompute.setUniformBuffer("uniformData", this.uniformBuffer);
        this.testCompute.setSamplerTexture("gBufferTexture", gBufferTexture);
        this.testCompute.setSamplerTexture("currentRenderTexture", this.currentRenderTexture);
        this.testCompute.setSamplerTexture("reflectionsGBufferTexture", reflectionsGBufferTexture);
        this.testCompute.setSamplerTexture("envMap", envMap);
        this.testCompute.setStorageTexture("outputTexture", this.outTexture);
        this.testCompute.workerSizeX = Math.ceil(this.outTexture.width / 16);
        this.testCompute.workerSizeY = Math.ceil(this.outTexture.height / 16);
        this.testCompute.workerSizeZ = 1;
      }
      render(view, command) {
      }
      compute(view) {
        if (!this.testCompute) {
          this._createGBufferPostResources();
          this.createCompute();
          this.onResize();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
          this.rendererPassState.label = "test";
        }
        let command = this._boundCtx.gpuContext.beginCommandEncoder();
        this._boundCtx.gpuContext.computeCommand(command, [this.testCompute]);
        this._boundCtx.gpuContext.endCommandEncoder(command);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        this.outTexture.resize(w, h);
        this.testCompute.workerSizeX = Math.ceil(this.outTexture.width / 16);
        this.testCompute.workerSizeY = Math.ceil(this.outTexture.height / 16);
      }
    }

    class GTAOPost extends PostBase {
      /**
       * @internal
       */
      gtaoTexture;
      /**
       * @internal
       */
      gtaoCompute;
      /**
       * @internal
       */
      gtaoSetting;
      /**
       * @internal
       */
      aoBuffer;
      /**
       * @internal
       */
      directionsBuffer;
      /**
       * @internal
       */
      directionsArray;
      rtFrame;
      constructor() {
        super();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.gtao.enable = true;
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.gtao.enable = false;
      }
      get maxDistance() {
        let setting = this.setting.render.postProcessing.gtao;
        return setting.maxDistance;
      }
      set maxDistance(value) {
        value = clamp$2(value, 0.1, 50);
        let setting = this.setting.render.postProcessing.gtao;
        setting.maxDistance = value;
      }
      get maxPixel() {
        let setting = this.setting.render.postProcessing.gtao;
        return setting.maxPixel;
      }
      set maxPixel(value) {
        value = clamp$2(value, 5, 100);
        let setting = this.setting.render.postProcessing.gtao;
        setting.maxPixel = value;
      }
      get darkFactor() {
        let setting = this.setting.render.postProcessing.gtao;
        return setting.darkFactor;
      }
      set darkFactor(value) {
        value = clamp$2(value, 0.01, 1);
        let setting = this.setting.render.postProcessing.gtao;
        setting.darkFactor = value;
      }
      get rayMarchSegment() {
        let setting = this.setting.render.postProcessing.gtao;
        return setting.rayMarchSegment;
      }
      set rayMarchSegment(value) {
        value = clamp$2(value, 4, 10);
        let setting = this.setting.render.postProcessing.gtao;
        setting.rayMarchSegment = value;
      }
      get multiBounce() {
        let setting = this.setting.render.postProcessing.gtao;
        return setting.multiBounce;
      }
      set multiBounce(value) {
        let setting = this.setting.render.postProcessing.gtao;
        setting.multiBounce = value;
      }
      get blendColor() {
        let setting = this.setting.render.postProcessing.gtao;
        return setting.blendColor;
      }
      set blendColor(value) {
        let setting = this.setting.render.postProcessing.gtao;
        setting.blendColor = value;
      }
      get usePosFloat32() {
        let setting = this.setting.render.postProcessing.gtao;
        return setting.usePosFloat32;
      }
      set usePosFloat32(value) {
        let setting = this.setting.render.postProcessing.gtao;
        setting.usePosFloat32 = value;
      }
      createCompute() {
        this.gtaoCompute = new ComputeShader(GTAO_cs);
        let gtaoSetting = new UniformGPUBuffer(4 * 2);
        this.gtaoCompute.setUniformBuffer("gtaoData", gtaoSetting);
        this.directionsArray = new Float32Array(8 * 2);
        this.directionsBuffer = new StorageGPUBuffer(8 * 2);
        this.directionsBuffer.setFloat32Array("array", this.randomDirection());
        this.directionsBuffer.apply();
        this.gtaoCompute.setStorageBuffer("directions", this.directionsBuffer);
        this.aoBuffer = new StorageGPUBuffer(this.gtaoTexture.width * this.gtaoTexture.height);
        this.gtaoCompute.setStorageBuffer("aoBuffer", this.aoBuffer);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        this.gtaoCompute.setSamplerTexture(`gBufferTexture`, rtFrame.getCompressGBufferTexture());
        this.gtaoCompute.setSamplerTexture("inTex", this.getLastRenderTexture());
        this.gtaoCompute.setStorageTexture(`outTex`, this.gtaoTexture);
        this.gtaoSetting = gtaoSetting;
      }
      _createGtaoResources() {
        let [w, h] = this._boundCtx.presentationSize;
        this.gtaoTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.gtaoTexture.name = "gtaoTex";
        let gtaoDec = new RTDescriptor();
        gtaoDec.loadOp = `load`;
        this.rtFrame = new RTFrame([this.gtaoTexture], [gtaoDec]);
      }
      randomCount = 0;
      randomDirection() {
        this.randomCount = 0;
        let offsetAngle = Math.PI * 2 * this.randomCount / 16;
        let angleSegment = Math.PI * 2 / 8;
        for (let i = 0; i < 8; i++) {
          let angle = offsetAngle + i * angleSegment;
          this.directionsArray[i * 2] = Math.sin(angle);
          this.directionsArray[i * 2 + 1] = Math.cos(angle);
        }
        return this.directionsArray;
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.gtaoCompute) {
          this._createGtaoResources();
          this.createCompute();
          this.onResize();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
          this.rendererPassState.label = "GTAO";
          let globalUniform = GlobalBindGroup.getCameraGroup(view.camera);
          this.gtaoCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
        }
        this.bindUpstream(this.gtaoCompute, "inTex");
        let cfg = this.setting.render.postProcessing.gtao;
        this.directionsBuffer.setFloat32Array("array", this.randomDirection());
        this.directionsBuffer.apply();
        let scaleFactor = 1 - 0.2 * (Time.frame % 2);
        let maxDistance = cfg.maxDistance * scaleFactor;
        let maxPixel = cfg.maxPixel * scaleFactor;
        this.gtaoSetting.setFloat("maxDistance", maxDistance);
        this.gtaoSetting.setFloat("maxPixel", maxPixel);
        this.gtaoSetting.setFloat("darkFactor", cfg.darkFactor);
        this.gtaoSetting.setFloat("rayMarchSegment", cfg.rayMarchSegment);
        let camera = view.camera;
        this.gtaoSetting.setFloat("cameraNear", camera.near);
        this.gtaoSetting.setFloat("cameraFar", camera.far);
        this.gtaoSetting.setFloat("multiBounce", cfg.multiBounce ? 1 : 0);
        this.gtaoSetting.setFloat("blendColor", cfg.blendColor ? 1 : 0);
        this.gtaoSetting.apply();
        this._boundCtx.gpuContext.computeCommand(command, [this.gtaoCompute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        this.gtaoTexture.resize(w, h);
        this.gtaoCompute.workerSizeX = Math.ceil(this.gtaoTexture.width / 8);
        this.gtaoCompute.workerSizeY = Math.ceil(this.gtaoTexture.height / 8);
        this.gtaoCompute.workerSizeZ = 1;
      }
    }

    class GlobalFog extends PostBase {
      /**
       * @internal
       */
      fogOpTexture;
      fogCompute;
      fogUniform;
      constructor() {
        super();
      }
      get fogSetting() {
        return this.setting.render.postProcessing.globalFog;
      }
      createCompute(view) {
        ShaderLib.register("GlobalFog_shader", GlobalFog_shader);
        this.fogCompute = new ComputeShader(GlobalFog_shader);
        this.fogUniform = new UniformGPUBuffer(4 * 5);
        this.fogCompute.setUniformBuffer("fogUniform", this.fogUniform);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, view.engine3D.context3D);
        this.fogCompute.setSamplerTexture("gBufferTexture", rtFrame.getCompressGBufferTexture());
        this.fogCompute.setSamplerTexture("inTex", rtFrame.getColorTexture());
        this._lastSkyTexture = this.getSkyTexture();
        this.fogCompute.setSamplerTexture(`prefilterMap`, this._lastSkyTexture);
        this.fogCompute.setStorageTexture(`outTex`, this.fogOpTexture);
        this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
        this.rendererPassState.label = "FOG";
        let lightUniformEntries = GlobalBindGroup.getLightEntries(view.scene);
        this.fogCompute.setStorageBuffer(`lightBuffer`, lightUniformEntries.storageGPUBuffer);
      }
      uploadSetting() {
        let fogUniform = this.fogUniform;
        let globalFog = this.fogSetting;
        fogUniform.setColor("fogColor", globalFog.fogColor);
        fogUniform.setFloat("fogType", globalFog.fogType);
        fogUniform.setFloat("fogHeightScale", globalFog.fogHeightScale);
        fogUniform.setFloat("start", globalFog.start);
        fogUniform.setFloat("end", globalFog.end);
        fogUniform.setFloat("density", globalFog.density);
        fogUniform.setFloat("ins", globalFog.ins);
        fogUniform.setFloat("falloff", globalFog.falloff);
        fogUniform.setFloat("rayLength", globalFog.rayLength);
        fogUniform.setFloat("scatteringExponent", globalFog.scatteringExponent);
        fogUniform.setFloat("dirHeightLine", globalFog.dirHeightLine);
        fogUniform.setFloat("skyFactor", globalFog.skyFactor);
        fogUniform.setFloat("skyRoughness", globalFog.skyRoughness);
        fogUniform.setFloat("overrideSkyFactor", globalFog.overrideSkyFactor);
        fogUniform.setFloat("isSkyHDR", 0);
        fogUniform.apply();
        this.fogCompute.setUniformBuffer("fogUniform", this.fogUniform);
      }
      rtFrame;
      _createFogTarget() {
        let [w, h] = this._boundCtx.presentationSize;
        this.fogOpTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.fogOpTexture.name = "fogTex";
        let fogDesc = new RTDescriptor();
        fogDesc.loadOp = `load`;
        this.rtFrame = new RTFrame([this.fogOpTexture], [fogDesc]);
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.globalFog.enable = true;
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.globalFog.enable = false;
      }
      set fogType(v) {
        this.fogSetting.fogType = v;
      }
      get fogType() {
        return this.fogSetting.fogType;
      }
      set fogHeightScale(v) {
        this.fogSetting.fogHeightScale = v;
      }
      get fogHeightScale() {
        return this.fogSetting.fogHeightScale;
      }
      set start(v) {
        this.fogSetting.start = v;
      }
      get start() {
        return this.fogSetting.start;
      }
      set end(v) {
        this.fogSetting.end = v;
      }
      get end() {
        return this.fogSetting.end;
      }
      set ins(v) {
        this.fogSetting.ins = v;
      }
      get ins() {
        return this.fogSetting.ins;
      }
      set density(v) {
        this.fogSetting.density = v;
      }
      get density() {
        return this.fogSetting.density;
      }
      set skyRoughness(v) {
        this.fogSetting.skyRoughness = v;
      }
      get skyRoughness() {
        return this.fogSetting.skyRoughness;
      }
      set skyFactor(v) {
        this.fogSetting.skyFactor = v;
      }
      get skyFactor() {
        return this.fogSetting.skyFactor;
      }
      set overrideSkyFactor(v) {
        this.fogSetting.overrideSkyFactor = v;
      }
      get overrideSkyFactor() {
        return this.fogSetting.overrideSkyFactor;
      }
      /**
       * @internal
       */
      get fogColor() {
        return this.fogSetting.fogColor;
      }
      /**
       * @internal
       */
      set fogColor(value) {
        this.fogSetting.fogColor.copy(value);
      }
      set falloff(v) {
        this.fogSetting.falloff = v;
      }
      get falloff() {
        return this.fogSetting.falloff;
      }
      set rayLength(v) {
        this.fogSetting.rayLength = v;
      }
      get rayLength() {
        return this.fogSetting.rayLength;
      }
      set scatteringExponent(v) {
        this.fogSetting.scatteringExponent = v;
      }
      get scatteringExponent() {
        return this.fogSetting.scatteringExponent;
      }
      set dirHeightLine(v) {
        this.fogSetting.dirHeightLine = v;
      }
      get dirHeightLine() {
        return this.fogSetting.dirHeightLine;
      }
      _lastSkyTexture;
      getSkyTexture(view) {
        let texture = Engine3D.resFor(view?.engine3D?.context3D).defaultSky;
        const sky = view ? EntityCollect.instance.getSky(view.scene) : void 0;
        if (sky instanceof SkyRenderer) {
          texture = sky.map;
        }
        return texture;
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.fogCompute) {
          this._createFogTarget();
          this.createCompute(view);
          this.onResize();
          let globalUniform = GlobalBindGroup.getCameraGroup(view.camera);
          this.fogCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
        }
        let skyTexture = this.getSkyTexture(view);
        if (skyTexture != this._lastSkyTexture) {
          this._lastSkyTexture = skyTexture;
          this.fogCompute.setSamplerTexture(`prefilterMap`, this._lastSkyTexture);
        }
        this.fogCompute.setUniformFloat("isSkyHDR", skyTexture.isHDRTexture ? 1 : 0);
        this.uploadSetting();
        this._boundCtx.gpuContext.computeCommand(command, [this.fogCompute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        this.fogOpTexture.resize(w, h);
        this.fogCompute.workerSizeX = Math.ceil(this.fogOpTexture.width / 8);
        this.fogCompute.workerSizeY = Math.ceil(this.fogOpTexture.height / 8);
        this.fogCompute.workerSizeZ = 1;
      }
    }

    class GodRayPost extends PostBase {
      /**
       * @internal
       */
      godRayTexture;
      /**
       * @internal
       */
      godRayCompute;
      /**
       * @internal
       */
      historyGodRayData;
      /**
       * @internal
       */
      godRaySetting;
      rtFrame;
      constructor() {
        super();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.godRay.enable = true;
        this.createGUI();
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.godRay.enable = false;
        this.removeGUI();
      }
      get blendColor() {
        return this.setting.render.postProcessing.godRay.blendColor;
      }
      set blendColor(value) {
        this.setting.render.postProcessing.godRay.blendColor = value;
      }
      get rayMarchCount() {
        return this.setting.render.postProcessing.godRay.rayMarchCount;
      }
      set rayMarchCount(value) {
        value = clamp$2(value, 8, 20);
        this.setting.render.postProcessing.godRay.rayMarchCount = value;
      }
      get scatteringExponent() {
        return this.setting.render.postProcessing.godRay.scatteringExponent;
      }
      set scatteringExponent(value) {
        value = clamp$2(value, 1, 40);
        this.setting.render.postProcessing.godRay.scatteringExponent = value;
      }
      get intensity() {
        return this.setting.render.postProcessing.godRay.intensity;
      }
      set intensity(value) {
        value = clamp$2(value, 0.01, 5);
        this.setting.render.postProcessing.godRay.intensity = value;
      }
      createGUI() {
      }
      removeGUI() {
      }
      createCompute(view) {
        this.godRayCompute = new ComputeShader(GodRay_cs);
        let godRaySetting = new UniformGPUBuffer(4 * 3);
        this.godRayCompute.setUniformBuffer("godRayUniform", godRaySetting);
        this.historyGodRayData = new StorageGPUBuffer(4 * this.godRayTexture.width * this.godRayTexture.height);
        this.godRayCompute.setStorageBuffer("historyGodRayData", this.historyGodRayData);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        this.godRayCompute.setSamplerTexture(`gBufferTexture`, rtFrame.getCompressGBufferTexture());
        this.godRayCompute.setSamplerTexture("inTex", this.getLastRenderTexture());
        this.godRayCompute.setStorageTexture(`outTex`, this.godRayTexture);
        const shadowMap = view.renderGraph?.pool.get(`_MainShadowMap`);
        if (shadowMap) {
          this.godRayCompute.setSamplerTexture(`shadowMap`, shadowMap);
        }
        this.godRaySetting = godRaySetting;
        this.onResize();
      }
      _createGodRayResources() {
        let presentationSize = this._boundCtx.presentationSize;
        let [w, h] = presentationSize;
        this.godRayTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.godRayTexture.name = "godRayTexture";
        let gtaoDec = new RTDescriptor();
        gtaoDec.loadOp = `load`;
        this.rtFrame = new RTFrame([this.godRayTexture], [gtaoDec]);
      }
      onResize() {
        let presentationSize = this._boundCtx.presentationSize;
        let [w, h] = presentationSize;
        this.godRayTexture.resize(w, h);
        this.historyGodRayData.resizeBuffer(4 * this.godRayTexture.width * this.godRayTexture.height);
        this.godRayCompute.setStorageBuffer("historyGodRayData", this.historyGodRayData);
        this.godRayCompute.workerSizeX = Math.ceil(this.godRayTexture.width / 8);
        this.godRayCompute.workerSizeY = Math.ceil(this.godRayTexture.height / 8);
        this.godRayCompute.workerSizeZ = 1;
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.godRayCompute) {
          this._createGodRayResources();
          this.createCompute(view);
          let lightUniformEntries = GlobalBindGroup.getLightEntries(view.scene);
          this.godRayCompute.setStorageBuffer("lightBuffer", lightUniformEntries.storageGPUBuffer);
          this.godRayCompute.setStorageBuffer("models", GlobalBindGroup.getModelMatrixBindGroup(view.engine3D.context3D).matrixBufferDst);
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
          this.rendererPassState.label = "GodRay";
          let globalUniform = GlobalBindGroup.getCameraGroup(view.camera);
          this.godRayCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
        }
        this.bindUpstream(this.godRayCompute, "inTex");
        let setting = this.setting.render.postProcessing.godRay;
        this.godRaySetting.setFloat("intensity", setting.intensity);
        this.godRaySetting.setFloat("rayMarchCount", setting.rayMarchCount);
        let presentationSize = this._boundCtx.presentationSize;
        let [w, h] = presentationSize;
        this.godRaySetting.setFloat("viewPortWidth", w);
        this.godRaySetting.setFloat("viewPortHeight", h);
        this.godRaySetting.setFloat("blendColor", setting.blendColor ? 1 : 0);
        this.godRaySetting.setFloat("scatteringExponent", setting.scatteringExponent);
        this.godRaySetting.apply();
        this._boundCtx.gpuContext.computeCommand(command, [this.godRayCompute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
    }

    class OutlinePostSlot {
      /** Entity indices included in this slot, padded with -1. */
      indexList;
      /** Outline color applied to every entity in this slot. */
      color;
      /** Number of valid entries in indexList. */
      count;
    }
    class OutlinePostData {
      //Supports up to 8 sets of colors
      /** Number of color slots (capped at 8). */
      SlotCount = 8;
      /** Maximum entities per slot. */
      MaxEntities = 16;
      /** Default outline color used when a slot is cleared. */
      defaultColor = new Color(0.2, 1, 1, 1);
      slots = [];
      dataDirty = true;
      constructor(groupCount = 8) {
        this.SlotCount = Math.max(1, Math.min(groupCount, this.SlotCount));
        for (let i = 0; i < this.SlotCount; i++) {
          let slot = this.slots[i] = new OutlinePostSlot();
          slot.indexList = new Float32Array(this.MaxEntities);
          slot.color = this.defaultColor.clone();
          slot.count = 0;
        }
      }
      /** Reset every slot to the default color and empty its entity list. */
      clear() {
        for (let i = 0; i < this.SlotCount; i++) {
          this.clearAt(i);
        }
      }
      /** Reset a single slot to the default color and empty its entity list. */
      clearAt(slotIndex) {
        this.dataDirty = true;
        let slot = this.slots[slotIndex];
        slot.color.copy(this.defaultColor);
        slot.indexList.fill(-1);
        slot.count = 0;
        return this;
      }
      /** Populate a slot with the given entity indices and outline color. */
      fillDataAt(slot, indexList, color) {
        this.dataDirty = true;
        let data = this.slots[slot];
        if (data) {
          data.indexList.fill(-1);
          for (let i = 0, c = indexList.length; i < c; i++) {
            data.indexList[i] = indexList[i];
          }
          data.count = indexList.length;
          data.color.copy(color);
        }
        return this;
      }
      /** Copy the dirty flag and slots into the target, then clear the dirty flag. */
      fetchData(target) {
        target.dirty = this.dataDirty;
        target.slots = this.slots;
        this.dataDirty = false;
        return this;
      }
    }
    let outlinePostData = new OutlinePostData();

    class OutlinePost extends PostBase {
      /**
       * @internal
       */
      outlineTex;
      /**
        * @internal
        */
      lowTex;
      /**
       * @internal
       */
      calcWeightCompute;
      /**
       * @internal
       */
      outlineCompute;
      /**
      * @internal
      */
      blendCompute;
      /**
       * @internal
       */
      outlineSetting;
      /**
       * @internal
       */
      slotsBuffer;
      /**
       * @internal
       */
      slotsArray;
      /**
       * @internal
       */
      entitiesArray;
      /**
       * @internal
       */
      entitiesBuffer;
      /**
       * @internal
       */
      weightBuffer;
      /**
       * @internal
       */
      lowTexSize;
      /**
       * @internal
       */
      oldOutlineColor;
      /**
       * @internal
       */
      rtFrame;
      view;
      constructor() {
        super();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.view = view;
        this.setting.render.postProcessing.outline.enable = true;
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.outline.enable = false;
      }
      set outlinePixel(value) {
        value = clamp$2(value, 0, 8);
        let cfg = this.setting.render.postProcessing.outline;
        if (cfg.outlinePixel != value) {
          cfg.outlinePixel = value;
        }
      }
      get outlinePixel() {
        return this.setting.render.postProcessing.outline.outlinePixel;
      }
      set fadeOutlinePixel(value) {
        let cfg = this.setting.render.postProcessing.outline;
        value = clamp$2(value, 0, 8);
        if (cfg.fadeOutlinePixel != value) {
          cfg.fadeOutlinePixel = value;
        }
      }
      get fadeOutlinePixel() {
        return this.setting.render.postProcessing.outline.fadeOutlinePixel;
      }
      set strength(value) {
        value = clamp$2(value, 0, 1);
        let cfg = this.setting.render.postProcessing.outline;
        if (cfg.strength != value) {
          cfg.strength = value;
        }
      }
      get strength() {
        return this.setting.render.postProcessing.outline.strength;
      }
      set useAddMode(value) {
        this.setting.render.postProcessing.outline.useAddMode = value;
      }
      get useAddMode() {
        return this.setting.render.postProcessing.outline.useAddMode;
      }
      createGUI() {
      }
      createCompute() {
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        this.calcWeightCompute = new ComputeShader(OutlineCalcOutline_cs);
        let globalUniform = GlobalBindGroup.getCameraGroup(this.view.camera);
        this.calcWeightCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
        this.calcWeightCompute.setStorageBuffer("outlineSetting", this.outlineSetting);
        this.calcWeightCompute.setStorageBuffer("slotsBuffer", this.slotsBuffer);
        this.calcWeightCompute.setStorageBuffer(`weightBuffer`, this.weightBuffer);
        this.calcWeightCompute.setStorageBuffer(`entitiesBuffer`, this.entitiesBuffer);
        this.calcWeightCompute.setSamplerTexture(`gBufferTexture`, rtFrame.getCompressGBufferTexture());
        this.calcWeightCompute.workerSizeX = Math.ceil(this.lowTex.width / 8);
        this.calcWeightCompute.workerSizeY = Math.ceil(this.lowTex.height / 8);
        this.calcWeightCompute.workerSizeZ = 1;
        this.outlineCompute = new ComputeShader(Outline_cs);
        this.outlineCompute.setStorageBuffer("outlineSetting", this.outlineSetting);
        this.outlineCompute.setStorageBuffer("slotsBuffer", this.slotsBuffer);
        this.outlineCompute.setStorageBuffer(`weightBuffer`, this.weightBuffer);
        this.outlineCompute.setStorageBuffer(`oldOutlineColor`, this.oldOutlineColor);
        this.outlineCompute.setStorageTexture(`lowTex`, this.lowTex);
        this.outlineCompute.workerSizeX = Math.ceil(this.lowTex.width / 8);
        this.outlineCompute.workerSizeY = Math.ceil(this.lowTex.height / 8);
        this.outlineCompute.workerSizeZ = 1;
        this.blendCompute = new ComputeShader(OutLineBlendColor_cs);
        this.blendCompute.setStorageBuffer("outlineSetting", this.outlineSetting);
        this.blendCompute.setSamplerTexture("inTex", this.getLastRenderTexture());
        this.blendCompute.setSamplerTexture(`lowTex`, this.lowTex);
        this.blendCompute.setStorageTexture(`outlineTex`, this.outlineTex);
        this.blendCompute.workerSizeX = Math.ceil(this.outlineTex.width / 8);
        this.blendCompute.workerSizeY = Math.ceil(this.outlineTex.height / 8);
        this.blendCompute.workerSizeZ = 1;
      }
      _createOutlineResources() {
        let presentationSize = this._boundCtx.presentationSize;
        let w = presentationSize[0];
        let h = presentationSize[1];
        let textureScale = this.setting.render.postProcessing.outline.textureScale;
        this.lowTexSize = new Vector2(Math.ceil(w * textureScale), Math.ceil(h * textureScale));
        this.lowTex = new VirtualTexture(this.lowTexSize.x, this.lowTexSize.y, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.lowTex.name = "lowTex";
        let lowDec = new RTDescriptor();
        lowDec.clearValue = [0, 0, 0, 1];
        lowDec.loadOp = `clear`;
        this.outlineTex = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.outlineTex.name = "outlineTex";
        let outDec = new RTDescriptor();
        outDec.clearValue = [0, 0, 0, 1];
        outDec.loadOp = `clear`;
        this.rtFrame = new RTFrame([this.outlineTex], [outDec]);
        this.outlineSetting = new UniformGPUBuffer(8);
        this.weightBuffer = new StorageGPUBuffer(this.lowTexSize.x * this.lowTexSize.y * 4, GPUBufferUsage.COPY_SRC);
        this.oldOutlineColor = new StorageGPUBuffer(this.lowTexSize.x * this.lowTexSize.y * 4, GPUBufferUsage.COPY_SRC);
        this.slotsArray = new Float32Array(outlinePostData.SlotCount * 4);
        this.slotsBuffer = new StorageGPUBuffer(this.slotsArray.length);
        this.slotsBuffer.setFloat32Array("slotsArray", this.slotsArray);
        this.slotsBuffer.apply();
        this.entitiesArray = new Float32Array(outlinePostData.SlotCount * outlinePostData.MaxEntities);
        this.entitiesBuffer = new StorageGPUBuffer(this.entitiesArray.length);
        this.entitiesBuffer.setFloat32Array("entitiesArray", this.entitiesArray);
        this.slotsBuffer.apply();
        this.fetchData ||= {};
      }
      fetchData;
      fetchOutlineData() {
        outlinePostData.fetchData(this.fetchData);
        if (this.fetchData.dirty) {
          let slotCount = outlinePostData.SlotCount;
          let maxEntities = outlinePostData.MaxEntities;
          for (let i = 0; i < slotCount; i++) {
            let offset = 4 * i;
            let slot = this.fetchData.slots[i];
            this.slotsArray[offset + 0] = slot.color.r;
            this.slotsArray[offset + 1] = slot.color.g;
            this.slotsArray[offset + 2] = slot.color.b;
            this.slotsArray[offset + 3] = slot.count;
            offset = maxEntities * i;
            this.entitiesArray.set(slot.indexList, offset);
          }
          this.slotsBuffer.setFloat32Array("slotsArray", this.slotsArray);
          this.slotsBuffer.apply();
          this.entitiesBuffer.setFloat32Array("entitiesArray", this.entitiesArray);
          this.entitiesBuffer.apply();
        }
      }
      computeList;
      /**
       * @internal
       */
      render(view, command) {
        if (!this.calcWeightCompute) {
          this._createOutlineResources();
          this.createCompute();
          this.createGUI();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
        }
        this.bindUpstream(this.blendCompute, "inTex");
        this.computeList ||= [this.calcWeightCompute, this.outlineCompute, this.blendCompute];
        let cfg = this.setting.render.postProcessing.outline;
        this.outlineSetting.setFloat("strength", cfg.strength);
        this.outlineSetting.setFloat("useAddMode", cfg.useAddMode ? 1 : 0);
        this.outlineSetting.setFloat("outlinePixel", cfg.outlinePixel);
        this.outlineSetting.setFloat("fadeOutlinePixel", cfg.fadeOutlinePixel);
        this.outlineSetting.setFloat("lowTexWidth", this.lowTexSize.x);
        this.outlineSetting.setFloat("lowTexHeight", this.lowTexSize.y);
        this.outlineSetting.apply();
        this.fetchOutlineData();
        this._boundCtx.gpuContext.computeCommand(command, this.computeList);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let presentationSize = this._boundCtx.presentationSize;
        let w = presentationSize[0];
        let h = presentationSize[1];
        let textureScale = this.setting.render.postProcessing.outline.textureScale;
        this.lowTexSize = new Vector2(Math.ceil(w * textureScale), Math.ceil(h * textureScale));
        this.lowTex.resize(this.lowTexSize.x, this.lowTexSize.y);
        this.outlineTex.resize(w, h);
        this.weightBuffer.resizeBuffer(this.lowTexSize.x * this.lowTexSize.y * 4);
        this.oldOutlineColor.resizeBuffer(this.lowTexSize.x * this.lowTexSize.y * 4);
        this.calcWeightCompute.workerSizeX = Math.ceil(this.lowTex.width / 8);
        this.calcWeightCompute.workerSizeY = Math.ceil(this.lowTex.height / 8);
        this.calcWeightCompute.workerSizeZ = 1;
        this.outlineCompute.workerSizeX = Math.ceil(this.lowTex.width / 8);
        this.outlineCompute.workerSizeY = Math.ceil(this.lowTex.height / 8);
        this.outlineCompute.workerSizeZ = 1;
        this.blendCompute.workerSizeX = Math.ceil(this.outlineTex.width / 8);
        this.blendCompute.workerSizeY = Math.ceil(this.outlineTex.height / 8);
        this.blendCompute.workerSizeZ = 1;
      }
    }

    class SSGIPost extends PostBase {
      /**
       * @internal
       */
      outTexture;
      newTexture;
      oldTexture;
      combineTexture;
      /**
       * @internal
       */
      ssgiCompute;
      delayCompute;
      combineCompute;
      rtFrame;
      textureScaleSmallCompute;
      textureScaleBigCompute;
      view;
      colorTexture;
      posTexture;
      normalTexture;
      gBufferTexture;
      lastPosTexture;
      downSampleCofe = 1;
      // public downSampleCofe: number = 0.5;
      debugChanal = "0";
      updateBuffer;
      constructor() {
        super();
        this.updateBuffer = new StorageGPUBuffer(8 * 4);
        this.updateBuffer.setFloat("frameCount", 10);
        this.updateBuffer.setFloat("indirectIns", 1.5);
        this.updateBuffer.setFloat("delay", 0.02);
        this.updateBuffer.setFloat("colorIns", 1);
        this.updateBuffer.setFloat("d1", 0.03);
        this.updateBuffer.apply();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.view = view;
        view.camera.transform.onPositionChange = view.camera.transform.onPositionChange ? mergeFunctions(view.camera.transform.onPositionChange, (a, b) => this.onCameraChange(a, b)) : (a, b) => this.onCameraChange(a, b);
      }
      onCameraChange(oldPos, newPos) {
        let p = Vector3.distance(oldPos, newPos);
        p = Math.min(0.45, p) + 0.01;
        this.updateBuffer.setFloat("delay", p);
      }
      /**
       * @internal
       */
      onDetach(view) {
      }
      set ins(v) {
        this.updateBuffer.setFloat("indirectIns", v);
        this.updateBuffer.apply();
      }
      get ins() {
        return this.updateBuffer.getFloat("indirectIns");
      }
      set delay(v) {
        this.updateBuffer.setFloat("delay", v);
        this.updateBuffer.apply();
      }
      get delay() {
        return this.updateBuffer.getFloat("delay");
      }
      set colorIns(v) {
        this.updateBuffer.setFloat("colorIns", v);
        this.updateBuffer.apply();
      }
      get colorIns() {
        return this.updateBuffer.getFloat("colorIns");
      }
      set frameCount(v) {
        this.updateBuffer.setFloat("frameCount", v);
        this.updateBuffer.apply();
      }
      get frameCount() {
        return this.updateBuffer.getFloat("frameCount");
      }
      set d1(v) {
        this.updateBuffer.setFloat("d1", v);
        this.updateBuffer.apply();
      }
      get d1() {
        return this.updateBuffer.getFloat("d1");
      }
      _createSsgiResources() {
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        this.gBufferTexture = rtFrame.getCompressGBufferTexture();
        let presentationSize = this._boundCtx.presentationSize;
        let w = presentationSize[0];
        let h = presentationSize[1];
        this.lastPosTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.lastPosTexture.name = "lastPosTexture";
        this.outTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.outTexture.name = "outTexture";
        let inW = Math.floor(w * this.downSampleCofe);
        let inH = Math.floor(h * this.downSampleCofe);
        this.newTexture = new VirtualTexture(inW, inH, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.newTexture.name = "newTexture";
        this.oldTexture = new VirtualTexture(inW, inH, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.oldTexture.name = "oldTexture";
        this.combineTexture = new VirtualTexture(inW, inH, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.combineTexture.name = "combineTexture";
        let ssgiDec = new RTDescriptor();
        ssgiDec.loadOp = `load`;
        this.rtFrame = new RTFrame([
          this.outTexture
        ], [
          ssgiDec
        ]);
      }
      createCompute() {
        this.ssgiCompute = new ComputeShader(SSGI2_cs);
        this.delayCompute = new ComputeShader(Denoising_cs);
        this.combineCompute = new ComputeShader(Combine_cs);
        let globalUniform = GlobalBindGroup.getCameraGroup(this.view.camera);
        {
          this.ssgiCompute.setSamplerTexture(`gBufferTexture`, this.gBufferTexture);
          this.ssgiCompute.setSamplerTexture(`combineTexture`, this.combineTexture);
          this.ssgiCompute.setSamplerTexture(`oldTexture`, this.oldTexture);
          this.ssgiCompute.setStorageTexture(`newTexture`, this.newTexture);
          this.ssgiCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
          this.ssgiCompute.setStorageBuffer("updateBuffer", this.updateBuffer);
          this.ssgiCompute.setSamplerTexture("inTex", this.getLastRenderTexture());
        }
        {
          this.delayCompute.setSamplerTexture(`newTexture`, this.newTexture);
          this.delayCompute.setSamplerTexture(`oldTexture`, this.oldTexture);
          this.delayCompute.setStorageTexture(`combineTexture`, this.combineTexture);
          this.delayCompute.setStorageBuffer("updateBuffer", this.updateBuffer);
        }
        {
          this.combineCompute.setSamplerTexture(`inputBTexture`, this.combineTexture);
          this.combineCompute.setSamplerTexture(`gBufferTexture`, this.gBufferTexture);
          this.combineCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
          this.combineCompute.setStorageTexture(`outTexture`, this.outTexture);
          this.combineCompute.setStorageBuffer(`updateBuffer`, this.updateBuffer);
        }
        {
          this.textureScaleBigCompute = new TextureScaleCompute();
          this.textureScaleBigCompute.setInputes(
            null,
            // this.colorTexture,
            [this.combineTexture],
            [this.outTexture]
          );
        }
      }
      render(view, command) {
      }
      frame = 0;
      compute(view) {
        if (!this.ssgiCompute) {
          this._createSsgiResources();
          this.createCompute();
          this.onResize();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
          this.rendererPassState.label = "SSGI";
        }
        this.bindUpstream(this.ssgiCompute, "inTex");
        this.frameCount = this.frame;
        this.frame++;
        const gpu = view.engine3D.context3D.gpuContext;
        let command = gpu.beginCommandEncoder();
        switch (parseInt(this.debugChanal)) {
          case 0:
            gpu.copyTexture(command, this.combineTexture, this.oldTexture);
            gpu.computeCommand(command, [this.ssgiCompute, this.delayCompute, this.combineCompute]);
            break;
          case 1:
            gpu.copyTexture(command, this.posTexture, this.lastPosTexture);
            gpu.copyTexture(command, this.lastPosTexture, this.outTexture);
            break;
          case 2:
            gpu.copyTexture(command, this.normalTexture, this.outTexture);
            break;
          case 3:
            gpu.copyTexture(command, this.posTexture, this.outTexture);
            break;
          case 4:
            gpu.copyTexture(command, this.colorTexture, this.outTexture);
            break;
          case 5:
            gpu.copyTexture(command, this.gBufferTexture, this.outTexture);
            break;
        }
        gpu.lastRenderPassState = this.rendererPassState;
        this.updateBuffer.setFloat("delay", 0.01);
      }
      onResize() {
        let presentationSize = this._boundCtx.presentationSize;
        let w = presentationSize[0];
        let h = presentationSize[1];
        this.outTexture.resize(w, h);
        this.ssgiCompute.workerSizeX = Math.ceil(this.newTexture.width / 16);
        this.ssgiCompute.workerSizeY = Math.ceil(this.newTexture.height / 16);
        this.ssgiCompute.workerSizeZ = 1;
        this.delayCompute.workerSizeX = Math.ceil(this.combineTexture.width / 16);
        this.delayCompute.workerSizeY = Math.ceil(this.combineTexture.height / 16);
        this.delayCompute.workerSizeZ = 1;
        this.combineCompute.workerSizeX = Math.ceil(this.outTexture.width / 16);
        this.combineCompute.workerSizeY = Math.ceil(this.outTexture.height / 16);
        this.combineCompute.workerSizeZ = 1;
      }
    }

    class SSGIPost2 extends PostBase {
      _outTex;
      _compute;
      _settingsBuffer;
      _rtFrame;
      _createResources() {
        const [w, h] = this._boundCtx.presentationSize;
        this._outTex = new VirtualTexture(
          w,
          h,
          GPUTextureFormat.rgba16float,
          false,
          GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING,
          1,
          0,
          1,
          this._boundCtx
        );
        this._outTex.name = "SSGIOut";
        const desc = new RTDescriptor();
        desc.loadOp = "load";
        this._rtFrame = new RTFrame([this._outTex], [desc]);
      }
      _createCompute(view) {
        ShaderLib.register("SSGI_cs", SSGI_cs);
        this._compute = new ComputeShader(SSGI_cs);
        this._settingsBuffer = new UniformGPUBuffer(4);
        this._compute.setUniformBuffer("ssgiSettings", this._settingsBuffer);
        const rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, view.engine3D.context3D);
        this._compute.setSamplerTexture("gBufferTexture", rtFrame.getCompressGBufferTexture());
        this._compute.setSamplerTexture("inTex", this.getLastRenderTexture());
        this._compute.setStorageTexture("outTex", this._outTex);
        const cameraGroup = GlobalBindGroup.getCameraGroup(view.camera);
        this._compute.setUniformBuffer("globalUniform", cameraGroup.uniformGPUBuffer);
      }
      render(view, command) {
        if (!this._compute) {
          this._createResources();
          this._createCompute(view);
          this.onResize();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this._rtFrame, null);
          this.rendererPassState.label = "SSGI";
        }
        this.bindUpstream(this._compute, "inTex");
        const cfg = this.setting.render.postProcessing.ssgi || {};
        this._settingsBuffer.setFloat("intensity", cfg.intensity ?? 0.5);
        this._settingsBuffer.setFloat("radius", cfg.radius ?? 50);
        this._settingsBuffer.setFloat("sliceCount", cfg.sliceCount ?? 4);
        this._settingsBuffer.setFloat("stepCount", cfg.stepCount ?? 8);
        this._settingsBuffer.apply();
        this._boundCtx.gpuContext.computeCommand(command, [this._compute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        const [w, h] = this._boundCtx.presentationSize;
        if (this._outTex) this._outTex.resize(w, h);
        if (this._compute) {
          this._compute.workerSizeX = Math.ceil(w / 8);
          this._compute.workerSizeY = Math.ceil(h / 8);
          this._compute.workerSizeZ = 1;
        }
      }
    }

    class SSRPost extends PostBase {
      SSR_RayTraceCompute;
      SSR_IS_Compute;
      SSR_Blend_Compute;
      /**
       * @internal
       */
      isRetTexture;
      /**
       * @internal
       */
      finalTexture;
      /**
       * @internal
       */
      ssrUniformBuffer;
      /**
       * @internal
       */
      rayTraceData;
      /**
       * @internal
       */
      ssrColorData;
      /**
       * @internal
       */
      rtFrame;
      historyPosition;
      view;
      /**
       * @internal
       */
      onAttach(view) {
        this.view = view;
        this.setting.render.postProcessing.ssr.enable = true;
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.ssr.enable = false;
      }
      reflectionRatio = 0.5;
      //sqrt
      get fadeEdgeRatio() {
        let setting = this.setting.render.postProcessing.ssr;
        return setting.fadeEdgeRatio;
      }
      set fadeEdgeRatio(value) {
        value = clamp$2(value, 0, 1);
        let setting = this.setting.render.postProcessing.ssr;
        setting.fadeEdgeRatio = value;
      }
      get rayMarchRatio() {
        let setting = this.setting.render.postProcessing.ssr;
        return setting.rayMarchRatio;
      }
      set rayMarchRatio(value) {
        value = clamp$2(value, 0, 1);
        let setting = this.setting.render.postProcessing.ssr;
        setting.rayMarchRatio = value;
      }
      get roughnessThreshold() {
        let setting = this.setting.render.postProcessing.ssr;
        return setting.roughnessThreshold;
      }
      set roughnessThreshold(value) {
        value = clamp$2(value, 0, 1);
        let setting = this.setting.render.postProcessing.ssr;
        setting.roughnessThreshold = value;
      }
      get fadeDistanceMin() {
        let setting = this.setting.render.postProcessing.ssr;
        return setting.fadeDistanceMin;
      }
      set fadeDistanceMin(value) {
        value = clamp$2(value, 0, 1e4);
        let setting = this.setting.render.postProcessing.ssr;
        setting.fadeDistanceMin = value;
      }
      get fadeDistanceMax() {
        let setting = this.setting.render.postProcessing.ssr;
        return setting.fadeDistanceMax;
      }
      set fadeDistanceMax(value) {
        value = clamp$2(value, 0, 1e4);
        let setting = this.setting.render.postProcessing.ssr;
        setting.fadeDistanceMax = value;
      }
      get powDotRN() {
        let setting = this.setting.render.postProcessing.ssr;
        return setting.powDotRN;
      }
      set powDotRN(value) {
        value = clamp$2(value, 0, 1);
        let setting = this.setting.render.postProcessing.ssr;
        setting.powDotRN = value;
      }
      createRayTraceShader() {
        let globalUniform = GlobalBindGroup.getCameraGroup(this.view.camera);
        this.SSR_RayTraceCompute = new ComputeShader(SSR_RayTrace_cs);
        this.SSR_RayTraceCompute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
        this.SSR_RayTraceCompute.setUniformBuffer("ssrUniform", this.ssrUniformBuffer);
        this.SSR_RayTraceCompute.setStorageBuffer(`rayTraceBuffer`, this.rayTraceData);
        this.SSR_RayTraceCompute.setStorageBuffer(`historyPosition`, this.historyPosition);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        let gBufferTexture = rtFrame.getCompressGBufferTexture();
        this.SSR_RayTraceCompute.setSamplerTexture("gBufferTexture", gBufferTexture);
        const sky = EntityCollect.instance.getSky(this.view?.scene);
        if (sky instanceof SkyRenderer)
          this.SSR_RayTraceCompute.setSamplerTexture(`prefilterMap`, sky.map);
        this.SSR_RayTraceCompute.workerSizeX = Math.ceil(this.isRetTexture.width / 8);
        this.SSR_RayTraceCompute.workerSizeY = Math.ceil(this.isRetTexture.height / 8);
        this.SSR_RayTraceCompute.workerSizeZ = 1;
      }
      createISShader() {
        this.SSR_IS_Compute = new ComputeShader(SSR_IS_cs);
        this.SSR_IS_Compute.setStorageBuffer("ssrUniform", this.ssrUniformBuffer);
        this.SSR_IS_Compute.setStorageBuffer(`rayTraceBuffer`, this.rayTraceData);
        this.SSR_IS_Compute.setStorageBuffer(`ssrColorData`, this.ssrColorData);
        this.SSR_IS_Compute.setStorageBuffer(`historyPosition`, this.historyPosition);
        this.SSR_IS_Compute.setSamplerTexture(`colorMap`, this.getLastRenderTexture());
        this.SSR_IS_Compute.setStorageTexture(`outTex`, this.isRetTexture);
        this.SSR_IS_Compute.workerSizeX = Math.ceil(this.isRetTexture.width / 8);
        this.SSR_IS_Compute.workerSizeY = Math.ceil(this.isRetTexture.height / 8);
        this.SSR_IS_Compute.workerSizeZ = 1;
      }
      createBlendShader(input) {
        let globalUniform = GlobalBindGroup.getCameraGroup(this.view.camera);
        this.SSR_Blend_Compute = new ComputeShader(SSR_BlendColor_cs);
        this.SSR_Blend_Compute.setStorageBuffer(`rayTraceBuffer`, this.rayTraceData);
        this.SSR_Blend_Compute.setUniformBuffer("globalUniform", globalUniform.uniformGPUBuffer);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        let gBufferTexture = rtFrame.getCompressGBufferTexture();
        this.SSR_Blend_Compute.setSamplerTexture("gBufferTexture", gBufferTexture);
        this.SSR_Blend_Compute.setSamplerTexture("colorMap", this.getLastRenderTexture());
        this.SSR_Blend_Compute.setSamplerTexture(`ssrMap`, input);
        this.SSR_Blend_Compute.setStorageTexture(`outTex`, this.finalTexture);
        this.SSR_Blend_Compute.workerSizeX = Math.ceil(this.finalTexture.width / 8);
        this.SSR_Blend_Compute.workerSizeY = Math.ceil(this.finalTexture.height / 8);
        this.SSR_Blend_Compute.workerSizeZ = 1;
      }
      _createSsrResources() {
        let [w, h] = this._boundCtx.presentationSize;
        this.finalTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.finalTexture.name = "ssrOutTex";
        let rtDec = new RTDescriptor();
        rtDec.clearValue = [0, 0, 0, 0];
        rtDec.loadOp = `clear`;
        let ssrWidth = Math.ceil(w * this.setting.render.postProcessing.ssr.pixelRatio);
        let ssrHeight = Math.ceil(h * this.setting.render.postProcessing.ssr.pixelRatio);
        this.isRetTexture = new VirtualTexture(ssrWidth, ssrHeight, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.isRetTexture.name = "ssrTextureIn";
        let isRetDec = new RTDescriptor();
        isRetDec.clearValue = [0, 0, 0, 0];
        isRetDec.loadOp = `clear`;
        this.rtFrame = new RTFrame([
          this.finalTexture,
          this.isRetTexture
        ], [
          rtDec,
          isRetDec
        ]);
        this.rayTraceData = new StorageGPUBuffer(ssrWidth * ssrHeight * 8, GPUBufferUsage.COPY_SRC);
        this.ssrColorData = new StorageGPUBuffer(ssrWidth * ssrHeight * 4, GPUBufferUsage.COPY_SRC);
        this.historyPosition = new StorageGPUBuffer(ssrWidth * ssrHeight * 4, GPUBufferUsage.COPY_SRC);
        this.ssrUniformBuffer = new UniformGPUBuffer(4 * 8);
        this.ssrUniformBuffer.setFloat("ssrBufferSizeX", this.isRetTexture.width);
        this.ssrUniformBuffer.setFloat("ssrBufferSizeY", this.isRetTexture.height);
        this.ssrUniformBuffer.setFloat("colorMapSizeX", this.finalTexture.width);
        this.ssrUniformBuffer.setFloat("colorMapSizeY", this.finalTexture.height);
        this.ssrUniformBuffer.apply();
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.SSR_RayTraceCompute) {
          this._createSsrResources();
          this.createISShader();
          this.createRayTraceShader();
          this.createBlendShader(this.isRetTexture);
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
          let standUniform = GlobalBindGroup.getCameraGroup(view.camera);
          this.SSR_RayTraceCompute.setUniformBuffer("standUniform", standUniform.uniformGPUBuffer);
        }
        this.bindUpstream(this.SSR_IS_Compute, "colorMap");
        this.bindUpstream(this.SSR_Blend_Compute, "colorMap");
        let setting = this.setting.render.postProcessing.ssr;
        this.ssrUniformBuffer.setFloat("fadeEdgeRatio", setting.fadeEdgeRatio);
        this.ssrUniformBuffer.setFloat("rayMarchRatio", setting.rayMarchRatio);
        this.ssrUniformBuffer.setFloat("fadeDistanceMin", setting.fadeDistanceMin);
        this.ssrUniformBuffer.setFloat("fadeDistanceMax", setting.fadeDistanceMax);
        this.ssrUniformBuffer.setFloat("mixThreshold", setting.mixThreshold);
        this.ssrUniformBuffer.setFloat("roughnessThreshold", setting.roughnessThreshold);
        this.ssrUniformBuffer.setFloat("reflectionRatio", this.reflectionRatio);
        this.ssrUniformBuffer.setFloat("powDotRN", setting.powDotRN);
        this.ssrUniformBuffer.setFloat("randomSeedX", Math.random());
        this.ssrUniformBuffer.setFloat("randomSeedY", Math.random());
        this.ssrUniformBuffer.apply();
        let computes = [this.SSR_RayTraceCompute, this.SSR_IS_Compute, this.SSR_Blend_Compute];
        this._boundCtx.gpuContext.computeCommand(command, computes);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        let ssrWidth = Math.ceil(w * this.setting.render.postProcessing.ssr.pixelRatio);
        let ssrHeight = Math.ceil(h * this.setting.render.postProcessing.ssr.pixelRatio);
        this.finalTexture.resize(w, h);
        this.isRetTexture.resize(ssrWidth, ssrHeight);
        this.rayTraceData.resizeBuffer(ssrWidth * ssrHeight * 8);
        this.ssrColorData.resizeBuffer(ssrWidth * ssrHeight * 4);
        this.historyPosition.resizeBuffer(ssrWidth * ssrHeight * 4);
        this.ssrUniformBuffer.setFloat("ssrBufferSizeX", this.isRetTexture.width);
        this.ssrUniformBuffer.setFloat("ssrBufferSizeY", this.isRetTexture.height);
        this.ssrUniformBuffer.setFloat("colorMapSizeX", this.finalTexture.width);
        this.ssrUniformBuffer.setFloat("colorMapSizeY", this.finalTexture.height);
        this.SSR_RayTraceCompute.workerSizeX = Math.ceil(this.isRetTexture.width / 8);
        this.SSR_RayTraceCompute.workerSizeY = Math.ceil(this.isRetTexture.height / 8);
        this.SSR_RayTraceCompute.workerSizeZ = 1;
        this.SSR_IS_Compute.workerSizeX = Math.ceil(this.isRetTexture.width / 8);
        this.SSR_IS_Compute.workerSizeY = Math.ceil(this.isRetTexture.height / 8);
        this.SSR_IS_Compute.workerSizeZ = 1;
        this.SSR_Blend_Compute.workerSizeX = Math.ceil(this.finalTexture.width / 8);
        this.SSR_Blend_Compute.workerSizeY = Math.ceil(this.finalTexture.height / 8);
        this.SSR_Blend_Compute.workerSizeZ = 1;
      }
    }
    class SSR_IS_Kernel {
      static createSeeds() {
        let scaler = 20;
        let count = 32;
        let list = [new Vector3(0, 0, scaler)];
        let angle = 0;
        let radius = 0.02;
        for (let i = 1; i < count; i++) {
          let pt = new Vector3();
          list.push(pt);
          angle += 1 - (1 - 0.618) * i / count;
          radius += i * 0.01;
          pt.x = Math.sin(angle) * radius;
          pt.y = Math.cos(angle) * radius;
          pt.z = 1 - i / count;
          pt.multiplyScalar(scaler);
        }
        return list;
      }
    }

    class SkylinePost extends PostBase {
      /**
       * @internal
       */
      skylineTexture;
      skylineCompute;
      skylineUniform;
      rtFrame;
      constructor() {
        super();
      }
      createCompute(view) {
        this.skylineCompute = new ComputeShader(Skyline_cs);
        this.skylineUniform = new UniformGPUBuffer(8);
        this.skylineCompute.setUniformBuffer("skylineSetting", this.skylineUniform);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        this.skylineCompute.setSamplerTexture("gBufferTexture", rtFrame.getCompressGBufferTexture());
        this.skylineCompute.setSamplerTexture("inTex", rtFrame.getColorTexture());
        this.skylineCompute.setStorageTexture("outTex", this.skylineTexture);
        this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
        this.rendererPassState.label = "Skyline";
      }
      uploadSetting() {
        let skylineUniform = this.skylineUniform;
        let setting = this.setting.render.postProcessing.skyline;
        skylineUniform.setColor("lineColor", setting.lineColor);
        skylineUniform.setFloat("lineWidth", setting.lineWidth);
        skylineUniform.setFloat("depthThreshold", setting.depthThreshold);
        skylineUniform.setFloat("strength", setting.strength);
        skylineUniform.setFloat("slot", 0);
        skylineUniform.apply();
        this.skylineCompute.setUniformBuffer("skylineSetting", this.skylineUniform);
      }
      createResource() {
        let [w, h] = this._boundCtx.presentationSize;
        this.skylineTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.skylineTexture.name = "skylineTex";
        let skylineDesc = new RTDescriptor();
        skylineDesc.loadOp = "load";
        this.rtFrame = new RTFrame([this.skylineTexture], [skylineDesc]);
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.skyline.enable = true;
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.skyline.enable = false;
      }
      /**
       * Line color of the skyline effect
       */
      get lineColor() {
        return this.setting.render.postProcessing.skyline.lineColor;
      }
      set lineColor(value) {
        this.setting.render.postProcessing.skyline.lineColor.copy(value);
      }
      /**
       * Line width in pixels
       */
      get lineWidth() {
        return this.setting.render.postProcessing.skyline.lineWidth;
      }
      set lineWidth(value) {
        this.setting.render.postProcessing.skyline.lineWidth = Math.max(1, Math.min(10, value));
      }
      /**
       * Depth threshold for edge detection
       */
      get depthThreshold() {
        return this.setting.render.postProcessing.skyline.depthThreshold;
      }
      set depthThreshold(value) {
        this.setting.render.postProcessing.skyline.depthThreshold = Math.max(1e-4, value);
      }
      /**
       * Strength of the skyline effect
       */
      get strength() {
        return this.setting.render.postProcessing.skyline.strength;
      }
      set strength(value) {
        this.setting.render.postProcessing.skyline.strength = Math.max(0, Math.min(1, value));
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.skylineCompute) {
          this.createResource();
          this.createCompute(view);
        }
        this.uploadSetting();
        let [w, h] = this._boundCtx.presentationSize;
        this.skylineCompute.workerSizeX = Math.ceil(w / 8);
        this.skylineCompute.workerSizeY = Math.ceil(h / 8);
        this.skylineCompute.workerSizeZ = 1;
        this._boundCtx.gpuContext.computeCommand(command, [this.skylineCompute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        if (this.skylineTexture) {
          this.skylineTexture.resize(w, h);
          this.skylineCompute.workerSizeX = Math.ceil(w / 8);
          this.skylineCompute.workerSizeY = Math.ceil(h / 8);
          this.skylineCompute.workerSizeZ = 1;
        }
      }
    }

    class TAAPost extends PostBase {
      /**
       * @internal
       */
      taaTexture;
      outTexture;
      /**
       * @internal
       */
      taaCompute;
      copyTexCompute;
      sharpCompute;
      /**
       * @internal
       */
      taaSetting;
      /**
       * @internal
       */
      preColorBuffer;
      preColorTex;
      /**
       * @internal
       */
      preProjMatrix;
      preViewMatrix;
      rtFrame;
      constructor() {
        super();
      }
      /**
       * @internal
       */
      onAttach(view) {
        this.setting.render.postProcessing.taa.enable = true;
        view.camera.enableJitterProjection(true);
        this.createGUI();
      }
      /**
       * @internal
       */
      onDetach(view) {
        this.setting.render.postProcessing.taa.enable = false;
        view.camera.enableJitterProjection(false);
      }
      get jitterSeedCount() {
        let setting = this.setting.render.postProcessing.taa;
        return setting.jitterSeedCount;
      }
      set jitterSeedCount(value) {
        value = clamp$2(value, 2, 32);
        value = Math.round(value);
        let setting = this.setting.render.postProcessing.taa;
        setting.jitterSeedCount = value;
      }
      get blendFactor() {
        let setting = this.setting.render.postProcessing.taa;
        return setting.blendFactor;
      }
      set blendFactor(value) {
        value = clamp$2(value, 0, 1);
        let setting = this.setting.render.postProcessing.taa;
        setting.blendFactor = value;
      }
      get sharpFactor() {
        let setting = this.setting.render.postProcessing.taa;
        return setting.sharpFactor;
      }
      set sharpFactor(value) {
        value = clamp$2(value, 0.1, 0.99);
        let setting = this.setting.render.postProcessing.taa;
        setting.sharpFactor = value;
      }
      get sharpPreBlurFactor() {
        let setting = this.setting.render.postProcessing.taa;
        return setting.sharpPreBlurFactor;
      }
      set sharpPreBlurFactor(value) {
        value = clamp$2(value, 0.1, 0.99);
        let setting = this.setting.render.postProcessing.taa;
        setting.sharpPreBlurFactor = value;
      }
      get temporalJitterScale() {
        let setting = this.setting.render.postProcessing.taa;
        return setting.temporalJitterScale;
      }
      set temporalJitterScale(value) {
        value = clamp$2(value, 0, 1);
        let setting = this.setting.render.postProcessing.taa;
        setting.temporalJitterScale = value;
      }
      createGUI() {
      }
      createCompute(view) {
        let computeShader = new ComputeShader(TAA_cs);
        let taaSetting = new UniformGPUBuffer(16 * 2 + 4 * 3);
        let standUniform = GlobalBindGroup.getCameraGroup(view.camera);
        computeShader.setUniformBuffer("globalUniform", standUniform.uniformGPUBuffer);
        computeShader.setUniformBuffer("taaData", taaSetting);
        computeShader.setStorageBuffer(`preColorBuffer`, this.preColorBuffer);
        let rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, this._boundCtx);
        computeShader.setSamplerTexture(`preColorTex`, this.preColorTex);
        computeShader.setSamplerTexture(`gBufferTexture`, rtFrame.getCompressGBufferTexture());
        computeShader.setSamplerTexture("inTex", this.getLastRenderTexture());
        computeShader.setStorageTexture(`outTex`, this.taaTexture);
        computeShader.workerSizeX = Math.ceil(this.taaTexture.width / 8);
        computeShader.workerSizeY = Math.ceil(this.taaTexture.height / 8);
        computeShader.workerSizeZ = 1;
        this.taaCompute = computeShader;
        this.taaSetting = taaSetting;
        this.copyTexCompute = new ComputeShader(TAACopyTex_cs);
        this.copyTexCompute.setStorageBuffer(`preColor`, this.preColorBuffer);
        this.copyTexCompute.setStorageTexture(`preColorTex`, this.preColorTex);
        this.copyTexCompute.workerSizeX = Math.ceil(this.taaTexture.width / 8);
        this.copyTexCompute.workerSizeY = Math.ceil(this.taaTexture.height / 8);
        this.copyTexCompute.workerSizeZ = 1;
        this.sharpCompute = new ComputeShader(TAASharpTex_cs);
        this.sharpCompute.setUniformBuffer("taaData", taaSetting);
        this.sharpCompute.setSamplerTexture(`inTex`, this.taaTexture);
        this.sharpCompute.setStorageTexture(`outTex`, this.outTexture);
        this.sharpCompute.workerSizeX = Math.ceil(this.outTexture.width / 8);
        this.sharpCompute.workerSizeY = Math.ceil(this.outTexture.height / 8);
        this.sharpCompute.workerSizeZ = 1;
      }
      _createTaaResources() {
        this.preProjMatrix = new Matrix4().identity();
        this.preViewMatrix = new Matrix4().identity();
        let [w, h] = this._boundCtx.presentationSize;
        this.preColorBuffer = new StorageGPUBuffer(w * h * 4, GPUBufferUsage.COPY_SRC);
        this.preColorTex = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.preColorTex.name = "taaTex";
        let preColorDec = new RTDescriptor();
        preColorDec.clearValue = [0, 0, 0, 1];
        preColorDec.loadOp = `clear`;
        this.taaTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.taaTexture.name = "taaTex";
        let taaDec = new RTDescriptor();
        taaDec.clearValue = [0, 0, 0, 1];
        taaDec.loadOp = `clear`;
        this.outTexture = new VirtualTexture(w, h, GPUTextureFormat.rgba16float, false, GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING, 1, 0, 1, this._boundCtx);
        this.outTexture.name = "sharpTaaTex";
        let outDec = new RTDescriptor();
        outDec.clearValue = [0, 0, 0, 1];
        outDec.loadOp = `clear`;
        this.rtFrame = new RTFrame([
          this.preColorTex,
          this.taaTexture,
          this.outTexture
        ], [
          preColorDec,
          taaDec,
          outDec
        ]);
      }
      /**
       * @internal
       */
      render(view, command) {
        if (!this.taaCompute) {
          this._createTaaResources();
          this.createCompute(view);
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this.rtFrame, null);
        }
        this.bindUpstream(this.taaCompute, "inTex");
        let cfg = this.setting.render.postProcessing.taa;
        this.taaSetting.setMatrix("preProjMatrix", this.preProjMatrix);
        this.taaSetting.setMatrix("preViewMatrix", this.preViewMatrix);
        this.taaSetting.setFloat("jitterFrameIndex", view.camera.jitterFrameIndex);
        this.taaSetting.setFloat("blendFactor", cfg.blendFactor);
        this.taaSetting.setFloat("sharpFactor", cfg.sharpFactor);
        this.taaSetting.setFloat("sharpPreBlurFactor", cfg.sharpPreBlurFactor);
        this.taaSetting.setFloat("jitterX", view.camera.jitterX);
        this.taaSetting.setFloat("jitterY", view.camera.jitterY);
        this.taaSetting.apply();
        this._boundCtx.gpuContext.computeCommand(command, [this.copyTexCompute, this.taaCompute, this.sharpCompute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
        this.preProjMatrix.copy(view.camera.projectionMatrix);
        this.preViewMatrix.copy(view.camera.viewMatrix);
      }
      onResize() {
        let [w, h] = this._boundCtx.presentationSize;
        this.preColorBuffer.resizeBuffer(w * h * 4);
        this.taaTexture.resize(w, h);
        this.outTexture.resize(w, h);
        this.preColorTex.resize(w, h);
        this.taaCompute.workerSizeX = Math.ceil(this.taaTexture.width / 8);
        this.taaCompute.workerSizeY = Math.ceil(this.taaTexture.height / 8);
        this.taaCompute.workerSizeZ = 1;
        this.copyTexCompute.workerSizeX = Math.ceil(this.taaTexture.width / 8);
        this.copyTexCompute.workerSizeY = Math.ceil(this.taaTexture.height / 8);
        this.copyTexCompute.workerSizeZ = 1;
        this.sharpCompute.workerSizeX = Math.ceil(this.outTexture.width / 8);
        this.sharpCompute.workerSizeY = Math.ceil(this.outTexture.height / 8);
        this.sharpCompute.workerSizeZ = 1;
      }
    }

    class VolumetricFogPost extends PostBase {
      _outTex;
      _compute;
      _settingsBuffer;
      _rtFrame;
      constructor() {
        super();
      }
      onAttach(_view) {
        const cfg = this.setting.render.postProcessing.volumetricFog;
        if (cfg) cfg.enable = true;
      }
      onDetach(_view) {
        const cfg = this.setting.render.postProcessing.volumetricFog;
        if (cfg) cfg.enable = false;
      }
      _createResources() {
        const [w, h] = this._boundCtx.presentationSize;
        this._outTex = new VirtualTexture(
          w,
          h,
          GPUTextureFormat.rgba16float,
          false,
          GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.COPY_DST | GPUTextureUsage.COPY_SRC | GPUTextureUsage.TEXTURE_BINDING,
          1,
          0,
          1,
          this._boundCtx
        );
        this._outTex.name = "VolumetricFogOut";
        const desc = new RTDescriptor();
        desc.loadOp = "load";
        this._rtFrame = new RTFrame([this._outTex], [desc]);
      }
      _createCompute(view) {
        ShaderLib.register("VolumetricFog_cs", VolumetricFog_cs);
        this._compute = new ComputeShader(VolumetricFog_cs);
        this._settingsBuffer = new UniformGPUBuffer(8);
        this._compute.setUniformBuffer("fogSettings", this._settingsBuffer);
        const lightEntries = GlobalBindGroup.getLightEntries(view.scene);
        this._compute.setStorageBuffer("lightBuffer", lightEntries.storageGPUBuffer);
        const rtFrame = GBufferFrame.getGBufferFrame(GBufferFrame.colorPass_GBuffer, view.engine3D.context3D);
        this._compute.setSamplerTexture("gBufferTexture", rtFrame.getCompressGBufferTexture());
        this._compute.setSamplerTexture("inTex", this.getLastRenderTexture());
        this._compute.setStorageTexture("outTex", this._outTex);
        const cameraGroup = GlobalBindGroup.getCameraGroup(view.camera);
        this._compute.setUniformBuffer("globalUniform", cameraGroup.uniformGPUBuffer);
      }
      _uploadSettings() {
        const cfg = this.setting.render.postProcessing.volumetricFog;
        if (!cfg) return;
        this._settingsBuffer.setFloat("density", cfg.density ?? 0.05);
        this._settingsBuffer.setFloat("scatteringIntensity", cfg.scatteringIntensity ?? 1);
        this._settingsBuffer.setFloat("anisotropy", cfg.anisotropy ?? 0.6);
        this._settingsBuffer.setFloat("maxDistance", cfg.maxDistance ?? 100);
        this._settingsBuffer.setFloat("stepCount", cfg.stepCount ?? 32);
        const ambient = cfg.ambient || { r: 0.02, g: 0.02, b: 0.04 };
        this._settingsBuffer.setFloat("ambientR", ambient.r);
        this._settingsBuffer.setFloat("ambientG", ambient.g);
        this._settingsBuffer.setFloat("ambientB", ambient.b);
        this._settingsBuffer.apply();
      }
      render(view, command) {
        if (!this._compute) {
          this._createResources();
          this._createCompute(view);
          this.onResize();
          this.rendererPassState = WebGPUDescriptorCreator.createRendererPassState(view.engine3D.context3D, this._rtFrame, null);
          this.rendererPassState.label = "VolumetricFog";
        }
        this.bindUpstream(this._compute, "inTex");
        this._uploadSettings();
        this._boundCtx.gpuContext.computeCommand(command, [this._compute]);
        this._boundCtx.gpuContext.lastRenderPassState = this.rendererPassState;
      }
      onResize() {
        const [w, h] = this._boundCtx.presentationSize;
        if (this._outTex) this._outTex.resize(w, h);
        if (this._compute) {
          this._compute.workerSizeX = Math.ceil(w / 8);
          this._compute.workerSizeY = Math.ceil(h / 8);
          this._compute.workerSizeZ = 1;
        }
      }
    }

    class OutlinePostManager {
      _tempIndexArray = [];
      /**
       * config outline manager.
       * Specify specific 3D objects to use the specified color for display outline
       * @param objectList A set of 3D objects
       * @param color Specified color for outline
       */
      setOutline(objectList, color) {
        this.setOutlineList([objectList], color ? [color] : null);
      }
      /**
       * config outline manager.
       * The first set of objects uses the first color to display outline, and so on
       * @param groupList A group of 3D objects set
       * @param colorList Specified color list for outline
       */
      setOutlineList(groupList, colorList) {
        groupList ||= [];
        let defaultColor = outlinePostData.defaultColor;
        let maxGroup = outlinePostData.SlotCount;
        for (let i = 0; i < maxGroup; i++) {
          this._tempIndexArray.length = 0;
          let group = groupList[i];
          let color = (colorList ? colorList[i] : null) || defaultColor;
          if (group) {
            for (const item of group) {
              this.getEntityIdList(item, this._tempIndexArray);
            }
          }
          outlinePostData.fillDataAt(i, this._tempIndexArray, color);
        }
      }
      /**
       * clear outline effect
       */
      clearOutline() {
        outlinePostData.clear();
        return this;
      }
      _rendererList = [];
      getEntityIdList(item, target) {
        this._rendererList.length = 0;
        let renderers = item.getComponents(exports.MeshRenderer, this._rendererList);
        for (const render of renderers) {
          target.push(render.object3D.transform._worldMatrix.index);
        }
      }
    }
    let outlinePostManager = new OutlinePostManager();

    class PickResult {
      /**
       * the intersection point (local coordinates) on the model.
       */
      localPosition = new Vector3();
      /**
       * the intersection point (world coordinates) on the model.
       */
      worldPosition = new Vector3();
      /**
       * the uv on the model.
       * Only when the PickType of the object is UVPick and the model has UV will it be valid
       * @see PickType
       */
      uv = new Vector2();
      /**
       * the triangle index at the intersection position of mesh
       */
      faceIndex;
      isIn = false;
      t = 0;
      u = 0;
      v = 0;
      /**
       * the triangle at the intersection position of mesh
       */
      triangle;
      /**
       * @internal
       * the uv0 at the intersection position of mesh
       */
      v0;
      /**
       * @internal
       * the uv1 at the intersection position of mesh
       */
      v1;
      /**
       * @internal
       */
      v2;
      /**
       * @internal
       */
      pickList;
      /**
      * @internal
      */
      color;
      //= new Color();
    }

    class RayCastMeshDetail {
      /**
       * define a tiny number
       */
      static EPS = 1e-4;
      /**
       * define a maximum float
       */
      static FLT_MAX = 3402823466e29;
      /**
       * calculate the distance between a point and a plane(defined by point a, point b, point c)
       */
      static distPtTri(p, a, b, c) {
        let v0 = new Vector3();
        let v1 = new Vector3();
        let v2 = new Vector3();
        Vector3.sub(c, a, v0);
        Vector3.sub(b, a, v1);
        Vector3.sub(p, a, v2);
        let dot00 = dot(v0, v0);
        let dot01 = dot(v0, v1);
        let dot02 = dot(v0, v2);
        let dot11 = dot(v1, v1);
        let dot12 = dot(v1, v2);
        let invDenom = 1 / (dot00 * dot11 - dot01 * dot01);
        let u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        let v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        if (u >= -RayCastMeshDetail.EPS && v >= -RayCastMeshDetail.EPS && u + v <= 1 + RayCastMeshDetail.EPS) {
          let y = a[1] + v0[1] * u + v1[1] * v;
          return Math.abs(y - p[1]);
        }
        return RayCastMeshDetail.FLT_MAX;
      }
      static _info = new PickResult();
      // Determine whether a ray intersect with a triangle
      // Parameters
      // orig: origin of the ray
      // dir: direction of the ray
      // v0, v1, v2: vertices of triangle
      // t(out): weight of the intersection for the ray
      // u(out), v(out): barycentric coordinate of intersection
      static IntersectTriangle(ray, face, backfaceCulling) {
        let v0 = face.v1;
        let v1 = face.v2;
        let v2 = face.v3;
        let E1 = Vector3.sub(v1, v0, Vector3.HELP_3);
        let E2 = Vector3.sub(v2, v0, Vector3.HELP_4);
        let P = Vector3.cross(ray.direction, E2, Vector3.HELP_5);
        let det = dot(E1, P);
        let T;
        if (det > 0) {
          if (backfaceCulling) {
            return null;
          }
          T = Vector3.sub(ray.origin, v0, Vector3.HELP_2);
        } else {
          T = Vector3.sub(v0, ray.origin, Vector3.HELP_2);
          det = -det;
        }
        if (det < 1e-4) {
          this._info.isIn = false;
          this._info.t = 0;
          this._info.u = 0;
          this._info.v = 0;
          return this._info;
        }
        let u = dot(T, P);
        if (u < 0 || u > det) {
          this._info.isIn = false;
          this._info.t = 0;
          this._info.u = 0;
          this._info.v = 0;
          return this._info;
        }
        let Q = Vector3.cross(T, E1, Vector3.HELP_1);
        let v = dot(ray.direction, Q);
        if (v < 0 || u + v > det) {
          this._info.isIn = false;
          this._info.t = 0;
          this._info.u = 0;
          this._info.v = 0;
          return this._info;
        }
        let t = dot(E2, Q);
        let fInvDet = 1 / det;
        t *= fInvDet;
        u *= fInvDet;
        v *= fInvDet;
        this._info.isIn = true;
        this._info.t = t;
        this._info.u = u;
        this._info.v = v;
        let d = 1 - u - v;
        this._u0.copy(face.u1);
        this._u0.multiplyScalar(d);
        this._u1.copy(face.u2);
        this._u1.multiplyScalar(u);
        this._u2.copy(face.u3);
        this._u2.multiplyScalar(v);
        this._info.uv.copy(this._u0);
        Vector2.add(this._info.uv, this._u1, this._info.uv);
        Vector2.add(this._info.uv, this._u2, this._info.uv);
        this._info.localPosition.copy(ray.direction).multiplyScalar(t);
        Vector3.add(this._info.localPosition, ray.origin, this._info.localPosition);
        return this._info;
      }
      static _u0 = new Vector2();
      static _u1 = new Vector2();
      static _u2 = new Vector2();
    }

    class LoaderManager extends CEventDispatcher {
      static _instance;
      _maxRetry = 3;
      /**
       * Load multiple resources of the same type simultaneously
       * @param urls URL list
       * @param c Type of resource parser
       * @returns
       */
      loadAll(urls, c) {
        return new Promise((succ, fail) => {
          let count = urls.length;
          let ret = [];
          urls.forEach((url, index) => {
            let parser = new c();
            this.load(url, c).then((data) => {
              parser.parse(data);
              ret.push(parser);
              count--;
              if (count === 0) {
                succ(ret);
              }
            });
          });
        });
      }
      constructor() {
        super();
        if (LoaderManager._instance) {
          throw new Error("LoadManager is singleton class...");
        }
      }
      static getInstance() {
        return this._instance || (this._instance = new LoaderManager());
      }
      loadUrls(urls, c) {
        return new Promise((succ, fail) => {
          let count = urls.length;
          let ret = [];
          urls.forEach((url, index) => {
            this.load(url, c).then((data) => {
              ret.push(data);
              count--;
              if (count === 0) {
                succ(ret);
              }
              if (count < 0) {
                console.error(`loadUrls ${urls} error`);
              }
            });
          });
        });
      }
      get maxRetry() {
        return this._maxRetry;
      }
      set maxRetry(value) {
        this._maxRetry = value;
      }
      // public set retry(value: number) {
      //   this._maxRetry = value;
      // }
      // public get retry():number {
      //   return this._maxRetry;
      // }
      load(url, c) {
        return new Promise((succ, fail) => {
          switch (c[`format`]) {
                  }
        });
      }
    }

    var GeoType = /* @__PURE__ */ ((GeoType2) => {
      GeoType2["Point"] = "Point";
      GeoType2["LineString"] = "LineString";
      GeoType2["MultiPolygon"] = "MultiPolygon";
      return GeoType2;
    })(GeoType || {});
    class GeoJsonParser extends ParserBase {
      static format = ParserFormat.JSON;
      /** Raw GeoJSON source text passed to the parser. */
      json;
      /**
       * Parse GeoJSON text into a {@link GeoJsonStruct}.
       * @param data Raw GeoJSON string.
       */
      async parseString(data) {
        this.json = data;
        this.data = JSON.parse(data);
      }
    }

    class GeoJsonUtil {
      /**
       * Extract polyline paths from a GeoJSON structure.
       * @param data Parsed GeoJSON feature collection.
       * @returns Arrays of {@link Vector3} points, one array per matching feature.
       */
      static getPath(data) {
        let lineArray = [];
        for (let i = 0; i < data.features.length; i++) {
          const element = data.features[i];
          switch (element.geometry.type) {
            case GeoType.LineString:
              break;
            case GeoType.MultiPolygon:
              let point3s = [];
              for (let i2 = 0; i2 < element.geometry.coordinates.length; i2++) {
                const pointArray = element.geometry.coordinates[i2];
                for (const list of pointArray) {
                  for (const iterator of list) {
                    let point3 = new Vector3(iterator[0], 0, iterator[1]);
                    point3s.push(point3);
                  }
                }
              }
              lineArray.push(point3s);
              break;
          }
        }
        return lineArray;
      }
    }

    class GLTFMaterial {
      /** Material name as declared in the glTF file. */
      name;
      /** Shader define flags collected for this material (e.g. blend mode hints). */
      defines;
      /** Whether the material is rendered double-sided. */
      doubleSided;
      /** Base color (albedo) factor as an RGBA tuple. */
      baseColorFactor;
      /** Emissive color factor. */
      emissiveFactor;
      /** Metallic scalar factor in the [0, 1] range. */
      metallicFactor;
      /** Roughness scalar factor in the [0, 1] range. */
      roughnessFactor;
      /** Alpha cutoff threshold used in alpha-mask mode. */
      alphaCutoff;
      /** Whether alpha blending is enabled for this material. */
      enableBlend;
      /** Base color (albedo) texture. */
      baseColorTexture;
      /** Combined metallic-roughness texture. */
      metallicRoughnessTexture;
      /** Tangent-space normal map. */
      normalTexture;
      /** Ambient occlusion texture. */
      occlusionTexture;
      /** Emissive texture. */
      emissiveTexture;
      /** Raw glTF material extensions dictionary. */
      extensions;
      /** UV offset/size transform for the base color texture. */
      baseMapOffsetSize;
      /** UV offset/size transform for the normal texture. */
      normalMapOffsetSize;
      /** UV offset/size transform for the emissive texture. */
      emissiveMapOffsetSize;
      /** UV offset/size transform for the roughness texture. */
      roughnessMapOffsetSize;
      /** UV offset/size transform for the metallic texture. */
      metallicMapOffsetSize;
      /** UV offset/size transform for the ambient occlusion texture. */
      aoMapOffsetSize;
    }

    class KHR_lights_punctual {
    }

    class KHR_materials_sheen {
    }

    class KHR_materials_specular {
    }

    class KHR_materials_variants {
    }

    class KHR_mesh_quantization {
    }

    class KHR_texture_basisu {
    }

    class KHR_texture_transform {
    }

    class PrefabBoneData {
      boneName;
      bonePath;
      parentBoneName;
      boneID;
      parentBoneID;
      instanceID;
      parentInstanceID;
      t;
      q;
      s;
      formBytes(bytes) {
        this.boneName = bytes.readUTF();
        this.bonePath = bytes.readUTF();
        this.parentBoneName = bytes.readUTF();
        this.boneID = bytes.readInt32();
        this.parentBoneID = bytes.readInt32();
        this.instanceID = bytes.readUTF();
        this.parentInstanceID = bytes.readUTF();
        this.t = bytes.readVector3();
        this.q = bytes.readQuaternion();
        this.s = bytes.readVector3();
      }
    }

    class PrefabAvatarData {
      name;
      count;
      boneData;
      boneMap;
      formBytes(bytes) {
        this.boneData = [];
        this.boneMap = /* @__PURE__ */ new Map();
        this.name = bytes.readUTF();
        this.count = bytes.readInt32();
        for (let i = 0; i < this.count; i++) {
          let boneData = new PrefabBoneData();
          boneData.formBytes(bytes.readBytesArray());
          this.boneData[i] = boneData;
          this.boneMap.set(boneData.boneName, boneData);
        }
      }
    }

    class PrefabAvatarParser extends ParserBase {
      static format = ParserFormat.BIN;
      /**
       * Read every avatar block from the stream and register the resulting
       * {@link PrefabAvatarData} instances on the resource host.
       * @param bytesStream the prefab binary stream positioned at the avatar section.
       * @param prefabParser the owning prefab parser, used for context lookup.
       */
      static parser(bytesStream, prefabParser) {
        let avatarCount = bytesStream.readInt32();
        for (let j = 0; j < avatarCount; j++) {
          let prefabAvatarData = new PrefabAvatarData();
          prefabAvatarData.formBytes(bytesStream.readBytesArray());
          Engine3D.resFor(prefabParser.ctx).addObj(prefabAvatarData.name, prefabAvatarData);
        }
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("verify failed.");
      }
    }
    ({
      "Position": VertexAttributeName.position,
      "Normal": VertexAttributeName.normal,
      "Color": VertexAttributeName.color,
      "Tangent": VertexAttributeName.TANGENT,
      "TexCoord0": VertexAttributeName.uv,
      "TexCoord1": VertexAttributeName.TEXCOORD_1,
      "TexCoord2": VertexAttributeName.TEXCOORD_2,
      "TexCoord3": VertexAttributeName.TEXCOORD_2,
      "TexCoord4": VertexAttributeName.TEXCOORD_4,
      "TexCoord5": VertexAttributeName.TEXCOORD_5,
      "TexCoord6": VertexAttributeName.TEXCOORD_6,
      "TexCoord7": VertexAttributeName.TEXCOORD_7,
      "BlendIndices": VertexAttributeName.joints0,
      "BlendWeight": VertexAttributeName.weights0
    });

    var ValueEnumType = /* @__PURE__ */ ((ValueEnumType2) => {
      ValueEnumType2[ValueEnumType2["single"] = 0] = "single";
      ValueEnumType2[ValueEnumType2["boolean"] = 1] = "boolean";
      ValueEnumType2[ValueEnumType2["int"] = 2] = "int";
      ValueEnumType2[ValueEnumType2["int16"] = 3] = "int16";
      ValueEnumType2[ValueEnumType2["int32"] = 4] = "int32";
      ValueEnumType2[ValueEnumType2["float"] = 5] = "float";
      ValueEnumType2[ValueEnumType2["long"] = 6] = "long";
      ValueEnumType2[ValueEnumType2["uint"] = 7] = "uint";
      ValueEnumType2[ValueEnumType2["uint32"] = 8] = "uint32";
      ValueEnumType2[ValueEnumType2["uint64"] = 9] = "uint64";
      ValueEnumType2[ValueEnumType2["double"] = 10] = "double";
      ValueEnumType2[ValueEnumType2["string"] = 11] = "string";
      ValueEnumType2[ValueEnumType2["singleArray"] = 12] = "singleArray";
      ValueEnumType2[ValueEnumType2["stringArray"] = 13] = "stringArray";
      ValueEnumType2[ValueEnumType2["floatArray"] = 14] = "floatArray";
      ValueEnumType2[ValueEnumType2["vector2"] = 15] = "vector2";
      ValueEnumType2[ValueEnumType2["vector3"] = 16] = "vector3";
      ValueEnumType2[ValueEnumType2["vector4"] = 17] = "vector4";
      ValueEnumType2[ValueEnumType2["color"] = 18] = "color";
      ValueEnumType2[ValueEnumType2["color32"] = 19] = "color32";
      ValueEnumType2[ValueEnumType2["animationCurve"] = 20] = "animationCurve";
      ValueEnumType2[ValueEnumType2["quaternion"] = 21] = "quaternion";
      ValueEnumType2[ValueEnumType2["matrix4x4"] = 22] = "matrix4x4";
      ValueEnumType2[ValueEnumType2["mesh"] = 23] = "mesh";
      ValueEnumType2[ValueEnumType2["texture"] = 24] = "texture";
      ValueEnumType2[ValueEnumType2["material"] = 25] = "material";
      ValueEnumType2[ValueEnumType2["materials"] = 26] = "materials";
      ValueEnumType2[ValueEnumType2["skeleton"] = 27] = "skeleton";
      ValueEnumType2[ValueEnumType2["animClip"] = 28] = "animClip";
      ValueEnumType2[ValueEnumType2["vector2Int"] = 29] = "vector2Int";
      ValueEnumType2[ValueEnumType2["int32List"] = 30] = "int32List";
      ValueEnumType2[ValueEnumType2["colorList"] = 31] = "colorList";
      ValueEnumType2[ValueEnumType2["color32List"] = 32] = "color32List";
      return ValueEnumType2;
    })(ValueEnumType || {});

    class MaterialUtilities {
      /**
       * Resolve a shader by its (possibly path-qualified) name and build a
       * {@link Material} using it.
       * @param shaderName the shader name, optionally with a path/dotted prefix.
       * @param ctx optional rendering context passed to the shader constructor.
       * @returns the constructed material.
       */
      static GetMaterial(shaderName, ctx) {
        let name = shaderName;
        let list = name.split("/");
        name = list[list.length - 1];
        list = name.split(".");
        name = list[list.length - 1];
        let shader = GetShader(name);
        if (shader) {
          let material = new Material();
          material.shader = new shader(ctx);
          return material;
        } else {
          throw new Error("not found shader, shader name is " + name);
        }
      }
      /**
       * Apply decoded textures onto a material, binding each to the matching
       * material/shader property or falling back to {@link Material.setTexture}.
       * @param mat the target material.
       * @param textures the decoded texture entries to apply.
       */
      static applyMaterialTexture(mat, textures) {
        for (let ii = 0; ii < textures.length; ii++) {
          const texInfo = textures[ii];
          if (texInfo.property in mat) {
            mat[texInfo.property] = texInfo.texture;
          } else if (texInfo.property in mat.shader) {
            mat.shader[texInfo.property] = texInfo.texture;
          } else {
            mat.setTexture(texInfo.property, texInfo.texture);
          }
        }
      }
      /**
       * Apply decoded key/value uniform properties onto a material, dispatching
       * by value type to the matching material/shader property or uniform setter.
       * @param mat the target material.
       * @param properties the decoded property entries to apply.
       */
      static applyMaterialProperties(mat, properties) {
        for (let ii = 0; ii < properties.length; ii++) {
          const propertyInfo = properties[ii];
          const key = propertyInfo.key;
          switch (propertyInfo.type) {
            case ValueEnumType.color:
            case ValueEnumType.color32:
              {
                let value = propertyInfo.getValue();
                if (key in mat) {
                  mat[key] = value;
                } else if (key in mat.shader) {
                  mat.shader[key] = value;
                } else {
                  mat.setUniformColor(key, value);
                }
              }
              break;
            case ValueEnumType.single:
            case ValueEnumType.float:
            case ValueEnumType.int:
            case ValueEnumType.int16:
            case ValueEnumType.int32:
            case ValueEnumType.uint:
            case ValueEnumType.uint32:
            case ValueEnumType.uint64:
              {
                let value = propertyInfo.getValue();
                if (key in mat) {
                  mat[key] = value;
                } else if (key in mat.shader) {
                  mat.shader[key] = value;
                } else {
                  mat.setUniformFloat(key, value);
                }
              }
              break;
            case ValueEnumType.singleArray:
              {
                let value = propertyInfo.getValue()[0];
                if (key in mat) {
                  mat[key] = value;
                } else if (key in mat.shader) {
                  mat.shader[key] = value;
                } else {
                  mat.setUniformFloat(key, value);
                }
              }
              break;
            case ValueEnumType.vector2:
            case ValueEnumType.vector2Int:
              {
                let value = propertyInfo.getValue();
                if (key in mat) {
                  mat[key] = value;
                } else if (key in mat.shader) {
                  mat.shader[key] = value;
                } else {
                  mat.setUniformVector2(key, value);
                }
              }
              break;
            case ValueEnumType.vector3:
              {
                let value = propertyInfo.getValue();
                if (key in mat) {
                  mat[key] = value;
                } else if (key in mat.shader) {
                  mat.shader[key] = value;
                } else {
                  mat.setUniformVector3(key, value);
                }
              }
              break;
            case ValueEnumType.vector4:
              {
                let value = propertyInfo.getValue();
                if (key in mat) {
                  mat[key] = value;
                } else if (key in mat.shader) {
                  mat.shader[key] = value;
                } else {
                  mat.setUniformVector4(key, value);
                }
              }
              break;
          }
        }
      }
    }

    class ValueParser {
      /**
       * Scoped rendering context for resource lookups (mesh/texture/material).
       * Set by PrefabParser at parse start and consumed by the lookups below.
       * Prefab parsing is not re-entrant in practice (a single parser drives
       * the whole buffer synchronously per call), so a shared slot is adequate.
       */
      static _currentCtx;
      /**
       * Decode a single typed value from the stream.
       * @param bytes the prefab byte stream positioned at a value's type tag.
       * @returns the decoded value `v` and its type tag `t`.
       */
      static parser(bytes) {
        let type = bytes.readInt32();
        switch (type) {
          case ValueEnumType.single:
            return { t: ValueEnumType.single, v: bytes.readFloat32() };
          case ValueEnumType.boolean:
            return { t: ValueEnumType.boolean, v: bytes.readBoolean() };
          case ValueEnumType.int:
            return { t: ValueEnumType.int, v: bytes.readInt32() };
          case ValueEnumType.int16:
            return { t: ValueEnumType.int16, v: bytes.readInt16() };
          case ValueEnumType.int32:
            return { t: ValueEnumType.int32, v: bytes.readInt32() };
          case ValueEnumType.float:
            return { t: ValueEnumType.float, v: bytes.readFloat32() };
          case ValueEnumType.long:
            return { t: ValueEnumType.long, v: bytes.readFloat64() };
          case ValueEnumType.uint:
            return { t: ValueEnumType.uint, v: bytes.readUnit32() };
          case ValueEnumType.uint32:
            return { t: ValueEnumType.uint32, v: bytes.readUnit32() };
          case ValueEnumType.uint64:
            return { t: ValueEnumType.uint64, v: bytes.readUnit32() };
          case ValueEnumType.double:
            return { t: ValueEnumType.double, v: bytes.readFloat64() };
          case ValueEnumType.string:
            return { t: ValueEnumType.string, v: bytes.readUTF() };
          case ValueEnumType.singleArray:
            return { t: ValueEnumType.singleArray, v: bytes.readFloatArray() };
          case ValueEnumType.stringArray:
            return { t: ValueEnumType.stringArray, v: bytes.readStringArray() };
          case ValueEnumType.floatArray:
            return { t: ValueEnumType.floatArray, v: bytes.readFloatArray() };
          case ValueEnumType.vector2:
            return { t: ValueEnumType.vector2, v: bytes.readVector2() };
          case ValueEnumType.vector3:
            return { t: ValueEnumType.vector3, v: bytes.readVector3() };
          case ValueEnumType.vector4:
            return { t: ValueEnumType.vector4, v: bytes.readVector4() };
          case ValueEnumType.color:
            return { t: ValueEnumType.color, v: bytes.readColor() };
          case ValueEnumType.color32:
            return { t: ValueEnumType.color32, v: bytes.readColor() };
          case ValueEnumType.animationCurve:
            return { t: ValueEnumType.animationCurve, v: null };
          case ValueEnumType.quaternion:
            return { t: ValueEnumType.quaternion, v: bytes.readQuaternion() };
          case ValueEnumType.matrix4x4:
            return { t: ValueEnumType.matrix4x4, v: null };
          case ValueEnumType.mesh: {
            let id = bytes.readUTF();
            let mesh = Engine3D.resFor(ValueParser._currentCtx).getGeometry(id);
            return { t: ValueEnumType.mesh, v: mesh };
          }
          case ValueEnumType.texture: {
            let id = bytes.readUTF();
            let texture = Engine3D.resFor(ValueParser._currentCtx).getTexture(id);
            return { t: ValueEnumType.texture, v: texture };
          }
          case ValueEnumType.material: {
            let id = bytes.readUTF();
            let mat = Engine3D.resFor(ValueParser._currentCtx).getMat(id);
            return { t: ValueEnumType.material, v: mat };
          }
          case ValueEnumType.materials: {
            let str = bytes.readStringArray();
            let mats = [];
            for (let i = 0; i < str.length; i++) {
              const element = str[i];
              let mat = Engine3D.resFor(ValueParser._currentCtx).getMat(element);
              mats.push(mat);
            }
            return { t: ValueEnumType.materials, v: mats };
          }
          case ValueEnumType.skeleton:
            break;
          case ValueEnumType.animClip: {
            let animClipDatas = [];
            let animClipCount = bytes.readInt32();
            for (let i = 0; i < animClipCount; i++) {
              let animationClipData = new PropertyAnimationClip();
              animationClipData.formBytes(bytes);
              animClipDatas.push(animationClipData);
            }
            return { t: ValueEnumType.animClip, v: animClipDatas };
          }
          case ValueEnumType.vector2Int:
            return { t: ValueEnumType.vector2Int, v: bytes.readVector2int() };
          case ValueEnumType.int32List:
            return { t: ValueEnumType.int32List, v: bytes.readInt32List() };
          case ValueEnumType.colorList:
            let len = bytes.readInt32();
            let list = [];
            for (let i = 0; i < len; i++) {
              const element = ValueParser.parser(bytes).v;
              list.push(element);
            }
            return { t: ValueEnumType.colorList, v: list };
          case ValueEnumType.color32List:
            let len2 = bytes.readInt32();
            let list2 = [];
            for (let i = 0; i < len2; i++) {
              const element = ValueParser.parser(bytes).v;
              list2.push(element);
            }
            return { t: ValueEnumType.color32List, v: list2 };
        }
      }
    }

    class KV {
      key;
      type;
      _data;
      getValue() {
        return this._data;
      }
      formBytes(matBytes) {
        this.key = matBytes.readUTF();
        let { t, v } = ValueParser.parser(matBytes);
        this.type = t;
        this._data = v;
      }
    }

    class PrefabTextureData {
      property;
      name;
      texture;
      texelSize;
      wrapModeU;
      wrapModeV;
      wrapModeW;
      wrapMode;
      anisoLevel;
      dimension;
      filterMode;
    }

    class PrefabMaterialParser extends ParserBase {
      static format = ParserFormat.TEXT;
      /**
       * Read every material block from the stream, build the corresponding
       * materials, and register them on the resource host keyed by id.
       * @param bytesStream the prefab binary stream positioned at the material section.
       * @param prefabParser the owning prefab parser, used for context lookup.
       */
      static parserMaterial(bytesStream, prefabParser) {
        let matCount = bytesStream.readInt32();
        for (let i = 0; i < matCount; i++) {
          let matBytes = bytesStream.readBytesArray();
          let matName = matBytes.readUTF();
          let id = matBytes.readUTF();
          matBytes.readUTF();
          let defines = matBytes.readStringArray();
          matBytes.readVector4();
          matBytes.readVector4();
          let shaderName = matBytes.readUTF();
          let properties = [];
          let textures = [];
          let propertyCount = matBytes.readInt32();
          for (let j = 0; j < propertyCount; j++) {
            let kv = new KV();
            kv.formBytes(matBytes);
            properties.push(kv);
          }
          let textureCount = matBytes.readInt32();
          for (let j = 0; j < textureCount; j++) {
            let texBytes = matBytes.readBytesArray();
            let textureData = new PrefabTextureData();
            textureData.property = texBytes.readUTF();
            textureData.name = texBytes.readUTF();
            textureData.texture = Engine3D.resFor(prefabParser.ctx).getTexture(textureData.name);
            textureData.texelSize = texBytes.readVector2();
            textureData.wrapModeU = texBytes.readUnit32();
            textureData.wrapModeV = texBytes.readUnit32();
            textureData.wrapModeW = texBytes.readUnit32();
            textureData.wrapMode = texBytes.readUnit32();
            textureData.anisoLevel = texBytes.readUnit32();
            textureData.dimension = texBytes.readUnit32();
            textureData.filterMode = texBytes.readUnit32();
            textures.push(textureData);
          }
          let mat = MaterialUtilities.GetMaterial(shaderName, prefabParser.ctx);
          mat.name = matName;
          for (let i2 = 0; i2 < defines.length; i2++) {
            const define = defines[i2];
            mat.shader.setDefine(define, true);
          }
          MaterialUtilities.applyMaterialTexture(mat, textures);
          MaterialUtilities.applyMaterialProperties(mat, properties);
          Engine3D.resFor(prefabParser.ctx).addMat(id, mat);
        }
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("verify failed.");
      }
    }

    class BlendShapePropertyData {
      shapeName;
      shapeIndex;
      frameCount;
      // public blendShapeFrameDatas: BlendShapeFrameData[];
      blendPositionList = new Float32Array();
      blendNormalList = new Float32Array();
      formBytes(byteArray) {
        let bytes = byteArray.readBytesArray();
        this.shapeName = bytes.readUTF();
        this.shapeIndex = bytes.readInt32();
        this.frameCount = bytes.readInt32();
        let len = bytes.readInt32();
        this.blendPositionList = bytes.readFloat32Array(len * 3);
        let len2 = bytes.readInt32();
        this.blendNormalList = bytes.readFloat32Array(len2 * 3);
      }
    }

    class BlendShapeData {
      vertexCount;
      shapeNames;
      shapeIndexs;
      blendCount;
      // public positionList: Float32Array;
      // public normalList: Float32Array;
      blendShapePropertyDatas;
      blendShapeMap;
      formBytes(byteArray) {
        this.blendShapeMap = /* @__PURE__ */ new Map();
        this.blendShapePropertyDatas = [];
        let bytes = byteArray.readBytesArray();
        this.vertexCount = bytes.readInt32();
        this.shapeNames = bytes.readStringArray();
        this.shapeIndexs = bytes.readIntArray();
        this.blendCount = bytes.readInt32();
        for (let i = 0; i < this.blendCount; i++) {
          let propertyData = new BlendShapePropertyData();
          propertyData.formBytes(bytes);
          this.blendShapePropertyDatas.push(propertyData);
          this.blendShapeMap.set(propertyData.shapeName, propertyData);
        }
        return byteArray;
      }
    }

    class PrefabMeshData {
      name;
      meshName;
      meshID;
      vertexCount;
      vertexStrip;
      vertexBuffer;
      indices;
      attributes;
      bones;
      bindPose;
      blendShapeData;
    }

    class PrefabMeshParser extends ParserBase {
      static format = ParserFormat.BIN;
      /**
       * Parse a raw mesh buffer. Reserved entry point; not used by the prefab
       * pipeline, which decodes meshes through {@link PrefabMeshParser.parserMeshs}.
       * @param buffer the raw mesh buffer.
       */
      async parseBuffer(buffer) {
      }
      /**
       * Read every mesh block from the stream, build the corresponding
       * geometries, and register them on the resource host keyed by mesh id.
       * @param bytesStream the prefab binary stream positioned at the mesh section.
       * @param prefabParser the owning prefab parser, used for context lookup.
       */
      static parserMeshs(bytesStream, prefabParser) {
        let meshCount = bytesStream.readInt32();
        for (let j = 0; j < meshCount; j++) {
          let prefabMesh = new PrefabMeshData();
          let meshBytesArray = bytesStream.readBytesArray();
          prefabMesh.meshName = meshBytesArray.readUTF();
          prefabMesh.meshID = meshBytesArray.readUTF();
          meshBytesArray.readFloat32() > 0;
          meshBytesArray.readFloat32() > 0;
          meshBytesArray.readFloat32() > 0;
          let useSkeleton = meshBytesArray.readFloat32() > 0;
          let useBlendShape = meshBytesArray.readFloat32() > 0;
          if (useSkeleton) {
            prefabMesh.bones = meshBytesArray.readStringArray();
            prefabMesh.bindPose = meshBytesArray.readMatrix44Array();
          }
          if (useBlendShape) {
            prefabMesh.blendShapeData = new BlendShapeData();
            prefabMesh.blendShapeData.formBytes(meshBytesArray);
          }
          let vertexBlock = meshBytesArray.readBytesArray();
          let vertexBuffer = meshBytesArray.readBytesArray();
          let attCount = vertexBlock.readInt32();
          let vertex_dim = 0;
          let attributes = [];
          for (let i = 0; i < attCount; i++) {
            attributes[i] = {};
            attributes[i].att = MeshVertexAttribute[vertexBlock.readUTF()];
            attributes[i].dim = vertexBlock.readInt32();
            vertex_dim += attributes[i].dim;
            attributes[i].format = vertexBlock.readUTF();
          }
          prefabMesh.vertexCount = vertexBlock.readInt32();
          prefabMesh.vertexBuffer = vertexBuffer.getFloat32Array();
          let tmpIndices = meshBytesArray.readInt32Array();
          let subMesh = [];
          let subMeshCount = meshBytesArray.readInt32();
          for (let jj = 0; jj < subMeshCount; jj++) {
            let subMesh_topology = meshBytesArray.readInt32();
            let subMesh_indexStart = meshBytesArray.readInt32();
            let subMesh_indexCount = meshBytesArray.readInt32();
            let subMesh_baseVertex = meshBytesArray.readInt32();
            let subMesh_firstVertex = meshBytesArray.readInt32();
            let subMesh_vertexCount = meshBytesArray.readInt32();
            meshBytesArray.readVector3();
            meshBytesArray.readVector3();
            let subDes = {
              indexStart: subMesh_indexStart,
              indexCount: subMesh_indexCount,
              vertexStart: subMesh_baseVertex,
              vertexCount: subMesh_vertexCount,
              firstStart: subMesh_firstVertex,
              topology: subMesh_topology,
              index: jj
            };
            subMesh.push(subDes);
          }
          if (tmpIndices.length > 65535) {
            prefabMesh.indices = new Uint32Array(tmpIndices);
          } else {
            prefabMesh.indices = new Uint16Array(tmpIndices);
          }
          let geometry = new GeometryBase();
          geometry.vertexDim = vertex_dim;
          geometry.geometryType = GeometryVertexType.compose_bin;
          geometry.setIndices(prefabMesh.indices);
          geometry.setAttribute(VertexAttributeName.all, prefabMesh.vertexBuffer);
          const dimFormat = ["", "float32", "float32x2", "float32x3", "float32x4"];
          let composeBinLayout = [];
          let floatOffset = 0;
          for (let i = 0; i < attributes.length; i++) {
            const dim = attributes[i].dim;
            composeBinLayout.push({
              name: attributes[i].att,
              format: dimFormat[dim] || `float32`,
              offset: floatOffset * 4,
              shaderLocation: i,
              stride: dim
            });
            floatOffset += dim;
          }
          geometry.vertexBuffer.setComposeBinLayout(composeBinLayout);
          if (useSkeleton) {
            geometry.skinNames = prefabMesh.bones;
            geometry.bindPose = prefabMesh.bindPose;
          }
          if (useBlendShape) {
            geometry.blendShapeData = prefabMesh.blendShapeData;
            geometry.morphTargetsRelative = true;
            geometry.morphTargetDictionary = {};
            for (let i = 0; i < prefabMesh.blendShapeData.blendCount; i++) {
              geometry.setAttribute("a_morphPositions_" + i, prefabMesh.blendShapeData.blendShapePropertyDatas[i].blendPositionList);
              geometry.setAttribute("a_morphNormals_" + i, prefabMesh.blendShapeData.blendShapePropertyDatas[i].blendNormalList);
              for (let i2 = 0; i2 < prefabMesh.blendShapeData.blendCount; i2++) {
                let blendName = prefabMesh.blendShapeData.shapeNames[i2];
                let blendIndex = prefabMesh.blendShapeData.shapeIndexs[i2];
                geometry.morphTargetDictionary[blendName] = blendIndex;
              }
            }
          }
          for (let ii = 0; ii < attributes.length; ii++) {
            const element = attributes[ii].att;
            geometry.setAttribute(element, null);
          }
          for (let kk = 0; kk < subMesh.length; kk++) {
            const element = subMesh[kk];
            geometry.addSubGeometry(element);
          }
          geometry.name = prefabMesh.meshName;
          Engine3D.resFor(prefabParser.ctx).addGeometry(prefabMesh.meshID, geometry);
        }
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("verify failed.");
      }
    }
    let MeshVertexAttribute = {
      "Position": VertexAttributeName.position,
      "Normal": VertexAttributeName.normal,
      "Color": VertexAttributeName.color,
      "Tangent": VertexAttributeName.TANGENT,
      "TexCoord0": VertexAttributeName.uv,
      "TexCoord1": VertexAttributeName.TEXCOORD_1,
      "TexCoord2": VertexAttributeName.TEXCOORD_2,
      "TexCoord3": VertexAttributeName.TEXCOORD_2,
      "TexCoord4": VertexAttributeName.TEXCOORD_4,
      "TexCoord5": VertexAttributeName.TEXCOORD_5,
      "TexCoord6": VertexAttributeName.TEXCOORD_6,
      "TexCoord7": VertexAttributeName.vIndex,
      "BlendIndices": VertexAttributeName.joints0,
      "BlendWeight": VertexAttributeName.weights0
    };

    class BytesArray extends DataView {
      position = 0;
      littleEndian = true;
      constructor(buffer, byteOffset, byteLength) {
        super(buffer, byteOffset, byteLength);
        this.position = 0;
        this.position += this.byteOffset;
      }
      //TODO Improve read/write byte
      readUTF() {
        let len = this.readInt32();
        let b = len % 4;
        if (b > 0 && b < 4) {
          b = 4 - b;
        }
        let ret = "";
        let strBuffer = new Int8Array(this.buffer, this.position, len);
        this.position += len * Int8Array.BYTES_PER_ELEMENT;
        ret += String.fromCharCode.apply(null, strBuffer);
        this.position += b * Int8Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readStringArray() {
        let ret = [];
        let len = this.readInt32();
        for (let i = 0; i < len; i++) {
          ret.push(this.readUTF());
        }
        return ret;
      }
      readByte() {
        let ret = this.buffer[this.position];
        this.position += 1;
        return ret;
      }
      readBoolean() {
        let ret = this.readInt32();
        this.position += 4;
        return ret == 1 ? true : false;
      }
      readBytes(byteLen) {
        let bufferView = new DataView(this.buffer, this.position, byteLen);
        this.position += byteLen;
        return bufferView.buffer;
      }
      readBytesArray() {
        let byteLen = this.readInt32();
        let bufferView = new BytesArray(this.buffer.slice(this.position, this.position + byteLen));
        this.position += byteLen;
        return bufferView;
      }
      readUnit8() {
        let ret = this.getUint8(this.position);
        this.position += Uint8Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readUnit16() {
        let ret = this.getUint16(this.position);
        this.position += Uint16Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readUnit32() {
        let ret = this.getUint32(this.position);
        this.position += Uint32Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readInt8() {
        let ret = this.getInt8(this.position);
        this.position += Int8Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readInt16() {
        let ret = this.getInt16(this.position, this.littleEndian);
        this.position += Int16Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readInt32() {
        let ret = this.getInt32(this.position, this.littleEndian);
        this.position += Int32Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readFloat32() {
        let ret = this.getFloat32(this.position, this.littleEndian);
        this.position += Float32Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readFloat64() {
        let ret = this.getFloat64(this.position, this.littleEndian);
        this.position += Float64Array.BYTES_PER_ELEMENT;
        return ret;
      }
      readInt32Array() {
        let len = this.readInt32();
        let ret = new Int32Array(this.buffer, this.position, len);
        ret = ret.slice(0, len);
        this.position += ret.byteLength;
        return ret;
      }
      readInt32List() {
        let len = this.readInt32();
        let ret = [];
        for (let i = 0; i < len; i++) {
          ret.push(this.readInt32());
        }
        return ret;
      }
      readFloatArray() {
        let len = this.readInt32();
        let ret = [];
        for (let i = 0; i < len; i++) {
          let v = this.readFloat32();
          ret.push(v);
        }
        return ret;
      }
      readIntArray() {
        let len = this.readInt32();
        let ret = [];
        for (let i = 0; i < len; i++) {
          let v = this.readInt32();
          ret.push(v);
        }
        return ret;
      }
      readVector2int() {
        let v = new Vector2();
        v.x = this.readInt32();
        v.y = this.readInt32();
        return v;
      }
      readVector2() {
        let v = new Vector2();
        v.x = this.readFloat32();
        v.y = this.readFloat32();
        return v;
      }
      readVector3() {
        let v = new Vector3();
        v.x = this.readFloat32();
        v.y = this.readFloat32();
        v.z = this.readFloat32();
        return v;
      }
      readVector3Array() {
        let list = [];
        let len = this.readInt32();
        for (let i = 0; i < len; i++) {
          list.push(this.readVector3());
        }
        return list;
      }
      readVector4() {
        let v = new Vector4();
        v.x = this.readFloat32();
        v.y = this.readFloat32();
        v.z = this.readFloat32();
        v.w = this.readFloat32();
        return v;
      }
      readVector4Array() {
        let list = [];
        let len = this.readInt32();
        for (let i = 0; i < len; i++) {
          list.push(this.readVector4());
        }
        return list;
      }
      readColor() {
        let v = new Color();
        v.r = this.readFloat32();
        v.g = this.readFloat32();
        v.b = this.readFloat32();
        v.a = this.readFloat32();
        return v;
      }
      readColorArray() {
        let list = [];
        let len = this.readInt32();
        for (let i = 0; i < len; i++) {
          list.push(this.readColor());
        }
        return list;
      }
      readQuaternion() {
        let v = new Quaternion();
        v.x = this.readFloat32();
        v.y = this.readFloat32();
        v.z = this.readFloat32();
        v.w = this.readFloat32();
        return v;
      }
      readQuaternionArray() {
        let list = [];
        let len = this.readInt32();
        for (let i = 0; i < len; i++) {
          list.push(this.readQuaternion());
        }
        return list;
      }
      readMatrix44() {
        let m = new Matrix4();
        let rawData = m.rawData;
        rawData[0] = this.readFloat32();
        rawData[1] = this.readFloat32();
        rawData[2] = this.readFloat32();
        rawData[3] = this.readFloat32();
        rawData[4] = this.readFloat32();
        rawData[5] = this.readFloat32();
        rawData[6] = this.readFloat32();
        rawData[7] = this.readFloat32();
        rawData[8] = this.readFloat32();
        rawData[9] = this.readFloat32();
        rawData[10] = this.readFloat32();
        rawData[11] = this.readFloat32();
        rawData[12] = this.readFloat32();
        rawData[13] = this.readFloat32();
        rawData[14] = this.readFloat32();
        rawData[15] = this.readFloat32();
        return m;
      }
      readMatrix44Array() {
        let len = this.readInt32();
        let list = [];
        for (let i = 0; i < len; i++) {
          let m = this.readMatrix44();
          list.push(m);
        }
        return list;
      }
      readFloat32Array(len) {
        let ret = new Float32Array(this.buffer, this.position, len);
        ret = ret.slice(0, this.byteLength);
        this.position += len * Float32Array.BYTES_PER_ELEMENT;
        return ret;
      }
      getFloat32Array() {
        let ret = new Float32Array(this.buffer, this.byteOffset, this.byteLength / Float32Array.BYTES_PER_ELEMENT);
        ret = ret.slice(0, this.byteLength);
        return ret;
      }
    }

    class PrefabTextureParser extends ParserBase {
      static format = ParserFormat.TEXT;
      /**
       * Read every texture reference from the stream, load the bitmap textures,
       * and register them on the resource host keyed by texture name.
       * @param bytesStream the prefab binary stream positioned at the texture section.
       * @param prefabParser the owning prefab parser, used for base URL and context.
       * @param loaderFunctions optional loader hooks (progress, URL transform, etc.).
       */
      static async parserTexture(bytesStream, prefabParser, loaderFunctions) {
        let preTextureCount = bytesStream.readInt32();
        let textures = [];
        for (let i = 0; i < preTextureCount; i++) {
          let texName = bytesStream.readUTF();
          if (PrefabParser.useWebp) {
            texName = texName.replace("png", "webp");
            texName = texName.replace("jpb", "webp");
            textures.push(prefabParser.baseUrl + `webp/` + texName);
          } else {
            textures.push(prefabParser.baseUrl + texName);
          }
        }
        const resHost = Engine3D.resFor(prefabParser.ctx);
        let textureList = await resHost.loadBitmapTextures(textures, prefabParser.ctx.engine.setting.loader.numConcurrent, loaderFunctions, true);
        for (const tex of textureList) {
          resHost.addTexture(tex.name, tex);
        }
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("verify failed.");
      }
    }

    var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
    var __decorateClass$5 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.LitSSSShader = class LitSSSShader extends Shader {
      constructor() {
        super();
        ShaderLib.register("PBRLitSSSShader", PBRLitSSSShader);
        let colorShader = new RenderShaderPass("PBRLitSSSShader", "PBRLitSSSShader");
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        this.addRenderPass(colorShader);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = true;
        shaderState.castShadow = true;
        shaderState.receiveEnv = true;
        shaderState.acceptGI = true;
        shaderState.useLight = true;
        this.setDefine("USE_BRDF", true);
        this.setDefine("USE_AO_R", true);
        this.setDefine("USE_ROUGHNESS_G", true);
        this.setDefine("USE_METALLIC_B", true);
        this.setDefine("USE_ALPHA_A", true);
        this.setDefine("USE_CUSTOMUNIFORM", true);
        this.setDefault();
        this.debug();
        this.computes = [
          new PreIntegratedLutCompute(this)
        ];
      }
      debug() {
      }
      setDefault() {
        this.setUniformFloat(`shadowBias`, 35e-5);
        this.setUniformVector4(`transformUV1`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`transformUV2`, new Vector4(0, 0, 1, 1));
        this.setUniformColor(`baseColor`, new Color());
        this.setUniformColor(`emissiveColor`, new Color(1, 1, 1));
        this.setUniformVector4(`materialF0`, new Vector4(0.04, 0.04, 0.04, 1));
        this.setUniformColor(`specularColor`, new Color(0.04, 0.04, 0.04));
        this.setUniformFloat(`envIntensity`, 1);
        this.setUniformFloat(`normalScale`, 1);
        this.setUniformFloat(`roughness`, 1);
        this.setUniformFloat(`metallic`, 0);
        this.setUniformFloat(`ao`, 1);
        this.setUniformFloat(`roughness_min`, 0);
        this.setUniformFloat(`roughness_max`, 1);
        this.setUniformFloat(`metallic_min`, 0);
        this.setUniformFloat(`metallic_max`, 1);
        this.setUniformFloat(`emissiveIntensity`, 0);
        this.setUniformFloat(`alphaCutoff`, 0);
        this.setUniformFloat(`ior`, 1.5);
        this.setUniformFloat(`clearcoatFactor`, 0);
        this.setUniformFloat(`clearcoatRoughnessFactor`, 0);
        this.setUniformColor(`clearcoatColor`, new Color(1, 1, 1));
        this.setUniformFloat(`clearcoatWeight`, 0);
        this.setUniformColor(`skinColor`, new Color(1, 0, 0));
        this.setUniformFloat(`skinPower`, 3.4);
        this.setUniformFloat(`skinColorIns`, 0.5);
        this.setUniformFloat(`curveFactor`, 1);
      }
      set _MainTex(value) {
        this.setTexture("baseMap", value);
      }
      set _BumpMap(value) {
        this.setTexture("normalMap", value);
      }
      set _SSSMap(value) {
        this.setTexture("sssMap", value);
      }
      set _MaskTex(value) {
        this.setTexture("maskMap", value);
      }
      set _UVTransform(value) {
        this.setUniformVector4("transformUV1", value);
      }
      set _Metallic(value) {
        this.setUniformFloat("metallic", value);
      }
      set _Roughness(value) {
        this.setUniformFloat("roughness", value);
      }
      set _MainColor(value) {
        this.setUniformColor("baseColor", value);
      }
      set _AlphaCutoff(value) {
        this.setUniformFloat("alphaCutoff", value);
      }
      set _DoubleSidedEnable(value) {
        let shader = this.getDefaultColorShader();
        shader.shaderState.cullMode = value ? GPUCullMode.none : shader.shaderState.cullMode;
      }
      set _SkinColor(value) {
        this.setUniformColor("skinColor", value);
      }
      set _SkinPower(value) {
        this.setUniformFloat("skinPower", value);
      }
      set _SkinColorIns(value) {
        this.setUniformFloat("skinColorIns", value);
      }
      set curveFactor(value) {
        this.setUniformFloat("curveFactor", value);
      }
      set _SurfaceType(value) {
        let shader = this.getDefaultColorShader();
        if (value == 0) {
          shader.blendMode = BlendMode.NONE;
        } else {
          shader.blendMode = BlendMode.ALPHA;
        }
      }
      set _AlphaCutoffEnable(value) {
        if (value == 0) {
          this.setDefine("USE_ALPHACUT", false);
        } else {
          this.setDefine("USE_ALPHACUT", true);
        }
      }
    };
    exports.LitSSSShader = __decorateClass$5([
      RegisterShader
    ], exports.LitSSSShader);

    var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
    var __decorateClass$4 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.LitShader = class LitShader extends Shader {
      _ctx;
      constructor(ctx) {
        super();
        this._ctx = ctx;
        let colorShader = new RenderShaderPass("PBRLItShader", "PBRLItShader");
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        this.addRenderPass(colorShader);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = true;
        shaderState.castShadow = true;
        shaderState.receiveEnv = true;
        shaderState.acceptGI = true;
        shaderState.useLight = true;
        this.setDefine("USE_BRDF", true);
        this.setDefine("USE_ROUGHNESS_G", true);
        this.setDefine("USE_METALLIC_B", true);
        this.setDefine("USE_ALPHA_A", true);
        this.setDefault();
      }
      setDefault() {
        this.setUniformFloat(`shadowBias`, 35e-5);
        this.setUniformVector4(`transformUV1`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`transformUV2`, new Vector4(0, 0, 1, 1));
        this.setUniformColor(`baseColor`, new Color());
        this.setUniformColor(`emissiveColor`, new Color(0, 0, 0));
        this.setUniformVector4(`materialF0`, new Vector4(0.04, 0.04, 0.04, 1));
        this.setUniformColor(`specularColor`, new Color(0.04, 0.04, 0.04));
        this.setUniformFloat(`envIntensity`, 1);
        this.setUniformFloat(`normalScale`, 1);
        this.setUniformFloat(`roughness`, 1);
        this.setUniformFloat(`metallic`, 0);
        this.setUniformFloat(`ao`, 1);
        this.setUniformFloat(`roughness_min`, 0);
        this.setUniformFloat(`roughness_max`, 1);
        this.setUniformFloat(`metallic_min`, 0);
        this.setUniformFloat(`metallic_max`, 1);
        this.setUniformFloat(`emissiveIntensity`, 0);
        this.setUniformFloat(`alphaCutoff`, 0);
        this.setUniformFloat(`ior`, 1.5);
        this.setUniformFloat(`clearcoatFactor`, 0);
        this.setUniformFloat(`clearcoatRoughnessFactor`, 0);
        this.setUniformColor(`clearcoatColor`, new Color(1, 1, 1));
        this.setUniformFloat(`clearcoatWeight`, 0);
        const res = Engine3D.resFor(this._ctx);
        this._MainTex = res.grayTexture;
        this._BumpMap = res.normalTexture;
        this._MaskTex = res.maskTexture;
      }
      set _MainTex(value) {
        this.setTexture("baseMap", value);
      }
      set _BumpMap(value) {
        this.setTexture("normalMap", value);
      }
      set _MaskTex(value) {
        this.setTexture("maskMap", value);
      }
      set _UVTransform(value) {
        this.setUniformVector4("transformUV1", value);
      }
      set _Metallic(value) {
        this.setUniformFloat("metallic", value);
      }
      set _Roughness(value) {
        this.setUniformFloat("roughness", value);
      }
      set _MainColor(value) {
        this.setUniformColor("baseColor", value);
      }
      set _AlphaCutoff(value) {
        this.setUniformFloat("alphaCutoff", value);
      }
      set _DoubleSidedEnable(value) {
        let subShader = this.getDefaultColorShader();
        subShader.shaderState.cullMode = value ? GPUCullMode.none : subShader.shaderState.cullMode;
      }
      set _SurfaceType(value) {
        let subShader = this.getDefaultColorShader();
        if (value == 0) {
          subShader.blendMode = BlendMode.NONE;
        } else {
          subShader.blendMode = BlendMode.ALPHA;
        }
      }
      set _AlphaCutoffEnable(value) {
        if (value == 0) {
          this.setDefine("USE_ALPHACUT", false);
        } else {
          this.setDefine("USE_ALPHACUT", true);
        }
      }
    };
    exports.LitShader = __decorateClass$4([
      RegisterShader
    ], exports.LitShader);

    class ComData {
      comName;
      data;
      static parser(bytesArray) {
        let comBuffer = bytesArray.readBytesArray();
        let comData = new ComData();
        comData.comName = comBuffer.readUTF();
        comData.data = [];
        let count = comBuffer.readInt32();
        for (let i = 0; i < count; i++) {
          let kv = new KV();
          kv.formBytes(comBuffer);
          comData.data.push(kv);
        }
        return comData;
      }
    }
    class PrefabNode {
      name;
      parentName;
      position;
      rotation;
      scale;
      comDatas;
      child;
      static parser(bytesArray) {
        let nodeBytes = bytesArray.readBytesArray();
        let prefabNode = new PrefabNode();
        prefabNode.name = nodeBytes.readUTF();
        prefabNode.parentName = nodeBytes.readUTF();
        prefabNode.position = nodeBytes.readVector3();
        prefabNode.rotation = nodeBytes.readQuaternion();
        prefabNode.scale = nodeBytes.readVector3();
        prefabNode.comDatas = [];
        prefabNode.child = [];
        let comCount = nodeBytes.readInt32();
        for (let i = 0; i < comCount; i++) {
          const comData = ComData.parser(nodeBytes);
          prefabNode.comDatas.push(comData);
        }
        let childCount = nodeBytes.readInt32();
        for (let i = 0; i < childCount; i++) {
          const childNodeData = PrefabNode.parser(nodeBytes);
          prefabNode.child.push(childNodeData);
        }
        return prefabNode;
      }
    }

    class PrefabParser extends ParserBase {
      /**
       * When true, texture URLs are rewritten to the `webp` variant before loading.
       */
      static useWebp = true;
      static format = ParserFormat.BIN;
      /**
       * Map of decoded avatar (skeleton) data keyed by avatar name.
       */
      avatarDic;
      /**
       * Root node of the decoded prefab hierarchy.
       */
      nodeData;
      /**
       * Decode the prefab buffer: parse textures, avatars, meshes, materials and
       * the node tree, then build the resulting {@link Object3D} hierarchy into `data`.
       * @param buffer the raw prefab binary buffer.
       */
      async parseBuffer(buffer) {
        this.avatarDic = {};
        const prevCtx = ValueParser._currentCtx;
        ValueParser._currentCtx = this.ctx;
        try {
          let bytesStream = new BytesArray(buffer, 0);
          await PrefabTextureParser.parserTexture(bytesStream, this, this.loaderFunctions);
          PrefabAvatarParser.parser(bytesStream, this);
          PrefabMeshParser.parserMeshs(bytesStream, this);
          PrefabMaterialParser.parserMaterial(bytesStream, this);
          this.nodeData = this.parserPrefabNode(bytesStream);
          this.data = this.data = this.parserNodeTree(this.nodeData);
        } finally {
          ValueParser._currentCtx = prevCtx;
        }
      }
      parserPrefabNode(bytesStream) {
        let rootNodeData = PrefabNode.parser(bytesStream);
        return rootNodeData;
      }
      parserNodeTree(nodeData) {
        let root = new exports.Object3D();
        root.localPosition = Vector3.serialize(nodeData.position);
        root.localQuaternion = Quaternion.serialize(nodeData.rotation);
        root.localScale = Vector3.serialize(nodeData.scale);
        root.name = nodeData.name;
        if (nodeData.comDatas) {
          for (let i = 0; i < nodeData.comDatas.length; i++) {
            const comData = nodeData.comDatas[i];
            let com = null;
            let comClass = GetComponentClass(comData.comName);
            if (comClass) {
              com = root.getOrAddComponent(comClass);
              for (let j = 0; j < comData.data.length; j++) {
                const kv = comData.data[j];
                if (kv.key in com) {
                  com[kv.key] = kv.getValue();
                }
              }
            }
          }
        }
        if (nodeData.child && nodeData.child.length > 0) {
          for (let j = 0; j < nodeData.child.length; j++) {
            let child = this.parserNodeTree(nodeData.child[j]);
            root.addChild(child);
          }
        }
        return root;
      }
      /**
       * Verify that parsing produced valid data.
       * @returns true when data is present; throws otherwise.
       */
      verification() {
        if (this.data) {
          return true;
        }
        throw new Error("verify failed.");
      }
    }

    class PrefabStringUtil {
      /**
       * Parse a string as a floating-point number.
       * @param st the source string.
       */
      static getNumber(st) {
        let v = parseFloat(st);
        return v;
      }
      /**
       * Parse a string as an integer.
       * @param st the source string.
       */
      static getInt(st) {
        let v = parseInt(st);
        return v;
      }
      /**
       * Parse a string as a boolean (`"true"` maps to true, anything else false).
       * @param st the source string.
       */
      static getBoolean(st) {
        let v = st == "true" ? true : false;
        return v;
      }
      /**
       * Parse a bracketed, comma-separated string into a list of numbers.
       * @param st the source string, e.g. `"[1,2,3]"`.
       */
      static getNumberArray(st) {
        let v = st.replaceAll("[", "");
        v = v.replaceAll("]", "");
        let list = v.split(",");
        for (let i = 0; i < list.length; i++) {
          parseFloat(list[i]);
        }
        return v;
      }
      /**
       * Parse a bracketed, comma-separated string into a list of strings.
       * @param st the source string, e.g. `"[a,b,c]"`.
       */
      static getStringArray(st) {
        let v = st.replaceAll("[", "");
        v = v.replaceAll("]", "");
        let list = v.split(",");
        let ret = [];
        for (let i = 0; i < list.length; i++) {
          const element = list[i];
          ret.push(element);
        }
        return ret;
      }
      /**
       * Parse a string into a {@link Vector2}. (Reserved; not yet implemented.)
       * @param st the source string.
       */
      static getVector2(st) {
      }
      /**
       * Parse a string into a {@link Vector3}. (Reserved; not yet implemented.)
       * @param st the source string.
       */
      static getVector3(st) {
      }
      /**
       * Parse a string into a {@link Vector4}. (Reserved; not yet implemented.)
       * @param st the source string.
       */
      static getVector4(st) {
      }
      /**
       * Parse a string into a {@link Quaternion}. (Reserved; not yet implemented.)
       * @param st the source string.
       */
      static getQuaternion(st) {
      }
      /**
       * Parse a string into a {@link Color}. (Reserved; not yet implemented.)
       * @param st the source string.
       */
      static getColor(st) {
      }
    }

    var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
    var __decorateClass$3 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.LitHairShader = class LitHairShader extends Shader {
      constructor() {
        super();
        this.create_opPass();
        this.setDefine("USEC", true);
        this.setDefine("USE_BRDF", true);
        this.setDefine("USE_AO_R", true);
        this.setDefine("USE_ROUGHNESS_G", true);
        this.setDefine("USE_METALLIC_B", true);
        this.setDefine("USE_ALPHA_A", true);
        this.setDefine("USE_HAIR", true);
        this.setDefine("USE_CUSTOMUNIFORM", true);
        this.setDefine("USE_HAIRCOLOR", true);
        this.setDefault();
        this.debug();
      }
      create_opPass() {
        ShaderLib.register("HairShader_op", Hair_shader_op);
        let colorShader = new RenderShaderPass("HairShader_op", "HairShader_op");
        this.addRenderPass(colorShader);
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = true;
        shaderState.castShadow = true;
        shaderState.receiveEnv = true;
        shaderState.acceptGI = true;
        shaderState.useLight = true;
        shaderState.blendMode = BlendMode.NONE;
        shaderState.cullMode = GPUCullMode.none;
        shaderState.writeMasks[0] = GPUColorWrite.ALL;
      }
      create_trPass() {
        ShaderLib.register("HairShader_tr", Hair_shader_tr);
        let colorShader = new RenderShaderPass("HairShader_tr", "HairShader_tr");
        this.addRenderPass(colorShader);
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = true;
        shaderState.castShadow = true;
        shaderState.receiveEnv = true;
        shaderState.acceptGI = true;
        shaderState.useLight = true;
        shaderState.depthWriteEnabled = false;
        shaderState.blendMode = BlendMode.NORMAL;
        shaderState.cullMode = GPUCullMode.none;
        shaderState.writeMasks[0] = GPUColorWrite.ALL;
        shaderState.writeMasks[1] = 0;
        shaderState.writeMasks[2] = 0;
        shaderState.writeMasks[3] = 0;
      }
      debug() {
      }
      setDefault() {
        this.setUniformFloat(`shadowBias`, 35e-5);
        this.setUniformVector4(`transformUV1`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`transformUV2`, new Vector4(0, 0, 1, 1));
        this.setUniformColor(`baseColor0`, new Color(3 / 255, 2 / 255, 2 / 255));
        this.setUniformColor(`baseColor1`, new Color(2 / 255, 2 / 255, 2 / 255));
        this.setUniformColor(`emissiveColor`, new Color(1, 1, 1));
        this.setUniformVector4(`materialF0`, new Vector4(0.04, 0.04, 0.04, 1));
        this.setUniformColor(`specularColor`, new Color(36 / 255, 36 / 255, 36 / 255));
        this.setUniformFloat(`envIntensity`, 1);
        this.setUniformFloat(`normalScale`, 1);
        this.setUniformFloat(`roughness`, 0.1);
        this.setUniformFloat(`metallic`, 0.3);
        this.setUniformFloat(`ao`, 1);
        this.setUniformFloat(`roughness_min`, 0);
        this.setUniformFloat(`roughness_max`, 1);
        this.setUniformFloat(`metallic_min`, 0);
        this.setUniformFloat(`metallic_max`, 1);
        this.setUniformFloat(`emissiveIntensity`, 0);
        this.setUniformFloat(`alphaCutoff`, 0.1);
        this.setUniformFloat(`ior`, 1.5);
        this.setUniformFloat(`backlit`, 0.3987);
        this.setUniformFloat(`area`, 0.0615);
      }
      set _MainTex(value) {
        this.setTexture("baseMap", value);
      }
      set _IDMap(value) {
        this.setTexture("idMap", value);
      }
      set _DepthMap(value) {
        this.setTexture("depthMap", value);
      }
      set _RootMap(value) {
        this.setTexture("rootMap", value);
      }
      set _AlphaMap(value) {
        this.setTexture("alphaMap", value);
      }
      set _UVTransform(value) {
        this.setUniformVector4("transformUV1", value);
      }
      set _Metallic(value) {
        this.setUniformFloat("metallic", value);
      }
      set _Roughness(value) {
        this.setUniformFloat("roughness", value);
      }
      set _HairColor0(value) {
        this.setUniformColor("baseColor0", value);
      }
      set _HairColor1(value) {
        this.setUniformColor("baseColor1", value);
      }
      set _SpecularColor(value) {
        this.setUniformColor("specularColor", value);
      }
      set _AlphaCutoff(value) {
        this.setUniformFloat("alphaCutoff", value);
      }
      set _BackLit(value) {
        this.setUniformFloat("backlit", value);
      }
      set _Area(value) {
        this.setUniformFloat("area", value);
      }
      set _DoubleSidedEnable(value) {
        let subShader = this.getSubShaders(PassType.COLOR)[0];
        subShader.shaderState.cullMode = value ? GPUCullMode.none : subShader.shaderState.cullMode;
      }
      set _SurfaceType(value) {
      }
      set _AlphaCutoffEnable(value) {
        if (value == 0) {
          this.setDefine("USE_ALPHACUT", false);
        } else {
          this.setDefine("USE_ALPHACUT", true);
        }
      }
    };
    exports.LitHairShader = __decorateClass$3([
      RegisterShader
    ], exports.LitHairShader);

    var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
    var __decorateClass$2 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.UnLitShader = class UnLitShader extends Shader {
      constructor() {
        super();
        let colorShader = new RenderShaderPass("UnLit", "UnLit");
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        this.addRenderPass(colorShader);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = false;
        shaderState.castShadow = false;
        shaderState.receiveEnv = false;
        shaderState.acceptGI = false;
        shaderState.useLight = false;
        this.setDefine("USE_BRDF", true);
        this.setDefine("USE_AO_R", true);
        this.setDefine("USE_ROUGHNESS_G", true);
        this.setDefine("USE_METALLIC_B", true);
        this.setDefine("USE_ALPHA_A", true);
        this.setDefault();
      }
      setDefault() {
        this.setUniformVector4(`transformUV1`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`transformUV2`, new Vector4(0, 0, 1, 1));
        this.setUniformColor(`baseColor`, new Color());
        this.setUniformFloat(`alphaCutoff`, 0);
      }
      set _MainTex(value) {
        this.setTexture("baseMap", value);
      }
      set _BumpMap(value) {
        this.setTexture("normalMap", value);
      }
      set _MaskTex(value) {
        this.setTexture("maskMap", value);
      }
      set _UVTransform(value) {
        this.setUniformVector4("transformUV1", value);
      }
      set _Metallic(value) {
        this.setUniformFloat("metallic", value);
      }
      set _Roughness(value) {
        this.setUniformFloat("roughness", value);
      }
      set _MainColor(value) {
        this.setUniformColor("baseColor", value);
      }
      set _AlphaCutoff(value) {
        this.setUniformFloat("alphaCutoff", value);
      }
      set _DoubleSidedEnable(value) {
        let defaultShader = this.getDefaultColorShader();
        defaultShader.shaderState.cullMode = value ? GPUCullMode.none : defaultShader.shaderState.cullMode;
      }
      set _SurfaceType(value) {
        let defaultShader = this.getDefaultColorShader();
        if (value == 0) {
          defaultShader.blendMode = BlendMode.NONE;
        } else {
          defaultShader.blendMode = BlendMode.ALPHA;
        }
      }
      set _AlphaCutoffEnable(value) {
        if (value == 0) {
          this.setDefine("USE_ALPHACUT", false);
        } else {
          this.setDefine("USE_ALPHACUT", true);
        }
      }
    };
    exports.UnLitShader = __decorateClass$2([
      RegisterShader
    ], exports.UnLitShader);

    var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
    var __decorateClass$1 = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.UnLitTexArrayShader = class UnLitTexArrayShader extends Shader {
      constructor() {
        super();
        ShaderLib.register("VertexAttributeIndexShader", VertexAttributeIndexShader);
        ShaderLib.register("UnLitTextureArray", UnLitTextureArray);
        let colorShader = new RenderShaderPass("UnLitTextureArray", "UnLitTextureArray");
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        this.addRenderPass(colorShader);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = false;
        shaderState.castShadow = false;
        shaderState.receiveEnv = false;
        shaderState.acceptGI = false;
        shaderState.useLight = false;
        this.setDefine("USE_BRDF", true);
        this.setDefine("USE_AO_R", true);
        this.setDefine("USE_ROUGHNESS_G", true);
        this.setDefine("USE_METALLIC_B", true);
        this.setDefine("USE_ALPHA_A", true);
        this.setDefault();
      }
      setDefault() {
        this.setUniformVector4(`transformUV1`, new Vector4(0, 0, 1, 1));
        this.setUniformVector4(`transformUV2`, new Vector4(0, 0, 1, 1));
        this.setUniformColor(`baseColor`, new Color());
        this.setUniformFloat(`alphaCutoff`, 0);
      }
      set _MainTex(value) {
        this.setTexture("baseMap", value);
      }
      set _BumpMap(value) {
        this.setTexture("normalMap", value);
      }
      set _MaskTex(value) {
        this.setTexture("maskMap", value);
      }
      set _UVTransform(value) {
        this.setUniformVector4("transformUV1", value);
      }
      set _Metallic(value) {
        this.setUniformFloat("metallic", value);
      }
      set _Roughness(value) {
        this.setUniformFloat("roughness", value);
      }
      set _MainColor(value) {
        this.setUniformColor("baseColor", value);
      }
      set _AlphaCutoff(value) {
        this.setUniformFloat("alphaCutoff", value);
      }
      set _DoubleSidedEnable(value) {
        let defaultShader = this.getDefaultColorShader();
        defaultShader.shaderState.cullMode = value ? GPUCullMode.none : defaultShader.shaderState.cullMode;
      }
      set _SurfaceType(value) {
        let defaultShader = this.getDefaultColorShader();
        if (value == 0) {
          defaultShader.blendMode = BlendMode.NONE;
        } else {
          defaultShader.blendMode = BlendMode.ALPHA;
        }
      }
      set _AlphaCutoffEnable(value) {
        if (value == 0) {
          this.setDefine("USE_ALPHACUT", false);
        } else {
          this.setDefine("USE_ALPHACUT", true);
        }
      }
    };
    exports.UnLitTexArrayShader = __decorateClass$1([
      RegisterShader
    ], exports.UnLitTexArrayShader);

    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __decorateClass = (decorators, target, key, kind) => {
      var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if (decorator = decorators[i])
          result = (decorator(result)) || result;
      return result;
    };
    exports.APatch = class APatch extends ComponentBase {
      size;
      blockSize;
      walk;
      obs;
      colors;
      aPaths;
      onGraphic(view) {
      }
    };
    exports.APatch = __decorateClass([
      RegisterComponent(exports.APatch, "APatch")
    ], exports.APatch);

    class BlendShapeFrameData {
      weight;
      // public deltaVertices: Vector3[];
      // public deltaNormals: Vector3[];
      // public deltaTangents: Vector3[];
      deltaVertices;
      deltaNormals;
      deltaTangents;
      formBytes(byteArray) {
        let bytes = byteArray.readBytesArray();
        this.weight = bytes.readFloat32();
        let len = 0;
        len = bytes.readInt32();
        this.deltaVertices = bytes.readFloat32Array(len * 3);
        len = bytes.readInt32();
        this.deltaNormals = bytes.readFloat32Array(len * 3);
        len = bytes.readInt32();
        this.deltaTangents = bytes.readFloat32Array(len * 3);
      }
    }

    class TileSet {
      asset;
      extras;
      geometricError;
      properties;
      refine;
      root;
    }
    class TileSetRoot {
      boundingVolume;
      children;
      geometricError;
      transform;
    }
    class TileSetChild {
      boundingVolume;
      geometricError;
      refine;
      content;
      contents;
    }
    class TileSetChildContent {
      uri;
      group;
      metadata;
    }
    class TileSetChildContentMetaData {
      class;
      properties;
    }

    class TilesRenderer {
      group;
      _modelList;
      _tileSet;
      _rootPath;
      _ctx;
      constructor(ctx) {
        this.group = new exports.Object3D();
        this._ctx = ctx;
      }
      /**
       * Load a tileset and add all of its tiles as children of `group`.
       * @param rootPath Base directory used to resolve tile content URIs.
       * @param file Tileset descriptor file name (e.g. `tileset.json`).
       */
      async loadTileSet(rootPath, file) {
        this._modelList = [];
        this._rootPath = rootPath;
        let combinePath = rootPath + "/" + file;
        const res = Engine3D.resFor(this._ctx);
        this._tileSet = await res.loadJSON(combinePath);
        if (this._tileSet.root.transform) {
          let rootMatrix = new Matrix4();
          for (let i = 0; i < 16; i++) {
            rootMatrix.rawData[i] = this._tileSet.root.transform[i];
          }
        }
        let adjustmentTransform = new Matrix4();
        const upAxis = this._tileSet.asset && this._tileSet.asset.gltfUpAxis || "y";
        switch (upAxis.toLowerCase()) {
          case "x":
            adjustmentTransform.makeRotationAxis(Vector3.Y_AXIS, -Math.PI / 2);
            break;
          case "y":
            adjustmentTransform.makeRotationAxis(Vector3.X_AXIS, Math.PI / 2);
            break;
          case "z":
            adjustmentTransform.identity();
            break;
        }
        let invertMatrix = adjustmentTransform.clone();
        invertMatrix.invert();
        this.applyTransform(this.group.transform, invertMatrix);
        for (let item of this._tileSet.root.children) {
          let uriList = [];
          if (item.content && item.content.uri) {
            uriList.push(item.content.uri);
          }
          if (item.contents) {
            for (let c of item.contents) {
              uriList.push(c.uri);
            }
          }
          for (let uriPath of uriList) {
            let url = this._rootPath + "/" + uriPath;
            let functions = {
              onProgress: (e) => this.onLoadProgress(e),
              onComplete: (e) => this.onComplete(e)
            };
            let tileObject3D;
            if (url.endsWith(".glb")) {
              tileObject3D = await res.loadGltf(url, functions);
              this.applyTransform(tileObject3D.transform, adjustmentTransform);
            } else if (url.endsWith("tileset.json")) {
              let childTilesetUrl = url.replace("/tileset.json", "");
              let tilesRenderer = new TilesRenderer(this._ctx);
              await tilesRenderer.loadTileSet(childTilesetUrl, "tileset.json");
              tileObject3D = tilesRenderer.group;
            } else if (url.endsWith(".i3dm")) {
              tileObject3D = await res.loadI3DM(url, functions, adjustmentTransform);
            } else if (url.endsWith(".b3dm")) {
              tileObject3D = await res.loadB3DM(url, functions, adjustmentTransform);
            }
            if (tileObject3D) {
              this._modelList.push(tileObject3D);
              this.group.addChild(tileObject3D);
            }
          }
        }
      }
      onLoadProgress(e) {
      }
      onComplete(e) {
      }
      applyTransform(transform, matrix) {
        let prs = matrix.decompose(Orientation3D.QUATERNION);
        transform.localRotQuat.copy(prs[1]);
        transform.localRotQuat = transform.localRotQuat;
        transform.localPosition.copy(prs[0]);
        transform.localPosition = transform.localPosition;
        transform.localScale.copy(prs[2]);
        transform.localScale = transform.localScale;
      }
    }

    class ColorLitMaterial extends Material {
      static count = 0;
      /**
       * @constructor
       */
      constructor(ctx) {
        super();
        ShaderLib.register("ColorLitShader", ColorLitShader);
        this.shader = new Shader();
        let renderShader = new RenderShaderPass(`ColorLitShader`, `ColorLitShader`);
        renderShader.passType = PassType.COLOR;
        this.shader.addRenderPass(renderShader);
        renderShader.setDefine("USE_BRDF", true);
        renderShader.setShaderEntry(`VertMain`, `FragMain`);
        renderShader.setUniformColor(`baseColor`, new Color());
        renderShader.setUniformColor(`emissiveColor`, new Color());
        renderShader.setUniformFloat(`envIntensity`, 1);
        renderShader.setUniformFloat(`normalScale`, 1);
        renderShader.setUniformFloat(`roughness`, 0);
        renderShader.setUniformFloat(`metallic`, 0);
        renderShader.setUniformFloat(`ao`, 1);
        renderShader.setUniformFloat(`alphaCutoff`, 0);
        let shaderState = renderShader.shaderState;
        shaderState.acceptShadow = true;
        shaderState.receiveEnv = true;
        shaderState.acceptGI = true;
        shaderState.useLight = true;
        const res = Engine3D.resFor(ctx);
        renderShader.setTexture("normalMap", res.normalTexture);
        renderShader.setTexture("emissiveMap", res.blackTexture);
      }
      clone() {
        return null;
      }
      debug() {
      }
    }

    class GlassMaterial extends Material {
      /**
       * @constructor
       */
      constructor(ctx) {
        super();
        ShaderLib.register("GlassShader", GlassShader);
        this.shader = new Shader();
        let colorShader = new RenderShaderPass("GlassShader", "GlassShader");
        colorShader.passType = PassType.COLOR;
        colorShader.setDefine("USE_BRDF", true);
        colorShader.setShaderEntry(`VertMain`, `FragMain`);
        let shaderState = colorShader.shaderState;
        shaderState.acceptShadow = true;
        shaderState.castShadow = true;
        shaderState.receiveEnv = true;
        shaderState.acceptGI = true;
        shaderState.useLight = true;
        const res = Engine3D.resFor(ctx);
        this.shader.setTexture("baseMap", res.whiteTexture);
        this.shader.setTexture("normalMap", res.normalTexture);
        this.shader.setTexture("emissiveMap", res.blackTexture);
      }
      // clone(): this {
      //     console.log(`clone material ${this.name}`);
      //     let ret = new GlassMaterial();
      //     ret.baseMap = this.baseMap;
      //     ret.normalMap = this.normalMap;
      //     ret.aoMap = this.aoMap;
      //     if (this.maskMap) ret.maskMap = this.maskMap;
      //     ret.emissiveMap = this.emissiveMap;
      //     this.transformUV1 && (ret.transformUV1 = new Vector4().copy(this.transformUV1));
      //     this.uvTransform_2 && (ret.uvTransform_2 = new Vector4().copy(this.uvTransform_2));
      //     ret.baseColor = this.baseColor.clone();
      //     ret.emissiveColor = this.emissiveColor.clone();
      //     this.materialF0 && (ret.materialF0 = new Vector4().copy(this.materialF0));
      //     ret.envIntensity = this.envIntensity;
      //     ret.normalScale = this.normalScale;
      //     ret.roughness = this.roughness;
      //     ret.metallic = this.metallic;
      //     ret.ao = this.ao;
      //     ret.roughness_min = this.roughness_min;
      //     ret.roughness_max = this.roughness_max;
      //     ret.metallic_min = this.metallic_min;
      //     ret.metallic_max = this.metallic_max;
      //     ret.emissiveIntensity = this.emissiveIntensity;
      //     ret.alphaCutoff = this.alphaCutoff;
      //     ret.ior = this.ior;
      //     ret.clearcoatFactor = this.clearcoatFactor;
      //     ret.clearcoatRoughnessFactor = this.clearcoatRoughnessFactor;
      //     return ret as this;
      // }
    }

    class HairMaterial extends Material {
      constructor(_ctx) {
        super();
        this.shader = new exports.LitHairShader();
      }
    }

    class LambertMaterial extends Material {
      _alphaMode = "OPAQUE";
      /**
       * @constructor
       */
      constructor(ctx) {
        super();
        let colorPass = new RenderShaderPass(`LambertShader`, `LambertShader`);
        colorPass.setShaderEntry(`VertMain`, `FragMain`);
        colorPass.passType = PassType.COLOR;
        colorPass.setUniformVector4(`transformUV1`, new Vector4(0, 0, 1, 1));
        colorPass.setUniformVector4(`transformUV2`, new Vector4(0, 0, 1, 1));
        colorPass.setUniformColor(`baseColor`, new Color(1, 1, 1, 1));
        colorPass.setUniformFloat(`alphaCutoff`, 0.5);
        let shaderState = colorPass.shaderState;
        shaderState.acceptShadow = false;
        shaderState.castShadow = false;
        shaderState.receiveEnv = false;
        shaderState.acceptGI = false;
        let newShader = new Shader();
        newShader.addRenderPass(colorPass);
        this.shader = newShader;
        this.baseMap = Engine3D.resFor(ctx).grayTexture;
      }
      /** glTF-aligned alpha handling. Mirrors LitMaterial.alphaMode so
       *  Lambert-shaded transparency uses the same routing rules. */
      get alphaMode() {
        return this._alphaMode;
      }
      /** Sets the glTF alpha mode and reconfigures blend/depth/define state. */
      set alphaMode(mode) {
        if (this._alphaMode === mode) return;
        this._alphaMode = mode;
        const colorPass = this.shader.getDefaultColorShader();
        const state = colorPass.shaderState;
        switch (mode) {
          case "OPAQUE":
            state.transparent = false;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 0;
            break;
          case "MASK":
            state.transparent = false;
            state.alphaToCoverageEnabled = true;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 0;
            break;
          case "HASH":
            state.transparent = false;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHAHASH", true);
            colorPass.renderOrder = 0;
            break;
          case "BLEND":
            state.transparent = true;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NORMAL;
            state.depthWriteEnabled = false;
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 3e3;
            break;
        }
        this._notifyRenderClassificationDirty();
      }
      /**
       * set base color map texture
       */
      set baseMap(tex) {
        this.shader.setTexture(`baseMap`, tex);
      }
      /**
       * get base color map texture
       */
      get baseMap() {
        return this.shader.getTexture(`baseMap`);
      }
      /**
       * set base color (tint color)
       */
      set baseColor(color) {
        this.shader.setUniformColor(`baseColor`, color);
      }
      /**
       * get base color (tint color)
       */
      get baseColor() {
        return this.shader.getUniformColor("baseColor");
      }
      /**
       * set environment texture, usually referring to cubemap
       */
      set envMap(texture) {
      }
      /**
       * @internal
       * set shadow map
       */
      set shadowMap(texture) {
      }
    }

    function registerMaterial(name, cls) {
    }

    class SkinMaterial extends LitMaterial {
      /** Creates the material, enables the subsurface path, and applies default skin uniforms. */
      constructor(ctx) {
        super(ctx);
        this.shader.setDefine("USE_SUBSURFACE", true);
        this.shader.setUniformFloat("subsurfaceRadius", 1);
        this.shader.setUniformColor("subsurfaceColor", { r: 1, g: 0.4, b: 0.3, a: 1 });
      }
      /** Sets the subsurface scattering radius uniform. */
      set subsurfaceRadius(value) {
        this.shader.setUniformFloat("subsurfaceRadius", value);
      }
      /** Gets the subsurface scattering radius uniform. */
      get subsurfaceRadius() {
        return this.shader.getUniformFloat("subsurfaceRadius");
      }
      /** Sets the thickness map texture and enables the thickness-map shader path. */
      set thicknessMap(texture) {
        this.shader.setTexture("thicknessMap", texture);
        this.shader.setDefine("USE_THICKNESS_MAP", true);
      }
      /** Gets the thickness map texture. */
      get thicknessMap() {
        return this.shader.getTexture("thicknessMap");
      }
    }

    class UnLitMaterial extends Material {
      _alphaMode = "OPAQUE";
      /**
       * @constructor
       */
      constructor(ctx) {
        super();
        this.shader = new exports.UnLitShader();
        this.baseMap = Engine3D.resFor(ctx).whiteTexture;
      }
      /** glTF-aligned alpha handling. Mirrors LitMaterial.alphaMode so
       *  unlit-shaded transparency uses the same routing rules. */
      get alphaMode() {
        return this._alphaMode;
      }
      /** Sets the glTF alpha mode and reconfigures blend/depth/define state. */
      set alphaMode(mode) {
        if (this._alphaMode === mode) return;
        this._alphaMode = mode;
        const colorPass = this.shader.getDefaultColorShader();
        const state = colorPass.shaderState;
        switch (mode) {
          case "OPAQUE":
            state.transparent = false;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 0;
            break;
          case "MASK":
            state.transparent = false;
            state.alphaToCoverageEnabled = true;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 0;
            break;
          case "HASH":
            state.transparent = false;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NONE;
            state.depthWriteEnabled = true;
            colorPass.setDefine("USE_ALPHAHASH", true);
            colorPass.renderOrder = 0;
            break;
          case "BLEND":
            state.transparent = true;
            state.alphaToCoverageEnabled = false;
            state.blendMode = BlendMode.NORMAL;
            state.depthWriteEnabled = false;
            colorPass.setDefine("USE_ALPHAHASH", false);
            colorPass.renderOrder = 3e3;
            break;
        }
        this._notifyRenderClassificationDirty();
      }
      /** Sets the base color map texture. */
      set baseMap(texture) {
        this.shader.setTexture(`baseMap`, texture);
      }
      /** Gets the base color map texture. */
      get baseMap() {
        return this.shader.getTexture(`baseMap`);
      }
      /**
       * set base color (tint color)
       */
      set baseColor(color) {
        this.shader.setUniformColor(`baseColor`, color);
      }
      /**
       * get base color (tint color)
       */
      get baseColor() {
        return this.shader.getUniformColor("baseColor");
      }
      /**
       * set environment texture, usually referring to cubemap
       */
      set envMap(texture) {
      }
      /**
       * @internal
       * set shadow map
       */
      set shadowMap(texture) {
      }
    }

    class SoftParticleMaterial extends UnLitMaterial {
      _fadeDistance = 0.5;
      /** Creates a soft particle material and enables the soft-fade shader path. */
      constructor(ctx) {
        super(ctx);
        this.shader.setDefine("USE_SOFT_PARTICLES", true);
        this.shader.setUniformFloat("softParticleFadeDistance", this._fadeDistance);
      }
      /** Distance (world units) over which the particle fades to alpha=0
       *  as it approaches an opaque surface. */
      get fadeDistance() {
        return this._fadeDistance;
      }
      /** Sets the world-space distance over which the particle fades near opaque surfaces. */
      set fadeDistance(value) {
        this._fadeDistance = value;
        this.shader.setUniformFloat("softParticleFadeDistance", value);
      }
    }

    class UnLitTexArrayMaterial extends Material {
      /**
       * @constructor
       */
      constructor(ctx) {
        super();
        this.shader = new exports.UnLitTexArrayShader();
        this.baseMap = Engine3D.resFor(ctx).whiteTexture;
      }
      /** Sets the base color map texture array. */
      set baseMap(texture) {
        this.shader.setTexture(`baseMap`, texture);
      }
      /** Gets the base color map texture array. */
      get baseMap() {
        return this.shader.getTexture(`baseMap`);
      }
      /**
       * set base color (tint color)
       */
      set baseColor(color) {
        this.shader.setUniformColor(`baseColor`, color);
      }
      /**
       * get base color (tint color)
       */
      get baseColor() {
        return this.shader.getUniformColor("baseColor");
      }
      // /**
      //  * set environment texture, usually referring to cubemap
      //  */
      // public set envMap(texture: Texture) {
      //     //not need env texture
      // }
      /**
       * @internal
       * set shadow map
       */
      set shadowMap(texture) {
      }
    }

    class PropertyAnimationClip {
      /** Name of the animation clip. */
      clipName;
      /** Whether the clip loops over time. */
      loopTime;
      /** Start time of the clip in seconds. */
      startTime;
      /** Stop time of the clip in seconds. */
      stopTime;
      /** Number of samples per second used when authoring the clip. */
      sampleRate;
      /** Whether the clip drives skeleton position curves. */
      useSkeletonPos;
      /** Whether the clip drives skeleton scale curves. */
      useSkeletonScale;
      /** Position animation curves keyed by node path. */
      positionCurves = /* @__PURE__ */ new Map();
      /** Rotation animation curves keyed by node path. */
      rotationCurves = /* @__PURE__ */ new Map();
      /** Scale animation curves keyed by node path. */
      scaleCurves = /* @__PURE__ */ new Map();
      /** Float-property animation curves keyed by attribute name. */
      floatCurves = /* @__PURE__ */ new Map();
      /** Deserialize the clip and all its curves from the given byte stream. */
      formBytes(bytes) {
        this.clipName = bytes.readUTF();
        this.loopTime = bytes.readInt32() ? false : true;
        this.startTime = bytes.readFloat32();
        this.stopTime = bytes.readFloat32();
        this.sampleRate = bytes.readInt32();
        this.useSkeletonPos = bytes.readInt32() > 0;
        this.useSkeletonScale = bytes.readInt32() > 0;
        if (this.useSkeletonPos) {
          let positionCurvesCount = bytes.readInt32();
          for (let i = 0; i < positionCurvesCount; i++) {
            let curveData = new AnimationCurveT();
            curveData.formBytes(bytes);
            this.positionCurves.set(curveData.path, curveData);
          }
        }
        let rotationCurvesCount = bytes.readInt32();
        for (let i = 0; i < rotationCurvesCount; i++) {
          let curveData = new AnimationCurveT();
          curveData.formBytes(bytes);
          this.rotationCurves.set(curveData.path, curveData);
        }
        if (this.useSkeletonScale) {
          let scaleCurvesCount = bytes.readInt32();
          for (let i = 0; i < scaleCurvesCount; i++) {
            let curveData = new AnimationCurveT();
            curveData.formBytes(bytes);
            this.scaleCurves.set(curveData.path, curveData);
          }
        }
        let floatCurvesCount = bytes.readInt32();
        for (let i = 0; i < floatCurvesCount; i++) {
          let curveData = new AnimationCurveT();
          curveData.formBytes(bytes);
          this.floatCurves.set(curveData.attribute, curveData);
        }
      }
    }

    class AnimationCurveT {
      /** Target node path this curve animates. */
      path;
      /** Animated attribute name. */
      attribute;
      /** Attribute split into its component property names. */
      propertys;
      /** Wrap mode applied for times before the first keyframe. */
      preInfinity;
      /** Wrap mode applied for times after the last keyframe. */
      postInfinity;
      /** Euler rotation order associated with this curve. */
      rotationOrder;
      /** Per-channel scalar animation curves. */
      m_curves;
      k = 0;
      _cacheValue;
      _kValue;
      constructor(k = 1) {
        this.k = k;
        this.m_curves = [];
        this.check();
      }
      check() {
        for (let i = 0; i < this.k; i++) {
          this.m_curves[i] ||= new AnimationCurve();
        }
        switch (this.k) {
          case 1:
            this._cacheValue = 0;
            break;
          case 2:
            this._cacheValue = new Vector2();
            break;
          case 3:
            this._cacheValue = new Vector3();
            break;
          case 4:
            this._cacheValue = new Vector4();
            break;
        }
      }
      /**
       * return this curve use total time
       */
      get totalTime() {
        return this.m_curves[0].totalTime;
      }
      /**
       * add keyFrame to curve keyframe last and calcTotalTime
       * @param keyFrame {@link Keyframe}  sea: one key frame data
       */
      addKeyFrame(keyFrame) {
        for (let i = 0; i < this.k; i++) {
          this.m_curves[i].addKeyFrame(keyFrame.getK(i));
        }
      }
      /**
       * remove keyframe from this curve
       * @param keyFrame {@link Keyframe} 
       */
      removeKeyFrame(keyFrame) {
        for (let i = 0; i < this.k; i++) {
          this.m_curves[i].removeKeyFrame(keyFrame.getK(i));
        }
      }
      /**
       * get caculate frames value 
       * @param time 
       * @returns 
       */
      getValue(time) {
        switch (this.k) {
          case 1:
            this._cacheValue = this.m_curves[0].getValue(time);
            break;
          case 2:
            this._cacheValue.x = this.m_curves[0].getValue(time);
            this._cacheValue.y = this.m_curves[1].getValue(time);
            break;
          case 3:
            this._cacheValue.x = this.m_curves[0].getValue(time);
            this._cacheValue.y = this.m_curves[1].getValue(time);
            this._cacheValue.z = this.m_curves[2].getValue(time);
            break;
          case 4:
            const extent = this.m_curves[0].getCurveFramesExtent(time);
            const lhsIndex = extent.lhsIndex;
            const rhsIndex = extent.rhsIndex;
            time = extent.time;
            let kL = this.m_curves[0].getKey(lhsIndex);
            let kR = this.m_curves[0].getKey(rhsIndex);
            if (lhsIndex === rhsIndex || kR.time === kL.time) {
              this._cacheValue.x = this.m_curves[0].getKey(lhsIndex).value;
              this._cacheValue.y = this.m_curves[1].getKey(lhsIndex).value;
              this._cacheValue.z = this.m_curves[2].getKey(lhsIndex).value;
              this._cacheValue.w = this.m_curves[3].getKey(lhsIndex).value;
              break;
            }
            let t = (time - kL.time) / (kR.time - kL.time);
            if (t < 0) t = 0;
            else if (t > 1) t = 1;
            Quaternion.HELP_0.set(
              this.m_curves[0].getKey(lhsIndex).value,
              this.m_curves[1].getKey(lhsIndex).value,
              this.m_curves[2].getKey(lhsIndex).value,
              this.m_curves[3].getKey(lhsIndex).value
            );
            Quaternion.HELP_1.set(
              this.m_curves[0].getKey(rhsIndex).value,
              this.m_curves[1].getKey(rhsIndex).value,
              this.m_curves[2].getKey(rhsIndex).value,
              this.m_curves[3].getKey(rhsIndex).value
            );
            Quaternion.HELP_2.slerp(Quaternion.HELP_0, Quaternion.HELP_1, t);
            this._cacheValue.x = Quaternion.HELP_2.x;
            this._cacheValue.y = Quaternion.HELP_2.y;
            this._cacheValue.z = Quaternion.HELP_2.z;
            this._cacheValue.w = Quaternion.HELP_2.w;
            break;
        }
        return this._cacheValue;
      }
      /**
       * get has Keyframe list count
       * @returns  int 
       */
      getKeyCount() {
        return this.m_curves[0].getKeyCount();
      }
      /**
       * Get a Keyframe Data by Index
       * @param index must int 
       * @returns Keyframe {@link Keyframe}
       */
      getKey(index) {
        let list = [];
        for (let i = 0; i < this.k; i++) {
          list.push(this.m_curves[i].getKey(index));
        }
        return list;
      }
      /**
       * Read this multi-channel curve from a binary byte stream.
       * @param bytes source byte array
       */
      formBytes(bytes) {
        this.path = bytes.readUTF();
        this.k = bytes.readInt32();
        this.check();
        this.attribute = bytes.readUTF();
        this.propertys = this.attribute.split(".");
        this.preInfinity = bytes.readInt32();
        this.postInfinity = bytes.readInt32();
        this.rotationOrder = bytes.readInt32();
        let curvesCount = bytes.readInt32();
        for (let i = 0; i < curvesCount; i++) {
          let keyframe = new KeyframeT(0);
          keyframe.formBytes(bytes);
          this.addKeyFrame(keyframe);
        }
      }
    }

    class Bezier2D {
      _points;
      _cacheValue;
      /**
       * instance bezier class
       */
      constructor(vec2Ds = []) {
        this.points = vec2Ds;
        this._cacheValue = new Vector2();
      }
      /**
       * get all bezier 2d points
       */
      get points() {
        return this._points;
      }
      /**
       * set bezier 2d point[x,y] list must great 4
       */
      set points(value) {
        this._points = value;
      }
      /**
       * get point2d at curve
       * @param v 0.0 ~ 1.0 
       * @returns return point2D at curve 
       */
      getValue(v) {
        if (v < 0) v = 0;
        if (v > 1) v = 1;
        let len = this.points.length - 1;
        let ci = Math.floor(len * v);
        let ni = ci + 1;
        let w = MathUtil.fract((len + 1) * v);
        if (ni >= len) {
          ni = ci;
          w = 0;
        }
        this._cacheValue.x = this.points[ci].x + (this.points[ni].x - this.points[ci].x) * w;
        this._cacheValue.y = this.points[ci].y + (this.points[ni].y - this.points[ci].y) * w;
        return this._cacheValue;
      }
      /**
       * caclute bezier curve points at line [ 0.0 , 1.0 ]
       * @param anchorpoints bezier anchor
       * @param pointsAmount point count 
       * @returns get a bezier curve [Bezier2D]
       */
      static createBezierPoints(anchorpoints, pointsAmount) {
        var bezier2d = new Bezier2D();
        for (var i = 0; i < pointsAmount; i++) {
          var point = Bezier2D.multiPointBezier(anchorpoints, i / pointsAmount);
          bezier2d.points.push(point);
        }
        return bezier2d;
      }
      static multiPointBezier(points, t) {
        var len = points.length;
        var x = 0, y = 0;
        var erxiangshi = function(start, end) {
          var cs = 1, bcs = 1;
          while (end > 0) {
            cs *= start;
            bcs *= end;
            start--;
            end--;
          }
          return cs / bcs;
        };
        for (var i = 0; i < len; i++) {
          var point = points[i];
          x += point.x * Math.pow(1 - t, len - 1 - i) * Math.pow(t, i) * erxiangshi(len - 1, i);
          y += point.y * Math.pow(1 - t, len - 1 - i) * Math.pow(t, i) * erxiangshi(len - 1, i);
        }
        return new Vector2(x, y);
      }
    }

    class Bezier3D {
      static tmp_points = [];
      /**
       * get cubic curve point value from t at bezier data 
       * @param t interval value
       * @param p0 start point
       * @param c1 left control point
       * @param c2 right control point
       * @param p3 end point
       * @returns cubic curve point
       */
      static calculateCubicBezierPoint(t, p0, c1, c2, p3) {
        if (t > 1) t = 1;
        if (t < 0) t = 0;
        let u = 1 - t;
        let uu = u * u;
        let uuu = u * u * u;
        let tt = t * t;
        let ttt = t * t * t;
        let p = p0.clone().multiplyScalar(uuu);
        let tp1 = c1.clone().multiplyScalar(3);
        tp1 = tp1.multiplyScalar(t);
        tp1 = tp1.multiplyScalar(uu);
        let tp2 = c2.clone().multiplyScalar(3);
        tp2 = tp2.multiplyScalar(tt);
        tp2 = tp2.multiplyScalar(u);
        let tp3 = p3.clone().multiplyScalar(ttt);
        p = p.add(tp1);
        p = p.add(tp2);
        p = p.add(tp3);
        return p;
      }
      /**
       * get curve point from three point bezier curve 
       * @param t interval value
       * @param p0 start point
       * @param c1 contrl point 
       * @param p1 end point
       * @returns get bezier point at curve 
       */
      static bezierPoint(t, p0, c1, p1) {
        if (t > 1) t = 1;
        if (t < 0) t = 0;
        let u = 1 - t;
        let uu = u * u;
        let tt = t * t;
        let pp0 = p0.clone().multiplyScalar(uu);
        let cc1 = c1.clone().multiplyScalar(2);
        cc1.multiplyScalar(u);
        cc1.multiplyScalar(t);
        let pp1 = p1.clone().multiplyScalar(tt);
        pp0 = pp0.add(cc1);
        pp0 = pp0.add(pp1);
        return pp0;
      }
      static calculateCubicBezierPoints(t, ps, skip) {
        if (t > 1) t = 1;
        if (t < 0) t = 0;
        let u = 1 - t;
        let uu = u * u;
        let uuu = u * u * u;
        let tt = t * t;
        let ttt = t * t * t;
        let p = ps[skip].clone().multiplyScalar(uuu);
        let tp1 = ps[skip + 1].clone().multiplyScalar(3);
        tp1 = tp1.multiplyScalar(t);
        tp1 = tp1.multiplyScalar(uu);
        let tp2 = ps[skip + 2].clone().multiplyScalar(3);
        tp2 = tp2.multiplyScalar(tt);
        tp2 = tp2.multiplyScalar(u);
        let tp3 = ps[skip + 3].clone().multiplyScalar(ttt);
        p = p.add(tp1);
        p = p.add(tp2);
        p = p.add(tp3);
        return p;
      }
      static bezierPathValue(t, points) {
        if (t > 1) t = 1;
        if (t < 0) t = 0;
        let count = points.length;
        let tmp_points = this.tmp_points;
        tmp_points.length = 0;
        for (let i = 1; i < count; ++i) {
          for (let j = 0; j < count - i; ++j) {
            if (i == 1) {
              let v = new Vector3();
              v.x = points[j].x * (1 - t) + points[j + 1].x * t;
              v.y = points[j].y * (1 - t) + points[j + 1].y * t;
              v.z = points[j].z * (1 - t) + points[j + 1].z * t;
              this.tmp_points.push(v);
              continue;
            }
            let v2 = new Vector3();
            v2.x = tmp_points[j].x * (1 - t) + tmp_points[j + 1].x * t;
            v2.y = tmp_points[j].y * (1 - t) + tmp_points[j + 1].y * t;
            v2.z = tmp_points[j].z * (1 - t) + tmp_points[j + 1].z * t;
            tmp_points.push(v2);
          }
        }
        return tmp_points[0];
      }
    }

    class BiMap extends Map {
      negtive;
      constructor(iterable) {
        super(iterable);
        this.negtive = /* @__PURE__ */ new Map();
        if (iterable) {
          for (let item of iterable) {
            this.negtive.set(item[1], item[0]);
          }
        }
      }
      delete(key) {
        if (this.has(key)) {
          let value = this.get(key);
          this.negtive.delete(value);
          return super.delete(key);
        }
        return false;
      }
      getKey(value) {
        return this.negtive.get(value);
      }
      deleteValue(value) {
        let k = this.negtive.get(value);
        k && this.delete(k);
        return this.negtive.delete(value);
      }
      set(key, value) {
        super.set(key, value);
        this.negtive.set(value, key);
        return this;
      }
      clear() {
        this.negtive.clear();
        super.clear();
      }
    }

    class ColorGradient {
      colorArray;
      /** Creates a gradient from an ordered array of colors. */
      constructor(array) {
        this.colorArray = array;
      }
      /** Returns the interpolated color at the normalized position `p` (0 to 1). */
      getColor(p) {
        let s = p * this.colorArray.length;
        let i = Math.floor(s);
        let k = Math.min(i + 1, this.colorArray.length - 1);
        let c1 = this.colorArray[i];
        let c2 = this.colorArray[k];
        return Color.lerp(s - i, c1, c2);
      }
    }

    class CubicBezierCurve {
      controlVertices;
      /**
       * @constructor
       * @param cvs controller points
       */
      constructor(cvs) {
        this.setControlVertices(cvs);
      }
      /**
       * update controller points
       * @param cvs controller points
       */
      setControlVertices(cvs) {
        if (cvs.length == 4) {
          this.controlVertices = cvs.concat();
        }
      }
      /**
       * get position by calc from curve
       * @param t a position in range [0-1]
       * @returns Vector3
       */
      getPoint(t) {
        if (!(t >= 0 && t <= 1)) {
          return Vector3.ZERO;
        }
        let c = 1 - t;
        let bb0 = c * c * c;
        let bb1 = 3 * t * c * c;
        let bb2 = 3 * t * t * c;
        let bb3 = t * t * t;
        let point = this.controlVertices[0].clone().multiplyScalar(bb0).add(this.controlVertices[1].clone().multiplyScalar(bb1)).add(this.controlVertices[2].clone().multiplyScalar(bb2)).add(this.controlVertices[3].clone().multiplyScalar(bb3));
        return point;
      }
      /**
       * get tagent by calc from curve
       * @param t a position in range [0-1]
       * @returns tagent direction
       */
      getTangent(t) {
        if (!(t >= 0 && t <= 1)) {
          return Vector3.ZERO;
        }
        let controlVerts = this.controlVertices;
        let q0 = controlVerts[0].clone().add(controlVerts[1].clone().add(controlVerts[0]).multiplyScalar(t));
        let q1 = controlVerts[1].clone().add(controlVerts[2].clone().add(controlVerts[1]).multiplyScalar(t));
        let q2 = controlVerts[2].clone().add(controlVerts[3].clone().add(controlVerts[2]).multiplyScalar(t));
        let r0 = q0.clone().add(q1.clone().sub(q0).multiplyScalar(t));
        let r1 = q1.clone().add(q2.clone().sub(q1).multiplyScalar(t));
        let tangent = r1.sub(r0);
        return tangent;
      }
      /**
       * get adjacent coordinates
       * @param pos position
       * @param paramThreshold threshold value
       * @returns a position in range [0-1]
       */
      getClosestParam(pos, paramThreshold = 1e-6) {
        return this.getClosestParamRec(pos, 0, 1, paramThreshold);
      }
      /**
       * get adjacent coordinates by given range
       * @param pos position
       * @param beginT range from
       * @param endT range end
       * @param thresholdT threshold value
       * @returns 
       */
      getClosestParamRec(pos, beginT, endT, thresholdT) {
        let mid = (beginT + endT) / 2;
        if (endT - beginT < thresholdT) {
          return mid;
        }
        let paramA = (beginT + mid) / 2;
        let paramB = (mid + endT) / 2;
        let posA = this.getPoint(paramA);
        let posB = this.getPoint(paramB);
        let distASq = posA.sub(pos).lengthSquared;
        let distBSq = posB.sub(pos).lengthSquared;
        if (distASq < distBSq) {
          endT = mid;
        } else {
          beginT = mid;
        }
        return this.getClosestParamRec(pos, beginT, endT, thresholdT);
      }
    }

    var CubicBezierType = /* @__PURE__ */ ((CubicBezierType2) => {
      CubicBezierType2[CubicBezierType2["Open"] = 0] = "Open";
      CubicBezierType2[CubicBezierType2["Closed"] = 1] = "Closed";
      return CubicBezierType2;
    })(CubicBezierType || {});
    class CubicBezierPath {
      type = 0 /* Open */;
      numCurveSegments = 0;
      numControlVertices = 0;
      controlVertices = [];
      // The term 'knot' is another name for a point right on the path (an interpolated point). With this constructor the
      // knots are supplied and interpolated. knots.length (the number of knots) must be >= 2. Interior Cvs are generated
      // transparently and automatically.
      constructor(controlVertices, t = 0 /* Open */) {
        this.setControlVertices(controlVertices, t);
      }
      /** Return the path type (open or closed). */
      getPathType() {
        return this.type;
      }
      /** Return true if the path is closed. */
      isClosed() {
        return this.type == 1 /* Closed */ ? true : false;
      }
      /**
       * @returns 
       */
      isValid() {
        return this.numCurveSegments > 0 ? true : false;
      }
      /** Reset the path to empty, open state with no control vertices or segments. */
      clear() {
        this.controlVertices.length = 0;
        this.type = 0 /* Open */;
        this.numCurveSegments = 0;
        this.numControlVertices = 0;
      }
      /** Compute an approximate path length by summing squared distances between interpolated points. */
      computeApproxLength() {
        if (!this.isValid()) return 0;
        let numInterpolatedPoints = this.numCurveSegments + 1;
        if (numInterpolatedPoints < 2) return 0;
        let totalDist = 0;
        let controlVertices = this.controlVertices;
        for (let n = 1; n < numInterpolatedPoints; n++) {
          let a = controlVertices[(n - 1) * 3];
          let b = controlVertices[n * 3];
          totalDist += a.clone().sub(b).lengthSquared;
        }
        if (totalDist == 0) return 0;
        return totalDist;
      }
      /** Return the approximate change in the raw parameter t per unit of path length. */
      computeApproxParamPerUnitLength() {
        let length = this.computeApproxLength();
        return this.numCurveSegments / length;
      }
      /** Return the approximate change in the normalized parameter t per unit of path length. */
      computeApproxNormParamPerUnitLength() {
        let length = this.computeApproxLength();
        return 1 / length;
      }
      /** Build the path from interpolated knots, generating interior control vertices automatically (knots.length must be >= 2). */
      interpolatePoints(knots, t) {
        let numKnots = knots.length;
        if (numKnots < 2) console.error("point count must great 1");
        this.clear();
        this.type = t;
        let controlVertices = this.controlVertices;
        switch (t) {
          case 0 /* Open */: {
            this.numCurveSegments = numKnots - 1;
            this.numControlVertices = 3 * numKnots - 2;
            controlVertices.length = this.numControlVertices;
            for (let n = 0; n < numKnots; n++) controlVertices[n * 3] = knots[n];
            let initialPoint = knots[1].clone().sub(knots[0]).multiplyScalar(0.25);
            controlVertices[1] = knots[0].clone().add(initialPoint);
            let finalPoint = knots[numKnots - 2].clone().sub(knots[numKnots - 1]).multiplyScalar(0.25);
            controlVertices[this.numControlVertices - 2] = knots[numKnots - 1].clone().add(finalPoint);
            for (let k = 1; k < this.numCurveSegments; k++) {
              let a = knots[k - 1].clone().sub(knots[k]);
              let b = knots[k + 1].clone().sub(knots[k]);
              let aLen = a.lengthSquared;
              let bLen = b.lengthSquared;
              if (aLen > 0 && bLen > 0) {
                let abLen = (aLen + bLen) / 8;
                let ab = b.divideScalar(bLen).sub(a.divideScalar(aLen));
                ab.normalize();
                ab = ab.multiplyScalar(abLen);
                controlVertices[k * 3 - 1] = knots[k].clone().sub(ab);
                controlVertices[k * 3 + 1] = knots[k].clone().add(ab);
              } else {
                controlVertices[k * 3 - 1] = knots[k];
                controlVertices[k * 3 + 1] = knots[k];
              }
            }
            break;
          }
          case 1 /* Closed */: {
            this.numCurveSegments = numKnots;
            this.numControlVertices = 3 * numKnots + 1;
            controlVertices.length = this.numControlVertices;
            for (let n = 0; n < numKnots; n++) controlVertices[n * 3] = knots[n];
            controlVertices[this.numControlVertices - 1] = knots[0];
            for (let k = 1; k <= this.numCurveSegments; k++) {
              let modkm1 = k - 1;
              let modkp1 = (k + 1) % this.numCurveSegments;
              let modk = k % this.numCurveSegments;
              let a = knots[modkm1].clone().sub(knots[modk]);
              let b = knots[modkp1].clone().sub(knots[modk]);
              let aLen = a.lengthSquared;
              let bLen = b.lengthSquared;
              let mod3km1 = 3 * k - 1;
              let mod3kp1 = (3 * k + 1) % (this.numControlVertices - 1);
              if (aLen > 0 && bLen > 0) {
                let abLen = (aLen + bLen) / 8;
                let ab = b.divideScalar(bLen).sub(a.divideScalar(aLen));
                ab.normalize();
                ab = ab.multiplyScalar(abLen);
                controlVertices[mod3km1] = knots[modk].clone().sub(ab);
                controlVertices[mod3kp1] = knots[modk].clone().add(ab);
              } else {
                controlVertices[mod3km1] = knots[modk];
                controlVertices[mod3kp1] = knots[modk];
              }
            }
            break;
          }
        }
      }
      // For a closed path the last CV must match the first.
      /** Set the path directly from explicit control vertices; for a closed path the last CV must match the first. */
      setControlVertices(cvs, t) {
        let numCVs = cvs.length;
        if (numCVs <= 0) return;
        if (t == 0 /* Open */ && numCVs < 4) return;
        if (t == 1 /* Closed */ && numCVs < 7) return;
        if (!((numCVs - 1) % 3 == 0)) return;
        this.clear();
        this.type = t;
        this.numControlVertices = numCVs;
        this.numCurveSegments = (numCVs - 1) / 3;
        this.controlVertices = cvs;
      }
      // t E [0, numSegments]. If the type is closed, the number of segments is one more than the equivalent open path.
      /** Return the point on the path at parameter t in [0, numSegments]; closed paths wrap out-of-range t. */
      getPoint(t) {
        if (this.type == 1 /* Closed */) {
          while (t < 0) t += this.numCurveSegments;
          while (t > this.numCurveSegments) t -= this.numCurveSegments;
        } else {
          t = MathUtil.clampf(t, 0, this.numCurveSegments);
        }
        if (!(t >= 0) && t <= this.numCurveSegments) return;
        let segment = Math.floor(t);
        if (segment >= this.numCurveSegments) segment = this.numCurveSegments - 1;
        let curveCVs = [];
        let controlVerts = this.controlVertices;
        curveCVs[0] = controlVerts[3 * segment + 0];
        curveCVs[1] = controlVerts[3 * segment + 1];
        curveCVs[2] = controlVerts[3 * segment + 2];
        curveCVs[3] = controlVerts[3 * segment + 3];
        let bc = new CubicBezierCurve(curveCVs);
        return bc.getPoint(t - segment);
      }
      // Does the same as GetPoint except that t is normalized to be E [0, 1] over all segments. The beginning of the curve
      // is at t = 0 and the end at t = 1. Closed paths allow a value bigger than 1 in which case they loop.
      /** Return the point on the path at normalized parameter t in [0, 1] over all segments. */
      getPointNorm(t) {
        return this.getPoint(t * this.numCurveSegments);
      }
      // Similar to GetPoint but returns the tangent at the specified point on the path. The tangent is not normalized.
      // The longer the tangent the 'more influence' it has pulling the path in that direction.
      /** Return the (un-normalized) tangent on the path at parameter t in [0, numSegments]. */
      getTangent(t) {
        if (this.type == 1 /* Closed */) {
          while (t < 0) t += this.numCurveSegments;
          while (t > this.numCurveSegments) t -= this.numCurveSegments;
        } else {
          t = MathUtil.clampf(t, 0, this.numCurveSegments);
        }
        if (!(t >= 0) && t <= this.numCurveSegments) return;
        let segment = Math.floor(t);
        if (segment >= this.numCurveSegments) segment = this.numCurveSegments - 1;
        let controlVerts = this.controlVertices;
        let curveCVs = [];
        curveCVs[0] = controlVerts[3 * segment + 0];
        curveCVs[1] = controlVerts[3 * segment + 1];
        curveCVs[2] = controlVerts[3 * segment + 2];
        curveCVs[3] = controlVerts[3 * segment + 3];
        let bc = new CubicBezierCurve(curveCVs);
        return bc.getTangent(t - segment);
      }
      /** Return the (un-normalized) tangent at normalized parameter t in [0, 1] over all segments. */
      getTangentNorm(t) {
        return this.getTangent(t * this.numCurveSegments);
      }
      // This function returns a single closest point. There may be more than one point on the path at the same distance.
      // Use ComputeApproxParamPerUnitLength to determine a good paramThreshold. eg. Say you want a 15cm threshold,
      // use: paramThreshold = ComputeApproxParamPerUnitLength() * 0.15f.
      /** Find the parameter t of the closest point on the path to pos, searching with the given param threshold. */
      computeClosestParam(pos, paramThreshold) {
        let minDistSq = Number.MAX_SAFE_INTEGER;
        let closestParam = 0;
        let curveCVs = [];
        let curve = new CubicBezierCurve(curveCVs);
        for (let startIndex = 0; startIndex < this.controlVertices.length - 1; startIndex += 3) {
          for (let i = 0; i < 4; i++) curveCVs[i] = this.controlVertices[startIndex + i];
          curve.setControlVertices(curveCVs);
          let curveClosestParam = curve.getClosestParam(pos, paramThreshold);
          let curvePos = curve.getPoint(curveClosestParam);
          let distSq = curvePos.sub(pos).lengthSquared;
          if (distSq < minDistSq) {
            minDistSq = distSq;
            let startParam = startIndex / 3;
            closestParam = startParam + curveClosestParam;
          }
        }
        return closestParam;
      }
      // Same as above but returns a t value E [0, 1]. You'll need to use a paramThreshold like
      // ComputeApproxParamPerUnitLength() * 0.15f if you want a 15cm tolerance.
      /** Like computeClosestParam but returns the closest point as a normalized parameter t in [0, 1]. */
      computeClosestNormParam(pos, paramThreshold) {
        return this.computeClosestParam(pos, paramThreshold * this.numCurveSegments);
      }
    }

    let PI = Math.PI;
    let TwoPI = PI * 2;
    class Matrix3 {
      /**
       * The width of x
       */
      a;
      /**
       * The slope of y
       */
      b;
      /**
       * The slope of x
       */
      c;
      /**
       * The height of y
       */
      d;
      /**
       * The position of the x coordinate
       */
      tx;
      /**
       * The position of the y coordinate
       */
      ty;
      /**
       * Create a Matrix3
       * @param a The width of x
       * @param b The slope of y
       * @param c The slope of x
       * @param d The height of y
       * @param tx The position of the x coordinate
       * @param ty The position of the y coordinate
       */
      constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
      }
      /**
       * Clone an Matrix3 object
       * @returns New Matrix3 object
       */
      clone() {
        return new Matrix3(this.a, this.b, this.c, this.d, this.tx, this.ty);
      }
      /**
       * Merges the current matrix with the target matrix
       * @param matrix target matrix
       */
      concat(matrix) {
        let a = this.a;
        let c = this.c;
        let tx = this.tx;
        this.a = a * matrix.a + this.b * matrix.c;
        this.b = a * matrix.b + this.b * matrix.d;
        this.c = c * matrix.a + this.d * matrix.c;
        this.d = c * matrix.b + this.d * matrix.d;
        this.tx = tx * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx * matrix.b + this.ty * matrix.d + matrix.ty;
        return this;
      }
      /**
       * The current matrix value is overwritten by the target matrix value
       * @param other  target matrix value
       * @returns current matrix
       */
      copy(other) {
        this.a = other.a;
        this.b = other.b;
        this.c = other.c;
        this.d = other.d;
        this.tx = other.tx;
        this.ty = other.ty;
        return this;
      }
      /**
       * Reset to the identity matrix
       */
      identity() {
        this.a = this.d = 1;
        this.b = this.c = this.tx = this.ty = 0;
        return this;
      }
      /**
       * Invert this matrix
       */
      invert() {
        this._invertInto(this);
        return this;
      }
      /**
       * Rotate according to Angle
       * @param angle rotation angle
       */
      rotate(angle) {
        angle = +angle;
        if (angle !== 0) {
          angle = angle * DEGREES_TO_RADIANS;
          let u = Math.cos(angle);
          let v = Math.sin(angle);
          let ta = this.a;
          let tb = this.b;
          let tc = this.c;
          let td = this.d;
          let ttx = this.tx;
          let tty = this.ty;
          this.a = ta * u - tb * v;
          this.b = ta * v + tb * u;
          this.c = tc * u - td * v;
          this.d = tc * v + td * u;
          this.tx = ttx * u - tty * v;
          this.ty = ttx * v + tty * u;
        }
        return this;
      }
      /**
       * Scale by offset
       * @param sx x axis scaling
       * @param sy y axis scaling
       */
      scale(sx, sy) {
        if (sx !== 1) {
          this.a *= sx;
          this.c *= sx;
          this.tx *= sx;
        }
        if (sy !== 1) {
          this.b *= sy;
          this.d *= sy;
          this.ty *= sy;
        }
        return this;
      }
      /**
       * Reset the matrix value
       * @param a Matrix element a
       * @param b Matrix element b
       * @param c Matrix element c
       * @param d Matrix element d
       * @param tx Matrix element tx
       * @param ty Matrix element ty
       * @returns The modified matrix
       */
      setTo(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;
        return this;
      }
      /**
       * transformation of coordinates
       * @param pointX x coordinate
       * @param pointY y coordinate
       * @param resultPoint Vector of results
       * @returns Vector of results
       */
      transformPoint(pointX, pointY, resultPoint) {
        let x = this.a * pointX + this.c * pointY + this.tx;
        let y = this.b * pointX + this.d * pointY + this.ty;
        if (resultPoint) {
          resultPoint.setTo(x, y, 0, 1);
          return resultPoint;
        }
        return new Vector3(x, y, 0, 1);
      }
      /**
       * translation
       * @param x x coordinate
       * @param y y coordinate
       */
      setTranslate(x, y) {
        this.tx = x;
        this.ty = y;
        return this;
      }
      /**
       * Translates the specified offset
       * @param dx The x-coordinate offset
       * @param dy The y-coordinate offset
       */
      translate(dx, dy) {
        this.tx += dx;
        this.ty += dy;
        return this;
      }
      /**
       * multiply
       * @param t target matrix
       */
      mul(t) {
        let m1 = this;
        let m2 = t;
        let aa = m1.a;
        let ab = m1.b;
        let ac = m1.c;
        let ad = m1.d;
        let atx = m1.tx;
        let aty = m1.ty;
        let ba = m2.a;
        let bb = m2.b;
        let bc = m2.c;
        let bd = m2.d;
        let btx = m2.tx;
        let bty = m2.ty;
        if (bb !== 0 || bc !== 0) {
          this.a = aa * ba + ab * bc;
          this.b = aa * bb + ab * bd;
          this.c = ac * ba + ad * bc;
          this.d = ac * bb + ad * bd;
          this.tx = ba * atx + bc * aty + btx;
          this.ty = bb * atx + bd * aty + bty;
        } else {
          this.a = aa * ba;
          this.b = ab * bd;
          this.c = ac * ba;
          this.d = ad * bd;
          this.tx = ba * atx + btx;
          this.ty = bd * aty + bty;
        }
        return this;
      }
      /**
       * Is equal to the given matrix
       * @param other matrix
       * @returns 
       */
      equals(other) {
        return this.a == other.a && this.b == other.b && this.c == other.c && this.d == other.d && this.tx == other.tx && this.ty == other.ty;
      }
      /**
       * get a front matrix by multiplication
       * @param a Multiply by a
       * @param b Multiply by b
       * @param c Multiply by c
       * @param d Multiply by d
       * @param tx Multiply by tx
       * @param ty Multiply by ty
       * @returns prematrix
       */
      prepend(a, b, c, d, tx, ty) {
        let tx1 = this.tx;
        if (a != 1 || b != 0 || c != 0 || d != 1) {
          let a1 = this.a;
          let c1 = this.c;
          this.a = a1 * a + this.b * c;
          this.b = a1 * b + this.b * d;
          this.c = c1 * a + this.d * c;
          this.d = c1 * b + this.d * d;
        }
        this.tx = tx1 * a + this.ty * c + tx;
        this.ty = tx1 * b + this.ty * d + ty;
        return this;
      }
      /**
       * Obtain a post-multiplication matrix by multiplication.
       * @param mat Matrix
       * @returns result
       */
      append(mat) {
        let a1 = this.a;
        let b1 = this.b;
        let c1 = this.c;
        let d1 = this.d;
        if (mat.a != 1 || mat.b != 0 || mat.c != 0 || mat.d != 1) {
          this.a = mat.a * a1 + mat.b * c1;
          this.b = mat.a * b1 + mat.b * d1;
          this.c = mat.c * a1 + mat.d * c1;
          this.d = mat.c * b1 + mat.d * d1;
        }
        this.tx = mat.tx * a1 + mat.ty * c1 + this.tx;
        this.ty = mat.tx * b1 + mat.ty * d1 + this.ty;
        return this;
      }
      /**
       * Use the given point for the transformation, ignoring the x, y coordinates
       * @param point A given point
       * @returns 
       */
      deltaTransformPoint(point) {
        let self = this;
        let x = self.a * point.x + self.c * point.y;
        let y = self.b * point.x + self.d * point.y;
        return new Vector3(x, y);
      }
      /**
       * Converts the current matrix to string form
       * @returns 
       */
      toString() {
        return "(a=" + this.a + ", b=" + this.b + ", c=" + this.c + ", d=" + this.d + ", tx=" + this.tx + ", ty=" + this.ty + ")";
      }
      /**
       * Set the matrix scaling, rotation, and conversion parameters
       * @param scaleX x axis scaling
       * @param scaleY y axis scaling
       * @param rotation rotation
       * @param tx x-coordinate
       * @param ty y-coordinate
       */
      createBox(scaleX, scaleY, rotation = 0, tx = 0, ty = 0) {
        let self = this;
        if (rotation !== 0) {
          rotation = rotation * DEGREES_TO_RADIANS;
          let u = Math.cos(rotation);
          let v = Math.sin(rotation);
          self.a = u * scaleX;
          self.b = v * scaleY;
          self.c = -v * scaleX;
          self.d = u * scaleY;
        } else {
          self.a = scaleX;
          self.b = 0;
          self.c = 0;
          self.d = scaleY;
        }
        self.tx = tx;
        self.ty = ty;
        return this;
      }
      /**
       * Create a gradient box
       * @param width width
       * @param height height
       * @param rotation rotation
       * @param tx x-coordinate
       * @param ty y-coordinate
       */
      createGradientBox(width, height, rotation = 0, tx = 0, ty = 0) {
        this.createBox(width / 1638.4, height / 1638.4, rotation, tx + width / 2, ty + height / 2);
        return this;
      }
      /**
       * Invert the given matrix
       * @param target matrix
       * @returns 
       */
      _invertInto(target) {
        let a = this.a;
        let b = this.b;
        let c = this.c;
        let d = this.d;
        let tx = this.tx;
        let ty = this.ty;
        if (b == 0 && c == 0) {
          target.b = target.c = 0;
          if (a == 0 || d == 0) {
            target.a = target.d = target.tx = target.ty = 0;
          } else {
            a = target.a = 1 / a;
            d = target.d = 1 / d;
            target.tx = -a * tx;
            target.ty = -d * ty;
          }
          return;
        }
        let determinant = a * d - b * c;
        if (determinant == 0) {
          target.identity();
          return;
        }
        determinant = 1 / determinant;
        let k = target.a = d * determinant;
        b = target.b = -b * determinant;
        c = target.c = -c * determinant;
        d = target.d = a * determinant;
        target.tx = -(k * tx + c * ty);
        target.ty = -(b * tx + d * ty);
      }
      /**
       * Return the scale factor along the X axis derived from this matrix.
       */
      getScaleX() {
        let m = this;
        if (m.a == 1 && m.b == 0) {
          return 1;
        }
        let result = Math.sqrt(m.a * m.a + m.b * m.b);
        return this.getDeterminant() < 0 ? -result : result;
      }
      /**
       * Return the scale factor along the Y axis derived from this matrix.
       */
      getScaleY() {
        let m = this;
        if (m.c == 0 && m.d == 1) {
          return 1;
        }
        let result = Math.sqrt(m.c * m.c + m.d * m.d);
        return this.getDeterminant() < 0 ? -result : result;
      }
      /**
       * Return the skew angle along the X axis derived from this matrix.
       */
      getSkewX() {
        return Math.atan2(this.d, this.c) - Math.PI / 2;
      }
      /**
       * Return the skew angle along the Y axis derived from this matrix.
       */
      getSkewY() {
        return Math.atan2(this.b, this.a);
      }
      /**
       * Update this matrix from the given scale and skew components.
       * @param scaleX scale factor along the X axis
       * @param scaleY scale factor along the Y axis
       * @param skewX skew angle along the X axis, in degrees
       * @param skewY skew angle along the Y axis, in degrees
       */
      updateScaleAndRotation(scaleX, scaleY, skewX, skewY) {
        if ((skewX == 0 || skewX == TwoPI) && (skewY == 0 || skewY == TwoPI)) {
          this.a = scaleX;
          this.b = this.c = 0;
          this.d = scaleY;
          return this;
        }
        skewX = skewX * DEGREES_TO_RADIANS;
        skewY = skewY * DEGREES_TO_RADIANS;
        let u = Math.cos(skewX);
        let v = Math.sin(skewX);
        if (skewX == skewY) {
          this.a = u * scaleX;
          this.b = v * scaleX;
        } else {
          this.a = Math.cos(skewY) * scaleX;
          this.b = Math.sin(skewY) * scaleX;
        }
        this.c = -v * scaleY;
        this.d = u * scaleY;
        return this;
      }
      /**
       * Multiply two matrices: result = a * b. Allocates a new Matrix3 if result is omitted.
       */
      static multiply(a, b, result) {
        result ||= new Matrix3();
        if (result !== a) {
          result.copy(a);
        }
        result.mul(b);
        return result;
      }
      /**
       * Pre-multiply two matrices: result = a * b (where a is pre-multiplied).
       * Allocates a new Matrix3 if result is omitted.
       */
      static preMultiply(a, b, result) {
        result ||= new Matrix3();
        b.preMultiplyInto(a, result);
        return result;
      }
      /**
       * Pre-multiply this matrix by another and store the result: target = other * this.
       * @param other the matrix to pre-multiply by
       * @param target receives the resulting matrix
       */
      preMultiplyInto(other, target) {
        let a = other.a * this.a;
        let b = 0;
        let c = 0;
        let d = other.d * this.d;
        let tx = other.tx * this.a + this.tx;
        let ty = other.ty * this.d + this.ty;
        if (other.b !== 0 || other.c !== 0 || this.b !== 0 || this.c !== 0) {
          a += other.b * this.c;
          d += other.c * this.b;
          b += other.a * this.b + other.b * this.d;
          c += other.c * this.a + other.d * this.c;
          tx += other.ty * this.c;
          ty += other.tx * this.b;
        }
        target.a = a;
        target.b = b;
        target.c = c;
        target.d = d;
        target.tx = tx;
        target.ty = ty;
      }
      /**
       * @private
       */
      $transformBounds(bounds) {
        let a = this.a;
        let b = this.b;
        let c = this.c;
        let d = this.d;
        let tx = this.tx;
        let ty = this.ty;
        let x = bounds.x;
        let y = bounds.y;
        let xMax = x + bounds.width;
        let yMax = y + bounds.height;
        let x0 = a * x + c * y + tx;
        let y0 = b * x + d * y + ty;
        let x1 = a * xMax + c * y + tx;
        let y1 = b * xMax + d * y + ty;
        let x2 = a * xMax + c * yMax + tx;
        let y2 = b * xMax + d * yMax + ty;
        let x3 = a * x + c * yMax + tx;
        let y3 = b * x + d * yMax + ty;
        let tmp = 0;
        if (x0 > x1) {
          tmp = x0;
          x0 = x1;
          x1 = tmp;
        }
        if (x2 > x3) {
          tmp = x2;
          x2 = x3;
          x3 = tmp;
        }
        bounds.x = Math.floor(x0 < x2 ? x0 : x2);
        bounds.width = Math.ceil((x1 > x3 ? x1 : x3) - bounds.x);
        if (y0 > y1) {
          tmp = y0;
          y0 = y1;
          y1 = tmp;
        }
        if (y2 > y3) {
          tmp = y2;
          y2 = y3;
          y3 = tmp;
        }
        bounds.y = Math.floor(y0 < y2 ? y0 : y2);
        bounds.height = Math.ceil((y1 > y3 ? y1 : y3) - bounds.y);
      }
      /**
       * @private
       */
      getDeterminant() {
        return this.a * this.d - this.b * this.c;
      }
    }

    class OrderMap extends Map {
      /** The values in insertion order; only populated when value recording is enabled. */
      valueList;
      /** The keys in insertion order; only populated when key recording is enabled. */
      keyList;
      /** Whether the map has changed since this flag was last reset. */
      isChange = true;
      /** Creates an order-preserving map, optionally recording keys and/or values in parallel lists. */
      constructor(iterable, recordKey, recordValue) {
        super(iterable);
        if (recordKey) this.keyList = [];
        if (recordValue) this.valueList = [];
        if (iterable) {
          for (let item of iterable) {
            this.valueList?.push(item[1]);
            this.keyList?.push(item[0]);
          }
        }
      }
      /** Removes the entry for the given key, also updating the order lists; returns whether it existed. */
      delete(key) {
        if (this.has(key)) {
          let value = this.get(key);
          this.valueList && this.deleteValue(value);
          this.keyList && this.deleteKey(key);
          this.isChange = true;
          return super.delete(key);
        }
        return false;
      }
      deleteValue(value) {
        let index = this.valueList.indexOf(value);
        if (index >= 0) {
          this.valueList.splice(index, 1);
        }
        return this;
      }
      deleteKey(key) {
        let index = this.keyList.indexOf(key);
        if (index >= 0) {
          this.keyList.splice(index, 1);
        }
        return this;
      }
      /** Sets the value for the given key, appending it to the end of the order lists. */
      set(key, value) {
        this.delete(key);
        this.keyList?.push(key);
        this.valueList?.push(value);
        super.set(key, value);
        this.isChange = true;
        return this;
      }
      /** Removes all entries from the map and clears the order lists. */
      clear() {
        if (this.valueList) this.valueList.length = 0;
        if (this.keyList) this.keyList.length = 0;
        this.isChange = true;
        super.clear();
      }
    }

    var ParticleSystemRandomnessIds = /* @__PURE__ */ ((ParticleSystemRandomnessIds2) => {
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemClampVelocityCurveId"] = 322376503] = "kParticleSystemClampVelocityCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemForceCurveId"] = 306581307] = "kParticleSystemForceCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemRotationCurveId"] = 1793934638] = "kParticleSystemRotationCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemRotationBySpeedCurveId"] = 3737431713] = "kParticleSystemRotationBySpeedCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemStartSpeedCurveId"] = 2527743459] = "kParticleSystemStartSpeedCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemSizeCurveId"] = 2368504881] = "kParticleSystemSizeCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemSizeBySpeedCurveId"] = 4085612399] = "kParticleSystemSizeBySpeedCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemVelocityCurveId"] = 3774601268] = "kParticleSystemVelocityCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemUVCurveId"] = 326370691] = "kParticleSystemUVCurveId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemColorGradientId"] = 1494990940] = "kParticleSystemColorGradientId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemColorByVelocityGradientId"] = 1089181156] = "kParticleSystemColorByVelocityGradientId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemMeshSelectionId"] = 3159510623] = "kParticleSystemMeshSelectionId";
      ParticleSystemRandomnessIds2[ParticleSystemRandomnessIds2["kParticleSystemUVRowSelectionId"] = 2941263940] = "kParticleSystemUVRowSelectionId";
      return ParticleSystemRandomnessIds2;
    })(ParticleSystemRandomnessIds || {});
    const kPI = 3.141592653589793;

    class Polynomials {
    }
    function cubicPolynomialRoot(p, q, r) {
      let rcp3 = 1 / 3;
      let half = 0.5;
      let po3 = p * rcp3;
      let po3_2 = po3 * po3;
      let po3_3 = po3_2 * po3;
      let b = po3_3 - po3 * q * half + r * half;
      let a = -po3_2 + q * rcp3;
      let a3 = a * a * a;
      let det = a3 + b * b;
      if (det >= 0) {
        let r0 = Math.sqrt(det) - b;
        r0 = r0 > 0 ? Math.pow(r0, rcp3) : -Math.pow(-r0, rcp3);
        return -po3 - a / r0 + r0;
      }
      let abs = Math.sqrt(-a3);
      let arg = Math.acos(-b / abs);
      abs = Math.pow(abs, rcp3);
      abs = abs - a / abs;
      arg = -po3 + abs * Math.cos(arg * rcp3);
      return arg;
    }
    function quadraticPolynomialRootsGeneric(a, b, c, out) {
      let eps = 1e-5;
      if (Math.abs(a) < eps) {
        if (Math.abs(b) > eps) {
          out.r0 = -c / b;
          return 1;
        } else {
          return 0;
        }
      }
      let disc = b * b - 4 * a * c;
      if (disc < 0) {
        return 0;
      }
      let halfRcpA = 0.5 / a;
      let sqrtDisc = Math.sqrt(disc);
      out.r0 = (sqrtDisc - b) * halfRcpA;
      out.r1 = (-sqrtDisc - b) * halfRcpA;
      return 2;
    }
    function cubicPolynomialRootsGeneric(roots, a, b, c, d) {
      let numRoots = 0;
      if (Math.abs(a) >= 1e-4) {
        let p = b / a;
        let q = c / a;
        let r = d / a;
        roots[0] = cubicPolynomialRoot(p, q, r);
        numRoots++;
        let la = a;
        let lb = b + a * roots[0];
        let lc = c + b * roots[0] + a * roots[0] * roots[0];
        numRoots += quadraticPolynomialRootsGeneric(la, lb, lc, { r0: roots[1], r1: roots[2] });
      } else {
        numRoots += quadraticPolynomialRootsGeneric(b, c, d, { r0: roots[1], r1: roots[2] });
      }
      return numRoots;
    }

    class Polynomial {
      coeff = [];
      static EvalSegment(t, coeff) {
        return t * (t * (t * coeff[0] + coeff[1]) + coeff[2]) + coeff[3];
      }
    }
    class PolynomialCurve {
      static kMaxNumSegments = 8;
      segments = [];
      integrationCache = [];
      doubleIntegrationCache = [];
      times = [];
      segmentCount;
      constructor() {
        this.segments[PolynomialCurve.kMaxNumSegments] = new Polynomial();
        this.integrationCache[PolynomialCurve.kMaxNumSegments] = 0;
        this.doubleIntegrationCache[PolynomialCurve.kMaxNumSegments] = 0;
        this.times[PolynomialCurve.kMaxNumSegments] = 0;
      }
      calculateMinMax(minmax, value) {
        minmax.x = Math.min(minmax.x, value);
        minmax.y = Math.max(minmax.y, value);
      }
      findMinMaxDoubleIntegrated() {
        let result = Vector2.ZERO.clone();
        let numSteps = 20;
        let delta = 1 / numSteps;
        let acc = delta;
        for (let i = 0; i < numSteps; i++) {
          this.calculateMinMax(result, this.evaluateDoubleIntegrated(acc));
          acc += delta;
        }
        return result;
      }
      // Find the maximum of the integrated curve (x: min, y: max)
      findMinMaxIntegrated() {
        let result = Vector2.ZERO.clone();
        let start = [];
        let end = [];
        for (let i = 0; i < this.segmentCount; i++) {
          let a = 4 * this.segments[i].coeff[0];
          let b = 3 * this.segments[i].coeff[1];
          let c = 2 * this.segments[i].coeff[2];
          let d = 1 * this.segments[i].coeff[3];
          let roots = [];
          let numRoots = cubicPolynomialRootsGeneric(roots, a, b, c, d);
          for (let r = 0; r < numRoots; r++) {
            let root = roots[r] + start[i];
            if (root >= start[i] && root < end[i]) {
              this.calculateMinMax(result, this.evaluateIntegrated(root));
            }
          }
          this.calculateMinMax(result, this.evaluateIntegrated(end[i]));
          this.times[i];
        }
        return result;
      }
      generateIntegrationCache(curve) {
        curve.integrationCache[0] = 0;
        let prevTimeValue0 = curve.times[0];
        let prevTimeValue1 = 0;
        for (let i = 1; i < curve.segmentCount; i++) {
          let coeff = curve.segments[i - 1].coeff;
          integrateSegment(coeff);
          let time = prevTimeValue0 - prevTimeValue1;
          curve.integrationCache[i] = curve.integrationCache[i - 1] + Polynomial.EvalSegment(time, coeff) * time;
          prevTimeValue1 = prevTimeValue0;
          prevTimeValue0 = curve.times[i];
        }
      }
      generateDoubleIntegrationCache(curve) {
        let sum = 0;
        let prevTimeValue = 0;
        for (let i = 0; i < curve.segmentCount; i++) {
          curve.doubleIntegrationCache[i] = sum;
          let time = curve.times[i] - prevTimeValue;
          time = Math.max(time, 0);
          sum += Polynomial.EvalSegment(time, curve.segments[i].coeff) * time * time + curve.integrationCache[i] * time;
          prevTimeValue = curve.times[i];
        }
      }
      // Integrates a velocity curve to be a position curve.
      // You have to call EvaluateIntegrated to evaluate the curve
      integrate() {
        this.generateIntegrationCache(this);
        for (let i = 0; i < this.segmentCount; i++) {
          integrateSegment(this.segments[i].coeff);
        }
      }
      // Integrates a velocity curve to be a position curve.
      // You have to call EvaluateDoubleIntegrated to evaluate the curve
      doubleIntegrate() {
        this.generateIntegrationCache(this);
        for (let i = 0; i < this.segmentCount; i++) {
          doubleIntegrateSegment(this.segments[i].coeff);
        }
        this.generateDoubleIntegrationCache(this);
      }
      // Evaluates if it is possible to represent animation curve as PolynomialCurve
      static isValidCurve(editorCurve) {
        let keyCount = editorCurve.getKeyCount();
        let segmentCount = keyCount - 1;
        if (editorCurve.getKey(0).time != 0) {
          segmentCount++;
        }
        if (editorCurve.getKey(keyCount - 1).time != 1) {
          segmentCount++;
        }
        return segmentCount <= PolynomialCurve.kMaxNumSegments;
      }
      evaluateDoubleIntegrated(t) {
        let prevTimeValue = 0;
        for (let i = 0; i < this.segmentCount; i++) {
          if (t <= this.times[i]) {
            let time = t - prevTimeValue;
            return this.doubleIntegrationCache[i] + this.integrationCache[i] * time + Polynomial.EvalSegment(time, this.segments[i].coeff) * time * time;
          }
          prevTimeValue = this.times[i];
        }
        return 1;
      }
      // Evaluate integrated Polynomial curve.
      // Example: position = EvaluateIntegrated (normalizedTime) * startEnergy
      // Use Integrate function to for example turn a velocity curve into a position curve.
      // Expects that t is in the 0...1 range.
      evaluateIntegrated(t) {
        let prevTimeValue = 0;
        for (let i = 0; i < this.segmentCount; i++) {
          if (t <= this.times[i]) {
            let time = t - prevTimeValue;
            return this.integrationCache[i] + Polynomial.EvalSegment(time, this.segments[i].coeff) * time;
          }
          prevTimeValue = this.times[i];
        }
        return 1;
      }
      // Evaluate the curve
      // extects that t is in the 0...1 range
      evaluate(t) {
        let prevTimeValue = 0;
        for (let i = 0; i < this.segmentCount; i++) {
          if (t <= this.times[i]) {
            return Polynomial.EvalSegment(t - prevTimeValue, this.segments[i].coeff);
          }
          prevTimeValue = this.times[i];
        }
        return 1;
      }
      buildCurve(editorCurve, scale) {
        let keyCount = editorCurve.getKeyCount();
        this.segmentCount = 1;
        let kMaxTime = 1.01;
        this.segments.length = 0;
        this.integrationCache.length = 0;
        this.doubleIntegrationCache.length = 0;
        this.times.length = 0;
        this.times[0] = kMaxTime;
        if (keyCount == 0) ; else if (keyCount == 1) {
          this.segments[0] = new Polynomial();
          this.segments[0].coeff[3] = editorCurve.getKey(0).value * scale;
        } else {
          this.segmentCount = keyCount - 1;
          let segmentOffset = 0;
          if (editorCurve.getKey(0).time != 0) {
            this.segments[0].coeff[3] = editorCurve.getKey(0).value;
            this.times[0] = editorCurve.getKey(0).time;
            segmentOffset = 1;
          }
          for (let i = 0; i < this.segmentCount; i++) {
            let cache;
            editorCurve.calculateCacheData(cache, i, i + 1, 0);
            this.segments[i + segmentOffset].coeff = cache.coeff.concat();
            this.times[i + segmentOffset] = editorCurve.getKey(i + 1).time;
          }
          this.segmentCount += segmentOffset;
          if (editorCurve.getKey(keyCount - 1).time != 1) {
            this.segments[this.segmentCount].coeff[3] = editorCurve.getKey(keyCount - 1).value;
            this.segmentCount++;
          }
          this.times[this.segmentCount - 1] = kMaxTime;
          for (let i = 0; i < this.segmentCount; i++) {
            this.segments[i].coeff[0] *= scale;
            this.segments[i].coeff[1] *= scale;
            this.segments[i].coeff[2] *= scale;
            this.segments[i].coeff[3] *= scale;
          }
        }
        return true;
      }
    }
    function doubleIntegrateSegment(coeff) {
      coeff[0] /= 20;
      coeff[1] /= 12;
      coeff[2] /= 6;
      coeff[3] /= 2;
    }
    function integrateSegment(coeff) {
      coeff[0] /= 4;
      coeff[1] /= 3;
      coeff[2] /= 2;
      coeff[3] /= 1;
    }

    var ParticleSystemCurveEvalMode = /* @__PURE__ */ ((ParticleSystemCurveEvalMode2) => {
      ParticleSystemCurveEvalMode2[ParticleSystemCurveEvalMode2["kEMScalar"] = 0] = "kEMScalar";
      ParticleSystemCurveEvalMode2[ParticleSystemCurveEvalMode2["kEMOptimized"] = 1] = "kEMOptimized";
      ParticleSystemCurveEvalMode2[ParticleSystemCurveEvalMode2["kEMOptimizedMinMax"] = 2] = "kEMOptimizedMinMax";
      ParticleSystemCurveEvalMode2[ParticleSystemCurveEvalMode2["kEMSlow"] = 3] = "kEMSlow";
      return ParticleSystemCurveEvalMode2;
    })(ParticleSystemCurveEvalMode || {});
    var MinMaxCurveState = /* @__PURE__ */ ((MinMaxCurveState2) => {
      MinMaxCurveState2[MinMaxCurveState2["kMMCScalar"] = 0] = "kMMCScalar";
      MinMaxCurveState2[MinMaxCurveState2["kMMCCurve"] = 1] = "kMMCCurve";
      MinMaxCurveState2[MinMaxCurveState2["kMMCTwoCurves"] = 2] = "kMMCTwoCurves";
      MinMaxCurveState2[MinMaxCurveState2["kMMCTwoConstants"] = 3] = "kMMCTwoConstants";
      return MinMaxCurveState2;
    })(MinMaxCurveState || {});
    class MinMaxAnimationCurves {
      // public SupportsProcedural ();
      max;
      min;
    }
    class MinMaxPolyCurves {
      max;
      min;
      integrate() {
        this.max.integrate();
        this.min.integrate();
      }
      doubleIntegrate() {
        this.max.doubleIntegrate();
        this.min.doubleIntegrate();
      }
      findMinMaxIntegrated() {
        return null;
      }
      findMinMaxDoubleIntegrated() {
        return null;
      }
    }
    class MinMaxCurve {
      minMaxState;
      // see enum MinMaxCurveState
      minCurve;
      maxCurve;
      _scalar = 1;
      // Since scalar is baked into the optimized curve we use the setter function to modify it.
      _minScalar;
      constructor(scalarValue = 1) {
        this._scalar = scalarValue;
        this.minMaxState = 0 /* kMMCScalar */;
        this.minCurve = new AnimationCurve();
        this.maxCurve = new AnimationCurve();
      }
      setScalar(value) {
        this._scalar = value;
      }
      getScalar() {
        return this._scalar;
      }
      static evaluateSlow(curve, t, factor) {
        let v = curve.maxCurve.getValue(t) * curve.getScalar();
        if (curve.minMaxState == 2 /* kMMCTwoCurves */) {
          return lerp(curve.minCurve.getValue(t) * curve.getScalar(), v, factor);
        } else return v;
      }
      static evaluate(curve, t, randomValue = 1) {
        if (curve.minMaxState == 0 /* kMMCScalar */) {
          return curve.getScalar();
        }
        let v = curve.maxCurve.getValue(t) * curve.getScalar();
        if (curve.minMaxState == 1 /* kMMCCurve */) {
          return lerp(curve.minCurve.getValue(t) * curve.getScalar(), v, randomValue);
        }
        if (curve.minMaxState == 3 /* kMMCTwoConstants */) {
          return lerp(curve._minScalar, curve._scalar, randomValue);
        }
        if (curve.minMaxState == 2 /* kMMCTwoCurves */) {
          return lerp(curve.minCurve.getValue(t) * curve.getScalar(), v, 1 * Math.random());
        }
        return this.evaluateSlow(curve, t, 1);
      }
      unSerialized(data) {
        this.minMaxState = data["minMaxState"];
        this._scalar = data["scalar"];
        this._minScalar = data["minScalar"];
        this.maxCurve.unSerialized(data["maxCurve"]);
        this.minCurve.unSerialized(data["minCurve"]);
      }
    }
    class ValueSpread {
      value = 0;
      mode = 0;
      spread = 0;
      speed = new MinMaxCurve();
      unSerialized(data) {
        this.value = data["value"];
        this.mode = data["mode"];
        this.spread = data["spread"];
        this.speed.unSerialized(data["speed"]);
      }
    }
    function curvesSupportProcedural(editorCurves, minMaxState) {
      let isValid = PolynomialCurve.isValidCurve(editorCurves.max);
      if (minMaxState != 2 /* kMMCTwoCurves */ && minMaxState != 3 /* kMMCTwoConstants */) {
        return isValid;
      } else {
        return isValid && PolynomialCurve.isValidCurve(editorCurves.min);
      }
    }
    function buildCurves(polyCurves, editorCurves, scalar, minMaxState) {
      polyCurves.max.buildCurve(editorCurves.max, scalar);
      if (minMaxState != 2 /* kMMCTwoCurves */ && minMaxState != 3 /* kMMCTwoConstants */) {
        polyCurves.min.buildCurve(editorCurves.max, scalar);
      } else {
        polyCurves.min.buildCurve(editorCurves.min, scalar);
      }
    }
    function calculateCurveRangesValue(minMaxValue, curve) {
      let keyCount = curve.getKeyCount();
      if (keyCount == 0) {
        return;
      }
      if (keyCount == 1) {
        calculateMinMax(minMaxValue, curve.getKey(0).value);
      } else {
        let segmentCount = keyCount - 1;
        calculateMinMax(minMaxValue, curve.getKey(0).value);
        for (let i = 0; i < segmentCount; i++) {
          let cache = new FrameCache();
          curve.calculateCacheData(cache, i, i + 1, 0);
          let a = 3 * cache.coeff[0];
          let b = 2 * cache.coeff[1];
          let c = 1 * cache.coeff[2];
          let start = curve.getKey(i).time;
          let end = curve.getKey(i + 1).time;
          let roots = [];
          let numRoots = quadraticPolynomialRootsGeneric(a, b, c, { r0: roots[0], r1: roots[1] });
          for (let r = 0; r < numRoots; r++) {
            if (roots[r] >= 0 && roots[r] + start < end) {
              calculateMinMax(minMaxValue, Polynomial.EvalSegment(roots[r], cache.coeff));
            }
          }
          calculateMinMax(minMaxValue, Polynomial.EvalSegment(end - start, cache.coeff));
        }
      }
    }
    function calculateMinMax(minmax, value) {
      minmax.x = Math.min(minmax.x, value);
      minmax.y = Math.max(minmax.y, value);
    }

    class Plane {
      /**
       * Center position of plane
       */
      point = new Vector3();
      /**
       * Plane normal vector
       */
      normal = Vector3.UP;
      /**
       * @internal
       */
      _tmpVecA = new Vector3();
      /**
       * Constructs a new plane object
       * @param pos Plane position
       * @param normal Plane normal quantity
       */
      constructor(pos, normal) {
        this.point = pos;
        this.normal = normal;
      }
      /**
       * Clones the current plane object
       * @returns New plane object
       */
      clone() {
        let plane = new Plane(this.point.clone(), this.normal.clone());
        return plane;
      }
      /**
       * Determine whether the plane intersects a line segment and calculate the intersection point
       * @param start Starting point of line segment
       * @param end End point of line segment
       * @param point Point of output intersection
       * @returns Returns whether it intersects
       */
      intersectsLine(start, end, point) {
        var d = -this.normal.dotProduct(this.point);
        var d0 = this.normal.dotProduct(start) + d;
        var d1 = this.normal.dotProduct(end) + d;
        var t = d0 / (d0 - d1);
        var intersects = t >= 0 && t <= 1;
        if (intersects && point) {
          point.lerp(start, end, t);
        }
        return intersects;
      }
      /**
       * Determine whether the plane intersects a ray and calculate the intersection point
       * @param ray Ray of input
       * @param outPoint Point of output intersection
       * @returns Returns whether it intersects
       */
      intersectsRay(ray, targetPoint) {
        targetPoint ||= this._tmpVecA;
        Vector3.sub(this.point, ray.origin, targetPoint);
        var t = this.normal.dotProduct(targetPoint) / this.normal.dotProduct(ray.direction);
        var intersects = t >= 0;
        if (intersects) {
          Vector3.addScaledVector(ray.origin, ray.direction, t, targetPoint);
        }
        return intersects;
      }
    }

    class PlaneClassification {
      /**
      * @language en_US
      * Back side
      * @platform Web,Native
      */
      static BACK = 0;
      /**
      * @language en_US
      * Front side
      * @platform Web,Native
      */
      static FRONT = 1;
      /**
      * @language en_US
      * The side that the normal points toward
      * @platform Web,Native
      */
      static IN = 0;
      /**
      * @language en_US
      * The side opposite the normal direction
      * @platform Web,Native
      */
      static OUT = 1;
      /**
      * @language en_US
      * Intersecting
      * @platform Web,Native
      */
      static INTERSECT = 2;
    }

    class Plane3D {
      /**
       * @language en_US
       * The A coefficient of this plane. (Also the x dimension of the plane normal)
       * @platform Web,Native
       */
      a;
      /**
       * @language en_US
       * The B coefficient of this plane. (Also the y dimension of the plane normal)
       * @platform Web,Native
       */
      b;
      /**
       * @language en_US
       * The C coefficient of this plane. (Also the z dimension of the plane normal)
       * @platform Web,Native
       */
      c;
      /**
       * @language en_US
       * The D coefficient of this plane. (Also the inverse dot product between normal and point)
       * @platform Web,Native
       */
      d;
      // indicates the alignment of the plane
      /**
       * Plane alignment: not aligned to any principal axis plane.
       */
      static ALIGN_ANY = 0;
      /**
       * Plane alignment: aligned to the XY axis plane.
       */
      static ALIGN_XY_AXIS = 1;
      /**
       * Plane alignment: aligned to the YZ axis plane.
       */
      static ALIGN_YZ_AXIS = 2;
      /**
       * Plane alignment: aligned to the XZ axis plane.
       */
      static ALIGN_XZ_AXIS = 3;
      /**
       * @language en_US
       * Create a Plane3D with ABCD coefficients
       * @param a
       * @param b
       * @param c
       * @param d
       * @platform Web,Native
       */
      constructor(a = 0, b = 0, c = 0, d = 0) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
      }
      /**
      * @language en_US
      * Fill the plane coefficients with the provided values.
      * @param a
      * @param b
      * @param c
      * @param d
      * @platform Web,Native
      */
      setTo(a = 0, b = 0, c = 0, d = 0) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
      }
      /**
       * @language en_US
       * Fills this Plane3D with the coefficients from 3 points in 3d space.
       * @param p0 Vector3
       * @param p1 Vector3
       * @param p2 Vector3
       * @platform Web,Native
       */
      fromPoints(p0, p1, p2) {
        var d1x = p1.x - p0.x;
        var d1y = p1.y - p0.y;
        var d1z = p1.z - p0.z;
        var d2x = p2.x - p0.x;
        var d2y = p2.y - p0.y;
        var d2z = p2.z - p0.z;
        this.a = d1y * d2z - d1z * d2y;
        this.b = d1z * d2x - d1x * d2z;
        this.c = d1x * d2y - d1y * d2x;
        this.d = -(this.a * p0.x + this.b * p0.y + this.c * p0.z);
      }
      /**
       * @language en_US
       * Fills this Plane3D with the coefficients from the plane's normal and a point in 3d space.
       * @param normal Vector3
       * @param point  Vector3
       * @platform Web,Native
       */
      fromNormalAndPoint(normal, point) {
        this.a = normal.x;
        this.b = normal.y;
        this.c = normal.z;
        this.d = -(this.a * point.x + this.b * point.y + this.c * point.z);
      }
      /**
       * @language en_US
       * Normalize this Plane3D
       * @returns number the length of the plane normal before normalization
       * @platform Web,Native
       */
      normalize() {
        var len = Math.sqrt(this.a * this.a + this.b * this.b + this.c * this.c);
        if (len > 0) {
          var invLength = 1 / len;
          this.a *= invLength;
          this.b *= invLength;
          this.c *= invLength;
          this.d *= invLength;
        }
        return len;
      }
      /**
       * @language en_US
       * Returns the signed distance between this Plane3D and the point p.
       * @param p Vector3
       * @returns number
       * @platform Web,Native
       */
      distance(p) {
        return this.a * p.x + this.b * p.y + this.c * p.z + this.d;
      }
      /**
       * @language en_US
       * Classify a point against this Plane3D. (in front, back or intersecting)
       * @param p Vector3
       * @param epsilon tolerance
       * @returns Plane3D.FRONT — point is in front of the plane;
       * Plane3D.BACK — point is behind the plane;
       * Plane3D.INTERSECT — point lies on the plane.
       * @platform Web,Native
       */
      classifyPoint(p, epsilon = 0.01) {
        var dis = this.distance(p);
        if (dis < -epsilon) {
          return PlaneClassification.BACK;
        } else if (dis > epsilon) {
          return PlaneClassification.FRONT;
        }
        return PlaneClassification.INTERSECT;
      }
      /**
      * @language en_US
      * Returns a string representation of this Plane3D
      * @returns string
      * @platform Web,Native
      */
      toString() {
        return "Plane3D [a:" + this.a + ", b:" + this.b + ", c:" + this.c + ", d:" + this.d + "]";
      }
    }

    function uniform_real_distribution(min, max) {
      return Math.random() * max + Math.random() * min + (max - min) * Math.random();
    }
    function uniform_real_distribution2(min, max, rng) {
      let rd = rng * Math.random();
      return Math.random() * max * rd + Math.random() * min * rd + (max - min) * Math.random() * rd;
    }
    function normal_distribution(min, max, skew) {
      let u = 0, v = 0;
      while (u === 0) u = Math.random();
      while (v === 0) v = Math.random();
      let num = Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
      num = num / 10 + 0.5;
      if (num > 1 || num < 0) num = normal_distribution(min, max, skew);
      num = Math.pow(num, skew);
      num *= max - min;
      num += min;
      return num;
    }
    function FASTFLOOR(x) {
      return x > 0 ? Math.floor(x) : Math.floor(x) - 1;
    }
    let perm = [
      151,
      160,
      137,
      91,
      90,
      15,
      131,
      13,
      201,
      95,
      96,
      53,
      194,
      233,
      7,
      225,
      140,
      36,
      103,
      30,
      69,
      142,
      8,
      99,
      37,
      240,
      21,
      10,
      23,
      190,
      6,
      148,
      247,
      120,
      234,
      75,
      0,
      26,
      197,
      62,
      94,
      252,
      219,
      203,
      117,
      35,
      11,
      32,
      57,
      177,
      33,
      88,
      237,
      149,
      56,
      87,
      174,
      20,
      125,
      136,
      171,
      168,
      68,
      175,
      74,
      165,
      71,
      134,
      139,
      48,
      27,
      166,
      77,
      146,
      158,
      231,
      83,
      111,
      229,
      122,
      60,
      211,
      133,
      230,
      220,
      105,
      92,
      41,
      55,
      46,
      245,
      40,
      244,
      102,
      143,
      54,
      65,
      25,
      63,
      161,
      1,
      216,
      80,
      73,
      209,
      76,
      132,
      187,
      208,
      89,
      18,
      169,
      200,
      196,
      135,
      130,
      116,
      188,
      159,
      86,
      164,
      100,
      109,
      198,
      173,
      186,
      3,
      64,
      52,
      217,
      226,
      250,
      124,
      123,
      5,
      202,
      38,
      147,
      118,
      126,
      255,
      82,
      85,
      212,
      207,
      206,
      59,
      227,
      47,
      16,
      58,
      17,
      182,
      189,
      28,
      42,
      223,
      183,
      170,
      213,
      119,
      248,
      152,
      2,
      44,
      154,
      163,
      70,
      221,
      153,
      101,
      155,
      167,
      43,
      172,
      9,
      129,
      22,
      39,
      253,
      19,
      98,
      108,
      110,
      79,
      113,
      224,
      232,
      178,
      185,
      112,
      104,
      218,
      246,
      97,
      228,
      251,
      34,
      242,
      193,
      238,
      210,
      144,
      12,
      191,
      179,
      162,
      241,
      81,
      51,
      145,
      235,
      249,
      14,
      239,
      107,
      49,
      192,
      214,
      31,
      181,
      199,
      106,
      157,
      184,
      84,
      204,
      176,
      115,
      121,
      50,
      45,
      127,
      4,
      150,
      254,
      138,
      236,
      205,
      93,
      222,
      114,
      67,
      29,
      24,
      72,
      243,
      141,
      128,
      195,
      78,
      66,
      215,
      61,
      156,
      180,
      151,
      160,
      137,
      91,
      90,
      15,
      131,
      13,
      201,
      95,
      96,
      53,
      194,
      233,
      7,
      225,
      140,
      36,
      103,
      30,
      69,
      142,
      8,
      99,
      37,
      240,
      21,
      10,
      23,
      190,
      6,
      148,
      247,
      120,
      234,
      75,
      0,
      26,
      197,
      62,
      94,
      252,
      219,
      203,
      117,
      35,
      11,
      32,
      57,
      177,
      33,
      88,
      237,
      149,
      56,
      87,
      174,
      20,
      125,
      136,
      171,
      168,
      68,
      175,
      74,
      165,
      71,
      134,
      139,
      48,
      27,
      166,
      77,
      146,
      158,
      231,
      83,
      111,
      229,
      122,
      60,
      211,
      133,
      230,
      220,
      105,
      92,
      41,
      55,
      46,
      245,
      40,
      244,
      102,
      143,
      54,
      65,
      25,
      63,
      161,
      1,
      216,
      80,
      73,
      209,
      76,
      132,
      187,
      208,
      89,
      18,
      169,
      200,
      196,
      135,
      130,
      116,
      188,
      159,
      86,
      164,
      100,
      109,
      198,
      173,
      186,
      3,
      64,
      52,
      217,
      226,
      250,
      124,
      123,
      5,
      202,
      38,
      147,
      118,
      126,
      255,
      82,
      85,
      212,
      207,
      206,
      59,
      227,
      47,
      16,
      58,
      17,
      182,
      189,
      28,
      42,
      223,
      183,
      170,
      213,
      119,
      248,
      152,
      2,
      44,
      154,
      163,
      70,
      221,
      153,
      101,
      155,
      167,
      43,
      172,
      9,
      129,
      22,
      39,
      253,
      19,
      98,
      108,
      110,
      79,
      113,
      224,
      232,
      178,
      185,
      112,
      104,
      218,
      246,
      97,
      228,
      251,
      34,
      242,
      193,
      238,
      210,
      144,
      12,
      191,
      179,
      162,
      241,
      81,
      51,
      145,
      235,
      249,
      14,
      239,
      107,
      49,
      192,
      214,
      31,
      181,
      199,
      106,
      157,
      184,
      84,
      204,
      176,
      115,
      121,
      50,
      45,
      127,
      4,
      150,
      254,
      138,
      236,
      205,
      93,
      222,
      114,
      67,
      29,
      24,
      72,
      243,
      141,
      128,
      195,
      78,
      66,
      215,
      61,
      156,
      180
    ];
    function grad1(hash, x) {
      let h = hash & 15;
      let grad = 1 + (h & 7);
      if (h & 8) grad = -grad;
      return grad * x;
    }
    function grad2(hash, x, y) {
      let h = hash & 7;
      let u = h < 4 ? x : y;
      let v = h < 4 ? y : x;
      return (h & 1 ? -u : u) + (h & 2 ? -2 * v : 2 * v);
    }
    function grad3(hash, x, y, z) {
      let h = hash & 15;
      let u = h < 8 ? x : y;
      let v = h < 4 ? y : h == 12 || h == 14 ? x : z;
      return (h & 1 ? -u : u) + (h & 2 ? -v : v);
    }
    function grad4(hash, x, y, z, t) {
      let h = hash & 31;
      let u = h < 24 ? x : y;
      let v = h < 16 ? y : z;
      let w = h < 8 ? z : t;
      return (h & 1 ? -u : u) + (h & 2 ? -v : v) + (h & 4 ? -w : w);
    }
    let simplex = [
      [0, 1, 2, 3],
      [0, 1, 3, 2],
      [0, 0, 0, 0],
      [0, 2, 3, 1],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [1, 2, 3, 0],
      [0, 2, 1, 3],
      [0, 0, 0, 0],
      [0, 3, 1, 2],
      [0, 3, 2, 1],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [1, 3, 2, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [1, 2, 0, 3],
      [0, 0, 0, 0],
      [1, 3, 0, 2],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [2, 3, 0, 1],
      [2, 3, 1, 0],
      [1, 0, 2, 3],
      [1, 0, 3, 2],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [2, 0, 3, 1],
      [0, 0, 0, 0],
      [2, 1, 3, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [2, 0, 1, 3],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [3, 0, 1, 2],
      [3, 0, 2, 1],
      [0, 0, 0, 0],
      [3, 1, 2, 0],
      [2, 1, 0, 3],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
      [3, 1, 0, 2],
      [0, 0, 0, 0],
      [3, 2, 0, 1],
      [3, 2, 1, 0]
    ];
    function snoise1(x) {
      let i0 = FASTFLOOR(x);
      let i1 = i0 + 1;
      let x0 = x - i0;
      let x1 = x0 - 1;
      let n0, n1;
      let t0 = 1 - x0 * x0;
      t0 *= t0;
      n0 = t0 * t0 * grad1(perm[i0 & 255], x0);
      let t1 = 1 - x1 * x1;
      t1 *= t1;
      n1 = t1 * t1 * grad1(perm[i1 & 255], x1);
      return 0.25 * (n0 + n1);
    }
    function snoise2(x, y) {
      const F2 = 0.366025403;
      const G2 = 0.211324865;
      let n0, n1, n2;
      let s = (x + y) * F2;
      let xs = x + s;
      let ys = y + s;
      let i = FASTFLOOR(xs);
      let j = FASTFLOOR(ys);
      let t = (i + j) * G2;
      let X0 = i - t;
      let Y0 = j - t;
      let x0 = x - X0;
      let y0 = y - Y0;
      let i1, j1;
      if (x0 > y0) {
        i1 = 1;
        j1 = 0;
      } else {
        i1 = 0;
        j1 = 1;
      }
      let x1 = x0 - i1 + G2;
      let y1 = y0 - j1 + G2;
      let x2 = x0 - 1 + 2 * G2;
      let y2 = y0 - 1 + 2 * G2;
      let ii = i & 255;
      let jj = j & 255;
      let t0 = 0.5 - x0 * x0 - y0 * y0;
      if (t0 < 0) n0 = 0;
      else {
        t0 *= t0;
        n0 = t0 * t0 * grad2(perm[ii + perm[jj]], x0, y0);
      }
      let t1 = 0.5 - x1 * x1 - y1 * y1;
      if (t1 < 0) n1 = 0;
      else {
        t1 *= t1;
        n1 = t1 * t1 * grad2(perm[ii + i1 + perm[jj + j1]], x1, y1);
      }
      let t2 = 0.5 - x2 * x2 - y2 * y2;
      if (t2 < 0) n2 = 0;
      else {
        t2 *= t2;
        n2 = t2 * t2 * grad2(perm[ii + 1 + perm[jj + 1]], x2, y2);
      }
      return 40 * (n0 + n1 + n2);
    }
    function snoise3(x, y, z) {
      const F3 = 0.333333333;
      const G3 = 0.166666667;
      let n0, n1, n2, n3;
      let s = (x + y + z) * F3;
      let xs = x + s;
      let ys = y + s;
      let zs = z + s;
      let i = FASTFLOOR(xs);
      let j = FASTFLOOR(ys);
      let k = FASTFLOOR(zs);
      let t = (i + j + k) * G3;
      let X0 = i - t;
      let Y0 = j - t;
      let Z0 = k - t;
      let x0 = x - X0;
      let y0 = y - Y0;
      let z0 = z - Z0;
      let i1, j1, k1;
      let i2, j2, k2;
      if (x0 >= y0) {
        if (y0 >= z0) {
          i1 = 1;
          j1 = 0;
          k1 = 0;
          i2 = 1;
          j2 = 1;
          k2 = 0;
        } else if (x0 >= z0) {
          i1 = 1;
          j1 = 0;
          k1 = 0;
          i2 = 1;
          j2 = 0;
          k2 = 1;
        } else {
          i1 = 0;
          j1 = 0;
          k1 = 1;
          i2 = 1;
          j2 = 0;
          k2 = 1;
        }
      } else {
        if (y0 < z0) {
          i1 = 0;
          j1 = 0;
          k1 = 1;
          i2 = 0;
          j2 = 1;
          k2 = 1;
        } else if (x0 < z0) {
          i1 = 0;
          j1 = 1;
          k1 = 0;
          i2 = 0;
          j2 = 1;
          k2 = 1;
        } else {
          i1 = 0;
          j1 = 1;
          k1 = 0;
          i2 = 1;
          j2 = 1;
          k2 = 0;
        }
      }
      let x1 = x0 - i1 + G3;
      let y1 = y0 - j1 + G3;
      let z1 = z0 - k1 + G3;
      let x2 = x0 - i2 + 2 * G3;
      let y2 = y0 - j2 + 2 * G3;
      let z2 = z0 - k2 + 2 * G3;
      let x3 = x0 - 1 + 3 * G3;
      let y3 = y0 - 1 + 3 * G3;
      let z3 = z0 - 1 + 3 * G3;
      let ii = i & 255;
      let jj = j & 255;
      let kk = k & 255;
      let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0;
      if (t0 < 0) n0 = 0;
      else {
        t0 *= t0;
        n0 = t0 * t0 * grad3(perm[ii + perm[jj + perm[kk]]], x0, y0, z0);
      }
      let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1;
      if (t1 < 0) n1 = 0;
      else {
        t1 *= t1;
        n1 = t1 * t1 * grad3(perm[ii + i1 + perm[jj + j1 + perm[kk + k1]]], x1, y1, z1);
      }
      let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2;
      if (t2 < 0) n2 = 0;
      else {
        t2 *= t2;
        n2 = t2 * t2 * grad3(perm[ii + i2 + perm[jj + j2 + perm[kk + k2]]], x2, y2, z2);
      }
      let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3;
      if (t3 < 0) n3 = 0;
      else {
        t3 *= t3;
        n3 = t3 * t3 * grad3(perm[ii + 1 + perm[jj + 1 + perm[kk + 1]]], x3, y3, z3);
      }
      return 32 * (n0 + n1 + n2 + n3);
    }
    function snoise4(x, y, z, w) {
      const F4 = 0.309016994;
      const G4 = 0.138196601;
      let n0, n1, n2, n3, n4;
      let s = (x + y + z + w) * F4;
      let xs = x + s;
      let ys = y + s;
      let zs = z + s;
      let ws = w + s;
      let i = FASTFLOOR(xs);
      let j = FASTFLOOR(ys);
      let k = FASTFLOOR(zs);
      let l = FASTFLOOR(ws);
      let t = (i + j + k + l) * G4;
      let X0 = i - t;
      let Y0 = j - t;
      let Z0 = k - t;
      let W0 = l - t;
      let x0 = x - X0;
      let y0 = y - Y0;
      let z0 = z - Z0;
      let w0 = w - W0;
      let c1 = x0 > y0 ? 32 : 0;
      let c2 = x0 > z0 ? 16 : 0;
      let c3 = y0 > z0 ? 8 : 0;
      let c4 = x0 > w0 ? 4 : 0;
      let c5 = y0 > w0 ? 2 : 0;
      let c6 = z0 > w0 ? 1 : 0;
      let c = c1 + c2 + c3 + c4 + c5 + c6;
      let i1, j1, k1, l1;
      let i2, j2, k2, l2;
      let i3, j3, k3, l3;
      i1 = simplex[c][0] >= 3 ? 1 : 0;
      j1 = simplex[c][1] >= 3 ? 1 : 0;
      k1 = simplex[c][2] >= 3 ? 1 : 0;
      l1 = simplex[c][3] >= 3 ? 1 : 0;
      i2 = simplex[c][0] >= 2 ? 1 : 0;
      j2 = simplex[c][1] >= 2 ? 1 : 0;
      k2 = simplex[c][2] >= 2 ? 1 : 0;
      l2 = simplex[c][3] >= 2 ? 1 : 0;
      i3 = simplex[c][0] >= 1 ? 1 : 0;
      j3 = simplex[c][1] >= 1 ? 1 : 0;
      k3 = simplex[c][2] >= 1 ? 1 : 0;
      l3 = simplex[c][3] >= 1 ? 1 : 0;
      let x1 = x0 - i1 + G4;
      let y1 = y0 - j1 + G4;
      let z1 = z0 - k1 + G4;
      let w1 = w0 - l1 + G4;
      let x2 = x0 - i2 + 2 * G4;
      let y2 = y0 - j2 + 2 * G4;
      let z2 = z0 - k2 + 2 * G4;
      let w2 = w0 - l2 + 2 * G4;
      let x3 = x0 - i3 + 3 * G4;
      let y3 = y0 - j3 + 3 * G4;
      let z3 = z0 - k3 + 3 * G4;
      let w3 = w0 - l3 + 3 * G4;
      let x4 = x0 - 1 + 4 * G4;
      let y4 = y0 - 1 + 4 * G4;
      let z4 = z0 - 1 + 4 * G4;
      let w4 = w0 - 1 + 4 * G4;
      let ii = i & 255;
      let jj = j & 255;
      let kk = k & 255;
      let ll = l & 255;
      let t0 = 0.6 - x0 * x0 - y0 * y0 - z0 * z0 - w0 * w0;
      if (t0 < 0) n0 = 0;
      else {
        t0 *= t0;
        n0 = t0 * t0 * grad4(perm[ii + perm[jj + perm[kk + perm[ll]]]], x0, y0, z0, w0);
      }
      let t1 = 0.6 - x1 * x1 - y1 * y1 - z1 * z1 - w1 * w1;
      if (t1 < 0) n1 = 0;
      else {
        t1 *= t1;
        n1 = t1 * t1 * grad4(perm[ii + i1 + perm[jj + j1 + perm[kk + k1 + perm[ll + l1]]]], x1, y1, z1, w1);
      }
      let t2 = 0.6 - x2 * x2 - y2 * y2 - z2 * z2 - w2 * w2;
      if (t2 < 0) n2 = 0;
      else {
        t2 *= t2;
        n2 = t2 * t2 * grad4(perm[ii + i2 + perm[jj + j2 + perm[kk + k2 + perm[ll + l2]]]], x2, y2, z2, w2);
      }
      let t3 = 0.6 - x3 * x3 - y3 * y3 - z3 * z3 - w3 * w3;
      if (t3 < 0) n3 = 0;
      else {
        t3 *= t3;
        n3 = t3 * t3 * grad4(perm[ii + i3 + perm[jj + j3 + perm[kk + k3 + perm[ll + l3]]]], x3, y3, z3, w3);
      }
      let t4 = 0.6 - x4 * x4 - y4 * y4 - z4 * z4 - w4 * w4;
      if (t4 < 0) n4 = 0;
      else {
        t4 *= t4;
        n4 = t4 * t4 * grad4(perm[ii + 1 + perm[jj + 1 + perm[kk + 1 + perm[ll + 1]]]], x4, y4, z4, w4);
      }
      return 27 * (n0 + n1 + n2 + n3 + n4);
    }

    class UV extends Vector2 {
      static uv_0 = new UV();
      u = 0;
      v = 0;
      constructor(x = 0, y = 0) {
        super(x, y);
        this.u = x;
        this.v = y;
      }
      length() {
        return 0;
      }
      static getUVSheet(frame, countX, countY) {
        let f = Math.floor(frame % (countX * countY));
        let fx = Math.floor(f / countX);
        let fy = f % countX;
        return new Vector4(fx / countX, fy / countY, 1 / countX, 1 / countY);
      }
    }

    class KeyframeT {
      /** Serialized format version of this keyframe. */
      serializedVersion = "2";
      /** Time of this keyframe. */
      time;
      /** Tangent mode flags for this keyframe. */
      tangentMode = 0;
      /** Weighted mode flags for this keyframe. */
      weightedMode = 0;
      // public value: CurveValueType;
      // public inSlope: CurveValueType;
      // public outSlope: CurveValueType;
      // public inWeight: CurveValueType
      // public outWeight: CurveValueType
      /** Map of channel index to its per-channel keyframe. */
      propertyKeyFrame;
      constructor(time = 0) {
        this.time = time;
        this.propertyKeyFrame = {};
      }
      /**
       * Get the per-channel keyframe stored at the given channel index.
       * @param k channel index
       * @returns the keyframe for that channel
       */
      getK(k) {
        return this.propertyKeyFrame[k];
      }
      /**
       * Split a multi-component value into per-channel keyframes, writing it to the given property.
       * @param type value type describing the component layout
       * @param value the value to distribute across channels
       * @param property the keyframe property name to assign (e.g. value, inSlope, outSlope)
       */
      split(type, value, property) {
        switch (type) {
          case ValueEnumType.single:
            {
              let keyFrame = this.getKeyFrame(0);
              keyFrame[property] = value;
            }
            break;
          case ValueEnumType.float:
            {
              let keyFrame = this.getKeyFrame(0);
              keyFrame[property] = value;
            }
            break;
          case ValueEnumType.vector2:
            {
              let v = value;
              let x_kf = this.getKeyFrame(0);
              x_kf[property] = v.x;
              let y_kf = this.getKeyFrame(1);
              y_kf[property] = v.y;
            }
            break;
          case ValueEnumType.vector3:
            {
              let v = value;
              let x_kf = this.getKeyFrame(0);
              x_kf[property] = v.x;
              let y_kf = this.getKeyFrame(1);
              y_kf[property] = v.y;
              let z_kf = this.getKeyFrame(2);
              z_kf[property] = v.z;
            }
            break;
          case ValueEnumType.vector4:
            {
              let v = value;
              let x_kf = this.getKeyFrame(0);
              x_kf[property] = v.x;
              let y_kf = this.getKeyFrame(1);
              y_kf[property] = v.y;
              let z_kf = this.getKeyFrame(2);
              z_kf[property] = v.z;
              let w_kf = this.getKeyFrame(3);
              w_kf[property] = v.w;
            }
            break;
          case ValueEnumType.quaternion:
            {
              let v = value;
              let x_kf = this.getKeyFrame(0);
              x_kf[property] = v.x;
              let y_kf = this.getKeyFrame(1);
              y_kf[property] = v.y;
              let z_kf = this.getKeyFrame(2);
              z_kf[property] = v.z;
              let w_kf = this.getKeyFrame(3);
              w_kf[property] = v.w;
            }
            break;
        }
      }
      getKeyFrame(k) {
        let keyFrame = this.propertyKeyFrame[k];
        if (!keyFrame) {
          keyFrame = new Keyframe();
          keyFrame.time = this.time;
          keyFrame.tangentMode = this.tangentMode;
          keyFrame.weightedMode = this.weightedMode;
          this.propertyKeyFrame[k] = keyFrame;
        }
        return keyFrame;
      }
      /**
       * Read this keyframe and its per-channel data from a binary byte stream.
       * @param bytes source byte array
       */
      formBytes(bytes) {
        this.time = bytes.readFloat32();
        {
          let { t, v } = ValueParser.parser(bytes);
          this.split(t, v, "value");
        }
        {
          let { t, v } = ValueParser.parser(bytes);
          this.split(t, v, "inSlope");
        }
        {
          let { t, v } = ValueParser.parser(bytes);
          this.split(t, v, "outSlope");
        }
        this.tangentMode = bytes.readInt32();
        this.weightedMode = bytes.readInt32();
        {
          let { t, v } = ValueParser.parser(bytes);
          this.split(t, v, "inWeight");
        }
        {
          let { t, v } = ValueParser.parser(bytes);
          this.split(t, v, "outWeight");
        }
      }
    }

    class ValueOp {
      /**
       * Subtract one curve value from another, dispatching on the runtime value type.
       * @param v1 minuend
       * @param v2 subtrahend
       * @returns the component-wise difference of the same type
       */
      static sub(v1, v2) {
        let t = v1.constructor.name;
        switch (t) {
          case `number`:
            return v1 - v2;
          case "Vector2": {
            let vv1 = v1;
            let vv2 = v2;
            return new Vector2(vv1.x - vv2.x, vv1.y - vv2.y);
          }
          case "Vector3": {
            let vv1 = v1;
            let vv2 = v2;
            return new Vector3(vv1.x - vv2.x, vv1.y - vv2.y, vv1.z - vv2.z);
          }
          case "Vector4": {
            let vv1 = v1;
            let vv2 = v2;
            return new Vector4(vv1.x - vv2.x, vv1.y - vv2.y, vv1.z - vv2.z, vv1.w - vv2.w);
          }
          case "Quaternion": {
            let vv1 = v1;
            let vv2 = v2;
            return new Quaternion(vv1.x - vv2.x, vv1.y - vv2.y, vv1.z - vv2.z, vv1.w - vv2.w);
          }
        }
      }
    }

    class DoubleArray {
      _keys = new Array();
      _values = new Array();
      getIndexByKey(key) {
        return this._keys.indexOf(key);
      }
      getValueByKey(key) {
        var index = this.getIndexByKey(key);
        if (index > -1) {
          return this._values[index];
        }
        return null;
      }
      put(key, value) {
        if (key == null)
          return null;
        var old = this.remove(key);
        this._keys.push(key);
        this._values.push(value);
        return old;
      }
      remove(key) {
        var index = this._keys.indexOf(key);
        var item;
        if (index > -1) {
          item = this._values[index];
          this._keys.splice(index, 1);
          this._values.splice(index, 1);
        }
        return item;
      }
      getValues() {
        return this._values;
      }
      getKeys() {
        return this._keys;
      }
      clear() {
        this._values.length = 0;
        this._keys.length = 0;
      }
    }

    class Navi3DMaskType {
      static WalkAble = 1;
    }

    class Navi3DConst {
      static SetConst(epsilon) {
        this.EPSILON = epsilon;
        this.POWER_EPSILON = epsilon * epsilon;
      }
      static EPSILON = 0.1;
      static POWER_EPSILON = this.EPSILON * this.EPSILON;
    }

    class Navi3DPoint extends Vector3 {
      static CALC_VECTOR3D1 = new Vector3();
      static CALC_VECTOR3D2 = new Vector3();
      static CALC_VECTOR3D3 = new Vector3();
      static CALC_VECTOR3D4 = new Vector3();
      static CALC_VECTOR3D5 = new Vector3();
      _pointId = 0;
      constructor(id, X, Y, Z) {
        super(X, Y, Z, 0);
        this._pointId = id;
      }
      get id() {
        return this._pointId;
      }
      static equalPoint(p1, p2) {
        return (p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y) + (p1.z - p2.z) * (p1.z - p2.z) < Navi3DConst.POWER_EPSILON;
      }
      static calcDistance(pt1, pt2) {
        Navi3DPoint.CALC_VECTOR3D3.setTo(pt1.x - pt2.x, pt1.y - pt2.y, pt1.z - pt2.z);
        return Navi3DPoint.CALC_VECTOR3D3.length;
      }
    }

    class Navi3DAstar {
      _openedList;
      _closedList;
      _endNode;
      _startNode;
      _triangleChannel;
      _navMesh;
      _findIndex = 0;
      constructor() {
        this._openedList = new Array();
        this._closedList = new Array();
      }
      findPath(navMesh, startTriangle, endTriangle) {
        this._findIndex++;
        this._navMesh = navMesh;
        this._startNode = startTriangle;
        this._endNode = endTriangle;
        this._openedList.length = 0;
        this._closedList.length = 0;
        if (this._startNode && this._endNode) {
          this._startNode.gg = 0;
          this._startNode.h = 0;
          this._startNode.f = 0;
          this._startNode.parent = null;
          return this.search();
        }
        return false;
      }
      search() {
        var node = this._startNode;
        var neibours = [];
        var test;
        while (node != this._endNode) {
          neibours = node.getNeibourTriangles(neibours, Navi3DMaskType.WalkAble, Navi3DMaskType.WalkAble);
          for (test of neibours) {
            if (test.closeId == this._findIndex)
              continue;
            if (test == node || !test.walkAble) {
              continue;
            }
            var g = node.gg + Navi3DPoint.calcDistance(test, node) * test.costMultiplier;
            var h = Navi3DPoint.calcDistance(test, this._endNode);
            var f = g + h;
            if (test.openId == this._findIndex) {
              if (test.f > f) {
                test.f = f;
                test.gg = g;
                test.h = h;
                test.parent = node;
              }
            } else {
              test.f = f;
              test.gg = g;
              test.h = h;
              test.parent = node;
              test.openId = this._findIndex;
              this._openedList.push(test);
            }
          }
          node.closeId = this._findIndex;
          this._closedList.push(node);
          if (this._openedList.length == 0) {
            return false;
          }
          this._openedList.sort(function(a, b) {
            return a.f - b.f;
          });
          node = this._openedList.shift();
        }
        this.buildPath();
        return true;
      }
      buildPath() {
        this._triangleChannel = [];
        var node = this._endNode;
        this._triangleChannel.push(node);
        while (node != this._startNode) {
          node = node.parent;
          this._triangleChannel.unshift(node);
        }
      }
      get channel() {
        return this._triangleChannel;
      }
    }

    class Navi3DPointFat extends Navi3DPoint {
      _ownerPoint;
      _ownerEdge;
      radius = 0;
      constructor(_point, _edge) {
        super(_point.id, 0, 0, 0);
        this._ownerEdge = _edge;
        this._ownerPoint = _point;
      }
      get ownerPoint() {
        return this._ownerPoint;
      }
      get ownerEdge() {
        return this._ownerEdge;
      }
      scalePoint(value = 0.7) {
        var point = new Navi3DPointFat(this._ownerPoint, this._ownerEdge);
        point.copy(this);
        point.decrementBy(this._ownerPoint);
        point.multiplyScalar(value);
        point.radius = point.length;
        point.incrementBy(this._ownerPoint);
        return point;
      }
    }

    class Navi3DEdge {
      _edgeMask = 0;
      _edgeSize = 0;
      _pointA;
      _pointB;
      _triangleOwners;
      _centerPoint;
      _edgeDirA2B;
      crossPoint;
      fatPointA;
      fatPointB;
      static CALC_FAT_VECTOR = new Vector3();
      constructor(point0, point1) {
        this._pointA = point0;
        this._pointB = point1;
        if (point0.id >= point1.id) {
          throw new Error("edge point order error!!!");
        }
        this._triangleOwners = new Array();
        this._centerPoint = new Vector3();
        this._edgeMask = Navi3DMaskType.WalkAble;
        Navi3DPoint.CALC_VECTOR3D1.setTo(point0.x - point1.x, point0.y - point1.y, point0.z - point1.z);
        this._edgeSize = Navi3DPoint.CALC_VECTOR3D1.length;
        this._centerPoint.setTo((point0.x + point1.x) / 2, (point0.y + point1.y) / 2, (point0.z + point1.z) / 2);
      }
      get size() {
        return this._edgeSize;
      }
      get triangleOwners() {
        return this._triangleOwners;
      }
      get centerPoint() {
        return this._centerPoint;
      }
      initFatPoints(radius) {
        this._edgeDirA2B = this._pointB.clone().sub(this._pointA);
        this._edgeDirA2B.normalize();
        this.fatPointA = this.fatPointA || new Navi3DPointFat(this._pointA, this);
        this.fatPointB = this.fatPointB || new Navi3DPointFat(this._pointB, this);
        if (this.fatPointA.radius != radius) {
          Navi3DEdge.CALC_FAT_VECTOR.copy(this._edgeDirA2B);
          Navi3DEdge.CALC_FAT_VECTOR.multiplyScalar(radius);
          Navi3DEdge.CALC_FAT_VECTOR.incrementBy(this._pointA);
          this.fatPointA.copy(Navi3DEdge.CALC_FAT_VECTOR);
          this.fatPointA.radius = radius;
        }
        if (this.fatPointB.radius != radius) {
          Navi3DEdge.CALC_FAT_VECTOR.copy(this._edgeDirA2B);
          Navi3DEdge.CALC_FAT_VECTOR.multiplyScalar(-radius);
          Navi3DEdge.CALC_FAT_VECTOR.incrementBy(this._pointB);
          this.fatPointB.copy(Navi3DEdge.CALC_FAT_VECTOR);
          this.fatPointB.radius = radius;
        }
      }
      getFatPoint(pt) {
        if (pt == this._pointA)
          return this.fatPointA;
        return this.fatPointB;
      }
      getAnotherFatPoint(pt) {
        if (pt == this._pointA)
          return this.fatPointB;
        return this.fatPointA;
      }
      getAnotherPoint(pt) {
        if (pt == this._pointA)
          return this._pointB;
        return this._pointA;
      }
      containsPoint(pt) {
        if (Navi3DPoint.equalPoint(pt, this._pointA))
          return this._pointA;
        if (Navi3DPoint.equalPoint(pt, this._pointB))
          return this._pointB;
        return null;
      }
      addTriangleOwners(triangle) {
        if (triangle.edges.indexOf(this) == -1) {
          throw new Error("the edge is not belong triangle!!!");
        }
        if (this._triangleOwners.indexOf(triangle) == -1) {
          this._triangleOwners.push(triangle);
        }
      }
      getPublicPoint(edge) {
        if (this._pointA == edge._pointA || this._pointA == edge._pointB) {
          return this._pointA;
        } else if (this._pointB == edge._pointA || this._pointB == edge._pointB) {
          return this._pointB;
        }
        return null;
      }
      getEqualPoint(p) {
        if (Navi3DPoint.equalPoint(p, this._pointA))
          return this._pointA;
        if (Navi3DPoint.equalPoint(p, this._pointB))
          return this._pointB;
        return null;
      }
      get pointA() {
        return this._pointA;
      }
      get pointB() {
        return this._pointB;
      }
      get walkAble() {
        return (this._edgeMask & Navi3DMaskType.WalkAble) == Navi3DMaskType.WalkAble;
      }
      testMask(value) {
        return (this._edgeMask & value) == value;
      }
    }

    class Navi3DRouter {
      endPoint;
      curPoint;
      rayA;
      rayB;
      rayAPoint;
      rayBPoint;
      static RAY_1 = new Vector3();
      static RAY_2 = new Vector3();
      static TEST_RAY = new Vector3();
      static TEST_RAY_1 = new Vector3();
      static TEST_RAY_2 = new Vector3();
      static CALC_CROSS_POINT = new Vector3();
      static CALC_CROSS_TEST = new Vector3();
      cornerPoint;
      cornerEdge;
      continuePass(fromPt, endPt, fromEdge) {
        this.resetData();
        this.curPoint = fromPt;
        this.endPoint = endPt;
        this.cornerEdge = fromEdge;
      }
      passEdge(commonEdge, nextCommonEdge, targetPoint, lastEdge) {
        if (this.rayA == null || this.rayB == null) {
          this.rayA = Navi3DRouter.RAY_1;
          this.rayB = Navi3DRouter.RAY_2;
          this.rayAPoint = commonEdge.pointA;
          this.rayBPoint = commonEdge.pointB;
          this.rayA.setTo(this.rayAPoint.x - this.curPoint.x, 0, this.rayAPoint.z - this.curPoint.z);
          this.rayB.setTo(this.rayBPoint.x - this.curPoint.x, 0, this.rayBPoint.z - this.curPoint.z);
        }
        if (lastEdge) {
          return this.checkEndPoint(targetPoint);
        }
        Navi3DRouter.TEST_RAY.setTo(targetPoint.x - this.curPoint.x, 0, targetPoint.z - this.curPoint.z);
        if (this.isPointAtCenter(Navi3DRouter.TEST_RAY, this.rayA, this.rayB)) {
          if (!this.hasCrossPoint(nextCommonEdge.pointA, nextCommonEdge.pointB, this.rayAPoint, this.rayA)) {
            this.rayA.copy(Navi3DRouter.TEST_RAY);
            if (targetPoint instanceof Navi3DPoint) {
              this.rayAPoint = targetPoint;
            } else {
              this.rayAPoint = null;
            }
          } else {
            this.rayB.copy(Navi3DRouter.TEST_RAY);
            if (targetPoint instanceof Navi3DPoint) {
              this.rayBPoint = targetPoint;
            } else {
              this.rayBPoint = null;
            }
          }
          var anotherPoint = nextCommonEdge.getAnotherPoint(targetPoint);
          Navi3DRouter.TEST_RAY.setTo(anotherPoint.x - this.curPoint.x, 0, anotherPoint.z - this.curPoint.z);
          if (anotherPoint == this.rayAPoint || anotherPoint == this.rayBPoint || this.isPointAtCenter(Navi3DRouter.TEST_RAY, this.rayA, this.rayB)) {
            this.cornerEdge = nextCommonEdge;
          }
        } else {
          var needReturn;
          Navi3DRouter.TEST_RAY_1.copy(nextCommonEdge.pointA);
          Navi3DRouter.TEST_RAY_1.decrementBy(this.curPoint);
          Navi3DRouter.TEST_RAY_2.copy(nextCommonEdge.pointB);
          Navi3DRouter.TEST_RAY_2.decrementBy(this.curPoint);
          Navi3DRouter.TEST_RAY_1.y = 0;
          Navi3DRouter.TEST_RAY_2.y = 0;
          if (this.isPointAtCenter(this.rayA, Navi3DRouter.TEST_RAY_1, Navi3DRouter.TEST_RAY_2) || this.isPointAtCenter(this.rayB, Navi3DRouter.TEST_RAY_1, Navi3DRouter.TEST_RAY_2)) {
            needReturn = false;
          } else {
            needReturn = true;
          }
          if (needReturn) {
            if (this.isPointAtCenter(this.rayA, Navi3DRouter.TEST_RAY, this.rayB)) {
              this.cornerPoint = this.rayAPoint;
            } else {
              this.cornerPoint = this.rayBPoint;
            }
            this.cornerEdge.crossPoint = this.cornerPoint;
            return false;
          }
        }
        return true;
      }
      checkEndPoint(targetPoint) {
        Navi3DRouter.TEST_RAY.setTo(targetPoint.x - this.curPoint.x, 0, targetPoint.z - this.curPoint.z);
        if (this.isPointAtCenter(Navi3DRouter.TEST_RAY, this.rayA, this.rayB)) ; else {
          if (this.isPointAtCenter(this.rayA, Navi3DRouter.TEST_RAY, this.rayB)) {
            this.cornerPoint = this.rayAPoint;
          } else {
            this.cornerPoint = this.rayBPoint;
          }
          this.cornerEdge.crossPoint = this.cornerPoint;
          return false;
        }
        return true;
      }
      calcCrossEdge(_edge, linePoint, lineDirection) {
        return this.calcCrossPoint(_edge.fatPointA, _edge.fatPointB, linePoint, lineDirection);
      }
      calcCrossPoint(segmentPt1, segmentPt2, linePoint, lineDirection) {
        Navi3DRouter.CALC_CROSS_POINT.copy(segmentPt2);
        Navi3DRouter.CALC_CROSS_POINT.decrementBy(segmentPt1);
        let distance = Navi3DRouter.CALC_CROSS_POINT.x * lineDirection.z - lineDirection.x * Navi3DRouter.CALC_CROSS_POINT.z;
        var scale = 0;
        if (distance != 0) {
          scale = ((segmentPt1.z - linePoint.z) * lineDirection.x - (segmentPt1.x - linePoint.x) * lineDirection.z) / distance;
        }
        if (scale > 1) {
          scale = 1;
        } else if (scale < 0) {
          scale = 0;
        }
        Navi3DRouter.CALC_CROSS_POINT.multiplyScalar(scale);
        Navi3DRouter.CALC_CROSS_POINT.incrementBy(segmentPt1);
        return Navi3DRouter.CALC_CROSS_POINT.clone();
      }
      calcCrossPointOut(segmentPt1, segmentPt2, linePoint, lineDirection) {
        Navi3DRouter.CALC_CROSS_POINT.copy(segmentPt2);
        Navi3DRouter.CALC_CROSS_POINT.decrementBy(segmentPt1);
        var scale = ((segmentPt1.z - linePoint.z) * lineDirection.x - (segmentPt1.x - linePoint.x) * lineDirection.z) / (Navi3DRouter.CALC_CROSS_POINT.x * lineDirection.z - lineDirection.x * Navi3DRouter.CALC_CROSS_POINT.z);
        if (scale <= 1 && scale >= 0) {
          return null;
        }
        Navi3DRouter.CALC_CROSS_POINT.multiplyScalar(scale);
        Navi3DRouter.CALC_CROSS_POINT.incrementBy(segmentPt1);
        return Navi3DRouter.CALC_CROSS_POINT.clone();
      }
      hasCrossPoint(segmentPt1, segmentPt2, linePoint, lineDirection) {
        Navi3DRouter.CALC_CROSS_TEST.copy(segmentPt2);
        Navi3DRouter.CALC_CROSS_TEST.decrementBy(segmentPt1);
        var scale = ((segmentPt1.z - linePoint.z) * lineDirection.x - (segmentPt1.x - linePoint.x) * lineDirection.z) / (Navi3DRouter.CALC_CROSS_TEST.x * lineDirection.z - lineDirection.x * Navi3DRouter.CALC_CROSS_TEST.z);
        return scale <= 1 && scale >= 0;
      }
      isPointAtCenter(point, vectorA, vectorB) {
        var cp1 = vectorA.clone().cross(point);
        if (cp1.length == 0 && point.length < vectorA.length) {
          return true;
        }
        var cp2 = vectorB.clone().cross(point);
        if (cp2.length == 0 && point.length < vectorB.length) {
          return true;
        }
        cp1.normalize();
        cp2.normalize();
        cp1.incrementBy(cp2);
        return cp1.length < 0.01;
      }
      resetData() {
        this.cornerEdge = null;
        this.cornerPoint = null;
        this.curPoint = null;
        this.rayA = this.rayB = null;
        this.rayAPoint = this.rayBPoint = null;
        Navi3DRouter.RAY_1.setTo(0, 0, 0);
        Navi3DRouter.RAY_2.setTo(0, 0, 0);
      }
    }

    class Navi3DFunnel {
      _aiRadius = 0;
      _router;
      _result;
      _tempPublicEdgeList = new Array();
      _tempSamePlaneList = new Array();
      static CROSS_TEST_DIRECTION = new Vector3();
      constructor() {
        this._router = new Navi3DRouter();
      }
      searchPath(startPt, endPt, triangleList, radius = 0) {
        if (radius <= 0)
          radius = 1;
        this._aiRadius = radius * 1.5;
        if (!this.searchEnable(startPt, endPt, triangleList))
          return false;
        this.search(startPt, endPt, triangleList);
        return true;
      }
      get path() {
        return this._result;
      }
      searchEnable(startPt, endPt, triangleList) {
        if (startPt == null || endPt == null || triangleList == null)
          return false;
        if (triangleList[0].plane.classifyPoint(startPt, Navi3DConst.EPSILON) != PlaneClassification.INTERSECT) {
          return false;
        }
        if (triangleList[triangleList.length - 1].plane.classifyPoint(endPt, Navi3DConst.EPSILON) != PlaneClassification.INTERSECT) {
          return false;
        }
        return true;
      }
      search(startPt, endPt, triangleList) {
        this._tempPublicEdgeList.length = 0;
        this._tempSamePlaneList.length = 0;
        var i = 0;
        var crossedEdgeCount = triangleList.length - 1;
        var tr;
        var curEdge;
        var pt;
        var plane;
        for (i = 0; i < crossedEdgeCount; i++) {
          curEdge = triangleList[i].getPublicEdge(triangleList[i + 1]);
          curEdge.crossPoint = null;
          curEdge.initFatPoints(this._aiRadius);
          this._tempPublicEdgeList.push(curEdge);
          tr = triangleList[i];
          plane = tr.plane;
          tr = triangleList[i + 1];
          pt = tr.getEdgeAgainstPoint(curEdge);
          this._tempSamePlaneList.push(plane.classifyPoint(pt, Navi3DConst.EPSILON) == PlaneClassification.INTERSECT);
        }
        this._router.continuePass(startPt, endPt, this._tempPublicEdgeList[0]);
        crossedEdgeCount = this._tempPublicEdgeList.length;
        var cornerPoint;
        var cornerEdge;
        var continuePass;
        var lastEdge;
        for (i = 0; i < crossedEdgeCount; i++) {
          curEdge = this._tempPublicEdgeList[i];
          tr = triangleList[i + 1];
          lastEdge = i == crossedEdgeCount - 1;
          if (lastEdge) {
            pt = endPt;
          } else {
            pt = tr.getEdgeAgainstPoint(curEdge);
          }
          continuePass = this._router.passEdge(curEdge, this._tempPublicEdgeList[i + 1], pt, lastEdge);
          if (!continuePass) {
            cornerPoint = this._router.cornerPoint;
            cornerEdge = this._router.cornerEdge;
            i = this._tempPublicEdgeList.indexOf(cornerEdge);
            this._router.continuePass(cornerPoint, endPt, this._tempPublicEdgeList[i + 1]);
          }
        }
        this.pushAllPathPoint2(startPt, endPt);
        if (this._result.length >= 3) {
          this.optimusTerminusFat();
          this.optimusByRadius();
        }
        let list = [];
        for (let point of this._result) {
          list.push(new Vector3().copy(point));
        }
        this._result = list;
      }
      optimusTerminusFat() {
        var startFat;
        var endFat;
        var pt;
        pt = this._result[1];
        if (pt instanceof Navi3DPointFat) {
          startFat = pt;
        }
        pt = this._result[this._result.length - 2];
        if (pt instanceof Navi3DPointFat) {
          endFat = pt;
        }
        if (startFat) {
          this._result[1] = startFat.scalePoint();
        }
        if (endFat && startFat != endFat) {
          this._result[this._result.length - 2] = endFat.scalePoint();
        }
      }
      pushAllPathPoint2(startPt, endPt) {
        var crossedEdgeCount = this._tempPublicEdgeList.length;
        var curEdge;
        var curEdgeJ;
        this._result = new Array();
        this._result.push(startPt);
        var fromPoint = startPt;
        var toPoint;
        var fatPoint;
        var crossPoint;
        for (var i = 0; i < crossedEdgeCount; i++) {
          curEdge = this._tempPublicEdgeList[i];
          fatPoint = null;
          if (curEdge.crossPoint) {
            fatPoint = this.getFatPoint(curEdge, curEdge.crossPoint);
            if (fatPoint) {
              this._result.push(fatPoint);
            } else {
              this._result.push(curEdge.crossPoint);
            }
            fromPoint = curEdge.crossPoint;
          } else {
            curEdgeJ = null;
            toPoint = null;
            for (var j = i + 1; j < crossedEdgeCount; j++) {
              curEdgeJ = this._tempPublicEdgeList[j];
              toPoint = curEdgeJ.crossPoint;
              if (toPoint) {
                break;
              }
            }
            if (toPoint == null) {
              toPoint = endPt;
            }
            fatPoint = this.getFatPoint(curEdge, toPoint);
            if (fatPoint) {
              this._result.push(fatPoint);
            } else {
              if (toPoint == fromPoint) {
                crossPoint = toPoint.clone();
              } else {
                Navi3DFunnel.CROSS_TEST_DIRECTION.setTo(toPoint.x - fromPoint.x, 0, toPoint.z - fromPoint.z);
                crossPoint = this._router.calcCrossEdge(curEdge, fromPoint, Navi3DFunnel.CROSS_TEST_DIRECTION);
              }
              this._result.push(crossPoint);
            }
          }
        }
        this._result.push(endPt);
      }
      optimusByRadius() {
        var optimusResult = new Array();
        optimusResult.length = this._result.length;
        var count = this._result.length - 2;
        var pt0;
        var pt1;
        var pt2;
        var fatPt0;
        var fatPt1;
        var fatPt2;
        var edgePt0;
        var edgePt1;
        var edgePt2;
        var centerEdge;
        var checkEnable;
        var optimusPoint;
        var i;
        for (i = 0; i < count; i++) {
          edgePt0 = edgePt1 = edgePt2 = null;
          fatPt0 = fatPt1 = fatPt2 = null;
          checkEnable = false;
          optimusPoint = null;
          pt0 = this._result[i];
          pt1 = this._result[i + 1];
          pt2 = this._result[i + 2];
          if (pt0 instanceof Navi3DPointFat) {
            fatPt0 = pt0;
          }
          if (pt1 instanceof Navi3DPointFat) {
            fatPt1 = pt1;
          }
          if (pt2 instanceof Navi3DPointFat) {
            fatPt2 = pt2;
          }
          if (fatPt0) {
            edgePt0 = fatPt0.ownerPoint;
          }
          if (fatPt1) {
            edgePt1 = fatPt1.ownerPoint;
          }
          if (fatPt2) {
            edgePt2 = fatPt2.ownerPoint;
          }
          if (edgePt0 && edgePt1 && edgePt0 == edgePt1 && edgePt1 != edgePt2) {
            checkEnable = true;
          }
          if (edgePt2 && edgePt1 && edgePt2 == edgePt1 && edgePt0 != edgePt1) {
            checkEnable = true;
          }
          if (checkEnable) {
            Navi3DFunnel.CROSS_TEST_DIRECTION.copy(pt0);
            Navi3DFunnel.CROSS_TEST_DIRECTION.decrementBy(pt2);
            centerEdge = fatPt1.ownerEdge;
            checkEnable = this._router.hasCrossPoint(centerEdge.pointA, centerEdge.pointB, pt2, Navi3DFunnel.CROSS_TEST_DIRECTION);
            if (checkEnable) {
              optimusPoint = this._router.calcCrossPointOut(edgePt1, pt1, pt2, Navi3DFunnel.CROSS_TEST_DIRECTION);
            }
            if (optimusPoint) {
              optimusResult[i + 1] = optimusPoint;
            }
          }
        }
      }
      getFatPoint(edge, target) {
        if (edge == null)
          return null;
        var fatPoint;
        if (target instanceof Navi3DPointFat) {
          fatPoint = target;
        }
        var edgePoint;
        if (fatPoint) {
          edgePoint = fatPoint.ownerPoint;
        } else {
          edgePoint = edge.getEqualPoint(target);
        }
        if (edgePoint == null)
          return null;
        fatPoint = edge.getFatPoint(edgePoint);
        return fatPoint;
      }
    }

    class Navi3DMergeVertex {
      /** The vertex positions extracted from the source geometry. */
      vertex;
      /** The (possibly remapped) triangle indices into {@link vertex}. */
      indices;
      /** Extracts vertices and indices from the geometry, merging vertices closer than the given threshold. */
      merge(geometry, threshould = 0.1) {
        let vertex = geometry.getAttribute(VertexAttributeName.position).data;
        this.makeOriginVertex(vertex);
        let sameVertexIndex = /* @__PURE__ */ new Map();
        let redirectionIndex = [];
        for (let i = 0, c = this.vertex.length; i < c; i++) {
          let item = this.vertex[i];
          let samePointIndex = -1;
          sameVertexIndex.forEach((v, i2) => {
            let distance = Vector3.distance(v, item);
            if (distance < threshould) {
              samePointIndex = i2;
            }
          });
          if (samePointIndex > -1) {
            redirectionIndex[i] = samePointIndex;
          } else {
            sameVertexIndex.set(i, item);
            redirectionIndex[i] = i;
          }
        }
        this.indices = [];
        let indices = geometry.getAttribute(VertexAttributeName.indices).data;
        for (const i of indices) {
          this.indices.push(redirectionIndex[i]);
        }
        return this;
      }
      /** Extracts vertices and indices from the geometry without merging any vertices. */
      parse(geometry) {
        let vertex = geometry.getAttribute(VertexAttributeName.position).data;
        this.makeOriginVertex(vertex);
        this.indices = [];
        let indices = geometry.getAttribute(VertexAttributeName.indices).data;
        for (const i of indices) {
          this.indices.push(i);
        }
        return this;
      }
      makeOriginVertex(source) {
        this.vertex = [];
        for (let i = 0, c = source.length / 3; i < c; i++) {
          let v = new Vector3(source[i * 3], source[i * 3 + 1], source[i * 3 + 2]);
          this.vertex.push(v);
        }
      }
    }

    class Navi3DTriangle extends Vector3 {
      _id = 0;
      _plane;
      _points = new Array();
      _edges = new Array();
      _neibourTriangles = new DoubleArray();
      _pointAgainstEdge = new DoubleArray();
      _edgeAgainstPoint = new DoubleArray();
      _mask = 0;
      _aabbBox;
      f = 0;
      gg = 0;
      h = 0;
      parent;
      costMultiplier = 1;
      openId = 0;
      closeId = 0;
      get aabb() {
        return this._aabbBox;
      }
      initAABB() {
        this._aabbBox = new QuadAABB();
        this._aabbBox.addPoint(this._points[0]);
        this._aabbBox.addPoint(this._points[1]);
        this._aabbBox.addPoint(this._points[2]);
      }
      calcGlobalQuadAABB() {
      }
      get isTriangle() {
        return true;
      }
      constructor(Id, edgeA, edgeB, edgeC) {
        super(0, 0, 0, 0);
        this._id = Id;
        this._mask = Navi3DMaskType.WalkAble;
        this._edges.push(edgeA, edgeB, edgeC);
        var edge;
        for (edge of this._edges) {
          if (this._points.indexOf(edge.pointA) == -1) {
            this._points.push(edge.pointA);
          }
          if (this._points.indexOf(edge.pointB) == -1) {
            this._points.push(edge.pointB);
          }
        }
        this.x = (this._points[0].x + this._points[1].x + this._points[2].x) / 3;
        this.y = (this._points[0].y + this._points[1].y + this._points[2].y) / 3;
        this.z = (this._points[0].z + this._points[1].z + this._points[2].z) / 3;
        this._plane = new Plane3D();
        this._plane.fromPoints(this._points[0], this._points[1], this._points[2]);
        this._plane.normalize();
        this.genarateAgainstData();
        this.initAABB();
      }
      genarateAgainstData() {
        var edge;
        var point;
        for (edge of this._edges) {
          for (point of this._points) {
            if (edge.pointA != point && edge.pointB != point) {
              this._edgeAgainstPoint.put(edge, point);
              this._pointAgainstEdge.put(point, edge);
            }
          }
        }
      }
      get id() {
        return this._id;
      }
      get plane() {
        return this._plane;
      }
      get points() {
        return this._points;
      }
      addNeibour(edge, triangle) {
        if (this._edges.indexOf(edge) >= 0) {
          this._neibourTriangles.put(edge, triangle);
        } else {
          throw new Error("the edge is not in triangle!!!");
        }
      }
      getNeibourTriangles(list = null, edgeMask = 1, triangleMask = 1) {
        list = list || new Array();
        list.length = 0;
        var neibour;
        var edge;
        var keys = this._neibourTriangles.getKeys();
        var obj;
        for (obj of keys) {
          edge = obj;
          if (edge.testMask(edgeMask)) {
            neibour = this._neibourTriangles.getValueByKey(edge);
            if (neibour.testMask(triangleMask)) {
              list.push(neibour);
            }
          }
        }
        return list;
      }
      getEdges(list = null, edgeMask = 1) {
        list = list || new Array();
        list.length = 0;
        var edge;
        for (edge of this._edges) {
          if (edge.testMask(edgeMask)) {
            list.push(edge);
          }
        }
        return list;
      }
      get walkAble() {
        return this.testMask(Navi3DMaskType.WalkAble);
      }
      get edges() {
        return this._edges;
      }
      testMask(value) {
        return (this._mask & value) == value;
      }
      getEdgeAgainstPoint(edge) {
        return this._edgeAgainstPoint.getValueByKey(edge);
      }
      getPointAgainstEdge(point) {
        return this._pointAgainstEdge.getValueByKey(point);
      }
      getPublicEdge(triangle) {
        if (triangle && triangle != this) {
          var keys = this._neibourTriangles.getKeys();
          var obj;
          for (obj of keys) {
            if (this._neibourTriangles.getValueByKey(obj) == triangle)
              return obj;
          }
        }
        return null;
      }
      loopPublicEdge(triangle) {
        var edgeA;
        var edgeB;
        if (triangle && triangle != this) {
          for (edgeA of this._edges) {
            for (edgeB of triangle._edges) {
              if (edgeA == edgeB)
                return edgeA;
            }
          }
        }
        return null;
      }
      randomPoint() {
        var pt0 = this._points[2].clone().sub(this._points[0]);
        {
          pt0.multiplyScalar(Math.random());
        }
        pt0.incrementBy(this._points[0]);
        var pt1 = this._points[1].clone().sub(pt0);
        {
          pt1.multiplyScalar(Math.random());
        }
        pt1.incrementBy(pt0);
        return pt1;
      }
    }

    class Navi3DMesh {
      _nav3dPoints;
      _nav3dEdges;
      _nav3dTriangles;
      _path;
      _edgesDict;
      _nav3dAstar;
      _nav3dFunnel;
      _terrainQuad;
      _triangleList;
      /** The edges that make up this navigation mesh. */
      get edges() {
        return this._nav3dEdges;
      }
      /** The points (vertices) that make up this navigation mesh. */
      get points() {
        return this._nav3dPoints;
      }
      /** The path computed by the most recent {@link findPath} call. */
      get path() {
        return this._path;
      }
      /** The triangles that make up this navigation mesh. */
      get triangles() {
        return this._nav3dTriangles;
      }
      /** Creates a navigation mesh from a list of points and triangle index lists. */
      constructor(pointList, triangleIndexList) {
        this._nav3dPoints = new Array();
        this._nav3dEdges = new Array();
        this._nav3dTriangles = new Array();
        this._edgesDict = new DoubleArray();
        this.initPoints(pointList);
        this.initEdgesAndTriangles(triangleIndexList);
        this.createConnections();
        this._nav3dAstar = new Navi3DAstar();
        this._nav3dFunnel = new Navi3DFunnel();
        this._terrainQuad = new QuadRoot(8, 128);
        this._terrainQuad.createQuadTree(this._nav3dTriangles);
      }
      /** Returns the triangle located at the given point within the given threshold. */
      getTriangleAtPoint(point, threshold = 5) {
        return this._terrainQuad.getTriangleAtPoint(point, threshold);
      }
      /** Finds a path between two points for an agent of the given radius; returns whether a path was found. */
      findPath(startPt, endPt, aiRadius = 5) {
        this._path = null;
        this._triangleList = null;
        var startNode = this.getTriangleAtPoint(startPt, 10);
        var endNode = this.getTriangleAtPoint(endPt, 10);
        var success = this._nav3dAstar.findPath(this, startNode, endNode);
        if (success) {
          this._triangleList = this._nav3dAstar.channel;
          success = this._nav3dFunnel.searchPath(startPt, endPt, this._triangleList, aiRadius);
          this._path = this._nav3dFunnel.path;
          return success;
        }
        return false;
      }
      initPoints(pointList) {
        var point;
        var nevPoint;
        var count = pointList.length;
        for (var i = 0; i < count; i++) {
          point = pointList[i];
          nevPoint = new Navi3DPoint(i, point.x, point.y, point.z);
          this._nav3dPoints.push(nevPoint);
        }
      }
      initEdgesAndTriangles(triangleIndexList) {
        var indexOrderList;
        var edge0;
        var edge1;
        var edge2;
        var triangle;
        var count = triangleIndexList.length;
        for (var i = 0; i < count; i++) {
          indexOrderList = triangleIndexList[i];
          edge0 = this.tryCreateEdge(indexOrderList[0], indexOrderList[1]);
          edge1 = this.tryCreateEdge(indexOrderList[1], indexOrderList[2]);
          edge2 = this.tryCreateEdge(indexOrderList[2], indexOrderList[0]);
          if (edge0 == null || edge1 == null || edge2 == null)
            continue;
          triangle = new Navi3DTriangle(i, edge0, edge1, edge2);
          this._nav3dTriangles.push(triangle);
        }
      }
      tryCreateEdge(pointAId, pointBId) {
        if (pointAId == pointBId) {
          return null;
        }
        if (pointAId > pointBId) {
          var tempId = pointAId;
          pointAId = pointBId;
          pointBId = tempId;
        }
        var edge = this._edgesDict.getValueByKey(pointAId + "_" + pointBId);
        if (edge == null) {
          edge = new Navi3DEdge(this._nav3dPoints[pointAId], this._nav3dPoints[pointBId]);
          this._nav3dEdges.push(edge);
          this._edgesDict.put(pointAId + "_" + pointBId, edge);
        }
        return edge;
      }
      createConnections() {
        var triangleACount = this._nav3dTriangles.length;
        var triangleBCount = this._nav3dTriangles.length;
        var triangleA;
        var triangleB;
        var edge;
        var publicEdge;
        for (var i = 0; i < triangleACount; i++) {
          triangleA = this._nav3dTriangles[i];
          for (edge of triangleA.edges) {
            edge.addTriangleOwners(triangleA);
          }
          for (var j = 0; j < triangleBCount; j++) {
            triangleB = this._nav3dTriangles[j];
            if (triangleA == triangleB)
              continue;
            publicEdge = triangleA.loopPublicEdge(triangleB);
            if (publicEdge) {
              triangleA.addNeibour(publicEdge, triangleB);
              triangleB.addNeibour(publicEdge, triangleA);
            }
          }
        }
      }
    }

    class Navi3DPoint2D {
      x;
      y;
      setTo(X, Y) {
        this.x = X;
        this.y = Y;
      }
      equals(X, Y) {
        return X == this.x && Y == this.y;
      }
      equalPoint(pt) {
        return this.equals(pt.x, pt.y);
      }
      get length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
      }
      clone() {
        var point = new Navi3DPoint2D();
        point.setTo(this.x, this.y);
        return point;
      }
      normalize() {
        var size = length;
        if (size == 0)
          return;
        this.setTo(this.x / size, this.y / size);
      }
    }

    class BoxGeometry extends GeometryBase {
      /**
       * box width
       */
      width;
      /**
       * box height
       */
      height;
      /**
       * box depth
       */
      depth;
      /**
       *
       * @constructor
       * @param width {number} box width, default value is 1
       * @param height {number} box height, default value is 1
       * @param depth {number} box depth, default value is 1
       */
      constructor(width = 1, height = 1, depth = 1) {
        super();
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.initVertex();
      }
      initVertex() {
        let halfW = this.width / 2;
        let halfH = this.height / 2;
        let halfD = this.depth / 2;
        this.bounds = new BoundingBox(Vector3.ZERO.clone(), new Vector3(this.width, this.height, this.depth));
        let position_arr = new Float32Array([
          //up
          -halfW,
          halfH,
          halfD,
          halfW,
          halfH,
          halfD,
          halfW,
          halfH,
          -halfD,
          -halfW,
          halfH,
          -halfD,
          -halfW,
          halfH,
          halfD,
          halfW,
          halfH,
          -halfD,
          //buttom
          halfW,
          -halfH,
          halfD,
          -halfW,
          -halfH,
          halfD,
          -halfW,
          -halfH,
          -halfD,
          halfW,
          -halfH,
          -halfD,
          halfW,
          -halfH,
          halfD,
          -halfW,
          -halfH,
          -halfD,
          //left
          -halfW,
          -halfH,
          halfD,
          -halfW,
          halfH,
          halfD,
          -halfW,
          halfH,
          -halfD,
          -halfW,
          -halfH,
          -halfD,
          -halfW,
          -halfH,
          halfD,
          -halfW,
          halfH,
          -halfD,
          //right
          halfW,
          halfH,
          halfD,
          halfW,
          -halfH,
          halfD,
          halfW,
          -halfH,
          -halfD,
          halfW,
          halfH,
          -halfD,
          halfW,
          halfH,
          halfD,
          halfW,
          -halfH,
          -halfD,
          //front
          halfW,
          halfH,
          halfD,
          -halfW,
          halfH,
          halfD,
          -halfW,
          -halfH,
          halfD,
          -halfW,
          -halfH,
          halfD,
          halfW,
          -halfH,
          halfD,
          halfW,
          halfH,
          halfD,
          //back
          halfW,
          -halfH,
          -halfD,
          -halfW,
          -halfH,
          -halfD,
          -halfW,
          halfH,
          -halfD,
          halfW,
          halfH,
          -halfD,
          halfW,
          -halfH,
          -halfD,
          -halfW,
          halfH,
          -halfD
        ]);
        let normal_arr = new Float32Array([
          //up
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          //buttom
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          //left
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          //right
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          //front
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          0,
          0,
          1,
          //back
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1,
          0,
          0,
          -1
        ]);
        let uv_arr = new Float32Array([1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 0, 1, 1, 0, 1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 0]);
        let indices_arr = [0, 2, 1, 3, 5, 4, 6, 8, 7, 9, 11, 10, 12, 14, 13, 15, 17, 16, 18, 20, 19, 21, 23, 22, 24, 26, 25, 27, 29, 28, 30, 32, 31, 33, 35, 34];
        let indicesData = new Uint16Array(indices_arr.reverse());
        this.setIndices(indicesData);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indices_arr.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
      }
    }

    class CylinderGeometry extends GeometryBase {
      /**
       * The radius of the top of the cylinder
       */
      radiusTop;
      /**
       * The radius of the bottom of the cylinder
       */
      radiusBottom;
      /**
       * The height of the cylinder
       */
      height;
      /**
       * Number of segments around the side of the cylinder
       */
      radialSegments;
      /**
       * The number of segments along the height of the cylindrical side
       */
      heightSegments;
      /**
       * Indicate whether the bottom surface of the cone is open or capped. The default value is false, which means that the bottom surface is capped by default.
       */
      openEnded;
      /**
       * Starting angle of the first segment
       */
      thetaStart;
      /**
       * The center angle of the circular sector on the bottom of the cylinder, with a default value of 2 * PI, makes it a complete cylinder.
       */
      thetaLength;
      /**
       *
       * @constructor
       * @param radiusTop 
       * @param radiusBottom 
       * @param height 
       * @param radialSegments 
       * @param heightSegments 
       * @param openEnded 
       * @param thetaStart 
       * @param thetaLength
       */
      constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 8, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2) {
        super();
        this.radiusTop = radiusTop;
        this.radiusBottom = radiusBottom;
        this.height = height;
        this.radialSegments = radialSegments;
        this.heightSegments = heightSegments;
        this.openEnded = openEnded;
        this.thetaStart = thetaStart;
        this.thetaLength = thetaLength;
        this.instanceID = UUID();
        this.buildGeometry();
      }
      /**
       * @internal
       * @param start 
       * @param count 
       * @param index 
       */
      addGroup(start, count, index) {
        this.addSubGeometry({
          indexStart: start,
          indexCount: count,
          vertexStart: start,
          vertexCount: 0,
          firstStart: 0,
          index,
          topology: 0
        });
      }
      buildGeometry() {
        const that = this;
        this.radialSegments = Math.floor(this.radialSegments);
        this.heightSegments = Math.floor(this.heightSegments);
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        let index = 0;
        const indexArray = [];
        const halfHeight = this.height / 2;
        let groupStart = 0;
        generateTorso();
        if (this.openEnded === false) {
          if (this.radiusTop > 0) generateCap(true);
          if (this.radiusBottom > 0) generateCap(false);
        }
        let position_arr = new Float32Array(vertices);
        let normal_arr = new Float32Array(normals);
        let uv_arr = new Float32Array(uvs);
        let indices_arr = new Uint16Array(indices);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.setIndices(indices_arr);
        function generateTorso() {
          const normal = new Vector3();
          const vertex = new Vector3();
          let groupCount = 0;
          const slope = (that.radiusBottom - that.radiusTop) / that.height;
          for (let y = 0; y <= that.heightSegments; y++) {
            const indexRow = [];
            const v = y / that.heightSegments;
            const radius = v * (that.radiusBottom - that.radiusTop) + that.radiusTop;
            for (let x = 0; x <= that.radialSegments; x++) {
              const u = x / that.radialSegments;
              let theta = u * that.thetaLength + that.thetaStart;
              if (x == that.radialSegments && Math.abs(that.thetaLength - that.thetaStart) == Math.PI * 2) {
                theta = 0;
              }
              const sinTheta = Math.sin(theta);
              const cosTheta = Math.cos(theta);
              vertex.x = radius * sinTheta;
              vertex.y = -v * that.height + halfHeight;
              vertex.z = radius * cosTheta;
              vertices.push(vertex.x, vertex.y, vertex.z);
              normal.set(sinTheta, slope, cosTheta).normalize();
              normals.push(normal.x, normal.y, normal.z);
              uvs.push(u, 1 - v);
              indexRow.push(index++);
            }
            indexArray.push(indexRow);
          }
          for (let x = 0; x < that.radialSegments; x++) {
            for (let y = 0; y < that.heightSegments; y++) {
              const a = indexArray[y][x];
              const b = indexArray[y + 1][x];
              const c = indexArray[y + 1][x + 1];
              const d = indexArray[y][x + 1];
              indices.push(a, b, d);
              indices.push(b, c, d);
              groupCount += 6;
            }
          }
          that.addGroup(groupStart, groupCount, 0);
          groupStart += groupCount;
        }
        function generateCap(top) {
          const centerIndexStart = index;
          const uv = new Vector2();
          const vertex = new Vector3();
          let groupCount = 0;
          const radius = top === true ? that.radiusTop : that.radiusBottom;
          const sign = top === true ? 1 : -1;
          for (let x = 1; x <= that.radialSegments; x++) {
            vertices.push(0, halfHeight * sign, 0);
            normals.push(0, sign, 0);
            uvs.push(0.5, 0.5);
            index++;
          }
          const centerIndexEnd = index;
          for (let x = 0; x <= that.radialSegments; x++) {
            const u = x / that.radialSegments;
            const theta = u * that.thetaLength + that.thetaStart;
            const cosTheta = Math.cos(theta);
            const sinTheta = Math.sin(theta);
            vertex.x = radius * sinTheta;
            vertex.y = halfHeight * sign;
            vertex.z = radius * cosTheta;
            vertices.push(vertex.x, vertex.y, vertex.z);
            normals.push(0, sign, 0);
            uv.x = cosTheta * 0.5 + 0.5;
            uv.y = sinTheta * 0.5 * sign + 0.5;
            uvs.push(uv.x, uv.y);
            index++;
          }
          for (let x = 0; x < that.radialSegments; x++) {
            const c = centerIndexStart + x;
            const i = centerIndexEnd + x;
            if (top === true) {
              indices.push(i, i + 1, c);
            } else {
              indices.push(i + 1, i, c);
            }
            groupCount += 3;
          }
          that.addGroup(groupStart, groupCount, top === true ? 1 : 2);
          groupStart += groupCount;
        }
      }
    }

    class StripeGeometry extends GeometryBase {
      segments;
      /**
       *
       * @constructor
       * @param width Width of the plane
       * @param height Height of the plane
       * @param segmentW Number of width segments of a plane
       * @param segmentH Number of height segments of a plane
       * @param up Define the normal vector of a plane
       */
      constructor(segments) {
        super();
        this.segments = segments;
        this.buildGeometry();
      }
      buildGeometry() {
        this.bounds = new BoundingBox();
        let numIndices = (this.segments.length - 1) * 2 * 3;
        let vertexCount = this.segments.length * 2;
        let position_arr = new Float32Array(vertexCount * 3);
        let normal_arr = new Float32Array(vertexCount * 3);
        let uv_arr = new Float32Array(vertexCount * 2);
        let indices_arr = new Uint16Array(numIndices);
        let index = 0;
        for (let item of this.segments) {
          position_arr[index++] = item[0].x;
          position_arr[index++] = item[0].y;
          position_arr[index++] = item[0].z;
          position_arr[index++] = item[1].x;
          position_arr[index++] = item[1].y;
          position_arr[index++] = item[1].z;
        }
        index = 0;
        let offset = 0;
        while (index < numIndices) {
          indices_arr[index++] = 2 + offset;
          indices_arr[index++] = 1 + offset;
          indices_arr[index++] = 0 + offset;
          indices_arr[index++] = 1 + offset;
          indices_arr[index++] = 2 + offset;
          indices_arr[index++] = 3 + offset;
          offset += 2;
        }
        this.setIndices(indices_arr);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indices_arr.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
        this.computeNormals();
      }
    }

    class TorusGeometry extends GeometryBase {
      /**
       * Radius of torus
       */
      radius;
      /**
       * Pipe radius
       */
      tube;
      /**
       * Number of torus segments.
       */
      radialSegments;
      /**
       * Number of pipeline segments.
       */
      tubularSegments;
      /**
       *
       * @constructor
       * @param radius {number} Radius of torus, default value is 0.4
       * @param tube {number} Pipe radius, default value is 0.1.
       * @param radialSegments {number}Number of torus segments, default value is 32.
       * @param tubularSegments {number} Number of pipeline segments, defualt value is 32.
       */
      constructor(radius = 0.4, tube = 0.1, radialSegments = 32, tubularSegments = 32) {
        super();
        this.radius = radius;
        this.tube = tube;
        this.radialSegments = radialSegments;
        this.tubularSegments = tubularSegments;
        this.initVertex();
      }
      initVertex() {
        const arc = 2 * Math.PI;
        const radius = this.radius;
        const tube = this.tube;
        const radialSegments = this.radialSegments;
        const tubularSegments = this.tubularSegments;
        this.bounds = new BoundingBox(Vector3.ZERO.clone(), new Vector3(radius * 2, tube * 2, radius * 2));
        var vertexCount = (radialSegments + 1) * (tubularSegments + 1);
        let position_arr = new Float32Array(vertexCount * 3);
        let normal_arr = new Float32Array(vertexCount * 3);
        let uv_arr = new Float32Array(vertexCount * 2);
        let indicesData = new Uint16Array(radialSegments * tubularSegments * 2 * 3);
        let pi = 0;
        let ni = 0;
        let ui = 0;
        let triIndex = 0;
        for (let j = 0; j <= radialSegments; j++) {
          for (let i = 0; i <= tubularSegments; i++) {
            const u = i / tubularSegments;
            const v = j / radialSegments;
            const u1 = u * arc;
            const v1 = v * Math.PI * 2;
            position_arr[pi++] = (radius + tube * Math.cos(v1)) * Math.sin(u1);
            position_arr[pi++] = tube * Math.sin(v1);
            position_arr[pi++] = (radius + tube * Math.cos(v1)) * Math.cos(u1);
            normal_arr[ni++] = Math.sin(u1) * Math.cos(v1);
            normal_arr[ni++] = Math.sin(v1);
            normal_arr[ni++] = Math.cos(u1) * Math.cos(v1);
            uv_arr[ui++] = u;
            uv_arr[ui++] = v;
            if (i < tubularSegments && j < radialSegments) {
              const segment = tubularSegments + 1;
              const a = segment * j + i;
              const b = segment * (j + 1) + i;
              const c = segment * (j + 1) + i + 1;
              const d = segment * j + i + 1;
              indicesData[triIndex++] = a;
              indicesData[triIndex++] = d;
              indicesData[triIndex++] = b;
              indicesData[triIndex++] = d;
              indicesData[triIndex++] = c;
              indicesData[triIndex++] = b;
            }
          }
        }
        this.setIndices(indicesData);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indicesData.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
      }
    }

    class TrailGeometry extends GeometryBase {
      /**
       * Number of trail segments of a plane
       */
      segment;
      row = 0;
      /**
       *
       * @constructor
       */
      constructor(segment) {
        super();
        this.segment = segment;
        this.buildGeometry();
      }
      buildGeometry() {
        this.row = this.segment + 1;
        let indices_arr = new Uint32Array(this.segment * 6);
        let position_arr = new Float32Array(this.row * 3 * 2);
        let normal_arr = new Float32Array(this.row * 3 * 2);
        let uv_arr = new Float32Array(this.row * 2 * 2);
        for (let i = 0; i < this.row; i++) {
          position_arr[i * 3 * 2 + 0] = 0;
          position_arr[i * 3 * 2 + 1] = 0;
          position_arr[i * 3 * 2 + 2] = 0;
          position_arr[i * 3 * 2 + 3] = 0;
          position_arr[i * 3 * 2 + 4] = 0;
          position_arr[i * 3 * 2 + 5] = 0;
          normal_arr[i * 3 * 2 + 0] = 0;
          normal_arr[i * 3 * 2 + 1] = 0;
          normal_arr[i * 3 * 2 + 2] = 1;
          normal_arr[i * 3 * 2 + 3] = 0;
          normal_arr[i * 3 * 2 + 4] = 0;
          normal_arr[i * 3 * 2 + 5] = 1;
          uv_arr[i * 2 * 2 + 0] = 0;
          uv_arr[i * 2 * 2 + 1] = i / this.segment;
          uv_arr[i * 2 * 2 + 2] = 1;
          uv_arr[i * 2 * 2 + 3] = i / this.segment;
          let c = i * 2;
          let f0 = c;
          let f1 = c + 1;
          let f2 = c + 2;
          let f3 = c + 3;
          indices_arr[i * 6 + 0] = f0;
          indices_arr[i * 6 + 1] = f1;
          indices_arr[i * 6 + 2] = f2;
          indices_arr[i * 6 + 3] = f1;
          indices_arr[i * 6 + 4] = f3;
          indices_arr[i * 6 + 5] = f2;
        }
        this.setIndices(indices_arr);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indices_arr.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
      }
    }

    class TriGeometry extends GeometryBase {
      faceCount = 0;
      /**
       *
       * @constructor
       */
      constructor(count) {
        super();
        this.faceCount = count;
        this.geometryType = GeometryVertexType.compose;
        this.buildGeometry();
      }
      buildGeometry() {
        let indices_arr = new Uint32Array(this.faceCount * 3);
        let position_arr = new Float32Array(this.faceCount * 3 * 3);
        let normal_arr = new Float32Array(this.faceCount * 3 * 3);
        let uv_arr = new Float32Array(this.faceCount * 3 * 2);
        let meshIndexList = new Float32Array(this.faceCount * 3 * 1);
        for (let index = 0; index < this.faceCount; index++) {
          let i1 = index * 3 + 0;
          let i2 = index * 3 + 1;
          let i3 = index * 3 + 2;
          indices_arr[i1] = i1;
          indices_arr[i2] = i2;
          indices_arr[i3] = i3;
        }
        this.setIndices(indices_arr);
        this.setAttribute(VertexAttributeName.position, position_arr);
        this.setAttribute(VertexAttributeName.normal, normal_arr);
        this.setAttribute(VertexAttributeName.uv, uv_arr);
        this.setAttribute(VertexAttributeName.TEXCOORD_1, uv_arr);
        this.setAttribute(VertexAttributeName.vIndex, meshIndexList);
        this.addSubGeometry({
          indexStart: 0,
          indexCount: indices_arr.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
      }
    }

    class DepthCubeTexture extends Texture {
      /**
       * texture width, default value is 4
       */
      width = 4;
      /**
       * texture height, default value is 4
       */
      height = 4;
      /**
       * depth or array layers, default value is 6
       */
      depthOrArrayLayers = 6;
      /**
       * GPUShaderStage
       */
      visibility = GPUShaderStage.VERTEX | GPUShaderStage.FRAGMENT | GPUShaderStage.COMPUTE;
      /**
       * @constructor
       */
      constructor(width, height, ctx) {
        super(width, height, 6);
        this.format = GPUTextureFormat.depth32float;
        this.mipmapCount = 1;
        this._ensureBound(ctx);
        this.init();
      }
      internalCreateBindingLayoutDesc() {
        this.samplerBindingLayout.type = `non-filtering`;
        this.textureBindingLayout.sampleType = `unfilterable-float`;
        this.textureBindingLayout.viewDimension = "cube";
      }
      internalCreateTexture() {
        this.textureDescriptor = {
          format: `depth24plus`,
          size: { width: this.width, height: this.height, depthOrArrayLayers: 6 },
          dimension: "2d",
          usage: GPUTextureUsage.COPY_DST | GPUTextureUsage.TEXTURE_BINDING
        };
        this.gpuTexture = this.getGPUTexture();
      }
      internalCreateView() {
        this.viewDescriptor = {
          dimension: `cube`
        };
        this.view = this.getGPUView();
      }
      internalCreateSampler() {
        this._ensureBound();
        const device = this._boundCtx.device;
        this.gpuSampler = device.createSampler({});
        this.gpuSampler_comparison = device.createSampler({
          compare: "less",
          label: "sampler_comparison"
        });
      }
    }

    class Float16ArrayTexture extends Texture {
      uint16Array;
      floatArray;
      _dataBuffer;
      /**
       * fill this texture by array of numbers;the format as [red0, green0, blue0, alpha0, red1, green1, blue1, alpha1...]
       * @param width assign the texture width
       * @param height assign the texture height
       * @param numbers color of each pixel
       * @param useMipmap  whether or not gen mipmap
       * @returns
       */
      create(width, height, numbers = null, mipmap = true, ctx) {
        if (numbers == null) {
          numbers = [];
          for (let i = 0, c = width * height * 4; i < c; i++) {
            numbers[i] = 0;
          }
        }
        this.updateTexture(width, height, numbers, mipmap, ctx);
        return this;
      }
      /**
       * validate the change of this texture
       */
      updateTexture(width, height, numbers, mipmap = true, ctx) {
        if (width != this.width || height != this.height) {
          this._dataBuffer && this._dataBuffer.destroy();
          this._dataBuffer = null;
          this.gpuTexture && this.gpuTexture.destroy();
          this.gpuTexture = null;
        }
        this.floatArray = numbers;
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        const bytesPerRow = width * 4 * 2;
        this.format = GPUTextureFormat.rgba16float;
        this.mipmapCount = Math.floor(mipmap ? Math.log2(width) : 1);
        this.createTextureDescriptor(width, height, this.mipmapCount, this.format);
        if (!this.uint16Array || this.uint16Array.length != numbers.length) {
          this.uint16Array = new Uint16Array(numbers.length);
        }
        let uint16Array = this.uint16Array;
        for (let i = 0, c = uint16Array.length; i < c; i++) {
          uint16Array[i] = toHalfFloat(numbers[i]);
        }
        const textureDataBuffer = this._dataBuffer = device.createBuffer({
          size: uint16Array.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, uint16Array);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        if (!this.useMipmap) {
          this.samplerBindingLayout.type = `filtering`;
          this.textureBindingLayout.sampleType = `float`;
        }
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
        this.gpuSampler = device.createSampler(this);
        this.gpuTexture = this.getGPUTexture();
        if (this.mipmapCount > 1) TextureMipmapGenerator.webGPUGenerateMipmap(this);
      }
    }

    class Float32ArrayTexture extends Texture {
      /**
       * fill this texture by array of numbers;the format as [red0, green0, blue0, alpha0, red1, green1, blue1, alpha1...]
       * @param width assign the texture width
       * @param height assign the texture height
       * @param data color of each pixel
       * @param filtering set the sampler type to filtering, else it's non-filtering
       * @returns
       */
      create(width, height, data, filtering = true, ctx) {
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        const bytesPerRow = width * 4 * 4;
        this.format = GPUTextureFormat.rgba32float;
        let mipmapCount = 1;
        this.createTextureDescriptor(width, height, mipmapCount, this.format);
        const textureDataBuffer = device.createBuffer({
          size: data.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, data);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
        if (filtering) {
          this.samplerBindingLayout.type = `non-filtering`;
          this.textureBindingLayout.sampleType = `unfilterable-float`;
        }
        this.gpuSampler = device.createSampler({});
      }
      /**
       * fill this texture GPUBuffer
       * @param width assign the texture width
       * @param height assign the texture height
       * @param textureDataBuffer GPUBuffer
       * @returns
       */
      fromBuffer(width, height, textureDataBuffer, ctx) {
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        const bytesPerRow = width * 4 * 4;
        this.format = GPUTextureFormat.rgba32float;
        this.mipmapCount = 1;
        this.createTextureDescriptor(width, height, this.mipmapCount, this.format);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
        this.samplerBindingLayout.type = `non-filtering`;
        this.textureBindingLayout.sampleType = `unfilterable-float`;
        this.gpuSampler = device.createSampler({});
        return this;
      }
    }

    class SolidColorSky extends LDRTextureCube {
      _internalTexture;
      _minSize = 32;
      _skyColor;
      /**
       * create a cube texture, which filled by solid color.
       * @param color solid color
       * @returns
       */
      constructor(color, ctx) {
        super();
        if (ctx) this._ensureBound(ctx);
        this._skyColor = color;
        this._internalTexture = new Float16ArrayTexture();
        let numbers = [];
        Res.fillColor(numbers, this._minSize, this._minSize, this.color.r, this.color.g, this.color.b, this.color.a);
        this._internalTexture.create(this._minSize, this._minSize, numbers, false, ctx);
        this.createFromTexture(this._minSize, this._internalTexture, ctx);
        return this;
      }
      changeColor(color) {
        this._skyColor = color;
        Res.fillColor(this._internalTexture.floatArray, this._minSize, this._minSize, this.color.r, this.color.g, this.color.b, this.color.a);
        this._internalTexture.updateTexture(this._minSize, this._minSize, this._internalTexture.floatArray, false);
        this._faceData.uploadTexture(0, this._internalTexture);
        return this;
      }
      get color() {
        return this._skyColor;
      }
      /**
       * change solid color
       * @param value target color
       * @returns
       */
      set color(value) {
        this.changeColor(value);
      }
    }

    class Uint16Texture extends Texture {
      /**
       * create texture by number array, which format is uint8
       * @param width width of texture
       * @param height height of texture
       * @param data uint8 array
       * @param useMipmap whether or not gen mipmap
       * @returns
       */
      create(width, height, data, useMiamp = true, ctx) {
        this._ensureBound(ctx);
        let device = this._boundCtx.device;
        const bytesPerRow = width * 4 * 4;
        this.format = GPUTextureFormat.rgba16float;
        this.mipmapCount = Math.floor(useMiamp ? Math.log2(width) : 1);
        this.createTextureDescriptor(width, height, this.mipmapCount, this.format);
        const textureDataBuffer = device.createBuffer({
          size: data.byteLength,
          usage: GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC
        });
        device.queue.writeBuffer(textureDataBuffer, 0, data);
        const commandEncoder = this._boundCtx.gpuContext.beginCommandEncoder();
        commandEncoder.copyBufferToTexture(
          {
            buffer: textureDataBuffer,
            bytesPerRow
          },
          {
            texture: this.getGPUTexture()
          },
          {
            width,
            height,
            depthOrArrayLayers: 1
          }
        );
        this._boundCtx.gpuContext.endCommandEncoder(commandEncoder);
        this.minFilter = `nearest`;
        this.magFilter = `nearest`;
        this.mipmapFilter = `nearest`;
        this.samplerBindingLayout.type = `non-filtering`;
        this.textureBindingLayout.sampleType = `unfilterable-float`;
        this.minFilter = `linear`;
        this.magFilter = `linear`;
        this.mipmapFilter = `nearest`;
        this.samplerBindingLayout.type = `filtering`;
        this.textureBindingLayout.sampleType = `float`;
        this.gpuSampler = device.createSampler(this);
        if (this.mipmapCount > 1) {
          TextureMipmapGenerator.webGPUGenerateMipmap(this);
        }
      }
    }

    class AxisObject extends exports.Object3D {
      length = 100;
      thickness = 0.1;
      constructor(length, thickness = 0.1) {
        super();
        this.length = length;
        this.thickness = thickness;
        this.init();
      }
      init() {
        let xAx = new exports.Object3D();
        let yAx = new exports.Object3D();
        let zAx = new exports.Object3D();
        let cubeX = new BoxGeometry(2, 2, 2);
        let cubeY = new BoxGeometry(2, 2, 2);
        let cubeZ = new BoxGeometry(2, 2, 2);
        let matX = new UnLitMaterial();
        matX.baseColor = new Color(1, 0, 0);
        let matY = new UnLitMaterial();
        matY.baseColor = new Color(0, 1, 0);
        let matZ = new UnLitMaterial();
        matZ.baseColor = new Color(0, 0, 1);
        let mrx = xAx.addComponent(exports.MeshRenderer);
        let mry = yAx.addComponent(exports.MeshRenderer);
        let mrz = zAx.addComponent(exports.MeshRenderer);
        mrx.geometry = cubeX;
        mrx.material = matX;
        mrx.castShadow = false;
        mry.geometry = cubeY;
        mry.material = matY;
        mry.castShadow = false;
        mrz.geometry = cubeZ;
        mrz.material = matZ;
        mrz.castShadow = false;
        xAx.localScale = new Vector3(this.length, this.thickness, this.thickness);
        xAx.x = this.length;
        yAx.localScale = new Vector3(this.thickness, this.length, this.thickness);
        yAx.y = this.length;
        zAx.localScale = new Vector3(this.thickness, this.thickness, this.length);
        zAx.z = this.length;
        this.addChild(xAx);
        this.addChild(yAx);
        this.addChild(zAx);
      }
    }

    let setTimeDelay = async function(ms) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, ms);
      });
    };
    let setFrameDelay = async function(frame) {
      return new Promise((resolve, reject) => {
        frame = Math.max(1, frame);
        let callback = function() {
          if (frame < 0) {
            resolve(true);
          } else {
            requestAnimationFrame(callback);
          }
          frame--;
        };
        requestAnimationFrame(callback);
      });
    };

    class GeometryUtil {
      static merge(geometries, matrixes, target) {
      }
      static mergeNumber(geometries, num, target) {
        let targetGeo = target || new GeometryBase();
        let posLen = geometries.getAttribute(VertexAttributeName.position).data.length / 3;
        let meshIndexList = new Float32Array(posLen * num);
        for (const iterator of geometries.vertexAttributeMap) {
          let attName = iterator[1].attribute;
          if (attName == VertexAttributeName.indices) continue;
          let data = geometries.getAttribute(attName).data;
          let len = data.length;
          let attData = new Float32Array(len * num);
          for (let i = 0; i < num; i++) {
            attData.set(data, len * i);
            for (let ii = 0; ii < posLen; ii++) {
              meshIndexList[posLen * i + ii] = i;
            }
          }
          targetGeo.setAttribute(attName, attData);
        }
        targetGeo.setAttribute(VertexAttributeName.vIndex, meshIndexList);
        let indexArray = geometries.getAttribute(VertexAttributeName.indices).data;
        let indexLen = indexArray.length;
        let newIndexArray = new Uint32Array(indexArray.length * num);
        for (let i = 0; i < num; i++) {
          for (let j = 0; j < indexLen; j++) {
            let skipFace = i * posLen;
            let index = i * indexLen;
            const ii = indexArray[j] + skipFace;
            newIndexArray[index + j] = ii;
          }
        }
        targetGeo.setIndices(newIndexArray);
        targetGeo.addSubGeometry({
          indexStart: 0,
          indexCount: newIndexArray.length,
          vertexStart: 0,
          index: 0,
          vertexCount: 0,
          firstStart: 0,
          topology: 0
        });
        return targetGeo;
      }
      static generateNormal() {
      }
      static generateTangent() {
      }
      static packUV() {
      }
    }

    class GridObject extends exports.Object3D {
      size = 100;
      divisions = 10;
      constructor(size = 100, divisions = 10) {
        super();
        this.size = size;
        this.divisions = divisions;
        this.buildGeometry();
        this.addAxis();
      }
      buildGeometry() {
        const step = this.size / this.divisions;
        const halfSize = this.size / 2;
        const center = this.divisions / 2;
        const vertices = [];
        for (let i = 0, k = -halfSize; i <= this.divisions; i++, k += step) {
          if (i === center) continue;
          vertices.push(-halfSize, 0, k, halfSize, 0, k);
          vertices.push(k, 0, -halfSize, k, 0, halfSize);
        }
        const vertexCount = vertices.length / 3;
        const indices = new Array(vertexCount);
        for (let i = 0; i < vertexCount; i++) indices[i] = i;
        const grid = new GeometryBase();
        grid.setIndices(vertexCount > 65535 ? new Uint32Array(indices) : new Uint16Array(indices));
        grid.setAttribute(VertexAttributeName.position, new Float32Array(vertices));
        grid.addSubGeometry({
          indexStart: 0,
          indexCount: indices.length,
          vertexStart: 0,
          vertexCount: 0,
          firstStart: 0,
          index: 0,
          topology: 0
        });
        const mat = new UnLitMaterial();
        mat.topology = "line-list";
        mat.baseColor = new Color(1, 1, 1, 0.15);
        mat.blendMode = BlendMode.ADD;
        mat.castReflection = false;
        const mr = this.addComponent(exports.MeshRenderer);
        mr.geometry = grid;
        mr.material = mat;
      }
      addAxis() {
        const halfSize = this.size / 2;
        const makeLine = (x0, z0, x1, z1) => {
          const geo = new GeometryBase();
          geo.setIndices(new Uint16Array([0, 1]));
          geo.setAttribute(VertexAttributeName.position, new Float32Array([x0, 0, z0, x1, 0, z1]));
          geo.addSubGeometry({
            indexStart: 0,
            indexCount: 2,
            vertexStart: 0,
            vertexCount: 0,
            firstStart: 0,
            index: 0,
            topology: 0
          });
          return geo;
        };
        {
          const x = new exports.Object3D();
          const mr = x.addComponent(exports.MeshRenderer);
          mr.geometry = makeLine(-halfSize, 0, halfSize, 0);
          const mat = mr.material = new UnLitMaterial();
          mat.topology = "line-list";
          mat.baseColor = new Color(1, 0, 0, 0.5);
          mat.blendMode = BlendMode.ADD;
          mat.castReflection = false;
          this.addChild(x);
        }
        {
          const z = new exports.Object3D();
          const mr = z.addComponent(exports.MeshRenderer);
          mr.geometry = makeLine(0, -halfSize, 0, halfSize);
          const mat = mr.material = new UnLitMaterial();
          mat.topology = "line-list";
          mat.baseColor = new Color(0, 1, 0, 0.5);
          mat.blendMode = BlendMode.ADD;
          mat.castReflection = false;
          this.addChild(z);
        }
      }
    }

    class KelvinUtil {
      /**
       * Convert color temperature to color object
       * @param color_temperature_Kelvin Color temperature value
       * @returns
       */
      static color_temperature_to_rgb(color_temperature_Kelvin) {
        if (color_temperature_Kelvin < 1e3) {
          color_temperature_Kelvin = 1e3;
        } else if (color_temperature_Kelvin > 4e4) {
          color_temperature_Kelvin = 4e4;
        }
        let tmp_internal = color_temperature_Kelvin / 100;
        let red = this.get_red(tmp_internal);
        let green = this.get_green(tmp_internal);
        let blue = this.get_blue(tmp_internal);
        return new Color(red / 255, green / 255, blue / 255, 1);
      }
      /**
       * Return red component [0-255]
       * @param temperature
       * @returns
       */
      static get_red(temperature) {
        if (temperature <= 66) return 255;
        let tmp_red = 329.698727446 * Math.pow(temperature - 60, -0.1332047592);
        return this.bound(tmp_red);
      }
      /**
       * Return green component [0-255]
       * @param temperature
       * @returns
       */
      static get_green(temperature) {
        let green = 0;
        if (temperature <= 66) {
          green = 99.4708025861 * Math.log(temperature) - 161.1195681661;
        } else {
          green = 288.1221695283 * Math.pow(temperature - 60, -0.0755148492);
        }
        return this.bound(green);
      }
      /**
       * Return blue component [0-255]
       * @param temperature
       * @returns
       */
      static get_blue(temperature) {
        let blue = 0;
        if (temperature >= 66) {
          return 255;
        }
        if (temperature <= 19) {
          return 0;
        }
        blue = 138.5177312231 * Math.log(temperature - 10) - 305.0447927307;
        return this.bound(blue);
      }
      /**
       * @internal
       * @param color_component
       * @param minimum
       * @param maximum
       * @returns
       */
      static bound(color_component, minimum = 0, maximum = 255) {
        let color_component_out = Math.max(color_component, minimum);
        return Math.min(color_component_out, maximum);
      }
    }

    class Object3DUtil {
      // Cached geometries/materials are GPU-bearing; keep one heap per Context3D
      // so samples that run under multiple engines don't cross-bind resources.
      static _getHeap(ctx) {
        let h = ctx.cache(Object3DUtil, () => ({
          boxGeo: null,
          planeGeo: null,
          sphere: null,
          material: null,
          materialMap: null
        }));
        if (!h.boxGeo) h.boxGeo = new BoxGeometry();
        if (!h.planeGeo) h.planeGeo = new PlaneGeometry(1, 1, 1, 1, Vector3.UP);
        if (!h.sphere) h.sphere = new SphereGeometry(1, 35, 35);
        if (!h.material) h.material = new LitMaterial();
        if (!h.materialMap) h.materialMap = /* @__PURE__ */ new Map();
        return h;
      }
      /** Shared unit box geometry for the given context. */
      static CubeMesh(ctx) {
        return this._getHeap(ctx).boxGeo;
      }
      /** Shared unit sphere geometry for the given context. */
      static SphereMesh(ctx) {
        return this._getHeap(ctx).sphere;
      }
      /** Create a cube Object3D using the shared box geometry and a cloned default material. */
      static GetCube(ctx) {
        const h = this._getHeap(ctx);
        let obj = new exports.Object3D();
        let renderer = obj.addComponent(exports.MeshRenderer);
        renderer.geometry = h.boxGeo;
        renderer.material = h.material.clone();
        renderer.castShadow = true;
        return obj;
      }
      /** Get (and cache per texture) a clone of a LitMaterial whose base map is the given texture. */
      static GetMaterial(ctx, tex) {
        const h = this._getHeap(ctx);
        let mat = h.materialMap.get(tex);
        if (!mat) {
          mat = new LitMaterial();
          mat.baseMap = tex;
          h.materialMap.set(tex, mat);
        }
        return mat.clone();
      }
      /** Create a textured, additively-blended plane Object3D (no shadow/GI/reflection). */
      static GetPlane(ctx, tex) {
        const h = this._getHeap(ctx);
        let obj = new exports.Object3D();
        let renderer = obj.addComponent(exports.MeshRenderer);
        renderer.geometry = h.planeGeo;
        let cloneMat = this.GetMaterial(ctx, tex);
        cloneMat.blendMode = BlendMode.ADD;
        cloneMat.castShadow = false;
        renderer.material = cloneMat;
        renderer.castGI = false;
        renderer.castReflection = false;
        return obj;
      }
      /** Create a standalone cube with its own box geometry and a colored LitMaterial. */
      static GetSingleCube(sizeX, sizeY, sizeZ, r, g, b) {
        let mat = new LitMaterial();
        mat.roughness = 0.5;
        mat.metallic = 0.1;
        mat.baseColor = new Color(r, g, b, 1);
        let obj = new exports.Object3D();
        let renderer = obj.addComponent(exports.MeshRenderer);
        renderer.castGI = true;
        renderer.geometry = new BoxGeometry(sizeX, sizeY, sizeZ);
        renderer.material = mat;
        return obj;
      }
      /** Create a standalone sphere with its own geometry and a colored LitMaterial. */
      static GetSingleSphere(radius, r, g, b) {
        let mat = new LitMaterial();
        mat.baseColor = new Color(r, g, b, 1);
        let obj = new exports.Object3D();
        let renderer = obj.addComponent(exports.MeshRenderer);
        renderer.castGI = true;
        renderer.geometry = new SphereGeometry(radius, 20, 20);
        renderer.material = mat;
        return obj;
      }
      /** Create a standalone cube with the given material and uniform size (no shadow). */
      static GetSingleCube2(mat, size = 10) {
        let obj = new exports.Object3D();
        let renderer = obj.addComponent(exports.MeshRenderer);
        renderer.castShadow = false;
        renderer.geometry = new BoxGeometry(size, size, size);
        renderer.material = mat;
        return obj;
      }
      /** Create a point light Object3D with a small visualizer sphere child. */
      static GetPointLight(pos, rotation, radius, r, g, b, intensity = 1, castShadow = true) {
        let lightObj = new exports.Object3D();
        let light = lightObj.addComponent(exports.PointLight);
        light.lightColor = new Color(r, g, b, 1);
        light.intensity = intensity;
        light.range = radius;
        light.at = 8;
        light.radius = 0;
        light.castShadow = castShadow;
        lightObj.localPosition = pos;
        lightObj.localRotation = rotation;
        let sp = this.GetSingleSphere(0.1, 1, 1, 1);
        lightObj.addChild(sp);
        return light;
      }
    }

    class StorageUtil {
      /** The most recently loaded data table. */
      static localData;
      /**
       * Load a JSON data table from local storage, creating an empty one if absent.
       * @param dataTable storage key
       * @returns the parsed data, typed as T
       */
      static load(dataTable) {
        let jsonData = localStorage.getItem(dataTable);
        if (jsonData) {
          this.localData = JSON.parse(jsonData);
        } else {
          this.localData = {};
          StorageUtil.save(dataTable, this.localData);
        }
        return this.localData;
      }
      /**
       * Serialize and persist a data table to local storage.
       * @param table storage key
       * @param data value to persist
       */
      static save(table, data) {
        let json = JSON.stringify(data);
        localStorage.setItem(table, json);
      }
    }

    class UIUtil {
      /** Text rendering options. Missing fields fall back to sensible defaults. */
      static DEFAULT_TEXT_OPTS = {
        font: "sans-serif",
        fontSize: 24,
        fontWeight: "normal",
        color: "#ffffff",
        strokeColor: "",
        strokeWidth: 0,
        align: "left",
        baseline: "top",
        maxWidth: 0,
        lineHeight: 1.2,
        padding: 4,
        dpr: typeof window !== "undefined" && window.devicePixelRatio || 1
      };
      /** Measure the CSS-pixel size needed to render `text` with the given options. */
      static measureText(text, opts) {
        const o = { ...UIUtil.DEFAULT_TEXT_OPTS, ...opts || {} };
        const lines = UIUtil._wrap(text, o);
        const ctx = UIUtil._measureCtx();
        UIUtil._applyFont(ctx, o);
        let maxW = 0;
        for (const line of lines) {
          const w = ctx.measureText(line).width;
          if (w > maxW) maxW = w;
        }
        const lineH = o.fontSize * o.lineHeight;
        return {
          width: Math.ceil(maxW) + o.padding * 2,
          height: Math.ceil(lineH * lines.length) + o.padding * 2
        };
      }
      /**
       * Render `text` to a new GPU texture. Returns a BitmapTexture2D bound to
       * `ctx`. The texture format is `rgba8unorm` with premultiplied alpha —
       * suitable for `SpriteMaterial.baseMap`.
       */
      static async textToTexture(text, ctx, opts) {
        const o = { ...UIUtil.DEFAULT_TEXT_OPTS, ...opts || {} };
        const { width, height } = UIUtil.measureText(text, o);
        const bitmap = await UIUtil._renderText(text, width, height, o);
        const texture = new BitmapTexture2D(true, ctx);
        texture.source = bitmap;
        return texture;
      }
      /**
       * Re-render `text` into an existing texture's backing store. Requires the
       * texture's `width/height` to match the new size — if they differ, the
       * texture is recreated under the hood via the standard source setter.
       */
      static async updateTextTexture(texture, text, opts) {
        const o = { ...UIUtil.DEFAULT_TEXT_OPTS, ...opts || {} };
        const { width, height } = UIUtil.measureText(text, o);
        const bitmap = await UIUtil._renderText(text, width, height, o);
        texture.source = bitmap;
      }
      // ---------- private helpers ----------
      static _measureCanvas = null;
      static _measureCtx() {
        if (!UIUtil._measureCanvas) UIUtil._measureCanvas = new OffscreenCanvas(4, 4);
        const ctx = UIUtil._measureCanvas.getContext("2d");
        if (!ctx) throw new Error("UIUtil: 2D context not available on OffscreenCanvas");
        return ctx;
      }
      static _applyFont(ctx, o) {
        ctx.font = `${o.fontWeight} ${o.fontSize}px ${o.font}`;
        ctx.textAlign = o.align;
        ctx.textBaseline = o.baseline;
      }
      static _wrap(text, o) {
        if (!o.maxWidth || o.maxWidth <= 0) return text.split("\n");
        const ctx = UIUtil._measureCtx();
        UIUtil._applyFont(ctx, o);
        const out = [];
        const rawLines = text.split("\n");
        for (const raw of rawLines) {
          const words = raw.split(/\s+/);
          let line = "";
          for (const word of words) {
            const probe = line.length === 0 ? word : line + " " + word;
            if (ctx.measureText(probe).width + o.padding * 2 > o.maxWidth) {
              if (line) {
                out.push(line);
                line = word;
              } else {
                out.push(probe);
                line = "";
              }
            } else {
              line = probe;
            }
          }
          if (line) out.push(line);
        }
        return out.length === 0 ? [""] : out;
      }
      static async _renderText(text, width, height, o) {
        const dpr = Math.max(1, o.dpr);
        const cvs = new OffscreenCanvas(Math.max(32, Math.ceil(width * dpr)), Math.max(32, Math.ceil(height * dpr)));
        const ctx = cvs.getContext("2d");
        if (!ctx) throw new Error("UIUtil: 2D context not available on OffscreenCanvas");
        ctx.scale(dpr, dpr);
        UIUtil._applyFont(ctx, o);
        ctx.clearRect(0, 0, width, height);
        const lines = UIUtil._wrap(text, o);
        const lineH = o.fontSize * o.lineHeight;
        let x = o.padding;
        if (o.align === "center") x = width / 2;
        else if (o.align === "right") x = width - o.padding;
        let y = o.padding;
        if (o.baseline === "middle") y = height / 2 - (lines.length - 1) * lineH / 2;
        else if (o.baseline === "bottom") y = height - o.padding - (lines.length - 1) * lineH;
        ctx.fillStyle = o.color;
        if (o.strokeColor && o.strokeWidth > 0) {
          ctx.strokeStyle = o.strokeColor;
          ctx.lineWidth = o.strokeWidth;
        }
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          const ly = y + i * lineH;
          if (o.strokeColor && o.strokeWidth > 0) ctx.strokeText(line, x, ly);
          ctx.fillText(line, x, ly);
        }
        return await createImageBitmap(cvs);
      }
    }

    class f32 extends Number {
    }
    class i32 extends Number {
    }
    class u32 extends Number {
    }

    class Vector3Struct extends Struct {
      x = 0;
      y = 0;
      z = 0;
      w = 0;
    }

    var TransformAxisEnum = /* @__PURE__ */ ((TransformAxisEnum2) => {
      TransformAxisEnum2[TransformAxisEnum2["X"] = 0] = "X";
      TransformAxisEnum2[TransformAxisEnum2["Y"] = 1] = "Y";
      TransformAxisEnum2[TransformAxisEnum2["Z"] = 2] = "Z";
      TransformAxisEnum2[TransformAxisEnum2["XY"] = 3] = "XY";
      TransformAxisEnum2[TransformAxisEnum2["XZ"] = 4] = "XZ";
      TransformAxisEnum2[TransformAxisEnum2["YZ"] = 5] = "YZ";
      TransformAxisEnum2[TransformAxisEnum2["XYZ"] = 6] = "XYZ";
      TransformAxisEnum2[TransformAxisEnum2["MAX"] = 7] = "MAX";
      TransformAxisEnum2[TransformAxisEnum2["NONE"] = 8] = "NONE";
      return TransformAxisEnum2;
    })(TransformAxisEnum || {});

    var TransformSpaceMode = /* @__PURE__ */ ((TransformSpaceMode2) => {
      TransformSpaceMode2[TransformSpaceMode2["Local"] = 0] = "Local";
      TransformSpaceMode2[TransformSpaceMode2["Global"] = 1] = "Global";
      return TransformSpaceMode2;
    })(TransformSpaceMode || {});

    class TransformControllerBaseComponent extends ComponentBase {
      mAxis;
      mAxisColor;
      mContainer;
      mAxisMaterial;
      mAxisCollider;
      constructor() {
        super();
        this._enable = false;
        this.mAxis = new Array(TransformAxisEnum.MAX);
        this.mAxisColor = new Array(TransformAxisEnum.MAX);
        this.mAxisMaterial = new Array(TransformAxisEnum.MAX);
        this.mAxisCollider = new Array(TransformAxisEnum.MAX);
      }
      /** The object currently controlled by the owning gizmo. */
      get target() {
        return this.object3D.target;
      }
      /** The gizmo's X-axis root object. */
      get mX() {
        return this.object3D.mXObj;
      }
      /** The gizmo's Y-axis object. */
      get mY() {
        return this.object3D.mYObj;
      }
      /** The gizmo's Z-axis object. */
      get mZ() {
        return this.object3D.mZObj;
      }
      /** The active transform space (local or global) from the owning gizmo. */
      get transformSpaceMode() {
        return this.object3D.transformSpaceMode;
      }
      /** Build the per-axis handle objects, materials and colliders. */
      init(param) {
        this.mContainer = new exports.Object3D();
        let xAxisMaterial = new UnLitMaterial();
        xAxisMaterial.baseColor = new Color(1, 0, 0);
        xAxisMaterial.depthCompare = GPUCompareFunction.always;
        this.mAxisColor[TransformAxisEnum.X] = xAxisMaterial.baseColor;
        this.mAxisMaterial[TransformAxisEnum.X] = xAxisMaterial;
        let yAxisMaterial = new UnLitMaterial();
        yAxisMaterial.baseColor = new Color(0, 1, 0);
        yAxisMaterial.depthCompare = GPUCompareFunction.always;
        this.mAxisColor[TransformAxisEnum.Y] = yAxisMaterial.baseColor;
        this.mAxisMaterial[TransformAxisEnum.Y] = yAxisMaterial;
        let zAxisMaterial = new UnLitMaterial();
        zAxisMaterial.baseColor = new Color(0, 0, 1);
        zAxisMaterial.depthCompare = GPUCompareFunction.always;
        this.mAxisColor[TransformAxisEnum.Z] = zAxisMaterial.baseColor;
        this.mAxisMaterial[TransformAxisEnum.Z] = zAxisMaterial;
        let axisX = this.createCustomAxis(TransformAxisEnum.X);
        let axisY = this.createCustomAxis(TransformAxisEnum.Y);
        let axisZ = this.createCustomAxis(TransformAxisEnum.Z);
        this.mContainer.addChild(this.mAxis[TransformAxisEnum.X] = axisX);
        this.mContainer.addChild(this.mAxis[TransformAxisEnum.Y] = axisY);
        this.mContainer.addChild(this.mAxis[TransformAxisEnum.Z] = axisZ);
        this.mAxisCollider[TransformAxisEnum.X] = axisX.getComponent(ColliderComponent);
        this.mAxisCollider[TransformAxisEnum.Y] = axisY.getComponent(ColliderComponent);
        this.mAxisCollider[TransformAxisEnum.Z] = axisZ.getComponent(ColliderComponent);
      }
      /** Component lifecycle start hook. */
      start() {
      }
      /** Attach the handle container and align the gizmo when enabled. */
      onEnable(view) {
        this.object3D.addChild(this.mContainer);
        this.reset();
      }
      /** Detach the handle container when disabled. */
      onDisable(view) {
        this.object3D.removeChild(this.mContainer);
      }
      /** Re-align the gizmo to the target according to the current transform space. */
      reset() {
        switch (this.transformSpaceMode) {
          case TransformSpaceMode.Local:
            {
              let targetInvWorldMatrix = Matrix4.help_matrix_0.copy(this.mX.transform.worldMatrix);
              let resultTRS = targetInvWorldMatrix.decompose();
              this.object3D.scaleX = 1;
              this.object3D.scaleY = 1;
              this.object3D.scaleZ = 1;
              this.object3D.rotationX = resultTRS[1].x;
              this.object3D.rotationY = resultTRS[1].y;
              this.object3D.rotationZ = resultTRS[1].z;
              this.object3D.x = resultTRS[0].x;
              this.object3D.y = resultTRS[0].y;
              this.object3D.z = resultTRS[0].z;
            }
            break;
          case TransformSpaceMode.Global:
            {
              this.object3D.scaleX = 1;
              this.object3D.scaleY = 1;
              this.object3D.scaleZ = 1;
              this.object3D.rotationX = 0;
              this.object3D.rotationY = 0;
              this.object3D.rotationZ = 0;
              const pos = this.mX.transform.worldPosition;
              this.object3D.x = pos.x;
              this.object3D.y = pos.y;
              this.object3D.z = pos.z;
            }
            break;
        }
      }
      _input() {
        const view = this.transform?.view3D;
        const owner = view?.engine3D;
        return owner?.inputSystem;
      }
      /** Ray-pick the axis handles under the pointer, returning the closest hit. */
      pickAxis() {
        const scene3D = this.object3D.transform.scene3D;
        const camera = scene3D.view.camera;
        const input = this._input();
        let ray = camera.screenPointToRay(input.mouseX, input.mouseY);
        let intersect;
        let lastResult;
        for (let i = 0; i <= TransformAxisEnum.MAX; i++) {
          let collider = this.mAxisCollider[i];
          if (!collider) {
            continue;
          }
          intersect = collider.rayPick(ray);
          if (intersect) {
            if (!lastResult || lastResult.distance > intersect.distance || i == TransformAxisEnum.XYZ) {
              lastResult = {
                axis: i,
                obj: collider.object3D,
                distance: intersect.distance,
                intersectPoint: intersect.intersectPoint
              };
              if (i == TransformAxisEnum.XYZ) {
                break;
              }
            }
          }
        }
        return lastResult;
      }
      currentAxis = TransformAxisEnum.NONE;
      beginPoint = new Vector3();
      beginMousePos = new Vector3();
      currentPoint = new Vector3();
      /** Begin a drag: pick an axis and record the start point. */
      onMouseDown(e) {
        if (e.mouseCode != MouseCode.MOUSE_LEFT) {
          return;
        }
        let result = this.pickAxis();
        if (!result) {
          return;
        }
        this.currentAxis = result.axis;
        e.stopImmediatePropagation();
        const scene3D = this.object3D.transform.scene3D;
        const camera = scene3D.view.camera;
        let screenPoint = camera.worldToScreenPoint(this.mX.transform.worldPosition);
        const input = this._input();
        let pos = camera.screenPointToWorld(input.mouseX, input.mouseY, screenPoint.z);
        this.beginPoint.copy(pos);
        this.beginMousePos.x = input.mouseX;
        this.beginMousePos.y = input.mouseY;
      }
      lastMoveObj;
      lastMoveAxis;
      /** Highlight handles on hover, or apply the transform while dragging. */
      onMouseMove(e) {
        if (this.currentAxis == TransformAxisEnum.NONE) {
          let mat = this.lastMoveObj.getComponent(exports.MeshRenderer).material;
          if (this.lastMoveObj && "baseColor" in mat) {
            mat.baseColor = this.mAxisColor[this.lastMoveAxis];
            this.lastMoveObj = null;
            if (this.lastMoveAxis == TransformAxisEnum.XYZ) {
              this.mAxis[TransformAxisEnum.X].getComponent(exports.MeshRenderer).material.setUniformColor("baseColor", this.mAxisColor[TransformAxisEnum.X]);
              this.mAxis[TransformAxisEnum.Y].getComponent(exports.MeshRenderer).material.setUniformColor("baseColor", this.mAxisColor[TransformAxisEnum.Y]);
              this.mAxis[TransformAxisEnum.Z].getComponent(exports.MeshRenderer).material.setUniformColor("baseColor", this.mAxisColor[TransformAxisEnum.Z]);
            }
            this.lastMoveAxis = TransformAxisEnum.NONE;
          }
          let result = this.pickAxis();
          if (!result) {
            return;
          }
          mat.setUniformColor("baseColor", new Color(1, 1, 1));
          this.lastMoveObj = result.obj;
          this.lastMoveAxis = result.axis;
          if (this.lastMoveAxis == TransformAxisEnum.XYZ) {
            this.mAxis[TransformAxisEnum.X].getComponent(exports.MeshRenderer).material.setUniformColor("baseColor", new Color(1, 1, 1));
            this.mAxis[TransformAxisEnum.Y].getComponent(exports.MeshRenderer).material.setUniformColor("baseColor", new Color(1, 1, 1));
            this.mAxis[TransformAxisEnum.Z].getComponent(exports.MeshRenderer).material.setUniformColor("baseColor", new Color(1, 1, 1));
          }
        } else {
          const scene3D = this.object3D.transform.scene3D;
          const camera = scene3D.view.camera;
          let screenPoint = camera.worldToScreenPoint(this.mX.transform.worldPosition);
          const input = this._input();
          let pos = camera.screenPointToWorld(input.mouseX, input.mouseY, screenPoint.z);
          this.currentPoint.copy(pos);
          let offset = pos.sub(this.beginPoint);
          Vector3.HELP_0.set(input.mouseX, input.mouseY, 0);
          let distance = Vector3.distance(Vector3.HELP_0, this.beginMousePos);
          this.beginMousePos.copy(Vector3.HELP_0);
          switch (this.transformSpaceMode) {
            case TransformSpaceMode.Local:
              this.applyLocalTransform(this.currentAxis, offset, distance);
              break;
            case TransformSpaceMode.Global:
              this.applyGlobalTransform(this.currentAxis, offset, distance);
              break;
          }
          this.beginPoint.copy(pos);
          this.reset();
        }
      }
      /** End a drag and clear the active axis. */
      onMouseUp(e) {
        if (e.mouseCode != MouseCode.MOUSE_LEFT) {
          return;
        }
        this.currentAxis = TransformAxisEnum.NONE;
        this.reset();
      }
      /** Keep the gizmo at a constant screen size and pinned to the target each frame. */
      onUpdate(view) {
        let distance = Vector3.distance(view.camera.transform.worldPosition, this.object3D.transform.worldPosition);
        let scale = distance / 100;
        this.mContainer.scaleX = this.mContainer.scaleY = this.mContainer.scaleZ = scale;
        if (this.mX) {
          const pos = this.mX.transform.worldPosition;
          this.object3D.x = pos.x;
          this.object3D.y = pos.y;
          this.object3D.z = pos.z;
        }
      }
      /** Apply the transform in local space for the active axis. Overridden by subclasses. */
      applyLocalTransform(currentAxis, offset, distance) {
        console.warn("not imp");
      }
      /** Apply the transform in world space for the active axis. Overridden by subclasses. */
      applyGlobalTransform(currentAxis, offset, distance) {
        console.warn("not imp");
      }
      /** Build the visual handle for one axis. Overridden by subclasses to add caps/arrows. */
      createCustomAxis(axis) {
        let axisObj = this.createAxis(axis);
        return axisObj;
      }
      /** Create the base axis shaft mesh and its box collider. */
      createAxis(axis) {
        let r = 0, g = 0, b = 0;
        switch (axis) {
          case TransformAxisEnum.X:
            r = 1;
            break;
          case TransformAxisEnum.Y:
            g = 1;
            break;
          case TransformAxisEnum.Z:
            b = 1;
            break;
        }
        let w = 0.4 + r * 20;
        let h = 0.4 + g * 20;
        let d = 0.4 + b * 20;
        let obj = new exports.Object3D();
        obj.x = w * 0.5;
        obj.y = h * 0.5;
        obj.z = d * 0.5;
        let mr = obj.addComponent(exports.MeshRenderer);
        mr.geometry = new BoxGeometry(w, h, d);
        mr.material = this.mAxisMaterial[axis];
        let collider = obj.addComponent(ColliderComponent);
        let boxShape = new BoxColliderShape();
        boxShape.setFromCenterAndSize(new Vector3(0, 0, 0), new Vector3(w + 1, h + 1, d + 1));
        collider.shape = boxShape;
        return obj;
      }
    }

    class ScaleControlComponents extends TransformControllerBaseComponent {
      /** Build the scale handles, including the central uniform-scale box. */
      init(param) {
        super.init(param);
        let boxXYZMaterial = new UnLitMaterial();
        boxXYZMaterial.doubleSide = true;
        boxXYZMaterial.baseColor = new Color(0.9, 0.9, 0.9);
        boxXYZMaterial.depthCompare = GPUCompareFunction.always;
        this.mAxisColor[TransformAxisEnum.XYZ] = boxXYZMaterial.baseColor;
        this.mAxisMaterial[TransformAxisEnum.XYZ] = boxXYZMaterial;
        let boxXYZ = new exports.Object3D();
        let mr = boxXYZ.addComponent(exports.MeshRenderer);
        mr.geometry = new BoxGeometry(2, 2, 2);
        mr.material = this.mAxisMaterial[TransformAxisEnum.XYZ];
        let collider = boxXYZ.addComponent(ColliderComponent);
        let boxShape = new BoxColliderShape();
        boxShape.setFromCenterAndSize(new Vector3(0, 0, 0), new Vector3(2, 2, 2));
        collider.shape = boxShape;
        this.mContainer.addChild(this.mAxis[TransformAxisEnum.XYZ] = boxXYZ);
        this.mAxisCollider[TransformAxisEnum.XYZ] = boxXYZ.getComponent(ColliderComponent);
      }
      /** Apply scaling in the target's local space for the active axis. */
      applyLocalTransform(currentAxis, offset, distance) {
        switch (this.currentAxis) {
          case TransformAxisEnum.XYZ:
            {
              let v = 0;
              if (Math.abs(offset.x) > Math.abs(offset.y)) {
                if (Math.abs(offset.x) > Math.abs(offset.z)) {
                  v = offset.x;
                } else {
                  v = offset.z;
                }
              } else {
                v = offset.y;
              }
              this.mX.scaleX += v;
              this.mX.scaleY += v;
              this.mX.scaleZ += v;
            }
            break;
          default:
            {
              Matrix4.transformVector(this.mX.transform.worldMatrix, offset, offset);
              if (this.currentAxis == TransformAxisEnum.X || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.XZ) {
                this.mX.scaleX = Math.abs(this.mX.scaleX + offset.x);
              }
              if (this.currentAxis == TransformAxisEnum.Y || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.YZ) {
                this.mX.scaleY = Math.abs(this.mX.scaleY + offset.y);
              }
              if (this.currentAxis == TransformAxisEnum.Z || this.currentAxis == TransformAxisEnum.XZ || this.currentAxis == TransformAxisEnum.YZ) {
                this.mX.scaleZ = Math.abs(this.mX.scaleZ + offset.z);
              }
            }
            break;
        }
      }
      /** Apply scaling in world space for the active axis. */
      applyGlobalTransform(currentAxis, offset, distance) {
        let value = Vector3.HELP_0;
        value.set(0, 0, 0);
        if (this.currentAxis == TransformAxisEnum.X || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.XZ) {
          value.x = offset.x;
        }
        if (this.currentAxis == TransformAxisEnum.Y || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.YZ) {
          value.y = offset.y;
        }
        if (this.currentAxis == TransformAxisEnum.Z || this.currentAxis == TransformAxisEnum.XZ || this.currentAxis == TransformAxisEnum.YZ) {
          value.z = offset.z;
        }
        Matrix4.transformVector(this.mX.transform.worldMatrix, value, Vector3.HELP_1);
        this.mX.scaleX += Vector3.HELP_1.x;
        this.mX.scaleY += Vector3.HELP_1.y;
        this.mX.scaleZ += Vector3.HELP_1.z;
      }
      /** Build the visual handle for one scale axis (shaft plus end box). */
      createCustomAxis(axis) {
        let axisObj = super.createAxis(axis);
        let arrowsObj = this.createBox(axis);
        axisObj.addChild(arrowsObj);
        return axisObj;
      }
      /** Create the box cap mesh at the end of one scale axis. */
      createBox(axis) {
        let r = 0, g = 0, b = 0;
        let obj = new exports.Object3D();
        switch (axis) {
          case TransformAxisEnum.X:
            r = 1;
            obj.rotationZ = -90;
            break;
          case TransformAxisEnum.Y:
            g = 1;
            break;
          case TransformAxisEnum.Z:
            b = 1;
            obj.rotationX = 90;
            break;
        }
        let w = 0.2 + r * 20;
        let h = 0.2 + g * 20;
        let d = 0.2 + b * 20;
        obj.x = w * 0.5;
        obj.y = h * 0.5;
        obj.z = d * 0.5;
        let mr = obj.addComponent(exports.MeshRenderer);
        mr.geometry = new BoxGeometry(2, 2, 2);
        mr.material = this.mAxisMaterial[axis];
        return obj;
      }
    }

    var TransformMode = /* @__PURE__ */ ((TransformMode2) => {
      TransformMode2[TransformMode2["Scale"] = 0] = "Scale";
      TransformMode2[TransformMode2["Rotation"] = 1] = "Rotation";
      TransformMode2[TransformMode2["Translation"] = 2] = "Translation";
      TransformMode2[TransformMode2["NONE"] = 3] = "NONE";
      return TransformMode2;
    })(TransformMode || {});

    class RotationControlComponents extends TransformControllerBaseComponent {
      /** Apply a rotation in the target's local space for the active axis. */
      applyLocalTransform(currentAxis, offset, distance) {
        if (this.currentAxis == TransformAxisEnum.X || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.XZ) ;
        if (this.currentAxis == TransformAxisEnum.Y || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.YZ) {
          Matrix4.help_matrix_0.copy(this.mX.transform.worldMatrix);
          Matrix4.help_matrix_1.identity();
          Matrix4.help_matrix_1.createByRotation(1, Vector3.Y_AXIS);
          Matrix4.help_matrix_2.multiplyMatrices(Matrix4.help_matrix_1, Matrix4.help_matrix_0);
          Matrix4.help_matrix_2.invert();
          Matrix4.help_matrix_1.multiplyMatrices(Matrix4.help_matrix_2, Matrix4.help_matrix_0);
          let trs = Matrix4.help_matrix_1.decompose();
          this.mX.rotationX += trs[1].x;
          this.mY.rotationY += trs[1].y;
          this.mZ.rotationZ += trs[1].z;
        }
        if (this.currentAxis == TransformAxisEnum.Z || this.currentAxis == TransformAxisEnum.XZ || this.currentAxis == TransformAxisEnum.YZ) ;
      }
      /** Compute the current pointer angle around the active rotation axis, in degrees. */
      getAngle() {
        const scene3D = this.object3D.transform.scene3D;
        const camera = scene3D.view.camera;
        const pos = this.mZ.transform.worldPosition;
        const input = this._input();
        camera.screenPointToRay(input.mouseX, input.mouseY);
        if (this.currentAxis == TransformAxisEnum.X) {
          let screenPoint = camera.worldToScreenPoint(pos);
          Vector3.HELP_1.set(screenPoint.x, screenPoint.y, 0);
          Vector3.HELP_2.set(input.mouseX, input.mouseY, 0);
          let vec3 = Vector3.HELP_2.sub(Vector3.HELP_1);
          let angle = Vector3.getAngle(Vector3.X_AXIS, vec3);
          if (vec3.y > 0) {
            angle = 360 - angle;
          }
          if (camera.transform.worldPosition.x - pos.x > 0) {
            angle = 360 - angle;
          }
          return angle;
        }
        if (this.currentAxis == TransformAxisEnum.Y) {
          let screenPoint = camera.worldToScreenPoint(pos);
          Vector3.HELP_1.set(screenPoint.x, screenPoint.y, 0);
          Vector3.HELP_2.set(input.mouseX, input.mouseY, 0);
          let vec3 = Vector3.HELP_2.sub(Vector3.HELP_1);
          let angle = Vector3.getAngle(Vector3.X_AXIS, vec3);
          if (vec3.y > 0) {
            angle = 360 - angle;
          }
          if (camera.transform.worldPosition.y - pos.y > 0) {
            angle = 360 - angle;
          }
          return angle;
        }
        if (this.currentAxis == TransformAxisEnum.Z) {
          let screenPoint = camera.worldToScreenPoint(pos);
          Vector3.HELP_1.set(screenPoint.x, screenPoint.y, 0);
          Vector3.HELP_2.set(input.mouseX, input.mouseY, 0);
          let vec3 = Vector3.HELP_2.sub(Vector3.HELP_1);
          let angle = Vector3.getAngle(Vector3.X_AXIS, vec3);
          if (vec3.y > 0) {
            angle = 360 - angle;
          }
          if (camera.transform.worldPosition.z - pos.z > 0) {
            angle = 360 - angle;
          }
          return angle;
        }
        return 0;
      }
      mLastAngle = 0;
      /** Apply a rotation in world space for the active axis. */
      applyGlobalTransform(currentAxis, offset, distance) {
        if (this.currentAxis == TransformAxisEnum.X || this.currentAxis == TransformAxisEnum.Y || this.currentAxis == TransformAxisEnum.Z) {
          let angle = this.getAngle();
          Matrix4.help_matrix_0.identity();
          switch (this.currentAxis) {
            case TransformAxisEnum.X:
              Matrix4.help_matrix_0.createByRotation(this.mLastAngle - angle, Vector3.X_AXIS);
              break;
            case TransformAxisEnum.Y:
              Matrix4.help_matrix_0.createByRotation(this.mLastAngle - angle, Vector3.Y_AXIS);
              break;
            case TransformAxisEnum.Z:
              Matrix4.help_matrix_0.createByRotation(this.mLastAngle - angle, Vector3.Z_AXIS);
              break;
          }
          Matrix4.help_matrix_1.copy(this.mX.transform.worldMatrix);
          Matrix4.help_matrix_1.append(Matrix4.help_matrix_0);
          if (this.mX.parent) {
            Matrix4.help_matrix_2.copy(this.mX.parent.worldMatrix);
            Matrix4.help_matrix_2.invert();
            Matrix4.help_matrix_1.multiply(Matrix4.help_matrix_2);
          }
          let trs = Matrix4.help_matrix_1.decompose(Orientation3D.QUATERNION);
          let rot = trs[1];
          Quaternion.HELP_0.set(rot.x, rot.y, rot.z, rot.w);
          this.mLastAngle = angle;
          this.mX.transform.localRotQuat = Quaternion.HELP_0;
        }
      }
      /** Begin a rotation drag, isolating the picked axis handle. */
      onMouseDown(e) {
        super.onMouseDown(e);
        if (this.currentAxis != TransformAxisEnum.NONE) {
          this.mAxis[TransformAxisEnum.X].getComponent(exports.MeshRenderer).enable = false;
          this.mAxis[TransformAxisEnum.Y].getComponent(exports.MeshRenderer).enable = false;
          this.mAxis[TransformAxisEnum.Z].getComponent(exports.MeshRenderer).enable = false;
          this.mAxis[this.currentAxis].getComponent(exports.MeshRenderer).enable = true;
          this.mLastAngle = this.getAngle();
        }
      }
      /** End a rotation drag and restore all axis handles. */
      onMouseUp(e) {
        super.onMouseUp(e);
        if (this.currentAxis == TransformAxisEnum.NONE) {
          this.mAxis[TransformAxisEnum.X].getComponent(exports.MeshRenderer).enable = true;
          this.mAxis[TransformAxisEnum.Y].getComponent(exports.MeshRenderer).enable = true;
          this.mAxis[TransformAxisEnum.Z].getComponent(exports.MeshRenderer).enable = true;
        }
      }
      /** Build the visual handle for one rotation axis. */
      createCustomAxis(axis) {
        let axisObj = this.createAxis(axis);
        return axisObj;
      }
      /** Create the torus mesh and collider for one rotation axis. */
      createAxis(axis) {
        let obj = new exports.Object3D();
        switch (axis) {
          case TransformAxisEnum.X:
            obj.rotationZ = 90;
            break;
          case TransformAxisEnum.Y:
            break;
          case TransformAxisEnum.Z:
            obj.rotationX = 90;
            break;
        }
        let mr = obj.addComponent(exports.MeshRenderer);
        mr.geometry = new TorusGeometry(20, 0.4);
        mr.material = this.mAxisMaterial[axis];
        let collider = obj.addComponent(ColliderComponent);
        let colliderShape = new BoxColliderShape();
        colliderShape.setFromCenterAndSize(new Vector3(), new Vector3(40, 0.4, 40));
        collider.shape = colliderShape;
        return obj;
      }
      /** Ray-pick the rotation handles under the pointer, returning the closest hit on a ring. */
      pickAxis() {
        const scene3D = this.object3D.transform.scene3D;
        const camera = scene3D.view.camera;
        const input = this._input();
        let ray = camera.screenPointToRay(input.mouseX, input.mouseY);
        let intersect;
        let lastResult;
        for (let i = 0; i <= TransformAxisEnum.MAX; i++) {
          let collider = this.mAxisCollider[i];
          if (!collider) {
            continue;
          }
          intersect = collider.rayPick(ray);
          if (intersect) {
            let distance = Vector3.distance(intersect.intersectPoint, collider.shape.center);
            if (distance > 20 + 0.8 || distance < 20 - 0.8) {
              continue;
            }
            if (!lastResult || lastResult.distance > intersect.distance) {
              lastResult = {
                axis: i,
                obj: collider.object3D,
                distance: intersect.distance,
                intersectPoint: intersect.intersectPoint
              };
            }
          }
        }
        return lastResult;
      }
    }

    class TranslationControlComponents extends TransformControllerBaseComponent {
      /** Build the translation handles, including the three drag planes. */
      init(param) {
        super.init(param);
        let xyPlaneMaterial = new UnLitMaterial();
        xyPlaneMaterial.doubleSide = true;
        xyPlaneMaterial.baseColor = new Color(0, 0, 1);
        xyPlaneMaterial.depthCompare = GPUCompareFunction.always;
        this.mAxisColor[TransformAxisEnum.XY] = xyPlaneMaterial.baseColor;
        this.mAxisMaterial[TransformAxisEnum.XY] = xyPlaneMaterial;
        let xzPlaneMaterial = new UnLitMaterial();
        xzPlaneMaterial.doubleSide = true;
        xzPlaneMaterial.baseColor = new Color(0, 1, 0);
        xzPlaneMaterial.depthCompare = GPUCompareFunction.always;
        this.mAxisColor[TransformAxisEnum.XZ] = xzPlaneMaterial.baseColor;
        this.mAxisMaterial[TransformAxisEnum.XZ] = xzPlaneMaterial;
        let yzPlaneMaterial = new UnLitMaterial();
        yzPlaneMaterial.doubleSide = true;
        yzPlaneMaterial.baseColor = new Color(1, 0, 0);
        yzPlaneMaterial.depthCompare = GPUCompareFunction.always;
        this.mAxisColor[TransformAxisEnum.YZ] = yzPlaneMaterial.baseColor;
        this.mAxisMaterial[TransformAxisEnum.YZ] = yzPlaneMaterial;
        let planeXY = this.createPlane(TransformAxisEnum.XY);
        let planeXZ = this.createPlane(TransformAxisEnum.XZ);
        let planeYZ = this.createPlane(TransformAxisEnum.YZ);
        this.mContainer.addChild(this.mAxis[TransformAxisEnum.XY] = planeXY);
        this.mContainer.addChild(this.mAxis[TransformAxisEnum.XZ] = planeXZ);
        this.mContainer.addChild(this.mAxis[TransformAxisEnum.YZ] = planeYZ);
        this.mAxisCollider[TransformAxisEnum.XY] = planeXY.getComponent(ColliderComponent);
        this.mAxisCollider[TransformAxisEnum.XZ] = planeXZ.getComponent(ColliderComponent);
        this.mAxisCollider[TransformAxisEnum.YZ] = planeYZ.getComponent(ColliderComponent);
      }
      /** Apply a translation in the target's local space for the active axis. */
      applyLocalTransform(currentAxis, offset, distance) {
        Matrix4.help_matrix_0.copy(this.mX.transform.worldMatrix).invert();
        Matrix4.transformVector(Matrix4.help_matrix_0, offset, Vector3.HELP_0);
        if (!(this.currentAxis == TransformAxisEnum.X || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.XZ)) {
          Vector3.HELP_0.x = 0;
        }
        if (!(this.currentAxis == TransformAxisEnum.Y || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.YZ)) {
          Vector3.HELP_0.y = 0;
        }
        if (!(this.currentAxis == TransformAxisEnum.Z || this.currentAxis == TransformAxisEnum.XZ || this.currentAxis == TransformAxisEnum.YZ)) {
          Vector3.HELP_0.z = 0;
        }
        Matrix4.transformVector(this.mX.transform.worldMatrix, Vector3.HELP_0, Vector3.HELP_1);
        this.mX.x += Vector3.HELP_1.x;
        this.mX.y += Vector3.HELP_1.y;
        this.mX.z += Vector3.HELP_1.z;
      }
      /** Apply a translation in world space for the active axis. */
      applyGlobalTransform(currentAxis, offset, distance) {
        Matrix4.help_matrix_0.identity();
        if (this.currentAxis == TransformAxisEnum.X || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.XZ) {
          Matrix4.help_matrix_0.appendTranslation(offset.x, 0, 0);
        }
        if (this.currentAxis == TransformAxisEnum.Y || this.currentAxis == TransformAxisEnum.XY || this.currentAxis == TransformAxisEnum.YZ) {
          Matrix4.help_matrix_0.appendTranslation(0, offset.y, 0);
        }
        if (this.currentAxis == TransformAxisEnum.Z || this.currentAxis == TransformAxisEnum.XZ || this.currentAxis == TransformAxisEnum.YZ) {
          Matrix4.help_matrix_0.appendTranslation(0, 0, offset.z);
        }
        Matrix4.help_matrix_1.copy(this.mX.transform.worldMatrix);
        Matrix4.help_matrix_1.append(Matrix4.help_matrix_0);
        if (this.mX.parent) {
          Matrix4.help_matrix_2.copy(this.mX.parent.worldMatrix);
          Matrix4.help_matrix_2.invert();
          Matrix4.help_matrix_1.multiply(Matrix4.help_matrix_2);
        }
        let trs = Matrix4.help_matrix_1.decompose(Orientation3D.QUATERNION);
        this.mX.transform.localPosition = trs[0];
      }
      /** Build the visual handle for one translation axis (shaft plus arrowhead). */
      createCustomAxis(axis) {
        let axisObj = super.createAxis(axis);
        let arrowsObj = this.createArrows(axis);
        axisObj.addChild(arrowsObj);
        return axisObj;
      }
      /** Create the cone arrowhead mesh at the end of one translation axis. */
      createArrows(axis) {
        let r = 0, g = 0, b = 0;
        let obj = new exports.Object3D();
        switch (axis) {
          case TransformAxisEnum.X:
            r = 1;
            obj.rotationZ = -90;
            break;
          case TransformAxisEnum.Y:
            g = 1;
            obj.rotationY = -90;
            break;
          case TransformAxisEnum.Z:
            b = 1;
            obj.rotationX = 90;
            break;
        }
        let w = 0.2 + r * 20;
        let h = 0.2 + g * 20;
        let d = 0.2 + b * 20;
        obj.x = w * 0.5;
        obj.y = h * 0.5;
        obj.z = d * 0.5;
        let mr = obj.addComponent(exports.MeshRenderer);
        mr.geometry = new CylinderGeometry(0, 1, 4);
        mr.material = this.mAxisMaterial[axis];
        return obj;
      }
      /** Create a planar drag handle (and its collider) for a two-axis combination. */
      createPlane(axis) {
        let obj = new exports.Object3D();
        let mr = obj.addComponent(exports.MeshRenderer);
        mr.material = this.mAxisMaterial[axis];
        let collider = obj.addComponent(ColliderComponent);
        let boxShape = new BoxColliderShape();
        collider.shape = boxShape;
        switch (axis) {
          case TransformAxisEnum.XY:
            mr.geometry = new PlaneGeometry(4, 4, 1, 1, Vector3.Z_AXIS);
            obj.x = 8;
            obj.y = 8;
            boxShape.setFromCenterAndSize(new Vector3(0, 0, 0), new Vector3(4, 4, 0.1));
            break;
          case TransformAxisEnum.XZ:
            mr.geometry = new PlaneGeometry(4, 4, 1, 1, Vector3.Y_AXIS);
            obj.x = 8;
            obj.z = 8;
            boxShape.setFromCenterAndSize(new Vector3(0, 0, 0), new Vector3(4, 0.1, 4));
            break;
          case TransformAxisEnum.YZ:
            mr.geometry = new PlaneGeometry(4, 4, 1, 1, Vector3.X_AXIS);
            obj.y = 8;
            obj.z = 8;
            boxShape.setFromCenterAndSize(new Vector3(0, 0, 0), new Vector3(0.1, 4, 4));
            break;
        }
        return obj;
      }
    }

    class Object3DTransformTools extends exports.Object3D {
      static _instance;
      /** Lazily-created shared instance of the transform tools. */
      static get instance() {
        if (!this._instance) {
          this._instance = new Object3DTransformTools();
        }
        return this._instance;
      }
      mTarget;
      mTransformMode = TransformMode.NONE;
      mTransformSpaceType = TransformSpaceMode.Global;
      mControllers;
      /** Root gizmo object aligned to the target on the X axis. */
      mXObj;
      /** Gizmo object nested under mXObj for the Y axis. */
      mYObj;
      /** Gizmo object nested under mYObj for the Z axis. */
      mZObj;
      constructor() {
        super();
        this.mControllers = [null, null, null];
        this.mControllers[TransformMode.Scale] = this.addComponent(ScaleControlComponents);
        this.mControllers[TransformMode.Rotation] = this.addComponent(RotationControlComponents);
        this.mControllers[TransformMode.Translation] = this.addComponent(TranslationControlComponents);
        this.mControllers[TransformMode.Scale].enable = false;
        this.mControllers[TransformMode.Rotation].enable = false;
        this.mControllers[TransformMode.Translation].enable = false;
        this.mXObj = new exports.Object3D();
        this.mYObj = new exports.Object3D();
        this.mZObj = new exports.Object3D();
        this.mXObj.addChild(this.mYObj);
        this.mYObj.addChild(this.mZObj);
      }
      /** Current transform mode (translation/rotation/scale/none). */
      get transformMode() {
        return this.mTransformMode;
      }
      /** Current transform space (local or global). */
      get transformSpaceMode() {
        return this.mTransformSpaceType;
      }
      /** Attach the gizmo to a scene so it becomes visible and interactive. */
      active(scene) {
        scene.addChild(this);
        scene.addChild(this.mXObj);
      }
      /** Detach the gizmo from a scene. */
      unActive(scene) {
        scene.removeChild(this);
      }
      /** The object currently controlled by the gizmo. */
      get target() {
        return this.mTarget;
      }
      /**
       * Bind the gizmo to a target object and optionally set the transform/space mode.
       * @param obj target object, or null to detach
       * @param transformMode optional transform mode to switch to
       * @param spaceMode optional transform space to switch to
       */
      selectObject(obj, transformMode, spaceMode) {
        if (this.mTarget != obj) {
          if (obj) {
            this.activate();
          } else {
            this.unactivate();
          }
          this.mTarget = obj;
          this.mXObj.localPosition = obj.transform.worldPosition.clone();
        }
        if (transformMode != void 0) {
          this.selectTransformMode(transformMode);
        }
        if (spaceMode != void 0) {
          this.selectTransformSpaceMode(spaceMode);
        }
      }
      /** Switch the active transform mode, toggling the matching controller. */
      selectTransformMode(transformMode) {
        if (this.mTransformMode == transformMode)
          return;
        if (this.mTransformMode != TransformMode.NONE)
          this.mControllers[this.mTransformMode].enable = false;
        this.mTransformMode = transformMode;
        if (this.mTransformMode != TransformMode.NONE)
          this.mControllers[this.mTransformMode].enable = true;
      }
      /** Switch the active transform space, resetting the current controller. */
      selectTransformSpaceMode(spaceMode) {
        if (this.mTransformSpaceType == spaceMode)
          return;
        this.mTransformSpaceType = spaceMode;
        if (this.mTransformMode != TransformMode.NONE)
          this.mControllers[this.mTransformMode].reset();
      }
      _input() {
        const view = this.transform?.view3D;
        const owner = view?.engine3D;
        return owner?.inputSystem;
      }
      activate() {
        const input = this._input();
        if (!input) return;
        input.addEventListener(KeyEvent.KEY_DOWN, this.onKeyDown, this);
        input.addEventListener(PointerEvent3D.POINTER_DOWN, this.onMouseDown, this, null, 99999);
        input.addEventListener(PointerEvent3D.POINTER_MOVE, this.onMouseMove, this, null, 99999);
        input.addEventListener(PointerEvent3D.POINTER_UP, this.onMouseUp, this, null, 99999);
      }
      unactivate() {
        const input = this._input();
        if (!input) return;
        input.removeEventListener(KeyEvent.KEY_DOWN, this.onKeyDown, this);
        input.removeEventListener(PointerEvent3D.POINTER_DOWN, this.onMouseDown, this);
        input.removeEventListener(PointerEvent3D.POINTER_MOVE, this.onMouseMove, this);
        input.removeEventListener(PointerEvent3D.POINTER_UP, this.onMouseUp, this);
      }
      onKeyDown(e) {
        switch (e.keyCode) {
          case KeyCode.Key_R:
            this.selectTransformMode(TransformMode.Scale);
            this.selectTransformSpaceMode(TransformSpaceMode.Local);
            break;
          case KeyCode.Key_E:
            this.selectTransformMode(TransformMode.Rotation);
            this.selectTransformSpaceMode(TransformSpaceMode.Global);
            break;
          case KeyCode.Key_W:
            this.selectTransformMode(TransformMode.Translation);
            this.selectTransformSpaceMode(TransformSpaceMode.Global);
            break;
          case KeyCode.Key_A:
            this.selectTransformSpaceMode(TransformSpaceMode.Local);
            break;
          case KeyCode.Key_S:
            this.selectTransformSpaceMode(TransformSpaceMode.Global);
            break;
        }
      }
      onMouseDown(e) {
        if (this.mTransformMode != TransformMode.NONE)
          this.mControllers[this.mTransformMode].onMouseDown(e);
      }
      onMouseMove(e) {
        if (this.mTransformMode != TransformMode.NONE) {
          this.mControllers[this.mTransformMode].onMouseMove(e);
        }
      }
      onMouseUp(e) {
        if (this.mTransformMode != TransformMode.NONE)
          this.mControllers[this.mTransformMode].onMouseUp(e);
      }
    }

    const __viteBrowserExternal = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
        __proto__: null
    }, Symbol.toStringTag, { value: 'Module' }));

    exports.AccelerateDecelerateInterpolator = AccelerateDecelerateInterpolator;
    exports.AccelerateInterpolator = AccelerateInterpolator;
    exports.AlphaHash_frag = AlphaHash_frag;
    exports.AnimationCurve = AnimationCurve;
    exports.AnimationCurveT = AnimationCurveT;
    exports.AnimationLayer = AnimationLayer;
    exports.AnimationMonitor = AnimationMonitor;
    exports.AnimatorEventKeyframe = AnimatorEventKeyframe;
    exports.AnticipateInterpolator = AnticipateInterpolator;
    exports.AnticipateOvershootInterpolator = AnticipateOvershootInterpolator;
    exports.ArrayHas = ArrayHas;
    exports.ArrayItemIndex = ArrayItemIndex;
    exports.AtlasParser = AtlasParser;
    exports.AtmosphericComponent = AtmosphericComponent;
    exports.AtmosphericScatteringSky = AtmosphericScatteringSky;
    exports.AtmosphericScatteringSkySetting = AtmosphericScatteringSkySetting;
    exports.AtmosphericScatteringSky_shader = AtmosphericScatteringSky_shader;
    exports.AttributeAnimCurve = AttributeAnimCurve;
    exports.AxisObject = AxisObject;
    exports.B3DMLoader = B3DMLoader;
    exports.B3DMLoaderBase = B3DMLoaderBase;
    exports.B3DMParseUtil = B3DMParseUtil;
    exports.B3DMParser = B3DMParser;
    exports.BLUR_CsShader = BLUR_CsShader;
    exports.BRDFLUT = BRDFLUT;
    exports.BRDFLUTGenerate = BRDFLUTGenerate;
    exports.BRDF_frag = BRDF_frag;
    exports.BatchMode = BatchMode;
    exports.BatchModeUtil = BatchModeUtil;
    exports.BatchTable = BatchTable;
    exports.Bezier2D = Bezier2D;
    exports.Bezier3D = Bezier3D;
    exports.BiMap = BiMap;
    exports.BillboardComponent = BillboardComponent;
    exports.BillboardType = BillboardType;
    exports.BitUtil = BitUtil;
    exports.BitmapTexture2D = BitmapTexture2D;
    exports.BitmapTexture2DArray = BitmapTexture2DArray;
    exports.BitmapTextureCube = BitmapTextureCube;
    exports.Blend = Blend;
    exports.BlendFactor = BlendFactor;
    exports.BlendMode = BlendMode;
    exports.BlendShapeData = BlendShapeData;
    exports.BlendShapeFrameData = BlendShapeFrameData;
    exports.BlendShapePropertyData = BlendShapePropertyData;
    exports.BlendTree1D = BlendTree1D;
    exports.BloomPost = BloomPost;
    exports.BlurEffectCreatorBlur_cs = BlurEffectCreatorBlur_cs;
    exports.BlurEffectCreatorSample_cs = BlurEffectCreatorSample_cs;
    exports.BlurTexture2DBufferCreator = BlurTexture2DBufferCreator;
    exports.BoneMask = BoneMask;
    exports.BounceInterpolator = BounceInterpolator;
    exports.BoundUtil = BoundUtil;
    exports.BoundingBox = BoundingBox;
    exports.BoundingSphere = BoundingSphere;
    exports.BoxColliderShape = BoxColliderShape;
    exports.BoxGeometry = BoxGeometry;
    exports.BrdfLut_frag = BrdfLut_frag;
    exports.BsDF_frag = BsDF_frag;
    exports.BxDF_frag = BxDF_frag;
    exports.BxdfDebug_frag = BxdfDebug_frag;
    exports.BytesArray = BytesArray;
    exports.CANVAS_TEXTURE = CANVAS_TEXTURE;
    exports.CCDIK = CCDIK;
    exports.CEvent = CEvent;
    exports.CEventDispatcher = CEventDispatcher;
    exports.CEventListener = CEventListener;
    exports.CLUSTER_LIGHTING_BUFFER = CLUSTER_LIGHTING_BUFFER;
    exports.COLOR_BUFFER = COLOR_BUFFER;
    exports.CResizeEvent = CResizeEvent;
    exports.CSM = CSM;
    exports.CSM_frag = CSM_frag;
    exports.Camera3D = Camera3D;
    exports.CameraControllerBase = CameraControllerBase;
    exports.CameraType = CameraType;
    exports.CameraUtil = CameraUtil;
    exports.CapsuleColliderShape = CapsuleColliderShape;
    exports.CastPointShadowMaterialPass = CastPointShadowMaterialPass;
    exports.CastShadowMaterialPass = CastShadowMaterialPass;
    exports.ClearDepthPass = ClearDepthPass;
    exports.Clearcoat_frag = Clearcoat_frag;
    exports.ClusterBoundsSource_cs = ClusterBoundsSource_cs;
    exports.ClusterConfig = ClusterConfig;
    exports.ClusterDebug_frag = ClusterDebug_frag;
    exports.ClusterLight = ClusterLight;
    exports.ClusterLightingBuffer = ClusterLightingBuffer;
    exports.ClusterLightingPass = ClusterLightingPass;
    exports.ClusterLighting_cs = ClusterLighting_cs;
    exports.CollectInfo = CollectInfo;
    exports.ColliderComponent = ColliderComponent;
    exports.ColliderShape = ColliderShape;
    exports.ColliderShapeType = ColliderShapeType;
    exports.Color = Color;
    exports.ColorGradient = ColorGradient;
    exports.ColorLitMaterial = ColorLitMaterial;
    exports.ColorLitShader = ColorLitShader;
    exports.ColorPass = ColorPass;
    exports.ColorPassFragmentOutput = ColorPassFragmentOutput;
    exports.ColorUtil = ColorUtil;
    exports.ComData = ComData;
    exports.Combine_cs = Combine_cs;
    exports.Common_frag = Common_frag;
    exports.Common_vert = Common_vert;
    exports.ComponentBase = ComponentBase;
    exports.ComponentCollect = ComponentCollect;
    exports.ComputeGPUBuffer = ComputeGPUBuffer;
    exports.ComputeShader = ComputeShader;
    exports.ContactShadowPost = ContactShadowPost;
    exports.ContactShadow_cs = ContactShadow_cs;
    exports.Context3D = Context3D;
    exports.CreateFloatArray = CreateFloatArray;
    exports.CubeCamera = CubeCamera;
    exports.CubeMapFaceEnum = CubeMapFaceEnum;
    exports.CubeSky_Shader = CubeSky_Shader;
    exports.CubicBezierCurve = CubicBezierCurve;
    exports.CubicBezierPath = CubicBezierPath;
    exports.CubicBezierType = CubicBezierType;
    exports.CycleInterpolator = CycleInterpolator;
    exports.CyclicDependencyError = CyclicDependencyError;
    exports.CylinderGeometry = CylinderGeometry;
    exports.DDGIIrradianceComputePass = DDGIIrradianceComputePass;
    exports.DDGIIrradianceGPUBufferReader = DDGIIrradianceGPUBufferReader;
    exports.DDGIIrradianceVolume = DDGIIrradianceVolume;
    exports.DDGIIrradiance_shader = DDGIIrradiance_shader;
    exports.DDGILightingPass = DDGILightingPass;
    exports.DDGILighting_shader = DDGILighting_shader;
    exports.DDGIMultiBouncePass = DDGIMultiBouncePass;
    exports.DDGI_DEPTH_MAP = DDGI_DEPTH_MAP;
    exports.DDGI_IRRADIANCE_MAP = DDGI_IRRADIANCE_MAP;
    exports.DDPBackPass = DDPBackPass;
    exports.DDPDepthPass = DDPDepthPass;
    exports.DDPFrontPass = DDPFrontPass;
    exports.DDPResolveShader = DDPResolveShader;
    exports.DDP_BACK_TEX = DDP_BACK_TEX;
    exports.DDP_DEFAULT_PASS_COUNT = DDP_DEFAULT_PASS_COUNT;
    exports.DDP_DEPTH_TEX_0 = DDP_DEPTH_TEX_0;
    exports.DDP_DEPTH_TEX_1 = DDP_DEPTH_TEX_1;
    exports.DDP_FRONT_DEPTH_TEX = DDP_FRONT_DEPTH_TEX;
    exports.DDP_FRONT_TEX = DDP_FRONT_TEX;
    exports.DDP_FRONT_TEX_0 = DDP_FRONT_TEX_0;
    exports.DDP_FRONT_TEX_1 = DDP_FRONT_TEX_1;
    exports.DDP_TEX_NAMES = DDP_TEX_NAMES;
    exports.DEGREES_TO_RADIANS = DEGREES_TO_RADIANS;
    exports.DRAW_CMDS_BUFFER = DRAW_CMDS_BUFFER;
    exports.DRAW_COUNT_BUFFER = DRAW_COUNT_BUFFER;
    exports.DecalComponent = DecalComponent;
    exports.DecalShadowVolumePass = DecalShadowVolumePass;
    exports.DecelerateInterpolator = DecelerateInterpolator;
    exports.DeferredRendererJob = DeferredRendererJob;
    exports.Denoising_cs = Denoising_cs;
    exports.Depth2DTextureArray = Depth2DTextureArray;
    exports.DepthCubeArrayTexture = DepthCubeArrayTexture;
    exports.DepthCubeTexture = DepthCubeTexture;
    exports.DepthMaterialPass = DepthMaterialPass;
    exports.DepthOfFieldPost = DepthOfFieldPost;
    exports.DepthOfView_cs = DepthOfView_cs;
    exports.DirectShadow_frag = DirectShadow_frag;
    exports.DoubleArray = DoubleArray;
    exports.DuplicateCreatorError = DuplicateCreatorError;
    exports.EarthAtmMaterial = EarthAtmMaterial;
    exports.EarthAtmRenderer = EarthAtmRenderer;
    exports.EarthAtm_Shader = EarthAtm_Shader;
    exports.EarthSkyMaterial = EarthSkyMaterial;
    exports.EarthSkyRenderer = EarthSkyRenderer;
    exports.EarthSky_Shader = EarthSky_Shader;
    exports.EditorInspector = EditorInspector;
    exports.Engine3D = Engine3D;
    exports.Entity = Entity;
    exports.EntityBatchCollect = EntityBatchCollect;
    exports.EntityCollect = EntityCollect;
    exports.EnvMap_frag = EnvMap_frag;
    exports.ErpImage2CubeMap = ErpImage2CubeMap;
    exports.ErpImage2CubeMapCreateCube_cs = ErpImage2CubeMapCreateCube_cs;
    exports.ErpImage2CubeMapRgbe2rgba_cs = ErpImage2CubeMapRgbe2rgba_cs;
    exports.ExtrudeGeometry = ExtrudeGeometry;
    exports.FASTFLOOR = FASTFLOOR;
    exports.FINAL_COLOR = FINAL_COLOR;
    exports.FXAAPost = FXAAPost;
    exports.FXAAShader = FXAAShader;
    exports.FastMathShader = FastMathShader;
    exports.FeatureTable = FeatureTable;
    exports.FileLoader = FileLoader;
    exports.FirstPersonCameraController = FirstPersonCameraController;
    exports.Float16ArrayTexture = Float16ArrayTexture;
    exports.Float32ArrayTexture = Float32ArrayTexture;
    exports.FlyCameraController = FlyCameraController;
    exports.ForwardRendererJob = ForwardRendererJob;
    exports.FragmentOutput = FragmentOutput;
    exports.FragmentVarying = FragmentVarying;
    exports.FrameCache = FrameCache;
    exports.Frustum = Frustum;
    exports.FrustumCSM = FrustumCSM;
    exports.FrustumCulling_cs = FrustumCulling_cs;
    exports.FullQuad_vert_wgsl = FullQuad_vert_wgsl;
    exports.GBufferFrame = GBufferFrame;
    exports.GBufferPass = GBufferPass;
    exports.GBufferPost = GBufferPost;
    exports.GBufferResourcePass = GBufferResourcePass;
    exports.GBufferStand = GBufferStand;
    exports.GBuffer_pass = GBuffer_pass;
    exports.GILighting = GILighting;
    exports.GIPass = GIPass;
    exports.GIProbeMaterial = GIProbeMaterial;
    exports.GIProbeMaterialType = GIProbeMaterialType;
    exports.GIProbeShader = GIProbeShader;
    exports.GIRenderCompleteEvent = GIRenderCompleteEvent;
    exports.GIRenderStartEvent = GIRenderStartEvent;
    exports.GLBChunk = GLBChunk;
    exports.GLBHeader = GLBHeader;
    exports.GLBParser = GLBParser;
    exports.GLSLLexer = GLSLLexer;
    exports.GLSLLexerToken = GLSLLexerToken;
    exports.GLSLPreprocessor = GLSLPreprocessor;
    exports.GLSLSyntax = GLSLSyntax;
    exports.GLTFBinaryExtension = GLTFBinaryExtension;
    exports.GLTFMaterial = GLTFMaterial;
    exports.GLTFParser = GLTFParser;
    exports.GLTFSubParser = GLTFSubParser;
    exports.GLTFSubParserCamera = GLTFSubParserCamera;
    exports.GLTFSubParserConverter = GLTFSubParserConverter;
    exports.GLTFSubParserMaterial = GLTFSubParserMaterial;
    exports.GLTFSubParserMesh = GLTFSubParserMesh;
    exports.GLTFSubParserSkeleton = GLTFSubParserSkeleton;
    exports.GLTFSubParserSkin = GLTFSubParserSkin;
    exports.GLTFType = GLTFType;
    exports.GLTF_Accessors = GLTF_Accessors;
    exports.GLTF_Info = GLTF_Info;
    exports.GLTF_Light = GLTF_Light;
    exports.GLTF_Mesh = GLTF_Mesh;
    exports.GLTF_Node = GLTF_Node;
    exports.GLTF_Primitives = GLTF_Primitives;
    exports.GLTF_Scene = GLTF_Scene;
    exports.GPUAddressMode = GPUAddressMode;
    exports.GPUBlendFactor = GPUBlendFactor;
    exports.GPUBufferBase = GPUBufferBase;
    exports.GPUBufferType = GPUBufferType;
    exports.GPUCompareFunction = GPUCompareFunction;
    exports.GPUContextInstance = GPUContextInstance;
    exports.GPUCullMode = GPUCullMode;
    exports.GPUCullPass = GPUCullPass;
    exports.GPUCullSystem = GPUCullSystem;
    exports.GPUFilterMode = GPUFilterMode;
    exports.GPUFrustumCull_cs = GPUFrustumCull_cs;
    exports.GPUParticleSystem = GPUParticleSystem;
    exports.GPUPrimitiveTopology = GPUPrimitiveTopology;
    exports.GPUStencilOperation = GPUStencilOperation;
    exports.GPUTextureFormat = GPUTextureFormat;
    exports.GPUVertexFormat = GPUVertexFormat;
    exports.GPUVertexStepMode = GPUVertexStepMode;
    exports.GTAOPost = GTAOPost;
    exports.GTAO_cs = GTAO_cs;
    exports.GUIPass = GUIPass;
    exports.GenerayRandomDir = GenerayRandomDir;
    exports.GeoJsonParser = GeoJsonParser;
    exports.GeoJsonUtil = GeoJsonUtil;
    exports.GeoType = GeoType;
    exports.GeometryBase = GeometryBase;
    exports.GeometryIndicesBuffer = GeometryIndicesBuffer;
    exports.GeometryUtil = GeometryUtil;
    exports.GeometryVertexBuffer = GeometryVertexBuffer;
    exports.GeometryVertexType = GeometryVertexType;
    exports.GetComponentClass = GetComponentClass;
    exports.GetCountInstanceID = GetCountInstanceID;
    exports.GetRepeat = GetRepeat;
    exports.GetShader = GetShader;
    exports.GlassMaterial = GlassMaterial;
    exports.GlassShader = GlassShader;
    exports.GlobalBindGroup = GlobalBindGroup;
    exports.GlobalBindGroupLayout = GlobalBindGroupLayout;
    exports.GlobalFog = GlobalFog;
    exports.GlobalFog_shader = GlobalFog_shader;
    exports.GlobalIlluminationComponent = GlobalIlluminationComponent;
    exports.GlobalUniform = GlobalUniform;
    exports.GlobalUniformGroup = GlobalUniformGroup;
    exports.GodRayPost = GodRayPost;
    exports.GodRay_cs = GodRay_cs;
    exports.GraphCompileError = GraphCompileError;
    exports.GraphValidator = GraphValidator;
    exports.GridObject = GridObject;
    exports.HDRTexture = HDRTexture;
    exports.HDRTextureCube = HDRTextureCube;
    exports.HIZ_PYRAMID = HIZ_PYRAMID;
    exports.HairMaterial = HairMaterial;
    exports.Hair_frag = Hair_frag;
    exports.Hair_shader_op = Hair_shader_op;
    exports.Hair_shader_tr = Hair_shader_tr;
    exports.HaltonSeq = HaltonSeq;
    exports.HiZPass = HiZPass;
    exports.HiZ_Init_cs = HiZ_Init_cs;
    exports.HiZ_Reduce_cs = HiZ_Reduce_cs;
    exports.HoverCameraController = HoverCameraController;
    exports.I3DMLoader = I3DMLoader;
    exports.I3DMLoaderBase = I3DMLoaderBase;
    exports.I3DMParser = I3DMParser;
    exports.IBLEnvMapCreator = IBLEnvMapCreator;
    exports.IBLEnvMapCreator_cs = IBLEnvMapCreator_cs;
    exports.IESProfiles = IESProfiles;
    exports.IESProfilesPool = IESProfilesPool;
    exports.IESProfiles_frag = IESProfiles_frag;
    exports.IKDTreeUserData = IKDTreeUserData;
    exports.IndicesGPUBuffer = IndicesGPUBuffer;
    exports.Inline_vert = Inline_vert;
    exports.InputSystem = InputSystem;
    exports.InstanceDrawComponent = InstanceDrawComponent;
    exports.InstanceUniform = InstanceUniform;
    exports.InstancedMesh = InstancedMesh;
    exports.Interpolator = Interpolator;
    exports.InterpolatorEnum = InterpolatorEnum;
    exports.IrradianceDataReaderCompleteEvent = IrradianceDataReaderCompleteEvent;
    exports.IrradianceVolumeData_frag = IrradianceVolumeData_frag;
    exports.Irradiance_frag = Irradiance_frag;
    exports.IsEditorInspector = IsEditorInspector;
    exports.IsNonSerialize = IsNonSerialize;
    exports.Joint = Joint;
    exports.JointPose = JointPose;
    exports.JumperInterpolator = JumperInterpolator;
    exports.KDTreeEntity = KDTreeEntity;
    exports.KDTreeNode = KDTreeNode;
    exports.KDTreeRange = KDTreeRange;
    exports.KDTreeSpace = KDTreeSpace;
    exports.KDTreeUUID = KDTreeUUID;
    exports.KHR_draco_mesh_compression = KHR_draco_mesh_compression;
    exports.KHR_lights_punctual = KHR_lights_punctual;
    exports.KHR_materials_clearcoat = KHR_materials_clearcoat;
    exports.KHR_materials_emissive_strength = KHR_materials_emissive_strength;
    exports.KHR_materials_ior = KHR_materials_ior;
    exports.KHR_materials_sheen = KHR_materials_sheen;
    exports.KHR_materials_specular = KHR_materials_specular;
    exports.KHR_materials_transmission = KHR_materials_transmission;
    exports.KHR_materials_unlit = KHR_materials_unlit;
    exports.KHR_materials_variants = KHR_materials_variants;
    exports.KHR_materials_volume = KHR_materials_volume;
    exports.KHR_mesh_quantization = KHR_mesh_quantization;
    exports.KHR_texture_basisu = KHR_texture_basisu;
    exports.KHR_texture_transform = KHR_texture_transform;
    exports.KV = KV;
    exports.KelvinUtil = KelvinUtil;
    exports.KeyCode = KeyCode;
    exports.KeyEvent = KeyEvent;
    exports.Keyframe = Keyframe;
    exports.KeyframeT = KeyframeT;
    exports.LDRTextureCube = LDRTextureCube;
    exports.LUT_glsl = LUT_glsl;
    exports.LambertMaterial = LambertMaterial;
    exports.Lambert_shader = Lambert_shader;
    exports.LayerBlendMode = LayerBlendMode;
    exports.LifetimeAnalyzer = LifetimeAnalyzer;
    exports.LightBase = LightBase;
    exports.LightData = LightData;
    exports.LightEntries = LightEntries;
    exports.LightType = LightType;
    exports.LightingFunction_frag = LightingFunction_frag;
    exports.Line = Line;
    exports.LineClassification = LineClassification;
    exports.LinearInterpolator = LinearInterpolator;
    exports.LitMaterial = LitMaterial;
    exports.Lit_shader = Lit_shader;
    exports.LoaderBase = LoaderBase;
    exports.LoaderEvent = LoaderEvent;
    exports.LoaderManager = LoaderManager;
    exports.MAIN_COLOR_RT = MAIN_COLOR_RT;
    exports.MAIN_DEPTH_TEXTURE = MAIN_DEPTH_TEXTURE;
    exports.MAIN_SHADOW_MAP = MAIN_SHADOW_MAP;
    exports.MAX_VALUE = MAX_VALUE;
    exports.MIN_VALUE = MIN_VALUE;
    exports.MOTION_VECTOR = MOTION_VECTOR;
    exports.Material = Material;
    exports.MaterialDataUniformGPUBuffer = MaterialDataUniformGPUBuffer;
    exports.MaterialUniform = MaterialUniform;
    exports.MaterialUtilities = MaterialUtilities;
    exports.MathShader = MathShader;
    exports.MathUtil = MathUtil;
    exports.Matrix3 = Matrix3;
    exports.Matrix4 = Matrix4;
    exports.MatrixBindGroup = MatrixBindGroup;
    exports.MatrixDO = MatrixDO;
    exports.MatrixGPUBuffer = MatrixGPUBuffer;
    exports.MatrixShader = MatrixShader;
    exports.MemoryDO = MemoryDO;
    exports.MemoryInfo = MemoryInfo;
    exports.MergeRGBACreator = MergeRGBACreator;
    exports.MergeRGBA_cs = MergeRGBA_cs;
    exports.MeshColliderShape = MeshColliderShape;
    exports.MinMaxAnimationCurves = MinMaxAnimationCurves;
    exports.MinMaxCurve = MinMaxCurve;
    exports.MinMaxCurveState = MinMaxCurveState;
    exports.MinMaxPolyCurves = MinMaxPolyCurves;
    exports.MirrorMaterial = MirrorMaterial;
    exports.MirrorShader = MirrorShader;
    exports.MissingCreatorError = MissingCreatorError;
    exports.MorePassParser = MorePassParser;
    exports.MorePassShader = MorePassShader;
    exports.MorphTargetBlender = MorphTargetBlender;
    exports.MorphTargetData = MorphTargetData;
    exports.MorphTargetFrame = MorphTargetFrame;
    exports.MorphTargetTransformKey = MorphTargetTransformKey;
    exports.MorphTarget_shader = MorphTarget_shader;
    exports.MotionVectorPass = MotionVectorPass;
    exports.MotionVector_cs = MotionVector_cs;
    exports.MouseCode = MouseCode;
    exports.MultiBouncePass_cs = MultiBouncePass_cs;
    exports.NORMAL_BUFFER = NORMAL_BUFFER;
    exports.Navi3DAstar = Navi3DAstar;
    exports.Navi3DConst = Navi3DConst;
    exports.Navi3DEdge = Navi3DEdge;
    exports.Navi3DFunnel = Navi3DFunnel;
    exports.Navi3DMaskType = Navi3DMaskType;
    exports.Navi3DMergeVertex = Navi3DMergeVertex;
    exports.Navi3DMesh = Navi3DMesh;
    exports.Navi3DPoint = Navi3DPoint;
    exports.Navi3DPoint2D = Navi3DPoint2D;
    exports.Navi3DPointFat = Navi3DPointFat;
    exports.Navi3DRouter = Navi3DRouter;
    exports.Navi3DTriangle = Navi3DTriangle;
    exports.NonSerialize = NonSerialize;
    exports.NormalMap_frag = NormalMap_frag;
    exports.OAnimationEvent = OAnimationEvent;
    exports.OBJParser = OBJParser;
    exports.OITAccumPass = OITAccumPass;
    exports.OITResolveShader = OITResolveShader;
    exports.OIT_ACCUM_TEX = OIT_ACCUM_TEX;
    exports.OIT_REVEAL_TEX = OIT_REVEAL_TEX;
    exports.Object3DEvent = Object3DEvent;
    exports.Object3DTransformTools = Object3DTransformTools;
    exports.Object3DUtil = Object3DUtil;
    exports.ObjectAnimClip = ObjectAnimClip;
    exports.OcclusionSystem = OcclusionSystem;
    exports.Octree = Octree;
    exports.OctreeEntity = OctreeEntity;
    exports.OrbitController = OrbitController;
    exports.OrderMap = OrderMap;
    exports.Orientation3D = Orientation3D;
    exports.OutLineBlendColor_cs = OutLineBlendColor_cs;
    exports.OutlineCalcOutline_cs = OutlineCalcOutline_cs;
    exports.OutlinePass = OutlinePass;
    exports.OutlinePost = OutlinePost;
    exports.OutlinePostData = OutlinePostData;
    exports.OutlinePostManager = OutlinePostManager;
    exports.OutlinePostSlot = OutlinePostSlot;
    exports.Outline_cs = Outline_cs;
    exports.OvershootInterpolator = OvershootInterpolator;
    exports.PBRLItShader = PBRLItShader;
    exports.PBRLitSSSShader = PBRLitSSSShader;
    exports.PCF_frag = PCF_frag;
    exports.POINT_SHADOW_CUBE_ARRAY = POINT_SHADOW_CUBE_ARRAY;
    exports.PRE_DEPTH_RT = PRE_DEPTH_RT;
    exports.ParserBase = ParserBase;
    exports.ParserFormat = ParserFormat;
    exports.ParticleSystemCurveEvalMode = ParticleSystemCurveEvalMode;
    exports.ParticleSystemRandomnessIds = ParticleSystemRandomnessIds;
    exports.PassGenerate = PassGenerate;
    exports.PassShader = PassShader;
    exports.PassType = PassType;
    exports.PavementShader = PavementShader;
    exports.PhysicMaterialUniform_frag = PhysicMaterialUniform_frag;
    exports.PickCompute = PickCompute;
    exports.PickFire = PickFire;
    exports.PickResult = PickResult;
    exports.Picker_cs = Picker_cs;
    exports.PingPong = PingPong;
    exports.PipelinePool = PipelinePool;
    exports.Plane = Plane;
    exports.Plane3D = Plane3D;
    exports.PlaneClassification = PlaneClassification;
    exports.PlaneGeometry = PlaneGeometry;
    exports.PointClassification = PointClassification;
    exports.PointShadowCubeCamera = PointShadowCubeCamera;
    exports.PointShadowDebug = PointShadowDebug;
    exports.PointShadowPass = PointShadowPass;
    exports.PointShadow_frag = PointShadow_frag;
    exports.PointerEvent3D = PointerEvent3D;
    exports.Polynomial = Polynomial;
    exports.PolynomialCurve = PolynomialCurve;
    exports.Polynomials = Polynomials;
    exports.PoolNode = PoolNode;
    exports.PostBase = PostBase;
    exports.PostPass = PostPass;
    exports.PostProcessingComponent = PostProcessingComponent;
    exports.PreDepthPass = PreDepthPass;
    exports.PreFilteredEnvironment_cs = PreFilteredEnvironment_cs;
    exports.PreFilteredEnvironment_cs2 = PreFilteredEnvironment_cs2;
    exports.PreIntegratedLut = PreIntegratedLut;
    exports.PreIntegratedLutCompute = PreIntegratedLutCompute;
    exports.PrefabAvatarData = PrefabAvatarData;
    exports.PrefabAvatarParser = PrefabAvatarParser;
    exports.PrefabBoneData = PrefabBoneData;
    exports.PrefabMaterialParser = PrefabMaterialParser;
    exports.PrefabMeshData = PrefabMeshData;
    exports.PrefabMeshParser = PrefabMeshParser;
    exports.PrefabNode = PrefabNode;
    exports.PrefabParser = PrefabParser;
    exports.PrefabStringUtil = PrefabStringUtil;
    exports.PrefabTextureData = PrefabTextureData;
    exports.PrefabTextureParser = PrefabTextureParser;
    exports.Preprocessor = Preprocessor;
    exports.Probe = Probe;
    exports.ProbeEntries = ProbeEntries;
    exports.ProbeGBufferFrame = ProbeGBufferFrame;
    exports.ProfilerUtil = ProfilerUtil;
    exports.PropertyAnimClip = PropertyAnimClip;
    exports.PropertyAnimTag = PropertyAnimTag;
    exports.PropertyAnimation = PropertyAnimation;
    exports.PropertyAnimationClip = PropertyAnimationClip;
    exports.PropertyAnimationClipState = PropertyAnimationClipState;
    exports.PropertyAnimationEvent = PropertyAnimationEvent;
    exports.PropertyHelp = PropertyHelp;
    exports.QuadAABB = QuadAABB;
    exports.QuadGlsl_fs = QuadGlsl_fs;
    exports.QuadGlsl_vs = QuadGlsl_vs;
    exports.QuadRoot = QuadRoot;
    exports.QuadTree = QuadTree;
    exports.QuadTreeCell = QuadTreeCell;
    exports.Quad_depth2dArray_frag_wgsl = Quad_depth2dArray_frag_wgsl;
    exports.Quad_depth2d_frag_wgsl = Quad_depth2d_frag_wgsl;
    exports.Quad_depthCube_frag_wgsl = Quad_depthCube_frag_wgsl;
    exports.Quad_frag_wgsl = Quad_frag_wgsl;
    exports.Quad_opaque_frag_wgsl = Quad_opaque_frag_wgsl;
    exports.Quad_premultiply_frag_wgsl = Quad_premultiply_frag_wgsl;
    exports.Quad_vert_wgsl = Quad_vert_wgsl;
    exports.Quaternion = Quaternion;
    exports.RADIANS_TO_DEGREES = RADIANS_TO_DEGREES;
    exports.REFLECTION_CUBE_MAP = REFLECTION_CUBE_MAP;
    exports.RGBEErrorCode = RGBEErrorCode;
    exports.RGBEHeader = RGBEHeader;
    exports.RGBEParser = RGBEParser;
    exports.RTDescriptor = RTDescriptor;
    exports.RTFrame = RTFrame;
    exports.RTResourceConfig = RTResourceConfig;
    exports.RTResourceMap = RTResourceMap;
    exports.Rand = Rand;
    exports.RandomSeed = RandomSeed;
    exports.Ray = Ray;
    exports.RayCastMeshDetail = RayCastMeshDetail;
    exports.Reader = Reader;
    exports.Rect = Rect;
    exports.Reference = Reference;
    exports.Reflection = Reflection;
    exports.ReflectionCG = ReflectionCG;
    exports.ReflectionEntries = ReflectionEntries;
    exports.ReflectionMaterial = ReflectionMaterial;
    exports.ReflectionPass = ReflectionPass;
    exports.ReflectionShader = ReflectionShader;
    exports.ReflectionShader_shader = ReflectionShader_shader;
    exports.RegisterComponent = RegisterComponent;
    exports.RegisterShader = RegisterShader;
    exports.RenderContext = RenderContext;
    exports.RenderGraph = RenderGraph;
    exports.RenderGraphComputePass = RenderGraphComputePass;
    exports.RenderGraphPass = RenderGraphPass;
    exports.RenderGraphRenderPass = RenderGraphRenderPass;
    exports.RenderGraphRenderTarget = RenderGraphRenderTarget;
    exports.RenderGraphResourcePool = RenderGraphResourcePool;
    exports.RenderNode = RenderNode;
    exports.RenderShaderCollect = RenderShaderCollect;
    exports.RenderShaderCompute = RenderShaderCompute;
    exports.RenderShaderPass = RenderShaderPass;
    exports.RenderTexture = RenderTexture;
    exports.RendererJob = RendererJob;
    exports.RendererMask = RendererMask;
    exports.RendererMaskUtil = RendererMaskUtil;
    exports.RendererPassState = RendererPassState;
    exports.RepeatSE = RepeatSE;
    exports.Res = Res;
    exports.Retargeter = Retargeter;
    exports.RotationControlComponents = RotationControlComponents;
    exports.SCENE_COLOR_PYRAMID = SCENE_COLOR_PYRAMID;
    exports.SHCommon_frag = SHCommon_frag;
    exports.SN_ArrayConstant = SN_ArrayConstant;
    exports.SN_BinaryOperation = SN_BinaryOperation;
    exports.SN_Break = SN_Break;
    exports.SN_CodeBlock = SN_CodeBlock;
    exports.SN_Constant = SN_Constant;
    exports.SN_Continue = SN_Continue;
    exports.SN_Declaration = SN_Declaration;
    exports.SN_Discard = SN_Discard;
    exports.SN_DoWhileLoop = SN_DoWhileLoop;
    exports.SN_Expression = SN_Expression;
    exports.SN_ForLoop = SN_ForLoop;
    exports.SN_Function = SN_Function;
    exports.SN_FunctionArgs = SN_FunctionArgs;
    exports.SN_FunctionCall = SN_FunctionCall;
    exports.SN_IFBranch = SN_IFBranch;
    exports.SN_Identifier = SN_Identifier;
    exports.SN_IndexOperation = SN_IndexOperation;
    exports.SN_Layout = SN_Layout;
    exports.SN_ParenExpression = SN_ParenExpression;
    exports.SN_Precision = SN_Precision;
    exports.SN_Return = SN_Return;
    exports.SN_SelectOperation = SN_SelectOperation;
    exports.SN_Struct = SN_Struct;
    exports.SN_TernaryOperation = SN_TernaryOperation;
    exports.SN_UnaryOperation = SN_UnaryOperation;
    exports.SN_WhileLoop = SN_WhileLoop;
    exports.SSAO_cs = SSAO_cs;
    exports.SSGI2_cs = SSGI2_cs;
    exports.SSGIPost = SSGIPost;
    exports.SSGIPost2 = SSGIPost2;
    exports.SSGI_cs = SSGI_cs;
    exports.SSRPost = SSRPost;
    exports.SSR_BlendColor_cs = SSR_BlendColor_cs;
    exports.SSR_IS_Kernel = SSR_IS_Kernel;
    exports.SSR_IS_cs = SSR_IS_cs;
    exports.SSR_RayTrace_cs = SSR_RayTrace_cs;
    exports.ScaleControlComponents = ScaleControlComponents;
    exports.Scene3D = Scene3D;
    exports.SceneCapturePass = SceneCapturePass;
    exports.SceneColorPyramidPass = SceneColorPyramidPass;
    exports.Shader = Shader;
    exports.ShaderAttributeInfo = ShaderAttributeInfo;
    exports.ShaderConverter = ShaderConverter;
    exports.ShaderConverterResult = ShaderConverterResult;
    exports.ShaderLib = ShaderLib;
    exports.ShaderPassBase = ShaderPassBase;
    exports.ShaderReflection = ShaderReflection;
    exports.ShaderStage = ShaderStage;
    exports.ShaderState = ShaderState;
    exports.ShaderUniformInfo = ShaderUniformInfo;
    exports.ShaderUtil = ShaderUtil;
    exports.ShadingInput = ShadingInput;
    exports.ShadowBiasCalculator = ShadowBiasCalculator;
    exports.ShadowCommon = ShadowCommon;
    exports.ShadowLightsCollect = ShadowLightsCollect;
    exports.ShadowMapping_frag = ShadowMapping_frag;
    exports.ShadowPass = ShadowPass;
    exports.Skeleton = Skeleton;
    exports.SkeletonAnimationClip = SkeletonAnimationClip;
    exports.SkeletonAnimationClipState = SkeletonAnimationClipState;
    exports.SkeletonAnimationCompute = SkeletonAnimationCompute;
    exports.SkeletonAnimation_shader = SkeletonAnimation_shader;
    exports.SkeletonBlendComputeArgs = SkeletonBlendComputeArgs;
    exports.SkeletonPose = SkeletonPose;
    exports.SkeletonTransformComputeArgs = SkeletonTransformComputeArgs;
    exports.SkinMaterial = SkinMaterial;
    exports.SkyGBufferPass = SkyGBufferPass;
    exports.SkyGBuffer_pass = SkyGBuffer_pass;
    exports.SkyMaterial = SkyMaterial;
    exports.SkyPass = SkyPass;
    exports.SkyRenderer = SkyRenderer;
    exports.Sky_glsl_fs = Sky_glsl_fs;
    exports.Sky_glsl_vs = Sky_glsl_vs;
    exports.SkylinePost = SkylinePost;
    exports.Skyline_cs = Skyline_cs;
    exports.SoftParticleMaterial = SoftParticleMaterial;
    exports.SolidColorSky = SolidColorSky;
    exports.SortedTransparentPass = SortedTransparentPass;
    exports.SphereColliderShape = SphereColliderShape;
    exports.SphereGeometry = SphereGeometry;
    exports.SphereReflection = SphereReflection;
    exports.Sprite = Sprite;
    exports.SpriteBatchEntry = SpriteBatchEntry;
    exports.SpriteMaterial = SpriteMaterial;
    exports.SpriteModifyFlags = SpriteModifyFlags;
    exports.Sprite_shader = Sprite_shader;
    exports.StandShader = StandShader;
    exports.StateMachine = StateMachine;
    exports.StatementNode = StatementNode;
    exports.StorageGPUBuffer = StorageGPUBuffer;
    exports.StorageUtil = StorageUtil;
    exports.StringUtil = StringUtil;
    exports.StripeGeometry = StripeGeometry;
    exports.Struct = Struct;
    exports.StructStorageGPUBuffer = StructStorageGPUBuffer;
    exports.SubGeometry = SubGeometry;
    exports.TAACopyTex_cs = TAACopyTex_cs;
    exports.TAAPost = TAAPost;
    exports.TAASharpTex_cs = TAASharpTex_cs;
    exports.TAA_cs = TAA_cs;
    exports.TRANSPARENT_DRAW_CTX = TRANSPARENT_DRAW_CTX;
    exports.TestComputeLoadBuffer = TestComputeLoadBuffer;
    exports.Texture = Texture;
    exports.TextureAtlas = TextureAtlas;
    exports.TextureCube = TextureCube;
    exports.TextureCubeFaceData = TextureCubeFaceData;
    exports.TextureCubeStdCreator = TextureCubeStdCreator;
    exports.TextureCubeUtils = TextureCubeUtils;
    exports.TextureIdentityWatcher = TextureIdentityWatcher;
    exports.TextureMipmapCompute = TextureMipmapCompute;
    exports.TextureMipmapGenerator = TextureMipmapGenerator;
    exports.TextureScaleCompute = TextureScaleCompute;
    exports.ThirdPersonCameraController = ThirdPersonCameraController;
    exports.TileSet = TileSet;
    exports.TileSetChild = TileSetChild;
    exports.TileSetChildContent = TileSetChildContent;
    exports.TileSetChildContentMetaData = TileSetChildContentMetaData;
    exports.TileSetRoot = TileSetRoot;
    exports.TilesRenderer = TilesRenderer;
    exports.Time = Time;
    exports.TokenType = TokenType;
    exports.TonemapPost = TonemapPost;
    exports.TonemapShader = TonemapShader;
    exports.TorusGeometry = TorusGeometry;
    exports.TouchData = TouchData;
    exports.TrailGeometry = TrailGeometry;
    exports.Transform = Transform;
    exports.TransformAxisEnum = TransformAxisEnum;
    exports.TransformControllerBaseComponent = TransformControllerBaseComponent;
    exports.TransformMode = TransformMode;
    exports.TransformSpaceMode = TransformSpaceMode;
    exports.TransientBufferPool = TransientBufferPool;
    exports.TransientResourceRegistry = TransientResourceRegistry;
    exports.TransientTexturePool = TransientTexturePool;
    exports.TranslationControlComponents = TranslationControlComponents;
    exports.TranslatorContext = TranslatorContext;
    exports.TransmissionOpaquePass = TransmissionOpaquePass;
    exports.TransparentDualDepthPeelingPass = TransparentDualDepthPeelingPass;
    exports.TransparentDualDepthPeelingResolvePass = TransparentDualDepthPeelingResolvePass;
    exports.TransparentOITPass = TransparentOITPass;
    exports.TransparentResolvePass = TransparentResolvePass;
    exports.TriGeometry = TriGeometry;
    exports.Triangle = Triangle;
    exports.TwoBoneIK = TwoBoneIK;
    exports.UIEvent = UIEvent;
    exports.UIUtil = UIUtil;
    exports.UUID = UUID;
    exports.UV = UV;
    exports.Uint16Texture = Uint16Texture;
    exports.Uint8ArrayTexture = Uint8ArrayTexture;
    exports.UnLit = UnLit;
    exports.UnLitMaterial = UnLitMaterial;
    exports.UnLitMaterialUniform_frag = UnLitMaterialUniform_frag;
    exports.UnLitTexArrayMaterial = UnLitTexArrayMaterial;
    exports.UnLitTextureArray = UnLitTextureArray;
    exports.UnLit_frag = UnLit_frag;
    exports.UniformGPUBuffer = UniformGPUBuffer;
    exports.UniformNode = UniformNode;
    exports.UniformType = UniformType;
    exports.UnresolvedResourceError = UnresolvedResourceError;
    exports.VISIBILITY_BUFFER = VISIBILITY_BUFFER;
    exports.ValueEnumType = ValueEnumType;
    exports.ValueOp = ValueOp;
    exports.ValueParser = ValueParser;
    exports.ValueSpread = ValueSpread;
    exports.Vector2 = Vector2;
    exports.Vector3 = Vector3;
    exports.Vector3Ex = Vector3Ex;
    exports.Vector3Struct = Vector3Struct;
    exports.Vector4 = Vector4;
    exports.VertexAttribute = VertexAttribute;
    exports.VertexAttributeIndexShader = VertexAttributeIndexShader;
    exports.VertexAttributeName = VertexAttributeName;
    exports.VertexAttributeSize = VertexAttributeSize;
    exports.VertexAttributeStride = VertexAttributeStride;
    exports.VertexAttributes = VertexAttributes;
    exports.VertexAttributes_vert = VertexAttributes_vert;
    exports.VertexBufferLayout = VertexBufferLayout;
    exports.VertexFormat = VertexFormat;
    exports.VertexFunction_vert = VertexFunction_vert;
    exports.VertexGPUBuffer = VertexGPUBuffer;
    exports.VertexOutput = VertexOutput;
    exports.VideoUniform_frag = VideoUniform_frag;
    exports.View3D = View3D;
    exports.ViewQuad = ViewQuad;
    exports.VirtualTexture = VirtualTexture;
    exports.VisibleLayerUtil = VisibleLayerUtil;
    exports.VolumetricFogPost = VolumetricFogPost;
    exports.VolumetricFog_cs = VolumetricFog_cs;
    exports.VoxelConeTracingGI = VoxelConeTracingGI;
    exports.WGSLTranslator = WGSLTranslator;
    exports.WasmMatrix = WasmMatrix;
    exports.WebGPUDescriptorCreator = WebGPUDescriptorCreator;
    exports.WorldMatrixUniform = WorldMatrixUniform;
    exports.WrapMode = WrapMode;
    exports.WrapTimeMode = WrapTimeMode;
    exports.WrongResourceKindError = WrongResourceKindError;
    exports.ZCullingCompute = ZCullingCompute;
    exports.ZPassShader_cs = ZPassShader_cs;
    exports.ZPassShader_vs = ZPassShader_vs;
    exports.ZSorterUtil = ZSorterUtil;
    exports.Z_BUFFER_TEXTURE = Z_BUFFER_TEXTURE;
    exports._registerDefaultCtxResolver = _registerDefaultCtxResolver;
    exports._registerGpuContextFactory = _registerGpuContextFactory;
    exports.append = append;
    exports.arrayToString = arrayToString;
    exports.bindCtx = bindCtx;
    exports.blendComponent = blendComponent;
    exports.buildCurves = buildCurves;
    exports.calculateCurveRangesValue = calculateCurveRangesValue;
    exports.calculateMinMax = calculateMinMax;
    exports.castPointShadowMap_vert = castPointShadowMap_vert;
    exports.clamp = clamp$2;
    exports.clampRepeat = clampRepeat;
    exports.computeBucketKey = computeBucketKey;
    exports.compute_skeleton_blend = compute_skeleton_blend;
    exports.compute_skeleton_transform = compute_skeleton_transform;
    exports.cos = cos;
    exports.crossProduct = crossProduct;
    exports.cubicPolynomialRoot = cubicPolynomialRoot;
    exports.cubicPolynomialRootsGeneric = cubicPolynomialRootsGeneric;
    exports.curvesSupportProcedural = curvesSupportProcedural;
    exports.defaultStencilFaceState = defaultStencilFaceState;
    exports.deg2Rad = deg2Rad;
    exports.directionShadowCastMap_frag = directionShadowCastMap_frag;
    exports.dot = dot;
    exports.doubleIntegrateSegment = doubleIntegrateSegment;
    exports.downSample = downSample;
    exports.drawNodes = drawNodes;
    exports.drawSortedTransparent = drawSortedTransparent;
    exports.drawTransmissionContinuation = drawTransmissionContinuation;
    exports.estimateTextureBytes = estimateTextureBytes;
    exports.evalCondition = evalCondition;
    exports.expand = expand;
    exports.f32 = f32;
    exports.fastInvSqrt = fastInvSqrt;
    exports.floorfToIntPos = floorfToIntPos;
    exports.generateRandom = generateRandom;
    exports.generateRandom3 = generateRandom3;
    exports.getFloatFromInt = getFloatFromInt;
    exports.getGLTypeFromTypedArray = getGLTypeFromTypedArray;
    exports.getGLTypeFromTypedArrayType = getGLTypeFromTypedArrayType;
    exports.getGlobalRandomSeed = getGlobalRandomSeed;
    exports.getLightData = getLightData;
    exports.getTypedArray = getTypedArray;
    exports.getTypedArrayTypeFromGLType = getTypedArrayTypeFromGLType;
    exports.grad1 = grad1;
    exports.grad2 = grad2;
    exports.grad3 = grad3;
    exports.grad4 = grad4;
    exports.hintToUsageBit = hintToUsageBit;
    exports.i32 = i32;
    exports.inPlaceResizable = inPlaceResizable;
    exports.integrateSegment = integrateSegment;
    exports.irradianceDataReader = irradianceDataReader;
    exports.kPI = kPI;
    exports.lerp = lerp;
    exports.lerpByte = lerpByte;
    exports.lerpColor = lerpColor;
    exports.lerpVector3 = lerpVector3;
    exports.magnitude = magnitude;
    exports.makeAnimatorParams = makeAnimatorParams;
    exports.makeBufferHandle = makeBufferHandle;
    exports.makeMatrix44 = makeMatrix44;
    exports.makeTextureHandle = makeTextureHandle;
    exports.matrixMultiply = matrixMultiply;
    exports.matrixRotate = matrixRotate;
    exports.matrixRotateY = matrixRotateY;
    exports.mergeFunctions = mergeFunctions;
    exports.multiplyMatrices4x4REF = multiplyMatrices4x4REF;
    exports.normal_distribution = normal_distribution;
    exports.normalizeFast = normalizeFast;
    exports.normalizeSafe = normalizeSafe;
    exports.normalizedToByte = normalizedToByte;
    exports.normalizedToWord = normalizedToWord;
    exports.outlinePostData = outlinePostData;
    exports.outlinePostManager = outlinePostManager;
    exports.perm = perm;
    exports.post = post;
    exports.quadraticPolynomialRootsGeneric = quadraticPolynomialRootsGeneric;
    exports.rad2Deg = rad2Deg;
    exports.random01 = random01;
    exports.randomBarycentricCoord = randomBarycentricCoord;
    exports.randomPointBetweenEllipsoid = randomPointBetweenEllipsoid;
    exports.randomPointBetweenSphere = randomPointBetweenSphere;
    exports.randomPointInsideCube = randomPointInsideCube;
    exports.randomPointInsideEllipsoid = randomPointInsideEllipsoid;
    exports.randomPointInsideUnitCircle = randomPointInsideUnitCircle;
    exports.randomPointInsideUnitSphere = randomPointInsideUnitSphere;
    exports.randomQuaternion = randomQuaternion;
    exports.randomQuaternionUniformDistribution = randomQuaternionUniformDistribution;
    exports.randomUnitVector = randomUnitVector;
    exports.randomUnitVector2 = randomUnitVector2;
    exports.rangedRandomFloat = rangedRandomFloat;
    exports.rangedRandomInt = rangedRandomInt;
    exports.readMagicBytes = readMagicBytes;
    exports.registerMaterial = registerMaterial;
    exports.renderGroupBundleKey = renderGroupBundleKey;
    exports.repeat = repeat;
    exports.resolveDefaultCtx = resolveDefaultCtx;
    exports.resolveSizeSpec = resolveSizeSpec;
    exports.resourceName = resourceName;
    exports.rotMatrix = rotMatrix;
    exports.rotateVectorByQuat = rotateVectorByQuat;
    exports.roundUpToPow2 = roundUpToPow2;
    exports.roundfToIntPos = roundfToIntPos;
    exports.scale = scale;
    exports.setFrameDelay = setFrameDelay;
    exports.setTimeDelay = setTimeDelay;
    exports.shadowCastMap_frag = shadowCastMap_frag;
    exports.shadowCastMap_vert = shadowCastMap_vert;
    exports.simplex = simplex;
    exports.sin = sin;
    exports.snoise1 = snoise1;
    exports.snoise2 = snoise2;
    exports.snoise3 = snoise3;
    exports.snoise4 = snoise4;
    exports.splitDouble = splitDouble;
    exports.splitDouble_Vector3 = splitDouble_Vector3;
    exports.sqrMagnitude = sqrMagnitude;
    exports.sqrtImpl = sqrtImpl;
    exports.subtractSplitDoubles = subtractSplitDoubles;
    exports.swap = swap;
    exports.textureCompress = textureCompress;
    exports.threshold = threshold;
    exports.toHalfFloat = toHalfFloat;
    exports.topoSort = topoSort;
    exports.tw = tw;
    exports.u32 = u32;
    exports.uniform_real_distribution = uniform_real_distribution;
    exports.uniform_real_distribution2 = uniform_real_distribution2;
    exports.upSample = upSample$1;
    exports.zSorterUtil = zSorterUtil;

    Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

}));
